(function() {
    'use strict';

    angular
        .module('sigmasfApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'kendo.directives',
            'ds.objectDiff',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ngMaterial',
            'bc.AngularKeypad',
            'angularResizable',
            'ngSanitize'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('pageRibbon', pageRibbon);

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
/**
 * Created by gmogas on 4/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoService', KendoService);

    KendoService.$inject = ['$http', '$filter'];

    function KendoService($http, $filter) {

        var service = {
            initDefaultDataSource: function (url) {
                return new kendo.data.DataSource({
                    transport: {
                        read: function(o) {
                            if (o.data.filter == undefined) {
                                o.data.filter = { filters: [] };
                            }

                            o.data.page = 1;
                            o.data.pageSize = 100000;
                            $http.get( url,
                                {params: o.data})
                                .success(function (response) {
                                    o.success(response.content);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        }
                    }
                });
            },
            initDataSource: function (url, page, pageSize, filters, sort, initialValue) {
                if (!filters) filters = [];
                return new kendo.data.DataSource({
                    transport: {
                        read: function(o) {
                            if (o.data.filter == undefined) {
                                o.data.filter = { filters: [] };
                            }

                            if (filters) {
                                angular.forEach( filters, function(item) {
                                    o.data.filter.filters = o.data.filter.filters.concat(
                                        [ item ]
                                    );
                                })
                            }

                            if (sort) {
                                o.data.sort = sort;
                            }

                            o.data.page = page;
                            o.data.pageSize = pageSize;
                            $http.get( url,
                                {params: o.data})
                                .success(function (response) {
                                    o.success(response.content);
                                })
                                .error(function (response) {});
                        }
                    },
                    //**************** Remove this because Kendo searchable dropdown stop functioning  *****************************//
                    /*schema: {
                        data: function (data) {
                            if (data.content !== undefined && initialValue) {
                                var item = $filter('filter')(data.content, {id: initialValue.id}, true);
                                if (!item.length) {
                                    data.content.push(initialValue);
                                }
                            }
                            return data.content;
                        }
                    },*/
                    //**************** / Remove this because Kendo searchable dropdown stop functioning  *****************************//
                    serverFiltering: true
                });
            },
            initDefaultOptions: function (dataSource, filter, dataTextField, dataValueField, valuePrimitive) {
                return {
                    dataSource: dataSource,
                    filter: filter,
                    valuePrimitive: valuePrimitive === undefined ? true : valuePrimitive,
                    dataTextField: dataTextField,
                    dataValueField: dataValueField
                }
            }
        };

        return service;

    }
})();
;
/**
 * Created by Teo on 28/08/2018.
 * A custom service using $resource just
 * like jHipster's default entity services,
 * but for '/search' API-endpoint
 * Use it like this:
   HospitalizationService.search({
        sort: {
            "field": "sortOrder",
            "dir": "asc"
        },
        page: 1,
        pageSize: 200,
        filter:{
            filters:[
                {
                    field: "leadCall.id",
                    operator: "eq",
                    value: 45
                }
            ]
        }}).$promise.then(function(result){...});
 */

(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('HospitalizationService', HospitalizationService);

    HospitalizationService.$inject = ['$resource'];

    function HospitalizationService ($resource) {
        var resourceUrl =  '/api/hospitalizations/search/';

        return $resource(resourceUrl, {}, {
            'search': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data.content;
                }
            }
        });
    }
})();
;
/**
 * Created by Teo on 23/08/2018.
 * A custom service using $resource just
 * like jHipster's default entity services,
 * but for '/search' API-endpoint
 * Use it like this:
   DiseaseTypeService.search({
        sort: {
            "field": "sortOrder",
            "dir": "asc"
        },
        page: 1,
        pageSize: 200,
        filter:{
            filters:[
                {
                    field: "sortOrder",
                    operator: "eq",
                    value: 1
                }
            ]
        }}).$promise.then(function(result){...});
 */

(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiseaseTypeService', DiseaseTypeService);

    DiseaseTypeService.$inject = ['$resource'];

    function DiseaseTypeService ($resource) {
        var resourceUrl =  '/api/disease-types/search/';

        return $resource(resourceUrl, {}, {
            'search': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data.content;
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64'];

    function AuthServerProvider ($http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires_at && token.expires_at > new Date().getTime();
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=sigmasfapp';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('sigmasfapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function logout () {
            $http.post('api/logout').then(function() {
                delete $localStorage.authenticationToken;
            });
        }
    }
})();
;
/**
 * Created by Kristy on 7/9/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('applicationParameters', applicationParameters);

    applicationParameters.$inject = ['$http', 'Principal'];

    function applicationParameters($http, Principal) {

        return {
            restrict: 'A',
            link: linkFunc
        };

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');
            var url = "/api/masterdata/application-parameters";

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result && reset) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    $http.get(url,
                        {params:{
                            page: 1,
                            pageSize: 1,
                            filter : { filters: [{field: "name", operator: "eq",  value: attrs.applicationParameters}] }}})
                        .success(function (response,status,headers) {
                            if (response.content[0].value == 1) {
                                defineVisibility(true);

                                /**
                                 *Pharmacies Tab View
                                 *Visible only when both "Visit_Pharmacies" & "Purchase_Pharmacies" parameters are true
                                 *Hidden if "Visit_Pharmacies" is set to false
                                 */

                                if ( attrs.applicationParameters == "Visit_Pharmacies" && attrs.extraApplicationParameters) {
                                    $http.get(url,
                                        {params:{
                                            page: 1,
                                            pageSize: 1,
                                            filter : { filters: [{field: "name", operator: "eq",  value: attrs.extraApplicationParameters}] }}})
                                        .success(function (response,status,headers) {
                                            var value = response.content[0].value == 1;
                                            defineVisibility(value);
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                }
                            } else {
                                defineVisibility(false);
                            }

                            var unauthorizedUsers = [ 'kksilouri', 'mathanasiou' ];
                            if (Principal.identity().$$state.value) {
                                if ( unauthorizedUsers.indexOf(Principal.identity().$$state.value.login) !== -1 && attrs.applicationParameters ==  "Approvals" ) {
                                    setHidden();
                                }
                            }

                        })
                        .error(function (response) {
                            console.log(response);
                        });

                });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('transportations', {
                parent: 'masterData',
                url: '/transportations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/transportations/transportations.html',
                        controller: 'MDTransportationsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTransportationsController', MDTransportationsController);

    MDTransportationsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'Transportation'];

    function MDTransportationsController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, Transportation) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.transportations.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/transportations/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        Transportation.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        Transportation.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            cost: { type: "number" }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "cost", title: "Κόστος",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:n0}"
                                });
                            },
                            showOperators: false
                        }
                    },
                    attributes:{style:"text-align:right;"},
                    template: "#= (cost == null) ? '' : kendo.format('{0:n0}', cost)#"
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 10/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tradePolicyRules', {
                parent: 'tradePoliciesView',
                url: '/tradePolicyRules',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/masterData/tradePolicies/tradePolicyRules/tradePolicyRules.html',
                controller: 'MDTradePoliciesViewRulesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 10/3/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTradePoliciesViewRulesController', MDTradePoliciesViewRulesController);

    MDTradePoliciesViewRulesController.$inject = ['$http','$state', '$stateParams', '$filter', 'KendoFilter', 'KendoGrid'];

    function MDTradePoliciesViewRulesController ($http, $state, $stateParams, $filter, KendoFilter, KendoGrid) {
        var vm = this;

        vm.selectedTradePolicyId = $stateParams.id;
        vm.ruleTypePurchasePrice = $filter('translate')('masterData.tradePolicyRules.purchasePrice');
        vm.ruleTypeQuantityPerRow = $filter('translate')('masterData.tradePolicyRules.quantityPerRow');
        vm.ruleTypeDataSource = new kendo.data.DataSource({
            data: [{ value: "purchasePrice", text: vm.ruleTypePurchasePrice}, { value: "quantityPerRow", text: vm.ruleTypeQuantityPerRow}]
        });
        vm.effectTypeDataSource = new kendo.data.DataSource({
            data: [{ value: "discount",
                    text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discount')},
                { value: "present",
                    text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.present')},
                { value: "discountPresent",
                    text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discountPresent')}]
        });
        vm.effectTypeDataSourceForQuantityPerRow = new kendo.data.DataSource({
            data: [
                { value: "present", text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.present')},
                { value: "discountInRow", text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discountInRow')}
            ]
        });
        vm.severityDataSource = new kendo.data.DataSource({
            data: [{ value: "recommend",
                text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.recommend')},
                { value: "strict",
                    text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.strict')},
                { value: "limit",
                    text: $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.limit')}]
        });
        vm.presentListDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 50;
                    $http.get('/api/present-lists/search',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });
        vm.productDataSource = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/products',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        function ruleTypeTemplate(container, options) {
            if (container.ruleType == "purchasePrice") {
                return vm.ruleTypePurchasePrice;
            }else if (container.ruleType == "quantityPerRow") {
                return vm.ruleTypeQuantityPerRow;
            }
            return "";
        }

        function effectTypeTemplate(container, options) {
            switch (container.effectType) {
                case "discount":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discount');
                    break;
                case "present":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.present');
                    break;
                case "discountPresent":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discountPresent');
                    break;
                case "discountInRow":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectTypeEnum.discountInRow');
                    break;
                default:
                    return "";
                    break;
            }
        }

        function severityTemplate(container, options) {
            switch (container.severity) {
                case "recommend":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.recommend');
                    break;
                case "strict":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.strict');
                    break;
                case "limit":
                    return $filter('translate')('masterData.tradePolicyRuleEffects.tradePolicyRuleEffectSeverityEnum.limit');
                    break;
                default:
                    return "";
                    break
            }
        }

        vm.tradePolicyRulesGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [{ "field": "tradePolicy.id", "operator": "eq",
                                "value":  vm.selectedTradePolicyId }]
                        );

                        $http.get('/api/trade-policy-rules/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        data.tradePolicy = { id: vm.selectedTradePolicyId };
                        $http.post('/api/trade-policy-rules', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#tradePolicyRulesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/trade-policy-rules', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#tradePolicyRulesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            ruleType: { validation: { required: true , validation: { required: true, min: 3}}},
                            fromValue: { type: 'number'},
                            toValue: { type: 'number' }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.tradePolicyRulesGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            selectable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "ruleType", title: "Τύπος Κανόνα",
                    template: ruleTypeTemplate,
                    editor: function(container, options) {
                        angular.element('<select id="day-time" data-bind="value:ruleType"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.ruleTypeDataSource,
                                filter: "eq",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    filterable: false
                },
                {
                    field: "fromValue", title: "Από (Αξία ή Ποσότητα)",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "toValue", title: "Εώς (Αξία ή Ποσότητα)",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

        vm.detailedGridOptions = function (dataItem) {
            console.log(dataItem);
            if (dataItem !== undefined && dataItem.ruleType !== undefined) {
                switch (dataItem.ruleType){
                    case "purchasePrice":
                        return {
                            dataSource: {
                                batch: true,
                                transport: {
                                    read: function(o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = { filters: [] };
                                        }
                                        o.data.filter.filters.push({field: "tradePolicyRule.id", operator: "eq", value: dataItem.id});
                                        $http.get('/api/trade-policy-rule-effects/search',
                                            {params: o.data})
                                            .success(function (response,status,headers) {
                                                o.success(response);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    },
                                    create: function(o) {
                                        var data = o.data.models[0];
                                        data.tradePolicyRule = {id : dataItem.id};

                                        if (!data.presentList.id) data.presentList = null;
                                        $http.post('/api/trade-policy-rule-effects', data)
                                            .success(function (response) {
                                                o.success(response);
                                                angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    },
                                    update: function(o) {
                                        var data = o.data.models[0];

                                        if (!data.presentList.id) data.presentList = null;
                                        $http.put('/api/trade-policy-rule-effects', data)
                                            .success(function (response) {
                                                o.success(response);
                                                angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                },
                                schema: {
                                    data: function (data) {
                                        if (data.content) {
                                            angular.forEach(data.content, function(item) {
                                                if (!item.presentList) item.presentList =  {};
                                            });
                                        }
                                        return data.content;
                                    },
                                    total: function (data) {
                                        return data.totalEntries;
                                    },
                                    model: {
                                        id: "id",
                                        fields: {
                                            id: { editable: false, nullable: true },
                                            effectType: { validation: { required: true , validation: { required: true, min: 3}} },
                                            discountPercent: { editable: true, type: "number", nullable: true },
                                            presentList: { defaultValue: {} }
                                        }
                                    }
                                },
                                serverFiltering: true,
                                serverSorting: true,
                                serverPaging: true,
                                pageSize: 15
                            },
                            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"}],
                            pageable: true,
                            sortable: true,
                            filterable: {
                                mode: "row"
                            },
                            columns: [
                                {
                                    field: "effectType", title: "Επίδραση Εμπορικής Πολιτικής",
                                    template: effectTypeTemplate,
                                    editor: function(container, options) {
                                        angular.element('<select id="effectType" data-bind="value:effectType"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.effectTypeDataSource,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "text",
                                                dataValueField: "value",
                                                change: function () {
                                                    var value = this.value();
                                                    if (value) {
                                                        var discountPercent = angular.element("#discountPercent").data("kendoNumericTextBox");
                                                        var presentList = angular.element("#presentList").data("kendoComboBox");
                                                        var isPresent = value == "present";
                                                        var isDiscount = value == "discount";

                                                        discountPercent.enable(!isPresent);
                                                        if (isPresent) {
                                                            discountPercent.value("");
                                                            discountPercent.trigger("change");
                                                        }

                                                        presentList.enable(!isDiscount);
                                                        if (isDiscount) {
                                                            presentList.value("");
                                                            presentList.trigger("change");
                                                        }
                                                    }
                                                }
                                            });
                                    },
                                    filterable: false
                                },
                                {
                                    field: "severity", title: "Τρόπος Επίδρασης",
                                    template: severityTemplate,
                                    editor: function(container, options) {
                                        angular.element('<select id="day-time" data-bind="value:severity"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.severityDataSource,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "text",
                                                dataValueField: "value"
                                            });
                                    },
                                    filterable: false
                                    // filterable: {
                                    //     cell: {
                                    //         operator: "startswith",
                                    //         showOperators: false,
                                    //         template: function (args) {
                                    //             args.element.kendoDropDownList({
                                    //                 autoBind:false,
                                    //                 dataTextField: "text",
                                    //                 dataValueField: "value",
                                    //                 dataSource: severityDataSource,
                                    //                 valuePrimitive: true
                                    //
                                    //             })
                                    //         }
                                    //     }
                                    // }
                                },
                                {
                                    field: "discountPercent", title: "Έκπτωση Παραστατικού",
                                    template: "#= (discountPercent == null) ? '' : kendo.format('{0:p0}', discountPercent / 100)#",
                                    editor: function(container,options){
                                        angular.element("<input id='discountPercent' data-bind='value: discountPercent'>")
                                            .appendTo(container)
                                            .kendoNumericTextBox({ format:"{0:#\\%}", min: 0 });
                                    },
                                    filterable: {
                                        cell: {
                                            operator: "eq",
                                            template: function (args) {
                                                args.element.kendoNumericTextBox({
                                                    format: "{0:#\\%}"
                                                });
                                            },
                                            showOperators: false
                                        }
                                    }
                                },
                                {
                                    field: "presentList.code", title: "Λιστα Δώρων",
                                    editor: function(container, options) {
                                        angular.element('<select id="presentList" data-bind="value:presentList.id"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.presentListDataSource,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "code",
                                                dataValueField: "id"
                                            });
                                    },
                                    filterable: {
                                        cell: {
                                            operator: "startswith",
                                            template: function (args) {
                                                KendoFilter.getTemplate(args);
                                            },
                                            showOperators: false
                                        }
                                    }
                                },
                                {
                                    command:[ {name:"edit", text: "Επεξεργασία"}],
                                    title: "&nbsp;"
                                }
                            ],
                            editable: "popup",
                            edit: function(e) {
                                if (e.model.effectType == "present") {
                                    var discountPercent = angular.element("#discountPercent").data("kendoNumericTextBox");
                                    discountPercent.enable(false);
                                }

                                if (e.model.effectType == "discount") {
                                    var presentList = angular.element("#presentList").data("kendoComboBox");
                                    presentList.enable(false);
                                }

                                KendoGrid.defaultEditPopup(this._editContainer);
                            }
                        };
                        break;
                    case "quantityPerRow":
                        return {
                            dataSource: {
                                batch: true,
                                transport: {
                                    read: function(o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = { filters: [] };
                                        }
                                        o.data.filter.filters.push({field: "tradePolicyRule.id", operator: "eq", value: dataItem.id});
                                        $http.get('/api/trade-policy-rule-effects/search',
                                            {params: o.data})
                                            .success(function (response,status,headers) {
                                                console.log(response);
                                                o.success(response);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    },
                                    create: function(o) {
                                        var data = o.data.models[0];
                                        data.tradePolicyRule = {id : dataItem.id};

                                        if (!data.presentList.id) data.presentList = null;
                                        $http.post('/api/trade-policy-rule-effects', data)
                                            .success(function (response) {
                                                o.success(response);
                                                angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    },
                                    update: function(o) {
                                        var data = o.data.models[0];

                                        if (!data.presentList.id) data.presentList = null;
                                        $http.put('/api/trade-policy-rule-effects', data)
                                            .success(function (response) {
                                                o.success(response);
                                                angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                },
                                schema: {
                                    data: function (data) {
                                        if (data.content) {
                                            angular.forEach(data.content, function(item) {
                                                if (!item.presentList) item.presentList =  {};
                                                if (!item.product) item.product = {};
                                            });
                                        }
                                        return data.content;
                                    },
                                    total: function (data) {
                                        return data.totalEntries;
                                    },
                                    model: {
                                        id: "id",
                                        fields: {
                                            id: { editable: false, nullable: true },
                                            effectType: { validation: { required: true , validation: { required: true, min: 3}} },
                                            discountPercent: { editable: true, type: "number", nullable: true },
                                            presentList: { defaultValue: {} },
                                            product: { defaultValue: {} }
                                        }
                                    }
                                },
                                serverFiltering: true,
                                serverSorting: true,
                                serverPaging: true,
                                pageSize: 15
                            },
                            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"}],
                            pageable: true,
                            sortable: true,
                            filterable: {
                                mode: "row"
                            },
                            columns: [
                                {
                                    field: "effectType", title: "Επίδραση Εμπορικής Πολιτικής",
                                    template: effectTypeTemplate,
                                    editor: function(container, options) {
                                        angular.element('<select id="effectType" data-bind="value:effectType"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.effectTypeDataSourceForQuantityPerRow,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "text",
                                                dataValueField: "value",
                                                change: function () {
                                                    var value = this.value();
                                                    console.log(value);
                                                    if (value) {
                                                        var discountPercent = angular.element("#discountPercent").data("kendoNumericTextBox");
                                                        var presentList = angular.element("#presentList").data("kendoComboBox");
                                                        var isPresent = value == "present";
                                                        var isDiscount = value == "discountInRow";

                                                        discountPercent.enable(!isPresent);
                                                        if (isPresent) {
                                                            discountPercent.value("");
                                                            discountPercent.trigger("change");
                                                        }

                                                        presentList.enable(!isDiscount);
                                                        if (isDiscount) {
                                                            presentList.value("");
                                                            presentList.trigger("change");
                                                        }
                                                    }
                                                }
                                            });
                                    },
                                    filterable: false
                                },
                                {
                                    field: "severity", title: "Τρόπος Επίδρασης",
                                    template: severityTemplate,
                                    editor: function(container, options) {
                                        angular.element('<select id="day-time" data-bind="value:severity"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.severityDataSource,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "text",
                                                dataValueField: "value"
                                            });
                                    },
                                    filterable: false
                                    // filterable: {
                                    //     cell: {
                                    //         operator: "startswith",
                                    //         showOperators: false,
                                    //         template: function (args) {
                                    //             args.element.kendoDropDownList({
                                    //                 autoBind:false,
                                    //                 dataTextField: "text",
                                    //                 dataValueField: "value",
                                    //                 dataSource: severityDataSource,
                                    //                 valuePrimitive: true
                                    //
                                    //             })
                                    //         }
                                    //     }
                                    // }
                                },
                                {
                                    field: "discountPercent", title: "Έκπτωση Παραστατικού",
                                    template: "#= (discountPercent == null) ? '' : kendo.format('{0:p0}', discountPercent / 100)#",
                                    editor: function(container,options){
                                        angular.element("<input id='discountPercent' data-bind='value: discountPercent'>")
                                            .appendTo(container)
                                            .kendoNumericTextBox({ format:"{0:#\\%}", min: 0 });
                                    },
                                    filterable: {
                                        cell: {
                                            operator: "eq",
                                            template: function (args) {
                                                args.element.kendoNumericTextBox({
                                                    format: "{0:#\\%}"
                                                });
                                            },
                                            showOperators: false
                                        }
                                    }
                                },
                                {
                                    field: "presentList.code", title: "Λιστα Δώρων",
                                    editor: function(container, options) {
                                        angular.element('<select id="presentList" data-bind="value:presentList.id"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.presentListDataSource,
                                                filter: "eq",
                                                valuePrimitive: true,
                                                dataTextField: "code",
                                                dataValueField: "id"
                                            });
                                    },
                                    filterable: {
                                        cell: {
                                            operator: "startswith",
                                            template: function (args) {
                                                KendoFilter.getTemplate(args);
                                            },
                                            showOperators: false
                                        }
                                    }
                                },
                                {
                                    field: "product.name", title: "Για το προιόν",
                                    editor: function(container, options) {
                                        angular.element('<select id="product" data-bind="value:product.id"></select>')
                                            .appendTo(container)
                                            .kendoComboBox({
                                                dataSource: vm.productDataSource,
                                                filter: "contains",
                                                valuePrimitive: true,
                                                dataTextField: "name",
                                                dataValueField: "id"
                                            });
                                    },
                                    filterable: {
                                        cell: {
                                            operator: "startswith",
                                            template: function (args) {
                                                KendoFilter.getTemplate(args);
                                            },
                                            showOperators: false
                                        }
                                    }
                                },
                                {
                                    command:[ {name:"edit", text: "Επεξεργασία"}],
                                    title: "&nbsp;"
                                }
                            ],
                            editable: "popup",
                            edit: function(e) {
                                if (e.model.effectType == "present") {
                                    var discountPercent = angular.element("#discountPercent").data("kendoNumericTextBox");
                                    discountPercent.enable(false);
                                }

                                if (e.model.effectType == "discount") {
                                    var presentList = angular.element("#presentList").data("kendoComboBox");
                                    presentList.enable(false);
                                }

                                KendoGrid.defaultEditPopup(this._editContainer);
                            }
                        };
                        break;
                }
            }
        };
    }

})();
;
/**
 * Created by Kristy on 10/3/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTradePoliciesViewController', MDTradePoliciesViewController);

    MDTradePoliciesViewController.$inject = ['$rootScope', '$http','$state', '$stateParams', '$filter', 'NotificationOptions', 'TradePolicy'];

    function MDTradePoliciesViewController ($rootScope, $http, $state, $stateParams, $filter, NotificationOptions, TradePolicy) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        // if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT'])) {
        //     vm.canEdit = true;
        // }else {
        //     vm.readOnly = true;
        // }

        vm.pageHeading = $filter('translate')('masterData.tradePolicy.title');
        vm.tradePolicy = {};
        vm.profilePicture = "handshake_icon.png";
        vm.selectedTradePolicyId = $stateParams.id;
        vm.$state = $state;

        $http.get('api/trade-policies/' + vm.selectedTradePolicyId)
            .success(function (response) {
                vm.tradePolicy = response;
            })
            .error(function (response) {
                console.log(response);
            });

        vm.update = function() {
            vm.tradePolicy.fromDate = kendo.toString(kendo.parseDate(vm.tradePolicy.fromDate), 'yyyy-MM-dd');
            vm.tradePolicy.toDate = kendo.toString(kendo.parseDate(vm.tradePolicy.toDate), 'yyyy-MM-dd');
            TradePolicy.update(vm.tradePolicy)
                .$promise.then(
                //success
                function( value ){
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                    }, "success");
                },
                //error
                function( error ){
                    console.log(error);
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                }
            );
        };
    }

})();
;
/**
 * Created by Kristy on 10/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tradePolicies', {
            parent: 'masterData',
            url: '/tradePolicies',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/tradePolicies/tradePolicies.html',
                    controller: 'MDTradePoliciesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tradePoliciesView', {
            parent: 'app',
            url: '/tradePolicies/search?id:tradePolicyId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/tradePolicies/tradePoliciesView.html',
                    controller: 'MDTradePoliciesViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 10/3/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTradePoliciesController', MDTradePoliciesController);

    MDTradePoliciesController.$inject = ['$state', 'DateUtils', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDTradePoliciesController ($state, DateUtils, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.tradePolicies.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/trade-policies/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        $('a.k-grid-update').hide();
                        var data = o.data.models[0];
                        data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                        $http.post('/api/trade-policies', data)
                            .success(function (response) {
                                o.success(response);
                                $('a.k-grid-update').show();
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                                $('a.k-grid-update').show();
                            });
                    },
                    update: function(o) {
                        $('a.k-grid-update').hide();
                        var data = o.data.models[0];
                        data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                        $http.put('/api/trade-policies', data)
                            .success(function (response) {
                                o.success(response);
                                $('a.k-grid-update').show();
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                $('a.k-grid-update').show();
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            code: { validation: { required: true , validation: { required: true, min: 3}}},
                            fromDate: { type: 'date'},
                            toDate: { type: 'date'}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            selectable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "description", title: "Περιγραφή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "fromDate",
                    title: "Ημερομηνία Ισχύος Από",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "toDate",
                    title: "Ημερομηνία Ισχύος Εώς",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

        vm.onSelection = function(data) {
            var selectedId = data.id;
            $state.go('tradePolicyRules', {id: selectedId});
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('taxStatuses', {
            parent: 'masterData',
            url: '/taxStatuses',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/taxStatuses/taxStatuses.html',
                    controller: 'MDTaxStatusesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTaxStatusesController', MDTaxStatusesController);

    MDTaxStatusesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDTaxStatusesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.taxStatuses.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/tax-statuses/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/tax-statuses', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/tax-statuses', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('taxStatusClasses', {
            parent: 'masterData',
            url: '/taxStatusClasses',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/taxStatusClasses/taxStatusClasses.html',
                    controller: 'MDTaxStatusClassesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTaxStatusClassesController', MDTaxStatusClassesController);

    MDTaxStatusClassesController.$inject = ['KendoGrid', 'KendoService', '$http', '$filter', 'KendoFilter'];

    function MDTaxStatusClassesController (KendoGrid, KendoService, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.taxStatusClasses.title');

        vm.dataSource = {};
        vm.dataSource.taxStatuses = KendoService.initDefaultDataSource('/api/tax-statuses/search');
        vm.dataSource.taxClasses = KendoService.initDefaultDataSource('/api/tax-classes/search');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/tax-status-classes/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/tax-status-classes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/tax-status-classes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            taxStatus: {defaultValue: { name: "" }},
                            'taxStatus.name': { validation: { required: true , validation: { required: true, min: 3}}},
                            taxClass: {defaultValue:  { name: "" }},
                            'taxClass.name': { validation: { required: true , validation: { required: true, min: 3}}},
                            value: {defaultValue: null}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "taxStatus.name", title: "Καθεστώς ΦΠΑ ΜΥ",
                    editor: function(container, options) {
                        angular.element('<select id="taxStatus" data-bind="value:taxStatus.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.dataSource.taxStatuses,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "taxClass.name", title: "Φ.Π.Α. Είδους",
                    editor: function(container, options) {
                        angular.element('<select id="taxClass" data-bind="value:taxClass.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.dataSource.taxClasses,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "value", title: "Ποσοστό",
                    template: "#= (value == null) ? ' ' : kendo.format('{0:p0}', value / 100)#",
                    editor: function(container,options){

                        angular.element('<input data-bind="value: value">')
                            .appendTo(container)
                            .kendoNumericTextBox({format:"{0:#\\%}"});
                    },
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:#\\%}"
                                });
                            },
                            showOperators: false
                        }
                    }},
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('taxClasses', {
            parent: 'masterData',
            url: '/taxClasses',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/taxClasses/taxClasses.html',
                    controller: 'MDTaxClassesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDTaxClassesController', MDTaxClassesController);

    MDTaxClassesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDTaxClassesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.taxClasses.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/tax-classes/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/tax-classes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/tax-classes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sortOrders', {
            parent: 'masterData',
            url: '/sortOrders',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/sortOrders/sortOrders.html',
                    controller: 'MDSortOrdersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDSortOrdersController', MDSortOrdersController);

    MDSortOrdersController.$inject = ['$scope', '$state', '$http', '$filter', 'KendoService', 'KendoGrid', 'KendoFilter', 'ApplicationParameters'];

    function MDSortOrdersController ($scope, $state, $http, $filter, KendoService, KendoGrid, KendoFilter, ApplicationParameters) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.sortOrders.title');
        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        var productCategoriesDataSource = KendoService.initDefaultDataSource('/api/masterdata/product-categories');
        vm.productCategoriesOptions = {
            dataSource: productCategoriesDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            change: function() { KendoGrid.refresh(vm.mainGridOptions); }
        };
        vm.productCategoriesOptions.dataSource.filter({
            field: 'isSalesCategory',
            operator: 'eq',
            value: true
        });

        var presentListDataSource = KendoService.initDefaultDataSource('/api/present-lists/search');
        vm.presentListOptions = {
            dataSource: presentListDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "description",
            dataValueField: "id",
            change: function() { KendoGrid.refresh(vm.mainGridOptions); }
        };
        vm.presentListOptions.dataSource.filter({
            field: 'selectable',
            operator: 'eq',
            value: true
        });

        vm.sortCategory = true;
        vm.currentCategory = true;

        vm.toolbarOptions = {
            items: [
                { type: "separator", overflow: "never" },
                { type: "separator", overflow: "never" },
                {
                    template: "<label>Επιλογή σειράς: </label>" +
                        "<div class='inline'>" +
                        "<md-radio-group style='padding-right: 10px; padding-left: 10px' layout='row' ng-model='vm.sortCategory'>" +
                            "<md-radio-button ng-value='true' class='md-primary'> Προϊόντα </md-radio-button>" +
                            "<md-radio-button ng-value='false' class='md-primary'> Δώρα </md-radio-button>" +
                        "</md-radio-group>" +
                        "</div>",
                    overflow: "never", class: "left-space"
                },
                {
                    template:
                    "<div ng-hide='!vm.sortCategory'>" +
                        "<label>Κατηγορία Προϊόντων: </label>" +
                        "<select id='productCategory' name='productCategory' class='inline' kendo-combo-box='vm.productCategoryCombo' " +
                        "k-options='vm.productCategoriesOptions' k-ng-model='vm.productCategory'></select>" +
                    "</div>",
                    overflow: "never", class: "left-space"
                },
                {
                    template:
                    "<div ng-hide='vm.sortCategory'>" +
                        "<label>Λίστα Δώρων: </label>" +
                        "<select id='presentList' name='presentList' class='inline' kendo-combo-box='vm.presentListCombo' " +
                        "k-options='vm.presentListOptions' k-ng-model='vm.presentList'></select>" +
                    "</div>",
                    overflow: "never", class: "left-space"
                }
            ]
        };

        vm.sortableOptions = {
            filter: ".k-grid tr[data-uid]",
            hint: $.noop,
            cursor: "move",
            // hint:function(element) {
            //     return element.clone().addClass("hint");
            // },
            placeholder: function(element) {
                //return element.clone().addClass("placeholder").text("Τοποθετήστε εδώ!");
                return element
                    .clone()
                    .removeAttr("uid")
                    .addClass("k-state-hover")
                    .addClass("k-state-selected")
                    .addClass("draggable");
            },
            container: ".k-grid tbody",
            change: function(e) {
                var sortableGrid = vm.sortableGrid,
                    dataItem = sortableGrid.dataSource.getByUid(e.item.data("uid"));
                sortableGrid.dataSource.remove(dataItem);
                sortableGrid.dataSource.insert(e.newIndex, dataItem);
                var data = sortableGrid.dataSource.data();

                angular.forEach( data, function (item, index){
                    item.sortOrder = index + 1;
                });

                if(vm.currentCategory){
                    $http.put('/api/product-category-products/mass', data)
                        .success(function (response,status,headers) {
                            console.log(response);
                            // o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                } else {
                    $http.put('/api/present-list-products/mass', data)
                        .success(function (response,status,headers) {
                            console.log(response);
                            // o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        };

        vm.mainGridOptions = {
            autoBind:false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }
                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "sortOrder",  "dir": "asc" };
                        }

                        if(vm.sortCategory){
                            if(vm.productCategory) {
                                o.data.filter.filters.push(
                                    { "field": "productCategory.id", "operator": "eq",
                                        "value": vm.productCategory }
                                );
                                $http.get('/api/product-category-products/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                                vm.currentCategory = vm.sortCategory;
                            } else {
                                o.success([]);
                            }
                        } else {
                            if(vm.presentList) {
                                o.data.filter.filters.push(
                                    { "field": "presentList.id", "operator": "eq",
                                        "value": vm.presentList }
                                );
                                $http.get('/api/present-list-products/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                                vm.currentCategory = vm.sortCategory;
                            } else {
                                o.success([]);
                            }
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 200
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                { field:"id", filterable: false, hidden : true },
                {
                    field: "product.image", title: "Φωτογραφία είδους",
                    template: '<div ng-if="dataItem.product.image" class="form-group">' +
                            '<img data-ng-src="{{\'data:\' + dataItem.product.imageContentType + \';base64,\' + dataItem.product.image}}" width="100px"/>' +
                            '</div>',
                    filterable: false
                },
                { field: "product.barcode", title: "Barcode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                { field: "product.code", title: "Κωδικός Είδους",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                { field: "product.name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            editable: false
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('socialInsurances', {
            parent: 'masterData',
            url: '/socialInsurances',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/socialInsurances/socialInsurances.html',
                    controller: 'MDSocialInsurancesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDSocialInsurancesController', MDSocialInsurancesController);

    MDSocialInsurancesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDSocialInsurancesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.socialInsurances.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/social-insurances',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/social-insurances', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/social-insurances', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: true},
                            name: {validation: {required: true, validation: {required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sectorTypes', {
            parent: 'masterData',
            url: '/sectorTypes',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/sectorTypes/sectorTypes.html',
                    controller: 'MDSectorTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDSectorTypesController', MDSectorTypesController);

    MDSectorTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'CustomUtils'];

    function MDSectorTypesController ($scope, KendoGrid, $http, $filter, KendoFilter, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.sectorTypes.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddSectorTypeClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.sectorTypeCategories = ["hcu", "beautyCenter", "pharmacy"];

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/sector-types',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/sector-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/sector-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { editable: true, validation: { required: true, validation: { required: true, min: 3 } } },
                            sectorTypeCategory: { editable: true, validation: { required: true } },
                            isPrivate: { editable: true, type:"boolean" },
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Τύποι Μονάδων Υγείας", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Τύποι Μονάδων Υγείας",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Τύποι Μονάδων Υγείας"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sectorTypeCategory",
                    title: "Κατηγορία Τύπου Μ.Υ.",
                    editor: function(container, options) {
                        angular.element('<select id="sectorType-sectorTypeCategory" name="sectorTypeSectorTypeCategory" required data-required-msg="Επιλέξτε Κατηγορία Τύπου Μ.Υ." data-bind="value:sectorTypeCategory"></select>')
                            .appendTo(container)
                            .kendoDropDownList({
                                dataSource: vm.sectorTypeCategories
                            }).kendoValidator().data("kendoValidator");
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="isPrivate" ng-model="dataItem.isPrivate" ' +
                    'ng-disabled="true"></md-checkbox>',
                    field: "isPrivate", title: "Ιδιωτικό",
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.isPrivate"  aria-label="isPrivate" ' +
                            'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function(e) {
                e.model.dirty = true;
                KendoGrid.defaultEditPopup(this._editContainer);
            },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Maria on 13/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorPositions', {
                parent: 'masterData',
                url: '/sectorPositions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/sectorPositions/sectorPositions.html',
                        controller: 'MDSectorPositionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Maria on 13/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDSectorPositionsController', MDSectorPositionsController);

    MDSectorPositionsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'CustomUtils'];

    function MDSectorPositionsController ($scope, KendoGrid, $http, $filter, KendoFilter, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.sectorPositions.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddSectorPositionClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/sector-positions',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/sector-positions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/sector-positions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Νοσοκομειακές Θέσεις", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Νοσοκομειακές Θέσεις",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Νοσοκομειακές Θέσεις"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('roomTypes', {
            parent: 'masterData',
            url: '/roomTypes',
            data: {
                authorities: ['ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/roomTypes/roomTypes.html',
                    controller: 'MDRoomTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDRoomTypesController', MDRoomTypesController);

    MDRoomTypesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'RoomType'];

    function MDRoomTypesController (KendoGrid, $http, $filter, KendoFilter, RoomType) {
        var vm = this;

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.roomTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/room-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        RoomType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        RoomType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('roomCosts', {
                parent: 'masterData',
                url: '/roomCosts',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/roomCosts/roomCosts.html',
                        controller: 'MDRoomCostsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDRoomCostsController', MDRoomCostsController);

    MDRoomCostsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'RoomCost'];

    function MDRoomCostsController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, RoomCost) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.roomCosts.title');
        var dataSource = {};
        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/room-costs/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        RoomCost.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        RoomCost.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            cost: { type: "number" },
                            costType: { defaultValue: null },
                            roomType: { defaultValue: null }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "cost", title: "Κόστος",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:n0}"
                                });
                            },
                            showOperators: false
                        }
                    },
                    attributes:{style:"text-align:right;"},
                    template: "#= (cost == null) ? '' : kendo.format('{0:n0}', cost)#"
                },
                {
                    field: "costType", title: "Τύπος Κόστους",
                    template: "#= costType ? costType.name : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    editor: function(container) {
                        //costType combobox edit configuration
                        dataSource.costType = KendoService.initDataSource('/api/cost-types/search', 1, 50);
                        vm.costTypeOptions = KendoService.initDefaultOptions(dataSource.costType, "startswith", "name", "id", false);

                        angular.element('<select id="costType" data-bind="value:costType" ' +
                            'kendo-combo-box k-options="vm.costTypeOptions"></select>')
                            .appendTo(container)
                    }
                },
                {
                    field: "roomType", title: "Τύπος Δωματίου",
                    template: "#= roomType ? roomType.name : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    editor: function(container) {
                        //roomType combobox edit configuration
                        dataSource.roomType = KendoService.initDataSource('/api/room-types/search', 1, 50);
                        vm.roomTypeOptions = KendoService.initDefaultOptions(dataSource.roomType, "startswith", "name", "id", false);

                        angular.element('<select id="roomType" data-bind="value:roomType" ' +
                            'kendo-combo-box k-options="vm.roomTypeOptions"></select>')
                            .appendTo(container)
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('relationshipTypes', {
                parent: 'masterData',
                url: '/relationshipTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/relationshipTypes/relationshipTypes.html',
                        controller: 'MDRelationshipTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDRelationshipTypesController', MDRelationshipTypesController);

    MDRelationshipTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'RelationshipType'];

    function MDRelationshipTypesController ($scope, KendoGrid, $http, $filter, KendoFilter, RelationshipType) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.relationshipTypes.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/relationship-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        RelationshipType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        RelationshipType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rejectionReasons', {
                parent: 'masterData',
                url: '/rejectionReasons',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/rejectionReasons/rejectionReasons.html',
                        controller: 'MDRejectionReasonsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDRejectionReasonsController', MDRejectionReasonsController);

    MDRejectionReasonsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'RejectionReason'];

    function MDRejectionReasonsController ($scope, KendoGrid, $http, $filter, KendoFilter, RejectionReason) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.rejectionReasons.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/rejection-reasons/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        RejectionReason.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        RejectionReason.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Maria on 27/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('regions', {
                parent: 'masterData',
                url: '/regions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/regions/regions.html',
                        controller: 'MDRegionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();



;
/**
 * Created by Maria on 27/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDRegionsController', MDRegionsController);

    MDRegionsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDRegionsController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.regions.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {


                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/regions',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                console.log(response)
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/regions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/regions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 21/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchaseStatuses', {
            parent: 'masterData',
            url: '/purchaseStatuses',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/purchaseStatuses/purchaseStatuses.html',
                    controller: 'MDPurchaseStatusesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 21/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPurchaseStatusesController', MDPurchaseStatusesController);

    MDPurchaseStatusesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'PurchaseStatus'];

    function MDPurchaseStatusesController (KendoGrid, $http, $filter, KendoFilter, PurchaseStatus) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.purchaseStatuses.title');
        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/masterdata/purchase-statuses',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        if(!data.cancellable) data.cancellable = false;
                        if(!data.isEditable) data.isEditable = false;

                        PurchaseStatus.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        PurchaseStatus.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , min: 3}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    template: '<md-checkbox class="checkbox-toolbar green inline"  aria-label="isEditable" ng-model="dataItem.isEditable" ng-disabled="true"></md-checkbox>',
                    field: "isEditable", title: "Επεξεργασία",
                    editor: function(container){
                        angular.element('<md-checkbox ng-model="dataItem.isEditable"  aria-label="isEditable" class="checkbox-toolbar green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    template: '<md-checkbox class="checkbox-toolbar green inline"  aria-label="cancellable" ng-model="dataItem.cancellable" ng-disabled="true"></md-checkbox>',
                    field: "cancellable", title: "Ακυρωμένη",
                    editor: function(container){
                        angular.element('<md-checkbox ng-model="dataItem.cancellable"  aria-label="cancellable" class="checkbox-toolbar green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function(e) {
                e.model.dirty = true;
                KendoGrid.defaultEditPopup(this._editContainer);
            },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchaseNumberingRows', {
            parent: 'masterData',
            url: '/purchaseNumberingRows',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/purchaseNumberingRows/purchaseNumberingRows.html',
                    controller: 'MDPurchaseNumberingRowsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 22/2/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPurchaseNumberingRowsController', MDPurchaseNumberingRowsController);

    MDPurchaseNumberingRowsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'ApplicationParameters'];

    function MDPurchaseNumberingRowsController ($scope, KendoGrid, $http, $filter, KendoFilter, ApplicationParameters) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.purchaseNumberingRows.title');

        ApplicationParameters.hasModule('Purchase_Pharmacies', true);

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/purchase-numbering-rows/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/purchase-numbering-rows', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/purchase-numbering-rows', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {field: "name", title: "Κωδικός Σειράς",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "lastUsedNumber", title: "Τελευταίος Αριθμός Σειράς",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('professions', {
                parent: 'masterData',
                url: '/professions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/professions/professions.html',
                        controller: 'MDProfessionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDProfessionsController', MDProfessionsController);

    MDProfessionsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDProfessionsController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.professions.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/professions/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/professions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/professions', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('products', {
            parent: 'masterData',
            url: '/products',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/products/products.html',
                    controller: 'MDProductsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDProductsController', MDProductsController);

    MDProductsController.$inject = ['$scope', 'DateUtils', '$http', '$filter', 'KendoFilter', 'DataUtils', 'ApplicationParameters', 'KendoGrid', 'CustomUtils'];

    function MDProductsController ($scope, DateUtils, $http, $filter, KendoFilter, DataUtils, ApplicationParameters, KendoGrid, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(67);
        vm.pageHeading = $filter('translate')('masterData.products.title');
        vm.selectedProductCategories = [];

        function productCategoriesDisplay(data, container) {
            if(data.productCategories) {
                return data.productCategories.map(function(elem) {
                    return elem.name
                }).join(', ');
            }
            return "";
        }

        vm.measurementUnitsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/measurement-units',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.taxClassesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/tax-classes/search',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.setImage = function ($file, product) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                console.log(product);
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        product.image = base64Data;
                        product.imageContentType = $file.type;
                    });
                });
            }
        };

        var purchasePharmaciesColumns = [ "barcode", "code", "supplierCode", "atcCode",
            "packaging", "defaultDiscount", "availableForVisit", "availableForPurchase" ];

        vm.onAddProductClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        if(vm.selectedProductCategories.length) {
                            o.data.filter.filters.push(
                                { "field": "productCategories.id", "operator": "in",
                                    "value": vm.selectedProductCategories.toString() }
                            );
                        }

                        $http.get('/api/masterdata/products',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        if(!data.measurementUnit.id)
                            data.measurementUnit = null;
                        if(!data.taxClass.id)
                            data.taxClass = null;

                        $http.post('/api/products', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        if(!data.measurementUnit.id)
                            data.measurementUnit = null;
                        if(!data.taxClass.id)
                            data.taxClass = null;

                        $http.put('/api/products', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function (item) {
                                if (item.measurementUnit === null) item.measurementUnit = {};
                                if (item.taxClass === null) item.taxClass = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            shortName: { validation: { required: true , validation: { required: true, min: 3}} },
                            activeSubstance: { validation: { required: false , validation: { required: true, min: 3}} },
                            updatedAt: { editable: false },
                            defaultDiscount: { editable: true, nullable: true, type: "number"},
                            availableForVisit: { type:"boolean" },
                            availableForPurchase: { type:"boolean" },
                            measurementUnit:{defaultValue: {id: null, name : null}},
                            taxClass:{defaultValue: {id: null, name : null}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            dataBound: function() {
                //var grid = $('#mainGrid').data('kendoGrid');
                var self = this;

                ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
                    if (response.data.content[0].value != 1) {
                        self.tbody.find("tr.k-master-row>.k-hierarchy-cell>a").hide();
                    //     angular.forEach( grid.columns, function (item, index) {
                    //         if( purchasePharmaciesColumns.indexOf( item.field ) !== -1 ) {
                    //             grid.hideColumn(index);
                    //         }
                    //     });
                    }
                    // vm.initPopupGrid = true;
                });
            },
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Προιόντα", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Προιόντα",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Προιόντα"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {field: "name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "activeSubstance", title: "Δραστική",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {
                    field: "productCategories",
                    title: "Κατηγορίες Προϊόντων",
                    filterable: {
                        cell: {
                            operator: "in",
                            showOperators: false,
                            template: function (args) {
                                args.element.removeAttr('data-bind').kendoMultiSelect({
                                    dataSource: new kendo.data.DataSource({
                                        serverFiltering: true,
                                        transport: {
                                            read: function (o) {
                                                if (o.data.filter == undefined) {
                                                    o.data.filter = {filters: []};
                                                }
                                                o.data.page = 1;
                                                o.data.pageSize = 10000;
                                                $http.get('/api/masterdata/product-categories',
                                                    {params: o.data})
                                                    .success(function (response, status, headers) {
                                                        response.content.unshift({id:"none", name :"(Κενό)"});
                                                        o.success(response.content);
                                                    })
                                                    .error(function (response) {
                                                        console.log(response);
                                                    });
                                            }
                                        }
                                    }),
                                    valuePrimitive: true,
                                    dataTextField: "name",
                                    dataValueField: "id",
                                    change: function () {
                                        vm.selectedProductCategories = this.value();
                                        vm.mainGridOptions.dataSource.read();
                                    },
                                    select: function (e) {
                                        var dataItem = this.dataSource.view()[e.item.index()];
                                        var values = this.value();

                                        if (dataItem.id === "none") {
                                            this.value("");
                                        } else if (values.indexOf("none") !== -1) {
                                            values = angular.element.grep(values, function (value) {
                                                return value !== "none";
                                            });
                                            this.value(values);
                                        }
                                    }
                                })
                            }
                        }
                    },
                    template: productCategoriesDisplay,
                    editor: function (container, options) {
                        angular.element('<select id="productCategories" multiple="multiple" data-bind="value: productCategories"/>')
                            .appendTo(container)
                            .kendoMultiSelect({
                                dataSource: new kendo.data.DataSource({
                                    serverFiltering: true,
                                    transport: {
                                        read: function (o) {
                                            if (o.data.filter == undefined) {
                                                o.data.filter = {filters: []};
                                            }

                                            o.data.page = 1;
                                            o.data.pageSize = 10000;
                                            $http.get('/api/masterdata/product-categories',
                                                {params: o.data})
                                                .success(function (response, status, headers) {
                                                    o.success(response.content);
                                                })
                                                .error(function (response) {
                                                    console.log(response);
                                                });
                                        }
                                    }
                                }),
                                valuePrimitive: false,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    sortable: false
                },
                {field: "barcode", title: "Barcode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "code", title: "Κωδικός Είδους",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "supplierCode", title: "Κωδικός Προμηθευτή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "atcCode", title: "ATC Code",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "packaging", title: "Συσκευασία",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "defaultDiscount", title: "Έκπτωση είδους", template: "#= (defaultDiscount == null) ? ' ' : kendo.format('{0:p0}', defaultDiscount / 100)#",
                    editor: function(container,options){
                        angular.element('<input data-bind="value: defaultDiscount">')
                            .appendTo(container)
                            .kendoNumericTextBox({format:"{0:#\\%}"});
                    },
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:#\\%}"
                                });
                            },
                            showOperators: false
                        }
                    }},
                {
                    field: "measurementUnit.name",
                    title: "Μονάδα Μέτρησης",
                    editor: function(container, options) {
                        angular.element('<select id="measurement-unit" data-bind="value:measurementUnit.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.measurementUnitsDataSource,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 145
                },
                {
                    field: "taxClass.name",
                    title: "Φ.Π.Α. Είδους",
                    editor: function(container, options) {
                        angular.element('<select id="tax-class" data-bind="value:taxClass.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.taxClassesDataSource,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 145
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="availableForVisit" ng-model="dataItem.availableForVisit" ' +
                    'ng-disabled="true"></md-checkbox>',
                    field: "availableForVisit", title: "Είδη για επίσκεψη",
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.availableForVisit"  aria-label="availableForVisit" ' +
                                'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }},
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="availableForPurchase" ng-model="dataItem.availableForPurchase" ' +
                'ng-disabled="true"></md-checkbox>',
                    field: "availableForPurchase", title: "Είδη για παραγγελια",
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.availableForPurchase"  aria-label="availableForPurchase" ' +
                            'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="calcPFS" ng-model="dataItem.calcPFS" ' +
                        'ng-disabled="true"></md-checkbox>',
                    field: "calcPFS", title: "ΠΦΣ",
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.calcPFS"  aria-label="calcPFS" ' +
                            'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "image", title: "Φωτογραφία είδους",hidden:true,
                    editor: function (container, options) {
                        angular.element('<div ng-if="dataItem.image" class="form-group">' +
                            '<img data-ng-src="{{\'data:\' + dataItem.imageContentType + \';base64,\' + dataItem.image}}" style="max-width: 80%;"/>' +
                            '</div></br><md-button type="button" class="md-button md-ink-ripple md-raised md-warn photo-btn" ngf-select ngf-change="vm.setImage($file, dataItem)" accept="image/*">' +
                            '{{ (dataItem.image == null) ? "Προσθήκη εικόνας" : "Αλλαγή εικόνας" }}</md-button><md-button type="button" class="md-button md-ink-ripple md-raised md-warn photo-btn" ' +
                            'ng-click="dataItem.image=null;dataItem.imageContentType=null;" ng-if="dataItem.image !== null">Διαγραφή εικόνας</md-button>')
                            .appendTo(container);
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;",
                    width: 150
                }
            ],
            height: vm.contentHeight,
            edit: function(e) {
                e.model.dirty = true;
                KendoGrid.defaultEditPopup(this._editContainer);
            },
            editable: { mode: "popup" }
        };

        vm.dateValidation = function(input, params) {
            var startedDate = angular.element("[name=startedDate]").data("kendoDatePicker").value();
            var endedDate = angular.element("[name=endedDate]").data("kendoDatePicker").value();

            if (input.is("[name=endedDate]")) {
                var gridData= vm.initialGridData;

                var highest = { startedDate: null };
                for (var i=gridData.length-1; i>=0; i--) {
                    if (gridData[i].id != vm.editRow.id) {
                        var tmp = gridData[i].startedDate;
                        if (tmp > highest.startedDate) {
                            highest = gridData[i];
                        }
                    }
                }
                if(highest.startedDate) {
                    if (startedDate && endedDate) {
                        input.attr("data-customValidation-msg", "Η «Ημερομηνία Από» δεν μπορεί να είναι μεταγενέστερη της «Ημερομηνίας Εως».");

                        if (startedDate > endedDate) {
                            return false;
                        }
                    }

                    if ( (startedDate >= highest.startedDate && (startedDate <= highest.endedDate || highest.endedDate == null)) ||
                        (endedDate >= highest.startedDate && (endedDate <= highest.endedDate || highest.endedDate == null))) {
                        input.attr("data-customValidation-msg", "Υπάρχουν αποθηκευμένες τιμές γι'αυτές τις ημερομηνίες.");
                        return false;
                    }
                }

            }
            return true;
        };

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                angular.forEach( o.data.filter.filters, function(item) {
                                    if ( item.value instanceof Date) {
                                        item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                    }
                                });

                                o.data.filter.filters.push({field: "product.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/product-prices/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            create: function(o) {
                                var data = o.data.models[0];
                                data.product = {id : dataItem.id};
                                data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                                data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);

                                $http.post('/api/product-prices', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            update: function(o) {
                                var data = o.data.models[0];
                                data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                                data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);

                                $http.put('/api/product-prices', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                vm.initialGridData = data.content;
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    startedDate: {type: 'date', defaultValue: "", nullable: true, validation: { customValidation: vm.dateValidation }},
                                    endedDate: {type: 'date', defaultValue: "", nullable: true, validation: { customValidation: vm.dateValidation }},
                                    retailPrice: { editable: true, nullable: true, type: "number" },
                                    wholesalePrice: { editable: true, nullable: true, type: "number"},
                                    costPrice: { editable: true, nullable: true, type: "number"}
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"}],
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {
                            field: "startedDate",
                            title: "Ημερομηνία Από",
                            template: "#= startedDate == null ? '' : kendo.toString(kendo.parseDate(startedDate), 'dddd, dd/MM/yyyy')#",
                            filterable: {
                                cell: {
                                    operator: "eqdateonly",
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "endedDate",
                            title: "Ημερομηνία Εως",
                            template: "#= endedDate == null ? '' : kendo.toString(kendo.parseDate(endedDate), 'dddd, dd/MM/yyyy')#",
                            filterable: {
                                cell: {
                                    operator: "eqdateonly",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "retailPrice", title: "Τιμή Λιανικής", template: "#= (retailPrice == null) ? ' ' : kendo.format('{0:c2}', retailPrice)#",
                            editor: function(container,options){

                                angular.element('<input data-bind="value: retailPrice">')
                                    .appendTo(container)
                                    .kendoNumericTextBox({format:"{0:c2}", min: 0});
                            },
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({format: "{0:c2}"});
                                    },
                                    showOperators: false
                                }
                            }},
                        {field: "wholesalePrice", title: "Τιμή Χονδρικής", template: "#= (wholesalePrice == null) ? ' ' : kendo.format('{0:c2}', wholesalePrice)#",
                            editor: function(container,options){

                                angular.element('<input data-bind="value: wholesalePrice">')
                                    .appendTo(container)
                                    .kendoNumericTextBox({format:"{0:c2}", min: 0});
                            },
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "{0:c2}"
                                        });
                                    },
                                    showOperators: false
                                }
                            }},
                        {field: "costPrice", title: "Τιμή Κόστους", template: "#= (costPrice == null) ? ' ' : kendo.format('{0:c2}', costPrice)#",
                            editor: function(container,options){

                                angular.element('<input data-bind="value: costPrice">')
                                    .appendTo(container)
                                    .kendoNumericTextBox({format:"{0:c2}", min: 0});
                            },
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "{0:c2}"
                                        });
                                    },
                                    showOperators: false
                                }
                            }},
                        {
                            command:[ {name:"edit", text: "Επεξεργασία"}],
                            title: "&nbsp;"
                        }
                    ],
                    editable: "popup",
                    edit: function(e) {
                        vm.editRow = e.model;
                        var updateBtnTxt = "Αποθήκευση",
                            cancelBtnTxt = "Ακύρωση",
                            curr_container = this._editContainer;

                        var validator = this.editable.validatable;

                        e.container.find("[name=startedDate]").change(function() {
                            validator.validateInput($("[name=endedDate]"));
                        });

                        e.container.find("[name=endedDate]").change(function() {
                            validator.validateInput($("[name=startedDate]"));
                        });

                        //sets the text of the "Update" button
                        $(curr_container).find("a.k-grid-update").text(updateBtnTxt);
                        //sets the text of the "Cancel" button
                        $(curr_container).find("a.k-grid-cancel").text(cancelBtnTxt);
                    }
                };
            }
        };

    }
})();
;
/**
 * Created by gmogas on 31/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('productLots', {
                parent: 'masterData',
                url: '/productLots',
                data: {
                    authorities: ['ROLE_SYSTEM','ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/productLots/productLots.html',
                        controller: 'ProductLotsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 31/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotsController', ProductLotsController);

    ProductLotsController.$inject = ['KendoGrid', 'KendoNotifications', '$http', '$filter', 'KendoFilter', 'ApplicationParameters', 'CustomUtils'];

    function ProductLotsController (KendoGrid, KendoNotifications, $http, $filter, KendoFilter, ApplicationParameters, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.productLots.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(67);
        ApplicationParameters.hasModule('Purchase_Pharmacies', true);

        vm.onAddProductLotClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.productsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/products',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.errorPopup = function(response) {
            var centered = $("#centeredNotification").kendoNotification({
                stacking: "down",
                autoHideAfter: 0,
                show: KendoNotifications.onShow,
                button: true,
                hideOnClick: false,
                width: 500,
                height: 250
            }).data("kendoNotification");

            centered.show(' ' + $filter('translate')('masterData.messages.error.'
                    + response.params[0] + ' ') + ': '  + response.params[1], "error"); //.split(" ")[0]
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/product-lots/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        if(!data.product.id)
                            data.product = null;

                        $http.post('/api/product-lots', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                                vm.errorPopup(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];

                        if(!data.product.id)
                            data.product = null;

                        $http.put('/api/product-lots', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                                vm.errorPopup(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function (item) {
                                if (item.product === null) item.product = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            product:{defaultValue: {id: null, name : null}},
                            referenceNumber: { validation: { required: true , referenceNumbervalidation: function (input) {
                                if (input.is("[name='referenceNumber']") && input.val() !== "") {
                                    input.attr("data-referenceNumbervalidation-msg", "Χρησιμοποιήστε μόνο λατινικούς χαρακτήρες");
                                    return /^[a-zA-Z0-9-]+$/.test(input.val());
                                }
                                return true;
                            }} },
                            expirationMonth: {  },
                            fromIdNumber: {  },
                            toIdNumber: {  },
                            registrationDate: { type: 'date' }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Παρτίδες Προιόντων", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Παρτίδες Προιόντων",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Παρτίδες Προιόντων"
            },
            height: vm.contentHeight,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "referenceNumber", title: "Αριθμός Παρτίδας",
                    filterable: {
                        cell:
                        {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.name",
                    title: "Όνομα είδους",
                    editor: function(container, options) {
                        angular.element('<select id="product" data-bind="value:product.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.productsDataSource,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 145
                },

                {
                    field: "expirationMonth", title: "Ημερομηνία λήξης",
                    filterable: {
                        cell:
                        {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "fromIdNumber", title: "Από ταινία γνησιότητας",
                    filterable: {
                        cell:
                        {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "toIdNumber", title: "Εως ταινία γνησιότητας",
                    filterable: {
                        cell:
                        {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "registrationDate",
                    title: "Ημερομηνία καταχώρησης",
                    template: "#= registrationDate == null ? '' : kendo.toString(kendo.parseDate(registrationDate), 'dddd, dd/MM/yyyy')#",
                    filterable: false
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };
    }
})();
;
/**
 * Created by gmogas on 31/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('productLotMass', {
                parent: 'masterData',
                url: '/productLotMass',
                data: {
                    authorities: ['ROLE_SYSTEM','ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/productLotMass/productLotMass.html',
                        controller: 'ProductLotMassController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 31/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotMassController', ProductLotMassController);

    ProductLotMassController.$inject = ['$scope', '$timeout', '$http', '$filter', 'ApplicationParameters', 'KendoNotifications'];

    function ProductLotMassController ($scope, $timeout, $http, $filter, ApplicationParameters, KendoNotifications) {
        var vm = this;
        var ALLOWED_EXTENSIONS = [".xlsx"];
        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        //material design to kendo upload button
        $timeout(function () {
            var uploadButton = $(".form-group .k-upload-button");
            uploadButton.removeClass("k-button");
            uploadButton.addClass("md-raised md-primary md-button");
            $(".form-group .k-widget.k-upload").addClass("upload-btn-background");
            uploadButton.prepend($('<md-icon ng-bind="&quot;file_upload&quot;" class="ng-binding material-icons">file_upload</md-icon>'));

        },100);

        vm.onSelect = function(e) {
            var extension = e.files[0].extension.toLowerCase();
            if (ALLOWED_EXTENSIONS.indexOf(extension) == -1) {
                alert("Please, select a supported file format");
                e.preventDefault();
            }
            // Load the converted document into the spreadsheet
            var spreadsheet = $("#spreadsheet").data("kendoSpreadsheet");
            spreadsheet.fromFile(e.files[0].rawFile);
        };

        vm.save = function () {
            var spreadsheet = $("#spreadsheet").data("kendoSpreadsheet");
            var spreadsheetData = spreadsheet.toJSON();
            var data = [];
            // extract data from json
            spreadsheetData.sheets[0].rows.forEach(function (row) {
                // prevent getting the header row
                if (row.index != 0) {
                    var productLot = {};
                    // starting to extract the objects
                    row.cells.forEach(function (cell) {
                        switch(cell.index) {
                            case 0:
                                productLot.barcode = cell.value;
                                break;
                            case 2:
                                productLot.referenceNumber = cell.value;
                                break;
                            case 3:
                                productLot.expirationMonth = cell.value;
                                break;
                            case 5:
                                productLot.fromIdNumber = cell.value;
                                break;
                            case 6:
                                productLot.toIdNumber = cell.value;
                                break;
                            case 7:
                                var rd = new Date('1900-01-01');
                                rd.setDate(rd.getDate() + cell.value -2);
                                productLot.registrationDate = rd.getDate() + '/' + (rd.getMonth() + 1) + '/' + rd.getFullYear();
                                break;
                            default:
                                break;
                        }
                    });
                    data.push(productLot);
                }
            });

            var req = {
                method: 'POST',
                url: 'api/product-lots/import',
                data: data
            };

            $http(req).then(function(){
                $scope.notification.show("Το ανέβασμα του αρχείου ολοκληρώθηκε με επιτυχία", "success");
            }, function(response){
                var centered = $("#centeredNotification").kendoNotification({
                    stacking: "down",
                    autoHideAfter: 0,
                    show: KendoNotifications.onShow,
                    button: true,
                    hideOnClick: false,
                    width: 500,
                    height: 250
                }).data("kendoNotification");

                centered.show(' ' + $filter('translate')('masterData.messages.error.'
                        + response.data.params[0] + ' ') + ': '  + response.data.params[1], "error"); //.split(" ")[0]
            });
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('productCategories', {
            parent: 'masterData',
            url: '/productCategories',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/productCategories/productCategories.html',
                    controller: 'MDProductCategoriesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDProductCategoriesController', MDProductCategoriesController);

    MDProductCategoriesController.$inject = ['$scope', '$state', '$http', '$filter', 'KendoFilter', 'ApplicationParameters', 'KendoGrid', 'CustomUtils'];

    function MDProductCategoriesController ($scope, $state, $http, $filter, KendoFilter, ApplicationParameters, KendoGrid, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(67);

        vm.pageHeading = $filter('translate')('masterData.productCategories.title');

        vm.numberEditor = function(container, options) {
            $('<input name="' + options.field + '"/>')
                .appendTo(container)
                .kendoNumericTextBox({
                    format: "{0:n0}"
                });
        };

        vm.onAddProductLotClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/product-categories',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/product-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/product-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            shortName: { validation: { required: true , validation: { required: true, min: 3}} },
                            isSalesCategory: { type: "boolean" },
                            sortOrder: { type: "number", format: "{n0}", max: 0 },
                            activeSubstance: { validation: { required: false , validation: { required: true, min: 3}} },
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Κατηγορίες Προιόντων", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Κατηγορίες Προιόντων",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Κατηγορίες Προιόντων"
            },
            height: vm.contentHeight,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Κατηγορία Προϊόντος",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.isSalesCategory" ' +
                'ng-disabled="true"></md-checkbox>',
                    field: "isSalesCategory", title: "Κατηγορία για πώληση",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }},
                {
                    field: "sortOrder", title: "Σειρά Εμφάνισης",
                    template: "#= (sortOrder == null) ? ' ' : kendo.format('{0:n0}', sortOrder)#",
                    editor: vm.numberEditor,
                    filterable: {
                        cell: {
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:n0}"
                                });
                            },
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            dataBound: function() {
                var grid = $('#mainGrid').data('kendoGrid');

                ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
                    if (response.data.content[0].value != 1) {
                        angular.forEach( grid.columns, function (item, index) {
                            if( item.field == "sortOrder" || item.field == "isSalesCategory") {
                                grid.hideColumn(index);
                            }
                        });
                    }
                });
            },
            edit: function(e) {

                KendoGrid.defaultEditPopup(this._editContainer);

                ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
                    if (response.data.content[0].value != 1) {
                        //remove sortOrder
                        e.container.find("[data-container-for='sortOrder']").remove();
                        e.container.find("[for='sortOrder']").parent().remove();

                        //remove isSalesCategory
                        e.container.find("[data-container-for='isSalesCategory']").remove();
                        e.container.find("[for='isSalesCategory']").parent().remove();
                    }
                });
            },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('presentLists', {
            parent: 'masterData',
            url: '/presentLists',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/presentLists/presentLists.html',
                    controller: 'MDPresentListsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPresentListsController', MDPresentListsController);

    MDPresentListsController.$inject = ['$scope', 'ApplicationParameters', '$http', '$filter', 'KendoFilter', 'KendoGrid', '$mdToast', 'Alerts', 'CustomUtils'];

    function MDPresentListsController ($scope, ApplicationParameters, $http, $filter, KendoFilter, KendoGrid, $mdToast, Alerts, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);
        vm.massSelect = true;
        vm.quantity = 1;
        vm.kendoGrid = KendoGrid;
        vm.pageHeading = $filter('translate')('masterData.presentLists.title');

        ApplicationParameters.hasModule('Purchase_Pharmacies', true);

        vm.productsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/products',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.onAddPresentListClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/present-lists/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/present-lists', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/present-lists', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            code: { validation: { required: true }},
                            selectable: { type:"boolean" }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Λίστες Δώρων", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Λίστες Δώρων",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Λίστες Δώρων"
            },
            height: vm.contentHeight,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "description", title: "Περιγραφή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.selectable" ' +
                'ng-disabled="true"></md-checkbox>',
                    field: "selectable", title: "Λίστα Επιλογής",
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.selectable"  aria-label="selectable" ' +
                            'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }},
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function(e) {
                e.model.dirty = true;
                KendoGrid.defaultEditPopup(this._editContainer);
            },
            editable: "popup"
        };

        vm.clearPopupWindow = function() {
            vm.quantity = 1;
            vm.selectedProducts = [];
            vm.newPresentListProducts = [];
            vm.selectedPresentList = null;
        };

        vm.openCustomPopup = function(presentList){
            vm.initPopupGrid = true;

            var wdw = angular.element("#popup-new-grid").data("kendoWindow");
            vm.clearPopupWindow();

            vm.selectedPresentList = presentList;
            wdw.center().open();
            vm.statusChanged = "opened";
        };

        vm.closeCustomPopup = function() {
            var wdw = angular.element("#popup-new-grid").data("kendoWindow");
            delete vm.initPopupGrid;
            wdw.close();
            vm.statusChanged = "closed";
        };

        vm.savePresentListProducts = function() {
            var wdw = angular.element("#popup-new-grid").data("kendoWindow");

            vm.newPresentListProducts = [];
            vm.selectedProducts.forEach(function(item,index){
                vm.newPresentListProducts.push({
                    id: null,
                    presentList: {
                        id: vm.selectedPresentList.id
                    },
                    product: {
                        id: item.id
                    },
                    quantity: vm.quantity
                });
            });

            const listSize = vm.newPresentListProducts.length;
            $http.post('api/present-list-products/mass',  vm.newPresentListProducts)
                .success(function (response) {
                    KendoGrid.refresh(angular.element("#detailGrid").data("kendoGrid"));
                    wdw.close();
                    if (response.length === 0) {
                        Alerts.showAlert("Sigma SalesForce", "Δεν προστέθηκε κανένα Προϊον επειδή όλα τα Προϊοντα που επιλέξατε υπάρχουν ήδη στη λίστα δώρων.", "ΟΚ");
                    }else if (response.length < listSize) {
                        Alerts.showAlert("Sigma SalesForce", "Προστέθηκαν " + response.length + " από " + listSize + " Προϊοντα. Τα υπόλοιπα Προϊοντα δεν προτέθηκαν επειδή υπάρχουν ήδη στη λίστα δώρων.", "ΟΚ");
                    }else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Επιτυχής Προσθήκη')
                                .position('bottom right')
                                .hideDelay(2500));
                    }
                })
                .error(function (response) {
                    console.log(response);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Κάποιο σφάλμα προέκυψε κατά την προσθήκη Προϊοντων στη λίστα δώρων')
                            .position('bottom right')
                            .hideDelay(2500));
                });
            vm.statusChanged = "saved";
        };

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem !== undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "presentList.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/present-list-products/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            create: function(o) {
                                var data = o.data.models[0];
                                data.presentList = {id : dataItem.id};

                                $http.post('/api/present-list-products', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                        $mdToast.show(
                                            $mdToast.simple()
                                                .textContent('Επιτυχής προσθήκη')
                                                .position('bottom right')
                                                .hideDelay(2500));
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                        o.error(response);
                                        $mdToast.show(
                                            $mdToast.simple()
                                                .textContent($filter('translate')('global.messages.error.' + response.message))
                                                .position('bottom right')
                                                .hideDelay(2500));
                                    });
                            },
                            update: function(o) {
                                var data = o.data.models[0];
                                console.log(data);

                                $http.put('/api/present-list-products', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                        $mdToast.show(
                                            $mdToast.simple()
                                                .textContent('Επιτυχής ενημέρωση')
                                                .position('bottom right')
                                                .hideDelay(2500));
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                        o.error(response);
                                        $mdToast.show(
                                            $mdToast.simple()
                                                .textContent($filter('translate')('global.messages.error.' + response.message))
                                                .position('bottom right')
                                                .hideDelay(2500));
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    product: { defaultValue: {}},
                                    quantity: { editable: true, nullable: true, type: "number" },
                                    active: { editable: true, type: 'boolean' }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    toolbar: [{ name: "custom-add",
                        text: "Προσθήκη Νέου Προιόν στη Λίστα",
                        template: "<input type='button' class='k-button' value = 'Προσθήκη Νέου Προιόν στη Λίστα' ng-click='vm.openCustomPopup(dataItem)' />" }],
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {field: "product.name", title: "Προϊόν",
                            editor: function(container, options) {
                                angular.element('<select id="product-name" data-bind="value:product.id" k-ng-model="product"></select>')
                                    .appendTo(container)
                                    .kendoComboBox({
                                        dataSource: vm.productsDataSource,
                                        filter: "startswith",
                                        change: function(e) {
                                            var index = e.sender.selectedIndex;
                                            $('#product-code').data('kendoComboBox').select(index);
                                        },
                                        valuePrimitive: true,
                                        dataTextField: "name",
                                        dataValueField: "id"
                                    });
                            },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }},
                        {field: "product.code", title: "Κωδικός Είδους",
                            editor: function(container, options) {
                                angular.element('<select id="product-code" data-bind="value:product.code"></select>')
                                    .appendTo(container)
                                    .kendoComboBox({
                                        dataSource: vm.productsDataSource,
                                        enable: false,
                                        dataTextField: "code"
                                    });
                            },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }},
                        {field: "quantity", title: "Ποσότητα",
                            template: "#= (quantity == null) ? ' ' : kendo.format('{0:n0}', quantity)#",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "{0:n0}"
                                        });
                                    },
                                    showOperators: false
                                }
                            }},
                        {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.active" ' +
                            'ng-disabled="true"></md-checkbox>',
                            field: "active", title: "Ενεργό",
                            editor: function(container,options){
                                angular.element('<md-checkbox ng-model="dataItem.active"  aria-label="active" ' +
                                    'class="checkbox-toolbar customers green inline"></md-checkbox>')
                                    .appendTo(container);
                            },
                            filterable: {
                                cell: {
                                    operator: "eqbool",
                                    template: function (args) {
                                        args.element.kendoDropDownList({
                                            autoBind:false,
                                            dataTextField: "text",
                                            dataValueField: "value",
                                            dataSource: new kendo.data.DataSource({
                                                data: [{ text: "Ναι", value: "true" },
                                                    { text: "Όχι", value: "false" }]
                                            }),
                                            valuePrimitive: true

                                        })
                                    },
                                    showOperators: false
                                }
                            }},
                        {
                            command:[ {name:"edit", text: "Επεξεργασία"}],
                            title: "&nbsp;"
                        }
                    ],
                    editable: "popup",
                    edit: function(e) {
                        vm.editRow = e.model;
                        e.model.dirty = true;

                        var updateBtnTxt = "Αποθήκευση",
                            cancelBtnTxt = "Ακύρωση",
                            curr_container = this._editContainer;

                        //sets the text of the "Update" button
                        $(curr_container).find("a.k-grid-update").text(updateBtnTxt);
                        //sets the text of the "Cancel" button
                        $(curr_container).find("a.k-grid-cancel").text(cancelBtnTxt);
                    }
                };
            }
        };

        vm.selectedProducts = [];
        vm.popupProductsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/products',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            scrolable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {field: "name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "code", title: "Κωδικός Είδους",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }}
            ],
            selectedItems: function(dataItems) {
                vm.selectedProducts = dataItems;
            },
            dataBound: function (e) {
                angular.element("#popupProductsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedProducts) {
                    var selectedProductsViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedProducts, {id: item.id}, true)[0];
                        if(vm.selectedProducts.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedProductsViewCounter++
                        }
                    });
                    if(selectedProductsViewCounter == view.length) {
                        angular.element("#popupProductsGridcheckbox").prop('checked', true);
                    }
                }
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prefectures', {
            parent: 'masterData',
            url: '/prefectures',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/prefectures/prefectures.html',
                    controller: 'MDPrefectureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPrefectureController', MDPrefectureController);

    MDPrefectureController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDPrefectureController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.prefectures.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/prefectures',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/prefectures', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/prefectures', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({field: "prefecture.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/masterdata/cities',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            create: function(o) {
                                var data = o.data.models[0];
                                data.prefecture = {id : dataItem.id};

                                $http.post('/api/cities', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            update: function(o) {
                                var data = o.data.models[0];
                                $http.put('/api/cities', data)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#detailGrid").data("kendoGrid").dataSource.read();
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            parameterMap: function (data, operation) {
                                if (operation !== 'read') {
                                    return JSON.stringify(data.models);
                                } else {
                                    return data;
                                }
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    name: { validation: { required: true , validation: { required: true, min: 3}} }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"}],
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        { field: "name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }},
                        {
                            field: "nameEn", title: "Όνομα (Αγγλικά)",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            command:[ {name:"edit", text: "Επεξεργασία"}],
                            title: "&nbsp;"
                        }
                    ],
                    editable: "popup",
                    edit: function() { KendoGrid.defaultEditPopup(this._editContainer); }
                };
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paymentMethods', {
            parent: 'masterData',
            url: '/paymentMethods',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/paymentMethods/paymentMethods.html',
                    controller: 'MDPaymentMethodsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPaymentMethodsController', MDPaymentMethodsController);

    MDPaymentMethodsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDPaymentMethodsController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.paymentMethods.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/payment-methods/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/payment-methods', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/payment-methods', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            code: { editable: true }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patchItems', {
            parent: 'masterData',
            url: '/patchItems',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/patchItems/patchItems.html',
                    controller: 'MDPatchItemsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDPatchItemsController', MDPatchItemsController);

    MDPatchItemsController.$inject = ['$scope', '$state', '$http', '$filter', 'KendoFilter'];

    function MDPatchItemsController ($scope, $state, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.patchItems.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/patch-items',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: true}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "legacyCode", title: "legacyCode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            editable: false
        };

    }
})();
;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('nativeLanguages', {
                parent: 'masterData',
                url: '/nativeLanguages',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/nativeLanguages/nativeLanguages.html',
                        controller: 'MDNativeLanguagesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDNativeLanguagesController', MDNativeLanguagesController);

    MDNativeLanguagesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDNativeLanguagesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.nativeLanguages.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/native-languages/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/native-languages', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/native-languages', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('measurementUnits', {
            parent: 'masterData',
            url: '/measurementUnits',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/measurementUnits/measurementUnits.html',
                    controller: 'MDMeasurementUnitsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDMeasurementUnitsController', MDMeasurementUnitsController);

    MDMeasurementUnitsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDMeasurementUnitsController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.measurementUnits.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/measurement-units',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/measurement-units', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/measurement-units', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('materialCategories', {
            parent: 'masterData',
            url: '/materialCategories',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/materialCategories/materialCategories.html',
                    controller: 'MDMaterialCategoriesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDMaterialCategoriesController', MDMaterialCategoriesController);

    MDMaterialCategoriesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDMaterialCategoriesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.materialCategories.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/patch-report-material-categories',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/patch-report-material-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/patch-report-material-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: true},
                            name: {validation: {required: true, validation: {required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('masterData', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadParameters', {
                parent: 'masterData',
                url: '/leadParameters',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/leadParameters/leadParameters.html',
                        controller: 'MDLeadParametersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDLeadParametersController', MDLeadParametersController);

    MDLeadParametersController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'LeadParameter'];

    function MDLeadParametersController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, LeadParameter) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.leadParameters.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/lead-parameters/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        LeadParameter.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        LeadParameter.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalizationTypes', {
            parent: 'masterData',
            url: '/hospitalizationTypes',
            data: {
                authorities: ['ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/hospitalizationTypes/hospitalizationTypes.html',
                    controller: 'MDHospitalizationTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDHospitalizationTypesController', MDHospitalizationTypesController);

    MDHospitalizationTypesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'HospitalizationType'];

    function MDHospitalizationTypesController (KendoGrid, $http, $filter, KendoFilter, KendoService, HospitalizationType) {
        var vm = this;
        vm.dataSource = {};
        vm.dataSource.parentHospitalizationTypes = KendoService.initDefaultDataSource('/api/masterdata/hospitalization-type-parents');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.hospitalizationTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/hospitalization-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        HospitalizationType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        HospitalizationType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if (!item.hospitalizationTypeParent) item.hospitalizationTypeParent = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            hospitalizationTypeParent: {defaultValue:  { name: "" }},
                            'hospitalizationTypeParent.name': { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "hospitalizationTypeParent.name",
                    title: "Κύριος Τύπος Ασφάλισης",
                    editor: function(container, options) {
                        angular.element('<select id="hospitalizationTypeParent" data-bind="value:hospitalizationTypeParent.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.dataSource.parentHospitalizationTypes,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Teo on 27/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationTypeParents', {
                parent: 'masterData',
                url: '/hospitalizationTypeParents',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/hospitalizationTypeParents/hospitalizationTypeParents.html',
                        controller: 'MDHospitalizationTypeParentsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 27/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDHospitalizationTypeParentsController', MDHospitalizationTypeParentsController);

    MDHospitalizationTypeParentsController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'HospitalizationTypeParent'];

    function MDHospitalizationTypeParentsController (KendoGrid, $http, $filter, KendoFilter, HospitalizationTypeParent) {
        console.log("MDHospitalizationTypeParentsController");
        var vm = this;

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.hospitalizationTypeParents.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/masterdata/hospitalization-type-parents',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        HospitalizationTypeParent.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        HospitalizationTypeParent.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('followupTypes', {
                parent: 'masterData',
                url: '/followupTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/followupTypes/followupTypes.html',
                        controller: 'MDFollowupTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDFollowupTypesController', MDFollowupTypesController);

    MDFollowupTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'FollowupType'];

    function MDFollowupTypesController ($scope, KendoGrid, $http, $filter, KendoFilter, FollowupType) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.followupTypes.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/followup-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        FollowupType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        FollowupType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('eventTypes', {
            parent: 'masterData',
            url: '/eventTypes',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/eventTypes/eventTypes.html',
                    controller: 'MDEventTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDEventTypesController', MDEventTypesController);

    MDEventTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDEventTypesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.eventTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/event-types',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/event-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/event-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('eventStatuses', {
            parent: 'masterData',
            url: '/eventStatuses',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/eventStatuses/eventStatuses.html',
                    controller: 'MDEventStatusesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDEventStatusesController', MDEventStatusesController);

    MDEventStatusesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDEventStatusesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.eventStatuses.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/event-statuses',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/event-statuses', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/event-statuses', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('eventPlaces', {
            parent: 'masterData',
            url: '/eventPlaces',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/eventPlaces/eventPlaces.html',
                    controller: 'MDEventPlacesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDEventPlacesController', MDEventPlacesController);

    MDEventPlacesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDEventPlacesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.eventPlaces.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/event-places',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/event-places', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/event-places', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('doctorSpecialties', {
            parent: 'masterData',
            url: '/doctorSpecialties',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/doctorSpecialties/doctorSpecialties.html',
                    controller: 'MDDoctorSpecialtiesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDDoctorSpecialtiesController', MDDoctorSpecialtiesController);

    MDDoctorSpecialtiesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'CustomUtils'];

    function MDDoctorSpecialtiesController ($scope, KendoGrid, $http, $filter, KendoFilter, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.doctorSpecialties.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddDoctorSpecialtyClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/doctor-specialties',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/doctor-specialties', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/doctor-specialties', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Ειδικότητες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Ειδικότητες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Ειδικότητες"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };
    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('diseaseTypes', {
                parent: 'masterData',
                url: '/diseaseTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/diseaseTypes/diseaseTypes.html',
                        controller: 'MDDiseaseTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDDiseaseTypesController', MDDiseaseTypesController);

    MDDiseaseTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'DiseaseType'];

    function MDDiseaseTypesController ($scope, KendoGrid, $http, $filter, KendoFilter, DiseaseType) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.diseaseTypes.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/disease-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        DiseaseType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        DiseaseType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            sortOrder: {
                                type: "number",
                                format: "{0:d}"
                            }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "advantages", title: "Πλεονεκτήματα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "offer", title: "Προσφορά",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "documents", title: "Έγγραφα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sortOrder", title: "Σειρά Εμφάνισης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('diseases', {
                parent: 'masterData',
                url: '/diseases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/diseases/diseases.html',
                        controller: 'MDDiseasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDDiseasesController', MDDiseasesController);

    MDDiseasesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'Disease'];

    function MDDiseasesController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, Disease) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.diseases.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/diseases/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        Disease.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        Disease.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            diseaseType: { defaultValue: null }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "diseaseType", title: "Κατηγορία",
                    template: "#= diseaseType ? diseaseType.name : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    editor: function(container) {
                        //diseaseType combobox edit configuration
                        dataSource.diseaseType = KendoService.initDataSource('/api/disease-types/search', 1, 50);
                        vm.diseaseTypeOptions = KendoService.initDefaultOptions(dataSource.diseaseType, "startswith", "name", "id", false);

                        angular.element('<select id="diseaseType" data-bind="value:diseaseType" ' +
                            'kendo-combo-box k-options="vm.diseaseTypeOptions"></select>')
                            .appendTo(container)
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('discountReasons', {
                parent: 'masterData',
                url: '/discountReasons',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/discountReasons/discountReasons.html',
                        controller: 'MDDiscountReasonsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDDiscountReasonsController', MDDiscountReasonsController);

    MDDiscountReasonsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'DiscountReason'];

    function MDDiscountReasonsController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, DiscountReason) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.discountReasons.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/discount-reasons/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        DiscountReason.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        DiscountReason.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('discountRates', {
                parent: 'masterData',
                url: '/discountRates',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/discountRates/discountRates.html',
                        controller: 'MDDiscountRatesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDDiscountRatesController', MDDiscountRatesController);

    MDDiscountRatesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'DiscountRate'];

    function MDDiscountRatesController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, DiscountRate) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.discountRates.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/discount-rates/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        DiscountRate.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        DiscountRate.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            value: { type: "number" }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "value", title: "Τιμή",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:n0}"
                                });
                            },
                            showOperators: false
                        }
                    },
                    attributes:{style:"text-align:right;"},
                    template: "#= (value == null) ? '' : kendo.format('{0:p}', value / 100)#"
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Maria on 13/6/2016.
 */

/**
 * Created by Maria on 13/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerTitles', {
                parent: 'masterData',
                url: '/customerTitles',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/customerTitles/customerTitles.html',
                        controller: 'MDCustomerTitlesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Maria on 13/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCustomerTitlesController', MDCustomerTitlesController);

    MDCustomerTitlesController.$inject = ['$scope', '$state', '$http', '$filter', 'KendoFilter', 'KendoGrid', 'CustomUtils'];

    function MDCustomerTitlesController ($scope, $state, $http, $filter, KendoFilter, KendoGrid, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.customerTitles.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddTitleClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/customer-titles',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/customer-titles', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/customer-titles', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Τίτλοι", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Τίτλοι",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Τίτλοι"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customerCategories', {
            parent: 'masterData',
            url: '/customerCategories',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/customerCategories/customerCategories.html',
                    controller: 'MDCustomerCategoriesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCustomerCategoriesController', MDCustomerCategoriesController);

    MDCustomerCategoriesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'CustomUtils'];

    function MDCustomerCategoriesController ($scope, KendoGrid, $http, $filter, KendoFilter, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(31);

        vm.pageHeading = $filter('translate')('masterData.customerCategories.title');
        vm.secondPageHeading = $filter('translate')('masterData.customerCategories.secondTitle');

        vm.numberEditor = function(container, options) {
            $('<input name="' + options.field + '"/>')
                .appendTo(container)
                .kendoNumericTextBox({
                    format: "{0:n0}"
                });
        };

        vm.onAddCategoryClick = function () {
            const grid = $("#mainCategoriesGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainCategoriesGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/customer-categories',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/customer-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainCategoriesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/customer-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainCategoriesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            circleDaysNo: { type: "number", format: "{n0}" },
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Κατηγορίες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Κατηγορίες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Κατηγορίες"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "circleDaysNo", title: "Κύκλος Ενημέρωσης",
                    template: "#= (circleDaysNo == null) ? ' ' : kendo.format('{0:n0}', circleDaysNo)#",
                    editor: vm.numberEditor,
                    filterable: {
                        cell: {
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "{0:n0}"
                                });
                            },
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

        vm.onAddSubcategoryClick = function () {
            const grid = $("#mainSubcategoriesGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainSubcategoriesGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/customer-sub-categories',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/customer-sub-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainSubcategoriesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/customer-sub-categories', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainSubcategoriesGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} ΥποΚατηγορίες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν ΥποΚατηγορίες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν ΥποΚατηγορίες"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα Υποκατηγορίας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },

                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('costTypes', {
                parent: 'masterData',
                url: '/costTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/costTypes/costTypes.html',
                        controller: 'MDCostTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCostTypesController', MDCostTypesController);

    MDCostTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'CostType'];

    function MDCostTypesController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, CostType) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.costTypes.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/cost-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        CostType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        CostType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('competitors', {
                parent: 'masterData',
                url: '/competitors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/competitors/competitors.html',
                        controller: 'MDCompetitorsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCompetitorsController', MDCompetitorsController);

    MDCompetitorsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'Competitor'];

    function MDCompetitorsController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, Competitor) {
        var vm = this;
        vm.pageHeading = $filter('translate')('masterData.competitors.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/competitors/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        Competitor.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        Competitor.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communicationTypes', {
            parent: 'masterData',
            url: '/communicationTypes',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/communicationTypes/communicationTypes.html',
                    controller: 'MDCommunicationTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCommunicationTypesController', MDCommunicationTypesController);

    MDCommunicationTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDCommunicationTypesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.communicationTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/communication-types',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/communication-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/communication-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Teo on 23/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communicationStatuses', {
                parent: 'masterData',
                url: '/communicationStatuses',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/communicationStatuses/communicationStatuses.html',
                        controller: 'MDCommunicationStatusesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 23/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCommunicationStatusesController', MDCommunicationStatusesController);

    MDCommunicationStatusesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'CommunicationStatus'];

    function MDCommunicationStatusesController ($scope, KendoGrid, $http, $filter, KendoFilter, KendoService, CommunicationStatus) {
        var vm = this;
        var dataSource = {};
        vm.pageHeading = $filter('translate')('masterData.communicationStatuses.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/masterdata/communication-statuses',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        CommunicationStatus.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        CommunicationStatus.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collaborations', {
            parent: 'masterData',
            url: '/collaborations',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/collaborations/collaborations.html',
                    controller: 'MDCollaborationsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCollaborationsController', MDCollaborationsController);

    MDCollaborationsController.$inject = ['Collaboration', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'CustomUtils'];

    function MDCollaborationsController (Collaboration, KendoGrid, $http, $filter, KendoFilter, CustomUtils) {
        var vm = this;

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.collaborations.title');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddCollaborationClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/collaborations/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        Collaboration.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        Collaboration.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Συνεργασίες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Συνεργασίες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Συνεργασίες"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clinicNames', {
            parent: 'masterData',
            url: '/clinicNames',
            data: {
                authorities: ['ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/clinicNames/clinicNames.html',
                    controller: 'MDClinicNamesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDClinicNamesController', MDClinicNamesController);

    MDClinicNamesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'ClinicName'];

    function MDClinicNamesController (KendoGrid, $http, $filter, KendoFilter, ClinicName) {
        var vm = this;

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.clinicNames.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/clinic-names/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        ClinicName.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        ClinicName.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('callTypes', {
                parent: 'masterData',
                url: '/callTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/callTypes/callTypes.html',
                        controller: 'MDCallTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 27/04/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDCallTypesController', MDCallTypesController);

    MDCallTypesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDCallTypesController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.callTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/call-types/search',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/call-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/call-types', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agreementValuations', {
            parent: 'masterData',
            url: '/agreementValuations',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/agreementValuations/agreementValuations.html',
                    controller: 'MDAgreementValuationsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDAgreementValuationsController', MDAgreementValuationsController);

    MDAgreementValuationsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter'];

    function MDAgreementValuationsController ($scope, KendoGrid, $http, $filter, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.agreementValuations.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/agreement-valuations',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        console.log(data)
                        $http.post('/api/agreement-valuations', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/agreement-valuations', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "nameEn", title: "Όνομα (Αγγλικά)",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('addDiseases', {
                parent: 'masterData',
                url: '/addDiseases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/addDiseases/addDiseases.html',
                        controller: 'MDAddDiseasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDAddDiseasesController', MDAddDiseasesController);

    MDAddDiseasesController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'AddDisease'];

    function MDAddDiseasesController ($scope, KendoGrid, $http, $filter, KendoFilter, AddDisease) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.addDiseases.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/add-diseases/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        AddDisease.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        AddDisease.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "information", title: "Πληροφορίες",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('addConditions', {
                parent: 'masterData',
                url: '/addConditions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/addConditions/addConditions.html',
                        controller: 'MDAddConditionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDAddConditionsController', MDAddConditionsController);

    MDAddConditionsController.$inject = ['$scope', 'KendoGrid', '$http', '$filter', 'KendoFilter', 'AddCondition'];

    function MDAddConditionsController ($scope, KendoGrid, $http, $filter, KendoFilter, AddCondition) {
        var vm = this;

        vm.pageHeading = $filter('translate')('masterData.addConditions.title');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };

                        $http.get('/api/add-conditions/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        AddCondition.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        AddCondition.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "information", title: "Πληροφορίες",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$http', '$mdDialog', 'ApplicationParameters'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $http, $mdDialog, ApplicationParameters) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.ApprovalsEnabled = false;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.customerView = '1';
        ApplicationParameters.hasModule('Customers_View', false).then(function(response) {
            vm.customerView  = response.data.content[0].value;
        });

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.onEventCycleClick = onEventCycleClick;
        vm.$state = $state;

        vm.productStates = ['products', 'productCategories', 'sortOrders', 'productLots', 'productLotMass'];
        vm.activeMasterDataState = activeMasterDataState;

        function activeMasterDataState() {
            var result = true;
            angular.forEach( vm.productStates, function ( item ) {
                if (vm.$state.includes(item)) {
                    result = false;
                }
            });
            return result;
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function onEventCycleClick(ev) {
            $mdDialog.show({
                controller: 'EventCycleMdDialogCtrl',
                templateUrl: 'app/components/event-cycle-md-dialog/event-cycle-md-dialog-template.html',
                clickOutsideToClose: false,
                targetEvent: ev
            });
        }

        vm.currentUser = {};
        vm.getCurrentUserInfo = function () {
            if (Principal.isAuthenticated()){
                vm.currentUser = Principal.identity();
            } else {
                vm.currentUser = {};
            }
        };

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.user = response;
            })
            .error(function (response) {
                console.log(response);
            });

        function getMenuVisibility (self) {
            var item = angular.element(self).children()[1];
            var left = item.offsetLeft;
            var width = item.offsetWidth;

            while (item.offsetParent) {
                item = item.offsetParent;
                left += item.offsetLeft;
            }

            return left >= window.pageXOffset &&
                (left + width) <= (window.pageXOffset + window.innerWidth);
        }

        //check submenu visibility
        angular.element(".dropdown-submenu").hover(
            function() {
                angular.element( this ).children().removeClass("navbar-pull-left");
                if (!getMenuVisibility( this )) {
                    var submenu = angular.element(".dropdown-submenu .dropdown-menu");
                    submenu.addClass( "navbar-pull-left" );
                }
            }, function() {}
        );

        //check menu visibility
        angular.element(".navbar").on('click', '.dropdown',
            function() {
                angular.element(this).children().removeClass("dropdown-pull-left");
                angular.element(this).addClass("open");

                if (!angular.element(this).find('.dropdown-submenu').length) {
                    if (!getMenuVisibility( this )) {
                        var submenu = angular.element(this).find(".dropdown-menu");
                        submenu.addClass("dropdown-pull-left");
                    }
                }
            }
        );


    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayDialogController', WorkingDayDialogController);

    WorkingDayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WorkingDay', 'CustomerSector'];

    function WorkingDayDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, WorkingDay, CustomerSector) {
        var vm = this;
        vm.workingDay = entity;
        vm.customersectors = CustomerSector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:workingDayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.workingDay.id !== null) {
                WorkingDay.update(vm.workingDay, onSaveSuccess, onSaveError);
            } else {
                WorkingDay.save(vm.workingDay, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayDetailController', WorkingDayDetailController);

    WorkingDayDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WorkingDay', 'CustomerSector'];

    function WorkingDayDetailController($scope, $rootScope, $stateParams, entity, WorkingDay, CustomerSector) {
        var vm = this;
        vm.workingDay = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:workingDayUpdate', function(event, result) {
            vm.workingDay = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayDeleteController',WorkingDayDeleteController);

    WorkingDayDeleteController.$inject = ['$uibModalInstance', 'entity', 'WorkingDay'];

    function WorkingDayDeleteController($uibModalInstance, entity, WorkingDay) {
        var vm = this;
        vm.workingDay = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WorkingDay.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('working-day', {
            parent: 'entity',
            url: '/working-day?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.workingDay.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/working-day/working-days.html',
                    controller: 'WorkingDayController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('workingDay');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('working-day-detail', {
            parent: 'entity',
            url: '/working-day/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.workingDay.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/working-day/working-day-detail.html',
                    controller: 'WorkingDayDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('workingDay');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'WorkingDay', function($stateParams, WorkingDay) {
                    return WorkingDay.get({id : $stateParams.id});
                }]
            }
        })
        .state('working-day.new', {
            parent: 'working-day',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/working-day/working-day-dialog.html',
                    controller: 'WorkingDayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                weekDayNo: null,
                                firstShiftFrom: null,
                                firstShiftTo: null,
                                secondShiftFrom: null,
                                secondShiftTo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('working-day', null, { reload: true });
                }, function() {
                    $state.go('working-day');
                });
            }]
        })
        .state('working-day.edit', {
            parent: 'working-day',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/working-day/working-day-dialog.html',
                    controller: 'WorkingDayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['WorkingDay', function(WorkingDay) {
                            return WorkingDay.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('working-day', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('working-day.delete', {
            parent: 'working-day',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/working-day/working-day-delete-dialog.html',
                    controller: 'WorkingDayDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['WorkingDay', function(WorkingDay) {
                            return WorkingDay.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('working-day', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('WorkingDay', WorkingDay);

    WorkingDay.$inject = ['$resource'];

    function WorkingDay ($resource) {
        var resourceUrl =  'api/working-days/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('WorkingDaySearch', WorkingDaySearch);

    WorkingDaySearch.$inject = ['$resource'];

    function WorkingDaySearch($resource) {
        var resourceUrl =  'api/_search/working-days/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayController', WorkingDayController);

    WorkingDayController.$inject = ['$scope', '$state', 'WorkingDay', 'WorkingDaySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WorkingDayController ($scope, $state, WorkingDay, WorkingDaySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                WorkingDaySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                WorkingDay.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.workingDays = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationDialogController', TransportationDialogController);

    TransportationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Transportation'];

    function TransportationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Transportation) {
        var vm = this;
        vm.transportation = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:transportationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.transportation.id !== null) {
                Transportation.update(vm.transportation, onSaveSuccess, onSaveError);
            } else {
                Transportation.save(vm.transportation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationDetailController', TransportationDetailController);

    TransportationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Transportation'];

    function TransportationDetailController($scope, $rootScope, $stateParams, entity, Transportation) {
        var vm = this;
        vm.transportation = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:transportationUpdate', function(event, result) {
            vm.transportation = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationDeleteController',TransportationDeleteController);

    TransportationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Transportation'];

    function TransportationDeleteController($uibModalInstance, entity, Transportation) {
        var vm = this;
        vm.transportation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Transportation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transportation', {
            parent: 'entity',
            url: '/transportation?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.transportation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transportation/transportations.html',
                    controller: 'TransportationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('transportation-detail', {
            parent: 'entity',
            url: '/transportation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.transportation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transportation/transportation-detail.html',
                    controller: 'TransportationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Transportation', function($stateParams, Transportation) {
                    return Transportation.get({id : $stateParams.id});
                }]
            }
        })
        .state('transportation.new', {
            parent: 'transportation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-dialog.html',
                    controller: 'TransportationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                cost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('transportation');
                });
            }]
        })
        .state('transportation.edit', {
            parent: 'transportation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-dialog.html',
                    controller: 'TransportationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Transportation', function(Transportation) {
                            return Transportation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transportation.delete', {
            parent: 'transportation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-delete-dialog.html',
                    controller: 'TransportationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Transportation', function(Transportation) {
                            return Transportation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Transportation', Transportation);

    Transportation.$inject = ['$resource'];

    function Transportation ($resource) {
        var resourceUrl =  'api/transportations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TransportationController', TransportationController);

    TransportationController.$inject = ['$scope', '$state', 'Transportation', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TransportationController ($scope, $state, Transportation, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Transportation.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transportations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectDialogController', TradePolicyRuleEffectDialogController);

    TradePolicyRuleEffectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicyRuleEffect', 'TradePolicyRule', 'Product', 'PresentList'];

    function TradePolicyRuleEffectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicyRuleEffect, TradePolicyRule, Product, PresentList) {
        var vm = this;
        vm.tradePolicyRuleEffect = entity;
        vm.tradepolicyrules = TradePolicyRule.query();
        vm.products = Product.query();
        vm.presentlists = PresentList.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyRuleEffectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicyRuleEffect.id !== null) {
                TradePolicyRuleEffect.update(vm.tradePolicyRuleEffect, onSaveSuccess, onSaveError);
            } else {
                TradePolicyRuleEffect.save(vm.tradePolicyRuleEffect, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectDetailController', TradePolicyRuleEffectDetailController);

    TradePolicyRuleEffectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TradePolicyRuleEffect', 'TradePolicyRule', 'Product', 'PresentList'];

    function TradePolicyRuleEffectDetailController($scope, $rootScope, $stateParams, entity, TradePolicyRuleEffect, TradePolicyRule, Product, PresentList) {
        var vm = this;
        vm.tradePolicyRuleEffect = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tradePolicyRuleEffectUpdate', function(event, result) {
            vm.tradePolicyRuleEffect = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectDeleteController',TradePolicyRuleEffectDeleteController);

    TradePolicyRuleEffectDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicyRuleEffect'];

    function TradePolicyRuleEffectDeleteController($uibModalInstance, entity, TradePolicyRuleEffect) {
        var vm = this;
        vm.tradePolicyRuleEffect = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicyRuleEffect.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-policy-rule-effect', {
            parent: 'entity',
            url: '/trade-policy-rule-effect?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRuleEffect.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule-effect/trade-policy-rule-effects.html',
                    controller: 'TradePolicyRuleEffectController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRuleEffect');
                    $translatePartialLoader.addPart('tradePolicyRuleEffectTypeEnum');
                    $translatePartialLoader.addPart('tradePolicyRuleEffectSeverityEnum');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trade-policy-rule-effect-detail', {
            parent: 'entity',
            url: '/trade-policy-rule-effect/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRuleEffect.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule-effect/trade-policy-rule-effect-detail.html',
                    controller: 'TradePolicyRuleEffectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRuleEffect');
                    $translatePartialLoader.addPart('tradePolicyRuleEffectTypeEnum');
                    $translatePartialLoader.addPart('tradePolicyRuleEffectSeverityEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TradePolicyRuleEffect', function($stateParams, TradePolicyRuleEffect) {
                    return TradePolicyRuleEffect.get({id : $stateParams.id});
                }]
            }
        })
        .state('trade-policy-rule-effect.new', {
            parent: 'trade-policy-rule-effect',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule-effect/trade-policy-rule-effect-dialog.html',
                    controller: 'TradePolicyRuleEffectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                effectType: null,
                                severity: null,
                                discountPercent: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule-effect', null, { reload: true });
                }, function() {
                    $state.go('trade-policy-rule-effect');
                });
            }]
        })
        .state('trade-policy-rule-effect.edit', {
            parent: 'trade-policy-rule-effect',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule-effect/trade-policy-rule-effect-dialog.html',
                    controller: 'TradePolicyRuleEffectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TradePolicyRuleEffect', function(TradePolicyRuleEffect) {
                            return TradePolicyRuleEffect.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule-effect', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trade-policy-rule-effect.delete', {
            parent: 'trade-policy-rule-effect',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule-effect/trade-policy-rule-effect-delete-dialog.html',
                    controller: 'TradePolicyRuleEffectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TradePolicyRuleEffect', function(TradePolicyRuleEffect) {
                            return TradePolicyRuleEffect.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule-effect', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TradePolicyRuleEffect', TradePolicyRuleEffect);

    TradePolicyRuleEffect.$inject = ['$resource'];

    function TradePolicyRuleEffect ($resource) {
        var resourceUrl =  'api/trade-policy-rule-effects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectController', TradePolicyRuleEffectController);

    TradePolicyRuleEffectController.$inject = ['$scope', '$state', 'TradePolicyRuleEffect', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TradePolicyRuleEffectController ($scope, $state, TradePolicyRuleEffect, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TradePolicyRuleEffect.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tradePolicyRuleEffects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleDialogController', TradePolicyRuleDialogController);

    TradePolicyRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicyRule', 'TradePolicy'];

    function TradePolicyRuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicyRule, TradePolicy) {
        var vm = this;
        vm.tradePolicyRule = entity;
        vm.tradepolicies = TradePolicy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicyRule.id !== null) {
                TradePolicyRule.update(vm.tradePolicyRule, onSaveSuccess, onSaveError);
            } else {
                TradePolicyRule.save(vm.tradePolicyRule, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleDetailController', TradePolicyRuleDetailController);

    TradePolicyRuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TradePolicyRule', 'TradePolicy'];

    function TradePolicyRuleDetailController($scope, $rootScope, $stateParams, entity, TradePolicyRule, TradePolicy) {
        var vm = this;
        vm.tradePolicyRule = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tradePolicyRuleUpdate', function(event, result) {
            vm.tradePolicyRule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleDeleteController',TradePolicyRuleDeleteController);

    TradePolicyRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicyRule'];

    function TradePolicyRuleDeleteController($uibModalInstance, entity, TradePolicyRule) {
        var vm = this;
        vm.tradePolicyRule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicyRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-policy-rule', {
            parent: 'entity',
            url: '/trade-policy-rule?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rules.html',
                    controller: 'TradePolicyRuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRule');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trade-policy-rule-detail', {
            parent: 'entity',
            url: '/trade-policy-rule/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-detail.html',
                    controller: 'TradePolicyRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRule');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TradePolicyRule', function($stateParams, TradePolicyRule) {
                    return TradePolicyRule.get({id : $stateParams.id});
                }]
            }
        })
        .state('trade-policy-rule.new', {
            parent: 'trade-policy-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-dialog.html',
                    controller: 'TradePolicyRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ruleType: null,
                                fromValue: null,
                                toValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('trade-policy-rule');
                });
            }]
        })
        .state('trade-policy-rule.edit', {
            parent: 'trade-policy-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-dialog.html',
                    controller: 'TradePolicyRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TradePolicyRule', function(TradePolicyRule) {
                            return TradePolicyRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trade-policy-rule.delete', {
            parent: 'trade-policy-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-delete-dialog.html',
                    controller: 'TradePolicyRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TradePolicyRule', function(TradePolicyRule) {
                            return TradePolicyRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TradePolicyRule', TradePolicyRule);

    TradePolicyRule.$inject = ['$resource'];

    function TradePolicyRule ($resource) {
        var resourceUrl =  'api/trade-policy-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleController', TradePolicyRuleController);

    TradePolicyRuleController.$inject = ['$scope', '$state', 'TradePolicyRule', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TradePolicyRuleController ($scope, $state, TradePolicyRule, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TradePolicyRule.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tradePolicyRules = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyDialogController', TradePolicyDialogController);

    TradePolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicy'];

    function TradePolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicy) {
        var vm = this;
        vm.tradePolicy = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicy.id !== null) {
                TradePolicy.update(vm.tradePolicy, onSaveSuccess, onSaveError);
            } else {
                TradePolicy.save(vm.tradePolicy, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyDetailController', TradePolicyDetailController);

    TradePolicyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TradePolicy'];

    function TradePolicyDetailController($scope, $rootScope, $stateParams, entity, TradePolicy) {
        var vm = this;
        vm.tradePolicy = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tradePolicyUpdate', function(event, result) {
            vm.tradePolicy = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyDeleteController',TradePolicyDeleteController);

    TradePolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicy'];

    function TradePolicyDeleteController($uibModalInstance, entity, TradePolicy) {
        var vm = this;
        vm.tradePolicy = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-policy', {
            parent: 'entity',
            url: '/trade-policy?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy/trade-policies.html',
                    controller: 'TradePolicyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trade-policy-detail', {
            parent: 'entity',
            url: '/trade-policy/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy/trade-policy-detail.html',
                    controller: 'TradePolicyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TradePolicy', function($stateParams, TradePolicy) {
                    return TradePolicy.get({id : $stateParams.id});
                }]
            }
        })
        .state('trade-policy.new', {
            parent: 'trade-policy',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-dialog.html',
                    controller: 'TradePolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                fromDate: null,
                                toDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('trade-policy');
                });
            }]
        })
        .state('trade-policy.edit', {
            parent: 'trade-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-dialog.html',
                    controller: 'TradePolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TradePolicy', function(TradePolicy) {
                            return TradePolicy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trade-policy.delete', {
            parent: 'trade-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy/trade-policy-delete-dialog.html',
                    controller: 'TradePolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TradePolicy', function(TradePolicy) {
                            return TradePolicy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TradePolicy', TradePolicy);

    TradePolicy.$inject = ['$resource', 'DateUtils'];

    function TradePolicy ($resource, DateUtils) {
        var resourceUrl =  'api/trade-policies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyController', TradePolicyController);

    TradePolicyController.$inject = ['$scope', '$state', 'TradePolicy', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TradePolicyController ($scope, $state, TradePolicy, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TradePolicy.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tradePolicies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempSectorDialogController', TempSectorDialogController);

    TempSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'TempSector', 'SectorType', 'DoctorSpecialty', 'Sector', 'CustomerSector', 'Country', 'Region', 'Prefecture', 'City', 'CompanyType', 'TaxOffice', 'TaxStatus', 'SectorCategory'];

    function TempSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, TempSector, SectorType, DoctorSpecialty, Sector, CustomerSector, Country, Region, Prefecture, City, CompanyType, TaxOffice, TaxStatus, SectorCategory) {
        var vm = this;
        vm.tempSector = entity;
        vm.sectortypes = SectorType.query();
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.sectors = Sector.query();
        vm.customersectors = CustomerSector.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.prefectures = Prefecture.query();
        vm.cities = City.query();
        vm.approvedsectors = Sector.query({filter: 'tempsector-is-null'});
        $q.all([vm.tempSector.$promise, vm.approvedsectors.$promise]).then(function() {
            if (!vm.tempSector.approvedSector || !vm.tempSector.approvedSector.id) {
                return $q.reject();
            }
            return Sector.get({id : vm.tempSector.approvedSector.id}).$promise;
        }).then(function(approvedSector) {
            vm.approvedsectors.push(approvedSector);
        });
        vm.companytypes = CompanyType.query();
        vm.taxoffices = TaxOffice.query();
        vm.taxstatuses = TaxStatus.query();
        vm.sectorcategories = SectorCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tempSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tempSector.id !== null) {
                TempSector.update(vm.tempSector, onSaveSuccess, onSaveError);
            } else {
                TempSector.save(vm.tempSector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issuedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempSectorDetailController', TempSectorDetailController);

    TempSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TempSector', 'SectorType', 'DoctorSpecialty', 'Sector', 'CustomerSector', 'Country', 'Region', 'Prefecture', 'City', 'CompanyType', 'TaxOffice', 'TaxStatus', 'SectorCategory'];

    function TempSectorDetailController($scope, $rootScope, $stateParams, entity, TempSector, SectorType, DoctorSpecialty, Sector, CustomerSector, Country, Region, Prefecture, City, CompanyType, TaxOffice, TaxStatus, SectorCategory) {
        var vm = this;
        vm.tempSector = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tempSectorUpdate', function(event, result) {
            vm.tempSector = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempSectorDeleteController',TempSectorDeleteController);

    TempSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'TempSector'];

    function TempSectorDeleteController($uibModalInstance, entity, TempSector) {
        var vm = this;
        vm.tempSector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TempSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-sector', {
            parent: 'entity',
            url: '/temp-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-sector/temp-sectors.html',
                    controller: 'TempSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-sector-detail', {
            parent: 'entity',
            url: '/temp-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-sector/temp-sector-detail.html',
                    controller: 'TempSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempSector');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempSector', function($stateParams, TempSector) {
                    return TempSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-sector.new', {
            parent: 'temp-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-dialog.html',
                    controller: 'TempSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                brick: null,
                                osfeBrick: null,
                                phone: null,
                                phone2: null,
                                countryName: null,
                                regionName: null,
                                prefectureName: null,
                                cityName: null,
                                postalCode: null,
                                address: null,
                                addressNum: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                autoapprove: null,
                                vat: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('temp-sector');
                });
            }]
        })
        .state('temp-sector.edit', {
            parent: 'temp-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-dialog.html',
                    controller: 'TempSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempSector', function(TempSector) {
                            return TempSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-sector.delete', {
            parent: 'temp-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-delete-dialog.html',
                    controller: 'TempSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempSector', function(TempSector) {
                            return TempSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempSector', TempSector);

    TempSector.$inject = ['$resource', 'DateUtils'];

    function TempSector ($resource, DateUtils) {
        var resourceUrl =  'api/temp-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempSectorSearch', TempSectorSearch);

    TempSectorSearch.$inject = ['$resource'];

    function TempSectorSearch($resource) {
        var resourceUrl =  'api/_search/temp-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempSectorController', TempSectorController);

    TempSectorController.$inject = ['$scope', '$state', 'TempSector', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TempSectorController ($scope, $state, TempSector, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TempSector.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tempSectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerSectorDialogController', TempCustomerSectorDialogController);

    TempCustomerSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'TempCustomerSector', 'TempCustomer', 'Sector', 'TempSector', 'SectorPosition', 'CustomerSector'];

    function TempCustomerSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, TempCustomerSector, TempCustomer, Sector, TempSector, SectorPosition, CustomerSector) {
        var vm = this;
        vm.tempCustomerSector = entity;
        vm.tempcustomers = TempCustomer.query();
        vm.sectors = Sector.query();
        vm.tempsectors = TempSector.query();
        vm.sectorpositions = SectorPosition.query();
        vm.approvedcustomersectors = CustomerSector.query({filter: 'tempcustomersector-is-null'});
        $q.all([vm.tempCustomerSector.$promise, vm.approvedcustomersectors.$promise]).then(function() {
            if (!vm.tempCustomerSector.approvedCustomerSector || !vm.tempCustomerSector.approvedCustomerSector.id) {
                return $q.reject();
            }
            return CustomerSector.get({id : vm.tempCustomerSector.approvedCustomerSector.id}).$promise;
        }).then(function(approvedCustomerSector) {
            vm.approvedcustomersectors.push(approvedCustomerSector);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tempCustomerSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tempCustomerSector.id !== null) {
                TempCustomerSector.update(vm.tempCustomerSector, onSaveSuccess, onSaveError);
            } else {
                TempCustomerSector.save(vm.tempCustomerSector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.endedAt = false;
        vm.datePickerOpenStatus.issuedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerSectorDetailController', TempCustomerSectorDetailController);

    TempCustomerSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TempCustomerSector', 'TempCustomer', 'Sector', 'TempSector', 'SectorPosition', 'CustomerSector'];

    function TempCustomerSectorDetailController($scope, $rootScope, $stateParams, entity, TempCustomerSector, TempCustomer, Sector, TempSector, SectorPosition, CustomerSector) {
        var vm = this;
        vm.tempCustomerSector = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tempCustomerSectorUpdate', function(event, result) {
            vm.tempCustomerSector = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerSectorDeleteController',TempCustomerSectorDeleteController);

    TempCustomerSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'TempCustomerSector'];

    function TempCustomerSectorDeleteController($uibModalInstance, entity, TempCustomerSector) {
        var vm = this;
        vm.tempCustomerSector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TempCustomerSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-customer-sector', {
            parent: 'entity',
            url: '/temp-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.tempCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sectors.html',
                    controller: 'TempCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomerSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-customer-sector-detail', {
            parent: 'entity',
            url: '/temp-customer-sector/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.tempCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-detail.html',
                    controller: 'TempCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomerSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempCustomerSector', function($stateParams, TempCustomerSector) {
                    return TempCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-customer-sector.new', {
            parent: 'temp-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-dialog.html',
                    controller: 'TempCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                endedAt: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                main: null,
                                phone: null,
                                monday: null,
                                tuesday: null,
                                wednesday: null,
                                thursday: null,
                                friday: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('temp-customer-sector');
                });
            }]
        })
        .state('temp-customer-sector.edit', {
            parent: 'temp-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-dialog.html',
                    controller: 'TempCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempCustomerSector', function(TempCustomerSector) {
                            return TempCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-customer-sector.delete', {
            parent: 'temp-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-delete-dialog.html',
                    controller: 'TempCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempCustomerSector', function(TempCustomerSector) {
                            return TempCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempCustomerSector', TempCustomerSector);

    TempCustomerSector.$inject = ['$resource', 'DateUtils'];

    function TempCustomerSector ($resource, DateUtils) {
        var resourceUrl =  'api/temp-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertLocalDateFromServer(data.startedAt);
                        data.endedAt = DateUtils.convertLocalDateFromServer(data.endedAt);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startedAt = DateUtils.convertLocalDateToServer(data.startedAt);
                    data.endedAt = DateUtils.convertLocalDateToServer(data.endedAt);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startedAt = DateUtils.convertLocalDateToServer(data.startedAt);
                    data.endedAt = DateUtils.convertLocalDateToServer(data.endedAt);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempCustomerSectorSearch', TempCustomerSectorSearch);

    TempCustomerSectorSearch.$inject = ['$resource'];

    function TempCustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/temp-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerSectorController', TempCustomerSectorController);

    TempCustomerSectorController.$inject = ['$scope', '$state', 'TempCustomerSector', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TempCustomerSectorController ($scope, $state, TempCustomerSector, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TempCustomerSector.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tempCustomerSectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerDialogController', TempCustomerDialogController);

    TempCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TempCustomer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'Customer', 'TempCustomerSector', 'Employee', 'CustomerType', 'Collaboration'];

    function TempCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TempCustomer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, Customer, TempCustomerSector, Employee, CustomerType, Collaboration) {
        var vm = this;
        vm.tempCustomer = entity;
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.customercategories = CustomerCategory.query();
        vm.customersectors = CustomerSector.query();
        vm.customertitles = CustomerTitle.query();
        vm.customersubcategories = CustomerSubCategory.query();
        vm.customers = Customer.query();
        vm.tempcustomersectors = TempCustomerSector.query();
        vm.employees = Employee.query();
        vm.customertypes = CustomerType.query();
        vm.collaborations = Collaboration.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tempCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tempCustomer.id !== null) {
                TempCustomer.update(vm.tempCustomer, onSaveSuccess, onSaveError);
            } else {
                TempCustomer.save(vm.tempCustomer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issuedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerDetailController', TempCustomerDetailController);

    TempCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TempCustomer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'Customer', 'TempCustomerSector', 'Employee', 'CustomerType', 'Collaboration'];

    function TempCustomerDetailController($scope, $rootScope, $stateParams, entity, TempCustomer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, Customer, TempCustomerSector, Employee, CustomerType, Collaboration) {
        var vm = this;
        vm.tempCustomer = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:tempCustomerUpdate', function(event, result) {
            vm.tempCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerDeleteController',TempCustomerDeleteController);

    TempCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'TempCustomer'];

    function TempCustomerDeleteController($uibModalInstance, entity, TempCustomer) {
        var vm = this;
        vm.tempCustomer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TempCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-customer', {
            parent: 'entity',
            url: '/temp-customer?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer/temp-customers.html',
                    controller: 'TempCustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-customer-detail', {
            parent: 'entity',
            url: '/temp-customer/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer/temp-customer-detail.html',
                    controller: 'TempCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempCustomer', function($stateParams, TempCustomer) {
                    return TempCustomer.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-customer.new', {
            parent: 'temp-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-dialog.html',
                    controller: 'TempCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                fatherName: null,
                                cellPhone: null,
                                phone: null,
                                isMale: null,
                                email: null,
                                notes: null,
                                saw: null,
                                isActive: null,
                                dayTime: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                lCode: null,
                                vatNumber: null,
                                etaaNumber: null,
                                amka: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('temp-customer');
                });
            }]
        })
        .state('temp-customer.edit', {
            parent: 'temp-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-dialog.html',
                    controller: 'TempCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempCustomer', function(TempCustomer) {
                            return TempCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-customer.delete', {
            parent: 'temp-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-delete-dialog.html',
                    controller: 'TempCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempCustomer', function(TempCustomer) {
                            return TempCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempCustomer', TempCustomer);

    TempCustomer.$inject = ['$resource', 'DateUtils'];

    function TempCustomer ($resource, DateUtils) {
        var resourceUrl =  'api/temp-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempCustomerSearch', TempCustomerSearch);

    TempCustomerSearch.$inject = ['$resource'];

    function TempCustomerSearch($resource) {
        var resourceUrl =  'api/_search/temp-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerController', TempCustomerController);

    TempCustomerController.$inject = ['$scope', '$state', 'TempCustomer', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TempCustomerController ($scope, $state, TempCustomer, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TempCustomer.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tempCustomers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusClassDialogController', TaxStatusClassDialogController);

    TaxStatusClassDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxStatusClass', 'TaxClass', 'TaxStatus'];

    function TaxStatusClassDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxStatusClass, TaxClass, TaxStatus) {
        var vm = this;
        vm.taxStatusClass = entity;
        vm.taxclasses = TaxClass.query();
        vm.taxstatuses = TaxStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxStatusClassUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxStatusClass.id !== null) {
                TaxStatusClass.update(vm.taxStatusClass, onSaveSuccess, onSaveError);
            } else {
                TaxStatusClass.save(vm.taxStatusClass, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusClassDetailController', TaxStatusClassDetailController);

    TaxStatusClassDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxStatusClass', 'TaxClass', 'TaxStatus'];

    function TaxStatusClassDetailController($scope, $rootScope, $stateParams, entity, TaxStatusClass, TaxClass, TaxStatus) {
        var vm = this;
        vm.taxStatusClass = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxStatusClassUpdate', function(event, result) {
            vm.taxStatusClass = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusClassDeleteController',TaxStatusClassDeleteController);

    TaxStatusClassDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxStatusClass'];

    function TaxStatusClassDeleteController($uibModalInstance, entity, TaxStatusClass) {
        var vm = this;
        vm.taxStatusClass = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxStatusClass.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-status-class', {
            parent: 'entity',
            url: '/tax-status-class?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatusClass.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status-class/tax-status-classes.html',
                    controller: 'TaxStatusClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatusClass');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-status-class-detail', {
            parent: 'entity',
            url: '/tax-status-class/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatusClass.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-detail.html',
                    controller: 'TaxStatusClassDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatusClass');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxStatusClass', function($stateParams, TaxStatusClass) {
                    return TaxStatusClass.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-status-class.new', {
            parent: 'tax-status-class',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-dialog.html',
                    controller: 'TaxStatusClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('tax-status-class');
                });
            }]
        })
        .state('tax-status-class.edit', {
            parent: 'tax-status-class',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-dialog.html',
                    controller: 'TaxStatusClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxStatusClass', function(TaxStatusClass) {
                            return TaxStatusClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-status-class.delete', {
            parent: 'tax-status-class',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status-class/tax-status-class-delete-dialog.html',
                    controller: 'TaxStatusClassDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxStatusClass', function(TaxStatusClass) {
                            return TaxStatusClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxStatusClass', TaxStatusClass);

    TaxStatusClass.$inject = ['$resource'];

    function TaxStatusClass ($resource) {
        var resourceUrl =  'api/tax-status-classes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusClassController', TaxStatusClassController);

    TaxStatusClassController.$inject = ['$scope', '$state', 'TaxStatusClass', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TaxStatusClassController ($scope, $state, TaxStatusClass, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TaxStatusClass.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taxStatusClasses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusDialogController', TaxStatusDialogController);

    TaxStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxStatus'];

    function TaxStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxStatus) {
        var vm = this;
        vm.taxStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxStatus.id !== null) {
                TaxStatus.update(vm.taxStatus, onSaveSuccess, onSaveError);
            } else {
                TaxStatus.save(vm.taxStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusDetailController', TaxStatusDetailController);

    TaxStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxStatus'];

    function TaxStatusDetailController($scope, $rootScope, $stateParams, entity, TaxStatus) {
        var vm = this;
        vm.taxStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxStatusUpdate', function(event, result) {
            vm.taxStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusDeleteController',TaxStatusDeleteController);

    TaxStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxStatus'];

    function TaxStatusDeleteController($uibModalInstance, entity, TaxStatus) {
        var vm = this;
        vm.taxStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-status', {
            parent: 'entity',
            url: '/tax-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status/tax-statuses.html',
                    controller: 'TaxStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-status-detail', {
            parent: 'entity',
            url: '/tax-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status/tax-status-detail.html',
                    controller: 'TaxStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxStatus', function($stateParams, TaxStatus) {
                    return TaxStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-status.new', {
            parent: 'tax-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-dialog.html',
                    controller: 'TaxStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('tax-status');
                });
            }]
        })
        .state('tax-status.edit', {
            parent: 'tax-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-dialog.html',
                    controller: 'TaxStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxStatus', function(TaxStatus) {
                            return TaxStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-status.delete', {
            parent: 'tax-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-delete-dialog.html',
                    controller: 'TaxStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxStatus', function(TaxStatus) {
                            return TaxStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxStatus', TaxStatus);

    TaxStatus.$inject = ['$resource'];

    function TaxStatus ($resource) {
        var resourceUrl =  'api/tax-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusController', TaxStatusController);

    TaxStatusController.$inject = ['$scope', '$state', 'TaxStatus', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TaxStatusController ($scope, $state, TaxStatus, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TaxStatus.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taxStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDialogController', TaxOfficeDialogController);

    TaxOfficeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxOffice'];

    function TaxOfficeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxOfficeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxOffice.id !== null) {
                TaxOffice.update(vm.taxOffice, onSaveSuccess, onSaveError);
            } else {
                TaxOffice.save(vm.taxOffice, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDetailController', TaxOfficeDetailController);

    TaxOfficeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxOffice'];

    function TaxOfficeDetailController($scope, $rootScope, $stateParams, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxOfficeUpdate', function(event, result) {
            vm.taxOffice = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDeleteController',TaxOfficeDeleteController);

    TaxOfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxOffice'];

    function TaxOfficeDeleteController($uibModalInstance, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxOffice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-office', {
            parent: 'entity',
            url: '/tax-office?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxOffice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-office/tax-offices.html',
                    controller: 'TaxOfficeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxOffice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-office-detail', {
            parent: 'entity',
            url: '/tax-office/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxOffice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-office/tax-office-detail.html',
                    controller: 'TaxOfficeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxOffice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxOffice', function($stateParams, TaxOffice) {
                    return TaxOffice.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-office.new', {
            parent: 'tax-office',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-dialog.html',
                    controller: 'TaxOfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('tax-office');
                });
            }]
        })
        .state('tax-office.edit', {
            parent: 'tax-office',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-dialog.html',
                    controller: 'TaxOfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxOffice', function(TaxOffice) {
                            return TaxOffice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-office.delete', {
            parent: 'tax-office',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-office/tax-office-delete-dialog.html',
                    controller: 'TaxOfficeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxOffice', function(TaxOffice) {
                            return TaxOffice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxOffice', TaxOffice);

    TaxOffice.$inject = ['$resource'];

    function TaxOffice ($resource) {
        var resourceUrl =  'api/tax-offices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeController', TaxOfficeController);

    TaxOfficeController.$inject = ['$scope', '$state', 'TaxOffice', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TaxOfficeController ($scope, $state, TaxOffice, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TaxOffice.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taxOffices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDialogController', TaxClassDialogController);

    TaxClassDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxClass'];

    function TaxClassDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxClassUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxClass.id !== null) {
                TaxClass.update(vm.taxClass, onSaveSuccess, onSaveError);
            } else {
                TaxClass.save(vm.taxClass, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDetailController', TaxClassDetailController);

    TaxClassDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxClass'];

    function TaxClassDetailController($scope, $rootScope, $stateParams, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxClassUpdate', function(event, result) {
            vm.taxClass = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDeleteController',TaxClassDeleteController);

    TaxClassDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxClass'];

    function TaxClassDeleteController($uibModalInstance, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxClass.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-class', {
            parent: 'entity',
            url: '/tax-class?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxClass.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-class/tax-classes.html',
                    controller: 'TaxClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxClass');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-class-detail', {
            parent: 'entity',
            url: '/tax-class/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxClass.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-class/tax-class-detail.html',
                    controller: 'TaxClassDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxClass');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxClass', function($stateParams, TaxClass) {
                    return TaxClass.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-class.new', {
            parent: 'tax-class',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-dialog.html',
                    controller: 'TaxClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('tax-class');
                });
            }]
        })
        .state('tax-class.edit', {
            parent: 'tax-class',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-dialog.html',
                    controller: 'TaxClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxClass', function(TaxClass) {
                            return TaxClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-class.delete', {
            parent: 'tax-class',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-delete-dialog.html',
                    controller: 'TaxClassDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxClass', function(TaxClass) {
                            return TaxClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxClass', TaxClass);

    TaxClass.$inject = ['$resource'];

    function TaxClass ($resource) {
        var resourceUrl =  'api/tax-classes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassController', TaxClassController);

    TaxClassController.$inject = ['$scope', '$state', 'TaxClass', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TaxClassController ($scope, $state, TaxClass, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TaxClass.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taxClasses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDialogController', SubcategoryDialogController);

    SubcategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Subcategory'];

    function SubcategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:subcategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.subcategory.id !== null) {
                Subcategory.update(vm.subcategory, onSaveSuccess, onSaveError);
            } else {
                Subcategory.save(vm.subcategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.updatedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDetailController', SubcategoryDetailController);

    SubcategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Subcategory'];

    function SubcategoryDetailController($scope, $rootScope, $stateParams, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:subcategoryUpdate', function(event, result) {
            vm.subcategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDeleteController',SubcategoryDeleteController);

    SubcategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Subcategory'];

    function SubcategoryDeleteController($uibModalInstance, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Subcategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subcategory', {
            parent: 'entity',
            url: '/subcategory?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.subcategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subcategory/subcategories.html',
                    controller: 'SubcategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subcategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subcategory-detail', {
            parent: 'entity',
            url: '/subcategory/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.subcategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subcategory/subcategory-detail.html',
                    controller: 'SubcategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subcategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Subcategory', function($stateParams, Subcategory) {
                    return Subcategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('subcategory.new', {
            parent: 'subcategory',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subcategory/subcategory-dialog.html',
                    controller: 'SubcategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                updatedAt: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subcategory', null, { reload: true });
                }, function() {
                    $state.go('subcategory');
                });
            }]
        })
        .state('subcategory.edit', {
            parent: 'subcategory',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subcategory/subcategory-dialog.html',
                    controller: 'SubcategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subcategory', function(Subcategory) {
                            return Subcategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('subcategory', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subcategory.delete', {
            parent: 'subcategory',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subcategory/subcategory-delete-dialog.html',
                    controller: 'SubcategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Subcategory', function(Subcategory) {
                            return Subcategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('subcategory', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Subcategory', Subcategory);

    Subcategory.$inject = ['$resource', 'DateUtils'];

    function Subcategory ($resource, DateUtils) {
        var resourceUrl =  'api/subcategories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.updatedAt = DateUtils.convertDateTimeFromServer(data.updatedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SubcategorySearch', SubcategorySearch);

    SubcategorySearch.$inject = ['$resource'];

    function SubcategorySearch($resource) {
        var resourceUrl =  'api/_search/subcategories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryController', SubcategoryController);

    SubcategoryController.$inject = ['$scope', '$state', 'Subcategory', 'SubcategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SubcategoryController ($scope, $state, Subcategory, SubcategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SubcategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Subcategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.subcategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceDialogController', SocialInsuranceDialogController);

    SocialInsuranceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SocialInsurance'];

    function SocialInsuranceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SocialInsurance) {
        var vm = this;
        vm.socialInsurance = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:socialInsuranceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.socialInsurance.id !== null) {
                SocialInsurance.update(vm.socialInsurance, onSaveSuccess, onSaveError);
            } else {
                SocialInsurance.save(vm.socialInsurance, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceDetailController', SocialInsuranceDetailController);

    SocialInsuranceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SocialInsurance'];

    function SocialInsuranceDetailController($scope, $rootScope, $stateParams, entity, SocialInsurance) {
        var vm = this;
        vm.socialInsurance = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:socialInsuranceUpdate', function(event, result) {
            vm.socialInsurance = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceDeleteController',SocialInsuranceDeleteController);

    SocialInsuranceDeleteController.$inject = ['$uibModalInstance', 'entity', 'SocialInsurance'];

    function SocialInsuranceDeleteController($uibModalInstance, entity, SocialInsurance) {
        var vm = this;
        vm.socialInsurance = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SocialInsurance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('social-insurance', {
            parent: 'entity',
            url: '/social-insurance?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.socialInsurance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-insurance/social-insurances.html',
                    controller: 'SocialInsuranceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialInsurance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-insurance-detail', {
            parent: 'entity',
            url: '/social-insurance/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.socialInsurance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-insurance/social-insurance-detail.html',
                    controller: 'SocialInsuranceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialInsurance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SocialInsurance', function($stateParams, SocialInsurance) {
                    return SocialInsurance.get({id : $stateParams.id});
                }]
            }
        })
        .state('social-insurance.new', {
            parent: 'social-insurance',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-dialog.html',
                    controller: 'SocialInsuranceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('social-insurance');
                });
            }]
        })
        .state('social-insurance.edit', {
            parent: 'social-insurance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-dialog.html',
                    controller: 'SocialInsuranceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SocialInsurance', function(SocialInsurance) {
                            return SocialInsurance.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('social-insurance.delete', {
            parent: 'social-insurance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-insurance/social-insurance-delete-dialog.html',
                    controller: 'SocialInsuranceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SocialInsurance', function(SocialInsurance) {
                            return SocialInsurance.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-insurance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SocialInsurance', SocialInsurance);

    SocialInsurance.$inject = ['$resource'];

    function SocialInsurance ($resource) {
        var resourceUrl =  'api/social-insurances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SocialInsuranceSearch', SocialInsuranceSearch);

    SocialInsuranceSearch.$inject = ['$resource'];

    function SocialInsuranceSearch($resource) {
        var resourceUrl =  'api/_search/social-insurances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceController', SocialInsuranceController);

    SocialInsuranceController.$inject = ['$scope', '$state', 'SocialInsurance', 'SocialInsuranceSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SocialInsuranceController ($scope, $state, SocialInsurance, SocialInsuranceSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SocialInsuranceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SocialInsurance.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.socialInsurances = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorTypeDialogController', SectorTypeDialogController);

    SectorTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorType'];

    function SectorTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorType) {
        var vm = this;
        vm.sectorType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorType.id !== null) {
                SectorType.update(vm.sectorType, onSaveSuccess, onSaveError);
            } else {
                SectorType.save(vm.sectorType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorTypeDetailController', SectorTypeDetailController);

    SectorTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SectorType'];

    function SectorTypeDetailController($scope, $rootScope, $stateParams, entity, SectorType) {
        var vm = this;
        vm.sectorType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:sectorTypeUpdate', function(event, result) {
            vm.sectorType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorTypeDeleteController',SectorTypeDeleteController);

    SectorTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorType'];

    function SectorTypeDeleteController($uibModalInstance, entity, SectorType) {
        var vm = this;
        vm.sectorType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-type', {
            parent: 'entity',
            url: '/sector-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-type/sector-types.html',
                    controller: 'SectorTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorType');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-type-detail', {
            parent: 'entity',
            url: '/sector-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-type/sector-type-detail.html',
                    controller: 'SectorTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorType');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorType', function($stateParams, SectorType) {
                    return SectorType.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-type.new', {
            parent: 'sector-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-dialog.html',
                    controller: 'SectorTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                sectorTypeCategory: null,
                                isPrivate: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('sector-type');
                });
            }]
        })
        .state('sector-type.edit', {
            parent: 'sector-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-dialog.html',
                    controller: 'SectorTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorType', function(SectorType) {
                            return SectorType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-type.delete', {
            parent: 'sector-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-type/sector-type-delete-dialog.html',
                    controller: 'SectorTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorType', function(SectorType) {
                            return SectorType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorType', SectorType);

    SectorType.$inject = ['$resource'];

    function SectorType ($resource) {
        var resourceUrl =  'api/sector-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SectorTypeSearch', SectorTypeSearch);

    SectorTypeSearch.$inject = ['$resource'];

    function SectorTypeSearch($resource) {
        var resourceUrl =  'api/_search/sector-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorTypeController', SectorTypeController);

    SectorTypeController.$inject = ['$scope', '$state', 'SectorType', 'SectorTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SectorTypeController ($scope, $state, SectorType, SectorTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SectorTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SectorType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectorTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorPositionDialogController', SectorPositionDialogController);

    SectorPositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorPosition'];

    function SectorPositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorPosition) {
        var vm = this;
        vm.sectorPosition = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorPositionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorPosition.id !== null) {
                SectorPosition.update(vm.sectorPosition, onSaveSuccess, onSaveError);
            } else {
                SectorPosition.save(vm.sectorPosition, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorPositionDetailController', SectorPositionDetailController);

    SectorPositionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SectorPosition'];

    function SectorPositionDetailController($scope, $rootScope, $stateParams, entity, SectorPosition) {
        var vm = this;
        vm.sectorPosition = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:sectorPositionUpdate', function(event, result) {
            vm.sectorPosition = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorPositionDeleteController',SectorPositionDeleteController);

    SectorPositionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorPosition'];

    function SectorPositionDeleteController($uibModalInstance, entity, SectorPosition) {
        var vm = this;
        vm.sectorPosition = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorPosition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-position', {
            parent: 'entity',
            url: '/sector-position?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorPosition.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-position/sector-positions.html',
                    controller: 'SectorPositionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorPosition');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-position-detail', {
            parent: 'entity',
            url: '/sector-position/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorPosition.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-position/sector-position-detail.html',
                    controller: 'SectorPositionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorPosition');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorPosition', function($stateParams, SectorPosition) {
                    return SectorPosition.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-position.new', {
            parent: 'sector-position',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-dialog.html',
                    controller: 'SectorPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('sector-position');
                });
            }]
        })
        .state('sector-position.edit', {
            parent: 'sector-position',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-dialog.html',
                    controller: 'SectorPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorPosition', function(SectorPosition) {
                            return SectorPosition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-position.delete', {
            parent: 'sector-position',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-delete-dialog.html',
                    controller: 'SectorPositionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorPosition', function(SectorPosition) {
                            return SectorPosition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorPosition', SectorPosition);

    SectorPosition.$inject = ['$resource'];

    function SectorPosition ($resource) {
        var resourceUrl =  'api/sector-positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SectorPositionSearch', SectorPositionSearch);

    SectorPositionSearch.$inject = ['$resource'];

    function SectorPositionSearch($resource) {
        var resourceUrl =  'api/_search/sector-positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorPositionController', SectorPositionController);

    SectorPositionController.$inject = ['$scope', '$state', 'SectorPosition', 'SectorPositionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SectorPositionController ($scope, $state, SectorPosition, SectorPositionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SectorPositionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SectorPosition.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectorPositions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameDialogController', SectorClinicNameDialogController);

    SectorClinicNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorClinicName', 'Sector', 'ClinicName'];

    function SectorClinicNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorClinicName, Sector, ClinicName) {
        var vm = this;
        vm.sectorClinicName = entity;
        vm.sectors = Sector.query();
        vm.clinicnames = ClinicName.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorClinicNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorClinicName.id !== null) {
                SectorClinicName.update(vm.sectorClinicName, onSaveSuccess, onSaveError);
            } else {
                SectorClinicName.save(vm.sectorClinicName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameDetailController', SectorClinicNameDetailController);

    SectorClinicNameDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SectorClinicName', 'Sector', 'ClinicName'];

    function SectorClinicNameDetailController($scope, $rootScope, $stateParams, entity, SectorClinicName, Sector, ClinicName) {
        var vm = this;
        vm.sectorClinicName = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:sectorClinicNameUpdate', function(event, result) {
            vm.sectorClinicName = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameDeleteController',SectorClinicNameDeleteController);

    SectorClinicNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorClinicName'];

    function SectorClinicNameDeleteController($uibModalInstance, entity, SectorClinicName) {
        var vm = this;
        vm.sectorClinicName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorClinicName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-clinic-name', {
            parent: 'entity',
            url: '/sector-clinic-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorClinicName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-names.html',
                    controller: 'SectorClinicNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorClinicName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-clinic-name-detail', {
            parent: 'entity',
            url: '/sector-clinic-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorClinicName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-detail.html',
                    controller: 'SectorClinicNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorClinicName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorClinicName', function($stateParams, SectorClinicName) {
                    return SectorClinicName.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-clinic-name.new', {
            parent: 'sector-clinic-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-dialog.html',
                    controller: 'SectorClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('sector-clinic-name');
                });
            }]
        })
        .state('sector-clinic-name.edit', {
            parent: 'sector-clinic-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-dialog.html',
                    controller: 'SectorClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorClinicName', function(SectorClinicName) {
                            return SectorClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-clinic-name.delete', {
            parent: 'sector-clinic-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-clinic-name/sector-clinic-name-delete-dialog.html',
                    controller: 'SectorClinicNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorClinicName', function(SectorClinicName) {
                            return SectorClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorClinicName', SectorClinicName);

    SectorClinicName.$inject = ['$resource'];

    function SectorClinicName ($resource) {
        var resourceUrl =  'api/sector-clinic-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameController', SectorClinicNameController);

    SectorClinicNameController.$inject = ['$scope', '$state', 'SectorClinicName', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SectorClinicNameController ($scope, $state, SectorClinicName, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            SectorClinicName.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectorClinicNames = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryDialogController', SectorCategoryDialogController);

    SectorCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorCategory'];

    function SectorCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorCategory) {
        var vm = this;
        vm.sectorCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorCategory.id !== null) {
                SectorCategory.update(vm.sectorCategory, onSaveSuccess, onSaveError);
            } else {
                SectorCategory.save(vm.sectorCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryDetailController', SectorCategoryDetailController);

    SectorCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SectorCategory'];

    function SectorCategoryDetailController($scope, $rootScope, $stateParams, entity, SectorCategory) {
        var vm = this;
        vm.sectorCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:sectorCategoryUpdate', function(event, result) {
            vm.sectorCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryDeleteController',SectorCategoryDeleteController);

    SectorCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorCategory'];

    function SectorCategoryDeleteController($uibModalInstance, entity, SectorCategory) {
        var vm = this;
        vm.sectorCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-category', {
            parent: 'entity',
            url: '/sector-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-category/sector-categories.html',
                    controller: 'SectorCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorCategory');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-category-detail', {
            parent: 'entity',
            url: '/sector-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-category/sector-category-detail.html',
                    controller: 'SectorCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorCategory');
                    $translatePartialLoader.addPart('sectorTypeCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorCategory', function($stateParams, SectorCategory) {
                    return SectorCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-category.new', {
            parent: 'sector-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-dialog.html',
                    controller: 'SectorCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                sectorTypeCategory: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('sector-category');
                });
            }]
        })
        .state('sector-category.edit', {
            parent: 'sector-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-dialog.html',
                    controller: 'SectorCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorCategory', function(SectorCategory) {
                            return SectorCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-category.delete', {
            parent: 'sector-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-category/sector-category-delete-dialog.html',
                    controller: 'SectorCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorCategory', function(SectorCategory) {
                            return SectorCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorCategory', SectorCategory);

    SectorCategory.$inject = ['$resource'];

    function SectorCategory ($resource) {
        var resourceUrl =  'api/sector-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryController', SectorCategoryController);

    SectorCategoryController.$inject = ['$scope', '$state', 'SectorCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SectorCategoryController ($scope, $state, SectorCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            SectorCategory.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectorCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorDialogController', SectorDialogController);

    SectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sector', 'SectorType', 'DoctorSpecialty', 'CustomerSector', 'Country', 'Region', 'Prefecture', 'City', 'CompanyType', 'TaxOffice', 'TaxStatus', 'ClinicName', 'SectorCategory'];

    function SectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sector, SectorType, DoctorSpecialty, CustomerSector, Country, Region, Prefecture, City, CompanyType, TaxOffice, TaxStatus, ClinicName, SectorCategory) {
        var vm = this;
        vm.sector = entity;
        vm.sectortypes = SectorType.query();
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.sectors = Sector.query();
        vm.customersectors = CustomerSector.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.prefectures = Prefecture.query();
        vm.cities = City.query();
        vm.companytypes = CompanyType.query();
        vm.taxoffices = TaxOffice.query();
        vm.taxstatuses = TaxStatus.query();
        vm.clinicnames = ClinicName.query();
        vm.sectorcategories = SectorCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sector.id !== null) {
                Sector.update(vm.sector, onSaveSuccess, onSaveError);
            } else {
                Sector.save(vm.sector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorDetailController', SectorDetailController);

    SectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Sector', 'SectorType', 'DoctorSpecialty', 'CustomerSector', 'Country', 'Region', 'Prefecture', 'City', 'CompanyType', 'TaxOffice', 'TaxStatus', 'ClinicName', 'SectorCategory'];

    function SectorDetailController($scope, $rootScope, $stateParams, entity, Sector, SectorType, DoctorSpecialty, CustomerSector, Country, Region, Prefecture, City, CompanyType, TaxOffice, TaxStatus, ClinicName, SectorCategory) {
        var vm = this;
        vm.sector = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:sectorUpdate', function(event, result) {
            vm.sector = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorDeleteController',SectorDeleteController);

    SectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sector'];

    function SectorDeleteController($uibModalInstance, entity, Sector) {
        var vm = this;
        vm.sector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Sector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector', {
            parent: 'entity',
            url: '/sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector/sectors.html',
                    controller: 'SectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-detail', {
            parent: 'entity',
            url: '/sector/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.sector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector/sector-detail.html',
                    controller: 'SectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                    return Sector.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector.new', {
            parent: 'sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                brick: null,
                                osfeBrick: null,
                                phone: null,
                                phone2: null,
                                countryName: null,
                                regionName: null,
                                prefectureName: null,
                                cityName: null,
                                postalCode: null,
                                address: null,
                                addressNum: null,
                                vat: null,
                                creditControlCheck: null,
                                code: null,
                                monday: null,
                                tuesday: null,
                                wednesday: null,
                                thursday: null,
                                friday: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: true });
                }, function() {
                    $state.go('sector');
                });
            }]
        })
        .state('sector.edit', {
            parent: 'sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector.delete', {
            parent: 'sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-delete-dialog.html',
                    controller: 'SectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Sector', Sector);

    Sector.$inject = ['$resource'];

    function Sector ($resource) {
        var resourceUrl =  'api/sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SectorSearch', SectorSearch);

    SectorSearch.$inject = ['$resource'];

    function SectorSearch($resource) {
        var resourceUrl =  'api/_search/sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorController', SectorController);

    SectorController.$inject = ['$scope', '$state', 'Sector', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SectorController ($scope, $state, Sector, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Sector.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomTypeDialogController', RoomTypeDialogController);

    RoomTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RoomType'];

    function RoomTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RoomType) {
        var vm = this;
        vm.roomType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:roomTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.roomType.id !== null) {
                RoomType.update(vm.roomType, onSaveSuccess, onSaveError);
            } else {
                RoomType.save(vm.roomType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomTypeDetailController', RoomTypeDetailController);

    RoomTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RoomType'];

    function RoomTypeDetailController($scope, $rootScope, $stateParams, entity, RoomType) {
        var vm = this;
        vm.roomType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:roomTypeUpdate', function(event, result) {
            vm.roomType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomTypeDeleteController',RoomTypeDeleteController);

    RoomTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RoomType'];

    function RoomTypeDeleteController($uibModalInstance, entity, RoomType) {
        var vm = this;
        vm.roomType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RoomType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room-type', {
            parent: 'entity',
            url: '/room-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.roomType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-type/room-types.html',
                    controller: 'RoomTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room-type-detail', {
            parent: 'entity',
            url: '/room-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.roomType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-type/room-type-detail.html',
                    controller: 'RoomTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RoomType', function($stateParams, RoomType) {
                    return RoomType.get({id : $stateParams.id});
                }]
            }
        })
        .state('room-type.new', {
            parent: 'room-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-dialog.html',
                    controller: 'RoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('room-type');
                });
            }]
        })
        .state('room-type.edit', {
            parent: 'room-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-dialog.html',
                    controller: 'RoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RoomType', function(RoomType) {
                            return RoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('room-type.delete', {
            parent: 'room-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-delete-dialog.html',
                    controller: 'RoomTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RoomType', function(RoomType) {
                            return RoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RoomType', RoomType);

    RoomType.$inject = ['$resource'];

    function RoomType ($resource) {
        var resourceUrl =  'api/room-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomTypeController', RoomTypeController);

    RoomTypeController.$inject = ['$scope', '$state', 'RoomType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RoomTypeController ($scope, $state, RoomType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            RoomType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.roomTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomCostDialogController', RoomCostDialogController);

    RoomCostDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RoomCost', 'CostType', 'RoomType'];

    function RoomCostDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RoomCost, CostType, RoomType) {
        var vm = this;
        vm.roomCost = entity;
        vm.costtypes = CostType.query();
        vm.roomtypes = RoomType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:roomCostUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.roomCost.id !== null) {
                RoomCost.update(vm.roomCost, onSaveSuccess, onSaveError);
            } else {
                RoomCost.save(vm.roomCost, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomCostDetailController', RoomCostDetailController);

    RoomCostDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RoomCost', 'CostType', 'RoomType'];

    function RoomCostDetailController($scope, $rootScope, $stateParams, entity, RoomCost, CostType, RoomType) {
        var vm = this;
        vm.roomCost = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:roomCostUpdate', function(event, result) {
            vm.roomCost = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomCostDeleteController',RoomCostDeleteController);

    RoomCostDeleteController.$inject = ['$uibModalInstance', 'entity', 'RoomCost'];

    function RoomCostDeleteController($uibModalInstance, entity, RoomCost) {
        var vm = this;
        vm.roomCost = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RoomCost.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room-cost', {
            parent: 'entity',
            url: '/room-cost?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.roomCost.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-cost/room-costs.html',
                    controller: 'RoomCostController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomCost');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room-cost-detail', {
            parent: 'entity',
            url: '/room-cost/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.roomCost.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-cost/room-cost-detail.html',
                    controller: 'RoomCostDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomCost');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RoomCost', function($stateParams, RoomCost) {
                    return RoomCost.get({id : $stateParams.id});
                }]
            }
        })
        .state('room-cost.new', {
            parent: 'room-cost',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-dialog.html',
                    controller: 'RoomCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('room-cost');
                });
            }]
        })
        .state('room-cost.edit', {
            parent: 'room-cost',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-dialog.html',
                    controller: 'RoomCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RoomCost', function(RoomCost) {
                            return RoomCost.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('room-cost.delete', {
            parent: 'room-cost',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-delete-dialog.html',
                    controller: 'RoomCostDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RoomCost', function(RoomCost) {
                            return RoomCost.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RoomCost', RoomCost);

    RoomCost.$inject = ['$resource'];

    function RoomCost ($resource) {
        var resourceUrl =  'api/room-costs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomCostController', RoomCostController);

    RoomCostController.$inject = ['$scope', '$state', 'RoomCost', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RoomCostController ($scope, $state, RoomCost, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            RoomCost.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.roomCosts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeDialogController', RelationshipTypeDialogController);

    RelationshipTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RelationshipType'];

    function RelationshipTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RelationshipType) {
        var vm = this;
        vm.relationshipType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:relationshipTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.relationshipType.id !== null) {
                RelationshipType.update(vm.relationshipType, onSaveSuccess, onSaveError);
            } else {
                RelationshipType.save(vm.relationshipType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeDetailController', RelationshipTypeDetailController);

    RelationshipTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RelationshipType'];

    function RelationshipTypeDetailController($scope, $rootScope, $stateParams, entity, RelationshipType) {
        var vm = this;
        vm.relationshipType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:relationshipTypeUpdate', function(event, result) {
            vm.relationshipType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeDeleteController',RelationshipTypeDeleteController);

    RelationshipTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RelationshipType'];

    function RelationshipTypeDeleteController($uibModalInstance, entity, RelationshipType) {
        var vm = this;
        vm.relationshipType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RelationshipType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('relationship-type', {
            parent: 'entity',
            url: '/relationship-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.relationshipType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship-type/relationship-types.html',
                    controller: 'RelationshipTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationshipType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relationship-type-detail', {
            parent: 'entity',
            url: '/relationship-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.relationshipType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship-type/relationship-type-detail.html',
                    controller: 'RelationshipTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationshipType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RelationshipType', function($stateParams, RelationshipType) {
                    return RelationshipType.get({id : $stateParams.id});
                }]
            }
        })
        .state('relationship-type.new', {
            parent: 'relationship-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-dialog.html',
                    controller: 'RelationshipTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('relationship-type');
                });
            }]
        })
        .state('relationship-type.edit', {
            parent: 'relationship-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-dialog.html',
                    controller: 'RelationshipTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RelationshipType', function(RelationshipType) {
                            return RelationshipType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relationship-type.delete', {
            parent: 'relationship-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-delete-dialog.html',
                    controller: 'RelationshipTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RelationshipType', function(RelationshipType) {
                            return RelationshipType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RelationshipType', RelationshipType);

    RelationshipType.$inject = ['$resource'];

    function RelationshipType ($resource) {
        var resourceUrl =  'api/relationship-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeController', RelationshipTypeController);

    RelationshipTypeController.$inject = ['$scope', '$state', 'RelationshipType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RelationshipTypeController ($scope, $state, RelationshipType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            RelationshipType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.relationshipTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RejectionReasonDialogController', RejectionReasonDialogController);

    RejectionReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RejectionReason'];

    function RejectionReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RejectionReason) {
        var vm = this;
        vm.rejectionReason = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:rejectionReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.rejectionReason.id !== null) {
                RejectionReason.update(vm.rejectionReason, onSaveSuccess, onSaveError);
            } else {
                RejectionReason.save(vm.rejectionReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RejectionReasonDetailController', RejectionReasonDetailController);

    RejectionReasonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RejectionReason'];

    function RejectionReasonDetailController($scope, $rootScope, $stateParams, entity, RejectionReason) {
        var vm = this;
        vm.rejectionReason = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:rejectionReasonUpdate', function(event, result) {
            vm.rejectionReason = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RejectionReasonDeleteController',RejectionReasonDeleteController);

    RejectionReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectionReason'];

    function RejectionReasonDeleteController($uibModalInstance, entity, RejectionReason) {
        var vm = this;
        vm.rejectionReason = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RejectionReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejection-reason', {
            parent: 'entity',
            url: '/rejection-reason?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.rejectionReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-reason/rejection-reasons.html',
                    controller: 'RejectionReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rejection-reason-detail', {
            parent: 'entity',
            url: '/rejection-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.rejectionReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-detail.html',
                    controller: 'RejectionReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RejectionReason', function($stateParams, RejectionReason) {
                    return RejectionReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('rejection-reason.new', {
            parent: 'rejection-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-dialog.html',
                    controller: 'RejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('rejection-reason');
                });
            }]
        })
        .state('rejection-reason.edit', {
            parent: 'rejection-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-dialog.html',
                    controller: 'RejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectionReason', function(RejectionReason) {
                            return RejectionReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejection-reason.delete', {
            parent: 'rejection-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-delete-dialog.html',
                    controller: 'RejectionReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RejectionReason', function(RejectionReason) {
                            return RejectionReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RejectionReason', RejectionReason);

    RejectionReason.$inject = ['$resource'];

    function RejectionReason ($resource) {
        var resourceUrl =  'api/rejection-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RejectionReasonController', RejectionReasonController);

    RejectionReasonController.$inject = ['$scope', '$state', 'RejectionReason', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RejectionReasonController ($scope, $state, RejectionReason, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            RejectionReason.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rejectionReasons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RegionDialogController', RegionDialogController);

    RegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Region', 'Country'];

    function RegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Region, Country) {
        var vm = this;
        vm.region = entity;
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:regionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.region.id !== null) {
                Region.update(vm.region, onSaveSuccess, onSaveError);
            } else {
                Region.save(vm.region, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RegionDetailController', RegionDetailController);

    RegionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Region', 'Country'];

    function RegionDetailController($scope, $rootScope, $stateParams, entity, Region, Country) {
        var vm = this;
        vm.region = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:regionUpdate', function(event, result) {
            vm.region = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RegionDeleteController',RegionDeleteController);

    RegionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Region'];

    function RegionDeleteController($uibModalInstance, entity, Region) {
        var vm = this;
        vm.region = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Region.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('region', {
            parent: 'entity',
            url: '/region?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.region.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/regions.html',
                    controller: 'RegionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('region-detail', {
            parent: 'entity',
            url: '/region/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.region.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/region-detail.html',
                    controller: 'RegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Region', function($stateParams, Region) {
                    return Region.get({id : $stateParams.id});
                }]
            }
        })
        .state('region.new', {
            parent: 'region',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: true });
                }, function() {
                    $state.go('region');
                });
            }]
        })
        .state('region.edit', {
            parent: 'region',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.delete', {
            parent: 'region',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-delete-dialog.html',
                    controller: 'RegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Region', Region);

    Region.$inject = ['$resource'];

    function Region ($resource) {
        var resourceUrl =  'api/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('RegionSearch', RegionSearch);

    RegionSearch.$inject = ['$resource'];

    function RegionSearch($resource) {
        var resourceUrl =  'api/_search/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RegionController', RegionController);

    RegionController.$inject = ['$scope', '$state', 'Region', 'RegionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RegionController ($scope, $state, Region, RegionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RegionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Region.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.regions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseStatusDialogController', PurchaseStatusDialogController);

    PurchaseStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseStatus'];

    function PurchaseStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseStatus) {
        var vm = this;
        vm.purchaseStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseStatus.id !== null) {
                PurchaseStatus.update(vm.purchaseStatus, onSaveSuccess, onSaveError);
            } else {
                PurchaseStatus.save(vm.purchaseStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseStatusDetailController', PurchaseStatusDetailController);

    PurchaseStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchaseStatus'];

    function PurchaseStatusDetailController($scope, $rootScope, $stateParams, entity, PurchaseStatus) {
        var vm = this;
        vm.purchaseStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseStatusUpdate', function(event, result) {
            vm.purchaseStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseStatusDeleteController',PurchaseStatusDeleteController);

    PurchaseStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchaseStatus'];

    function PurchaseStatusDeleteController($uibModalInstance, entity, PurchaseStatus) {
        var vm = this;
        vm.purchaseStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchaseStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-status', {
            parent: 'entity',
            url: '/purchase-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-status/purchase-statuses.html',
                    controller: 'PurchaseStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-status-detail', {
            parent: 'entity',
            url: '/purchase-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-status/purchase-status-detail.html',
                    controller: 'PurchaseStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseStatus', function($stateParams, PurchaseStatus) {
                    return PurchaseStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-status.new', {
            parent: 'purchase-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-dialog.html',
                    controller: 'PurchaseStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                cancellable: null,
                                code: null,
                                isEditable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('purchase-status');
                });
            }]
        })
        .state('purchase-status.edit', {
            parent: 'purchase-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-dialog.html',
                    controller: 'PurchaseStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseStatus', function(PurchaseStatus) {
                            return PurchaseStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-status.delete', {
            parent: 'purchase-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-delete-dialog.html',
                    controller: 'PurchaseStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseStatus', function(PurchaseStatus) {
                            return PurchaseStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseStatus', PurchaseStatus);

    PurchaseStatus.$inject = ['$resource'];

    function PurchaseStatus ($resource) {
        var resourceUrl =  'api/purchase-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseStatusController', PurchaseStatusController);

    PurchaseStatusController.$inject = ['$scope', '$state', 'PurchaseStatus', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchaseStatusController ($scope, $state, PurchaseStatus, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchaseStatus.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchaseStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemLotDialogController', PurchasePresentItemLotDialogController);

    PurchasePresentItemLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchasePresentItemLot', 'PurchasePresentItem'];

    function PurchasePresentItemLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchasePresentItemLot, PurchasePresentItem) {
        var vm = this;
        vm.purchasePresentItemLot = entity;
        vm.purchasepresentitems = PurchasePresentItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchasePresentItemLotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchasePresentItemLot.id !== null) {
                PurchasePresentItemLot.update(vm.purchasePresentItemLot, onSaveSuccess, onSaveError);
            } else {
                PurchasePresentItemLot.save(vm.purchasePresentItemLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemLotDetailController', PurchasePresentItemLotDetailController);

    PurchasePresentItemLotDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchasePresentItemLot', 'PurchasePresentItem'];

    function PurchasePresentItemLotDetailController($scope, $rootScope, $stateParams, entity, PurchasePresentItemLot, PurchasePresentItem) {
        var vm = this;
        vm.purchasePresentItemLot = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchasePresentItemLotUpdate', function(event, result) {
            vm.purchasePresentItemLot = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemLotDeleteController',PurchasePresentItemLotDeleteController);

    PurchasePresentItemLotDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasePresentItemLot'];

    function PurchasePresentItemLotDeleteController($uibModalInstance, entity, PurchasePresentItemLot) {
        var vm = this;
        vm.purchasePresentItemLot = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchasePresentItemLot.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-present-item-lot', {
            parent: 'entity',
            url: '/purchase-present-item-lot?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.purchasePresentItemLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lots.html',
                    controller: 'PurchasePresentItemLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItemLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-present-item-lot-detail', {
            parent: 'entity',
            url: '/purchase-present-item-lot/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.purchasePresentItemLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-detail.html',
                    controller: 'PurchasePresentItemLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItemLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchasePresentItemLot', function($stateParams, PurchasePresentItemLot) {
                    return PurchasePresentItemLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-present-item-lot.new', {
            parent: 'purchase-present-item-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-dialog.html',
                    controller: 'PurchasePresentItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                quantity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('purchase-present-item-lot');
                });
            }]
        })
        .state('purchase-present-item-lot.edit', {
            parent: 'purchase-present-item-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-dialog.html',
                    controller: 'PurchasePresentItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchasePresentItemLot', function(PurchasePresentItemLot) {
                            return PurchasePresentItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-present-item-lot.delete', {
            parent: 'purchase-present-item-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item-lot/purchase-present-item-lot-delete-dialog.html',
                    controller: 'PurchasePresentItemLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchasePresentItemLot', function(PurchasePresentItemLot) {
                            return PurchasePresentItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchasePresentItemLot', PurchasePresentItemLot);

    PurchasePresentItemLot.$inject = ['$resource'];

    function PurchasePresentItemLot ($resource) {
        var resourceUrl =  'api/purchase-present-item-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemLotController', PurchasePresentItemLotController);

    PurchasePresentItemLotController.$inject = ['$scope', '$state', 'PurchasePresentItemLot', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchasePresentItemLotController ($scope, $state, PurchasePresentItemLot, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchasePresentItemLot.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchasePresentItemLots = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemDialogController', PurchasePresentItemDialogController);

    PurchasePresentItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchasePresentItem', 'Purchase', 'Product', 'PresentListProduct'];

    function PurchasePresentItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchasePresentItem, Purchase, Product, PresentListProduct) {
        var vm = this;
        vm.purchasePresentItem = entity;
        vm.purchases = Purchase.query();
        vm.products = Product.query();
        vm.presentlistproducts = PresentListProduct.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchasePresentItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchasePresentItem.id !== null) {
                PurchasePresentItem.update(vm.purchasePresentItem, onSaveSuccess, onSaveError);
            } else {
                PurchasePresentItem.save(vm.purchasePresentItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemDetailController', PurchasePresentItemDetailController);

    PurchasePresentItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchasePresentItem', 'Purchase', 'Product', 'PresentListProduct'];

    function PurchasePresentItemDetailController($scope, $rootScope, $stateParams, entity, PurchasePresentItem, Purchase, Product, PresentListProduct) {
        var vm = this;
        vm.purchasePresentItem = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchasePresentItemUpdate', function(event, result) {
            vm.purchasePresentItem = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemDeleteController',PurchasePresentItemDeleteController);

    PurchasePresentItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasePresentItem'];

    function PurchasePresentItemDeleteController($uibModalInstance, entity, PurchasePresentItem) {
        var vm = this;
        vm.purchasePresentItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchasePresentItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-present-item', {
            parent: 'entity',
            url: '/purchase-present-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchasePresentItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-items.html',
                    controller: 'PurchasePresentItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItem');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-present-item-detail', {
            parent: 'entity',
            url: '/purchase-present-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchasePresentItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-detail.html',
                    controller: 'PurchasePresentItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItem');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchasePresentItem', function($stateParams, PurchasePresentItem) {
                    return PurchasePresentItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-present-item.new', {
            parent: 'purchase-present-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-dialog.html',
                    controller: 'PurchasePresentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                price: null,
                                quantityExecuted: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('purchase-present-item');
                });
            }]
        })
        .state('purchase-present-item.edit', {
            parent: 'purchase-present-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-dialog.html',
                    controller: 'PurchasePresentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchasePresentItem', function(PurchasePresentItem) {
                            return PurchasePresentItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-present-item.delete', {
            parent: 'purchase-present-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-delete-dialog.html',
                    controller: 'PurchasePresentItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchasePresentItem', function(PurchasePresentItem) {
                            return PurchasePresentItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchasePresentItem', PurchasePresentItem);

    PurchasePresentItem.$inject = ['$resource'];

    function PurchasePresentItem ($resource) {
        var resourceUrl =  'api/purchase-present-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemController', PurchasePresentItemController);

    PurchasePresentItemController.$inject = ['$scope', '$state', 'PurchasePresentItem', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchasePresentItemController ($scope, $state, PurchasePresentItem, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchasePresentItem.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchasePresentItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNumberingRowDialogController', PurchaseNumberingRowDialogController);

    PurchaseNumberingRowDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseNumberingRow'];

    function PurchaseNumberingRowDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseNumberingRow) {
        var vm = this;
        vm.purchaseNumberingRow = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseNumberingRowUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseNumberingRow.id !== null) {
                PurchaseNumberingRow.update(vm.purchaseNumberingRow, onSaveSuccess, onSaveError);
            } else {
                PurchaseNumberingRow.save(vm.purchaseNumberingRow, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNumberingRowDetailController', PurchaseNumberingRowDetailController);

    PurchaseNumberingRowDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchaseNumberingRow'];

    function PurchaseNumberingRowDetailController($scope, $rootScope, $stateParams, entity, PurchaseNumberingRow) {
        var vm = this;
        vm.purchaseNumberingRow = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseNumberingRowUpdate', function(event, result) {
            vm.purchaseNumberingRow = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNumberingRowDeleteController',PurchaseNumberingRowDeleteController);

    PurchaseNumberingRowDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchaseNumberingRow'];

    function PurchaseNumberingRowDeleteController($uibModalInstance, entity, PurchaseNumberingRow) {
        var vm = this;
        vm.purchaseNumberingRow = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchaseNumberingRow.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-numbering-row', {
            parent: 'entity',
            url: '/purchase-numbering-row?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseNumberingRow.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-rows.html',
                    controller: 'PurchaseNumberingRowController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseNumberingRow');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-numbering-row-detail', {
            parent: 'entity',
            url: '/purchase-numbering-row/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseNumberingRow.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-detail.html',
                    controller: 'PurchaseNumberingRowDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseNumberingRow');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseNumberingRow', function($stateParams, PurchaseNumberingRow) {
                    return PurchaseNumberingRow.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-numbering-row.new', {
            parent: 'purchase-numbering-row',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-dialog.html',
                    controller: 'PurchaseNumberingRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lastUsedNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('purchase-numbering-row');
                });
            }]
        })
        .state('purchase-numbering-row.edit', {
            parent: 'purchase-numbering-row',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-dialog.html',
                    controller: 'PurchaseNumberingRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseNumberingRow', function(PurchaseNumberingRow) {
                            return PurchaseNumberingRow.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-numbering-row.delete', {
            parent: 'purchase-numbering-row',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-delete-dialog.html',
                    controller: 'PurchaseNumberingRowDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseNumberingRow', function(PurchaseNumberingRow) {
                            return PurchaseNumberingRow.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseNumberingRow', PurchaseNumberingRow);

    PurchaseNumberingRow.$inject = ['$resource'];

    function PurchaseNumberingRow ($resource) {
        var resourceUrl =  'api/purchase-numbering-rows/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNumberingRowController', PurchaseNumberingRowController);

    PurchaseNumberingRowController.$inject = ['$scope', '$state', 'PurchaseNumberingRow', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchaseNumberingRowController ($scope, $state, PurchaseNumberingRow, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchaseNumberingRow.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchaseNumberingRows = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDialogController', PurchaseItemLotDialogController);

    PurchaseItemLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseItemLot', 'PurchaseItem'];

    function PurchaseItemLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseItemLot, PurchaseItem) {
        var vm = this;
        vm.purchaseItemLot = entity;
        vm.purchaseItems = PurchaseItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseItemLot.id !== null) {
                PurchaseItemLot.update(vm.purchaseItemLot, onSaveSuccess, onSaveError);
            } else {
                PurchaseItemLot.save(vm.purchaseItemLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDetailController', PurchaseItemLotDetailController);

    PurchaseItemLotDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchaseItemLot', 'PurchaseItem'];

    function PurchaseItemLotDetailController($scope, $rootScope, $stateParams, entity, PurchaseItemLot, PurchaseItem) {
        var vm = this;
        vm.purchaseItemLot = entity;

        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseItemLotUpdate', function(event, result) {
            vm.purchaseItemLot = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDeleteController',PurchaseItemLotDeleteController);

    PurchaseItemLotDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchaseItemLot'];

    function PurchaseItemLotDeleteController($uibModalInstance, entity, PurchaseItemLot) {
        var vm = this;
        vm.purchaseItemLot = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchaseItemLot.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-item-lot', {
            parent: 'entity',
            url: '/purchase-item-lot?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItemLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lots.html',
                    controller: 'PurchaseItemLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItemLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-item-lot-detail', {
            parent: 'entity',
            url: '/purchase-item-lot/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItemLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-detail.html',
                    controller: 'PurchaseItemLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItemLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseItemLot', function($stateParams, PurchaseItemLot) {
                    return PurchaseItemLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-item-lot.new', {
            parent: 'purchase-item-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-dialog.html',
                    controller: 'PurchaseItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                quantity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('purchase-item-lot');
                });
            }]
        })
        .state('purchase-item-lot.edit', {
            parent: 'purchase-item-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-dialog.html',
                    controller: 'PurchaseItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseItemLot', function(PurchaseItemLot) {
                            return PurchaseItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-item-lot.delete', {
            parent: 'purchase-item-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-delete-dialog.html',
                    controller: 'PurchaseItemLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseItemLot', function(PurchaseItemLot) {
                            return PurchaseItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseItemLot', PurchaseItemLot);

    PurchaseItemLot.$inject = ['$resource'];

    function PurchaseItemLot ($resource) {
        var resourceUrl =  'api/purchase-item-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotController', PurchaseItemLotController);

    PurchaseItemLotController.$inject = ['$scope', '$state', 'PurchaseItemLot', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchaseItemLotController ($scope, $state, PurchaseItemLot, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchaseItemLot.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchaseItemLots = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemDialogController', PurchaseItemDialogController);

    PurchaseItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseItem', 'Product', 'Purchase', 'MeasurementUnit'];

    function PurchaseItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseItem, Product, Purchase, MeasurementUnit) {
        var vm = this;
        vm.purchaseItem = entity;
        vm.products = Product.query();
        vm.purchases = Purchase.query();
        vm.measurementunits = MeasurementUnit.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseItem.id !== null) {
                PurchaseItem.update(vm.purchaseItem, onSaveSuccess, onSaveError);
            } else {
                PurchaseItem.save(vm.purchaseItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemDetailController', PurchaseItemDetailController);

    PurchaseItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchaseItem', 'Product', 'Purchase', 'MeasurementUnit'];

    function PurchaseItemDetailController($scope, $rootScope, $stateParams, entity, PurchaseItem, Product, Purchase, MeasurementUnit) {
        var vm = this;
        vm.purchaseItem = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseItemUpdate', function(event, result) {
            vm.purchaseItem = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemDeleteController',PurchaseItemDeleteController);

    PurchaseItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchaseItem'];

    function PurchaseItemDeleteController($uibModalInstance, entity, PurchaseItem) {
        var vm = this;
        vm.purchaseItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchaseItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-item', {
            parent: 'entity',
            url: '/purchase-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item/purchase-items.html',
                    controller: 'PurchaseItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-item-detail', {
            parent: 'entity',
            url: '/purchase-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item/purchase-item-detail.html',
                    controller: 'PurchaseItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseItem', function($stateParams, PurchaseItem) {
                    return PurchaseItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-item.new', {
            parent: 'purchase-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-dialog.html',
                    controller: 'PurchaseItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                productPrice: null,
                                netPrice: null,
                                discountPercent: null,
                                discountPrice: null,
                                discountLinePercent: null,
                                discountLinePrice: null,
                                totalPrice: null,
                                taxPrice: null,
                                finalPrice: null,
                                comment: null,
                                quantityExecuted: null,
                                discountPurchasePercent: null,
                                discountPurchasePrice: null,
                                discountSummary: null,
                                taxPercent: null,
                                lotNumber: null,
                                pfs: null,
                                executedDiscountSummary: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('purchase-item');
                });
            }]
        })
        .state('purchase-item.edit', {
            parent: 'purchase-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-dialog.html',
                    controller: 'PurchaseItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseItem', function(PurchaseItem) {
                            return PurchaseItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-item.delete', {
            parent: 'purchase-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-delete-dialog.html',
                    controller: 'PurchaseItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseItem', function(PurchaseItem) {
                            return PurchaseItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseItem', PurchaseItem);

    PurchaseItem.$inject = ['$resource'];

    function PurchaseItem ($resource) {
        var resourceUrl =  'api/purchase-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemController', PurchaseItemController);

    PurchaseItemController.$inject = ['$scope', '$state', 'PurchaseItem', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchaseItemController ($scope, $state, PurchaseItem, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PurchaseItem.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchaseItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseDialogController', PurchaseDialogController);

    PurchaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Purchase', 'Employee', 'PurchaseStatus', 'Sector', 'Customer', 'PaymentMethod', 'TaxStatus', 'PurchaseNumberingRow', 'TradePolicy'];

    function PurchaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Purchase, Employee, PurchaseStatus, Sector, Customer, PaymentMethod, TaxStatus, PurchaseNumberingRow, TradePolicy) {
        var vm = this;
        vm.purchase = entity;
        vm.employees = Employee.query();
        vm.purchasestatuses = PurchaseStatus.query();
        vm.sectors = Sector.query();
        vm.customers = Customer.query();
        vm.paymentmethods = PaymentMethod.query();
        vm.taxstatuses = TaxStatus.query();
        vm.purchasenumberingrows = PurchaseNumberingRow.query();
        vm.tradepolicies = TradePolicy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchase.id !== null) {
                Purchase.update(vm.purchase, onSaveSuccess, onSaveError);
            } else {
                Purchase.save(vm.purchase, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issueDate = false;
        vm.datePickerOpenStatus.desirableExecutionDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseDetailController', PurchaseDetailController);

    PurchaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Purchase', 'Employee', 'PurchaseStatus', 'Sector', 'Customer', 'PaymentMethod', 'TaxStatus', 'PurchaseNumberingRow', 'TradePolicy'];

    function PurchaseDetailController($scope, $rootScope, $stateParams, entity, Purchase, Employee, PurchaseStatus, Sector, Customer, PaymentMethod, TaxStatus, PurchaseNumberingRow, TradePolicy) {
        var vm = this;
        vm.purchase = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseUpdate', function(event, result) {
            vm.purchase = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseDeleteController',PurchaseDeleteController);

    PurchaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Purchase'];

    function PurchaseDeleteController($uibModalInstance, entity, Purchase) {
        var vm = this;
        vm.purchase = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Purchase.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase', {
            parent: 'entity',
            url: '/purchase?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchase.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase/purchases.html',
                    controller: 'PurchaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchase');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-detail', {
            parent: 'entity',
            url: '/purchase/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchase.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase/purchase-detail.html',
                    controller: 'PurchaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchase');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Purchase', function($stateParams, Purchase) {
                    return Purchase.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase.new', {
            parent: 'purchase',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-dialog.html',
                    controller: 'PurchaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                issueDate: null,
                                desirableExecutionDate: null,
                                shippingAddressNum: null,
                                shippingAddress: null,
                                shippingCityName: null,
                                shippingPrefectureName: null,
                                shippingRegionName: null,
                                shippingCountryName: null,
                                shippingPostalCode: null,
                                netPrice: null,
                                discountPrice: null,
                                totalPrice: null,
                                taxPrice: null,
                                finalPrice: null,
                                comment: null,
                                previousBalance: null,
                                creditLimit: null,
                                newBalance: null,
                                discountPercent: null,
                                presentPrice: null,
                                sectorAddressNum: null,
                                sectorAddress: null,
                                sectorCityName: null,
                                sectorPrefectureName: null,
                                sectorRegionName: null,
                                sectorCountryName: null,
                                sectorPostalCode: null,
                                code: null,
                                presentPercent: null,
                                discountFinalPrice: null,
                                createdFromBackOffice: null,
                                eventComments: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('purchase');
                });
            }]
        })
        .state('purchase.edit', {
            parent: 'purchase',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-dialog.html',
                    controller: 'PurchaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Purchase', function(Purchase) {
                            return Purchase.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase.delete', {
            parent: 'purchase',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-delete-dialog.html',
                    controller: 'PurchaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Purchase', function(Purchase) {
                            return Purchase.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Purchase', Purchase);

    Purchase.$inject = ['$resource', 'DateUtils'];

    function Purchase ($resource, DateUtils) {
        var resourceUrl =  'api/purchases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        data.desirableExecutionDate = DateUtils.convertLocalDateFromServer(data.desirableExecutionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    data.desirableExecutionDate = DateUtils.convertLocalDateToServer(data.desirableExecutionDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    data.desirableExecutionDate = DateUtils.convertLocalDateToServer(data.desirableExecutionDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseController', PurchaseController);

    PurchaseController.$inject = ['$scope', '$state', 'Purchase', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PurchaseController ($scope, $state, Purchase, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Purchase.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.purchases = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientDialogController', ProspectivePatientDialogController);

    ProspectivePatientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProspectivePatient', 'Attendant', 'Profession', 'NativeLanguage', 'Country', 'Region', 'Prefecture', 'City', 'Patient', 'CountryPhoneCode'];

    function ProspectivePatientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProspectivePatient, Attendant, Profession, NativeLanguage, Country, Region, Prefecture, City, Patient, CountryPhoneCode) {
        var vm = this;
        vm.prospectivePatient = entity;
        vm.attendants = Attendant.query();
        vm.professions = Profession.query();
        vm.nativelanguages = NativeLanguage.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.prefectures = Prefecture.query();
        vm.cities = City.query();
        vm.patients = Patient.query();
        vm.countryphonecodes = CountryPhoneCode.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:prospectivePatientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.prospectivePatient.id !== null) {
                ProspectivePatient.update(vm.prospectivePatient, onSaveSuccess, onSaveError);
            } else {
                ProspectivePatient.save(vm.prospectivePatient, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientDetailController', ProspectivePatientDetailController);

    ProspectivePatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProspectivePatient', 'Attendant', 'Profession', 'NativeLanguage', 'Country', 'Region', 'Prefecture', 'City', 'Patient', 'CountryPhoneCode'];

    function ProspectivePatientDetailController($scope, $rootScope, $stateParams, entity, ProspectivePatient, Attendant, Profession, NativeLanguage, Country, Region, Prefecture, City, Patient, CountryPhoneCode) {
        var vm = this;
        vm.prospectivePatient = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:prospectivePatientUpdate', function(event, result) {
            vm.prospectivePatient = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientDeleteController',ProspectivePatientDeleteController);

    ProspectivePatientDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProspectivePatient'];

    function ProspectivePatientDeleteController($uibModalInstance, entity, ProspectivePatient) {
        var vm = this;
        vm.prospectivePatient = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProspectivePatient.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prospective-patient', {
            parent: 'entity',
            url: '/prospective-patient?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prospectivePatient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prospective-patient/prospective-patients.html',
                    controller: 'ProspectivePatientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prospectivePatient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prospective-patient-detail', {
            parent: 'entity',
            url: '/prospective-patient/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prospectivePatient.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-detail.html',
                    controller: 'ProspectivePatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prospectivePatient');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProspectivePatient', function($stateParams, ProspectivePatient) {
                    return ProspectivePatient.get({id : $stateParams.id});
                }]
            }
        })
        .state('prospective-patient.new', {
            parent: 'prospective-patient',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-dialog.html',
                    controller: 'ProspectivePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                phone: null,
                                email: null,
                                mobile: null,
                                birthYear: null,
                                countryName: null,
                                regionName: null,
                                prefectureName: null,
                                cityName: null,
                                postalCode: null,
                                address: null,
                                addressNum: null,
                                isWrongPhone: null,
                                isWrongContact: null,
                                amka: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('prospective-patient');
                });
            }]
        })
        .state('prospective-patient.edit', {
            parent: 'prospective-patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-dialog.html',
                    controller: 'ProspectivePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProspectivePatient', function(ProspectivePatient) {
                            return ProspectivePatient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prospective-patient.delete', {
            parent: 'prospective-patient',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-delete-dialog.html',
                    controller: 'ProspectivePatientDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProspectivePatient', function(ProspectivePatient) {
                            return ProspectivePatient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProspectivePatient', ProspectivePatient);

    ProspectivePatient.$inject = ['$resource'];

    function ProspectivePatient ($resource) {
        var resourceUrl =  'api/prospective-patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientController', ProspectivePatientController);

    ProspectivePatientController.$inject = ['$scope', '$state', 'ProspectivePatient', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProspectivePatientController ($scope, $state, ProspectivePatient, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ProspectivePatient.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.prospectivePatients = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionDialogController', ProfessionDialogController);

    ProfessionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Profession'];

    function ProfessionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Profession) {
        var vm = this;
        vm.profession = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:professionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.profession.id !== null) {
                Profession.update(vm.profession, onSaveSuccess, onSaveError);
            } else {
                Profession.save(vm.profession, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionDetailController', ProfessionDetailController);

    ProfessionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Profession'];

    function ProfessionDetailController($scope, $rootScope, $stateParams, entity, Profession) {
        var vm = this;
        vm.profession = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:professionUpdate', function(event, result) {
            vm.profession = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionDeleteController',ProfessionDeleteController);

    ProfessionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Profession'];

    function ProfessionDeleteController($uibModalInstance, entity, Profession) {
        var vm = this;
        vm.profession = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Profession.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profession', {
            parent: 'entity',
            url: '/profession?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.profession.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profession/professions.html',
                    controller: 'ProfessionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profession-detail', {
            parent: 'entity',
            url: '/profession/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.profession.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profession/profession-detail.html',
                    controller: 'ProfessionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profession');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Profession', function($stateParams, Profession) {
                    return Profession.get({id : $stateParams.id});
                }]
            }
        })
        .state('profession.new', {
            parent: 'profession',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-dialog.html',
                    controller: 'ProfessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('profession');
                });
            }]
        })
        .state('profession.edit', {
            parent: 'profession',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-dialog.html',
                    controller: 'ProfessionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profession', function(Profession) {
                            return Profession.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profession.delete', {
            parent: 'profession',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profession/profession-delete-dialog.html',
                    controller: 'ProfessionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profession', function(Profession) {
                            return Profession.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profession', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Profession', Profession);

    Profession.$inject = ['$resource'];

    function Profession ($resource) {
        var resourceUrl =  'api/professions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionController', ProfessionController);

    ProfessionController.$inject = ['$scope', '$state', 'Profession', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProfessionController ($scope, $state, Profession, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Profession.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.professions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductPriceDialogController', ProductPriceDialogController);

    ProductPriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductPrice', 'Product'];

    function ProductPriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductPrice, Product) {
        var vm = this;
        vm.productPrice = entity;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productPriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productPrice.id !== null) {
                ProductPrice.update(vm.productPrice, onSaveSuccess, onSaveError);
            } else {
                ProductPrice.save(vm.productPrice, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedDate = false;
        vm.datePickerOpenStatus.endedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductPriceDetailController', ProductPriceDetailController);

    ProductPriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductPrice', 'Product'];

    function ProductPriceDetailController($scope, $rootScope, $stateParams, entity, ProductPrice, Product) {
        var vm = this;
        vm.productPrice = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productPriceUpdate', function(event, result) {
            vm.productPrice = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductPriceDeleteController',ProductPriceDeleteController);

    ProductPriceDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductPrice'];

    function ProductPriceDeleteController($uibModalInstance, entity, ProductPrice) {
        var vm = this;
        vm.productPrice = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductPrice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-price', {
            parent: 'entity',
            url: '/product-price?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productPrice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-price/product-prices.html',
                    controller: 'ProductPriceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productPrice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-price-detail', {
            parent: 'entity',
            url: '/product-price/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productPrice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-price/product-price-detail.html',
                    controller: 'ProductPriceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productPrice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductPrice', function($stateParams, ProductPrice) {
                    return ProductPrice.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-price.new', {
            parent: 'product-price',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-price/product-price-dialog.html',
                    controller: 'ProductPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedDate: null,
                                endedDate: null,
                                retailPrice: null,
                                wholesalePrice: null,
                                costPrice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-price', null, { reload: true });
                }, function() {
                    $state.go('product-price');
                });
            }]
        })
        .state('product-price.edit', {
            parent: 'product-price',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-price/product-price-dialog.html',
                    controller: 'ProductPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductPrice', function(ProductPrice) {
                            return ProductPrice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-price', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-price.delete', {
            parent: 'product-price',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-price/product-price-delete-dialog.html',
                    controller: 'ProductPriceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductPrice', function(ProductPrice) {
                            return ProductPrice.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-price', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductPrice', ProductPrice);

    ProductPrice.$inject = ['$resource', 'DateUtils'];

    function ProductPrice ($resource, DateUtils) {
        var resourceUrl =  'api/product-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedDate = DateUtils.convertLocalDateFromServer(data.startedDate);
                        data.endedDate = DateUtils.convertLocalDateFromServer(data.endedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                    data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startedDate = DateUtils.convertLocalDateToServer(data.startedDate);
                    data.endedDate = DateUtils.convertLocalDateToServer(data.endedDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductPriceController', ProductPriceController);

    ProductPriceController.$inject = ['$scope', '$state', 'ProductPrice', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductPriceController ($scope, $state, ProductPrice, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ProductPrice.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productPrices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotDialogController', ProductLotDialogController);

    ProductLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductLot', 'Product'];

    function ProductLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductLot, Product) {
        var vm = this;
        vm.productLot = entity;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productLotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productLot.id !== null) {
                ProductLot.update(vm.productLot, onSaveSuccess, onSaveError);
            } else {
                ProductLot.save(vm.productLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.registrationDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotDetailController', ProductLotDetailController);

    ProductLotDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductLot', 'Product'];

    function ProductLotDetailController($scope, $rootScope, $stateParams, entity, ProductLot, Product) {
        var vm = this;
        vm.productLot = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productLotUpdate', function(event, result) {
            vm.productLot = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotDeleteController',ProductLotDeleteController);

    ProductLotDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductLot'];

    function ProductLotDeleteController($uibModalInstance, entity, ProductLot) {
        var vm = this;
        vm.productLot = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductLot.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-lot', {
            parent: 'entity',
            url: '/product-lot?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-lot/product-lots.html',
                    controller: 'ProductLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-lot-detail', {
            parent: 'entity',
            url: '/product-lot/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-lot/product-lot-detail.html',
                    controller: 'ProductLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductLot', function($stateParams, ProductLot) {
                    return ProductLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-lot.new', {
            parent: 'product-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-dialog.html',
                    controller: 'ProductLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                referenceNumber: null,
                                expirationMonth: null,
                                fromIdNumber: null,
                                toIdNumber: null,
                                registrationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('product-lot');
                });
            }]
        })
        .state('product-lot.edit', {
            parent: 'product-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-dialog.html',
                    controller: 'ProductLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductLot', function(ProductLot) {
                            return ProductLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-lot.delete', {
            parent: 'product-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-delete-dialog.html',
                    controller: 'ProductLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductLot', function(ProductLot) {
                            return ProductLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductLot', ProductLot);

    ProductLot.$inject = ['$resource', 'DateUtils'];

    function ProductLot ($resource, DateUtils) {
        var resourceUrl =  'api/product-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertLocalDateFromServer(data.registrationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.registrationDate = DateUtils.convertLocalDateToServer(data.registrationDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.registrationDate = DateUtils.convertLocalDateToServer(data.registrationDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotController', ProductLotController);

    ProductLotController.$inject = ['$scope', '$state', 'ProductLot', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductLotController ($scope, $state, ProductLot, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ProductLot.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productLots = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductDialogController', ProductCategoryProductDialogController);

    ProductCategoryProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductCategoryProduct', 'Product', 'ProductCategory'];

    function ProductCategoryProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductCategoryProduct, Product, ProductCategory) {
        var vm = this;
        vm.productCategoryProduct = entity;
        vm.products = Product.query();
        vm.productcategories = ProductCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productCategoryProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productCategoryProduct.id !== null) {
                ProductCategoryProduct.update(vm.productCategoryProduct, onSaveSuccess, onSaveError);
            } else {
                ProductCategoryProduct.save(vm.productCategoryProduct, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductDetailController', ProductCategoryProductDetailController);

    ProductCategoryProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductCategoryProduct', 'Product', 'ProductCategory'];

    function ProductCategoryProductDetailController($scope, $rootScope, $stateParams, entity, ProductCategoryProduct, Product, ProductCategory) {
        var vm = this;
        vm.productCategoryProduct = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productCategoryProductUpdate', function(event, result) {
            vm.productCategoryProduct = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductDeleteController',ProductCategoryProductDeleteController);

    ProductCategoryProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductCategoryProduct'];

    function ProductCategoryProductDeleteController($uibModalInstance, entity, ProductCategoryProduct) {
        var vm = this;
        vm.productCategoryProduct = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductCategoryProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-category-product', {
            parent: 'entity',
            url: '/product-category-product',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategoryProduct.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category-product/product-category-products.html',
                    controller: 'ProductCategoryProductController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategoryProduct');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-category-product-detail', {
            parent: 'entity',
            url: '/product-category-product/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategoryProduct.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category-product/product-category-product-detail.html',
                    controller: 'ProductCategoryProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategoryProduct');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductCategoryProduct', function($stateParams, ProductCategoryProduct) {
                    return ProductCategoryProduct.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-category-product.new', {
            parent: 'product-category-product',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-dialog.html',
                    controller: 'ProductCategoryProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('product-category-product');
                });
            }]
        })
        .state('product-category-product.edit', {
            parent: 'product-category-product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-dialog.html',
                    controller: 'ProductCategoryProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductCategoryProduct', function(ProductCategoryProduct) {
                            return ProductCategoryProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-category-product.delete', {
            parent: 'product-category-product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-delete-dialog.html',
                    controller: 'ProductCategoryProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductCategoryProduct', function(ProductCategoryProduct) {
                            return ProductCategoryProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductCategoryProduct', ProductCategoryProduct);

    ProductCategoryProduct.$inject = ['$resource'];

    function ProductCategoryProduct ($resource) {
        var resourceUrl =  'api/product-category-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductController', ProductCategoryProductController);

    ProductCategoryProductController.$inject = ['$scope', '$state', 'ProductCategoryProduct'];

    function ProductCategoryProductController ($scope, $state, ProductCategoryProduct) {
        var vm = this;
        vm.productCategoryProducts = [];
        vm.loadAll = function() {
            ProductCategoryProduct.query(function(result) {
                vm.productCategoryProducts = result;
            });
        };

        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryDialogController', ProductCategoryDialogController);

    ProductCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductCategory'];

    function ProductCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productCategory.id !== null) {
                ProductCategory.update(vm.productCategory, onSaveSuccess, onSaveError);
            } else {
                ProductCategory.save(vm.productCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryDetailController', ProductCategoryDetailController);

    ProductCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductCategory'];

    function ProductCategoryDetailController($scope, $rootScope, $stateParams, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productCategoryUpdate', function(event, result) {
            vm.productCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryDeleteController',ProductCategoryDeleteController);

    ProductCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductCategory'];

    function ProductCategoryDeleteController($uibModalInstance, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-category', {
            parent: 'entity',
            url: '/product-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category/product-categories.html',
                    controller: 'ProductCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-category-detail', {
            parent: 'entity',
            url: '/product-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category/product-category-detail.html',
                    controller: 'ProductCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductCategory', function($stateParams, ProductCategory) {
                    return ProductCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-category.new', {
            parent: 'product-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-dialog.html',
                    controller: 'ProductCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                isSalesCategory: null,
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('product-category');
                });
            }]
        })
        .state('product-category.edit', {
            parent: 'product-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-dialog.html',
                    controller: 'ProductCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductCategory', function(ProductCategory) {
                            return ProductCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-category.delete', {
            parent: 'product-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-delete-dialog.html',
                    controller: 'ProductCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductCategory', function(ProductCategory) {
                            return ProductCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductCategory', ProductCategory);

    ProductCategory.$inject = ['$resource'];

    function ProductCategory ($resource) {
        var resourceUrl =  'api/product-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryController', ProductCategoryController);

    ProductCategoryController.$inject = ['$scope', '$state', 'ProductCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductCategoryController ($scope, $state, ProductCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ProductCategory.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Product', 'ProductCategory', 'TaxClass', 'MeasurementUnit'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Product, ProductCategory, TaxClass, MeasurementUnit) {
        var vm = this;
        vm.product = entity;
        vm.productcategories = ProductCategory.query();
        vm.taxclasses = TaxClass.query();
        vm.measurementunits = MeasurementUnit.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setImage = function ($file, product) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        product.image = base64Data;
                        product.imageContentType = $file.type;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Product', 'ProductCategory', 'TaxClass', 'MeasurementUnit'];

    function ProductDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Product, ProductCategory, TaxClass, MeasurementUnit) {
        var vm = this;
        vm.product = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;
        vm.product = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'entity',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id});
                }]
            }
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                activeSubstance: null,
                                image: null,
                                imageContentType: null,
                                barcode: null,
                                code: null,
                                supplierCode: null,
                                atcCode: null,
                                packaging: null,
                                defaultDiscount: null,
                                availableForVisit: null,
                                availableForPurchase: null,
                                calcPFS: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('product');
                });
            }]
        })
        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ProductSearch', ProductSearch);

    ProductSearch.$inject = ['$resource'];

    function ProductSearch($resource) {
        var resourceUrl =  'api/_search/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$state', 'DataUtils', 'Product', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductController ($scope, $state, DataUtils, Product, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            Product.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDialogController', PresentListProductDialogController);

    PresentListProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PresentListProduct', 'Product', 'PresentList'];

    function PresentListProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PresentListProduct, Product, PresentList) {
        var vm = this;
        vm.presentListProduct = entity;
        vm.products = Product.query();
        vm.presentlists = PresentList.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:presentListProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.presentListProduct.id !== null) {
                PresentListProduct.update(vm.presentListProduct, onSaveSuccess, onSaveError);
            } else {
                PresentListProduct.save(vm.presentListProduct, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDetailController', PresentListProductDetailController);

    PresentListProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PresentListProduct', 'Product', 'PresentList'];

    function PresentListProductDetailController($scope, $rootScope, $stateParams, entity, PresentListProduct, Product, PresentList) {
        var vm = this;
        vm.presentListProduct = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:presentListProductUpdate', function(event, result) {
            vm.presentListProduct = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDeleteController',PresentListProductDeleteController);

    PresentListProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'PresentListProduct'];

    function PresentListProductDeleteController($uibModalInstance, entity, PresentListProduct) {
        var vm = this;
        vm.presentListProduct = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PresentListProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('present-list-product', {
            parent: 'entity',
            url: '/present-list-product?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentListProduct.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list-product/present-list-products.html',
                    controller: 'PresentListProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentListProduct');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('present-list-product-detail', {
            parent: 'entity',
            url: '/present-list-product/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentListProduct.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list-product/present-list-product-detail.html',
                    controller: 'PresentListProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentListProduct');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PresentListProduct', function($stateParams, PresentListProduct) {
                    return PresentListProduct.get({id : $stateParams.id});
                }]
            }
        })
        .state('present-list-product.new', {
            parent: 'present-list-product',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-dialog.html',
                    controller: 'PresentListProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('present-list-product');
                });
            }]
        })
        .state('present-list-product.edit', {
            parent: 'present-list-product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-dialog.html',
                    controller: 'PresentListProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PresentListProduct', function(PresentListProduct) {
                            return PresentListProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('present-list-product.delete', {
            parent: 'present-list-product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-delete-dialog.html',
                    controller: 'PresentListProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PresentListProduct', function(PresentListProduct) {
                            return PresentListProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PresentListProduct', PresentListProduct);

    PresentListProduct.$inject = ['$resource'];

    function PresentListProduct ($resource) {
        var resourceUrl =  'api/present-list-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductController', PresentListProductController);

    PresentListProductController.$inject = ['$scope', '$state', 'PresentListProduct', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PresentListProductController ($scope, $state, PresentListProduct, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PresentListProduct.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.presentListProducts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListDialogController', PresentListDialogController);

    PresentListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PresentList'];

    function PresentListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PresentList) {
        var vm = this;
        vm.presentList = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:presentListUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.presentList.id !== null) {
                PresentList.update(vm.presentList, onSaveSuccess, onSaveError);
            } else {
                PresentList.save(vm.presentList, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListDetailController', PresentListDetailController);

    PresentListDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PresentList'];

    function PresentListDetailController($scope, $rootScope, $stateParams, entity, PresentList) {
        var vm = this;
        vm.presentList = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:presentListUpdate', function(event, result) {
            vm.presentList = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListDeleteController',PresentListDeleteController);

    PresentListDeleteController.$inject = ['$uibModalInstance', 'entity', 'PresentList'];

    function PresentListDeleteController($uibModalInstance, entity, PresentList) {
        var vm = this;
        vm.presentList = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PresentList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('present-list', {
            parent: 'entity',
            url: '/present-list?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list/present-lists.html',
                    controller: 'PresentListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentList');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('present-list-detail', {
            parent: 'entity',
            url: '/present-list/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentList.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list/present-list-detail.html',
                    controller: 'PresentListDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentList');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PresentList', function($stateParams, PresentList) {
                    return PresentList.get({id : $stateParams.id});
                }]
            }
        })
        .state('present-list.new', {
            parent: 'present-list',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-dialog.html',
                    controller: 'PresentListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                selectable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('present-list');
                });
            }]
        })
        .state('present-list.edit', {
            parent: 'present-list',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-dialog.html',
                    controller: 'PresentListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PresentList', function(PresentList) {
                            return PresentList.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('present-list.delete', {
            parent: 'present-list',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-delete-dialog.html',
                    controller: 'PresentListDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PresentList', function(PresentList) {
                            return PresentList.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PresentList', PresentList);

    PresentList.$inject = ['$resource'];

    function PresentList ($resource) {
        var resourceUrl =  'api/present-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListController', PresentListController);

    PresentListController.$inject = ['$scope', '$state', 'PresentList', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PresentListController ($scope, $state, PresentList, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PresentList.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.presentLists = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureDialogController', PrefectureDialogController);

    PrefectureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Prefecture', 'Region'];

    function PrefectureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Prefecture, Region) {
        var vm = this;
        vm.prefecture = entity;
        vm.regions = Region.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:prefectureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.prefecture.id !== null) {
                Prefecture.update(vm.prefecture, onSaveSuccess, onSaveError);
            } else {
                Prefecture.save(vm.prefecture, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureDetailController', PrefectureDetailController);

    PrefectureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Prefecture', 'Region'];

    function PrefectureDetailController($scope, $rootScope, $stateParams, entity, Prefecture, Region) {
        var vm = this;
        vm.prefecture = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:prefectureUpdate', function(event, result) {
            vm.prefecture = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureDeleteController',PrefectureDeleteController);

    PrefectureDeleteController.$inject = ['$uibModalInstance', 'entity', 'Prefecture'];

    function PrefectureDeleteController($uibModalInstance, entity, Prefecture) {
        var vm = this;
        vm.prefecture = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Prefecture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prefecture', {
            parent: 'entity',
            url: '/prefecture?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prefecture.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prefecture/prefectures.html',
                    controller: 'PrefectureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prefecture');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prefecture-detail', {
            parent: 'entity',
            url: '/prefecture/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prefecture.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prefecture/prefecture-detail.html',
                    controller: 'PrefectureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prefecture');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Prefecture', function($stateParams, Prefecture) {
                    return Prefecture.get({id : $stateParams.id});
                }]
            }
        })
        .state('prefecture.new', {
            parent: 'prefecture',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-dialog.html',
                    controller: 'PrefectureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('prefecture');
                });
            }]
        })
        .state('prefecture.edit', {
            parent: 'prefecture',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-dialog.html',
                    controller: 'PrefectureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Prefecture', function(Prefecture) {
                            return Prefecture.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prefecture.delete', {
            parent: 'prefecture',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-delete-dialog.html',
                    controller: 'PrefectureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Prefecture', function(Prefecture) {
                            return Prefecture.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Prefecture', Prefecture);

    Prefecture.$inject = ['$resource'];

    function Prefecture ($resource) {
        var resourceUrl =  'api/prefectures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PrefectureSearch', PrefectureSearch);

    PrefectureSearch.$inject = ['$resource'];

    function PrefectureSearch($resource) {
        var resourceUrl =  'api/_search/prefectures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureController', PrefectureController);

    PrefectureController.$inject = ['$scope', '$state', 'Prefecture', 'PrefectureSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PrefectureController ($scope, $state, Prefecture, PrefectureSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PrefectureSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Prefecture.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.prefectures = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodDialogController', PaymentMethodDialogController);

    PaymentMethodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentMethod'];

    function PaymentMethodDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentMethod) {
        var vm = this;
        vm.paymentMethod = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:paymentMethodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.paymentMethod.id !== null) {
                PaymentMethod.update(vm.paymentMethod, onSaveSuccess, onSaveError);
            } else {
                PaymentMethod.save(vm.paymentMethod, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodDetailController', PaymentMethodDetailController);

    PaymentMethodDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PaymentMethod'];

    function PaymentMethodDetailController($scope, $rootScope, $stateParams, entity, PaymentMethod) {
        var vm = this;
        vm.paymentMethod = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:paymentMethodUpdate', function(event, result) {
            vm.paymentMethod = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodDeleteController',PaymentMethodDeleteController);

    PaymentMethodDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaymentMethod'];

    function PaymentMethodDeleteController($uibModalInstance, entity, PaymentMethod) {
        var vm = this;
        vm.paymentMethod = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PaymentMethod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment-method', {
            parent: 'entity',
            url: '/payment-method?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.paymentMethod.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment-method/payment-methods.html',
                    controller: 'PaymentMethodController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paymentMethod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('payment-method-detail', {
            parent: 'entity',
            url: '/payment-method/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.paymentMethod.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment-method/payment-method-detail.html',
                    controller: 'PaymentMethodDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paymentMethod');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PaymentMethod', function($stateParams, PaymentMethod) {
                    return PaymentMethod.get({id : $stateParams.id});
                }]
            }
        })
        .state('payment-method.new', {
            parent: 'payment-method',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-dialog.html',
                    controller: 'PaymentMethodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('payment-method');
                });
            }]
        })
        .state('payment-method.edit', {
            parent: 'payment-method',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-dialog.html',
                    controller: 'PaymentMethodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaymentMethod', function(PaymentMethod) {
                            return PaymentMethod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment-method.delete', {
            parent: 'payment-method',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-delete-dialog.html',
                    controller: 'PaymentMethodDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PaymentMethod', function(PaymentMethod) {
                            return PaymentMethod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PaymentMethod', PaymentMethod);

    PaymentMethod.$inject = ['$resource'];

    function PaymentMethod ($resource) {
        var resourceUrl =  'api/payment-methods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodController', PaymentMethodController);

    PaymentMethodController.$inject = ['$scope', '$state', 'PaymentMethod', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PaymentMethodController ($scope, $state, PaymentMethod, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PaymentMethod.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.paymentMethods = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientDialogController', PatientDialogController);

    PatientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Patient', 'ProspectivePatient'];

    function PatientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Patient, ProspectivePatient) {
        var vm = this;
        vm.patient = entity;
        vm.prospectivepatients = ProspectivePatient.query({filter: 'patient-is-null'});
        $q.all([vm.patient.$promise, vm.prospectivepatients.$promise]).then(function() {
            if (!vm.patient.prospectivePatient || !vm.patient.prospectivePatient.id) {
                return $q.reject();
            }
            return ProspectivePatient.get({id : vm.patient.prospectivePatient.id}).$promise;
        }).then(function(prospectivePatient) {
            vm.prospectivepatients.push(prospectivePatient);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patient.id !== null) {
                Patient.update(vm.patient, onSaveSuccess, onSaveError);
            } else {
                Patient.save(vm.patient, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientDetailController', PatientDetailController);

    PatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Patient', 'ProspectivePatient'];

    function PatientDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Patient, ProspectivePatient) {
        var vm = this;
        vm.patient = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patientUpdate', function(event, result) {
            vm.patient = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientDeleteController',PatientDeleteController);

    PatientDeleteController.$inject = ['$uibModalInstance', 'entity', 'Patient'];

    function PatientDeleteController($uibModalInstance, entity, Patient) {
        var vm = this;
        vm.patient = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Patient.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient', {
            parent: 'entity',
            url: '/patient?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.patient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient/patients.html',
                    controller: 'PatientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patient-detail', {
            parent: 'entity',
            url: '/patient/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.patient.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient/patient-detail.html',
                    controller: 'PatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patient');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Patient', function($stateParams, Patient) {
                    return Patient.get({id : $stateParams.id});
                }]
            }
        })
        .state('patient.new', {
            parent: 'patient',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-dialog.html',
                    controller: 'PatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                yearOfBirth: null,
                                amka: null,
                                phone: null,
                                notes: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('patient');
                });
            }]
        })
        .state('patient.edit', {
            parent: 'patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-dialog.html',
                    controller: 'PatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Patient', function(Patient) {
                            return Patient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient.delete', {
            parent: 'patient',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-delete-dialog.html',
                    controller: 'PatientDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Patient', function(Patient) {
                            return Patient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Patient', Patient);

    Patient.$inject = ['$resource'];

    function Patient ($resource) {
        var resourceUrl =  'api/patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientController', PatientController);

    PatientController.$inject = ['$scope', '$state', 'DataUtils', 'Patient', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatientController ($scope, $state, DataUtils, Patient, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            Patient.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patients = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDialogController', PatchReportPhotoDialogController);

    PatchReportPhotoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PatchReportPhoto', 'PatchReport'];

    function PatchReportPhotoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PatchReportPhoto, PatchReport) {
        var vm = this;
        vm.patchReportPhoto = entity;
        vm.patchreports = PatchReport.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportPhotoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReportPhoto.id !== null) {
                PatchReportPhoto.update(vm.patchReportPhoto, onSaveSuccess, onSaveError);
            } else {
                PatchReportPhoto.save(vm.patchReportPhoto, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setPatchPhoto = function ($file, patchReportPhoto) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        patchReportPhoto.patchPhoto = base64Data;
                        patchReportPhoto.patchPhotoContentType = $file.type;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDetailController', PatchReportPhotoDetailController);

    PatchReportPhotoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'PatchReportPhoto', 'PatchReport'];

    function PatchReportPhotoDetailController($scope, $rootScope, $stateParams, DataUtils, entity, PatchReportPhoto, PatchReport) {
        var vm = this;
        vm.patchReportPhoto = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchReportPhotoUpdate', function(event, result) {
            vm.patchReportPhoto = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDeleteController',PatchReportPhotoDeleteController);

    PatchReportPhotoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportPhoto'];

    function PatchReportPhotoDeleteController($uibModalInstance, entity, PatchReportPhoto) {
        var vm = this;
        vm.patchReportPhoto = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportPhoto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-photo', {
            parent: 'entity',
            url: '/patch-report-photo?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportPhoto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photos.html',
                    controller: 'PatchReportPhotoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportPhoto');
                    $translatePartialLoader.addPart('patchPhotoType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-photo-detail', {
            parent: 'entity',
            url: '/patch-report-photo/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportPhoto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-detail.html',
                    controller: 'PatchReportPhotoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportPhoto');
                    $translatePartialLoader.addPart('patchPhotoType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportPhoto', function($stateParams, PatchReportPhoto) {
                    return PatchReportPhoto.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-photo.new', {
            parent: 'patch-report-photo',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-dialog.html',
                    controller: 'PatchReportPhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                patchPhotoName: null,
                                patchPhotoType: null,
                                patchPhoto: null,
                                patchPhotoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('patch-report-photo');
                });
            }]
        })
        .state('patch-report-photo.edit', {
            parent: 'patch-report-photo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-dialog.html',
                    controller: 'PatchReportPhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportPhoto', function(PatchReportPhoto) {
                            return PatchReportPhoto.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-photo.delete', {
            parent: 'patch-report-photo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-delete-dialog.html',
                    controller: 'PatchReportPhotoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportPhoto', function(PatchReportPhoto) {
                            return PatchReportPhoto.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportPhoto', PatchReportPhoto);

    PatchReportPhoto.$inject = ['$resource'];

    function PatchReportPhoto ($resource) {
        var resourceUrl =  'api/patch-report-photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoController', PatchReportPhotoController);

    PatchReportPhotoController.$inject = ['$scope', '$state', 'DataUtils', 'PatchReportPhoto', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchReportPhotoController ($scope, $state, DataUtils, PatchReportPhoto, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            PatchReportPhoto.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchReportPhotos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryDialogController', PatchReportMaterialCategoryDialogController);

    PatchReportMaterialCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchReportMaterialCategory'];

    function PatchReportMaterialCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchReportMaterialCategory) {
        var vm = this;
        vm.patchReportMaterialCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportMaterialCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReportMaterialCategory.id !== null) {
                PatchReportMaterialCategory.update(vm.patchReportMaterialCategory, onSaveSuccess, onSaveError);
            } else {
                PatchReportMaterialCategory.save(vm.patchReportMaterialCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryDetailController', PatchReportMaterialCategoryDetailController);

    PatchReportMaterialCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PatchReportMaterialCategory'];

    function PatchReportMaterialCategoryDetailController($scope, $rootScope, $stateParams, entity, PatchReportMaterialCategory) {
        var vm = this;
        vm.patchReportMaterialCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchReportMaterialCategoryUpdate', function(event, result) {
            vm.patchReportMaterialCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryDeleteController',PatchReportMaterialCategoryDeleteController);

    PatchReportMaterialCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportMaterialCategory'];

    function PatchReportMaterialCategoryDeleteController($uibModalInstance, entity, PatchReportMaterialCategory) {
        var vm = this;
        vm.patchReportMaterialCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportMaterialCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-material-category', {
            parent: 'entity',
            url: '/patch-report-material-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportMaterialCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-categories.html',
                    controller: 'PatchReportMaterialCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportMaterialCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-material-category-detail', {
            parent: 'entity',
            url: '/patch-report-material-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportMaterialCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-detail.html',
                    controller: 'PatchReportMaterialCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportMaterialCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportMaterialCategory', function($stateParams, PatchReportMaterialCategory) {
                    return PatchReportMaterialCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-material-category.new', {
            parent: 'patch-report-material-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-dialog.html',
                    controller: 'PatchReportMaterialCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('patch-report-material-category');
                });
            }]
        })
        .state('patch-report-material-category.edit', {
            parent: 'patch-report-material-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-dialog.html',
                    controller: 'PatchReportMaterialCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportMaterialCategory', function(PatchReportMaterialCategory) {
                            return PatchReportMaterialCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-material-category.delete', {
            parent: 'patch-report-material-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-delete-dialog.html',
                    controller: 'PatchReportMaterialCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportMaterialCategory', function(PatchReportMaterialCategory) {
                            return PatchReportMaterialCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportMaterialCategory', PatchReportMaterialCategory);

    PatchReportMaterialCategory.$inject = ['$resource'];

    function PatchReportMaterialCategory ($resource) {
        var resourceUrl =  'api/patch-report-material-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryController', PatchReportMaterialCategoryController);

    PatchReportMaterialCategoryController.$inject = ['$scope', '$state', 'PatchReportMaterialCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchReportMaterialCategoryController ($scope, $state, PatchReportMaterialCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PatchReportMaterialCategory.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchReportMaterialCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportItemDialogController', PatchReportItemDialogController);

    PatchReportItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchReportItem', 'PatchReport', 'PatchItem', 'Icd10'];

    function PatchReportItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchReportItem, PatchReport, PatchItem, Icd10) {
        var vm = this;
        vm.patchReportItem = entity;
        vm.patchreports = PatchReport.query();
        vm.patchitems = PatchItem.query();
        vm.icd10s = Icd10.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReportItem.id !== null) {
                PatchReportItem.update(vm.patchReportItem, onSaveSuccess, onSaveError);
            } else {
                PatchReportItem.save(vm.patchReportItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportItemDetailController', PatchReportItemDetailController);

    PatchReportItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PatchReportItem', 'PatchReport', 'PatchItem', 'Icd10'];

    function PatchReportItemDetailController($scope, $rootScope, $stateParams, entity, PatchReportItem, PatchReport, PatchItem, Icd10) {
        var vm = this;
        vm.patchReportItem = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchReportItemUpdate', function(event, result) {
            vm.patchReportItem = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportItemDeleteController',PatchReportItemDeleteController);

    PatchReportItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportItem'];

    function PatchReportItemDeleteController($uibModalInstance, entity, PatchReportItem) {
        var vm = this;
        vm.patchReportItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-item', {
            parent: 'entity',
            url: '/patch-report-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-item/patch-report-items.html',
                    controller: 'PatchReportItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-item-detail', {
            parent: 'entity',
            url: '/patch-report-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-detail.html',
                    controller: 'PatchReportItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportItem', function($stateParams, PatchReportItem) {
                    return PatchReportItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-item.new', {
            parent: 'patch-report-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-dialog.html',
                    controller: 'PatchReportItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                monthlyQuantity: null,
                                durationInMonths: null,
                                bodyArea: null,
                                participationPercent: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('patch-report-item');
                });
            }]
        })
        .state('patch-report-item.edit', {
            parent: 'patch-report-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-dialog.html',
                    controller: 'PatchReportItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportItem', function(PatchReportItem) {
                            return PatchReportItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-item.delete', {
            parent: 'patch-report-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-delete-dialog.html',
                    controller: 'PatchReportItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportItem', function(PatchReportItem) {
                            return PatchReportItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportItem', PatchReportItem);

    PatchReportItem.$inject = ['$resource'];

    function PatchReportItem ($resource) {
        var resourceUrl =  'api/patch-report-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchReportItemSearch', PatchReportItemSearch);

    PatchReportItemSearch.$inject = ['$resource'];

    function PatchReportItemSearch($resource) {
        var resourceUrl =  'api/_search/patch-report-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportItemController', PatchReportItemController);

    PatchReportItemController.$inject = ['$scope', '$state', 'PatchReportItem', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchReportItemController ($scope, $state, PatchReportItem, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PatchReportItem.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchReportItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportDialogController', PatchReportDialogController);

    PatchReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchReport', 'PatchCustomer', 'Employee', 'PatchReportMaterialCategory', 'CustomerSector'];

    function PatchReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchReport, PatchCustomer, Employee, PatchReportMaterialCategory, CustomerSector) {
        var vm = this;
        vm.patchReport = entity;
        vm.patchcustomers = PatchCustomer.query();
        vm.employees = Employee.query();
        vm.patchreportmaterialcategories = PatchReportMaterialCategory.query();
        vm.customersectors = CustomerSector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReport.id !== null) {
                PatchReport.update(vm.patchReport, onSaveSuccess, onSaveError);
            } else {
                PatchReport.save(vm.patchReport, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issueDate = false;
        vm.datePickerOpenStatus.executedDate = false;
        vm.datePickerOpenStatus.approvalDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportDetailController', PatchReportDetailController);

    PatchReportDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PatchReport', 'PatchCustomer', 'Employee', 'PatchReportMaterialCategory', 'CustomerSector'];

    function PatchReportDetailController($scope, $rootScope, $stateParams, entity, PatchReport, PatchCustomer, Employee, PatchReportMaterialCategory, CustomerSector) {
        var vm = this;
        vm.patchReport = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchReportUpdate', function(event, result) {
            vm.patchReport = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportDeleteController',PatchReportDeleteController);

    PatchReportDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReport'];

    function PatchReportDeleteController($uibModalInstance, entity, PatchReport) {
        var vm = this;
        vm.patchReport = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReport.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report', {
            parent: 'entity',
            url: '/patch-report?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report/patch-reports.html',
                    controller: 'PatchReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReport');
                    $translatePartialLoader.addPart('patchStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-detail', {
            parent: 'entity',
            url: '/patch-report/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report/patch-report-detail.html',
                    controller: 'PatchReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReport');
                    $translatePartialLoader.addPart('patchStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReport', function($stateParams, PatchReport) {
                    return PatchReport.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report.new', {
            parent: 'patch-report',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-dialog.html',
                    controller: 'PatchReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                barcode: null,
                                issueDate: null,
                                submitPoint: null,
                                durationInMonths: null,
                                comment: null,
                                patchStatus: null,
                                executedBy: null,
                                executedDate: null,
                                latitude: null,
                                longitude: null,
                                checkDoctor: null,
                                approvalDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('patch-report');
                });
            }]
        })
        .state('patch-report.edit', {
            parent: 'patch-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-dialog.html',
                    controller: 'PatchReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReport', function(PatchReport) {
                            return PatchReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report.delete', {
            parent: 'patch-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-delete-dialog.html',
                    controller: 'PatchReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReport', function(PatchReport) {
                            return PatchReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReport', PatchReport);

    PatchReport.$inject = ['$resource', 'DateUtils'];

    function PatchReport ($resource, DateUtils) {
        var resourceUrl =  'api/patch-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        data.executedDate = DateUtils.convertDateTimeFromServer(data.executedDate);
                        data.approvalDate = DateUtils.convertDateTimeFromServer(data.approvalDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchReportSearch', PatchReportSearch);

    PatchReportSearch.$inject = ['$resource'];

    function PatchReportSearch($resource) {
        var resourceUrl =  'api/_search/patch-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportController', PatchReportController);

    PatchReportController.$inject = ['$scope', '$state', 'PatchReport', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchReportController ($scope, $state, PatchReport, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PatchReport.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchReports = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchItemDialogController', PatchItemDialogController);

    PatchItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchItem'];

    function PatchItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchItem) {
        var vm = this;
        vm.patchItem = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchItem.id !== null) {
                PatchItem.update(vm.patchItem, onSaveSuccess, onSaveError);
            } else {
                PatchItem.save(vm.patchItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchItemDetailController', PatchItemDetailController);

    PatchItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PatchItem'];

    function PatchItemDetailController($scope, $rootScope, $stateParams, entity, PatchItem) {
        var vm = this;
        vm.patchItem = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchItemUpdate', function(event, result) {
            vm.patchItem = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchItemDeleteController',PatchItemDeleteController);

    PatchItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchItem'];

    function PatchItemDeleteController($uibModalInstance, entity, PatchItem) {
        var vm = this;
        vm.patchItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-item', {
            parent: 'entity',
            url: '/patch-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-item/patch-items.html',
                    controller: 'PatchItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-item-detail', {
            parent: 'entity',
            url: '/patch-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-item/patch-item-detail.html',
                    controller: 'PatchItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchItem', function($stateParams, PatchItem) {
                    return PatchItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-item.new', {
            parent: 'patch-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-dialog.html',
                    controller: 'PatchItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                legacyCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('patch-item');
                });
            }]
        })
        .state('patch-item.edit', {
            parent: 'patch-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-dialog.html',
                    controller: 'PatchItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchItem', function(PatchItem) {
                            return PatchItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-item.delete', {
            parent: 'patch-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-item/patch-item-delete-dialog.html',
                    controller: 'PatchItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchItem', function(PatchItem) {
                            return PatchItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchItem', PatchItem);

    PatchItem.$inject = ['$resource'];

    function PatchItem ($resource) {
        var resourceUrl =  'api/patch-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchItemSearch', PatchItemSearch);

    PatchItemSearch.$inject = ['$resource'];

    function PatchItemSearch($resource) {
        var resourceUrl =  'api/_search/patch-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchItemController', PatchItemController);

    PatchItemController.$inject = ['$scope', '$state', 'PatchItem', 'PatchItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchItemController ($scope, $state, PatchItem, PatchItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PatchItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PatchItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerDialogController', PatchCustomerDialogController);

    PatchCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchCustomer', 'SocialInsurance', 'Country', 'Region', 'Prefecture', 'City'];

    function PatchCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchCustomer, SocialInsurance, Country, Region, Prefecture, City) {
        var vm = this;
        vm.patchCustomer = entity;
        vm.socialinsurances = SocialInsurance.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.prefectures = Prefecture.query();
        vm.cities = City.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchCustomer.id !== null) {
                PatchCustomer.update(vm.patchCustomer, onSaveSuccess, onSaveError);
            } else {
                PatchCustomer.save(vm.patchCustomer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerDetailController', PatchCustomerDetailController);

    PatchCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PatchCustomer', 'SocialInsurance', 'Country', 'Region', 'Prefecture', 'City'];

    function PatchCustomerDetailController($scope, $rootScope, $stateParams, entity, PatchCustomer, SocialInsurance, Country, Region, Prefecture, City) {
        var vm = this;
        vm.patchCustomer = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchCustomerUpdate', function(event, result) {
            vm.patchCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerDeleteController',PatchCustomerDeleteController);

    PatchCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchCustomer'];

    function PatchCustomerDeleteController($uibModalInstance, entity, PatchCustomer) {
        var vm = this;
        vm.patchCustomer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-customer', {
            parent: 'entity',
            url: '/patch-customer?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-customer/patch-customers.html',
                    controller: 'PatchCustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchCustomer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-customer-detail', {
            parent: 'entity',
            url: '/patch-customer/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-customer/patch-customer-detail.html',
                    controller: 'PatchCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchCustomer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchCustomer', function($stateParams, PatchCustomer) {
                    return PatchCustomer.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-customer.new', {
            parent: 'patch-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-customer/patch-customer-dialog.html',
                    controller: 'PatchCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                amka: null,
                                dateOfBirth: null,
                                firstName: null,
                                lastName: null,
                                directName: null,
                                directAmka: null,
                                directAma: null,
                                phone: null,
                                mobile: null,
                                addressNum: null,
                                address: null,
                                postalCode: null,
                                cityName: null,
                                prefectureName: null,
                                regionName: null,
                                countryName: null,
                                legacyCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-customer', null, { reload: true });
                }, function() {
                    $state.go('patch-customer');
                });
            }]
        })
        .state('patch-customer.edit', {
            parent: 'patch-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-customer/patch-customer-dialog.html',
                    controller: 'PatchCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchCustomer', function(PatchCustomer) {
                            return PatchCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-customer.delete', {
            parent: 'patch-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-customer/patch-customer-delete-dialog.html',
                    controller: 'PatchCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchCustomer', function(PatchCustomer) {
                            return PatchCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchCustomer', PatchCustomer);

    PatchCustomer.$inject = ['$resource', 'DateUtils'];

    function PatchCustomer ($resource, DateUtils) {
        var resourceUrl =  'api/patch-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfBirth = DateUtils.convertLocalDateFromServer(data.dateOfBirth);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateOfBirth = DateUtils.convertLocalDateToServer(data.dateOfBirth);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchCustomerSearch', PatchCustomerSearch);

    PatchCustomerSearch.$inject = ['$resource'];

    function PatchCustomerSearch($resource) {
        var resourceUrl =  'api/_search/patch-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerController', PatchCustomerController);

    PatchCustomerController.$inject = ['$scope', '$state', 'PatchCustomer', 'PatchCustomerSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatchCustomerController ($scope, $state, PatchCustomer, PatchCustomerSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PatchCustomerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PatchCustomer.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patchCustomers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OtherEventDialogController', OtherEventDialogController);

    OtherEventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OtherEvent', 'EventCategoryType', 'Employee'];

    function OtherEventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OtherEvent, EventCategoryType, Employee) {
        var vm = this;
        vm.otherEvent = entity;
        vm.eventcategorytypes = EventCategoryType.query();
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:otherEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.otherEvent.id !== null) {
                OtherEvent.update(vm.otherEvent, onSaveSuccess, onSaveError);
            } else {
                OtherEvent.save(vm.otherEvent, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateFrom = false;
        vm.datePickerOpenStatus.dateTo = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OtherEventDetailController', OtherEventDetailController);

    OtherEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OtherEvent', 'EventCategoryType', 'Employee'];

    function OtherEventDetailController($scope, $rootScope, $stateParams, entity, OtherEvent, EventCategoryType, Employee) {
        var vm = this;
        vm.otherEvent = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:otherEventUpdate', function(event, result) {
            vm.otherEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OtherEventDeleteController',OtherEventDeleteController);

    OtherEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'OtherEvent'];

    function OtherEventDeleteController($uibModalInstance, entity, OtherEvent) {
        var vm = this;
        vm.otherEvent = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OtherEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('other-event', {
            parent: 'entity',
            url: '/other-event?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.otherEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-event/other-events.html',
                    controller: 'OtherEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('other-event-detail', {
            parent: 'entity',
            url: '/other-event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.otherEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-event/other-event-detail.html',
                    controller: 'OtherEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherEvent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OtherEvent', function($stateParams, OtherEvent) {
                    return OtherEvent.get({id : $stateParams.id});
                }]
            }
        })
        .state('other-event.new', {
            parent: 'other-event',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-dialog.html',
                    controller: 'OtherEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                dateFrom: null,
                                dateTo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('other-event');
                });
            }]
        })
        .state('other-event.edit', {
            parent: 'other-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-dialog.html',
                    controller: 'OtherEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OtherEvent', function(OtherEvent) {
                            return OtherEvent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('other-event.delete', {
            parent: 'other-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-event/other-event-delete-dialog.html',
                    controller: 'OtherEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OtherEvent', function(OtherEvent) {
                            return OtherEvent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('OtherEvent', OtherEvent);

    OtherEvent.$inject = ['$resource', 'DateUtils'];

    function OtherEvent ($resource, DateUtils) {
        var resourceUrl =  'api/other-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateFrom = DateUtils.convertDateTimeFromServer(data.dateFrom);
                        data.dateTo = DateUtils.convertDateTimeFromServer(data.dateTo);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OtherEventController', OtherEventController);

    OtherEventController.$inject = ['$scope', '$state', 'OtherEvent', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OtherEventController ($scope, $state, OtherEvent, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            OtherEvent.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.otherEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusDialogController', OfferStatusDialogController);

    OfferStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfferStatus'];

    function OfferStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfferStatus) {
        var vm = this;
        vm.offerStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:offerStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.offerStatus.id !== null) {
                OfferStatus.update(vm.offerStatus, onSaveSuccess, onSaveError);
            } else {
                OfferStatus.save(vm.offerStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusDetailController', OfferStatusDetailController);

    OfferStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OfferStatus'];

    function OfferStatusDetailController($scope, $rootScope, $stateParams, entity, OfferStatus) {
        var vm = this;
        vm.offerStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:offerStatusUpdate', function(event, result) {
            vm.offerStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusDeleteController',OfferStatusDeleteController);

    OfferStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'OfferStatus'];

    function OfferStatusDeleteController($uibModalInstance, entity, OfferStatus) {
        var vm = this;
        vm.offerStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OfferStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('offer-status', {
            parent: 'entity',
            url: '/offer-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.offerStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/offer-status/offer-statuses.html',
                    controller: 'OfferStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('offerStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('offer-status-detail', {
            parent: 'entity',
            url: '/offer-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.offerStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/offer-status/offer-status-detail.html',
                    controller: 'OfferStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('offerStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OfferStatus', function($stateParams, OfferStatus) {
                    return OfferStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('offer-status.new', {
            parent: 'offer-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-dialog.html',
                    controller: 'OfferStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('offer-status');
                });
            }]
        })
        .state('offer-status.edit', {
            parent: 'offer-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-dialog.html',
                    controller: 'OfferStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfferStatus', function(OfferStatus) {
                            return OfferStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('offer-status.delete', {
            parent: 'offer-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-delete-dialog.html',
                    controller: 'OfferStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OfferStatus', function(OfferStatus) {
                            return OfferStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('OfferStatus', OfferStatus);

    OfferStatus.$inject = ['$resource'];

    function OfferStatus ($resource) {
        var resourceUrl =  'api/offer-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusController', OfferStatusController);

    OfferStatusController.$inject = ['$scope', '$state', 'OfferStatus', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OfferStatusController ($scope, $state, OfferStatus, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            OfferStatus.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.offerStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageDialogController', NativeLanguageDialogController);

    NativeLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NativeLanguage'];

    function NativeLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NativeLanguage) {
        var vm = this;
        vm.nativeLanguage = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:nativeLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.nativeLanguage.id !== null) {
                NativeLanguage.update(vm.nativeLanguage, onSaveSuccess, onSaveError);
            } else {
                NativeLanguage.save(vm.nativeLanguage, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageDetailController', NativeLanguageDetailController);

    NativeLanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'NativeLanguage'];

    function NativeLanguageDetailController($scope, $rootScope, $stateParams, entity, NativeLanguage) {
        var vm = this;
        vm.nativeLanguage = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:nativeLanguageUpdate', function(event, result) {
            vm.nativeLanguage = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageDeleteController',NativeLanguageDeleteController);

    NativeLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'NativeLanguage'];

    function NativeLanguageDeleteController($uibModalInstance, entity, NativeLanguage) {
        var vm = this;
        vm.nativeLanguage = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            NativeLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('native-language', {
            parent: 'entity',
            url: '/native-language?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.nativeLanguage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/native-language/native-languages.html',
                    controller: 'NativeLanguageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nativeLanguage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('native-language-detail', {
            parent: 'entity',
            url: '/native-language/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.nativeLanguage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/native-language/native-language-detail.html',
                    controller: 'NativeLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nativeLanguage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NativeLanguage', function($stateParams, NativeLanguage) {
                    return NativeLanguage.get({id : $stateParams.id});
                }]
            }
        })
        .state('native-language.new', {
            parent: 'native-language',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-dialog.html',
                    controller: 'NativeLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('native-language');
                });
            }]
        })
        .state('native-language.edit', {
            parent: 'native-language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-dialog.html',
                    controller: 'NativeLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NativeLanguage', function(NativeLanguage) {
                            return NativeLanguage.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('native-language.delete', {
            parent: 'native-language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-delete-dialog.html',
                    controller: 'NativeLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NativeLanguage', function(NativeLanguage) {
                            return NativeLanguage.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('NativeLanguage', NativeLanguage);

    NativeLanguage.$inject = ['$resource'];

    function NativeLanguage ($resource) {
        var resourceUrl =  'api/native-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageController', NativeLanguageController);

    NativeLanguageController.$inject = ['$scope', '$state', 'NativeLanguage', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function NativeLanguageController ($scope, $state, NativeLanguage, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            NativeLanguage.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.nativeLanguages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineDialogController', MedicineDialogController);

    MedicineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Medicine'];

    function MedicineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Medicine) {
        var vm = this;
        vm.medicine = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medicineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medicine.id !== null) {
                Medicine.update(vm.medicine, onSaveSuccess, onSaveError);
            } else {
                Medicine.save(vm.medicine, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineDetailController', MedicineDetailController);

    MedicineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Medicine'];

    function MedicineDetailController($scope, $rootScope, $stateParams, entity, Medicine) {
        var vm = this;
        vm.medicine = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:medicineUpdate', function(event, result) {
            vm.medicine = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineDeleteController',MedicineDeleteController);

    MedicineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medicine'];

    function MedicineDeleteController($uibModalInstance, entity, Medicine) {
        var vm = this;
        vm.medicine = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Medicine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medicine', {
            parent: 'entity',
            url: '/medicine?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medicine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicine/medicines.html',
                    controller: 'MedicineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medicine-detail', {
            parent: 'entity',
            url: '/medicine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medicine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicine/medicine-detail.html',
                    controller: 'MedicineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Medicine', function($stateParams, Medicine) {
                    return Medicine.get({id : $stateParams.id});
                }]
            }
        })
        .state('medicine.new', {
            parent: 'medicine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-dialog.html',
                    controller: 'MedicineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                barcode: null,
                                pairCode: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('medicine');
                });
            }]
        })
        .state('medicine.edit', {
            parent: 'medicine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-dialog.html',
                    controller: 'MedicineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicine', function(Medicine) {
                            return Medicine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicine.delete', {
            parent: 'medicine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-delete-dialog.html',
                    controller: 'MedicineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medicine', function(Medicine) {
                            return Medicine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Medicine', Medicine);

    Medicine.$inject = ['$resource'];

    function Medicine ($resource) {
        var resourceUrl =  'api/medicines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineController', MedicineController);

    MedicineController.$inject = ['$scope', '$state', 'Medicine', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MedicineController ($scope, $state, Medicine, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Medicine.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.medicines = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportLineDialogController', MedReportLineDialogController);

    MedReportLineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedReportLine', 'MedReport', 'Medicine'];

    function MedReportLineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedReportLine, MedReport, Medicine) {
        var vm = this;
        vm.medReportLine = entity;
        vm.medreports = MedReport.query();
        vm.medicines = Medicine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medReportLineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medReportLine.id !== null) {
                MedReportLine.update(vm.medReportLine, onSaveSuccess, onSaveError);
            } else {
                MedReportLine.save(vm.medReportLine, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportLineDetailController', MedReportLineDetailController);

    MedReportLineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MedReportLine', 'MedReport', 'Medicine'];

    function MedReportLineDetailController($scope, $rootScope, $stateParams, entity, MedReportLine, MedReport, Medicine) {
        var vm = this;
        vm.medReportLine = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:medReportLineUpdate', function(event, result) {
            vm.medReportLine = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportLineDeleteController',MedReportLineDeleteController);

    MedReportLineDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedReportLine'];

    function MedReportLineDeleteController($uibModalInstance, entity, MedReportLine) {
        var vm = this;
        vm.medReportLine = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MedReportLine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-report-line', {
            parent: 'entity',
            url: '/med-report-line?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReportLine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report-line/med-report-lines.html',
                    controller: 'MedReportLineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReportLine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('med-report-line-detail', {
            parent: 'entity',
            url: '/med-report-line/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReportLine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report-line/med-report-line-detail.html',
                    controller: 'MedReportLineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReportLine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MedReportLine', function($stateParams, MedReportLine) {
                    return MedReportLine.get({id : $stateParams.id});
                }]
            }
        })
        .state('med-report-line.new', {
            parent: 'med-report-line',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-dialog.html',
                    controller: 'MedReportLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                aQuantity: null,
                                bQuantity: null,
                                sum: null,
                                marketSharePercentage: null,
                                numberOfChanges: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('med-report-line');
                });
            }]
        })
        .state('med-report-line.edit', {
            parent: 'med-report-line',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-dialog.html',
                    controller: 'MedReportLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedReportLine', function(MedReportLine) {
                            return MedReportLine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-report-line.delete', {
            parent: 'med-report-line',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-delete-dialog.html',
                    controller: 'MedReportLineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedReportLine', function(MedReportLine) {
                            return MedReportLine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('MedReportLine', MedReportLine);

    MedReportLine.$inject = ['$resource'];

    function MedReportLine ($resource) {
        var resourceUrl =  'api/med-report-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportLineController', MedReportLineController);

    MedReportLineController.$inject = ['$scope', '$state', 'MedReportLine', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MedReportLineController ($scope, $state, MedReportLine, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            MedReportLine.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.medReportLines = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportDialogController', MedReportDialogController);

    MedReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedReport', 'Customer', 'Employee', 'MedReportLine'];

    function MedReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedReport, Customer, Employee, MedReportLine) {
        var vm = this;
        vm.medReport = entity;
        vm.customers = Customer.query();
        vm.employees = Employee.query();
        vm.medreportlines = MedReportLine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medReport.id !== null) {
                MedReport.update(vm.medReport, onSaveSuccess, onSaveError);
            } else {
                MedReport.save(vm.medReport, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportDetailController', MedReportDetailController);

    MedReportDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MedReport', 'Customer', 'Employee', 'MedReportLine'];

    function MedReportDetailController($scope, $rootScope, $stateParams, entity, MedReport, Customer, Employee, MedReportLine) {
        var vm = this;
        vm.medReport = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:medReportUpdate', function(event, result) {
            vm.medReport = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportDeleteController',MedReportDeleteController);

    MedReportDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedReport'];

    function MedReportDeleteController($uibModalInstance, entity, MedReport) {
        var vm = this;
        vm.medReport = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MedReport.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-report', {
            parent: 'entity',
            url: '/med-report?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report/med-reports.html',
                    controller: 'MedReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReport');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('med-report-detail', {
            parent: 'entity',
            url: '/med-report/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report/med-report-detail.html',
                    controller: 'MedReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReport');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MedReport', function($stateParams, MedReport) {
                    return MedReport.get({id : $stateParams.id});
                }]
            }
        })
        .state('med-report.new', {
            parent: 'med-report',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-dialog.html',
                    controller: 'MedReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fromDate: null,
                                toDate: null,
                                code: null,
                                checkDigit1: null,
                                checkDigit2: null,
                                isActive: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('med-report');
                });
            }]
        })
        .state('med-report.edit', {
            parent: 'med-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-dialog.html',
                    controller: 'MedReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedReport', function(MedReport) {
                            return MedReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-report.delete', {
            parent: 'med-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report/med-report-delete-dialog.html',
                    controller: 'MedReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedReport', function(MedReport) {
                            return MedReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('MedReport', MedReport);

    MedReport.$inject = ['$resource', 'DateUtils'];

    function MedReport ($resource, DateUtils) {
        var resourceUrl =  'api/med-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportController', MedReportController);

    MedReportController.$inject = ['$scope', '$state', 'MedReport', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MedReportController ($scope, $state, MedReport, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            MedReport.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.medReports = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MeasurementUnitDialogController', MeasurementUnitDialogController);

    MeasurementUnitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MeasurementUnit'];

    function MeasurementUnitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MeasurementUnit) {
        var vm = this;
        vm.measurementUnit = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:measurementUnitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.measurementUnit.id !== null) {
                MeasurementUnit.update(vm.measurementUnit, onSaveSuccess, onSaveError);
            } else {
                MeasurementUnit.save(vm.measurementUnit, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MeasurementUnitDetailController', MeasurementUnitDetailController);

    MeasurementUnitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MeasurementUnit'];

    function MeasurementUnitDetailController($scope, $rootScope, $stateParams, entity, MeasurementUnit) {
        var vm = this;
        vm.measurementUnit = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:measurementUnitUpdate', function(event, result) {
            vm.measurementUnit = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MeasurementUnitDeleteController',MeasurementUnitDeleteController);

    MeasurementUnitDeleteController.$inject = ['$uibModalInstance', 'entity', 'MeasurementUnit'];

    function MeasurementUnitDeleteController($uibModalInstance, entity, MeasurementUnit) {
        var vm = this;
        vm.measurementUnit = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MeasurementUnit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('measurement-unit', {
            parent: 'entity',
            url: '/measurement-unit?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.measurementUnit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/measurement-unit/measurement-units.html',
                    controller: 'MeasurementUnitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('measurementUnit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('measurement-unit-detail', {
            parent: 'entity',
            url: '/measurement-unit/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.measurementUnit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-detail.html',
                    controller: 'MeasurementUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('measurementUnit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MeasurementUnit', function($stateParams, MeasurementUnit) {
                    return MeasurementUnit.get({id : $stateParams.id});
                }]
            }
        })
        .state('measurement-unit.new', {
            parent: 'measurement-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-dialog.html',
                    controller: 'MeasurementUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('measurement-unit');
                });
            }]
        })
        .state('measurement-unit.edit', {
            parent: 'measurement-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-dialog.html',
                    controller: 'MeasurementUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MeasurementUnit', function(MeasurementUnit) {
                            return MeasurementUnit.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('measurement-unit.delete', {
            parent: 'measurement-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-delete-dialog.html',
                    controller: 'MeasurementUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MeasurementUnit', function(MeasurementUnit) {
                            return MeasurementUnit.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('MeasurementUnit', MeasurementUnit);

    MeasurementUnit.$inject = ['$resource'];

    function MeasurementUnit ($resource) {
        var resourceUrl =  'api/measurement-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MeasurementUnitSearch', MeasurementUnitSearch);

    MeasurementUnitSearch.$inject = ['$resource'];

    function MeasurementUnitSearch($resource) {
        var resourceUrl =  'api/_search/measurement-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MeasurementUnitController', MeasurementUnitController);

    MeasurementUnitController.$inject = ['$scope', '$state', 'MeasurementUnit', 'MeasurementUnitSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MeasurementUnitController ($scope, $state, MeasurementUnit, MeasurementUnitSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MeasurementUnitSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MeasurementUnit.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.measurementUnits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadParameterDialogController', LeadParameterDialogController);

    LeadParameterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadParameter'];

    function LeadParameterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadParameter) {
        var vm = this;
        vm.leadParameter = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadParameterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadParameter.id !== null) {
                LeadParameter.update(vm.leadParameter, onSaveSuccess, onSaveError);
            } else {
                LeadParameter.save(vm.leadParameter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadParameterDetailController', LeadParameterDetailController);

    LeadParameterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadParameter'];

    function LeadParameterDetailController($scope, $rootScope, $stateParams, entity, LeadParameter) {
        var vm = this;
        vm.leadParameter = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadParameterUpdate', function(event, result) {
            vm.leadParameter = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadParameterDeleteController',LeadParameterDeleteController);

    LeadParameterDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadParameter'];

    function LeadParameterDeleteController($uibModalInstance, entity, LeadParameter) {
        var vm = this;
        vm.leadParameter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadParameter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-parameter', {
            parent: 'entity',
            url: '/lead-parameter?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadParameter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-parameter/lead-parameters.html',
                    controller: 'LeadParameterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadParameter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-parameter-detail', {
            parent: 'entity',
            url: '/lead-parameter/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadParameter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-detail.html',
                    controller: 'LeadParameterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadParameter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadParameter', function($stateParams, LeadParameter) {
                    return LeadParameter.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-parameter.new', {
            parent: 'lead-parameter',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-dialog.html',
                    controller: 'LeadParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('lead-parameter');
                });
            }]
        })
        .state('lead-parameter.edit', {
            parent: 'lead-parameter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-dialog.html',
                    controller: 'LeadParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadParameter', function(LeadParameter) {
                            return LeadParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-parameter.delete', {
            parent: 'lead-parameter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-delete-dialog.html',
                    controller: 'LeadParameterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadParameter', function(LeadParameter) {
                            return LeadParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadParameter', LeadParameter);

    LeadParameter.$inject = ['$resource'];

    function LeadParameter ($resource) {
        var resourceUrl =  'api/lead-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadParameterController', LeadParameterController);

    LeadParameterController.$inject = ['$scope', '$state', 'LeadParameter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadParameterController ($scope, $state, LeadParameter, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadParameter.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadParameters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferRoomTypeDialogController', LeadOfferRoomTypeDialogController);

    LeadOfferRoomTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadOfferRoomType', 'LeadOffer', 'RoomType'];

    function LeadOfferRoomTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadOfferRoomType, LeadOffer, RoomType) {
        var vm = this;
        vm.leadOfferRoomType = entity;
        vm.leadoffers = LeadOffer.query();
        vm.roomtypes = RoomType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadOfferRoomTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadOfferRoomType.id !== null) {
                LeadOfferRoomType.update(vm.leadOfferRoomType, onSaveSuccess, onSaveError);
            } else {
                LeadOfferRoomType.save(vm.leadOfferRoomType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferRoomTypeDetailController', LeadOfferRoomTypeDetailController);

    LeadOfferRoomTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadOfferRoomType', 'LeadOffer', 'RoomType'];

    function LeadOfferRoomTypeDetailController($scope, $rootScope, $stateParams, entity, LeadOfferRoomType, LeadOffer, RoomType) {
        var vm = this;
        vm.leadOfferRoomType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadOfferRoomTypeUpdate', function(event, result) {
            vm.leadOfferRoomType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferRoomTypeDeleteController',LeadOfferRoomTypeDeleteController);

    LeadOfferRoomTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadOfferRoomType'];

    function LeadOfferRoomTypeDeleteController($uibModalInstance, entity, LeadOfferRoomType) {
        var vm = this;
        vm.leadOfferRoomType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadOfferRoomType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-offer-room-type', {
            parent: 'entity',
            url: '/lead-offer-room-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOfferRoomType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-types.html',
                    controller: 'LeadOfferRoomTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOfferRoomType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-offer-room-type-detail', {
            parent: 'entity',
            url: '/lead-offer-room-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOfferRoomType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-detail.html',
                    controller: 'LeadOfferRoomTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOfferRoomType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadOfferRoomType', function($stateParams, LeadOfferRoomType) {
                    return LeadOfferRoomType.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-offer-room-type.new', {
            parent: 'lead-offer-room-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-dialog.html',
                    controller: 'LeadOfferRoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                discussedPrice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('lead-offer-room-type');
                });
            }]
        })
        .state('lead-offer-room-type.edit', {
            parent: 'lead-offer-room-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-dialog.html',
                    controller: 'LeadOfferRoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadOfferRoomType', function(LeadOfferRoomType) {
                            return LeadOfferRoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-offer-room-type.delete', {
            parent: 'lead-offer-room-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-delete-dialog.html',
                    controller: 'LeadOfferRoomTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadOfferRoomType', function(LeadOfferRoomType) {
                            return LeadOfferRoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadOfferRoomType', LeadOfferRoomType);

    LeadOfferRoomType.$inject = ['$resource'];

    function LeadOfferRoomType ($resource) {
        var resourceUrl =  'api/lead-offer-room-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferRoomTypeController', LeadOfferRoomTypeController);

    LeadOfferRoomTypeController.$inject = ['$scope', '$state', 'LeadOfferRoomType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadOfferRoomTypeController ($scope, $state, LeadOfferRoomType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadOfferRoomType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadOfferRoomTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferDialogController', LeadOfferDialogController);

    LeadOfferDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadOffer', 'CostType', 'RoomType', 'Transportation', 'Competitor', 'LeadDiscount', 'LeadCall', 'OfferStatus'];

    function LeadOfferDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadOffer, CostType, RoomType, Transportation, Competitor, LeadDiscount, LeadCall, OfferStatus) {
        var vm = this;
        vm.leadOffer = entity;
        vm.costtypes = CostType.query();
        vm.roomtypes = RoomType.query();
        vm.transportations = Transportation.query();
        vm.competitors = Competitor.query();
        vm.leaddiscounts = LeadDiscount.query();
        vm.leadcalls = LeadCall.query();
        vm.offerstatuses = OfferStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadOfferUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadOffer.id !== null) {
                LeadOffer.update(vm.leadOffer, onSaveSuccess, onSaveError);
            } else {
                LeadOffer.save(vm.leadOffer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.firstEstimationDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferDetailController', LeadOfferDetailController);

    LeadOfferDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadOffer', 'CostType', 'RoomType', 'Transportation', 'Competitor', 'LeadDiscount', 'LeadCall', 'OfferStatus'];

    function LeadOfferDetailController($scope, $rootScope, $stateParams, entity, LeadOffer, CostType, RoomType, Transportation, Competitor, LeadDiscount, LeadCall, OfferStatus) {
        var vm = this;
        vm.leadOffer = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadOfferUpdate', function(event, result) {
            vm.leadOffer = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferDeleteController',LeadOfferDeleteController);

    LeadOfferDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadOffer'];

    function LeadOfferDeleteController($uibModalInstance, entity, LeadOffer) {
        var vm = this;
        vm.leadOffer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadOffer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-offer', {
            parent: 'entity',
            url: '/lead-offer?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOffer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer/lead-offers.html',
                    controller: 'LeadOfferController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOffer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-offer-detail', {
            parent: 'entity',
            url: '/lead-offer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOffer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer/lead-offer-detail.html',
                    controller: 'LeadOfferDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOffer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadOffer', function($stateParams, LeadOffer) {
                    return LeadOffer.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-offer.new', {
            parent: 'lead-offer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-dialog.html',
                    controller: 'LeadOfferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstEstimationDate: null,
                                wantsTransportation: null,
                                attendantMeal: null,
                                hasCompetitiveBid: null,
                                openHospitalizationReference: null,
                                roomServices: null,
                                comments: null,
                                invitationText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('lead-offer');
                });
            }]
        })
        .state('lead-offer.edit', {
            parent: 'lead-offer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-dialog.html',
                    controller: 'LeadOfferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadOffer', function(LeadOffer) {
                            return LeadOffer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-offer.delete', {
            parent: 'lead-offer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-delete-dialog.html',
                    controller: 'LeadOfferDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadOffer', function(LeadOffer) {
                            return LeadOffer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadOffer', LeadOffer);

    LeadOffer.$inject = ['$resource', 'DateUtils'];

    function LeadOffer ($resource, DateUtils) {
        var resourceUrl =  'api/lead-offers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.firstEstimationDate = DateUtils.convertDateTimeFromServer(data.firstEstimationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferController', LeadOfferController);

    LeadOfferController.$inject = ['$scope', '$state', 'LeadOffer', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadOfferController ($scope, $state, LeadOffer, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadOffer.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadOffers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseDialogController', LeadHospitalizationDiseaseDialogController);

    LeadHospitalizationDiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadHospitalizationDisease', 'Disease', 'LeadHospitalization'];

    function LeadHospitalizationDiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadHospitalizationDisease, Disease, LeadHospitalization) {
        var vm = this;
        vm.leadHospitalizationDisease = entity;
        vm.diseases = Disease.query();
        vm.leadhospitalizations = LeadHospitalization.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadHospitalizationDiseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadHospitalizationDisease.id !== null) {
                LeadHospitalizationDisease.update(vm.leadHospitalizationDisease, onSaveSuccess, onSaveError);
            } else {
                LeadHospitalizationDisease.save(vm.leadHospitalizationDisease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseDetailController', LeadHospitalizationDiseaseDetailController);

    LeadHospitalizationDiseaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadHospitalizationDisease', 'Disease', 'LeadHospitalization'];

    function LeadHospitalizationDiseaseDetailController($scope, $rootScope, $stateParams, entity, LeadHospitalizationDisease, Disease, LeadHospitalization) {
        var vm = this;
        vm.leadHospitalizationDisease = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadHospitalizationDiseaseUpdate', function(event, result) {
            vm.leadHospitalizationDisease = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseDeleteController',LeadHospitalizationDiseaseDeleteController);

    LeadHospitalizationDiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadHospitalizationDisease'];

    function LeadHospitalizationDiseaseDeleteController($uibModalInstance, entity, LeadHospitalizationDisease) {
        var vm = this;
        vm.leadHospitalizationDisease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadHospitalizationDisease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-hospitalization-disease', {
            parent: 'entity',
            url: '/lead-hospitalization-disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalizationDisease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-diseases.html',
                    controller: 'LeadHospitalizationDiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalizationDisease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-hospitalization-disease-detail', {
            parent: 'entity',
            url: '/lead-hospitalization-disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalizationDisease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-detail.html',
                    controller: 'LeadHospitalizationDiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalizationDisease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadHospitalizationDisease', function($stateParams, LeadHospitalizationDisease) {
                    return LeadHospitalizationDisease.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-hospitalization-disease.new', {
            parent: 'lead-hospitalization-disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comments: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('lead-hospitalization-disease');
                });
            }]
        })
        .state('lead-hospitalization-disease.edit', {
            parent: 'lead-hospitalization-disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadHospitalizationDisease', function(LeadHospitalizationDisease) {
                            return LeadHospitalizationDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-hospitalization-disease.delete', {
            parent: 'lead-hospitalization-disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-delete-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadHospitalizationDisease', function(LeadHospitalizationDisease) {
                            return LeadHospitalizationDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadHospitalizationDisease', LeadHospitalizationDisease);

    LeadHospitalizationDisease.$inject = ['$resource'];

    function LeadHospitalizationDisease ($resource) {
        var resourceUrl =  'api/lead-hospitalization-diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseaseController', LeadHospitalizationDiseaseController);

    LeadHospitalizationDiseaseController.$inject = ['$scope', '$state', 'LeadHospitalizationDisease', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadHospitalizationDiseaseController ($scope, $state, LeadHospitalizationDisease, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadHospitalizationDisease.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadHospitalizationDiseases = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDialogController', LeadHospitalizationDialogController);

    LeadHospitalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadHospitalization', 'Sector', 'Competitor', 'HospitalizationType', 'ClinicName', 'AddDisease', 'AddCondition', 'CommunicationStatus'];

    function LeadHospitalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadHospitalization, Sector, Competitor, HospitalizationType, ClinicName, AddDisease, AddCondition, CommunicationStatus) {
        var vm = this;
        vm.leadHospitalization = entity;
        vm.sectors = Sector.query();
        vm.competitors = Competitor.query();
        vm.hospitalizationtypes = HospitalizationType.query();
        vm.clinicnames = ClinicName.query();
        vm.adddiseases = AddDisease.query();
        vm.addconditions = AddCondition.query();
        vm.communicationstatuses = CommunicationStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadHospitalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadHospitalization.id !== null) {
                LeadHospitalization.update(vm.leadHospitalization, onSaveSuccess, onSaveError);
            } else {
                LeadHospitalization.save(vm.leadHospitalization, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.diagnosisDate = false;
        vm.datePickerOpenStatus.possibleDischargeDate = false;
        vm.datePickerOpenStatus.hospitalizationDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDetailController', LeadHospitalizationDetailController);

    LeadHospitalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadHospitalization', 'Sector', 'Competitor', 'HospitalizationType', 'ClinicName', 'AddDisease', 'AddCondition', 'CommunicationStatus'];

    function LeadHospitalizationDetailController($scope, $rootScope, $stateParams, entity, LeadHospitalization, Sector, Competitor, HospitalizationType, ClinicName, AddDisease, AddCondition, CommunicationStatus) {
        var vm = this;
        vm.leadHospitalization = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadHospitalizationUpdate', function(event, result) {
            vm.leadHospitalization = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDeleteController',LeadHospitalizationDeleteController);

    LeadHospitalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadHospitalization'];

    function LeadHospitalizationDeleteController($uibModalInstance, entity, LeadHospitalization) {
        var vm = this;
        vm.leadHospitalization = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadHospitalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-hospitalization', {
            parent: 'entity',
            url: '/lead-hospitalization?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalizations.html',
                    controller: 'LeadHospitalizationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-hospitalization-detail', {
            parent: 'entity',
            url: '/lead-hospitalization/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-detail.html',
                    controller: 'LeadHospitalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadHospitalization', function($stateParams, LeadHospitalization) {
                    return LeadHospitalization.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-hospitalization.new', {
            parent: 'lead-hospitalization',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-dialog.html',
                    controller: 'LeadHospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                isClosedHospitalization: null,
                                hadSurgery: null,
                                surgeryType: null,
                                sectorOther: null,
                                diagnosisDate: null,
                                possibleDischargeDate: null,
                                isFollowingHospitalization: null,
                                comments: null,
                                addDiseaseOther: null,
                                hospitalizationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('lead-hospitalization');
                });
            }]
        })
        .state('lead-hospitalization.edit', {
            parent: 'lead-hospitalization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-dialog.html',
                    controller: 'LeadHospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadHospitalization', function(LeadHospitalization) {
                            return LeadHospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-hospitalization.delete', {
            parent: 'lead-hospitalization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization/lead-hospitalization-delete-dialog.html',
                    controller: 'LeadHospitalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadHospitalization', function(LeadHospitalization) {
                            return LeadHospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadHospitalization', LeadHospitalization);

    LeadHospitalization.$inject = ['$resource', 'DateUtils'];

    function LeadHospitalization ($resource, DateUtils) {
        var resourceUrl =  'api/lead-hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.diagnosisDate = DateUtils.convertLocalDateFromServer(data.diagnosisDate);
                        data.possibleDischargeDate = DateUtils.convertLocalDateFromServer(data.possibleDischargeDate);
                        data.hospitalizationDate = DateUtils.convertLocalDateFromServer(data.hospitalizationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.diagnosisDate = DateUtils.convertLocalDateToServer(data.diagnosisDate);
                    data.possibleDischargeDate = DateUtils.convertLocalDateToServer(data.possibleDischargeDate);
                    data.hospitalizationDate = DateUtils.convertLocalDateToServer(data.hospitalizationDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.diagnosisDate = DateUtils.convertLocalDateToServer(data.diagnosisDate);
                    data.possibleDischargeDate = DateUtils.convertLocalDateToServer(data.possibleDischargeDate);
                    data.hospitalizationDate = DateUtils.convertLocalDateToServer(data.hospitalizationDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationController', LeadHospitalizationController);

    LeadHospitalizationController.$inject = ['$scope', '$state', 'LeadHospitalization', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadHospitalizationController ($scope, $state, LeadHospitalization, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadHospitalization.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadHospitalizations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadDiscountDialogController', LeadDiscountDialogController);

    LeadDiscountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadDiscount', 'DiscountReason', 'DiscountRate'];

    function LeadDiscountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadDiscount, DiscountReason, DiscountRate) {
        var vm = this;
        vm.leadDiscount = entity;
        vm.discountreasons = DiscountReason.query();
        vm.discountrates = DiscountRate.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadDiscountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadDiscount.id !== null) {
                LeadDiscount.update(vm.leadDiscount, onSaveSuccess, onSaveError);
            } else {
                LeadDiscount.save(vm.leadDiscount, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadDiscountDetailController', LeadDiscountDetailController);

    LeadDiscountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadDiscount', 'DiscountReason', 'DiscountRate'];

    function LeadDiscountDetailController($scope, $rootScope, $stateParams, entity, LeadDiscount, DiscountReason, DiscountRate) {
        var vm = this;
        vm.leadDiscount = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadDiscountUpdate', function(event, result) {
            vm.leadDiscount = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadDiscountDeleteController',LeadDiscountDeleteController);

    LeadDiscountDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadDiscount'];

    function LeadDiscountDeleteController($uibModalInstance, entity, LeadDiscount) {
        var vm = this;
        vm.leadDiscount = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadDiscount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-discount', {
            parent: 'entity',
            url: '/lead-discount?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadDiscount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-discount/lead-discounts.html',
                    controller: 'LeadDiscountController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadDiscount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-discount-detail', {
            parent: 'entity',
            url: '/lead-discount/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadDiscount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-discount/lead-discount-detail.html',
                    controller: 'LeadDiscountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadDiscount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadDiscount', function($stateParams, LeadDiscount) {
                    return LeadDiscount.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-discount.new', {
            parent: 'lead-discount',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-dialog.html',
                    controller: 'LeadDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                hasRequestedDiscount: null,
                                requestedReasonOther: null,
                                isEntitledToDiscount: null,
                                entitledToReasonOther: null,
                                finalReasonOther: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('lead-discount');
                });
            }]
        })
        .state('lead-discount.edit', {
            parent: 'lead-discount',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-dialog.html',
                    controller: 'LeadDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadDiscount', function(LeadDiscount) {
                            return LeadDiscount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-discount.delete', {
            parent: 'lead-discount',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-delete-dialog.html',
                    controller: 'LeadDiscountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadDiscount', function(LeadDiscount) {
                            return LeadDiscount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadDiscount', LeadDiscount);

    LeadDiscount.$inject = ['$resource'];

    function LeadDiscount ($resource) {
        var resourceUrl =  'api/lead-discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadDiscountController', LeadDiscountController);

    LeadDiscountController.$inject = ['$scope', '$state', 'LeadDiscount', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadDiscountController ($scope, $state, LeadDiscount, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadDiscount.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadDiscounts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallDialogController', LeadCallDialogController);

    LeadCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadCall', 'CallType', 'ProspectivePatient', 'Patient', 'LeadHospitalization', 'Customer'];

    function LeadCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadCall, CallType, ProspectivePatient, Patient, LeadHospitalization, Customer) {
        var vm = this;
        vm.leadCall = entity;
        vm.calltypes = CallType.query();
        vm.prospectivepatients = ProspectivePatient.query();
        vm.patients = Patient.query();
        vm.leadhospitalizations = LeadHospitalization.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadCallUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadCall.id !== null) {
                LeadCall.update(vm.leadCall, onSaveSuccess, onSaveError);
            } else {
                LeadCall.save(vm.leadCall, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateTime = false;
        vm.datePickerOpenStatus.appointmentDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallDetailController', LeadCallDetailController);

    LeadCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LeadCall', 'CallType', 'ProspectivePatient', 'Patient', 'LeadHospitalization', 'Customer'];

    function LeadCallDetailController($scope, $rootScope, $stateParams, entity, LeadCall, CallType, ProspectivePatient, Patient, LeadHospitalization, Customer) {
        var vm = this;
        vm.leadCall = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:leadCallUpdate', function(event, result) {
            vm.leadCall = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallDeleteController',LeadCallDeleteController);

    LeadCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadCall'];

    function LeadCallDeleteController($uibModalInstance, entity, LeadCall) {
        var vm = this;
        vm.leadCall = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-call', {
            parent: 'entity',
            url: '/lead-call?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-call/lead-calls.html',
                    controller: 'LeadCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadCall');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-call-detail', {
            parent: 'entity',
            url: '/lead-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-call/lead-call-detail.html',
                    controller: 'LeadCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadCall', function($stateParams, LeadCall) {
                    return LeadCall.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-call.new', {
            parent: 'lead-call',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-dialog.html',
                    controller: 'LeadCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateTime: null,
                                noContact: null,
                                isOldPatient: null,
                                isOldPatientRelative: null,
                                appointmentDate: null,
                                bookedAppointment: null,
                                isImportant: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('lead-call');
                });
            }]
        })
        .state('lead-call.edit', {
            parent: 'lead-call',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-dialog.html',
                    controller: 'LeadCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadCall', function(LeadCall) {
                            return LeadCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-call.delete', {
            parent: 'lead-call',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-delete-dialog.html',
                    controller: 'LeadCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadCall', function(LeadCall) {
                            return LeadCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadCall', LeadCall);

    LeadCall.$inject = ['$resource', 'DateUtils'];

    function LeadCall ($resource, DateUtils) {
        var resourceUrl =  'api/lead-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateTime = DateUtils.convertDateTimeFromServer(data.dateTime);
                        data.appointmentDate = DateUtils.convertDateTimeFromServer(data.appointmentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallController', LeadCallController);

    LeadCallController.$inject = ['$scope', '$state', 'LeadCall', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LeadCallController ($scope, $state, LeadCall, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            LeadCall.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.leadCalls = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameDialogController', LastNameDialogController);

    LastNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LastName'];

    function LastNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LastName) {
        var vm = this;
        vm.lastName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:lastNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.lastName.id !== null) {
                LastName.update(vm.lastName, onSaveSuccess, onSaveError);
            } else {
                LastName.save(vm.lastName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameDetailController', LastNameDetailController);

    LastNameDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LastName'];

    function LastNameDetailController($scope, $rootScope, $stateParams, entity, LastName) {
        var vm = this;
        vm.lastName = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:lastNameUpdate', function(event, result) {
            vm.lastName = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameDeleteController',LastNameDeleteController);

    LastNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'LastName'];

    function LastNameDeleteController($uibModalInstance, entity, LastName) {
        var vm = this;
        vm.lastName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LastName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('last-name', {
            parent: 'entity',
            url: '/last-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.lastName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/last-name/last-names.html',
                    controller: 'LastNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lastName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('last-name-detail', {
            parent: 'entity',
            url: '/last-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.lastName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/last-name/last-name-detail.html',
                    controller: 'LastNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lastName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LastName', function($stateParams, LastName) {
                    return LastName.get({id : $stateParams.id});
                }]
            }
        })
        .state('last-name.new', {
            parent: 'last-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-dialog.html',
                    controller: 'LastNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('last-name');
                });
            }]
        })
        .state('last-name.edit', {
            parent: 'last-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-dialog.html',
                    controller: 'LastNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LastName', function(LastName) {
                            return LastName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('last-name.delete', {
            parent: 'last-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-delete-dialog.html',
                    controller: 'LastNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LastName', function(LastName) {
                            return LastName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LastName', LastName);

    LastName.$inject = ['$resource'];

    function LastName ($resource) {
        var resourceUrl =  'api/last-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('LastNameSearch', LastNameSearch);

    LastNameSearch.$inject = ['$resource'];

    function LastNameSearch($resource) {
        var resourceUrl =  'api/_search/last-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameController', LastNameController);

    LastNameController.$inject = ['$scope', '$state', 'LastName', 'LastNameSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LastNameController ($scope, $state, LastName, LastNameSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                LastNameSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                LastName.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.lastNames = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10DialogController', Icd10DialogController);

    Icd10DialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Icd10'];

    function Icd10DialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Icd10) {
        var vm = this;
        vm.icd10 = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:icd10Update', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.icd10.id !== null) {
                Icd10.update(vm.icd10, onSaveSuccess, onSaveError);
            } else {
                Icd10.save(vm.icd10, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10DetailController', Icd10DetailController);

    Icd10DetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Icd10'];

    function Icd10DetailController($scope, $rootScope, $stateParams, entity, Icd10) {
        var vm = this;
        vm.icd10 = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:icd10Update', function(event, result) {
            vm.icd10 = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10DeleteController',Icd10DeleteController);

    Icd10DeleteController.$inject = ['$uibModalInstance', 'entity', 'Icd10'];

    function Icd10DeleteController($uibModalInstance, entity, Icd10) {
        var vm = this;
        vm.icd10 = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Icd10.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('icd-10', {
            parent: 'entity',
            url: '/icd-10?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.icd10.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/icd-10/icd-10-s.html',
                    controller: 'Icd10Controller',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('icd10');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('icd-10-detail', {
            parent: 'entity',
            url: '/icd-10/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.icd10.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/icd-10/icd-10-detail.html',
                    controller: 'Icd10DetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('icd10');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Icd10', function($stateParams, Icd10) {
                    return Icd10.get({id : $stateParams.id});
                }]
            }
        })
        .state('icd-10.new', {
            parent: 'icd-10',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-dialog.html',
                    controller: 'Icd10DialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                title: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('icd-10');
                });
            }]
        })
        .state('icd-10.edit', {
            parent: 'icd-10',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-dialog.html',
                    controller: 'Icd10DialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Icd10', function(Icd10) {
                            return Icd10.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('icd-10.delete', {
            parent: 'icd-10',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-delete-dialog.html',
                    controller: 'Icd10DeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Icd10', function(Icd10) {
                            return Icd10.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Icd10', Icd10);

    Icd10.$inject = ['$resource'];

    function Icd10 ($resource) {
        var resourceUrl =  'api/icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10Controller', Icd10Controller);

    Icd10Controller.$inject = ['$scope', '$state', 'Icd10', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function Icd10Controller ($scope, $state, Icd10, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Icd10.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.icd10S = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeParentDialogController', HospitalizationTypeParentDialogController);

    HospitalizationTypeParentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationTypeParent'];

    function HospitalizationTypeParentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationTypeParent = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:hospitalizationTypeParentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.hospitalizationTypeParent.id !== null) {
                HospitalizationTypeParent.update(vm.hospitalizationTypeParent, onSaveSuccess, onSaveError);
            } else {
                HospitalizationTypeParent.save(vm.hospitalizationTypeParent, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeParentDetailController', HospitalizationTypeParentDetailController);

    HospitalizationTypeParentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'HospitalizationTypeParent'];

    function HospitalizationTypeParentDetailController($scope, $rootScope, $stateParams, entity, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationTypeParent = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:hospitalizationTypeParentUpdate', function(event, result) {
            vm.hospitalizationTypeParent = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeParentDeleteController',HospitalizationTypeParentDeleteController);

    HospitalizationTypeParentDeleteController.$inject = ['$uibModalInstance', 'entity', 'HospitalizationTypeParent'];

    function HospitalizationTypeParentDeleteController($uibModalInstance, entity, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationTypeParent = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            HospitalizationTypeParent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-type-parent', {
            parent: 'entity',
            url: '/hospitalization-type-parent?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.hospitalizationTypeParent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parents.html',
                    controller: 'HospitalizationTypeParentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationTypeParent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-type-parent-detail', {
            parent: 'entity',
            url: '/hospitalization-type-parent/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.hospitalizationTypeParent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-detail.html',
                    controller: 'HospitalizationTypeParentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationTypeParent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HospitalizationTypeParent', function($stateParams, HospitalizationTypeParent) {
                    return HospitalizationTypeParent.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization-type-parent.new', {
            parent: 'hospitalization-type-parent',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-dialog.html',
                    controller: 'HospitalizationTypeParentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('hospitalization-type-parent');
                });
            }]
        })
        .state('hospitalization-type-parent.edit', {
            parent: 'hospitalization-type-parent',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-dialog.html',
                    controller: 'HospitalizationTypeParentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationTypeParent', function(HospitalizationTypeParent) {
                            return HospitalizationTypeParent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-type-parent.delete', {
            parent: 'hospitalization-type-parent',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-delete-dialog.html',
                    controller: 'HospitalizationTypeParentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationTypeParent', function(HospitalizationTypeParent) {
                            return HospitalizationTypeParent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('HospitalizationTypeParent', HospitalizationTypeParent);

    HospitalizationTypeParent.$inject = ['$resource'];

    function HospitalizationTypeParent ($resource) {
        var resourceUrl =  'api/hospitalization-type-parents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeParentController', HospitalizationTypeParentController);

    HospitalizationTypeParentController.$inject = ['$scope', '$state', 'HospitalizationTypeParent', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function HospitalizationTypeParentController ($scope, $state, HospitalizationTypeParent, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            HospitalizationTypeParent.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.hospitalizationTypeParents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeDialogController', HospitalizationTypeDialogController);

    HospitalizationTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationType', 'HospitalizationTypeParent'];

    function HospitalizationTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationType, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationType = entity;
        vm.hospitalizationtypeparents = HospitalizationTypeParent.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:hospitalizationTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.hospitalizationType.id !== null) {
                HospitalizationType.update(vm.hospitalizationType, onSaveSuccess, onSaveError);
            } else {
                HospitalizationType.save(vm.hospitalizationType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeDetailController', HospitalizationTypeDetailController);

    HospitalizationTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'HospitalizationType', 'HospitalizationTypeParent'];

    function HospitalizationTypeDetailController($scope, $rootScope, $stateParams, entity, HospitalizationType, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:hospitalizationTypeUpdate', function(event, result) {
            vm.hospitalizationType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeDeleteController',HospitalizationTypeDeleteController);

    HospitalizationTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'HospitalizationType'];

    function HospitalizationTypeDeleteController($uibModalInstance, entity, HospitalizationType) {
        var vm = this;
        vm.hospitalizationType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            HospitalizationType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-type', {
            parent: 'entity',
            url: '/hospitalization-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalizationType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-types.html',
                    controller: 'HospitalizationTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-type-detail', {
            parent: 'entity',
            url: '/hospitalization-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalizationType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-detail.html',
                    controller: 'HospitalizationTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HospitalizationType', function($stateParams, HospitalizationType) {
                    return HospitalizationType.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization-type.new', {
            parent: 'hospitalization-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-dialog.html',
                    controller: 'HospitalizationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('hospitalization-type');
                });
            }]
        })
        .state('hospitalization-type.edit', {
            parent: 'hospitalization-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-dialog.html',
                    controller: 'HospitalizationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationType', function(HospitalizationType) {
                            return HospitalizationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-type.delete', {
            parent: 'hospitalization-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-delete-dialog.html',
                    controller: 'HospitalizationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationType', function(HospitalizationType) {
                            return HospitalizationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('HospitalizationType', HospitalizationType);

    HospitalizationType.$inject = ['$resource'];

    function HospitalizationType ($resource) {
        var resourceUrl =  'api/hospitalization-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeController', HospitalizationTypeController);

    HospitalizationTypeController.$inject = ['$scope', '$state', 'HospitalizationType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function HospitalizationTypeController ($scope, $state, HospitalizationType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            HospitalizationType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.hospitalizationTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationDialogController', HospitalizationDialogController);

    HospitalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Hospitalization', 'Patient', 'Customer', 'Sector', 'CustomerTitle', 'ClinicName', 'RoomType', 'HospitalizationType', 'LeadCall'];

    function HospitalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Hospitalization, Patient, Customer, Sector, CustomerTitle, ClinicName, RoomType, HospitalizationType, LeadCall) {
        var vm = this;
        vm.hospitalization = entity;
        vm.patients = Patient.query();
        vm.customers = Customer.query();
        vm.sectors = Sector.query();
        vm.customertitles = CustomerTitle.query();
        vm.clinicnames = ClinicName.query();
        vm.roomtypes = RoomType.query();
        vm.hospitalizationtypes = HospitalizationType.query();
        vm.leadcalls = LeadCall.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:hospitalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.hospitalization.id !== null) {
                Hospitalization.update(vm.hospitalization, onSaveSuccess, onSaveError);
            } else {
                Hospitalization.save(vm.hospitalization, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateIssue = false;

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationDetailController', HospitalizationDetailController);

    HospitalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Hospitalization', 'Patient', 'Customer', 'Sector', 'CustomerTitle', 'ClinicName', 'RoomType', 'HospitalizationType', 'LeadCall'];

    function HospitalizationDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Hospitalization, Patient, Customer, Sector, CustomerTitle, ClinicName, RoomType, HospitalizationType, LeadCall) {
        var vm = this;
        vm.hospitalization = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:hospitalizationUpdate', function(event, result) {
            vm.hospitalization = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationDeleteController',HospitalizationDeleteController);

    HospitalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Hospitalization'];

    function HospitalizationDeleteController($uibModalInstance, entity, Hospitalization) {
        var vm = this;
        vm.hospitalization = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Hospitalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization', {
            parent: 'entity',
            url: '/hospitalization?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization/hospitalizations.html',
                    controller: 'HospitalizationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-detail', {
            parent: 'entity',
            url: '/hospitalization/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization/hospitalization-detail.html',
                    controller: 'HospitalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Hospitalization', function($stateParams, Hospitalization) {
                    return Hospitalization.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization.new', {
            parent: 'hospitalization',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                    controller: 'HospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pagientAge: null,
                                notes: null,
                                dateIssue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('hospitalization');
                });
            }]
        })
        .state('hospitalization.edit', {
            parent: 'hospitalization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                    controller: 'HospitalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Hospitalization', function(Hospitalization) {
                            return Hospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization.delete', {
            parent: 'hospitalization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization/hospitalization-delete-dialog.html',
                    controller: 'HospitalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Hospitalization', function(Hospitalization) {
                            return Hospitalization.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Hospitalization', Hospitalization);

    Hospitalization.$inject = ['$resource', 'DateUtils'];

    function Hospitalization ($resource, DateUtils) {
        var resourceUrl =  'api/hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateIssue = DateUtils.convertLocalDateFromServer(data.dateIssue);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateIssue = DateUtils.convertLocalDateToServer(data.dateIssue);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateIssue = DateUtils.convertLocalDateToServer(data.dateIssue);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationController', HospitalizationController);

    HospitalizationController.$inject = ['$scope', '$state', 'DataUtils', 'Hospitalization', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function HospitalizationController ($scope, $state, DataUtils, Hospitalization, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            Hospitalization.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.hospitalizations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDialogController', GeodataDialogController);

    GeodataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Geodata'];

    function GeodataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:geodataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.geodata.id !== null) {
                Geodata.update(vm.geodata, onSaveSuccess, onSaveError);
            } else {
                Geodata.save(vm.geodata, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDetailController', GeodataDetailController);

    GeodataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Geodata'];

    function GeodataDetailController($scope, $rootScope, $stateParams, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:geodataUpdate', function(event, result) {
            vm.geodata = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDeleteController',GeodataDeleteController);

    GeodataDeleteController.$inject = ['$uibModalInstance', 'entity', 'Geodata'];

    function GeodataDeleteController($uibModalInstance, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Geodata.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('geodata', {
            parent: 'entity',
            url: '/geodata?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.geodata.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geodata/geodata.html',
                    controller: 'GeodataController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geodata');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('geodata-detail', {
            parent: 'entity',
            url: '/geodata/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.geodata.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geodata/geodata-detail.html',
                    controller: 'GeodataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geodata');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Geodata', function($stateParams, Geodata) {
                    return Geodata.get({id : $stateParams.id});
                }]
            }
        })
        .state('geodata.new', {
            parent: 'geodata',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-dialog.html',
                    controller: 'GeodataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                country: null,
                                region: null,
                                prefecture: null,
                                city: null,
                                street: null,
                                postalCode: null,
                                fromNum1: null,
                                toNum1: null,
                                fromNum2: null,
                                toNum2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('geodata');
                });
            }]
        })
        .state('geodata.edit', {
            parent: 'geodata',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-dialog.html',
                    controller: 'GeodataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Geodata', function(Geodata) {
                            return Geodata.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geodata.delete', {
            parent: 'geodata',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-delete-dialog.html',
                    controller: 'GeodataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Geodata', function(Geodata) {
                            return Geodata.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Geodata', Geodata);

    Geodata.$inject = ['$resource'];

    function Geodata ($resource) {
        var resourceUrl =  'api/geodata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('GeodataSearch', GeodataSearch);

    GeodataSearch.$inject = ['$resource'];

    function GeodataSearch($resource) {
        var resourceUrl =  'api/_search/geodata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataController', GeodataController);

    GeodataController.$inject = ['$scope', '$state', 'Geodata', 'GeodataSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function GeodataController ($scope, $state, Geodata, GeodataSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GeodataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Geodata.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.geodata = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDialogController', FollowupTypeDialogController);

    FollowupTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FollowupType'];

    function FollowupTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:followupTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.followupType.id !== null) {
                FollowupType.update(vm.followupType, onSaveSuccess, onSaveError);
            } else {
                FollowupType.save(vm.followupType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDetailController', FollowupTypeDetailController);

    FollowupTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FollowupType'];

    function FollowupTypeDetailController($scope, $rootScope, $stateParams, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:followupTypeUpdate', function(event, result) {
            vm.followupType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDeleteController',FollowupTypeDeleteController);

    FollowupTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupType'];

    function FollowupTypeDeleteController($uibModalInstance, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-type', {
            parent: 'entity',
            url: '/followup-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-type/followup-types.html',
                    controller: 'FollowupTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-type-detail', {
            parent: 'entity',
            url: '/followup-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-type/followup-type-detail.html',
                    controller: 'FollowupTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupType', function($stateParams, FollowupType) {
                    return FollowupType.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-type.new', {
            parent: 'followup-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-dialog.html',
                    controller: 'FollowupTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('followup-type');
                });
            }]
        })
        .state('followup-type.edit', {
            parent: 'followup-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-dialog.html',
                    controller: 'FollowupTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupType', function(FollowupType) {
                            return FollowupType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-type.delete', {
            parent: 'followup-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-type/followup-type-delete-dialog.html',
                    controller: 'FollowupTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupType', function(FollowupType) {
                            return FollowupType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FollowupType', FollowupType);

    FollowupType.$inject = ['$resource'];

    function FollowupType ($resource) {
        var resourceUrl =  'api/followup-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeController', FollowupTypeController);

    FollowupTypeController.$inject = ['$scope', '$state', 'FollowupType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FollowupTypeController ($scope, $state, FollowupType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            FollowupType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.followupTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusDialogController', FollowupStatusDialogController);

    FollowupStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FollowupStatus'];

    function FollowupStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FollowupStatus) {
        var vm = this;
        vm.followupStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:followupStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.followupStatus.id !== null) {
                FollowupStatus.update(vm.followupStatus, onSaveSuccess, onSaveError);
            } else {
                FollowupStatus.save(vm.followupStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusDetailController', FollowupStatusDetailController);

    FollowupStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FollowupStatus'];

    function FollowupStatusDetailController($scope, $rootScope, $stateParams, entity, FollowupStatus) {
        var vm = this;
        vm.followupStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:followupStatusUpdate', function(event, result) {
            vm.followupStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusDeleteController',FollowupStatusDeleteController);

    FollowupStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupStatus'];

    function FollowupStatusDeleteController($uibModalInstance, entity, FollowupStatus) {
        var vm = this;
        vm.followupStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-status', {
            parent: 'entity',
            url: '/followup-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-status/followup-statuses.html',
                    controller: 'FollowupStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-status-detail', {
            parent: 'entity',
            url: '/followup-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-status/followup-status-detail.html',
                    controller: 'FollowupStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupStatus', function($stateParams, FollowupStatus) {
                    return FollowupStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-status.new', {
            parent: 'followup-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-dialog.html',
                    controller: 'FollowupStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('followup-status');
                });
            }]
        })
        .state('followup-status.edit', {
            parent: 'followup-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-dialog.html',
                    controller: 'FollowupStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupStatus', function(FollowupStatus) {
                            return FollowupStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-status.delete', {
            parent: 'followup-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-delete-dialog.html',
                    controller: 'FollowupStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupStatus', function(FollowupStatus) {
                            return FollowupStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FollowupStatus', FollowupStatus);

    FollowupStatus.$inject = ['$resource'];

    function FollowupStatus ($resource) {
        var resourceUrl =  'api/followup-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupStatusController', FollowupStatusController);

    FollowupStatusController.$inject = ['$scope', '$state', 'FollowupStatus', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FollowupStatusController ($scope, $state, FollowupStatus, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            FollowupStatus.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.followupStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupCallDialogController', FollowupCallDialogController);

    FollowupCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FollowupCall', 'FollowupType', 'LeadCall', 'RejectionReason', 'FollowupStatus', 'Competitor'];

    function FollowupCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FollowupCall, FollowupType, LeadCall, RejectionReason, FollowupStatus, Competitor) {
        var vm = this;
        vm.followupCall = entity;
        vm.followuptypes = FollowupType.query();
        vm.leadcalls = LeadCall.query();
        vm.rejectionreasons = RejectionReason.query();
        vm.followupstatuses = FollowupStatus.query();
        vm.competitors = Competitor.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:followupCallUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.followupCall.id !== null) {
                FollowupCall.update(vm.followupCall, onSaveSuccess, onSaveError);
            } else {
                FollowupCall.save(vm.followupCall, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupCallDetailController', FollowupCallDetailController);

    FollowupCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FollowupCall', 'FollowupType', 'LeadCall', 'RejectionReason', 'FollowupStatus', 'Competitor'];

    function FollowupCallDetailController($scope, $rootScope, $stateParams, entity, FollowupCall, FollowupType, LeadCall, RejectionReason, FollowupStatus, Competitor) {
        var vm = this;
        vm.followupCall = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:followupCallUpdate', function(event, result) {
            vm.followupCall = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupCallDeleteController',FollowupCallDeleteController);

    FollowupCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupCall'];

    function FollowupCallDeleteController($uibModalInstance, entity, FollowupCall) {
        var vm = this;
        vm.followupCall = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-call', {
            parent: 'entity',
            url: '/followup-call?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-call/followup-calls.html',
                    controller: 'FollowupCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupCall');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-call-detail', {
            parent: 'entity',
            url: '/followup-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-call/followup-call-detail.html',
                    controller: 'FollowupCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupCall', function($stateParams, FollowupCall) {
                    return FollowupCall.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-call.new', {
            parent: 'followup-call',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-dialog.html',
                    controller: 'FollowupCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                willTheyCall: null,
                                comments: null,
                                completed: null,
                                wentToAnotherRehubCenter: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('followup-call');
                });
            }]
        })
        .state('followup-call.edit', {
            parent: 'followup-call',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-dialog.html',
                    controller: 'FollowupCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupCall', function(FollowupCall) {
                            return FollowupCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-call.delete', {
            parent: 'followup-call',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-call/followup-call-delete-dialog.html',
                    controller: 'FollowupCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupCall', function(FollowupCall) {
                            return FollowupCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FollowupCall', FollowupCall);

    FollowupCall.$inject = ['$resource', 'DateUtils'];

    function FollowupCall ($resource, DateUtils) {
        var resourceUrl =  'api/followup-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupCallController', FollowupCallController);

    FollowupCallController.$inject = ['$scope', '$state', 'FollowupCall', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FollowupCallController ($scope, $state, FollowupCall, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            FollowupCall.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.followupCalls = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameDialogController', FirstNameDialogController);

    FirstNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FirstName'];

    function FirstNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FirstName) {
        var vm = this;
        vm.firstName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:firstNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.firstName.id !== null) {
                FirstName.update(vm.firstName, onSaveSuccess, onSaveError);
            } else {
                FirstName.save(vm.firstName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameDetailController', FirstNameDetailController);

    FirstNameDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FirstName'];

    function FirstNameDetailController($scope, $rootScope, $stateParams, entity, FirstName) {
        var vm = this;
        vm.firstName = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:firstNameUpdate', function(event, result) {
            vm.firstName = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameDeleteController',FirstNameDeleteController);

    FirstNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'FirstName'];

    function FirstNameDeleteController($uibModalInstance, entity, FirstName) {
        var vm = this;
        vm.firstName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FirstName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('first-name', {
            parent: 'entity',
            url: '/first-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.firstName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/first-name/first-names.html',
                    controller: 'FirstNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firstName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('first-name-detail', {
            parent: 'entity',
            url: '/first-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.firstName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/first-name/first-name-detail.html',
                    controller: 'FirstNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firstName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FirstName', function($stateParams, FirstName) {
                    return FirstName.get({id : $stateParams.id});
                }]
            }
        })
        .state('first-name.new', {
            parent: 'first-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-dialog.html',
                    controller: 'FirstNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('first-name');
                });
            }]
        })
        .state('first-name.edit', {
            parent: 'first-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-dialog.html',
                    controller: 'FirstNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirstName', function(FirstName) {
                            return FirstName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('first-name.delete', {
            parent: 'first-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-delete-dialog.html',
                    controller: 'FirstNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FirstName', function(FirstName) {
                            return FirstName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FirstName', FirstName);

    FirstName.$inject = ['$resource'];

    function FirstName ($resource) {
        var resourceUrl =  'api/first-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('FirstNameSearch', FirstNameSearch);

    FirstNameSearch.$inject = ['$resource'];

    function FirstNameSearch($resource) {
        var resourceUrl =  'api/_search/first-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameController', FirstNameController);

    FirstNameController.$inject = ['$scope', '$state', 'FirstName', 'FirstNameSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FirstNameController ($scope, $state, FirstName, FirstNameSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FirstNameSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FirstName.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.firstNames = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FavouriteFilterDialogController', FavouriteFilterDialogController);

    FavouriteFilterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'FavouriteFilter', 'Employee'];

    function FavouriteFilterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, FavouriteFilter, Employee) {
        var vm = this;
        vm.favouriteFilter = entity;
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:favouriteFilterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.favouriteFilter.id !== null) {
                FavouriteFilter.update(vm.favouriteFilter, onSaveSuccess, onSaveError);
            } else {
                FavouriteFilter.save(vm.favouriteFilter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FavouriteFilterDetailController', FavouriteFilterDetailController);

    FavouriteFilterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'FavouriteFilter', 'Employee'];

    function FavouriteFilterDetailController($scope, $rootScope, $stateParams, DataUtils, entity, FavouriteFilter, Employee) {
        var vm = this;
        vm.favouriteFilter = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:favouriteFilterUpdate', function(event, result) {
            vm.favouriteFilter = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FavouriteFilterDeleteController',FavouriteFilterDeleteController);

    FavouriteFilterDeleteController.$inject = ['$uibModalInstance', 'entity', 'FavouriteFilter'];

    function FavouriteFilterDeleteController($uibModalInstance, entity, FavouriteFilter) {
        var vm = this;
        vm.favouriteFilter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FavouriteFilter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('favourite-filter', {
            parent: 'entity',
            url: '/favourite-filter?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.favouriteFilter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/favourite-filter/favourite-filters.html',
                    controller: 'FavouriteFilterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('favouriteFilter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('favourite-filter-detail', {
            parent: 'entity',
            url: '/favourite-filter/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.favouriteFilter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-detail.html',
                    controller: 'FavouriteFilterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('favouriteFilter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FavouriteFilter', function($stateParams, FavouriteFilter) {
                    return FavouriteFilter.get({id : $stateParams.id});
                }]
            }
        })
        .state('favourite-filter.new', {
            parent: 'favourite-filter',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-dialog.html',
                    controller: 'FavouriteFilterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                viewName: null,
                                name: null,
                                kendoOptions: null,
                                masterOptions: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('favourite-filter');
                });
            }]
        })
        .state('favourite-filter.edit', {
            parent: 'favourite-filter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-dialog.html',
                    controller: 'FavouriteFilterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FavouriteFilter', function(FavouriteFilter) {
                            return FavouriteFilter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('favourite-filter.delete', {
            parent: 'favourite-filter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-delete-dialog.html',
                    controller: 'FavouriteFilterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FavouriteFilter', function(FavouriteFilter) {
                            return FavouriteFilter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FavouriteFilter', FavouriteFilter);

    FavouriteFilter.$inject = ['$resource'];

    function FavouriteFilter ($resource) {
        var resourceUrl =  'api/favourite-filters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FavouriteFilterController', FavouriteFilterController);

    FavouriteFilterController.$inject = ['$scope', '$state', 'DataUtils', 'FavouriteFilter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FavouriteFilterController ($scope, $state, DataUtils, FavouriteFilter, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            FavouriteFilter.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.favouriteFilters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventTypeDialogController', EventTypeDialogController);

    EventTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventType'];

    function EventTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventType) {
        var vm = this;
        vm.eventType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventType.id !== null) {
                EventType.update(vm.eventType, onSaveSuccess, onSaveError);
            } else {
                EventType.save(vm.eventType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventTypeDetailController', EventTypeDetailController);

    EventTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventType'];

    function EventTypeDetailController($scope, $rootScope, $stateParams, entity, EventType) {
        var vm = this;
        vm.eventType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventTypeUpdate', function(event, result) {
            vm.eventType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventTypeDeleteController',EventTypeDeleteController);

    EventTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventType'];

    function EventTypeDeleteController($uibModalInstance, entity, EventType) {
        var vm = this;
        vm.eventType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-type', {
            parent: 'entity',
            url: '/event-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-type/event-types.html',
                    controller: 'EventTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-type-detail', {
            parent: 'entity',
            url: '/event-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-type/event-type-detail.html',
                    controller: 'EventTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventType', function($stateParams, EventType) {
                    return EventType.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-type.new', {
            parent: 'event-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-dialog.html',
                    controller: 'EventTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('event-type');
                });
            }]
        })
        .state('event-type.edit', {
            parent: 'event-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-dialog.html',
                    controller: 'EventTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventType', function(EventType) {
                            return EventType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-type.delete', {
            parent: 'event-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-delete-dialog.html',
                    controller: 'EventTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventType', function(EventType) {
                            return EventType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventType', EventType);

    EventType.$inject = ['$resource'];

    function EventType ($resource) {
        var resourceUrl =  'api/event-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventTypeSearch', EventTypeSearch);

    EventTypeSearch.$inject = ['$resource'];

    function EventTypeSearch($resource) {
        var resourceUrl =  'api/_search/event-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventTypeController', EventTypeController);

    EventTypeController.$inject = ['$scope', '$state', 'EventType', 'EventTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventTypeController ($scope, $state, EventType, EventTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusDialogController', EventStatusDialogController);

    EventStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventStatus', 'EventType'];

    function EventStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventStatus, EventType) {
        var vm = this;
        vm.eventStatus = entity;
        vm.eventtypes = EventType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventStatus.id !== null) {
                EventStatus.update(vm.eventStatus, onSaveSuccess, onSaveError);
            } else {
                EventStatus.save(vm.eventStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusDetailController', EventStatusDetailController);

    EventStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventStatus', 'EventType'];

    function EventStatusDetailController($scope, $rootScope, $stateParams, entity, EventStatus, EventType) {
        var vm = this;
        vm.eventStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventStatusUpdate', function(event, result) {
            vm.eventStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusDeleteController',EventStatusDeleteController);

    EventStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventStatus'];

    function EventStatusDeleteController($uibModalInstance, entity, EventStatus) {
        var vm = this;
        vm.eventStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-status', {
            parent: 'entity',
            url: '/event-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-status/event-statuses.html',
                    controller: 'EventStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-status-detail', {
            parent: 'entity',
            url: '/event-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-status/event-status-detail.html',
                    controller: 'EventStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventStatus', function($stateParams, EventStatus) {
                    return EventStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-status.new', {
            parent: 'event-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('event-status');
                });
            }]
        })
        .state('event-status.edit', {
            parent: 'event-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventStatus', function(EventStatus) {
                            return EventStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-status.delete', {
            parent: 'event-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-delete-dialog.html',
                    controller: 'EventStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventStatus', function(EventStatus) {
                            return EventStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventStatus', EventStatus);

    EventStatus.$inject = ['$resource'];

    function EventStatus ($resource) {
        var resourceUrl =  'api/event-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventStatusSearch', EventStatusSearch);

    EventStatusSearch.$inject = ['$resource'];

    function EventStatusSearch($resource) {
        var resourceUrl =  'api/_search/event-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusController', EventStatusController);

    EventStatusController.$inject = ['$scope', '$state', 'EventStatus', 'EventStatusSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventStatusController ($scope, $state, EventStatus, EventStatusSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventStatusSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventStatus.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleDialogController', EventScheduleDialogController);

    EventScheduleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventSchedule', 'Employee'];

    function EventScheduleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventSchedule, Employee) {
        var vm = this;
        vm.eventSchedule = entity;
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventScheduleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventSchedule.id !== null) {
                EventSchedule.update(vm.eventSchedule, onSaveSuccess, onSaveError);
            } else {
                EventSchedule.save(vm.eventSchedule, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.finishedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleDetailController', EventScheduleDetailController);

    EventScheduleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventSchedule', 'Employee'];

    function EventScheduleDetailController($scope, $rootScope, $stateParams, entity, EventSchedule, Employee) {
        var vm = this;
        vm.eventSchedule = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventScheduleUpdate', function(event, result) {
            vm.eventSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleDeleteController',EventScheduleDeleteController);

    EventScheduleDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventSchedule'];

    function EventScheduleDeleteController($uibModalInstance, entity, EventSchedule) {
        var vm = this;
        vm.eventSchedule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventSchedule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-schedule', {
            parent: 'entity',
            url: '/event-schedule?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventSchedule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-schedule/event-schedules.html',
                    controller: 'EventScheduleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventSchedule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-schedule-detail', {
            parent: 'entity',
            url: '/event-schedule/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventSchedule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-schedule/event-schedule-detail.html',
                    controller: 'EventScheduleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventSchedule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventSchedule', function($stateParams, EventSchedule) {
                    return EventSchedule.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-schedule.new', {
            parent: 'event-schedule',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-dialog.html',
                    controller: 'EventScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                finishedAt: null,
                                reminder: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('event-schedule');
                });
            }]
        })
        .state('event-schedule.edit', {
            parent: 'event-schedule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-dialog.html',
                    controller: 'EventScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventSchedule', function(EventSchedule) {
                            return EventSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-schedule.delete', {
            parent: 'event-schedule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-delete-dialog.html',
                    controller: 'EventScheduleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventSchedule', function(EventSchedule) {
                            return EventSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventSchedule', EventSchedule);

    EventSchedule.$inject = ['$resource', 'DateUtils'];

    function EventSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/event-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.finishedAt = DateUtils.convertDateTimeFromServer(data.finishedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventScheduleSearch', EventScheduleSearch);

    EventScheduleSearch.$inject = ['$resource'];

    function EventScheduleSearch($resource) {
        var resourceUrl =  'api/_search/event-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleController', EventScheduleController);

    EventScheduleController.$inject = ['$scope', '$state', 'EventSchedule', 'EventScheduleSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventScheduleController ($scope, $state, EventSchedule, EventScheduleSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventScheduleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventSchedule.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventSchedules = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceDialogController', EventPlaceDialogController);

    EventPlaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventPlace'];

    function EventPlaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventPlace) {
        var vm = this;
        vm.eventPlace = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventPlaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventPlace.id !== null) {
                EventPlace.update(vm.eventPlace, onSaveSuccess, onSaveError);
            } else {
                EventPlace.save(vm.eventPlace, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceDetailController', EventPlaceDetailController);

    EventPlaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventPlace'];

    function EventPlaceDetailController($scope, $rootScope, $stateParams, entity, EventPlace) {
        var vm = this;
        vm.eventPlace = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventPlaceUpdate', function(event, result) {
            vm.eventPlace = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceDeleteController',EventPlaceDeleteController);

    EventPlaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventPlace'];

    function EventPlaceDeleteController($uibModalInstance, entity, EventPlace) {
        var vm = this;
        vm.eventPlace = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventPlace.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-place', {
            parent: 'entity',
            url: '/event-place?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventPlace.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-place/event-places.html',
                    controller: 'EventPlaceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventPlace');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-place-detail', {
            parent: 'entity',
            url: '/event-place/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventPlace.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-place/event-place-detail.html',
                    controller: 'EventPlaceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventPlace');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventPlace', function($stateParams, EventPlace) {
                    return EventPlace.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-place.new', {
            parent: 'event-place',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-dialog.html',
                    controller: 'EventPlaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('event-place');
                });
            }]
        })
        .state('event-place.edit', {
            parent: 'event-place',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-dialog.html',
                    controller: 'EventPlaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventPlace', function(EventPlace) {
                            return EventPlace.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-place.delete', {
            parent: 'event-place',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-place/event-place-delete-dialog.html',
                    controller: 'EventPlaceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventPlace', function(EventPlace) {
                            return EventPlace.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-place', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventPlace', EventPlace);

    EventPlace.$inject = ['$resource'];

    function EventPlace ($resource) {
        var resourceUrl =  'api/event-places/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventPlaceSearch', EventPlaceSearch);

    EventPlaceSearch.$inject = ['$resource'];

    function EventPlaceSearch($resource) {
        var resourceUrl =  'api/_search/event-places/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceController', EventPlaceController);

    EventPlaceController.$inject = ['$scope', '$state', 'EventPlace', 'EventPlaceSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventPlaceController ($scope, $state, EventPlace, EventPlaceSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventPlaceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventPlace.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventPlaces = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCustomerSectorDialogController', EventCustomerSectorDialogController);

    EventCustomerSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventCustomerSector', 'CommunicationType', 'CustomerSector', 'AgreementValuation', 'Event', 'Sector'];

    function EventCustomerSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventCustomerSector, CommunicationType, CustomerSector, AgreementValuation, Event, Sector) {
        var vm = this;
        vm.eventCustomerSector = entity;
        vm.communicationtypes = CommunicationType.query();
        vm.customersectors = CustomerSector.query();
        vm.agreementvaluations = AgreementValuation.query();
        vm.events = Event.query();
        vm.sectors = Sector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventCustomerSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventCustomerSector.id !== null) {
                EventCustomerSector.update(vm.eventCustomerSector, onSaveSuccess, onSaveError);
            } else {
                EventCustomerSector.save(vm.eventCustomerSector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCustomerSectorDetailController', EventCustomerSectorDetailController);

    EventCustomerSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventCustomerSector', 'CommunicationType', 'CustomerSector', 'AgreementValuation', 'Event', 'Sector'];

    function EventCustomerSectorDetailController($scope, $rootScope, $stateParams, entity, EventCustomerSector, CommunicationType, CustomerSector, AgreementValuation, Event, Sector) {
        var vm = this;
        vm.eventCustomerSector = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventCustomerSectorUpdate', function(event, result) {
            vm.eventCustomerSector = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCustomerSectorDeleteController',EventCustomerSectorDeleteController);

    EventCustomerSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventCustomerSector'];

    function EventCustomerSectorDeleteController($uibModalInstance, entity, EventCustomerSector) {
        var vm = this;
        vm.eventCustomerSector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventCustomerSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-customer-sector', {
            parent: 'entity',
            url: '/event-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sectors.html',
                    controller: 'EventCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCustomerSector');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-customer-sector-detail', {
            parent: 'entity',
            url: '/event-customer-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-detail.html',
                    controller: 'EventCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCustomerSector');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventCustomerSector', function($stateParams, EventCustomerSector) {
                    return EventCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-customer-sector.new', {
            parent: 'event-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-dialog.html',
                    controller: 'EventCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                latitude: null,
                                longitude: null,
                                agreedPercent: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('event-customer-sector');
                });
            }]
        })
        .state('event-customer-sector.edit', {
            parent: 'event-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-dialog.html',
                    controller: 'EventCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventCustomerSector', function(EventCustomerSector) {
                            return EventCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-customer-sector.delete', {
            parent: 'event-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-delete-dialog.html',
                    controller: 'EventCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventCustomerSector', function(EventCustomerSector) {
                            return EventCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventCustomerSector', EventCustomerSector);

    EventCustomerSector.$inject = ['$resource'];

    function EventCustomerSector ($resource) {
        var resourceUrl =  'api/event-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventCustomerSectorSearch', EventCustomerSectorSearch);

    EventCustomerSectorSearch.$inject = ['$resource'];

    function EventCustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/event-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCustomerSectorController', EventCustomerSectorController);

    EventCustomerSectorController.$inject = ['$scope', '$state', 'EventCustomerSector', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventCustomerSectorController ($scope, $state, EventCustomerSector, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            EventCustomerSector.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventCustomerSectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryTypeDialogController', EventCategoryTypeDialogController);

    EventCategoryTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventCategoryType', 'EventCategory', 'EventType'];

    function EventCategoryTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventCategoryType, EventCategory, EventType) {
        var vm = this;
        vm.eventCategoryType = entity;
        vm.eventcategories = EventCategory.query();
        vm.eventtypes = EventType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventCategoryTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventCategoryType.id !== null) {
                EventCategoryType.update(vm.eventCategoryType, onSaveSuccess, onSaveError);
            } else {
                EventCategoryType.save(vm.eventCategoryType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryTypeDetailController', EventCategoryTypeDetailController);

    EventCategoryTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventCategoryType', 'EventCategory', 'EventType'];

    function EventCategoryTypeDetailController($scope, $rootScope, $stateParams, entity, EventCategoryType, EventCategory, EventType) {
        var vm = this;
        vm.eventCategoryType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventCategoryTypeUpdate', function(event, result) {
            vm.eventCategoryType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryTypeDeleteController',EventCategoryTypeDeleteController);

    EventCategoryTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventCategoryType'];

    function EventCategoryTypeDeleteController($uibModalInstance, entity, EventCategoryType) {
        var vm = this;
        vm.eventCategoryType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventCategoryType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-category-type', {
            parent: 'entity',
            url: '/event-category-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategoryType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category-type/event-category-types.html',
                    controller: 'EventCategoryTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategoryType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-category-type-detail', {
            parent: 'entity',
            url: '/event-category-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategoryType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category-type/event-category-type-detail.html',
                    controller: 'EventCategoryTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategoryType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventCategoryType', function($stateParams, EventCategoryType) {
                    return EventCategoryType.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-category-type.new', {
            parent: 'event-category-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-dialog.html',
                    controller: 'EventCategoryTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('event-category-type');
                });
            }]
        })
        .state('event-category-type.edit', {
            parent: 'event-category-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-dialog.html',
                    controller: 'EventCategoryTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventCategoryType', function(EventCategoryType) {
                            return EventCategoryType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-category-type.delete', {
            parent: 'event-category-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-delete-dialog.html',
                    controller: 'EventCategoryTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventCategoryType', function(EventCategoryType) {
                            return EventCategoryType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventCategoryType', EventCategoryType);

    EventCategoryType.$inject = ['$resource'];

    function EventCategoryType ($resource) {
        var resourceUrl =  'api/event-category-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventCategoryTypeSearch', EventCategoryTypeSearch);

    EventCategoryTypeSearch.$inject = ['$resource'];

    function EventCategoryTypeSearch($resource) {
        var resourceUrl =  'api/_search/event-category-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryTypeController', EventCategoryTypeController);

    EventCategoryTypeController.$inject = ['$scope', '$state', 'EventCategoryType', 'EventCategoryTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventCategoryTypeController ($scope, $state, EventCategoryType, EventCategoryTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventCategoryTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventCategoryType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventCategoryTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryDialogController', EventCategoryDialogController);

    EventCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventCategory'];

    function EventCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventCategory) {
        var vm = this;
        vm.eventCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventCategory.id !== null) {
                EventCategory.update(vm.eventCategory, onSaveSuccess, onSaveError);
            } else {
                EventCategory.save(vm.eventCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryDetailController', EventCategoryDetailController);

    EventCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventCategory'];

    function EventCategoryDetailController($scope, $rootScope, $stateParams, entity, EventCategory) {
        var vm = this;
        vm.eventCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventCategoryUpdate', function(event, result) {
            vm.eventCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryDeleteController',EventCategoryDeleteController);

    EventCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventCategory'];

    function EventCategoryDeleteController($uibModalInstance, entity, EventCategory) {
        var vm = this;
        vm.eventCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-category', {
            parent: 'entity',
            url: '/event-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category/event-categories.html',
                    controller: 'EventCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-category-detail', {
            parent: 'entity',
            url: '/event-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category/event-category-detail.html',
                    controller: 'EventCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventCategory', function($stateParams, EventCategory) {
                    return EventCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-category.new', {
            parent: 'event-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category/event-category-dialog.html',
                    controller: 'EventCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-category', null, { reload: true });
                }, function() {
                    $state.go('event-category');
                });
            }]
        })
        .state('event-category.edit', {
            parent: 'event-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category/event-category-dialog.html',
                    controller: 'EventCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventCategory', function(EventCategory) {
                            return EventCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-category.delete', {
            parent: 'event-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category/event-category-delete-dialog.html',
                    controller: 'EventCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventCategory', function(EventCategory) {
                            return EventCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventCategory', EventCategory);

    EventCategory.$inject = ['$resource'];

    function EventCategory ($resource) {
        var resourceUrl =  'api/event-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventCategorySearch', EventCategorySearch);

    EventCategorySearch.$inject = ['$resource'];

    function EventCategorySearch($resource) {
        var resourceUrl =  'api/_search/event-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryController', EventCategoryController);

    EventCategoryController.$inject = ['$scope', '$state', 'EventCategory', 'EventCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventCategoryController ($scope, $state, EventCategory, EventCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventDialogController', EventDialogController);

    EventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Event', 'EventStatus', 'Employee', 'EventCategoryType', 'EventCustomerSector', 'EventSchedule'];

    function EventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Event, EventStatus, Employee, EventCategoryType, EventCustomerSector, EventSchedule) {
        var vm = this;
        vm.event = entity;
        vm.eventstatuses = EventStatus.query();
        vm.employees = Employee.query();
        vm.eventcategorytypes = EventCategoryType.query();
        vm.eventcustomersectors = EventCustomerSector.query();
        vm.eventschedules = EventSchedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.finishedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventDetailController', EventDetailController);

    EventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Event', 'EventStatus', 'Employee', 'EventCategoryType', 'EventCustomerSector', 'EventSchedule'];

    function EventDetailController($scope, $rootScope, $stateParams, entity, Event, EventStatus, Employee, EventCategoryType, EventCustomerSector, EventSchedule) {
        var vm = this;
        vm.event = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventUpdate', function(event, result) {
            vm.event = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventDeleteController',EventDeleteController);

    EventDeleteController.$inject = ['$uibModalInstance', 'entity', 'Event'];

    function EventDeleteController($uibModalInstance, entity, Event) {
        var vm = this;
        vm.event = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Event.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event', {
            parent: 'entity',
            url: '/event?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.event.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/events.html',
                    controller: 'EventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('event');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-detail', {
            parent: 'entity',
            url: '/event/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.event.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/event-detail.html',
                    controller: 'EventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('event');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.id});
                }]
            }
        })
        .state('event.new', {
            parent: 'event',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                finishedAt: null,
                                title: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event', null, { reload: true });
                }, function() {
                    $state.go('event');
                });
            }]
        })
        .state('event.edit', {
            parent: 'event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event.delete', {
            parent: 'event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-delete-dialog.html',
                    controller: 'EventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Event', Event);

    Event.$inject = ['$resource', 'DateUtils'];

    function Event ($resource, DateUtils) {
        var resourceUrl =  'api/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.finishedAt = DateUtils.convertDateTimeFromServer(data.finishedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventSearch', EventSearch);

    EventSearch.$inject = ['$resource'];

    function EventSearch($resource) {
        var resourceUrl =  'api/_search/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventController', EventController);

    EventController.$inject = ['$scope', '$state', 'Event', 'EventSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventController ($scope, $state, Event, EventSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Event.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.events = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeCustomerSectorDialogController', EmployeeCustomerSectorDialogController);

    EmployeeCustomerSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeeCustomerSector', 'Employee', 'CustomerSector', 'Sector'];

    function EmployeeCustomerSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeeCustomerSector, Employee, CustomerSector, Sector) {
        var vm = this;
        vm.employeeCustomerSector = entity;
        vm.employees = Employee.query();
        vm.customersectors = CustomerSector.query();
        vm.sectors = Sector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:employeeCustomerSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.employeeCustomerSector.id !== null) {
                EmployeeCustomerSector.update(vm.employeeCustomerSector, onSaveSuccess, onSaveError);
            } else {
                EmployeeCustomerSector.save(vm.employeeCustomerSector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeCustomerSectorDetailController', EmployeeCustomerSectorDetailController);

    EmployeeCustomerSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EmployeeCustomerSector', 'Employee', 'CustomerSector', 'Sector'];

    function EmployeeCustomerSectorDetailController($scope, $rootScope, $stateParams, entity, EmployeeCustomerSector, Employee, CustomerSector, Sector) {
        var vm = this;
        vm.employeeCustomerSector = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:employeeCustomerSectorUpdate', function(event, result) {
            vm.employeeCustomerSector = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeCustomerSectorDeleteController',EmployeeCustomerSectorDeleteController);

    EmployeeCustomerSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'EmployeeCustomerSector'];

    function EmployeeCustomerSectorDeleteController($uibModalInstance, entity, EmployeeCustomerSector) {
        var vm = this;
        vm.employeeCustomerSector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EmployeeCustomerSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-customer-sector', {
            parent: 'entity',
            url: '/employee-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employeeCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sectors.html',
                    controller: 'EmployeeCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeeCustomerSector');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-customer-sector-detail', {
            parent: 'entity',
            url: '/employee-customer-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employeeCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-detail.html',
                    controller: 'EmployeeCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeeCustomerSector');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EmployeeCustomerSector', function($stateParams, EmployeeCustomerSector) {
                    return EmployeeCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('employee-customer-sector.new', {
            parent: 'employee-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-dialog.html',
                    controller: 'EmployeeCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                myTarget: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('employee-customer-sector');
                });
            }]
        })
        .state('employee-customer-sector.edit', {
            parent: 'employee-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-dialog.html',
                    controller: 'EmployeeCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeeCustomerSector', function(EmployeeCustomerSector) {
                            return EmployeeCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-customer-sector.delete', {
            parent: 'employee-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-delete-dialog.html',
                    controller: 'EmployeeCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EmployeeCustomerSector', function(EmployeeCustomerSector) {
                            return EmployeeCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EmployeeCustomerSector', EmployeeCustomerSector);

    EmployeeCustomerSector.$inject = ['$resource'];

    function EmployeeCustomerSector ($resource) {
        var resourceUrl =  'api/employee-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EmployeeCustomerSectorSearch', EmployeeCustomerSectorSearch);

    EmployeeCustomerSectorSearch.$inject = ['$resource'];

    function EmployeeCustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/employee-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeCustomerSectorController', EmployeeCustomerSectorController);

    EmployeeCustomerSectorController.$inject = ['$scope', '$state', 'EmployeeCustomerSector', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EmployeeCustomerSectorController ($scope, $state, EmployeeCustomerSector, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            EmployeeCustomerSector.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.employeeCustomerSectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeDialogController', EmployeeDialogController);

    EmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Employee', 'User', 'ProductCategory', 'PurchaseNumberingRow'];

    function EmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Employee, User, ProductCategory, PurchaseNumberingRow) {
        var vm = this;
        vm.employee = entity;
        vm.users = User.query();
        vm.employees = Employee.query();
        vm.productcategories = ProductCategory.query();
        vm.purchasenumberingrows = PurchaseNumberingRow.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:employeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.employee.id !== null) {
                Employee.update(vm.employee, onSaveSuccess, onSaveError);
            } else {
                Employee.save(vm.employee, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeDetailController', EmployeeDetailController);

    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Employee', 'User', 'ProductCategory', 'PurchaseNumberingRow'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, entity, Employee, User, ProductCategory, PurchaseNumberingRow) {
        var vm = this;
        vm.employee = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:employeeUpdate', function(event, result) {
            vm.employee = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeDeleteController',EmployeeDeleteController);

    EmployeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Employee'];

    function EmployeeDeleteController($uibModalInstance, entity, Employee) {
        var vm = this;
        vm.employee = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Employee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee', {
            parent: 'entity',
            url: '/employee?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employees.html',
                    controller: 'EmployeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employee');
                    $translatePartialLoader.addPart('districtEnum');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-detail', {
            parent: 'entity',
            url: '/employee/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employee-detail.html',
                    controller: 'EmployeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employee');
                    $translatePartialLoader.addPart('districtEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Employee', function($stateParams, Employee) {
                    return Employee.get({id : $stateParams.id});
                }]
            }
        })
        .state('employee.new', {
            parent: 'employee',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                phone: null,
                                mobileVersion: null,
                                district: null,
                                pin: null,
                                geodata: null,
                                code: null,
                                device: null,
                                osVersion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: true });
                }, function() {
                    $state.go('employee');
                });
            }]
        })
        .state('employee.edit', {
            parent: 'employee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee.delete', {
            parent: 'employee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-delete-dialog.html',
                    controller: 'EmployeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Employee', Employee);

    Employee.$inject = ['$resource'];

    function Employee ($resource) {
        var resourceUrl =  'api/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EmployeeSearch', EmployeeSearch);

    EmployeeSearch.$inject = ['$resource'];

    function EmployeeSearch($resource) {
        var resourceUrl =  'api/_search/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeController', EmployeeController);

    EmployeeController.$inject = ['$scope', '$state', 'Employee', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EmployeeController ($scope, $state, Employee, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Employee.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.employees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DoctorSpecialtyDialogController', DoctorSpecialtyDialogController);

    DoctorSpecialtyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DoctorSpecialty'];

    function DoctorSpecialtyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DoctorSpecialty) {
        var vm = this;
        vm.doctorSpecialty = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:doctorSpecialtyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.doctorSpecialty.id !== null) {
                DoctorSpecialty.update(vm.doctorSpecialty, onSaveSuccess, onSaveError);
            } else {
                DoctorSpecialty.save(vm.doctorSpecialty, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DoctorSpecialtyDetailController', DoctorSpecialtyDetailController);

    DoctorSpecialtyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DoctorSpecialty'];

    function DoctorSpecialtyDetailController($scope, $rootScope, $stateParams, entity, DoctorSpecialty) {
        var vm = this;
        vm.doctorSpecialty = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:doctorSpecialtyUpdate', function(event, result) {
            vm.doctorSpecialty = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DoctorSpecialtyDeleteController',DoctorSpecialtyDeleteController);

    DoctorSpecialtyDeleteController.$inject = ['$uibModalInstance', 'entity', 'DoctorSpecialty'];

    function DoctorSpecialtyDeleteController($uibModalInstance, entity, DoctorSpecialty) {
        var vm = this;
        vm.doctorSpecialty = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DoctorSpecialty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('doctor-specialty', {
            parent: 'entity',
            url: '/doctor-specialty?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.doctorSpecialty.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialties.html',
                    controller: 'DoctorSpecialtyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('doctorSpecialty');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('doctor-specialty-detail', {
            parent: 'entity',
            url: '/doctor-specialty/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.doctorSpecialty.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-detail.html',
                    controller: 'DoctorSpecialtyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('doctorSpecialty');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DoctorSpecialty', function($stateParams, DoctorSpecialty) {
                    return DoctorSpecialty.get({id : $stateParams.id});
                }]
            }
        })
        .state('doctor-specialty.new', {
            parent: 'doctor-specialty',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-dialog.html',
                    controller: 'DoctorSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('doctor-specialty');
                });
            }]
        })
        .state('doctor-specialty.edit', {
            parent: 'doctor-specialty',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-dialog.html',
                    controller: 'DoctorSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DoctorSpecialty', function(DoctorSpecialty) {
                            return DoctorSpecialty.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('doctor-specialty.delete', {
            parent: 'doctor-specialty',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-delete-dialog.html',
                    controller: 'DoctorSpecialtyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DoctorSpecialty', function(DoctorSpecialty) {
                            return DoctorSpecialty.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DoctorSpecialty', DoctorSpecialty);

    DoctorSpecialty.$inject = ['$resource'];

    function DoctorSpecialty ($resource) {
        var resourceUrl =  'api/doctor-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('DoctorSpecialtySearch', DoctorSpecialtySearch);

    DoctorSpecialtySearch.$inject = ['$resource'];

    function DoctorSpecialtySearch($resource) {
        var resourceUrl =  'api/_search/doctor-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DoctorSpecialtyController', DoctorSpecialtyController);

    DoctorSpecialtyController.$inject = ['$scope', '$state', 'DoctorSpecialty', 'DoctorSpecialtySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DoctorSpecialtyController ($scope, $state, DoctorSpecialty, DoctorSpecialtySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DoctorSpecialtySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DoctorSpecialty.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.doctorSpecialties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeDialogController', DiseaseTypeDialogController);

    DiseaseTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiseaseType'];

    function DiseaseTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiseaseType) {
        var vm = this;
        vm.diseaseType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:diseaseTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.diseaseType.id !== null) {
                DiseaseType.update(vm.diseaseType, onSaveSuccess, onSaveError);
            } else {
                DiseaseType.save(vm.diseaseType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeDetailController', DiseaseTypeDetailController);

    DiseaseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DiseaseType'];

    function DiseaseTypeDetailController($scope, $rootScope, $stateParams, entity, DiseaseType) {
        var vm = this;
        vm.diseaseType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:diseaseTypeUpdate', function(event, result) {
            vm.diseaseType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeDeleteController',DiseaseTypeDeleteController);

    DiseaseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiseaseType'];

    function DiseaseTypeDeleteController($uibModalInstance, entity, DiseaseType) {
        var vm = this;
        vm.diseaseType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DiseaseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disease-type', {
            parent: 'entity',
            url: '/disease-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.diseaseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease-type/disease-types.html',
                    controller: 'DiseaseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diseaseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disease-type-detail', {
            parent: 'entity',
            url: '/disease-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.diseaseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease-type/disease-type-detail.html',
                    controller: 'DiseaseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diseaseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiseaseType', function($stateParams, DiseaseType) {
                    return DiseaseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('disease-type.new', {
            parent: 'disease-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-dialog.html',
                    controller: 'DiseaseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                advantages: null,
                                offer: null,
                                documents: null,
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('disease-type');
                });
            }]
        })
        .state('disease-type.edit', {
            parent: 'disease-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-dialog.html',
                    controller: 'DiseaseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiseaseType', function(DiseaseType) {
                            return DiseaseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disease-type.delete', {
            parent: 'disease-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-delete-dialog.html',
                    controller: 'DiseaseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiseaseType', function(DiseaseType) {
                            return DiseaseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiseaseType', DiseaseType);

    DiseaseType.$inject = ['$resource'];

    function DiseaseType ($resource) {
        var resourceUrl =  'api/disease-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeController', DiseaseTypeController);

    DiseaseTypeController.$inject = ['$scope', '$state', 'DiseaseType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DiseaseTypeController ($scope, $state, DiseaseType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            DiseaseType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.diseaseTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseDialogController', DiseaseDialogController);

    DiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Disease', 'DiseaseType'];

    function DiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Disease, DiseaseType) {
        var vm = this;
        vm.disease = entity;
        vm.diseasetypes = DiseaseType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:diseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.disease.id !== null) {
                Disease.update(vm.disease, onSaveSuccess, onSaveError);
            } else {
                Disease.save(vm.disease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseDetailController', DiseaseDetailController);

    DiseaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Disease', 'DiseaseType'];

    function DiseaseDetailController($scope, $rootScope, $stateParams, entity, Disease, DiseaseType) {
        var vm = this;
        vm.disease = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:diseaseUpdate', function(event, result) {
            vm.disease = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseDeleteController',DiseaseDeleteController);

    DiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Disease'];

    function DiseaseDeleteController($uibModalInstance, entity, Disease) {
        var vm = this;
        vm.disease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Disease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disease', {
            parent: 'entity',
            url: '/disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.disease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease/diseases.html',
                    controller: 'DiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disease-detail', {
            parent: 'entity',
            url: '/disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.disease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease/disease-detail.html',
                    controller: 'DiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Disease', function($stateParams, Disease) {
                    return Disease.get({id : $stateParams.id});
                }]
            }
        })
        .state('disease.new', {
            parent: 'disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-dialog.html',
                    controller: 'DiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('disease');
                });
            }]
        })
        .state('disease.edit', {
            parent: 'disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-dialog.html',
                    controller: 'DiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disease', function(Disease) {
                            return Disease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disease.delete', {
            parent: 'disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-delete-dialog.html',
                    controller: 'DiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Disease', function(Disease) {
                            return Disease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Disease', Disease);

    Disease.$inject = ['$resource'];

    function Disease ($resource) {
        var resourceUrl =  'api/diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseController', DiseaseController);

    DiseaseController.$inject = ['$scope', '$state', 'Disease', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DiseaseController ($scope, $state, Disease, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Disease.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.diseases = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountReasonDialogController', DiscountReasonDialogController);

    DiscountReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountReason'];

    function DiscountReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountReason) {
        var vm = this;
        vm.discountReason = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:discountReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.discountReason.id !== null) {
                DiscountReason.update(vm.discountReason, onSaveSuccess, onSaveError);
            } else {
                DiscountReason.save(vm.discountReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountReasonDetailController', DiscountReasonDetailController);

    DiscountReasonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DiscountReason'];

    function DiscountReasonDetailController($scope, $rootScope, $stateParams, entity, DiscountReason) {
        var vm = this;
        vm.discountReason = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:discountReasonUpdate', function(event, result) {
            vm.discountReason = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountReasonDeleteController',DiscountReasonDeleteController);

    DiscountReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiscountReason'];

    function DiscountReasonDeleteController($uibModalInstance, entity, DiscountReason) {
        var vm = this;
        vm.discountReason = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DiscountReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-reason', {
            parent: 'entity',
            url: '/discount-reason?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-reason/discount-reasons.html',
                    controller: 'DiscountReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('discount-reason-detail', {
            parent: 'entity',
            url: '/discount-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-reason/discount-reason-detail.html',
                    controller: 'DiscountReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiscountReason', function($stateParams, DiscountReason) {
                    return DiscountReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('discount-reason.new', {
            parent: 'discount-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-dialog.html',
                    controller: 'DiscountReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('discount-reason');
                });
            }]
        })
        .state('discount-reason.edit', {
            parent: 'discount-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-dialog.html',
                    controller: 'DiscountReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountReason', function(DiscountReason) {
                            return DiscountReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-reason.delete', {
            parent: 'discount-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-delete-dialog.html',
                    controller: 'DiscountReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiscountReason', function(DiscountReason) {
                            return DiscountReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiscountReason', DiscountReason);

    DiscountReason.$inject = ['$resource'];

    function DiscountReason ($resource) {
        var resourceUrl =  'api/discount-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountReasonController', DiscountReasonController);

    DiscountReasonController.$inject = ['$scope', '$state', 'DiscountReason', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DiscountReasonController ($scope, $state, DiscountReason, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            DiscountReason.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.discountReasons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateDialogController', DiscountRateDialogController);

    DiscountRateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountRate'];

    function DiscountRateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountRate) {
        var vm = this;
        vm.discountRate = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:discountRateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.discountRate.id !== null) {
                DiscountRate.update(vm.discountRate, onSaveSuccess, onSaveError);
            } else {
                DiscountRate.save(vm.discountRate, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateDetailController', DiscountRateDetailController);

    DiscountRateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DiscountRate'];

    function DiscountRateDetailController($scope, $rootScope, $stateParams, entity, DiscountRate) {
        var vm = this;
        vm.discountRate = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:discountRateUpdate', function(event, result) {
            vm.discountRate = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateDeleteController',DiscountRateDeleteController);

    DiscountRateDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiscountRate'];

    function DiscountRateDeleteController($uibModalInstance, entity, DiscountRate) {
        var vm = this;
        vm.discountRate = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DiscountRate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-rate', {
            parent: 'entity',
            url: '/discount-rate?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountRate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-rate/discount-rates.html',
                    controller: 'DiscountRateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountRate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('discount-rate-detail', {
            parent: 'entity',
            url: '/discount-rate/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountRate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-rate/discount-rate-detail.html',
                    controller: 'DiscountRateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountRate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiscountRate', function($stateParams, DiscountRate) {
                    return DiscountRate.get({id : $stateParams.id});
                }]
            }
        })
        .state('discount-rate.new', {
            parent: 'discount-rate',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-dialog.html',
                    controller: 'DiscountRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('discount-rate');
                });
            }]
        })
        .state('discount-rate.edit', {
            parent: 'discount-rate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-dialog.html',
                    controller: 'DiscountRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountRate', function(DiscountRate) {
                            return DiscountRate.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-rate.delete', {
            parent: 'discount-rate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-delete-dialog.html',
                    controller: 'DiscountRateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiscountRate', function(DiscountRate) {
                            return DiscountRate.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiscountRate', DiscountRate);

    DiscountRate.$inject = ['$resource'];

    function DiscountRate ($resource) {
        var resourceUrl =  'api/discount-rates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateController', DiscountRateController);

    DiscountRateController.$inject = ['$scope', '$state', 'DiscountRate', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DiscountRateController ($scope, $state, DiscountRate, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            DiscountRate.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.discountRates = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDialogController', CustomerTypeDialogController);

    CustomerTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerType'];

    function CustomerTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerType.id !== null) {
                CustomerType.update(vm.customerType, onSaveSuccess, onSaveError);
            } else {
                CustomerType.save(vm.customerType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDetailController', CustomerTypeDetailController);

    CustomerTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerType'];

    function CustomerTypeDetailController($scope, $rootScope, $stateParams, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerTypeUpdate', function(event, result) {
            vm.customerType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDeleteController',CustomerTypeDeleteController);

    CustomerTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerType'];

    function CustomerTypeDeleteController($uibModalInstance, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-type', {
            parent: 'entity',
            url: '/customer-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-type/customer-types.html',
                    controller: 'CustomerTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-type-detail', {
            parent: 'entity',
            url: '/customer-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-type/customer-type-detail.html',
                    controller: 'CustomerTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerType', function($stateParams, CustomerType) {
                    return CustomerType.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-type.new', {
            parent: 'customer-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-dialog.html',
                    controller: 'CustomerTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('customer-type');
                });
            }]
        })
        .state('customer-type.edit', {
            parent: 'customer-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-dialog.html',
                    controller: 'CustomerTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerType', function(CustomerType) {
                            return CustomerType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-type.delete', {
            parent: 'customer-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-type/customer-type-delete-dialog.html',
                    controller: 'CustomerTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerType', function(CustomerType) {
                            return CustomerType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerType', CustomerType);

    CustomerType.$inject = ['$resource'];

    function CustomerType ($resource) {
        var resourceUrl =  'api/customer-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeController', CustomerTypeController);

    CustomerTypeController.$inject = ['$scope', '$state', 'CustomerType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerTypeController ($scope, $state, CustomerType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CustomerType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTitleDialogController', CustomerTitleDialogController);

    CustomerTitleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerTitle'];

    function CustomerTitleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerTitle) {
        var vm = this;
        vm.customerTitle = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerTitleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerTitle.id !== null) {
                CustomerTitle.update(vm.customerTitle, onSaveSuccess, onSaveError);
            } else {
                CustomerTitle.save(vm.customerTitle, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTitleDetailController', CustomerTitleDetailController);

    CustomerTitleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerTitle'];

    function CustomerTitleDetailController($scope, $rootScope, $stateParams, entity, CustomerTitle) {
        var vm = this;
        vm.customerTitle = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerTitleUpdate', function(event, result) {
            vm.customerTitle = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTitleDeleteController',CustomerTitleDeleteController);

    CustomerTitleDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerTitle'];

    function CustomerTitleDeleteController($uibModalInstance, entity, CustomerTitle) {
        var vm = this;
        vm.customerTitle = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerTitle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-title', {
            parent: 'entity',
            url: '/customer-title?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerTitle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-title/customer-titles.html',
                    controller: 'CustomerTitleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerTitle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-title-detail', {
            parent: 'entity',
            url: '/customer-title/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerTitle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-title/customer-title-detail.html',
                    controller: 'CustomerTitleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerTitle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerTitle', function($stateParams, CustomerTitle) {
                    return CustomerTitle.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-title.new', {
            parent: 'customer-title',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-dialog.html',
                    controller: 'CustomerTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('customer-title');
                });
            }]
        })
        .state('customer-title.edit', {
            parent: 'customer-title',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-dialog.html',
                    controller: 'CustomerTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerTitle', function(CustomerTitle) {
                            return CustomerTitle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-title.delete', {
            parent: 'customer-title',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-delete-dialog.html',
                    controller: 'CustomerTitleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerTitle', function(CustomerTitle) {
                            return CustomerTitle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerTitle', CustomerTitle);

    CustomerTitle.$inject = ['$resource'];

    function CustomerTitle ($resource) {
        var resourceUrl =  'api/customer-titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerTitleSearch', CustomerTitleSearch);

    CustomerTitleSearch.$inject = ['$resource'];

    function CustomerTitleSearch($resource) {
        var resourceUrl =  'api/_search/customer-titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTitleController', CustomerTitleController);

    CustomerTitleController.$inject = ['$scope', '$state', 'CustomerTitle', 'CustomerTitleSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerTitleController ($scope, $state, CustomerTitle, CustomerTitleSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomerTitleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomerTitle.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerTitles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSubCategoryDialogController', CustomerSubCategoryDialogController);

    CustomerSubCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerSubCategory'];

    function CustomerSubCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerSubCategory) {
        var vm = this;
        vm.customerSubCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerSubCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerSubCategory.id !== null) {
                CustomerSubCategory.update(vm.customerSubCategory, onSaveSuccess, onSaveError);
            } else {
                CustomerSubCategory.save(vm.customerSubCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSubCategoryDetailController', CustomerSubCategoryDetailController);

    CustomerSubCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerSubCategory'];

    function CustomerSubCategoryDetailController($scope, $rootScope, $stateParams, entity, CustomerSubCategory) {
        var vm = this;
        vm.customerSubCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerSubCategoryUpdate', function(event, result) {
            vm.customerSubCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSubCategoryDeleteController',CustomerSubCategoryDeleteController);

    CustomerSubCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerSubCategory'];

    function CustomerSubCategoryDeleteController($uibModalInstance, entity, CustomerSubCategory) {
        var vm = this;
        vm.customerSubCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerSubCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-sub-category', {
            parent: 'entity',
            url: '/customer-sub-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSubCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-categories.html',
                    controller: 'CustomerSubCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSubCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-sub-category-detail', {
            parent: 'entity',
            url: '/customer-sub-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSubCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-detail.html',
                    controller: 'CustomerSubCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSubCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerSubCategory', function($stateParams, CustomerSubCategory) {
                    return CustomerSubCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-sub-category.new', {
            parent: 'customer-sub-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-dialog.html',
                    controller: 'CustomerSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('customer-sub-category');
                });
            }]
        })
        .state('customer-sub-category.edit', {
            parent: 'customer-sub-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-dialog.html',
                    controller: 'CustomerSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSubCategory', function(CustomerSubCategory) {
                            return CustomerSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sub-category.delete', {
            parent: 'customer-sub-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-delete-dialog.html',
                    controller: 'CustomerSubCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerSubCategory', function(CustomerSubCategory) {
                            return CustomerSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerSubCategory', CustomerSubCategory);

    CustomerSubCategory.$inject = ['$resource'];

    function CustomerSubCategory ($resource) {
        var resourceUrl =  'api/customer-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSubCategorySearch', CustomerSubCategorySearch);

    CustomerSubCategorySearch.$inject = ['$resource'];

    function CustomerSubCategorySearch($resource) {
        var resourceUrl =  'api/_search/customer-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSubCategoryController', CustomerSubCategoryController);

    CustomerSubCategoryController.$inject = ['$scope', '$state', 'CustomerSubCategory', 'CustomerSubCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerSubCategoryController ($scope, $state, CustomerSubCategory, CustomerSubCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomerSubCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomerSubCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerSubCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorDialogController', CustomerSectorDialogController);

    CustomerSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerSector', 'Customer', 'Sector', 'WorkingDay', 'SectorPosition', 'EventCustomerSector', 'EmployeeCustomerSector'];

    function CustomerSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerSector, Customer, Sector, WorkingDay, SectorPosition, EventCustomerSector, EmployeeCustomerSector) {
        var vm = this;

        vm.customerSector = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();
        vm.sectors = Sector.query();
        vm.workingdays = WorkingDay.query();
        vm.sectorpositions = SectorPosition.query();
        vm.eventcustomersectors = EventCustomerSector.query();
        vm.employeecustomersectors = EmployeeCustomerSector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customerSector.id !== null) {
                CustomerSector.update(vm.customerSector, onSaveSuccess, onSaveError);
            } else {
                CustomerSector.save(vm.customerSector, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sigmasfApp:customerSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.endedAt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorDetailController', CustomerSectorDetailController);

    CustomerSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomerSector', 'Customer', 'Sector', 'WorkingDay', 'SectorPosition', 'EventCustomerSector', 'EmployeeCustomerSector'];

    function CustomerSectorDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomerSector, Customer, Sector, WorkingDay, SectorPosition, EventCustomerSector, EmployeeCustomerSector) {
        var vm = this;

        vm.customerSector = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sigmasfApp:customerSectorUpdate', function(event, result) {
            vm.customerSector = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorDeleteController',CustomerSectorDeleteController);

    CustomerSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerSector'];

    function CustomerSectorDeleteController($uibModalInstance, entity, CustomerSector) {
        var vm = this;

        vm.customerSector = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomerSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-sector', {
            parent: 'entity',
            url: '/customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sector/customer-sectors.html',
                    controller: 'CustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-sector-detail', {
            parent: 'customer-sector',
            url: '/customer-sector/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.customerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sector/customer-sector-detail.html',
                    controller: 'CustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSector');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerSector', function($stateParams, CustomerSector) {
                    return CustomerSector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer-sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-sector-detail.edit', {
            parent: 'customer-sector-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sector.new', {
            parent: 'customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                endedAt: null,
                                phone: null,
                                main: null,
                                monday: null,
                                tuesday: null,
                                wednesday: null,
                                thursday: null,
                                friday: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('customer-sector');
                });
            }]
        })
        .state('customer-sector.edit', {
            parent: 'customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-dialog.html',
                    controller: 'CustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sector.delete', {
            parent: 'customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sector/customer-sector-delete-dialog.html',
                    controller: 'CustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerSector', function(CustomerSector) {
                            return CustomerSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sector', null, { reload: 'customer-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerSector', CustomerSector);

    CustomerSector.$inject = ['$resource', 'DateUtils'];

    function CustomerSector ($resource, DateUtils) {
        var resourceUrl =  'api/customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertLocalDateFromServer(data.startedAt);
                        data.endedAt = DateUtils.convertLocalDateFromServer(data.endedAt);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startedAt = DateUtils.convertLocalDateToServer(copy.startedAt);
                    copy.endedAt = DateUtils.convertLocalDateToServer(copy.endedAt);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startedAt = DateUtils.convertLocalDateToServer(copy.startedAt);
                    copy.endedAt = DateUtils.convertLocalDateToServer(copy.endedAt);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSectorSearch', CustomerSectorSearch);

    CustomerSectorSearch.$inject = ['$resource'];

    function CustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorController', CustomerSectorController);

    CustomerSectorController.$inject = ['$state', 'CustomerSector', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomerSectorController($state, CustomerSector, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomerSector.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerSectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryDialogController', CustomerCategoryDialogController);

    CustomerCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerCategory'];

    function CustomerCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerCategory) {
        var vm = this;
        vm.customerCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerCategory.id !== null) {
                CustomerCategory.update(vm.customerCategory, onSaveSuccess, onSaveError);
            } else {
                CustomerCategory.save(vm.customerCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryDetailController', CustomerCategoryDetailController);

    CustomerCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerCategory'];

    function CustomerCategoryDetailController($scope, $rootScope, $stateParams, entity, CustomerCategory) {
        var vm = this;
        vm.customerCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerCategoryUpdate', function(event, result) {
            vm.customerCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryDeleteController',CustomerCategoryDeleteController);

    CustomerCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerCategory'];

    function CustomerCategoryDeleteController($uibModalInstance, entity, CustomerCategory) {
        var vm = this;
        vm.customerCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-category', {
            parent: 'entity',
            url: '/customer-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-category/customer-categories.html',
                    controller: 'CustomerCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-category-detail', {
            parent: 'entity',
            url: '/customer-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-category/customer-category-detail.html',
                    controller: 'CustomerCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerCategory', function($stateParams, CustomerCategory) {
                    return CustomerCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-category.new', {
            parent: 'customer-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-dialog.html',
                    controller: 'CustomerCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                circleDaysNo: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('customer-category');
                });
            }]
        })
        .state('customer-category.edit', {
            parent: 'customer-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-dialog.html',
                    controller: 'CustomerCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerCategory', function(CustomerCategory) {
                            return CustomerCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-category.delete', {
            parent: 'customer-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-delete-dialog.html',
                    controller: 'CustomerCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerCategory', function(CustomerCategory) {
                            return CustomerCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerCategory', CustomerCategory);

    CustomerCategory.$inject = ['$resource'];

    function CustomerCategory ($resource) {
        var resourceUrl =  'api/customer-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerCategorySearch', CustomerCategorySearch);

    CustomerCategorySearch.$inject = ['$resource'];

    function CustomerCategorySearch($resource) {
        var resourceUrl =  'api/_search/customer-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryController', CustomerCategoryController);

    CustomerCategoryController.$inject = ['$scope', '$state', 'CustomerCategory', 'CustomerCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerCategoryController ($scope, $state, CustomerCategory, CustomerCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomerCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomerCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Customer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'CustomerType', 'Collaboration'];

    function CustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Customer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, CustomerType, Collaboration) {
        var vm = this;
        vm.customer = entity;
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.customercategories = CustomerCategory.query();
        vm.customersectors = CustomerSector.query();
        vm.customertitles = CustomerTitle.query();
        vm.customersubcategories = CustomerSubCategory.query();
        vm.customertypes = CustomerType.query();
        vm.collaborations = Collaboration.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};

        vm.setProfilePhoto = function ($file, customer) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        customer.profilePhoto = base64Data;
                        customer.profilePhotoContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.lastVisitDate = false;

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Customer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'CustomerType', 'Collaboration'];

    function CustomerDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Customer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, CustomerType, Collaboration) {
        var vm = this;
        vm.customer = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:customerUpdate', function(event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerDeleteController',CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;
        vm.customer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'entity',
            url: '/customer?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customers.html',
                    controller: 'CustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('software');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-detail', {
            parent: 'entity',
            url: '/customer/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-detail.html',
                    controller: 'CustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('software');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customer', function($stateParams, Customer) {
                    return Customer.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer.new', {
            parent: 'customer',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                fatherName: null,
                                cellPhone: null,
                                phone: null,
                                isMale: null,
                                email: null,
                                notes: null,
                                saw: null,
                                isActive: null,
                                dayTime: null,
                                lCode: null,
                                vatNumber: null,
                                etaaNumber: null,
                                amka: null,
                                profilePhoto: null,
                                profilePhotoContentType: null,
                                software: null,
                                lastVisitDate: null,
                                docId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('customer');
                });
            }]
        })
        .state('customer.edit', {
            parent: 'customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.delete', {
            parent: 'customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                    controller: 'CustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils'];

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastVisitDate = DateUtils.convertDateTimeFromServer(data.lastVisitDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource'];

    function CustomerSearch($resource) {
        var resourceUrl =  'api/_search/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['$scope', '$state', 'DataUtils', 'Customer', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerController ($scope, $state, DataUtils, Customer, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            Customer.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryPhoneCodeDialogController', CountryPhoneCodeDialogController);

    CountryPhoneCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CountryPhoneCode'];

    function CountryPhoneCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CountryPhoneCode) {
        var vm = this;
        vm.countryPhoneCode = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:countryPhoneCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.countryPhoneCode.id !== null) {
                CountryPhoneCode.update(vm.countryPhoneCode, onSaveSuccess, onSaveError);
            } else {
                CountryPhoneCode.save(vm.countryPhoneCode, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryPhoneCodeDetailController', CountryPhoneCodeDetailController);

    CountryPhoneCodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CountryPhoneCode'];

    function CountryPhoneCodeDetailController($scope, $rootScope, $stateParams, entity, CountryPhoneCode) {
        var vm = this;
        vm.countryPhoneCode = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:countryPhoneCodeUpdate', function(event, result) {
            vm.countryPhoneCode = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryPhoneCodeDeleteController',CountryPhoneCodeDeleteController);

    CountryPhoneCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CountryPhoneCode'];

    function CountryPhoneCodeDeleteController($uibModalInstance, entity, CountryPhoneCode) {
        var vm = this;
        vm.countryPhoneCode = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CountryPhoneCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country-phone-code', {
            parent: 'entity',
            url: '/country-phone-code?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.countryPhoneCode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-phone-code/country-phone-codes.html',
                    controller: 'CountryPhoneCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('countryPhoneCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-phone-code-detail', {
            parent: 'entity',
            url: '/country-phone-code/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.countryPhoneCode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-detail.html',
                    controller: 'CountryPhoneCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('countryPhoneCode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CountryPhoneCode', function($stateParams, CountryPhoneCode) {
                    return CountryPhoneCode.get({id : $stateParams.id});
                }]
            }
        })
        .state('country-phone-code.new', {
            parent: 'country-phone-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-dialog.html',
                    controller: 'CountryPhoneCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('country-phone-code');
                });
            }]
        })
        .state('country-phone-code.edit', {
            parent: 'country-phone-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-dialog.html',
                    controller: 'CountryPhoneCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CountryPhoneCode', function(CountryPhoneCode) {
                            return CountryPhoneCode.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-phone-code.delete', {
            parent: 'country-phone-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-delete-dialog.html',
                    controller: 'CountryPhoneCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CountryPhoneCode', function(CountryPhoneCode) {
                            return CountryPhoneCode.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CountryPhoneCode', CountryPhoneCode);

    CountryPhoneCode.$inject = ['$resource'];

    function CountryPhoneCode ($resource) {
        var resourceUrl =  'api/country-phone-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryPhoneCodeController', CountryPhoneCodeController);

    CountryPhoneCodeController.$inject = ['$scope', '$state', 'CountryPhoneCode', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CountryPhoneCodeController ($scope, $state, CountryPhoneCode, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CountryPhoneCode.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.countryPhoneCodes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;
        vm.country = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, entity, Country) {
        var vm = this;
        vm.country = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;
        vm.country = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'entity',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id});
                }]
            }
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                isoSymbol: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  'api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', '$state', 'Country', 'CountrySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CountryController ($scope, $state, Country, CountrySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CountrySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Country.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.countries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CostTypeDialogController', CostTypeDialogController);

    CostTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CostType'];

    function CostTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CostType) {
        var vm = this;
        vm.costType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:costTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.costType.id !== null) {
                CostType.update(vm.costType, onSaveSuccess, onSaveError);
            } else {
                CostType.save(vm.costType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CostTypeDetailController', CostTypeDetailController);

    CostTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CostType'];

    function CostTypeDetailController($scope, $rootScope, $stateParams, entity, CostType) {
        var vm = this;
        vm.costType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:costTypeUpdate', function(event, result) {
            vm.costType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CostTypeDeleteController',CostTypeDeleteController);

    CostTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CostType'];

    function CostTypeDeleteController($uibModalInstance, entity, CostType) {
        var vm = this;
        vm.costType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CostType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cost-type', {
            parent: 'entity',
            url: '/cost-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.costType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-type/cost-types.html',
                    controller: 'CostTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cost-type-detail', {
            parent: 'entity',
            url: '/cost-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.costType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-type/cost-type-detail.html',
                    controller: 'CostTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CostType', function($stateParams, CostType) {
                    return CostType.get({id : $stateParams.id});
                }]
            }
        })
        .state('cost-type.new', {
            parent: 'cost-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-dialog.html',
                    controller: 'CostTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('cost-type');
                });
            }]
        })
        .state('cost-type.edit', {
            parent: 'cost-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-dialog.html',
                    controller: 'CostTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CostType', function(CostType) {
                            return CostType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cost-type.delete', {
            parent: 'cost-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-delete-dialog.html',
                    controller: 'CostTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CostType', function(CostType) {
                            return CostType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CostType', CostType);

    CostType.$inject = ['$resource'];

    function CostType ($resource) {
        var resourceUrl =  'api/cost-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CostTypeController', CostTypeController);

    CostTypeController.$inject = ['$scope', '$state', 'CostType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CostTypeController ($scope, $state, CostType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CostType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.costTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorDialogController', CompetitorDialogController);

    CompetitorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Competitor'];

    function CompetitorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Competitor) {
        var vm = this;
        vm.competitor = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:competitorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.competitor.id !== null) {
                Competitor.update(vm.competitor, onSaveSuccess, onSaveError);
            } else {
                Competitor.save(vm.competitor, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorDetailController', CompetitorDetailController);

    CompetitorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Competitor'];

    function CompetitorDetailController($scope, $rootScope, $stateParams, entity, Competitor) {
        var vm = this;
        vm.competitor = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:competitorUpdate', function(event, result) {
            vm.competitor = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorDeleteController',CompetitorDeleteController);

    CompetitorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Competitor'];

    function CompetitorDeleteController($uibModalInstance, entity, Competitor) {
        var vm = this;
        vm.competitor = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Competitor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('competitor', {
            parent: 'entity',
            url: '/competitor?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.competitor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/competitor/competitors.html',
                    controller: 'CompetitorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('competitor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('competitor-detail', {
            parent: 'entity',
            url: '/competitor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.competitor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/competitor/competitor-detail.html',
                    controller: 'CompetitorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('competitor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Competitor', function($stateParams, Competitor) {
                    return Competitor.get({id : $stateParams.id});
                }]
            }
        })
        .state('competitor.new', {
            parent: 'competitor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/competitor/competitor-dialog.html',
                    controller: 'CompetitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('competitor', null, { reload: true });
                }, function() {
                    $state.go('competitor');
                });
            }]
        })
        .state('competitor.edit', {
            parent: 'competitor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/competitor/competitor-dialog.html',
                    controller: 'CompetitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Competitor', function(Competitor) {
                            return Competitor.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('competitor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('competitor.delete', {
            parent: 'competitor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/competitor/competitor-delete-dialog.html',
                    controller: 'CompetitorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Competitor', function(Competitor) {
                            return Competitor.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('competitor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Competitor', Competitor);

    Competitor.$inject = ['$resource'];

    function Competitor ($resource) {
        var resourceUrl =  'api/competitors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorController', CompetitorController);

    CompetitorController.$inject = ['$scope', '$state', 'Competitor', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompetitorController ($scope, $state, Competitor, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Competitor.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.competitors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeDialogController', CompanyTypeDialogController);

    CompanyTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyType'];

    function CompanyTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyType) {
        var vm = this;
        vm.companyType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:companyTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.companyType.id !== null) {
                CompanyType.update(vm.companyType, onSaveSuccess, onSaveError);
            } else {
                CompanyType.save(vm.companyType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeDetailController', CompanyTypeDetailController);

    CompanyTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyType'];

    function CompanyTypeDetailController($scope, $rootScope, $stateParams, entity, CompanyType) {
        var vm = this;
        vm.companyType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:companyTypeUpdate', function(event, result) {
            vm.companyType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeDeleteController',CompanyTypeDeleteController);

    CompanyTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyType'];

    function CompanyTypeDeleteController($uibModalInstance, entity, CompanyType) {
        var vm = this;
        vm.companyType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CompanyType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company-type', {
            parent: 'entity',
            url: '/company-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.companyType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-type/company-types.html',
                    controller: 'CompanyTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companyType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('company-type-detail', {
            parent: 'entity',
            url: '/company-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.companyType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-type/company-type-detail.html',
                    controller: 'CompanyTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companyType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CompanyType', function($stateParams, CompanyType) {
                    return CompanyType.get({id : $stateParams.id});
                }]
            }
        })
        .state('company-type.new', {
            parent: 'company-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-dialog.html',
                    controller: 'CompanyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('company-type');
                });
            }]
        })
        .state('company-type.edit', {
            parent: 'company-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-dialog.html',
                    controller: 'CompanyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompanyType', function(CompanyType) {
                            return CompanyType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-type.delete', {
            parent: 'company-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-delete-dialog.html',
                    controller: 'CompanyTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompanyType', function(CompanyType) {
                            return CompanyType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CompanyType', CompanyType);

    CompanyType.$inject = ['$resource'];

    function CompanyType ($resource) {
        var resourceUrl =  'api/company-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeController', CompanyTypeController);

    CompanyTypeController.$inject = ['$scope', '$state', 'CompanyType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyTypeController ($scope, $state, CompanyType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CompanyType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeDialogController', CommunicationTypeDialogController);

    CommunicationTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationType'];

    function CommunicationTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CommunicationType) {
        var vm = this;
        vm.communicationType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:communicationTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationType.id !== null) {
                CommunicationType.update(vm.communicationType, onSaveSuccess, onSaveError);
            } else {
                CommunicationType.save(vm.communicationType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeDetailController', CommunicationTypeDetailController);

    CommunicationTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationType'];

    function CommunicationTypeDetailController($scope, $rootScope, $stateParams, entity, CommunicationType) {
        var vm = this;
        vm.communicationType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:communicationTypeUpdate', function(event, result) {
            vm.communicationType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeDeleteController',CommunicationTypeDeleteController);

    CommunicationTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationType'];

    function CommunicationTypeDeleteController($uibModalInstance, entity, CommunicationType) {
        var vm = this;
        vm.communicationType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-type', {
            parent: 'entity',
            url: '/communication-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.communicationType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-type/communication-types.html',
                    controller: 'CommunicationTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-type-detail', {
            parent: 'entity',
            url: '/communication-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.communicationType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-type/communication-type-detail.html',
                    controller: 'CommunicationTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationType', function($stateParams, CommunicationType) {
                    return CommunicationType.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-type.new', {
            parent: 'communication-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-dialog.html',
                    controller: 'CommunicationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('communication-type');
                });
            }]
        })
        .state('communication-type.edit', {
            parent: 'communication-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-dialog.html',
                    controller: 'CommunicationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationType', function(CommunicationType) {
                            return CommunicationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-type.delete', {
            parent: 'communication-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-delete-dialog.html',
                    controller: 'CommunicationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationType', function(CommunicationType) {
                            return CommunicationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CommunicationType', CommunicationType);

    CommunicationType.$inject = ['$resource'];

    function CommunicationType ($resource) {
        var resourceUrl =  'api/communication-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CommunicationTypeSearch', CommunicationTypeSearch);

    CommunicationTypeSearch.$inject = ['$resource'];

    function CommunicationTypeSearch($resource) {
        var resourceUrl =  'api/_search/communication-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeController', CommunicationTypeController);

    CommunicationTypeController.$inject = ['$scope', '$state', 'CommunicationType', 'CommunicationTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationTypeController ($scope, $state, CommunicationType, CommunicationTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CommunicationTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CommunicationType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDialogController', CommunicationStatusDialogController);

    CommunicationStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:communicationStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationStatus.id !== null) {
                CommunicationStatus.update(vm.communicationStatus, onSaveSuccess, onSaveError);
            } else {
                CommunicationStatus.save(vm.communicationStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDetailController', CommunicationStatusDetailController);

    CommunicationStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDetailController($scope, $rootScope, $stateParams, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:communicationStatusUpdate', function(event, result) {
            vm.communicationStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDeleteController',CommunicationStatusDeleteController);

    CommunicationStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDeleteController($uibModalInstance, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-status', {
            parent: 'entity',
            url: '/communication-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.communicationStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-status/communication-statuses.html',
                    controller: 'CommunicationStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-status-detail', {
            parent: 'entity',
            url: '/communication-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.communicationStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-status/communication-status-detail.html',
                    controller: 'CommunicationStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationStatus', function($stateParams, CommunicationStatus) {
                    return CommunicationStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-status.new', {
            parent: 'communication-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-dialog.html',
                    controller: 'CommunicationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('communication-status');
                });
            }]
        })
        .state('communication-status.edit', {
            parent: 'communication-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-dialog.html',
                    controller: 'CommunicationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationStatus', function(CommunicationStatus) {
                            return CommunicationStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-status.delete', {
            parent: 'communication-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-delete-dialog.html',
                    controller: 'CommunicationStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationStatus', function(CommunicationStatus) {
                            return CommunicationStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CommunicationStatus', CommunicationStatus);

    CommunicationStatus.$inject = ['$resource'];

    function CommunicationStatus ($resource) {
        var resourceUrl =  'api/communication-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusController', CommunicationStatusController);

    CommunicationStatusController.$inject = ['$scope', '$state', 'CommunicationStatus', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationStatusController ($scope, $state, CommunicationStatus, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CommunicationStatus.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CollaborationDialogController', CollaborationDialogController);

    CollaborationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Collaboration'];

    function CollaborationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Collaboration) {
        var vm = this;
        vm.collaboration = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:collaborationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.collaboration.id !== null) {
                Collaboration.update(vm.collaboration, onSaveSuccess, onSaveError);
            } else {
                Collaboration.save(vm.collaboration, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CollaborationDetailController', CollaborationDetailController);

    CollaborationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Collaboration'];

    function CollaborationDetailController($scope, $rootScope, $stateParams, entity, Collaboration) {
        var vm = this;
        vm.collaboration = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:collaborationUpdate', function(event, result) {
            vm.collaboration = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CollaborationDeleteController',CollaborationDeleteController);

    CollaborationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Collaboration'];

    function CollaborationDeleteController($uibModalInstance, entity, Collaboration) {
        var vm = this;
        vm.collaboration = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Collaboration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collaboration', {
            parent: 'entity',
            url: '/collaboration?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.collaboration.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collaboration/collaborations.html',
                    controller: 'CollaborationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collaboration');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collaboration-detail', {
            parent: 'entity',
            url: '/collaboration/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.collaboration.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collaboration/collaboration-detail.html',
                    controller: 'CollaborationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collaboration');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Collaboration', function($stateParams, Collaboration) {
                    return Collaboration.get({id : $stateParams.id});
                }]
            }
        })
        .state('collaboration.new', {
            parent: 'collaboration',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-dialog.html',
                    controller: 'CollaborationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('collaboration');
                });
            }]
        })
        .state('collaboration.edit', {
            parent: 'collaboration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-dialog.html',
                    controller: 'CollaborationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collaboration', function(Collaboration) {
                            return Collaboration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collaboration.delete', {
            parent: 'collaboration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-delete-dialog.html',
                    controller: 'CollaborationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Collaboration', function(Collaboration) {
                            return Collaboration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Collaboration', Collaboration);

    Collaboration.$inject = ['$resource'];

    function Collaboration ($resource) {
        var resourceUrl =  'api/collaborations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CollaborationController', CollaborationController);

    CollaborationController.$inject = ['$scope', '$state', 'Collaboration', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CollaborationController ($scope, $state, Collaboration, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Collaboration.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.collaborations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameDialogController', ClinicNameDialogController);

    ClinicNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClinicName'];

    function ClinicNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClinicName) {
        var vm = this;
        vm.clinicName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:clinicNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.clinicName.id !== null) {
                ClinicName.update(vm.clinicName, onSaveSuccess, onSaveError);
            } else {
                ClinicName.save(vm.clinicName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameDetailController', ClinicNameDetailController);

    ClinicNameDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ClinicName'];

    function ClinicNameDetailController($scope, $rootScope, $stateParams, entity, ClinicName) {
        var vm = this;
        vm.clinicName = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:clinicNameUpdate', function(event, result) {
            vm.clinicName = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameDeleteController',ClinicNameDeleteController);

    ClinicNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClinicName'];

    function ClinicNameDeleteController($uibModalInstance, entity, ClinicName) {
        var vm = this;
        vm.clinicName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ClinicName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clinic-name', {
            parent: 'entity',
            url: '/clinic-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.clinicName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clinic-name/clinic-names.html',
                    controller: 'ClinicNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clinicName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('clinic-name-detail', {
            parent: 'entity',
            url: '/clinic-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.clinicName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clinic-name/clinic-name-detail.html',
                    controller: 'ClinicNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clinicName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ClinicName', function($stateParams, ClinicName) {
                    return ClinicName.get({id : $stateParams.id});
                }]
            }
        })
        .state('clinic-name.new', {
            parent: 'clinic-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-dialog.html',
                    controller: 'ClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('clinic-name');
                });
            }]
        })
        .state('clinic-name.edit', {
            parent: 'clinic-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-dialog.html',
                    controller: 'ClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClinicName', function(ClinicName) {
                            return ClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('clinic-name.delete', {
            parent: 'clinic-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-delete-dialog.html',
                    controller: 'ClinicNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClinicName', function(ClinicName) {
                            return ClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ClinicName', ClinicName);

    ClinicName.$inject = ['$resource'];

    function ClinicName ($resource) {
        var resourceUrl =  'api/clinic-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameController', ClinicNameController);

    ClinicNameController.$inject = ['$scope', '$state', 'ClinicName', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ClinicNameController ($scope, $state, ClinicName, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ClinicName.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clinicNames = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CityDialogController', CityDialogController);

    CityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'City', 'Prefecture'];

    function CityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, City, Prefecture) {
        var vm = this;
        vm.city = entity;
        vm.prefectures = Prefecture.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:cityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.city.id !== null) {
                City.update(vm.city, onSaveSuccess, onSaveError);
            } else {
                City.save(vm.city, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CityDetailController', CityDetailController);

    CityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'City', 'Prefecture'];

    function CityDetailController($scope, $rootScope, $stateParams, entity, City, Prefecture) {
        var vm = this;
        vm.city = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:cityUpdate', function(event, result) {
            vm.city = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CityDeleteController',CityDeleteController);

    CityDeleteController.$inject = ['$uibModalInstance', 'entity', 'City'];

    function CityDeleteController($uibModalInstance, entity, City) {
        var vm = this;
        vm.city = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            City.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('city', {
            parent: 'entity',
            url: '/city?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.city.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/cities.html',
                    controller: 'CityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('city-detail', {
            parent: 'entity',
            url: '/city/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.city.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/city-detail.html',
                    controller: 'CityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'City', function($stateParams, City) {
                    return City.get({id : $stateParams.id});
                }]
            }
        })
        .state('city.new', {
            parent: 'city',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: true });
                }, function() {
                    $state.go('city');
                });
            }]
        })
        .state('city.edit', {
            parent: 'city',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.delete', {
            parent: 'city',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-delete-dialog.html',
                    controller: 'CityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('City', City);

    City.$inject = ['$resource'];

    function City ($resource) {
        var resourceUrl =  'api/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CitySearch', CitySearch);

    CitySearch.$inject = ['$resource'];

    function CitySearch($resource) {
        var resourceUrl =  'api/_search/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CityController', CityController);

    CityController.$inject = ['$scope', '$state', 'City', 'CitySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CityController ($scope, $state, City, CitySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CitySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                City.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangesDialogController', ChangesDialogController);

    ChangesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Changes', 'ChangeField', 'ChangeTable', 'Customer', 'Sector', 'CustomerSector', 'WorkingDay', 'Employee'];

    function ChangesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Changes, ChangeField, ChangeTable, Customer, Sector, CustomerSector, WorkingDay, Employee) {
        var vm = this;
        vm.changes = entity;
        vm.changefields = ChangeField.query();
        vm.changetables = ChangeTable.query();
        vm.customers = Customer.query();
        vm.sectors = Sector.query();
        vm.customersectors = CustomerSector.query();
        vm.workingdays = WorkingDay.query();
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:changesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.changes.id !== null) {
                Changes.update(vm.changes, onSaveSuccess, onSaveError);
            } else {
                Changes.save(vm.changes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.issuedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangesDetailController', ChangesDetailController);

    ChangesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Changes', 'ChangeField', 'ChangeTable', 'Customer', 'Sector', 'CustomerSector', 'WorkingDay', 'Employee'];

    function ChangesDetailController($scope, $rootScope, $stateParams, entity, Changes, ChangeField, ChangeTable, Customer, Sector, CustomerSector, WorkingDay, Employee) {
        var vm = this;
        vm.changes = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:changesUpdate', function(event, result) {
            vm.changes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangesDeleteController',ChangesDeleteController);

    ChangesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Changes'];

    function ChangesDeleteController($uibModalInstance, entity, Changes) {
        var vm = this;
        vm.changes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Changes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('changes', {
            parent: 'entity',
            url: '/changes?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/changes/changes.html',
                    controller: 'ChangesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changes');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('changes-detail', {
            parent: 'entity',
            url: '/changes/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/changes/changes-detail.html',
                    controller: 'ChangesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changes');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Changes', function($stateParams, Changes) {
                    return Changes.get({id : $stateParams.id});
                }]
            }
        })
        .state('changes.new', {
            parent: 'changes',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-dialog.html',
                    controller: 'ChangesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                oldValue: null,
                                valueId: null,
                                oldValueId: null,
                                issuedBy: null,
                                issuedDate: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('changes');
                });
            }]
        })
        .state('changes.edit', {
            parent: 'changes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-dialog.html',
                    controller: 'ChangesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Changes', function(Changes) {
                            return Changes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('changes.delete', {
            parent: 'changes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-delete-dialog.html',
                    controller: 'ChangesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Changes', function(Changes) {
                            return Changes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Changes', Changes);

    Changes.$inject = ['$resource', 'DateUtils'];

    function Changes ($resource, DateUtils) {
        var resourceUrl =  'api/changes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ChangesSearch', ChangesSearch);

    ChangesSearch.$inject = ['$resource'];

    function ChangesSearch($resource) {
        var resourceUrl =  'api/_search/changes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangesController', ChangesController);

    ChangesController.$inject = ['$scope', '$state', 'Changes', 'ChangesSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChangesController ($scope, $state, Changes, ChangesSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ChangesSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Changes.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.changes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeTableDialogController', ChangeTableDialogController);

    ChangeTableDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChangeTable'];

    function ChangeTableDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChangeTable) {
        var vm = this;
        vm.changeTable = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:changeTableUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.changeTable.id !== null) {
                ChangeTable.update(vm.changeTable, onSaveSuccess, onSaveError);
            } else {
                ChangeTable.save(vm.changeTable, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeTableDetailController', ChangeTableDetailController);

    ChangeTableDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ChangeTable'];

    function ChangeTableDetailController($scope, $rootScope, $stateParams, entity, ChangeTable) {
        var vm = this;
        vm.changeTable = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:changeTableUpdate', function(event, result) {
            vm.changeTable = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeTableDeleteController',ChangeTableDeleteController);

    ChangeTableDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChangeTable'];

    function ChangeTableDeleteController($uibModalInstance, entity, ChangeTable) {
        var vm = this;
        vm.changeTable = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ChangeTable.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-table', {
            parent: 'entity',
            url: '/change-table?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeTable.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-table/change-tables.html',
                    controller: 'ChangeTableController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeTable');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('change-table-detail', {
            parent: 'entity',
            url: '/change-table/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeTable.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-table/change-table-detail.html',
                    controller: 'ChangeTableDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeTable');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChangeTable', function($stateParams, ChangeTable) {
                    return ChangeTable.get({id : $stateParams.id});
                }]
            }
        })
        .state('change-table.new', {
            parent: 'change-table',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-dialog.html',
                    controller: 'ChangeTableDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameGr: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('change-table');
                });
            }]
        })
        .state('change-table.edit', {
            parent: 'change-table',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-dialog.html',
                    controller: 'ChangeTableDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChangeTable', function(ChangeTable) {
                            return ChangeTable.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('change-table.delete', {
            parent: 'change-table',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-delete-dialog.html',
                    controller: 'ChangeTableDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChangeTable', function(ChangeTable) {
                            return ChangeTable.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ChangeTable', ChangeTable);

    ChangeTable.$inject = ['$resource'];

    function ChangeTable ($resource) {
        var resourceUrl =  'api/change-tables/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ChangeTableSearch', ChangeTableSearch);

    ChangeTableSearch.$inject = ['$resource'];

    function ChangeTableSearch($resource) {
        var resourceUrl =  'api/_search/change-tables/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeTableController', ChangeTableController);

    ChangeTableController.$inject = ['$scope', '$state', 'ChangeTable', 'ChangeTableSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChangeTableController ($scope, $state, ChangeTable, ChangeTableSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ChangeTableSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ChangeTable.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.changeTables = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldDialogController', ChangeFieldDialogController);

    ChangeFieldDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChangeField'];

    function ChangeFieldDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChangeField) {
        var vm = this;
        vm.changeField = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:changeFieldUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.changeField.id !== null) {
                ChangeField.update(vm.changeField, onSaveSuccess, onSaveError);
            } else {
                ChangeField.save(vm.changeField, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldDetailController', ChangeFieldDetailController);

    ChangeFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ChangeField'];

    function ChangeFieldDetailController($scope, $rootScope, $stateParams, entity, ChangeField) {
        var vm = this;
        vm.changeField = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:changeFieldUpdate', function(event, result) {
            vm.changeField = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldDeleteController',ChangeFieldDeleteController);

    ChangeFieldDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChangeField'];

    function ChangeFieldDeleteController($uibModalInstance, entity, ChangeField) {
        var vm = this;
        vm.changeField = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ChangeField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-field', {
            parent: 'entity',
            url: '/change-field?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeField.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-field/change-fields.html',
                    controller: 'ChangeFieldController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeField');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('change-field-detail', {
            parent: 'entity',
            url: '/change-field/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeField.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-field/change-field-detail.html',
                    controller: 'ChangeFieldDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeField');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChangeField', function($stateParams, ChangeField) {
                    return ChangeField.get({id : $stateParams.id});
                }]
            }
        })
        .state('change-field.new', {
            parent: 'change-field',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-dialog.html',
                    controller: 'ChangeFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameGr: null,
                                isRelationship: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('change-field');
                });
            }]
        })
        .state('change-field.edit', {
            parent: 'change-field',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-dialog.html',
                    controller: 'ChangeFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChangeField', function(ChangeField) {
                            return ChangeField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('change-field.delete', {
            parent: 'change-field',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-delete-dialog.html',
                    controller: 'ChangeFieldDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChangeField', function(ChangeField) {
                            return ChangeField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ChangeField', ChangeField);

    ChangeField.$inject = ['$resource'];

    function ChangeField ($resource) {
        var resourceUrl =  'api/change-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ChangeFieldSearch', ChangeFieldSearch);

    ChangeFieldSearch.$inject = ['$resource'];

    function ChangeFieldSearch($resource) {
        var resourceUrl =  'api/_search/change-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldController', ChangeFieldController);

    ChangeFieldController.$inject = ['$scope', '$state', 'ChangeField', 'ChangeFieldSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChangeFieldController ($scope, $state, ChangeField, ChangeFieldSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ChangeFieldSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ChangeField.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.changeFields = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CallTypeDialogController', CallTypeDialogController);

    CallTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CallType'];

    function CallTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CallType) {
        var vm = this;
        vm.callType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:callTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.callType.id !== null) {
                CallType.update(vm.callType, onSaveSuccess, onSaveError);
            } else {
                CallType.save(vm.callType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CallTypeDetailController', CallTypeDetailController);

    CallTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CallType'];

    function CallTypeDetailController($scope, $rootScope, $stateParams, entity, CallType) {
        var vm = this;
        vm.callType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:callTypeUpdate', function(event, result) {
            vm.callType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CallTypeDeleteController',CallTypeDeleteController);

    CallTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CallType'];

    function CallTypeDeleteController($uibModalInstance, entity, CallType) {
        var vm = this;
        vm.callType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CallType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('call-type', {
            parent: 'entity',
            url: '/call-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.callType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/call-type/call-types.html',
                    controller: 'CallTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('callType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('call-type-detail', {
            parent: 'entity',
            url: '/call-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.callType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/call-type/call-type-detail.html',
                    controller: 'CallTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('callType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CallType', function($stateParams, CallType) {
                    return CallType.get({id : $stateParams.id});
                }]
            }
        })
        .state('call-type.new', {
            parent: 'call-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-dialog.html',
                    controller: 'CallTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('call-type');
                });
            }]
        })
        .state('call-type.edit', {
            parent: 'call-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-dialog.html',
                    controller: 'CallTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CallType', function(CallType) {
                            return CallType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('call-type.delete', {
            parent: 'call-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-delete-dialog.html',
                    controller: 'CallTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CallType', function(CallType) {
                            return CallType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CallType', CallType);

    CallType.$inject = ['$resource'];

    function CallType ($resource) {
        var resourceUrl =  'api/call-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CallTypeController', CallTypeController);

    CallTypeController.$inject = ['$scope', '$state', 'CallType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CallTypeController ($scope, $state, CallType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CallType.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.callTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDialogController', BrickOsfeDialogController);

    BrickOsfeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BrickOsfe'];

    function BrickOsfeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:brickOsfeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.brickOsfe.id !== null) {
                BrickOsfe.update(vm.brickOsfe, onSaveSuccess, onSaveError);
            } else {
                BrickOsfe.save(vm.brickOsfe, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDetailController', BrickOsfeDetailController);

    BrickOsfeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BrickOsfe'];

    function BrickOsfeDetailController($scope, $rootScope, $stateParams, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:brickOsfeUpdate', function(event, result) {
            vm.brickOsfe = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDeleteController',BrickOsfeDeleteController);

    BrickOsfeDeleteController.$inject = ['$uibModalInstance', 'entity', 'BrickOsfe'];

    function BrickOsfeDeleteController($uibModalInstance, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            BrickOsfe.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brick-osfe', {
            parent: 'entity',
            url: '/brick-osfe?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brickOsfe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick-osfe/brick-osfes.html',
                    controller: 'BrickOsfeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brickOsfe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brick-osfe-detail', {
            parent: 'entity',
            url: '/brick-osfe/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brickOsfe.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-detail.html',
                    controller: 'BrickOsfeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brickOsfe');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrickOsfe', function($stateParams, BrickOsfe) {
                    return BrickOsfe.get({id : $stateParams.id});
                }]
            }
        })
        .state('brick-osfe.new', {
            parent: 'brick-osfe',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-dialog.html',
                    controller: 'BrickOsfeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaName: null,
                                territoryName: null,
                                codeGroup: null,
                                code: null,
                                postalCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('brick-osfe');
                });
            }]
        })
        .state('brick-osfe.edit', {
            parent: 'brick-osfe',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-dialog.html',
                    controller: 'BrickOsfeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrickOsfe', function(BrickOsfe) {
                            return BrickOsfe.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brick-osfe.delete', {
            parent: 'brick-osfe',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-delete-dialog.html',
                    controller: 'BrickOsfeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrickOsfe', function(BrickOsfe) {
                            return BrickOsfe.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('BrickOsfe', BrickOsfe);

    BrickOsfe.$inject = ['$resource'];

    function BrickOsfe ($resource) {
        var resourceUrl =  'api/brick-osfes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeController', BrickOsfeController);

    BrickOsfeController.$inject = ['$scope', '$state', 'BrickOsfe', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BrickOsfeController ($scope, $state, BrickOsfe, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            BrickOsfe.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.brickOsfes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickDialogController', BrickDialogController);

    BrickDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Brick'];

    function BrickDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Brick) {
        var vm = this;
        vm.brick = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:brickUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.brick.id !== null) {
                Brick.update(vm.brick, onSaveSuccess, onSaveError);
            } else {
                Brick.save(vm.brick, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickDetailController', BrickDetailController);

    BrickDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Brick'];

    function BrickDetailController($scope, $rootScope, $stateParams, entity, Brick) {
        var vm = this;
        vm.brick = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:brickUpdate', function(event, result) {
            vm.brick = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickDeleteController',BrickDeleteController);

    BrickDeleteController.$inject = ['$uibModalInstance', 'entity', 'Brick'];

    function BrickDeleteController($uibModalInstance, entity, Brick) {
        var vm = this;
        vm.brick = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Brick.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brick', {
            parent: 'entity',
            url: '/brick?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brick.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick/bricks.html',
                    controller: 'BrickController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brick');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brick-detail', {
            parent: 'entity',
            url: '/brick/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brick.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick/brick-detail.html',
                    controller: 'BrickDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brick');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Brick', function($stateParams, Brick) {
                    return Brick.get({id : $stateParams.id});
                }]
            }
        })
        .state('brick.new', {
            parent: 'brick',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-dialog.html',
                    controller: 'BrickDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaNo: null,
                                areaName: null,
                                territoryNo: null,
                                territoryName: null,
                                postalCode: null,
                                municipality: null,
                                microCode: null,
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('brick');
                });
            }]
        })
        .state('brick.edit', {
            parent: 'brick',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-dialog.html',
                    controller: 'BrickDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Brick', function(Brick) {
                            return Brick.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brick.delete', {
            parent: 'brick',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick/brick-delete-dialog.html',
                    controller: 'BrickDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Brick', function(Brick) {
                            return Brick.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Brick', Brick);

    Brick.$inject = ['$resource'];

    function Brick ($resource) {
        var resourceUrl =  'api/bricks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickController', BrickController);

    BrickController.$inject = ['$scope', '$state', 'Brick', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BrickController ($scope, $state, Brick, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Brick.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bricks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AttendantDialogController', AttendantDialogController);

    AttendantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Attendant', 'Profession', 'RelationshipType', 'CountryPhoneCode'];

    function AttendantDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Attendant, Profession, RelationshipType, CountryPhoneCode) {
        var vm = this;
        vm.attendant = entity;
        vm.professions = Profession.query();
        vm.relationshiptypes = RelationshipType.query();
        vm.countryphonecodes = CountryPhoneCode.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:attendantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.attendant.id !== null) {
                Attendant.update(vm.attendant, onSaveSuccess, onSaveError);
            } else {
                Attendant.save(vm.attendant, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AttendantDetailController', AttendantDetailController);

    AttendantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Attendant', 'Profession', 'RelationshipType', 'CountryPhoneCode'];

    function AttendantDetailController($scope, $rootScope, $stateParams, entity, Attendant, Profession, RelationshipType, CountryPhoneCode) {
        var vm = this;
        vm.attendant = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:attendantUpdate', function(event, result) {
            vm.attendant = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AttendantDeleteController',AttendantDeleteController);

    AttendantDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attendant'];

    function AttendantDeleteController($uibModalInstance, entity, Attendant) {
        var vm = this;
        vm.attendant = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Attendant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('attendant', {
            parent: 'entity',
            url: '/attendant?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.attendant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attendant/attendants.html',
                    controller: 'AttendantController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attendant');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('attendant-detail', {
            parent: 'entity',
            url: '/attendant/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.attendant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attendant/attendant-detail.html',
                    controller: 'AttendantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attendant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Attendant', function($stateParams, Attendant) {
                    return Attendant.get({id : $stateParams.id});
                }]
            }
        })
        .state('attendant.new', {
            parent: 'attendant',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-dialog.html',
                    controller: 'AttendantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                phone: null,
                                email: null,
                                isWrongPhone: null,
                                isWrongContact: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('attendant');
                });
            }]
        })
        .state('attendant.edit', {
            parent: 'attendant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-dialog.html',
                    controller: 'AttendantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Attendant', function(Attendant) {
                            return Attendant.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('attendant.delete', {
            parent: 'attendant',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-delete-dialog.html',
                    controller: 'AttendantDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Attendant', function(Attendant) {
                            return Attendant.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Attendant', Attendant);

    Attendant.$inject = ['$resource'];

    function Attendant ($resource) {
        var resourceUrl =  'api/attendants/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AttendantController', AttendantController);

    AttendantController.$inject = ['$scope', '$state', 'Attendant', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AttendantController ($scope, $state, Attendant, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Attendant.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attendants = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParameterDialogController', ApplicationParameterDialogController);

    ApplicationParameterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationParameter'];

    function ApplicationParameterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationParameter) {
        var vm = this;
        vm.applicationParameter = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:applicationParameterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.applicationParameter.id !== null) {
                ApplicationParameter.update(vm.applicationParameter, onSaveSuccess, onSaveError);
            } else {
                ApplicationParameter.save(vm.applicationParameter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParameterDetailController', ApplicationParameterDetailController);

    ApplicationParameterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationParameter'];

    function ApplicationParameterDetailController($scope, $rootScope, $stateParams, entity, ApplicationParameter) {
        var vm = this;
        vm.applicationParameter = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:applicationParameterUpdate', function(event, result) {
            vm.applicationParameter = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParameterDeleteController',ApplicationParameterDeleteController);

    ApplicationParameterDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationParameter'];

    function ApplicationParameterDeleteController($uibModalInstance, entity, ApplicationParameter) {
        var vm = this;
        vm.applicationParameter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ApplicationParameter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-parameter', {
            parent: 'entity',
            url: '/application-parameter?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.applicationParameter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-parameter/application-parameters.html',
                    controller: 'ApplicationParameterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationParameter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-parameter-detail', {
            parent: 'entity',
            url: '/application-parameter/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.applicationParameter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-parameter/application-parameter-detail.html',
                    controller: 'ApplicationParameterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationParameter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationParameter', function($stateParams, ApplicationParameter) {
                    return ApplicationParameter.get({id : $stateParams.id});
                }]
            }
        })
        .state('application-parameter.new', {
            parent: 'application-parameter',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-dialog.html',
                    controller: 'ApplicationParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('application-parameter');
                });
            }]
        })
        .state('application-parameter.edit', {
            parent: 'application-parameter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-dialog.html',
                    controller: 'ApplicationParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationParameter', function(ApplicationParameter) {
                            return ApplicationParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-parameter.delete', {
            parent: 'application-parameter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-parameter/application-parameter-delete-dialog.html',
                    controller: 'ApplicationParameterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationParameter', function(ApplicationParameter) {
                            return ApplicationParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ApplicationParameter', ApplicationParameter);

    ApplicationParameter.$inject = ['$resource'];

    function ApplicationParameter ($resource) {
        var resourceUrl =  'api/application-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ApplicationParameterSearch', ApplicationParameterSearch);

    ApplicationParameterSearch.$inject = ['$resource'];

    function ApplicationParameterSearch($resource) {
        var resourceUrl =  'api/_search/application-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParameterController', ApplicationParameterController);

    ApplicationParameterController.$inject = ['$scope', '$state', 'ApplicationParameter', 'ApplicationParameterSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ApplicationParameterController ($scope, $state, ApplicationParameter, ApplicationParameterSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ApplicationParameterSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ApplicationParameter.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.applicationParameters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationDialogController', AgreementValuationDialogController);

    AgreementValuationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgreementValuation'];

    function AgreementValuationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AgreementValuation) {
        var vm = this;
        vm.agreementValuation = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:agreementValuationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.agreementValuation.id !== null) {
                AgreementValuation.update(vm.agreementValuation, onSaveSuccess, onSaveError);
            } else {
                AgreementValuation.save(vm.agreementValuation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationDetailController', AgreementValuationDetailController);

    AgreementValuationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgreementValuation'];

    function AgreementValuationDetailController($scope, $rootScope, $stateParams, entity, AgreementValuation) {
        var vm = this;
        vm.agreementValuation = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:agreementValuationUpdate', function(event, result) {
            vm.agreementValuation = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationDeleteController',AgreementValuationDeleteController);

    AgreementValuationDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgreementValuation'];

    function AgreementValuationDeleteController($uibModalInstance, entity, AgreementValuation) {
        var vm = this;
        vm.agreementValuation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AgreementValuation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agreement-valuation', {
            parent: 'entity',
            url: '/agreement-valuation?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreementValuation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuations.html',
                    controller: 'AgreementValuationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreementValuation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agreement-valuation-detail', {
            parent: 'entity',
            url: '/agreement-valuation/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreementValuation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-detail.html',
                    controller: 'AgreementValuationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreementValuation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AgreementValuation', function($stateParams, AgreementValuation) {
                    return AgreementValuation.get({id : $stateParams.id});
                }]
            }
        })
        .state('agreement-valuation.new', {
            parent: 'agreement-valuation',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-dialog.html',
                    controller: 'AgreementValuationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('agreement-valuation');
                });
            }]
        })
        .state('agreement-valuation.edit', {
            parent: 'agreement-valuation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-dialog.html',
                    controller: 'AgreementValuationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AgreementValuation', function(AgreementValuation) {
                            return AgreementValuation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agreement-valuation.delete', {
            parent: 'agreement-valuation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-delete-dialog.html',
                    controller: 'AgreementValuationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AgreementValuation', function(AgreementValuation) {
                            return AgreementValuation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AgreementValuation', AgreementValuation);

    AgreementValuation.$inject = ['$resource'];

    function AgreementValuation ($resource) {
        var resourceUrl =  'api/agreement-valuations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('AgreementValuationSearch', AgreementValuationSearch);

    AgreementValuationSearch.$inject = ['$resource'];

    function AgreementValuationSearch($resource) {
        var resourceUrl =  'api/_search/agreement-valuations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationController', AgreementValuationController);

    AgreementValuationController.$inject = ['$scope', '$state', 'AgreementValuation', 'AgreementValuationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgreementValuationController ($scope, $state, AgreementValuation, AgreementValuationSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AgreementValuationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgreementValuation.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agreementValuations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementDialogController', AgreementDialogController);

    AgreementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Agreement', 'Event', 'AgreementValuation', 'Product'];

    function AgreementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Agreement, Event, AgreementValuation, Product) {
        var vm = this;
        vm.agreement = entity;
        vm.events = Event.query();
        vm.agreementvaluations = AgreementValuation.query();
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:agreementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.agreement.id !== null) {
                Agreement.update(vm.agreement, onSaveSuccess, onSaveError);
            } else {
                Agreement.save(vm.agreement, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementDetailController', AgreementDetailController);

    AgreementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Agreement', 'Event', 'AgreementValuation', 'Product'];

    function AgreementDetailController($scope, $rootScope, $stateParams, entity, Agreement, Event, AgreementValuation, Product) {
        var vm = this;
        vm.agreement = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:agreementUpdate', function(event, result) {
            vm.agreement = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementDeleteController',AgreementDeleteController);

    AgreementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Agreement'];

    function AgreementDeleteController($uibModalInstance, entity, Agreement) {
        var vm = this;
        vm.agreement = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Agreement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agreement', {
            parent: 'entity',
            url: '/agreement?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement/agreements.html',
                    controller: 'AgreementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agreement-detail', {
            parent: 'entity',
            url: '/agreement/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement/agreement-detail.html',
                    controller: 'AgreementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agreement', function($stateParams, Agreement) {
                    return Agreement.get({id : $stateParams.id});
                }]
            }
        })
        .state('agreement.new', {
            parent: 'agreement',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-dialog.html',
                    controller: 'AgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                promisedQuantity: null,
                                agreedPrice: null,
                                description: null,
                                priority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('agreement');
                });
            }]
        })
        .state('agreement.edit', {
            parent: 'agreement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-dialog.html',
                    controller: 'AgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agreement', function(Agreement) {
                            return Agreement.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agreement.delete', {
            parent: 'agreement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-delete-dialog.html',
                    controller: 'AgreementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agreement', function(Agreement) {
                            return Agreement.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Agreement', Agreement);

    Agreement.$inject = ['$resource'];

    function Agreement ($resource) {
        var resourceUrl =  'api/agreements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('AgreementSearch', AgreementSearch);

    AgreementSearch.$inject = ['$resource'];

    function AgreementSearch($resource) {
        var resourceUrl =  'api/_search/agreements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementController', AgreementController);

    AgreementController.$inject = ['$scope', '$state', 'Agreement', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgreementController ($scope, $state, Agreement, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Agreement.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agreements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseDialogController', AddDiseaseDialogController);

    AddDiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AddDisease'];

    function AddDiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AddDisease) {
        var vm = this;
        vm.addDisease = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:addDiseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.addDisease.id !== null) {
                AddDisease.update(vm.addDisease, onSaveSuccess, onSaveError);
            } else {
                AddDisease.save(vm.addDisease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseDetailController', AddDiseaseDetailController);

    AddDiseaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AddDisease'];

    function AddDiseaseDetailController($scope, $rootScope, $stateParams, entity, AddDisease) {
        var vm = this;
        vm.addDisease = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:addDiseaseUpdate', function(event, result) {
            vm.addDisease = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseDeleteController',AddDiseaseDeleteController);

    AddDiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'AddDisease'];

    function AddDiseaseDeleteController($uibModalInstance, entity, AddDisease) {
        var vm = this;
        vm.addDisease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AddDisease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('add-disease', {
            parent: 'entity',
            url: '/add-disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addDisease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-disease/add-diseases.html',
                    controller: 'AddDiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addDisease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('add-disease-detail', {
            parent: 'entity',
            url: '/add-disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addDisease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-disease/add-disease-detail.html',
                    controller: 'AddDiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addDisease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AddDisease', function($stateParams, AddDisease) {
                    return AddDisease.get({id : $stateParams.id});
                }]
            }
        })
        .state('add-disease.new', {
            parent: 'add-disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-dialog.html',
                    controller: 'AddDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                information: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('add-disease');
                });
            }]
        })
        .state('add-disease.edit', {
            parent: 'add-disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-dialog.html',
                    controller: 'AddDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AddDisease', function(AddDisease) {
                            return AddDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('add-disease.delete', {
            parent: 'add-disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-delete-dialog.html',
                    controller: 'AddDiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AddDisease', function(AddDisease) {
                            return AddDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AddDisease', AddDisease);

    AddDisease.$inject = ['$resource'];

    function AddDisease ($resource) {
        var resourceUrl =  'api/add-diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseController', AddDiseaseController);

    AddDiseaseController.$inject = ['$scope', '$state', 'AddDisease', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AddDiseaseController ($scope, $state, AddDisease, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            AddDisease.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.addDiseases = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionDialogController', AddConditionDialogController);

    AddConditionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AddCondition'];

    function AddConditionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AddCondition) {
        var vm = this;
        vm.addCondition = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:addConditionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.addCondition.id !== null) {
                AddCondition.update(vm.addCondition, onSaveSuccess, onSaveError);
            } else {
                AddCondition.save(vm.addCondition, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionDetailController', AddConditionDetailController);

    AddConditionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AddCondition'];

    function AddConditionDetailController($scope, $rootScope, $stateParams, entity, AddCondition) {
        var vm = this;
        vm.addCondition = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:addConditionUpdate', function(event, result) {
            vm.addCondition = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionDeleteController',AddConditionDeleteController);

    AddConditionDeleteController.$inject = ['$uibModalInstance', 'entity', 'AddCondition'];

    function AddConditionDeleteController($uibModalInstance, entity, AddCondition) {
        var vm = this;
        vm.addCondition = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AddCondition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('add-condition', {
            parent: 'entity',
            url: '/add-condition?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addCondition.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-condition/add-conditions.html',
                    controller: 'AddConditionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addCondition');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('add-condition-detail', {
            parent: 'entity',
            url: '/add-condition/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addCondition.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-condition/add-condition-detail.html',
                    controller: 'AddConditionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addCondition');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AddCondition', function($stateParams, AddCondition) {
                    return AddCondition.get({id : $stateParams.id});
                }]
            }
        })
        .state('add-condition.new', {
            parent: 'add-condition',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-dialog.html',
                    controller: 'AddConditionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                information: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('add-condition');
                });
            }]
        })
        .state('add-condition.edit', {
            parent: 'add-condition',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-dialog.html',
                    controller: 'AddConditionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AddCondition', function(AddCondition) {
                            return AddCondition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('add-condition.delete', {
            parent: 'add-condition',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-condition/add-condition-delete-dialog.html',
                    controller: 'AddConditionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AddCondition', function(AddCondition) {
                            return AddCondition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-condition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AddCondition', AddCondition);

    AddCondition.$inject = ['$resource'];

    function AddCondition ($resource) {
        var resourceUrl =  'api/add-conditions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionController', AddConditionController);

    AddConditionController.$inject = ['$scope', '$state', 'AddCondition', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AddConditionController ($scope, $state, AddCondition, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            AddCondition.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.addConditions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
/**
 * Created by Maria on 27/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorViewController', SectorViewController);

    SectorViewController.$inject = [ 'entity', '$state' ];

    function SectorViewController ( entity, $state ) {
        var vm = this;

        vm.$state = $state;
        vm.profilePicture = "hospital_icon.png";
        vm.sector = entity;

        vm.goBack = function () {
            window.history.back();
        };
    }
})();
;
/**
 * Created by Maria on 26/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectors', {
                parent: 'app',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/sectors/sectors.html',
                        controller: 'SectorsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('sectorView', {
                parent: 'app',
                url: '/sectors/search?id:sectorId',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']
                   //pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/sectors/sectorView.html',
                        controller: 'SectorViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                        return Sector.get({id : $stateParams.id});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Maria on 26/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorsController', SectorsController);

    SectorsController.$inject = ['$http', '$state', '$timeout', 'KendoGrid', 'KendoService', 'KendoFilter', 'CustomUtils'];

    function SectorsController ($http, $state, $timeout, KendoGrid, KendoService, KendoFilter, CustomUtils) {
        var vm = this;
        vm.pageHeading = 'Μοναδες Υγειας';
        vm.selectedEmployees = [];
        var comboBoxes = ["#masterFilter","#prefectures", "#cities", "#parentSector"];
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddSectorClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.employeesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.activated", "operator": "eqbool",
                                "value": true }
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        };
                    });
                    return data;
                }
            }
        });

        vm.employeesMultiOptions = KendoService.initDefaultOptions( vm.employeesMultiDataSource, "startswith", "employee.account.fullName", "id");
        vm.employeesMultiOptions.placeholder = "Επιλογή ιατρικού επισκέπτη";
        vm.employeesMultiOptions.change = function (e) {
            angular.element("#mainGrid").data("kendoGrid").dataSource.read();
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };

        vm.dataSource = {};
        vm.dataSource.doctorSpecialty = KendoService.initDefaultDataSource('/api/masterdata/doctor-specialties');
        vm.dataSource.sectorTypes =  new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters.push({ "field": "sectorTypeCategory", "operator": "startswith", "value": 'hcu'});

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get( '/api/masterdata/sector-types',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.sectorTypeComboBoxOptions = {
            dataSource: vm.dataSource.sectorTypes,
            filterable: true,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            suggest: true,
            change: function() {
                var obj = this.dataItem();
                //$timeout to trigger the change
                $timeout(function(){
                    vm.isPrivate = obj.isPrivate;
                    if(vm.isPrivate) {
                        vm.specialtyComboBox.value('');
                        vm.sectorsComboBox.text('');
                        vm.sectorsComboBox.value('');
                    }
                });
            }
        };

        vm.specialtyComboBoxOptions = {
            dataSource: vm.dataSource.doctorSpecialty,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.sectorsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            //isPrivate eqbool false
                            { "field": "iseditable", "operator": "eqbool",
                                "value": false }
                        ]
                    );

                    if(vm.sectorId) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "id", "operator": "noteq",
                                    "value": vm.sectorId }
                            ]
                        )
                    }

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get('/api/me/sectors',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        vm.sectorsAllComboBoxOptions = {
            dataSource: vm.sectorsDataSource,
            filter: "like",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        $http.get('/api/employees/me')
            .success(function (response) {
                vm.geodata = response.geodata;

                if(!vm.geodata) {
                    var prefecturesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100000;
                                $http.get('/api/masterdata/prefectures',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        }
                    });

                    //DropDown Options
                    vm.prefecturesComboBoxOptions = {
                        dataSource: prefecturesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        change: function(){
                            var filter = {};
                            var parentFilter = {};
                            if(this.value() && !isNaN(this.value())) {
                                filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": this.value()
                                };
                                parentFilter = {
                                    "field": "prefectureName",
                                    "operator": "eq",
                                    "value": this.text()
                                };
                            }
                            vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                            vm.refreshCombobox(parentFilter, vm.sectorsAllComboBoxOptions.dataSource);
                        }
                    };

                    var citiesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 50;
                                $http.get('/api/masterdata/cities',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        }
                    });

                    //DropDown Options
                    vm.citiesComboBoxOptions = {
                        dataSource: citiesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        template: "<table>${name} &nbsp;" +
                        "<span class='hint'>(${prefecture.name})</span></table>",
                        change: function(e){
                            var filter = {};
                            if(this.dataItem(this.select())) {
                                filter = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : this.dataItem(this.select()).prefecture.id
                                };
                            }
                            vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);

                        }
                    };
                }
                else {
                    var geodataDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100;
                                $http.get('/api/masterdata/geodata',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        },
                        schema: {
                            parse: function(data) {
                                angular.forEach(data, function(item) {
                                    item.masterFilter = "";
                                    if(item.street !==null) {
                                        item.masterFilter =  item.street + ", ";
                                    }
                                    item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                                });
                                return data;
                            }
                        }
                    });

                    vm.masterFilterComboBoxOptions = {
                        dataSource: geodataDataSource,
                        filter: "search",
                        dataTextField: "masterFilter",
                        dataValueField: "id",
                        headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                        "<span>Διεύθυνση</span>"+
                        "<span>Πόλη</span>"+
                        "<span>Τ.Κ.</span>"+
                        "<span>Νομός</span></div>",
                        template:
                            "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                        placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                        change: function(){
                            //initialize inputs (autocomplete)
                            if(this.dataItem(this.select())) {
                                var self = this;
                                //using $timeout to trigger the change
                                $timeout(function(){
                                    vm.saveNewSector.prefectureName = self.dataItem(self.select()).prefecture;
                                    vm.saveNewSector.cityName = self.dataItem(self.select()).city;
                                    vm.saveNewSector.address = self.dataItem(self.select()).street;
                                    vm.saveNewSector.postalCode = self.dataItem(self.select()).postalCode;
                                    vm.suggestBricks(vm.saveNewSector.postalCode);

                                    var parentFilter = {};
                                    if (vm.saveNewSector.prefectureName) {
                                        parentFilter = {
                                            "field": "prefectureName",
                                            "operator": "eq",
                                            "value": vm.saveNewSector.prefectureName
                                        };
                                    }
                                    vm.refreshCombobox(parentFilter, vm.sectorsAllComboBoxOptions.dataSource);
                                },0);
                            }
                        }
                    };
                }

                vm.mainGridOptions = {
                    dataSource: new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                if(vm.selectedEmployees.length) {
                                    o.data.filter.filters = o.data.filter.filters.concat(
                                        [
                                            { "field": "customerSectors.employeeCustomerSectors.employee.id", "operator": "inAll",
                                                "value": vm.selectedEmployees.toString() }
                                        ]
                                    );
                                }

                                if(o.data.filter != undefined && o.data.filter.filters != undefined){
                                    angular.forEach(o.data.filter.filters, function(item) {
                                        if (item.field === "sectorParent.name"){
                                            item.field = "parent.name"
                                        }
                                    });
                                }

                                if(o.data.sort != undefined){
                                    angular.forEach(o.data.sort, function(item) {
                                        if (item.field === "sectorParent.name"){
                                            item.field = "parent.name"
                                        }
                                    });
                                }

                                $http.get('/api/me/sectors',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {});
                            },
                            create: function(o) {
                                vm.newSector = o.data.models[0];

                                if(!vm.newSector.city != null && (vm.newSector.city.id === null || isNaN(vm.newSector.city.id))){
                                    vm.newSector.city = null;
                                }

                                if(vm.newSector.prefecture != null && (vm.newSector.prefecture.id === null || isNaN(vm.newSector.prefecture.id))){
                                    vm.newSector.prefecture = null;
                                }

                                if(vm.newSector.sectorType != null && vm.newSector.sectorType.id === null){
                                    vm.newSector.sectorType = null;
                                }

                                if(vm.newSector.doctorSpecialty != null){
                                    if(vm.newSector.doctorSpecialty.id === null || vm.newSector.sectorType.isPrivate) {
                                        vm.newSector.doctorSpecialty = null;
                                    }
                                }

                                if(vm.newSector.parent != null){
                                    if(vm.newSector.parent.id === null || vm.newSector.sectorType.isPrivate) {
                                        vm.newSector.parent = null;
                                    }
                                }

                                angular.extend(vm.newSector, vm.saveNewSector);
                                delete vm.newSector.id;

                                vm.newSector.brick = vm.brick;
                                vm.newSector.osfeBrick = vm.osfeBrick;

                                $http.post('api/sectors',vm.newSector)
                                    .success(function (response) {
                                        o.success(response);
                                        angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                                    })
                                    .error(function (response) {});
                            },
                            update: function(o) {

                                vm.updateSector = o.data.models[0];
                                angular.extend(vm.saveNewSector, vm.updateSector);

                                if(vm.updateSector.city != null) {
                                    if((vm.updateSector.city.id === null
                                        || vm.updateSector.city.id === undefined || isNaN(vm.updateSector.city.id)) || vm.geodata){
                                        vm.updateSector.city = null;
                                    }
                                }

                                if(vm.updateSector.prefecture != null) {
                                    if((vm.updateSector.prefecture.id === null
                                        || vm.updateSector.prefecture.id === undefined || isNaN(vm.updateSector.prefecture.id)) || vm.geodata){
                                        vm.updateSector.prefecture = null;
                                    }
                                }

                                if(vm.updateSector.sectorType != null) {
                                    if(vm.updateSector.sectorType.id === null || vm.updateSector.sectorType.id === undefined){
                                        vm.updateSector.sectorType = null;
                                    }
                                }

                                if(vm.updateSector.doctorSpecialty != null){
                                    if(vm.updateSector.doctorSpecialty.id === null || vm.updateSector.doctorSpecialty.id === undefined || vm.updateSector.sectorType.isPrivate) {
                                        vm.updateSector.doctorSpecialty = null;
                                    }
                                }

                                if(vm.updateSector.parent != null){
                                    if(vm.updateSector.parent.id === null || vm.updateSector.parent.id === undefined || vm.updateSector.sectorType.isPrivate) {
                                        vm.updateSector.parent = null;
                                    }
                                }

                                vm.updateSector.brick = vm.brick;
                                vm.updateSector.osfeBrick = vm.osfeBrick;

                                $http.put('api/sectors',vm.updateSector)
                                    .success(function (response) {
                                        vm.mainGridOptions.dataSource.read();
                                    })
                                    .error(function (response) {});
                            }
                        },
                        schema: {
                            data: function (data) {
                                if(data.content != undefined) {
                                    data.content.forEach(function(item){
                                        if(item.name === null){
                                            item.name = "";
                                        }

                                        if(item.sectorType === null){
                                            item.sectorType = {};
                                            item.sectorType.name = "";
                                        }

                                        if(item.doctorSpecialty === null){
                                            item.doctorSpecialty = {};
                                            item.doctorSpecialty.name = "";
                                        }

                                        if(item.parent === null){
                                            item.parent = {};
                                            item.parent.name = "";
                                        }

                                    });
                                }

                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: false },
                                    sectorType : {defaultValue : { id : null, name : null}},
                                    prefecture: { defaultValue: { id : null, name : null} },
                                    city : {defaultValue : {id : null, name : null}},
                                    doctorSpecialty : {defaultValue : { id : null, name : null}},
                                    sectorParent: { from: "parent", defaultValue : { id : null, name : null} }
                                }
                            }
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        pageSize: 100
                    }),
                    sortable: true,
                    pageable: {
                        messages: {
                            display: "{0} - {1} από {2} Μοναδες Υγειας", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                            empty: "Δεν βρέθηκαν Μοναδες Υγειας",
                            page: "Σελίδα",
                            allPages: "Όλα",
                            of: "από {0}", // {0} is total amount of pages.
                            itemsPerPage: "εγγραφές ανά σελίδα",
                            first: "Πήγαινε στη πρώτη σελίδα",
                            previous: "Πήγαινε στη τελευταία σελίδα",
                            next: "Πήγαινε στην επόμενη σελίδα",
                            last: "Πήγαινε στη τελευταία σελίδα",
                            refresh: "Ανανέωση"
                        }
                    },
                    noRecords: {
                        template: "Δεν βρέθηκαν Μοναδες Υγειας"
                    },
                    selectable: true,
                    resizable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {field: "name", title: "Όνομα Μονάδας Υγείας",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "sectorType.name", title: "Τύπος Μονάδας Υγείας",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "doctorSpecialty.name", title: "Ειδικότητες στη ΜΣ",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "addressNum", title: "Αριθμός",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "postalCode", title: "Τ.Κ.",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "prefectureName", title: "Νομός",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "brick", title: "Brick",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "osfeBrick", title: "Brick ΟΣΦΕ",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "phone", title: "Τηλέφωνο",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "sectorParent.name", title: "Ανήκει στη ΜΣ",
                            filterable: {
                                cell: {
                                    field : "parent.name",
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {command:[{name:"edit", text: "Επεξεργασία"}], title: "&nbsp;", width:140}
                    ],
                    editable: {
                        mode: "popup",
                        template: kendo.template(angular.element("#popup_editor").html())
                    },
                    height: vm.contentHeight,
                    edit: function(e) {
                        e.model.dirty = true;
                        vm.selectedSector = e.model;
                        vm.sectorId = null;
                        if (vm.selectedSector.sectorType) {
                            vm.isPrivate = vm.selectedSector.sectorType.isPrivate;
                        }
                        vm.saveNewSector = {};
                        if(e.model.id) {
                            vm.saveNewSector = vm.selectedSector;
                        }
                        if (e.model.sectorParent) vm.sectorParent = e.model.sectorParent;
                        KendoGrid.defaultCustomEditPopup(this._editContainer,1000,990);
                        // angular.element("div.k-edit-form-container").width(1000);

                        //refresh kendoComboBox
                        if(e.model.isNew()) {
                            angular.forEach(comboBoxes, function (item) {
                                var comboBox = angular.element(item).data("kendoComboBox");
                                if (comboBox) {
                                    vm.refreshCombobox({}, comboBox.dataSource);
                                }
                            });
                        }

                        if(!e.model.isNew()) {
                            vm.sectorId = e.model.id;

                            if(e.model.prefecture && !vm.geodata){
                                var filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": e.model.prefecture.id
                                };

                                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                            }

                            if(e.model.city && !vm.geodata){
                                var filterCity = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : e.model.city.prefecture.id
                                };

                                vm.refreshCombobox(filterCity, vm.prefecturesComboBoxOptions.dataSource);
                            }

                            if(e.model.prefectureName){
                                var filterParent = {
                                    "field": "prefectureName",
                                    "operator": "eq",
                                    "value": e.model.prefectureName
                                };

                                vm.refreshCombobox(filterParent, vm.sectorsAllComboBoxOptions.dataSource);
                            }

                            vm.brick = e.model.brick;
                            vm.osfeBrick = e.model.osfeBrick;
                        }

                        vm.initPrefecturesComboBox = true;
                        vm.initCitiesComboBox = true;

                        //if geodata init city and prefecture
                        if(!e.model.city) e.model.city = {};
                        if(!e.model.prefecture) e.model.prefecture = {};

                        var wnd = angular.element(e.container).data("kendoWindow");
                        wnd.center();
                    },
                    save: function() {
                        delete vm.initPrefecturesComboBox;
                        delete vm.initCitiesComboBox;
                    },
                    cancel: function() {
                        delete vm.initPrefecturesComboBox;
                        delete vm.initCitiesComboBox;
                    }
                };
            })
            .error(function (response) {});

        vm.onSelection = function(data) {
            var sectorId = data.id;
            $state.go('sectorInfo', {id: sectorId});
        };

        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};

            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.brick = response.content[0].territoryNo;
                    }
                })
                .error(function (response) {});


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.osfeBrick = response.content[0].territoryName;
                    }
                })
                .error(function (response) {});
        };
    }
})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorInfo', {
                parent: 'sectorView',
                url: '/info',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/sectors/info/info.html',
                controller: 'SectorInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorInfoController', SectorInfoController);

    SectorInfoController.$inject = ['$http', '$state', '$timeout', '$stateParams', 'KendoService', 'NotificationOptions', 'CustomUtils', 'Principal', 'CustomDataUtils'];

    function SectorInfoController ($http, $state, $timeout, $stateParams, KendoService, NotificationOptions, CustomUtils, Principal, CustomDataUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(50);
        vm.$state = $state;
        vm.pageHeading = 'Μονάδα Υγείας';
        vm.selectedSectorId = $stateParams.id;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.editSectorType = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']);

        // DataSources
        vm.dataSource = {};
        vm.dataSource.sectorTypes =  new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters.push({ "field": "sectorTypeCategory", "operator": "startswith", "value": 'hcu'});

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get( '/api/masterdata/sector-types',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.dataSource.companyTypes = KendoService.initDefaultDataSource('/api/masterdata/company-types');
        vm.dataSource.taxOffices = KendoService.initDefaultDataSource('/api/masterdata/tax-offices');
        vm.dataSource.doctorSpecialty = KendoService.initDefaultDataSource('/api/masterdata/doctor-specialties');
        vm.dataSource.sectors = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            //isPrivate eqbool false
                            {
                                "field": "iseditable",
                                "operator": "eqbool",
                                "value": false }
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get('/api/me/sectors',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });
        vm.dataSource.workingHours = new kendo.data.DataSource({
            data: [
                { value: 'morning', text: 'Πρωί'},
                { value: 'afternoon', text: 'Απόγευμα'},
                { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
            ]
        });

        // Drop Down Options
        vm.dropDownOptions = {};
        vm.dropDownOptions.companyType = {
            dataSource: vm.dataSource.companyTypes,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.taxOffice = {
            dataSource: vm.dataSource.taxOffices,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.sector = {
            dataSource: vm.dataSource.sectors,
            filter: "like",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "name"
        };
        vm.dropDownOptions.doctorSpecialty = {
            dataSource: vm.dataSource.doctorSpecialty,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.workingHours = {
            dataSource: vm.dataSource.workingHours,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value"
        };

        vm.dropDownOptions.sectorType = KendoService.initDefaultOptions(vm.dataSource.sectorTypes, "startswith", "name", "id");
        vm.dropDownOptions.sectorType.change = function() {
            var obj = this.dataItem();

            //$timeout to trigger the change
            $timeout(function(){
                vm.isPrivate = obj.isPrivate;
                if(vm.isPrivate) {
                    vm.sector.doctorSpecialty = null;
                    vm.specialtyComboBox.value('');
                    vm.sector.parent = null;
                    vm.sectorsComboBox.text('');
                    vm.sectorsComboBox.value('');
                }
            });
        };

        $http.get('api/sectors/' + vm.selectedSectorId)
            .success(function (response) {
                vm.sector = response;
                if (vm.sector.sectorType) {
                    vm.isPrivate = vm.sector.sectorType.isPrivate;
                }

                $http.get('/api/employees/me')
                    .success(function (response) {
                        vm.geodata = response.geodata;
                        if(!vm.geodata) {
                            var prefecturesDataSource = new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function(o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = { filters: [] };
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 100000;
                                        $http.get('/api/masterdata/prefectures',
                                            {params: o.data})
                                            .success(function (response,status,headers) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                }
                            });

                            //DropDown Options
                            vm.prefecturesComboBoxOptions = {
                                autoBind: false,
                                dataSource: prefecturesDataSource,
                                text: vm.sector.prefectureName,
                                filter: "startswith",
                                valuePrimitive: false,
                                dataTextField: "name",
                                dataValueField: "id",
                                change: function(e){
                                    var filter = {};
                                    if(this.value() && !isNaN(this.value())) {
                                        filter = {
                                            "field": "prefecture.id",
                                            "operator": "eq",
                                            "value": this.value()
                                        };
                                    }
                                    vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                                }
                            };

                            var citiesDataSource = new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function(o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = { filters: [] };
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 50;
                                        $http.get('/api/masterdata/cities',
                                            {params: o.data})
                                            .success(function (response,status,headers) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                }
                            });

                            //DropDown Options
                            vm.citiesComboBoxOptions = {
                                autoBind: false,
                                dataSource: citiesDataSource,
                                text: vm.sector.cityName,
                                filter: "startswith",
                                valuePrimitive: false,
                                dataTextField: "name",
                                dataValueField: "id",
                                template: "<table>${name} &nbsp;" +
                                "<span class='hint'>(${prefecture.name})</span></table>",
                                change: function(e){
                                    var filter = {};
                                    if(this.dataItem(this.select())) {
                                        filter = {
                                            "field"   : "id",
                                            "operator": "eq",
                                            "value"   : this.dataItem(this.select()).prefecture.id
                                        };
                                    }
                                    vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                                }
                            };

                            if(vm.sector.prefecture) {
                                var filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": vm.sector.prefecture.id
                                };
                                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                            }

                        }
                        else {
                            var geodataDataSource = new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function(o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = { filters: [] };
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 100;
                                        $http.get('/api/masterdata/geodata',
                                            {params: o.data})
                                            .success(function (response,status,headers) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                },
                                schema: {
                                    parse: function(data) {
                                        angular.forEach(data, function(item) {
                                            item.masterFilter = "";
                                            if(item.street !==null) {
                                                item.masterFilter =  item.street + ", ";
                                            }
                                            item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                                        });
                                        return data;
                                    }
                                }
                            });

                            vm.masterFilterComboBoxOptions = {
                                dataSource: geodataDataSource,
                                filter: "search",
                                dataTextField: "masterFilter",
                                dataValueField: "id",
                                headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                                "<span>Διεύθυνση</span>"+
                                "<span>Πόλη</span>"+
                                "<span>Τ.Κ.</span>"+
                                "<span>Νομός</span></div>",
                                template:
                                    "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                                placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                                change: function(e){
                                    //initialize inputs (autocomplete)
                                    if(this.dataItem(this.select())) {
                                        var self = this;
                                        //using $timeout to trigger the change
                                        $timeout(function(){
                                            vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                                            vm.sector.cityName = self.dataItem(self.select()).city;
                                            vm.sector.address = self.dataItem(self.select()).street;
                                            vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                                            vm.suggestBricks(vm.sector.postalCode);
                                        },0);
                                    }
                                }
                            };
                        }
                    })
                    .error(function (response) {});
            })
            .error(function (response) {});

        vm.update = function() {

            if(vm.geodata) {
                delete vm.sector.city;
                delete vm.sector.prefecture;
            }

            if (vm.sector.creditControlCheck == true) {
                vm.sector.creditControlCheck = 1;
            } else {
                vm.sector.creditControlCheck = 0;
            }

            if(vm.sector.sectorType !== null){
                if(vm.sector.sectorType.id === null) {
                    vm.sector.sectorType = null;
                }
            }

            vm.sector.parent = (vm.sector.parent && vm.sector.parent.id > 0) ? vm.sector.parent : null;
            //Todo Add Validation
           // if (validator.validate()) {
            $http.put('api/sectors', vm.sector)
                .success(function (response) {
                    // For binding a city that does not exist in initial dataSource of cityComboBox
                    if (!vm.geodata && CustomDataUtils.isNotNil(response.city) && CustomDataUtils.isNotNil(vm.citiesComboBoxOptions) &&
                        CustomDataUtils.isNotNil(vm.citiesComboBoxOptions.dataSource)) {
                        const dataArray = vm.citiesComboBoxOptions.dataSource.data();
                        if (CustomDataUtils.isNotEmpty(dataArray) && dataArray.filter(function (e) { return e.id === response.city.id }).length < 1) {
                            // push sector's city in city dataSource
                            vm.citiesComboBoxOptions.dataSource.pushUpdate(response.city);
                        }
                    }

                    vm.sector = response;

                    notification.show({
                        message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                    }, "success");
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });
           // }else{
           //    angular.element("#errorNotification").kendoNotification().data("kendoNotification").show("Η ενημέρωση των στοιχείων απέτυχε!", "error");
           // }

        };

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};

            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.brick = response.content[0].territoryNo;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.osfeBrick = response.content[0].territoryName;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });
        };
    }
})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorCustomers', {
                parent: 'sectorView',
                url: '/customers',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/sectors/customers/customers.html',
                controller: 'SectorCustomersController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                        return Sector.get({id : $stateParams.id});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCustomersController', SectorCustomersController);

    SectorCustomersController.$inject = ['$http', 'entity', '$stateParams','$filter', 'KendoGrid', 'KendoFilter', 'MasterFiltersService', 'CustomUtils', '$mdToast'];

    function SectorCustomersController ($http, entity, $stateParams, $filter, KendoGrid, KendoFilter, MasterFiltersService, CustomUtils, $mdToast) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        vm.sector = entity;
        vm.customers = vm.sector.customers;

        vm.selectedSectorId = $stateParams.id;
        vm.selectedAssignees = vm.selectedEmployees =[];
        vm.massSelect = true;
        vm.startedAt = kendo.toString(new Date(), "d");

        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.customerSector = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            {"field": "sector.id", "operator": "eq", "value": vm.selectedSectorId}
                        ]
                    );

                    $http.get('/api/me/customer-sectors',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            o.error(response);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Κάποιο σφάλμα προέκυψε')
                                    .position("bottom right")
                                    .hideDelay(3000));
                        });
                },
                create: function (o) {
                    angular.forEach(vm.selectedAssignees, function (item) {
                        if (!item.customerCategory.name) item.customerCategory = null;
                        if (!item.customerSubCategory.name) item.customerSubCategory = null;
                        if (!item.customerTitle.name) item.customerTitle = null;
                        if (!item.doctorSpecialty.name) item.doctorSpecialty = null;
                        if (!item.doctorSpecificSpecialty.name) item.doctorSpecificSpecialty = null;
                    });

                    $http.post(' api/customers/sector/'+ vm.selectedSectorId, vm.selectedAssignees)
                        .success(function () {
                            KendoGrid.refresh(vm.gridOptions.customerSector);
                        })
                        .error(function (response) {});
                }
            },
            batch: true,
            schema: {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (item.customer){
                                if(item.customer.doctorSpecialty === null || item.customer.doctorSpecialty === undefined){
                                    item.customer.doctorSpecialty = { name: "" };
                                }

                                if(item.customer.customerCategory === null || item.customer.customerCategory === undefined){
                                    item.customer.customerCategory = { name: "" };
                                }

                                if(item.customer.dayTime !== null && item.customer.dayTime !== undefined){
                                    if(item.customer.dayTime === "day") {
                                        item.customer.dayTime = "ΠΡΩΙΝΌ";
                                    }else if(item.customer.dayTime === "night"){
                                        item.customer.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                                    }
                                }else {
                                    item.customer.dayTime = ""
                                }

                                if(item.customer.customerSubCategory !== null && item.customer.customerSubCategory !== undefined){
                                    if(item.customer.customerSubCategory === "one") {
                                        item.customer.customerSubCategory = '1';
                                    }else if(item.customer.customerSubCategory === "two"){
                                        item.customer.customerSubCategory = '2';
                                    }
                                }else {
                                    item.customer.customerSubCategory = {}
                                }
                            }else {
                                item.customer = {
                                    firstName: "",
                                    lastName: "",
                                    cellPhone: "",
                                    phone: "",
                                    email: "",
                                    doctorSpecialty: { name: "" },
                                    customerCategory: { name: "" },
                                    customerSubCategory: {},
                                    dayTime: {},
                                    title: "",
                                    isActive: null,
                                    saw: null
                                };
                            }
                        });
                    }
                    return data.content;

                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true},
                        customer: { defaultValue: {
                            doctorSpecialty: { defaultValue: {id: null, name : null} },
                            customerCategory: { defaultValue: {id: null, name : null} },
                                customerSubCategory: { defaultValue: {id: null, name : null}} }
                        },
                        'customer.isActive':{
                            type: "boolean",
                            defaultValue: true,
                            parse: function(value) {
                                if (value == "1" || value == "true" || value == true) {
                                    return true;
                                }
                                return false;
                            }
                        },
                        'customer.saw':{
                            type: "boolean",
                            defaultValue: true,
                            parse: function(value) {
                                return !!(value == "1" || value == "true" || value == true);

                            }
                        },
                        'customer.dayTime':{defaultValue: null}
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20,
            scrollable:false
        });

        vm.dataSource.grid.suggestedCustomers = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    //master filters functionality
                    if(vm.selectedEmployees.length) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "customerSectors.employeeCustomerSectors.employee.id", "operator": "in",
                                    "value": vm.selectedEmployees.toString() }
                            ]
                        );
                    }

                    $http.get('/api/customers/sectors/' + vm.selectedSectorId + '/suggest',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response);
                        })
                        .error(function (response) {
                            o.error(response);
                            console.log(response);
                        });
                }
            },
            batch: true,
            schema: {
                data: function (data) {
                    if(data.content != undefined) {
                        data.content.forEach(function(item){

                            if(item.doctorSpecialty === null){
                                item.doctorSpecialty = {};
                                item.doctorSpecialty.name = "";
                            }

                            if(item.doctorSpecificSpecialty === null){
                                item.doctorSpecificSpecialty = {};
                                item.doctorSpecificSpecialty.name = "";
                            }

                            if(item.customerCategory === null){
                                item.customerCategory = {};
                                item.customerCategory.name = "";
                            }

                            if(item.customerSubCategory === null){
                                item.customerSubCategory = {};
                                item.customerSubCategory.name = "";
                            }

                            if(item.customerTitle === null){
                                item.customerTitle = {};
                                item.customerTitle.name = "";
                            }

                        });
                    }
                    return data.content;

                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true},
                        doctorSpecialty:{defaultValue: {id: null, name : null}},
                        customerCategory:{defaultValue: { id : null, name : null}},
                        customerSubCategory:{defaultValue: { id : null, name : null}}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        // MultiSelect Options
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["none", "me"]); //"all",
        vm.employeesMultiOptions.change = function (e) {
            KendoGrid.refresh(vm.gridOptions.suggestedCustomers);
        };

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.customerSector = [
            {
                field: "customer.lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width:140
            },
            {
                field: "customer.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.doctorSpecialty.name",
                title: "Ειδικοτητα 1η",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.customerCategory.name",
                title: "Κατηγορία",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.customerSubCategory.name",
                title: "Υποκατηγορία",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "1", value: "1" },
                                        { text: "2", value: "2" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                }
            },
            {
                field: "customer.cellPhone",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.phone",
                title: "Σταθερό Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.dayTime",
                title: "Ωράριο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "ΠΡΩΙΝΌ", value: "ΠΡΩΙΝΌ" },
                                        { text: "ΑΠΟΓΕΥΜΑΤΙΝΌ", value: "ΑΠΟΓΕΥΜΑΤΙΝΌ" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                }
            },
            {
                field: "customer.title",
                title: "Τίτλος",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.isActive",
                title: "Ενεργός",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }],
                                    filtering : function(e){
                                        console.log(e)
                                    }
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                template: "#= (customer.isActive == '1') ? 'Ναι' : 'Όχι' #"
            },
            {
                field: "customer.saw",
                title: "MyTarget",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                template: "#= (customer.saw == '1') ? 'Ναι' : 'Όχι' #"
            }
        ];
        vm.gridColumns.suggestedCustomers = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "doctorSpecialty.name",
                title: "Ειδικοτητα 1η",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "doctorSpecificSpecialty.name",
                title: "Ειδικοτητα 2η",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "customerCategory.name",
                title: "Κατηγορία",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 94
            },
            {
                field: "customerSubCategory.name",
                title: "Υποκατηγορία",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 115
            }
        ];

        // Grid Options
        vm.gridOptions = {};
        vm.gridOptions.customerSector = {
            dataSource: vm.dataSource.grid.customerSector,
            toolbar: [{ template: "<a class='k-button k-button-icontext k-grid-add'><span class='k-icon k-add'></span>Προσθήκη Επαγγελματιών Υγείας</a>" },
                { template: "<div class='right'><label>Σύνολο: {{vm.dataSource.grid.customerSector.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            selectable: true,
            scrolable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns.customerSector,
            edit: function(e) {
                vm.initPopupGrid = true;
                vm.selectedAssignees = [];
                vm.selectedEmployees = [];
                //reload popup grid
                KendoGrid.refresh(vm.gridOptions.suggestedCustomers);
                KendoGrid.defaultCustomEditPopup(e.container, 1300, 1290);
            },
            editable: {
                mode: "popup",
                template: kendo.template(angular.element("#popup_editor").html())
            },
            cancel: function() {
                KendoGrid.refresh(vm.gridOptions.customerSector);
                delete vm.initPopupGrid;
            },
            save: function() {
                delete vm.initPopupGrid;
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };
        vm.gridOptions.suggestedCustomers = {
            dataSource: vm.dataSource.grid.suggestedCustomers,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns: vm.gridColumns.suggestedCustomers,
            selectedItems: function(dataItems) {
                vm.selectedAssignees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#popupGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedAssigneesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedAssignees, {id: item.id}, true)[0];
                    if(vm.selectedAssignees.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedAssigneesViewCounter++
                    }
                });
                if(selectedAssigneesViewCounter == view.length) {
                    angular.element("#popupGridcheckbox").prop('checked', true);
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };
    }
})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorClinicNames', {
                parent: 'sectorView',
                url: '/clinicNames',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/sectors/clinicNames/clinicNames.html',
                controller: 'SectorClinicNamesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                        return Sector.get({id : $stateParams.id});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNamesController', SectorClinicNamesController);

    SectorClinicNamesController.$inject = ['$http', '$stateParams','$filter', 'KendoGrid', 'KendoFilter', 'CustomUtils', '$mdToast'];

    function SectorClinicNamesController ($http, $stateParams, $filter, KendoGrid, KendoFilter, CustomUtils, $mdToast) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        vm.selectedSectorId = $stateParams.id;
        vm.selectedClinicNames = vm.selectedSectorClinicNames = [];
        vm.massSelect = true;

        vm.deleteSectorClinicNames = function() {
            $http.put('api/sector-clinic-names/delete', vm.selectedSectorClinicNames)
                .success(function () { KendoGrid.refresh(vm.sectorClinicNamesGridOptions); })
                .error(function (response) {});
        };

        var grid = {};
        grid.dataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            {"field": "sector.id", "operator": "eq", "value": vm.selectedSectorId}
                        ]
                    );

                    $http.get('/api/sector-clinic-names/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            o.error(response);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Κάποιο σφάλμα προέκυψε')
                                    .position("bottom right")
                                    .hideDelay(3000));
                        });
                },
                create: function(o) {
                    $http.post('api/clinic-names/sector/'+ vm.selectedSectorId, vm.selectedClinicNames)
                        .success(function () { KendoGrid.refresh(vm.sectorClinicNamesGridOptions); })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.content.forEach(function (item) {
                            if (item.clinicName === null) item.clinicName = {};
                        })
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        clinicName: { defaultValue: {} }
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20
        });

        grid.columns = [
            {
                field: "clinicName.name", title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.sectorClinicNamesGridOptions = {
            dataSource: grid.dataSource,
            toolbar: [{name :"create", text: "Προσθήκη Κλινικής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.sectorClinicNamesGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" },
                { template: "<div class='k-button k-button-icontext' ng-click='vm.deleteSectorClinicNames()'>" +
                            "<span class='material-icons md-light md-26 pull-left'>delete_forever</span>Διαγραφή Κλινικής από Μονάδα Υγείας</div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            selectable: true,
            columns: grid.columns,
            edit: function(e) {
                vm.initPopupGrid = true;
                KendoGrid.refresh(vm.clinicNamesGridOptions);
                vm.selectedClinicNames = [];
                KendoGrid.defaultCustomEditPopup(e.container, 1300, 1290);
            },
            editable: {
                mode: "popup",
                template: kendo.template(angular.element("#popup_editor").html())
            },
            selectedItems: function(dataItems) {
                vm.selectedSectorClinicNames = dataItems;
            },
            dataBound: function () {
                angular.element("#mainGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedSectorClinicNamesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedSectorClinicNames, {id: item.id}, true)[0];
                    if(vm.selectedSectorClinicNames.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedSectorClinicNamesViewCounter++
                    }
                });
                if(selectedSectorClinicNamesViewCounter === view.length) {
                    angular.element("#mainGridcheckbox").prop('checked', true);
                }
            },
            cancel: function() {
                delete vm.initPopupGrid;
            },
            save: function() {
                delete vm.initPopupGrid;
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };

        grid.clinicNamesDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    $http.get('/api/clinic-names/sector/' + vm.selectedSectorId + '/suggest',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id"
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20
        });

        grid.clinicNamesColumns = [
            {
                field: "name", title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.clinicNamesGridOptions = {
            dataSource: grid.clinicNamesDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            selectable: true,
            columns: grid.clinicNamesColumns,
            selectedItems: function(dataItems) {
                vm.selectedClinicNames = dataItems;
            },
            dataBound: function () {
                angular.element("#popupGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedClinicNamesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedClinicNames, {id: item.id}, true)[0];
                    if(vm.selectedClinicNames.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedClinicNamesViewCounter++
                    }
                });
                if(selectedClinicNamesViewCounter === view.length) {
                    angular.element("#popupGridcheckbox").prop('checked', true);
                }
            }
        };
    }
})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorSectors', {
                parent: 'recDoctorView',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                templateUrl: 'app/displays/recDoctors/sectors/sectors.html',
                controller: 'RecDoctorViewSectorsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewSectorsController', RecDoctorViewSectorsController);

    RecDoctorViewSectorsController.$inject = ['$http','$compile', '$stateParams','$filter', '$timeout', 'KendoGrid', 'NotificationOptions', '$scope', 'KendoFilter'];

    function RecDoctorViewSectorsController ($http, $compile, $stateParams, $filter, $timeout, KendoGrid, NotificationOptions, $scope, KendoFilter) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;
        vm.newSector = false;
        vm.massSelect = true;
        vm.kendoGrid = KendoGrid;
        vm.hasAssignations = vm.myTarget = true;

        $http.get('/api/employees/me')
            .success(function (response) {
                vm.geodata = response.geodata;

                vm.refreshCombobox = function(filter, combobox) {
                    combobox.filter(filter);
                    combobox.read();
                };

                if(!vm.geodata) {

                    var prefecturesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter === undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100000;
                                $http.get('/api/masterdata/prefectures',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        }
                    });

                    //DropDown Options
                    vm.prefecturesComboBoxOptions = {
                        dataSource: prefecturesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        change: function(e){
                            var filter = {};
                            if(this.value() && !isNaN(this.value())) {
                                filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": this.value()
                                };
                            }
                            vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                        }
                    };

                    var citiesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter === undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 50;
                                $http.get('/api/masterdata/cities',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        }
                    });

                    //DropDown Options
                    vm.citiesComboBoxOptions = {
                        dataSource: citiesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        template: "<table>${name} &nbsp;" +
                        "<span class='hint'>(${prefecture.name})</span></table>",
                        change: function(){
                            var filter = {};
                            if(this.dataItem(this.select())) {
                                filter = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : this.dataItem(this.select()).prefecture.id
                                };
                                vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                                //prefecturesCombo.one("dataBound", function() { this.select(0) });
                                //prefecturesCombo.trigger("change");
                            } else {
                                vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                            }
                        }
                    };
                } else {
                    var geodataDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter === undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100;
                                $http.get('/api/masterdata/geodata',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {});
                            }
                        },
                        schema: {
                            parse: function(data) {
                                angular.forEach(data, function(item) {
                                    item.masterFilter = "";
                                    if(item.street !==null) {
                                        item.masterFilter =  item.street + ", ";
                                    }
                                    item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                                });
                                return data;
                            }
                        }
                    });

                    vm.masterFilterComboBoxOptions = {
                        dataSource: geodataDataSource,
                        filter: "search",
                        dataTextField: "masterFilter",
                        dataValueField: "id",
                        headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                        "<span>Διεύθυνση</span>"+
                        "<span>Πόλη</span>"+
                        "<span>Τ.Κ.</span>"+
                        "<span>Νομός</span></div>",
                        template:
                            "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                        placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                        change: function(e){
                            //initialize inputs (autocomplete)
                            if(this.dataItem(this.select())) {
                                var self = this;
                                //using $timeout to trigger the change
                                $timeout(function(){
                                    vm.saveNewSector.prefectureName = self.dataItem(self.select()).prefecture;
                                    vm.saveNewSector.cityName = self.dataItem(self.select()).city;
                                    vm.saveNewSector.address = self.dataItem(self.select()).street;
                                    vm.saveNewSector.postalCode = self.dataItem(self.select()).postalCode;
                                    vm.suggestBricks(vm.saveNewSector.postalCode);
                                },0);
                            }
                        }
                    };
                }
            })
            .error(function (response) {});

        var comboBoxes = ["#masterFilter","#sectorPosition", "#sectorType", "#prefectures", "#cities"]; //add "#regions" if wanted

        var validator = angular.element("#form").kendoValidator({
            rules: {
                custom: function (input) {

                    if (input.data('custom')) {
                        if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
            messages: {
                custom: "Πρέπει να επιλέξετε από την λίστα",
                maxlength: "Το κινητό τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
            }
        }).data("kendoValidator");
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        var sectorPositionsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/sector-positions',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.sectorPositionComboBoxOptions = {
            dataSource: sectorPositionsDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        var sectorTypeFilter = function () {
            return {
                "field"   : "isPrivate",
                "operator": "eq",
                "value"   : vm.newSector
            };
        };

        var sectorTypesDataSource = new kendo.data.DataSource({
            filter: sectorTypeFilter(),
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters.push({ "field": "sectorTypeCategory", "operator": "startswith", "value": 'hcu'});

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/sector-types',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.sectorTypeComboBoxOptions = {
            dataSource: sectorTypesDataSource,
            filterable: true,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            suggest: true,
            cascade: function() {
                angular.element("#sectors").data("kendoComboBox").text("");
            }
        };

        var sectorsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get('api/customer-sectors/customers/' + vm.selectedUserId +'/sectors/suggest',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.sectorsComboBoxOptions = {
            dataSource: sectorsDataSource,
            cascadeFrom: "sectorType",
            cascadeFromField: "sectorType.id",
            filter: "like",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            template: "#= name # <br/>(#= prefectureName #, #= cityName #)"
        };

        vm.cancelSector= function (){
            vm.newSector = false;
            vm.sectorTypeComboBoxOptions.dataSource.filter(sectorTypeFilter());
            vm.savedSector = false;
        };

        //Save New Sector
        vm.updateSector = function(){

            if (validator.validate()) {

                var url = 'api/sectors';

                $http.post(url,vm.saveNewSector)
                    .success(function (response) {
                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                        vm.savedSector = true;

                        vm.newSectorObj = response;
                        vm.sectorsComboBoxOptions.dataSource.add(response);
                        angular.element("#sectors").data("kendoComboBox").value(response.id);

                    })
                    .error(function (response) {});
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }
        };

        function employeeCustomerSectorsDisplay(data) {
            return data.employeeCustomerSectors.map(function(elem) {
                return elem.employee.account.fullName
            }).join(', ');
        }

        vm.sectorsGridColumns = [
            {command:[{name:"edit", text: ""}], title: "&nbsp;", width:140},
            {
                title: "Στοιχεία Μονάδας Υγείας",
                columns: [
                    {
                        field: "sector.name", title: "Μονάδα Υγείας",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "sector.sectorType.name",
                        title: "Τύπος",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            {field: "startedAt", title: "Ημερομηνία Έναρξης", template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            },
            {field: "endedAt", title: "Ημερομηνία Λήξης", template: "#= (endedAt == null) ? '' : kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="main" ng-model="dataItem.main" ng-disabled="true"></md-checkbox>',
                field: "main", title: "Βασική Μονάδα",
                // editor: function(container){
                //     angular.element('<md-checkbox ng-model="dataItem.main"  aria-label="main" ' +
                //         'class="checkbox-toolbar green inline"></md-checkbox>')
                //         .appendTo(container);
                // },
                filterable: {
                    cell: {
                        operator: "eq",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.sectorsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        $http.get('/api/customers/' + vm.selectedUserId + '/me/customer-sectors')
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    update: function(o) {
                        vm.saveSector = o.data.models[0];

                        //if deleted make active false
                        angular.forEach(vm.saveSector.employeeCustomerSectorsAll, function(item) {
                            var notFound = $filter('filter')(vm.saveSector.employeeCustomerSectors, {id: item.id}, true)[0];
                            if (vm.saveSector.employeeCustomerSectors.indexOf(notFound) === -1) {
                                item.active = false;
                                vm.saveSector.employeeCustomerSectors.push(item);
                            }
                        });

                        if(!vm.saveSector.sectorPosition.id) {
                            vm.saveSector.sectorPosition = null;
                        }
                        if(!vm.saveSector.sector.parent.id) {
                            vm.saveSector.sector.parent = null;
                        }

                        vm.saveSector.startedAt = kendo.toString(vm.saveSector.startedAt,"yyyy-MM-dd");
                        vm.saveSector.endedAt = kendo.toString(vm.saveSector.endedAt,"yyyy-MM-dd");

                        var url = 'api/customer-sectors';

                        $http.put(url,vm.saveSector)
                            .success(function (response) {
                                angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {});
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(options.data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data !== undefined) {
                            data.forEach(function(item){

                                if(item.sector === null){
                                    item.sector = {
                                        name: "",
                                        address: "",
                                        cityName: "",
                                        prefectureName: ""
                                    };
                                } else if (item.sector.parent === null) {
                                    item.sector.parent = { name: "" };
                                }

                                if(item.sector.sectorType === null){
                                    item.sector.sectorType = {};
                                    item.sector.sectorType.name = "";
                                }

                                if(item.sectorPosition === null){
                                    item.sectorPosition = {};
                                    item.sectorPosition.name = "";
                                }

                                if(item.employeeCustomerSectors === null){
                                    item.employeeCustomerSectors = {
                                        employee: {
                                            account: {}
                                        }
                                    };
                                }

                            });
                        }

                        return data;
                    },
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            if (item.startedAt !== undefined) {
                                item.startedAt = kendo.toString(kendo.parseDate(item.startedAt), 'dd/MM/yyyy');
                            }

                            if (item.endedAt !== undefined) {
                                item.endedAt = kendo.toString(kendo.parseDate(item.endedAt), 'dd/MM/yyyy');
                            }

                            //copy employeeCustomerSectors so to splice in foreach
                            var employeeCustomerSectorsToShow = angular.copy(item.employeeCustomerSectors);
                            //copy for backup
                            item.employeeCustomerSectorsAll = angular.copy(item.employeeCustomerSectors);
                            if(item.employeeCustomerSectors !== null) {
                                angular.forEach(item.employeeCustomerSectors, function(employeeCustomerSector) {
                                    if(employeeCustomerSector.active === false) {
                                        var foundItemById = $filter('filter')(employeeCustomerSectorsToShow, {id: employeeCustomerSector.id}, true)[0];
                                        employeeCustomerSectorsToShow.splice(employeeCustomerSectorsToShow.indexOf(foundItemById), 1);
                                    }
                                });

                                item.employeeCustomerSectors = employeeCustomerSectorsToShow;
                                angular.forEach(item.employeeCustomerSectors, function(employeeCustomerSector) {
                                    employeeCustomerSector.employee.account.fullName =
                                        employeeCustomerSector.employee.account.lastName + " " + employeeCustomerSector.employee.account.firstName;
                                });
                            }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            sector: { defaultValue : { id : null, name : null} },
                            'sector.name': { editable: false },
                            sectorPosition: {defaultValue : { id : null, name : null}},
                            phone : { defaultValue : null},
                            startedAt: { type: 'date'},
                            endedAt: { type: 'date', defaultValue : null},
                            'employeeCustomerSectors': {},
                            sectorParent: { from: "sector.parent", defaultValue : { id : null, name : null} },
                            'sectorParent.name': { editable: false },
                            'sector.address': { editable: false },
                            'sector.addressNum': { editable: false },
                            'sector.postalCode': { editable: false },
                            'sector.brick': { editable: false },
                            'sector.osfeBrick': { editable: false },
                            'sector.cityName': { editable: false },
                            'sector.prefectureName': { editable: false },
                            main: { editable: true, type: "boolean" }
                        }
                    }
                }
            }),
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.sectorsGridColumns,
            toolbar: [{ name: "New Customer Sector",
                text: "New Customer Sector", template: "<input type='button' class='k-button' value = 'Προσθήκη Μονάδας Υγείας' ng-click='vm.openWindow()' />" },
                { template: "<div class='right'><label>Σύνολο: {{vm.sectorsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }],
            edit: function(e) {
                e.model.dirty = true;
                vm.employeeDataItems = angular.copy(e.model);
                if(!e.model.isNew()) {
                    if (e.model.main) angular.element("[name=main]").prop("disabled", true);
                }
                this._editContainer.addClass("default-popup");
                vm.kendoGrid.defaultCustomEditPopup(this._editContainer, 1000, 470);
                // angular.element(e.container).width(1000);
                angular.element(e.container).data("kendoWindow").center();
            },
            editable: {
                mode: "popup"
            },
            save: function (e) {
                var customerSectorsGrid = angular.element("#sectorsGrid").data("kendoGrid");
                customerSectorsGrid.refresh();
            }
        };

        vm.clearWindow = function () {
            //clear inputs
            vm.newCustomerSector = vm.saveNewSector = null;

            //clear kendoComboBox
            angular.forEach(comboBoxes, function (item) {
                var filter = {};
                var comboBox = angular.element(item).data("kendoComboBox");
                if(comboBox) {
                    comboBox.value("");
                    if (item === "#cities") {
                        vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                    } else if (item === "#prefectures") {
                        vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                    }
                }
            });

            //clear employees selected
            vm.selectedEmployees = [];
        };

        vm.openWindow = function(){
            vm.initPopupGrid = true;
            var wdw = angular.element("#popup-new-customSector").data("kendoWindow");
            vm.clearWindow();
            wdw.center().open();

            vm.newSector = false;
            vm.sectorTypeComboBoxOptions.dataSource.filter(sectorTypeFilter());
            vm.savedSector = false;
            vm.todayDate = new Date();
            $("#started_at").data("kendoDatePicker").value(vm.todayDate);
            //clear dataItems selected
            vm.statusChanged = "opened";
        };

        vm.closeWindow = function() {
            var wdw = angular.element("#popup-new-customSector").data("kendoWindow");
            delete vm.newSectorObj;
            wdw.close();
            delete vm.initPopupGrid;
            //clear dataItems selected
            vm.statusChanged = "closed";
        };

        vm.saveCustomerSectors = function() {
            var wdw = angular.element("#popup-new-customSector").data("kendoWindow");

            var url = 'api/customer-sectors';

            vm.choices = [];
            vm.selectedEmployees.forEach(function(item,index){
                vm.choices.push(
                    {active: true,
                        myTarget: vm.myTarget,
                        employee: {
                            id: item.id
                        },
                        id: null
                    }
                )
            });

            vm.newCustomerSector.employeeCustomerSectors =  vm.choices;
            vm.newCustomerSector.id =  null;
            vm.newCustomerSector.customer = {
                id :  vm.selectedUserId
            };

            vm.newCustomerSector.startedAt =  vm.todayDate;
            if (vm.newSectorObj) {
                vm.newCustomerSector.sector = vm.newSectorObj;
            }

            $http.post(url,  vm.newCustomerSector)
                .success(function (response) {
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    delete vm.newSectorObj;
                    wdw.close();
                })
                .error(function (response) {});
            //clear dataItems selected
            vm.statusChanged = "saved";

        };

        vm.timeToString = function(date) {
            return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        };

        vm.gridColumns = [
            {
                title: "Στοιχεία Χρήστη",
                columns: [
                    {
                        field: "account.login",
                        title: "Όνομα σύνδεσης",
                        editor: function(container, options) {
                            angular.element('<select id="comboBox" data-bind="value:account.id"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    dataSource: vm.usersComboBoxDataSource,
                                    filter: "startswith",
                                    change: function(e) {
                                        var index = e.sender.selectedIndex;
                                        $('#firstName').data('kendoComboBox').select(index);
                                        $('#lastName').data('kendoComboBox').select(index);
                                    },
                                    valuePrimitive: true,
                                    dataTextField: "login",
                                    dataValueField: "id",
                                    template: "<table><span width='100px'><strong>(${login}) </strong></span>" +
                                    "<span width='50px'>${firstName} </span>" +
                                    "<span width='50px'>${lastName}</span></table>"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "account.firstName",
                        title: "Όνομα",
                        editor: function(container, options) {
                            angular.element('<select id="firstName" data-bind="value:account.firstName"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    enable: false,
                                    dataSource: vm.usersComboBoxDataSource,
                                    dataTextField: "firstName"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "account.lastName",
                        title: "Επώνυμο",
                        editor: function(container, options) {
                            angular.element('<select id="lastName" data-bind="value:account.lastName"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    enable: false,
                                    dataSource: vm.usersComboBoxDataSource,
                                    dataTextField: "lastName"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.selectedEmployees = [];

        //POPUP grid
        vm.employeeAllGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data !== undefined) {
                            data.content.forEach(function(item){

                                if (!item.account) {
                                    item.account = {
                                        firstName: "",
                                        lastName: "",
                                        login: ""
                                    };
                                }

                                if (!item.supervisor) {
                                    item.supervisor = {
                                        account: {fullName: ""}
                                    }
                                } else {
                                    if (item.supervisor.account.lastName && item.supervisor.account.firstName) {
                                        item.supervisor.account.fullName =
                                            item.supervisor.account.lastName + " " + item.supervisor.account.firstName;
                                    } else if (!item.supervisor.account.firstName) {
                                        item.supervisor.account.fullName = item.supervisor.account.lastName;
                                    } else if (!item.supervisor.account.lastName) {
                                        item.supervisor.account.fullName = item.supervisor.account.firstName;
                                    }
                                }
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            district : {defaultValue: {}},
                            password: { type: 'password', editable: true, nullable: false, defaultValue: null },
                            supervisor: { defaultValue: { account: { defaultValue: {}} }},
                            account: { defaultValue: {} },
                            mobileVersion: {editable:false}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            scrolable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.gridColumns,
            selectedItems: function(dataItems) {
                vm.selectedEmployees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#employeeAllGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedEmployees) {
                    var selectedEmployeesViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedEmployees, {id: item.id}, true)[0];
                        if(vm.selectedEmployees.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedEmployeesViewCounter++
                        }
                    });
                    if(selectedEmployeesViewCounter === view.length) {
                        angular.element("#employeeAllGridcheckbox").prop('checked', true);
                    }
                }
            }
        };

        vm.addSector = function(){
            vm.newSector = true;
            vm.sectorTypeComboBoxOptions.dataSource.filter(sectorTypeFilter());
            vm.saveNewSector = {};
        };


        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};

            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content !== null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.saveNewSector.brick = response.content[0].territoryNo;
                    }
                })
                .error(function (response) {});


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content !== null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.saveNewSector.osfeBrick = response.content[0].territoryName;
                    }
                })
                .error(function (response) {});
        };

        vm.toggleSelectAll = function (ev) {
            vm.allSelected = !vm.allSelected;
            var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid");
            angular.forEach( grid.dataSource.data(), function( dataItem ) {
                dataItem.myTarget = vm.allSelected;
            });
        };

        vm.onMyTargetClick = function (dataItem) {
            dataItem.myTarget = !dataItem.myTarget;
            if (!dataItem.myTarget) {
                vm.allSelected = dataItem.myTarget;
            }
        };

        //check customer type
        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
                vm.allSelected = false;

                var foundItemById = $filter('filter')(vm.customer.customerTypes, {id: 1}, true)[0];

                if ( vm.customer.customerTypes.indexOf(foundItemById) !== -1) {
                    var grid = angular.element("#sectorsGrid").data("kendoGrid");

                    vm.sectorsGridColumns.push({
                        field: "employeeCustomerSectors",
                        title: "Ιατρικοί Επισκέπτες",
                        filterable: false,
                        template: employeeCustomerSectorsDisplay,
                        editor: function (container, options) {
                            angular.element('<select id="employeeCustomerSectors" style="width:800px;" multiple="multiple" data-bind="value: employeeCustomerSectors"/>')
                                .appendTo(container)
                                .kendoMultiSelect({
                                    dataSource: new kendo.data.DataSource({
                                        serverFiltering: true,
                                        transport: {
                                            read: function (o) {
                                                if (o.data.filter === undefined) {
                                                    o.data.filter = {filters: []};
                                                }

                                                o.data.page = 1;
                                                o.data.pageSize = 10000;
                                                $http.get('/api/me/employees',
                                                    {params: o.data})
                                                    .success(function (response) {
                                                        o.success(response.content);
                                                    })
                                                    .error(function (response) {});
                                            }
                                        },
                                        schema: {
                                            parse: function(data) {
                                                angular.forEach(data, function(item) {
                                                    //define object for data binding
                                                    if(item.account !== null) {
                                                        item.active = item.myTarget = true;
                                                        item.employee = {
                                                            account : {
                                                                fullName: item.account.lastName + " " + item.account.firstName
                                                            },
                                                            id: item.id
                                                        }
                                                    }
                                                    //if exists but active false keep employeeCustomerSectors id
                                                    if ( vm.employeeDataItems.employeeCustomerSectorsAll ) {
                                                        if (vm.employeeDataItems.employeeCustomerSectorsAll.length) {
                                                            var foundItemByEmployeeId = $filter('filter')(vm.employeeDataItems.employeeCustomerSectorsAll, {employee: {id: item.id}}, true)[0];
                                                            if (vm.employeeDataItems.employeeCustomerSectorsAll.indexOf(foundItemByEmployeeId) !== -1) {
                                                                item.id = foundItemByEmployeeId.id
                                                            } else {
                                                                item.id = null;
                                                            }
                                                        } else {
                                                            item.id = null;
                                                        }
                                                    }

                                                });
                                                return data;
                                            }
                                        }
                                    }),
                                    valuePrimitive: false,
                                    dataTextField: "employee.account.fullName",
                                    dataValueField: "employee.id"
                                });

                            vm.myTargetGridOptions = {
                                dataSource : new kendo.data.DataSource({
                                    data: angular.element("#employeeCustomerSectors").data("kendoMultiSelect").dataItems(),
                                    pageSize: 10,
                                    schema: {
                                        model: {
                                            id: "id",
                                            fields: {
                                                id: { editable: false, nullable: true },
                                                'employee.account.fullName': { editable: false },
                                                myTarget: { type: "boolean" }
                                            }
                                        }
                                    }
                                }),
                                sortable: true,
                                pageable: true,
                                scrolable: true,
                                editable: true,
                                filterable: {
                                    mode: "row"
                                },
                                resizable: true,
                                columns: [
                                    {
                                        field: "employee.account.fullName",
                                        title: "Επιλεγμένοι Ιατρικοί Επισκέπτες",
                                        filterable: {
                                            cell: {
                                                operator: "startswith",
                                                template: function (args) {
                                                    KendoFilter.getTemplate(args);
                                                },
                                                showOperators: false
                                            }
                                        }
                                    },
                                    {
                                        template: '<input type="checkbox" ng-click="vm.onMyTargetClick( dataItem );" ng-checked="dataItem.myTarget" class="checkbox"/>', //
                                        title: "<label>myTarget </label>" +
                                        "<input id='checkboxMyTarget' type='checkbox' class='checkbox' ng-checked='vm.allSelected' " +
                                        "ng-click='vm.toggleSelectAll($event)'/>",
                                        width: 100,
                                        filterable: false
                                    }
                                ]
                            };

                            angular.element($compile('<div kendo-grid id="employeeCustomerSectorsGrid" style="width:800px;" k-options="vm.myTargetGridOptions" ' +
                                                        'data-bind="source: employeeCustomerSectors"></div>')($scope))
                                .appendTo(container);
                        }
                    });

                    grid.setOptions({
                        columns: vm.sectorsGridColumns
                    });
                } else {
                    vm.hasAssignations = false;
                }
            })
            .error(function (response) {});
    }
})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorScheduler', {
                parent: 'recDoctorView',
                url: '/scheduler',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                templateUrl: 'app/displays/recDoctors/scheduler/scheduler.html',
                controller: 'RecDoctorViewSchedulerController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewSchedulerController', RecDoctorViewSchedulerController);

    RecDoctorViewSchedulerController.$inject = ['$http','$state', '$stateParams','$filter', 'Principal', 'ApplicationParameters'];

    function RecDoctorViewSchedulerController ($http, $state, $stateParams, $filter, Principal, ApplicationParameters) {
        var vm = this;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_REC_MANAGEMENT'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }
        ApplicationParameters.hasModule('Scheduling', true);
        vm.customer = {};
        vm.selectedUserId = $stateParams.id;
        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {});

        vm.tooltipContent = kendo.template($("#template").html());
        if (vm.readOnly) {
            var startTime = new Date();
            startTime.setHours(8,0,0,0);

            var viewModel2 = new kendo.observable({
                schedulerData: new kendo.data.SchedulerDataSource ({
                    batch: true,
                    transport: {
                        read: function(o){
                            var scheduler = $("#scheduler").data("kendoScheduler");
                            var view = scheduler.view();

                            if (o.data.filter === undefined) {
                                o.data.filter = { filters: [
                                    { "field": "eventCustomerSector.customerSector.customer.id", "operator": "eq",
                                        "value": vm.selectedUserId },
                                    { "field": "startedAt", "operator": "from",
                                        "value": $filter('date')(view.startDate(), 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "startedAt", "operator": "to",
                                        "value": $filter('date')(view.endDate(), 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ] };
                            }

                            $http.get('/api/me/events-and-schedules/all', { params: o.data })
                                .success(function (response,status,headers) {
                                    o.success(response);
                                })
                                .error(function (response) {});
                        },
                        create: function(o){
                            var data = o.data.models[0];
                            data.eventCategoryType = {
                                id: 1
                            };

                            var date = new Date(data.start);
                            date.setTime(date.getTime() + (data.duration*60*1000));
                            angular.extend(data.eventSchedule, {
                                startedAt: data.start,
                                finishedAt: date
                            });

                            data.id = null;
                            data.eventCustomerSector.id = null;

                            $http.post('/api/events', data)
                                .success(function (response,status,headers) {
                                    o.success([response]);
                                    var scheduler = $("#scheduler").data("kendoScheduler");
                                    scheduler.dataSource.read();
                                })
                                .error(function (response) {});
                        },
                        update: function(o){
                            var data = o.data.models[0];
                            data.eventCategoryType = {
                                id: 1
                            };
                            var date = new Date(data.start);
                            date.setTime(date.getTime() + (data.duration*60*1000));
                            if(!data.startedAt) {
                                data.eventSchedule.startedAt = data.start;
                                data.eventSchedule.finishedAt = date;
                            } else {
                                data.startedAt = data.start;
                                data.finishedAt = date;
                            }

                            data.eventCustomerSector.agreementValuation = null;

                            $http.put('/api/events', data)
                                .success(function (response,status,headers) {
                                    o.success([response]);
                                    var scheduler = $("#scheduler").data("kendoScheduler");
                                    scheduler.dataSource.read();
                                })
                                .error(function (response) {});
                        }
                    },
                    schema: {
                        data: function (data) {
                            if(data) {
                                data.forEach( function (item) {
                                    if (!item.eventCustomerSector) {
                                        item.eventCustomerSector = {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                },
                                                sector: {
                                                    address: "",
                                                    city: {
                                                        name: ""
                                                    }
                                                }
                                            },
                                            agreementValuation: {
                                                name: ""
                                            },
                                            communicationType: {
                                                name: ""
                                            }
                                        };
                                    } else {
                                        if (item.eventCustomerSector.agreementValuation === null) {
                                            item.eventCustomerSector.agreementValuation = {};
                                            item.eventCustomerSector.agreementValuation.name = "";
                                        }
                                        if (item.eventCustomerSector.communicationType === null) {
                                            item.eventCustomerSector.communicationType = {};
                                            item.eventCustomerSector.communicationType.name = "";
                                        }
                                    }

                                    if (item.eventSchedule === null) {
                                        item.eventSchedule = {
                                            description: ""
                                        };
                                    }
                                });
                            }

                            return data;
                        },
                        parse: function (data) {
                            if(data) {
                                data.forEach( function (item) {
                                    if (item.startedAt === null) {
                                        item.isSchedule = true;
                                        item.start = item.eventSchedule.startedAt;
                                        item.end = item.eventSchedule.finishedAt;
                                    } else {
                                        item.isSchedule = false;
                                        item.start = item.startedAt;
                                        item.end = item.finishedAt;
                                    }

                                    item.duration = ((new Date(item.end) - new Date(item.start))/1000/60) << 0;
                                });
                            }
                            return data;
                        },
                        model: {
                            id: "taskId",
                            fields: {
                                taskId: { from: "id", type: "number", editable: false },
                                start: { type: "date", from: "start" },
                                end: { type: "date", from: "end" },
                                durationTime: { type: "number", defaultValue: 15, from: "duration" },
                                title: { from: "title", defaultValue: "ΠΡΟΣΩΠΙΚΗ ΕΠΙΣΚΕΨΗ", validation: { required: true } },
                                eventSchedule: { defaultValue: {} },
                                eventCustomerSector: {
                                    defaultValue: {
                                        communicationType: { defaultValue: {} },
                                        customerSector: {
                                            defaultValue: { customer: {defaultValue: {}}, sector: {defaultValue: {}}}
                                        }
                                    }
                                }
                            }
                        }
                    },
                    serverFiltering: true
                })
            });

            //vm.checkAvailability = function (e) {
            //    if (e.event.eventCustomerSector.customerSector.customer) {
            //        if (e.event.eventCustomerSector.customerSector.customer.id != vm.selectedUserId) {
            //            e.preventDefault();
            //        }
            //    }
            //};

            vm.schedulerOptions = {
                dataSource: viewModel2.schedulerData,
                dataBound: function(e) {
                    if (this.view().name === "day") {
                        vm.view = "day";
                    } else if (this.view().name === "workWeek" || this.view().name === "week") {
                        vm.view = "week";
                    } else if (this.view().name === "month") {
                        vm.view = "month";
                    }
                },
                resources: [
                    {
                        field: "isSchedule",
                        dataSource: [
                            { text: "Event", value: true, color: "#007fff!important" },
                            { text: "Schedule", value: false, color: "#ff5c33!important" }
                        ]
                    }
                ],
                date: new Date(),
                startTime: startTime,
                allDaySlot: false,
                messages: {
                    today: "Τρέχουσα Ημέρα",
                    showFullDay: "Προβολή ολόκληρης της ημέρας",
                    showWorkDay: "Προβολή ωραρίου εργασίας",
                    "cancel": "Κλείσιμο",
                    "save": "Αποθήκευση",
                    "editor": {
                        "title": "Τίτλος Ραντεβού",
                        "start": "Ημερομηνία",
                        "end": "Τελειώνει"
                    }
                },
                height: 600,
                views: [
                    { type: "day", title: "Ημέρα" },
                    { type: "workWeek", title: "Εργάσιμες Ημέρες", selected: true },
                    { type: "week", title: "Εβδομάδα" },
                    { type: "month", title: "Μήνας" }
                ],
                editable: {
                    destroy: false,
                    mode: "popup",
                    template: kendo.template(angular.element("#popup_editor2").html())
                },
                //resize: function(e) {
                //    vm.checkAvailability(e);
                //},
                //move: function(e) {
                //    vm.checkAvailability(e);
                //},
                //save: function(e) {
                //    vm.checkAvailability(e);
                //},
                edit: function(e) {
                    $("div.k-edit-form-container").width(1000);
                    var wnd = $(e.container).data("kendoWindow");
                    wnd.setOptions({
                        title: "Ραντεβού"
                    });

                    e.container
                        .find("[name=isAllDay]") // find the all day checkbox
                        .parent() // get its wrapper
                        .prev() // get the label wrapper
                        .remove() // remove the label wrapper
                        .end() // get back to the checkbox wrapper
                        .remove(); // remove the checkbox wrapper

                    e.container
                        .find("[name=recurrenceRule]") // find the recurrence rule
                        .parent() // get its wrapper
                        .prev() // get the label wrapper
                        .remove() // remove the label wrapper
                        .end() // get back to the checkbox wrapper
                        .remove(); // remove the checkbox wrapper

                    vm.currentCustomer = e.event.eventCustomerSector.customerSector.customer;
                    vm.currentSector = e.event.eventCustomerSector.customerSector.sector;

                    //choose readonly editor if is not a schedule
                    if(!e.event.isNew()) {
                        vm.customerChanged = false;
                        vm.isSchedule = !e.event.startedAt;

                        if(!vm.isSchedule) {
                            wnd.setOptions({
                                title: "Δραστηριότητα"
                            });
                        }

                        if(!vm.isSchedule || vm.currentCustomer.id !== vm.selectedUserId) {
                            e.container
                                .find(".k-edit-buttons") // find edit buttons
                                .remove(); // remove the checkbox wrapper
                        }

                        //read customerSectors
                        var sector = $("#sector").data("kendoComboBox");
                        sector.dataSource.read();
                    } else {
                        vm.customerChanged = true;
                        vm.currentCustomer = vm.customer;
                        vm.isSchedule = true;
                    }
                }
            };

            vm.customerSectorComboBoxDataSource= new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if(vm.currentCustomer) {
                            var filter =  { "filters" : [ { "field": "customer.id", "operator": "eq",  "value": vm.currentCustomer.id } ] }
                        }
                        var url = '/api/me/customer-sectors';
                        o.data.page = 1;
                        o.data.pageSize = 1000;
                        o.data.filter = filter;
                        $http.get(url, {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                }
            });

            vm.communicationTypesComboBoxDataSource= new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        var url = '/api/masterdata/communication-types';
                        o.data.page = 1;
                        o.data.pageSize = 1000;
                        $http.get(url, {params: o.data })
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                }
            });

            vm.communicationTypesComboBoxOptions = {
                dataSource: vm.communicationTypesComboBoxDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                dataBound: function() {
                    if (!this.value() && this.selectedIndex === -1) {
                        this.select(0);
                        this.trigger("change");
                    }
                }
            };

            vm.sectorComboBoxOptions = {
                dataSource: vm.customerSectorComboBoxDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "sector.name",
                dataValueField: "id",
                dataBound: function() {
                    if (vm.customerChanged) {
                        this.select(0);
                        this.trigger("change");
                    }
                }
            };
        }

    }
})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewController', RecDoctorViewController);

    RecDoctorViewController.$inject = ['DataUtils', '$http','$state', '$stateParams', '$filter', 'Principal', '$scope', 'NotificationOptions'];

    function RecDoctorViewController (DataUtils, $http, $state, $stateParams, $filter, Principal, $scope, NotificationOptions) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        if (Principal.hasAnyAuthority(['ROLE_REC_ADMINISTRATOR'])) {
            vm.readOnly = true;
        }

        vm.customer = {};
        vm.profilePicture = "customer_icon.png";
        vm.selectedUserId = $stateParams.id;
        vm.$state = $state;

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {});

        kendo.Backbone = kendo.Backbone || {};

        kendo.Backbone.DataSource = kendo.data.DataSource.extend({
            init: function(options) {
                if (options.transport && options.transport.read) {
                    options.transport.read.type = 'GET';
                    options.transport.read.dataType = 'json';
                    options.transport.read.contentType = 'application/json;charset=UTF-8';
                }
                kendo.data.DataSource.fn.init.call(this, options);
            }
        });

        vm.setProfilePhoto = function ($file, customer) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        customer.profilePhoto = base64Data;
                        customer.profilePhotoContentType = $file.type;
                    });

                    $http.put('api/customers', customer)
                        .success(function (response) {
                            notification.show({
                                message: "Η ενημέρωση της φωτογραφίας ήταν επιτυχής!"
                            }, "success");
                        })
                        .error(function (response) {});
                });
            }
        };
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctors', {
                parent: 'app',
                url: '/recDoctors',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/recDoctors/recDoctors.html',
                        controller: 'RecDoctorsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    .state('recDoctorView', {
            abstract: true,
            parent: 'app',
            url: '/recDoctors/search?id:doctorId',
            data: {
                authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                pageTitle: 'sigmaCrmApp.recDoctor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/recDoctors/recDoctorView.html',
                    controller: 'RecDoctorViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorsController', RecDoctorsController);

    RecDoctorsController.$inject = ['$scope', '$http','$state', 'Principal', 'KendoFilter', 'KendoGrid', 'KendoService'];

    function RecDoctorsController ($scope, $http, $state, Principal, KendoFilter, KendoGrid, KendoService) {
        var vm = this;

        vm.pageHeading = 'Επαγγελματίες Υγείας';
        vm.canEdit = Principal.hasAuthority(['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_MANAGEMENT']);

        vm.addEditFunctionality = function() {
            var grid = angular.element("#mainGrid").data("kendoGrid");
            vm.gridColumns.unshift({
                command: [
                    {name: "edit", text: ""}
                ],
                title: "&nbsp;",
                width: 80
            });

            vm.gridToolbar.unshift({name: "create", text: "Προσθήκη Νέου Επαγγελματία Υγείας"});

            grid.setOptions({
                columns: vm.gridColumns,
                editable: {
                    mode: "popup"
                },
                edit: function() {
                    KendoGrid.defaultEditPopup(this._editContainer);
                    //fix css
                    angular.element( "input[name='isActive']" ).parent().addClass("k-checkbox-custom");
                },
                toolbar: vm.gridToolbar
            });
        };

        //Data for DropDown
        vm.specialtyDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/doctor-specialties',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //CustomerTitle combobox edit configuration
        var dataSource = {};
        dataSource.customerTitlesDataSource = KendoService.initDataSource('/api/masterdata/customer-titles', 1, 20);

        vm.url = "/api/customers";

        vm.gridColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "amka",
                title: "A.M.K.A.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "doctorSpecialty.name",
                title: "Ειδικοτητα 1η",
                editor: function(container, options) {
                    angular.element('<select id="doctor-specialty" data-bind="value:doctorSpecialty.id" required="required"' +
                        'data-required-msg="Η ειδικότητα του Επαγγελματία Υγείας είναι υποχρεωτική"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.specialtyDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "customerTitle.name",
                title: "Τύπος Επαγγελματία Υγείας",
                editor: function(container, options) {
                    angular.element('<select id="customer-title" data-bind="value:customerTitle.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.customerTitlesDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "cellPhone",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 79
            },
            {
                field: "phone",
                title: "Σταθερό Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 151
            },
            {
                field: "email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 151
            },
            {
                field: "isActive",
                title: "Ενεργός",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                width: 133,
                template: "#= (isActive == '1') ? 'Ναι' : 'Όχι' #"
            }
        ];

        vm.gridToolbar = [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
            overflow: "never" }];

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/me/customers',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function (o){

                        var data = o.data.models[0];
                        if(!data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        $http.post(vm.url, data)
                            .success(function (response) {
                                o.success(response);
                                $state.go('recDoctorInfo', {id: response.id});
                            })
                            .error(function (response) {});
                    },
                    update: function (o){

                        var data = o.data.models[0];

                        if(!data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        $http.put(vm.url, data)
                            .success(function () {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {});
                    }
                },
                batch: true,
                schema: {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if(item.doctorSpecialty === null)
                                    item.doctorSpecialty = { name: ""};
                                if(!item.customerTitle) item.customerTitle = {};
                            });
                        }
                        return data.content;

                    },
                    total: function (data) {
                      return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true},
                            lastName: { validation: { required: { message: "Το επώνυμο του Επαγγελματία Υγείας είναι υποχρεωτικό" } } },
                            firstName: { validation: { required: { message: "Το όνομα του Επαγγελματία Υγείας είναι υποχρεωτικό" } } },
                            //amka: { validation: { required: { message: "Το A.M.K.A. του Επαγγελματία Υγείας είναι υποχρεωτικό" } } },
                            isActive:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return (value === "1" || value === "true" || value === true);

                                }
                            },
                            doctorSpecialty:{defaultValue: {id: null, name : null}},
                            customerTitle:{defaultValue: {id: null, name : null}}
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            }),
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns: vm.gridColumns,
            save: function (e) {
                var customersGrid = angular.element("#mainGrid").data("kendoGrid");
                customersGrid.refresh();
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        $scope.$on("kendoRendered", function () {
            if(vm.canEdit) vm.addEditFunctionality();
        });

        vm.onSelection = function(data) {
            $state.go('recDoctorInfo', {id: data.id});
        };

    }
})();
;
/**
 * Created by Kristy on 1/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorNotes', {
                parent: 'recDoctorView',
                url: '/notes',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                templateUrl: 'app/displays/recDoctors/notes/notes.html',
                controller: 'RecDoctorViewNotesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewNotesController', RecDoctorViewNotesController);

    RecDoctorViewNotesController.$inject = ['$http', '$stateParams', 'Principal', 'NotificationOptions'];

    function RecDoctorViewNotesController ($http, $stateParams, Principal, NotificationOptions) {
        var vm = this;

        // if (!Principal.hasAnyAuthority(['ROLE_REC_ADMINISTRATOR'])) {
        //     vm.readOnly = true;
        // }

        vm.customer = {};
        vm.selectedUserId = $stateParams.id;

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {});

        var validator = angular.element("#form").kendoValidator({}).data("kendoValidator");
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.update = function() {
            if (validator.validate()) {
                $http.put('api/customers', vm.customer)
                    .success(function (response) {
                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                    })
                    .error(function (response) {
                        notification.show({
                            message: "Η ενημέρωση των στοιχείων απέτυχε!"
                        }, "error");
                    });
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }

        };
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorInfo', {
                parent: 'recDoctorView',
                url: '',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                templateUrl: 'app/displays/recDoctors/info/info.html',
                controller: 'RecDoctorViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewInfoController', RecDoctorViewInfoController);

    RecDoctorViewInfoController.$inject = ['$http', '$stateParams', 'NotificationOptions'];

    function RecDoctorViewInfoController ($http, $stateParams, NotificationOptions) {
        var vm = this;

        // if (!Principal.hasAnyAuthority(['ROLE_REC_ADMINISTRATOR'])) {
        //     vm.readOnly = true;
        // }

        vm.customer = { customerTypes: []};
        vm.selectedUserId = $stateParams.id;

        vm.validatorOptions = {
            rules: {
                custom: function (input) {

                    if (input.data('custom')) {
                        if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
            messages: {
                custom: "Πρέπει να επιλέξετε από την λίστα",
                maxlength: "Το κινητό τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
            }
        };

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        var dayTimeDataSource = new kendo.data.DataSource({
            data: [
                { id: 1, name: "ΠΡΩΙΝΌ"},
                { id: 2,  name: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}
            ]
        });

        vm.dayTimeDropDownOptions = {
            dataSource: dayTimeDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Ωράριο"

        };

        var customerTitlesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get('/api/masterdata/customer-titles',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.customerTitleComboBoxOptions = {
            dataSource: customerTitlesDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.customerTypeDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            var customerTypes = response.content;
                            var filteredCustomerTypes = [];

                            // Add only specific customerTypes
                            customerTypes.forEach(function (currentValue) {
                                if (currentValue.id === 1) {
                                    filteredCustomerTypes.push(currentValue);
                                }
                            });

                            // check application parameter Approvals
                            $http.get('/api/masterdata/application-parameters',
                                {params:{
                                    page: 1,
                                    pageSize: 1,
                                    filter : { filters: [{field: "name", operator: "eq",  value: "Patches"}] }}})
                                .success(function (response) {
                                    if (response.content.length > 0 && response.content[0].value === '1') {
                                        customerTypes.forEach(function (currentValue) {
                                            if (currentValue.id === 2) {
                                                filteredCustomerTypes.push(currentValue);
                                            }
                                        });
                                    }
                                    o.success(filteredCustomerTypes);
                                })
                                .error(function (response) {});
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.customerTypesMultiOptions = {
            dataSource: vm.customerTypeDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;

                if (vm.customer.saw === true) {
                    vm.isViewing = true;
                }

                if (vm.customer.isActive === true) {
                    vm.isCustomerActive = true;
                }

                if(vm.customer.dayTime !== null){
                    if(vm.customer.dayTime === "day") {
                        vm.customer.dayTime = "ΠΡΩΙΝΌ";
                    }else if(vm.customer.dayTime === "night"){
                        vm.customer.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                    }
                }
            })
            .error(function (response) {});

        var specialtyDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10000;
                    $http.get('/api/masterdata/doctor-specialties',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });

        //DropDown Options
        vm.specialtyComboBoxOptions = {
            dataSource: specialtyDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.subCategoryComboBoxOptions = {
            autoBind: false,
            dataSource: new kendo.Backbone.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get('/api/masterdata/customer-sub-categories',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                }
            }),
            valuePrimitive: true,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή Υποκατηγορίας..."
        };

        vm.categoryComboBoxOptions = {
            autoBind: false,
            dataSource: new kendo.Backbone.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get('/api/masterdata/customer-categories',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                }
            }),
            valuePrimitive: true,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή κατηγορίας..."
        };

        vm.update = function() {

            if (vm.isViewing === true) {
                vm.customer.saw = 1;
            } else {
                vm.customer.saw = 0;
            }

            if (vm.isCustomerActive === true) {
                vm.customer.isActive = 1;
            } else {
                vm.customer.isActive = 0;
            }

            if(vm.customer.dayTime !== null){
                if(vm.customer.dayTime === 1 || vm.customer.dayTime === "ΠΡΩΙΝΌ" ) {
                    vm.customer.dayTime = "day";
                }else if(vm.customer.dayTime === 2 || vm.customer.dayTime === "ΑΠΟΓΕΥΜΑΤΙΝΌ"){
                    vm.customer.dayTime = "night";
                }
            }


            if(vm.customer.customerSubCategory !== null){
                if(vm.customer.customerSubCategory.id === null) {
                    vm.customer.customerSubCategory = null;
                }
            }

            if(vm.customer.doctorSpecialty !== null){
                if(vm.customer.doctorSpecialty.id === null) {
                    vm.customer.doctorSpecialty = null;
                }
            }

            if(vm.customer.customerCategory !== null) {
                if (vm.customer.customerCategory.id === null) {
                    vm.customer.customerCategory = null;
                }
            }

            if (vm.validator.validate()) {
                $http.put('api/customers', vm.customer)
                    .success(function (response) {

                        if(response.dayTime !== null){
                            if(response.dayTime === "day") {
                                vm.customer.dayTime = "ΠΡΩΙΝΌ";
                            }else if(vm.customer.dayTime === "night"){
                                vm.customer.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                            }
                        }

                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                    })
                    .error(function (response) {});
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }

        };
    }

})();
;
/**
 * Created by Kristy on 3/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorHospitalization', {
                parent: 'recDoctorView',
                url: '/hospitalizations',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/recDoctors/hospitalization/hospitalization.html',
                controller: 'RecDoctorViewHospitalizationController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 3/7/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewHospitalizationController', RecDoctorViewHospitalizationController);

    RecDoctorViewHospitalizationController.$inject = [ '$stateParams', '$http', '$filter', 'KendoFilter' ];

    function RecDoctorViewHospitalizationController ( $stateParams, $http, $filter, KendoFilter ) {
        var vm = this;
        var grid = {};
        var recDoctorId = $stateParams.id;

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    o.data.filter.filters =
                        o.data.filter.filters.concat([ { "field": "customer.id", "operator": "eq", "value": recDoctorId } ]);

                    $http.get('/api/hospitalizations/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (item.sector === null) item.sector = {};
                            if (item.sector.sectorType === null) item.sector.sectorType = {};
                            if (item.clinicName === null) item.clinicName = {};
                            if (item.roomType === null) item.roomType = {};
                            if (item.finalRoomType === null) item.finalRoomType = {};
                            if (item.hospitalizationType === null) item.hospitalizationType = {};
                            if (item.customerTitle === null) item.customerTitle = {};
                            if (item.patient === null) item.patient = {};
                            if (item.customer === null) item.customer = {};
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateIssue: { type: "date" }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                field: "customer.lastName",
                title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.sectorType.name",
                title: "Τύπος Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customerTitle.name",
                title: "Τύπος Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "clinicName.name",
                title: "Κλινική",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "roomType.name",
                title: "Επιθυμητός Τύπος Δωματίου",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "finalRoomType.name",
                title: "Τελική Τοποθέτηση",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "hospitalizationType.name",
                title: "Παρατηρήσεις",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "notes",
                title: "Σχόλια",
                editor: function(container) {
                    angular.element('<textarea rows="3" cols="150" class = "k-textbox custom-popup-textarea pull-right" data-bind="value:notes"></textarea>')
                        .appendTo(container);
                },
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "dateIssue", title: "Ημερομηνία Εισαγωγής", template: "#= dateIssue ? kendo.toString(kendo.parseDate(dateIssue), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            }
        ];

        vm.hospitalizationsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.hospitalizationsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('recDoctorEvents', {
                parent: 'recDoctorView',
                url: '/events',
                data: {
                    authorities: ['ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.recDoctor.home.title'
                },
                templateUrl: 'app/displays/recDoctors/events/events.html',
                controller: 'RecDoctorViewEventsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 1/6/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RecDoctorViewEventsController', RecDoctorViewEventsController);

    RecDoctorViewEventsController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter'];

    function RecDoctorViewEventsController ($http, $state, $stateParams, $filter, Principal, KendoFilter) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;

        vm.googleMapsRedirect = function(dataItem) {
            if (dataItem.latitude !== 0 && dataItem.longitude !== 0) {
                window.open(
                    'http://maps.google.com/maps?q=' + dataItem.latitude + ',' + dataItem.longitude,
                    '_blank' //This is what makes it open in a new window.
                );
            }
        };

        vm.imageChoice = function(dataItem) {
            return !(dataItem.latitude === 0 && dataItem.longitude === 0);
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id === "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id === "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            if ( e.target !== undefined) {
                if (e.target[0].offsetParent.id === 'masterFiltersEvents') {
                    vm.eventsFrom = vm.from;
                    vm.eventsTo = vm.to;
                    vm.eventsGridOptions.dataSource.read();
                }
            } else {
                if ( vm.selectedTabStrip === 2) {
                    vm.eventsFrom = vm.from;
                    vm.eventsTo = vm.to;
                    vm.eventsGridOptions.dataSource.read();
                    angular.element("#eventsGrid").data("kendoGrid").dataSource.read();
                }
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value && vm.selectedTabStrip === 2) {
                    vm.eventsFrom = value;
                }
                vm.from = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value && vm.selectedTabStrip === 2) {
                    vm.eventsTo = value;
                }
                vm.to = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.eventsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "eventCustomerSector.customerSector.customer.id", "operator": "eq",  "value": vm.selectedUserId}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        //master filters functionality
                        if(vm.eventsFrom && vm.eventsTo) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "startedAt", "operator": "from",  "value": $filter('date')(vm.eventsFrom, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "startedAt", "operator": "to",  "value": $filter('date')(vm.eventsTo, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ]
                            );
                        }

                        $http.get('/api/me/events',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    parameterMap: function (data) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        if(data !== undefined) {
                            data.content.forEach(function(item){

                                if (item.eventStatus === null) item.eventStatus = { name: "" };

                                if(item.employee === null){
                                    item.employee = {
                                        account : {
                                            lastName : ""
                                        }
                                    }
                                }

                                if (item.eventCustomerSector === null) {
                                    if (item.agreementValuation === null) {
                                        item.agreementValuation = {
                                            name: ""
                                        };
                                    }

                                    if (item.customerSector === null) {
                                        item.customerSector = {
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    if (item.eventCustomerSector.agreementValuation === null) {
                                        item.eventCustomerSector.agreementValuation = {
                                            name: ""
                                        };
                                    }

                                    if (item.eventCustomerSector.customerSector === null) {
                                        item.eventCustomerSector.customerSector = {
                                            sector: {
                                                sectorType: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    } else {
                                        if (item.eventCustomerSector.customerSector.sector === null) {
                                            item.eventCustomerSector.customerSector.sector = {
                                                name: "",
                                                sectorType: {
                                                    name: ""
                                                }
                                            };
                                        } else {
                                            if (item.eventCustomerSector.customerSector.sector.sectorType === null) {
                                                item.eventCustomerSector.customerSector.sector.sectorType = {
                                                    name: ""
                                                };
                                            }
                                        }
                                    }
                                }

                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}} },
                            startedAt: { type: 'date'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50
            }),
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {field: "startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }},
                {field: "eventStatus.name", title: "Κατάσταση Επίσκεψης",attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "eventCustomerSector.agreementValuation.name", title: "Αξιολόγηση", template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null ) ? ' ' : eventCustomerSector.agreementValuation.name #",
                    attributes: {   class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {
                    command:[
                        {name:"map2", template: "<md-button class='md-fab md-mini md-primary' aria-label='Google Maps' " +
                        "ng-class='{googlemap: vm.imageChoice(dataItem.eventCustomerSector), errormap: !vm.imageChoice(dataItem.eventCustomerSector)}' ng-click='vm.googleMapsRedirect(dataItem.eventCustomerSector)'>" +
                        "</md-button>"
                        }
                    ],
                    attributes: { class: "#= 'link-cell-color' #" },
                    title: "Τοποθεσία",
                    width:120
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        { field: "eventCustomerSector.customerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "description", title: "Σημειώσεις",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }}
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.eventsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Kristy on 20/4/2017.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('PurchaseGrids', PurchaseGrids);

    PurchaseGrids.$inject = ['$filter', '$http', '$timeout', 'KendoGrid', 'PurchaseItem', 'KendoService', 'NotificationOptions', 'KendoNotifications', 'Alerts', '$window'];
    function PurchaseGrids ($filter, $http, $timeout, KendoGrid, PurchaseItem, KendoService, NotificationOptions, KendoNotifications, Alerts, $window) {
        var exportState;
        var isEditable;
        var dataSource = {};
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        dataSource.codesDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');
        dataSource.productsDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');

        var setEditVisibility = function( value ) {
            var purchaseItemsGrid = angular.element("#purchaseItemsGrid").data("kendoGrid");
            if (!value) {
                //hide delete command column and create button on toolbar
                purchaseItemsGrid.hideColumn(12);
                angular.element('#purchaseItemsGrid .k-grid-add').hide();
            } else {
                //show delete command column and create button on toolbar
                purchaseItemsGrid.showColumn(12);
                angular.element('#purchaseItemsGrid .k-grid-add').show();
            }
        };

        var purchaseItemsColumns = [
            {
                field: "button",
                title: " ",
                template: "<button class='md-raised md-primary md-button md-ink-ripple' ng-click='vm.addPurchaseItemLot(dataItem)' " +
                        "ng-disabled='dataItem.quantity <= dataItem.quantityExecuted'>" +
                        "<md-icon ng-bind='\"add\"' style='font-size: 20px;'></md-icon>Προσθήκη</button>",
                width: 150
            },
            {
                field: "product.code",
                title: "Κωδικός είδους",
                attributes: {class:"product-code"},
                template: "#= product.code ? product.code : ''#",
                editor: function(container) {
                    angular.element('<select id="productCode" data-bind="value:product"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.codesDataSource,
                            dataBound: function (e) {
                                var dataSource = e.sender.dataSource;
                                angular.forEach( dataSource.data(), function(item) {
                                    if (!item.code) {
                                        dataSource.remove(item);
                                    }
                                });
                            },
                            filter: "contains",
                            dataTextField: "code",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "product.name",
                title: "Περιγραφή είδους",
                template: "#= product ? product.name : ''#",
                editor: function(container) {
                    angular.element('<select id="productName" data-bind="value:product"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.productsDataSource,
                            filter: "contains",
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            // {
            //     field: "lotNumber",
            //     title: "Παρτίδες Φαρμάκων"
            // },
            {
                field: "quantity",
                title: "Ποσότητα",
                footerTemplate: "Σύνολο: #=kendo.format('{0:n0}', sum)#"
            },
            {
                field: "quantityExecuted",
                title: "Εκτελεσμένη Ποσότητα",
                editor: function(container,options){
                    angular.element("<input id='quantityExecuted' data-bind='value: quantityExecuted'>")
                        .appendTo(container)
                        .kendoNumericTextBox({ format:"{0:#}", min: 0 });
                },
                width: 200,
                footerTemplate: "Σύνολο: #=kendo.format('{0:n0}', sum)#"
            },
            {
                field: "productPrice",
                title: "Τιμή",
                attributes:{style:"text-align:right;"},
                template: "#= (productPrice == null) ? '' : kendo.format('{0:c}', productPrice)#"
            },
            {
                field: "totalPrice",
                title: "Μικτή Αξία",
                attributes:{style:"text-align:right;"},
                template: "#= (totalPrice == null) ? '' : kendo.format('{0:c}', totalPrice)#"
            },
            // {
            //     field: "discountPercent",
            //     title: "Έκπτωση(%)",
            //     template: "#= (discountPercent == null) ? '' : kendo.format('{0:p0}', discountPercent / 100)#"
            // },
            // {
            //     field: "discountPrice",
            //     title: "Έκπτωση",
            //     attributes:{style:"text-align:right;"},
            //     template: "#= (discountPrice == null) ? '' : kendo.format('{0:c}', discountPrice)#"
            // },
            // {
            //     field: "discountFinalPercent",
            //     title: "Συνολική Έκπτωση(%)",
            //     template: "#= (discountFinalPercent == null) ? '' : kendo.format('{0:p0}', discountFinalPercent / 100)#"
            // },
            {
                field: "discountSummary",
                title: "Συνολική έκπτωση",
                attributes:{style:"text-align:right;"},
                template: "#= (discountSummary == null) ? '' : kendo.format('{0:c}', discountSummary)#",
                width: "8%"
            },
            {
                field: "netPrice",
                title: "Καθαρή αξία",
                attributes:{style:"text-align:right;"},
                template: "#= (netPrice == null) ? '' : kendo.format('{0:c}', netPrice)#"
            },
            {
                field: "taxPrice",
                title: "Αξία Φ.Π.Α.",
                attributes:{style:"text-align:right;"},
                template: "#= (taxPrice == null) ? '' : kendo.format('{0:c}', taxPrice)#"
            },
            {
                field: "finalPrice",
                title: "Συνολική Αξία",
                attributes:{style:"text-align:right;"},
                template: "#= (finalPrice == null) ? '' : kendo.format('{0:c}', finalPrice)#"
            },
            {
                field: "edit",
                command: [
                    {name: "edit", text: ""}
                ],
                title: "&nbsp;",
                width: 110
            },
            {
                field: "destroy",
                command: [
                    {
                        name: "destroy", text: "",
                        template: "<button data-command='destroy' class='k-button k-button-icontext k-grid-delete' aria-label='Delete'>" +
                        "<i class='material-icons' style='vertical-align: inherit;color: rgb(255,87,34)'>delete_forever</i>" +
                        "</button>"
                    }
                ],
                title: "&nbsp;",
                width: 110
            }
        ];
        var purchasePresentItemsColumns = [
            {
                field: "button",
                title: " ",
                template: "<md-button class='md-raised md-primary md-button md-ink-ripple' ng-click='vm.addPurchasePresentItemLot(dataItem)' " +
                "ng-disabled='dataItem.quantity <= dataItem.quantityExecuted'>" +
                "<md-icon ng-bind='\"add\"' style='font-size: 20px;'></md-icon>Προσθήκη</md-button>",
                width: "8%"
            },
            {
                field: "product.name",
                title: "Προϊόν"
            },
            {
                field: "quantity",
                title: "Ποσότητα"
            },
            {
                field: "quantityExecuted",
                title: "Εκτελεσμένη Ποσότητα"
            },
            {
                field: "price",
                title: "Τιμή",
                template: "#= price ? price + ' €' : ''#"
            }
        ];

        var purchaseItemsDatasource = function (selectedPurchaseId) {
            return new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "purchase.id", "operator": "eq",  "value": selectedPurchaseId }
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/purchase-items/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function (o){
                        var data = o.data;
                        data.purchase = { id: selectedPurchaseId };
                        data.quantityExecuted = 0;
                        PurchaseItem.update(data,
                            function() {
                                KendoNotifications.onSaveSuccess(notification);
                                KendoGrid.refresh(angular.element("#purchaseItemsGrid").data("kendoGrid"));
                            },
                            function() { KendoNotifications.onSaveError(notification); });
                    },
                    update: function (o){
                        var data = o.data;
                        if(data.measurementUnit && !data.measurementUnit.id)
                            data.measurementUnit = null;
                        PurchaseItem.update(data, function() {
                            KendoGrid.refresh(angular.element("#purchaseItemsGrid").data("kendoGrid"));
                        }, function(error){
                            if (error.status && error.status === 409) {
                                Alerts.showConfirmDialog(null, $filter('translate')('error.purchaseItem.purchaseItemConcurrencyFailureTitle'),
                                    $filter('translate')('error.purchaseItem.purchaseItemConcurrencyFailureMessage'),
                                    false, $filter('translate')('entity.action.refresh'), $filter('translate')('entity.action.cancel'), function () {
                                        // on confirm
                                        $window.location.reload();
                                    }, function () {
                                        // on cancel
                                    });
                            }else {
                                KendoNotifications.onSaveError(notification);
                            }
                        });
                    },
                    destroy: function (o){
                        $http.delete('/api/purchase-items-with-purchase-item-lots/' + o.data.id)
                            .success(function () {
                                o.success(o.data.id);
                                KendoNotifications.onDeleteSuccess(notification);
                                KendoGrid.refresh(angular.element("#purchaseItemsGrid").data("kendoGrid"));
                            })
                            .error(function () { KendoNotifications.onDeleteError(notification); });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.product === null) item.product = {};
                                if (item.measurementUnit === null) item.measurementUnit = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true},
                            button: { editable: false, nullable: true},
                            product: { defaultValue: { id: null, code: "", name: "" } },
                            'measurementUnit.name': { editable: false, nullable: true},
                            quantity: { type: "number", editable: true, nullable: true, validation: { min: 0 }},
                            quantityExecuted: { editable: false, nullable: true, type: "number" },
                            productPrice: { editable: false, nullable: true},
                            totalPrice: { editable: false, nullable: true},
                            discountSummary: { editable: false, nullable: true},
                            netPrice: { editable: false, nullable: true},
                            taxPrice: { editable: false, nullable: true},
                            finalPrice: { editable: false, nullable: true}
                        }
                    }
                },
                aggregate: [{field: "quantity", aggregate: "sum"},
                    {field: "quantityExecuted", aggregate: "sum"}],
                sort: ({ field: "createdDate", dir: "desc" }),
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var purchasePresentItemsDatasource = function (selectedPurchaseId) {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "purchase.id", "operator": "eq",  "value": selectedPurchaseId }
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/purchase-present-items/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.product === null) item.product = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: "id"
                        }
                    }
                },
                pageSize: 500,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };

        var columnsToHide = ["productPrice", "totalPrice", "discountSummary", "netPrice", "taxPrice", "finalPrice"];
        return {
            getPurchasePresentItemsGridOptions: function ( selectedPurchaseId ) {
                return {
                    dataSource: purchasePresentItemsDatasource(selectedPurchaseId),
                    resizable: true,
                    columns:  purchasePresentItemsColumns,
                    toolbar: [
                        { template: "<div class='form-group left'><label class='control-label col-sm-2'>Ποσότητα: </label>" +
                            "<div class='col-sm-6 col-lg-3'>" +
                            "<input kendo-numeric-text-box id='quantityLot' k-options='vm.options' ng-model='vm.quantityLot' class='currency-alignment' min='0'/>" +
                            "</div></div>" },
                        { template: "<div class='form-group left'><label class='control-label col-sm-2'>Barcode: </label>" +
                            "<div class='col-sm-6 col-lg-3'>" +
                            "<input id='barcode' class='k-textbox' name='barcode' ng-model='vm.barcode'/></div></div>" },
                        { template: "<div class='form-group left'><md-button style='margin: 0!important;' class='md-raised md-primary md-button md-ink-ripple' aria-label='submit' ng-click='vm.addPresentProductLots()'>" +
                            "<md-icon ng-bind='\"add\"' style='font-size: 20px;'></md-icon>Καταχώρηση</md-button></div>" },
                        { name: "refresh", template: "<div class='right'><md-button style='padding: 0!important;' class='md-icon-button md-accent md-warn' aria-label='refresh' ng-click='vm.kendoGrid.refresh(vm.purchasePresentItemsGridOptions)'>" +
                            "<md-icon class='material-icons'>refresh</md-icon></md-button></div>" }
                    ]
                };
            },
            getPurchaseItemsGridOptions: function ( selectedPurchaseId ) {
                return {
                    dataSource: purchaseItemsDatasource(selectedPurchaseId),
                    save: function () {
                        var grid = this;
                        $timeout(function () {
                            grid.refresh();
                        })
                    },
                    navigatable: true,
                    resizable: true,
                    columns:  purchaseItemsColumns,
                    toolbar: [
                        { template: "<div class='form-group left'><label class='control-label col-sm-2'>Ποσότητα: </label>" +
                        "<div class='col-sm-6 col-lg-3'>" +
                        "<input kendo-numeric-text-box id='quantityLot' k-options='vm.options' ng-model='vm.quantityLot' class='currency-alignment' min='0' />" +
                        "</div></div>" },
                        { template: "<div class='form-group left'><label class='control-label col-sm-2'>Barcode: </label>" +
                        "<div class='col-sm-6 col-lg-3'>" +
                        "<input id='barcode' class='k-textbox' name='barcode' ng-model='vm.barcode'/></div></div>" },
                        { template: "<div class='form-group left'><md-button style='margin: 0!important;' class='md-raised md-primary md-button md-ink-ripple' aria-label='submit' ng-click='vm.addProductLots()'>" +
                        "<md-icon ng-bind='\"add\"' style='font-size: 20px;'></md-icon>Καταχώρηση</md-button></div>" },
                        { name: "refresh", template: "<div class='right'><md-button style='padding: 0!important;' class='md-icon-button md-accent md-warn' aria-label='refresh' ng-click='vm.kendoGrid.refresh(vm.purchaseItemsGridOptions)'>" +
                        "<md-icon class='material-icons'>refresh</md-icon></md-button></div>" },
                        { name: "excel", template: "<div class='right'><md-button style='margin: 0!important;' class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                        "<span class='k-icon k-i-excel'></span>Export</md-button></div>" },
                        { template: "<div class='clearfix'></div>" },
                        { name :"create", text: "Προσθήκη Νέας Γραμμής" }
                    ],
                    excel: {
                        allPages: true,
                        fileName: "Γραμμές Παραγγελιών.xlsx"
                    },
                    pageable: true,
                    editable: {
                        mode: "inline",
                        confirmation: false // the confirmation message for destroy command
                    },
                    edit: function(e) {
                        if (!e.model.isNew()) {
                            angular.element("#productCode").kendoComboBox({ enable: false });
                            angular.element("#productName").kendoComboBox({ enable: false });

                            angular.element("#productCode").data("kendoComboBox").text(e.model.product.code);
                            angular.element("#productName").data("kendoComboBox").text(e.model.product.name);
                        }
                        KendoGrid.defaultEditInline(this._editContainer);
                    },
                    excelExport: function(e) {
                        e.preventDefault();
                        setTimeout(function () {
                            $("#purchaseItemLotsGrid").data("kendoGrid").saveAsExcel();
                        });
                    }
                };
            },
            getExportState: function() {
                return exportState;
            },
            setExportState: function( value ) {
                exportState = value;
            },
            getQuantityDefaultValue: function( quantity, data, dataItem ) {
                var defaultValue = quantity;
                angular.forEach( data, function (item) {
                    if (dataItem.id != item.id) {
                        defaultValue -= item.quantity;
                    }
                });
                return defaultValue;
            },
            setIsEditable: function( value ) {
                isEditable = value;
                setEditVisibility(isEditable)
            },
            setVisibility: function(isStorehouse) {
                var purchaseItemsGrid = angular.element("#purchaseItemsGrid").data("kendoGrid");
                if (isStorehouse && purchaseItemsGrid) {
                    //hide columns from ROLE_STOREHOUSE
                    angular.forEach( purchaseItemsGrid.columns, function (item, index) {
                        if( columnsToHide.indexOf( item.field ) !== -1 ) {
                            purchaseItemsGrid.hideColumn(index);
                        }
                    });
                }
            }
        };

    }
})();
;
/**
 * Created by gmogas on 18/1/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseViewController', PurchaseViewController);

    PurchaseViewController.$inject = ['$window', '$q', '$state', '$http','KendoService', 'KendoFilter', '$stateParams', 'Principal', 'NotificationOptions', 'Purchase', 'PurchaseGrids', '$timeout', 'employees', 'Alerts', '$filter', 'purchase'];

    function PurchaseViewController ($window, $q, $state, $http, KendoService, KendoFilter, $stateParams, Principal, NotificationOptions, Purchase, PurchaseGrids, $timeout, employees, Alerts, $filter, purchase) {
        var vm = this;
        vm.purchase = parsePurchase(purchase);
        vm.employees = employees;
        vm.purchaseGrids = PurchaseGrids;
        vm.purchaseGrids.setExportState(false);
        vm.sectorSearchWindowVisible = false;
        vm.selectedTab = 'purchaseItems'; // indicates which tab is selected for show/hide export button

        vm.selectedPurchaseId = $stateParams.id;
        vm.$state = $state;
        vm.pageHeading = 'Επεξεργασια Παραγγελιας: ' + vm.selectedPurchaseId;
        vm.options = {
            spinners: false,
            format: "c2",
            decimals: 2
        };

        Principal.hasAuthority('ROLE_STOREHOUSE').then( function (result) { vm.isStorehouse = !!result; });

        var sectorSearchWindow = angular.element('#sectorSearchWindow');

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        var purchaseStatusDataSource =  new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get( '/api/masterdata/purchase-statuses',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            sort: { field: "code", dir: "asc" }
        });
        var purchaseItemsColumnsHidden = [ "button", "quantityExecuted", "productPrice", "netPrice", "discountPercent", "discountPrice",
            "discountFinalPercent", "discountFinalPrice", "totalPrice", "discountSummary", "edit", "delete",
            "taxPrice", "finalPrice"];
        var purchasePresentItemsColumnsHidden = [ "button"];

        var employeesDataSource = new kendo.data.DataSource({
            data: vm.employees,
            schema: {
                parse: function (employeesArray) {
                    if (employeesArray && employeesArray.length > 0){
                        var length = employeesArray.length;
                        var dataItem;
                        var idx = 0;
                        for (; idx < length; idx++) {
                            dataItem = employeesArray[idx];
                            dataItem.fullName = dataItem.account.lastName + " " + dataItem.account.firstName;
                        }
                    }

                    return employeesArray;
                }
            }
        });
        vm.employeesComboBoxOptions = KendoService.initDefaultOptions(employeesDataSource, "startswith", "fullName", "id", false);
        vm.employeesComboBoxOptions.cascade = function () { vm.purchase.employee = this.dataItem(); };

        vm.purchaseStatusOptions = {
            dataSource: purchaseStatusDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.pickerDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_STOREHOUSE" }
                        ]
                    );
                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee= {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        }
                    });
                    return data;
                }
            }
        });

        vm.pickerDirty = false;
        vm.pickerOptions = {
            dataSource: vm.pickerDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή αποθηκάριου",
            change: function () {
                vm.pickerDirty = true;
            }
        };

        vm.dataSource = {};
        vm.dataSource.paymentMethods = KendoService.initDefaultDataSource('/api/payment-methods/search');
        vm.paymentMethodOptions = {
            dataSource: vm.dataSource.paymentMethods,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή τρόπου πληρωμής"
        };

        var sectorTypeCategories = ["pharmacy", "beautyCenter"];
        vm.dataSource.sectorsDataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) o.data.filter = { filters: [] };

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "sectorType.sectorTypeCategory", "operator": "in",
                                "value": sectorTypeCategories.toString() }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                        }
                    });

                    $http.get('/api/me/sectors',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema : {
                data: function (data) {
                    angular.forEach( data.content, function (item) {
                        if ( item.companyType == null ) {
                            item.companyType = {};
                        }
                        if ( item.taxStatus == null ) {
                            item.taxStatus = {};
                        }
                        if ( item.taxOffice == null ) {
                            item.taxOffice = {};
                        }
                    });
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        name : { editable: false },
                        vat : { editable: false },
                        address : { editable: false },
                        addressNum : { editable: false },
                        cityName : { editable: false },
                        prefectureName : { editable: false },
                        brick : { editable: false },
                        osfeBrick : { editable: false },
                        phone : { editable: false },
                        createdDate: { type: 'date', editable: false},
                        companyType: { defaultValue: { id: null, name: null }},
                        taxStatus: { defaultValue: { id: null, name: null }},
                        taxOffice: { defaultValue: { id: null, name: null }},
                        creditControlCheck: { type: "boolean" }
                    }
                }
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        vm.sectorsComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.sectorsDataSource, "startswith", "name", "id");
        vm.sectorsComboBoxOptions.valuePrimitive = false;
        vm.sectorsComboBoxOptions.autoBind = false;
        vm.sectorsComboBoxOptions.change = function() {
            $timeout( function() { if(vm.purchase.sector) vm.purchase.sector.shippingAddress = vm.purchase.sector.address; });
            if(vm.purchase.sector) {
                if (vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            }
        };
        vm.onSectorsGridSelection = function(e) {
            e.preventDefault();
            var data = this.dataItem(angular.element(e.currentTarget).closest("tr"));

            $timeout( function() {
                vm.purchase.sector = data;
                vm.purchase.sector.shippingAddress = vm.purchase.sector.address;
                if(vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            });
            angular.element("#sectorName").data('kendoComboBox').text(data.name);
            sectorSearchWindow.data("kendoWindow").close();
        };
        vm.sectorSearchWindowOptions = {
            title: "Επιλέξτε επαγγελματία υγείας",
            visible: false,
            modal: true,
            width: '90%'
        };
        vm.sectorsColumns = [
            {
                field: "code",
                title: "Κωδικός Ε.Ε.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "name",
                title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sectorType.sectorTypeCategory",
                title: "Τύπος",
                template: "#= (sectorType.sectorTypeCategory == 'beautyCenter') ? 'Κέντρο Αισθητικής' : (sectorType.sectorTypeCategory == 'pharmacy') ? 'Φαρμακείο' : '' #",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Κέντρο Αισθητικής", value: "beautyCenter" },
                                        { text: "Φαρμακείο", value: "pharmacy" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.creditControlCheck" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }},
            {
                command: {
                    text: "Επιλογή",
                    click: vm.onSectorsGridSelection
                }
            }
        ];
        vm.sectorsGridOptions = {
            autoBind: false,
            dataSource: vm.dataSource.sectorsDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns:  vm.sectorsColumns
        };

        vm.openSectorsGrid = function() {
            sectorSearchWindow.data("kendoWindow").center().open();
            vm.sectorSearchWindowVisible = true;
            vm.sectorsGridOptions.dataSource.read();
        };

        vm.closeSectorsGrid = function() {
            vm.sectorSearchWindowVisible = false;
        };

        vm.update = function(ev) {
            if(vm.purchase.picker && vm.pickerDirty) { vm.purchase.picker.id = vm.purchase.picker.fullName; }
            if(vm.purchase.picker) {
                if(!vm.purchase.picker.id) { vm.purchase.picker = null; }
            }
            if(vm.purchase.paymentMethod) {
                if(!vm.purchase.paymentMethod.id) { vm.purchase.paymentMethod = null; }
            }
            vm.purchase.issueDate = kendo.toString(kendo.parseDate(vm.purchase.issueDate), 'yyyy-MM-dd');
            if (vm.purchase.desirableExecutionDate !== null &&
                vm.purchase.desirableExecutionDate !== undefined &&
                vm.purchase.desirableExecutionDate !== ""){
                vm.purchase.desirableExecutionDate = kendo.toString(kendo.parseDate(vm.purchase.desirableExecutionDate), 'yyyy-MM-dd');
            }

            if (vm.validator.validate()) {
                Purchase.update(vm.purchase).$promise.then(
                    //success
                    function(response){
                        vm.purchase = parsePurchase(response);
                        if (vm.purchase.purchaseStatus) {
                            PurchaseGrids.setIsEditable(vm.purchase.purchaseStatus.isEditable);
                        }

                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                    },
                    //error
                    function( error ){
                        if (error.status && error.status === 409) {
                            Alerts.showConfirmDialog(ev, $filter('translate')('error.purchase.purchaseConcurrencyFailureTitle'),
                                $filter('translate')('error.purchase.purchaseConcurrencyFailureMessage'),
                                false, $filter('translate')('entity.action.refresh'), $filter('translate')('entity.action.cancel'), function () {
                                // on confirm
                                $window.location.reload();
                            }, function () {
                                // on cancel
                            });
                        }else {
                            notification.show({
                                message: $filter('translate')('error.purchase.updateFailedMessage')
                            }, "error");
                        }
                    }
                );
            } else {
                notification.show({
                    message: $filter('translate')('error.purchase.validateFailedMessage')
                }, "error");
            }
        };

        vm.hideColumnsForPDF = function(hide, gridId, columnsHidden) {
            var hideColumnsDefer = $q.defer();
            var grid = angular.element('#' + gridId).data('kendoGrid');
            if (grid) {
                if (vm.isStorehouse && gridId === 'purchaseItemsForPDFGrid') columnsHidden.push("product.code");
                angular.forEach( grid.columns, function (item, index) {
                    if( columnsHidden.indexOf( item.field ) !== -1 ) {
                        if (hide) {
                            grid.hideColumn(index);
                        } else {
                            grid.showColumn(index);
                        }
                    }
                });
                hideColumnsDefer.resolve(true);
            }
            return hideColumnsDefer.promise;
        };

        vm.hideToolbarForPDF = function(hide) {
            var hideToolbarDefer = $q.defer();
            if (hide) angular.element("#purchaseItemsForPDFGrid .k-grid-toolbar").hide();
            else angular.element("#purchaseItemsForPDFGrid .k-grid-toolbar").show();
            hideToolbarDefer.resolve(true);
            return hideToolbarDefer.promise;
        };

        vm.increaseFontSizeForPDF = function (increase) {
            var increaseFontSizeDefer = $q.defer();
            if (increase){
                angular.element("#pdf-wrapper").css({'font-size':'180%'});
            }else {
                angular.element("#pdf-wrapper").css({'font-size':'100%'});
            }
            increaseFontSizeDefer.resolve(true);
            return increaseFontSizeDefer.promise;
        };

        vm.adjustColumnsForPDF = function(adjust, gridId) {
            var adjustColumnsDefer = $q.defer();
            var grid = angular.element('#' + gridId).data('kendoGrid');
            if (grid){
                var newOptions = angular.extend({}, grid.getOptions());

                angular.forEach( grid.columns, function (item, index) {
                    if (item.field === "product.code"){
                        //newOptions.columns[index].width = adjust ? "15%" : "auto";
                        newOptions.columns[index].width = adjust ? 130 : "auto";
                    }else if (item.field === "product.name"){
                        //newOptions.columns[index].width = adjust ? "75%" : "auto";
                        newOptions.columns[index].width = adjust ? 500 : "auto";
                    }else if (item.field === "quantity"){
                        //newOptions.columns[index].width = adjust ? "10%" : "auto";
                        newOptions.columns[index].width = adjust ? 60 : "auto";
                    }
                });

                adjustColumnsDefer.resolve(true);
                grid.setOptions(newOptions);
            }
            return adjustColumnsDefer.promise;
        };

        vm.exportPDF = function() {
            vm.purchaseGrids.setExportState(true);

            $q.all([
                vm.hideColumnsForPDF(true, 'purchaseItemsForPDFGrid', purchaseItemsColumnsHidden),
                vm.hideColumnsForPDF(true, 'purchasePresentItemsGrid', purchasePresentItemsColumnsHidden),
                vm.adjustColumnsForPDF(true, 'purchaseItemsForPDFGrid'),
                vm.hideToolbarForPDF(true),
                vm.increaseFontSizeForPDF(true),
                angular.element("#purchaseItemsGrid").data("kendoGrid").dataSource.read()
            ])
            .then(function() {
                kendo.drawing.drawDOM(angular.element("#pdf-wrapper"))
                    .then(function(group) {
                        // Render the result as a PDF file
                        return kendo.drawing.exportPDF(group, {
                            paperSize: "auto",
                            margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }
                        });
                    })
                    .done(function(data) {
                        kendo.saveAs({
                            dataURI: data,
                            fileName: "Παραγγελία.pdf"
                        });

                        $timeout(function (){
                            vm.purchaseGrids.setExportState(false);
                        }, 0);
                        vm.hideColumnsForPDF(false, 'purchaseItemsForPDFGrid', purchaseItemsColumnsHidden);
                        vm.hideColumnsForPDF(false, 'purchasePresentItemsGrid', purchasePresentItemsColumnsHidden);
                        vm.adjustColumnsForPDF(false, 'purchaseItemsForPDFGrid');
                        vm.hideToolbarForPDF(false);
                        vm.increaseFontSizeForPDF(false);
                        $window.location.reload();
                    });
            });
        };

        vm.onTabStripClick = function (selectedTab) {
            vm.selectedTab = selectedTab;
        };

        vm.goBack = function () {
            $state.go('purchases');
        };

        function parsePurchase(p) {
            if(p.netPrice) vm.netPrice = p.netPrice.toLocaleString();
            if(p.discountFinalPrice) vm.discountFinalPrice = p.discountFinalPrice.toLocaleString();
            if(p.totalPrice) vm.totalPrice = p.totalPrice.toLocaleString();
            if(p.taxPrice) vm.taxPrice = p.taxPrice.toLocaleString();
            if(p.finalPrice) vm.finalPrice = p.finalPrice.toLocaleString();

            if (!p.shippingAddressNum) p.shippingAddressNum = "";
            if (!p.shippingPostalCode) p.shippingPostalCode = "";

            p.fullAddress = p.shippingAddress + " "
                + p.shippingAddressNum + " "
                + p.shippingCityName + " "
                + p.shippingPrefectureName + " "
                + p.shippingCountryName + " "
                + p.shippingPostalCode;

            if (p.picker) {
                p.picker.fullName = p.picker.account.lastName + " " + p.picker.account.firstName
            }

            return angular.copy(p);
        }
    }
})();
;
/**
 * Created by gmogas on 11/1/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchases', {
                parent: 'app',
                url: '/purchases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_STOREHOUSE', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/purchases/purchases.html',
                        controller: 'PurchasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchaseView', {
                abstract: true,
                parent: 'app',
                url: '/purchases/search?id:purchaseId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_STOREHOUSE', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/purchases/purchaseView.html',
                        controller: 'PurchaseViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employees: ['Employee', function (Employee) {
                        return Employee.query({page: 0, size: 300}).$promise;
                    }],
                    purchase: ['$http', '$stateParams', function ($http, $stateParams) {
                        return $http.get('api/purchases/' + $stateParams.id).then(function (response) {
                            return response.data;
                        });
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchaseNew', {
                parent: 'app',
                url: '/purchases/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_STOREHOUSE', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/purchases/purchaseNew.html',
                        controller: 'PurchaseNewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employees: ['Employee', function (Employee) {
                        return Employee.query({page: 0, size: 300}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchasesBacklog', {
                parent: 'app',
                url: '/purchases/backlog',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_STOREHOUSE', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/purchases/purchaseBacklog.html',
                        controller: 'PurchaseBacklogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchaseAccountingView', {
                parent: 'app',
                url: '/purchases/accountingSearch?id:purchaseId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_STOREHOUSE', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/purchases/purchaseAccountingView.html',
                        controller: 'PurchaseAccountingViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employees: ['Employee', function (Employee) {
                        return Employee.query({page: 0, size: 300}).$promise;
                    }],
                    purchase: ['$http','$stateParams', function ($http, $stateParams) {
                        return $http.get('api/purchases/' + $stateParams.id).then(function (response) {
                            return response.data;
                        });
                    }],
                    purchaseItems: ['$http','$stateParams', function ($http, $stateParams) {
                        return $http.get('/api/purchase-items/search',
                            {params: {
                                    filter: {
                                        filters: [{
                                            field: "purchase.id",
                                            operator: "eq",
                                            value: $stateParams.id
                                        }]
                                    }
                                }}).then(function (response) {
                                    return response.data.content});
                    }],
                    purchasePresentItems: ['$http','$stateParams', function ($http, $stateParams) {
                        return $http.get('/api/purchase-present-items/search',
                            {params: {
                                    filter: {
                                        filters: [{
                                            field: "purchase.id",
                                            operator: "eq",
                                            value: $stateParams.id
                                        }]
                                    }
                                }}).then(function (response) {
                            return response.data.content});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
;
/**
 * Created by gmogas on 11/1/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesController', PurchasesController);

    PurchasesController.$inject = ['$http','$state','$filter', 'Principal', 'KendoService', 'KendoFilter','KendoGrid', 'ApplicationParameters', 'CustomUtils'];

    function PurchasesController ($http, $state, $filter, Principal, KendoService, KendoFilter, KendoGrid, ApplicationParameters, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(64);
        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        vm.principal = Principal;
        vm.pageHeading = 'Παραγγελιες';
        vm.disabled = false;
        vm.validation = true;
        var purchasesGrid = angular.element('#purchasesGrid');
        var dataSource = {};
        vm.showProgress = false;

        dataSource.purchaseStatusDataSource = KendoService.initDefaultDataSource('/api/masterdata/purchase-statuses');
        vm.purchaseStatusOptions = KendoService.initDefaultOptions(dataSource.purchaseStatusDataSource, "startswith", "name", "id");
        vm.purchaseStatusOptions.change = function() { KendoGrid.refresh(vm.purchasesGridOptions); };
        vm.purchaseStatusOptions.dataBound = function () {
            var self = this;
            Principal.hasAuthority('ROLE_STOREHOUSE').then( function (result) {
                if (result) {
                    self.select(3);
                    self.trigger("change");
                }
                vm.disabled = !!result;
                KendoGrid.refresh(vm.purchasesGridOptions);
            });
        };

        function getPurchaseAddress (sector) {
            return {
                shippingAddress: sector.address,
                shippingAddressNum:  secto.addressNum,
                shippingCityName:  sector.cityName,
                shippingPrefectureName:  sector.prefectureName,
                shippingCountryName:  sector.countryName,
                shippingPostalCode:  sector.postalCode
            }
        }

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            purchasesGrid.data("kendoGrid").dataSource.read();
        };

        vm.purchasesColumns = [];
        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_ACCOUNTING_DEP'])){
            vm.purchasesColumns = [
                {
                    field: "issueDate",
                    title: "Ημερομηνία",
                    template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }/*,
                    width: 50*/
                },
                {
                    field: "purchaseStatus.name",
                    title: "Κατάσταση",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 60*/
                },
                {
                    field: "employee.account.firstName",
                    title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 70*/
                },
                {
                    field: "employee.account.lastName",
                    title: "Επίθετο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 70*/
                },
                {
                    field: "sector.name",
                    title: "Επαγγελματίας Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 120*/
                },
                {
                    field: "sector.vat",
                    title: "Α.Φ.Μ Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 40*/
                },
                {
                    field: "sector.companyType.name",
                    title: "Εταιρική μορφή",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 60*/
                },
                {
                    field: "comment",
                    title: "Σχόλια",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 100*/
                },
                {
                    field: "finalPrice",
                    title: "Σύνολο",
                    template: "#= kendo.format('{0:c}', finalPrice || 0) #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 50*/
                },
                {
                    field: "picker.account.firstName",
                    title: "Όνομα Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 70*/
                },
                {
                    field: "picker.account.lastName",
                    title: "Επίθετο Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 70*/
                },
                {
                    field: "eventComments",
                    title: "Σχόλια Event",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }/*,
                    width: 100*/
                },
                { command: { text: "ΕΠΕΞΕΡΓΑΣΙΑ ΑΠΟ \n ΛΟΓΙΣΤΗΡΙΟ", click: accountingEdit }, title: " ", width: "180px" }
            ];
        }else if (Principal.hasAnyAuthority(['ROLE_STOREHOUSE'])){
            vm.purchasesColumns = [
                {
                    field: "issueDate",
                    title: "Ημερομηνία",
                    template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "purchaseStatus.name",
                    title: "Κατάσταση",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "employee.account.firstName",
                    title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "employee.account.lastName",
                    title: "Επίθετο",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.name",
                    title: "Επαγγελματίας Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.vat",
                    title: "Α.Φ.Μ Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.companyType.name",
                    title: "Εταιρική μορφή",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "comment",
                    title: "Σχόλια",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "picker.account.firstName",
                    title: "Όνομα Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "picker.account.lastName",
                    title: "Επίθετο Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "finalPrice",
                    title: "Σύνολο",
                    template: "#= kendo.format('{0:c}', finalPrice || 0) #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "eventComments",
                    title: "Σχόλια Event",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ];
        } else {
            vm.purchasesColumns = [
                {
                    field: "issueDate",
                    title: "Ημερομηνία",
                    template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "purchaseStatus.name",
                    title: "Κατάσταση",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "employee.account.firstName",
                    title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "employee.account.lastName",
                    title: "Επίθετο",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.name",
                    title: "Επαγγελματίας Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.vat",
                    title: "Α.Φ.Μ Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sector.companyType.name",
                    title: "Εταιρική μορφή",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "comment",
                    title: "Σχόλια",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "finalPrice",
                    title: "Σύνολο",
                    template: "#= kendo.format('{0:c}', finalPrice || 0) #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "picker.account.firstName",
                    title: "Όνομα Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "picker.account.lastName",
                    title: "Επίθετο Αποθηκάριου",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "eventComments",
                    title: "Σχόλια Event",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
            ];
        }

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                },
                {
                    template: "<label>Κατάσταση: </label><select id='purchaseStatus' name='purchaseStatus' class='inline' kendo-combo-box='vm.purchaseStatusCombo' " +
                    "k-options='vm.purchaseStatusOptions' k-ng-model='vm.purchaseStatus'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.from = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.to = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.onAddPurchaseClick = function () {
            $state.go('purchaseNew');
        };

        vm.onExcelExportClick = function () {
            const grid = $("#purchasesGrid").data("kendoGrid");
            grid.saveAsExcel();
            vm.showProgress = true;
        };

        const exportedColumns = [
            "issueDate",
            "employee.account.firstName",
            "employee.account.lastName",
            "sector.name", "sector.vat",
            "purchaseStatus.name",
            "comment"
        ];
        var exportFlag = false;
        vm.purchasesGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        //master filters functionality
                        if(vm.from && vm.to) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "issueDate", "operator": "fromdate",
                                        "value": vm.from },
                                    { "field": "issueDate", "operator": "todate",
                                        "value": vm.to }
                                ]
                            );
                        }

                        if (vm.purchaseStatus) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "purchaseStatus.id", "operator": "eq",
                                        "value": vm.purchaseStatus }
                                ]
                            );
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/purchases/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        data.picker = null;
                        data.employee = vm.employee;
                        if(!data.paymentMethod.id) data.paymentMethod = null;

                        angular.extend(data, getPurchaseAddress(data.sector));

                        $http.post('/api/purchases', data)
                            .success(function (response) {
                                o.success(response);

                                var purchaseItems = vm.purchaseItemsOptions.dataSource.data();
                                angular.forEach( purchaseItems, function (item) {
                                    item.quantityExecuted = 0;
                                });
                                angular.forEach(purchaseItems, function(item) {
                                    item.purchase = { id: response.id };
                                });

                                $http.post('/api/purchase-items/list', purchaseItems)
                                    .success(function (response) {
                                        o.success(response);
                                        KendoGrid.refresh(vm.purchasesGridOptions);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content) {
                            angular.forEach(data.content, function(item) {
                                if(!item.picker) item.picker = { account: {} };
                                if(!item.purchaseStatus) item.purchaseStatus = { name: "" };
                                if(!item.sector) item.sector = { name: "" };
                                if(!item.sector.companyType) item.sector.companyType = { name: "" };
                            })

                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: "id",
                            issueDate: { type: 'date', defaultValue: new Date()},
                            purchaseStatus: { defaultValue: { id: null, name: "" }},
                            paymentMethod: { defaultValue: { id: null, name: "" }},
                            employee: { defaultValue: { account: { firstName: "", lastName: "" } } },
                            sector: { defaultValue: { name: "", companyType: {name:""} }},
                            picker: { defaultValue: { account: { firstName: "", lastName: "" } } },
                            purchaseNumberingRow: { defaultValue: { id: null, name: "" }}
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                sort: { field: "issueDate", dir: "desc" },
                scrollable:false,
                serverFiltering :true
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Παραγγελίες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Παραγγελίες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            height: vm.contentHeight,
            columns:  vm.purchasesColumns,
            noRecords: {
                template: "Δεν βρέθηκαν Παραγγελίες"
            },
            excel: {
                allPages: true,
                fileName: "Παραγγελίες.xlsx"
            },
            excelExport: function (e) {
                if (!exportFlag){
                    for (var i=0; i<e.sender.columns.length; i++) {
                        if (exportedColumns.indexOf(e.sender.columns[i].field) === -1) {
                            e.sender.hideColumn(i);
                        }
                    }

                    e.preventDefault();
                    exportFlag = true;
                    setTimeout(function () {
                        e.sender.saveAsExcel();
                    });
                }else {
                    for (var j=0; j<e.sender.columns.length; j++) {
                        if (exportedColumns.indexOf(e.sender.columns[j].field) === -1) {
                            e.sender.showColumn(j);
                        }
                    }
                    exportFlag = false;
                    vm.showProgress = false;
                }
            }
        };

        vm.onSelection = function(data) {
            var selectedId = data.id;
            $state.go('purchaseItems', {id: selectedId});
        };

        function accountingEdit(e){
            e.preventDefault();
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            $state.go('purchaseAccountingView', {id: dataItem.id});
        }
    }
})();
;
/**
 * Created by Kristy on 24/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasePresentItems', {
                parent: 'purchaseView',
                url: '/purchasePresentItems',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/purchases/purchasePresentItems/purchasePresentItems.html',
                controller: 'PurchasePresentItemsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchase');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemsController', PurchasePresentItemsController);

    PurchasePresentItemsController.$inject = ['PurchasePresentItemLot', '$http', '$filter', '$timeout', '$stateParams', 'PurchaseGrids', 'KendoGrid', 'KendoFilter', 'KendoNotifications', 'PurchasePresentItem', 'ApplicationParameters', 'Principal', 'Alerts', '$window'];

    function PurchasePresentItemsController (PurchasePresentItemLot, $http, $filter, $timeout, $stateParams, PurchaseGrids, KendoGrid, KendoFilter, KendoNotifications, PurchasePresentItem, ApplicationParameters, Principal, Alerts, $window) {
        var vm = this;
        var firstTime = true;
        vm.showProgress = false;

        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        vm.selectedPurchaseId = $stateParams.id;
        vm.purchaseGrids = PurchaseGrids;
        vm.kendoGrid = KendoGrid;
        vm.purchasePresentItemsGridHeading = $filter('translate')('sigmasfApp.purchase.purchasePresentItemsGrid.title');
        vm.purchaseItemsGridHeading = $filter('translate')('sigmasfApp.purchase.purchaseItemsGrid.title');
        vm.quantityLot = 1;
        vm.options = {
            format: "n2",
            decimals: 2
        };

        vm.purchasePresentItemsGridOptions = PurchaseGrids.getPurchasePresentItemsGridOptions(vm.selectedPurchaseId);
        vm.purchasePresentItemsGridOptions.dataBound = function () {
            Principal.hasAuthority('ROLE_STOREHOUSE').then(function (result) {
                if (result === true){
                    // Hide 'price' column for ROLE_STOREHOUSE
                    var index = null;
                    if (vm.purchasePresentItemsGridOptions && vm.purchasePresentItemsGridOptions.columns &&
                        vm.purchasePresentItemsGridOptions.columns.length > 0){
                        for (var i=0; i<vm.purchasePresentItemsGridOptions.columns.length; i++){
                            if (vm.purchasePresentItemsGridOptions.columns[i].field === 'price'){
                                index = i;
                                break;
                            }
                        }
                        if (index !== null){
                            angular.element("#purchasePresentItemsGrid").data("kendoGrid").hideColumn(index);
                        }
                    }
                    // Also hide 'price' column for ROLE_STOREHOUSE from purchaseItemsForPDFGrid
                    if (vm.purchaseItemsForPDFGridOptions && vm.purchaseItemsForPDFGridOptions.columns &&
                        vm.purchaseItemsForPDFGridOptions.columns.length > 0){
                        for (var j=0; j<vm.purchaseItemsForPDFGridOptions.columns.length; j++){
                            if (vm.purchaseItemsForPDFGridOptions.columns[j].field === 'price'){
                                index = j;
                                break;
                            }
                        }
                        if (index !== null){
                            angular.element("#purchaseItemsForPDFGrid").data("kendoGrid").hideColumn(index);
                        }
                    }
                }
            });
        };
        // vm.purchaseItemsGridOptions = PurchaseGrids.getPurchaseItemsGridOptions(vm.selectedPurchaseId);
        vm.purchaseItemsForPDFGridOptions = PurchaseGrids.getPurchaseItemsGridOptions(vm.selectedPurchaseId);

        vm.addPurchasePresentItemLot = function(dataItem) {
            //expand row
            var grid = angular.element("#purchasePresentItemsGrid");
            var row = grid.find("[data-uid=" + dataItem.uid +"]");
            grid.data("kendoGrid").expandRow(row);

            //add row in detailed grid
            var detailedGrid = row.next('tr').find('#detailGrid');
            $timeout(function (){
                detailedGrid.data("kendoGrid").addRow();
            }, 500);
        };

        vm.addPresentProductLots = function(){
            var data = {
                quantity: vm.quantityLot,
                idNumber: vm.barcode,
                purchaseId: vm.selectedPurchaseId
            };

            var request = {
                method: 'POST',
                url: 'api/product-lots/dispense-presents',
                data: data
            };

            $http(request).then(function successCallback(response) {
                if (response.data) {
                    var grid = angular.element("#purchasePresentItemsGrid").data("kendoGrid");
                    var dataItem = grid.dataSource.get(response.data.id);
                    dataItem.quantityExecuted = response.data.quantityExecuted;
                    vm.quantityLot = 1;
                    vm.barcode = null;
                    angular.element("#quantityLot").data("kendoNumericTextBox").focus();
                    // Refresh grid
                    vm.kendoGrid.refresh(vm.purchasePresentItemsGridOptions)
                }
            }, function errorCallback(response) {

                var centered = $("#centeredNotification").kendoNotification({
                    stacking: "down",
                    autoHideAfter: 0,
                    show: KendoNotifications.onShow,
                    button: true,
                    hideOnClick: false,
                    width: 500,
                    height: 250
                }).data("kendoNotification");

                centered.show(' ' + $filter('translate')('global.messages.error.' + response.data.params[0] + ' '), "error");
            });
        };

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "purchasePresentItem.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/purchase-present-item-lots/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                        vm.showProgress = false;
                                    });
                            },
                            create: function(o) {
                                vm.showProgress = true;
                                var data = o.data.models[0];
                                data.purchasePresentItem = {id : dataItem.id};

                                $http.post('/api/purchase-present-item-lots', data)
                                    .success(function (response) {
                                        o.success(response);
                                        dataItem.quantityExecuted = response.purchasePresentItem.quantityExecuted;
                                        dataItem.quantity = response.purchasePresentItem.quantity;
                                        dataItem.version = response.purchasePresentItem.version;

                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        o.error(response);
                                        vm.showProgress = false;
                                        console.log(response);
                                        Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά την δημιουργία Παρτίδας!\n" + response.message, "ΟΚ");
                                        vm.kendoGrid.refresh(vm.purchasePresentItemsGridOptions)
                                    });
                            },
                            update: function(o) {
                                vm.showProgress = true;
                                var data = o.data.models[0];

                                $http.put('/api/purchase-present-item-lots', data)
                                    .success(function (response) {
                                        o.success(response);
                                        dataItem.quantityExecuted = response.purchasePresentItem.quantityExecuted;
                                        dataItem.quantity = response.purchasePresentItem.quantity;
                                        dataItem.version = response.purchasePresentItem.version;

                                        vm.showProgress = false;
                                    })
                                    .error(function (error) {
                                        o.error(error);
                                        vm.showProgress = false;
                                        if (error.message && error.message.includes("error.concurrencyFailure")) {
                                            Alerts.showConfirmDialog(null, $filter('translate')('error.purchasePresentItemLot.purchasePresentItemLotConcurrencyFailureTitle'),
                                                $filter('translate')('error.purchasePresentItemLot.purchasePresentItemLotConcurrencyFailureMessage'),
                                                false, $filter('translate')('entity.action.refresh'), $filter('translate')('entity.action.cancel'), function () {
                                                    // on confirm
                                                    $window.location.reload();
                                                }, function () {
                                                    // on cancel
                                                });
                                        }else {
                                            Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά την δημιουργία Παρτίδας!\n" + error.message, "ΟΚ");
                                            vm.kendoGrid.refresh(vm.purchaseItemsGridOptions);
                                        }
                                    });
                            },
                            destroy: function(o) {
                                var data = o.data.models[0];
                                PurchasePresentItemLot.delete({id: data.id},
                                    function () {
                                        console.log("PurchasePresentItemLot with id: " + data.id + ", successfully deleted!");
                                        var grid = angular.element("#purchasePresentItemsGrid");
                                        grid.data("kendoGrid").dataSource.read();
                                    });

                            }
                        },
                        requestEnd: function(e) {
                            var type = e.type;
                            if (type == "create" || type == "destroy" ) {
                                var dataSource = this;
                                dataSource.read();
                            }
                            vm.showProgress = false;
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    quantity: { editable: true, nullable: false, type: "number", validation: { min: 1,
                                            reqvalidation: function (input) {
                                                if (firstTime) {
                                                    firstTime=false;
                                                    return true;
                                                }
                                                if (input.is("[name='quantity']") && input.val() === "") {
                                                    input.attr("data-reqvalidation-msg", "Η ποσότητα είναι υποχρεωτική");
                                                    return false;
                                                }
                                                return true;
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {
                            field: "name",
                            title: "Παρτίδα",
                            filterable: false
                        },
                        {
                            field: "quantity",
                            title: "Ποσότητα", format: "{0:n0}",
                            filterable: false
                        },
                        {
                            field: "destroy",
                            filterable: false,
                            command: [
                                {
                                    name: "destroy",
                                    text: ""
                                }
                            ],
                            title: "&nbsp;"
                        }
                    ],
                    editable: "inline",
                    selectable: "row",
                    navigatable: true,
                    rowTemplate: kendo.template(angular.element("#gridPresentItemsRowTemplate").html()),
                    edit: function(e) {
                        var data = this._data;
                        var item = e.model;

                        var quantityDefaultValue = PurchaseGrids.getQuantityDefaultValue(dataItem.quantity, data, item);

                        if(e.model.isNew()) {
                            e.model.set("quantity", quantityDefaultValue);
                        }
                        e.container.find("input[name=quantity]").data("kendoNumericTextBox").setOptions({
                            max: quantityDefaultValue
                        });
                    },
                    // This event causes problems with the PurchasePresentItem.ExecQuantity.
                    // It runs before the update of PurchasePresentItemLot
                    /*save: function(e) {
                        console.log("detailedGridOptions::save");
                        var data = this._data;
                        dataItem.quantityExecuted = 0;
                        angular.forEach( data, function (item) {
                            dataItem.quantityExecuted += item.quantity;
                        });
                        if (dataItem.quantityExecuted <= dataItem.quantity) {
                            dataItem.measurementUnit = null;
                            PurchasePresentItem.update(dataItem,
                                function (success) {},
                                function (error) {}
                            );
                        }
                    },*/
                    dataBound: function() {
                        angular.element("#detailGrid tbody tr").on("click", function(e) {
                            if (!angular.element(this).hasClass('k-grid-edit-row')) {
                                angular.element("#detailGrid").data("kendoGrid").editRow(angular.element(this));
                            }
                        });
                    }
                };
            }
        };
    }
})();
;
/**
 * Created by gmogas on 13/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseNewController', PurchaseNewController);

    PurchaseNewController.$inject = ['$filter', 'KendoFilter', '$state','ApplicationParameters', 'KendoService', '$http', '$timeout', 'KendoGrid', '$mdDialog', 'KendoNotifications', 'NotificationOptions', 'employees'];

    function PurchaseNewController ($filter, KendoFilter, $state, ApplicationParameters, KendoService, $http, $timeout, KendoGrid, $mdDialog, KendoNotifications, NotificationOptions, employees) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.employees = [];
        if (employees !== null && employees !== undefined){
            angular.forEach(employees, function (employee) {
                // Push only activated employees with an assigned account
                if (employee.account !== null && employee.account !== undefined && employee.account.activated === true){
                    vm.employees.push(employee);
                }
            });
        }

        vm.sectorSearchWindowVisible = false;
        vm.priceCalculation = true;
        vm.validation = true;
        vm.purchase = {};
        vm.presentListProductsWindow = {};
        vm.isSaving = false;
        vm.selectedProducts = [];
        vm.massSelect = true;

        vm.options = {
            spinners: false,
            format: "c2"
        };
        vm.percentOptions = {
            format: "# \\%",
            max: 100
        };

        var sectorTypeCategories = ["pharmacy", "beautyCenter"];
        var purchaseItemsGridColumnsToHide = ["productPrice", "totalPrice", "discountLinePercent", "discountLinePrice", "discountSummary", "taxPrice", "finalPrice"];

        function getToday() {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();

            if(dd<10) {
                dd = '0'+dd
            }

            if(mm<10) {
                mm = '0'+mm
            }

            return dd + '/' + mm + '/' + yyyy;
        }
        vm.purchase.issueDate = getToday();

        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        vm.pageHeading = 'Νεα Παραγγελια';
        var dataSource = {};
        var sectorSearchWindow = angular.element('#sectorSearchWindow');

        dataSource.sectorsDataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) o.data.filter = { filters: [] };

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "sectorType.sectorTypeCategory", "operator": "in",
                                "value": sectorTypeCategories.toString() }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                        }
                    });

                    $http.get('/api/me/sectors',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema : {
                data: function (data) {
                    angular.forEach( data.content, function (item) {
                        if ( item.companyType == null ) {
                            item.companyType = {};
                        }
                        if ( item.taxStatus == null ) {
                            item.taxStatus = {};
                        }
                        if ( item.taxOffice == null ) {
                            item.taxOffice = {};
                        }
                    });
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        name : { editable: false },
                        vat : { editable: false },
                        address : { editable: false },
                        addressNum : { editable: false },
                        cityName : { editable: false },
                        prefectureName : { editable: false },
                        brick : { editable: false },
                        osfeBrick : { editable: false },
                        phone : { editable: false },
                        createdDate: { type: 'date', editable: false},
                        companyType: { defaultValue: { id: null, name: null }},
                        taxStatus: { defaultValue: { id: null, name: null }},
                        taxOffice: { defaultValue: { id: null, name: null }},
                        creditControlCheck: { type: "boolean" }
                    }
                }
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        dataSource.employeesDataSource = new kendo.data.DataSource({
            data: vm.employees,
            schema: {
                parse: function (employeesArray) {
                    if (employeesArray && employeesArray.length > 0){
                        var length = employeesArray.length;
                        var dataItem;
                        var idx = 0;
                        for (; idx < length; idx++) {
                            dataItem = employeesArray[idx];
                            dataItem.fullName = dataItem.account.lastName + " " + dataItem.account.firstName;
                        }
                    }

                    return employeesArray;
                }
            }
        });

        vm.sectorsComboBoxOptions = KendoService.initDefaultOptions(dataSource.sectorsDataSource, "like", "name", "id");
        vm.sectorsComboBoxOptions.valuePrimitive = false;
        vm.sectorsComboBoxOptions.change = function() {
            $timeout( function() { if(vm.purchase.sector) vm.purchase.sector.shippingAddress = vm.purchase.sector.address; });
            if(vm.purchase.sector) {
                if (vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            }
        };

        vm.employeesComboBoxOptions = KendoService.initDefaultOptions(dataSource.employeesDataSource, "startswith", "fullName", "id", false);
        vm.employeesComboBoxOptions.cascade = function () {
            // Cascade event to fire when widget value changes programmatically (from '/api/employees/me' call below)
            vm.purchase.employee = this.dataItem();
            vm.purchase.employee.fullName = vm.purchase.employee.account.lastName + " " + vm.purchase.employee.account.firstName;
            angular.element("#employee").css('width', ((vm.purchase.employee.fullName.length + 1) * 8) + 'px');

            dataSource.purchaseNumberingRowDataSource = vm.purchase.employee.purchaseNumberingRows;
            vm.purchaseNumberingRowOptions = KendoService.initDefaultOptions(dataSource.purchaseNumberingRowDataSource, "startswith", "name", "id");
        };

        $http.get('/api/employees/me')
            .success(function (response) {
                if (response !== null && response !== undefined){
                    vm.purchase.employee = response;
                }
            })
            .error(function (response) {});

        dataSource.presentLists = KendoService.initDataSource('/api/present-lists/search', 1, 20);
        vm.presentListsComboBoxOptions = KendoService.initDefaultOptions(dataSource.presentLists, "startswith", "code", "id");
        vm.presentListsComboBoxOptions.valuePrimitive = false;

        dataSource.paymentMethods = KendoService.initDefaultDataSource('/api/payment-methods/search');
        vm.paymentMethodOptions = KendoService.initDefaultOptions(dataSource.paymentMethods, "startswith", "name", "id");
        vm.paymentMethodOptions.placeholder = "Επιλογή τρόπου πληρωμής";

        function getPurchaseAddress (sector) {
            return {
                shippingAddress: sector.address,
                shippingAddressNum:  sector.addressNum,
                shippingCityName:  sector.cityName,
                shippingPrefectureName:  sector.prefectureName,
                shippingCountryName:  sector.countryName,
                shippingPostalCode:  sector.postalCode
            }
        }

        dataSource.codesDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');
        dataSource.productsDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');

        dataSource.purchaseStatusDataSource = KendoService.initDataSource('/api/masterdata/purchase-statuses', 1, 20, null, { "field": "code",  "dir": "asc" });
        vm.purchaseStatusOptions = KendoService.initDefaultOptions(dataSource.purchaseStatusDataSource, "startswith", "name", "id");

        dataSource.purchaseStatusDataSource = KendoService.initDataSource('/api/masterdata/purchase-statuses', 1, 20, null, { "field": "code",  "dir": "asc" });
        vm.purchaseStatusOptions = KendoService.initDefaultOptions(dataSource.purchaseStatusDataSource, "startswith", "name", "id");

        dataSource.pickerDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_STOREHOUSE" }
                        ]
                    );
                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee= {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        }
                    });
                    return data;
                }
            }
        });
        vm.pickerOptions = KendoService.initDefaultOptions(dataSource.pickerDataSource, "startswith", "employee.account.fullName", "id");
        vm.pickerOptions.placeholder = "Επιλογή αποθηκάριου";

        var purchaseItemsColumns = [
            {
                field: "product",
                title: "Κωδικός είδους",
                template: "#= product.code ? product.code : ''#",
                editor: function(container, options) {
                    angular.element('<select id="productCode" data-bind="value:product"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.codesDataSource,
                            dataBound: function (e) {
                                var dataSource = e.sender.dataSource;
                                angular.forEach( dataSource.data(), function(item) {
                                    if (!item.code) {
                                        dataSource.remove(item);
                                    }
                                });
                            },
                            filter: "contains",
                            dataTextField: "code",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "product",
                title: "Περιγραφή είδους",
                template: "#= product ? product.name : ''#",
                editor: function(container) {
                    angular.element('<select id="productName" data-bind="value:product"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.productsDataSource,
                            filter: "contains",
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "quantity",
                title: "Ποσότητα",
                attributes:{style:"text-align:right;"},
                footerTemplate: "Σύνολο: #=kendo.format('{0:n0}', sum)#",
                template: function (model) {
                    model.quantity = model.quantity || 1;
                    return kendo.format('{0:n0}', model.quantity);
                }
            },
            {
                field: "productPrice",
                title: "Τιμή",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    var date = new Date();
                    angular.forEach( model.product.productPrices, function( productPrice ) {
                        if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                            model.productPrice = productPrice.wholesalePrice || 0;
                        }
                    });
                    return kendo.format('{0:c}', model.productPrice || 0);
                }
            },
            {
                field: "totalPrice",
                title: "Μικτή Αξία",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.totalPrice = model.quantity * model.productPrice;
                    return kendo.format('{0:c}', model.totalPrice);
                }
            },
            {
                field: "discountLinePercent",
                title: "Έκπτωση (%)",
                attributes:{style:"text-align:right;"},
                template: "#= (discountLinePercent == null) ? '' : kendo.format('{0:p}', discountLinePercent / 100)#"
            },
            {
                field: "discountLinePrice",
                title: "Αξία Έκπτωσης",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.discountLinePrice = (model.totalPrice - (model.totalPrice * (model.product.defaultDiscount/100))) * (model.discountLinePercent/100) || 0;
                    return kendo.format('{0:c}', model.discountLinePrice);
                }
            },
            {
                field: "discountSummary",
                title: "Συνολική Έκπτωση",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.discountSummary = (model.totalPrice * model.product.defaultDiscount / 100) + model.discountLinePrice + model.discountPurchasePrice || 0;
                    return kendo.format('{0:c}', model.discountSummary);
                }
            },
            {
                field: "netPrice",
                title: "Καθαρή Αξία",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.netPrice = model.totalPrice - model.discountSummary + model.pfs;
                    return kendo.format('{0:c}', model.netPrice);
                }
            },
            {
                field: "taxPrice",
                title: "Αξία Φ.Π.Α.",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    if (model.product.taxClass) {
                        model.taxPercent =
                            $filter('filter')(model.product.taxClass.taxStatusClasses, { taxStatus: { id: vm.purchase.sector.taxStatus.id } }, true)[0].value;
                    }
                    model.taxPrice = model.netPrice * model.taxPercent/100;
                    return kendo.format('{0:c}', model.taxPrice);
                }
            },
            {
                field: "finalPrice",
                title: "Συνολική Αξία",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.finalPrice = model.netPrice + model.taxPrice;
                    return kendo.format('{0:c}', model.finalPrice);
                }
            },
            {
                field: "pfs",
                title: "Π.Φ.Σ.",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    model.pfs = 0;
                    if(model.product)
                        if(model.product.calcPFS) model.pfs = model.totalPrice * 0.004;

                    return kendo.format('{0:c}', model.pfs);
                }
            },
            {
                field: "destroy",
                template: "<md-button data-command='destroy' class='k-grid-delete md-icon-button md-mini md-warn' aria-label='Delete'>" +
                "<i class='material-icons' style='vertical-align: inherit;'>delete_forever</i>" +
                "</md-button>",
                title: "&nbsp;",
                width: 100
            }
        ];

        vm.purchaseItemsOptions = {
            dataSource:  new kendo.data.DataSource({
                data: [],
                schema : {
                    model: {
                        id: "id",
                        fields: {
                            id: "id",
                            product: { defaultValue: { id: null, code: "", name: "", barcode: "" } },
                            quantity: { type: "number", validation: { min: 1 }, defaultValue: 1 },
                            productPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            totalPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountLinePercent: { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountLinePrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountSummary: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            taxPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            finalPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            'product.defaultDiscount': { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPrice: { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPurchasePercent: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPurchasePrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            taxPercent: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            netPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            pfs: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 }
                        }
                    }
                },
                aggregate: [{field: "quantity", aggregate: "sum"}]
            }),
            navigatable: true,
            editable: true,
            toolbar: [{ template: "<md-button class='blue-color-md-button md-raised md-mini md-primary k-grid-add' aria-label='add' ng-disabled='!vm.purchase.sector'>" +
                "<i class='material-icons fixed-icons fixed-icons-2'>add</i>Προσθήκη Νέας Γραμμής Παραγγελίας</md-button>"}],
            resizable: true,
            columns:  purchaseItemsColumns,
            dataBound: function (e) {
                var items = e.sender.items();
                var columns = e.sender.options.columns;
                var grid = e.sender;
                var data = e.sender.dataSource.data();
                var totalPrice = 0, discountFinalPrice = 0, netPrice = 0, taxPrice = 0, finalPrice = 0, discountPrice = 0, pfs = 0;

                //Total Prices
                angular.forEach(data, function(item) {
                    totalPrice += item.totalPrice;
                    discountFinalPrice += item.discountSummary;
                    netPrice += item.netPrice;
                    taxPrice += item.taxPrice;
                    finalPrice += item.finalPrice;
                    discountPrice += item.discountPurchasePrice;
                    pfs += item.pfs;
                });
                vm.purchase.totalPrice = totalPrice;
                vm.purchase.discountFinalPrice = discountFinalPrice;
                vm.purchase.netPrice = netPrice;
                vm.purchase.taxPrice = taxPrice;
                vm.purchase.finalPrice = finalPrice;
                vm.purchase.discountPercent = 0;
                vm.purchase.discountPrice = discountPrice;
                vm.purchase.presentPercent = 0;
                vm.purchase.presentPrice = 0;
                vm.purchase.pfs = pfs;

                //Functionality for save row on enter.
                items.each(function () {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].field !== "destroy") {
                            angular.element(this).find("td:eq(" + i + ")").keydown(function (e) {
                                if (e.keyCode === 13) {
                                    grid.saveRow();
                                }
                            });
                        }

                        var row = angular.element(this);
                        if(!vm.priceCalculation) row.find(".k-hierarchy-cell").html("");
                    }
                });
                this.expandRow(this.tbody.find("tr.k-master-row"));
            },
            pageable: false
        };

        var purchasePresentItemsColumns = [
            {
                field: "product.code",
                title: "Κωδικός είδους"
            },
            {
                field: "product.name",
                title: "Περιγραφή είδους"
            },
            {
                field: "quantity",
                title: "Ποσότητα",
                attributes:{style:"text-align:right;"}
            },
            {
                field: "quantityExecuted",
                title: "Εκτελεσμένη Ποσότητα",
                attributes:{style:"text-align:right;"}
            },
            {
                field: "price",
                title: "Τιμή",
                attributes:{style:"text-align:right;"},
                template: function (model) {
                    var date = new Date();
                    angular.forEach( model.product.productPrices, function( productPrice ) {
                        if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                            model.price = productPrice.wholesalePrice || 0;
                        }
                    });
                    return kendo.format('{0:c}', model.price || 0);
                }
            },
            {
                field: "destroy",
                template: "<md-button data-command='destroy' class='k-grid-delete md-icon-button md-mini md-warn' aria-label='Delete'>" +
                "<i class='material-icons' style='vertical-align: inherit;'>delete_forever</i>" +
                "</md-button>",
                title: "&nbsp;",
                width: 100
            }
        ];

        vm.purchasePresentItemsOptions = {
            dataSource:  new kendo.data.DataSource({
                data: vm.selectedProducts,
                schema : {
                    model: {
                        id: "id",
                        fields: {
                            'product.name': { editable: false },
                            'product.code': { editable: false },
                            quantity: { editable: true, type: "number", validation: { min: 0 }, defaultValue: 1 },
                            quantityExecuted: { editable: true, type: "number", validation: { min: 0 } },
                            price: { editable: false, type: "number", validation: { min: 0 } }
                        }
                    }
                }
            }),
            navigatable: true,
            editable: true,
            resizable: true,
            columns:  purchasePresentItemsColumns,
            pageable: false,
            dataBound: function(e) {
                var items = e.sender.items();
                var columns = e.sender.options.columns;
                var grid = e.sender;
                //Functionality for save row on enter.
                items.each(function () {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].field !== "destroy") {
                            angular.element(this).find("td:eq(" + i + ")").keydown(function (e) {
                                if (e.keyCode === 13) {
                                    grid.saveRow();
                                }
                            });
                        }
                    }
                });
            }
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchase.sector) if (vm.purchase.sector.id === null) vm.purchase.sector = null;
            if (vm.purchase.paymentMethod) if (vm.purchase.paymentMethod.id === null) vm.purchase.paymentMethod = null;
            if (vm.purchase.purchaseNumberingRow) if (vm.purchase.purchaseNumberingRow.id === null) vm.purchase.purchaseNumberingRow = null;
            if (vm.purchase.picker) if (vm.purchase.picker.id === null) vm.purchase.picker = null;

            if (!vm.priceCalculation) {
                if (vm.purchase.sector) vm.purchase.sector.shippingAddress = null;
                vm.purchase.purchaseStatus = null;
                vm.purchase.picker = null;
                vm.purchase.comment = null;
            }

            vm.purchase.createdFromBackOffice = true;

            var gridData = vm.purchaseItemsOptions.dataSource.data();

            vm.validation = true;

            if (vm.validator.validate()) {
                if (gridData.length > 0) {
                    for (var i = 0, len = gridData.length; i < len; i++) {
                        if (!gridData[i].product || !gridData[i].product.name) {
                            vm.validation = false;
                            vm.isSaving = false;
                            break;
                        }
                    }

                    if (vm.validation === true) {
                        vm.purchase.purchaseStatus = {id: 1};

                        var dayHelper = vm.purchase.issueDate.split("/");
                        vm.purchase.issueDate = dayHelper[2] + "-" + dayHelper[1] + "-" + dayHelper[0];
                        if (vm.purchase.desirableExecutionDate !== null &&
                            vm.purchase.desirableExecutionDate !== undefined &&
                            vm.purchase.desirableExecutionDate !== ""){
                            dayHelper = vm.purchase.desirableExecutionDate.split("/");
                            vm.purchase.desirableExecutionDate = dayHelper[2] + "-" + dayHelper[1] + "-" + dayHelper[0];
                        }

                        angular.extend(vm.purchase, getPurchaseAddress(vm.purchase.sector));

                        $http.post('/api/purchases', vm.purchase)
                            .success(function (response) {
                                vm.purchase = angular.copy(response);
                                var purchaseItems = gridData;
                                angular.forEach(purchaseItems, function (item) {
                                    item.quantityExecuted = 0;
                                    item.executedDiscountSummary = 0;
                                    item.purchase = vm.purchase
                                });

                                $http.post('/api/purchase-items/list', purchaseItems)
                                    .success(function () {

                                        var purchasePresentItems = vm.purchasePresentItemsOptions.dataSource.data();
                                        angular.forEach(purchasePresentItems, function (item) {
                                            item.purchase = vm.purchase;
                                            item.id = null;
                                        });

                                        $http.post('/api/purchase-present-items/list', purchasePresentItems)
                                            .success(function () {
                                                vm.isSaving = false;
                                                KendoNotifications.onSaveSuccess(notification);
                                                $state.go('purchases');
                                            })
                                            .error(function (error) {
                                                KendoNotifications.onSaveError(notification);
                                            });

                                    })
                                    .error(function (error) {
                                        KendoNotifications.onSaveError(notification);
                                    });
                            })
                            .error(function (error) {
                                KendoNotifications.onSaveError(notification);
                            });
                    }
                } else {
                    vm.isSaving = false;
                    vm.validation = false;
                }
            } else {
                vm.isSaving = false;
                KendoNotifications.onSaveError(notification);
            }
        };

        vm.cancel = function () {
            $state.go('purchases');
        };

        vm.onSectorsGridSelection = function(e) {
            e.preventDefault();
            var data = this.dataItem(angular.element(e.currentTarget).closest("tr"));

            $timeout( function() {
                vm.purchase.sector = data;
                vm.purchase.sector.shippingAddress = vm.purchase.sector.address;
                if(vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            });
            angular.element("#sectorName").data('kendoComboBox').text(data.name);
            sectorSearchWindow.data("kendoWindow").close();
        };

        vm.sectorSearchWindowOptions = {
            title: "Επιλέξτε επαγγελματία υγείας",
            visible: false,
            modal: true,
            width: '90%'
        };

        vm.sectorsColumns = [
            {
                field: "code",
                title: "Κωδικός Ε.Ε.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "name",
                title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sectorType.sectorTypeCategory",
                title: "Τύπος",
                template: "#= (sectorType.sectorTypeCategory == 'beautyCenter') ? 'Κέντρο Αισθητικής' : (sectorType.sectorTypeCategory == 'pharmacy') ? 'Φαρμακείο' : '' #",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Κέντρο Αισθητικής", value: "beautyCenter" },
                                        { text: "Φαρμακείο", value: "pharmacy" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.creditControlCheck" ' +
            'ng-disabled="true"></md-checkbox>',
                field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }},
            {
                command: {
                    text: "Επιλογή",
                    click: vm.onSectorsGridSelection
                }
            }
        ];

        vm.sectorsGridOptions = {
            autoBind: false,
            dataSource: dataSource.sectorsDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns:  vm.sectorsColumns
        };

        vm.openSectorsGrid = function() {
            sectorSearchWindow.data("kendoWindow").center().open();
            vm.sectorSearchWindowVisible = true;
            vm.sectorsGridOptions.dataSource.read();
        };

        vm.closeSectorsGrid = function() {
            vm.sectorSearchWindowVisible = false;
        };

        vm.setView = function () {
            var purchaseItemsGrid = angular.element("#purchaseItemsGrid").data("kendoGrid");

            angular.forEach(purchaseItemsGridColumnsToHide, function (column) {
                angular.forEach(purchaseItemsGrid.dataSource.data(), function (item) {
                    item[column] = null;
                });

                if (!vm.priceCalculation) purchaseItemsGrid.hideColumn(column);
                else purchaseItemsGrid.showColumn(column);

                vm.purchaseItemsOptions.dataSource.read();
                vm.purchasePresentItemsOptions.dataSource.read();
            });

            vm.purchase.totalPrice = null;
            vm.purchase.discountFinalPrice = null;
            vm.purchase.netPrice = null;
            vm.purchase.taxPrice = null;
            vm.purchase.finalPrice = null;
            vm.purchase.discountPercent = null;
            vm.purchase.discountPrice = null;
            vm.purchase.presentPercent = null;
            vm.purchase.presentPrice = null;
            vm.purchase.pfs = null;
        };

        vm.clearPopUpGrid = function(status) {
            KendoGrid.refresh(vm.productsGridOptions);
            vm.statusChanged = status;
        };

        vm.addPresentList = function () {
            vm.initPopupGrid = true;
            vm.clearPopUpGrid("opened");
            vm.presentListProductsWindow.center().open();
        };

        vm.productsGridDataSource = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) o.data.filter = {filters: []};
                    o.data.filter.filters.push({field: "presentList.id", operator: "eq", value: vm.purchase.presentList.id});

                    $http.get('/api/present-list-products/search', {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true},
                        'product.code': { editable: false, nullable: true},
                        'product.name': { editable: false, nullable: true, type: "text"}
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20,
            scrollable:false
        });

        vm.productsGridColumns = [
            {
                field: "product.code",
                title: "Κωδικός Είδους",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "product.name",
                title: "Περιγραφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.active" ' + 'ng-disabled="true"></md-checkbox>',
                editor: function(container,options){
                    angular.element('<md-checkbox ng-model="dataItem.active"  aria-label="active" ' +
                        'class="checkbox-toolbar customers green inline"></md-checkbox>')
                        .appendTo(container);
                },
                field: "active",
                title: "Ενεργό",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.productsGridOptions = {
            dataSource: vm.productsGridDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            editable: true,
            columns: vm.productsGridColumns,
            selectedItems: function(dataItems) {
                vm.selectedProducts = dataItems;
            },
            dataBound: function () {
                angular.element("#productsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedProductsViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedProducts, {id: item.id}, true)[0];
                    if(vm.selectedProducts.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedProductsViewCounter++
                    }
                });
                if(selectedProductsViewCounter == view.length) {
                    angular.element("#productsGridcheckbox").prop('checked', true);
                }
            }
        };

        vm.closeProductsWindow = function () {
            delete vm.initPopupGrid;
            vm.clearPopUpGrid("closed");
            vm.presentListProductsWindow.close();
        };

        var presentList;
        vm.addProducts = function () {
            if (!vm.purchasePresentItemsOptions.dataSource.data().length || presentList === vm.purchase.presentList) {
                angular.forEach( vm.selectedProducts, function( item ) {

                    var data = { filter: { filters: [{field: "product.id", operator: "eq", value: item.id}] } };
                    $http.get('/api/product-prices/search', {params: data})
                        .success(function (response) {
                            var newItem = {
                                id: item.id,
                                quantity: item.quantity,
                                quantityExecuted: 0,
                                presentListProduct: { id: item.id },
                                product: { id: item.product.id ,code: item.product.code, name: item.product.name,
                                    productPrices: item.product.productPrices },
                                price: null
                            };

                            angular.forEach( response.content, function( productPrice ) {
                               var date = new Date();
                               if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                                   newItem.price = productPrice.wholesalePrice || null;
                               }
                            });

                            vm.purchasePresentItemsOptions.dataSource.add( newItem );
                        })
                        .error(function (response) {});
                });
                presentList = vm.purchase.presentList;
            } else {
                vm.showConfirm();
            }

            vm.presentListProductsWindow.close();
            vm.clearPopUpGrid("closed");
        };

        vm.showConfirm = function() {
            var confirm = $mdDialog.confirm()
                .title('Τα ήδη υπάρχοντα προϊόντα θα διαγραφουν!')
                .textContent('Είστε σίγουροι ότι θέλετε να συνεχίσετε;')
                .ariaLabel('list-warning')
                .ok('Ναι!')
                .cancel('Όχι');

            $mdDialog.show(confirm).then(function() {
                angular.forEach( vm.purchasePresentItemsOptions.dataSource.data(), function( item ) {
                    var foundItemById = $filter('filter')(vm.selectedProducts, {id: item.id}, true)[0];
                    if(vm.selectedProducts.indexOf(foundItemById) !== -1){
                        vm.selectedProducts.splice(vm.selectedProducts.indexOf(foundItemById), 1);
                    }
                });
                vm.purchasePresentItemsOptions.dataSource.data([]);
                vm.addProducts();
            }, function() {});
        };

        vm.goBack = function () {
            $state.go('purchases');
        };
    }
})();
;
/**
 * Created by gmogas on 14/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseBacklogController', PurchaseBacklogController);

    PurchaseBacklogController.$inject = ['$http', '$filter', 'KendoFilter', 'KendoToolbar', 'KendoGrid'];

    function PurchaseBacklogController ($http, $filter, KendoFilter, KendoToolbar, KendoGrid) {
        var vm = this;
        vm.pageHeading = "Ανεκτελεστες ποσοτητες";

        vm.purchaseItemsGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: false,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = {filters: []};
                        }

                        if(vm.from && vm.to) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "purchase.issueDate", "operator": "fromdate",
                                        "value": $filter('date')(vm.from, 'yyyy-MM-dd')},
                                    { "field": "purchase.issueDate", "operator": "todate",
                                        "value": $filter('date')(vm.to, 'yyyy-MM-dd')}
                                ]
                            );
                        }
                        if (o.data.sort === undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "purchase.issueDate",  "dir": "desc" };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {"field": "quantity", "operator": "greaterThan", "value": "quantityExecuted"},
                                {"field": "purchase.purchaseStatus.cancellable", "operator": "noteqbool", "value": true}
                            ]
                        );

                        angular.forEach(o.data.filter.filters, function (item) {
                            if (item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/purchase-items/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if (data.content != undefined) {
                            data.content.forEach(function (item) {
                                if (item.product === null) item.product = {};
                                if (item.measurementUnit === null) item.measurementUnit = {};

                                item.offset = item.quantity - item.quantityExecuted;
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: true},
                            'purchase.issueDate': {type: "date"},
                            'product.code': {editable: false, nullable: true},
                            'product.name': {editable: false, nullable: true},
                            quantity: {type: "number", editable: true, nullable: true, validation: {min: 0}},
                            quantityExecuted: {editable: false, nullable: true, type: "number"},
                            offset: {editable: false, nullable: true, type: "number"},
                        }
                    }
                },
                aggregate: [
                    { field: "offset", aggregate: "sum" },
                    { field: "quantity", aggregate: "sum" },
                    { field: "quantityExecuted", aggregate: "sum" }
                ],
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            }),
            filterable: {
                mode: "row"
            },
            sortable: true,
            pageable: true,
            toolbar: ["excel"],
            excel: {
                allPages: true,
                fileName: "Ανεκτέλεστες ποσότητες.xlsx"
            },
            columns: [
                {
                    field: "purchase.issueDate",
                    title: "Ημερομηνία παραγγελίας",
                    template: "#= kendo.toString(kendo.parseDate(purchase.issueDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdateonly",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "purchase.code",
                    title: "Κωδικός παραγγελίας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "purchase.sector.name",
                    title: "Επαγγελματίας Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "purchase.purchaseStatus.name",
                    title: "Κατάσταση παραγγελίας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.code",
                    title: "Κωδικός είδους",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.name",
                    title: "Περιγραφή είδους",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }

                },
                {
                    field: "quantity",
                    title: "Ποσότητα",
                    aggregates: ["sum"],
                    footerTemplate: "#=sum#",
                    filterable: false
                },
                {
                    field: "quantityExecuted",
                    title: "Εκτελεσμένη Ποσότητα",
                    aggregates: ["sum"],
                    footerTemplate: "#=sum#",
                    filterable: false
                },
                {
                    field: "offset",
                    title: "Ανεκτέλεστη Ποσότητα",
                    aggregates: ["sum"],
                    footerTemplate: "#=sum#",
                    filterable: false
                }
            ]
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                vm.from = new Date(date.getFullYear(), 0, 1);
                vm.to = new Date();
            }
            KendoToolbar.setFrom(vm.from);
            KendoToolbar.setTo(vm.to);
            KendoGrid.refresh(vm.purchaseItemsGridOptions);
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "from", "to"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.from = value;
                } else {
                    vm.from = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.to = value;
                } else {
                    vm.to = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

    }
})();
;
/**
 * Created by Teo on 11/02/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseAccountingViewController', PurchaseAccountingViewController);

    PurchaseAccountingViewController.$inject = ['$state', '$http', '$stateParams', '$filter', '$timeout', '$mdDialog', 'KendoService', 'KendoGrid', 'KendoFilter', 'KendoNotifications', 'Purchase', 'PurchaseItem', 'PurchaseGrids',
        'NotificationOptions', 'employees', 'purchase', 'purchaseItems', 'purchasePresentItems', 'Alerts', '$window'];

    function PurchaseAccountingViewController ($state, $http, $stateParams, $filter, $timeout, $mdDialog, KendoService, KendoGrid, KendoFilter, KendoNotifications, Purchase, PurchaseItem, PurchaseGrids,
                                               NotificationOptions, employees, purchase, purchaseItems, purchasePresentItems, Alerts, $window) {
        var vm = this;
        vm.employees = employees;
        vm.purchase = purchase;
        setUpWithPurchase();
        vm.purchaseItems = purchaseItems;
        vm.purchasePresentItems = purchasePresentItems;
        vm.selectedProducts = angular.copy(vm.purchasePresentItems);
        vm.priceCalculation = true;
        vm.selectedPurchaseId = $stateParams.id;
        vm.options = {
            spinners: false,
            format: "c2"
        };
        vm.percentOptions = {
            format: "# \\%",
            max: 100
        };
        vm.presentListProductsWindow = {};
        vm.sectorSearchWindowVisible = false;
        vm.sectorSearchWindowOptions = {
            title: "Επιλέξτε επαγγελματία υγείας",
            visible: false,
            modal: true,
            width: '90%'
        };

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var sectorSearchWindow = angular.element('#popupSectorSearchWindow');
        var sectorTypeCategories = ["pharmacy", "beautyCenter"];
        var dataSource = {};
        dataSource.sectorsDataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) o.data.filter = { filters: [] };

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "sectorType.sectorTypeCategory", "operator": "in",
                                "value": sectorTypeCategories.toString() }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                        }
                    });

                    $http.get('/api/me/sectors',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema : {
                data: function (data) {
                    angular.forEach( data.content, function (item) {
                        if ( item.companyType == null ) {
                            item.companyType = {};
                        }
                        if ( item.taxStatus == null ) {
                            item.taxStatus = {};
                        }
                        if ( item.taxOffice == null ) {
                            item.taxOffice = {};
                        }
                    });
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        name : { editable: false },
                        vat : { editable: false },
                        address : { editable: false },
                        addressNum : { editable: false },
                        cityName : { editable: false },
                        prefectureName : { editable: false },
                        brick : { editable: false },
                        osfeBrick : { editable: false },
                        phone : { editable: false },
                        createdDate: { type: 'date', editable: false},
                        companyType: { defaultValue: { id: null, name: null }},
                        taxStatus: { defaultValue: { id: null, name: null }},
                        taxOffice: { defaultValue: { id: null, name: null }},
                        creditControlCheck: { type: "boolean" }
                    }
                }
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        dataSource.employeesDataSource = new kendo.data.DataSource({
            data: vm.employees,
            schema: {
                parse: function (employeesArray) {
                    if (employeesArray && employeesArray.length > 0){
                        var length = employeesArray.length;
                        var dataItem;
                        var idx = 0;
                        for (; idx < length; idx++) {
                            dataItem = employeesArray[idx];
                            dataItem.fullName = dataItem.account.lastName + " " + dataItem.account.firstName;
                        }
                    }

                    return employeesArray;
                }
            }
        });
        dataSource.purchaseStatusDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get( '/api/masterdata/purchase-statuses',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            sort: { field: "code", dir: "asc" }
        });
        dataSource.paymentMethods = KendoService.initDefaultDataSource('/api/payment-methods/search');
        dataSource.codesDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');
        dataSource.productsDataSource = KendoService.initDefaultDataSource('/api/masterdata/products');
        dataSource.pickerDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_STOREHOUSE" }
                        ]
                    );
                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        }
                    });
                    return data;
                }
            }
        });
        dataSource.presentLists = KendoService.initDataSource('/api/present-lists/search', 1, 20);
        vm.productsGridDataSource = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) o.data.filter = {filters: []};
                    o.data.filter.filters.push({field: "presentList.id", operator: "eq", value: vm.purchase.presentList.id});

                    $http.get('/api/present-list-products/search', {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true},
                        'product.code': { editable: false, nullable: true},
                        'product.name': { editable: false, nullable: true, type: "text"}
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20,
            scrollable:false
        });

        vm.sectorsComboBoxOptions = KendoService.initDefaultOptions(dataSource.sectorsDataSource, "startswith", "name", "id", false);
        vm.sectorsComboBoxOptions.autoBind = false;
        vm.sectorsComboBoxOptions.change = function() {
            $timeout( function() { if(vm.purchase.sector) vm.purchase.sector.shippingAddress = vm.purchase.sector.address; });
            if(vm.purchase.sector) {
                if (vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            }
        };
        vm.employeesComboBoxOptions = KendoService.initDefaultOptions(dataSource.employeesDataSource, "startswith", "fullName", "id", false);
        vm.employeesComboBoxOptions.cascade = function () {
            // Cascade event to fire when widget value changes programmatically (from '/api/employees/me' call below)
            vm.purchase.employee = this.dataItem();
            vm.purchase.employee.fullName = vm.purchase.employee.account.lastName + " " + vm.purchase.employee.account.firstName;
            angular.element("#employee").css('width', ((vm.purchase.employee.fullName.length + 1) * 8) + 'px');

            dataSource.purchaseNumberingRowDataSource = vm.purchase.employee.purchaseNumberingRows;
            vm.purchaseNumberingRowOptions = KendoService.initDefaultOptions(dataSource.purchaseNumberingRowDataSource, "startswith", "name", "id");
        };
        vm.purchaseStatusOptions = {
            dataSource: dataSource.purchaseStatusDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.paymentMethodOptions = KendoService.initDefaultOptions(dataSource.paymentMethods, "startswith", "name", "id");
        vm.pickerOptions = KendoService.initDefaultOptions(dataSource.pickerDataSource, "startswith", "employee.account.fullName", "id");
        vm.presentListsComboBoxOptions = KendoService.initDefaultOptions(dataSource.presentLists, "startswith", "code", "id");
        vm.presentListsComboBoxOptions.valuePrimitive = false;

        vm.purchaseItemsOptions = {
            dataSource:  new kendo.data.DataSource({
                data: vm.purchaseItems,
                schema : {
                    model: {
                        id: "id",
                        fields: {
                            id: "id",
                            product: { defaultValue: { id: null, code: "", name: "", barcode: "" } },
                            quantity: { type: "number", validation: { min: 1 }, defaultValue: 1 },
                            productPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            totalPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountLinePercent: { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountLinePrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountSummary: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            taxPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            finalPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            'product.defaultDiscount': { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPrice: { type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPurchasePercent: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            discountPurchasePrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            taxPercent: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            netPrice: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 },
                            pfs: { editable: false, type: "number", validation: { min: 0 }, defaultValue: 0 }
                        }
                    }
                },
                aggregate: [{field: "quantity", aggregate: "sum"}]
            }),
            navigatable: true,
            editable: true,
            toolbar: [{ template: "<md-button class='blue-color-md-button md-raised md-mini md-primary k-grid-add' aria-label='add' ng-disabled='!vm.purchase.sector'>" +
                "<i class='material-icons fixed-icons fixed-icons-2'>add</i>Προσθήκη Νέας Γραμμής Παραγγελίας</md-button>"}],
            resizable: true,
            columns: [
                {
                    field: "product",
                    title: "Κωδικός είδους",
                    template: "#= product.code ? product.code : ''#",
                    editor: function(container, options) {
                        angular.element('<select id="productCode" data-bind="value:product"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: dataSource.codesDataSource,
                                dataBound: function (e) {
                                    var dataSource = e.sender.dataSource;
                                    angular.forEach( dataSource.data(), function(item) {
                                        if (!item.code) {
                                            dataSource.remove(item);
                                        }
                                    });
                                },
                                filter: "contains",
                                dataTextField: "code",
                                dataValueField: "id"
                            });
                    }
                },
                {
                    field: "product",
                    title: "Περιγραφή είδους",
                    template: "#= product ? product.name : ''#",
                    editor: function(container) {
                        angular.element('<select id="productName" data-bind="value:product"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: dataSource.productsDataSource,
                                filter: "contains",
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    }
                },
                {
                    field: "quantity",
                    title: "Ποσότητα",
                    attributes:{style:"text-align:right;"},
                    footerTemplate: "Σύνολο: #=kendo.format('{0:n0}', sum)#",
                    template: function (model) {
                        model.quantity = model.quantity || 1;
                        return kendo.format('{0:n0}', model.quantity);
                    }
                },
                {
                    field: "productPrice",
                    title: "Τιμή",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        var date = new Date();
                        angular.forEach( model.product.productPrices, function( productPrice ) {
                            if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                                model.productPrice = productPrice.wholesalePrice || 0;
                            }
                        });
                        return kendo.format('{0:c}', model.productPrice || 0);
                    }
                },
                {
                    field: "totalPrice",
                    title: "Μικτή Αξία",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.totalPrice = model.quantity * model.productPrice;
                        return kendo.format('{0:c}', model.totalPrice);
                    }
                },
                {
                    field: "discountLinePercent",
                    title: "Έκπτωση (%)",
                    attributes:{style:"text-align:right;"},
                    template: "#= (discountLinePercent == null) ? '' : kendo.format('{0:p}', discountLinePercent / 100)#"
                },
                {
                    field: "discountLinePrice",
                    title: "Αξία Έκπτωσης",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.discountLinePrice = (model.totalPrice - (model.totalPrice * (model.product.defaultDiscount/100))) * (model.discountLinePercent/100) || 0;
                        return kendo.format('{0:c}', model.discountLinePrice);
                    }
                },
                {
                    field: "discountSummary",
                    title: "Συνολική Έκπτωση",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.discountSummary = (model.totalPrice * model.product.defaultDiscount / 100) + model.discountLinePrice + model.discountPurchasePrice || 0;
                        return kendo.format('{0:c}', model.discountSummary);
                    }
                },
                {
                    field: "netPrice",
                    title: "Καθαρή Αξία",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.netPrice = model.totalPrice - model.discountSummary + model.pfs;
                        return kendo.format('{0:c}', model.netPrice);
                    }
                },
                {
                    field: "taxPrice",
                    title: "Αξία Φ.Π.Α.",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        if (model.product.taxClass) {
                            model.taxPercent =
                                $filter('filter')(model.product.taxClass.taxStatusClasses, { taxStatus: { id: vm.purchase.sector.taxStatus.id } }, true)[0].value;
                        }
                        model.taxPrice = model.netPrice * model.taxPercent/100;
                        return kendo.format('{0:c}', model.taxPrice);
                    }
                },
                {
                    field: "finalPrice",
                    title: "Συνολική Αξία",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.finalPrice = model.netPrice + model.taxPrice;
                        return kendo.format('{0:c}', model.finalPrice);
                    }
                },
                {
                    field: "pfs",
                    title: "Π.Φ.Σ.",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        model.pfs = 0;
                        if(model.product)
                            if(model.product.calcPFS) model.pfs = model.totalPrice * 0.004;

                        return kendo.format('{0:c}', model.pfs);
                    }
                },
                {
                    field: "destroy",
                    template: "<md-button data-command='destroy' class='k-grid-delete md-icon-button md-mini md-warn' aria-label='Delete'>" +
                    "<i class='material-icons' style='vertical-align: inherit;'>delete_forever</i>" +
                    "</md-button>",
                    title: "&nbsp;",
                    width: 100
                }
            ],
            dataBound: function (e) {
                var items = e.sender.items();
                var columns = e.sender.options.columns;
                var grid = e.sender;
                var data = e.sender.dataSource.data();
                var totalPrice = 0, discountFinalPrice = 0, netPrice = 0, taxPrice = 0, finalPrice = 0, discountPrice = 0, pfs = 0;

                //Total Prices
                angular.forEach(data, function(item) {
                    totalPrice += item.totalPrice;
                    discountFinalPrice += item.discountSummary;
                    netPrice += item.netPrice;
                    taxPrice += item.taxPrice;
                    finalPrice += item.finalPrice;
                    discountPrice += item.discountPurchasePrice;
                    pfs += item.pfs;
                });
                vm.purchase.totalPrice = totalPrice;
                vm.purchase.discountFinalPrice = discountFinalPrice;
                vm.purchase.netPrice = netPrice;
                vm.purchase.taxPrice = taxPrice;
                vm.purchase.finalPrice = finalPrice;
                vm.purchase.discountPercent = 0;
                vm.purchase.discountPrice = discountPrice;
                vm.purchase.presentPercent = 0;
                vm.purchase.presentPrice = 0;
                vm.purchase.pfs = pfs;

                //Functionality for save row on enter.
                items.each(function () {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].field !== "destroy") {
                            angular.element(this).find("td:eq(" + i + ")").keydown(function (e) {
                                if (e.keyCode === 13) {
                                    grid.saveRow();
                                }
                            });
                        }

                        var row = angular.element(this);
                        if(!vm.priceCalculation) row.find(".k-hierarchy-cell").html("");
                    }
                });
                this.expandRow(this.tbody.find("tr.k-master-row"));
            },
            pageable: false
        };
        vm.purchasePresentItemsOptions = {
            dataSource:  new kendo.data.DataSource({
                data: vm.selectedProducts,
                schema : {
                    model: {
                        id: "id",
                        fields: {
                            id:"id",
                            'product.name': { editable: false },
                            'product.code': { editable: false },
                            quantity: { editable: true, type: "number", validation: { min: 0 }, defaultValue: 1 },
                            quantityExecuted: { editable: true, type: "number", validation: { min: 0 } },
                            price: { editable: false, type: "number", validation: { min: 0 } }
                        }
                    }
                }
            }),
            navigatable: true,
            editable: true,
            resizable: true,
            columns:  [
                {
                    field: "product.code",
                    title: "Κωδικός είδους"
                },
                {
                    field: "product.name",
                    title: "Περιγραφή είδους"
                },
                {
                    field: "quantity",
                    title: "Ποσότητα",
                    attributes:{style:"text-align:right;"}
                },
                {
                    field: "quantityExecuted",
                    title: "Εκτελεσμένη Ποσότητα",
                    attributes:{style:"text-align:right;"}
                },
                {
                    field: "price",
                    title: "Τιμή",
                    attributes:{style:"text-align:right;"},
                    template: function (model) {
                        var date = new Date();
                        angular.forEach( model.product.productPrices, function( productPrice ) {
                            if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                                model.price = productPrice.wholesalePrice || 0;
                            }
                        });
                        return kendo.format('{0:c}', model.price || 0);
                    }
                },
                {
                    field: "destroy",
                    template: "<md-button data-command='destroy' class='k-grid-delete md-icon-button md-mini md-warn' aria-label='Delete'>" +
                    "<i class='material-icons' style='vertical-align: inherit;'>delete_forever</i>" +
                    "</md-button>",
                    title: "&nbsp;",
                    width: 100
                }
            ],
            pageable: false,
            dataBound: function(e) {
                var items = e.sender.items();
                var columns = e.sender.options.columns;
                var grid = e.sender;
                //Functionality for save row on enter.
                items.each(function () {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].field !== "destroy") {
                            angular.element(this).find("td:eq(" + i + ")").keydown(function (e) {
                                if (e.keyCode === 13) {
                                    grid.saveRow();
                                }
                            });
                        }
                    }
                });
            }
        };
        vm.productsGridOptions = {
            dataSource: vm.productsGridDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            editable: true,
            columns: [
                {
                    field: "product.code",
                    title: "Κωδικός Είδους",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.name",
                    title: "Περιγραφή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.active" ' + 'ng-disabled="true"></md-checkbox>',
                    editor: function(container,options){
                        angular.element('<md-checkbox ng-model="dataItem.active"  aria-label="active" ' +
                            'class="checkbox-toolbar customers green inline"></md-checkbox>')
                            .appendTo(container);
                    },
                    field: "active",
                    title: "Ενεργό",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            selectedItems: function(dataItems) {
                vm.selectedProducts = dataItems;
            },
            dataBound: function () {
                angular.element("#productsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedProductsViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedProducts, {id: item.id}, true)[0];
                    if(vm.selectedProducts.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedProductsViewCounter++
                    }
                });
                if(selectedProductsViewCounter === view.length) {
                    angular.element("#productsGridcheckbox").prop('checked', true);
                }
            }
        };
        vm.sectorsGridOptions = {
            autoBind: false,
            dataSource: dataSource.sectorsDataSource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "code",
                    title: "Κωδικός Ε.Ε.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "name",
                    title: "Επωνυμία",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "vat",
                    title: "Α.Φ.Μ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "address",
                    title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "addressNum",
                    title: "Αριθμός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "cityName",
                    title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "prefectureName",
                    title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "phone",
                    title: "Τηλέφωνο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "sectorType.sectorTypeCategory",
                    title: "Τύπος",
                    template: "#= (sectorType.sectorTypeCategory == 'beautyCenter') ? 'Κέντρο Αισθητικής' : (sectorType.sectorTypeCategory == 'pharmacy') ? 'Φαρμακείο' : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Κέντρο Αισθητικής", value: "beautyCenter" },
                                            { text: "Φαρμακείο", value: "pharmacy" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.creditControlCheck" ' +
                    'ng-disabled="true"></md-checkbox>',
                    field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }},
                {
                    command: {
                        text: "Επιλογή",
                        click: onSectorGridSelection
                    }
                }
            ]
        };

        vm.update = function(ev) {
            vm.isSaving = true;
            if (vm.purchase.sector) if (vm.purchase.sector.id === null) vm.purchase.sector = null;
            if (vm.purchase.paymentMethod) if (vm.purchase.paymentMethod.id === null) vm.purchase.paymentMethod = null;
            if (vm.purchase.purchaseNumberingRow) if (vm.purchase.purchaseNumberingRow.id === null) vm.purchase.purchaseNumberingRow = null;
            if (vm.purchase.picker) if (vm.purchase.picker.id === null) vm.purchase.picker = null;

            if (!vm.priceCalculation) {
                if (vm.purchase.sector) vm.purchase.sector.shippingAddress = null;
                vm.purchase.purchaseStatus = null;
                vm.purchase.picker = null;
                vm.purchase.comment = null;
            }

            var purchaseItemList = vm.purchaseItemsOptions.dataSource.data();

            vm.validation = true;

            if (vm.validator.validate()){
                if (purchaseItemList.length > 0) {
                    for (var i = 0, len = purchaseItemList.length; i < len; i++) {
                        if (!purchaseItemList[i].product || !purchaseItemList[i].product.name) {
                            vm.validation = false;
                            vm.isSaving = false;
                            break;
                        }
                    }

                    vm.purchase.issueDate = kendo.toString(kendo.parseDate(vm.purchase.issueDate), 'yyyy-MM-dd');
                    if (vm.purchase.desirableExecutionDate !== null &&
                        vm.purchase.desirableExecutionDate !== undefined &&
                        vm.purchase.desirableExecutionDate !== ""){
                        vm.purchase.desirableExecutionDate = kendo.toString(kendo.parseDate(vm.purchase.desirableExecutionDate), 'yyyy-MM-dd');
                    }

                    angular.extend(vm.purchase, getPurchaseAddress(vm.purchase.sector));
                    angular.forEach(purchaseItemList, function (item) {
                        item.purchase = {id: vm.selectedPurchaseId};
                    });

                    var purchasePresentItemList = vm.purchasePresentItemsOptions.dataSource.data();
                    angular.forEach(purchasePresentItemList, function (item) {
                        item.purchase = {id: vm.selectedPurchaseId};
                    });

                    //console.log("try to save purchase with items:");
                    //console.log({purchase: vm.purchase, purchaseItems: purchaseItemList, purchasePresentItems: purchasePresentItemList});

                    $http.put('/api/purchases/update-with-items', {
                        purchase: vm.purchase,
                        purchaseItems: purchaseItemList,
                        purchasePresentItems: purchasePresentItemList
                    }).success(function (response) {
                        vm.isSaving = false;
                        KendoNotifications.onSaveSuccess(notification);
                        vm.goBack();
                    }).error(function (error) {
                        if (error.message && error.message.includes("error.concurrencyFailure")) {
                            Alerts.showConfirmDialog(ev, $filter('translate')('error.purchase.purchaseConcurrencyFailureTitle'),
                                $filter('translate')('error.purchase.purchaseConcurrencyFailureMessage'),
                                false, $filter('translate')('entity.action.refresh'), $filter('translate')('entity.action.cancel'), function () {
                                    // on confirm
                                    $window.location.reload();
                                }, function () {
                                    // on cancel
                                });
                        }else {
                            KendoNotifications.onSaveError(notification);
                        }
                    });
                }else {
                    vm.isSaving = false;
                    vm.validation = false;
                }
            }else {
                vm.isSaving = false;
                KendoNotifications.onSaveError(notification);
            }
        };

        vm.addPresentList = function () {
            vm.initPopupGrid = true;
            vm.clearPopUpGrid("opened");
            vm.presentListProductsWindow.center().open();
        };

        vm.closeProductsWindow = function () {
            delete vm.initPopupGrid;
            vm.clearPopUpGrid("closed");
            vm.presentListProductsWindow.close();
        };

        vm.clearPopUpGrid = function(status) {
            KendoGrid.refresh(vm.productsGridOptions);
            vm.statusChanged = status;
        };

        vm.openSectorsGrid = function() {
            vm.sectorsGridOptions.dataSource.read();
            vm.window.title("Επιλέξτε Επαγγελματία Υγείας");
            vm.window.center().open();
        };

        vm.closeSectorsGrid = function() {
            vm.window.close();
        };

        var presentList;
        vm.addProducts = function () {
            if (!vm.purchasePresentItemsOptions.dataSource.data().length || presentList === vm.purchase.presentList) {
                angular.forEach( vm.selectedProducts, function( item ) {

                    var data = { filter: { filters: [{field: "product.id", operator: "eq", value: item.id}] } };
                    $http.get('/api/product-prices/search', {params: data})
                        .success(function (response) {
                            var newItem = {
                                quantity: item.quantity,
                                quantityExecuted: 0,
                                presentListProduct: { id: item.id },
                                product: { id: item.product.id ,code: item.product.code, name: item.product.name,
                                    productPrices: item.product.productPrices },
                                price: null
                            };

                            angular.forEach( response.content, function( productPrice ) {
                                var date = new Date();
                                if (date > new Date(productPrice.startedDate) && date < new Date(productPrice.endedDate)) {
                                    newItem.price = productPrice.wholesalePrice || null;
                                }
                            });

                            vm.purchasePresentItemsOptions.dataSource.add( newItem );
                        })
                        .error(function (response) {});
                });
                presentList = vm.purchase.presentList;
            } else {
                vm.showConfirm();
            }

            vm.presentListProductsWindow.close();
            vm.clearPopUpGrid("closed");
        };

        vm.showConfirm = function() {
            var confirm = $mdDialog.confirm()
                .title('Τα ήδη υπάρχοντα προϊόντα θα διαγραφουν!')
                .textContent('Είστε σίγουροι ότι θέλετε να συνεχίσετε;')
                .ariaLabel('list-warning')
                .ok('Ναι!')
                .cancel('Όχι');

            $mdDialog.show(confirm).then(function() {
                angular.forEach( vm.purchasePresentItemsOptions.dataSource.data(), function( item ) {
                    var foundItemById = $filter('filter')(vm.selectedProducts, {id: item.id}, true)[0];
                    if(vm.selectedProducts.indexOf(foundItemById) !== -1){
                        vm.selectedProducts.splice(vm.selectedProducts.indexOf(foundItemById), 1);
                    }
                });
                vm.purchasePresentItemsOptions.dataSource.data([]);
                vm.addProducts();
            }, function() {});
        };

        vm.goBack = function () {
            $state.go('purchases');
        };

        function setUpWithPurchase() {
            if(vm.purchase.netPrice) vm.netPrice = vm.purchase.netPrice.toLocaleString();
            if(vm.purchase.discountFinalPrice) vm.discountFinalPrice = vm.purchase.discountFinalPrice.toLocaleString();
            if(vm.purchase.totalPrice) vm.totalPrice = vm.purchase.totalPrice.toLocaleString();
            if(vm.purchase.taxPrice) vm.taxPrice = vm.purchase.taxPrice.toLocaleString();
            if(vm.purchase.finalPrice) vm.finalPrice = vm.purchase.finalPrice.toLocaleString();

            if (!vm.purchase.shippingAddressNum) vm.purchase.shippingAddressNum = "";
            if (!vm.purchase.shippingPostalCode) vm.purchase.shippingPostalCode = "";

            vm.purchase.fullAddress = vm.purchase.shippingAddress + " "
                + vm.purchase.shippingAddressNum + " "
                + vm.purchase.shippingCityName + " "
                + vm.purchase.shippingPrefectureName + " "
                + vm.purchase.shippingCountryName + " "
                + vm.purchase.shippingPostalCode;

            if (vm.purchase.picker) {
                vm.purchase.picker.fullName = vm.purchase.picker.account.lastName + " " + vm.purchase.picker.account.firstName
            }
        }

        function getPurchaseAddress (sector) {
            return {
                shippingAddress: sector.address,
                shippingAddressNum:  sector.addressNum,
                shippingCityName:  sector.cityName,
                shippingPrefectureName:  sector.prefectureName,
                shippingCountryName:  sector.countryName,
                shippingPostalCode:  sector.postalCode
            }
        }

        function onSectorGridSelection(e){
            e.preventDefault();
            var data = this.dataItem(angular.element(e.currentTarget).closest("tr"));

            $timeout( function() {
                vm.purchase.sector = data;
                vm.purchase.sector.shippingAddress = vm.purchase.sector.address;
                if(vm.purchase.sector.address) {
                    angular.element("#sectorAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                    angular.element("#sectorShippingAddress").css('width', ((vm.purchase.sector.address.length + 1) * 10) + 'px');
                }
            });
            angular.element("#sectorName").data('kendoComboBox').text(data.name);
            vm.closeSectorsGrid();
        }
    }
})();
;
/**
 * Created by gmogas on 18/1/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchaseItems', {
                parent: 'purchaseView',
                url: '/purchaseItems',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/purchases/items/purchaseItems.html',
                controller: 'PurchaseItemsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Purchase', function($stateParams, Purchase) {
                        return Purchase.get({id : $stateParams.id});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchase');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 18/1/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemsController', PurchaseItemsController);

    PurchaseItemsController.$inject = ['PurchaseItemLot', 'entity', '$http', '$stateParams', '$filter', '$timeout', 'KendoGrid', 'KendoFilter', 'PurchaseItem', 'KendoNotifications', 'PurchaseGrids', 'ApplicationParameters', 'Principal', 'Alerts', '$window'];

    function PurchaseItemsController (PurchaseItemLot, entity, $http, $stateParams, $filter, $timeout, KendoGrid, KendoFilter, PurchaseItem, KendoNotifications, PurchaseGrids, ApplicationParameters, Principal, Alerts, $window) {
        var vm = this;
        var firstTime = true;
        vm.showProgress = false;

        ApplicationParameters.hasModule('Purchase_Pharmacies', true);
        vm.purchaseGrids = PurchaseGrids;
        vm.kendoGrid = KendoGrid;
        vm.selectedPurchaseId = $stateParams.id;
        vm.purchase = entity;
        vm.purchasePresentItemsGridHeading = $filter('translate')('sigmasfApp.purchase.purchasePresentItemsGrid.title');
        vm.purchaseItemsGridHeading = $filter('translate')('sigmasfApp.purchase.purchaseItemsGrid.title');
        vm.quantityLot = 1;
        vm.options = {
            format: "n2",
            decimals: 2
        };

        vm.addPurchaseItemLot = function(dataItem) {
            //expand row
            var grid = angular.element("#purchaseItemsGrid");
            var row = grid.find("[data-uid=" + dataItem.uid +"]");
            grid.data("kendoGrid").expandRow(row);

            //add row in detailed grid
            var detailedGrid = row.next('tr').find('#detailGrid');
            $timeout(function (){
                detailedGrid.data("kendoGrid").addRow();
            }, 500);
        };

        vm.addProductLots = function() {
            var data = {
                quantity: vm.quantityLot,
                idNumber: vm.barcode,
                purchaseId: vm.selectedPurchaseId
            };

            var request = {
                method: 'POST',
                url: 'api/product-lots/dispense',
                data: data
            };

            $http(request).then(function successCallback(response) {
                if (response.data) {
                    var grid = angular.element("#purchaseItemsGrid").data("kendoGrid");
                    var dataItem = grid.dataSource.get(response.data.id);
                    dataItem.quantityExecuted = response.data.quantityExecuted;
                    vm.quantityLot = 1;
                    vm.barcode = null;
                    angular.element("#quantityLot").data("kendoNumericTextBox").focus();
                    // Refresh grid
                    vm.kendoGrid.refresh(vm.purchaseItemsGridOptions);
                }
            }, function errorCallback(response) {

                var centered = $("#centeredNotification").kendoNotification({
                    stacking: "down",
                    autoHideAfter: 0,
                    show: KendoNotifications.onShow,
                    button: true,
                    hideOnClick: false,
                    width: 500,
                    height: 250
                }).data("kendoNotification");

                centered.show(' ' + $filter('translate')('global.messages.error.' + response.data.params[0] + ' '), "error");
            });


        };

        vm.purchaseItemsGridOptions = PurchaseGrids.getPurchaseItemsGridOptions(vm.selectedPurchaseId);
        vm.purchaseItemsForPDFGridOptions = PurchaseGrids.getPurchaseItemsGridOptions(vm.selectedPurchaseId);
        vm.purchaseItemsGridOptions.height = 750;
        vm.purchaseItemsGridOptions.dataBound = function () {
            angular.element("#quantityLot").data("kendoNumericTextBox").focus();
            Principal.hasAuthority('ROLE_STOREHOUSE')
                .then( function (result) {
                    vm.purchaseGrids.setVisibility(!!result);
                    if (result === true){
                        // Hide 'destroy' column for ROLE_STOREHOUSE from purchaseItemsGrid
                        var index = null;
                        if (vm.purchaseItemsGridOptions && vm.purchaseItemsGridOptions.columns && vm.purchaseItemsGridOptions.columns.length > 0){
                            for (var i=0; i<vm.purchaseItemsGridOptions.columns.length; i++){
                                if (vm.purchaseItemsGridOptions.columns[i].field === 'destroy'){
                                    index = i;
                                    break;
                                }
                            }
                            if (index !== null){
                                angular.element("#purchaseItemsGrid").data("kendoGrid").hideColumn(index);
                            }
                        }
                        // Also hide 'destroy' column for ROLE_STOREHOUSE from purchaseItemsForPDFGrid
                        if (vm.purchaseItemsForPDFGridOptions && vm.purchaseItemsForPDFGridOptions.columns && vm.purchaseItemsForPDFGridOptions.length > 0){
                            index = null;
                            for (var j=0; i<vm.purchaseItemsForPDFGridOptions.columns.length; j++){
                                if (vm.purchaseItemsForPDFGridOptions.columns[j].field === 'destroy'){
                                    index = j;
                                    break;
                                }
                            }
                            if (index !== null){
                                angular.element("#purchaseItemsForPDFGrid").data("kendoGrid").hideColumn(index);
                            }
                        }
                    }
                });
            if (vm.purchase.purchaseStatus) PurchaseGrids.setIsEditable(vm.purchase.purchaseStatus.isEditable);
        };
        vm.purchasePresentItemsGridOptions = PurchaseGrids.getPurchasePresentItemsGridOptions(vm.selectedPurchaseId);

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                vm.showProgress = true;
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "purchaseItem.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/purchase-item-lots/search',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                        vm.showProgress = false;
                                    });
                            },
                            create: function(o) {
                                vm.showProgress = true;
                                var data = o.data.models[0];
                                data.purchaseItem = {id : dataItem.id};

                                $http.post('/api/purchase-item-lots', data)
                                    .success(function (response) {
                                        o.success(response);
                                        dataItem.quantityExecuted = response.purchaseItem.quantityExecuted;
                                        dataItem.quantity = response.purchaseItem.quantity;
                                        dataItem.measurementUnit = response.purchaseItem.measurementUnit;
                                        dataItem.executedDiscountSummary = response.purchaseItem.executedDiscountSummary;
                                        dataItem.version = response.purchaseItem.version;

                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        o.error(response);
                                        vm.showProgress = false;
                                        console.log(response);
                                        Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά την δημιουργία Παρτίδας!\n" + response.message, "ΟΚ");
                                        vm.kendoGrid.refresh(vm.purchaseItemsGridOptions);
                                    });
                            },
                            update: function(o) {
                                vm.showProgress = true;
                                var data = o.data.models[0];

                                $http.put('/api/purchase-item-lots', data)
                                    .success(function (response) {
                                        o.success(response);
                                        dataItem.quantityExecuted = response.purchaseItem.quantityExecuted;
                                        dataItem.quantity = response.purchaseItem.quantity;
                                        dataItem.measurementUnit = response.purchaseItem.measurementUnit;
                                        dataItem.executedDiscountSummary = response.purchaseItem.executedDiscountSummary;
                                        dataItem.version = response.purchaseItem.version;

                                        vm.showProgress = false;
                                    })
                                    .error(function (error) {
                                        o.error(error);
                                        vm.showProgress = false;
                                        if (error.message && error.message.includes("error.concurrencyFailure")) {
                                            Alerts.showConfirmDialog(null, $filter('translate')('error.purchaseItemLot.purchaseItemLotConcurrencyFailureTitle'),
                                                $filter('translate')('error.purchaseItemLot.purchaseItemLotConcurrencyFailureMessage'),
                                                false, $filter('translate')('entity.action.refresh'), $filter('translate')('entity.action.cancel'), function () {
                                                    // on confirm
                                                    $window.location.reload();
                                                }, function () {
                                                    // on cancel
                                                });
                                        }else {
                                            Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά την δημιουργία Παρτίδας!\n" + error.message, "ΟΚ");
                                            vm.kendoGrid.refresh(vm.purchaseItemsGridOptions);
                                        }
                                    });
                            },
                            destroy: function(o) {
                                var data = o.data.models[0];
                                PurchaseItemLot.delete({id: data.id},
                                    function () {
                                        var grid = angular.element("#purchaseItemsGrid");
                                        grid.data("kendoGrid").dataSource.read();
                                    });

                            }
                        },
                        requestEnd: function(e) {
                            var type = e.type;
                            if (type == "create"|| type == "destroy") {
                                var dataSource = this;
                                dataSource.read();
                            }

                            if (type == "create" || type == "update"|| type == "destroy") {
                                var grid = angular.element("#detailGrid").data("kendoGrid");
                                grid.dataSource.read();
                            }
                            vm.showProgress = false;
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    name: { validation: { namevalidation: function (input) {
                                        if (input.is("[name='name']") && input.val() !== "") {
                                            input.attr("data-namevalidation-msg", "Χρησιμοποιήστε μόνο λατινικούς χαρακτήρες");
                                            return /^[a-zA-Z0-9]+$/.test(input.val());
                                        }
                                        return true;
                                    } } },
                                    quantity: { editable: true, nullable: false, type: "number",
                                        validation: { min: 1, required: { message: "Η ποσότητα είναι υποχρεωτική" }}
                                        /*defaultValue: dataItem.quantity - dataItem.quantityExecuted*/
                                    }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {
                            field: "name",
                            title: "Παρτίδα",
                            filterable: false
                        },
                        {
                            field: "quantity", title: "Ποσότητα", format: "{0:n0}",
                            filterable: false
                        },
                        {
                            field: "destroy",
                            filterable: false,
                            command: [
                                {
                                    name: "destroy",
                                    text: ""
                                }
                            ],
                            title: "&nbsp;"
                        }
                    ],
                    editable: "inline",
                    selectable: "row",
                    navigatable: true,
                    rowTemplate: kendo.template(angular.element("#gridItemsRowTemplate").html()),
                    edit: function(e) {
                        KendoGrid.defaultEditInline(this._editContainer);
                        var quantityDefaultValue = dataItem.quantity - dataItem.quantityExecuted;

                        // This setOptions here does not work SIGMASF-2197
                        // Updating inside event handler is not recommended (https://docs.telerik.com/kendo-ui/api/javascript/ui/widget/methods/setoptions)
                        /*e.container.find("input[name=quantity]").data("kendoNumericTextBox").setOptions({
                            max: quantityDefaultValue,
                            value: quantityDefaultValue,
                            format: '{0:n0}'
                        });*/

                        var quantityInput = e.container.find("input[name=quantity]").data("kendoNumericTextBox");
                        if (quantityInput.value() === null){
                            // Apply the default value only if there is not any value
                            quantityInput.value(quantityDefaultValue);
                            quantityInput.max(quantityDefaultValue);
                            quantityInput.trigger("change");
                        }
                    },
                    // This event causes problems with the PurchaseItem.ExecQuantity.
                    // It runs before the update of PurchaseItemLot
                    /*save: function() {
                        vm.showProgress = true;
                        var data = this._data;
                        dataItem.quantityExecuted = 0;
                        angular.forEach( data, function (item) {
                            dataItem.quantityExecuted += item.quantity;
                        });
                        if (dataItem.quantityExecuted <= dataItem.quantity) {
                            dataItem.measurementUnit = null;
                            dataItem.executedDiscountSummary = (dataItem.quantityExecuted / (dataItem.quantity ? dataItem.quantity : 1)) * (dataItem.discountSummary ? dataItem.discountSummary : 0);
                            PurchaseItem.update(dataItem, function (success) {
                                vm.showProgress = false;
                            }, function (error) {
                                vm.showProgress = false;
                            });
                        }
                    },*/
                    dataBound: function() {
                        angular.element("#detailGrid tbody tr").on("click", function(e) {
                            if (!angular.element(this).hasClass('k-grid-edit-row')) {
                                angular.element("#detailGrid").data("kendoGrid").editRow(angular.element(this));
                            }
                        });
                    }
                };
            }
        };

        vm.purchaseItemLotsColumns = [
            {
                field: "purchaseItem.purchase.code",
                title: "Αριθμός"
            },
            {
                field: "purchaseItem.purchase.sector.code",
                title: "Κωδικός επαγγελματία υγείας"
            },
            {
                field: "purchaseItem.purchase.sector.name",
                title: "Επωνυμία"
            },
            {
                field: "paymentMethod.code",
                title: "Τρόπος Πληρωμής"
            },
            {
                field: "employeeCode",
                title: "Ιατρικός Επισκέπτης"
            },
            {
                field: "purchaseItem.product.code",
                title: "Κωδικός Είδους"
            },
            {
                field: "name",
                title: "Παρτίδα"
            },
            {
                field: "quantity",
                title: "Ποσότητα"
            },
            {
                field: "purchaseItem.productPrice",
                title: "Τιμή Μονάδος"
            },
            { //09
                field: "purchaseItem.discountSummary",
                title: "Συνολική Έκπτωση"
            },
            { //10
                field: "purchaseItem.executedDiscountSummary",
                title: "Συνολική Έκπτωση"
            },
            { //11
                field: "purchaseItem.purchase.eventComments",
                title: "Σχόλια Event"
            },
            { //12
                field: "isPresent",
                title: "Δώρο"
            },
            { //13
                field: "totalLineValue",
                title: "Συνολική Αξία Γραμμής"
            },
            { //14
                field: "progressiveValue",
                title: "Προοδευτική Αξία"
            }
        ];

        vm.purchaseItemLotsDatasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "purchaseItem.purchase.id", "operator": "eq",  "value": vm.selectedPurchaseId }
                        ]
                    );

                    /** Need sort in product for calculating correctly the 'progressiveValue' in excel SIGMASF-2073 **/
                    o.data.sort = { "field": "purchaseItem.id",  "dir": "asc" };

                    $http.get('/api/purchase-item-lots/search',
                        {params: o.data})
                        .success(function (response) {
                            // Also get Purchase Present Item Lots and add them to response
                            var filters = {
                                data: {
                                    "page": 1,
                                    "pageSize": 5000,
                                    filter: {
                                        logic: "and",
                                        filters: [{
                                            "operator": "eq",
                                            "value": vm.selectedPurchaseId,
                                            "field": "purchasePresentItem.purchase.id"
                                        }]
                                    },
                                    sort: {
                                        "field": "purchasePresentItem.id", "dir": "asc"
                                    }
                                }
                            };
                            $http.get('/api/purchase-present-item-lots/search', {params: filters.data})
                                .success(function (purchasePresentItemLots) {
                                    response.content.forEach(function (item) {
                                        item.isPresent = 0;
                                    });
                                    if (purchasePresentItemLots !== null && purchasePresentItemLots !== undefined && purchasePresentItemLots.content){
                                        var addedPresents = 0;
                                        for (var i=0; i<purchasePresentItemLots.content.length; i++){
                                            var item = purchasePresentItemLots.content[i];
                                            if (item.purchasePresentItem.quantityExecuted !== null &&
                                                item.purchasePresentItem.quantityExecuted !== undefined &&
                                                item.purchasePresentItem.quantityExecuted > 0){
                                                response.content.push({
                                                    "id": item.id,
                                                    "name": item.name,
                                                    "quantity": item.quantity,
                                                    "purchaseItem": {
                                                        "createdBy": item.purchasePresentItem.createdBy,
                                                        "createdDate": item.purchasePresentItem.createdDate,
                                                        "lastModifiedBy": item.purchasePresentItem.lastModifiedBy,
                                                        "lastModifiedDate": item.purchasePresentItem.lastModifiedDate,
                                                        "id": item.purchasePresentItem.id,
                                                        "quantity": item.purchasePresentItem.quantity,
                                                        "productPrice": item.purchasePresentItem.price,
                                                        "netPrice": 0,
                                                        "discountPercent": 0,
                                                        "discountPrice": 0,
                                                        "discountLinePercent": 0,
                                                        "discountLinePrice": 0,
                                                        "totalPrice": 0,
                                                        "taxPrice": 0,
                                                        "finalPrice": 0,
                                                        "comment": null,
                                                        "quantityExecuted": item.purchasePresentItem.quantityExecuted,
                                                        "discountPurchasePercent": 0,
                                                        "discountPurchasePrice": 0,
                                                        "discountSummary": item.quantity * item.purchasePresentItem.price,
                                                        "executedDiscountSummary": item.purchasePresentItem.quantityExecuted * item.purchasePresentItem.price,
                                                        "taxPercent": 0,
                                                        "lotNumber": null,
                                                        "pfs": 0,
                                                        "product": item.purchasePresentItem.product,
                                                        "purchase": item.purchasePresentItem.purchase,
                                                        "measurementUnit": null
                                                    },
                                                    "isPresent": 1
                                                });
                                                addedPresents++;
                                            }
                                        }
                                        response.count = response.count + addedPresents;
                                        response.totalEntries = response.totalEntries + addedPresents;
                                    }
                                    // bind initial response
                                    o.success(response);
                            }).error(function (error) {
                                // bind initial response anyway
                                o.success(response);
                            });
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content.length) {
                        var progressiveValue = 0;
                        var prevRowId = null;
                        angular.forEach(data.content, function(item){
                            item.paymentMethod = vm.purchase.paymentMethod;
                            if (vm.purchase.employee) { item.employeeCode = vm.purchase.employee.code; }
                            if (!item.purchaseItem) { item.purchaseItem = { product: {} } }
                            if (!item.paymentMethod) { item.paymentMethod = {} }
                            if (item.purchaseItem.purchase === null) item.purchaseItem.purchase = {};
                            if (item.purchaseItem.purchase.code === null) item.purchaseItem.purchase.code ="";
                            if (item.purchaseItem.purchase.sector === null) item.purchaseItem.purchase.sector = {};
                            if (item.purchaseItem.purchase.sector.name === null) item.purchaseItem.purchase.sector.name = "";
                            if (item.purchaseItem.purchase.sector.code === null) item.purchaseItem.purchase.sector.code = "";
                            // Custom calculated values
                            //item.totalLineValue = (item.purchaseItem.netPrice ? item.purchaseItem.netPrice : 0) + (item.purchaseItem.pfs ? item.purchaseItem.pfs : 0); // OLD
                            if (item.isPresent === 0){
                                // Purchase Item
                                if (item.purchaseItem.product.calcPFS === true){
                                    item.totalLineValue = ((item.purchaseItem.quantityExecuted ? item.purchaseItem.quantityExecuted : 0) * (item.purchaseItem.productPrice ? item.purchaseItem.productPrice : 0) * 1.004) - (item.purchaseItem.executedDiscountSummary ? item.purchaseItem.executedDiscountSummary : 0); // NEW
                                }else {
                                    item.totalLineValue = ((item.purchaseItem.quantityExecuted ? item.purchaseItem.quantityExecuted : 0) * (item.purchaseItem.productPrice ? item.purchaseItem.productPrice : 0)) - (item.purchaseItem.executedDiscountSummary ? item.purchaseItem.executedDiscountSummary : 0); // NEW
                                }
                            }else {
                                // Purchase Present Item
                                item.totalLineValue = ((item.purchaseItem.quantityExecuted ? item.purchaseItem.quantityExecuted : 0) * (item.purchaseItem.productPrice ? item.purchaseItem.productPrice : 0)) - (item.purchaseItem.executedDiscountSummary ? item.purchaseItem.executedDiscountSummary : 0); // NEW
                            }

                            if (prevRowId === null){
                                prevRowId = item.purchaseItem.id;
                                progressiveValue += (item.isPresent === 0 ? item.totalLineValue : 0);
                            }else {
                                if (prevRowId !== item.purchaseItem.id){
                                    // Only sum the progressive value if the product has changed.
                                    // Works in a sorted list. SIGMASF-2073
                                    progressiveValue += (item.isPresent === 0 ? item.totalLineValue : 0);
                                }
                                prevRowId = item.purchaseItem.id;
                            }

                            item.progressiveValue = progressiveValue;
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true}
                    }
                }
            },
            pageSize: 100,
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            scrollable:false
        });

        var exportFlag = false;
        vm.purchaseItemLotsGridOptions = {
            dataSource: vm.purchaseItemLotsDatasource,
            columns:  vm.purchaseItemLotsColumns,
            dataBound: function () {
                // Hide the custom calculated columns when displaying grid
                this.hideColumn(10); // item.executedDiscountSummary - Συνολική Έκπτωση
                this.hideColumn(11); // item.purchase.eventComments - Σχόλια Event
                this.hideColumn(12); // item.isPresent - Δώρο
                this.hideColumn(13); // item.totalLineValue - Συνολική Αξία Γραμμής
                this.hideColumn(14); // item.progressiveValue - Προοδευτική Αξία
            },
            excel: {
                allPages: true,
                fileName: "Παρτίδες Φαρμάκων.xlsx"
            },
            editable: false,
            excelExport: function (e) {
                // Show/Hide custom calculated columns when export grid in excel
                if (!exportFlag){
                    e.sender.hideColumn(9);  // item.discountSummary - Συνολική Έκπτωση
                    e.sender.showColumn(10); // item.executedDiscountSummary - Συνολική Έκπτωση
                    e.sender.showColumn(11); // item.purchase.eventComments - Σχόλια Event
                    e.sender.showColumn(12); // item.isPresent - Δώρο
                    e.sender.showColumn(13); // item.totalLineValue - Συνολική Αξία Γραμμής
                    e.sender.showColumn(14); // item.progressiveValue - Προοδευτική Αξία
                    e.preventDefault();
                    exportFlag = true;
                    setTimeout(function () {
                        console.log(e.sender.columns);
                        e.sender.saveAsExcel();
                    });
                }else {
                    this.showColumn(9);  // item.discountSummary - Συνολική Έκπτωση
                    this.hideColumn(10); // item.executedDiscountSummary - Συνολική Έκπτωση
                    this.hideColumn(11); // item.purchase.eventComments - Σχόλια Event
                    this.hideColumn(12); // item.isPresent - Δώρο
                    this.hideColumn(13); // item.totalLineValue - Συνολική Αξία Γραμμής
                    this.hideColumn(14); // item.progressiveValue - Προοδευτική Αξία
                    exportFlag = false;
                }
            }
        };
    }

})();
;
/**
 * Created by Kristy on 10/5/2018.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientViewController', ProspectivePatientViewController);

    ProspectivePatientViewController.$inject = ['entity', '$state'];

    function ProspectivePatientViewController (entity, $state) {
        var vm = this;
        vm.$state = $state;
        vm.prospectivePatient = entity;

        vm.goBack = function () {
            $state.go('prospectivePatients');
        };
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatients', {
                parent: 'app',
                url: '/prospectivePatients',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/prospectivePatients/prospectivePatients.html',
                        controller: 'ProspectivePatientsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prospectivePatientView', {
                abstract: true,
                parent: 'app',
                url: '/prospectivePatients/search?id:prospectivePatientId',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/prospectivePatients/prospectivePatientView.html',
                        controller: 'ProspectivePatientViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    entity: ['$stateParams', 'ProspectivePatient', function($stateParams, ProspectivePatient) {
                        return ProspectivePatient.get({id : $stateParams.id});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientsController', ProspectivePatientsController);

    ProspectivePatientsController.$inject = ['$http', '$state', '$filter','KendoFilter', 'KendoGrid', 'ProspectivePatient', 'CalculateAge', 'KendoService', '$timeout', 'CustomUtils'];

    function ProspectivePatientsController ($http, $state, $filter, KendoFilter, KendoGrid, ProspectivePatient, CalculateAge, KendoService, $timeout, CustomUtils) {
        var vm = this;
        vm.editMode = false;
        vm.pageHeading = "Πιθανοι Ασθενεις";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(66);
        var comboBoxes = ["#masterFilter", "#prefectures", "#cities"];
        var grid = {};
        var dataSource = {};

        vm.birthYearOptions = {
            start: "decade",
            depth: "decade",
            format: "yyyy"
        };

        var promise = $http.get('/api/employees/me');
        promise.then(function(response) {
            vm.geodata = response.data.geodata;
            if(!vm.geodata) vm.initializeMasterData();
            else vm.initializeGeodata();
        });

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        vm.initializeMasterData = function() {
            //Prefectures Combobox
            dataSource.prefecturesDataSource = KendoService.initDefaultDataSource('/api/masterdata/prefectures');
            vm.prefecturesComboBoxOptions = KendoService.initDefaultOptions(dataSource.prefecturesDataSource, "startswith", "name", "id", false);
            vm.prefecturesComboBoxOptions.change = function() {
                var filter = {};
                if(this.value() && !isNaN(this.value())) {
                    filter = {
                        "field": "prefecture.id",
                        "operator": "eq",
                        "value": this.value()
                    };
                }
                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
            };

            //Cities Combobox
            dataSource.citiesDataSource = KendoService.initDataSource('/api/masterdata/cities', 1, 50);
            vm.citiesComboBoxOptions = KendoService.initDefaultOptions(dataSource.citiesDataSource, "startswith", "name", "id", false);
            vm.citiesComboBoxOptions.template = "<table>${name} &nbsp;<span class='hint'>(${prefecture.name})</span></table>";
            vm.citiesComboBoxOptions.change = function() {
                var filter = {};
                if(this.dataItem(this.select())) {
                    filter = {
                        "field"   : "id",
                        "operator": "eq",
                        "value"   : this.dataItem(this.select()).prefecture.id
                    };
                    vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                } else {
                    vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                }
            };
        };

        vm.initializeGeodata = function() {
            dataSource.geodataDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) o.data.filter = { filters: [] };

                        o.data.page = 1;
                        o.data.pageSize = 100;
                        $http.get('/api/masterdata/geodata',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            item.masterFilter = "";
                            if(item.street !==null) {
                                item.masterFilter =  item.street + ", ";
                            }
                            item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                        });
                        return data;
                    }
                }
            });

            vm.masterFilterComboBoxOptions = KendoService.initDefaultOptions(dataSource.geodataDataSource, "search", "masterFilter", "id");
            vm.masterFilterComboBoxOptions.headerTemplate = "<div class='dropdown-header k-widget k-header'>" +
                "<span>Διεύθυνση</span>"+
                "<span>Πόλη</span>"+
                "<span>Τ.Κ.</span>"+
                "<span>Νομός</span></div>";
            vm.masterFilterComboBoxOptions.template = "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #";
            vm.masterFilterComboBoxOptions.placeholder =   "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό";
            vm.masterFilterComboBoxOptions.change = function(){
                //initialize inputs (autocomplete)
                if(this.dataItem(this.select())) {
                    var self = this;
                    //using $timeout to trigger the change
                    $timeout(function(){
                        vm.selectedItem.prefectureName = self.dataItem(self.select()).prefecture;
                        vm.selectedItem.cityName = self.dataItem(self.select()).city;
                        vm.selectedItem.address = self.dataItem(self.select()).street;
                        vm.selectedItem.postalCode = self.dataItem(self.select()).postalCode;
                    },0);
                }
            };
        };

        vm.customEdit = function(e) {
            angular.element("#prospectivePatientsGrid").data("kendoGrid")
                .editRow($(e.currentTarget).closest("tr"));
        };

        vm.customAdd = function() {
            angular.element("#prospectivePatientsGrid").data("kendoGrid")
                .addRow();
        };

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/prospective-patients/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                },
                create: function (o){
                    var data = o.data.models[0];
                    /*if (data.age) {
                        data.birthYear = CalculateAge.getBirthYearFromAge(data.age).getFullYear();
                    } else {
                        data.birthYear = "";
                    }*/

                    if( !data.city.id ) data.city = null;
                    if( !data.prefecture.id ) data.prefecture = null;
                    if( !data.attendant.id ) data.attendant = null;
                    if( !data.profession.id ) data.profession = null;
                    ProspectivePatient.update({}, data,
                        function(result){
                            $state.go('prospectivePatientInfo', {id: result.id});
                            KendoGrid.refresh(vm.prospectivePatientsGridOptions)
                    });
                },
                update: function (o){
                    var data = o.data.models[0];
                    /*if (data.age) {
                        data.birthYear = CalculateAge.getBirthYearFromAge(data.age).getFullYear();
                    } else {
                        data.birthYear = "";
                    }*/

                    if( !data.city.id ) data.city = null;
                    if( !data.prefecture.id ) data.prefecture = null;
                    if( !data.attendant.id ) data.attendant = null;
                    if( !data.profession.id ) data.profession = null;
                    ProspectivePatient.update({}, data,
                        function(){ KendoGrid.refresh(vm.prospectivePatientsGridOptions) });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (item.attendant) {
                                if (item.attendant.lastName && item.attendant.firstName) {
                                    item.attendant.fullName = item.attendant.lastName + " " + item.attendant.firstName;
                                } else if (!item.attendant.firstName) {
                                    item.attendant.fullName = item.attendant.lastName;
                                } else if (!item.attendant.lastName) {
                                    item.attendant.fullName = item.attendant.firstName;
                                }
                            }
                            if (item.attendant === null) item.attendant = {};
                            if (item.profession === null) item.profession = {};

                            /*if (item.birthYear) {
                                var date = new Date();
                                date.setFullYear(item.birthYear);
                                item.birthYear = date;
                                item.age = CalculateAge.getAgeFromBirthYear(item.birthYear);
                            }*/
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        lastName: { validation: { required: { message: "Το επώνυμο του Ασθενή είναι υποχρεωτικό" } } },
                        firstName: { validation: { required: { message: "Το όνομα του Ασθενή είναι υποχρεωτικό" } } },
                        age: { type: "number" },
                        email: { type: "email" },
                        birthYear: { type: "number", defaultValue: "", validation: { max: 4 } },
                        attendant: { defaultValue: {} },
                        profession: { defaultValue: {} },
                        isWrongPhone: { defaultValue: false },
                        isWrongContact: { defaultValue: false },
                        amka: { type: "text" }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        grid.columns = vm.gridColumns = [
            {
                template: "<md-button ng-click='vm.customEdit($event)' class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='add'>" +
                    " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80,
                selectable: false
            },
            {
                field: "lastName",
                title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "mobile",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "birthYear",
                title: "Έτος Γέννησης",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "amka",
                title: "ΑΜΚΑ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "postalCode",
                title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                template: '<md-checkbox class="checkbox-toolbar green inline"  aria-label="selectable" ' +
                'ng-model="dataItem.isWrongPhone" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "isWrongPhone", title: "Λάθος Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            },
            {
                template: '<md-checkbox class="checkbox-toolbar green inline"  aria-label="selectable" ' +
                'ng-model="dataItem.isWrongContact" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "isWrongContact", title: "Λάθος Στοιχεία Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "attendant.fullName", title: "Συνοδός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                sortable: false
            },
            {
                field: "profession.name", title: "Επάγγελμα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.prospectivePatientsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: {
                mode: "popup",
                template: kendo.template(angular.element("#popup-prospective-patient").html())
            },
            edit: function(e) {
                vm.editMode = true;
                KendoGrid.defaultEditPopup(this._editContainer);
                e.model.dirty = true;
                vm.selectedItem = e.model;
                KendoGrid.defaultCustomEditPopup(this._editContainer,1000,990);

                //Attendants Combobox
                dataSource.attendant = new kendo.data.DataSource({
                    serverFiltering: true,
                    serverSorting: true,
                    transport: {
                        read: function (o) {
                            var url = '/api/attendants/search';
                            if (o.data.filter === undefined) o.data.filter = { filters: [] };

                            o.data.page = 1;
                            o.data.pageSize = 1;
                            $http.get(url, {params: o.data})
                                .success(function (response) {
                                    o.success(response.content);
                                })
                                .error(function (response) {});
                        }
                    },
                    schema: {
                        parse: function (data) {
                            var attendant = $filter('filter')(data, {id: vm.selectedItem.attendant.id}, true);
                            if (!attendant.length) {
                                data.push(vm.selectedItem.attendant);
                            }
                            data.forEach(function (item) {
                                item.fullName = item.lastName + " " + item.firstName
                            });
                            return data;
                        }
                    }
                });
                vm.attendantOptions = KendoService.initDefaultOptions(dataSource.attendant, "startswith", "fullName", "id", false);
                vm.attendantOptions.placeholder = "Επιλογή συνοδού";

                //Professions Combobox
                dataSource.professions = KendoService.initDefaultDataSource('/api/professions/search');
                vm.professionOptions = KendoService.initDefaultOptions(dataSource.professions, "startswith", "name", "id", false);

                //refresh kendoComboBox
                if(e.model.isNew()) {
                    angular.forEach(comboBoxes, function (item) {
                        var comboBox = angular.element(item).data("kendoComboBox");
                        if (comboBox) {
                            vm.refreshCombobox({}, comboBox.dataSource);
                        }
                    });
                }

                if(!e.model.isNew()) {
                    if(e.model.prefecture && !vm.geodata){
                        var filter = {
                            "field": "prefecture.id",
                            "operator": "eq",
                            "value": e.model.prefecture.id
                        };

                        vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                    }

                    if(e.model.city && !vm.geodata){
                        var filterCity = {
                            "field"   : "id",
                            "operator": "eq",
                            "value"   : e.model.city.prefecture.id
                        };

                        vm.refreshCombobox(filterCity, vm.prefecturesComboBoxOptions.dataSource);
                    }
                }

                vm.initPrefecturesComboBox = true;
                vm.initCitiesComboBox = true;

                //if geodata init city and prefecture
                if(!e.model.city) e.model.city = {};
                if(!e.model.prefecture) e.model.prefecture = {};

            },
            toolbar: [
                /*{ template: "<md-button class='md-raised md-mini md-primary' aria-label='add' ng-click='vm.customAdd()'>" +
                    "Προσθήκη Νέας Εγγραφής</md-button>" },*/
                { template: "<div class='right'><label>Σύνολο: {{vm.prospectivePatientsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            cancel: function(){
                vm.editMode = false;
                vm.canceled = true;
                KendoGrid.refresh(vm.prospectivePatientsGridOptions)
            },
            save: function(e){
                vm.editMode = false;
            }
        };

        vm.onSelection = function(data) {
            if (!vm.editMode && !vm.canceled) $state.go('prospectivePatientInfo', {id: data.id});
            if ( vm.canceled ) { vm.canceled = !vm.canceled };
        };
    }
})();
;
/**
 * Created by Teo on 01/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatientLeadCalls', {
                parent: 'prospectivePatientView',
                url: '/leadCalls',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatient.home.title'
                },
                templateUrl: 'app/displays/prospectivePatients/leadCalls/leadCalls.html',
                controller: 'ProspectivePatientViewLeadCallsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 01/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientViewLeadCallsController', ProspectivePatientViewLeadCallsController);

    ProspectivePatientViewLeadCallsController.$inject = [ '$stateParams', '$http', '$state', '$filter', 'KendoFilter', 'LeadCall', 'callTypes', 'CustomUtils'];

    function ProspectivePatientViewLeadCallsController ( $stateParams, $http, $state, $filter, KendoFilter, LeadCall, callTypes, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        var grid = {};
        var prospectivePatientId = $stateParams.id;
        vm.selectedLeadCallId = null;
        vm.leadCall = {};
        vm.callTypes = callTypes;
        vm.showProgress = false;

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if(vm.from && vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "dateTime", "operator": "fromdate",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-dd')},
                                { "field": "dateTime", "operator": "todate",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-dd')}
                            ]
                        );
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "dateTime",  "dir": "desc" };
                    }
                    angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    o.data.filter.filters =
                        o.data.filter.filters.concat([ { "field": "prospectivePatient.id", "operator": "eq", "value": prospectivePatientId } ]);
                    $http.get('/api/lead-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.callType) item.callType = {};
                            if (!item.prospectivePatient){
                                console.log(item);
                                item.prospectivePatient = {};
                            }
                            if (item.prospectivePatient && !item.prospectivePatient.attendant){
                                item.prospectivePatient.attendant = {}
                            }
                            if (!item.oldPatient) item.oldPatient = {};
                            if (!item.oldPatientDoctor) item.oldPatientDoctor = {};

                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateTime: { type: "date" },
                        nextFollowUpDate: { type: "date"}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:true,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                field: "dateTime", title: "Ημερομηνία", template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy, HH:mm') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            }
        ];

        vm.leadCallsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false/*,
            dataBound: resizeGrid,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.hospitalizationsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]*/
        };

        vm.onSelection = function(data) {
            vm.showProgress = true;
            vm.selectedLeadCallId = data.id;
            LeadCall.get({id : vm.selectedLeadCallId}).$promise.then(function (result) {
                vm.showProgress = false;
                if (result){
                    //console.log(result);
                    vm.leadCall = result;
                    // Quick workaround for setup callType radio button
                    vm.leadCall.callType = vm.callTypes.find(function (callType) {
                        return vm.leadCall.callType.id === callType.id;
                    });
                    vm.startDate = vm.startTime = vm.leadCall.dateTime;
                    vm.setData(["prospectivePatient", "attendant", "oldPatient", "oldPatientDoctor"]);
                }else {
                    vm.leadCall = {};
                }
            });
        };

        vm.setData = function (model) {
            if( vm.leadCall.prospectivePatient && model.indexOf("prospectivePatient") !== -1 ) {
                vm.leadCall.prospectivePatient.fullName = vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName;
            }else {
                vm.leadCall.prospectivePatient = {};
            }
            if( vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.attendant && model.indexOf("attendant") !== -1 ) {
                vm.leadCall.prospectivePatient.attendant.fullName = vm.leadCall.prospectivePatient.attendant.lastName + " " + vm.leadCall.prospectivePatient.attendant.firstName;
            }else {
                vm.leadCall.prospectivePatient = {};
                vm.leadCall.prospectivePatient.attendant = {};
            }
            if( vm.leadCall.oldPatient && model.indexOf("oldPatient") !== -1 ) {
                vm.leadCall.oldPatient.fullName = vm.leadCall.oldPatient.lastName + " " + vm.leadCall.oldPatient.firstName;
            }else {
                vm.leadCall.oldPatient = {};
            }
            if( vm.leadCall.oldPatientDoctor && model.indexOf("oldPatientDoctor") !== -1 ) {
                vm.leadCall.oldPatientDoctor.fullName = vm.leadCall.oldPatientDoctor.lastName + " " + vm.leadCall.oldPatientDoctor.firstName;
            }else {
                vm.leadCall.oldPatientDoctor = {};
            }
        };

        vm.goTo = function (where, id) {
            switch (where){
                case "prospectivePatient":
                    $state.go('prospectivePatientInfo', {id: id});
                    break;
                case "attendant":
                    // View does not exist
                    //$state.go('attendantView', {id: id});
                    console.log("View does not exist! Coming soon!");
                    break;
                case "oldPatient":
                    $state.go('patientInfo', {id: id});
                    break;
                case "oldPatientDoctor":
                    $state.go('customerInfo', {id: id});
                    break;
                case "leadCall":
                    $state.go('leadCallView', {id: id});
                    break;
            }
        }

        /*resizeGrid();
        $(window).resize(function(){
            resizeGrid();
        });*/
        /*function resizeGrid() {
            console.log("resizeGrid");
            var gridElement = $("#patientLeadCallsGrid"),
                dataArea = gridElement.find(".k-grid-content"),
                gridHeight = gridElement.innerHeight(),
                otherElements = gridElement.children().not(".k-grid-content"),
                otherElementsHeight = 0;
            otherElements.each(function(){
                otherElementsHeight += $(this).outerHeight();
            });
            dataArea.height(gridHeight - otherElementsHeight);
        }*/
    }
})();
;
/**
 * Created by Kristy on 10/5/2018.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatientInfo', {
                parent: 'prospectivePatientView',
                url: '',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/prospectivePatients/info/info.html',
                controller: 'ProspectivePatientViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    entity: ['$stateParams', 'ProspectivePatient', function($stateParams, ProspectivePatient) {
                        return ProspectivePatient.get({id : $stateParams.id}).$promise;
                    }],
                    professions: ['Profession', function (Profession) {
                        return Profession.query({page: 0, size: 400}).$promise;
                    }],
                    relationshipTypes: ['RelationshipType', function (RelationshipType) {
                        return RelationshipType.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 10/5/2018.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientViewInfoController', ProspectivePatientViewInfoController);

    ProspectivePatientViewInfoController.$inject = [ '$http', '$filter', '$timeout', '$state', 'KendoService', 'NotificationOptions', 'Alerts', 'KendoNotifications', 'entity', 'ProspectivePatient', 'Attendant', 'Patient', 'professions', 'relationshipTypes', 'CustomUtils'];

    function ProspectivePatientViewInfoController ( $http, $filter, $timeout, $state, KendoService, NotificationOptions, Alerts, KendoNotifications, entity, ProspectivePatient, Attendant, Patient, professions, relationshipTypes, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        var dataSource = {};
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.professions = professions;
        vm.relationshipTypes = relationshipTypes;
        vm.showAttendantLayout = false;
        vm.showAttendantActions = true;
        vm.showAttendantSecondaryActions = false;
        vm.showConvertButton = false;
        vm.prospectivePatient = entity;
        vm.attendant = {};
        if (vm.prospectivePatient.attendant){
            vm.attendant = vm.prospectivePatient.attendant;
            setAttendantFullName();
        }

        //Attendants Combobox
        dataSource.attendant = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/attendants/search';
                    if (o.data.filter === undefined) o.data.filter = { filters: [] };

                    o.data.page = 1;
                    o.data.pageSize = 1;
                    $http.get(url, {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function (data) {
                    var attendant = $filter('filter')(data, {id: vm.prospectivePatient.attendant.id}, true);
                    if (!attendant.length) {
                        data.push(vm.prospectivePatient.attendant);
                    }
                    data.forEach(function (item) {
                        item.fullName = item.lastName + " " + item.firstName
                    });
                    return data;
                }
            }
        });
        vm.attendantOptions = KendoService.initDefaultOptions(dataSource.attendant, "startswith", "fullName", "id", false);
        vm.attendantOptions.placeholder = "Επιλογή συνοδού";

        //Professions Combobox
        dataSource.professions = KendoService.initDefaultDataSource('/api/professions/search');
        vm.professionOptions = KendoService.initDefaultOptions(dataSource.professions, "startswith", "name", "id", false);

        vm.update = function() {
            if (vm.validator.validate()) {
                vm.prospectivePatient.attendant = vm.attendant.id > 0 ? vm.attendant : null;
                ProspectivePatient.update({}, vm.prospectivePatient,
                    function () {
                        KendoNotifications.onSaveSuccess(notification)
                    },
                    function () {
                        KendoNotifications.onSaveError(notification)
                    })
            } else {
                KendoNotifications.onSaveError(notification);
            }
        };

        vm.onAttendantActionButtonsClick = function (action, ev) {
            switch (action){
                case "add":
                    if (vm.attendant.id > 0){
                        // Ask if there is an attendant
                        Alerts.showConfirmDialog(ev, "Sigma SalesForce", "Προσθήκη νέου Συνοδού? Ο παλιός θα διαγραφεί!", true, "ΝΑΙ", "OXI", function () {
                            // Positive
                            vm.attendant = {};
                            vm.showAttendantLayout = true;
                            vm.showAttendantActions = false;
                            vm.showAttendantSecondaryActions = true;
                        }, function () {
                            // Negative
                        });
                    }else {
                        vm.showAttendantLayout = true;
                        vm.showAttendantActions = false;
                        vm.showAttendantSecondaryActions = true;
                    }
                    break;
                case "edit":
                    vm.showAttendantLayout = true;
                    vm.showAttendantActions = false;
                    vm.showAttendantSecondaryActions = true;
                    break;
                case "delete":
                    Alerts.showConfirmDialog(ev, "Sigma SalesForce", "Διαγραφή Συνοδού?", true, "ΝΑΙ", "OXI", function () {
                        // Positive
                        vm.attendant = {};
                    }, function () {
                        // Negative
                    });
                    break;
                case "save":
                    if (vm.attendantValidator.validate()){
                        Attendant.update({}, vm.attendant,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Συνοδού");
                                vm.attendant = result;
                                vm.prospectivePatient.attendant = vm.attendant;
                                setAttendantFullName();
                                vm.onAttendantActionButtonsClick("close");
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Συνοδού!");
                            });
                    }else {
                        Alerts.showAlert("Sigma SalesForce", "Ελέγξτε τα στοιχεία του Συνοδού!", "Ok")
                    }
                    break;
                case "close":
                    vm.showAttendantLayout = false;
                    vm.showAttendantActions = true;
                    vm.showAttendantSecondaryActions = false;
                    break;
            }
        };

        vm.convertToPatient = function () {
            if (vm.prospectivePatient && vm.prospectivePatient.id > 0){
                var cancel = false;
                var message = "";

                if (vm.prospectivePatient.firstName === null ||
                    vm.prospectivePatient.firstName === '' ||
                    vm.prospectivePatient.firstName === undefined){
                    cancel = true;
                    message = "Απαραίτητο πεδίο Όνομα";
                }

                if (vm.prospectivePatient.lastName === null ||
                    vm.prospectivePatient.lastName === '' ||
                    vm.prospectivePatient.lastName === undefined){
                    cancel = true;
                    message = "Απαραίτητο πεδίο Επώνυμο";
                }

                if (cancel){
                    Alerts.showAlert("Sigma SalesForce", message, "Ok");
                }else {
                    var patientForSave = {
                        firstName: vm.prospectivePatient.firstName,
                        lastName: vm.prospectivePatient.lastName,
                        email: vm.prospectivePatient.email,
                        yearOfBirth: vm.prospectivePatient.birthYear,
                        phone: vm.prospectivePatient.phone,
                        notes: vm.prospectivePatient.notes,
                        prospectivePatient: {
                            id: vm.prospectivePatient.id
                        },
                        amka: vm.prospectivePatient.amka
                    };

                    Patient.save(patientForSave, function (result) {
                        KendoNotifications.showSuccessNotification(notification, "Επιτυχής μετατροπή Πιθανού Ασθενή σε Ασθενή");
                        vm.showConvertButton = false;
                        // Go to New Hospitalization with this Patient
                        $timeout(function () {
                            //$state.go('hospitalizationView', {patientId: result.id});
                            $state.go('patientInfo', {id: result.id}); // ECRM-321
                        }, 600);
                    }, function (error) {
                        console.log(error);
                        var errorMessage = "Κάποιο σφάλμα προέκυψε κατά την μετατροπή Πιθανού Ασθενή σε Ασθενή!";
                        if (error.data.message &&
                            error.data.message.includes("Cannot save Patient with ProspectivePatient id that exists")){
                            errorMessage = "Ο Ασθενής υπάρχει ήδη!";
                        }
                        KendoNotifications.showErrorNotification(notification, errorMessage);
                    });
                }
            }else {

            }
        };

        function setAttendantFullName(){
            vm.attendant.fullName = vm.attendant.lastName + " " + vm.attendant.firstName;
        }

        // Search Patient with this ProspectivePatient to show/hide convert btn
        // Removed ECRM-351
       /* var patientFilters = {
            field: "prospectivePatient.id",
            operator: "eq",
            value: vm.prospectivePatient.id
        };
        $http.get('/api/patients/search',
            {params:{
                    page: "1",
                    pageSize: "1",
                    filter : { filters: [patientFilters] }}})
            .success(function (response) {
                // Show/hide convert button if patient with prospectivePatient id exists
                vm.showConvertButton = !(response.content && response.content.length > 0);
            })
            .error(function (error) {
                console.log(error);
            });*/
    }

})();
;
/**
 * Created by Teo on 01/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatientLeadHospitalizationDiseases', {
                parent: 'prospectivePatientView',
                url: '/history',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatient.home.title'
                },
                templateUrl: 'app/displays/prospectivePatients/diseases/leadHospitalizationDiseases.html',
                controller: 'ProspectivePatientViewLeadHospitalizationDiseasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    /*callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],*/
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 01/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProspectivePatientViewLeadHospitalizationDiseasesController', ProspectivePatientViewLeadHospitalizationDiseasesController);

    ProspectivePatientViewLeadHospitalizationDiseasesController.$inject = [ '$stateParams', '$http', 'CustomUtils'];

    function ProspectivePatientViewLeadHospitalizationDiseasesController ( $stateParams, $http, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        var prospectivePatientId = $stateParams.id;
        vm.showProgress = false;

        if (prospectivePatientId !== null && prospectivePatientId > 0){
            var prospectivePatientFilter = {
                field: "leadHospitalization.leadCalls.prospectivePatient.id",
                operator: "eq",
                value: prospectivePatientId
            };
            $http.get('/api/lead-hospitalization-diseases/search-with-dates',
                {params:{
                        page: "1",
                        pageSize: "200",
                        filter : { filters: [prospectivePatientFilter] }}})
                .success(function (response) {
                    if (response != null && response.content != null && response.content.length > 0){
                        vm.leadHospitalizationDiseases = response.content;
                    }
                })
                .error(function (error) {
                    console.log(error);
                });
        }

        /**
         * Convert date to human readable format
         * @param diagnosisDate ZonedDateTime object '2018-05-15T21:00:00.000Z'
         */
        vm.beautifyDate = function (diagnosisDate) {
            if (diagnosisDate !== null && diagnosisDate !== undefined && diagnosisDate !== ''){
                //return CustomDateUtils.fromServerDateFormat(new Date(diagnosisDate));
                return moment(new Date(diagnosisDate)).format('DD/MM/YYYY h:mm')
            }
            return '';
        }
    }
})();
;
/**
 * Created by Kristy on 19/12/2016.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('PharmacyAssignations', PharmacyAssignations);

    PharmacyAssignations.$inject = ['$filter'];
    function PharmacyAssignations ($filter) {
        var selectedSectors,
            employees = [];
        var employee;

        return {
            getSelectedSectors: function () {
                return selectedSectors;
            },
            setSelectedSectors: function (value) {
                selectedSectors = value;
            },
            getEmployees: function () {
                return employees;
            },
            setEmployees: function (value) {
                employees = value;
            },
            getEmployee: function () {
                return employee;
            },
            setEmployee: function (value) {
                employee = value;
            }
        };

    }
})();
;
/**
 * Created by Kristy on 19/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorsPharmacyAssignations', {
                parent: 'pharmacyAssignations',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/pharmacyAssignations/sectors/sectors.html',
                controller: 'SectorsAssignationsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 19/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorsAssignationsController', SectorsAssignationsController);

    SectorsAssignationsController.$inject = ['$filter','$http', '$state', 'PharmacyAssignations', 'KendoFilter'];

    function SectorsAssignationsController ($filter, $http, $state, PharmacyAssignations, KendoFilter) {
        var vm = this;

        vm.selectedEmployees = [];
        vm.massSelect = vm.myTarget = true;

        vm.employeesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';

                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities.name", "operator": "in",
                                "value": "ROLE_PHARM_VISITOR", "ignoreCase": true}
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });


                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        };
                    });
                    return data;
                }
            }
        });

        vm.employeesMultiSelectOptions = {
            dataSource: vm.employeesDataSource,
            change: function (e) {
                if (vm.selectedEmployees) {
                    PharmacyAssignations.setEmployees(vm.selectedEmployees);

                    vm.sectorGridOptions.dataSource.read();
                }
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή ιατρικού επισκέπτη/επισκεπτών"
        };

        vm.employeesComboBoxOptions = {
            dataSource: vm.employeesDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή ιατρικού επισκέπτη",
            change: function() {
                PharmacyAssignations.setEmployee(this.dataItem(this.select()));
            }
        };

        vm.toolbarOptions = {
            items: [
                { template: "<label>Μεταφορά φαρμακείου από ιατρικό επισκέπτη </label>" },
                {
                    template: "<select id='multiSelect' name='multiSelect' kendo-multi-select multiple='multiple' " +
                    "k-ng-model='vm.selectedEmployees' k-options='vm.employeesMultiSelectOptions'></select>",
                    overflow: "never"
                },
                { template: "<label>σε ιατρικό επισκέπτη </label>" },
                {
                    template: "<select id='comboBox' name='comboBox' kendo-combo-box k-options='vm.employeesComboBoxOptions' k-ng-model='vm.newEmployee'></select>",
                    overflow: "never"
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ui-sref='previewPharmacyAssignations'>Επόμενο" +
                    "<md-icon class='arrow-right'></md-icon></md-button>", attributes: { class: "right" }
                }
            ]
        };

        vm.gridColumns = [
            { field:"id", filterable: false, hidden : true },
            {
                field: "name",
                title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            // {
            //     field: "taxOffice.name",
            //     title: "Δ.Ο.Υ.",
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             showOperators: false
            //         }
            //     }
            // },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "brick",
                title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "osfeBrick",
                title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone2",
                title: "Τηλέφωνο 2",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.sectorGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "customer.lastName",  "dir": "asc" };
                        }

                        if (vm.selectedEmployees.length) {
                            o.data.filter.filters.push(
                                {
                                    "field": "employee.id", "operator": "in",
                                    "value": vm.selectedEmployees.toString()
                                }
                            );

                            $http.get('/api/me/employee-customer-sectors/pharmacies/assignations',
                                {params: o.data})
                                .success(function (response,status,headers) {
                                    o.success(response);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        } else {
                            o.success([]);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.forEach(function(item){
                                if(item.companyType === null){
                                    item.companyType = {
                                        name: ""
                                    };
                                }
                                if(item.taxOffice === null){
                                    item.taxOffice = {
                                        name: ""
                                    };
                                }
                            });
                        }
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true }
                        }
                    }
                },
                pageSize: 100
            }),
            selectedItems: function(dataItems) {
                PharmacyAssignations.setSelectedSectors(dataItems);
            },
            sortable: true,
            scrollable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            selectable: true,
            columns: vm.gridColumns,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.sectorGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }
})();
;
/**
 * Created by Kristy on 19/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('previewPharmacyAssignations', {
                parent: 'pharmacyAssignations',
                url: '/previewPharmacyAssignations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/pharmacyAssignations/preview/preview.html',
                controller: 'PreviewPharmacyAssignationsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 19/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PreviewPharmacyAssignationsController', PreviewPharmacyAssignationsController);

    PreviewPharmacyAssignationsController.$inject = ['$filter', '$scope','$http', '$state', '$mdToast', 'PharmacyAssignations', 'NotificationOptions','KendoFilter'];

    function PreviewPharmacyAssignationsController ($filter, $scope, $http, $state, $mdToast, PharmacyAssignations, NotificationOptions, KendoFilter) {
        var vm = this;

        vm.success = vm.error = "";
        vm.allSelected = false;
        vm.employee = PharmacyAssignations.getEmployee();
        vm.disableSave = !!(!PharmacyAssignations.getEmployee() || !PharmacyAssignations.getSelectedSectors().length);
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.assign = function () {
            var sectors = PharmacyAssignations.getSelectedSectors();
            var employees = PharmacyAssignations.getEmployees();
            var employeeID = PharmacyAssignations.getEmployee().id;

            var assignations = {
                "employeeToId": employeeID,
                "employeeFromIds": employees,
                "sectors": sectors
            };

            $mdToast.show({
                hideDelay   : 0,
                position    : 'top right',
                controller  : 'ToastCtrl',
                templateUrl : 'app/components/md-toast/toast-template.html'
            });
            vm.disableSave = true;
            $http.put('/api/employee-customer-sectors/pharmacies/mass', assignations)
                .success(function (response) {
                    $mdToast
                        .hide()
                        .then(function () {
                        });
                    notification.show({
                        message: "Η μαζική ανάθεση πραγματοποιήθηκε με επιτυχία!"
                    }, "success");
                })
                .error(function (response) {
                    $mdToast
                        .hide()
                        .then(function () {
                        });
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });
        };

        vm.toolbarPreviewOptions = {
            items: [
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ui-sref='sectorsPharmacyAssignations'>" +
                    "<md-icon class='arrow-left'></md-icon>Προηγούμενο</md-button>"
                },
                { template: "<label>Μεταφορά επιλεγμένου φαρμακείου στον ιατρικό επισκέπτη </label>" },
                {
                    template: "<md-input-container class='md-block' flex-gt-sm=''>" +
                                "<md-icon class='assignment-ind'></md-icon><input aria-label='employee' ng-model='vm.employee.employee.account.fullName' ng-readonly='true'>" +
                            "</md-input-container>",
                    overflow: "never"
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ng-click='vm.assign()' ng-disabled='vm.disableSave'>" +
                    "Τέλος<md-icon class='done'></md-icon></md-button>",
                    attributes: { class: "right" }
                }
            ]
        };

        vm.removeItem = function(id) {
            var gridData = vm.previewGridOptions.dataSource.data();
            angular.forEach(gridData, function (item) {
                if (item.id.toString() === id.toString()){
                    gridData.remove(item);
                }
            });
            PharmacyAssignations.setSelectedSectors(gridData);
        };

        vm.toggleSelectAll = function (ev) {
            vm.allSelected = !vm.allSelected;
            var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid");
            angular.forEach( grid.dataSource.data(), function( dataItem ) {
                dataItem.myTarget = vm.allSelected;
            });
        };

        vm.gridColumns = [
            { field:"id", filterable: false, hidden : true },
            {
                field: "name",
                title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            // {
            //     field: "taxOffice.name",
            //     title: "Δ.Ο.Υ.",
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             showOperators: false
            //         }
            //     }
            // },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "brick",
                title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "osfeBrick",
                title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone2",
                title: "Τηλέφωνο 2",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            { "template": "<md-button class='md-icon-button' aria-label='Remove' ng-click='vm.removeItem(#=id#)'>" +
            "<md-icon class='remove'></md-icon></md-button>", width: 90 }
        ];

        vm.previewGridOptions = {
            dataSource: new kendo.data.DataSource({
                data  : PharmacyAssignations.getSelectedSectors(),
                schema: {
                    model: {
                        id: "id"
                    }
                },
                pageSize: 100
            }),
            sortable: true,
            scrollable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.previewGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }
})();
;
/**
 * Created by Kristy on 19/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyAssignations', {
                abstract: true,
                parent: 'app',
                url: '/pharmacyAssignations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        template: '<p><ui-view /></p>',
                        controller: 'PharmacyAssignationsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 20/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PharmacyAssignationsController', PharmacyAssignationsController);

    PharmacyAssignationsController.$inject = ['$filter','$http', '$state', 'ApplicationParameters'];

    function PharmacyAssignationsController ($filter, $http, $state, ApplicationParameters) {
        var vm = this;

        ApplicationParameters.hasModule('Visit_Pharmacies', true);
    }
})();
;
/**
 * Created by Kristy on 7/6/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientViewController', PatientViewController);

    PatientViewController.$inject = ['$state', '$stateParams', 'Patient'];

    function PatientViewController ($state, $stateParams, Patient) {
        var vm = this;
        vm.$state = $state;

        Patient.get({id : $stateParams.id})
            .$promise.then(function(data) {
                vm.patient = data;
            });

        vm.goBack = function () {
            $state.go('patients');
        };
    }
})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patients', {
                parent: 'app',
                url: '/patients',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.patients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/patients/patients.html',
                        controller: 'PatientsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('patientView', {
                abstract: true,
                parent: 'app',
                url: '/patients/search?id:patientId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.patients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/patients/patientView.html',
                        controller: 'PatientViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientsController', PatientsController);

    PatientsController.$inject = ['$http', '$state', '$timeout', 'Patient', 'KendoGrid','KendoFilter', 'CalculateAge', 'CustomUtils'];

    function PatientsController ($http, $state, $timeout, Patient, KendoGrid, KendoFilter, CalculateAge, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Ασθενεις";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        var grid = {};
        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    $http.get('/api/patients/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                },
                create: function (o){
                    var data = o.data.models[0];
                    data.yearOfBirth = kendo.toString( data.yearOfBirth, 'yyyy');
                    Patient.update({}, data, function(){ KendoGrid.refresh(vm.patientsGridOptions) });
                },
                update: function (o){
                    var data = o.data.models[0];
                    data.yearOfBirth = kendo.toString( data.yearOfBirth, 'yyyy' );
                    Patient.update({}, data, function(){ KendoGrid.refresh(vm.patientsGridOptions) });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        angular.forEach( data.content, function (item) {
                            if (item.yearOfBirth) {
                                var date = new Date();
                                date.setFullYear(item.yearOfBirth);
                                item.yearOfBirth = date;
                                item.age = CalculateAge.getAgeFromBirthYear(item.yearOfBirth);
                            }
                        })
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        lastName: { validation: { required: { message: "Το επώνυμο του Ασθενή είναι υποχρεωτικό" } } },
                        firstName: { validation: { required: { message: "Το όνομα του Ασθενή είναι υποχρεωτικό" } } },
                        age: { type: "number" }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        grid.columns = vm.gridColumns = [
            {
                command: [
                    {name: "edit", text: ""}
                ],
                title: "&nbsp;",
                width: 80
            },
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "amka",
                title: "Α.Μ.Κ.Α",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλ. Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "yearOfBirth", title: "Έτος Γέννησης",
                format: "{0:yyyy}",
                editor: function(container, options) {
                    angular.element('<input id="yearOfBirth"  data-bind="value:yearOfBirth" class = "custom-popup-datepicker pull-right" title="yearOfBirth"/>')
                        .appendTo(container)
                        .kendoDatePicker({
                            start: "decade",
                            depth: "decade",
                            format: "yyyy",
                            change: function() {
                                options.model.set("age", this.value() ? CalculateAge.getAgeFromBirthYear(this.value()) : null);
                            }
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "age", title: "Ηλικία",
                editor: function(container, options) {
                    angular.element('<input id="age" min="0"  data-bind="value:age" class = "custom-popup-numeric pull-right">')
                        .appendTo(container)
                        .kendoNumericTextBox({
                            change: function() {
                                options.model.set("yearOfBirth", CalculateAge.getBirthYearFromAge(this.value()));
                            },
                            spin: function() {
                                options.model.set("yearOfBirth", CalculateAge.getBirthYearFromAge(this.value()));
                            },
                            format: "n0"
                        });
                },
                filterable: false,
                sortable: false
            },
            {
                field: "notes",
                title: "Σχόλια",
                editor: function(container) {
                    angular.element('<textarea rows="3" cols="150" class = "k-textbox custom-popup-textarea pull-right" data-bind="value:notes"></textarea>')
                        .appendTo(container);
                },
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.patientsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Ασθενείς", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Ασθενείς",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Ασθενείς"
            },
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: {
                mode: "popup"
            },
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); }
        };

        vm.onSelection = function(data) {
            $state.go('patientInfo', {id: data.id});
        };

        vm.onAddPatientClick = function () {
            const grid = $("#patientsGrid").data("kendoGrid");
            grid.addRow();
        };
    }
})();
;
/**
 * Created by Teo on 31/05/2018.
 */

/*(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patientLeadCalls', {
                parent: 'patientView',
                url: '/leadCalls',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/patients/leadCalls/leadCalls.html',
                controller: 'PatientViewLeadCallsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();*/
;
/**
 * Created by Teo on 31/05/2018.
 */


/**
 * NOT USED RIGHT NOW. Will be used later
 */
/*(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientViewLeadCallsController', PatientViewLeadCallsController);

    PatientViewLeadCallsController.$inject = [ '$stateParams', '$http', '$state', '$location', '$rootScope', '$filter', 'KendoFilter', 'LeadCall', 'callTypes'];

    function PatientViewLeadCallsController ( $stateParams, $http, $state, $location, $rootScope, $filter, KendoFilter, LeadCall, callTypes) {
        var vm = this;
        var grid = {};
        var patientId = $stateParams.id;
        vm.selectedLeadCallId = null;
        vm.leadCall = {};
        vm.callTypes = callTypes;
        vm.showProgress = false;

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if(vm.from && vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "dateTime", "operator": "fromdate",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-dd')},
                                { "field": "dateTime", "operator": "todate",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-dd')}
                            ]
                        );
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "dateTime",  "dir": "desc" };
                    }
                    angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    // TODO: when database will be refactored, use patientId
                    /!*o.data.filter.filters =
                        o.data.filter.filters.concat([ { "field": "patient.id", "operator": "eq", "value": patientId } ]);*!/
                    $http.get('/api/lead-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.callType) item.callType = {};
                            if (!item.prospectivePatient){
                                console.log(item);
                                item.prospectivePatient = {};
                            }
                            if (item.prospectivePatient && !item.prospectivePatient.attendant){
                                item.prospectivePatient.attendant = {}
                            }
                            if (!item.oldPatient) item.oldPatient = {};
                            if (!item.oldPatientDoctor) item.oldPatientDoctor = {};

                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateTime: { type: "date" },
                        nextFollowUpDate: { type: "date"}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:true,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                field: "dateTime", title: "Ημερομηνία", template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy, hh:mm') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            }
        ];

        vm.leadCallsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false/!*,
            dataBound: resizeGrid,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.hospitalizationsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]*!/
        };

        vm.onSelection = function(data) {
            vm.showProgress = true;
            vm.selectedLeadCallId = data.id;
            LeadCall.get({id : vm.selectedLeadCallId}).$promise.then(function (result) {
                vm.showProgress = false;
                if (result){
                    //console.log(result);
                    vm.leadCall = result;
                    // Quick workaround for setup callType radio button
                    vm.leadCall.callType = vm.callTypes.find(function (callType) {
                        return vm.leadCall.callType.id === callType.id;
                    });
                    vm.startDate = vm.startTime = vm.leadCall.dateTime;
                    vm.setData(["prospectivePatient", "attendant", "oldPatient", "oldPatientDoctor"]);
                }else {
                    vm.leadCall = {};
                }
            });
        };

        vm.setData = function (model) {
            if( vm.leadCall.prospectivePatient && model.indexOf("prospectivePatient") !== -1 ) {
                vm.leadCall.prospectivePatient.fullName = vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName;
            }else {
                vm.leadCall.prospectivePatient = {};
            }
            if( vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.attendant && model.indexOf("attendant") !== -1 ) {
                vm.leadCall.prospectivePatient.attendant.fullName = vm.leadCall.prospectivePatient.attendant.lastName + " " + vm.leadCall.prospectivePatient.attendant.firstName;
            }else {
                vm.leadCall.prospectivePatient = {};
                vm.leadCall.prospectivePatient.attendant = {};
            }
            if( vm.leadCall.oldPatient && model.indexOf("oldPatient") !== -1 ) {
                vm.leadCall.oldPatient.fullName = vm.leadCall.oldPatient.lastName + " " + vm.leadCall.oldPatient.firstName;
            }else {
                vm.leadCall.oldPatient = {};
            }
            if( vm.leadCall.oldPatientDoctor && model.indexOf("oldPatientDoctor") !== -1 ) {
                vm.leadCall.oldPatientDoctor.fullName = vm.leadCall.oldPatientDoctor.lastName + " " + vm.leadCall.oldPatientDoctor.firstName;
            }else {
                vm.leadCall.oldPatientDoctor = {};
            }
        };

        vm.goTo = function (where, id) {
            switch (where){
                case "prospectivePatient":
                    $state.go('prospectivePatientInfo', {id: id});
                    break;
                case "attendant":
                    // View does not exist
                    //$state.go('attendantView', {id: id});
                    console.log("View does not exist! Coming soon!");
                    break;
                case "oldPatient":
                    $state.go('patientInfo', {id: id});
                    break;
                case "oldPatientDoctor":
                    $state.go('customerInfo', {id: id});
                    break;
            }
        }

        /!*resizeGrid();
        $(window).resize(function(){
            resizeGrid();
        });*!/
        /!*function resizeGrid() {
            console.log("resizeGrid");
            var gridElement = $("#patientLeadCallsGrid"),
                dataArea = gridElement.find(".k-grid-content"),
                gridHeight = gridElement.innerHeight(),
                otherElements = gridElement.children().not(".k-grid-content"),
                otherElementsHeight = 0;
            otherElements.each(function(){
                otherElementsHeight += $(this).outerHeight();
            });
            dataArea.height(gridHeight - otherElementsHeight);
        }*!/
    }
})();*/
;
/**
 * Created by Kristy on 7/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patientInfo', {
                parent: 'patientView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/patients/info/info.html',
                controller: 'PatientViewInfoController',
                controllerAs: 'vm',
                params: {
                    id: null, // patient id
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/6/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientViewInfoController', PatientViewInfoController);

    PatientViewInfoController.$inject = [ '$stateParams', '$timeout', 'Patient', 'NotificationOptions', 'KendoNotifications', 'CalculateAge' ];

    function PatientViewInfoController ( $stateParams, $timeout, Patient, NotificationOptions, KendoNotifications, CalculateAge ) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var date = new Date();

        function calculateYearOfBirth() {
            var self = this;
            $timeout(function (){
                vm.patient.yearOfBirth = CalculateAge.getBirthYearFromAge(self.value());
            });
        }

        function calculateAge() {
            var self = this;
            $timeout(function (){
                vm.patient.age = CalculateAge.getAgeFromBirthYear(self.value());
            });
        }

        vm.ageOptions = {
            change: calculateYearOfBirth,
            spin: calculateYearOfBirth
        };

        Patient.get({id : $stateParams.id})
            .$promise.then(function(data) {
                vm.patient = data;
                date.setFullYear(vm.patient.yearOfBirth);
                vm.patient.yearOfBirth = date;
                vm.patient.age = CalculateAge.getAgeFromBirthYear(vm.patient.yearOfBirth);
            });

        vm.yearOfBirthOptions = {
            start: "decade",
            depth: "decade",
            format: "yyyy",
            change: calculateAge
        };

        vm.update = function() {
            if (vm.validator.validate()) {
                vm.patient.yearOfBirth = kendo.toString(vm.patient.yearOfBirth, 'yyyy');
                Patient.update({}, vm.patient,
                    function () {
                        KendoNotifications.onSaveSuccess(notification)
                    },
                    function () {
                        KendoNotifications.onSaveError(notification)
                    })
            } else {
                KendoNotifications.onSaveError(notification);
            }
        };
    }

})();
;
/**
 * Created by Kristy on 7/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patientHospitalization', {
                parent: 'patientView',
                url: '/hospitalizations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/patients/hospitalization/hospitalization.html',
                controller: 'PatientViewHospitalizationController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 7/6/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatientViewHospitalizationController', PatientViewHospitalizationController);

    PatientViewHospitalizationController.$inject = [ '$stateParams', '$http', '$filter', 'KendoFilter' ];

    function PatientViewHospitalizationController ( $stateParams, $http, $filter, KendoFilter ) {
        var vm = this;
        var grid = {};
        var patientId = $stateParams.id;

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    o.data.filter.filters =
                        o.data.filter.filters.concat([ { "field": "patient.id", "operator": "eq", "value": patientId } ]);

                    $http.get('/api/hospitalizations/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (item.sector === null) item.sector = {};
                            if (item.sector.sectorType === null) item.sector.sectorType = {};
                            if (item.clinicName === null) item.clinicName = {};
                            if (item.roomType === null) item.roomType = {};
                            if (item.finalRoomType === null) item.finalRoomType = {};
                            if (item.hospitalizationType === null) item.hospitalizationType = {};
                            if (item.customerTitle === null) item.customerTitle = {};
                            if (item.patient === null) item.patient = {};
                            if (item.customer === null) item.customer = {};
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateIssue: { type: "date" }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                field: "customer.lastName",
                title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.sectorType.name",
                title: "Τύπος Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customerTitle.name",
                title: "Τύπος Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "clinicName.name",
                title: "Κλινική",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "roomType.name",
                title: "Επιθυμητός Τύπος Δωματίου",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "finalRoomType.name",
                title: "Τελική Τοποθέτηση",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "hospitalizationType.name",
                title: "Παρατηρήσεις",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "notes",
                title: "Σχόλια",
                editor: function(container) {
                    angular.element('<textarea rows="3" cols="150" class = "k-textbox custom-popup-textarea pull-right" data-bind="value:notes"></textarea>')
                        .appendTo(container);
                },
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "dateIssue", title: "Ημερομηνία Εισαγωγής", template: "#= dateIssue ? kendo.toString(kendo.parseDate(dateIssue), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            }
        ];

        vm.hospitalizationsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.hospitalizationsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportApprovals.pending', {
                parent: 'medReportApprovals',
                url: '/pending',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                templateUrl: 'app/displays/medReportApprovals/pending/pending.html',
                controller: 'MedReportApprovalsPendingController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportApprovalsPendingController', MedReportApprovalsPendingController);

    MedReportApprovalsPendingController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'KendoGrid', 'Approvals', 'KendoFilter', 'CustomUtils', 'KendoService', 'MedReport'];

    function MedReportApprovalsPendingController ($http, $state, $stateParams, $filter, $timeout, KendoGrid, Approvals, KendoFilter, CustomUtils, KendoService, MedReport) {
        var vm = this;
        vm.statusChanged = '';
        vm.saw = true;
        vm.approvals = Approvals;
        Approvals.setSelectedList([]);
        vm.massSelect = true;
        vm.kendoGrid = KendoGrid;
        vm.gridId = '#approvalsPendingGrid';

        var employeesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';

                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.fullName = item.account.lastName + " " + item.account.firstName;
                    });
                    return data;
                }
            }
        });
        vm.employeesComboBoxOptions = KendoService.initDefaultOptions(employeesDataSource, "startswith", "fullName", "id", false);

        vm.changeStatus = function(e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            var data = this.dataItem(tr);
            var change = [data];

            $http.put('api/med-reports/'+e.data.commandName, change)
                .success(function (response,status,headers) {
                    switch (e.data.commandName) {
                        case "approve":
                            notification.show({
                                message: "Η εγγραφή εγκρίθηκε με επιτυχία!"
                            }, "success");
                            break;
                    }
                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
        };

        vm.approveSelected = function(status) {
            $http.put('api/med-reports/'+status, Approvals.getSelectedList())
                .success(function (response,status) {
                    switch (status) {
                        case "approve":
                            notification.show({
                                message: "Οι αλλαγές εγκρίθηκαν με επιτυχία!"
                            }, "success");
                            break;
                    }
                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    vm.pendingGridOptions.dataSource.read();
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
            vm.previewWindow.close();
        };

        vm.openPreviewWindow = function (status) {
            if(Approvals.getSelectedList().length) {
                vm.initPopupGrid = true;
                vm.status = status;
                Approvals.openWindow(vm.previewWindow, status);
            }
        };

        vm.closePreviewWindow = function() {
            Approvals.closeWindow(vm.pendingGridOptions, vm.previewWindow);
            delete vm.initPopupGrid;
        };

        vm.pendingPreviewGridOptions = {
            dataSource: new kendo.data.DataSource({
                data: Approvals.getSelectedList(),
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            fromDate: {type: 'date'}
                        }
                    }
                },
                pageSize: 20
            }),
            pageable: true,
            columns: [
                {
                    field: "fromDate",
                    title: "Μήνας",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'MMMM')#", width: 200,
                    filterable: false
                },
                {
                    field: "toDate",
                    title: "Έτος",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'yyyy')#",
                    filterable: false, width: 180
                },
                {
                    field: "checkDigit1", title: "Check Digit",
                    filterable: false, width: 180
                },
                {
                    field: "checkDigit2", title: "Check Digit 2",
                    filterable: false, width: 180
                },
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 250
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 180
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 180
                },
                { "template": '<md-button class="md-icon-button" aria-label="Remove" ng-click="vm.approvals.removeItem(vm.pendingPreviewGridOptions.dataSource.data(), #=id#, vm.gridId)">' +
                "<md-icon class='remove'></md-icon></md-button>", width: 90 }
            ]
        }

        vm.pendingGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "isActive", "operator": "eqbool", "value": true }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "eq",  "value": "pending"}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/med-reports',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function () {});
                    },
                    update: function(o) {
                        vm.saveMedReport = o.data.models[0];
                        MedReport.update({}, vm.saveMedReport,
                            function () {
                                vm.pendingGridOptions.dataSource.read();
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            fromDate: {  editable: false,type: 'date'},
                            toDate: {  editable: false,type: 'date'},
                            code: {  editable: false, type: 'string'},
                            checkDigit1: {  editable: false,type: 'number'},
                            checkDigit2: {  editable: false,type: 'number'},
                            'employee.account.lastName': { editable: true }
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            height: CustomUtils.getHeightPixelsFromPercentage(60),
            sortable: true,
            pageable: true,
            resizable: true,
            editable: "inline",
            selectable: "row",
            navigatable: true,
            filterable: false,
            columns: [
                {
                    command:[
                        { name:"approve", text: "Έγκριση", click: vm.changeStatus }
                    ],
                    attributes: { class: "#= 'green-color' #" },
                    title: "&nbsp",
                    width:85
                },
                {
                    field: "fromDate",
                    title: "Μήνας",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'MMMM')#", width: 250
                },
                {
                    field: "toDate",
                    title: "Έτος",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'yyyy')#", width: 230
                },
                {
                    field: "checkDigit1", title: "Check Digit", width: 230
                },
                {
                    field: "checkDigit2", title: "Check Digit 2", width: 230
                },
                {
                    field: "code", title: "Κωδικός", width: 300
                },
                {field: "employee.account.lastName", title: "Ιατρικός Επισκέπτης", attributes: {
                        "name": "employee"
                    },
                    template: "#= employee.account.lastName#" + ' ' + "#= employee.account.firstName #",
                    editor: function(container) {
                        angular.element('<select id="employee-account" data-bind="value:employee.id"></select>')
                            .appendTo(container)
                            .kendoComboBox(vm.employeesComboBoxOptions);
                    }
                }
            ],
            selectedItems: function(dataItems) {
                Approvals.setSelectedList(dataItems);
            },
            edit: function(e) {
                e.model.dirty = true;
            },
            dataBound: function (e) {
                angular.element("#pendingGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (Approvals.getSelectedList().length) {
                    var selectedListViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(Approvals.getSelectedList(), {id: item.id}, true)[0];
                        if(Approvals.getSelectedList().indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedListViewCounter++
                        }
                    });
                    if(selectedListViewCounter == view.length) {
                        angular.element("#pendingGridcheckbox").prop('checked', true);
                    }
                }

                angular.element("#approvalsPendingGrid tbody tr [name='employee']").on("click", function(e) {
                    if (!angular.element(this).hasClass('k-grid-edit-row')) {
                        angular.element("#approvalsPendingGrid").data("kendoGrid").editRow(angular.element(this));
                    }
                });
            },
            toolbar: [
                {template: "<md-button class='green-color-md-button md-raised md-mini md-primary' aria-label='approveSelected' ng-click='vm.openPreviewWindow(\"approve\")'>" +
                "Μαζική Έγκριση επιλεγμένων</md-button>"},
                { template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.medReportLinesGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                vm.showProgress = true;
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "medReport.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/med-report-lines/search',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function () {
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    sum: { type: "number" },
                                    aQuantity: { type: 'number' },
                                    bQuantity: { type: 'number' }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {field: "medicine.name", title: "Όνομα Σκευάσματος",
                            filterable: false
                        },
                        {field: "medicine.barcode", title: "Barcode Σκευάσματος",
                            filterable: false
                        },
                        {
                            field: "aQuantity",
                            title: "Ποσότητα Α",
                            filterable: false
                        },
                        {
                            field: "bQuantity",
                            title: "Ποσότητα Β",
                            filterable: false
                        },
                        {
                            field: "sum", title: "Σύνολο",
                            filterable: false
                        }
                    ],
                    editable: false
                };
            }
        };
    }
})();
;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportApprovals', {
                abstract: true,
                parent: 'app',
                url: '/report-approvals',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/medReportApprovals/medReportApprovals.html',
                        controller: 'MedReportApprovalsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportApprovalsController', MedReportApprovalsController);

    MedReportApprovalsController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'ApplicationParameters', 'HasAuthorizationByUser'];

    function MedReportApprovalsController ($http, $state, $stateParams, $filter, $timeout, ApplicationParameters, HasAuthorizationByUser) {
        var vm = this;
        ApplicationParameters.hasModule('Med_Report', true);
        vm.$state = $state;
    }
})();
;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportApprovals.history', {
                parent: 'medReportApprovals',
                url: '/history',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                templateUrl: 'app/displays/medReportApprovals/history/history.html',
                controller: 'MedReportApprovalsHistoryController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportApprovalsHistoryController', MedReportApprovalsHistoryController);

    MedReportApprovalsHistoryController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'KendoFilter', 'CustomUtils'];

    function MedReportApprovalsHistoryController ($http, $state, $stateParams, $filter, $timeout, KendoFilter, CustomUtils ) {
        var vm = this;

        vm.historyGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "isActive", "operator": "eqbool", "value": true }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "eq",  "value": "approved"}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/med-reports',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function () {});
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            fromDate: { type: 'date'},
                            toDate: { type: 'date'},
                            checkDigit1: { type: 'number'},
                            checkDigit2: { type: 'number'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            height: CustomUtils.getHeightPixelsFromPercentage(60),
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "fromDate",
                    title: "Μήνας",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'MMMM')#",
                    filterable: false, width: 250
                },
                {
                    field: "toDate",
                    title: "Έτος",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'yyyy')#",
                    filterable: false, width: 230
                },
                {
                    field: "checkDigit1", title: "Check Digit",
                    filterable: false,
                    width: 230
                },
                {
                    field: "checkDigit2", title: "Check Digit 2",
                    filterable: false,
                    width: 230
                },
                {
                    field: "code", title: "Κωδικός", width: 300,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:230
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:230
                }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>", overflow: "never" }
            ]
        };
    }
})();
;
/**
 * Created by Teo on 03/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadEvents', {
                parent: 'app',
                url: '/leadEvents',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.global.menu.lead-management.lead-events'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/leadEvents/leadEvents.html',
                        controller: 'LeadEventsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
;
/**
 * Created by Teo on 03/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadEventsController', LeadEventsController);

    LeadEventsController.$inject = ['$http', '$scope', '$state', '$filter','KendoFilter', 'KendoToolbar', 'KendoGrid', 'CustomUtils'];

    function LeadEventsController ($http, $scope, $state, $filter, KendoFilter, KendoToolbar, KendoGrid, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Ραντεβου";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(62);
        var grid = {};

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    if (vm.from){
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "appointmentDate", "operator": "from",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                }
                            ]
                        );
                    }

                    if (vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "appointmentDate", "operator": "to",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                }
                            ]
                        );
                    }

                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "appointmentDate",  "dir": "desc" };
                    }

                    angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            case "appointmentDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    o.data.filter.filters.push({
                        field: "appointmentDate",
                        operator: "notnull",
                        value: true // add value here, not null!
                    });

                    // console.log(o);
                    // console.log(JSON.stringify(o));
                    $http.get('/api/lead-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.callType) item.callType = {};
                            if (!item.prospectivePatient){
                                item.prospectivePatient = {};
                            }
                            if (item.prospectivePatient && !item.prospectivePatient.attendant){
                                item.prospectivePatient.attendant = {}
                            }
                            if (!item.oldPatient) item.oldPatient = {};
                            if (!item.oldPatientDoctor) item.oldPatientDoctor = {};

                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateTime: { type: "date" },
                        appointmentDate: { type: "date" },
                        nextFollowUpDate: { type: "date"}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='edit' ng-click='vm.edit(dataItem)' >" + // ui-sref='leadCallEdit({id:dataItem.id})'
                " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80
            },
            {
                field: "appointmentDate", title: "Ημερομηνία", template: "#= appointmentDate ? kendo.toString(kendo.parseDate(appointmentDate), 'dddd, dd/MM/yyyy, HH:mm') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.firstName",
                title: "Όνομα Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.lastName",
                title: "Επώνυμο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.phone",
                title: "Τηλέφωνο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.age",
                title: "Ηλικία",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.firstName",
                title: "Όνομα Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.lastName",
                title: "Επώνυμο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.phone",
                title: "Τηλέφωνο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.bookedAppointment" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "bookedAppointment",
                title: "Δια Ζώσης",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                },
                width: 130
            }
        ];

        vm.leadCallsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false,
            toolbar: [
                /*{ template: "<md-button class='md-raised md-mini md-primary' aria-label='add' ng-click='vm.addNew()'>" +
                    "Προσθήκη Νέας Εγγραφής</md-button>" },*/
                { template: "<div class='right'><label>Σύνολο: {{vm.leadCallsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                vm.from = new Date(date.getFullYear(), 0, 1);
                vm.to = new Date(new Date().getFullYear(), 11, 31);
            }
            KendoToolbar.setFrom(vm.from);
            KendoToolbar.setTo(vm.to);
            KendoGrid.refresh(vm.leadCallsGridOptions);
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "from", "to"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                console.log("vm.fromOptions::change");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.from = value;
                } else {
                    vm.from = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                console.log("vm.toOptions::change");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.to = value;
                } else {
                    vm.to = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.onFilterChange = function () {
            angular.element("#leadCallsGrid").data("kendoGrid").dataSource.read();
        };

        vm.edit = function(dataItem) {
            $state.go('leadCallView', {id: dataItem.id});
        };

        /**
         * This gets called on page load finish.
         * Add it into 'data-ng-init' directive of a div, grid etc.
         * If you try to touch/edit a toolbar control inside controller,
         * then you get an undefined error. If you put it here, all
         * the controls are ready and you can touch them.
         */
        vm.onPageLoad = function () {
            var today = new Date();
            // today.setHours(0);
            // today.setMinutes(0);
            // today.setSeconds(1);
            // today.setMilliseconds(1);
            vm.from = today;
            KendoToolbar.setFrom(today);
            //KendoGrid.refresh(vm.leadCallsGridOptions);
        };
    }
})();
;
/**
 * Created by Teo on 14/05/2018.
 */

(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('LeadCallHelper', LeadCallHelper);

    LeadCallHelper.$inject = ['DateUtils'];

    function LeadCallHelper (DateUtils) {
        return {
            prepareLeadCall : prepareLeadCall,
            leadHospitalizationEqual : leadHospitalizationEqual,
            leadOfferEqual : leadOfferEqual,
            leadDiscountEqual : leadDiscountEqual,
            hasLeadHospitalization : hasLeadHospitalization,
            hasLeadOffer : hasLeadOffer,
            hasLeadDiscount : hasLeadDiscount,
            hasModifyDiseases : hasModifyDiseases,
            equalsLeadCall : equalsLeadCall,
            equalsLeadHospitalization : equalsLeadHospitalization,
            isUndefinedOrNull : isUndefinedOrNull,
            hasProspectivePatient: hasProspectivePatient,
            hasAttendant: hasAttendant,
            validateProspectivePatient: validateProspectivePatient,
            validateAttendant: validateAttendant,
            validatePhone: validatePhone
        };

        function prepareLeadCall(leadCall){
            if (leadCall.prospectivePatient && !leadCall.prospectivePatient.id) leadCall.prospectivePatient = null;
            if (leadCall.oldPatient && !leadCall.oldPatient.id) leadCall.oldPatient = null;
            if (leadCall.oldPatientDoctor && !leadCall.oldPatientDoctor.id) leadCall.oldPatientDoctor = null;
            if (leadCall.leadHospitalizations[0] !== null && leadCall.leadHospitalizations[0] !== undefined){
                if (leadCall.leadHospitalizations[0].possibleDischargeDate !== null && leadCall.leadHospitalizations[0].possibleDischargeDate !== undefined){
                    leadCall.leadHospitalizations[0].possibleDischargeDate = DateUtils.convertLocalDateToServer(leadCall.leadHospitalizations[0].possibleDischargeDate);
                }

                if (leadCall.leadHospitalizations[0].diagnosisDate !== null && leadCall.leadHospitalizations[0].diagnosisDate !== undefined){
                    leadCall.leadHospitalizations[0].diagnosisDate = DateUtils.convertLocalDateToServer(leadCall.leadHospitalizations[0].diagnosisDate);
                }

                if (leadCall.leadHospitalizations[0].hospitalizationDate !== null && leadCall.leadHospitalizations[0].hospitalizationDate !== undefined){
                    leadCall.leadHospitalizations[0].hospitalizationDate = DateUtils.convertLocalDateToServer(leadCall.leadHospitalizations[0].hospitalizationDate);
                }
            }

            //console.log(leadCall);

            return leadCall;
        }

        function leadHospitalizationEqual(initObject, object) {
            if (initObject.hospitalizationType.id === object.hospitalizationType.id &&
                initObject.isClosedHospitalization === object.isClosedHospitalization &&
                initObject.hadSurgery === object.hadSurgery &&
                initObject.surgeryType === object.surgeryType &&
                initObject.clinicName.id === object.clinicName.id &&
                initObject.possibleDischargeDate.getTime() === object.possibleDischargeDate.getTime() &&
                initObject.isFollowingHospitalization === object.isFollowingHospitalization &&
                initObject.diagnosisDate.getTime() === object.diagnosisDate.getTime() &&
                initObject.comments === object.comments){
                return true;
            }else {
                return false;
            }
        }

        function leadOfferEqual (initObject, object){
            if (initObject.costType.id === object.costType.id &&
                initObject.roomType.id === object.roomType.id &&
                initObject.firstEstimationDate.getTime() === object.firstEstimationDate.getTime() &&
                initObject.desirableRoomType.id === object.desirableRoomType.id &&
                initObject.upgradedRoomType.id === object.upgradedRoomType.id &&
                initObject.transportation.id === object.transportation.id &&
                initObject.wantsTransportation === object.wantsTransportation &&
                initObject.attendantMeal === object.attendantMeal &&
                initObject.hasCompetitiveBid === object.hasCompetitiveBid &&
                initObject.competitor.id === object.competitor.id){
                return true;
            }else {
                return false;
            }
        }

        function leadDiscountEqual(initObject, object) {
            if (initObject.hasRequestedDiscount === object.hasRequestedDiscount &&
                initObject.discountReason.id === object.discountReason.id &&
                initObject.isEntitledToDiscount === object.isEntitledToDiscount &&
                initObject.entitledToReason.id === object.entitledToReason.id &&
                initObject.finalDiscount.id === object.finalDiscount.id &&
                initObject.finalReason.id === object.finalReason.id &&
                initObject.wantsTransportation === object.wantsTransportation){
                return true;
            }else {
                return false;
            }
        }

        /**
         * Checks if a LeadHospitalization object has changed from an
         * initial LeadHospitalization object.
         * WARNING: This does not compare 2 LeadHospitalization objects for equality!
         * For example, it checks if object has sector, not if it is the same as initObject.
         * @param initObject The initial LeadHospitalization object
         * @param object The LeadHospitalization object that is about to be saved
         * @returns {boolean} True if object is different from initialObject, false if not
         */
        function hasLeadHospitalization(initObject, object){
            var has = false;

            if (object.hospitalizationType && object.hospitalizationType.id > 0){
                console.log("has LeadHospitalization.hospitalizationType");
                return true;
            }

            if (object.clinicName && object.clinicName.id > 0){
                console.log("has LeadHospitalization.clinicName");
                return true;
            }

            if (object.sector && object.sector.id > 0){
                console.log("has LeadHospitalization.sector");
                return true;
            }

            if (initObject.isClosedHospitalization !== object.isClosedHospitalization){
                console.log("has LeadHospitalization.isClosedHospitalization");
                return true;
            }

            if (initObject.hadSurgery !== object.hadSurgery){
                console.log("has LeadHospitalization.hadSurgery");
                return true;
            }

            if (initObject.surgeryType !== object.surgeryType){
                console.log("has LeadHospitalization.surgeryType");
                return true;
            }

            // if (initObject.possibleDischargeDate.getTime() !== object.possibleDischargeDate.getTime()){
            //     console.log("has possibleDischargeDate");
            //     return true;
            // }
            if (object.possibleDischargeDate !== null){
                console.log("has LeadHospitalization.possibleDischargeDate");
                return true;
            }

            if (initObject.isFollowingHospitalization !== object.isFollowingHospitalization){
                console.log("has LeadHospitalization.isFollowingHospitalization");
                return true;
            }

            // if (initObject.diagnosisDate.getTime() !== object.diagnosisDate.getTime()){
            //     console.log("has diagnosisDate");
            //     return true;
            // }
            if (object.diagnosisDate !== null){
                console.log("has LeadHospitalization.diagnosisDate");
                return true;
            }

            if (initObject.comments !== object.comments){
                console.log("has LeadHospitalization.comments");
                return true;
            }

            console.log(object.addDiseases);
            if (/*typeof object.addDiseases !== 'undefined' && */object.addDiseases.length > 0){
                console.log("has LeadHospitalization.addDiseases");
                return true;
            }

            console.log(object.addConditions);
            if (/*typeof object.addConditions !== 'undefined' && */object.addConditions.length > 0){
                console.log("has LeadHospitalization.addConditions");
                return true;
            }

            return has;
        }

        /**
         * Checks if a LeadOffer object has changed from an
         * initial LeadOffer object.
         * WARNING: This does not compare 2 LeadOffer objects for equality!
         * For example, it checks if object has roomType, not if it is the same as initObject.
         * @param initObject The initial LeadOffer object
         * @param object The LeadOffer object that is about to be saved
         * @returns {boolean} True if object is different from initialObject, false if not
         */
        function hasLeadOffer(initObject, object){
            var has = false;

            if (object.costType && object.costType.id > 0){
                console.log("has LeadOffer.costType");
                return true;
            }

            if (object.roomType && object.roomType.id > 0){
                console.log("has LeadOffer.roomType");
                return true;
            }

            if (object.desirableRoomType && object.desirableRoomType.id > 0){
                console.log("has LeadOffer.desirableRoomType");
                return true;
            }

            if (object.upgradedRoomType && object.upgradedRoomType.id > 0){
                console.log("has LeadOffer.upgradedRoomType");
                return true;
            }

            if (object.transportation && object.transportation.id > 0){
                console.log("has LeadOffer.transportation");
                return true;
            }

            if (object.competitor && object.competitor.id > 0){
                console.log("has LeadOffer.competitor");
                return true;
            }

            // if (initObject.firstEstimationDate.getTime() !== object.firstEstimationDate.getTime()){
            //     console.log("has LeadOffer.possibleDischargeDate");
            //     return true;
            // }
            if (object.firstEstimationDate !== null){
                console.log("has LeadOffer.firstEstimationDate");
                return true;
            }

            if (initObject.wantsTransportation !== object.wantsTransportation){
                console.log("has LeadOffer.wantsTransportation");
                return true;
            }

            if (initObject.attendantMeal !== object.attendantMeal){
                console.log("has LeadOffer.attendantMeal");
                return true;
            }

            if (initObject.hasCompetitiveBid !== object.hasCompetitiveBid){
                console.log("has LeadOffer.hasCompetitiveBid");
                return true;
            }

            return has;
        }

        /**
         * Checks if a LeadDiscount object has changed from an
         * initial LeadDiscount object.
         * WARNING: This does not compare 2 LeadDiscount objects for equality!
         * For example, it checks if object has hasRequestedDiscount, not if it is the same as initObject.
         * @param initObject The initial LeadDiscount object
         * @param object The LeadDiscount object that is about to be saved
         * @returns {boolean} True if object is different from initialObject, false if not
         */
        function hasLeadDiscount(initObject, object){
            var has = false;

            if (initObject.hasRequestedDiscount !== object.hasRequestedDiscount){
                console.log("has LeadDiscount.hasRequestedDiscount");
                return true;
            }

            if (object.discountReason && object.discountReason.id > 0){
                console.log("has LeadDiscount.discountReason");
                return true;
            }

            if (initObject.isEntitledToDiscount !== object.isEntitledToDiscount){
                console.log("has LeadDiscount.isEntitledToDiscount");
                return true;
            }

            if (object.entitledToReason && object.entitledToReason.id > 0){
                console.log("has LeadDiscount.entitledToReason");
                return true;
            }

            if (object.finalDiscount && object.finalDiscount.id > 0){
                console.log("has LeadDiscount.finalDiscount");
                return true;
            }

            if (object.finalReason && object.finalReason.id > 0){
                console.log("has LeadDiscount.finalReason");
                return true;
            }

            return has;
        }

        /**
         * Checks if a LeadOffer object is equal with other.
         * Inside objects are compared only with their ids.
         * @param o1 Object to compare
         * @param o2 Object to compare
         * @returns {boolean} True if arguments are equal
         */
        function equalsLeadCall(o1, o2){
            // console.log("Comparing LeadCalls ...");
            // console.log(o1);
            // console.log(o2);
            if (isUndefinedOrNull(o1) && isUndefinedOrNull(o2)){
                console.log("both objects are null or undefined");
                return true;
            }
            if (!isUndefinedOrNull(o1) && isUndefinedOrNull(o2)){
                console.log("obj2 is null or undefined");
                return false;
            }
            if (!isUndefinedOrNull(o2) && isUndefinedOrNull(o1)){
                console.log("obj1 is null or undefined");
                return false;
            }
            if (moment(o1.dateTime).isSame(o2.dateTime, 'minutes') === false){
                console.log("object.dateTime differs");
                return false;
            }
            if (o1.noContact !== o2.noContact){
                console.log("object.noContact differs");
                return false;
            }
            if (o1.isOldPatient !== o2.isOldPatient){
                console.log("object.isOldPatient differs");
                return false;
            }
            if (o1.isOldPatientRelative !== o2.isOldPatientRelative){
                console.log("object.isOldPatientRelative differs");
                return false;
            }

            if (!isUndefinedOrNull(o1.callType.id) && !isUndefinedOrNull(o2.callType.id)){
                if (angular.equals(o1.callType.id, o2.callType.id) === false){
                    console.log("object.callType differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.callType.id) && isUndefinedOrNull(o2.callType.id)){
                    console.log("object1.callType is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.callType.id) && isUndefinedOrNull(o1.callType.id)){
                    console.log("object2.callType is null");
                    return false;
                }
            }

            if (!isUndefinedOrNull(o1.prospectivePatient) && !isUndefinedOrNull(o2.prospectivePatient)){
                if (angular.equals(o1.prospectivePatient.id, o2.prospectivePatient.id) === false){
                    console.log("object.prospectivePatient differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.prospectivePatient) && isUndefinedOrNull(o2.prospectivePatient)){
                    console.log("object1.prospectivePatient is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.prospectivePatient) && isUndefinedOrNull(o1.prospectivePatient)){
                    console.log("object2.prospectivePatient is null");
                    return false;
                }
            }

            if (!isUndefinedOrNull(o1.oldPatient) && !isUndefinedOrNull(o2.oldPatient)){
                if (angular.equals(o1.oldPatient.id, o2.oldPatient.id) === false){
                    console.log("object.oldPatient differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.oldPatient) && isUndefinedOrNull(o2.oldPatient)){
                    console.log("object1.oldPatient is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.oldPatient) && isUndefinedOrNull(o1.oldPatient)){
                    console.log("object2.oldPatient is null");
                    return false;
                }
            }

            if (!isUndefinedOrNull(o1.oldPatientDoctor) && !isUndefinedOrNull(o2.oldPatientDoctor)){
                if (angular.equals(o1.oldPatientDoctor.id, o2.oldPatientDoctor.id) === false){
                    console.log("object.oldPatientDoctor differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.oldPatientDoctor) && isUndefinedOrNull(o2.oldPatientDoctor)){
                    console.log("object1.oldPatientDoctor is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.oldPatientDoctor) && isUndefinedOrNull(o1.oldPatientDoctor)){
                    console.log("object2.oldPatientDoctor is null");
                    return false;
                }
            }

            return true;
        }

        /**
         * Checks if a LeadHospitalization object is equal with other.
         * Inside objects are compared only with their ids.
         * @param o1 Object to compare
         * @param o2 Object to compare
         * @returns {boolean} True if arguments are equal
         */
        function equalsLeadHospitalization(o1, o2){
            console.log("Comparing LeadHospitalizations ...");
            console.log(o1);
            console.log(o2);
            if (isUndefinedOrNull(o1) && isUndefinedOrNull(o2)){
                console.log("both objects are null or undefined");
                return true;
            }
            if (!isUndefinedOrNull(o1) && isUndefinedOrNull(o2)){
                console.log("obj2 is null or undefined");
                return false;
            }
            if (!isUndefinedOrNull(o2) && isUndefinedOrNull(o1)){
                console.log("obj1 is null or undefined");
                return false;
            }
            if (o1.isClosedHospitalization !== o2.isClosedHospitalization){
                console.log("object.isClosedHospitalization differs");
                return false;
            }
            if (o1.hadSurgery !== o2.hadSurgery){
                console.log("object.hadSurgery differs");
                return false;
            }
            if (angular.equals(o1.surgeryType, o2.surgeryType) === false){
                console.log("object.surgeryType differs");
                return false;
            }
            if (angular.equals(o1.sectorOther, o2.sectorOther) === false){
                console.log("object.sectorOther differs");
                return false;
            }
            if (!isUndefinedOrNull(o1.diagnosisDate) && !isUndefinedOrNull(o2.diagnosisDate)){
                if (moment(o1.diagnosisDate).isSame(o2.diagnosisDate, 'minutes') === false){
                    console.log("object.diagnosisDate differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.diagnosisDate) && isUndefinedOrNull(o2.diagnosisDate)){
                    console.log("object1.diagnosisDate is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.diagnosisDate) && isUndefinedOrNull(o1.diagnosisDate)){
                    console.log("object2.diagnosisDate is null");
                    return false;
                }
            }
            if (!isUndefinedOrNull(o1.possibleDischargeDate) && !isUndefinedOrNull(o2.possibleDischargeDate)){
                if (moment(o1.possibleDischargeDate).isSame(o2.possibleDischargeDate, 'minutes') === false){
                    console.log("object.possibleDischargeDate differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.possibleDischargeDate) && isUndefinedOrNull(o2.possibleDischargeDate)){
                    console.log("object1.possibleDischargeDate is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.possibleDischargeDate) && isUndefinedOrNull(o1.possibleDischargeDate)){
                    console.log("object2.possibleDischargeDate is null");
                    return false;
                }
            }
            if (o1.isFollowingHospitalization !== o2.isFollowingHospitalization){
                console.log("object.isFollowingHospitalization differs");
                return false;
            }
            if (angular.equals(o1.comments, o2.comments) === false){
                console.log("object.comments differs");
                return false;
            }
            if (angular.equals(o1.addDiseaseOther, o2.addDiseaseOther) === false){
                console.log("object.addDiseaseOther differs");
                return false;
            }

            if (!isUndefinedOrNull(o1.sector) && !isUndefinedOrNull(o2.sector)){
                if (angular.equals(o1.sector.id, o2.sector.id) === false){
                    console.log("object.sector differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.sector) && isUndefinedOrNull(o2.sector)){
                    console.log("object1.sector is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.sector) && isUndefinedOrNull(o1.sector)){
                    console.log("object2.sector is null");
                    return false;
                }
            }

            if (!isUndefinedOrNull(o1.hospitalizationType) && !isUndefinedOrNull(o2.hospitalizationType)){
                if (angular.equals(o1.hospitalizationType.id, o2.hospitalizationType.id) === false){
                    console.log("object.hospitalizationType differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.hospitalizationType) && isUndefinedOrNull(o2.hospitalizationType)){
                    console.log("object1.hospitalizationType is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.hospitalizationType) && isUndefinedOrNull(o1.hospitalizationType)){
                    console.log("object2.hospitalizationType is null");
                    return false;
                }
            }

            if (!isUndefinedOrNull(o1.clinicName) && !isUndefinedOrNull(o2.clinicName)){
                if (angular.equals(o1.clinicName.id, o2.clinicName.id) === false){
                    console.log("object.clinicName differs");
                    return false;
                }
            }else {
                if (!isUndefinedOrNull(o1.clinicName) && isUndefinedOrNull(o2.clinicName)){
                    console.log("object1.clinicName is null");
                    return false;
                }
                if (!isUndefinedOrNull(o2.clinicName) && isUndefinedOrNull(o1.clinicName)){
                    console.log("object2.clinicName is null");
                    return false;
                }
            }

            return true;
        }

        function hasModifyDiseases(leadHospitalizationDiseases, selectedDiseases) {
            var has = false;

            // console.log("leadHospitalizationDiseases: ");
            // console.log(leadHospitalizationDiseases);
            // console.log("selectedDiseases: ");
            // console.log(selectedDiseases);

            if (leadHospitalizationDiseases === null || leadHospitalizationDiseases.length === 0){
                if (selectedDiseases != null && selectedDiseases.length > 0){
                    // case: there wasn't any diseases, has added new
                    console.log("there wasn't any diseases, has added new");
                    return true;
                }
            }

            if (selectedDiseases === null || selectedDiseases.length === 0){
                if (leadHospitalizationDiseases != null && leadHospitalizationDiseases.length > 0){
                    // case: there was diseases, has remove them all
                    console.log("there was diseases, has remove them all");
                    return true;
                }
            }

            if (leadHospitalizationDiseases != null && leadHospitalizationDiseases.length > 0 &&
                selectedDiseases != null && selectedDiseases.length > 0){
                var diseases = [];

                for (var i=0; i < leadHospitalizationDiseases.length; i++) {
                    diseases.push(leadHospitalizationDiseases[i].disease);
                }

                if (diseases.length !== selectedDiseases.length){
                    // case: there was diseases and there are new but lengths are different
                    console.log("there was diseases and there are new but lengths are different");
                    return true;
                }else {
                    // case: oldDiseases length is equal to new diseases, check items
                    console.log("oldDiseases length is equal to new diseases, check items");
                    for (var j = diseases.length; j--;){
                        if (diseases[j].id !== selectedDiseases[j].id){
                            has = true;
                            break;
                        }
                    }
                }
            }

            console.log("has not made any changes in Diseases!");

            return has;
        }

        function hasProspectivePatient(prospectivePatient){
            var has = false;

            if (prospectivePatient !== null && prospectivePatient !== undefined) {

                if (prospectivePatient.firstName !== null && prospectivePatient.firstName !== undefined && prospectivePatient.firstName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.lastName !== null && prospectivePatient.lastName !== undefined && prospectivePatient.lastName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.phone !== null && prospectivePatient.phone !== undefined && prospectivePatient.phone.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.email !== null && prospectivePatient.email !== undefined && prospectivePatient.email.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.mobile !== null && prospectivePatient.mobile !== undefined && prospectivePatient.mobile.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.birthYear !== null && prospectivePatient.birthYear !== undefined && prospectivePatient.birthYear.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.countryName !== null && prospectivePatient.countryName !== undefined && prospectivePatient.countryName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.regionName !== null && prospectivePatient.regionName !== undefined && prospectivePatient.regionName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.prefectureName !== null && prospectivePatient.prefectureName !== undefined && prospectivePatient.prefectureName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.prefectureName !== null && prospectivePatient.prefectureName !== undefined && prospectivePatient.prefectureName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.cityName !== null && prospectivePatient.cityName !== undefined && prospectivePatient.cityName.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.postalCode !== null && prospectivePatient.postalCode !== undefined && prospectivePatient.postalCode.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.address !== null && prospectivePatient.address !== undefined && prospectivePatient.address.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.addressNum !== null && prospectivePatient.addressNum !== undefined && prospectivePatient.addressNum.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.postalCode !== null && prospectivePatient.postalCode !== undefined && prospectivePatient.postalCode.length > 0){
                    has = true;
                    return has;
                }

                if (prospectivePatient.profession !== null && prospectivePatient.profession !== undefined && prospectivePatient.profession.id > 0){
                    has = true;
                    return has;
                }

                /*if (prospectivePatient.nativeLanguage !== null && prospectivePatient.nativeLanguage !== undefined && prospectivePatient.nativeLanguage.id > 0){
                    has = true;
                    return has;
                }*/

            }

            return has;
        }

        function hasAttendant(attendant){
            var has = false;

            if (attendant !== null && attendant !== undefined) {

                if (attendant.firstName !== null && attendant.firstName !== undefined && attendant.firstName.length > 0){
                    has = true;
                    return has;
                }

                if (attendant.lastName !== null && attendant.lastName !== undefined && attendant.lastName.length > 0){
                    has = true;
                    return has;
                }

                if (attendant.phone !== null && attendant.phone !== undefined && attendant.phone.length > 0){
                    has = true;
                    return has;
                }

                if (attendant.email !== null && attendant.email !== undefined && attendant.email.length > 0){
                    has = true;
                    return has;
                }

                if (attendant.profession !== null && attendant.profession !== undefined && attendant.profession.id > 0){
                    has = true;
                    return has;
                }

                if (attendant.relationshipType !== null && attendant.relationshipType !== undefined && attendant.relationshipType.id > 0){
                    has = true;
                    return has;
                }

            }

            return has;
        }

        function validateAttendant(attendant){
            var isValid = true;

            if (attendant === null || attendant === undefined){
                isValid = false;
                return isValid;
            }

            if (attendant.firstName === null || attendant.firstName === undefined){
                isValid = false;
                return isValid;
            }

            if (attendant.lastName === null || attendant.lastName === undefined){
                isValid = false;
                return isValid;
            }

            return isValid;
        }

        function validateProspectivePatient(prospectivePatient){
            var isValid = true;

            if (prospectivePatient === null || prospectivePatient === undefined){
                isValid = false;
                return isValid;
            }

            if (prospectivePatient.firstName === null || prospectivePatient.firstName === undefined){
                isValid = false;
                return isValid;
            }

            if (prospectivePatient.lastName === null || prospectivePatient.lastName === undefined){
                isValid = false;
                return isValid;
            }

            return isValid;
        }

        function isUndefinedOrNull (val) {
            return angular.isUndefined(val) || val === null
        }

        /**
         * Custom validation for phone. Atm it works only for Greek numbers.
         * Note that phone is nullable, so it is valid if it is null.
         * CountryPhone.id == 1 is for Greece.
         * @param countryPhoneCode The countryCode for different Country validations
         * @param phone The actual phone to validate
         * @returns {boolean} True if is valid, false if not
         */
        function validatePhone(countryPhoneCode, phone){
            var isValid = false;

            if (countryPhoneCode && countryPhoneCode.id === 1){
                // Greece Validation
                if (phone && phone !== null && phone.length > 0){
                    // Make validations
                    if (isNumeric(phone)){
                        isValid = phone.length === 10 && (phone.startsWith("6") || phone.startsWith("2"))
                    }else {
                        isValid = false;
                    }
                }else {
                    isValid = true;
                }
            }else {
                isValid = true;
            }

            return isValid;
        }

        /**
         * Checks if a string has only numbers
         * @param n The string to check
         * @returns {boolean} True if it is, false if not
         */
        function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
    }
})();
;
/**
 * Created by Teo on 09/05/2018.
 */

(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('LeadCallsGrids', LeadCallsGrids);

    LeadCallsGrids.$inject = ['$http', 'KendoFilter'];

    function LeadCallsGrids ($http, KendoFilter) {
        var popupGrid = {};

        //Grid's Columns initialization
        var customerColumns = [
            {
                field: "customer.lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.doctorSpecialty.name",
                title: "Ειδικότητα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var patientColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "amka",
                title: "Α.Μ.Κ.Α",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλ. Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "yearOfBirth", title: "Έτος Γέννηση",
                format: "{0:yyyy}",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "notes",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var prospectivePatientColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλ. Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "birthYear", title: "Έτος Γέννηση",
                format: "{0:yyyy}",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var attendantColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "profession.name",
                title: "Ειδικότητα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        //Grid's Datasource initialization
        var getCustomerDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        // get only active customer-sectors
                        o.data.active = true;

                        $http.get('/api/me/customer-sectors',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            angular.forEach( data.content, function( item ) {
                                if( !item.customer.doctorSpecialty ) item.customer.doctorSpecialty = {};
                                if( !item.sector ) item.sector = {};
                            })
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getPatientDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/patients/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        /*if(data.content !== undefined) {
                            angular.forEach( data.content, function (item) {
                                if (item.yearOfBirth) {
                                    var date = new Date();
                                    date.setFullYear(item.yearOfBirth);
                                    item.yearOfBirth = date;
                                }
                            })
                        }*/
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getProspectivePatientDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        // this filters only ProspectivePatients that
                        // have become Patients ECRM-242
                        // o.data.filter.filters[0] = {
                        //     field: "patient",
                        //     operator: "notempty",
                        //     value: "true"
                        // };
                        $http.get('/api/prospective-patients/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        /*if(data.content !== undefined) {
                            angular.forEach( data.content, function (item) {
                                if (item.birthYear) {
                                    var date = new Date();
                                    date.setFullYear(item.birthYear);
                                    item.birthYear = date;
                                }
                            })
                        }*/
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getAttendantDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/attendants/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            angular.forEach( data.content, function (item) {
                                if (!item.profession) item.profession = {};
                                /*if (item.yearOfBirth) {
                                    var date = new Date();
                                    date.setFullYear(item.yearOfBirth);
                                    item.yearOfBirth = date;
                                }*/
                            })
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };

        return {
            getGridOptions: getGridOptions,
            getGridTitle: getGridTitle
        };

        function getGridOptions( grid ) {
            switch (grid) {
                case 'oldPatient':
                    popupGrid.columns = patientColumns;
                    popupGrid.datasource = getPatientDatasource();
                    break;
                case 'oldPatientDoctor':
                    popupGrid.columns = customerColumns;
                    popupGrid.datasource = getCustomerDatasource();
                    break;
                case 'prospectivePatient':
                    popupGrid.columns = prospectivePatientColumns;
                    popupGrid.datasource = getProspectivePatientDatasource();
                    break;
                case 'attendant':
                    popupGrid.columns = attendantColumns;
                    popupGrid.datasource = getAttendantDatasource();
                    break;
                default:
                    popupGrid.columns = null;
                    popupGrid.datasource = null;
                    break
            }

            return {
                dataSource: popupGrid.datasource,
                sortable: true,
                pageable: true,
                filterable: {
                    mode: "row"
                },
                resizable: true,
                selectable: true,
                columns:  popupGrid.columns,
                editable: false,
                grid: grid
            };
        }

        function getGridTitle( grid ){
            switch (grid){
                case 'oldPatient':
                    return "Επιλέξτε Παλιό Ασθενή";
                case 'oldPatientDoctor':
                    return "Επιλέξτε Επαγγελματία Υγείας Παλιού Ασθενή";
                case 'prospectivePatient':
                    return "Επιλέξτε Πιθανό Ασθενή";
                case 'attendant':
                    return "Επιλέξτε Συνοδό";
                default:
                    return "Επιλέξτε";
            }
        }
    }
})();
;
/**
 * Created by Teo on 02/05/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsViewController', LeadCallsViewController);

    LeadCallsViewController.$inject = ['$scope', '$state', '$http', '$filter', '$stateParams', '$timeout', 'LeadCallHelper', 'PdfBuilder', 'CustomDateUtils', 'LeadCallsGrids', 'KendoGrid', 'KendoFilter',
        'KendoService', 'NotificationOptions', 'KendoNotifications', 'Alerts', 'callTypes', 'professions', 'relationshipTypes',
        'nativeLanguages', 'hospitalizationTypes', 'costTypes', 'roomTypes', 'transportations', 'discountReasons',
        'discountRates', 'competitors', 'addDiseases', 'addConditions', 'diseaseTypes', 'diseases', 'offerStatuses', 'communicationStatuses', 'countryPhoneCodes', 'CalculateAge', 'ProspectivePatient',
        'Attendant', 'Patient', 'Customer', 'LeadCall', 'DateUtils', 'CustomUtils', 'HospitalizationService'];

    function LeadCallsViewController ($scope, $state, $http, $filter, $stateParams, $timeout, LeadCallHelper, PDFPdfBuilder, CustomDateUtils, LeadCallsGrids, KendoGrid, KendoFilter,
                                      KendoService, NotificationOptions, KendoNotifications, Alerts, callTypes, professions, relationshipTypes,
                                      nativeLanguages, hospitalizationTypes, costTypes, roomTypes, transportations, discountReasons,
                                      discountRates, competitors, addDiseases, addConditions, diseaseTypes, diseases, offerStatuses, communicationStatuses, countryPhoneCodes, CalculateAge, ProspectivePatient,
                                      Attendant, Patient, Customer, LeadCall, DateUtils, CustomUtils, HospitalizationService) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(61);
        var dataSource = {};
        var followUpGrid = {};
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var previousTab = "tabLeadCall";
        vm.title = 'Δημιουργία Νέας Κλήσης';
        vm.saveButtonLabel = 'Αποθήκευση Κλήσης';

        vm.expandCollapseButtonLabel = vm.expandCollapseButtonLabel_attendant = "Περισσότερα Πεδία";
        vm.expandCollapseIcon = vm.expandCollapseIcon_attendant = 'expand_more';
        vm.isExpanded = vm.isExpanded_attendant = vm.disableCostType = false;

        // Init MasterData
        vm.callTypes = callTypes;
        vm.professions = professions;
        vm.relationshipTypes = relationshipTypes;
        vm.nativeLanguages = nativeLanguages;
        vm.hospitalizationTypes = hospitalizationTypes;
        vm.costTypes = costTypes;
        vm.roomTypes = roomTypes;
        setupRoomTypes();
        vm.transportations = transportations;
        vm.discountReasons = discountReasons;
        vm.discountRates = discountRates;
        vm.competitors = competitors;
        vm.addDiseases = addDiseases;
        setupAddDiseases();
        vm.addConditions = addConditions;
        setupAddConditions();
        vm.diseaseTypes = diseaseTypes;
        vm.diseases = diseases;
        setupDiseasesWithTypes();
        vm.leadHospitalizationDiseases = [];
        vm.leadOfferRoomTypes = [];
        vm.offerStatuses = offerStatuses;
        vm.communicationStatuses = communicationStatuses;
        vm.countryPhoneCodes = countryPhoneCodes;

        if ($stateParams.id){
            // Edit Mode
            vm.title = 'Επεξεργασία Κλήσης';

            LeadCall.get({id : $stateParams.id}).$promise.then(function (data) {
                vm.leadCall = data;
                if (vm.leadCall){
                    vm.copied_leadCall = angular.copy(vm.leadCall);
                    // Quick workaround for setup callType radio button
                    vm.leadCall.callType = vm.callTypes.find(function (callType) {
                        return vm.leadCall.callType.id === callType.id;
                    });
                    vm.startDate = vm.startTime = vm.leadCall.dateTime;
                    vm.appointmentDate = vm.appointmentTime = vm.leadCall.appointmentDate;

                    if (vm.leadCall.prospectivePatient !== null && vm.leadCall.prospectivePatient !== undefined){
                        vm.prospectivePatient = angular.copy(vm.leadCall.prospectivePatient);//vm.leadCall.prospectivePatient;
                        if (vm.leadCall.prospectivePatient.attendant !== null && vm.leadCall.prospectivePatient.attendant !== undefined){
                            vm.attendant = angular.copy(vm.leadCall.prospectivePatient.attendant);//vm.leadCall.prospectivePatient.attendant;
                        }
                    }
                    vm.setData(["prospectivePatient", "attendant", "oldPatient", "oldPatientDoctor"]);

                    if (vm.leadCall.leadHospitalizations[0]){
                        vm.leadHospitalization = vm.leadCall.leadHospitalizations[0];
                        vm.copied_leadHospitalization = angular.copy(vm.leadHospitalization);
                        if (vm.leadHospitalization.addDiseases != null && vm.leadHospitalization.addDiseases.length > 0){
                            setAddDiseases();
                        }

                        if (vm.leadHospitalization.addConditions != null && vm.leadHospitalization.addConditions.length > 0){
                            setAddConditions();
                        }

                        // Get LeadHospitalizationDiseases by leadHospitalizationId
                        var leadHospitalizationDiseasefilter = {
                            field: "leadHospitalization.id",
                            operator: "eq",
                            value: vm.leadCall.leadHospitalizations[0].id
                        };
                        $http.get('/api/lead-hospitalization-diseases/search',
                            {params:{
                                    page: "1",
                                    pageSize: "200",
                                    filter : { filters: [leadHospitalizationDiseasefilter] }}})
                            .success(function (response) {
                                vm.leadHospitalizationDiseases = response.content;
                                setDiseases();
                            })
                            .error(function (error) {
                                console.log(error);
                            });
                    }

                    // Get LeadOffer
                    $http.get('/api/lead-offers/full/' + vm.leadCall.id)
                        .success(function (response) {
                            vm.leadOffer = response.leadOffer;
                            vm.leadOfferRoomTypes = response.leadOfferRoomTypes;
                            vm.leadDiscount = vm.leadOffer.leadDiscount;

                            if (vm.leadOffer.firstEstimationDate != null){
                                vm.isFirstEstimationDate = true;
                            }

                            vm.hasFinalDiscount = (vm.leadOffer.leadDiscount && vm.leadOffer.leadDiscount.finalDiscount && vm.leadOffer.leadDiscount.finalDiscount.id > 0) ||
                                (vm.leadOffer.leadDiscount && vm.leadOffer.leadDiscount.finalReason && vm.leadOffer.leadDiscount.finalReason.id > 0);
                            // Trigger cost calculation
                            vm.onRoomCostChange();
                            // Also set it's LeadOfferRoomTypes
                            setRoomTypes();
                        })
                        .error(function (error) {
                            console.log(error);
                            // No saved LeadOffer, set LeadCall to new LeadOffer
                            vm.leadOffer.leadCall = vm.leadCall;
                        });
                }
            });
        }

        // Init objects
        vm.leadCall = {
            noContact: false,
            isOldPatient: false,
            isOldPatientRelative: false,
            isImportant: false,
            bookedAppointment: false,
            callType: vm.callTypes != null && vm.callTypes.length > 0 ? vm.callTypes[1] : {},
            prospectivePatient: {
                isWrongPhone: false,
                isWrongContact: false,
                attendant: {
                    isWrongPhone: false,
                    isWrongContact: false,
                    profession: null,
                    relationshipType: null
                },
                profession: null,
                nativeLanguage: null
            },
            oldPatient: null,
            oldPatientDoctor: null,
            leadHospitalizations: []
        };
        vm.prospectivePatient = {
            isWrongPhone: false,
            isWrongContact: false,
            attendant: null/*{
                isWrongPhone: false,
                isWrongContact: false,
                profession: null,
                relationshipType: null
            }*/,
            profession: null,
            countryPhoneCode: vm.countryPhoneCodes !== null && vm.countryPhoneCodes.length > 0 ?
                vm.countryPhoneCodes.find(function (countryPhoneCode) { return countryPhoneCode.id === 1 }) : null,
            nativeLanguage: vm.nativeLanguages != null && vm.nativeLanguages.length > 0 ? vm.nativeLanguages[0] : {}
        };
        vm.attendant = {
            isWrongPhone: false,
            isWrongContact: false,
            profession: null,
            relationshipType: null,
            countryPhoneCode: vm.countryPhoneCodes !== null && vm.countryPhoneCodes.length > 0 ?
                vm.countryPhoneCodes.find(function (countryPhoneCode) { return countryPhoneCode.id === 1 }) : null,
        };
        vm.oldPatient = {};
        vm.oldPatientDoctor = {};
        vm.leadHospitalization = {
            possibleDischargeDate: null, // new Date(),
            diagnosisDate: null, // new Date(),
            hospitalizationDate: null,
            isClosedHospitalization: true,
            hadSurgery: false,
            isFollowingHospitalization: false,
            sector: null,
            hospitalizationType: vm.hospitalizationTypes != null && vm.hospitalizationTypes.length > 0 ? vm.hospitalizationTypes[0] : null,
            clinicName: null,
            communicationStatus: null,
            comments: "",
            surgeryType: "",
            addDiseases: [],
            addConditions: []
        };
        vm.leadOffer = {
            firstEstimationDate: null, // new Date(),
            openHospitalizationReference: false,
            wantsTransportation: false,
            attendantMeal: false,
            hasCompetitiveBid: false,
            costType: null,
            roomType: null,
            transportation: null, // vm.transportations != null && vm.transportations.length > 0 ? vm.transportations[0] : {},
            offerStatus: null,
            competitor: null,
            desirableRoomType: null,
            upgradedRoomType: null,
            roomServices: "",
            comments: "",
            leadDiscount: {
                hasRequestedDiscount: false,
                isEntitledToDiscount: false,
                requestedReason: null,
                entitledToReason: null,
                finalDiscount: null,
                finalReason: null
            },
            leadCall: {
                noContact: false,
                isOldPatient: false,
                isOldPatientRelative: false,
                isImportant: false,
                callType: vm.callTypes != null && vm.callTypes.length > 0 ? vm.callTypes[0] : {},
                prospectivePatient: {
                    isWrongPhone: false,
                    isWrongContact: false,
                    attendant: {
                        isWrongPhone: false,
                        isWrongContact: false,
                        profession: null,
                        relationshipType: null
                    },
                    profession: null,
                    nativeLanguage: null
                },
                oldPatient: null,
                oldPatientDoctor: null,
                leadHospitalizations: []
            },
            invitationText: null
        };
        vm.leadDiscount = {
            hasRequestedDiscount: false,
            isEntitledToDiscount: false,
            requestedReason: null,
            entitledToReason: null,
            finalDiscount: null,
            finalReason: null
        };
        vm.roomCost = null;
        vm.roomCostWithDiscount = null;
        // Keep a reference to initial objects for comparing
        vm._leadCall = angular.copy(vm.leadCall);
        vm._prospectivePatient = angular.copy(vm.prospectivePatient);
        vm._attendant = angular.copy(vm.attendant);
        vm._oldPatient = angular.copy(vm.oldPatient);
        vm._oldPatientDoctor = angular.copy(vm.oldPatientDoctor);
        vm._leadHospitalization = angular.copy(vm.leadHospitalization);
        vm._leadOffer = angular.copy(vm.leadOffer);
        vm._leadDiscount = angular.copy(vm.leadDiscount);

        // Init helper fields/attrs
        vm.isFirstEstimationDate = false;
        vm.hasFinalDiscount = false;
        vm.startDate = vm.startTime = new Date();
        vm.appointmentDate = vm.appointmentTime = null;
        vm.attendantFullName = vm.doctorFullName = vm.oldPatientFullName = vm.prospectivePatientFullName = "";
        vm.editProspectivePatientMode = vm.editAttendantMode = vm.editOldPatientMode = vm.editOldPatientDoctorMode =
            vm.focusYearOfBirth = vm.focusAge = vm.oldPatientFocusYearOfBirth = vm.oldPatientFocusAge = false;
        vm.showSaveButton = true;
        vm.showChargesTabButtons = false;
        vm.showDiseasesTabButtons = false;
        vm.showAddDiseaseOther = false;
        vm.today = new Date().getFullYear();

        vm.validatorOptions = {
            rules: {
                custom: function (input) {
                    var valid = true;
                    if (input.data('custom')) {
                        if (input.is("[name='prospectivePatientPhone']")){
                            valid = LeadCallHelper.validatePhone(vm.prospectivePatient.countryPhoneCode, vm.prospectivePatient.phone);
                        }else if (input.is("[name='attendantPhone']")){
                            valid = LeadCallHelper.validatePhone(vm.attendant.countryPhoneCode, vm.attendant.phone);
                        }
                    }
                    return valid;
                }
            },
            messages: { custom: "Η μοφρή τηλεφώνου είναι λάθος!" },
            validateOnBlur: false
        };

        // GeoData
        var geodataDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/geodata',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                parse: function(data) {
                    angular.forEach(data, function(item) {
                        item.masterFilter = "";
                        if(item.street !== null) {
                            item.masterFilter =  item.street + ", ";
                        }
                        item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                    });
                    return data;
                }
            }
        });
        vm.masterFilterComboBoxOptions = {
            dataSource: geodataDataSource,
            filter: "search",
            dataTextField: "masterFilter",
            dataValueField: "id",
            headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
            "<span>Διεύθυνση</span>"+
            "<span>Πόλη</span>"+
            "<span>Τ.Κ.</span>"+
            "<span>Νομός</span></div>",
            template:
                "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
            placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
            change: function(){
                //initialize inputs (autocomplete)
                if(this.dataItem(this.select())) {
                    var self = this;
                    //using $timeout to trigger the change
                    $timeout(function(){
                        vm.prospectivePatient.prefectureName = self.dataItem(self.select()).prefecture;
                        vm.prospectivePatient.cityName = self.dataItem(self.select()).city;
                        vm.prospectivePatient.address = self.dataItem(self.select()).street;
                        vm.prospectivePatient.postalCode = self.dataItem(self.select()).postalCode;

                        var parentFilter = {};
                        if (vm.leadCall.prospectivePatient.prefectureName) {
                            parentFilter = {
                                "field": "prefectureName",
                                "operator": "eq",
                                "value": vm.leadCall.prospectivePatient.prefectureName
                            };
                        }
                    }, 0);
                }
            }
        };
        // Sector combobox edit configuration
        dataSource.sectorsDataSource = KendoService.initDataSource('/api/me/sectors', 1, 20);
        vm.sectorOptions = KendoService.initDefaultOptions(dataSource.sectorsDataSource, "like", "name", "id");
        vm.sectorOptions.placeholder = "Πληκτρολογήστε Νοσοκομείο";
        vm.sectorOptions.valuePrimitive = false;
        vm.sectorOptions.autoBind = false;
        // ClinicNames combobox edit configuration
        dataSource.clinicNamesDataSource = KendoService.initDataSource('/api/clinic-names/search', 1, 20);
        vm.clinicNamesOptions = KendoService.initDefaultOptions(dataSource.clinicNamesDataSource, "like", "name", "id");
        vm.clinicNamesOptions.placeholder = "ΠΛηκτρολογήστε Κλινική";
        vm.clinicNamesOptions.valuePrimitive = false;
        vm.clinicNamesOptions.autoBind = false;

        // Follow Up Grid
        followUpGrid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    o.data.filter.filters.push({
                        field: "leadCall.id",
                        operator: "eq",
                        value: (vm.leadCall.id && vm.leadCall.id > 0) ? vm.leadCall.id : $stateParams.id
                    });
                    $http.get('/api/followup-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                },
                create: function (o){
                    var data = o.data.models[0];
                    if (!data.followupType.id > 0){
                        data.followupType = null;
                    }
                    if (!data.rejectionReason.id > 0){
                        data.rejectionReason = null;
                    }
                    if (!data.followupStatus.id > 0){
                        data.followupStatus = null;
                    }
                    data.leadCall = {
                        id: (vm.leadCall.id && vm.leadCall.id > 0) ? vm.leadCall.id : $stateParams.id
                    };
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    $http.post('/api/followup-calls', data)
                        .success(function (response) {
                            o.success(response);
                            angular.element("#followUpsGrid").data("kendoGrid").dataSource.read();
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                },
                update: function (o){
                    var data = o.data.models[0];
                    if (!data.followupType.id > 0){
                        data.followupType = null;
                    }
                    if (!data.rejectionReason.id > 0){
                        data.rejectionReason = null;
                    }
                    if (!data.followupStatus.id > 0){
                        data.followupStatus = null;
                    }
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    $http.put('/api/followup-calls', data)
                        .success(function (response) {
                            o.success(response);
                            //KendoGrid.refresh(vm.followUpGridOptions)
                            angular.element("#followUpsGrid").data("kendoGrid").dataSource.read();
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (item.followupType === null){
                                item.followupType = {};
                            }
                            if (item.rejectionReason === null){
                                item.rejectionReason = {};
                            }
                            if (item.leadCall === null){
                                item.leadCall = {};
                            }
                            if (item.followupStatus === null){
                                item.followupStatus = {};
                            }
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        date: {
                            type: "date",
                            validation: {
                                required: {
                                    message: "Επιλέξτε FollowUp Ημερ/νία"
                                }
                            }
                        },
                        willTheyCall: {
                            type: "boolean",
                            defaultValue: false,
                            parse: function(value) {
                                return (value === "1" || value === "true" || value === true);

                            }
                        },
                        completed: {
                            type: "boolean",
                            defaultValue: false,
                            parse: function(value) {
                                return (value === "1" || value === "true" || value === true);

                            }
                        },
                        followupType: {
                            defaultValue: {id: null, name : null},
                            validation: {
                                required: {
                                    message: "Επιλέξτε Τύπο Follow Up"
                                }
                            }
                        },
                        /*leadCall: {
                            defaultValue: {id: (vm.leadCall.id && vm.leadCall.id > 0) ? vm.leadCall.id : $stateParams.id, name : null}
                        },*/
                        rejectionReason: {
                            defaultValue: {id: null, name : null}
                        },
                        followupStatus: {
                            defaultValue: {id: null, name : null}
                        }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        followUpGrid.columns = [
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='add'>" +
                " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80,
                selectable: false,
                command:[
                    {name:"edit", text: ""}
                ]
            },
            {field: "date", title: "FollowUp - Ημερ/νία", template: "#= date ? kendo.toString(kendo.parseDate(date), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.willTheyCall" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "willTheyCall",
                title: "Θα Καλέσουν",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true
                            })
                        },
                        showOperators: false
                    }
                },
                width: 160
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.completed" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "completed",
                title: "Ολοκληρωμένο",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true
                            })
                        },
                        showOperators: false
                    }
                },
                width: 160
            },
            {
                field: "followupType.name",
                title: "Τύπος",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                editor: function(container, options) {
                    vm.followUpTypeComboBoxDataSource= new kendo.data.DataSource({
                        transport: {
                            read: function(o) {
                                var url = '/api/followup-types';
                                $http.get(url)
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function (data) {
                                return data;
                            }
                        }
                    });

                    angular.element('<select id="followUp-type" name="followUpType" required data-required-msg="Επιλέξτε Τύπο Follow Up" data-bind="value:followupType.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.followUpTypeComboBoxDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        }).kendoValidator().data("kendoValidator");
                }
            },
            {
                field: "rejectionReason.name",
                title: "Λόγος Απόρριψης",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                editor: function(container, options) {
                    vm.rejectionReasonComboBoxDataSource= new kendo.data.DataSource({
                        transport: {
                            read: function(o) {
                                var url = '/api/rejection-reasons';
                                $http.get(url)
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function (data) {
                                return data;
                            }
                        }
                    });

                    angular.element('<select data-bind="value:rejectionReason.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.rejectionReasonComboBoxDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "followupStatus.name",
                title: "Κατάσταση Κλήσης",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                editor: function(container, options) {
                    vm.followUpStatusComboBoxDataSource= new kendo.data.DataSource({
                        transport: {
                            read: function(o) {
                                var url = '/api/followup-statuses';
                                $http.get(url)
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function (data) {
                                return data;
                            }
                        }
                    });

                    angular.element('<select data-bind="value:followupStatus.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.followUpStatusComboBoxDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "comments",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                editor: function (container, options) {
                    // Change simple input to textarea
                    $('<textarea rows="5" cols="30" data-bind="value: ' + options.field + '"></textarea>').appendTo(container);
                }
            }
        ];
        vm.followUpGridOptions = {
            dataSource: followUpGrid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  followUpGrid.columns,
            editable: {
                mode: "popup"
            },
            edit: function() {
                KendoGrid.defaultEditPopup(this._editContainer);
                //fix css in grid column header
                //angular.element( "div[data-container-for='comments']" ).addClass("k-textarea");
                //angular.element( "div[data-container-for='comments']" ).css("height", "30px").addClass("k-textarea")
            },
            toolbar: [{name :"create", text: "Προσθήκη Follow Up"},
                { template: "<div class='right'><label>Σύνολο: {{vm.followUpGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            save: function(e){
                //vm.editMode = false;
            }
        };

        vm.goBack = function(ev){
            Alerts.showConfirmDialog(ev, "Sigma SalesForce", "Θα θέλατε να αποθηκεύσετε πριν την έξοδο?", true, "ΝΑΙ", "OXI", function () {
                vm.save(true);
            }, function () {
                //$state.go('leadCalls');
                history.back();
            });
        };

        vm.showInfo = function (title, info) {
            Alerts.showAlert(title, info, "Ok");
        };

        vm.openWindow = function (grid) {
            if (vm.popupGridOptions) KendoGrid.refresh(vm.popupGridOptions);
            vm.popupGridOptions = LeadCallsGrids.getGridOptions(grid);

            vm.window.title(LeadCallsGrids.getGridTitle(grid));
            vm.window.center().open();
        };

        vm.dataItemSelected = function () {
            var grid = angular.element("#popupGrid").data("kendoGrid");
            var selectedItem = grid.dataItem(grid.select());
            if (selectedItem) {
                switch (vm.popupGridOptions.grid) {
                    case "prospectivePatient":
                        vm.leadCall.prospectivePatient = selectedItem;
                        //vm.leadCall.isOldPatient = true; // ECRM-264, removed
                        vm.toggle("prospectivePatient", "clear");
                        vm.toggle("attendant", "clear");
                        vm.setData(["prospectivePatient", "attendant"]);
                        break;
                    case "attendant":
                        vm.leadCall.prospectivePatient.attendant = selectedItem;
                        vm.prospectivePatient.attendant = selectedItem;
                        vm.setData(["attendant"]);
                        break;
                    case "oldPatient":
                        vm.leadCall.oldPatient = selectedItem;
                        vm.setData(["oldPatient"]);
                        break;
                    case "oldPatientDoctor":
                        vm.leadCall.oldPatientDoctor = selectedItem.customer;
                        vm.setData(["oldPatientDoctor"]);
                        break;
                }
            }
            vm.window.close();
        };

        vm.setData = function (model) {
            if( vm.leadCall.prospectivePatient && model.indexOf("prospectivePatient") !== -1 ) {
                if (vm.leadCall.prospectivePatient.lastName !== null && vm.leadCall.prospectivePatient.firstName !== null){
                    vm.leadCall.prospectivePatient.fullName = vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName;
                }else {
                    vm.leadCall.prospectivePatient.fullName = "";
                }
            }
            if( vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.attendant && model.indexOf("attendant") !== -1 ) {
                if (vm.leadCall.prospectivePatient.attendant.lastName !== null && vm.leadCall.prospectivePatient.attendant.firstName !== null){
                    vm.leadCall.prospectivePatient.attendant.fullName = vm.leadCall.prospectivePatient.attendant.lastName + " " + vm.leadCall.prospectivePatient.attendant.firstName;
                }else {
                    // Set empty space to Attendant.fullName because Attendant can have null first and last name.
                    vm.leadCall.prospectivePatient.attendant.fullName = " ";
                }
            }
            if( vm.leadCall.oldPatient && model.indexOf("oldPatient") !== -1 ) {
                if (vm.leadCall.oldPatient.lastName !== null && vm.leadCall.oldPatient.firstName !== null){
                    vm.leadCall.oldPatient.fullName = vm.leadCall.oldPatient.lastName + " " + vm.leadCall.oldPatient.firstName;
                }else {
                    vm.leadCall.oldPatient.fullName = "";
                }
            }
            if( vm.leadCall.oldPatientDoctor && model.indexOf("oldPatientDoctor") !== -1 ) {
                if (vm.leadCall.oldPatientDoctor.lastName !== null && vm.leadCall.oldPatientDoctor.firstName !== null){
                    vm.leadCall.oldPatientDoctor.fullName = vm.leadCall.oldPatientDoctor.lastName + " " + vm.leadCall.oldPatientDoctor.firstName;
                }else {
                    vm.leadCall.oldPatientDoctor.fullName = "";
                }
            }
        };

        vm.toggle = function(model, action) {
            if (!model) {
                model = vm.popupGridOptions.grid;
                vm.window.close();
            }
            //var date;
            switch (model) {
                case "prospectivePatient": // ProspectivePatient
                    vm.editProspectivePatientMode = action === "add" || action === "edit";
                    if ( action === "add" || action === "erase") {
                        if (vm.prospectivePatient.id === null || vm.prospectivePatient.id === undefined || vm.prospectivePatient.id === ''){
                            // Only reset prospectivePatient if he hasn't an id ECRM-281
                            vm.prospectivePatient = angular.copy(vm._prospectivePatient);
                        }
                    }
                    if ( action === "edit" ) { vm.prospectivePatient = vm.leadCall.prospectivePatient; }
                    if ( action === "erase" ) {
                        // for not loosing attendant obj when erase prospectivePatient
                        var pp = angular.copy(vm._prospectivePatient);
                        pp.attendant = vm.leadCall.prospectivePatient.attendant;
                        vm.leadCall.prospectivePatient = angular.copy(pp);
                    }
                    if ( action === "go") {
                        if (vm.prospectivePatient && vm.prospectivePatient.id > 0){
                            $state.go('prospectivePatientInfo', {id: vm.prospectivePatient.id});
                        }else if (vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.id > 0){
                            $state.go('prospectivePatientInfo', {id: vm.leadCall.prospectivePatient.id});
                        }
                    }
                    if ( action === "clear"){
                        vm.expandCollapseButtonLabel = "Περισσότερα Πεδία";
                        vm.expandCollapseIcon = 'expand_more';
                        vm.isExpanded = false;
                    }
                    break;
                case "attendant": // Attendant
                    vm.editAttendantMode = action === "add" || action === "edit";
                    if ( action === "add" || action === "erase" ) vm.attendant = angular.copy(vm._attendant);
                    if ( action === "edit" ) vm.attendant = vm.leadCall.prospectivePatient.attendant;
                    if ( action === "erase" ) { vm.leadCall.prospectivePatient.attendant = angular.copy(vm._attendant); }
                    if ( action === "clear"){
                        vm.expandCollapseButtonLabel_attendant = "Περισσότερα Πεδία";
                        vm.expandCollapseIcon_attendant = 'expand_more';
                        vm.isExpanded_attendant = false;
                    }
                    break;
                case "oldPatient": // Patient
                    vm.editOldPatientMode = action === "add" || action === "edit";
                    if ( action === "add" ) vm.oldPatient = angular.copy(vm._oldPatient);
                    if ( action === "edit" ) {
                        vm.oldPatient = vm.leadCall.oldPatient;
                    }
                    if ( action === "erase" ) vm.leadCall.oldPatient = angular.copy(vm._oldPatient);
                    break;
                case "oldPatientDoctor": // Customer
                    vm.editOldPatientDoctorMode = action === "add" || action === "edit";
                    if ( action === "add" || action === "erase" ) vm.oldPatientDoctor = angular.copy(vm._oldPatientDoctor);
                    if ( action === "edit" ) vm.oldPatientDoctor = vm.leadCall.oldPatientDoctor;
                    if ( action === "erase" ) vm.leadCall.oldPatientDoctor = angular.copy(vm._oldPatientDoctor);
                    break
            }
        };

        vm.toggleKeypad = function(keypad) {
            switch (keypad) {
                case "yearOfBirth":
                    vm.focusYearOfBirth = true;
                    if(vm.prospectivePatient.birthYear) {
                        vm.focusYearOfBirth = !(vm.prospectivePatient.birthYear.toString().length === 4);
                    }
                    vm.focusAge = false;
                    break;
                case "age":
                    vm.focusAge = true;
                    if(vm.prospectivePatient.age) {
                        vm.focusAge = !(vm.prospectivePatient.age.toString().length >= 2);
                    }
                    vm.focusYearOfBirth = false;
                    break;
                case "oldPatientYearOfBirth":
                    vm.oldPatientFocusYearOfBirth = true;
                    if(vm.oldPatient.yearOfBirth) {
                        vm.oldPatientFocusYearOfBirth = !(vm.oldPatient.yearOfBirth.toString().length === 4);
                    }
                    vm.oldPatientFocusAge = false;
                    break;
                case "oldPatientAge":
                    vm.oldPatientFocusAge = true;
                    if(vm.oldPatient.age) {
                        vm.oldPatientFocusAge = !(vm.oldPatient.age.toString().length >= 2);
                    }
                    vm.oldPatientFocusYearOfBirth = false;
                    break;
            }
        };

        vm.hideKeypadOnBlur = function(e, element) {
            switch (element) {
                case "yearOfBirth" :
                    vm.focusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.focusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "yearOfBirthKeypad";
                    break;
                case "age" :
                    vm.focusAge = false;
                    if (e.relatedTarget)
                        vm.focusAge = e.relatedTarget.parentNode.parentNode.id === "ageKeypad";
                    break;
                case "yearOfBirthKeypad" :
                    vm.focusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.focusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "yearOfBirth";
                    break;
                case "ageKeypad" :
                    vm.focusAge = false;
                    if (e.relatedTarget)
                        vm.focusAge = e.relatedTarget.parentNode.parentNode.id === "age";
                    break;
                case "oldPatientYearOfBirth":
                    vm.oldPatientFocusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.oldPatientFocusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "oldPatientYearOfBirthKeypad";
                    break;
                case "oldPatientAge":
                    vm.oldPatientFocusAge = false;
                    if (e.relatedTarget)
                        vm.oldPatientFocusAge = e.relatedTarget.parentNode.parentNode.id === "oldPatientAgeKeypad";
                    break;
                case "oldPatientYearOfBirthKeypad":
                    vm.oldPatientFocusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.oldPatientFocusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "oldPatientYearOfBirth";
                    break;
                case "oldPatientAgeKeypad":
                    vm.oldPatientFocusAge = false;
                    if (e.relatedTarget)
                        vm.oldPatientFocusAge = e.relatedTarget.parentNode.parentNode.id === "oldPatientAge";
                    break;
            }
        };

        vm.toggleSwitch = function(model, value){
            switch (model) {
                case "isOldPatientRelative":
                    if (!value) {
                        vm.oldPatient = angular.copy(vm._oldPatient);
                    }
                    break;
                case "isFirstEstimationDate":
                    if (!value){
                        vm.leadOffer.firstEstimationDate = null;
                    }else {
                        vm.leadOffer.firstEstimationDate = new Date();
                    }
                    break;
                case "hasRequestedDiscount":
                    if (!value) {
                        vm.leadDiscount.discountReason = {};
                    }
                    break;
                case "isEntitledToDiscount":
                    if (!value) {
                        vm.leadDiscount.entitledToReason = null;
                    }
                    break;
                case "wantsTransportation":
                    if (!value) {
                        vm.leadOffer.transportation = null;
                        vm.leadOffer.comments = "";
                    }
                    break;
                case "hasCompetitiveBid":
                    if (value) {
                        vm.leadOffer.competitor = {};
                    }
                    break;
                case "hasFinalDiscount":
                    if (!value){
                        vm.leadDiscount.finalDiscount = null;
                        vm.leadDiscount.finalReason = null;
                    }
                    break;
                case "hadSurgery":
                    if (!value){
                        vm.leadHospitalization.surgeryType = "";
                    }
                    break;
                case "bookedAppointment":
                    if (!value){
                        vm.appointmentDate = null;
                        vm.appointmentTime = null;
                    }
                    break;
            }
        };

        vm.tabHeaderClick = function (tab, ev) {
            showSaveDialog(tab, ev);
            switch (tab){
                case "tabLeadCall":
                    vm.showSaveButton = true;
                    vm.saveButtonLabel = "Αποθήκευση Κλήσης";
                    vm.showChargesTabButtons = false;
                    vm.showDiseasesTabButtons = false;
                    break;
                case "tabHospitalization":
                    vm.showSaveButton = true;
                    vm.saveButtonLabel = "Αποθήκευση Νοσηλείας";
                    vm.showChargesTabButtons = false;
                    vm.showDiseasesTabButtons = false;
                    break;
                case "tabCharges":
                    vm.showSaveButton = false;
                    vm.saveButtonLabel = "Αποθήκευση Κλήσης";
                    vm.showChargesTabButtons = true;
                    vm.showDiseasesTabButtons = false;
                    vm.leadOffer.invitationText === null ?
                        vm.leadOffer.invitationText = "Αξιότιμε κ. " + getFullNameForPdf() :
                        vm.leadOffer.invitationText;
                    break;
                case "tabDiseases":
                    vm.showSaveButton = false;
                    vm.saveButtonLabel = "Αποθήκευση Κλήσης";
                    vm.showChargesTabButtons = false;
                    vm.showDiseasesTabButtons = true;
                    break;
                case "tabFollowup":
                    vm.showSaveButton = false;
                    vm.saveButtonLabel = "Αποθήκευση Κλήσης";
                    vm.showChargesTabButtons = false;
                    vm.showDiseasesTabButtons = false;
                    KendoGrid.refresh(vm.followUpGridOptions);
                    break;
            }
        };

        vm.onRoomCostChange = function () {
            // Comment-out for ECRM-287
            /*if (vm.leadOffer.costType && vm.leadOffer.costType.id > 0 &&
                vm.leadOffer.roomType && vm.leadOffer.roomType.id > 0){
                var costTypeFilter = {
                    field: "costType.id",
                    operator: "eq",
                    value: vm.leadOffer.costType.id
                };
                var roomTypeFilter = {
                    field: "roomType.id",
                    operator: "eq",
                    value: vm.leadOffer.roomType.id
                };

                $http.get('/api/room-costs/search',
                    {params:{
                            page: "1",
                            pageSize: "1",
                            filter : { filters: [costTypeFilter, roomTypeFilter] }}})
                    .success(function (response) {
                        vm.roomCost = response.content[0];
                        // Trigger cost calculation with discount
                        vm.onFinalDiscountChange();
                    })
                    .error(function (error) {
                        console.log(error);
                    });
            }else {
                vm.roomCost = null;
            }*/
        };

        vm.onCostTypeChange = function () {
            ////////////// New ECRM-306 - 8 /////////////////////////
            var selectedCostType = vm.leadOffer.costType;
            if (selectedCostType.name && vm.hospitalizationTypes &&
                (selectedCostType.name.toUpperCase().includes("ΤΑΜΕΙΟ"))){
                for (var i=0; i<vm.hospitalizationTypes.length; i++){
                    if (vm.hospitalizationTypes[i].name && vm.hospitalizationTypes[i].name.toUpperCase().includes("ΕΟΠΥΥ")){
                        vm.leadHospitalization.hospitalizationType = vm.hospitalizationTypes[i];
                        break;
                    }
                }
            }
            /////////////////////////////////////////////////////////

            ////////////// Comment-out for ECRM-287 /////////////////
            /*var selectedCostType = vm.leadOffer.costType;
            // Filter RoomTypes by selected costType
            var costTypeFilter = {
                field: "costType.id",
                operator: "eq",
                value: selectedCostType.id
            };
            $http.get('/api/room-costs/search',
                {params:{
                        page: "1",
                        pageSize: "200",
                        filter : { filters: [costTypeFilter] }}})
                .success(function (response) {
                    vm.roomTypes = getRoomTypesFromRoomCosts(response.content);
                    vm.onRoomCostChange();
                })
                .error(function (error) {
                    console.log(error);
                });*/
            //////////////////////////////////////////////////////////
        };

        vm.onRoomTypeChange = function () {
            // Comment-out for ECRM-287
            //vm.onRoomCostChange();
        };

        vm.onFinalDiscountChange = function () {
            // Comment-out for ECRM-287
            /*if (vm.roomCost !== null && vm.leadDiscount.finalDiscount !== null && vm.leadDiscount.finalDiscount.id > 0){
                vm.roomCostWithDiscount = vm.roomCost.cost - ((vm.leadDiscount.finalDiscount.value / 100) * vm.roomCost.cost);
            }else {
                vm.roomCostWithDiscount = null;
            }*/
        };

        vm.onDiseaseChange = function(disease){
            if (disease.id === 9 && disease.selected === true){
                // Set CostType to id=3 and disable it
                vm.leadOffer.costType = vm.costTypes.find(function (element) {
                    return element.id === 3;
                });
                vm.onCostTypeChange();
                vm.disableCostType = true;
            }else {
                vm.disableCostType = false;
            }
        };

        vm.onHospitalizationTypeChange = function () {
            var selectedHospitalizationType = vm.leadHospitalization.hospitalizationType;
            if (selectedHospitalizationType.name && vm.costTypes &&
                (selectedHospitalizationType.name.toUpperCase().includes("ΕΟΠΥΥ"))){
                for (var i=0; i<vm.costTypes.length; i++){
                    if (vm.costTypes[i].name && vm.costTypes[i].name.toUpperCase().includes("ΤΑΜΕΙΟ")){
                        vm.leadOffer.costType = vm.costTypes[i];
                        break;
                    }
                }
            }
        };

        /**
         * Triggered when an addDiseaseItem has changed.
         * It shows addDiseaseOther text area below addDiseases list.
         * @param item The AddDisease object that changed.
         */
        vm.onAddDiseaseChange = function (item) {
            if (item.name && (item.name.toUpperCase().includes("ΑΛΛΟ") ||
                    item.name.toUpperCase().includes("ΆΛΛΟ") ||
                    item.name.toUpperCase().includes("'ΑΛΛΟ"))){
                if (item.selected){
                    vm.showAddDiseaseOther = true;
                }else {
                    vm.showAddDiseaseOther = false;
                    vm.leadHospitalization.addDiseaseOther = "";
                }
            }
        };

        vm.leadOfferRoomTypeChange = function (item) {
            if (item.selected === true){
                // give focus to input
                $timeout(function () {
                    angular.element("#roomTypePrice" + item.id).focus();
                }, 20);
            }else {
                item.price = '';
            }
        };

        vm.expandClick = function (which) {
            var p;
            switch (which){
                case "prospectivePatient":
                    p = $('#fieldsContainer');
                    if (vm.isExpanded === true){
                        // Collapse
                        p.css('height','170px');
                        vm.expandCollapseButtonLabel = "Περισσότερα Πεδία";
                        vm.expandCollapseIcon = 'expand_more';
                    }else {
                        // Expand
                        p.css('height','auto');
                        vm.expandCollapseButtonLabel = "Λιγότερα Πεδία";
                        vm.expandCollapseIcon = 'expand_less';
                    }
                    vm.isExpanded = !vm.isExpanded;
                    break;
                case "attendant":
                    p = $('#fieldsContainerAttendant');
                    if (vm.isExpanded_attendant === true){
                        // Collapse
                        p.css('height','280');
                        vm.expandCollapseButtonLabel_attendant = "Περισσότερα Πεδία";
                        vm.expandCollapseIcon_attendant = 'expand_more';
                    }else {
                        // Expand
                        p.css('height','auto');
                        vm.expandCollapseButtonLabel_attendant = "Λιγότερα Πεδία";
                        vm.expandCollapseIcon_attendant = 'expand_less';
                    }
                    vm.isExpanded_attendant = !vm.isExpanded_attendant;
                    break;
            }
        };

        vm.prospectivePatientAge = null;
        vm.prospectivePatientBirthYearOnChange = function(birthYear){
            if (birthYear != null && birthYear.length === 4 && new Date().getFullYear() >= birthYear){
                vm.prospectivePatientAge = (new Date().getFullYear() - birthYear).toString();
            }else {
                vm.prospectivePatientAge = null;
            }
        };
        vm.prospectivePatientAgeChange = function (age) {
            if (age === null || age.length === 0){
                vm.prospectivePatient.birthYear = null;
            }else if (age !== null && age < 130){
                vm.prospectivePatient.birthYear = new Date().getFullYear() - age;
            }else {
                vm.prospectivePatient.birthYear = null;
            }
        };
        vm.oldPatientAge = null;
        vm.oldPatientBirthYearOnChange = function(birthYear){
            if (birthYear != null && birthYear.length === 4 && new Date().getFullYear() >= birthYear){
                vm.oldPatientAge = (new Date().getFullYear() - birthYear).toString();
            }else {
                vm.oldPatientAge = null;
            }
        };

        /**
         * Create or Update a specific model.
         * ProspectivePatient and attendant cases not used! Check vm.updateProspectivePatientAndAttendant();
         * @param model
         */
        vm.update = function(model){
            switch (model) {
                case "prospectivePatient":
                    if (vm.prospectivePatientValidator.validate()){
                        // Assign Attendant if exists
                        if (vm.attendant && vm.attendant.id > 0){
                            vm.prospectivePatient.attendant.id = vm.attendant.id;
                        }else if (vm.leadCall.prospectivePatient.attendant && vm.leadCall.prospectivePatient.attendant.id > 0){
                            vm.prospectivePatient.attendant.id = vm.leadCall.prospectivePatient.attendant.id;
                        }
                        ProspectivePatient.update({}, vm.prospectivePatient,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Πιθανού Ασθενή");
                                vm.toggle("prospectivePatient", "clear");
                                vm.leadCall.prospectivePatient = result;
                                vm.setData(["prospectivePatient"]);
                                vm.setData(["attendant"]);
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Πιθανού Ασθενή!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Πιθανού Ασθενή!");
                    }
                    break;
                case "attendant":
                    if (vm.attendantValidator.validate()){
                        Attendant.update({}, vm.attendant,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Συνοδού");
                                vm.toggle("attendant", "clear");
                                //vm.prospectivePatient.attendant = result;
                                vm.leadCall.prospectivePatient.attendant = result;
                                vm.setData(["attendant"]);
                                // Also update ProspectivePatient if exists
                                if (vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.id > 0){
                                    vm.leadCall.prospectivePatient.attendant.id = result.id;
                                    ProspectivePatient.update({}, vm.leadCall.prospectivePatient,
                                        function (result) {
                                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Πιθανού Ασθενή με Συνοδό");
                                            //vm.toggle("prospectivePatient", "clear");
                                            vm.leadCall.prospectivePatient = result;
                                            vm.setData(["prospectivePatient"]);
                                            vm.setData(["attendant"]);
                                        },
                                        function () {
                                            KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την ενημέρωση του Πιθανού Ασθενή με Συνοδό!");
                                        });
                                }
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Συνοδού!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Συνοδού!");
                    }
                    break;
                case "oldPatient":
                    if (vm.oldPatientValidator.validate()){
                        Patient.update({}, vm.oldPatient,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Παλιού Ασθενή");
                                vm.toggle("oldPatient", "clear");
                                vm.leadCall.oldPatient = result;
                                vm.setData(["oldPatient"]);
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Πιθανού Ασθενή!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Παλιού Ασθενή!");
                    }
                    break;
                case "oldPatientDoctor":
                    if (vm.oldPatientDoctorValidator.validate()){
                        Customer.update({}, vm.oldPatientDoctor,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Επαγγελματία Υγείας");
                                vm.toggle("oldPatientDoctor", "clear");
                                vm.leadCall.oldPatientDoctor = result;
                                vm.setData(["oldPatientDoctor"]);
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Επαγγελματία Υγείας!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Επαγγελματία Υγείας!");
                    }
                    break;
                case "convertToPatient":
                    if (vm.leadCall.id === null || vm.leadCall.id === undefined ||
                        vm.leadCall.id === '' || !vm.leadCall.id > 0){
                        Alerts.showConfirmDialog(null, "Sigma SalesForce",
                            "Θα πρέπει να αποθηκέυσετε πρώτα τη Κλήση. Αποθήκευση τώρα?",
                            true, "ΝΑΙ", "OXI", function () {
                            vm.save(false);
                        }, function () {});
                    }else {
                        if (vm.prospectivePatient && vm.prospectivePatient.id > 0){
                            // First check if there is any Hospitalization with this selected leadCall.id
                            HospitalizationService.search({
                                page: 1, pageSize: 5,
                                filter: {
                                    filters: [
                                        {
                                            field: "leadCall.id",
                                            operator: "eq",
                                            value: vm.leadCall.id
                                        }
                                    ]
                                }
                            }).$promise.then(function(result){
                                if (result.length > 0){
                                    Alerts.showAlert("Sigma SalesForce",
                                        "Η συγκεκριμένη Κλήση #" + vm.leadCall.id + " έχει γίνει ήδη Εισαγωγή με ημερομηνία εισαγωγής " + result[0].dateIssue,
                                        "Ok");
                                }else {
                                    // There aren't any Hospitalizations with this leadCall.id, continue
                                    var cancel = false;
                                    var message = "";

                                    if (vm.prospectivePatient.firstName === null ||
                                        vm.prospectivePatient.firstName === '' ||
                                        vm.prospectivePatient.firstName === undefined){
                                        cancel = true;
                                        message = "Απαραίτητο πεδίο Όνομα";
                                    }

                                    if (vm.prospectivePatient.lastName === null ||
                                        vm.prospectivePatient.lastName === '' ||
                                        vm.prospectivePatient.lastName === undefined){
                                        cancel = true;
                                        message = "Απαραίτητο πεδίο Επώνυμο";
                                    }

                                    if (cancel){
                                        Alerts.showAlert("Sigma SalesForce", message, "Ok");
                                    }else {
                                        var patientForSave = {
                                            firstName: vm.prospectivePatient.firstName,
                                            lastName: vm.prospectivePatient.lastName,
                                            email: vm.prospectivePatient.email,
                                            yearOfBirth: vm.prospectivePatient.birthYear,
                                            phone: vm.prospectivePatient.phone,
                                            notes: vm.prospectivePatient.notes,
                                            prospectivePatient: {
                                                id: vm.prospectivePatient.id
                                            },
                                            amka: vm.prospectivePatient.amka
                                        };

                                        Patient.save(patientForSave, function (result) {
                                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής μετατροπή Πιθανού Ασθενή σε Ασθενή");
                                            vm.toggle("prospectivePatient", "clear");
                                            // Go to New Hospitalization with this Patient
                                            $timeout(function () {
                                                $state.go('hospitalizationView', {patientId: result.id,
                                                    leadCallId: vm.leadCall.id !== null && vm.leadCall.id > 0 ? vm.leadCall.id : null});
                                            }, 600);
                                        }, function (error) {
                                            console.log(error);
                                            if (error.data.message &&
                                                error.data.message.includes("Cannot save Patient with ProspectivePatient id that exists")){
                                                KendoNotifications.showErrorNotification(notification, "Ο Ασθενής υπάρχει ήδη! Μεταφορά στην Εισαγωγή...");
                                                $timeout(function () {
                                                    // error.data.params[0]: contains PatientId
                                                    $state.go('hospitalizationView', {patientId: error.data.params[0] !== null && error.data.params[0] !== undefined ? error.data.params[0] : null,
                                                        leadCallId: vm.leadCall.id != null && vm.leadCall.id > 0 ? vm.leadCall.id : null});
                                                }, 600);
                                            }else {
                                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την μετατροπή Πιθανού Ασθενή σε Ασθενή!");
                                            }
                                        });
                                    }
                                }
                            });
                        }else {
                            Alerts.showAlert("Sigma SalesForce", "Θα πρέπει να έχει καταχωρηθεί πρώτα ο Πιθανός Ασθενής", "Ok");
                        }
                    }
                    break;
            }
        };

        /**
         * Updates or creates Attendant and ProspectivePatient
         */
        vm.updateProspectivePatientAndAttendant = function () {
            if (LeadCallHelper.hasAttendant(vm.attendant)){
                if (LeadCallHelper.hasProspectivePatient(vm.prospectivePatient)){
                    // Save Attendant then save ProspectivePatient
                    //console.log("Save Attendant then save ProspectivePatient");
                    if (vm.validator.validate()){
                        if (vm.validator.validate()){
                            Attendant.update({}, vm.attendant,
                                function (result) {
                                    KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Συνοδού");
                                    if (vm.leadCall.prospectivePatient) {
                                        vm.leadCall.prospectivePatient.attendant = result;
                                    }
                                    vm.prospectivePatient.attendant = result;
                                    vm.attendant = result;
                                    vm.toggle("attendant", "clear");
                                    vm.setData(["attendant"]);
                                    ProspectivePatient.update({}, vm.prospectivePatient,
                                        function (result) {
                                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Πιθανού Ασθενή με Συνοδό");
                                            vm.leadCall.prospectivePatient = result;
                                            vm.prospectivePatient = result;
                                            vm.toggle("prospectivePatient", "clear");
                                            vm.setData(["prospectivePatient", "attendant"]);
                                        },
                                        function () {
                                            KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Πιθανού Ασθενή με Συνοδό!");
                                        });
                                },
                                function () {
                                    KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Συνοδού!");
                                });
                        }else {
                            KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Πιθανού Ασθενή!");
                            document.getElementById("prospectivePatient").scrollIntoView();
                        }
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Συνοδού!");
                        document.getElementById("attendant").scrollIntoView();
                    }
                }else {
                    // Save Attendant then save an empty ProspectivePatient
                    //console.log("Save Attendant then save an empty ProspectivePatient");
                    if (vm.validator.validate()){
                        Attendant.update({}, vm.attendant,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Συνοδού");
                                if (vm.leadCall.prospectivePatient.attendant){
                                    vm.leadCall.prospectivePatient.attendant = result;
                                }
                                vm.prospectivePatient.attendant = result;
                                vm.attendant = result;
                                vm.toggle("attendant", "clear");
                                vm.setData(["attendant"]);
                                ProspectivePatient.update({}, vm.prospectivePatient,
                                    function (result) {
                                        KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Πιθανού Ασθενή με Συνοδό");
                                        vm.leadCall.prospectivePatient = result;
                                        vm.prospectivePatient = result;
                                        vm.toggle("prospectivePatient", "clear");
                                        vm.setData(["prospectivePatient", "attendant"]);
                                    },
                                    function () {
                                        KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Πιθανού Ασθενή με Συνοδό!");
                                    });
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Συνοδού!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Συνοδού!");
                        document.getElementById("attendant").scrollIntoView();
                    }
                }
            }else {
                if (LeadCallHelper.hasProspectivePatient(vm.prospectivePatient)){
                    //console.log("Save ProspectivePatient ONLY!!");
                    // Save ProspectivePatient ONLY!!
                    if (vm.validator.validate()){
                        ProspectivePatient.update({}, vm.prospectivePatient,
                            function (result) {
                                KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Πιθανού Ασθενή με Συνοδό");
                                vm.leadCall.prospectivePatient = result;
                                vm.prospectivePatient = result;
                                vm.toggle("prospectivePatient", "clear");
                                vm.setData(["prospectivePatient", "attendant"]);
                            },
                            function () {
                                KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση του Πιθανού Ασθενή με Συνοδό!");
                            });
                    }else {
                        KendoNotifications.showErrorNotification(notification, "Ελέγξτε τα στοιχεία του Πιθανού Ασθενή!");
                        document.getElementById("prospectivePatient").scrollIntoView();
                    }
                }else {
                    // Show message
                    Alerts.showAlert("Sigma SalesForce",
                        "Θα πρέπει να συμπληρώσετε κάποια βασικά στοιχεία για τουλάχιστον ένα πρόσωπο (Πιθανός Ασθενής / Συνοδός).",
                        "Ok");
                }
            }
        };

        /**
         * Save LeadCall with LeadHospitalization
         * @param exit Boolean that indicates to exit screen after successful save
         */
        vm.save = function(exit){
            var cancel = false;
            var message = "";

            if (vm.startDate === null || vm.startDate === '' || vm.startDate === undefined ||
                vm.startTime === null || vm.startTime === '' || vm.startTime === undefined){
                cancel = true;
                message = "Θα πρέπει να επιλέξετε Ημερομηνία και Ώρα!";
            }

            if (vm.leadCall.callType === null || vm.leadCall.callType === '' || vm.leadCall.callType === undefined){
                cancel = true;
                message = "Θα πρέπει να επιλέξετε Τύπο Κλήσης!"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "Ok");
            }else {
                if (LeadCallHelper.hasLeadHospitalization(vm._leadHospitalization, vm.leadHospitalization)){
                    vm.leadHospitalization.addDiseases = getSelectedAddDiseases();
                    vm.leadHospitalization.addConditions = getSelectedAddConditions();
                    vm.leadCall.leadHospitalizations[0] = vm.leadHospitalization;
                }

                vm.leadCall.dateTime = CustomDateUtils.getDateTime(vm.startDate, vm.startTime);
                if (vm.appointmentDate !== null && vm.appointmentDate !== '' && vm.appointmentDate !== undefined &&
                    vm.appointmentTime !== null && vm.appointmentTime !== '' && vm.appointmentTime !== undefined){
                    vm.leadCall.appointmentDate = CustomDateUtils.getDateTime(vm.appointmentDate, vm.appointmentTime);
                }else {
                    vm.leadCall.appointmentDate = null;
                }

                vm.leadCall = LeadCallHelper.prepareLeadCall(vm.leadCall);
                $http.post('/api/lead-calls/full', vm.leadCall)
                    .success(function (response) {
                        console.log("Success Save LeadCall!");
                        KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Κλήσης");
                        vm.leadCall = response;
                        vm.leadOffer.leadCall = vm.leadCall;
                        vm.leadCall.callType = vm.callTypes.find(function (callType) {return vm.leadCall.callType.id === callType.id;});
                        vm.setData(["prospectivePatient", "attendant", "oldPatient", "oldPatientDoctor"]);
                        //vm.copied_leadCall = angular.copy(vm.leadCall);
                        $scope.leadCallForm.$setPristine();
                        //vm.copied_leadHospitalization = angular.copy(vm.leadCall.leadHospitalizations[0]);
                        $scope.leadHospitalizationForm.$setPristine();
                        vm.title = 'Επεξεργασία Κλήσης';
                        if (exit){
                            //$state.go('leadCalls');
                            history.back();
                        }
                    })
                    .error(function (error) {
                        console.log("Error Save LeadCall!");
                        console.log(error);
                        KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση Κλήσης!");
                    });
            }
        };

        /**
         * Save LeadOffer with LeadDiscount
         */
        vm.saveLeadOffer = function () {
            if (LeadCallHelper.hasLeadOffer(vm._leadOffer, vm.leadOffer)){
                var cancel = false;
                var message = "";

                if (vm.leadOffer.leadCall === null || vm.leadOffer.leadCall === undefined ||
                    vm.leadOffer.leadCall.id === null || vm.leadOffer.leadCall.id === undefined){
                    cancel = true;
                    message = "Θα πρέπει ανατεθεί Κλήση στη Προσφορά!"
                }

                if (cancel){
                    Alerts.showAlert("Sigma SalesForce", message, "Ok");
                }else {
                    if (LeadCallHelper.hasLeadDiscount(vm._leadDiscount, vm.leadDiscount)){
                        vm.leadOffer.leadDiscount = vm.leadDiscount;
                    }

                    vm.leadOfferDTO = {
                        leadOffer: vm.leadOffer,
                        leadOfferRoomTypes: getSelectedLeadOfferRoomTypes()
                    };
                    $http.post('/api/lead-offers/full', vm.leadOfferDTO)
                        .success(function (response) {
                            console.log("Success Save LeadOffer!");
                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Χρέωσης");
                            vm.leadOffer = response.leadOffer;
                            vm.hasFinalDiscount = (vm.leadOffer.leadDiscount && vm.leadOffer.leadDiscount.finalDiscount && vm.leadOffer.leadDiscount.finalDiscount.id > 0) ||
                                (vm.leadOffer.leadDiscount && vm.leadOffer.leadDiscount.finalReason && vm.leadOffer.leadDiscount.finalReason.id > 0);
                            $scope.chargesForm.$setPristine();
                        })
                        .error(function (error) {
                            console.log("Error Save LeadOffer!");
                            console.log(error);
                            KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση Προσφοράς!");
                        });
                }
            }else {
                $scope.chargesForm.$setPristine();
                Alerts.showAlert("Sigma SalesForce", "Δεν έχετε επιλέξει στοιχεία Προσφοράς!", "Ok");
            }
        };

        /**
         * Save LeadHospitalization Diseases
         */
        vm.saveDiseases = function () {
            var newDiseases = getSelectedDiseases();
            if (LeadCallHelper.hasModifyDiseases(vm.leadHospitalizationDiseases, newDiseases)){
                var cancel = false;
                var message = "";

                if (vm.leadCall.leadHospitalizations[0] === null || vm.leadCall.leadHospitalizations[0] === undefined ||
                    vm.leadCall.leadHospitalizations[0].id === null || vm.leadCall.leadHospitalizations[0].id === undefined){
                    cancel = true;
                    message = "Θα πρέπει υπάρχει Νοσηλεία για να αποθηκεύσετε Ασθένειες!"
                }

                if (cancel){
                    Alerts.showAlert("Sigma SalesForce", message, "Ok");
                }else {
                    var leadHospitalizationDiseases = [];
                    for (var i=0; i < newDiseases.length; i++){
                        var leadHospitalizationDisease = {};
                        leadHospitalizationDisease.comments = null;
                        leadHospitalizationDisease.disease = newDiseases[i];
                        leadHospitalizationDisease.leadHospitalization = vm.leadCall.leadHospitalizations[0];
                        leadHospitalizationDiseases.push(leadHospitalizationDisease);
                    }

                    $http.post('/api/lead-hospitalization/' + vm.leadCall.leadHospitalizations[0].id + '/diseases/all', leadHospitalizationDiseases)
                        .success(function (response) {
                            console.log("Success Save LeadHospitalizationDiseases!");
                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής καταχώρηση Ασθενειών");
                            vm.leadHospitalizationDiseases = response;
                            $scope.diseasesForm.$setPristine();
                        })
                        .error(function (error) {
                            console.log("Error Save LeadHospitalizationDiseases!");
                            console.log(error);
                            KendoNotifications.showErrorNotification(notification, "Κάποιο σφάλμα προέκυψε κατά την καταχώρηση Ασθενειών!");
                        });
                }
            }else {
                Alerts.showAlert("Sigma SalesForce", "Δεν υπάρχει κάποια αλλαγή στις Ασθένεις!", "Ok");
                $scope.diseasesForm.$setPristine();
            }
        };

        /**
         * Creates an Offer object, passes it to pdfBuilder
         * and opens the pdf in new tab
         */
        vm.printOffer = function (ev) {
            var object = {
                pdfPronouncement: vm.leadOffer.invitationText,
                date: new Date(),
                fullName: getFullNameForPdf()
            };
            if (vm.leadOffer.attendantMeal){
                object.attendantMealPrice = 15;
            }
            if (vm.leadOffer.transportation && vm.leadOffer.transportation.id > 0){
                object.transportation = vm.leadOffer.transportation;
            }
            if (vm.roomCost != null && vm.roomCost.id > 0){
                object.roomCost = vm.roomCost;
            }
            if (vm.leadDiscount.finalDiscount != null && vm.leadDiscount.finalDiscount.id > 0){
                object.finalDiscount = vm.leadDiscount.finalDiscount;
            }

            if (isDiseaseSelected(9)){
                // relief_treatment.pdf
                PDFPdfBuilder.makeReliefTherapyOfferWithImages(object)
            }else {
                if (vm.leadOffer.costType !== null &&
                    vm.leadOffer.costType !== undefined &&
                    vm.leadOffer.costType.id > 0 &&
                    vm.leadOffer.costType.name !== null &&
                    vm.leadOffer.costType.name !== undefined){
                    if ((vm.leadOffer.costType.name.toUpperCase().includes("ΤΑΜΕΙΟ")) ||
                        (vm.leadOffer.costType.name.toUpperCase().includes("ΤΑΜΕΊΟ"))){
                        // fund_hospitalization.pdf
                        PDFPdfBuilder.makeFundOfferWithImages(object);
                    }else if ((vm.leadOffer.costType.name.toUpperCase().includes("ΙΔΙΩΤΙΚΑ")) ||
                        (vm.leadOffer.costType.name.toUpperCase().includes("ΙΔΙΩΤΙΚΆ"))){
                        // private_hospitalization.pdf
                        PDFPdfBuilder.makePrivateOfferWithImages(object);
                    }else {
                        Alerts.showAlert("Sigma SalesForce", "Δεν έχει επιλεχθεί το σωστό Κόστος για εκτύπωση!", "Ok");
                    }
                }else {
                    Alerts.showAlert("Sigma SalesForce", "Δεν έχει επιλεχθεί το σωστό Κόστος για εκτύπωση!", "Ok");
                }
            }
        };

        vm.shareWithEmail = function () {
            var receivers = '';
            var subject = 'Απαραίτητες Πληροφορίες και Παροχές';
            var body = vm.leadOffer.invitationText;
            const LINEBREAK = '%0D%0A';

            if (vm.leadCall.prospectivePatient &&
                vm.leadCall.prospectivePatient.attendant &&
                vm.leadCall.prospectivePatient.attendant.email){
                receivers += vm.leadCall.prospectivePatient.attendant.email + ";";
                //subject = 'Προσφορά για ' + vm.leadCall.prospectivePatient.attendant.lastName + " " + vm.leadCall.prospectivePatient.attendant.firstName;
                //body += 'Αξιότιμη / Αξιότιμε κ. ' + vm.leadCall.prospectivePatient.attendant.lastName + " " + vm.leadCall.prospectivePatient.attendant.firstName + LINEBREAK;
                //body += vm.leadOffer.invitationText;
            }else if (vm.prospectivePatient &&
                vm.prospectivePatient.attendant &&
                vm.prospectivePatient.attendant.email){
                receivers += vm.prospectivePatient.attendant.email + ";";
                //subject = 'Προσφορά για ' + vm.prospectivePatient.attendant.lastName + " " + vm.prospectivePatient.attendant.firstName;
                //body += 'Αξιότιμη / Αξιότιμε κ. ' + vm.prospectivePatient.attendant.lastName + " " + vm.prospectivePatient.attendant.firstName + LINEBREAK;
                //body += vm.leadOffer.invitationText;
            }

            if (receivers === ''){
                // if there isn't Attendant's email, set ProspectivePatient's
                if (vm.leadCall.prospectivePatient &&
                    vm.leadCall.prospectivePatient.email){
                    receivers += vm.leadCall.prospectivePatient.email + ";";
                    //subject = 'Προσφορά για ' + vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName;
                    //body += 'Αξιότιμη / Αξιότιμε κ. ' + vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName + LINEBREAK;
                    //body += vm.leadOffer.invitationText;
                }else if (vm.prospectivePatient && vm.prospectivePatient.email){
                    receivers += vm.prospectivePatient.email + ";";
                    //subject = 'Προσφορά για ' + vm.prospectivePatient.lastName + " " + vm.prospectivePatient.firstName;
                    //body += 'Αξιότιμη / Αξιότιμε κ. ' + vm.prospectivePatient.attendant.lastName + " " + vm.prospectivePatient.attendant.firstName + LINEBREAK;
                    //body += vm.leadOffer.invitationText;
                }
            }

            body += LINEBREAK + 'Σας αποστέλλουμε όλες τις απαραίτητες πληροφορίες που αφορούν την εισαγωγή στο Κέντρο μας.' + LINEBREAK;
            body += 'Παραμένουμε στη διάθεση σας.' + LINEBREAK;
            body += 'Με εκτίμηση,' + LINEBREAK;
            //body += LINEBREAK + 'Υποδοχή  - Γραφείο Κίνησης' + LINEBREAK;
            //body += 'Ασθενών Κλειστής Νοσηλείας';

            if (receivers === ''){
                // If neither Attendant's / ProspectivePatient's exist..
                //subject = 'Προσφορά';
                //body = 'Αξιότιμη / Αξιότιμε κ.' + LINEBREAK;
                body = vm.leadOffer.invitationText + LINEBREAK;
                body += LINEBREAK + 'Σας αποστέλλουμε όλες τις απαραίτητες πληροφορίες που αφορούν την εισαγωγή στο Κέντρο μας.' + LINEBREAK;
                body += 'Παραμένουμε στη διάθεση σας.' + LINEBREAK;
                body += 'Με εκτίμηση,' + LINEBREAK;
                //body += LINEBREAK + 'Υποδοχή  - Γραφείο Κίνησης' + LINEBREAK;
                //body += 'Ασθενών Κλειστής Νοσηλείας';
                window.location.href = "mailto:" + '?subject=' + subject + '&body=' + body;
                return;
            }

            window.location.href = 'mailto:' + receivers + '?subject=' + subject + '&body=' + body;
        };

        // Adds boolean 'selected' attribute to each element of vm.addDiseases array
        function setupAddDiseases(){
            if (vm.addDiseases !== null && vm.addDiseases.length > 0){
                for (var i=0; i < vm.addDiseases.length; i++){
                    vm.addDiseases[i].selected = false;
                }
            }
        }

        // Adds boolean 'selected' attribute to each element of vm.addConditions array
        function setupAddConditions() {
            if (vm.addConditions !== null && vm.addConditions.length > 0){
                for (var i=0; i < vm.addConditions.length; i++){
                    vm.addConditions[i].selected = false;
                }
            }
        }

        // Adds boolean 'selected' and 'price' attribute to each element of vm.roomTypes array
        function setupRoomTypes(){
            if (vm.roomTypes !== null && vm.roomTypes.length > 0){
                for (var i=0; i < vm.roomTypes.length; i++){
                    vm.roomTypes[i].selected = false;
                    vm.roomTypes[i].price = '';
                }
            }
        }

        /**
         * Adds a diseases array inside every diseaseType item (need it for ui) if disease has the specific diseaseType.
         * Adds boolean selected attribute in every disease element of vm.diseaseType.diseases
         */
        function setupDiseasesWithTypes(){
            if (vm.diseaseTypes != null && vm.diseaseTypes.length > 0){
                for (var i=0; i < vm.diseaseTypes.length; i++){
                    vm.diseaseTypes[i].diseases = [];
                    //vm.diseaseTypes[i].selected = false;
                    if (vm.diseases != null && vm.diseases.length > 0){
                        for (var j=0; j < vm.diseases.length; j++){
                            vm.diseases[j].selected = false;
                            if (vm.diseases[j].diseaseType && vm.diseaseTypes[i].id === vm.diseases[j].diseaseType.id){
                                vm.diseaseTypes[i].diseases.push(vm.diseases[j]);
                            }
                        }
                    }
                }
            }
        }

        // Binds leadHospitalization's selected addDiseases into ui
        function setAddDiseases(){
            if (vm.leadHospitalization.addDiseases != null &&
                vm.leadHospitalization.addDiseases.length > 0){
                for (var i=0; i < vm.leadHospitalization.addDiseases.length; i++){
                    for (var j=0; j < vm.addDiseases.length; j++){
                        if (vm.leadHospitalization.addDiseases[i].id === vm.addDiseases[j].id){
                            vm.addDiseases[j].selected = true;
                            // This to show showAddDiseaseOther field on edit
                            if (vm.addDiseases[j].name && (vm.addDiseases[j].name.toUpperCase().includes("ΑΛΛΟ") ||
                                    vm.addDiseases[j].name.toUpperCase().includes("ΆΛΛΟ") ||
                                    vm.addDiseases[j].name.toUpperCase().includes("ΑΛΛΟ"))){
                                vm.showAddDiseaseOther = vm.addDiseases[j].selected;
                            }
                        }
                    }
                }
            }
        }

        // Binds leadHospitalization's selected addConditions into ui
        function setAddConditions() {
            if (vm.leadHospitalization.addConditions != null &&
                vm.leadHospitalization.addConditions.length > 0){
                for (var i=0; i < vm.leadHospitalization.addConditions.length; i++){
                    for (var j=0; j < vm.addConditions.length; j++){
                        if (vm.leadHospitalization.addConditions[i].id === vm.addConditions[j].id){
                            vm.addConditions[j].selected = true;
                        }
                    }
                }
            }
        }

        // Binds leadHospitalizationDiseases into ui
        function setDiseases() {
            if (vm.leadHospitalizationDiseases != null && vm.leadHospitalizationDiseases.length > 0){
                for (var i=0; i < vm.leadHospitalizationDiseases.length; i++){
                    for (var j=0; j < vm.diseases.length; j++){
                        if (vm.leadHospitalizationDiseases[i].disease.id === vm.diseases[j].id){
                            vm.diseases[j].selected = true;
                        }
                    }
                }
            }
        }

        // Binds leadOffer's selected roomTypes into ui
        function setRoomTypes(){
            if (vm.leadOfferRoomTypes !== null && vm.leadOfferRoomTypes.length > 0 &&
                vm.roomTypes !== null && vm.roomTypes.length > 0){
                for (var i=0; i < vm.leadOfferRoomTypes.length; i++){
                    for (var j=0; j < vm.roomTypes.length; j++){
                        if (vm.leadOfferRoomTypes[i].roomType.id === vm.roomTypes[j].id){
                            vm.roomTypes[j].selected = true;
                            vm.roomTypes[j].price = vm.leadOfferRoomTypes[i].discussedPrice;
                        }
                    }
                }
            }
        }

        // Get selected addDiseases
        function getSelectedAddDiseases(){
            var selectedAddDiseases = [];
            for (var i=0; i < vm.addDiseases.length; i++){
                if (vm.addDiseases[i].selected){
                    selectedAddDiseases.push(vm.addDiseases[i]);
                }
            }

            return selectedAddDiseases;
        }

        // Get selected addConditions
        function getSelectedAddConditions(){
            var selectedAddConditions = [];
            for (var i=0; i < vm.addConditions.length; i++){
                if (vm.addConditions[i].selected){
                    selectedAddConditions.push(vm.addConditions[i]);
                }
            }

            return selectedAddConditions;
        }

        // Get selected diseases
        function getSelectedDiseases(){
            var selectedDiseases = [];
            for (var i=0; i < vm.diseaseTypes.length; i++){
                for (var j=0; j < vm.diseaseTypes[i].diseases.length; j++){
                    if (vm.diseaseTypes[i].diseases[j].selected){
                        selectedDiseases.push(vm.diseaseTypes[i].diseases[j]);
                    }
                }
            }

            return selectedDiseases;
        }

        // Get selected LeadOfferRoomTypes
        function getSelectedLeadOfferRoomTypes(){
            var selectedLeadOfferRoomTypes = [];
            for (var i=0; i < vm.roomTypes.length; i++){
                if (vm.roomTypes[i].selected === true){
                    selectedLeadOfferRoomTypes.push({
                        leadOffer: vm.leadOffer,
                        roomType: vm.roomTypes[i],
                        discussedPrice: vm.roomTypes[i].price
                    });
                }
            }

            return selectedLeadOfferRoomTypes;
        }

        /**
         * Shows a dialog for saving LeadCall / LeadHospitalization / LeadOffer / LeadDiscount / addedDiseases.
         * Dialog will be displayed when switching from tab 'tabHospitalization' or tab 'tabLeadCall' to any other tab.
         * Also dialog will be displayed when switching from tab 'tabCharges' or 'tabDiseases' or 'tabFollowup' to any other tab.
         * @param currentTab The tab that user is about to go
         * @param ev Click event for mdDialog
         */
        function showSaveDialog(currentTab, ev) {
            if (currentTab !== previousTab){
                var msg = "Έχει πραγματοποιηθεί αλλαγή σε ";
                if (previousTab === "tabLeadCall" || previousTab === "tabHospitalization"){
                    if (currentTab !== "tabLeadCall" && currentTab !== "tabHospitalization"){
                        if ($scope.leadCallForm.$dirty === true || $scope.leadHospitalizationForm.$dirty === true){
                            if ($scope.leadCallForm.$dirty === true && $scope.leadHospitalizationForm.$dirty){
                                msg += "Κλήση και Νοσηλεία";
                            }else if ($scope.leadCallForm.$dirty === true) {
                                msg += "Κλήση";
                            }else if ($scope.leadHospitalizationForm.$dirty === true){
                                msg += "Νοσηλεία";
                            }
                            msg += ". Αποθήκευση?";
                            Alerts.showConfirmDialog(ev, "Sigma SalesForce", msg, true, "ΝΑΙ", "OXI", function () {
                                vm.save(false);
                            }, function () {});
                        }
                    }
                }else if (previousTab === "tabDiseases"){
                    if ($scope.diseasesForm.$dirty === true){
                        msg += "Ιατρικό Ιστορικό. Αποθήκευση?";
                        Alerts.showConfirmDialog(ev, "Sigma SalesForce", msg, true, "ΝΑΙ", "OXI", function () {
                            vm.saveDiseases();
                        }, function () {});
                    }
                }else if (previousTab === "tabCharges"){
                    if ($scope.chargesForm.$dirty === true){
                        msg += "Χρεώσεις. Αποθήκευση?";
                        Alerts.showConfirmDialog(ev, "Sigma SalesForce", msg, true, "ΝΑΙ", "OXI", function () {
                            vm.saveLeadOffer();
                        }, function () {});
                    }
                }

                previousTab = currentTab;
            }

            // This was with custom equals
            /*if (currentTab === "tabCharges" || currentTab === "tabDiseases" || currentTab === "tabFollowup"){
                if (previousTab === "tabHospitalization" || previousTab === "tabLeadCall"){
                    var hasTouchLeadCall = $scope.leadCallForm.$dirty; //!LeadCallHelper.equalsLeadCall(vm.copied_leadCall, vm.leadCall);
                    var hasTouchLeadHospitalization = $scope.leadHospitalizationForm.$dirty; //!LeadCallHelper.equalsLeadHospitalization(vm.copied_leadHospitalization, vm.leadHospitalization);
                    // console.log("LeadCall hasChanged: " + hasTouchLeadCall);
                    // console.log("LeadHospitalization hasChanged: " + hasTouchLeadHospitalization);
                    if (hasTouchLeadCall || hasTouchLeadHospitalization){
                        var msg = "Έχει πραγματοποιηθεί αλλαγή σε ";
                        if (hasTouchLeadCall && hasTouchLeadHospitalization){
                            msg += "Κλήση και Νοσηλεία";
                        }else if (hasTouchLeadCall) {
                            msg += "Κλήση";
                        }else if (hasTouchLeadHospitalization){
                            msg += "Νοσηλεία";
                        }
                        msg += ". Αποθήκευση?";
                        Alerts.showConfirmDialog(ev, "Sigma SalesForce", msg, true, "ΝΑΙ", "OXI", function () {
                            vm.save(false);
                        }, function () {});
                    }
                }
            }*/
        }

        /**
         * Checks if a specific disease is selected in diseasesTab, by Disease.id
         * @param diseaseId The disease id to check
         * @returns {boolean} True if it is selected, false if not
         */
        function isDiseaseSelected(diseaseId) {
            var is = false;
            var selectedDiseases = getSelectedDiseases();
            if (selectedDiseases !== null && selectedDiseases !== undefined && selectedDiseases.length > 0){
                for (var i=0; i < selectedDiseases.length; i++){
                    if (selectedDiseases[i].id === diseaseId){
                        is = true;
                        break;
                    }
                }
            }

            return is;
        }

        function getRoomTypesFromRoomCosts(roomCosts){
            var roomTypes = [];

            if (roomCosts !== null && roomCosts !== undefined && roomCosts.length > 0){
                for (var i=0; i<roomCosts.length; i++){
                    roomTypes.push(roomCosts[i].roomType);
                }
            }

            return roomTypes;
        }

        function openPDF(uri){
            var link = angular.element('<a href="' + uri + '" target="_blank"></a>');
            angular.element(document.body).append(link);
            link[0].click();
            link.remove();
        }

        function openPDFinNewTab(dataUri){
            //var string = document.output(dataUri);
            var iframe = "<iframe width='100%' height='100%' src='" + dataUri + "'></iframe>"
            var x = window.open();
            x.document.open();
            x.document.write(iframe);
            x.document.close();
        }

        function getFullNameForPdf(){
            var fullName = "";
            if (vm.leadCall.prospectivePatient !== null){
                if (vm.leadCall.prospectivePatient.attendant !== null &&
                    vm.leadCall.prospectivePatient.attendant.lastName &&
                    vm.leadCall.prospectivePatient.attendant.firstName){
                    // Get Attendant's
                    fullName = vm.leadCall.prospectivePatient.attendant.lastName + " " +
                        vm.leadCall.prospectivePatient.attendant.firstName;
                }else {
                    // Get ProspectivePatient's
                    fullName = vm.leadCall.prospectivePatient.lastName + " " + vm.leadCall.prospectivePatient.firstName;
                }
            }

            return fullName;
        }

        if (!$stateParams.id){
            //vm.toggle('prospectivePatient', 'add');
            vm.editProspectivePatientMode = true;
            vm.editAttendantMode = true;
        }

        /**
         * This fixes verticalDivider height since verticalDivider
         * is inside scrollable container (need to be inside timeout)
         */
        $timeout(function(){
            vm.chargesFormContentScrollHeight = angular.element("#chargesForm")[0].scrollHeight - 20;
            vm.leadHospitalizationContentScrollHeight = angular.element("#leadHospitalizationForm")[0].scrollHeight - 20;
        }, 10);
    }
})();
;
/**
 * Created by Teo on 02/05/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCalls', {
                parent: 'app',
                url: '/leadCalls',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.global.menu.lead-management.lead-calls'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/leadCalls/leadCalls.html',
                        controller: 'LeadCallsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('leadCallView', {
                parent: 'app',
                url: '/leadCalls/search?id:leadCallId',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.leadCall.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/leadCalls/leadCallsView.html',
                        controller: 'LeadCallsViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    professions: ['Profession', function (Profession) {
                        return Profession.query({page: 0, size: 200}).$promise;
                    }],
                    relationshipTypes: ['RelationshipType', function (RelationshipType) {
                        return RelationshipType.query({page: 0, size: 200}).$promise;
                    }],
                    nativeLanguages: ['NativeLanguage', function (NativeLanguage) {
                        return NativeLanguage.query({page: 0, size: 200}).$promise;
                    }],
                    callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],
                    hospitalizationTypes: ['HospitalizationType', function (HospitalizationType) {
                        return HospitalizationType.query({page: 0, size: 200}).$promise;
                    }],
                    costTypes: ['CostType', function (CostType) {
                        return CostType.query({page: 0, size: 200}).$promise;
                    }],
                    roomTypes: ['RoomType', function (RoomType) {
                        return RoomType.query({page: 0, size: 200}).$promise;
                    }],
                    transportations: ['Transportation', function (Transportation) {
                        return Transportation.query({page: 0, size: 200}).$promise;
                    }],
                    discountReasons: ['DiscountReason', function (DiscountReason) {
                        return DiscountReason.query({page: 0, size: 200}).$promise;
                    }],
                    discountRates: ['DiscountRate', function (DiscountRate) {
                        return DiscountRate.query({page: 0, size: 200}).$promise;
                    }],
                    competitors: ['Competitor', function (Competitor) {
                        return Competitor.query({page: 0, size: 200}).$promise;
                    }],
                    addDiseases: ['AddDisease', function (AddDisease) {
                        return AddDisease.query({page: 0, size: 200}).$promise;
                    }],
                    addConditions: ['AddCondition', function (AddCondition) {
                        return AddCondition.query({page: 0, size: 200}).$promise;
                    }],
                    diseaseTypes: ['DiseaseTypeService', function (DiseaseTypeService) {
                        return DiseaseTypeService.search({
                            sort: {
                                "field": "sortOrder",
                                "dir": "asc"
                            },
                            page: 1,
                            pageSize: 200
                            // you can add filters here
                        }).$promise;
                    }],
                    diseases: ['Disease', function (Disease) {
                        return Disease.query({page: 0, size: 200}).$promise;
                    }],
                    offerStatuses: ['OfferStatus', function (OfferStatus) {
                        return OfferStatus.query({page: 0, size: 200}).$promise;
                    }],
                    communicationStatuses: ['CommunicationStatus', function (CommunicationStatus) {
                        return CommunicationStatus.query({page: 0, size: 200}).$promise;
                    }],
                    countryPhoneCodes: ['CountryPhoneCode', function (CountryPhoneCode) {
                        return CountryPhoneCode.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('leadCall');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
;
/**
 * Created by Teo on 02/05/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsController', LeadCallsController);

    LeadCallsController.$inject = ['$http', '$state', '$filter','KendoFilter', 'KendoToolbar', 'KendoGrid', 'CustomUtils'];

    function LeadCallsController ($http, $state, $filter, KendoFilter, KendoToolbar, KendoGrid, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Κλησεις";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(62);
        var grid = {};

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (vm.from && vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "dateTime", "operator": "from",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                },
                                {
                                    "field": "dateTime", "operator": "to",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                }
                            ]
                        );
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "dateTime",  "dir": "desc" };
                    }
                    angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            case "leadHospitalizations.possibleDischargeDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    //console.log(o);
                    $http.get('/api/lead-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            //console.log(response);
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.callType) item.callType = {};
                            if (!item.prospectivePatient) item.prospectivePatient = {};
                            if (item.prospectivePatient && !item.prospectivePatient.attendant) item.prospectivePatient.attendant = {};
                            if (!item.oldPatient) item.oldPatient = {};
                            if (!item.oldPatientDoctor) item.oldPatientDoctor = {};
                            if (!item.leadOffers) item.leadOffers = {};
                            if (!item.leadOffers.offerStatus) item.leadOffers.offerStatus = {};
                            if (!item.leadHospitalizations) item.leadHospitalizations = {};
                            if (!item.leadHospitalizations.hospitalizationType) item.leadHospitalizations.hospitalizationType = {};
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateTime: { type: "date" },
                        nextFollowUpDate: { type: "date"},
                        'leadHospitalizations.possibleDischargeDate': {type: 'date'}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='add' ui-sref='leadCallView({id:dataItem.id})'>" + // ui-sref='leadCallEdit({id:dataItem.id})'
                " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80
            },
            {
                field: "dateTime",
                title: "Ημερομηνία",
                template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy, HH:mm') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {
                field: "callType.name",
                title: "Τύπος Κλήσης",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadOffers.offerStatus.name",
                title: "Προσφορά",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.firstName",
                title: "Όνομα Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.lastName",
                title: "Επώνυμο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.phone",
                title: "Τηλέφωνο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.age",
                title: "Ηλικία",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadHospitalizations.hospitalizationType.name",
                title: "Ασφάλιση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            /*{
                field: "prospectivePatient.attendant.firstName",
                title: "Όνομα Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },*/
            {
                field: "prospectivePatient.attendant.lastName",
                title: "Επώνυμο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.phone",
                title: "Τηλέφωνο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadHospitalizations.possibleDischargeDate",
                title: "Πιθανή Ημερ/νια Εξιτηρίου",
                template: "#= leadHospitalizations.possibleDischargeDate ? kendo.toString(kendo.parseDate(leadHospitalizations.possibleDischargeDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "nextFollowUpDate",
                title: "FollowUp - Ημερ/νία",
                template: "#= nextFollowUpDate ? kendo.toString(kendo.parseDate(nextFollowUpDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "createdBy",
                title: "Δημιουργία Από",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "lastModifiedBy",
                title: "Τελευτ. Επεξεργ. Από",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.leadCallsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false,
            toolbar: [
                /*{ template: "<md-button class='md-raised md-mini md-primary' aria-label='add' ng-click='vm.addNew()'>" +
                    "Προσθήκη Νέας Εγγραφής</md-button>" },*/
                { template: "<div class='right'><label>Σύνολο: {{vm.leadCallsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                vm.from = new Date(date.getFullYear(), 0, 1);
                vm.to = new Date();
            }
            KendoToolbar.setFrom(vm.from);
            KendoToolbar.setTo(vm.to);
            KendoGrid.refresh(vm.leadCallsGridOptions);
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "from", "to"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.from = value;
                } else {
                    vm.from = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.to = value;
                } else {
                    vm.to = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.addNew = function() {
            $state.go('leadCallView', {id: null});
        };

        vm.onFilterChange = function () {
            angular.element("#leadCallsGrid").data("kendoGrid").dataSource.read();
        };

        vm.edit = function(dataItem) {
            $state.go('leadCallView', {id: dataItem.id});
            //vm.leadCallWindow.title("Επεξεργασία Κλήσης");
            //vm.leadCallWindow.center().open();
        };
    }
})();
;
/**
 * Created by Kristy on 9/6/2017.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('HospitalizationGrids', HospitalizationGrids);

    HospitalizationGrids.$inject = ['$http', 'KendoFilter'];
    function HospitalizationGrids ($http, KendoFilter) {
        var popupGrid = {};

        //Grid's Columns initialization
        var customerColumns = [
            {
                field: "customer.lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.doctorSpecialty.name",
                title: "Ειδικότητα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var patientColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "amka",
                title: "Α.Μ.Κ.Α",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλ. Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email Επικοινωνίας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "yearOfBirth", title: "Έτος Γέννηση",
                format: "{0:yyyy}",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "notes",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var sectorColumns = [
            {field: "name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sectorType.name", title: "Τύπος Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        var prospectivePatientColumns = [
            {
                field: "lastName",
                title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "birthYear",
                title: "Έτος Γέννησης",
                filterable: {
                    cell: {
                        operator: "startswithnum",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "attendant.fullName", title: "Συνοδός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                sortable: false
            }
        ];
        var leadCallColumns = [
            {
                field: "dateTime",
                title: "Ημερομηνία Κλήσης",
                template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy, HH:mm') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {
                field: "leadOffers.offerStatus.name",
                title: "Προσφορά",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.firstName",
                title: "Όνομα Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.lastName",
                title: "Επώνυμο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.phone",
                title: "Τηλέφωνο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadHospitalizations.hospitalizationType.name",
                title: "Ασφάλιση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.firstName",
                title: "Όνομα Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.lastName",
                title: "Επώνυμο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prospectivePatient.attendant.phone",
                title: "Τηλέφωνο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        //Grid's Datasource initialization
        var getCustomerDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        // get only active customer-sectors
                        o.data.active = true;

                        $http.get('/api/me/customer-sectors',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            angular.forEach( data.content, function( item ) {
                                if( !item.customer.doctorSpecialty ) item.customer.doctorSpecialty = {};
                                if( !item.sector ) item.sector = {};
                            })
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getPatientDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/patients/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            angular.forEach( data.content, function (item) {
                                if (item.yearOfBirth) {
                                    var date = new Date();
                                    date.setFullYear(item.yearOfBirth);
                                    item.yearOfBirth = date;
                                }
                            })
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getSectorDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/me/sectors',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if(item.name === null) item.name = "";
                                if(item.sectorType === null) item.sectorType = {};
                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 100
            })
        };
        var getProspectivePatientDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/prospective-patients/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            });
                    },
                    create: function (o){
                        var data = o.data.models[0];
                        /*if (data.age) {
                            data.birthYear = CalculateAge.getBirthYearFromAge(data.age).getFullYear();
                        } else {
                            data.birthYear = "";
                        }*/

                        if( !data.city.id ) data.city = null;
                        if( !data.prefecture.id ) data.prefecture = null;
                        if( !data.attendant.id ) data.attendant = null;
                        ProspectivePatient.update({}, data,
                            function(){ KendoGrid.refresh(vm.prospectivePatientsGridOptions) });
                    },
                    update: function (o){
                        var data = o.data.models[0];
                        /*if (data.age) {
                            data.birthYear = CalculateAge.getBirthYearFromAge(data.age).getFullYear();
                        } else {
                            data.birthYear = "";
                        }*/

                        if( !data.city.id ) data.city = null;
                        if( !data.prefecture.id ) data.prefecture = null;
                        if( !data.attendant.id ) data.attendant = null;
                        ProspectivePatient.update({}, data,
                            function(){ KendoGrid.refresh(vm.prospectivePatientsGridOptions) });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if (item.attendant) {
                                    if (item.attendant.lastName && item.attendant.firstName) {
                                        item.attendant.fullName = item.attendant.lastName + " " + item.attendant.firstName;
                                    } else if (!item.attendant.firstName) {
                                        item.attendant.fullName = item.attendant.lastName;
                                    } else if (!item.attendant.lastName) {
                                        item.attendant.fullName = item.attendant.firstName;
                                    }
                                }
                                if (item.attendant === null) item.attendant = {};
                                if (item.profession === null) item.profession = {};

                                /*if (item.birthYear) {
                                    var date = new Date();
                                    date.setFullYear(item.birthYear);
                                    item.birthYear = date;
                                    item.age = CalculateAge.getAgeFromBirthYear(item.birthYear);
                                }*/
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            lastName: { validation: { required: { message: "Το επώνυμο του Ασθενή είναι υποχρεωτικό" } } },
                            firstName: { validation: { required: { message: "Το όνομα του Ασθενή είναι υποχρεωτικό" } } },
                            age: { type: "number" },
                            email: { type: "email" },
                            birthYear: { type: "number", validation: { max: 4 } },
                            attendant: { defaultValue: {} },
                            profession: { defaultValue: {} }
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };
        var getLeadCallDatasource = function () {
            return new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        if (o.data.sort === undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "dateTime",  "dir": "desc" };
                        }
                        angular.forEach( o.data.filter.filters, function(item) {
                            switch (item.field){
                                case "dateTime":
                                    if (item.value instanceof Date) {
                                        item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                    }
                                    break;
                                case "nextFollowUpDate":
                                    if (item.value instanceof Date) {
                                        item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                    }
                                    break;
                                case "leadHospitalizations.possibleDischargeDate":
                                    if (item.value instanceof Date) {
                                        item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                    }
                                    break;
                                default:
                                    break;
                            }
                        });

                        // filter only LeadCalls that hasn't turned into Hospitalization
                        o.data.filter.filters.push(
                            { "field": "hospitalizations",
                                "operator": "isnull",
                                "value": true }
                        );
                        $http.get('/api/lead-calls/search',
                            {params: o.data})
                            .success(function (response) {
                                //console.log(response);
                                o.success(response);
                            });
                    }
                },
                schema : {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if (!item.callType) item.callType = {};
                                if (!item.prospectivePatient) item.prospectivePatient = {};
                                if (item.prospectivePatient && !item.prospectivePatient.attendant) item.prospectivePatient.attendant = {};
                                if (!item.oldPatient) item.oldPatient = {};
                                if (!item.oldPatientDoctor) item.oldPatientDoctor = {};
                                if (!item.leadOffers) item.leadOffers = {};
                                if (!item.leadOffers.offerStatus) item.leadOffers.offerStatus = {};
                                if (!item.leadHospitalizations) item.leadHospitalizations = {};
                                if (!item.leadHospitalizations.hospitalizationType) item.leadHospitalizations.hospitalizationType = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            dateTime: { type: "date" },
                            nextFollowUpDate: { type: "date"},
                            'leadHospitalizations.possibleDischargeDate': {type: 'date'}
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            });
        };

        return {
            getGridOptions: getGridOptions,
            getGridTitle: getGridTitle
        };

        function getGridOptions( grid ) {
            switch (grid) {
                case 'patient':
                    popupGrid.columns = patientColumns;
                    popupGrid.datasource = getPatientDatasource();
                    break;
                case 'customer':
                    popupGrid.columns = customerColumns;
                    popupGrid.datasource = getCustomerDatasource();
                    break;
                case 'sector':
                    popupGrid.columns = sectorColumns;
                    popupGrid.datasource = getSectorDatasource();
                    break;
                case 'prospectivePatient':
                    popupGrid.columns = prospectivePatientColumns;
                    popupGrid.datasource = getProspectivePatientDatasource();
                    break;
                case 'leadCall':
                    popupGrid.columns = leadCallColumns;
                    popupGrid.datasource = getLeadCallDatasource();
                    break;
                default:
            }

            return {
                dataSource: popupGrid.datasource,
                sortable: true,
                pageable: true,
                filterable: {
                    mode: "row"
                },
                resizable: true,
                selectable: true,
                columns:  popupGrid.columns,
                editable: false,
                grid: grid
            };
        }

        function getGridTitle( grid ){
            switch (grid){
                case 'patient':
                    return "Επιλέξτε Ασθενή";
                case 'customer':
                    return "Επιλέξτε Επαγγελματία Υγείας";
                case 'sector':
                    return "Επιλέξτε Νοσοκομείο";
                case 'prospectivePatient':
                    return "Επιλέξτε Ασθενή από LeadManagement";
                case 'leadCall':
                    return "Επιλέξτε Κλήση από LeadManagement";
                default:
                    return "Επιλέξτε";
            }
        }
    }
})();
;
/**
 * Created by Kristy on 6/6/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationViewController', HospitalizationViewController);

    HospitalizationViewController.$inject = ['$scope', '$http', '$filter', '$stateParams', '$state', '$timeout', 'HospitalizationGrids', 'KendoGrid', 'KendoService', 'NotificationOptions', 'KendoNotifications', 'Hospitalization', 'CustomerSector', 'CalculateAge', 'Patient', 'Customer', 'Sector', 'Alerts', 'LeadCall', 'HospitalizationService'];

    function HospitalizationViewController ($scope, $http, $filter, $stateParams, $state, $timeout, HospitalizationGrids, KendoGrid, KendoService, NotificationOptions, KendoNotifications, Hospitalization, CustomerSector, CalculateAge, Patient, Customer, Sector, Alerts, LeadCall, HospitalizationService) {
        var vm = this;
        var dataSource = {};
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var watchGroup = ['vm.hospitalization.patient.fullName', 'vm.hospitalization.customer.fullName',
            'vm.hospitalization.sector', 'vm.isCustomerSectorRequired', 'vm.hospitalization.hospitalizationType.id'];
        vm.hospitalization = vm.patient = vm.customer = vm.sector = vm.leadCall = {};
        vm.isCustomerSectorConnected = vm.isCustomerSectorRequired = true;
        vm.editPatientMode = vm.editCustomerMode = vm.editSectorMode = vm.focusYearOfBirth = vm.focusAge = false;
        vm.today = new Date().getFullYear();
        vm.selectedGrid = "";
        setPageHeading(false);

        $scope.$watchGroup( watchGroup ,function(newValues, oldValues) {
            if(newValues === oldValues) return;

            if (newValues[0] !== oldValues[0] && !!newValues[0])
                vm.validator.validateInput(angular.element("input[name=patient]"));
            if(!newValues[0]) vm.hospitalization.patient = null;

            if (newValues[1] !== oldValues[1] && !!newValues[1])
                vm.validator.validateInput(angular.element("input[name=customer]"));
            if(!newValues[1]) vm.hospitalization.customer = null;

            if (newValues[2] !== oldValues[2] && !!newValues[2])
                vm.validator.validateInput(angular.element("select[name=sector]"));

            if (newValues[3] === false) {
                vm.validator.validateInput(angular.element("input[name=customer]"));
                vm.validator.validateInput(angular.element("select[name=sector]"));
            }

            if (newValues[4] !== oldValues[4] && !!newValues[4])
                vm.validator.validateInput(angular.element("select[name=hospitalizationType]"));
        });

        vm.validatorOptions = {
            rules: {
                custom: function (input) {
                    if (input.data('custom')) {
                        if (input.val() !== null && input.val() !== "" &&
                            angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }
                    return true;
                }
            },
            messages: { custom: "Πρέπει να επιλέξετε από την λίστα" },
            validateOnBlur: false
        };

        vm.calculateAge = function() {
            if (vm.patient.yearOfBirth > vm.today)
                vm.patient.yearOfBirth = vm.today.toString();

            if ( vm.patient.yearOfBirth.length === 4 ) {
                var date = new Date();
                date.setFullYear(vm.patient.yearOfBirth);
                vm.patient.age = CalculateAge.getAgeFromBirthYear(date);
            } else {
                vm.patient.age = "";
            }
            vm.toggleKeypad('yearOfBirth');
        };
        vm.calculateYearOfBirth = function() {
            if (vm.patient.age) {
                vm.patient.yearOfBirth = CalculateAge.getBirthYearFromAge(vm.patient.age).getFullYear();
            } else {
                vm.patient.yearOfBirth = "";
            }
            vm.toggleKeypad('age');
        };

        vm.setData = function (model) {
            if( vm.hospitalization.customer && model.indexOf("customer") !== -1 ) {
                vm.hospitalization.customer.fullName =  vm.hospitalization.customer.lastName + " " +  vm.hospitalization.customer.firstName;
                // vm.customerOptions.dataSource.add(vm.hospitalization.customer);
            }
            if( vm.hospitalization.sector && model.indexOf("sector") !== -1 ) {
                vm.sectorOptions.dataSource.add(vm.hospitalization.sector);
            }
            if( vm.hospitalization.patient && model.indexOf("patient") !== -1 ) {
                vm.hospitalization.patient.fullName = vm.hospitalization.patient.lastName + " " + vm.hospitalization.patient.firstName;
                if ( vm.hospitalization.patient.yearOfBirth instanceof Date)
                    vm.hospitalization.patient.yearOfBirth = vm.hospitalization.patient.yearOfBirth.getFullYear();
            }
            if( vm.hospitalization.clinicName && model.indexOf("clinicName") !== -1 ) {
                vm.clinicNameOptions.dataSource.add(vm.hospitalization.clinicName);
            }
        };

        if ($stateParams.id) {
            Hospitalization.get({id : $stateParams.id})
                .$promise.then(function(data) {
                    vm.hospitalization = data;
                    if(vm.hospitalization) vm.setData(["customer", "sector", "patient", "clinicName"]);
                    filterCustomerSector();
                });
        } else {
            vm.hospitalization.dateIssue = new Date();
            if ($stateParams.patientId){
                Patient.get({id: $stateParams.patientId}, function (result) {
                    vm.patient = result;
                    vm.hospitalization.patient = result;
                    vm.setData(["patient"]);
                }, function (error) {
                    console.log(error);
                });
            }
            if ($stateParams.leadCallId){
                LeadCall.get({id: $stateParams.leadCallId}, function (result) {
                    vm.leadCall = result;
                    vm.hospitalization.leadCall = result;
                    setPageHeading(true);
                }, function (error) {
                   console.log(error);
                });
            }
        }

        function filterCustomerSector () {
            if (vm.hospitalization.customer && vm.hospitalization.sector) {
                var data = { filter: { filters: [] },
                    page: 1, pageSize: 1};
                data.filter.filters.push(
                    { "field": "customer.id", "operator": "eq",
                        "value": vm.hospitalization.customer.id },
                    { "field": "sector.id", "operator": "eq",
                        "value": vm.hospitalization.sector.id }
                );
                data.sort={"field":"id","dir":"desc"};
                data.active = true;

                //Show connect sector with customer message if CustomerSector doesn't exist
                $http.get('/api/me/customer-sectors',
                    {params: data})
                    .success(function (response) {
                        vm.isCustomerSectorConnected = response.content.length;
                    });

                //Suggest ClinicName according to last hospitalization record for the selected CustomerSector
                $http.get('/api/hospitalizations/search',
                    {params: data})
                    .success(function (response) {
                        if (response.content.length) {
                            if (response.content[0].clinicName) {
                                $timeout(function () {
                                    if (vm.hospitalization.sector)
                                        vm.clinicNameOptions.dataSource.data(vm.hospitalization.sector.clinicNames);

                                    var foundItemById =
                                        $filter('filter')(Array.from(vm.clinicNameOptions.dataSource.data()), {id: response.content[0].clinicName.id}, true)[0];
                                    if ( vm.clinicNameOptions.dataSource.data().indexOf(foundItemById) === -1) {
                                        vm.hospitalization.clinicName = response.content[0].clinicName;
                                        vm.clinicNameOptions.dataSource.add(vm.hospitalization.clinicName);
                                    }
                                });
                            }
                        }
                    });
            }
        }

        //CustomerTitle combobox edit configuration
        dataSource.customerTitlesDataSource = KendoService.initDataSource('/api/masterdata/customer-titles', 1, 20);
        vm.customerTitleOptions = KendoService.initDefaultOptions(dataSource.customerTitlesDataSource, "startswith", "name", "id");
        vm.customerTitleOptions.valuePrimitive = false;

        //ClinicName combobox edit configuration
        dataSource.clinicNamesDataSource = KendoService.initDataSource('/api/clinic-names/search', 1, 200);
        dataSource.clinicNamesDataSource.options.serverFiltering = false;
        vm.clinicNameOptions = KendoService.initDefaultOptions(dataSource.clinicNamesDataSource, "contains", "name", "id");
        vm.clinicNameOptions.valuePrimitive = false;
        vm.clinicNameOptions.dataBound = function () {
            if (vm.hospitalization.clinicName) {
                var foundClinicNameById =
                    $filter('filter')(Array.from(vm.clinicNameOptions.dataSource.data()), {id: vm.hospitalization.clinicName.id}, true)[0];
                if (!foundClinicNameById) {
                    vm.hospitalization.clinicName = {};
                    angular.element("#clinicName").data("kendoComboBox").value('');
                }
            }
        };

        //Sector combobox edit configuration
        dataSource.sectorsDataSource = KendoService.initDataSource('/api/me/sectors', 1, 20);
        vm.sectorOptions = KendoService.initDefaultOptions(dataSource.sectorsDataSource, "like", "name", "id");
        vm.sectorOptions.valuePrimitive = false;
        vm.sectorOptions.autoBind = false;
        vm.sectorOptions.change = function(){
            var self = this;
            filterCustomerSector();
            $timeout(function () {
                if (self.dataItem(self.select())) {
                    if (self.dataItem(self.select()).clinicNames.length) {
                        vm.clinicNameOptions.dataSource.data(self.dataItem(self.select()).clinicNames);
                    } else {
                        vm.clinicNameOptions.dataSource.read();
                    }
                }
            });
        };

        //RoomType combobox edit configuration
        dataSource.roomTypesDataSource = KendoService.initDataSource('/api/room-types/search', 1, 20);
        vm.roomTypeOptions = KendoService.initDefaultOptions(dataSource.roomTypesDataSource, "startswith", "name", "id");

        //FinalRoomType combobox edit configuration
        dataSource.finalRoomTypesDataSource = dataSource.roomTypesDataSource;
        vm.finalRoomTypeOptions = KendoService.initDefaultOptions(dataSource.finalRoomTypesDataSource, "startswith", "name", "id");

        //HospitalizationType combobox edit configuration
        dataSource.hospitalizationTypesDataSource = KendoService.initDataSource('/api/hospitalization-types/search', 1, 20);
        vm.hospitalizationTypeOptions = KendoService.initDefaultOptions(dataSource.hospitalizationTypesDataSource, "startswith", "name", "id");
        vm.hospitalizationTypeOptions.dataBound = vm.hospitalizationTypeOptions.change = vm.hospitalizationTypeOptions.cascade = function () {
            var value = this.value();
            $timeout( function() {
                vm.isCustomerSectorRequired = value === '3' || value === null || value === "" || value === undefined;
            } );
        };

        //DoctorSpecialty combobox edit configuration
        dataSource.doctorSpecialtiesDataSource = KendoService.initDataSource('/api/masterdata/doctor-specialties', 1, 20);
        vm.doctorSpecialtyOptions = KendoService.initDefaultOptions(dataSource.doctorSpecialtiesDataSource, "startswith", "name", "id");

        //SectorType combobox edit configuration
        dataSource.sectorTypesDataSource = KendoService.initDataSource('/api/masterdata/sector-types', 1, 20);
        vm.sectorTypeOptions = KendoService.initDefaultOptions(dataSource.sectorTypesDataSource, "startswith", "name", "id");

        vm.save = function () {
            if (vm.validator.validate()) {
                if (vm.hospitalization.clinicName)
                    if (!vm.hospitalization.clinicName.id) vm.hospitalization.clinicName = null;
                if (vm.hospitalization.hospitalizationType)
                    if (!vm.hospitalization.hospitalizationType.id) vm.hospitalization.hospitalizationType = null;
                if (vm.hospitalization.roomType)
                    if (!vm.hospitalization.roomType.id) vm.hospitalization.roomType = null;
                // if (vm.hospitalization.patient)
                //     if (!vm.hospitalization.patient.id) vm.hospitalization.patient = null;
                if (vm.hospitalization.sector)
                    if (!vm.hospitalization.sector.id) vm.hospitalization.sector = null;
                // if (vm.hospitalization.customer)
                //     if (!vm.hospitalization.customer.id) vm.hospitalization.customer = null;
                if (vm.hospitalization.finalRoomType)
                    if (!vm.hospitalization.finalRoomType.id) vm.hospitalization.finalRoomType = null;

                var cancel = false;
                var message = "";

                if (vm.hospitalization.patient === null ||
                    vm.hospitalization.patient === undefined ||
                    !vm.hospitalization.patient.id > 0){
                    cancel = true;
                    message = "Καταχωρήστε ή επιλέξτε Ασθενή";
                }

                if (!cancel && (vm.hospitalization.customer === null ||
                    vm.hospitalization.customer === undefined ||
                    !vm.hospitalization.customer.id > 0)){
                    cancel = true;
                    message = "Καταχωρήστε ή επιλέξτε Επαγγελματία Υγείας";
                }

                if (!cancel && (vm.hospitalization.sector === null ||
                    vm.hospitalization.sector === undefined ||
                    !vm.hospitalization.sector.id > 0)){
                    cancel = true;
                    message = "Καταχωρήστε ή επιλέξτε Νοσοκομείο";
                }

                if (cancel){
                    Alerts.showAlert("Sigma SalesForce", message, "Ok");
                }else {
                    if (vm.hospitalization.leadCall && vm.hospitalization.leadCall.id > 0){
                        vm.hospitalization.leadCall.leadHospitalizations = null;
                    }
                    Hospitalization.update(vm.hospitalization,
                        function () {
                            KendoNotifications.onSaveSuccess(notification);
                            vm.isCustomerSectorConnected = true;
                            vm.isCustomerSectorRequired = true;
                        },
                        function () {
                            KendoNotifications.onSaveError(notification)
                        });

                    //clear view if on new entry view
                    if (!$stateParams.id) {
                        vm.hospitalization = {};
                        vm.hospitalization.dateIssue = new Date();
                    }

                    setPageHeading(false);
                }
            } else {
                KendoNotifications.onSaveError(notification);
            }
        };

        vm.openWindow = function (grid) {
            vm.selectedGrid = grid;
            if (vm.popupGridOptions) KendoGrid.refresh(vm.popupGridOptions);
            vm.popupGridOptions = HospitalizationGrids.getGridOptions(grid);

            vm.window.title(HospitalizationGrids.getGridTitle(grid));
            vm.window.center().open();
        };

        vm.dataItemSelected = function () {
            var grid = angular.element("#popupGrid").data("kendoGrid");
            var selectedItem = grid.dataItem(grid.select());
            if (selectedItem) {
                switch (vm.popupGridOptions.grid) {
                    case "patient":
                        vm.hospitalization.patient = selectedItem;
                        vm.setData(["patient"]);
                        break;
                    case "customer":
                        vm.hospitalization.customer = selectedItem.customer;
                        vm.hospitalization.customerTitle = selectedItem.customer.customerTitle;
                        vm.hospitalization.sector = selectedItem.sector;
                        vm.setData(["customer", "sector"]);
                        filterCustomerSector();
                        $timeout(function () {
                            if (selectedItem.sector.clinicNames) {
                                if (selectedItem.sector.clinicNames.length) {
                                    vm.clinicNameOptions.dataSource.data(selectedItem.sector.clinicNames);
                                } else {
                                    vm.clinicNameOptions.dataSource.read();
                                }
                            }
                        });
                        break;
                    case "sector":
                        vm.hospitalization.sector = selectedItem;
                        vm.setData(["sector"]);
                        filterCustomerSector();
                        $timeout(function () {
                            if (selectedItem) {
                                if (selectedItem.clinicNames.length) {
                                    vm.clinicNameOptions.dataSource.data(selectedItem.clinicNames);
                                } else {
                                    vm.clinicNameOptions.dataSource.read();
                                }
                            }
                        });
                        break;
                    case "prospectivePatient":
                        // Get Patient by selected ProspectivePatient
                        var patientFilter = {
                            field: "prospectivePatient.id",
                            operator: "eq",
                            value: selectedItem.id
                        };
                        $http.get('/api/patients/search',
                            {params:{
                                    page: "1",
                                    pageSize: "200",
                                    filter : { filters: [patientFilter] }}})
                            .success(function (response) {
                                console.log(response.content);
                                if (response.content === null || response.content.length === 0){
                                    // There is not any Patient from selected ProspectivePatient, show convert dialog
                                    Alerts.showConfirmDialog(null, "Sigma SalesForce", "Ο Πιθανός Ασθενείς που επιλέχθηκε δεν υπάρχει στο σύστημα ως κανονικός Ασθενής. Μετατροπή σε Ασθενή τώρα?", true, "ΝΑΙ", "OXI", function () {
                                        var patientForSave = {
                                            firstName: selectedItem.firstName,
                                            lastName: selectedItem.lastName,
                                            email: selectedItem.email,
                                            yearOfBirth: selectedItem.birthYear,
                                            phone: selectedItem.phone,
                                            notes: selectedItem.notes,
                                            prospectivePatient: {
                                                id: selectedItem.id
                                            },
                                            amka: selectedItem.amka
                                        };
                                        console.log(patientForSave);
                                        Patient.save(patientForSave, function (result) {
                                            console.log(result);
                                            KendoNotifications.showSuccessNotification(notification, "Επιτυχής μετατροπή Πιθανού Ασθενή σε Ασθενή");
                                            vm.hospitalization.patient = result;
                                            vm.setData(["patient"]);
                                        }, function (error) {
                                            console.log(error);
                                            var errorMessage = "Κάποιο σφάλμα προέκυψε κατά την μετατροπή Πιθανού Ασθενή σε Ασθενή!";
                                            if (error.data.message &&
                                                error.data.message.includes("Cannot save Patient with ProspectivePatient id that exists")){
                                                errorMessage = "Ο Ασθενής υπάρχει ήδη!";
                                            }
                                            KendoNotifications.showErrorNotification(notification, errorMessage);
                                        });
                                    }, function () {
                                        // User cancel convert to Patient
                                    });
                                }else {
                                    // There is a Patient from selected Patient, continue as usual
                                    vm.hospitalization.patient = selectedItem;
                                    vm.setData(["patient"]);
                                }
                            })
                            .error(function (error) {
                                console.log(error);
                            });
                        break;
                    case "leadCall":
                        // First check if there is any Hospitalization with this selected leadCall.id
                        HospitalizationService.search({
                            page: 1, pageSize: 5,
                            filter: {
                                filters: [
                                    {
                                        field: "leadCall.id",
                                        operator: "eq",
                                        value: selectedItem.id
                                    }
                                ]
                            }
                        }).$promise.then(function (result) {
                            if (result.length > 0){
                                Alerts.showAlert("Sigma SalesForce", "Η Κλήση που επιλέξατε έχει γίνει ήδη Εισαγωγή!", "Ok");
                            }else {
                                // There aren't any Hospitalizations with this leadCall.id, continue
                                var selectedPatientFilter = {
                                    field: "prospectivePatient.id",
                                    operator: "eq",
                                    value: selectedItem.prospectivePatient.id
                                };
                                $http.get('/api/patients/search',
                                    {params:{
                                            page: "1",
                                            pageSize: "200",
                                            filter : { filters: [selectedPatientFilter] }}})
                                    .success(function (response) {
                                        if (response.content === null || response.content.length === 0){
                                            // There is not any Patient from selected ProspectivePatient, show convert dialog
                                            Alerts.showConfirmDialog(null, "Sigma SalesForce", "Ο Πιθανός Ασθενείς που επιλέχθηκε δεν υπάρχει στο σύστημα ως κανονικός Ασθενής. Μετατροπή σε Ασθενή τώρα?", true, "ΝΑΙ", "OXI", function () {
                                                var patientForSave = {
                                                    firstName: selectedItem.prospectivePatient.firstName,
                                                    lastName: selectedItem.prospectivePatient.lastName,
                                                    email: selectedItem.prospectivePatient.email,
                                                    yearOfBirth: selectedItem.prospectivePatient.birthYear,
                                                    phone: selectedItem.prospectivePatient.phone,
                                                    notes: selectedItem.prospectivePatient.notes,
                                                    prospectivePatient: {
                                                        id: selectedItem.prospectivePatient.id
                                                    },
                                                    amka: selectedItem.prospectivePatient.amka
                                                };
                                                Patient.save(patientForSave, function (result) {
                                                    console.log(result);
                                                    KendoNotifications.showSuccessNotification(notification, "Επιτυχής μετατροπή Πιθανού Ασθενή σε Ασθενή");
                                                    vm.hospitalization.patient = result;
                                                    // Also set LeadCall into Hospitalization
                                                    vm.leadCall = selectedItem;
                                                    vm.hospitalization.leadCall = selectedItem;
                                                    setPageHeading(true);
                                                    vm.setData(["patient"]);
                                                }, function (error) {
                                                    console.log(error);
                                                    var errorMessage = "Κάποιο σφάλμα προέκυψε κατά την μετατροπή Πιθανού Ασθενή σε Ασθενή!";
                                                    if (error.data.message &&
                                                        error.data.message.includes("Cannot save Patient with ProspectivePatient id that exists")){
                                                        errorMessage = "Ο Ασθενής υπάρχει ήδη!";
                                                    }
                                                    KendoNotifications.showErrorNotification(notification, errorMessage);
                                                });
                                            }, function () {
                                                // User cancel convert to Patient
                                            });
                                        }else {
                                            // There is a Patient from selected Patient, continue as usual
                                            vm.hospitalization.patient = response.content[0];
                                            // Also set LeadCall into Hospitalization
                                            vm.leadCall = selectedItem;
                                            vm.hospitalization.leadCall = selectedItem;
                                            setPageHeading(true);
                                            vm.setData(["patient"]);
                                        }
                                    })
                                    .error(function (error) {
                                        console.log(error);
                                    });
                            }
                        });
                        break;
                }
            }
            vm.window.close();
        };

        //Connect customer with sector
        vm.addCustomerSector = function() {
            var data = {
                customer: vm.hospitalization.customer,
                sector: vm.hospitalization.sector,
                startedAt: new Date()
            };

            CustomerSector.update(data,
                function() {
                    KendoNotifications.onSaveSuccess(notification);
                    vm.isCustomerSectorConnected = true;
                },
                function(){ KendoNotifications.onSaveError(notification) });
        };

        //Toggle view
        vm.toggle = function(model, action) {
            if (!model) {
                model = vm.popupGridOptions.grid;
                vm.window.close();
            }
            switch (model) {
                case "patient":
                    vm.editPatientMode = action === "add" || action === "edit";
                    if ( action === "add" || action === "erase") vm.patient = {};
                    if ( action === "edit" ) {
                        if (vm.hospitalization.patient.yearOfBirth) {
                            var date = new Date();
                            date.setFullYear(vm.hospitalization.patient.yearOfBirth);
                            vm.hospitalization.patient.age = CalculateAge.getAgeFromBirthYear(date);
                        }
                        vm.patient = vm.hospitalization.patient;
                        vm.patient.age = vm.hospitalization.patient.age.toString();
                        vm.patient.yearOfBirth = vm.hospitalization.patient.yearOfBirth.toString();
                    }
                    if ( action === "erase" ) vm.hospitalization.patient = {};
                    break;
                case "customer":
                    vm.editCustomerMode = action === "add" || action === "edit";
                    if ( action === "add" || action === "erase" ) vm.customer = {};
                    if ( action === "edit" ) vm.customer = vm.hospitalization.customer;
                    if ( action === "erase" ) vm.hospitalization.customer = {};
                    break;
                case "sector":
                    vm.editSectorMode = action === "add" || action === "edit";
                    if ( action === "add" ) vm.sector = {};
                    if ( action === "edit" ) vm.sector = vm.hospitalization.sector;
                    if ( action === "erase" ) {
                        vm.hospitalization.sector = null;
                        angular.element("#sector").data("kendoComboBox").value("");
                    }
                    break;
            }
        };

        //Update Patient, Customer & Sector
        vm.update = function(model) {
            switch (model) {
                case "patient":
                    // vm.patient.yearOfBirth = kendo.toString( vm.patient.yearOfBirth, 'yyyy' );
                    if (vm.patientValidator.validate()) {
                        Patient.update({}, vm.patient,
                            function (result) {
                                KendoNotifications.onSaveSuccess(notification);
                                vm.toggle("patient", "clear");
                                vm.hospitalization.patient = result;
                                vm.setData(["patient"]);
                            },
                            function () {
                                KendoNotifications.onSaveError(notification)
                            });
                    } else {
                        KendoNotifications.onSaveError(notification);
                    }
                    break;
                case "customer":
                    vm.customer.isActive = true;
                    if (vm.customerValidator.validate()) {
                        Customer.update({}, vm.customer,
                            function( result ){
                                KendoNotifications.onSaveSuccess(notification);
                                vm.toggle("customer", "clear");
                                vm.hospitalization.customer = result;
                                filterCustomerSector();
                                vm.setData(["customer"]);
                            },
                            function(){ KendoNotifications.onSaveError(notification) });
                    } else {
                        KendoNotifications.onSaveError(notification);
                    }
                    break;
                case "sector":
                    if (vm.sectorValidator.validate()) {
                        Sector.update({}, vm.sector,
                            function (result) {
                                KendoNotifications.onSaveSuccess(notification);
                                vm.toggle("sector", "clear");
                                vm.hospitalization.sector = result;
                                filterCustomerSector();
                                var foundItemById =
                                    $filter('filter')(Array.from(vm.sectorOptions.dataSource.data()), {id: vm.hospitalization.sector.id}, true)[0];
                                if ( vm.sectorOptions.dataSource.data().indexOf(foundItemById) === -1) {
                                    vm.sectorOptions.dataSource.add(vm.hospitalization.sector);
                                    vm.clinicNameOptions.dataSource.read();
                                }

                                vm.setData(["sector"]);
                            },
                            function () {
                                KendoNotifications.onSaveError(notification)
                            });
                    } else {
                        KendoNotifications.onSaveError(notification);
                    }
                    break;
            }
        };

        vm.toggleKeypad = function(keypad) {
            switch (keypad) {
                case "yearOfBirth":
                    vm.focusYearOfBirth = true;
                    if(vm.patient.yearOfBirth) {
                        vm.focusYearOfBirth = !(vm.patient.yearOfBirth.toString().length === 4);
                    }
                    vm.focusAge = false;
                    break;
                case "age":
                    vm.focusAge = true;
                    if(vm.patient.age) {
                        vm.focusAge = !(vm.patient.age.toString().length >= 2);
                    }
                    vm.focusYearOfBirth = false;
                    break;
            }
        };

        vm.hideKeypadOnBlur = function(e, element) {
            switch (element) {
                case "yearOfBirth" :
                    vm.focusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.focusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "yearOfBirthKeypad";
                    break;
                case "age" :
                    vm.focusAge = false;
                    if (e.relatedTarget)
                        vm.focusAge = e.relatedTarget.parentNode.parentNode.id === "ageKeypad";
                    break;
                case "yearOfBirthKeypad" :
                    vm.focusYearOfBirth = false;
                    if (e.relatedTarget)
                        vm.focusYearOfBirth = e.relatedTarget.parentNode.parentNode.id === "yearOfBirth";
                    break;
                case "ageKeypad" :
                    vm.focusAge = false;
                    if (e.relatedTarget)
                        vm.focusAge = e.relatedTarget.parentNode.parentNode.id === "age";
                    break;
            }
        }

        function setPageHeading(fromLeadCall){
            if (fromLeadCall === true){
                vm.pageHeading = "Εισαγωγή από Κλήση #" + vm.hospitalization.leadCall.id;
            }else {
                vm.pageHeading = "Εισαγωγή";
            }
        }
    }
})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizations', {
                parent: 'app',
                url: '/hospitalizations',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.hospitalizations.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/hospitalizations/hospitalizations.html',
                        controller: 'HospitalizationsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hospitalizationView', {
                parent: 'app',
                url: '/hospitalizations/search?id:hospitalizationId',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.hospitalizations.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/hospitalizations/hospitalizationView.html',
                        controller: 'HospitalizationViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null,
                    patientId: null,
                    leadCallId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search,
                            patientId: $stateParams.patientId,
                            leadCallId: $stateParams.leadCallId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsController', HospitalizationsController);

    HospitalizationsController.$inject = ['$http', '$state', '$filter','KendoFilter', 'KendoToolbar', 'KendoGrid', 'CustomUtils'];

    function HospitalizationsController ($http, $state, $filter, KendoFilter, KendoToolbar, KendoGrid, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(62);
        vm.pageHeading = "Εισαγωγες";
        var grid = {};

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if(vm.from && vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "dateIssue", "operator": "fromdate",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-dd')},
                                { "field": "dateIssue", "operator": "todate",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-dd')}
                            ]
                        );
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "dateIssue",  "dir": "desc" };
                    }
                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/hospitalizations/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.sector) item.sector = {};
                            if (!item.sector.sectorType) item.sector.sectorType = {};
                            if (!item.clinicName) item.clinicName = {};
                            if (!item.roomType) item.roomType = {};
                            if (!item.finalRoomType) item.finalRoomType = {};
                            if (!item.hospitalizationType) item.hospitalizationType = {};
                            if (!item.patient) item.patient = {};
                            if (!item.customer) item.customer = { customerTitle: {} };
                            if (!item.customer.customerTitle) item.customer.customerTitle = {};
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        dateIssue: { type: "date" }
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });
        grid.columns = vm.gridColumns = [
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='add' ng-click='vm.edit(dataItem)'>" +
                    " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80
            },
            {
                field: "patient.lastName",
                title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "patient.firstName",
                title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.lastName",
                title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.sectorType.name",
                title: "Τύπος Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.customerTitle.name",
                title: "Τύπος Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "clinicName.name",
                title: "Κλινική",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "roomType.name",
                title: "Επιθυμητός Τύπος Δωματίου",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "finalRoomType.name",
                title: "Τελική Τοποθέτηση",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "hospitalizationType.name",
                title: "Παρατηρήσεις",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "notes",
                title: "Σχόλια",
                editor: function(container) {
                    angular.element('<textarea rows="3" cols="150" class = "k-textbox custom-popup-textarea pull-right" data-bind="value:notes"></textarea>')
                        .appendTo(container);
                },
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "dateIssue", title: "Ημερομηνία Εισαγωγής", template: "#= dateIssue ? kendo.toString(kendo.parseDate(dateIssue), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            }
        ];

        vm.hospitalizationsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: false,
            toolbar: [
                /*{ template: "<md-button class='md-raised md-mini md-primary' aria-label='add' ng-click='vm.addNew()'>" +
                    "Προσθήκη Νέας Εγγραφής</md-button>" },*/
                { template: "<div class='right'><label>Σύνολο: {{vm.hospitalizationsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                vm.from = new Date(date.getFullYear(), 0, 1);
                vm.to = new Date();
            }
            KendoGrid.refresh(vm.hospitalizationsGridOptions);
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "from", "to"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.from = value;
                } else {
                    vm.from = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.to = value;
                } else {
                    vm.to = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.addNew = function() {
            $state.go('hospitalizationView', {id: null});
        };

        vm.onFilterChange = function () {
            angular.element("#hospitalizationsGrid").data("kendoGrid").dataSource.read();
        };

        vm.edit = function(dataItem) {
            $state.go('hospitalizationView', {id: dataItem.id});
        };
    }
})();
;
/**
 * Created by Teo on 21/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('followUpCalls', {
                parent: 'app',
                url: '/followUpCalls',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.global.menu.lead-management.followup-calls'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/followUpCalls/followUpCalls.html',
                        controller: 'FollowUpCallsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            /*.state('leadCallView', {
                parent: 'app',
                url: '/leadCalls/search?id:leadCallId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'sigmaCrmApp.leadCall.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/leadCalls/leadCallsView.html',
                        controller: 'LeadCallsViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    professions: ['Profession', function (Profession) {
                        return Profession.query({page: 0, size: 200}).$promise;
                    }],
                    relationshipTypes: ['RelationshipType', function (RelationshipType) {
                        return RelationshipType.query({page: 0, size: 200}).$promise;
                    }],
                    nativeLanguages: ['NativeLanguage', function (NativeLanguage) {
                        return NativeLanguage.query({page: 0, size: 200}).$promise;
                    }],
                    callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],
                    hospitalizationTypes: ['HospitalizationType', function (HospitalizationType) {
                        return HospitalizationType.query({page: 0, size: 200}).$promise;
                    }],
                    clinicNames: ['ClinicName', function (ClinicName) {
                        return ClinicName.query({page: 0, size: 200}).$promise;
                    }],
                    costTypes: ['CostType', function (CostType) {
                        return CostType.query({page: 0, size: 200}).$promise;
                    }],
                    roomTypes: ['RoomType', function (RoomType) {
                        return RoomType.query({page: 0, size: 200}).$promise;
                    }],
                    transportations: ['Transportation', function (Transportation) {
                        return Transportation.query({page: 0, size: 200}).$promise;
                    }],
                    discountReasons: ['DiscountReason', function (DiscountReason) {
                        return DiscountReason.query({page: 0, size: 200}).$promise;
                    }],
                    discountRates: ['DiscountRate', function (DiscountRate) {
                        return DiscountRate.query({page: 0, size: 200}).$promise;
                    }],
                    competitors: ['Competitor', function (Competitor) {
                        return Competitor.query({page: 0, size: 200}).$promise;
                    }],
                    addDiseases: ['AddDisease', function (AddDisease) {
                        return AddDisease.query({page: 0, size: 200}).$promise;
                    }],
                    addConditions: ['AddCondition', function (AddCondition) {
                        return AddCondition.query({page: 0, size: 200}).$promise;
                    }],
                    diseaseTypes: ['DiseaseType', function (DiseaseType) {
                        return DiseaseType.query({page: 0, size: 200}).$promise;
                    }],
                    diseases: ['Disease', function (Disease) {
                        return Disease.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('leadCall');
                        return $translate.refresh();
                    }]
                }
            })*/
    }
})();
;
/**
 * Created by Teo on 21/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowUpCallsController', FollowUpCallsController);

    FollowUpCallsController.$inject = ['$http', '$state', '$filter', 'KendoService', 'KendoFilter', 'KendoToolbar', 'KendoGrid', 'FollowupCall', 'CustomUtils'];

    function FollowUpCallsController ($http, $state, $filter, KendoService, KendoFilter, KendoToolbar, KendoGrid, FollowupCall, CustomUtils) {
        var vm = this;
        vm.editMode = false;
        vm.pageHeading = "Εκκρεμοτητες";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(62);
        var grid = {};
        var dataSource = {};

        grid.datasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            {
                                "field": "leadCall.leadOffers.offerStatus.id", "operator": "noteq",
                                "value": 3
                            }
                        ]
                    );
                    if (vm.from && vm.to) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "date", "operator": "fromdate",
                                    "value": $filter('date')(vm.from, 'yyyy-MM-dd')
                                },
                                {
                                    "field": "date", "operator": "todate",
                                    "value": $filter('date')(vm.to, 'yyyy-MM-dd')
                                }
                            ]
                        );
                    }
                    if (o.data.sort === undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "date",  "dir": "desc" };
                    }else {
                        angular.forEach(o.data.sort, function (item) {
                            if (item.field === "leadCall.leadHospitalizations[0].possibleDischargeDate"){
                                item.field = "leadCall.leadHospitalizations.possibleDischargeDate";
                            }
                        });
                    }
                    angular.forEach( o.data.filter.filters, function(item) {
                        /*if (item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }*/
                        switch (item.field){
                            case "date":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            case "leadCall.leadHospitalizations[0].possibleDischargeDate":
                                item.field = "leadCall.leadHospitalizations.possibleDischargeDate";
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    o.data.filter.filters.push({
                        field: "completed",
                        operator: "eqbool",
                        value: "false"
                    });
                    o.data.filter.filters.push({
                        field: "leadCall.prospectivePatient.patient",
                        operator: "isnull",
                        value: "true"
                    });
                    $http.get('/api/followup-calls/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        });
                },
                create: function (o){},
                update: function (o){
                    var data = o.data.models[0];

                    if ( data.followupType === null || !data.followupType.id ) { data.followupType = null; }
                    if ( data.rejectionReason === null || !data.rejectionReason.id ) { data.rejectionReason = null; }
                    if ( data.followupStatus === null || !data.followupStatus.id ) { data.followupStatus = null; }

                    FollowupCall.update({}, data, function () {
                        KendoGrid.refresh(vm.followUpCallsGridOptions)
                    });
                }
            },
            schema : {
                data: function (data) {
                    if(data.content !== undefined) {
                        data.content.forEach(function(item){
                            if (!item.leadCall){
                                item.leadCall = {};
                            }

                            if (item.leadCall && !item.leadCall.prospectivePatient){
                                item.leadCall.prospectivePatient = {}
                            }

                            if (item.leadCall && item.leadCall.prospectivePatient && !item.leadCall.prospectivePatient.attendant){
                                item.leadCall.prospectivePatient.attendant = {};
                            }
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        date: { type: "date"},
                        willTheyCall: { type: "boolean" },
                        comments: { type: "string" },
                        completed: { type: "boolean" },
                        'leadCall.leadHospitalizations[0].possibleDischargeDate': {type: 'date'}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        grid.columns = vm.gridColumns = [
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' aria-label='edit' ng-click='vm.customEdit($event)'>" + // ui-sref='leadCallEdit({id:dataItem.id})'
                " <i class='dark-grey material-icons fixed-icons-2'>edit</i></md-button>",
                title: "&nbsp;",
                width: 80
            },
            {field: "date", title: "Ημερομηνία", template: "#= date ? kendo.toString(kendo.parseDate(date), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.firstName",
                title: "Όνομα Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.lastName",
                title: "Επώνυμο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.phone",
                title: "Τηλέφωνο Πιθανού Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.attendant.firstName",
                title: "Όνομα Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.attendant.lastName",
                title: "Επώνυμο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.prospectivePatient.attendant.phone",
                title: "Τηλέφωνο Συνοδού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                template: '<md-checkbox class="checkbox-toolbar green inline"  aria-label="selectable" ' +
                'ng-model="dataItem.leadCall.isImportant" ' +
                'ng-disabled="true"></md-checkbox>',
                field: "leadCall.isImportant", title: "Σημαντικό",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "leadCall.leadHospitalizations[0].possibleDischargeDate",
                title: "Πιθανή Ημερ/νια Εξιτηρίου",
                template: "#= leadCall.leadHospitalizations[0].possibleDischargeDate ? kendo.toString(kendo.parseDate(leadCall.leadHospitalizations[0].possibleDischargeDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                template: "<md-button class='md-raised md-mini' style='min-width: 50px;margin: 0;' ui-sref='leadCallView({id:dataItem.leadCall.id})'>" + // ui-sref='leadCallEdit({id:dataItem.id})'
                " Μετάβαση στην Κλήση</md-button>",
                title: "&nbsp;",
                width: 190
            }
        ];

        vm.followUpCallsGridOptions = {
            dataSource: grid.datasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  grid.columns,
            editable: {
                mode: "popup",
                template: kendo.template(angular.element("#popup-follow-up-call").html())
            },
            rowTemplate: kendo.template($("#rowTemplate").html()),
            edit: function(e) {
                vm.editMode = true;
                //e.model.formattedDate = moment(e.model.date).format('DD-MM-YYYY').toString();
                KendoGrid.defaultEditPopup(this._editContainer);
                e.model.dirty = true;
                vm.selectedItem = e.model;
                KendoGrid.defaultCustomEditPopup(this._editContainer,1100,1090);

                //FollowUpType Combobox
                dataSource.followUpTypes = KendoService.initDefaultDataSource('/api/followup-types/search');
                vm.followUpTypeOptions = KendoService.initDefaultOptions(dataSource.followUpTypes, "startswith", "name", "id", false);

                //RejectionReason Combobox
                dataSource.rejectionReasons = KendoService.initDefaultDataSource('/api/rejection-reasons/search');
                vm.rejectionReasonOptions = KendoService.initDefaultOptions(dataSource.rejectionReasons, "startswith", "name", "id", false);

                //RejectionReason Combobox
                dataSource.followupStatuses = KendoService.initDefaultDataSource('/api/followup-statuses/search');
                vm.followupStatuses = KendoService.initDefaultOptions(dataSource.followupStatuses, "startswith", "name", "id", false);
            },
            toolbar: [
                { template: "<div class='right'><label>Σύνολο: {{vm.followUpCallsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            cancel: function(){
                vm.editMode = false;
                vm.canceled = true;
                KendoGrid.refresh(vm.followUpCallsGridOptions)
            },
            save: function(e){
                vm.editMode = false;
            }
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                vm.from = new Date(date.getFullYear(), 0, 1);
                vm.to = new Date(new Date().getFullYear(), 11, 31);
            }
            KendoToolbar.setFrom(vm.from);
            KendoToolbar.setTo(vm.to);
            KendoGrid.refresh(vm.followUpCallsGridOptions);
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "from", "to"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.from = value;
                } else {
                    vm.from = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.to = value;
                } else {
                    vm.to = null;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.customEdit = function(e) {
            angular.element("#followUpCallsGrid").data("kendoGrid")
                .editRow($(e.currentTarget).closest("tr"));
        };

        vm.onSelection = function(data) {
            /*if (!vm.editMode && !vm.canceled) $state.go('prospectivePatientInfo', {id: data.id});*/
            if ( vm.canceled ) { vm.canceled = !vm.canceled };
        };
    }
})();
;
/**
 * Created by gmogas on 15/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bricks', {
                parent: 'app',
                url: '/bricks',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/bricks/bricks.html',
                        controller: 'BricksController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 15/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BricksController', BricksController);

    BricksController.$inject = ['$http', '$filter', 'NotificationOptions', 'KendoFilter', 'KendoGrid'];

    function BricksController ($http, $filter, NotificationOptions, KendoFilter, KendoGrid) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.pageHeading = $filter('translate')('global.menu.settings.bricks');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/bricks',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        console.log(data)
                        $http.post('/api/bricks', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                notification.show({
                                    message: "Ο ταχυδρομικός αριθμός χρησιμοποιείται ήδη."
                                }, "error");
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/bricks', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                notification.show({
                                    message: "Ο ταχυδρομικός αριθμός χρησιμοποιείται ήδη."
                                }, "error");
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined){
                            data.content.forEach(function(item){

                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "microCode", title: "Μίκρο-κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "municipality", title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "territoryNo", title: "Κωδ. Διαμερίσματος",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "territoryName", title: "Διαμέρισμα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "areaNo", title: "Κωδ. Περιοχής",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "areaName", title: "Περιοχή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };
    }
})();
;
/**
 * Created by gmogas on 15/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('brick-osfes', {
                parent: 'app',
                url: '/brick-osfes',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/brick-osfes/brick-osfes.html',
                        controller: 'BrickOsfesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 15/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfesController', BrickOsfesController);

    BrickOsfesController.$inject = ['$http', '$filter', 'NotificationOptions', 'KendoFilter', 'KendoGrid'];

    function BrickOsfesController ($http, $filter, NotificationOptions, KendoFilter, KendoGrid) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.pageHeading = $filter('translate')('global.menu.settings.brickOsfes');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/brick-osfes',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        console.log(data)
                        $http.post('/api/brick-osfes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                notification.show({
                                    message: "Ο ταχυδρομικός αριθμός χρησιμοποιείται ήδη."
                                }, "error");

                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/brick-osfes', data)
                            .success(function (response) {
                                o.success(response);
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                notification.show({
                                    message: "Ο ταχυδρομικός αριθμός χρησιμοποιείται ήδη."
                                }, "error");

                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined){
                            data.content.forEach(function(item){

                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "codeGroup", title: "Κωδικός Group",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "territoryName", title: "Διαμέρισμα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "areaName", title: "Περιοχή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };
    }
})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenterPurchases', {
                parent: 'beautyCenterView',
                url: '/beautyCenterPurchases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/beautyCenters/purchases/purchases.html',
                controller: 'BeautyCenterViewPurchasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewPurchasesController', BeautyCenterViewPurchasesController);

    BeautyCenterViewPurchasesController.$inject = ['$http', '$stateParams', '$state', '$filter'];

    function BeautyCenterViewPurchasesController ($http, $stateParams, $state, $filter) {
        var vm = this;
        vm.selectedSectorId = $stateParams.id;

        vm.pageHeading = 'Παραγγελίες';

        vm.purchasesColumns = [
            {
                field: "issueDate",
                title: "Ημερομηνία",
                template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "purchaseStatus.name",
                title: "Κατάσταση",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.lastName",
                title: "Επίθετο",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "comment",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "finalPrice",
                title: "Σύνολο σε €",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            }

        ];

        vm.purchasesDatasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "sector.id", "operator": "eq",  "value": $stateParams.id }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/purchases/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema : {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        issueDate: { type: 'date', editable: false}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        vm.purchasesGridOptions = {
            dataSource: vm.purchasesDatasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  vm.purchasesColumns
        };

        vm.onSelection = function(data) {
            var selectedId = data.id;
            $state.go('purchaseItems', {id: selectedId});
        };
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenterInfo', {
                parent: 'beautyCenterView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                templateUrl: 'app/displays/beautyCenters/info/info.html',
                controller: 'BeautyCenterViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                        return Sector.get({id : $stateParams.id});
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewInfoController', BeautyCenterViewInfoController);

    BeautyCenterViewInfoController.$inject = ['$http', 'entity', 'employee', '$stateParams', 'Principal', '$scope', 'NotificationOptions', 'KendoService', 'Sector', '$timeout'];

    function BeautyCenterViewInfoController ($http, entity, employee, $stateParams, Principal, $scope, NotificationOptions, KendoService, Sector, $timeout) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.isSaving = false;
        vm.canEdit = !!Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']);
        vm.sector = entity;
        vm.selectedSectorId = $stateParams.id;
        vm.geodata = employee.data.geodata;

        vm.dataSource = {};
        vm.dropDownOptions = {};
        vm.dataSource.companyTypes = KendoService.initDefaultDataSource('/api/masterdata/company-types');
        vm.dropDownOptions.companyType = KendoService.initDefaultOptions(vm.dataSource.companyTypes, "startswith", "name", "id");
        vm.dataSource.taxOffices = KendoService.initDefaultDataSource('/api/masterdata/tax-offices');
        vm.dropDownOptions.taxOffice = KendoService.initDefaultOptions(vm.dataSource.taxOffices, "startswith", "name", "id");
        vm.dataSource.taxStatuses = KendoService.initDefaultDataSource('/api/tax-statuses/search');
        vm.dropDownOptions.taxStatus = KendoService.initDefaultOptions(vm.dataSource.taxStatuses, "startswith", "name", "id");

        if(!vm.geodata) {
            vm.dataSource.prefectures = KendoService.initDefaultDataSource('/api/masterdata/prefectures');
            vm.prefecturesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.prefectures, "startswith", "name", "id");
            vm.prefecturesComboBoxOptions.valuePrimitive = false;
            vm.prefecturesComboBoxOptions.change = function(){
                var filter = {};
                if(this.value() && !isNaN(this.value())) {
                    filter = {
                        "field": "prefecture.id",
                        "operator": "eq",
                        "value": this.value()
                    };
                }
                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
            };

            vm.dataSource.cities = KendoService.initDefaultDataSource('/api/masterdata/cities');
            vm.citiesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.cities, "startswith", "name", "id");
            vm.citiesComboBoxOptions.valuePrimitive = false;
            vm.citiesComboBoxOptions.template = "<table>${name} &nbsp;<span class='hint'>(${prefecture.name})</span></table>";
            vm.citiesComboBoxOptions.change = function(){
                var filter = {};
                if(this.dataItem(this.select())) {
                    filter = {
                        "field"   : "id",
                        "operator": "eq",
                        "value"   : this.dataItem(this.select()).prefecture.id
                    };
                }
                vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
            };
        }
        else {
            var geodataDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) o.data.filter = { filters: [] };

                        o.data.page = 1;
                        o.data.pageSize = 100;
                        $http.get('/api/masterdata/geodata', {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function () {});
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            item.masterFilter = "";
                            if(item.street !==null) {
                                item.masterFilter =  item.street + ", ";
                            }
                            item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                        });
                        return data;
                    }
                }
            });

            vm.masterFilterComboBoxOptions = {
                dataSource: geodataDataSource,
                filter: "search",
                dataTextField: "masterFilter",
                dataValueField: "id",
                headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                "<span>Διεύθυνση</span>"+
                "<span>Πόλη</span>"+
                "<span>Τ.Κ.</span>"+
                "<span>Νομός</span></div>",
                template:
                    "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                change: function(){
                    //initialize inputs (autocomplete)
                    if(this.dataItem(this.select())) {
                        var self = this;
                        //using $timeout to trigger the change
                        $timeout(function(){
                            vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                            vm.sector.cityName = self.dataItem(self.select()).city;
                            vm.sector.address = self.dataItem(self.select()).street;
                            vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                        },0);
                    }
                }
            };
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorUpdate', result);
            vm.isSaving = false;
            notification.show({
                message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
            }, "success");
        };

        var onSaveError = function () {
            vm.isSaving = false;
            notification.show({
                message: "Η ενημέρωση των στοιχείων απέτυχε!"
            }, "error");
        };

        vm.save = function () {
            vm.isSaving = true;
            Sector.update(vm.sector, onSaveSuccess, onSaveError);
        };

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };
    }

})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenterEvents', {
                parent: 'beautyCenterView',
                url: '/beautyCenterEvents',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/beautyCenters/events/events.html',
                controller: 'BeautyCenterViewEventsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewEventsController', BeautyCenterViewEventsController);

    BeautyCenterViewEventsController.$inject = ['$stateParams', '$http', '$filter', 'KendoFilter'];

    function BeautyCenterViewEventsController ($stateParams, $http, $filter, KendoFilter) {
        var vm = this;
        vm.pageHeading = 'Επισκέψεις στο κέντρο αισθητικής';
        vm.selectedSectorId = $stateParams.id;

        var urls = {};
        urls.sectorEvents = '/api/sector/'+vm.selectedSectorId+'/events';

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.events = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                        }
                    });

                    $http.get(urls.sectorEvents,{params: o.data})
                        .success(function (response) {
                            console.log(response);
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.content.forEach(function(item){

                            if (item.eventStatus === null) {
                                item.eventStatus = {};
                                item.eventStatus.name = "";
                            }

                            if(item.employee === null){
                                item.employee = {
                                    account : {
                                        lastName : ""
                                    }
                                }
                            }

                            if (item.eventCustomerSector === null) {
                                if (item.agreementValuation === null) {
                                    item.agreementValuation = {
                                        name: ""
                                    };
                                }

                                if (item.customerSector === null) {
                                    item.customerSector = {
                                        sector: {
                                            address: "",
                                            city: {
                                                name: ""
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (item.eventCustomerSector.agreementValuation === null) {
                                    item.eventCustomerSector.agreementValuation = {
                                        name: ""
                                    };
                                }
                            }

                        });
                    }
                    return data.content;
                },
                total : function(data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        name: { validation: { required: true , validation: { required: true, min: 3}} },
                        startedAt: { type: 'date'}
                    }
                }
            },
            batch: true,
            serverSorting: true,
            serverFiltering: true,
            serverPaging: true,
            pageSize: 50
        });

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.events = [
            {
                field: "startedAt",
                title: "Ημερομηνία Επίσκεψης",
                template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {
                field: "eventStatus.name",
                title: "Κατάσταση Επίσκεψης",
                attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "eventCustomerSector.agreementValuation.name",
                title: "Αξιολόγηση",
                template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null ) ? ' ' : eventCustomerSector.agreementValuation.name #",
                attributes: {
                    class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                command: [
                    {
                        name:"map2",
                        template: "<md-button class='md-fab md-mini md-primary' aria-label='Google Maps' " + "ng-class='{googlemap: vm.imageChoice(dataItem.eventCustomerSector), errormap: !vm.imageChoice(dataItem.eventCustomerSector)}' ng-click='vm.googleMapsRedirect(dataItem.eventCustomerSector)'></md-button>"
                    }
                ],
                attributes: { class: "#= 'link-cell-color' #" },
                title: "Τοποθεσία",
                width:120
            },
            {
                field: "eventCustomerSector.agreedPercent",
                title: "Ποσοστό Συχνότητας",
                template: "#= (eventCustomerSector.agreedPercent == null) ? ' ' : kendo.format('{0:p0}', eventCustomerSector.agreedPercent / 100)#",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.lastName",
                title: "Επώνυμο Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "description",
                title: "Σημειώσεις",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.gridOptions = {};
        vm.gridOptions.events = {
            dataSource: vm.dataSource.grid.events,
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.gridColumns.events
        };
    }
})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenterEmployees', {
                parent: 'beautyCenterView',
                url: '/beautyCenterEmployees',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/beautyCenters/employees/employees.html',
                controller: 'BeautyCenterViewEmployeesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 30/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewEmployeesController', BeautyCenterViewEmployeesController);

    BeautyCenterViewEmployeesController.$inject = ['$http', '$stateParams', 'EmployeeCustomerSector'];

    function BeautyCenterViewEmployeesController ($http, $stateParams, EmployeeCustomerSector) {
        var vm = this;
        var grid = angular.element('#employeesGrid');
        var modal = angular.element('#popup-employee-customer-sector');
        var multiSelect = angular.element('#employees');

        vm.selectedSectorId = $stateParams.id;
        vm.selectedEmployeeCustomerSector = {};
        vm.selectedEmployeeCustomerSectors = [];
        vm.currentEmployeeCustomerSectors = [];
        vm.pageHeading = 'Ιατρικοί Επισκέπτες που επισκέπτονται το κέντρο αισθητικής';

        var urls = {};
        urls.sectorEmployees = '/api/sectors/'+vm.selectedSectorId+'/employees';

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.employee = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    $http.get(urls.sectorEmployees,{})
                        .success(function (response) {
                            vm.currentEmployeeCustomerSectors = response;
                            if( multiSelect.data('kendoMultiSelect')) multiSelect.data('kendoMultiSelect').dataSource.read();
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            batch: true,
            pageSize: 100,
            scrollable:false
        });

        vm.modalWindowOptions = {
            title: "Επιλέξτε ιατρικό επισκέπτη/τες",
            visible: false,
            modal: true,
            resizable: true,
            width: 800,
            height: 300
        };

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.employee = [
            {
                field: "employee.account.lastName",
                title: "Επώνυμο"
            },
            {
                field: "employee.account.firstName",
                title: "Όνομα"
            },
            {
                field: "employee.account.login",
                title: "Χρήστης"
            },
            {
                field: "employee.phone",
                title: "Τηλέφωνο"
            },
            {
                command:
                {
                    name: "delete",
                    text: "ΔΙΑΓΡΑΦΗ",
                    click: deleteButtonPush,
                    className: "k-i-cancel"
                },
                title: "&nbsp;"
            }
        ];

        vm.options = {};
        vm.options.employees = {
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = {filters: []};
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "account.authorities.name", "operator": "in",
                                    "value": "ROLE_BC_VISITOR", "ignoreCase": true}
                            ]
                        );

                        o.data.page = 1;
                        o.data.pageSize = 10000;
                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response, status, headers) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            //define object for data binding
                            if(item.account != null) {
                                item.active = true;
                                item.employee = {
                                    account : {
                                        fullName: item.account.lastName + " " + item.account.firstName
                                    },
                                    id: item.id
                                }
                            }
                        });

                        var filteredData = [];

                        data.forEach(function (item) {
                            var found = false;
                            vm.currentEmployeeCustomerSectors.forEach(function (ecs) {
                                if (ecs.employee.id == item.id) {
                                    found = true;
                                }
                            })
                            if (!found) {
                                filteredData.push(item);
                            }
                        });

                         return filteredData;
                    }
                }
            }),
            valuePrimitive: false,
            dataTextField: "employee.account.fullName",
            dataValueField: "employee.id"
        };


        vm.gridOptions = {};
        vm.gridOptions.employee = {
            dataSource: vm.dataSource.grid.employee,
            resizable: true,
            columns: vm.gridColumns.employee,
            toolbar: [
                {
                    name: "New Employee Customer Sector",
                    text: "New Employee Customer Sector",
                    template: "<input type='button' class='k-button' value = 'Ανάθεση σε ιατρικό επισκέπτη/τες' ng-click='vm.openModalWindow()' />"
                }
            ]
        };

        vm.openModalWindow = function() {
            modal.data("kendoWindow").center().open();
        };

        vm.closeModalWindow = function() {
            modal.data("kendoWindow").close();
        };

        function deleteButtonPush(e) {
            e.preventDefault();
            vm.selectedEmployeeCustomerSector = this.dataItem($(e.currentTarget).closest("tr"));
            vm.selectedEmployeeCustomerSector.active = false;
            EmployeeCustomerSector.update(vm.selectedEmployeeCustomerSector, onDeleteSaveSuccess, onDeleteSaveError);
        }

        vm.add = function () {
            var postData = [];
            vm.selectedEmployeeCustomerSectors.forEach(function (item) {
                var newPost = {};
                newPost.active = true;
                newPost.sector = {};
                newPost.sector.id = vm.selectedSectorId;
                newPost.employee = {};
                newPost.employee.id = item.id;
                postData.push(newPost)
            });

            $http.post('api/employee-customer-sectors/mass', postData, {}).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.selectedEmployeeCustomerSectors = [];
            grid.data('kendoGrid').dataSource.read();
            vm.closeModalWindow();
        }

        function onSaveError() {
            console.error("Error on saving vm.selectedEmployeeCustomerSectors");
        }

        function onDeleteSaveSuccess(result) {
            grid.data('kendoGrid').dataSource.read();
        }

        function onDeleteSaveError() {
            console.error("Error on saving vm.selectedEmployeeCustomerSector");
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenterCustomers', {
                parent: 'beautyCenterView',
                url: '/beautyCenterCustomers',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                templateUrl: 'app/displays/beautyCenters/customers/customers.html',
                controller: 'BeautyCenterViewCustomersController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewCustomersController', BeautyCenterViewCustomersController);

    BeautyCenterViewCustomersController.$inject = ['$http', '$stateParams', 'Principal', 'Customer', 'CustomerSector', 'KendoGrid'];

    function BeautyCenterViewCustomersController ($http, $stateParams, Principal, Customer, CustomerSector, KendoGrid) {
        var vm = this;

        vm.canEditCustomerSector = Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_MANAGEMENT'])
        vm.selectedSectorId = $stateParams.id;
        vm.selectedCustomerTypes = [];
        vm.pageHeading = 'Επαφές Κέντρου Αισθητικής';
        vm.editableItem = {};

        var urls = {};
        urls.sectorCustomerSectors = '/api/sectors/'+vm.selectedSectorId+'/customer-sectors';

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.customerSector = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    $http.get(urls.sectorCustomerSectors,{})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                },
                create: function (o) {
                    Customer.save(o.data.customer,
                        function(result) {
                            o.data.customer = result;
                            CustomerSector.save(o.data,
                                function() {
                                    vm.gridOptions.customerSector.dataSource.read();
                                }, onCustomerSectorSaveError);
                        }, onCustomerSaveError);
                },
                update: function (o) {
                    Customer.update(o.data.customer,
                        function(result) {
                            o.data.customer = result;
                            CustomerSector.update(o.data,
                                function() {
                                    vm.gridOptions.customerSector.dataSource.read();
                                }, onCustomerSectorSaveError);
                        }, onCustomerSaveError);
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.forEach(function(item) {
                            item.types = "";
                            if (item.customer != null && item.customer.customerTypes != null) {
                                item.customer.customerTypes.forEach(function (type) {
                                    if (item.types === "") {
                                        item.types = type.name;
                                    } else {
                                        item.types = item.types + ", " + type.name;
                                    }
                                })
                            }
                        });
                    }
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        startedAt: { type: 'date', defaultValue: new Date()},
                        endedAt: { type: 'date', defaultValue : null},
                        customer: { defaultValue: {} }
                    }
                }
            },
            pageSize: 100,
            scrollable:false
        });

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.customerSector = [
            {
                hidden: !vm.canEditCustomerSector,
                command:
                    {
                        name: "edit",
                        text: ""
                    },
                title: "&nbsp;",
                width: 80
            },
            {
                field: "types",
                title: "Θέση",
                filterable: false
            },
            {
                field: "customer.lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.amka",
                title: "Α.Μ.Κ.Α.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.cellPhone",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.phone",
                title: "Σταθερό Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "startedAt",
                template: "#= startedAt ? kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy') : ''#",
                title: "Από",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "endedAt",
                template: "#= endedAt ? kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy') : ''#",
                title: "Έως",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            }
        ];

        vm.customerTypes = [
            {id : 6, name : "ΥΠΕΥΘΥΝΟΣ ΚΕΝΤΡΟΥ"}
        ];

        vm.options = {};
        vm.options.customerTypes = {
            dataTextField: "name",
            dataValueField: "id",
            valuePrimitive: true,
            autoBind: true,
            dataSource: {
                data : vm.customerTypes
            }
        };

        vm.gridOptions = {};
        vm.gridOptions.customerSector = {
            dataSource: vm.dataSource.grid.customerSector,
            resizable: true,
            selectable: true,
            columns: vm.gridColumns.customerSector,
            toolbar: [ {name :"create", text: "Προσθήκη Νέας επαφής"} ],
            editable: {
                mode: "popup",
                template: kendo.template(angular.element("#popup-customer").html())
            },
            edit: function (e) {
                e.model.dirty = true;
                e.model.sector = { id: vm.selectedSectorId };
                if(e.model.isNew()) {
                    e.model.set("customer.customerTypes", vm.customerTypes);
                }

                KendoGrid.defaultEditPopup(this._editContainer);
            }
        };

        var onCustomerSaveError = function() {
            console.log("error on saving the customer");
        };

        var onCustomerSectorSaveError = function() {
            console.log("error on saving the customer sector");
        };
    }
})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCenterViewController', BeautyCenterViewController);

    BeautyCenterViewController.$inject = ['$http','$state', '$stateParams', 'Principal'];

    function BeautyCenterViewController ($http, $state, $stateParams, Principal) {
        var vm = this;

        vm.pageHeading = 'Φαρμακείο';
        vm.profilePicture = "lotus_icon.png";
        vm.selectedSectorId = $stateParams.id;
        vm.$state = $state;


        $http.get('api/sectors/' + vm.selectedSectorId)
            .success(function (response) {
                vm.sector = response;
            })
            .error(function (response) {
                console.log(response);
            });

        kendo.Backbone = kendo.Backbone || {};

        kendo.Backbone.DataSource = kendo.data.DataSource.extend({
            init: function(options) {
                if (options.transport && options.transport.read) {
                    options.transport.read.type = 'GET';
                    options.transport.read.dataType = 'json';
                    options.transport.read.contentType = 'application/json;charset=UTF-8';
                    options.transport.read.parameterMap = function (data, operation) {
                        return JSON.stringify(data);
                    }
                }
                kendo.data.DataSource.fn.init.call(this, options);
            }
        });
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenters', {
                parent: 'app',
                url: '/beautyCenters',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/beautyCenters/beautyCenters.html',
                        controller: 'BeautyCentersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('beautyCenterView', {
                abstract: true,
                parent: 'app',
                url: '/beautyCenters/search?id:beautyCenterId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/beautyCenters/beautyCenterView.html',
                        controller: 'BeautyCenterViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 29/11/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BeautyCentersController', BeautyCentersController);

    BeautyCentersController.$inject = ['$timeout', '$state', '$http','employee','$filter', 'Principal', 'KendoService', 'KendoGrid','KendoFilter'];

    function BeautyCentersController ($timeout, $state, $http, employee, $filter, Principal, KendoService, KendoGrid, KendoFilter) {
        var vm = this;
        var beautyCentersGrid = angular.element('#beautyCentersGrid');
        vm.geodata = employee.data.geodata;
        vm.canCreateSector = Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN']);
        vm.showFilters = false;
        vm.showFilters = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']);
        vm.mToolbar = [];
        if (Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR'])){
            vm.mToolbar = [{name: "create", text: "Προσθήκη Νέας εγγραφής"}];
        }

        vm.selectedEmployees = vm.selectedSupervisors = [];
        vm.sector= {};
        var comboBoxes = ["#masterFilter","#prefectures", "#cities"];

        vm.isSaving = false;

        vm.pageHeading = 'Κεντρα Αισθητικης';

        vm.dataSource = {};
        vm.dataSource.companyTypes = KendoService.initDefaultDataSource('/api/masterdata/company-types');
        vm.companyTypesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.companyTypes, "startswith", "name", "id");
        vm.dataSource.taxOffices = KendoService.initDefaultDataSource('/api/masterdata/tax-offices');
        vm.taxOfficesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.taxOffices, "startswith", "name", "id");
        vm.dataSource.taxStatuses = KendoService.initDefaultDataSource('/api/tax-statuses/search');
        vm.taxStatusesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.taxStatuses, "startswith", "name", "id");

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        if(!vm.geodata) {
            vm.dataSource.prefectures = KendoService.initDefaultDataSource('/api/masterdata/prefectures');
            vm.prefecturesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.prefectures, "startswith", "name", "id");
            vm.prefecturesComboBoxOptions.valuePrimitive = false;
            vm.prefecturesComboBoxOptions.change = function(){
                var filter = {};
                if(this.value() && !isNaN(this.value())) {
                    filter = {
                        "field": "prefecture.id",
                        "operator": "eq",
                        "value": this.value()
                    };
                }
                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
            };

            vm.dataSource.cities = KendoService.initDefaultDataSource('/api/masterdata/cities');
            vm.citiesComboBoxOptions = KendoService.initDefaultOptions(vm.dataSource.cities, "startswith", "name", "id");
            vm.citiesComboBoxOptions.valuePrimitive = false;
            vm.citiesComboBoxOptions.template = "<table>${name} &nbsp;<span class='hint'>(${prefecture.name})</span></table>";
            vm.citiesComboBoxOptions.change = function(){
                var filter = {};
                if(this.dataItem(this.select())) {
                    filter = {
                        "field"   : "id",
                        "operator": "eq",
                        "value"   : this.dataItem(this.select()).prefecture.id
                    };
                }
                vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
            };
        }
        else {
            var geodataDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) o.data.filter = { filters: [] };

                        o.data.page = 1;
                        o.data.pageSize = 100;
                        $http.get('/api/masterdata/geodata', {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function () {});
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            item.masterFilter = "";
                            if(item.street !==null) {
                                item.masterFilter =  item.street + ", ";
                            }
                            item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                        });
                        return data;
                    }
                }
            });

            vm.masterFilterComboBoxOptions = {
                dataSource: geodataDataSource,
                filter: "search",
                dataTextField: "masterFilter",
                dataValueField: "id",
                headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                    "<span>Διεύθυνση</span>"+
                    "<span>Πόλη</span>"+
                    "<span>Τ.Κ.</span>"+
                    "<span>Νομός</span></div>",
                template:
                    "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                change: function(){
                    //initialize inputs (autocomplete)
                    if(this.dataItem(this.select())) {
                        var self = this;
                        //using $timeout to trigger the change
                        $timeout(function(){
                            vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                            vm.sector.cityName = self.dataItem(self.select()).city;
                            vm.sector.address = self.dataItem(self.select()).street;
                            vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                        },0);
                    }
                }
            };
        }

        vm.gridColumns = [
            {
                hidden: !vm.canCreateSector,
                command: [
                    {name: "edit", text: ""}
                ],
                title: "&nbsp;",
                width: 80
            },
            {
                field: "code",
                title: "Κωδικός Ε.Ε.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "name",
                title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "addressNum",
                title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "createdDate",
                title: "Ημερομηνία εισαγωγής",
                template: "#= kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm')#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="selectable" ng-model="dataItem.creditControlCheck" ' +
            'ng-disabled="true"></md-checkbox>',
                field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }}
        ];
        vm.beautyCentersGridOptions = {
                    dataSource: new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) o.data.filter = { filters: [] };

                                //master filters functionality
                                if(vm.from && vm.to) {
                                    o.data.filter.filters = o.data.filter.filters.concat(
                                        [
                                            { "field": "createdDate", "operator": "from",
                                                "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                            { "field": "createdDate", "operator": "to",
                                                "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                        ]
                                    );
                                }

                                if (vm.selectedEmployees.length > 0)
                                    o.data.selectedEmployeeIds = vm.selectedEmployees.toString();

                                if(vm.selectedSupervisors.length && !vm.selectedEmployees.length)
                                    o.data.selectedSupervisorIds = vm.selectedSupervisors.toString();

                                angular.forEach( o.data.filter.filters, function(item) {
                                    if ( item.value instanceof Date)
                                        item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                });

                                $http.get('/api/me/beauty-centers',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function () {});
                            },
                            create: function (o){
                                var data = o.data.models[0];
                                var params = {
                                    filter: { filters: [{ "field": "sectorTypeCategory", "operator": "startswith",  "value": "beautyCenter"}] },
                                    page: 1,
                                    pageSize: 1
                                };

                                $http.get('/api/masterdata/sector-types', {params: params})
                                    .success(function (response) {
                                        data.sectorType = response.content[0];

                                        if(!data.companyType.id) data.companyType = null;
                                        if(!data.taxStatus.id) data.taxStatus = null;
                                        if(!data.taxOffice.id) data.taxOffice = null;
                                        if(!data.city.id) data.city = null;
                                        if(!data.prefecture.id) data.prefecture = null;

                                        if(vm.sector.city != null && (vm.sector.city.id === null || isNaN(vm.sector.city.id))){
                                            vm.sector.city = null;
                                        }

                                        if(vm.sector.prefecture != null && (vm.sector.prefecture.id === null || isNaN(vm.sector.prefecture.id))){
                                            vm.sector.prefecture = null;
                                        }

                                        angular.extend(data, vm.sector);

                                        $http.post('/api/sectors', data)
                                            .success(function (response) {
                                                beautyCentersGrid.data("kendoGrid").dataSource.read();
                                                vm.onSelection(response);
                                            })
                                            .error(function (response) {});
                                    })
                                    .error(function (response) {});
                            },
                            update: function (o){

                                var data = o.data.models[0];
                                var params = {
                                    filter: { filters: [{ "field": "sectorTypeCategory", "operator": "startswith",  "value": "beautyCenter"}] },
                                    page: 1,
                                    pageSize: 1
                                };

                                $http.get('/api/masterdata/sector-types', {params: params})
                                    .success(function (response) {
                                        data.sectorType = response.content[0];

                                        if(!data.companyType.id) data.companyType = vm.sector.companyType = null;
                                        if(!data.taxStatus.id) data.taxStatus = vm.sector.taxStatus = null;
                                        if(!data.taxOffice.id) data.taxOffice = vm.sector.taxOffice = null;

                                        if(vm.sector.city != null) {
                                            if((vm.sector.city.id === null
                                                    || vm.sector.city.id === undefined || isNaN(vm.sector.city.id)) || vm.geodata){
                                                vm.sector.city = null;
                                            }
                                        }

                                        if(vm.sector.prefecture != null) {
                                            if((vm.sector.prefecture.id === null
                                                    || vm.sector.prefecture.id === undefined || isNaN(vm.sector.prefecture.id)) || vm.geodata){
                                                vm.sector.prefecture = null;
                                            }
                                        }

                                        angular.extend(data, vm.sector);

                                        $http.put('/api/sectors', data)
                                            .success(function () {
                                                beautyCentersGrid.data("kendoGrid").dataSource.read();
                                            })
                                            .error(function () {});
                                    })
                                    .error(function () {});
                            }
                        },
                        schema : {
                            data: function (data) {
                                angular.forEach( data.content, function (item) {
                                    if ( item.companyType == null ) item.companyType = {};
                                    if ( item.taxStatus == null ) item.taxStatus = {};
                                    if ( item.taxOffice == null ) item.taxOffice = {};
                                });
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: "id",
                                    name : { editable: false },
                                    vat : { editable: false },
                                    address : { editable: false },
                                    addressNum : { editable: false },
                                    cityName : { editable: false },
                                    prefectureName : { editable: false },
                                    phone : { editable: false },
                                    createdDate: { type: 'date', editable: false},
                                    companyType: { defaultValue: { id: null, name: null }},
                                    taxStatus: { defaultValue: { id: null, name: null }},
                                    taxOffice: { defaultValue: { id: null, name: null }},
                                    creditControlCheck: { type: "boolean" }
                                }
                            }
                        },
                        pageSize: 100,
                        serverPaging: true,
                        serverSorting: true,
                        scrollable:false,
                        serverFiltering :true
                    }),
                    sortable: true,
                    pageable: true,
                    filterable: {
                        mode: "row"
                    },
                    resizable: true,
                    selectable: true,
                    columns:  vm.gridColumns,
                    editable: {
                        mode: "popup",
                        template: kendo.template(angular.element("#popup_editor_beautyCenters").html())
                    },
                    edit: function(e) {
                        e.model.dirty = true;
                        vm.selectedSector = e.model;

                        if(e.model.id) vm.sector = vm.selectedSector;
                        else vm.sector= {};

                        //refresh kendoComboBox
                        if(e.model.isNew()) {
                            angular.forEach(comboBoxes, function (item) {
                                var comboBox = angular.element(item).data("kendoComboBox");
                                if (comboBox) {
                                    vm.refreshCombobox({}, comboBox.dataSource);
                                }
                            });
                        }

                        if(!e.model.isNew()) {
                            if(e.model.prefecture && !vm.geodata){
                                var filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": e.model.prefecture.id
                                };

                                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                            }

                            if(e.model.city && !vm.geodata){
                                var filterCity = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : e.model.city.prefecture.id
                                };

                                vm.refreshCombobox(filterCity, vm.prefecturesComboBoxOptions.dataSource);
                            }
                        }

                        //if geodata init city and prefecture
                        if(!e.model.city) e.model.city = {};
                        if(!e.model.prefecture) e.model.prefecture = {};

                        KendoGrid.defaultCustomEditPopup(this._editContainer, 1000, 990);
                        angular.element(e.container).data("kendoWindow").center();
                    },
                    cancel: function() { beautyCentersGrid.data("kendoGrid").dataSource.read(); },
                    //toolbar: [{name: "create", text: "Προσθήκη Νέας εγγραφής"}]
                    toolbar: vm.mToolbar
                };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id === "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id === "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            beautyCentersGrid.data("kendoGrid").dataSource.read();
        };

        vm.employeesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';

                    if (o.data.filter == undefined) o.data.filter = { filters: [] };
                    if (o.data.sort == undefined || !o.data.sort.length) o.data.sort = { "field": "account.lastName",  "dir": "asc" };

                    if(vm.selectedSupervisors.length) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                                [{ "field": "supervisor.id", "operator": "in", "value": vm.selectedSupervisors.toString() }]);
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.activated", "operator": "eqbool",
                                "value": true }
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url, {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function () {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: { fullName: item.account.lastName + " " + item.account.firstName } };
                    });
                    return data;
                }
            }
        });
        vm.employeesMultiOptions = {
            dataSource: vm.employeesMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή ιατρικού επισκέπτη",
            change: function () {
                beautyCentersGrid.data("kendoGrid").dataSource.read();
            }
        };

        vm.supervisorsMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter == undefined) o.data.filter = { filters: [] };
                    if (o.data.sort == undefined || !o.data.sort.length) o.data.sort = { "field": "account.lastName",  "dir": "asc" };

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [{ "field": "account.authorities", "operator": "eq", "value": "ROLE_SUPERVISOR" },
                        { "field": "account.activated", "operator": "eqbool", "value": true }]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url, {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function () {});
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: { fullName: item.account.lastName + " " + item.account.firstName }
                        };
                    });
                    return data;
                }
            }
        });
        vm.supervisorsMultiOptions = {
            dataSource: vm.supervisorsMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή προισταμένου",
            change: function () {
                vm.employeesMulti.value('');
                vm.selectedEmployees = [];
                vm.employeesMulti.dataSource.read();
                beautyCentersGrid.data("kendoGrid").dataSource.read();
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                },
                { type: "separator" },
                { type: "separator" },
                {
                    template: "<label ng-if='vm.showFilters'>Ιατρικός Επισκέπτης: </label>"
                },
                {
                    template: "<input ng-if='vm.showFilters' id='multiSelect' style='width: 200px;' class='inline' multiple='multiple' k-options='vm.employeesMultiOptions' k-ng-model='vm.selectedEmployees' kendo-multi-select='vm.employeesMulti'/>",
                    overflow: "never"
                },
                {
                    template: "<label ng-if='vm.showFilters'>Προιστάμενος: </label>"
                },
                {
                    template: "<input ng-if='vm.showFilters' id='multiSelect' style='width: 200px;' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.selectedSupervisors'></input>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.from = value;
                }
                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.to = value;
                }
                vm.masterFiltersOnClick(e);
            }
        };

        vm.onSelection = function(data) {
            var sectorId = data.id;
            $state.go('beautyCenterInfo', {id: sectorId});
        };

    }
})();
;
/**
 * Created by Kristy on 29/8/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('previewAssignations', {
                parent: 'assignations',
                url: '/previewAssignations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/assignations/transfers/preview/preview.html',
                controller: 'PreviewAssignationsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 29/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PreviewAssignationsController', PreviewAssignationsController);

    PreviewAssignationsController.$inject = ['$filter', '$scope','$http', '$state', '$mdToast', 'Assignations', 'NotificationOptions', 'KendoFilter', 'CustomUtils'];

    function PreviewAssignationsController ($filter, $scope, $http, $state, $mdToast, Assignations, NotificationOptions, KendoFilter, CustomUtils) {
        var vm = this;

        vm.success = vm.error = "";
        vm.allSelected = false;
        vm.employee = Assignations.getEmployee();
        vm.disableSave = !!(!Assignations.getEmployee() || !Assignations.getSelectedCustomerSectors().length);
        vm.copy = Assignations.isCopy();
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.assign = function () {
            var customerSectors = Assignations.getSelectedCustomerSectors();
            var employees = Assignations.getEmployees();
            var employeeID = Assignations.getEmployee().id;

            angular.forEach(customerSectors, function(customerSector) {
                angular.forEach(customerSector.employeeCustomerSectors, function(employee) {
                    if(employees && employees.indexOf(employee.id) !== -1) {
                        employee.id = employeeID;
                    }
                })
            });

            var assignations = {
                "copy": vm.copy,
                "employeeToId": employeeID,
                "employeeFromIds": employees,
                "customerSectors": customerSectors
            };

            $mdToast.show({
                hideDelay   : 0,
                position    : 'top right',
                controller  : 'ToastCtrl',
                templateUrl : 'app/components/md-toast/toast-template.html'
            });
            vm.disableSave = true;
            $http.post('/api/customer-sectors/mass', assignations)
                .success(function () {
                    $mdToast
                        .hide()
                        .then(function () {
                        });
                    notification.show({
                        message: "Η μαζική ανάθεση πραγματοποιήθηκε με επιτυχία!"
                    }, "success");
                })
                .error(function (response) {
                    $mdToast
                        .hide()
                        .then(function () {
                        });
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });
        };

        vm.toolbarPreviewOptions = {
            items: [
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ui-sref='customerSectorsAssignations'>" +
                    "<md-icon class='arrow-left'></md-icon>Προηγούμενο</md-button>"
                },
                { template: "<label>{{ vm.copy ? 'Αντιγραφή' : 'Μεταφορά' }} επιλεγμένου τομέα/πελατολογίου στον ιατρικό επισκέπτη </label>" },
                {
                    template: "<md-input-container class='md-block' flex-gt-sm=''>" +
                                "<md-icon class='assignment-ind'></md-icon><input aria-label='employee' ng-model='vm.employee.employee.account.fullName' ng-readonly='true'>" +
                            "</md-input-container>",
                    overflow: "never"
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ng-click='vm.assign()' ng-disabled='vm.disableSave'>" +
                    "Τέλος<md-icon class='done'></md-icon></md-button>",
                    attributes: { class: "right" }
                }
            ]
        };

        vm.removeItem = function(id) {
            var gridData = vm.previewGridOptions.dataSource.data();
            angular.forEach(gridData, function (item) {
                if (item.id.toString() === id.toString()){
                    gridData.remove(item);
                }
            });
            Assignations.setSelectedCustomerSectors(gridData);
        };

        vm.toggleSelectAll = function (ev) {
            vm.allSelected = !vm.allSelected;
            var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid");
            angular.forEach( grid.dataSource.data(), function( dataItem ) {
                dataItem.myTarget = vm.allSelected;
            });
        };

        vm.onMyTargetClick = function (dataItem) {
            dataItem.myTarget = !dataItem.myTarget;
            if (!dataItem.myTarget) {
                vm.allSelected = dataItem.myTarget;
            }
        };

        vm.gridColumns = [
            { field:"id", filterable: false, hidden : true },
            { title: "Επαγγελματίας Υγείας",
                columns: [
                    { field: "customer.lastName", title: "Επώνυμο",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "customer.firstName", title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "customer.doctorSpecialty.name", title: "Ειδικότητα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            { title: "Μονάδα Υγείας",
                columns: [
                    { field: "sector.name", title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.address", title: "Διεύθυνση",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.cityName", title: "Πόλη",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.postalCode", title: "Τ.Κ",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.prefectureName", title: "Νομός",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            { "template": "<md-checkbox ng-click='vm.onMyTargetClick( dataItem );' aria-label='myTarget' ng-checked='dataItem.myTarget' " +
                            "class='checkbox-toolbar green inline'></md-checkbox>", width: 90,
                title: "<label>My Target</label>" +
                        "<input id='checkboxMyTarget' type='checkbox' class='checkbox' ng-checked='vm.allSelected' " +
                        "ng-click='vm.toggleSelectAll($event)'/>" },
            { "template": "<md-button class='md-icon-button' aria-label='Remove' ng-click='vm.removeItem(#=id#)'>" +
            "<md-icon class='remove'></md-icon></md-button>", width: 90 }
        ];

        vm.previewGridOptions = {
            dataSource: new kendo.data.DataSource({
                data  : Assignations.getSelectedCustomerSectors(),
                schema: {
                    model: {
                        id: "id"
                    }
                },
                pageSize: 200
            }),
            height: CustomUtils.getHeightPixelsFromPercentage(55),
            sortable: true,
            scrollable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.previewGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }
})();
;
/**
 * Created by Kristy on 28/7/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerSectorsAssignations', {
                parent: 'assignations',
                url: '/customerSectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/assignations/transfers/customerSectors/customerSectors.html',
                controller: 'CustomerSectorsAssignationsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 28/7/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorsAssignationsController', CustomerSectorsAssignationsController);

    CustomerSectorsAssignationsController.$inject = ['$http', '$timeout', 'Assignations', 'KendoFilter', 'MasterFiltersService', 'CustomUtils'];

    function CustomerSectorsAssignationsController ($http, $timeout, Assignations, KendoFilter, MasterFiltersService, CustomUtils) {
        var vm = this;

        vm.selectedEmployees = [];
        vm.massSelect = vm.myTarget = true;
        Assignations.setCopy(false);
        vm.copy = Assignations.isCopy();

        vm.toggleIsCopy = function() {
            vm.copy=!vm.copy;
            Assignations.setCopy(vm.copy);
        };

        vm.employeesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';

                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities.name", "operator": "in",
                                "value": "ROLE_HEALTH_VISITOR", "ignoreCase": true}
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });


                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        };
                    });
                    return data;
                }
            }
        });

        vm.employeesMultiSelectOptions = {
            dataSource: vm.employeesDataSource,
            change: function (e) {
                if (vm.selectedEmployees) {
                    Assignations.setEmployees(vm.selectedEmployees);

                    vm.customerSectorGridOptions.dataSource.read();
                }
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή ιατρικού επισκέπτη/επισκεπτών"
        };

        vm.employeesComboBoxOptions = {
            dataSource: vm.employeesDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή ιατρικού επισκέπτη",
            change: function() {
                Assignations.setEmployee(this.dataItem(this.select()));
            }
        };

        vm.toolbarOptions = {
            items: [
                { template: "<label>{{ vm.copy ? 'Αντιγραφή' : 'Μεταφορά' }} τομέα/πελατολογίου από ιατρικό επισκέπτη </label>" },
                {
                    template: "<select id='multiSelect' name='multiSelect' kendo-multi-select multiple='multiple' " +
                    "k-ng-model='vm.selectedEmployees' k-options='vm.employeesMultiSelectOptions'></select>",
                    overflow: "never"
                },
                { template: "<label>σε ιατρικό επισκέπτη </label>" },
                {
                    template: "<select id='comboBox' name='comboBox' kendo-combo-box k-options='vm.employeesComboBoxOptions' k-ng-model='vm.newEmployee'></select>",
                    overflow: "never"
                },
                { template: "<label>My Target: </label>" },
                {
                    template: "<md-checkbox aria-label='myTarget' ng-checked='vm.myTarget' ng-click='vm.myTarget=!vm.myTarget; vm.customerSectorGridOptions.dataSource.read()' class='checkbox-toolbar green'></md-checkbox>"
                },
                { template: "<label>Αντιγραφή πελατολογίου: </label>" },
                {
                    template: "<md-checkbox aria-label='copy' ng-checked='vm.copy' ng-click='vm.toggleIsCopy()' class='checkbox-toolbar green'></md-checkbox>"
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-warn' ui-sref='previewAssignations'>Επόμενο" +
                    "<md-icon class='arrow-right'></md-icon></md-button>", attributes: { class: "right" }
                }
            ]
        };

        vm.gridColumns = [
            { field:"id", filterable: false, hidden : true },
            { title: "Επαγγελματίας Υγείας",
                columns: [
                    { field: "customer.lastName", title: "Επώνυμο",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "customer.firstName", title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "customer.doctorSpecialty.name", title: "Ειδικότητα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            { title: "Μονάδα Υγείας",
                columns: [
                    { field: "sector.name", title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.sectorType.name", title: "Τύπος",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.address", title: "Διεύθυνση",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.cityName", title: "Πόλη",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.postalCode", title: "Τ.Κ",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    { field: "sector.prefectureName", title: "Νομός",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {field: "sector.brick", title: "Brick",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {field: "sector.osfeBrick", title: "Brick ΟΣΦΕ",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            }
        ];

        vm.customerSectorGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "customer.lastName",  "dir": "asc" };
                        }

                        if (vm.selectedEmployees.length) {
                            o.data.filter.filters.push(
                                {
                                    "field": "employee.id", "operator": "in",
                                    "value": vm.selectedEmployees.toString()
                                },
                                {
                                    "field": "customerSectors.employeeCustomerSectors.myTarget", "operator": "eqbool",
                                    "value": vm.myTarget
                                }
                            );

                            $http.get('/api/me/customer-sectors/assignations',
                                {params: o.data})
                                .success(function (response,status,headers) {
                                    o.success(response);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        } else {
                            o.success([]);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.forEach(function(item){
                                if(item.customer.doctorSpecialty === null){
                                    item.customer.doctorSpecialty = {
                                        name: ""
                                    };
                                }
                            });
                        }
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            sector: {defaultValue : { id : null, name : ""}},
                            customer: { defaultValue : { id : null, firstName : "", lastName : ""}}
                        }
                    }
                },
                pageSize: 200
            }),
            selectedItems: function(dataItems) {
                Assignations.setSelectedCustomerSectors(dataItems);
            },
            height: CustomUtils.getHeightPixelsFromPercentage(56),
            sortable: true,
            scrollable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns: vm.gridColumns/*,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.customerSectorGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]*/
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Kristy on 30/8/2016.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('Assignations', Assignations);

    Assignations.$inject = ['$filter'];
    function Assignations ($filter) {
        var selectedCustomerSectors,
            employees = [];
        var employee, copy;

        return {
            getSelectedCustomerSectors: function () {
                return selectedCustomerSectors;
            },
            setSelectedCustomerSectors: function (value) {
                selectedCustomerSectors = value;
            },
            getEmployees: function () {
                return employees;
            },
            setEmployees: function (value) {
                employees = value;
            },
            getEmployee: function () {
                return employee;
            },
            setEmployee: function (value) {
                employee = value;
            },
            isCopy: function () {
                return copy;
            },
            setCopy: function (value) {
                copy = value;
            }
        };

    }
})();
;
/**
 * Created by Teo on 06/11/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('deletions', {
                parent: 'assignations',
                url: '/deletions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/assignations/deletions/deletions.html',
                controller: 'DeletionsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    healthVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_HEALTH_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data.sort(compare)});

                        /**
                         * Compare function for sorting by fullName
                         */
                        function compare(a, b) {
                            if ( a.fullName < b.fullName ){
                                return -1;
                            }
                            if ( a.fullName > b.fullName ){
                                return 1;
                            }
                            return 0;
                        }
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 06/11/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DeletionsController', DeletionsController);

    DeletionsController.$inject = ['$http', '$filter', 'KendoFilter', 'CustomUtils', '$timeout', 'Alerts', 'healthVisitors', 'customersView'];

    function DeletionsController ($http, $filter, KendoFilter, CustomUtils, $timeout, Alerts, healthVisitors, customersView) {
        var vm = this;
        vm.showProgress = false;
        vm.customerView = customersView.data.content[0].value;
        vm.selectedEmployeeId = null;
        vm.masterFilters = { myTarget: true };
        vm.selectedCustomersIds = [];

        var filterTemplate = function (args) { KendoFilter.getTemplate(args); };

        vm.employeeOptions = {
            dataSource: {
                data: healthVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "Επιλέξτε Ιατρικό Επισκέπτη",
            change: function () {
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.deleteSelected = function (ev) {
            var numberOfCustomersToDelete = vm.selectedCustomersIds.length;
            Alerts.showConfirmDialog(ev, "Sigma SalesForce", "Διαγραφή των " + numberOfCustomersToDelete + " επιλεγμένων Επαγγελματιών Υγείας από τον Ιατρικό Επισκέπτη?", false, "ΝΑΙ", "OXI", function () {
                vm.showProgress = true;
                $http.post('/api/employee-customer-sectors/deactivate', vm.selectedCustomersIds)
                    .success(function (response) {
                        vm.showProgress = false;
                        vm.mainGridOptions.dataSource.read();
                        Alerts.showAlert("Sigma SalesForce", "Διαγράφτηκαν επιτυχώς " + response + " από " + numberOfCustomersToDelete + " Επαγγελματίες Υγείας", "OK");
                    })
                    .error(function (error) {
                        console.log(error);
                        vm.showProgress = false;
                        vm.mainGridOptions.dataSource.read();
                        Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά την διαγραφή των Επαγγελματιών Υγείας", "OK");
                    });
            }, function () {});
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (vm.selectedEmployeeId !== null && vm.selectedEmployeeId !== undefined) {
                            o.data.filter = {filters: []};

                            o.data.filter.filters.push({
                                field: "employee.id",
                                operator: "eq",
                                value: vm.selectedEmployeeId
                            });

                            // MyTarget
                            o.data.filter.filters.push({
                                field: "myTarget",
                                operator: "eqbool",
                                "value": vm.masterFilters.myTarget
                            });

                            // Ενεργοί
                            o.data.filter.filters.push({
                                field: "active",
                                operator: "eqbool",
                                value: true
                            });

                            if (vm.customerView === '3') {
                                // Cross, fetch only not expired customerSectors
                                o.data.filter.filters.push({
                                    field: "customerSector.endedAt",
                                    operator: "null_or_greater",
                                    value: $filter('date')(Date.now(), 'yyyy-MM-dd')
                                });
                            }

                            o.data.sort = {
                                field: "customerSector.customer.lastName",
                                dir: "asc"
                            };

                            $http.get('/api/employee-customer-sectors/all', {params: o.data})
                                .success(function (response) {
                                    o.success(response);
                                })
                                .error(function (response) {
                                    o.error(response);
                                });
                        }else {
                            o.error([]);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            if (item.customerSector === null) {
                                item.customerSector = {
                                    customer: {
                                        customerCategory: {},
                                        customerSubCategory: {},
                                        doctorSpecialty: {}
                                    },
                                    sector: {
                                        city: {},
                                        prefecture: {},
                                        sectorType: {}
                                    },
                                    main: 'false',
                                    dayTime: ''
                                }
                            }else {
                                if (item.customerSector.customer === null) item.customerSector.customer = {};
                                if (item.customerSector.customer !== null) {
                                    if (item.customerSector.customer.customerCategory === null) item.customerSector.customer.customerCategory = {};
                                    if (item.customerSector.customer.customerSubCategory === null) item.customerSector.customer.customerSubCategory = {};
                                    if (item.customerSector.customer.doctorSpecialty === null) item.customerSector.customer.doctorSpecialty = {}
                                }
                                if (item.customerSector.sector === null) item.customerSector.sector = {};
                                if (item.customerSector.sector !== null) {
                                    if (item.customerSector.sector.city === null) item.customerSector.sector.city = {};
                                    if (item.customerSector.sector.prefecture === null) item.customerSector.sector.prefecture = {};
                                    if (item.customerSector.sector.sectorType === null) item.customerSector.sector.sectorType = {};
                                }
                                item.main = item.customerSector.main === true ? "true" : "false";
                                item.dayTime = item.customerSector.customer !== null ? (item.customerSector.customer.dayTime === 'day' ? 'ΠΡΩΙΝΌ' : item.customerSector.customer.dayTime === 'night' ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '') : '';
                                item.myTarget = item.myTarget === true ? 'Ναι' : 'Όχι';
                            }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            isActive: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);
                                }
                            }
                        }
                    }
                }
            }),
            sortable: true,
            groupable: false,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "multiple, row",
            columns: [
                { selectable: true, width: 20 },
                {
                    title: "Στοιχεία Επαγγελματία Υγείας",
                    columns: [
                        {
                            field: "customerSector.customer.lastName",
                            title: "Επώνυμο",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 140
                        },
                        {
                            field: "customerSector.customer.firstName",
                            title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120
                        },
                        {
                            field: "customerSector.customer.doctorSpecialty.name",
                            title: "Ειδικοτητα 1η",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 130
                        },
                        {
                            field: "customerSector.customer.customerCategory.name",
                            title: "Κατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 60
                        },
                        {
                            field: "customerSector.customer.customerSubCategory.name",
                            title: "Υποκατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 60
                        }
                    ]
                },
                {
                    title: "Στοιχεία Μονάδας Υγείας",
                    columns: [
                        {
                            field: "customerSector.sector.sectorType.name",
                            title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120
                        },
                        {
                            field: "customerSector.sector.name",
                            title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "contains",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 190
                        },
                        {
                            field: "customerSector.sector.address",
                            title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120
                        },
                        {
                            field: "customerSector.sector.cityName",
                            title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 90
                        },
                        {
                            field: "customerSector.sector.prefectureName",
                            title: "Νομός",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 80
                        }
                    ]
                },
                {
                    field: "dayTime",
                    title: "Ωράριο",
                    template: "#= (dayTime == 'ΠΡΩΙΝΌ') ? 'ΠΡΩΙΝΌ' : (dayTime == 'ΑΠΟΓΕΥΜΑΤΙΝΌ') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "ΠΡΩΙΝΌ", value: "ΠΡΩΙΝΌ"},
                                            {text: "ΑΠΟΓΕΥΜΑΤΙΝΌ", value: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    width: 100
                },
                {
                    field: "myTarget",
                    title: "MyTarget",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "Ναι", value: "Ναι"},
                                            {text: "Όχι", value: "Όχι"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    width: 100
                }
            ],
            toolbar: [
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select name='employeeSelect' id='employeeSelect' kendo-combo-box k-ng-model='vm.selectedEmployeeId' k-options='vm.employeeOptions' style='width: 20%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label class='left-space'>My Target: </label><div class='inline'>" +
                    "<md-radio-group class='left-space' layout='row' ng-change='vm.mainGridOptions.dataSource.read()' ng-model='vm.masterFilters.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                {
                    name: "deleteAction",
                    template: "<md-button id='deleteButton' class='md-raised md-mini md-warn' style='margin-left: 50px;' aria-label='deleteSelected' ng-click='vm.deleteSelected($event)'>" +
                                "<md-icon class='icon-delete'></md-icon><span id='deleteButtonLabel'>ΔΙΑΓΡΑΦΗ</span>" +
                              "</md-button>"
                },
                {
                    name: "memo",
                    template: "<label style='font-style: italic; margin-left: 20px;'>Κρατήστε πατημένο το πλήκτρο Ctrl για πολλαπλή επιλογή</label>"
                },
                {
                    name: "sum",
                    template: "<div class='right'><label style='margin-top: 8px;'>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>"
                }
            ],
            height: CustomUtils.getHeightPixelsFromPercentage(62),
            noRecords: {
                template: "Δεν βρέθηκαν Επαγγελματίες Υγείας"
            },
            dataBound: function () {
                vm.selectedCustomersIds = [];
                updateDeleteButton();
            },
            change: function (e) {
                var grid = $("#mainGrid").data("kendoGrid");
                var rows = e.sender.select();
                vm.selectedCustomersIds = [];
                rows.each(function(e) {
                    var dataItem = grid.dataItem(this);
                    vm.selectedCustomersIds.push(dataItem.id);
                });
                updateDeleteButton();
            }
        };

        function updateDeleteButton() {
            var deleteButton = angular.element(document.getElementById('deleteButton'))[0];
            var deleteButtonLabel = angular.element(document.getElementById('deleteButtonLabel'))[0];
            if (vm.selectedCustomersIds.length > 0) {
                deleteButton.disabled = false;
                deleteButtonLabel.innerHTML = "Διαγραφή (" + vm.selectedCustomersIds.length + ")";
            }else {
                deleteButton.disabled = true;
                deleteButtonLabel.innerHTML = "Διαγραφή";
            }
        }

        $timeout(function () {
            // Initially disable delete button
            angular.element(document.getElementById('deleteButton'))[0].disabled = true;
        });
    }
})();
;
/**
 * Created by Kristy on 28/7/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('assignations', {
                abstract: true,
                parent: 'app',
                url: '/assignations',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/assignations/assignations.html',
                        controller: 'AssignationsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 06/11/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AssignationsController', AssignationsController);

    AssignationsController.$inject = ['$state'];

    function AssignationsController ($state) {
        var vm = this;
        vm.$state = $state;

    }
})();
;
/**
 * Created by Kristy on 22/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Approvals', Approvals);

    Approvals.$inject = ['$filter', '$timeout'];

    function Approvals ($filter, $timeout) {
        var selectedList = [];
        var gridId = "#pendingGrid";

        return {
            getSelectedList: function () {
                return selectedList;
            },
            setSelectedList: function (value) {
                selectedList = value;
            },
            calculateValue : calculateValue,
            openWindow : openWindow,
            closeWindow : closeWindow,
            removeItem : removeItem
        };

        function calculateValue(container, value) {
            if(container.changeField.name === 'dayTime') {
                switch (value) {
                    case 'night':
                        return 'Απογευματινό';
                    case 'day':
                        return 'Πρωινό';
                    default :
                        return ''
                }
            } else if (container.changeField.name === 'saw' || container.changeField.name === 'isActive' || container.changeField.name === 'main') {
                switch (value) {
                    case 'true':
                        return 'Ναι';
                    case 'false':
                        return 'Όχι';
                    default :
                        return ''
                }
            } else if (container.changeField.name === 'isMale') {
                switch (value) {
                    case 'true':
                        return 'Άρρεν';
                    case 'false':
                        return 'Θήλυ';
                    default :
                        return ''
                }
            } else if (container.changeField.name === 'startedAt' || container.changeField.name === 'endedAt') {
                if (container.changeField.name != null) {
                    return kendo.toString(kendo.parseDate(value), 'dd/MM/yyyy')
                }
            } else if (container.changeField.name === 'monday' || container.changeField.name === 'tuesday' ||
                container.changeField.name === 'wednesday' || container.changeField.name === 'thursday' ||
                container.changeField.name === 'friday') {
                switch (value) {
                    case 'morning':
                        return 'Πρωί';
                    case 'afternoon':
                        return 'Απόγευμα';
                    case 'morningAfternoon':
                        return 'Πρωί/Απόγευμα';
                    default:
                        return '';
                }
            } else if (value == null) {
                return ''
            } else {
                return value;
            }
        }

        function openWindow(previewWindow, status) {
            var title = '';
            switch (status) {
                case 'approve':
                    title = 'Επιλεγμένες Εγγραφές προς Έγκριση';
                    break;
                case 'reject':
                    title = 'Επιλεγμένες Εγγραφές προς Απόρριψη';
                    break;
                default :
                    break;
            }
            previewWindow.title(title);
            previewWindow.center().open();
        }

        function closeWindow(grid, previewWindow) {
            grid.dataSource.read();
            previewWindow.close();
        }

        function removeItem(gridData, id, grid) {
            angular.forEach(gridData, function (item) {
                if (item.id.toString() === id.toString()){
                    gridData.remove(item);
                    $timeout(function() {
                        $(grid ? grid : gridId).data("kendoGrid").tbody.find("tr[data-uid='" + item.uid + "']").trigger('click');
                    });
                }
            });
            this.setSelectedList(gridData);
        }
    }

})();
;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.newRecords.pendingHistory', {
                parent: 'approvals.newRecords',
                url: '/pendingHistory',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/newRecords/pendingHistory/pendingHistory.html',
                controller: 'PendingHistoryController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingHistoryController', PendingHistoryController);

    PendingHistoryController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'KendoGrid', 'KendoFilter'];

    function PendingHistoryController ($http, $state, $stateParams, $filter, $timeout, KendoGrid, KendoFilter) {
        var vm = this;
        vm.saw = true;
        vm.sectorType = null;

        vm.customerTypesDataSource = new kendo.data.DataSource({
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.customerTypesMultiOptions = {
            dataSource: vm.customerTypesDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.statusDataSource = new kendo.data.DataSource({
            data: [
                { value: 'approved', text: "ΕΓΚΡΙΘΗΚΕ"},
                { value: 'rejected',  text: "ΑΠΟΡΡΙΦΘΗΚΕ"}
            ]
        });

        vm.pendingHistoryGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "noteq",  "value": "pending"}
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType", "operator": "sectortype",  "value": vm.sectorType}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/temp-customers',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                item.newSector = false;
                                item.selectedIndex = 0;

                                if (item.doctorSpecialty === null) {
                                    item.doctorSpecialty = { id: null, name: "" };
                                }
                                if (item.doctorSpecificSpecialty === null) {
                                    item.doctorSpecificSpecialty = { id: null, name: "" };
                                }
                                if (item.customerCategory === null) {
                                    item.customerCategory = { id: null, name: "" };
                                }
                                if (item.customerSubCategory === null) {
                                    item.customerSubCategory = { id: null, name: "" };
                                }
                                if (item.customerTitle === null) {
                                    item.customerTitle = { id: null, name: "" };
                                }

                                if(item.tempCustomerSectors === null) {
                                    item.tempCustomerSectors = [];
                                }
                                angular.forEach(item.tempCustomerSectors, function (tempCustomerSector){
                                    if(tempCustomerSector.sector) {
                                        tempCustomerSector.displaySector = tempCustomerSector.sector;
                                    } else {
                                        item.newSector = true;
                                        tempCustomerSector.newSector = true;
                                        tempCustomerSector.displaySector = tempCustomerSector.tempSector;
                                    }

                                    if(tempCustomerSector.tempSector === null) {
                                        tempCustomerSector.tempSector = { sectorType: {} };
                                    } else if (tempCustomerSector.tempSector.sectorType === null){
                                        tempCustomerSector.tempSector.sectorType= {};
                                    }

                                    if(tempCustomerSector.sector === null) {
                                        tempCustomerSector.sector = { sectorType: {} };
                                    } else if (tempCustomerSector.sector.sectorType === null){
                                        tempCustomerSector.sector.sectorType= {};
                                    }
                                });
                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingHistoryGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            columns: [
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:200
                },
                {
                    title: "Νέα",
                    template: kendo.template(angular.element("#labelsTemplate").html()), width:50
                },
                {field: "lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {
                    title: "Συνδέσεις",
                    template:"<span class='label label-warning'>#: tempCustomerSectors.length#</span>", width:80
                },
                {field: "status", title: "Κατάσταση",
                    template: "#= (status == 'approved') ? 'ΕΓΚΡΙΘΗΚΕ' : (status == 'rejected') ? 'ΑΠΟΡΡΙΦΘΗΚΕ' : '' #",
                    attributes: {
                        class: "#=status == 'approved' ? 'green' : status == 'rejected' ? 'red' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataSource: vm.statusDataSource,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    valuePrimitive: true

                                })
                            }
                        }
                    },
                    width:160
                }
            ]
        };

        vm.sectorTypeOptions = {
            dataSource: [
                { text: 'Φαρμακοποιοί', value: "pharmacy" },
                { text: 'Επαγγελματίες Υγείας', value: "hcu" },
                { text: 'Υπεύθυνοι Κέντρου', value: "beautyCenter" }
            ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            change: function () {
                var self = this;
                $timeout(function() {
                    vm.sectorType = self.value();
                    vm.pendingHistoryGridOptions.dataSource.read();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Τύπος Επαγγελματία Υγείας: </label><select id='sectorType' name='sectorType' class='inline' kendo-combo-box " +
                    "k-options='vm.sectorTypeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };
    }
})();
;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.newRecords.pending', {
                parent: 'approvals.newRecords',
                url: '/pending',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/newRecords/pending/pending.html',
                controller: 'PendingController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingController', PendingController);

    PendingController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'NotificationOptions', 'KendoGrid', 'Approvals', 'KendoFilter'];

    function PendingController ($http, $state, $stateParams, $filter, $timeout, NotificationOptions, KendoGrid, Approvals, KendoFilter) {
        var vm = this;
        vm.statusChanged = '';
        vm.saw = true;
        vm.approvals = Approvals;
        Approvals.setSelectedList([]);
        vm.massSelect = true;
        vm.sectorType = null;
        vm.kendoGrid = KendoGrid;

        vm.customerTypesDataSource = new kendo.data.DataSource({
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.customerTypesMultiOptions = {
            dataSource: vm.customerTypesDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.changeStatus = function(e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            var data = this.dataItem(tr);
            var change = [data];

            $http.put('api/temp-customers/'+e.data.commandName, change)
                .success(function (response,status,headers) {
                    switch (e.data.commandName) {
                        case "approve":
                            notification.show({
                                message: "Η εγγραφή εγκρίθηκε με επιτυχία!"
                            }, "success");
                            break;
                        case "reject":
                            notification.show({
                                message: "Η εγγραφή απορριφθηκε με επιτυχία!"
                            }, "success");
                            break
                    }
                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
        };

        vm.approveRejectSelected = function(status) {
            $http.put('api/temp-customers/'+status, Approvals.getSelectedList())
                .success(function (response,status,headers) {
                    switch (status) {
                        case "approve":
                            notification.show({
                                message: "Οι αλλαγές εγκρίθηκαν με επιτυχία!"
                            }, "success");
                            break;
                        case "reject":
                            notification.show({
                                message: "Οι αλλαγές απορρίφθηκαν με επιτυχία!"
                            }, "success");
                            break
                    }
                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    vm.pendingGridOptions.dataSource.read();
                    console.log(response);
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
            vm.previewWindow.close();
        };

        vm.openPreviewWindow = function (status) {
            if(Approvals.getSelectedList().length) {
                vm.initPopupGrid = true;
                vm.status = status;
                Approvals.openWindow(vm.previewWindow, status);
            }
        };

        vm.closePreviewWindow = function() {
            Approvals.closeWindow(vm.pendingGridOptions, vm.previewWindow);
            delete vm.initPopupGrid;
        };

        vm.pendingPreviewGridOptions = {
            dataSource: new kendo.data.DataSource({
                data: Approvals.getSelectedList(),
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                pageSize: 20
            }),
            pageable: true,
            columns: [
                {
                    field: "createdDate",
                    title: "Ημερομηνία",
                    template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: false
                },
                {
                    title: "Νέα",
                    template: kendo.template(angular.element("#labelsTemplate").html()), width:50
                },
                {field: "lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: false,
                    width:160
                },
                {field: "firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: false,
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: false,
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: false,
                    width:160
                },
                {
                    title: "Συνδέσεις",
                    template:"<span class='label label-warning'>#: tempCustomerSectors.length#</span>", width:80
                },
                { "template": "<md-button class='md-icon-button' aria-label='Remove' ng-click='vm.approvals.removeItem(vm.pendingPreviewGridOptions.dataSource.data(), #=id#)'>" +
                "<md-icon class='remove'></md-icon></md-button>", width: 90 }
            ]
        };

        vm.pendingGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "eq",  "value": "pending"}
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType", "operator": "sectortype",  "value": vm.sectorType}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/temp-customers',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                item.newSector = false;
                                item.selectedIndex = 0;

                                if (item.doctorSpecialty === null) {
                                    item.doctorSpecialty = { id: null, name: "" };
                                }
                                if (item.doctorSpecificSpecialty === null) {
                                    item.doctorSpecificSpecialty = { id: null, name: "" };
                                }
                                if (item.customerCategory === null) {
                                    item.customerCategory = { id: null, name: "" };
                                }
                                if (item.customerSubCategory === null) {
                                    item.customerSubCategory = { id: null, name: "" };
                                }
                                if (item.customerTitle === null) {
                                    item.customerTitle = { id: null, name: "" };
                                }

                                if(item.tempCustomerSectors === null) {
                                    item.tempCustomerSectors = [];
                                }
                                angular.forEach(item.tempCustomerSectors, function (tempCustomerSector){
                                    if(tempCustomerSector.sector) {
                                        tempCustomerSector.displaySector = tempCustomerSector.sector;
                                    } else {
                                        item.newSector = true;
                                        tempCustomerSector.newSector = true;
                                        tempCustomerSector.displaySector = tempCustomerSector.tempSector;
                                    }

                                    if(tempCustomerSector.tempSector === null) {
                                        tempCustomerSector.tempSector = { sectorType: {} };
                                    } else if (tempCustomerSector.tempSector.sectorType === null){
                                        tempCustomerSector.tempSector.sectorType= {};
                                    }

                                    if(tempCustomerSector.sector === null) {
                                        tempCustomerSector.sector = { sectorType: {} };
                                    } else if (tempCustomerSector.sector.sectorType === null){
                                        tempCustomerSector.sector.sectorType= {};
                                    }
                                });
                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    command:[
                        { name:"approve", text: "Έγκριση", click: vm.changeStatus }
                    ],
                    attributes: { class: "#= 'green-color' #" },
                    title: "&nbsp",
                    width:85
                },
                {
                    command:[
                        { name:"reject", text: "Απόρριψη", click: vm.changeStatus }
                    ],
                    attributes: { class: "#= 'red-color' #" },
                    title: "&nbsp",
                    width:90
                },
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:200
                },
                {
                    title: "Νέα",
                    template: kendo.template(angular.element("#labelsTemplate").html()), width:60
                },
                {field: "lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {
                    title: "Συνδέσεις",
                    template:"<span class='label label-warning'>#: tempCustomerSectors.length#</span>", width:80
                }
            ],
            selectedItems: function(dataItems) {
                Approvals.setSelectedList(dataItems);
            },
            dataBound: function (e) {
                angular.element("#pendingGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (Approvals.getSelectedList().length) {
                    var selectedListViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(Approvals.getSelectedList(), {id: item.id}, true)[0];
                        if(Approvals.getSelectedList().indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedListViewCounter++
                        }
                    });
                    if(selectedListViewCounter == view.length) {
                        angular.element("#pendingGridcheckbox").prop('checked', true);
                    }
                }
            },
            toolbar: [
                {template: "<md-button class='green-color-md-button md-raised md-mini md-primary' aria-label='approveSelected' ng-click='vm.openPreviewWindow(\"approve\")'>" +
                "Μαζική Έγκριση επιλεγμένων</md-button>"},
                {template: "<md-button class='red-color-md-button md-raised md-mini md-primary' aria-label='rejectSelected' ng-click='vm.openPreviewWindow(\"reject\")'>" +
                "Μαζική Απόρριψη επιλεγμένων</md-button>"},
                { template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.sectorTypeOptions = {
            dataSource: [
                { text: 'Φαρμακοποιοί', value: "pharmacy" },
                { text: 'Επαγγελματίες Υγείας', value: "hcu" },
                { text: 'Υπεύθυνοι Κέντρου', value: "beautyCenter" }
            ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            change: function () {
                var self = this;
                $timeout(function() {
                    vm.sectorType = self.value();
                    vm.pendingGridOptions.dataSource.read();
                });

            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Τύπος Επαγγελματία Υγείας: </label><select id='sectorType' name='sectorType' class='inline' kendo-combo-box " +
                    "k-options='vm.sectorTypeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };
    }
})();
;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.newRecords', {
                parent: 'approvals',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/newRecords/newRecords.html',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.changedRecords.pendingHistory', {
                parent: 'approvals.changedRecords',
                url: '/pendingChangesHistory',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/changedRecords/pendingHistory/pendingHistory.html',
                controller: 'PendingChangesHistoryController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingChangesHistoryController', PendingChangesHistoryController);

    PendingChangesHistoryController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'KendoFilter', 'Approvals'];

    function PendingChangesHistoryController ($http, $state, $stateParams, $filter, $timeout, KendoFilter, Approvals) {
        var vm = this;
        vm.saw = true;
        vm.sectorType = null;

        function showOldValue(container) {
            return Approvals.calculateValue(container, container.oldValue);
        }

        function showNewValue(container) {
            return Approvals.calculateValue(container, container.value);
        }

        vm.statusDataSource = new kendo.data.DataSource({
            data: [
                { value: 'approved', text: "ΕΓΚΡΙΘΗΚΕ"},
                { value: 'rejected',  text: "ΑΠΟΡΡΙΦΘΗΚΕ"}
            ]
        });

        vm.pendingHistoryGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "noteq",  "value": "pending"}
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType", "operator": "sectortype",  "value": vm.sectorType}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/changes',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            toolbar: [
                { template: "<div class='right'><label>Σύνολο: {{vm.pendingHistoryGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            columns: [
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:200
                },
                {
                    title: "Αλλαγές",
                    template:"<span class='label label-info'>#: changeTable.nameGr#</span>", width:160
                },
                {field: "customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "changeField.nameGr", title: "Πεδίο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "oldValue", title: "Από",
                    template: showOldValue,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "value", title: "Σε",
                    template: showNewValue,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "status", title: "Κατάσταση",
                    template: "#= (status == 'approved') ? 'ΕΓΚΡΙΘΗΚΕ' : (status == 'rejected') ? 'ΑΠΟΡΡΙΦΘΗΚΕ' : '' #",
                    attributes: {
                        class: "#=status == 'approved' ? 'green' : status == 'rejected' ? 'red' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataSource: vm.statusDataSource,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    valuePrimitive: true

                                })
                            }
                        }
                    },
                    width:160
                }
            ]
        };

        vm.sectorTypeOptions = {
            dataSource: [
                { text: 'Φαρμακοποιοί', value: "pharmacy" },
                { text: 'Επαγγελματίες Υγείας', value: "hcu" },
                { text: 'Υπεύθυνοι Κέντρου', value: "beautyCenter" }
            ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            change: function () {
                var self = this;
                $timeout(function() {
                    vm.sectorType = self.value();
                    vm.pendingHistoryGridOptions.dataSource.read();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Τύπος Επαγγελματία Υγείας: </label><select id='sectorType' name='sectorType' class='inline' kendo-combo-box " +
                    "k-options='vm.sectorTypeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };
    }
})();
;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.changedRecords.pending', {
                parent: 'approvals.changedRecords',
                url: '/pendingChanges',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/changedRecords/pending/pending.html',
                controller: 'PendingChangesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingChangesController', PendingChangesController);

    PendingChangesController.$inject = ['$http', '$timeout', '$state', '$stateParams','$filter', 'KendoNotifications', 'KendoGrid', 'Approvals', 'KendoFilter'];

    function PendingChangesController ($http, $timeout, $state, $stateParams, $filter, KendoNotifications, KendoGrid, Approvals, KendoFilter) {
        var vm = this;
        vm.statusChanged = '';
        vm.saw = true;
        vm.approvals = Approvals;
        Approvals.setSelectedList([]);
        vm.massSelect = true;
        vm.kendoGrid = KendoGrid;
        vm.sectorType = null;

        var notification = angular.element("#notification").kendoNotification({
            autoHideAfter: 7000,
            allowHideAfter: 1000,
            button: true,
            hideOnClick: false
        }).data("kendoNotification");

        vm.changeStatus = function(e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            var change = this.dataItem(tr);

            $http.put('api/changes/' + e.data.commandName + '-one', change)
                .success(function () {
                    switch (e.data.commandName) {
                        case "approve":
                            notification.success("Η αλλαγή εγκρίθηκε με επιτυχία!");
                            break;
                        case "reject":
                            notification.success("Η αλλαγή απορριφθηκε με επιτυχία!");
                            break
                    }
                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    console.log(response);
                    notification.error("Η ενημέρωση των στοιχείων απέτυχε! " + $filter('translate')('global.messages.error.' + response.params[0]));
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
        };

        vm.approveRejectSelected = function(action) {
            var selectedList = Approvals.getSelectedList();
            $http.put('api/changes/' + action, selectedList)
                .success(function (response) {
                    var msg = "";
                    if (response.length === selectedList.length) {
                        msg = "Όλες οι Αλλαγές ";
                        if (action === 'approve') {
                            msg += "εγκρίθηκαν με επιτυχία!";
                        }else {
                            msg += "απορρίφθηκαν με επιτυχία!";
                        }
                        notification.success(msg);
                    } else if (response.length === 0) {
                        msg = "Καμία Αλλαγή δεν ";
                        if (action === 'approve') {
                            msg += "Εγκρίθηκε. ";
                        }else {
                            msg += "Απορρίφθηκε. ";
                        }
                        msg += "Πατήστε Έγκριση/Απόρριψη μεμονωμένα σε κάθε Αλλαγή για περισσότερες λεπτομέρειες";
                        notification.error(msg);
                    } else {
                        if (action === 'approve') {
                            msg = "Εγκρίθηκαν ";
                        }else {
                            msg = "Απορρίφθηκαν ";
                        }
                        msg += response.length + " από " + selectedList.length +
                            " Αλλαγές. Πατήστε Έγκριση/Απόρριψη μεμονωμένα σε κάθε Αλλαγή για περισσότερες λεπτομέρειες";
                        notification.warning(msg);
                    }

                    vm.statusChanged = 'statusChanged';
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    console.log(response);
                    notification.error("Η ενημέρωση των στοιχείων απέτυχε! " + $filter('translate')('global.messages.error.' + response.params[0]));
                    vm.pendingGridOptions.dataSource.read();
                });

            //clear selected list
            vm.statusChanged = '';
            Approvals.setSelectedList([]);
            vm.previewWindow.close();
        };

        function showOldValue(container) {
            return Approvals.calculateValue(container, container.oldValue);
        }

        function showNewValue(container) {
            return Approvals.calculateValue(container, container.value);
        }

        vm.openPreviewWindow = function (status) {
            if(Approvals.getSelectedList().length) {
                vm.initPopupGrid = true;
                vm.status = status;
                Approvals.openWindow(vm.previewWindow, status);
            }
        };

        vm.closePreviewWindow = function() {
            Approvals.closeWindow(vm.pendingGridOptions, vm.previewWindow);
            delete vm.initPopupGrid;
        };

        vm.pendingPreviewGridOptions = {
            dataSource: new kendo.data.DataSource({
                data: Approvals.getSelectedList(),
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                pageSize: 20
            }),
            pageable: true,
            columns: [
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: false,
                    width:200
                },
                {
                    title: "Αλλαγή",
                    template:"<span class='label label-info'>#: changeTable.nameGr#</span>", width:100
                },
                {field: "customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: false,
                    width:160
                },
                {field: "customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: false,
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: false,
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: false,
                    width:160
                },
                {field: "changeField.nameGr", title: "Πεδίο",
                    filterable: false,
                    width:140
                },
                {field: "oldValue", title: "Από",
                    template: showOldValue,
                    filterable: false,
                    width:160
                },
                {field: "value", title: "Σε",
                    template: showNewValue,
                    filterable: false,
                    width:160
                },
                { "template": "<md-button class='md-icon-button' aria-label='Remove' ng-click='vm.approvals.removeItem(vm.pendingPreviewGridOptions.dataSource.data(), #=id#)'>" +
                "<md-icon class='remove'></md-icon></md-button>", width: 90 }
            ]
        };

        vm.pendingGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "eq",  "value": "pending"}
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType", "operator": "sectortype",  "value": vm.sectorType}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/changes',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    command:[
                        { name:"approve", text: "Έγκριση", click: vm.changeStatus }
                    ],
                    attributes: { class: "#= 'green-color' #" },
                    title: "&nbsp",
                    width:90
                },
                {
                    command:[
                        { name:"reject", text: "Απόρριψη", click: vm.changeStatus }
                    ],
                    attributes: { class: "#= 'red-color' #" },
                    title: "&nbsp",
                    width:100
                },
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:200
                },
                {
                    title: "Αλλαγή",
                    template:"<span class='label label-info'>#: changeTable.nameGr#</span>", width:100
                },
                {field: "customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "changeField.nameGr", title: "Πεδίο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:140
                },
                {field: "oldValue", title: "Από",
                    template: showOldValue,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "value", title: "Σε",
                    template: showNewValue,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                }
            ],
            selectedItems: function(dataItems) {
                Approvals.setSelectedList(dataItems);
            },
            dataBound: function (e) {
                angular.element("#pendingGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (Approvals.getSelectedList().length) {
                    var selectedListViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(Approvals.getSelectedList(), {id: item.id}, true)[0];
                        if(Approvals.getSelectedList().indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedListViewCounter++
                        }
                    });
                    if(selectedListViewCounter == view.length) {
                        angular.element("#pendingGridcheckbox").prop('checked', true);
                    }
                }
            },
            toolbar: [
                {template: "<md-button class='green-color-md-button md-raised md-mini md-primary' aria-label='approveSelected' ng-click='vm.openPreviewWindow(\"approve\")'>" +
                "Μαζική Έγκριση επιλεγμένων</md-button>"},
                {template: "<md-button class='red-color-md-button md-raised md-mini md-primary' aria-label='rejectSelected' ng-click='vm.openPreviewWindow(\"reject\")'>" +
                "Μαζική Απόρριψη επιλεγμένων</md-button>"},
                { template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ]
        };

        vm.sectorTypeOptions = {
            dataSource: [
                { text: 'Φαρμακοποιοί', value: "pharmacy" },
                { text: 'Επαγγελματίες Υγείας', value: "hcu" },
                { text: 'Υπεύθυνοι Κέντρου', value: "beautyCenter" }
            ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            change: function () {
                var self = this;
                $timeout(function() {
                    vm.sectorType = self.value();
                    vm.pendingGridOptions.dataSource.read();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Τύπος Επαγγελματία Υγείας: </label><select id='sectorType' name='sectorType' class='inline' kendo-combo-box " +
                    "k-options='vm.sectorTypeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };
    }
})();
;
/**
 * Created by Kristy on 31/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals.changedRecords', {
                parent: 'approvals',
                url: '/changes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                templateUrl: 'app/displays/approvals/changedRecords/changedRecords.html',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('approvals', {
                abstract: true,
                parent: 'app',
                url: '/approvals',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/approvals/approvals.html',
                        controller: 'ApprovalsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

;
/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApprovalsController', ApprovalsController);

    ApprovalsController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'ApplicationParameters', 'HasAuthorizationByUser'];

    function ApprovalsController ($http, $state, $stateParams, $filter, $timeout, ApplicationParameters, HasAuthorizationByUser) {
        var vm = this;
        ApplicationParameters.hasModule('Approvals', true);
        HasAuthorizationByUser.hasAuthority();

        vm.$state = $state;
    }
})();
;
/**
 * Created by Maria on 26/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('applicationParameters', {
                parent: 'app',
                url: '/applicationParameters',
                data: {
                    authorities: ['ROLE_SYSTEM']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/applicationParameters/applicationParameters.html',
                        controller: 'ApplicationParametersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 26/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParametersController', ApplicationParametersController);

    ApplicationParametersController.$inject = ['$scope', 'KendoGrid', '$http', 'KendoFilter', 'CustomUtils'];

    function ApplicationParametersController ($scope, KendoGrid, $http, KendoFilter, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Παραμετροι Συστηματος";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddApplicationParameterClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/masterdata/application-parameters',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });

                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        $http.post('/api/application-parameters', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        $http.put('/api/application-parameters', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }

                    }
                },
                schema: {
                    data: function (data) {
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true }
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 20
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Παράμετροι Συστήματος", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Παράμετροι Συστήματος",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Παράμετροι Συστήματος"
            },
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα Παραμέτρου",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "value", title: "Τιμή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            height: vm.contentHeight,
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('analyticsNew', {
            parent: 'app',
            url: '/analyticsNew',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/analyticsNew/analyticsNew.html',
                    controller: 'AnalyticsNewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AnalyticsNewController', AnalyticsNewController);

    AnalyticsNewController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$http'];

    function AnalyticsNewController ($scope, Principal, LoginService, $state, $http) {


        var vm = this;

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.user = response;
                Principal.identity().then(function (account) {
                    if (vm.user.account.login == 'gstefanidis') {
                        var iframe = document.getElementById('iFrameEmbedReport');
                        iframe.src = "https://app.powerbi.com/view?r=eyJrIjoiN2QwZTUxMjMtM2Q4Mi00MThjLWIyODQtMzc5Njk4ZmYyODNmIiwidCI6IjZlZDUwOWI4LTViMzAtNDFmYS1hNzc4LWZjNDAwZTRkZDhmYiIsImMiOjh9";
                        console.log("new");
                    }
                })
            })
            .error(function (response) {
                console.log(response);
            });

        vm.printIframe = function (iFrameContent) {
            var frame = angular.element(iFrameContent);

            if (!frame) {
                console.log('No iFrame found');
                return;
            }
            window.print();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('analytics', {
            parent: 'app',
            url: '/analytics',
            data: {
                authorities: ['ROLE_BI_VIEWER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/analytics/analytics.html',
                    controller: 'AnalyticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AnalyticsController', AnalyticsController);

    AnalyticsController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$http'];

    function AnalyticsController ($scope, Principal, LoginService, $state, $http) {
        var vm = this;

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.user = response;
                Principal.identity().then(function(account) {
                    var filter = {};
                    if ( account.authorities.indexOf('ROLE_SUPERVISOR') > -1)
                    {
                        switch(vm.user.account.login)
                        {
                            case 'antoniou':
                            case 'vsarakinis':
                                filter = {field: "name", operator: "eq",  value: "Bi_Url_" + vm.user.district};
                                break;
                            case 'vstefanou':
                            case 'kksilouri':
                            case 'mathanasiou':
                                filter = {field: "name", operator: "eq",  value: "Bi_Url_" + vm.user.account.login};
                                break;
                            default:
                                filter = {field: "name", operator: "eq",  value: "Bi_Url"};
                                break;
                        }
                    }
                    else
                    {
                        filter = {field: "name", operator: "eq",  value: "Bi_Url"};
                    }

                    $http.get('/api/masterdata/application-parameters',
                        {params:{
                            page: "1",
                            pageSize: "1",
                            filter : { filters: [filter] }}})
                        .success(function (response,status,headers) {
                            var iframe = document.getElementById('iFrameEmbedReport');
                            iframe.src = response.content[0].value;
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                });
            })
            .error(function (response) {
                console.log(response);
            });

        vm.printIframe = function (iFrameContent) {
            var frame = angular.element(iFrameContent);

            if (!frame) {
                console.log('No iFrame found');
                return;
            }
            window.print();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adminUsers', {
            parent: 'app',
            url: '/users',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK' ]
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminUsers/adminUsers.html',
                    controller: 'AdminUsersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminUsersController', AdminUsersController);

    AdminUsersController.$inject = ['$scope', 'Principal', 'KendoGrid', 'ApplicationParameters','$http', 'KendoFilter', 'CustomUtils'];

    function AdminUsersController ($scope, Principal, KendoGrid, ApplicationParameters, $http, KendoFilter, CustomUtils) {
        var vm = this;
        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']);
        vm.pageHeading = 'Χρηστες';
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);

        vm.onAddUserClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.gridColumns = [
            {
                field: "login",
                title: "Όνομα σύνδεσης",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "activated",
                title: "Ενεργός",
                template: "#= (activated == '1') ? 'Ναι' : 'Όχι' #",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true
                            })
                        }
                    }
                }
            },
            {
                field: "authorities",
                title: "Ρόλοι",
                filterable: false,
                template: "#= authorities ? authorities.join(', '): ''#",
                editor: function (container, options) {
                    var dataSource= new kendo.data.DataSource({
                        data: [ 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_HEALTH_VISITOR', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR',
                            'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR',
                            'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_FRONT_DESK', 'ROLE_BI_VIEWER', 'ROLE_CHECKER' ]
                    });
                    angular.element("<select id='authorities' multiple='multiple' data-bind='value : authorities'/>")
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: dataSource
                        });

                    var hasPatchModulePromise = ApplicationParameters.hasModule('Patches', false);
                    var hasVisitPharmaciesModulePromise = ApplicationParameters.hasModule('Visit_Pharmacies', false);
                    var hasVisitBeautyCentersModulePromise = ApplicationParameters.hasModule('Visit_Beauty_Centers', false);

                    hasPatchModulePromise.success(function(result) {
                        if(result.content[0].value === "1") {
                            dataSource.data().push('ROLE_PATCH_VISITOR');
                            angular.element('#authorities').data('kendoMultiSelect').value(options.model.authorities);
                        }
                    });

                    hasVisitPharmaciesModulePromise.success(function(result) {
                        if(result.content[0].value === "1") {
                            dataSource.data().push('ROLE_PHARM_VISITOR');
                            dataSource.data().push('ROLE_PHARM_SUPERVISOR');
                            angular.element('#authorities').data('kendoMultiSelect').value(options.model.authorities);
                        }
                    });

                    hasVisitBeautyCentersModulePromise.success(function(result) {
                        if(result.content[0].value === "1") {
                            dataSource.data().push('ROLE_BC_VISITOR');
                            angular.element('#authorities').data('kendoMultiSelect').value(options.model.authorities);
                        }
                    });
                }
            }
        ];

        vm.gridToolbar = [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
            overflow: "never" }];

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/users/with-criteria',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function (o){

                        var data = o.data.models[0];

                        $http.post('/api/users', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function (o){

                        var data = o.data.models[0];

                        $http.put('/api/users', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){

                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            email: { type: 'email', editable: true, nullable: false, defaultValue: null,
                                required: true,
                                validation: {
                                    emailValidation: function (input) {

                                        if(input[0].name == 'email') {
                                            var value=$.trim(input.val());
                                            if (value.length === 0) {
                                                input.attr("data-emailValidation-msg", "Το email χρήστη απαιτείται");
                                                return false;
                                            }
                                        }

                                        return true;
                                    }
                                }
                            },
                            password: { type: 'password', editable: true, nullable: false, defaultValue: null },
                            activated: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            authorities: { defaultValue: [] }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 100
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Χρηστες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Χρηστες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Χρηστες"
            },
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.gridColumns,
            height: vm.contentHeight,
            edit: function(e) {
                if (e.model.isNew() == false) {
                    $('input[name *= "login"]').attr("disabled", true);
                }
                KendoGrid.defaultEditPopup(this._editContainer);
            },
            editable: {
                mode: "popup"
            }
        };

        vm.addEditFunctionality = function() {
            var grid = angular.element('#mainGrid').data('kendoGrid');
            vm.gridColumns.unshift({
                command: [
                    {name: "edit", text: ""}
                ],
                title: "&nbsp;",
                width: 80
            });
            grid.setOptions({
                columns: vm.gridColumns
            });
        };

        $scope.$on("kendoRendered", function () {
            if(vm.canEdit) vm.addEditFunctionality();
        });
    }
})();
;
/**
 * Created by Kristy on 30/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminSchedulesGrid', {
                parent: 'app',
                url: '/schedules/grid',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_PHARM_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminSchedulesGrid/adminSchedulesGrid.html',
                        controller: 'AdminSchedulesGridController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 30/6/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminSchedulesGridController', AdminSchedulesGridController);

    AdminSchedulesGridController.$inject = ['$scope', '$state','$http', '$rootScope', '$location', '$filter','KendoFilter', 'ApplicationParameters'];

    function AdminSchedulesGridController ($scope, $state, $http, $rootScope, $location, $filter, KendoFilter, ApplicationParameters) {
        var vm = this;
        var apiMeSchedulesURL = '/api/me/schedules';
        ApplicationParameters.hasModule('Scheduling', true);
        vm.pageHeading = 'Ραντεβου';
        vm.eventTarget = 'all';

        function onChange(arg) {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if((cellIndex === 0 || cellIndex === 1) &&
                this.dataItem(row).eventCustomerSector.sector.sectorType.sectorTypeCategory === 'hcu') {
                var customerId = this.dataItem(row).eventCustomerSector.customerSector.customer.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = customerId;
                    $state.go('customerInfo', {id: customerId, stateFrom: 'adminSchedulesGrid'});
                });
            } else if (cellIndex === 7 || cellIndex === 8) {
                var userId = this.dataItem(row).employee.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = userId;
                    // $location.path('/employees/search').search({id:userId});
                    $state.go('userInfo', {id: userId, stateFrom: 'adminSchedulesGrid'});
                });
            } else {
                //this.clearSelection(row); //this throws error
                this.saveChanges();
            }
        }

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        if (vm.eventTarget === 'customers'){
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnotnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        if (vm.eventTarget === 'sectors') {
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        $http.get(apiMeSchedulesURL,
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (options.data.filter != undefined) {
                                angular.forEach(options.data.filter.filters, function (item) {
                                    if (item.field === "eventSchedule.startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventCustomerSector === null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            customer: {
                                                last_name: "",
                                                first_name: ""
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    };
                                } else {
                                    if (item.eventCustomerSector.customerSector == null) {
                                        item.eventCustomerSector.customerSector = {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                doctorSpecialty: {
                                                    name: ""
                                                }
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    }
                                }

                                if (item.eventCustomerSector.sector == null) {
                                    item.eventCustomerSector.sector = {
                                        sectorType: {}
                                    };
                                }

                                if (item.eventCustomerSector.sector.sectorType == null) {
                                    item.eventCustomerSector.sector.sectorType = {
                                        name: ""
                                    };
                                }

                                if (item.employee === null) {
                                    item.employee = { account: { lastName: ""}};
                                }else {
                                    if (item.employee.account === null) {
                                        item.employee.account = { lastName: "" };
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            'eventSchedule.startedAt': { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 100
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : 'link-cell link-cell-color'#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : ''#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "eventSchedule.startedAt", title: "Ημερομηνία Ραντεβού", template: "#= eventSchedule.startedAt ? kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:210
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        { field: "eventCustomerSector.sector.name", title: "Όνομα",
                            template: "<span>#: eventCustomerSector.sector.name # </span>",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:210
                        },
                        {field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:120
                        }
                    ]
                },
                {
                    title: "Ιατρικός Επισκέπτης",
                    columns: [
                        {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "title", title: "Τίτλος",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "eventSchedule.description", title: "Σημειώσεις Ραντεβού",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            editable: "inline",
            selectable: "cell",
            change: onChange,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.onEventTargetChange = function () {
            vm.mainGridOptions.dataSource.read();
        };
    }
})();
;
/**
 * Created by Kristy on 8/7/2016.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('MassSchedules', MassSchedules);

    MassSchedules.$inject = ['$filter'];
    function MassSchedules ($filter) {

        this.createSchedule = function (customerSectors, shiftType, data, item, index, restartIndex) {
            var startDate;
            var finishedDate;

            //use new empty object for override issues
            var schedule = {};
            angular.copy(data, schedule);

            switch (shiftType) {
                case 'day':
                    if(schedule.firstShiftFrom && schedule.firstShiftTo) {
                        startDate = schedule.start.setTime(schedule.firstShiftFrom.getTime() + schedule.durationTime*60*1000*index);
                        finishedDate = new Date(startDate).getTime() + schedule.durationTime*60*1000;
                        if (finishedDate > schedule.start.setTime(schedule.firstShiftTo.getTime())) {
                            return 'validationError';
                        }
                    }
                    break;
                case 'night':
                    if(schedule.secondShiftFrom && schedule.secondShiftTo) {
                        startDate = schedule.start.setTime(schedule.secondShiftFrom.getTime() + schedule.durationTime*60*1000*index);
                        finishedDate = new Date(startDate).getTime()+ schedule.durationTime*60*1000;
                        if (finishedDate > schedule.start.setTime(schedule.secondShiftTo.getTime())) {
                            return 'validationError';
                        }
                    }
                    break;
                case 'dayNight':
                    if(schedule.firstShiftFrom && schedule.firstShiftTo && schedule.secondShiftFrom && schedule.secondShiftTo) {
                        startDate = schedule.start.setTime(schedule.firstShiftFrom.getTime() + schedule.durationTime*60*1000*index);
                        finishedDate = new Date(startDate).getTime()+ schedule.durationTime*60*1000;
                        if (finishedDate > schedule.start.setTime(schedule.firstShiftTo.getTime())) {
                            schedule.secondShift = true;
                            startDate = schedule.start.setTime(schedule.secondShiftFrom.getTime() + schedule.durationTime*60*1000*restartIndex);
                            finishedDate = new Date(startDate).getTime()+ schedule.durationTime*60*1000;
                            if (finishedDate > schedule.start.setTime(schedule.secondShiftTo.getTime())) {
                                return 'validationError';
                            }
                        }
                    }
                    break;
            }

            schedule.eventSchedule.startedAt = new Date(startDate);
            schedule.eventSchedule.finishedAt = new Date(finishedDate);

            if (!item.eventCustomerSector) {
                schedule.eventCustomerSector.customerSector.id = item.id;
                angular.extend(schedule.eventCustomerSector.customerSector, {
                    customer: item.customer,
                    sector: item.sector
                });
            } else {
                angular.extend(schedule.eventCustomerSector, item.eventCustomerSector);
            }

            schedule.id = null;
            schedule.eventCategoryType = {
                id: 1
            };

            return schedule;
        };

    }
})();
;
/**
 * Created by Kristy on 22/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminSchedules', {
                parent: 'app',
                url: '/schedules',
                data: {
                    authorities: ['ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminSchedules/adminSchedules.html',
                        controller: 'AdminSchedulesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 22/6/2016.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminSchedulesController', AdminSchedulesController);

    AdminSchedulesController.$inject = ['$scope', '$q', '$compile', '$timeout', '$filter', 'Principal', 'MassSchedules', 'KendoGrid', 'ApplicationParameters', 'KendoFilter', '$http', 'customersView', '$location'];

    function AdminSchedulesController($scope, $q, $compile, $timeout, $filter, Principal, MassSchedules, KendoGrid, ApplicationParameters, KendoFilter, $http, customersView, $location) {
        var vm = this;

        vm.pageHeading = 'Ατζεντα';
        vm.userAuth = '';
        vm.selectedCustomers = [];
        var startTime = new Date();
        startTime.setHours(8, 0, 0, 0);
        ApplicationParameters.hasModule('Scheduling', true);
        vm.customerView = customersView.data.content[0].value;

        Principal.identity().then(function (account) {
            vm.account = account;
            vm.tooltipContent = kendo.template($("#template").html());

            if (account.authorities.indexOf('ROLE_MANAGEMENT') > -1 || account.authorities.indexOf('ROLE_REC_MANAGEMENT') > -1
                || account.authorities.indexOf('ROLE_SUPERVISOR') > -1) {
                vm.userAuth = 'ROLE_MANAGEMENT';

                var viewModel = new kendo.observable({
                    ownerMultiDataSource: new kendo.data.DataSource({
                        serverSorting: true,
                        transport: {
                            read: function (o) {
                                if(account.authorities.indexOf('ROLE_SUPERVISOR') > -1){
                                    var url = '/api/me/employees';
                                    if (o.data.sort == undefined || !o.data.sort.length) {
                                        o.data.sort = {"field": "account.lastName", "dir": "asc"};
                                    }
                                    o.data.page = 1;
                                    o.data.pageSize = 100;
                                    $http.get(url,
                                        {params: o.data})
                                        .success(function (response) {
                                            o.success(response.content);
                                            if (response.content !== null && response.content !== undefined) {
                                                response.content.forEach(function (employee) {
                                                    if (employee.account && employee.account.id === vm.account.id) {
                                                        var multiSelect = $("#ownerMultiSelect").data("kendoMultiSelect");
                                                        multiSelect.value(employee);
                                                        multiSelect.trigger("change");
                                                    }
                                                });
                                            }
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                } else {
                                    var url = '/api/employees/all';
                                    if (o.data.sort == undefined || !o.data.sort.length) {
                                        o.data.sort = {"field": "account.lastName", "dir": "asc"};
                                    }
                                    $http.get(url,
                                        {params: o.data})
                                        .success(function (response) {
                                            o.success(response);
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                }
                            }
                        },
                        schema: {
                            parse: function (data) {
                                data.forEach(function (item) {
                                    item.name = item.account.lastName + " " + item.account.firstName;
                                });
                                return data;
                            }
                        }
                    }),
                    schedulerData: new kendo.data.SchedulerDataSource({
                        batch: true,
                        transport: {
                            read: function (o) {
                                var scheduler = angular.element("#scheduler").data("kendoScheduler");
                                var view = scheduler.view();

                                if (o.data.filter == undefined) {
                                    o.data.filter = {
                                        filters: [
                                            {
                                                "field": "startedAt", "operator": "from",
                                                "value": $filter('date')(view.startDate(), 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                            },
                                            {
                                                "field": "startedAt", "operator": "to",
                                                "value": $filter('date')(view.endDate(), 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                            }
                                        ]
                                    };
                                }

                                if (vm.selectedCustomers.length) {
                                    o.data.filter.filters.push(
                                        {
                                            "field": "employee.id", "operator": "in",
                                            "value": vm.selectedCustomers.toString()
                                        }
                                    );
                                    $http.get('/api/events-and-schedules/all', {params: o.data})
                                        .success(function (response, status, headers) {
                                            o.success(response);
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                } else {
                                    o.success([]);
                                }
                            },
                            parameterMap: function (options, operation) {
                                if (operation !== "read" && options.models) {
                                    return {models: kendo.stringify(options.models)};
                                }
                            }
                        },
                        schema: {
                            parse: function (data) {
                                if (data) {
                                    data.forEach(function (item) {
                                        if (item.eventCategoryType.eventCategory.id === 1) {
                                            // Episkepsh / Rantevou
                                            if (item.startedAt === null) {
                                                item.isSchedule = '1';
                                                item.start = item.eventSchedule.startedAt;
                                                item.end = item.eventSchedule.finishedAt;
                                            } else {
                                                if (item.startedAt !== null && !item.eventSchedule) {
                                                    item.isSchedule = '2';
                                                } else {
                                                    item.isSchedule = '3';
                                                }
                                                item.start = item.startedAt;
                                                item.end = item.finishedAt;
                                            }
                                            item.duration = ((new Date(item.end) - new Date(item.start)) / 1000 / 60) << 0;
                                        } else {
                                            // Ektos Pediou
                                            item.start = item.startedAt;
                                            item.end = item.finishedAt;
                                            item.isSchedule = '4';
                                            //item.isAllDay = true;
                                        }
                                    });
                                }
                                return data;
                            },
                            model: {
                                id: "taskId",
                                fields: {
                                    taskId: {from: "id", type: "number", editable: false},
                                    start: {type: "date", from: "start", editable: false},
                                    end: {type: "date", from: "end", editable: false},
                                    title: {
                                        from: "title",
                                        defaultValue: "Χωρίς Τίτλο",
                                        validation: {required: true},
                                        editable: false
                                    },
                                    durationTime: {type: "number", from: "duration"}
                                }
                            }
                        },
                        serverFiltering: true,
                        move: function (e) {
                            e.preventDefault();
                        },
                        moveStart: function (e) {
                            e.preventDefault();
                        },
                        moveEnd: function (e) {
                            e.preventDefault();
                        },
                        resize: function (e) {
                            e.preventDefault();
                        },
                        resizeStart: function (e) {
                            e.preventDefault();
                        },
                        resizeEnd: function (e) {
                            e.preventDefault();
                        }
                    })
                });

                //DropDown Options
                vm.ownerMultiOptions = {
                    dataSource: viewModel.ownerMultiDataSource,
                    change: function (e) {
                        var scheduler = angular.element("#scheduler").data("kendoScheduler");
                        scheduler.dataSource.read();
                    },
                    filter: "startswith",
                    valuePrimitive: true,
                    dataTextField: "name",
                    dataValueField: "id",
                    placeholder: "Επιλογή Ιατρικών Επισκεπτών"
                };

                vm.schedulerOptions = {
                    toolbar: ["pdf"],
                    pdf: {
                        fileName: "Ατζέντα.pdf"
                    },
                    dataSource: viewModel.schedulerData,
                    resources: [
                        {
                            field: "isSchedule",
                            dataSource: [
                                {text: "Schedule", value: '1', color: "#007fff!important"},
                                {text: "Event", value: '2', color: "#BE1C1C!important"},
                                {text: "WasScheduled", value: '3', color: "#ff5c33!important"},
                                {text: "OtherEvent", value: '4', color: "#757575!important"}
                            ]
                        }
                    ],
                    dataBound: function (e) {
                        if (this.view().name === "day") {
                            vm.view = "day";
                        } else if (this.view().name === "workWeek" || this.view().name === "week") {
                            vm.view = "week";
                        } else if (this.view().name === "month") {
                            vm.view = "month";
                        }


                    },
                    date: new Date(),
                    startTime: startTime,
                    allDaySlot: false,
                    messages: {
                        allDay: "Όλη την ημέρα",
                        today: "Τρέχουσα Ημέρα",
                        showFullDay: "Προβολή ολόκληρης της ημέρας",
                        showWorkDay: "Προβολή ωραρίου εργασίας",
                        "cancel": "Κλείσιμο",
                        "editor": {
                            "title": "Τίτλος",
                            "start": "Ξεκινάει",
                            "end": "Τελειώνει",
                            "eventSchedule.description": "Περιγραφή"
                        }
                    },
                    height: 600,
                    views: [
                        {type: "day", title: "Ημέρα"},
                        {type: "workWeek", title: "Εργάσιμες Ημέρες", selected: true},
                        {type: "week", title: "Εβδομάδα"},
                        {type: "month", title: "Μήνας"}
                    ],
                    selectable: true,
                    editable: false,
                    autoBind: false,
                    change: function (e) {
                        //using $timeout to trigger the change
                        $timeout(function () {
                            vm.event = e.events[0];
                        }, 0);
                    }
                };
            } else if (account.authorities.indexOf('ROLE_HEALTH_VISITOR') > -1 ||
                account.authorities.indexOf('ROLE_REC_HEALTH_VISITOR') > -1 || account.authorities.indexOf('ROLE_PHARM_SUPERVISOR') > -1) {
                vm.userAuth = 'ROLE_HEALTH_VISITOR';
                vm.validationError = false;

                var viewModel2 = new kendo.observable({
                    ownerMultiDataSource: new kendo.data.DataSource({
                        serverSorting: true,
                        transport: {
                            read: function (o) {
                                var url = '/api/me/employees';
                                if (o.data.sort == undefined || !o.data.sort.length) {
                                    o.data.sort = {"field": "account.lastName", "dir": "asc"};
                                }
                                o.data.page = 1;
                                o.data.pageSize = 100;
                                $http.get(url,
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response.content);
                                        if (response.content !== null && response.content !== undefined) {
                                            // Preselect current user in ownerMultiSelect
                                            response.content.forEach(function (employee) {
                                                if (employee.account && employee.account.id === vm.account.id) {
                                                    var multiSelect = $("#ownerMultiSelect2").data("kendoMultiSelect");
                                                    multiSelect.value(employee);
                                                    multiSelect.trigger("change");
                                                }
                                            });
                                        }
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function (data) {
                                data.forEach(function (item) {
                                    item.name = item.account.lastName + " " + item.account.firstName;
                                });
                                return data;
                            }
                        }
                    }),
                    schedulerData: new kendo.data.SchedulerDataSource({
                        batch: true,
                        transport: {
                            read: function (o) {
                                var scheduler = angular.element("#scheduler2").data("kendoScheduler");
                                var view = scheduler.view();

                                if (o.data.filter == undefined) {
                                    o.data.filter = {
                                        filters: [
                                            {
                                                "field": "startedAt", "operator": "from",
                                                "value": $filter('date')(view.startDate(), 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                            },
                                            {
                                                "field": "startedAt", "operator": "to",
                                                "value": $filter('date')(view.endDate(), 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                            }
                                        ]
                                    };
                                }

                                if (vm.selectedCustomers.length) {
                                    o.data.filter.filters.push(
                                        {
                                            "field": "employee.id", "operator": "in",
                                            "value": vm.selectedCustomers.toString()
                                        }
                                    );

                                    $http.get('/api/me/events-and-schedules/all', {params: o.data})
                                        .success(function (response) {
                                            o.success(response);
                                        })
                                        .error(function (response) {
                                        });
                                } else {
                                    o.success([]);
                                }
                            },
                            create: function (o) {
                                var data = o.data.models[0];
                                data.id = null;
                                data.eventCategoryType = {
                                    id: 1
                                };
                                if (!vm.massCustomerSectors.length) {
                                    var date = new Date(data.start);
                                    date.setTime(date.getTime() + (data.duration * 60 * 1000));
                                    angular.extend(data.eventSchedule, {
                                        startedAt: data.start,
                                        finishedAt: date
                                    });

                                    data.eventCustomerSector.customerSector.id = vm.currentCustomerSector.id;

                                    $http.post('/api/events', data)
                                        .success(function (response, status, headers) {
                                            var scheduler = $("#scheduler2").data("kendoScheduler");
                                            scheduler.dataSource.read();
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                } else {
                                    if (vm.validationError == false) {
                                        $http.post('/api/events/all', vm.previewArray)
                                            .success(function (response, status, headers) {
                                                var scheduler = angular.element("#scheduler2").data("kendoScheduler");
                                                scheduler.dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }


                                }


                            },
                            update: function (o) {
                                var data = o.data.models[0];
                                data.eventCategoryType = {
                                    id: 1
                                };
                                var date = new Date(data.start);
                                date.setTime(date.getTime() + (data.duration * 60 * 1000));
                                if (!data.startedAt) {
                                    data.eventSchedule.startedAt = data.start;
                                    data.eventSchedule.finishedAt = date;
                                } else {
                                    data.startedAt = data.start;
                                    data.finishedAt = date;
                                }

                                data.eventCustomerSector.agreementValuation = null;
                                if (vm.customerChanged) {
                                    data.eventCustomerSector.customerSector.id = vm.currentCustomerSector.id;
                                    vm.customerChanged = false;
                                }

                                $http.put('/api/events', data)
                                    .success(function (response, status, headers) {
                                        var scheduler = angular.element("#scheduler2").data("kendoScheduler");
                                        scheduler.dataSource.read();
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            parameterMap: function (options, operation) {
                                if (operation !== "read" && options.models) {
                                    return {models: kendo.stringify(options.models)};
                                }
                            }
                        },
                        schema: {
                            data: function (data) {
                                if (data) {
                                    data.forEach(function (item) {
                                        if (!item.eventCustomerSector) {
                                            item.eventCustomerSector = {
                                                customerSector: {
                                                    customer: {
                                                        lastName: "",
                                                        firstName: "",
                                                        doctorSpecialty: {}
                                                    },
                                                    sector: {
                                                        address: ""
                                                    }
                                                },
                                                agreementValuation: {
                                                    name: ""
                                                },
                                                communicationType: {
                                                    name: ""
                                                }
                                            };
                                        } else {
                                            if (item.eventCustomerSector.agreementValuation === null) {
                                                item.eventCustomerSector.agreementValuation = {};
                                                item.eventCustomerSector.agreementValuation.name = "";
                                            }
                                            if (item.eventCustomerSector.communicationType === null) {
                                                item.eventCustomerSector.communicationType = {};
                                                item.eventCustomerSector.communicationType.name = "";
                                            }

                                            if (item.eventSchedule === null) {
                                                item.eventSchedule = {
                                                    description: ""
                                                }
                                            }
                                        }
                                    });
                                }

                                return data;
                            },
                            parse: function (data) {
                                if (data) {
                                    data.forEach(function (item) {
                                        if (item.eventCategoryType.eventCategory.id === 1) {
                                            // Episkepsh / Rantevou
                                            if (item.startedAt === null) {
                                                item.isSchedule = '1';
                                                item.start = item.eventSchedule.startedAt;
                                                item.end = item.eventSchedule.finishedAt;
                                            } else {
                                                if (item.startedAt !== null && !item.eventSchedule) {
                                                    item.isSchedule = '2';
                                                } else {
                                                    item.isSchedule = '3';
                                                }
                                                item.start = item.startedAt;
                                                item.end = item.finishedAt;
                                            }
                                            item.duration = ((new Date(item.end) - new Date(item.start)) / 1000 / 60) << 0;
                                        } else {
                                            // Ektos Pediou
                                            item.start = item.startedAt;
                                            item.end = item.finishedAt;
                                            item.isSchedule = '4';
                                            //item.isAllDay = true;
                                        }

                                    });
                                }
                                return data;
                            },
                            model: {
                                id: "taskId",
                                fields: {
                                    taskId: {from: "id", type: "number", editable: false},
                                    start: {type: "date", from: "start"},
                                    end: {type: "date", from: "end"},
                                    durationTime: {type: "number", defaultValue: 15, from: "duration"},
                                    title: {
                                        from: "title",
                                        defaultValue: 'ΠΡΟΣΩΠΙΚΗ ΕΠΙΣΚΕΨΗ',
                                        validation: {required: true}
                                    },
                                    eventSchedule: {defaultValue: {}},
                                    firstShiftFrom: {
                                        type: "date",
                                        template: "#= kendo.toString(kendo.parseDate(start.setHours(9, 0 ,0 ,0)), 'HH:mm')#"
                                    },
                                    firstShiftTo: {
                                        type: "date",
                                        template: "#= kendo.toString(kendo.parseDate(start.setHours(14, 0 ,0 ,0)), 'HH:mm')#"
                                    },
                                    secondShiftFrom: {
                                        type: "date",
                                        template: "#= kendo.toString(kendo.parseDate(start.setHours(17, 0 ,0 ,0)), 'HH:mm')#"
                                    },
                                    secondShiftTo: {
                                        type: "date",
                                        template: "#= kendo.toString(kendo.parseDate(start.setHours(21, 0 ,0 ,0)), 'HH:mm')#"
                                    },
                                    eventCustomerSector: {
                                        defaultValue: {
                                            communicationType: {defaultValue: {}},
                                            customerSector: {
                                                defaultValue: {
                                                    customer: {defaultValue: {doctorSpecialty: {defaultValue: {}}}},
                                                    sector: {defaultValue: {}}
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        serverFiltering: true,
                        move: function (e) {
                            e.preventDefault();
                        },
                        moveStart: function (e) {
                            e.preventDefault();
                        },
                        moveEnd: function (e) {
                            e.preventDefault();
                        },
                        resize: function (e) {
                            e.preventDefault();
                        },
                        resizeStart: function (e) {
                            e.preventDefault();
                        },
                        resizeEnd: function (e) {
                            e.preventDefault();
                        }
                    })
                });

                vm.ownerMultiOptions = {
                    dataSource: viewModel2.ownerMultiDataSource,
                    change: function (e) {
                        var scheduler = angular.element("#scheduler2").data("kendoScheduler");
                        scheduler.dataSource.read();
                    },
                    filter: "startswith",
                    valuePrimitive: true,
                    dataTextField: "name",
                    dataValueField: "id",
                    placeholder: "Επιλογή Ιατρικού Επισκέπτη"
                };

                vm.schedulerOptions = {
                    toolbar: ["pdf"],
                    pdf: {
                        fileName: "Ατζέντα.pdf"
                    },
                    dataSource: viewModel2.schedulerData,
                    dataBound: function (e) {
                        if (this.view().name === "day") {
                            vm.view = "day";
                        } else if (this.view().name === "workWeek" || this.view().name === "week") {
                            vm.view = "week";
                        } else if (this.view().name === "month") {
                            vm.view = "month";
                        }


                    },
                    resources: [
                        {
                            field: "isSchedule",
                            dataSource: [
                                {text: "Schedule", value: '1', color: "#007fff!important"},
                                {text: "Event", value: '2', color: "#BE1C1C!important"},
                                {text: "WasScheduled", value: '3', color: "#ff5c33!important"},
                                {text: "OtherEvent", value: '4', color: "#757575!important"}
                            ]
                        }
                    ],
                    date: new Date(),
                    startTime: startTime,
                    allDaySlot: false,
                    messages: {
                        today: "Τρέχουσα Ημέρα",
                        showFullDay: "Προβολή ολόκληρης της ημέρας",
                        showWorkDay: "Προβολή ωραρίου εργασίας",
                        "cancel": "Κλείσιμο",
                        "save": "Αποθήκευση",
                        "editor": {
                            "title": "Τίτλος Ραντεβού",
                            "start": "Ημερομηνία",
                            "end": "Τελειώνει",
                            "eventSchedule.description": "Περιγραφή"
                        }
                    },
                    height: 600,
                    views: [
                        {type: "day", title: "Ημέρα"},
                        {type: "workWeek", title: "Εργάσιμες Ημέρες", selected: true},
                        {type: "week", title: "Εβδομάδα"},
                        {type: "month", title: "Μήνας"}
                    ],
                    editable: false,
                    /*editable: {
                        destroy: false,
                        mode: "popup",
                        template: kendo.template(angular.element("#popup_editor").html())
                    },*/
                    edit: function (e) {
                        vm.initPopupGrid = true;
                        vm.currentEvent = e.event;
                        vm.massSelect = false;
                        vm.canMasSchedule = true;
                        vm.shiftType = 'dayNight';
                        vm.page = 'firstPage';
                        vm.btnNextName = 'Επόμενο';
                        vm.btnBackName = 'Πίσω';
                        vm.massCustomerSectors = [];
                        vm.search_text = "";
                        vm.masterFilter = {};
                        vm.allSelected = false;

                        angular.element("div.k-edit-form-container").width(1000);
                        var wnd = angular.element(e.container).data("kendoWindow");
                        wnd.setOptions({
                            title: "Ραντεβού"
                        });

                        vm.currentCustomerSector = e.event.eventCustomerSector.customerSector;

                        //choose readonly editor if is not a schedule
                        if (!e.event.isNew()) {
                            if (!e.event.startedAt) vm.isSchedule = '1';
                            else {
                                if (!e.event.eventSchedule) {
                                    vm.isSchedule = '2';
                                } else {
                                    vm.isSchedule = '3';
                                }
                            }

                            vm.canMasSchedule = false;

                            if (vm.isSchedule !== '1') {
                                wnd.setOptions({
                                    title: "Δραστηριότητα"
                                });

                                e.container
                                    .find(".k-edit-buttons") // find edit buttons
                                    .remove(); // remove the checkbox wrapper
                            }
                        } else {
                            vm.isSchedule = '1';

                            var date = e.event.start;

                            //set default date for shifts
                            e.event.set("firstShiftFrom", new Date(date.getFullYear(), date.getMonth(), date.getDate(), 9, 0, 0, 0));
                            e.event.set("firstShiftTo", new Date(date.getFullYear(), date.getMonth(), date.getDate(), 14, 0, 0, 0));
                            e.event.set("secondShiftFrom", new Date(date.getFullYear(), date.getMonth(), date.getDate(), 17, 0, 0, 0));
                            e.event.set("secondShiftTo", new Date(date.getFullYear(), date.getMonth(), date.getDate(), 21, 0, 0, 0));

                        }

                        //reload popup grid
                        KendoGrid.refresh(vm.customerSectorGridOptions);
                    },
                    save: function () {
                        delete vm.initPopupGrid;
                    },
                    cancel: function () {
                        delete vm.initPopupGrid;
                    }
                };

                vm.defineState = function (btn) {
                    var updateBtn = angular.element(".k-edit-buttons .k-button.k-scheduler-update");

                    switch (vm.page) {
                        case 'firstPage':
                            vm.page = 'secondPage';
                            vm.btnNextName = 'Επόμενο';
                            vm.showBackBtn = true;
                            break;
                        case 'secondPage':
                            if (btn == 'next') {
                                vm.page = 'thirdPage';
                                var grid = angular.element("#previewGrid").data("kendoGrid");
                                grid.dataSource.read();
                                updateBtn.show();
                                vm.showNextBtn = false;

                                vm.sortableOptions = {
                                    filter: ".k-grid tr[data-uid]",
                                    hint: $.noop,
                                    cursor: "move",
                                    placeholder: function (element) {
                                        return element
                                            .clone()
                                            .removeAttr("uid")
                                            .addClass("k-state-hover")
                                            .addClass("k-state-selected")
                                            .addClass("draggable");
                                        //.css("opacity", 0.65);
                                    },
                                    container: ".k-grid tbody",
                                    change: function (e) {
                                        var sortableGrid = vm.sortableGrid,
                                            dataItem = sortableGrid.dataSource.getByUid(e.item.data("uid"));

                                        sortableGrid.dataSource.remove(dataItem);
                                        sortableGrid.dataSource.insert(e.newIndex, dataItem);
                                        vm.massCustomerSectors = sortableGrid.dataSource.data();
                                        grid.dataSource.read();
                                    }
                                };
                            } else {
                                vm.page = 'firstPage';
                            }
                            vm.btnNextName = 'Επόμενο';
                            break;
                        case 'thirdPage':
                            vm.page = 'secondPage';
                            vm.showNextBtn = true;
                            updateBtn.hide();
                            break;
                    }
                };

                vm.toggleMassSchedules = function (e) {
                    var editBtn = angular.element(".k-edit-buttons .k-button");
                    var buttonDiv = angular.element(".k-edit-buttons.k-state-default");
                    var nextBtn = angular.element("#next");
                    var backBtn = angular.element("#back");
                    var btnshtml = '<a class="k-button" id="back" ng-show="vm.showBackBtn" ng-model="vm.page" ng-click="vm.defineState(\'back\')">{{vm.btnBackName}}</a>' +
                        '<a class="k-button k-primary" id="next" ng-show="vm.showNextBtn" ng-model="vm.page" ng-click="vm.defineState(\'next\')">{{vm.btnNextName}}</a>';
                    var temp = $compile(btnshtml)($scope);
                    switch (vm.massSelect) {
                        case true:
                            editBtn.hide();
                            buttonDiv.prepend(temp);
                            vm.showBackBtn = false;
                            vm.showNextBtn = true;
                            break;
                        case false:
                            vm.massCustomerSectors = [];
                            editBtn.show();
                            nextBtn.remove();
                            backBtn.remove();
                            break;
                    }
                };

                vm.communicationTypesComboBoxDataSource = new kendo.data.DataSource({
                    serverFiltering: true,
                    transport: {
                        read: function (o) {
                            var url = '/api/masterdata/communication-types';
                            o.data.page = 1;
                            o.data.pageSize = 1000;
                            $http.get(url, {params: o.data})
                                .success(function (response) {
                                    o.success(response.content);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        }
                    }
                });

                vm.communicationTypesComboBoxOptions = {
                    dataSource: vm.communicationTypesComboBoxDataSource,
                    filter: "startswith",
                    valuePrimitive: true,
                    dataTextField: "name",
                    dataValueField: "id",
                    dataBound: function () {
                        if (!this.value() && this.selectedIndex == -1) {
                            this.select(0);
                            this.trigger("change");
                        }
                    },
                    change: function (e) {
                        var value = this.text();
                        //change title according to communication type
                        $('input[name=eventTitle]').val(value).trigger('change');
                    }
                };

                //Customers Grid
                vm.search = function () {
                    vm.masterFilter = {"field": "masterFilter", "operator": "search", "value": vm.search_text};
                    angular.element("#customersMeGrid").data("kendoGrid").dataSource.read();
                };
                vm.toolbarOptions = {
                    items: [
                        {
                            template: "<label>Αναζητήστε επαγγελματία υγείας: </label>" +
                                "<input type='text' class='k-input k-textbox' id='masterFilter' ng-model='vm.search_text' ng-change='vm.search()' />",
                            overflow: "never"
                        }
                    ]
                };

                vm.massCustomerSectors = [];

                vm.onChange = function (e, dataItem) {
                    var grid = e.sender;

                    //using $timeout to trigger the change
                    $timeout(function () {
                        vm.currentCustomerSector = dataItem;
                    }, 0);
                    vm.customerChanged = true;
                    vm.currentEvent.dirty = true;
                };

                vm.gridColumns = [
                    {field: "id", filterable: false, hidden: true},
                    {
                        title: "Επαγγελματίας Υγείας",
                        columns: [
                            {
                                field: "customer.lastName", title: "Επώνυμο",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "customer.firstName", title: "Όνομα",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "customer.doctorSpecialty.name", title: "Ειδικότητα",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            }
                        ]
                    },
                    {
                        title: "Μονάδα Υγείας",
                        columns: [
                            {
                                field: "sector.name", title: "Όνομα",
                                filterable: {
                                    cell: {
                                        operator: "like",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "sector.address", title: "Διεύθυνση",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "sector.cityName", title: "Πόλη",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "sector.postalCode", title: "Τ.Κ",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            },
                            {
                                field: "sector.prefectureName", title: "Νομός",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }
                            }
                        ]
                    }
                ];

                vm.customerSectorGridOptions = {
                    autoBind: false,
                    dataSource: new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function (o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = {filters: []};
                                }

                                if (o.data.sort == undefined || !o.data.sort.length) {
                                    o.data.sort = {"field": "customer.lastName", "dir": "asc"};
                                }

                                //masterFilter functionality
                                if (vm.masterFilter) {
                                    o.data.filter.filters.push(vm.masterFilter);
                                }

                                $http.get('/api/me/customer-sectors',
                                    {params: o.data})
                                    .success(function (response, status, headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            parameterMap: function (data, operation) {
                                if (operation !== 'read') {
                                    return JSON.stringify(data.models);
                                }
                                return data;
                            }
                        },
                        schema: {
                            data: function (data) {
                                if (data.content != undefined) {
                                    data.content.forEach(function (item) {
                                        if (item.customer.doctorSpecialty === null) {
                                            item.customer.doctorSpecialty = {
                                                name: ""
                                            };
                                        }

                                        if (item.sector == null) {
                                            item.sector = {
                                                name: ""
                                            }
                                        }

                                    });
                                }
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    sector: {defaultValue: {id: null, name: ""}},
                                    customer: {defaultValue: {id: null, firstName: "", lastName: ""}}
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 40
                    }),
                    selectedItems: function (dataItems) {
                        vm.massCustomerSectors = dataItems;
                    },
                    sortable: true,
                    pageable: true,
                    filterable: {
                        mode: "row"
                    },
                    selectable: true,
                    scrolable: true,
                    columns: vm.gridColumns,
                    dataBound: function (e) {
                        angular.element("#customersMeGridcheckbox").prop('checked', false);
                        //toggle class on click
                        angular.element(".checkbox").bind("change", function (e) {
                            angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                        });

                        var view = this.dataSource.data();
                        var me = this;

                        var massCustomerSectorsViewCounter = 0;
                        angular.forEach(view, function (item) {
                            var foundItemById = $filter('filter')(vm.massCustomerSectors, {id: item.id}, true)[0];
                            if (vm.massCustomerSectors.indexOf(foundItemById) !== -1) {
                                me.tbody.find("tr[data-uid='" + item.uid + "']")
                                    .addClass("k-state-selected");
                                item.selected = true;
                                massCustomerSectorsViewCounter++
                            }
                        });
                        if (massCustomerSectorsViewCounter == view.length) {
                            angular.element("#customersMeGridcheckbox").prop('checked', true);
                        }
                    }
                };

                vm.gridPreviewColumns = [
                    {field: "id", filterable: false, hidden: true},
                    {
                        title: "Επαγγελματίας Υγείας",
                        columns: [
                            {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο"},
                            {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα"},
                            {
                                field: "eventCustomerSector.customerSector.customer.doctorSpecialty.name",
                                title: "Ειδικότητα"
                            }
                        ]
                    },
                    {
                        title: "Μονάδα Υγείας",
                        columns: [
                            {field: "eventCustomerSector.customerSector.sector.name", title: "Όνομα"},
                            {field: "eventCustomerSector.customerSector.sector.cityName", title: "Πόλη"},
                            {field: "eventCustomerSector.customerSector.sector.prefectureName", title: "Νομός"},
                            {field: "eventCustomerSector.customerSector.sector.address", title: "Διεύθυνση"},
                            {field: "eventCustomerSector.customerSector.sector.postalCode", title: "Τ.Κ"}
                        ]
                    },
                    {
                        field: "eventSchedule.startedAt",
                        template: "#= kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'HH:mm')#",
                        title: "Ώρα Έναρξης"
                    },
                    {
                        field: "eventSchedule.finishedAt",
                        template: "#= kendo.toString(kendo.parseDate(eventSchedule.finishedAt), 'HH:mm')#",
                        title: "Ώρα Λήξης"
                    }
                ];

                vm.previewGridOptions = {
                    dataSource: new kendo.data.DataSource({
                        transport: {
                            read: function (options) {
                                var scheduler = angular.element("#scheduler2").data("kendoScheduler");
                                if (scheduler) {
                                    var length = scheduler.dataSource.data().length;
                                    var event = scheduler.dataSource.at(length - 1);
                                    event.secondShift = false;
                                }

                                //create each schedule - define startedAt & finishedAt of eventSchedule
                                vm.validationError = false;
                                var restartIndex = 0;
                                vm.previewArray = [];
                                angular.forEach(vm.massCustomerSectors, function (item, index) {
                                    var schedule = MassSchedules.createSchedule(vm.massCustomerSectors, vm.shiftType, event, item, index, restartIndex);
                                    //restart index if second shift
                                    if (schedule.secondShift) {
                                        restartIndex++;
                                    }
                                    if (schedule !== 'validationError') {
                                        vm.previewArray.push(schedule);
                                    } else {
                                        vm.validationError = true;
                                    }

                                });
                                options.success(vm.previewArray); // where data is the local data array
                            }
                        },
                        schema: {
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    'eventCustomerSector.customerSector.sector': {defaultValue: {id: null, name: ""}},
                                    'eventCustomerSector.customerSector.customer': {
                                        defaultValue: {
                                            id: null,
                                            firstName: "",
                                            lastName: ""
                                        }
                                    },
                                    'eventSchedule.startedAt': {type: "date", defaultValue: null},
                                    'eventSchedule.finishedAt': {type: "date", defaultValue: null},

                                }
                            }
                        },
                        pageSize: 40
                    }),
                    sortable: true,
                    pageable: true,
                    selectable: true,
                    columns: vm.gridPreviewColumns
                };
            }
        });
    }
})();
;
/**
 * Created by gmogas on 13/1/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyPurchases', {
                parent: 'adminPharmacyView',
                url: '/pharmacyPurchases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminPharmacies/purchases/purchases.html',
                controller: 'AdminPharmacyViewPurchasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacy');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 13/1/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewPurchasesController', AdminPharmacyViewPurchasesController);

    AdminPharmacyViewPurchasesController.$inject = ['$http', '$stateParams', '$state', '$filter'];

    function AdminPharmacyViewPurchasesController ($http, $stateParams, $state, $filter) {
        var vm = this;
        vm.selectedSectorId = $stateParams.id;

        vm.pageHeading = 'Παραγγελίες';

        vm.purchasesColumns = [
            {
                field: "issueDate",
                title: "Ημερομηνία",
                template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "purchaseStatus.name",
                title: "Κατάσταση",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.lastName",
                title: "Επίθετο",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "comment",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "finalPrice",
                title: "Σύνολο σε €",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            }

        ];

        vm.purchasesDatasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "sector.id", "operator": "eq",  "value": $stateParams.id }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/purchases/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        issueDate: { type: 'date', editable: false}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        vm.purchasesGridOptions = {
            dataSource: vm.purchasesDatasource,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  vm.purchasesColumns
        };

        vm.onSelection = function(data) {
            var selectedId = data.id;
            $state.go('purchaseItems', {id: selectedId});
        };
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyInfo', {
                parent: 'adminPharmacyView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminPharmacies/info/info.html',
                controller: 'AdminPharmacyViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacy');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewInfoController', AdminPharmacyViewInfoController);

    AdminPharmacyViewInfoController.$inject = ['$http', '$stateParams', 'Principal', '$scope', 'NotificationOptions', 'KendoService', 'Sector', '$timeout', 'CustomUtils'];

    function AdminPharmacyViewInfoController ($http, $stateParams, Principal, $scope, NotificationOptions, KendoService, Sector, $timeout, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(50);

        vm.isSaving = false;

        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']);

        vm.sector = {};
        vm.selectedSectorId = $stateParams.id;

        // DataSources
        vm.dataSource = {};
        vm.dataSource.companyTypes = KendoService.initDefaultDataSource('/api/masterdata/company-types');
        vm.dataSource.taxOffices = KendoService.initDefaultDataSource('/api/masterdata/tax-offices');
        vm.dataSource.taxStatuses = KendoService.initDefaultDataSource('/api/tax-statuses/search');
        vm.dataSource.workingHours = new kendo.data.DataSource({
            data: [
                { value: 'morning', text: 'Πρωί'},
                { value: 'afternoon', text: 'Απόγευμα'},
                { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
            ]
        });

        // Drop Down Options
        vm.dropDownOptions = {};
        vm.dropDownOptions.companyType = {
            dataSource: vm.dataSource.companyTypes,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.taxOffice = {
            dataSource: vm.dataSource.taxOffices,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.taxStatus = {
            dataSource: vm.dataSource.taxStatuses,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.dropDownOptions.workingHours = {
            dataSource: vm.dataSource.workingHours,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value"
        };

        $http.get('api/sectors/' + vm.selectedSectorId)
            .success(function (response) {
                vm.sector = response;
            })
            .error(function (response) {
                console.log(response);
            });

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.geodata = response.geodata;

                if(!vm.geodata) {
                    vm.dataSource.prefectures = KendoService.initDefaultDataSource('/api/masterdata/prefectures');

                    //DropDown Options
                    vm.prefecturesComboBoxOptions = {
                        dataSource: vm.dataSource.prefectures,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        change: function(e){
                            var filter = {};
                            if(this.value() && !isNaN(this.value())) {
                                filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": this.value()
                                };
                            }
                            vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                        }
                    };

                    var citiesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 50;
                                $http.get('/api/masterdata/cities',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        }
                    });

                    //DropDown Options
                    vm.citiesComboBoxOptions = {
                        dataSource: citiesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        template: "<table>${name} &nbsp;" +
                        "<span class='hint'>(${prefecture.name})</span></table>",
                        change: function(e){
                            var filter = {};
                            if(this.dataItem(this.select())) {
                                filter = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : this.dataItem(this.select()).prefecture.id
                                };
                            }
                            vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);

                        }
                    };
                }
                else {
                    var geodataDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100;
                                $http.get('/api/masterdata/geodata',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function(data) {
                                angular.forEach(data, function(item) {
                                    item.masterFilter = "";
                                    if(item.street !==null) {
                                        item.masterFilter =  item.street + ", ";
                                    }
                                    item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                                });
                                return data;
                            }
                        }
                    });

                    vm.masterFilterComboBoxOptions = {
                        dataSource: geodataDataSource,
                        filter: "search",
                        dataTextField: "masterFilter",
                        dataValueField: "id",
                        headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                        "<span>Διεύθυνση</span>"+
                        "<span>Πόλη</span>"+
                        "<span>Τ.Κ.</span>"+
                        "<span>Νομός</span></div>",
                        template:
                            "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                        placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                        change: function(e){
                            //initialize inputs (autocomplete)
                            if(this.dataItem(this.select())) {
                                var self = this;
                                //using $timeout to trigger the change
                                $timeout(function(){
                                    vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                                    vm.sector.cityName = self.dataItem(self.select()).city;
                                    vm.sector.address = self.dataItem(self.select()).street;
                                    vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                                    vm.suggestBricks(vm.sector.postalCode);
                                },0);
                            }
                        }
                    };
                }
            })
            .error(function (response) {
                console.log(response);
            });


        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorUpdate', result);
            vm.isSaving = false;
            notification.show({
                message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
            }, "success");
        };

        var onSaveError = function () {
            vm.isSaving = false;
            notification.show({
                message: "Η ενημέρωση των στοιχείων απέτυχε!"
            }, "error");
        };

        vm.save = function () {
            if (vm.validator.validate()){
                vm.isSaving = true;
                Sector.update(vm.sector, onSaveSuccess, onSaveError);
            }else {
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }
        };

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};

            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.brick = response.content[0].code;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.osfeBrick = response.content[0].code;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });
        };
    }
})();
;
/**
 * Created by gmogas on 8/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyEvents', {
                parent: 'adminPharmacyView',
                url: '/pharmacyEvents',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminPharmacies/events/events.html',
                controller: 'AdminPharmacyViewEventsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacy');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 8/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewEventsController', AdminPharmacyViewEventsController);

    AdminPharmacyViewEventsController.$inject = ['$stateParams', '$http', '$filter', 'KendoFilter'];

    function AdminPharmacyViewEventsController ($stateParams, $http, $filter, KendoFilter) {
        var vm = this;
        vm.pageHeading = 'Επισκέψεις στο φαρμακείο';
        vm.selectedSectorId = $stateParams.id;

        var grid = angular.element('#eventsGrid');

        var urls = {};
        urls.sectorEvents = '/api/sector/'+vm.selectedSectorId+'/events';

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.events = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                        }
                    });

                    $http.get(urls.sectorEvents,{params: o.data})
                        .success(function (response) {
                            //console.log(response);
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.content.forEach(function(item){

                            if (item.eventStatus === null) {
                                item.eventStatus = {};
                                item.eventStatus.name = "";
                            }

                            if(item.employee === null){
                                item.employee = {
                                    account : {
                                        lastName : ""
                                    }
                                }
                            }

                            if (item.eventCustomerSector === null) {
                                if (item.agreementValuation === null) {
                                    item.agreementValuation = {
                                        name: ""
                                    };
                                }

                                if (item.customerSector === null) {
                                    item.customerSector = {
                                        sector: {
                                            address: "",
                                            city: {
                                                name: ""
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (item.eventCustomerSector.agreementValuation === null) {
                                    item.eventCustomerSector.agreementValuation = {
                                        name: ""
                                    };
                                }
                            }

                        });
                    }
                    return data.content;
                },
                total : function(data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        name: { validation: { required: true , validation: { required: true, min: 3}} },
                        startedAt: { type: 'date'}
                    }
                }
            },
            batch: true,
            serverSorting: true,
            serverFiltering: true,
            serverPaging: true,
            pageSize: 50
        });

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.events = [
            {
                field: "startedAt",
                title: "Ημερομηνία Επίσκεψης",
                template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {
                field: "eventStatus.name",
                title: "Κατάσταση Επίσκεψης",
                attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "eventCustomerSector.agreementValuation.name",
                title: "Αξιολόγηση",
                template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null ) ? ' ' : eventCustomerSector.agreementValuation.name #",
                attributes: {
                    class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                command: [
                    {
                        name:"map2",
                        template: "<md-button class='md-fab md-mini md-primary' aria-label='Google Maps' " + "ng-class='{googlemap: vm.imageChoice(dataItem.eventCustomerSector), errormap: !vm.imageChoice(dataItem.eventCustomerSector)}' ng-click='vm.googleMapsRedirect(dataItem.eventCustomerSector)'></md-button>"
                    }
                ],
                attributes: { class: "#= 'link-cell-color' #" },
                title: "Τοποθεσία",
                width:120
            },
            {
                field: "eventCustomerSector.agreedPercent",
                title: "Ποσοστό Συχνότητας",
                template: "#= (eventCustomerSector.agreedPercent == null) ? ' ' : kendo.format('{0:p0}', eventCustomerSector.agreedPercent / 100)#",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "employee.account.lastName",
                title: "Επώνυμο Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "description",
                title: "Σημειώσεις",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.gridOptions = {};
        vm.gridOptions.events = {
            dataSource: vm.dataSource.grid.events,
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.gridColumns.events
        };
    }
})();
;
/**
 * Created by gmogas on 11/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyEmployees', {
                parent: 'adminPharmacyView',
                url: '/pharmacyEmployees',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminPharmacies/employees/employees.html',
                controller: 'AdminPharmacyViewEmployeesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacy');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 11/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewEmployeesController', AdminPharmacyViewEmployeesController);

    AdminPharmacyViewEmployeesController.$inject = ['$http', '$stateParams', 'EmployeeCustomerSector'];

    function AdminPharmacyViewEmployeesController ($http, $stateParams, EmployeeCustomerSector) {
        var vm = this;
        var grid = angular.element('#employeesGrid');
        var modal = angular.element('#popup-employee-customer-sector');
        var multiSelect = angular.element('#employees');

        vm.selectedSectorId = $stateParams.id;
        vm.selectedEmployeeCustomerSector = {};
        vm.selectedEmployeeCustomerSectors = [];
        vm.currentEmployeeCustomerSectors = [];
        vm.pageHeading = 'Ιατρικοί Επισκέπτες που επισκέπτονται το φαρμακείο';

        var urls = {};
        urls.sectorEmployees = '/api/sectors/'+vm.selectedSectorId+'/employees';

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.employee = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    $http.get(urls.sectorEmployees,{})
                        .success(function (response) {
                            vm.currentEmployeeCustomerSectors = response;
                            if( multiSelect.data('kendoMultiSelect')) multiSelect.data('kendoMultiSelect').dataSource.read();
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            batch: true,
            pageSize: 100,
            scrollable:false
        });

        vm.modalWindowOptions = {
            title: "Επιλέξτε ιατρικό επισκέπτη/τες",
            visible: false,
            modal: true,
            resizable: true,
            width: 800,
            height: 300
        };

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.employee = [
            {
                field: "employee.account.lastName",
                title: "Επώνυμο"
            },
            {
                field: "employee.account.firstName",
                title: "Όνομα"
            },
            {
                field: "employee.account.login",
                title: "Χρήστης"
            },
            {
                field: "employee.phone",
                title: "Τηλέφωνο"
            },
            {
                command:
                {
                    name: "delete",
                    text: "ΔΙΑΓΡΑΦΗ",
                    click: deleteButtonPush,
                    className: "k-i-cancel"
                },
                title: "&nbsp;"
            }
        ];

        vm.options = {};
        vm.options.employees = {
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = {filters: []};
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "account.authorities.name", "operator": "in",
                                    "value": "ROLE_PHARM_VISITOR", "ignoreCase": true}
                            ]
                        );

                        o.data.page = 1;
                        o.data.pageSize = 10000;
                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response, status, headers) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            //define object for data binding
                            if(item.account != null) {
                                item.active = true;
                                item.employee = {
                                    account : {
                                        fullName: item.account.lastName + " " + item.account.firstName
                                    },
                                    id: item.id
                                }
                            }
                        });

                        var filteredData = [];

                        data.forEach(function (item) {
                            var found = false;
                            vm.currentEmployeeCustomerSectors.forEach(function (ecs) {
                                if (ecs.employee.id == item.id) {
                                    found = true;
                                }
                            })
                            if (!found) {
                                filteredData.push(item);
                            }
                        });

                         return filteredData;
                    }
                }
            }),
            valuePrimitive: false,
            dataTextField: "employee.account.fullName",
            dataValueField: "employee.id"
        };


        vm.gridOptions = {};
        vm.gridOptions.employee = {
            dataSource: vm.dataSource.grid.employee,
            resizable: true,
            columns: vm.gridColumns.employee,
            toolbar: [
                {
                    name: "New Employee Customer Sector",
                    text: "New Employee Customer Sector",
                    template: "<input type='button' class='k-button' value = 'Ανάθεση σε ιατρικό επισκέπτη/τες' ng-click='vm.openModalWindow()' />"
                }
            ]
        };

        vm.openModalWindow = function() {
            modal.data("kendoWindow").center().open();
        };

        vm.closeModalWindow = function() {
            modal.data("kendoWindow").close();
        };

        function deleteButtonPush(e) {
            e.preventDefault();
            vm.selectedEmployeeCustomerSector = this.dataItem($(e.currentTarget).closest("tr"));
            vm.selectedEmployeeCustomerSector.active = false;
            EmployeeCustomerSector.update(vm.selectedEmployeeCustomerSector, onDeleteSaveSuccess, onDeleteSaveError);
        }

        vm.add = function () {
            var postData = [];
            vm.selectedEmployeeCustomerSectors.forEach(function (item) {
                var newPost = {};
                newPost.active = true;
                newPost.sector = {};
                newPost.sector.id = vm.selectedSectorId;
                newPost.employee = {};
                newPost.employee.id = item.id;
                postData.push(newPost)
            });

            $http.post('api/employee-customer-sectors/mass', postData, {}).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.selectedEmployeeCustomerSectors = [];
            grid.data('kendoGrid').dataSource.read();
            vm.closeModalWindow();
        }

        function onSaveError() {
            console.error("Error on saving vm.selectedEmployeeCustomerSectors");
        }

        function onDeleteSaveSuccess(result) {
            grid.data('kendoGrid').dataSource.read();
        }

        function onDeleteSaveError() {
            console.error("Error on saving vm.selectedEmployeeCustomerSector");
        }
    }

})();
;
/**
 * Created by gmogas on 11/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pharmacyCustomers', {
                parent: 'adminPharmacyView',
                url: '/pharmacyCustomers',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminPharmacies/customers/customers.html',
                controller: 'AdminPharmacyViewCustomersController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacy');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by gmogas on 11/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewCustomersController', AdminPharmacyViewCustomersController);

    AdminPharmacyViewCustomersController.$inject = ['$http', '$stateParams', 'Principal', 'Customer', 'CustomerSector'];

    function AdminPharmacyViewCustomersController ($http, $stateParams, Principal, Customer, CustomerSector) {
        var vm = this;

        var modal = angular.element('#popup-customer');
        var grid = angular.element('#customerSectorGrid');
        var multiSelect = angular.element('#customerType');

        vm.selectedSectorId = $stateParams.id;
        vm.selectedCustomerTypes = [];
        vm.pageHeading = 'Επαφές Φαρμακείου';
        vm.editableItem = {};
        vm.isSaving = false;

        var urls = {};
        urls.sectorCustomerSectors = '/api/sectors/'+vm.selectedSectorId+'/customer-sectors';

        vm.modalWindowOptions = {
            title: "Νέα επαφή",
            visible: false,
            modal: true,
            resizable: true,
            width: 800,
            height: 700
        };

        // DataSources
        vm.dataSource = {};
        vm.dataSource.grid = {};
        vm.dataSource.grid.customerSector = new kendo.data.DataSource({
            autoBind: false,
            transport: {
                read: function (o) {
                    $http.get(urls.sectorCustomerSectors,{})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.forEach(function(item) {
                            item.types = "";
                            if (item.customer != null && item.customer.customerTypes != null) {
                                item.customer.customerTypes.forEach(function (type) {
                                    if (item.types === "") {
                                        item.types = type.name;
                                    } else {
                                        item.types = item.types + ", " + type.name;
                                    }
                                })
                            }
                        });
                    }
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        startedAt: { type: 'date'},
                        endedAt: { type: 'date', defaultValue : null}
                    }
                }
            },
            batch: true,
            pageSize: 100,
            scrollable:false
        });

        // Grid Columns
        vm.gridColumns = {};
        vm.gridColumns.customerSector = [
            {
                field: "types",
                title: "Θέση",
                filterable: false
            },
            {
                field: "customer.lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.amka",
                title: "Α.Μ.Κ.Α.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.cellPhone",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.phone",
                title: "Σταθερό Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "startedAt",
                template: "#= startedAt ? kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy') : ''#",
                title: "Από",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {
                field: "endedAt",
                template: "#= endedAt ? kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy') : ''#",
                title: "Έως",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            }
        ];

        vm.canEditCustomerSector = false;
        if (Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_MANAGEMENT', 'ROLE_PHARM_SUPERVISOR'])) {
            vm.canEditCustomerSector = true;
            vm.gridColumns.customerSector.unshift({
                command:
                {
                    name: "edit",
                    text: "",
                    click: editButtonPush
                },
                title: "&nbsp;",
                width: 80
            });
        }

        vm.options = {};
        vm.options.customerTypes = {
            dataTextField: "name",
            dataValueField: "id",
            valuePrimitive: true,
            autoBind: true,
            dataSource: {
                data : [
                    {id : 3, name : "ΦΑΡΜΑΚΟΠΟΙΟΣ"},
                    {id : 4, name : "ΥΠΕΥΘΥΝΟΣ ΦΑΡΜΑΚΕΙΟΥ"},
                    {id : 5, name : "ΒΟΗΘΟΣ ΦΑΡΜΑΚΕΙΟΥ"}
                ]
            }
        };

        vm.gridOptions = {};
        vm.gridOptions.customerSector = {
            dataSource: vm.dataSource.grid.customerSector,
            resizable: true,
            selectable: true,
            columns: vm.gridColumns.customerSector,
            toolbar: [
                {
                    name: "New Customer Sector",
                    text: "New Customer Sector",
                    template: "<input type='button' class='k-button' value = 'Προσθήκη νέας επαφής' ng-show='vm.canEditCustomerSector' ng-click='vm.openModalWindow()' />"
                }
            ]
        };

        vm.closeModalWindow = function() {
            vm.editableItem = {};
            modal.data("kendoWindow").close();
        };

        vm.openModalWindow = function() {
            vm.editableItem = {};
            vm.editableItem.customer = {};
            vm.editableItem.customer.customerTypes = [{id : 3, name : "ΦΑΡΜΑΚΟΠΟΙΟΣ"}];
            vm.editableItem.sector = {};
            vm.editableItem.sector.id = vm.selectedSectorId;
            vm.editableItem.startedAt = getTodayDate();
            vm.showModalWindow();
        };

        function editButtonPush(e) {
            e.preventDefault();
            vm.editableItem = this.dataItem($(e.currentTarget).closest("tr"));
            vm.showModalWindow();
        }

        vm.showModalWindow = function() {
            vm.selectedCustomerTypes = [];
            vm.editableItem.customer.customerTypes.forEach(function (item) {
                vm.selectedCustomerTypes.push(item.id);
            });
            multiSelect.data('kendoMultiSelect').value(vm.selectedCustomerTypes);
            modal.data("kendoWindow").center().open();
        };

        vm.save = function () {
            vm.isSaving = true;

            vm.editableItem.customer.customerTypes = [];
            vm.selectedCustomerTypes.forEach(function (item) {
                vm.editableItem.customer.customerTypes.push({ id: item});
            });

            if (vm.editableItem.customer.id != null) {
                Customer.update(vm.editableItem.customer, onCustomerSaveSuccess, onCustomerSaveError);
            } else {
                Customer.save(vm.editableItem.customer, onCustomerSaveSuccess, onCustomerSaveError);
            }
        };

        var onCustomerSaveSuccess = function(result) {
            vm.editableItem.customer = result;

            vm.editableItem.startedAt = kendo.toString(kendo.parseDate(vm.editableItem.startedAt), 'yyyy-MM-dd');
            vm.editableItem.endedAt = kendo.toString(kendo.parseDate(vm.editableItem.endedAt), 'yyyy-MM-dd');

            console.log(vm.editableItem);
            if (vm.editableItem.id != null) {
                CustomerSector.update(vm.editableItem, onCustomerSectorSaveSuccess, onCustomerSectorSaveError);
            } else {
                CustomerSector.save(vm.editableItem, onCustomerSectorSaveSuccess, onCustomerSectorSaveError);
            }
        };

        var onCustomerSaveError = function() {
            vm.isSaving = false;
            console.log("errorrr on saving the customer");
        };

        var onCustomerSectorSaveSuccess = function(result) {
            grid.data('kendoGrid').dataSource.read();
            vm.isSaving = false;
            vm.closeModalWindow();
        };

        var onCustomerSectorSaveError = function() {
            vm.isSaving = false;
            console.log("errorrr on saving the customer sector");
        };

        function getTodayDate() {
            var today = new Date();

            var returnDate;

            if (today.getDate() < 10) {
                returnDate = today.getFullYear()
                    + '-'
                    + (today.getMonth() + 1)
                    + '-0'
                    + today.getDate();
            } else {
                returnDate = today.getFullYear()
                    + '-'
                    + (today.getMonth() + 1)
                    + '-'
                    + today.getDate();
            }

            return returnDate;
        }
    }
})();
;
/**
 * Created by Maria on 16/5/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmacyViewController', AdminPharmacyViewController);

    AdminPharmacyViewController.$inject = ['$rootScope', '$http','$state', '$stateParams', '$filter', 'Principal', '$scope'];

    function AdminPharmacyViewController ($rootScope, $http, $state, $stateParams, $filter, Principal, $scope) {
        var vm = this;

        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }

        vm.pageHeading = 'Επεξεργασια Φαρμακειου';
        vm.profilePicture = "hospital_icon.png";
        vm.selectedSectorId = $stateParams.id;
        vm.$state = $state;


        $http.get('api/sectors/' + vm.selectedSectorId)
            .success(function (response) {
                vm.sector = response;
                if (vm.sector && vm.sector.name){
                    vm.pageHeading = vm.sector.name;
                }
            })
            .error(function (response) {
                console.log(response);
            });

        kendo.Backbone = kendo.Backbone || {};

        kendo.Backbone.DataSource = kendo.data.DataSource.extend({
            init: function(options) {
                if (options.transport && options.transport.read) {
                    options.transport.read.type = 'GET';
                    options.transport.read.dataType = 'json';
                    options.transport.read.contentType = 'application/json;charset=UTF-8';
                    options.transport.read.parameterMap = function (data, operation) {
                        return JSON.stringify(data);
                    }
                }
                kendo.data.DataSource.fn.init.call(this, options);
            }
        });

        vm.goBack = function () {
            $state.go('adminPharmacies');
        };
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPharmacies', {
                parent: 'app',
                url: '/pharmacies',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.pharmacies.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminPharmacies/adminPharmacies.html',
                        controller: 'AdminPharmaciesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmacies');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('adminPharmacyView', {
            abstract: true,
            parent: 'app',
            url: '/pharmacies/search?id:pharmacyId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                pageTitle: 'sigmaCrmApp.pharmacies.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminPharmacies/adminPharmacyView.html',
                    controller: 'AdminPharmacyViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmacies');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPharmaciesController', AdminPharmaciesController);

    AdminPharmaciesController.$inject = ['$timeout', '$http','$state','$filter', 'Principal', 'KendoService', 'KendoGrid','KendoFilter', 'CustomUtils'];

    function AdminPharmaciesController ($timeout, $http, $state, $filter, Principal, KendoService, KendoGrid, KendoFilter, CustomUtils) {
        var vm = this;
        var pharmaciesGrid = angular.element('#pharmaciesGrid');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.principal = Principal;
        vm.showProgress = false;

        vm.canCreateSector = Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR']);
        vm.showFilters = false;
        vm.showFilters = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_SUPERVISOR']);
        vm.gridColumns = [];
        if (Principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'])){
            // GridColumns with Edit
            vm.gridColumns = [
                {
                    command: [
                        {name: "edit", text: ""}
                    ],
                    title: "&nbsp;",
                    width: 80
                },
                {
                    field: "code",
                    title: "Κωδικός Ε.Ε.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "name",
                    title: "Επωνυμία",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "vat",
                    title: "Α.Φ.Μ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "companyType.name",
                    title: "Εταιρική Μορφή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "address",
                    title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "addressNum",
                    title: "Αριθμός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "cityName",
                    title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "prefectureName",
                    title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "brick",
                    title: "Brick",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "osfeBrick",
                    title: "Brick ΟΣΦΕ",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "phone",
                    title: "Τηλέφωνο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "createdDate",
                    title: "Ημερομηνία εισαγωγής",
                    template: "#= kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                    template: "#= creditControlCheck === true ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true
                                })
                            },
                            showOperators: false
                        }
                    }}
            ];
        }else {
            // GridColumns without Edit
            vm.gridColumns = [
                {
                    field: "code",
                    title: "Κωδικός Ε.Ε.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "name",
                    title: "Επωνυμία",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "vat",
                    title: "Α.Φ.Μ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "companyType.name",
                    title: "Εταιρική Μορφή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "address",
                    title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "addressNum",
                    title: "Αριθμός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "cityName",
                    title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "prefectureName",
                    title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "brick",
                    title: "Brick",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "osfeBrick",
                    title: "Brick ΟΣΦΕ",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "phone",
                    title: "Τηλέφωνο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "createdDate",
                    title: "Ημερομηνία εισαγωγής",
                    template: "#= kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "creditControlCheck", title: "Πιστωτικός Έλεγχος",
                    template: "#= creditControlCheck === true ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true
                                })
                            },
                            showOperators: false
                        }
                    }}
            ];
        }

        vm.selectedEmployees = vm.selectedSupervisors = [];
        vm.sector= {};
        var comboBoxes = ["#masterFilter","#prefectures", "#cities"];

        vm.isSaving = false;

        vm.pageHeading = 'Φαρμακεια';

        vm.dataSource = {};
        vm.dataSource.companyTypes = KendoService.initDefaultDataSource('/api/masterdata/company-types');
        vm.dataSource.taxOffices = KendoService.initDefaultDataSource('/api/masterdata/tax-offices');
        vm.dataSource.taxStatuses = KendoService.initDefaultDataSource('/api/tax-statuses/search');

        vm.companyTypesComboBoxOptions = {
            dataSource: vm.dataSource.companyTypes,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.taxOfficesComboBoxOptions = {
            dataSource: vm.dataSource.taxOffices,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.taxStatusesComboBoxOptions = {
            dataSource: vm.dataSource.taxStatuses,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        vm.onExcelExportClick = function () {
            const grid = $("#pharmaciesGrid").data("kendoGrid");
            grid.saveAsExcel();
            vm.showProgress = true;
        };

        vm.onAddPharmacyClick = function () {
            const grid = $("#pharmaciesGrid").data("kendoGrid");
            grid.addRow();
        };

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.geodata = response.geodata;

                if(!vm.geodata) {
                    var prefecturesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100000;
                                $http.get('/api/masterdata/prefectures',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        }
                    });

                    //DropDown Options
                    vm.prefecturesComboBoxOptions = {
                        dataSource: prefecturesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        change: function(e){
                            var filter = {};
                            if(this.value() && !isNaN(this.value())) {
                                filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": this.value()
                                };
                            }
                            vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                        }
                    };

                    var citiesDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 50;
                                $http.get('/api/masterdata/cities',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        }
                    });

                    //DropDown Options
                    vm.citiesComboBoxOptions = {
                        dataSource: citiesDataSource,
                        filter: "startswith",
                        valuePrimitive: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        template: "<table>${name} &nbsp;" +
                        "<span class='hint'>(${prefecture.name})</span></table>",
                        change: function(e){
                            var filter = {};
                            if(this.dataItem(this.select())) {
                                filter = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : this.dataItem(this.select()).prefecture.id
                                };
                            }
                            vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);

                        }
                    };
                }
                else {
                    var geodataDataSource = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.page = 1;
                                o.data.pageSize = 100;
                                $http.get('/api/masterdata/geodata',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response.content);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function(data) {
                                angular.forEach(data, function(item) {
                                    item.masterFilter = "";
                                    if(item.street !==null) {
                                        item.masterFilter =  item.street + ", ";
                                    }
                                    item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                                });
                                return data;
                            }
                        }
                    });

                    vm.masterFilterComboBoxOptions = {
                        dataSource: geodataDataSource,
                        filter: "search",
                        dataTextField: "masterFilter",
                        dataValueField: "id",
                        headerTemplate:"<div class='dropdown-header k-widget k-header'>" +
                        "<span>Διεύθυνση</span>"+
                        "<span>Πόλη</span>"+
                        "<span>Τ.Κ.</span>"+
                        "<span>Νομός</span></div>",
                        template:
                            "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #",
                        placeholder: "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό",
                        change: function(e){
                            //initialize inputs (autocomplete)
                            if(this.dataItem(this.select())) {
                                var self = this;
                                //using $timeout to trigger the change
                                $timeout(function(){
                                    vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                                    vm.sector.cityName = self.dataItem(self.select()).city;
                                    vm.sector.address = self.dataItem(self.select()).street;
                                    vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                                    vm.suggestBricks(vm.sector.postalCode);
                                },0);
                            }
                        }
                    };
                }

                vm.pharmaciesGridOptions = {
                    dataSource: new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                //master filters functionality
                                if(vm.from && vm.to) {
                                    o.data.filter.filters = o.data.filter.filters.concat(
                                        [
                                            { "field": "createdDate", "operator": "from",
                                                "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                            { "field": "createdDate", "operator": "to",
                                                "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                        ]
                                    );
                                }

                                if (vm.selectedEmployees.length > 0) {
                                    o.data.selectedEmployeeIds = vm.selectedEmployees.toString();
                                }

                                if(vm.selectedSupervisors.length && !vm.selectedEmployees.length) {
                                    o.data.selectedSupervisorIds = vm.selectedSupervisors.toString();
                                }

                                angular.forEach( o.data.filter.filters, function(item) {
                                    if ( item.value instanceof Date) {
                                        item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                    }
                                });

                                $http.get('/api/me/pharmacies',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            },
                            create: function (o){
                                var data = o.data.models[0];
                                var params = {
                                    filter: { filters: [{ "field": "sectorTypeCategory", "operator": "startswith",  "value": "pharmacy"}] },
                                    page: 1,
                                    pageSize: 1
                                };

                                $http.get('/api/masterdata/sector-types', {params: params})
                                    .success(function (response) {
                                        data.sectorType = response.content[0];

                                        if(!data.companyType.id)
                                            data.companyType = null;
                                        if(!data.taxStatus.id)
                                            data.taxStatus = null;
                                        if(!data.taxOffice.id)
                                            data.taxOffice = null;
                                        if(!data.city.id)
                                            data.city = null;
                                        if(!data.prefecture.id)
                                            data.prefecture = null;

                                        if(vm.sector.city != null && (vm.sector.city.id === null || isNaN(vm.sector.city.id))){
                                            vm.sector.city = null;
                                        }

                                        if(vm.sector.prefecture != null && (vm.sector.prefecture.id === null || isNaN(vm.sector.prefecture.id))){
                                            vm.sector.prefecture = null;
                                        }

                                        angular.extend(data, vm.sector);

                                        $http.post('/api/sectors', data)
                                            .success(function (response) {
                                                pharmaciesGrid.data("kendoGrid").dataSource.read();
                                                vm.onSelection(response);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    })
                                    .error(function (response) {});
                            },
                            update: function (o){

                                var data = o.data.models[0];
                                var params = {
                                    filter: { filters: [{ "field": "sectorTypeCategory", "operator": "startswith",  "value": "pharmacy"}] },
                                    page: 1,
                                    pageSize: 1
                                };

                                $http.get('/api/masterdata/sector-types', {params: params})
                                    .success(function (response) {
                                        data.sectorType = response.content[0];

                                        if(!data.companyType.id)
                                            data.companyType = vm.sector.companyType = null;
                                        if(!data.taxStatus.id)
                                            data.taxStatus = vm.sector.taxStatus = null;
                                        if(!data.taxOffice.id)
                                            data.taxOffice = vm.sector.taxOffice = null;

                                        if(vm.sector.city != null) {
                                            if((vm.sector.city.id === null
                                                    || vm.sector.city.id === undefined || isNaN(vm.sector.city.id)) || vm.geodata){
                                                vm.sector.city = null;
                                            }
                                        }

                                        if(vm.sector.prefecture != null) {
                                            if((vm.sector.prefecture.id === null
                                                    || vm.sector.prefecture.id === undefined || isNaN(vm.sector.prefecture.id)) || vm.geodata){
                                                vm.sector.prefecture = null;
                                            }
                                        }

                                        angular.extend(data, vm.sector);

                                        $http.put('/api/sectors', data)
                                            .success(function (response) {
                                                pharmaciesGrid.data("kendoGrid").dataSource.read();
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    })
                                    .error(function (response) {});
                            },
                            parameterMap: function (options, operation) {
                                if (operation !== 'read') {
                                    return JSON.stringify(options.data.models);
                                } else {
                                    return data;
                                }
                            }
                        },
                        schema : {
                            data: function (data) {
                                angular.forEach( data.content, function (item) {
                                    if ( item.companyType == null ) {
                                        item.companyType = {};
                                    }
                                    if ( item.taxStatus == null ) {
                                        item.taxStatus = {};
                                    }
                                    if ( item.taxOffice == null ) {
                                        item.taxOffice = {};
                                    }
                                    if (item.creditControlCheck === null || item.creditControlCheck === undefined) {
                                        item.creditControlCheck = false;
                                    }
                                });
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: "id",
                                    name : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    vat : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    address : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    addressNum : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    cityName : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    prefectureName : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    brick : { editable: false },
                                    osfeBrick : { editable: false },
                                    phone : { editable: false, validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                    createdDate: { type: 'date', editable: false},
                                    companyType: { defaultValue: { id: null, name: null }},
                                    taxStatus: { defaultValue: { id: null, name: null }},
                                    taxOffice: { defaultValue: { id: null, name: null }},
                                    creditControlCheck: { type: "boolean" }
                                }
                            }
                        },
                        pageSize: 100,
                        serverPaging: true,
                        serverSorting: true,
                        scrollable:false,
                        serverFiltering :true
                    }),
                    dataBound: function(e) {
                        if (!vm.canCreateSector) {
                            var grid = pharmaciesGrid.data("kendoGrid");
                            var gridData = grid.dataSource.view();
                            if(gridData.length) {
                                var currentUid = gridData[0].uid;
                                var currentRow = grid.table.find("tr[data-uid='" + currentUid + "']");
                                var editButton = $(currentRow).find(".k-grid-edit");
                                editButton.hide();
                            }
                        }
                    },
                    noRecords: {
                        template: "Δεν βρέθηκαν Φαρμακεία"
                    },
                    sortable: true,
                    pageable: {
                        messages: {
                            display: "{0} - {1} από {2} Φαρμακεία", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                            empty: "Δεν βρέθηκαν Φαρμακεία",
                            page: "Σελίδα",
                            allPages: "Όλα",
                            of: "από {0}", // {0} is total amount of pages.
                            itemsPerPage: "εγγραφές ανά σελίδα",
                            first: "Πήγαινε στη πρώτη σελίδα",
                            previous: "Πήγαινε στη τελευταία σελίδα",
                            next: "Πήγαινε στην επόμενη σελίδα",
                            last: "Πήγαινε στη τελευταία σελίδα",
                            refresh: "Ανανέωση"
                        }
                    },
                    filterable: {
                        mode: "row"
                    },
                    resizable: true,
                    selectable: true,
                    columns:  vm.gridColumns,
                    height: vm.contentHeight,
                    editable: {
                        mode: "popup",
                        template: kendo.template($("#popup_editor_pharmacies").html())
                    },
                    edit: function(e) {
                        e.model.dirty = true;
                        vm.selectedSector = e.model;
                        if(e.model.id) {
                            vm.sector = vm.selectedSector;
                        } else {
                            vm.sector= {};
                        }

                        //refresh kendoComboBox
                        if(e.model.isNew()) {
                            angular.forEach(comboBoxes, function (item) {
                                var comboBox = angular.element(item).data("kendoComboBox");
                                if (comboBox) {
                                    vm.refreshCombobox({}, comboBox.dataSource);
                                }
                            });
                        }

                        if(!e.model.isNew()) {
                            if(e.model.prefecture && !vm.geodata){
                                var filter = {
                                    "field": "prefecture.id",
                                    "operator": "eq",
                                    "value": e.model.prefecture.id
                                };

                                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
                            }

                            if(e.model.city && !vm.geodata){
                                var filterCity = {
                                    "field"   : "id",
                                    "operator": "eq",
                                    "value"   : e.model.city.prefecture.id
                                };

                                vm.refreshCombobox(filterCity, vm.prefecturesComboBoxOptions.dataSource);
                            }
                        }

                        //if geodata init city and prefecture
                        if(!e.model.city) e.model.city = {};
                        if(!e.model.prefecture) e.model.prefecture = {};


                        KendoGrid.defaultCustomEditPopup(this._editContainer, 1000, 990);

                        // angular.element("div.k-edit-form-container").width(1000);
                        var wnd = angular.element(e.container).data("kendoWindow");
                        wnd.center();
                    },
                    cancel: function() {
                        pharmaciesGrid.data("kendoGrid").dataSource.read();
                    },
                    excel: {
                        allPages: true,
                        fileName: "Φαρμακεία.xlsx"
                    },
                    excelExport: function (e) {
                        const sheet = e.workbook.sheets[0];
                        var columnIdx = null;

                        for (var i=0; i<e.sender.columns.length; i++) {
                            if (e.sender.columns[i].field === "creditControlCheck") {
                                columnIdx = i;
                                break;
                            }
                        }

                        if (columnIdx != null) {
                            var template = kendo.template(this.columns[columnIdx].template);
                            for (var j = 1; j < sheet.rows.length; j++) {
                                var row = sheet.rows[j];

                                var dataItem = {
                                    creditControlCheck: row.cells[columnIdx - 1].value
                                };

                                row.cells[columnIdx - 1].value = template(dataItem);
                            }
                        }

                        vm.showProgress = false;
                    }
                };

            })
            .error(function (response) {
                console.log(response);
            });

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            console.log(e);

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            pharmaciesGrid.data("kendoGrid").dataSource.read();
        };

        vm.employeesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';

                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    if(vm.selectedSupervisors.length) {
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "supervisor.id", "operator": "in",
                                    "value": vm.selectedSupervisors.toString() }
                            ]
                        );
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.activated", "operator": "eqbool",
                                "value": true }
                        ]
                    );

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        };
                    });
                    return data;
                }
            }
        });

        vm.employeesMultiOptions = {
            dataSource: vm.employeesMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή Ιατρικού Επισκέπτη",
            change: function (e) {
                pharmaciesGrid.data("kendoGrid").dataSource.read();
            }
        };

        vm.supervisorsMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/me/employees';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_SUPERVISOR" },
                            { "field": "account.activated", "operator": "eqbool",
                                "value": true }

                        ]
                    );
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_PHARM_SUPERVISOR" }
                        ]
                    );
                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach(function (item) {
                        item.employee = {
                            account: {
                                fullName: item.account.lastName + " " + item.account.firstName
                            }
                        };
                    });
                    return data;
                }
            }
        });

        vm.supervisorsMultiOptions = {
            dataSource: vm.supervisorsMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "employee.account.fullName",
            dataValueField: "id",
            placeholder: "Επιλογή προισταμένου",
            change: function (e) {
                vm.employeesMulti.value('');
                vm.selectedEmployees = [];
                vm.employeesMulti.dataSource.read();
                pharmaciesGrid.data("kendoGrid").dataSource.read();
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                },
                { type: "separator" },
                { type: "separator" },
                {
                    template: "<label ng-if='vm.showFilters'>Ιατρικός Επισκέπτης: </label>"
                },
                {
                    template: "<input ng-if='vm.showFilters' id='multiSelect' style='width: 200px;' class='inline' multiple='multiple' k-options='vm.employeesMultiOptions' k-ng-model='vm.selectedEmployees' kendo-multi-select='vm.employeesMulti'/>",
                    overflow: "never"
                },
                {
                    template: "<label ng-if='vm.showFilters'>Προιστάμενος: </label>"
                },
                {
                    template: "<input ng-if='vm.showFilters' id='multiSelect' style='width: 200px;' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.selectedSupervisors'></input>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.from = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.to = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.onSelection = function(data) {
            var sectorId = data.id;
            $state.go('pharmacyInfo', {id: sectorId});
        };

        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};

            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.brick = response.content[0].code;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.osfeBrick = response.content[0].code;
                    }
                })
                .error(function (response) {
                    console.log(response);
                });
        };
    }
})();
;
/**
 * Created by Kristy on 10/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchReportPhoto', PatchReportPhoto);

    PatchReportPhoto.$inject = ['$http'];

    function PatchReportPhoto($http) {

        return {
            validationCheck: validationCheck
        };

        function validationCheck( gridData, patchPhotoType ) {
            var counter = 0;
            angular.forEach( gridData, function(item) {
                if( item.patchPhotoType == patchPhotoType) {
                    counter++
                }
            });

            switch (patchPhotoType) {
                case 'injury' :
                    return counter <= 3;
                    break;
                default :
                    return counter <= 4;
                    break;
            }
        }
    }
})();
;
/**
 * Created by Kristy on 3/10/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchItemMasterFilter', PatchItemMasterFilter);

    PatchItemMasterFilter.$inject = ['$http', '$timeout'];

    function PatchItemMasterFilter($http, $timeout) {
        var selectedPatchItems = [];
        var patchItemsMultiOptions = {
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20,
                transport: {
                    read: function (o) {
                        var url = '/api/masterdata/patch-items';
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            }),
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή επιθεμάτων",
            change: function (e) {
                setSelectedPatchItems(this.value());
                angular.element("#patchReportGrid2").data("kendoGrid").dataSource.read();
            }
        };

        return {
            getSelectedPatchItems: getSelectedPatchItems,
            setSelectedPatchItems: setSelectedPatchItems,
            getPatchItemsMultiOptions: function () {
                return patchItemsMultiOptions
            }
        };

        function getSelectedPatchItems() {
            return selectedPatchItems
        }

        function setSelectedPatchItems(value) {
            selectedPatchItems = value;
        }
    }
})();
;
/**
 * Created by Kristy on 25/4/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchReportGridsService', PatchReportGridsService);

    PatchReportGridsService.$inject = ['$http', '$filter', 'KendoFilter', 'PatchItemMasterFilter'];

    function PatchReportGridsService($http, $filter, KendoFilter, PatchItemMasterFilter) {

        var gridColumns = [
            {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.firstName", title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "barcode", title: "Barcode",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "materialCategory.name", title: "Κατηγορία Υλικού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            // {field: "submitPoint", title: "Σημείο Υποβολής",
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             template: function (args) {
            //                 KendoFilter.getTemplate(args);
            //             },
            //             showOperators: false
            //         }
            //     }
            // },
            {field: "approvalDate", title: "Ημερ/νια Έγκρισης",
                template: "#= approvalDate ? kendo.toString(kendo.parseDate(approvalDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdatetime",
                        showOperators: false
                    }
                }
            },
            {field: "checkDoctor", title: "Ελεγκτής Επαγγελματίας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        return {
            getGridOptions: function (filter) {
                return {
                    dataSource: new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function(o) {
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        { "field": "patchStatus", "operator": "eq",
                                            "value": filter }
                                    ]
                                );

                                if(PatchItemMasterFilter.getSelectedPatchItems().length) {
                                    o.data.filter.filters = o.data.filter.filters.concat(
                                        [
                                            { "field": "patchReportItems.patchItem.id", "operator": "in",
                                                "value": PatchItemMasterFilter.getSelectedPatchItems().toString() }
                                        ]
                                    );
                                }

                                angular.forEach( o.data.filter.filters, function(item) {
                                    if ( item.value instanceof Date ) {
                                        switch (item.operator) {
                                            case "eqdate":
                                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                                break;
                                            case "eqdatetime":
                                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                                break;
                                            default:
                                        }
                                    }
                                });

                                $http.get('/api/me/patch-reports',
                                    {params: o.data})
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                if(data.content != undefined) {
                                    data.content.forEach(function(item){
                                        if (item.materialCategory === null)
                                            item.materialCategory = {};
                                    });
                                }
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    issueDate: { type: 'date'},
                                    approvalDate: { type: 'date'}
                                }
                            }
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        pageSize: 50
                    }),
                    sortable: true,
                    pageable: true,
                    resizable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: gridColumns,
                    toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                        overflow: "never" }]
                };
            }
        };
    }
})();
;
/**
 * Created by Kristy on 3/10/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('DetailGridsService', DetailGridsService);

    DetailGridsService.$inject = ['$http', '$timeout'];

    function DetailGridsService($http, $timeout) {

        return {
            getPatchReportItemsGridOptions: function (dataItem) {
                if (dataItem != undefined) {
                    return {
                        dataSource: {
                            batch: true,
                            transport: {
                                read: function(o) {
                                    var url = '/api/me/patch-report-items';
                                    if (o.data.filter == undefined) {
                                        o.data.filter = { filters: [] };
                                    }
                                    o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                    $http.get(url, {params: o.data })
                                        .success(function (response,status,headers) {
                                            o.success(response);
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                }
                            },
                            schema: {
                                data: function (data) {
                                    if(data.content != undefined) {
                                        data.content.forEach(function(item){
                                            if (item.icd10 === null) item.icd10 = {};
                                        });
                                    }
                                    return data.content;
                                },
                                total: function (data) {
                                    return data.totalEntries;
                                },
                                model: {
                                    id: "id",
                                    fields: {
                                        id: {editable: false, nullable: true},
                                        monthlyQuantity: {type: 'number'}
                                    }
                                }
                            },
                            serverPaging: true,
                            pageSize: 15
                        },
                        pageable: true,
                        columns: [
                            {field: "patchItem.name", title: "Περιγραφή Υλικού",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        showOperators: false
                                    }
                                }
                            },
                            {field: "monthlyQuantity", title: "Μηνιαία Ποσότητα σε τεμάχια",
                                filterable: {
                                    cell: {
                                        operator: "eq",
                                        showOperators: false
                                    }
                                }
                            },
                            {field: "icd10.code", title: "Κωδικός Διάγνωσης",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        showOperators: false
                                    }
                                }
                            },
                            {field: "icd10.description", title: "Περιγραφή Διάγνωσης",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        showOperators: false
                                    }
                                }
                            },
                            {field: "comment", title: "Σχόλια",
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        showOperators: false
                                    }
                                }
                            }
                        ]
                    };
                }
            },
            getPatchReportPhotosGridOptions:  function (dataItem, gridColumns) {
                if (dataItem != undefined) {
                    return {
                        dataSource: {
                            batch: true,
                            transport: {
                                read: function(o) {
                                    var url = '/api/me/patch-report-photos';
                                    if (o.data.filter == undefined) {
                                        o.data.filter = { filters: [] };
                                    }
                                    o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                    $http.get(url, {params: o.data })
                                        .success(function (response,status,headers) {
                                            o.success(response);
                                        })
                                        .error(function (response) {
                                            console.log(response);
                                        });
                                }
                            },
                            schema: {
                                data: function (data) {
                                    return data.content;
                                },
                                total: function (data) {
                                    return data.totalEntries;
                                },
                                model: {
                                    id: "id",
                                    fields: {
                                        id: {editable: false, nullable: true},
                                        monthlyQuantity: {type: 'number'}
                                    }
                                }
                            },
                            serverPaging: true,
                            pageSize: 15
                        },
                        pageable: true,
                        columns: gridColumns
                    };
                }
            }
        };
    }
})();
;
/**
 * Created by Kristy on 30/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchReports.pendingHistory', {
                parent: 'adminPatchReports',
                url: '/pendingHistory',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
                },
                templateUrl: 'app/displays/adminPatchReports/pendingHistory/pendingHistory.html',
                controller: 'PendingHistoryPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 30/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingHistoryPatchReportsController', PendingHistoryPatchReportsController);

    PendingHistoryPatchReportsController.$inject = ['$http','$state', '$q', 'PatchReportGridsService','$filter', '$timeout', 'KendoGrid', 'DetailGridsService', 'PatchItemMasterFilter', 'KendoFilter'];

    function PendingHistoryPatchReportsController ($http, $state, $q, PatchReportGridsService, $filter, $timeout, KendoGrid, DetailGridsService, PatchItemMasterFilter, KendoFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;
        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.pendingHistoryGridOptions = PatchReportGridsService.getGridOptions('executed');

        vm.gridColumns = [
            {field: "patchPhotoName", title: "Όνομα αρχείου"},
            {field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#"},
            {
                command:[
                    { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                ],
                title: "&nbsp",
                width:90
            }
        ];
    }
})();
;
/**
 * Created by Kristy on 30/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchReports.pending', {
                parent: 'adminPatchReports',
                url: '/pending',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
                },
                templateUrl: 'app/displays/adminPatchReports/pending/pending.html',
                controller: 'PendingPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 30/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingPatchReportsController', PendingPatchReportsController);

    PendingPatchReportsController.$inject = ['$http', '$scope', '$q','$filter', 'PatchReportGridsService', 'NotificationOptions', 'DetailGridsService', 'PatchItemMasterFilter', 'DataUtils', 'PatchReportPhoto', 'KendoFilter'];

    function PendingPatchReportsController ($http, $scope, $q, $filter, PatchReportGridsService, NotificationOptions, DetailGridsService, PatchItemMasterFilter, DataUtils, PatchReportPhoto, KendoFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        // vm.executePatchReport = function(e) {
        //     e.preventDefault();
        //     // e.target is the DOM element representing the button
        //     var tr = $(e.target).closest("tr"); // get the current table row (tr)
        //     // get the data bound to the current table row
        //     var data = this.dataItem(tr);
        //
        //     $http.put('api/patch-reports/' + data.id + '/execute', data)
        //         .success(function (response,status,headers) {
        //             notification.show({
        //                 message: "Η εγγραφή εκτελέστηκε με επιτυχία!"
        //             }, "success");
        //             vm.pendingGridOptions.dataSource.read();
        //         })
        //         .error(function (response) {
        //             notification.show({
        //                 message: "Η ενημέρωση των στοιχείων απέτυχε!"
        //             }, "error");
        //             console.log(response);
        //         });
        // };

        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.pendingGridOptions = PatchReportGridsService.getGridOptions('pending');

        vm.onSelectImage = function(e) {
            var file = e.files[0].rawFile;
            console.log(file);
        };

        vm.patchPhotoTypeDataSource = [
            { id: 'injury', name: 'Τραύμα' },
            { id: 'booklet', name: 'Βιβλιάριο' },
            { id: 'report', name: 'Χαρτί γνωμάτευσης' }
        ];

        vm.setPatchPhoto = function ($file) {

            if ($file) {
                if ($file.size > 1024000) {
                    notification.show({
                        message: "Το αρχείο δεν πρέπει να ξεπερνάει τα 500kB!"
                    }, "error");
                    return;
                }
            }

            if(!$scope.$$phase) {
                $scope.$apply(function() {
                    vm.patchPhotoName = $file.name;
                });
            }

            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    vm.patchReportPhoto = base64Data;
                });
            }
        };

        vm.deletePatchPhoto = function() {
            delete vm.patchReportPhoto;
            delete vm.patchPhotoName;
        };

        vm.gridColumns = [
            {field: "patchPhotoName", title: "Όνομα αρχείου"},
            {field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#"},
            {
                command:[
                    { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                ],
                title: "&nbsp",
                width:90
            }
        ];


        // Principal.hasAuthority('ROLE_MANAGEMENT').then( function (result) {
        //     if (result) {
        //         vm.gridColumns.unshift({
        //             command:[
        //                 { name:"execute", text: "Εκτέλεση", click: vm.executePatchReport }
        //             ],
        //             attributes: { class: "#= 'green-color' #" },
        //             title: "&nbsp",
        //             width:90
        //         });
        //
        //         vm.pendingGrid.setOptions({
        //             columns: vm.gridColumns
        //         });
        //     }
        // });
    }
})();
;
/**
 * Created by Kristy on 25/4/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchReports.partExecuted', {
                parent: 'adminPatchReports',
                url: '/partExecuted',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
                },
                templateUrl: 'app/displays/adminPatchReports/partExecuted/partExecuted.html',
                controller: 'PartExecutedPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/4/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PartExecutedPatchReportsController', PartExecutedPatchReportsController);

    PartExecutedPatchReportsController.$inject = ['$http','$state', '$q', 'PatchReportGridsService','$filter', '$timeout', 'DetailGridsService', 'PatchItemMasterFilter', 'KendoFilter'];

    function PartExecutedPatchReportsController ($http, $state, $q, PatchReportGridsService, $filter, $timeout, DetailGridsService, PatchItemMasterFilter, KendoFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;

        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.partedExecutedGridOptions = PatchReportGridsService.getGridOptions('partExecuted');

        vm.gridColumns = [
            {field: "patchPhotoName", title: "Όνομα αρχείου"},
            {field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#"},
            {
                command:[
                    { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                ],
                title: "&nbsp",
                width:90
            }
        ];
    }
})();
;
/**
 * Created by Kristy on 25/4/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchReports.cancelled', {
                parent: 'adminPatchReports',
                url: '/cancelled',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
                },
                templateUrl: 'app/displays/adminPatchReports/cancelled/cancelled.html',
                controller: 'CanceledPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 25/4/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CanceledPatchReportsController', CanceledPatchReportsController);

    CanceledPatchReportsController.$inject = ['$http','$state', '$q', 'PatchReportGridsService','$filter', '$timeout', 'DetailGridsService', 'PatchItemMasterFilter', 'KendoFilter'];

    function CanceledPatchReportsController ($http, $state, $q, PatchReportGridsService, $filter, $timeout, DetailGridsService, PatchItemMasterFilter, KendoFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;

        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.canceledGridOptions = PatchReportGridsService.getGridOptions('cancelled');

        vm.gridColumns = [
            {field: "patchPhotoName", title: "Όνομα αρχείου"},
            {field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#"},
            {
                command:[
                    { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                ],
                title: "&nbsp",
                width:90
            }
        ];
    }
})();
;
/**
 * Created by Kristy on 30/9/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchReports', {
                parent: 'app',
                url: '/patch-reports',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminPatchReports/adminPatchReports.html',
                        controller: 'AdminPatchReportsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 30/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPatchReportsController', AdminPatchReportsController);

    AdminPatchReportsController.$inject = ['$http', '$state', 'ApplicationParameters', 'PatchItemMasterFilter'];

    function AdminPatchReportsController ($http, $state, ApplicationParameters, PatchItemMasterFilter) {
        var vm = this;
        vm.selectedPatchItems = PatchItemMasterFilter.getSelectedPatchItems();
        ApplicationParameters.hasModule('Patches', true);

        vm.patchItemsMultiOptions = PatchItemMasterFilter.getPatchItemsMultiOptions();

        vm.toolbarOptions = {
            items: [
                { template: "<label>Επίθεμα: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.patchItemsMulti' multiple='multiple' " +
                "k-options='vm.patchItemsMultiOptions' k-ng-model='vm.selectedPatchItems'></select>", overflow: "never" }
            ]
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminPatchDoctors', {
                parent: 'app',
                url: '/patch-doctors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminPatchDoctors/adminPatchDoctors.html',
                        controller: 'AdminPatchDoctorsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPatchDoctorsController', AdminPatchDoctorsController);

    AdminPatchDoctorsController.$inject = ['$http','$state','$filter', 'Principal', 'ApplicationParameters', 'KendoFilter', 'KendoGrid'];

    function AdminPatchDoctorsController ($http, $state, $filter, Principal, ApplicationParameters, KendoFilter, KendoGrid) {
        var vm = this;

        ApplicationParameters.hasModule('Patches', true);

        vm.pageHeading = 'Συστησαντες Επαγγελματίες Υγείας';
        //
        //Data for DropDown
        var cityDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    var url = '/api/v1/cities/all';
                    $http.get(url)
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });


                }
            }
        });
        //DropDown Options
        vm.cityDropDownOptions = {
            dataSource: cityDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        //Data for DropDown
        vm.specialtyDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/doctor-specialties',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        //Data for DropDown
        vm.categoryDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/customer-categories',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        //Data for DropDown
        vm.subCategoryDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/customer-sub-categories',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        var sectorDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    var url = '/api/sectors';
                    $http.get(url)
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });


                }
            }
        });
        //DropDown Options
        vm.sectorDropDownOptions = {
            dataSource: sectorDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        var assignedUserDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    var url = '/api/employees';
                    $http.get(url)
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });

                }
            }
        });
        //DropDown Options
        vm.assignedUserDropDownOptions = {
            dataSource: assignedUserDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.dayTimeDataSource = new kendo.data.DataSource({
            data: [
                { value: 'day', text: "ΠΡΩΙΝΌ"},
                { value: 'night',  text: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}
            ]
        });

        vm.titleDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/customer-titles',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.customerUrl = "/api/customers";

        vm.gridColumns = [
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "doctorSpecialty.name",
                title: "Ειδικοτητα 1η",
                editor: function(container, options) {
                    angular.element('<select id="doctor-specialty" data-bind="value:doctorSpecialty.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.specialtyDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "doctorSpecificSpecialty.name",
                title: "Ειδικοτητα 2η",
                editor: function(container, options) {
                    angular.element('<select id="doctor-specific-specialty" data-bind="value:doctorSpecificSpecialty.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.specialtyDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                field: "customerCategory.name",
                title: "Κατηγορία",
                editor: function(container, options) {
                    angular.element('<select id="customer-category" data-bind="value:customerCategory.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.categoryDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 94
            },
            {
                field: "customerSubCategory.name",
                title: "Υποκατηγορία",
                editor: function(container, options) {
                    angular.element('<select id="customer-subcategory" data-bind="value:customerSubCategory.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.subCategoryDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 115
            },
            //{
            //    field: "user.lastName",
            //    title: "Πόρος",
            //    filterable: {
            //        cell: {
            //            operator: "startswith",
            //            showOperators: false
            //        }
            //    }
            //},
            //{
            //    field: "user.user_detail.district.name",
            //    title: "Περιοχή",
            //    aggregates: ["count"],
            //    filterable: {
            //        cell: {
            //            operator: "startswith",
            //            showOperators: false
            //        }
            //    }
            //},
            //{
            //    field: "sector.name",
            //    title: "Τύπος Μονάδας Υγείας",
            //    filterable: {
            //        cell: {
            //            operator: "startswith",
            //            showOperators: false
            //        }
            //    }
            //},
            {
                field: "cellPhone",
                title: "Κινητό Τηλ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 90
            },
            {
                field: "phone",
                title: "Σταθερό Τηλ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 90
            },
            {
                field: "email",
                title: "Email",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 151
            },
            {
                field: "dayTime",
                title: "Ωράριο",
                template: "#= (dayTime == 'day') ? 'ΠΡΩΙΝΌ' : (dayTime == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                editor: function(container, options) {
                    angular.element('<select id="day-time" data-bind="value:dayTime"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.dayTimeDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ value: "day", text: "ΠΡΩΙΝΌ" },
                                        { value: "night", text: "ΑΠΟΓΕΥΜΑΤΙΝΌ" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                width: 120
            },
            //{
            //    field: "city.county.name",
            //    title: "Νομός",
            //    filterable: {
            //        cell: {
            //            operator: "startswith",
            //            showOperators: false
            //        }
            //    }
            //},
            //{
            //    field: "city.name",
            //    title: "Πόλη",
            //    filterable: {
            //        cell: {
            //            operator: "startswith",
            //            showOperators: false
            //        }
            //    }
            //},
            {
                field: "customerTitle.name",
                title: "Τίτλος",
                editor: function(container, options) {
                    angular.element('<select id="customer-title" data-bind="value:customerTitle.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.titleDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 120
            },
            {
                field: "isActive",
                title: "Ενεργός",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }],
                                    filtering : function(e){
                                        console.log(e)
                                    }
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                width: 75,
                template: "#= (isActive == '1') ? 'Ναι' : 'Όχι' #"
            },
            {
                field: "saw",
                title: "MyTarget",
                filterable: {
                    cell: {
                        operator: "eqbool",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                width: 80,
                template: "#= (saw == '1') ? 'Ναι' : 'Όχι' #"
            },
            {field: "createdDate", title: "Ημερομηνία Εισαγωγής", template: "#= kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm')#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                },
                width: 140
            },
            {
                hidden: true,
                field: "customerTypes",
                title: "Τύποι Επαγγελματία Υγείας",
                filterable: false,
                editor: function (container, options) {
                    angular.element('<select id="customerTypes" multiple="multiple" data-bind="value: customerTypes"/>')
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    {id:2, name:"ΕΠΑΓΓΕΛΜΑΤΙΕΣ ΥΓΕΙΑΣ ΓΙΑ ΕΠΙΘΕΜΑΤΑ"}
                                ]
                            }),
                            valuePrimitive: false,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                width: 120
            }
        ];

        vm.gridToolbar = [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
            overflow: "never" }];

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('/api/patches/customers',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function (o){

                        var data = o.data.models[0];

                        if(!data.customerCategory.id)
                            data.customerCategory = null;

                        if(!data.customerSubCategory.id)
                            data.customerSubCategory = null;

                        if(!data.customerTitle.id)
                            data.customerTitle = null;

                        if(!data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        if(!data.doctorSpecificSpecialty.id)
                            data.doctorSpecificSpecialty = null;

                        //type for patches customers
                        //data.customerTypes = [{ id: 2 }];

                        $http.post(vm.customerUrl, data)
                            .success(function (response) {
                                var newCustomerId = response.id;
                                $state.go('customerInfo', {id: newCustomerId});
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function (o){

                        var data = o.data.models[0];

                        if(!data.customerCategory.id)
                            data.customerCategory = null;

                        if(!data.customerSubCategory.id)
                            data.customerSubCategory = null;

                        if(!data.customerTitle.id)
                            data.customerTitle = null;

                        if(!data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        if(!data.doctorSpecificSpecialty.id)
                            data.doctorSpecificSpecialty = null;

                        $http.put(vm.customerUrl, data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                batch: true,
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if(item.doctorSpecialty === null){
                                    item.doctorSpecialty = {};
                                    item.doctorSpecialty.name = "";
                                }

                                if(item.doctorSpecificSpecialty === null){
                                    item.doctorSpecificSpecialty = {};
                                    item.doctorSpecificSpecialty.name = "";
                                }

                                if(item.customerCategory === null){
                                    item.customerCategory = {};
                                    item.customerCategory.name = "";
                                }

                                if(item.customerSubCategory === null){
                                    item.customerSubCategory = {};
                                    item.customerSubCategory.name = "";
                                }

                                if(item.customerTitle === null){
                                    item.customerTitle = {};
                                    item.customerTitle.name = "";
                                }

                            });
                        }
                        return data.content;

                    },
                    total: function (data) {
                      return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true},
                            isActive:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            saw:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            doctorSpecialty:{defaultValue: {id: null, name : null}},
                            doctorSpecificSpecialty:{defaultValue: {id: null, name : null}},
                            customerCategory:{defaultValue: { id : null, name : null}},
                            customerTitle:{defaultValue: { id : null, name : null}},
                            customerSubCategory:{defaultValue: { id : null, name : null}},
                            dayTime:{defaultValue: null},
                            createdDate: { type: 'date', editable: false},
                            customerTypes: {defaultValue: [{ id : 2, name : "ΕΠΑΓΓΕΛΜΑΤΙΕΣ ΥΓΕΙΑΣ ΓΙΑ ΕΠΙΘΕΜΑΤΑ"}]}
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            }),
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns: vm.gridColumns,
            save: function (e) {
                var customersGrid = angular.element("#mainGrid").data("kendoGrid");
                customersGrid.refresh();
            },
            toolbar: vm.gridToolbar
        };

        Principal.hasAuthority('ROLE_HEALTH_VISITOR').then( function (result) {
            if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {

                var grid = angular.element("#mainGrid").data("kendoGrid");
                vm.gridColumns.unshift({
                    command: [
                        {name: "edit", text: ""}
                    ],
                    title: "&nbsp;",
                    width: 80
                });

                vm.gridToolbar.unshift({name: "create", text: "Προσθήκη Νέου Επαγγελματία Υγείας"});

                grid.setOptions({
                    columns: vm.gridColumns,
                    editable: {
                        mode: "popup"
                    },
                    edit: function(e) {
                        //$scope.countyName = e.model.city.county.name;
                        KendoGrid.defaultEditPopup(this._editContainer);

                        //fix css
                        angular.element( "input[name='isActive']" ).parent().addClass("k-checkbox-custom");
                        angular.element( "input[name='saw']" ).parent().addClass("k-checkbox-custom");
                        angular.element( "div[data-container-for='customerTypes']" ).addClass("k-multi-custom");
                        angular.element( "label[for='createdDate']" ).parent().next().addClass("k-text-custom");
                    },
                    toolbar: vm.gridToolbar
                });
            }
        });

        vm.onSelection = function(data) {
            var selectedId = data.id;
            $state.go('customerInfo', {id: selectedId, stateFrom: 'adminPatchDoctors'});
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adminPatchCustomers', {
            parent: 'app',
            url: '/patch-customers',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_STOREHOUSE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminPatchCustomers/adminPatchCustomers.html',
                    controller: 'AdminPatchCustomersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminPatchCustomersController', AdminPatchCustomersController);

    AdminPatchCustomersController.$inject = ['$scope', '$state', '$timeout', 'Principal', '$filter', 'ParseLinks', 'AlertService', 'KendoFilter', 'ApplicationParameters','$http'];

    function AdminPatchCustomersController ($scope, $state, $timeout, Principal, $filter, ParseLinks, AlertService, KendoFilter, ApplicationParameters, $http) {
        var vm = this;

        vm.pageHeading = 'Ασθενεις';
        ApplicationParameters.hasModule('Patches', true);

        var socialInsuranceDataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 50;
                    $http.get('/api/masterdata/social-insurances',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.socialInsuranceComboBoxOptions = {
            dataSource: socialInsuranceDataSource,
            filterable: true,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.gridColumns = [
            {
                field: "firstName",
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "lastName",
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "amka",
                title: "Α.Μ.Κ.Α",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "directAma", title: "Α.Μ.Α",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "socialInsurance.name", title: "Ασφάλιση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.gridToolbar = [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
            overflow: "never" }];

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        $http.get('/api/patch-customers/filter',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){
                                if (!item.socialInsurance) {
                                    item.socialInsurance = {};
                                }
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 100
            }),
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: vm.gridColumns,
            toolbar: vm.gridToolbar
        };
    }
})();
;
/**
 * Created by Kristy on 14/9/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SupervisorsService', SupervisorsService);

    SupervisorsService.$inject = ['$http', '$timeout'];

    function SupervisorsService($http, $timeout) {
        var selectedSupervisors = [];

        return {
            getSelectedSupervisors: function () {
                return selectedSupervisors;
            },
            setSelectedSupervisors: function (value) {
                selectedSupervisors = value;
            }
        };
    }
})();
;
/**
 * Created by Kristy on 11/9/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MasterToKendoFiltersService', MasterToKendoFiltersService);

    MasterToKendoFiltersService.$inject = ['SupervisorsService', '$filter', 'MasterFilters'];

    function MasterToKendoFiltersService(SupervisorsService, $filter, MasterFilters) {

        return {
            getMasterFilters: getMasterFilters
        };

        function getMasterFilters(data, masterFilters, view) {
            switch(view) {
                case 'customers':
                    if (masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("createdDate", masterFilters.from, masterFilters.to) );
                    }
                    if (masterFilters.selectedCustomers.length && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedCustomers[0] == 'all')) {
                        var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" :  masterFilters.selectedCustomers[0] === "none" ? masterFilters.selectedCustomers[0] : masterFilters.selectedCustomers.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "customerSectors.employeeCustomerSectors.employee.id", "in", selectedCustomers ) );
                    }
                    if ((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedCustomers.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedCustomers[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "customerSectors.employeeCustomerSectors.employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                    }
                    if (masterFilters.selectedSpecialties) {
                        var selectedSpecialties = masterFilters.selectedSpecialties[0] === "all" ? "" :  masterFilters.selectedSpecialties[0] === "none" ? masterFilters.selectedSpecialties[0] : masterFilters.selectedSpecialties.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "doctorSpecialty.id", "in", selectedSpecialties ) );
                    }
                    if(masterFilters.selectedSoftwares) {
                        if (masterFilters.selectedSoftwares.length) {
                            data = data.concat(
                                [
                                    {
                                        "field": "software",
                                        "operator": masterFilters.selectedSoftwares.indexOf('none') > -1 ? "isnull" : "in",
                                        "value": masterFilters.selectedSoftwares.indexOf('all') > -1 ? "medexpress,medmobile" :
                                            masterFilters.selectedSoftwares.indexOf('none') > -1 ? null :
                                                masterFilters.selectedSoftwares.toString()
                                    }
                                ]
                            );
                        }
                    }
                    if(masterFilters.lastVisitDate) {
                        if (masterFilters.lastVisitDate.value) {
                            data = data.concat(
                                [
                                    {
                                        "field": "lastVisitDate",
                                        "operator": masterFilters.lastVisitDate.operator ? masterFilters.lastVisitDate.operator : 'eqdate',
                                        "value": masterFilters.lastVisitDate.value
                                    }
                                ]
                            );
                        }
                    }
                    data = data.concat(
                        [
                            {
                                "field": "customerSectors.employeeCustomerSectors.myTarget", "operator": "eqbool",
                                "value": masterFilters.saw
                            }
                        ]
                    );
                    data = data.concat(
                        [
                            {
                                "field": "isActive", "operator": "eqbool",
                                "value": masterFilters.isActive
                            }
                        ]
                    );
                    break;
                case 'customerSectors':
                    if (masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("lastModifiedDate", masterFilters.from, masterFilters.to) );
                    }
                    if (masterFilters.selectedCustomerSectors.length && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedCustomerSectors[0] == 'all')) {
                        var selectedCustomerSectors = masterFilters.selectedCustomerSectors[0] === "all" ? "" :  masterFilters.selectedCustomerSectors[0] === "none" ? masterFilters.selectedCustomerSectors[0] : masterFilters.selectedCustomerSectors.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employeeCustomerSectors.employee.id", "in", selectedCustomerSectors ) );
                        data = data.concat( MasterFilters.addMasterFilter( "employeeCustomerSectors.customerSectors.myTarget", "eqbool", masterFilters.myTarget ) );
                    }
                    if ((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedCustomerSectors.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedCustomerSectors[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "employeeCustomerSectors.employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                        data = data.concat( MasterFilters.addMasterFilter( "employeeCustomerSectors.customerSectors.myTarget", "eqbool", masterFilters.myTarget ) );
                    }
                    if (masterFilters.selectedCities.length) {
                        var cityArray = [];
                        angular.forEach(masterFilters.selectedCities, function (city) {
                            cityArray.push(city);
                        });

                        var selectedCities = masterFilters.selectedCities[0].id === "all" ? "" :  masterFilters.selectedCities[0].id === "none" ? masterFilters.selectedCities[0] : JSON.stringify(cityArray);
                        data = data.concat( MasterFilters.addMasterFilter( "sector.cityName", "in", selectedCities ) );
                    }
                    if (masterFilters.selectedPrefectures.length) {
                        var prefectureArray = [];
                        angular.forEach(masterFilters.selectedPrefectures, function (prefecture) {
                            prefectureArray.push(prefecture);
                        });

                        var selectedPrefectures = masterFilters.selectedPrefectures[0] === "all" ? "" :  masterFilters.selectedPrefectures[0] === "none" ? masterFilters.selectedPrefectures[0] : JSON.stringify(prefectureArray);
                        data = data.concat( MasterFilters.addMasterFilter( "sector.prefectureName", "in", selectedPrefectures ) );
                    }
                    if (masterFilters.selectedSectorTypes.length) {
                        console.log(masterFilters.selectedSectorTypes);
                        var selectedSectorTypes = masterFilters.selectedSectorTypes[0] === "all" ? "" :  masterFilters.selectedSectorTypes[0] === "none" ? masterFilters.selectedSectorTypes[0] : masterFilters.selectedSectorTypes.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "sector.sectorType.id", "in", selectedSectorTypes ) );
                    }
                    break;
                case 'events':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilterGMT("startedAt", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length  && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" :  masterFilters.selectedEmployees[0] === "none" ? masterFilters.selectedEmployees[0] : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }
                    if((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedEmployees.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                    }
                    if(masterFilters.selectedCustomers) {
                        var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" : masterFilters.selectedCustomers.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "eventCustomerSector.customerSector.customer.id", "in", selectedCustomers ) );
                    }
                    if(masterFilters.eventStatus) {
                        data = data.concat(
                            [
                                { "field": "eventStatus.id", "operator": "eq",
                                    "value": masterFilters.eventStatus }
                            ]
                        );
                    }
                    if(masterFilters.selectedAgreementValuations) {
                        var selectedAgreementValuations = masterFilters.selectedAgreementValuations[0] === "all" ? "" :  masterFilters.selectedAgreementValuations[0] === "none" ? masterFilters.selectedAgreementValuations[0] : masterFilters.selectedAgreementValuations.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "eventCustomerSector.agreementValuation.id", "in", selectedAgreementValuations ) );
                    }
                    break;
                case 'events_filter':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("startedAt", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length  && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" :  masterFilters.selectedEmployees[0] === "none" ? masterFilters.selectedEmployees[0] : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }
                    if((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedEmployees.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                    }
                    if(masterFilters.selectedCustomers) {
                        var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" : masterFilters.selectedCustomers.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "eventCustomerSector.customerSector.customer.id", "in", selectedCustomers ) );
                    }
                    if(masterFilters.eventStatus) {
                        data = data.concat(
                            [
                                { "field": "eventStatus.id", "operator": "eq",
                                    "value": masterFilters.eventStatus }
                            ]
                        );
                    }
                    if(masterFilters.selectedAgreementValuations) {
                        var selectedAgreementValuations = masterFilters.selectedAgreementValuations[0] === "all" ? "" :  masterFilters.selectedAgreementValuations[0] === "none" ? masterFilters.selectedAgreementValuations[0] : masterFilters.selectedAgreementValuations.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "eventCustomerSector.agreementValuation.id", "in", selectedAgreementValuations ) );
                    }
                    break;
                case 'otherEvents':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("dateFrom", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length  && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" :  masterFilters.selectedEmployees[0] === "none" ? masterFilters.selectedEmployees[0] : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }
                    if((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedEmployees.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                    }
                    break;
                case 'agreements':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("event.startedAt", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length  && !(SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "event.employee.id", "in", selectedEmployees ) );
                    }
                    if((SupervisorsService.getSelectedSupervisors().length && !masterFilters.selectedEmployees.length) || (SupervisorsService.getSelectedSupervisors().length && masterFilters.selectedEmployees[0] == 'all')) {
                        data = data.concat( MasterFilters.addMasterFilter( "event.employee.id", "in_with_hierarchy", SupervisorsService.getSelectedSupervisors().toString() ) );
                    }
                    if(masterFilters.selectedCustomers.length) {
                        var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" : masterFilters.selectedCustomers.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "event.eventCustomerSector.customerSector.customer.id", "in", selectedCustomers ) );
                    }
                    if(masterFilters.selectedProducts) {
                        var selectedProducts = masterFilters.selectedProducts[0] === "all" ? "" : masterFilters.selectedProducts.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "product.id", "in", selectedProducts ) );
                    }
                    if(masterFilters.selectedAgreementValuations) {
                        var selectedAgreementValuations = masterFilters.selectedAgreementValuations[0] === "all" ? "" : masterFilters.selectedAgreementValuations.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "agreementValuation.id", "in", selectedAgreementValuations ) );
                    }
                    break;
                case 'employeeVisits':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("startedAt", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }
                    break;
                case 'customerProducts':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("event.startedAt", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "event.employee.id", "in", selectedEmployees ) );
                    }
                    if(masterFilters.selectedProducts) {
                        var selectedProducts = masterFilters.selectedProducts[0] === "all" ? "" : masterFilters.selectedProducts.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "product.id", "in", selectedProducts ) );
                    }
                    if(masterFilters.selectedCustomers.length) {
                        var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" : masterFilters.selectedCustomers.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "event.eventCustomerSector.customerSector.customer.id", "in", selectedCustomers ) );
                    }
                    break;
                case 'purchasesReport':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateOnlyFilter("issueDate", masterFilters.from, masterFilters.to) );
                    }
                    if(masterFilters.selectedEmployees.length) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }
                    if(masterFilters.selectedPharmacies.length) {
                        var selectedPharmacies = masterFilters.selectedPharmacies[0] === "all" ? "" : masterFilters.selectedPharmacies.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "sector.id", "in", selectedPharmacies ) );
                    }
                    break;
                case 'hospitalizations':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateOnlyFilter("dateIssue", masterFilters.from, masterFilters.to) );
                    }
                    break;
                case 'leadManagement':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("dateTime", masterFilters.from, masterFilters.to) );
                    }
                    // Remove bookedAppointment filter ECRM-337
                    /*if(masterFilters.from1) {
                        data = data.concat( MasterFilters.addMasterFilter( "appointmentDate", "from", masterFilters.from1 ) );
                    }
                    if(masterFilters.to1) {
                        data = data.concat( MasterFilters.addMasterFilter( "appointmentDate", "to", masterFilters.to1 ) );
                    }*/
                    if (masterFilters.selectedCallTypes && masterFilters.selectedCallTypes.length > 0) {
                        var selectedCallTypes = masterFilters.selectedCallTypes[0] === "all" ? "" :  masterFilters.selectedCallTypes[0] === "none" ? masterFilters.selectedCallTypes[0] : masterFilters.selectedCallTypes.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "callType.id", "in", selectedCallTypes ) );
                    }

                    data = data.concat( MasterFilters.addMasterFilter( "hospitalizations", "isnull", masterFilters.hospitalizations ) );
                    //data = data.concat( MasterFilters.addMasterFilter( "bookedAppointment", "eqbool", masterFilters.bookedAppointment ) );
                    break;
                case "followUp":
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("leadCall.dateTime", masterFilters.from, masterFilters.to) );
                    }
                    // Remove bookedAppointment filter ECRM-337
                    /*if(masterFilters.from1) {
                        data = data.concat( MasterFilters.addMasterFilter( "leadCall.appointmentDate", "from", masterFilters.from1 ) );
                    }
                    if(masterFilters.to1) {
                        data = data.concat( MasterFilters.addMasterFilter( "leadCall.appointmentDate", "to", masterFilters.to1 ) );
                    }*/

                    data = data.concat( MasterFilters.addMasterFilter( "leadCall.hospitalizations", "isnull", masterFilters.hospitalizations ) );
                    //data = data.concat( MasterFilters.addMasterFilter( "leadCall.bookedAppointment", "eqbool", masterFilters.bookedAppointment ) );
                    break;
                case "leadHospitalizations":
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("leadHospitalization.leadCalls.dateTime", masterFilters.from, masterFilters.to) );
                    }
                    // Remove bookedAppointment filter ECRM-337
                    /*if(masterFilters.from1) {
                        data = data.concat( MasterFilters.addMasterFilter( "leadHospitalization.leadCalls.appointmentDate", "from", masterFilters.from1 ) );
                    }
                    if(masterFilters.to1) {
                        data = data.concat( MasterFilters.addMasterFilter( "leadHospitalization.leadCalls.appointmentDate", "to", masterFilters.to1 ) );
                    }*/

                    data = data.concat( MasterFilters.addMasterFilter( "leadHospitalization.leadCalls.hospitalizations", "isnull", masterFilters.hospitalizations ) );
                    //data = data.concat( MasterFilters.addMasterFilter( "leadHospitalization.leadCalls.bookedAppointment", "eqbool", masterFilters.bookedAppointment ) );
                    break;
                case "patchReports":
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateOnlyFilter("patchReport.issueDate", masterFilters.from, masterFilters.to) );
                    }
                    break;
                case 'schedules':
                    if(masterFilters.from && masterFilters.to) {
                        data = data.concat( MasterFilters.addDateFilter("eventSchedule.startedAt", masterFilters.from, masterFilters.to) );
                    }
                    break;
                case 'medReport':
                    data = data.concat( MasterFilters.addMasterFilter( "isActive", "eqbool", true ) );

                    data = data.concat(
                        [
                            {
                                "field": "isActive", "operator": "eqbool",
                                "value": masterFilters.isActive
                            }
                        ]
                    );

                    if(masterFilters.selectedMonths) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                }
                            ]
                        );
                    }

                    if(masterFilters.selectedYears) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inYears",
                                    "value": masterFilters.selectedYears.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inYears",
                                    "value": masterFilters.selectedYears.toString()
                                }
                            ]
                        );
                    }

                    if (masterFilters.selectedEmployees) {
                        if(masterFilters.selectedEmployees.length) {
                            var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                            data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                        }
                    }
                    if (masterFilters.selectedCustomers) {
                        if (masterFilters.selectedCustomers.length) {
                            var selectedCustomers = masterFilters.selectedCustomers[0] === "all" ? "" : masterFilters.selectedCustomers.toString();
                            data = data.concat(MasterFilters.addMasterFilter("sector.id", "in", selectedCustomers));
                        }
                    }
                    if (masterFilters.selectedMedicines) {
                        if (masterFilters.selectedMedicines.length) {
                            data = data.concat(MasterFilters.addMasterFilter("medReportLines.medicine.id", "in", masterFilters.selectedMedicines.toString()));
                        }
                    }
                    break;
                case 'medReportSumsPerCustomerAndMonth':
                    data = data.concat( MasterFilters.addMasterFilter( "isActive", "eqbool", true ) );

                    data = data.concat(
                        [
                            {
                                "field": "isActive", "operator": "eqbool",
                                "value": masterFilters.isActive
                            }
                        ]
                    );

                    if(masterFilters.selectedMonths) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                }
                            ]
                        );
                    }

                    if(masterFilters.selectedYear) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inYears",
                                    "value": masterFilters.selectedYear.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inYears",
                                    "value": masterFilters.selectedYear.toString()
                                }
                            ]
                        );
                    }

                    if(masterFilters.selectedEmployees.length) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }

                    if (masterFilters.selectedMedicines.length) {
                        data = data.concat(MasterFilters.addMasterFilter("medReportLines.medicine.id", "in", masterFilters.selectedMedicines.toString()));
                    }
                    break;
                case 'medReportSumsPerMonth':
                    data = data.concat( MasterFilters.addMasterFilter( "isActive", "eqbool", true ) );

                    data = data.concat(
                        [
                            {
                                "field": "isActive", "operator": "eqbool",
                                "value": masterFilters.isActive
                            }
                        ]
                    );

                    if(masterFilters.selectedMonths) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inMonths",
                                    "value": masterFilters.selectedMonths.toString()
                                }
                            ]
                        );
                    }

                    if(masterFilters.selectedYear) {
                        data = data.concat(
                            [
                                {
                                    "field": "fromDate", "operator": "inYears",
                                    "value": masterFilters.selectedYear.toString()
                                },
                                {
                                    "field": "toDate", "operator": "inYears",
                                    "value": masterFilters.selectedYear.toString()
                                }
                            ]
                        );
                    }

                    if(masterFilters.selectedEmployees.length) {
                        var selectedEmployees = masterFilters.selectedEmployees[0] === "all" ? "" : masterFilters.selectedEmployees.toString();
                        data = data.concat( MasterFilters.addMasterFilter( "employee.id", "in", selectedEmployees ) );
                    }

                    if (masterFilters.selectedMedicines.length) {
                        data = data.concat(MasterFilters.addMasterFilter("medReportLines.medicine.id", "in", masterFilters.selectedMedicines.toString()));
                    }
                    break;
            }
            return data
        }
    }
})();
;
/**
 * Created by Kristy on 14/9/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MasterFiltersService', MasterFiltersService);

    MasterFiltersService.$inject = ['$http', '$timeout', 'SupervisorsService'];

    function MasterFiltersService($http, $timeout, SupervisorsService) {
        var supervisorsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/employees/all';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_SUPERVISOR" },
                            { "field": "account.activated", "operator": "eqbool",
                                "value": true }
                        ]
                    );
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach( function (item) {
                        if(item.id !== "all" && item.id !== "none") {
                            item.employee = {
                                account: {
                                    fullName: item.account.lastName + " " + item.account.firstName
                                }
                            };
                        }
                    });
                    return data;
                }
            }
        });
        var agreementValuationsDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }
                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/agreement-valuations',
                        {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"all", name:"Επιλογή όλων"});
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });
        var customersDataSource = new kendo.data.DataSource({
            serverSorting: true,
            transport: {
                read: function(o) {
                    var url = '/api/me/customers';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "lastName",  "dir": "asc" };
                    }
                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"all", fullName:"Επιλογή όλων"});
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach( function (item) {
                        if(item.id !== "all")
                            item.fullName = item.lastName + " " + item.firstName;
                    });
                    return data;
                }
            },
            serverPaging: true,
            serverFiltering :true
        });
        var callTypesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: function (o) {
                    var url = '/api/call-types';
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    if (o.data.sort == undefined || !o.data.sort.length) {
                        o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                    }
                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "account.authorities", "operator": "eq",
                                "value": "ROLE_SUPERVISOR" }
                        ]
                    );
                    $http.get(url)
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    return data;
                }
            }
        });
        function getEmployeesDataSource(operations) {
            return new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                transport: {
                    read: function(o) {
                        var url = '/api/employees/all';
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }
                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                        }
                        if(o.data.filter.filters.length) {
                            if(o.data.filter.filters[0].field == 'name') {
                                o.data.filter.filters[0].field = 'employee.account.fullName'
                            }
                            o.data.filter.filters = [o.data.filter.filters[0]];
                        }

                        if(SupervisorsService.getSelectedSupervisors().length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "supervisor.id", "operator": "in",
                                        "value": SupervisorsService.getSelectedSupervisors().toString() }
                                ]
                            );
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "account.activated", "operator": "eqbool",
                                    "value": true }
                            ]
                        );

                        if(operations.indexOf("me") !== -1){
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "employee.id", "operator": "in", "value": "me"}
                                ]
                            );
                        }

                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                if (operations.indexOf("all") !== -1) {
                                    response.unshift({id:"all",name :"Επιλογή όλων"});
                                }
                                if (operations.indexOf("none") !== -1 && !SupervisorsService.getSelectedSupervisors().length) {
                                    response.unshift({id:"none", name :"(Κενό)"});
                                }
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    parse: function (data) {
                        data.forEach(function (item) {
                            if (item.id !== "all" && item.id !== "none") {
                                item.name = item.account.lastName + " " + item.account.firstName
                            }
                        });
                        return data;
                    }
                }
            });
        }

        function getPharmaciesDataSource(operations) {
            return new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                transport: {
                    read: function (o) {
                        var url = '/api/me/pharmacies';
                        if (o.data.filter === undefined) {
                            o.data.filter = {filters: []};
                        }

                        o.data.page = 1;
                        o.data.pageSize = 100;
                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                if (operations.indexOf("all") !== -1) {
                                    response.content.unshift({id: "all", name: "Επιλογή όλων"});
                                }
                                if (operations.indexOf("none") !== -1) {
                                    response.content.unshift({id: "none", name: "(Κενό)"});
                                }
                                o.success(response.content);
                            })
                            .error(function () {});
                    }
                }
            });
        }

        return {
            getAgreementValuationsComboBoxOptions : getAgreementValuationsComboBoxOptions,
            getEmployeesComboBoxOptions : getEmployeesComboBoxOptions,
            getCustomersComboBoxOptions : getCustomersComboBoxOptions,
            getSupervisorsComboBoxOptions : getSupervisorsComboBoxOptions,
            getPharmaciesComboBoxOptions : getPharmaciesComboBoxOptions,
            getCallTypeComboBoxOptions : getCallTypeComboBoxOptions,
            selectAllNone: selectAllNone,
            clearFilterEvent: clearFilterEvent
        };

        function clearFilterEvent() {
            angular.element(".k-i-close").click(function(e) {
                angular.element(e.target.parentElement).next().data("kendoMultiSelect").dataSource.filter({});
            });
        }

        function selectAllNone(combobox, dataItem, values, operations) {
            if (dataItem.id === "all" || dataItem.id === "none") {
                combobox.value("");
            } else if (operations.indexOf("all") !== -1 && values.indexOf("all") !== -1) {
                values = angular.element.grep(values, function(value) {
                    return value !== "all";
                });
                combobox.value(values);
            } else if (operations.indexOf("none") !== -1 && values.indexOf("none") !== -1) {
                values = angular.element.grep(values, function(value) {
                    return value !== "none";
                });
                combobox.value(values);
            }
        }

        function getAgreementValuationsComboBoxOptions() {
            return {
                dataSource: agreementValuationsDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                select: function(e) {
                    var dataItem = this.dataSource.view()[e.item.index()];
                    var values = this.value();
                    var self = this;

                    selectAllNone(self, dataItem, values, ["all"]);
                }
            };
        }

        function getSupervisorsComboBoxOptions() {
            return {
                dataSource: supervisorsDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "employee.account.fullName",
                dataValueField: "id",
                placeholder: "Επιλογή προισταμένου"
            };
        }

        function getEmployeesComboBoxOptions(operations) {
            return {
                dataSource: getEmployeesDataSource(operations),
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                placeholder: "Επιλογή Ιατρικού Επισκέπτη",
                select: function (e) {
                    var dataItem = this.dataSource.view()[e.item.index()];
                    var values = this.value();
                    var self = this;

                    selectAllNone(self, dataItem, values, operations);
                },
                close:function(){
                    if (!this.value().length) {
                        this.dataSource.filter({});
                    }
                }
            };
        }

        function getPharmaciesComboBoxOptions(operations) {
            return {
                dataSource: getPharmaciesDataSource(operations),
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                placeholder: "Επιλογή Φαρμακείου",
                select: function (e) {
                    var dataItem = this.dataSource.view()[e.item.index()];
                    var values = this.value();
                    var self = this;

                    selectAllNone(self, dataItem, values, operations);
                },
                close:function(){
                    if (!this.value().length) {
                        this.dataSource.filter({});
                    }
                }
            };
        }

        function getCustomersComboBoxOptions() {
            return {
                dataSource: customersDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "fullName",
                dataValueField: "id",
                placeholder: "Επιλογή Επαγγελματία Υγείας",
                select: function (e) {
                    var dataItem = this.dataSource.view()[e.item.index()];
                    var values = this.value();
                    var self = this;

                    selectAllNone(self, dataItem, values, ["all"]);
                }
            };
        }

        function getCallTypeComboBoxOptions() {
            return {
                dataSource: callTypesDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                placeholder: "Επιλογή Τύπου Κλήσης",
                select: function (e) {
                    var dataItem = this.dataSource.view()[e.item.index()];
                    var values = this.value();
                    var self = this;

                    selectAllNone(self, dataItem, values, ["all"]);
                }
            };
        }
    }
})();
;
/**
 * Created by Kristy on 07/9/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('FavouriteFiltersService', FavouriteFiltersService);

    FavouriteFiltersService.$inject = ['SupervisorsService'];

    function FavouriteFiltersService(SupervisorsService) {

        return {
            setMasterOptions: setMasterOptions,
            clearMasterFilters: clearMasterFilters,
            getKendoOptions: getKendoOptions,
            setKendoOptions: setKendoOptions
        };

        function setMasterOptions(options, masterFilters) {
            angular.forEach(options, function (option) {
                var multiSelect = [];
                if( typeof option.value === "string" ) multiSelect = option.value === "none" ? [option.value] : option.value === "" ? ["all"] : option.value.split(',').map(function (item) {
                    return parseInt(item, 10);
                });

                if (option.field.endsWith("appointmentDate")){
                    // This for extra filters 'appointmentDate - from/to' in LeadManagement reports
                    if (option.operator === "from") masterFilters.from1 = new Date(option.value.split(".")[0]);
                    if (option.operator === "to") masterFilters.to1 = new Date(option.value.split(".")[0]);
                }else {
                    if (option.operator === "from") masterFilters.from = new Date(option.value.split(".")[0]);
                    if (option.operator === "to") masterFilters.to = new Date(option.value.split(".")[0]);
                }
                if (option.operator === "in_with_hierarchy") {
                    masterFilters.selectedSupervisors = option.value === "" ? [] : option.value.split(',').map(function (item) {
                        return parseInt(item, 10);
                    });
                    SupervisorsService.setSelectedSupervisors(masterFilters.selectedSupervisors)
                }

                if (option.field === "fromDate") {
                    if (option.operator === "inMonths") masterFilters.selectedMonths = multiSelect;
                    if (option.operator === "inYears") masterFilters.selectedYear = multiSelect;
                }
                if (option.operator === "in" && option.field === "medReportLines.medicine.id")
                    masterFilters.selectedMedicines = multiSelect;
                if ((option.operator === "in" && option.field === "customerSectors.employeeCustomerSectors.employee.id") || option.field.indexOf("customer.id") !== -1)
                    masterFilters.selectedCustomers = multiSelect;
                if (option.operator === "in" && option.field === "employeeCustomerSectors.employee.id")
                    masterFilters.selectedCustomerSectors = multiSelect;
                if (option.field === "doctorSpecialty.id")
                    masterFilters.selectedSpecialties = option.value === "none" ? [option.value] : option.value === "" ? [] : option.value.split(',').map(function (item) {
                        return parseInt(item, 10);
                    });
                if (option.field === "callType.id"){
                    masterFilters.selectedCallTypes = option.value === "none" ? [option.value] : option.value === "" ? [] : option.value.split(',').map(function (item) {
                        return parseInt(item, 10);
                    });
                }
                if (option.operator === "in" && (option.field === "employee.id" || option.field === "event.employee.id"))
                    masterFilters.selectedEmployees = multiSelect;
                if (option.field.indexOf("agreementValuation.id") !== -1)
                    masterFilters.selectedAgreementValuations = multiSelect;
                if (option.field.indexOf("product.id") !== -1)
                    masterFilters.selectedProducts = multiSelect;
                if (option.field === "sector.id")
                    masterFilters.selectedPharmacies = multiSelect;
                if (option.field === "sector.cityName")
                    masterFilters.selectedCities = option.value === "none" ? [{id : option.value}] : option.value === "" ? [{ id: "all" }] : JSON.parse(option.value);
                if (option.field === "sector.prefectureName")
                    masterFilters.selectedPrefectures = option.value === "none" ? [{id : option.value}] : option.value === "" ? [{ id: "all" }] : JSON.parse(option.value);
                if (option.field === "sector.sectorType.id")
                    masterFilters.selectedSectorTypes = multiSelect;
                if (option.field === "customerSectors.employeeCustomerSectors.myTarget") masterFilters.saw = option.value;
                if (option.field === "isActive") masterFilters.isActive = option.value;
                if (option.field === "eventStatus.id") masterFilters.eventStatus = option.value;
                if (option.field.indexOf("myTarget") !== -1) masterFilters.myTarget = option.value;
                if (option.field.indexOf("hospitalizations") !== -1) masterFilters.hospitalizations = option.value;
                if (option.field.indexOf("bookedAppointment") !== -1) masterFilters.bookedAppointment = option.value;
            });

            return masterFilters;
        }

        function clearMasterFilters() {
            angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
            SupervisorsService.setSelectedSupervisors([]);
            return {
                selectedSupervisors: [],
                selectedCustomers: [],
                selectedSpecialties: [],
                selectedCallTypes: [],
                saw: true,
                isActive: true,
                myTarget: true,
                hospitalizations: false,
                bookedAppointment: false,
                selectedCustomerSectors: [],
                selectedCities: [],
                selectedPrefectures: [],
                selectedSectorTypes: [],
                selectedEmployees: [],
                selectedProducts: [],
                selectedAgreementValuations: [],
                selectedPharmacies: [],
                selectedMedicines: [],
                selectedMonths: [],
                selectedYear: null};
        }

        function getKendoOptions(grid) {
            return {
                "filters": grid.getOptions().dataSource.filter ? grid.getOptions().dataSource.filter.filters : [],
                "sort": grid.getOptions().dataSource.sort ? grid.getOptions().dataSource.sort : [],
                "group": grid.getOptions().dataSource.group,
                "aggregate": grid.getOptions().dataSource.aggregate ? grid.getOptions().dataSource.aggregate : []
            };
        }

        function setKendoOptions(options, grid) {

            if (options) {
                grid.dataSource.query({
                    filter: options.filters ? options.filters : [],
                    sort: options.sort ? options.sort : [],
                    group: options.group ? options.group : [],
                    aggregate: options.aggregate ? options.aggregate : []
                });
            }
            else {
                if (grid.getOptions().sortable) {
                    grid.dataSource.query({
                        filter: [],
                        sort: [],
                        group: []
                    });
                }
            }
        }
    }
})();
;
/**
 * Created by Kristy on 02/09/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('schedulesAll', {
                parent: 'adminIndex',
                url: '/schedules/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/schedulesAll/schedulesAll.html',
                        controller: 'SchedulesAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "schedules"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 02/09/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SchedulesAllController', SchedulesAllController);

    SchedulesAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'favouriteFilters','KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'employee', 'CustomUtils'];

    function SchedulesAllController ($scope, $filter, $http, $timeout, KendoFilter, favouriteFilters, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                          MasterToKendoFiltersService, employee, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Ραντεβού";
        vm.contentWidth = CustomUtils.getWidthPixelsFromPercentage(84);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(51);
        vm.url = '/api/event-schedules/all';
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = {};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'schedules';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' onkeydown='return false' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' onkeydown='return false' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var grid = {};
        grid.columns = [
            {
               title: "Επαγγελματίας Υγείας",
               columns: [
                   {
                       field: "eventCustomerSector.customerSector.customer.lastName",
                       title: "Επώνυμο Επαγγελματία Υγείας",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       }
                   },
                   {
                       field: "eventCustomerSector.customerSector.customer.firstName",
                       title: "Όνομα Επαγγελματία Υγείας",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       }
                   },
                   {
                       field: "eventCustomerSector.customerSector.customer.doctorSpecialty.name",
                       title: "Ειδικότητα 1η",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       }
                   },
                   {
                       field: "eventCustomerSector.customerSector.customer.customerCategory.name",
                       title: "Κατηγορία",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       width: 94
                   },
                   {
                       field: "eventCustomerSector.customerSector.customer.customerSubCategory.name",
                       title: "Υποκατηγορία",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       width: 115
                   },
                   {
                       field: "eventCustomerSector.customerSector.customer.collaboration.name",
                       title: "Συνεργασία",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       width: 100
                   }
               ]
            },
            {
                field: "eventSchedule.startedAt",
                title: "Ημερομηνία Ραντεβού",
                template: "#= eventSchedule.startedAt ? kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                filterable: false,
                groupable: false
            },
            {
                title: "Μονάδα Υγείας",
                columns: [
                    {
                        field: "eventCustomerSector.sector.sectorType.name",
                        title: "Τύπος",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "eventCustomerSector.sector.name",
                        title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "eventCustomerSector.sector.address",
                        title: "Διεύθυνση",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "eventCustomerSector.sector.cityName",
                        title: "Πόλη",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "eventCustomerSector.sector.prefectureName",
                        title: "Νομός",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                    o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                    // o.data.filter.filters.push({
                    //     field: "eventCustomerSector.customerSector",
                    //     operator: "isnotnull",
                    //     value: "null"
                    // });

                    $http.get(vm.url, {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data !== null && data !== undefined) {
                        data.forEach(function(item){
                            if (!item.eventCustomerSector) {
                                item.eventCustomerSector = {
                                    customerSector: {
                                        customer: {
                                            last_name: "",
                                            first_name: "",
                                            doctorSpecialty: {},
                                            customerCategory: {},
                                            customerSubCategory: {},
                                            collaboration: {}
                                        },
                                        sector: {
                                            address: "",
                                            city: {
                                                name: ""
                                            }
                                        }
                                    },
                                    sector: {
                                        address: "",
                                        sectorType: {}
                                    }
                                };
                            } else {
                                if (!item.eventCustomerSector.customerSector) {
                                    item.eventCustomerSector.customerSector = {
                                        customer: {
                                            last_name: "",
                                            first_name: "",
                                            doctorSpecialty: {},
                                            customerCategory: {},
                                            customerSubCategory: {},
                                            collaboration: {}
                                        },
                                        sector: {
                                            address: "",
                                            city: {
                                                name: ""
                                            }
                                        }
                                    };
                                } else {
                                    if (!item.eventCustomerSector.customerSector.customer.doctorSpecialty)
                                        item.eventCustomerSector.customerSector.customer.doctorSpecialty = {};

                                    if (!item.eventCustomerSector.customerSector.customer.customerCategory)
                                        item.eventCustomerSector.customerSector.customer.customerCategory = {};

                                    if (!item.eventCustomerSector.customerSector.customer.customerSubCategory)
                                        item.eventCustomerSector.customerSector.customer.customerSubCategory = {};

                                    if (!item.eventCustomerSector.customerSector.customer.collaboration)
                                        item.eventCustomerSector.customerSector.customer.collaboration = {};
                                }

                                if (item.eventCustomerSector.sector == null) {
                                    item.eventCustomerSector.sector = {
                                        sectorType: {}
                                    };
                                }

                                if (item.eventCustomerSector.sector.sectorType == null) {
                                    item.eventCustomerSector.sector.sectorType = {
                                        name: ""
                                    };
                                }
                            }
                        });
                    }
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: {editable: false, nullable: false},
                        'eventSchedule.startedAt': { type: 'date'}
                    }
                }
            }
        });
        vm.mainGridOptions = {
            autoBind: false,
            dataSource: grid.dataSource,
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: grid.columns,
            toolbar: [
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αναφορά Ραντεβού.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };
    }
})();
;
/**
 * Created by Kristy on 22/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesReport', {
                parent: 'adminIndex',
                url: '/purchases/report',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/purchasesReport/purchasesReport.html',
                        controller: 'PurchasesReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "purchasesReport"
                        }] } }} );
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 22/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesReportController', PurchasesReportController);

    PurchasesReportController.$inject = ['$scope', '$filter', '$timeout','$http', 'employee', 'favouriteFilters', 'FavouriteFiltersService', 'MasterFiltersService', 'KendoFilter', 'MasterToKendoFiltersService', 'CustomUtils', 'CustomDataUtils', 'Alerts'];

    function PurchasesReportController ($scope, $filter, $timeout, $http, employee, favouriteFilters, FavouriteFiltersService, MasterFiltersService, KendoFilter, MasterToKendoFiltersService, CustomUtils, CustomDataUtils, Alerts) {
        var vm = this;
        vm.url = '/api/purchases/all';
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(57);
        vm.gridGrouped = false;
        vm.exportOnlyTotals = true;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { selectedEmployees: [], selectedPharmacies: [] };
        vm.pageHeading = 'Αναφορά Παραγγελιών';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'purchasesReport';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to || (vm.masterFilters.selectedEmployees.length === 0);
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };

        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to", "vm.masterFilters.selectedEmployees"], function () { setView(); });
        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        vm.pharmaciesMultiOptions = MasterFiltersService.getPharmaciesComboBoxOptions(["all"]);
        vm.pharmaciesMultiOptions.dataSource.filter({});

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                vm.clearDatePickers();

                $timeout(function (){
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function (){
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function (){
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Φαρμακείο: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.pharmaciesMulti' multiple='multiple' " +
                    "k-options='vm.pharmaciesMultiOptions' k-ng-model='vm.masterFilters.selectedPharmacies'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read();' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };


        var sumAggregates = ", Σύνολο Μικτής Αξίας: #=kendo.format('{0:c}', aggregates.totalPrice.sum)#, " +
            "Σύνολο Έκπτωσης: #=kendo.format('{0:c}', aggregates.discountFinalPrice.sum)#, " +
            "Σύνολο Καθαρής Αξίας: #=kendo.format('{0:c}', aggregates.netPrice.sum)#, " +
            "Σύνολο Έκπτωσης Δώρων: #=kendo.format('{0:c}', aggregates.value1.sum)#";

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get(vm.url, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        angular.forEach(data, function(item) {
                            if(!item.purchase.purchaseStatus) item.purchase.purchaseStatus = { name: "" };
                            if(!item.purchase.sector) item.purchase.sector = { name: "" };
                            if(item.purchase.employee && item.purchase.employee.account){
                                item.purchase.employee.account.fullName = item.purchase.employee.account.lastName + " " + item.purchase.employee.account.firstName;
                            }else {
                                item.purchase.employee = { account: {} }
                            }
                        });
                        return data;
                    },
                    parse: function (data) {
                        angular.forEach(data, function (item) {
                            item.issueDate = item.purchase.issueDate ? kendo.toString(kendo.parseDate(item.purchase.issueDate), 'dd/MM/yyyy') : null;
                            if (item.value1 === undefined || item.value1 === null){ item.value1 = 0; }
                            item.totalPrice = (item.purchase.totalPrice === undefined || item.purchase.totalPrice === null) ? 0 : item.purchase.totalPrice;
                            item.discountFinalPrice = (item.purchase.discountFinalPrice === undefined || item.purchase.discountFinalPrice === null) ? 0 : item.purchase.discountFinalPrice;
                            item.netPrice = (item.purchase.netPrice === undefined || item.purchase.netPrice === null) ? 0 : item.purchase.netPrice;
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: "id",
                            issueDate: { type: 'date' }
                        }
                    }
                },
                aggregate: [
                    {field: "totalPrice", aggregate: "sum"},
                    {field: "discountFinalPrice", aggregate: "sum"},
                    {field: "netPrice", aggregate: "sum"},
                    {field: "value1", aggregate: "sum"}
                ],
                serverFiltering: false,
                sort: { field: "issueDate", dir: "desc" },
                change: function() {
                    vm.gridGrouped = this.group().length > 0;
                }
            }),
            height: CustomUtils.getHeightPixelsFromPercentage(55),
            sortable: true,
            groupable: false,
            filterable: false,
            resizable: true,
            columns: [
                {
                    field: "issueDate",
                    title: "Ημερομηνία",
                    template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eq", // Put 'eqdateonly' if you enable server filtering
                            showOperators: false
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "Ημερομηνία: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')# (Σύνολο: #=kendo.format('{0:n0}', count)#" + sumAggregates + ")"
                },
                {
                    field: "purchase.purchaseStatus.name",
                    title: "Κατάσταση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#" + sumAggregates + ")"
                },
                {
                    field: "purchase.employee.account.fullName",
                    title: "Ιατρικός Επισκέπτης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#" + sumAggregates + ")"
                },
                {
                    field: "purchase.sector.name",
                    title: "Φαρμακείο",
                    filterable: {
                        cell: {
                            operator: "contains", // Put 'like' if you enable serverFiltering
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#" + sumAggregates + ")"
                },
                {
                    field: "purchase.sector.vat",
                    title: "Α.Φ.Μ Φαρμακείου",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#" + sumAggregates + ")",
                    footerTemplate: "Σύνολο: "
                },
                {
                    field: "totalPrice",
                    title: "Αξία Προ Έκπτωσης",
                    attributes:{style:"text-align:right;"},
                    template: "#= (totalPrice == null) ? '' : kendo.format('{0:c}', totalPrice)#",
                    filterable: false,
                    groupable: false,
                    footerTemplate: "#=kendo.format('{0:c}', sum)#",
                    aggregates: ["sum"]
                },
                {
                    field: "netPrice",
                    title: "Καθαρή Αξία",
                    attributes:{style:"text-align:right;"},
                    template: "#= (netPrice == null) ? '' : kendo.format('{0:c}', netPrice)#",
                    filterable: false,
                    groupable: false,
                    footerTemplate: "#=kendo.format('{0:c}', sum)#",
                    aggregates: ["sum"]
                },
                {
                    field: "discountFinalPrice",
                    title: "Σύνολική Αξιακή Έκπτωση",
                    attributes:{style:"text-align:right;"},
                    template: "#= (discountFinalPrice == null) ? '' : kendo.format('{0:c}', discountFinalPrice)#",
                    filterable: false,
                    groupable: false,
                    footerTemplate: "#=kendo.format('{0:c}', sum)#",
                    aggregates: ["sum"]
                },
                {
                    field: "value1",
                    title: "Σύνολο Έκπτωσης Δώρων",
                    attributes:{style:"text-align:right;"},
                    template: "#= (value1 == null) ? '' : kendo.format('{0:c}', value1)#",
                    filterable: false,
                    groupable: false,
                    footerTemplate: "#=kendo.format('{0:c}', sum)#",
                    aggregates: ["sum"]
                }
            ],
            toolbar: [
                { template: "<md-button ng-if='vm.gridGrouped' class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Σύμπτυξη όλων</md-button>" },
                { template: "<md-button ng-if='vm.gridGrouped' class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Επέκταση Όλων</md-button>" },
                {
                    name: "onlyTotals", template: "<div style='float: right; margin-right: 10px;'><md-switch class='md-primary' style='top: 0' ng-model='vm.exportOnlyTotals'><label>Εξαγωγή μόνο σύνολα</label></md-switch></div>"
                },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            },
            excel: {
                allPages: true,
                fileName: "Παραγγελίες.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); },
            excelExport: function (e) {
                if (vm.exportOnlyTotals){
                    // Check if user has applied at least 1 grouping into the grid, by checking the length of columns
                    // Same length means that the grid hasn't any grouping
                    if (e.workbook.sheets[0].columns.length !== vm.mainGridOptions.columns.length){
                        e.workbook.sheets[0].columns[0].autoWidth = true;
                        var result = CustomDataUtils.arrayRemove(e.workbook.sheets[0].rows, 'data'); // remove data
                        result = CustomDataUtils.arrayRemove(result, 'footer'); // also remove footer

                        //Define column headers
                        var index = result[0].cells.length;
                        while (index--) if (index < 6 && index !== 0) result[0].cells.splice(index, 1);
                        result[0].cells.splice(1, 0, {background: "#7a7a7a", color: "#fff", value: "Σύνολο Παραγγελιών", colSpan: 1, rowSpan: 1});

                        for (var i=0; i<result.length; i++){
                            if (result[i].type === 'group-header'){
                                var val = result[i].cells[result[i].cells.length - 1].value;
                                var _val = angular.copy(val);

                                //Get group column name
                                result[i].cells[0].value = CustomDataUtils.getGroupColumn(result[i].cells[0].value);
                                result[i].cells[0].colSpan = 0;

                                var values = CustomDataUtils.getValueFromHeaderLabel(val.substring(val.indexOf("Σύνολο: "))); // get val after a certain string
                                if ( values ) {
                                    for(var j = 0; j < values.length; j++) {
                                        result[i].cells.push({
                                            value: CustomDataUtils.convertToNumberFormat(values[j]),
                                            background: "#dfdfdf",
                                            color: "#333",
                                            colSpan: 1
                                        });
                                        if(result[i].cells.length > 2)
                                            result[i].cells[result[i].cells.length-1].format = "#,##0.00 €";
                                    }
                                }

                                // Keep only month in header labels
                                // result[i].cells[result[i].cells.length - 2].value = CustomDataUtils.removeTotalsFromHeaderLabel(String(_val));
                            }
                        }
                        e.workbook.sheets[0].rows = angular.copy(result);
                    } else {
                        e.preventDefault();
                        Alerts.showAlert("Sigma SalesForce", "Θα πρέπει να εφαρμόσετε τουλάχιστον 1 group by στη λίστα για να εξάγετε μόνο σύνολα. Ειδάλλως, κλείστε τον διακόπτη Εξαγωγή μόνο σύνολα και ξαναπροσπαθήστε.", "ΟΚ");
                    }
                } else {
                    var sheet = e.workbook.sheets[0];
                    var groupHeaders = vm.mainGrid.getOptions().dataSource.group.length;

                    //fix purchaseStatus column's width
                    sheet.columns[groupHeaders + 1].autoWidth = false;
                    sheet.columns[groupHeaders + 1].width = 160;

                    //fix date column's width
                    if (!groupHeaders.length) {
                        sheet.columns[0].autoWidth = false;
                        sheet.columns[0].width = 90;
                    }

                    //convert to number and set format
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {
                        var row = sheet.rows[rowIndex];
                        for (var cellIndex = 5; cellIndex < row.cells.length; cellIndex ++) {
                            var cell = row.cells[groupHeaders + cellIndex];
                            if (cell) {
                                if (typeof cell.value === 'string' || cell.value instanceof String) cell.value = CustomDataUtils.convertToNumberFormat(cell.value);
                                cell.format = "#,##0.00 €";
                            }
                        }
                    }

                }
            }
        };

        function hasAppliedGrouping(gridColumnsLength, workBookSheetColumnLength) {
            var has = false;

            has = gridColumnsLength !== workBookSheetColumnLength;

            return has;
        }
    }
})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregated', {
                abstract: true,
                parent: 'app',
                url: '/purchases/aggregated',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/purchasesAggregated/purchasesAggregated.html',
                        controller: 'PurchasesAggregatedController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedController', PurchasesAggregatedController);

    PurchasesAggregatedController.$inject = ['$state'];

    function PurchasesAggregatedController ($state) {
        var vm = this;
        vm.$state = $state;
        vm.pageHeading = "Συνολα & Συγκριτικα Παραγγελιων";
    }
})();
;
/**
 * Created by Teo on 17/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerSector', {
                parent: 'purchasesAggregated',
                url: '/perSector',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Sector'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perSector/purchasesAggregatedPerSector.html',
                controller: 'PurchasesAggregatedPerSectorController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 17/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedPerSectorController', PurchasesAggregatedPerSectorController);

    PurchasesAggregatedPerSectorController.$inject = ['$http', 'KendoGrid', 'KendoService', 'CustomUtils', 'Alerts', '$timeout', 'pharmacyVisitors', '$filter', 'CustomDataUtils', 'accountingDeps'];

    function PurchasesAggregatedPerSectorController ($http, KendoGrid, KendoService, CustomUtils, Alerts, $timeout, pharmacyVisitors, $filter, CustomDataUtils, accountingDeps) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(50);
        vm.showProgress = false;

        vm.masterFilters = {};
        vm.selectedEmployeeId = null;
        vm.selectedSector = null;

        Array.prototype.push.apply(pharmacyVisitors, accountingDeps);
        vm.employeeOptions = {
            dataSource: {
                data: pharmacyVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "'Ολοι οι Ιατρικοί Επισκέπτες Φαρμακείων"
        };

        vm.sectorOptions = KendoService.initDefaultOptions(KendoService.initDataSource('/api/me/pharmacies', 1, 20), "like", "name", "id");
        vm.sectorOptions.placeholder = "Όλοι οι Επαγγελματίες Υγείας";
        vm.sectorOptions.valuePrimitive = false;
        vm.sectorOptions.autoBind = false;

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.showProgress = true;
                        $http.get(constructUrl())
                            .success(function (response) {
                                o.success(response);
                                vm.showProgress = false;
                            })
                            .error(function (error) {
                                o.error(error);
                                vm.showProgress = false;
                                Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                console.log(error);
                            });
                    }
                },
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            numberOfPurchases: { type: "number" },
                            totalNetPrice: { type: "number" },
                            totalDiscountPrice: { type: "number" },
                            execItemQuantities: { type: "number" },
                            trueExecItemQuantities: { type: "number" },
                            totalPresentPrice: { type: "number" },
                            execPresentItemQuantities: { type: "number" },
                            trueExecPresentItemQuantities: { type: "number" },
                            totalSyfaNetPrice: { type: "number" },
                            execQuantitiesSyfa: { type: "number" },
                            trueExecQuantitiesSyfa: { type: "number" },
                            totalMhsyfaNetPrice: { type: "number" },
                            execQuantitiesMhSyfa: { type: "number" },
                            trueExecQuantitiesMhSyfa: { type: "number" },
                            totalIatrNetPrice: { type: "number" },
                            execQuantitiesIatr: { type: "number" },
                            trueExecQuantitiesIatr: { type: "number" },
                            totalCosmeticNetPrice: { type: "number" },
                            execQuantitiesCosmetics: { type: "number" },
                            trueExecQuantitiesCosmetics: { type: "number" },
                            totalFSupplementsNetPrice: { type: "number" },
                            execQuantitiesFSupplements: { type: "number" },
                            trueExecQuantitiesFSupplements: { type: "number" }
                        }
                    },
                    data: function (data) {
                        if (data != null && data !== undefined && data.length > 0){
                            angular.forEach(data, function (item) {
                                // item.employee.fullName = item.employee.account.lastName + " " + item.employee.account.firstName;
                                if (!item.sector) item.sector = {};
                                if (item.numberOfPurchases === null) item.numberOfPurchases = 0;
                                if (item.totalNetPrice === null) item.totalNetPrice = 0;
                                if (item.totalDiscountPrice === null) item.totalDiscountPrice = 0;
                                if (item.execItemQuantities === null) item.execItemQuantities = 0;
                                if (item.trueExecItemQuantities === null) item.trueExecItemQuantities = 0;
                                if (item.totalPresentPrice === null) item.totalPresentPrice = 0;
                                if (item.execPresentItemQuantities === null) item.execPresentItemQuantities = 0;
                                if (item.trueExecPresentItemQuantities === null) item.trueExecPresentItemQuantities = 0;
                                if (item.totalSyfaNetPrice === null) item.totalSyfaNetPrice = 0;
                                if (item.execQuantitiesSyfa === null) item.execQuantitiesSyfa = 0;
                                if (item.trueExecQuantitiesSyfa === null) item.trueExecQuantitiesSyfa = 0;
                                if (item.totalMhsyfaNetPrice === null) item.totalMhsyfaNetPrice = 0;
                                if (item.execQuantitiesMhSyfa === null) item.execQuantitiesMhSyfa = 0;
                                if (item.trueExecQuantitiesMhSyfa === null) item.trueExecQuantitiesMhSyfa = 0;
                                if (item.totalIatrNetPrice === null) item.totalIatrNetPrice = 0;
                                if (item.execQuantitiesIatr === null) item.execQuantitiesIatr = 0;
                                if (item.trueExecQuantitiesIatr === null) item.trueExecQuantitiesIatr = 0;
                                if (item.totalCosmeticNetPrice === null) item.totalCosmeticNetPrice = 0;
                                if (item.execQuantitiesCosmetics === null) item.execQuantitiesCosmetics = 0;
                                if (item.trueExecQuantitiesCosmetics === null) item.trueExecQuantitiesCosmetics = 0;
                                if (item.totalFSupplementsNetPrice === null) item.totalFSupplementsNetPrice = 0;
                                if (item.execQuantitiesFSupplements === null) item.execQuantitiesFSupplements = 0;
                                if (item.trueExecQuantitiesFSupplements === null) item.trueExecQuantitiesFSupplements = 0;
                            });
                        }
                        return data;
                    }
                },
                aggregate: [
                    {field: "numberOfCustomers", aggregate: "sum"},
                    {field: "numberOfPurchases", aggregate: "sum"},
                    {field: "totalNetPrice", aggregate: "sum"},
                    {field: "totalDiscountPrice", aggregate: "sum"},
                    {field: "execItemQuantities", aggregate: "sum"},
                    {field: "trueExecItemQuantities", aggregate: "sum"},
                    {field: "totalPresentPrice", aggregate: "sum"},
                    {field: "execPresentItemQuantities", aggregate: "sum"},
                    {field: "trueExecPresentItemQuantities", aggregate: "sum"},
                    {field: "totalSyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesSyfa", aggregate: "sum"},
                    {field: "totalMhsyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "totalIatrNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesIatr", aggregate: "sum"},
                    {field: "trueExecQuantitiesIatr", aggregate: "sum"},
                    {field: "totalCosmeticNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesCosmetics", aggregate: "sum"},
                    {field: "trueExecQuantitiesCosmetics", aggregate: "sum"},
                    {field: "totalFSupplementsNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesFSupplements", aggregate: "sum"},
                    {field: "trueExecQuantitiesFSupplements", aggregate: "sum"}
                ]
            }),
            sortable: true,
            groupable: false,
            filterable: false,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "sector.name",
                    title: "Επαγγελματίας Υγείας",
                    width: "270px"
                },
                /*{
                    field: "employee.fullName",
                    title: "Ιατρικός Επισκέπτης",
                    width: "150px"
                },*/
                {
                    field: "numberOfPurchases",
                    title: "Αριθμός Παραγγελιών",
                    width: "170px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalNetPrice",
                    title: "Τζίρος (€)",
                    width: "160px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalNetPrice) #",
                    footerTemplate: "#= kendo.toString(sum, 'C') #"
                },
                {
                    field: "totalDiscountPrice",
                    title: "Συνολική Αξιακή Έκπτωση (€)",
                    width: "210px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalDiscountPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execItemQuantities",
                    title: "Ποσότητα Παραγγελίας (Τεμ)",
                    width: "240px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecItemQuantities",
                    title: "Εκτελ. Ποσότητα Παραγγελίας (Τεμ)",
                    width: "250px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalPresentPrice",
                    title: "Συνολική Έκπτωση σε Δώρα (€)",
                    width: "230px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalPresentPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execPresentItemQuantities",
                    title: "Ποσότητα Δώρων Παραγγελίας (Τεμ)",
                    width: "255px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecPresentItemQuantities",
                    title: "Εκτελ. Ποσότητα Δώρων Παραγγελίας (Τεμ)",
                    width: "295px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalSyfaNetPrice",
                    title: "Τζίρος ΣΥΦΑ (€)",
                    width: "120px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalSyfaNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesSyfa",
                    title: "Τεμάχια ΣΥΦΑ",
                    width: "120px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesSyfa",
                    title: "Εκτελ. Τεμάχια ΣΥΦΑ",
                    width: "160px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalMhsyfaNetPrice",
                    title: "Τζίρος ΜΗΣΥΦΑ (€)",
                    width: "140px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalMhsyfaNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesMhSyfa",
                    title: "Τεμάχια ΜΗΣΥΦΑ",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesMhSyfa",
                    title: "Εκτελ. Τεμάχια ΜΗΣΥΦΑ",
                    width: "170px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalIatrNetPrice",
                    title: "Τζίρος ΙΑΤΡ (€)",
                    width: "120px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalIatrNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesIatr",
                    title: "Τεμάχια ΙΑΤΡ",
                    width: "120px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesIatr",
                    title: "Εκτελ. Τεμάχια ΙΑΤΡ",
                    width: "160px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalCosmeticNetPrice",
                    title: "Τζίρος COSMETICS (€)",
                    width: "160px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalCosmeticNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesCosmetics",
                    title: "Τεμάχια COSMETICS",
                    width: "160px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesCosmetics",
                    title: "Εκτελ. Τεμάχια COSMETICS",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalFSupplementsNetPrice",
                    title: "Τζίρος F Supplements (€)",
                    width: "180px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalFSupplementsNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesFSupplements",
                    title: "Τεμάχια F Supplements",
                    width: "170px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesFSupplements",
                    title: "Εκτελ. Τεμάχια F Supplements",
                    width: "220px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                }
            ],
            excel: {
                allPages: true,
                fileName: "Σύνολα Παραγγελιών ανά Επαγγελματία Υγείας.xlsx"
            },
            excelExport: function (e) {
                var footerCells = $filter('filter')(e.workbook.sheets[0].rows, {type: "footer"}, true)[0].cells;
                for(var i = 1; i < footerCells.length; i++) {
                    if (footerCells[i].value.includes("€")) {
                        footerCells[i].value.replace(' €','');
                        footerCells[i].format = "#,##0.00 €";
                    }
                    footerCells[i].hAlign = "right";
                    CustomDataUtils.convertToNumberFormat(footerCells[i].value);
                }
            },
            dataBound: function () {
                $timeout(function() {
                    kendo.resize($("#mainGrid"));
                });
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            var cancel = false;
            var message = "";
            if (vm.masterFilters.from === null || vm.masterFilters.to === null ||
                vm.masterFilters.from === undefined || vm.masterFilters.to === undefined){
                cancel = true;
                message = "Επιλέξτε ημερομηνίες";
            }

            if (!cancel && (vm.masterFilters.from > vm.masterFilters.to)){
                cancel = true;
                message = "Η ημερομηνία 'Από' πρέπει να είναι μικρότερη από την ημερομηνία 'Εώς'"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "ΟΚ");
            }else {
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                vm.clearDatePickers();

                $timeout(function (){
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            } else if (e.id === "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function (){
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            } else if (e.id === "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function (){
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select name='employeeSelect' id='employeeSelect' kendo-combo-box k-ng-model='vm.selectedEmployeeId' k-options='vm.employeeOptions' style='width: 60%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select name='sectorSelect' id='sectorSelect' kendo-combo-box k-ng-model='vm.selectedSector' k-options='vm.sectorOptions' style='width: 60%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.getData();' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel' aria-label='search' ng-click='vm.exportData();' ng-disabled='vm.disabled'>" +
                    "<span class='k-icon k-i-excel'></span>EXPORT</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        function constructUrl() {
            var url = "/api/purchases/totals-per-sector";
            url += "?dateFrom=" + $filter('date')(vm.masterFilters.from, 'yyyy-MM-dd');
            url += "&dateTo=" + $filter('date')(vm.masterFilters.to, 'yyyy-MM-dd');
            if (vm.selectedEmployeeId !== null){
                url += "&employeeId=" + vm.selectedEmployeeId;
            }
            if (vm.selectedSector !== null && vm.selectedSector.id){
                url += "&sectorId=" + vm.selectedSector.id;
            }

            return url;
        }

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click ok when screen opens
        $timeout(function () {
            $("#today").click();
        });
    }
})();
;
/**
 * Created by Teo on 18/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerProduct', {
                parent: 'purchasesAggregated',
                url: '/perProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Product'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perProduct/purchasesAggregatedPerProduct.html',
                controller: 'PurchasesAggregatedPerProductController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    purchaseProducts: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/masterdata/min-products-for-purchases').then(function (response) {return response;});
                    }],
                    productCategories: ['ProductCategory', function (ProductCategory) {
                        return ProductCategory.query({page: 0, size: 200}).$promise;
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 18/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedPerProductController', PurchasesAggregatedPerProductController);

    PurchasesAggregatedPerProductController.$inject = ['$http', 'KendoGrid', 'KendoService', 'CustomUtils', 'Alerts', '$timeout', 'pharmacyVisitors', 'productCategories', '$filter', 'CustomDataUtils', 'accountingDeps', 'purchaseProducts'];

    function PurchasesAggregatedPerProductController ($http, KendoGrid, KendoService, CustomUtils, Alerts, $timeout, pharmacyVisitors, productCategories, $filter, CustomDataUtils, accountingDeps, purchaseProducts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);
        vm.showProgress = false;

        vm.masterFilters = {};
        vm.selectedEmployeeId = null;
        vm.selectedProductCategoryId = null;
        vm.selectedProduct = null;

        Array.prototype.push.apply(pharmacyVisitors, accountingDeps);
        vm.employeeOptions = {
            dataSource: {
                data: pharmacyVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "ΟΛΟΙ"
        };

        vm.productCategoryOptions = {
            dataSource: {
                data: productCategories
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            clearButton: false,
            placeholder: "ΟΛΑ",
            change: function (e) {
                var productComboBox = $("#productSelect").data("kendoComboBox");
                if (this.dataItem() === undefined || this.dataItem() === null){
                    productComboBox.enable(true);
                }else {
                    productComboBox.value(null);
                    productComboBox.enable(false);
                }
            }
        };

        vm.productsOptions = {
            dataSource: purchaseProducts,
            filter: "contains",
            dataTextField: "name",
            dataValueField: "id",
            clearButton: true,
            placeholder: "ΟΛΑ",
            change: function (e) {
                var productCategoryComboBox = $("#productCategorySelect").data("kendoComboBox");
                if (this.dataItem() === undefined || this.dataItem() === null){
                    productCategoryComboBox.enable(true);
                }else {
                    productCategoryComboBox.value(null);
                    productCategoryComboBox.enable(false);
                }
            }
        };

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.showProgress = true;
                        $http.get(constructUrl())
                            .success(function (response) {
                                o.success(response);
                                vm.showProgress = false;
                            })
                            .error(function (error) {
                                o.error(error);
                                vm.showProgress = false;
                                Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                console.log(error);
                            });
                    }
                },
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            totalPrice: { type: "number" },
                            totalQuantities: { type: "number" },
                            totalExecQuantities: { type: "number" },
                            totalSyfaNetPrice: { type: "number" },
                            execQuantitiesSyfa: { type: "number" },
                            trueExecQuantitiesSyfa: { type: "number" },
                            totalMhsyfaNetPrice: { type: "number" },
                            execQuantitiesMhSyfa: { type: "number" },
                            trueExecQuantitiesMhSyfa: { type: "number" },
                            totalIatrNetPrice: { type: "number" },
                            execQuantitiesIatr: { type: "number" },
                            trueExecQuantitiesIatr: { type: "number" },
                            totalCosmeticNetPrice: { type: "number" },
                            execQuantitiesCosmetics: { type: "number" },
                            trueExecQuantitiesCosmetics: { type: "number" },
                            totalFSupplementsNetPrice: { type: "number" },
                            execQuantitiesFSupplements: { type: "number" },
                            trueExecQuantitiesFSupplements: { type: "number" }
                        }
                    },
                    data: function (data) {
                        if (data != null && data !== undefined && data.length > 0){
                            angular.forEach(data, function (item) {
                                if (!item.product) item.product = {};
                                if (item.totalSyfaNetPrice === null) item.totalSyfaNetPrice = 0;
                                if (item.execQuantitiesSyfa === null) item.execQuantitiesSyfa = 0;
                                if (item.trueExecQuantitiesSyfa === null) item.trueExecQuantitiesSyfa = 0;
                                if (item.totalMhsyfaNetPrice === null) item.totalMhsyfaNetPrice = 0;
                                if (item.execQuantitiesMhSyfa === null) item.execQuantitiesMhSyfa = 0;
                                if (item.trueExecQuantitiesMhSyfa === null) item.trueExecQuantitiesMhSyfa = 0;
                                if (item.totalIatrNetPrice === null) item.totalIatrNetPrice = 0;
                                if (item.execQuantitiesIatr === null) item.execQuantitiesIatr = 0;
                                if (item.trueExecQuantitiesIatr === null) item.trueExecQuantitiesIatr = 0;
                                if (item.totalCosmeticNetPrice === null) item.totalCosmeticNetPrice = 0;
                                if (item.execQuantitiesCosmetics === null) item.execQuantitiesCosmetics = 0;
                                if (item.trueExecQuantitiesCosmetics === null) item.trueExecQuantitiesCosmetics = 0;
                                if (item.totalFSupplementsNetPrice === null) item.totalFSupplementsNetPrice = 0;
                                if (item.execQuantitiesFSupplements === null) item.execQuantitiesFSupplements = 0;
                                if (item.trueExecQuantitiesFSupplements === null) item.trueExecQuantitiesFSupplements = 0;

                                // Extra columns
                                item.totalPrice = item.totalSyfaNetPrice + item.totalMhsyfaNetPrice + item.totalIatrNetPrice + item.totalCosmeticNetPrice + item.totalFSupplementsNetPrice;
                                item.totalQuantities = item.execQuantitiesSyfa + item.execQuantitiesMhSyfa + item.execQuantitiesIatr + item.execQuantitiesCosmetics + item.execQuantitiesFSupplements;
                                item.totalExecQuantities = item.trueExecQuantitiesSyfa + item.trueExecQuantitiesMhSyfa + item.trueExecQuantitiesIatr + item.trueExecQuantitiesCosmetics + item.trueExecQuantitiesFSupplements;
                            });
                        }

                        return data;
                    }
                },
                aggregate: [
                    {field: "totalPrice", aggregate: "sum"},
                    {field: "totalQuantities", aggregate: "sum"},
                    {field: "totalExecQuantities", aggregate: "sum"},
                    {field: "totalSyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesSyfa", aggregate: "sum"},
                    {field: "totalMhsyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "totalIatrNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesIatr", aggregate: "sum"},
                    {field: "trueExecQuantitiesIatr", aggregate: "sum"},
                    {field: "totalCosmeticNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesCosmetics", aggregate: "sum"},
                    {field: "trueExecQuantitiesCosmetics", aggregate: "sum"},
                    {field: "totalFSupplementsNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesFSupplements", aggregate: "sum"},
                    {field: "trueExecQuantitiesFSupplements", aggregate: "sum"}
                ]
            }),
            sortable: true,
            groupable: false,
            filterable: false,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "product.name",
                    title: "Είδος",
                    width: "340px"
                },
                {
                    field: "totalPrice",
                    title: "Σύνολο Τζίρου",
                    width: "130px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "totalQuantities",
                    title: "Ποσότητα Παραγγελίας (Τεμ)",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalExecQuantities",
                    title: "Εκτελ. Ποσότητα Παραγγελίας (Τεμ)",
                    width: "245px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalSyfaNetPrice",
                    title: "Τζίρος ΣΥΦΑ",
                    width: "110px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalSyfaNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesSyfa",
                    title: "Τεμ. ΣΥΦΑ",
                    width: "90px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesSyfa",
                    title: "Εκτελ. Τεμ. ΣΥΦΑ",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalMhsyfaNetPrice",
                    title: "Τζίρος ΜΗΣΥΦΑ",
                    width: "120px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalMhsyfaNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesMhSyfa",
                    title: "Τεμ. ΜΗΣΥΦΑ",
                    width: "110px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesMhSyfa",
                    title: "Εκτελ. Τεμ. ΜΗΣΥΦΑ (Τεμ)",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalIatrNetPrice",
                    title: "Τζίρος ΙΑΤΡ",
                    width: "110px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalIatrNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesIatr",
                    title: "Τεμ. ΙΑΤΡ",
                    width: "90px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesIatr",
                    title: "Εκτελ. Τεμ. ΙΑΤΡ",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalCosmeticNetPrice",
                    title: "Τζίρος COSMETICS",
                    width: "150px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalCosmeticNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesCosmetics",
                    title: "Τεμ. COSMETICS",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesCosmetics",
                    title: "Εκτελ. Τεμ. COSMETICS",
                    width: "180px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalFSupplementsNetPrice",
                    title: "Τζίρος F Supplements",
                    width: "160px",
                    aggregates: ["sum"],
                    template: "#= kendo.format('{0:c}', totalFSupplementsNetPrice) #",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesFSupplements",
                    title: "Τεμ. F Supplements",
                    width: "150px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesFSupplements",
                    title: "Εκτελ. Τεμ. F Supplements",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                }
            ],
            excel: {
                allPages: true,
                fileName: "Σύνολα Ειδών.xlsx"
            },
            excelExport: function (e) {
                var footerCells = $filter('filter')(e.workbook.sheets[0].rows, {type: "footer"}, true)[0].cells;
                for(var i = 1; i < footerCells.length; i++) {
                    if (footerCells[i].value.includes("€")) {
                        footerCells[i].value.replace(' €','');
                        footerCells[i].format = "#,##0.00 €";
                    }
                    footerCells[i].hAlign = "right";
                    CustomDataUtils.convertToNumberFormat(footerCells[i].value);
                }
            },
            dataBound: function () {
                $timeout(function() {
                    kendo.resize($("#mainGrid"));
                });
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            var cancel = false;
            var message = "";
            if (vm.masterFilters.from === null || vm.masterFilters.to === null ||
                vm.masterFilters.from === undefined || vm.masterFilters.to === undefined){
                cancel = true;
                message = "Επιλέξτε ημερομηνίες";
            }

            if (!cancel && (vm.masterFilters.from > vm.masterFilters.to)){
                cancel = true;
                message = "Η ημερομηνία 'Από' πρέπει να είναι μικρότερη από την ημερομηνία 'Εώς'"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "ΟΚ");
            }else {
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.clearFilters = function () {
            // $("#today").click();
            var employeeComboBox = $("#employeeSelect").data("kendoComboBox");
            employeeComboBox.value(null);
            vm.selectedEmployeeId = null;
            var productCategoryComboBox = $("#productCategorySelect").data("kendoComboBox");
            productCategoryComboBox.value(null);
            productCategoryComboBox.enable(true);
            vm.selectedProductCategoryId = null;
            var productComboBox = $("#productSelect").data("kendoComboBox");
            productComboBox.value(null);
            productComboBox.enable(true);
            vm.selectedProduct = null;
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                vm.clearDatePickers();

                $timeout(function (){
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            } else if (e.id === "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function (){
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            } else if (e.id === "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function (){
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Από: </label><input style='width: 100px;' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input style='width: 100px;' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select style='width: 210px; margin-right: 2px' name='employeeSelect' id='employeeSelect' kendo-combo-box k-ng-model='vm.selectedEmployeeId' k-options='vm.employeeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Κατ. Ειδών: </label><select style='width: 100px; margin-right: 2px' name='productCategorySelect' id='productCategorySelect' kendo-combo-box k-ng-model='vm.selectedProductCategoryId' k-options='vm.productCategoryOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Είδος: </label><select style='width: 440px; margin-right: 2px' name='productSelect' id='productSelect' kendo-combo-box k-ng-model='vm.selectedProduct' k-options='vm.productsOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.getData();' style='margin-left: 2px; margin-right: 2px;'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "left" }
                },
                /*{
                    template: "<md-button class='md-icon-button' aria-label='search' ng-click='vm.clearFilters();' style='padding: 2px 0 0 0; margin: 2px 0 0 0;'>" +
                    "<md-icon class='clear-red'></md-icon><md-tooltip md-direction='top'>Εκκαθάριση φίλτρων</md-tooltip></md-button>", overflow: "never", attributes: { class: "left" }
                },*/
                {
                    template: "<md-button class='md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel' aria-label='search' ng-click='vm.exportData();' style='margin-left: 2px; margin-right: 2px;'>" +
                    "<span class='k-icon k-i-excel'></span>EXPORT</md-button>", overflow: "never", attributes: { class: "left" }
                }
            ]
        };

        function constructUrl() {
            var url = "/api/purchases/totals-per-product";
            url += "?dateFrom=" + $filter('date')(vm.masterFilters.from, 'yyyy-MM-dd');
            url += "&dateTo=" + $filter('date')(vm.masterFilters.to, 'yyyy-MM-dd');
            if (vm.selectedEmployeeId !== null){
                url += "&employeeId=" + vm.selectedEmployeeId;
            }
            if (vm.selectedProduct !== null){
                url += "&productId=" + vm.selectedProduct.id;
            }
            if (vm.selectedProductCategoryId !== null){
                url += "&productCategoryId=" + vm.selectedProductCategoryId;
            }

            return url;
        }

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click ok when screen opens
        $timeout(function () {
            $("#today").click();
        });
    }
})();
;
/**
 * Created by Teo on 02/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesPerEmployeeSectorProduct', {
                parent: 'purchasesAggregated',
                url: '/perEmployeeSectorProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee Per Sector Per Product'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployeeSectorProduct/purchasesPerEmployeeSectorProduct.html',
                controller: 'PurchasesAggregatedPerEmployeeSectorProductController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    purchaseProducts: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/masterdata/min-products-for-purchases').then(function (response) {return response;});
                    }],
                    productCategories: ['ProductCategory', function (ProductCategory) {
                        return ProductCategory.query({page: 0, size: 200}).$promise;
                    }],
                    purchaseStatuses: ['$http','$stateParams', function ($http) {
                        var filters = {
                            data: {
                                "page": 1,
                                "pageSize": 30,
                                filter: {
                                    logic: "and",
                                    filters: [{
                                        field: "cancellable",
                                        operator: "eqbool",
                                        value: "false"
                                    }]
                                }
                            }
                        };
                        return $http.get('/api/masterdata/purchase-statuses', {params: filters.data}).then(function (response) {return response;});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 02/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedPerEmployeeSectorProductController', PurchasesAggregatedPerEmployeeSectorProductController);

    PurchasesAggregatedPerEmployeeSectorProductController.$inject = ['$scope', '$filter', '$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout', 'KendoToolbar', 'CustomDataUtils', 'pharmacyVisitors', 'accountingDeps', 'KendoService', 'productCategories', 'purchaseProducts', 'purchaseStatuses'];

    function PurchasesAggregatedPerEmployeeSectorProductController ($scope, $filter, $http, KendoGrid, CustomUtils, Alerts, $timeout, KendoToolbar, CustomDataUtils, pharmacyVisitors, accountingDeps, KendoService, productCategories, purchaseProducts, purchaseStatuses) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(48);
        vm.showProgress = false;
        vm.masterFilters = {};
        vm.mainGrid = {};

        vm.selectedEmployeeId = null;
        vm.selectedSector = null;
        vm.selectedProductCategoryId = null;
        vm.selectedProduct = null;
        vm.purchaseStatusIdsString = constructPurchaseStatusIdsString();

        Array.prototype.push.apply(pharmacyVisitors, accountingDeps);
        vm.employeeOptions = {
            dataSource: {
                data: pharmacyVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "'Ολοι οι Ιατρικοί Επισκέπτες Φαρμακείων"
        };

        vm.sectorOptions = KendoService.initDefaultOptions(KendoService.initDataSource('/api/me/pharmacies', 1, 20), "like", "name", "id");
        vm.sectorOptions.placeholder = "Όλοι οι Επαγγελματίες Υγείας";
        vm.sectorOptions.valuePrimitive = false;
        vm.sectorOptions.autoBind = false;

        vm.productCategoryOptions = {
            dataSource: {
                data: productCategories
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            clearButton: false,
            placeholder: "ΟΛΑ",
            change: function (e) {
                var productComboBox = $("#productSelect").data("kendoComboBox");
                if (this.dataItem() === undefined || this.dataItem() === null){
                    productComboBox.enable(true);
                }else {
                    productComboBox.value(null);
                    productComboBox.enable(false);
                }
            }
        };

        vm.productsOptions = {
            dataSource: purchaseProducts,
            filter: "contains",
            dataTextField: "name",
            dataValueField: "id",
            clearButton: true,
            placeholder: "ΟΛΑ",
            change: function (e) {
                var productCategoryComboBox = $("#productCategorySelect").data("kendoComboBox");
                if (this.dataItem() === undefined || this.dataItem() === null){
                    productCategoryComboBox.enable(true);
                }else {
                    productCategoryComboBox.value(null);
                    productCategoryComboBox.enable(false);
                }
            }
        };

        vm.getData = function () {
            var cancel = false;
            var message = "";
            if (vm.masterFilters.from === null || vm.masterFilters.to === null ||
                vm.masterFilters.from === undefined || vm.masterFilters.to === undefined){
                cancel = true;
                message = "Επιλέξτε ημερομηνίες";
            }

            if (!cancel && (vm.masterFilters.from > vm.masterFilters.to)){
                cancel = true;
                message = "Η ημερομηνία 'Από' πρέπει να είναι μικρότερη από την ημερομηνία 'Εώς'"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "ΟΚ");
            }else {
                $("#mainGrid").data('kendoGrid').dataSource.data([]);
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };

        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input style='width: 100px;' class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input style='width: 100px;' class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select name='employeeSelect' id='employeeSelect' style='width: 210px; margin-right: 2px' kendo-combo-box k-ng-model='vm.selectedEmployeeId' k-options='vm.employeeOptions' style='width: 60%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select name='sectorSelect' id='sectorSelect' style='width: 180px; margin-right: 2px' kendo-combo-box k-ng-model='vm.selectedSector' k-options='vm.sectorOptions' style='width: 60%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Κατ. Ειδών: </label><select style='width: 100px; margin-right: 2px' name='productCategorySelect' id='productCategorySelect' kendo-combo-box k-ng-model='vm.selectedProductCategoryId' k-options='vm.productCategoryOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Είδος: </label><select style='width: 420px; margin-right: 2px' name='productSelect' id='productSelect' kendo-combo-box k-ng-model='vm.selectedProduct' k-options='vm.productsOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Σύμπτυξη όλων</md-button>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Επέκταση Όλων</md-button>", overflow: "never", attributes: { class: "left" }
                },
                /*{ THIS WILL BE IMPLEMENTED WHEN WE UPDATE KENDO
                    template: "<md-button class='md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel' aria-label='search' ng-click='vm.exportData();' ng-disabled='vm.disabled'>" +
                    "<span class='k-icon k-i-excel'></span>EXPORT</md-button>", overflow: "never", attributes: { class: "right" }
                },*/
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.getData();' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        // KEEP THIS in comments for groupHeaderColumnTemplate functionality when we update Kendo UI
        /*var dummyData2 = [
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TOLI MARIA"
                        }
                    },
                    sector: {
                        name: "PHARMACY 1"
                    },
                    name: "DEPON 1",
                    totalNetPrice: 600,
                    execItemQuantities: 75,
                    totalSyfaNetPrice: 600,
                    execQuantitiesSyfa: 75,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TOLI MARIA"
                        }
                    },
                    sector: {
                        name: "PHARMACY 1"
                    },
                    name: "DEPON 2",
                    totalNetPrice: 500,
                    execItemQuantities: 65,
                    totalSyfaNetPrice: 500,
                    execQuantitiesSyfa: 65,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TOLI MARIA"
                        }
                    },
                    sector: {
                        name: "PHARMACY 1"
                    },
                    name: "DEPON 3",
                    totalNetPrice: 400,
                    execItemQuantities: 55,
                    totalSyfaNetPrice: 400,
                    execQuantitiesSyfa: 65,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TOLI MARIA"
                        }
                    },
                    sector: {
                        name: "PHARMACY 2"
                    },
                    name: "DEPON 1",
                    totalNetPrice: 300,
                    execItemQuantities: 45,
                    totalSyfaNetPrice: 300,
                    execQuantitiesSyfa: 45,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TOLI MARIA"
                        }
                    },
                    sector: {
                        name: "PHARMACY 2"
                    },
                    name: "DEPON 2",
                    totalNetPrice: 100,
                    execItemQuantities: 25,
                    totalSyfaNetPrice: 100,
                    execQuantitiesSyfa: 25,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TSIALIKIS VAGGELIS"
                        }
                    },
                    sector: {
                        name: "PHARMACY 4"
                    },
                    name: "DEPON 1",
                    totalNetPrice: 150,
                    execItemQuantities: 30,
                    totalSyfaNetPrice: 150,
                    execQuantitiesSyfa: 30,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            },
            {
                product: {
                    employee: {
                        account: {
                            fullName: "TSIALIKIS VAGGELIS"
                        }
                    },
                    sector: {
                        name: "PHARMACY 4"
                    },
                    name: "DEPON 2",
                    totalNetPrice: 200,
                    execItemQuantities: 35,
                    totalSyfaNetPrice: 200,
                    execQuantitiesSyfa: 35,
                    totalMhSyfaNetPrice: 0,
                    execQuantityesMhSyfa: 0,
                    totalIatrNetPrice: 0,
                    execQuantitiesIatr: 0
                }
            }
        ];
        var group2 = [
            {
                field: "product.employee.account.fullName",
                aggregates: [
                    { field: "product.totalNetPrice", aggregate: "sum"},
                    { field: "product.execItemQuantities", aggregate: "sum"},
                    { field: "product.totalSyfaNetPrice", aggregate: "sum"},
                    { field: "product.execQuantitiesSyfa", aggregate: "sum"},
                    { field: "product.totalMhSyfaNetPrice", aggregate: "sum"},
                    { field: "product.execQuantityesMhSyfa", aggregate: "sum"},
                    { field: "product.totalIatrNetPrice", aggregate: "sum"},
                    { field: "product.execQuantitiesIatr", aggregate: "sum"}
                ]
            }
            // {field: "product.sector.name"}
        ];
        var aggregate2 = [
            { field: "product.name", aggregate: "count"},
            { field: "product.totalNetPrice", aggregate: "sum"},
            { field: "product.execItemQuantities", aggregate: "sum"},
            { field: "product.totalSyfaNetPrice", aggregate: "sum"},
            { field: "product.execQuantitiesSyfa", aggregate: "sum"},
            { field: "product.totalMhSyfaNetPrice", aggregate: "sum"},
            { field: "product.execQuantityesMhSyfa", aggregate: "sum"},
            { field: "product.totalIatrNetPrice", aggregate: "sum"},
            { field: "product.execQuantitiesIatr", aggregate: "sum"}
        ];
        var columns2 = [
            {
                field: "product.name",
                title: "Προιόν",
                width: "250px"
            },
            {
                field: "product.employee.account.fullName",
                title: "Ιατρικός Επισκέπτης",
                width: "250px"
            },
            {
                field: "product.sector.name",
                title: "Φαρμακείο",
                width: "250px",
                aggregates: ["count"]
            },
            {
                field: "product.totalNetPrice",
                title: "Τζίρος",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.execItemQuantities",
                title: "Τεμάχια",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.totalSyfaNetPrice",
                title: "Τζίρος. ΣΥΦΑ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.execQuantitiesSyfa",
                title: "ΤΕΜ. ΣΥΦΑ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.totalMhSyfaNetPrice",
                title: "Τζίρος. ΜΗΣΥΦΑ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.execQuantityesMhSyfa",
                title: "ΤΕΜ. ΜΗΣΥΦΑ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.totalIatrNetPrice",
                title: "Τζίρος. ΙΑΤΡ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            },
            {
                field: "product.execQuantitiesIatr",
                title: "ΤΕΜ. ΙΑΤΡ",
                width: "250px",
                aggregates: ["sum"],
                groupHeaderColumnTemplate: "Sum: #=sum#"
            }
        ];
        $(document).ready(function () {
            console.log(kendo.version);
            $("#grid").kendoGrid({
                dataSource: {
                    type: "odata",
                    data: dummyData2,
                    group: group2,
                    aggregate: aggregate2
                    /!*batch: true,
                    transport: {
                        read: function (o) {
                            vm.showProgress = true;
                            $http.get(constructUrl())
                                .success(function (response) {
                                    o.success(response);
                                    vm.showProgress = false;
                                })
                                .error(function (error) {
                                    o.error(error);
                                    vm.showProgress = false;
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                    console.log(error);
                                });
                        }
                    },
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                numberOfCustomers: { type: "number" },
                                numberOfPurchases: { type: "number" },
                                totalNetPrice: { type: "number" },
                                totalDiscountPrice: { type: "number" },
                                execItemQuantities: { type: "number" },
                                totalPresentPrice: { type: "number" },
                                execPresentItemQuantities: { type: "number" },
                                totalSyfaNetPrice: { type: "number" },
                                execQuantitiesSyfa: { type: "number" },
                                totalMhsyfaNetPrice: { type: "number" },
                                execQuantitiesMhSyfa: { type: "number" },
                                totalIatrNetPrice: { type: "number" },
                                execQuantitiesIatr: { type: "number" }
                            }
                        },
                        data: function (data) {
                            console.log(data);
                            if (data != null && data !== undefined && data.length > 0){
                                angular.forEach(data, function (item) {
                                    item.employee.fullName = item.employee.account.lastName + " " + item.employee.account.firstName;
                                    if (item.numberOfCustomers === null) item.numberOfCustomers = 0;
                                    if (item.numberOfPurchases === null) item.numberOfPurchases = 0;
                                    if (item.totalNetPrice === null) item.totalNetPrice = 0;
                                    if (item.totalDiscountPrice === null) item.totalDiscountPrice = 0;
                                    if (item.execItemQuantities === null) item.execItemQuantities = 0;
                                    if (item.totalPresentPrice === null) item.totalPresentPrice = 0;
                                    if (item.execPresentItemQuantities === null) item.execPresentItemQuantities = 0;
                                    if (item.totalSyfaNetPrice === null) item.totalSyfaNetPrice = 0;
                                    if (item.execQuantitiesSyfa === null) item.execQuantitiesSyfa = 0;
                                    if (item.totalMhsyfaNetPrice === null) item.totalMhsyfaNetPrice = 0;
                                    if (item.execQuantitiesMhSyfa === null) item.execQuantitiesMhSyfa = 0;
                                    if (item.totalIatrNetPrice === null) item.totalIatrNetPrice = 0;
                                    if (item.execQuantitiesIatr === null) item.execQuantitiesIatr = 0;
                                });
                            }
                            return data;
                        }
                    },
                    aggregate: [
                        {field: "numberOfCustomers", aggregate: "sum"},
                        {field: "numberOfPurchases", aggregate: "sum"},
                        {field: "totalNetPrice", aggregate: "sum"},
                        {field: "totalDiscountPrice", aggregate: "sum"},
                        {field: "execItemQuantities", aggregate: "sum"},
                        {field: "totalPresentPrice", aggregate: "sum"},
                        {field: "execPresentItemQuantities", aggregate: "sum"},
                        {field: "totalSyfaNetPrice", aggregate: "sum"},
                        {field: "execQuantitiesSyfa", aggregate: "sum"},
                        {field: "totalMhsyfaNetPrice", aggregate: "sum"},
                        {field: "execQuantitiesMhSyfa", aggregate: "sum"},
                        {field: "totalIatrNetPrice", aggregate: "sum"},
                        {field: "execQuantitiesIatr", aggregate: "sum"}
                    ]*!/
                },
                sortable: true,
                scrollable: false,
                pageable: true,
                groupable: true,
                columns: columns2
            });
        });*/

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.showProgress = true;
                        $http.get("/api/purchase-items/all", {params: getFilters().data})
                            .success(function (response) {
                                o.success(response);
                                vm.showProgress = false;
                                console.log(response);
                            })
                            .error(function (error) {
                                o.error(error);
                                vm.showProgress = false;
                                Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                console.log(error);
                            });
                    }
                },
                group: [
                    {
                        field: "purchase.employee.fullName",
                        aggregates: [
                            { field: "quantity", aggregate: "sum" },
                            { field: "netPrice", aggregate: "sum" }
                        ]
                    },
                    {
                        field: "purchase.sector.name",
                        aggregates: [
                            { field: "quantity", aggregate: "sum" },
                            { field: "netPrice", aggregate: "sum" }
                        ]
                    },
                    {
                        field: "product.name",
                        aggregates: [
                            { field: "quantity", aggregate: "sum" },
                            { field: "netPrice", aggregate: "sum" }
                        ]
                    }
                ],
                aggregate: [
                    {field: "netPrice", aggregate: "sum"},
                    {field: "quantity", aggregate: "sum"}
                ],
                schema: {
                    data: function (data) {
                        if (data != null && data !== undefined && data.length > 0){
                            angular.forEach(data, function(item) {
                                item.purchase.employee.fullName = item.purchase.employee.account.lastName + " " + item.purchase.employee.account.firstName;
                                if (!item.purchase){
                                    item.purchase = {
                                        employee: { fullName: "" },
                                        sector: { name: "" }
                                    }
                                }else {
                                    if (!item.product){
                                        item.product = {
                                            name: "",
                                            productCategories: []
                                        }
                                    }
                                }
                            });
                        }

                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: "id",
                            issueDate: { type: 'date' }
                        }
                    }
                },
                serverFiltering: false,
                serverPaging: false,
                pageSize: 100
            }),
            sortable: false,
            groupable: false,
            filterable: false,
            resizable: false,
            pageable: true,
            scrollable: true,
            columns: [
                {
                    field: "purchase.employee.fullName",
                    title: "Ιατρικός Επισκέπτης",
                    groupHeaderTemplate: "<i class=\"material-icons\" style='font-size: 14px;'>assignment_ind</i> " +
                    "<span>#= typeof value !== 'undefined' ? value : '' # - </span> " +
                    "<span style='color: red'> Τεμάχια: #= aggregates.quantity.sum#, Τζίρος: #= kendo.format('{0:c}', aggregates.netPrice.sum)# </span>"
                },
                {
                    field: "purchase.sector.name",
                    title: "Επαγγελματίας Υγείας",
                    groupHeaderTemplate: "<i class=\"material-icons\" style='font-size: 14px;'>business</i> " +
                    "<span>#= typeof value !== 'undefined' ? value : '' # - </span>" +
                    "<span style='color: red'> Τεμάχια: #= aggregates.quantity.sum#, Τζίρος: #= kendo.format('{0:c}', aggregates.netPrice.sum)# </span>"
                },
                {
                    field: "product.name",
                    title: "Προιόν",
                    groupHeaderTemplate: "<i class=\"material-icons\" style='font-size: 14px;'>shopping_basket</i> " +
                    "<span>#= typeof value !== 'undefined' ? value : '' # - </span>" +
                    "<span style='color: red'> Τεμάχια: #= aggregates.quantity.sum#, Τζίρος: #= kendo.format('{0:c}', aggregates.netPrice.sum)# </span>"
                },
                {
                    field: "productCategories",
                    title: "Κατηγορία",
                    template: productCategoriesDisplay
                },
                {
                    field: "quantity",
                    title: "Τεμάχια",
                    template: "#= (quantity == null) ? '' : quantity#",
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#",
                    aggregates: ["sum"]
                },
                {
                    field: "netPrice",
                    title: "Τζίρος",
                    template: "#= (netPrice == null) ? '' : kendo.format('{0:c}', netPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#",
                    aggregates: ["sum"]
                }
            ],
            height: vm.contentHeight,
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            },
            excel: {
                allPages: true,
                fileName: "ΓραμμέςΠαραγγελιών.xlsx"
            },
            excelExport: function (e) {
                if (vm.exportOnlyTotals){
                    // Check if user has applied at least 1 grouping into the grid, by checking the length of columns
                    // Same length means that the grid hasn't any grouping
                    if (e.workbook.sheets[0].columns.length !== vm.mainGridOptions.columns.length){
                        e.workbook.sheets[0].columns[0].autoWidth = true;
                        var result = CustomDataUtils.arrayRemove(e.workbook.sheets[0].rows, 'data'); // remove data
                        result = CustomDataUtils.arrayRemove(result, 'footer'); // also remove footer

                        //Define column headers
                        var index = result[0].cells.length;
                        while (index--) if (index < 6 && index !== 0) result[0].cells.splice(index, 1);
                        result[0].cells.splice(1, 0, {background: "#7a7a7a", color: "#fff", value: "Σύνολο Παραγγελιών", colSpan: 1, rowSpan: 1});

                        for (var i=0; i<result.length; i++){
                            if (result[i].type === 'group-header'){
                                var val = result[i].cells[result[i].cells.length - 1].value;
                                var _val = angular.copy(val);

                                //Get group column name
                                result[i].cells[0].value = CustomDataUtils.getGroupColumn(result[i].cells[0].value);
                                result[i].cells[0].colSpan = 0;

                                var values = CustomDataUtils.getValueFromHeaderLabel(val.substring(val.indexOf("Σύνολο: "))); // get val after a certain string
                                if ( values ) {
                                    for(var j = 0; j < values.length; j++) {
                                        result[i].cells.push({
                                            value: CustomDataUtils.convertToNumberFormat(values[j]),
                                            background: "#dfdfdf",
                                            color: "#333",
                                            colSpan: 1
                                        });
                                        if(result[i].cells.length > 2)
                                            result[i].cells[result[i].cells.length-1].format = "#,##0.00 €";
                                    }
                                }

                                // Keep only month in header labels
                                // result[i].cells[result[i].cells.length - 2].value = CustomDataUtils.removeTotalsFromHeaderLabel(String(_val));
                            }
                        }
                        e.workbook.sheets[0].rows = angular.copy(result);
                    } else {
                        e.preventDefault();
                        Alerts.showAlert("Sigma SalesForce", "Θα πρέπει να εφαρμόσετε τουλάχιστον 1 group by στη λίστα για να εξάγετε μόνο σύνολα. Ειδάλλως, κλείστε τον διακόπτη Εξαγωγή μόνο σύνολα και ξαναπροσπαθήστε.", "ΟΚ");
                    }
                } else {
                    var sheet = e.workbook.sheets[0];
                    var groupHeaders = vm.mainGrid.getOptions().dataSource.group.length;

                    //fix purchaseStatus column's width
                    sheet.columns[groupHeaders + 1].autoWidth = false;
                    sheet.columns[groupHeaders + 1].width = 160;

                    //fix date column's width
                    if (!groupHeaders.length) {
                        sheet.columns[0].autoWidth = false;
                        sheet.columns[0].width = 90;
                    }

                    //convert to number and set format
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {
                        var row = sheet.rows[rowIndex];
                        for (var cellIndex = 5; cellIndex < row.cells.length; cellIndex ++) {
                            var cell = row.cells[groupHeaders + cellIndex];
                            if (cell) {
                                if (typeof cell.value === 'string' || cell.value instanceof String) cell.value = CustomDataUtils.convertToNumberFormat(cell.value);
                                cell.format = "#,##0.00 €";
                            }
                        }
                    }

                }
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        function getFilters(){
            var filters = {
                data: {
                    "page": 1, // actually not used by the server
                    "pageSize": 20, // actually not used by the server
                    filter: {
                        logic: "and",
                        filters: [{
                            "operator": "from",
                            "value": $filter('date')(vm.masterFilters.from, 'yyyy-MM-dd'),
                            "field": "purchase.issueDate"
                        }, {
                            "field": "to",
                            "operator": $filter('date')(vm.masterFilters.to, 'yyyy-MM-dd'),
                            "value": "purchase.issueDate"
                        }]
                    }
                }
            };

            if (vm.purchaseStatusIdsString !== null){
                filters.data.filter.filters.push({
                    "operator": "in",
                    "field": "purchase.purchaseStatus.id",
                    "value": vm.purchaseStatusIdsString
                });
            }

            if (vm.selectedEmployeeId !== null){
                filters.data.filter.filters.push({
                    "operator": "eq",
                    "value": vm.selectedEmployeeId,
                    "field": "purchase.employee.id"
                });
            }

            if (vm.selectedSector !== null && vm.selectedSector.id){
                filters.data.filter.filters.push({
                    "operator": "eq",
                    "value": vm.selectedSector.id,
                    "field": "purchase.sector.id"
                });
            }

            if (vm.selectedProduct !== null){
                filters.data.filter.filters.push({
                    "operator": "eq",
                    "value": vm.selectedProduct.id,
                    "field": "product.id"
                });
            }

            if (vm.selectedProductCategoryId !== null){
                filters.data.filter.filters.push({
                    "operator": "in",
                    "value": vm.selectedProductCategoryId,
                    "field": "product.productCategories.id"
                });
            }

            return filters;
        }

        function productCategoriesDisplay(data) {
            if(data.product.productCategories) {
                return data.product.productCategories.map(function(elem) {
                    return elem.name
                }).join(', ');
            }
            return "";
        }

        function constructPurchaseStatusIdsString(){
            var idsString = null;
            if (purchaseStatuses !== null && purchaseStatuses.data && purchaseStatuses.data.content.length > 0){
                idsString = "";
                angular.forEach(purchaseStatuses.data.content, function (item) {
                    idsString += item.id + ",";
                });

                if (idsString.endsWith(",")) {
                    idsString = idsString.slice(0, -1);
                }
            }

            return idsString;
        }

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click today when screen opens
        $timeout(function () {
            $("#today").click();
        });
    }
})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerEmployeeComparative', {
                parent: 'purchasesAggregated',
                url: '/perEmployeeComparative',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee Comparative'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployeeComparative/purchasesAggregatedPerEmployeeComparative.html',
                controller: 'PurchasesAggregatedPerEmployeeControllerComparative',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedPerEmployeeControllerComparative', PurchasesAggregatedPerEmployeeControllerComparative);

    PurchasesAggregatedPerEmployeeControllerComparative.$inject = ['$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout', 'pharmacyVisitors', 'accountingDeps'];

    function PurchasesAggregatedPerEmployeeControllerComparative ($http, KendoGrid, CustomUtils, Alerts, $timeout, pharmacyVisitors, accountingDeps) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(50);
        vm.showProgress = false;

        var allYears = CustomUtils.getYears(2016, true);
        vm.selectedYears = [allYears[0]];
        vm.yearsOptions = {
            dataSource: {
                data: allYears
            },
            dataTextField: "value",
            dataValueField: "value",
            maxSelectedItems: 2
        };

        var allMonths = CustomUtils.getMonths(false);
        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος"
        };

        Array.prototype.push.apply(pharmacyVisitors, accountingDeps);
        vm.selectedEmployees = [];
        vm.employeesOptions = {
            dataSource: {
                data: pharmacyVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "'Ολοι οι Ιατρικοί Επισκέπτες Φαρμακείων"
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            if (vm.selectedYears.length < 1){
                Alerts.showAlert("Sigma SalesForce", "Επιλέξτε ένα ή δύο έτη", "ΟΚ");
            }else {
                $("#mainGrid").data().kendoGrid.destroy();
                $("#mainGrid").empty();
                vm.showProgress = true;
                $http.get("/api/purchases/totals-per-employee-comparative?years=" + yearObjectsToArray(vm.selectedYears) + "&months=" + vm.selectedMonths + "&employeeIds=" + employeeObjectsToArray(vm.selectedEmployees))
                    .success(function (response) {
                        vm.showProgress = false;
                        generateGrid(response);
                    })
                    .error(function (error) {
                        vm.showProgress = false;
                        console.log(error);
                        Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                    });
            }
        };

        function generateGrid(response){
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            console.log(data);
                            if (data !== null && data !== undefined && data.length > 0){
                                for (var i=0; i<data.length; i++){
                                    if (i === 2 || i === 3 || i === 4 || i === 5 || i === 8 || i === 11 || i === 14 || i === 17) {
                                        // Format all non-integer values with 2 decimals
                                        for (var j=0; j<data[i].results.length; j++){
                                            data[i].results[j].value = kendo.toString(parseFloat(data[i].results[j].value), 'n2');
                                        }
                                    }else {
                                        // Format all integer values without decimals
                                        for (var k=0; k<data[i].results.length; k++){
                                            data[i].results[k].value = kendo.toString(parseFloat(data[i].results[k].value), 'n0');
                                        }
                                    }
                                }
                            }

                            return data;
                        }
                    }
                },
                columns: generateColumns(response),
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                group: {
                    field: "employee"
                },
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                },
                excel: {
                    allPages: true,
                    fileName: "Συγκριτικά Παραγγελιών ανά Ιατρικό Επισκέπτη.xlsx"
                }
            });
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "label",
                title: " ",
                width: "335px"
            }, {
                field: "value",
                title: "Σύνολο Όλων",
                template: sumTemplate,
                width: "130px"
            });

            var employeeIteration = { id: 0 }; // dummy initial employee
            for (var i=0; i<response[0].results.length; i++){
                if (response[0].results[i].employee.id !== employeeIteration.id){
                    // Add a new title column
                    columns.push({
                        title: response[0].results[i].employee.account.lastName + " " + response[0].results[i].employee.account.firstName,
                        columns: [{
                            field: "results[" + i + "].value",
                            title: response[0].results[i].label,
                            width: "140px"
                            //template: "#= kendo.toString(" + "parseFloat(results[" + i + "].value)" + ", 'n2') #"
                        }]
                    });
                }else {
                    // Add a simple column
                    columns[columns.length - 1].columns.push({
                        field: "results[" + i + "].value",
                        title: response[0].results[i].label,
                        width: "140px"
                        //template: "#= kendo.toString(" + "parseFloat(results[" + i + "].value)" + ", 'n2') #"
                    });
                }

                employeeIteration = response[0].results[i].employee; // hold the previous employee, to know when to change column title
            }

            return columns;
        }

        /**
         * Calculates the sum of each row.
         * Note that it sums only the 'Σύνολο' columns.
         * @param data The whole row of the grid.
         * @returns {number} The total sum of the row.
         */
        function sumTemplate(data) {
            var result = 0;
            if (data !== null && data.results !== null && data.results !== undefined){
                angular.forEach(data.results, function (item) {
                    if (item.label === "Σύνολο Ιατρικού Επισκέπτη"){
                        // All item.values here are strings
                        // First remove dots (.) and then replace commas with dots from values so the number conversions runs ok
                        var s = item.value.replace(".", "").replace(",", ".");
                        result += parseFloat(s);
                    }
                });
            }

            return Number.isInteger(result) ? result.toString() : kendo.toString(result, 'n2');
        }

        function yearObjectsToArray(selectedYears){
            var arr = [];
            angular.forEach(selectedYears, function (yearObject) {
                arr.push(yearObject.value);
            });
            return arr;
        }

        function employeeObjectsToArray(selectedEmployees) {
            var arr = [];
            angular.forEach(selectedEmployees, function (employeeId) {
                arr.push(employeeId);
            });
            return arr;
        }

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });
    }
})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerEmployee', {
                parent: 'purchasesAggregated',
                url: '/perEmployee',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployee/purchasesAggregatedPerEmployee.html',
                controller: 'PurchasesAggregatedPerEmployeeController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasesAggregatedPerEmployeeController', PurchasesAggregatedPerEmployeeController);

    PurchasesAggregatedPerEmployeeController.$inject = ['$scope', '$filter', '$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout', 'KendoToolbar', 'CustomDataUtils'];

    function PurchasesAggregatedPerEmployeeController ($scope, $filter, $http, KendoGrid, CustomUtils, Alerts, $timeout, KendoToolbar, CustomDataUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(50);
        vm.showProgress = false;
        vm.masterFilters = {};
        vm.mainGrid = {};

        vm.getData = function () {
            var cancel = false;
            var message = "";
            if (vm.masterFilters.from === null || vm.masterFilters.to === null ||
                vm.masterFilters.from === undefined || vm.masterFilters.to === undefined){
                cancel = true;
                message = "Επιλέξτε ημερομηνίες";
            }

            if (!cancel && (vm.masterFilters.from > vm.masterFilters.to)){
                cancel = true;
                message = "Η ημερομηνία 'Από' πρέπει να είναι μικρότερη από την ημερομηνία 'Εώς'"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "ΟΚ");
            }else {
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.getData();' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel' aria-label='search' ng-click='vm.exportData();' ng-disabled='vm.disabled'>" +
                    "<span class='k-icon k-i-excel'></span>EXPORT</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.showProgress = true;
                        $http.get("/api/purchases/totals-per-employee?dateFrom=" + $filter('date')(vm.masterFilters.from, 'yyyy-MM-dd') + "&dateTo=" + $filter('date')(vm.masterFilters.to, 'yyyy-MM-dd'))
                            .success(function (response) {
                                o.success(response);
                                vm.showProgress = false;
                            })
                            .error(function (error) {
                                o.error(error);
                                vm.showProgress = false;
                                Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                console.log(error);
                            });
                    }
                },
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            numberOfCustomers: { type: "number" },
                            numberOfPurchases: { type: "number" },
                            totalNetPrice: { type: "number" },
                            totalDiscountPrice: { type: "number" },
                            execItemQuantities: { type: "number" },
                            trueExecItemQuantities: { type: "number" },
                            totalPresentPrice: { type: "number" },
                            execPresentItemQuantities: { type: "number" },
                            trueExecPresentItemQuantities: { type: "number" },
                            totalSyfaNetPrice: { type: "number" },
                            execQuantitiesSyfa: { type: "number" },
                            trueExecQuantitiesSyfa: { type: "number" },
                            totalMhsyfaNetPrice: { type: "number" },
                            execQuantitiesMhSyfa: { type: "number" },
                            trurExecQuantitiesMhSyfa: { type: "number" },
                            totalIatrNetPrice: { type: "number" },
                            execQuantitiesIatr: { type: "number" },
                            trueExecQuantitiesIatr: { type: "number" },
                            totalCosmeticNetPrice: { type: "number" },
                            execQuantitiesCosmetics: { type: "number" },
                            trueExecQuantitiesCosmetics: { type: "number" },
                            totalFSupplementsNetPrice: { type: "number" },
                            execQuantitiesFSupplements: { type: "number" },
                            trueExecQuantitiesFSupplements: { type: "number" }
                        }
                    },
                    data: function (data) {
                        if (data != null && data !== undefined && data.length > 0){
                            angular.forEach(data, function (item) {
                                item.employee.fullName = item.employee.account.lastName + " " + item.employee.account.firstName;
                                if (item.numberOfCustomers === null) item.numberOfCustomers = 0;
                                if (item.numberOfPurchases === null) item.numberOfPurchases = 0;
                                if (item.totalNetPrice === null) item.totalNetPrice = 0;
                                if (item.totalDiscountPrice === null) item.totalDiscountPrice = 0;
                                if (item.execItemQuantities === null) item.execItemQuantities = 0;
                                if (item.trueExecItemQuantities === null) item.trueExecItemQuantities = 0;
                                if (item.totalPresentPrice === null) item.totalPresentPrice = 0;
                                if (item.execPresentItemQuantities === null) item.execPresentItemQuantities = 0;
                                if (item.trueExecPresentItemQuantities === null) item.trueExecPresentItemQuantities = 0;
                                if (item.totalSyfaNetPrice === null) item.totalSyfaNetPrice = 0;
                                if (item.execQuantitiesSyfa === null) item.execQuantitiesSyfa = 0;
                                if (item.trueExecQuantitiesSyfa === null) item.trueExecQuantitiesSyfa = 0;
                                if (item.totalMhsyfaNetPrice === null) item.totalMhsyfaNetPrice = 0;
                                if (item.execQuantitiesMhSyfa === null) item.execQuantitiesMhSyfa = 0;
                                if (item.trueExecQuantitiesMhSyfa === null) item.trueExecQuantitiesMhSyfa = 0;
                                if (item.totalIatrNetPrice === null) item.totalIatrNetPrice = 0;
                                if (item.execQuantitiesIatr === null) item.execQuantitiesIatr = 0;
                                if (item.trueExecQuantitiesIatr === null) item.trueExecQuantitiesIatr = 0;
                                if (item.totalCosmeticNetPrice === null) item.totalCosmeticNetPrice = 0;
                                if (item.execQuantitiesCosmetics === null) item.execQuantitiesCosmetics = 0;
                                if (item.trueExecQuantitiesCosmetics === null) item.trueExecQuantitiesCosmetics = 0;
                                if (item.totalFSupplementsNetPrice === null) item.totalFSupplementsNetPrice = 0;
                                if (item.execQuantitiesFSupplements === null) item.execQuantitiesFSupplements = 0;
                                if (item.trueExecQuantitiesFSupplements === null) item.trueExecQuantitiesFSupplements = 0;
                            });
                        }
                        return data;
                    }
                },
                aggregate: [
                    {field: "numberOfCustomers", aggregate: "sum"},
                    {field: "numberOfPurchases", aggregate: "sum"},
                    {field: "totalNetPrice", aggregate: "sum"},
                    {field: "totalDiscountPrice", aggregate: "sum"},
                    {field: "execItemQuantities", aggregate: "sum"},
                    {field: "trueExecItemQuantities", aggregate: "sum"},
                    {field: "totalPresentPrice", aggregate: "sum"},
                    {field: "execPresentItemQuantities", aggregate: "sum"},
                    {field: "trueExecPresentItemQuantities", aggregate: "sum"},
                    {field: "totalSyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesSyfa", aggregate: "sum"},
                    {field: "totalMhsyfaNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "trueExecQuantitiesMhSyfa", aggregate: "sum"},
                    {field: "totalIatrNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesIatr", aggregate: "sum"},
                    {field: "trueExecQuantitiesIatr", aggregate: "sum"},
                    {field: "totalCosmeticNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesCosmetics", aggregate: "sum"},
                    {field: "trueExecQuantitiesCosmetics", aggregate: "sum"},
                    {field: "totalFSupplementsNetPrice", aggregate: "sum"},
                    {field: "execQuantitiesFSupplements", aggregate: "sum"},
                    {field: "trueExecQuantitiesFSupplements", aggregate: "sum"}
                ]
            }),
            sortable: true,
            groupable: false,
            filterable: false,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "employee.fullName",
                    title: "Υπάλληλος",
                    width: "250px",
                    footerTemplate: "Σύνολο"
                },
                {
                    field: "numberOfCustomers",
                    title: "Αριθμός Επαγγελματιών Υγείας",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "numberOfPurchases",
                    title: "Αριθμός Παραγγελιών",
                    width: "170px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalNetPrice",
                    title: "Τζίρος (€)",
                    width: "160px",
                    aggregates: ["sum"],
                    template: "#= (totalNetPrice == null) ? '' : kendo.format('{0:c}', totalNetPrice)#",
                    footerTemplate: "#= kendo.toString(sum, 'C') #"
                },
                {
                    field: "totalDiscountPrice",
                    title: "Συνολική Αξιακή Έκπτωση (€)",
                    width: "210px",
                    aggregates: ["sum"],
                    template: "#= (totalDiscountPrice == null) ? '' : kendo.format('{0:c}', totalDiscountPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execItemQuantities",
                    title: "Ποσότητα Παραγγελίας (Τεμ)",
                    width: "230px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecItemQuantities",
                    title: "Εκτελ. Ποόσητητα Παραγγελίας (Τεμ)",
                    width: "250px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalPresentPrice",
                    title: "Συνολική Έκπτωση σε Δώρα (€)",
                    width: "230px",
                    aggregates: ["sum"],
                    template: "#= (totalPresentPrice == null) ? '' : kendo.format('{0:c}', totalPresentPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execPresentItemQuantities",
                    title: "Ποσότητα Δώρων παραγγελίας (Τεμ)",
                    width: "245px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecPresentItemQuantities",
                    title: "Εκτελ. Ποσότητα Δώρων παραγγελίας (Τεμ)",
                    width: "290px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalSyfaNetPrice",
                    title: "Τζίρος ΣΥΦΑ (€)",
                    width: "120px",
                    aggregates: ["sum"],
                    template: "#= (totalSyfaNetPrice == null) ? '' : kendo.format('{0:c}', totalSyfaNetPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesSyfa",
                    title: "Τεμάχια ΣΥΦΑ",
                    width: "120px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesSyfa",
                    title: "Εκτελ. Τεμάχια ΣΥΦΑ",
                    width: "150px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalMhsyfaNetPrice",
                    title: "Τζίρος ΜΗΣΥΦΑ (€)",
                    width: "140px",
                    aggregates: ["sum"],
                    template: "#= (totalMhsyfaNetPrice == null) ? '' : kendo.format('{0:c}', totalMhsyfaNetPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesMhSyfa",
                    title: "Τεμάχια ΜΗΣΥΦΑ",
                    width: "130px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesMhSyfa",
                    title: "Εκτελ. Τεμάχια ΜΗΣΥΦΑ",
                    width: "170px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalIatrNetPrice",
                    title: "Τζίρος ΙΑΤΡ (€)",
                    width: "120px",
                    aggregates: ["sum"],
                    template: "#= (totalIatrNetPrice == null) ? '' : kendo.format('{0:c}', totalIatrNetPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesIatr",
                    title: "Τεμάχια ΙΑΤΡ",
                    width: "120px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesIatr",
                    title: "Εκτελ. Τεμάχια ΙΑΤΡ",
                    width: "160px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalCosmeticNetPrice",
                    title: "Τζίρος COSMETIC (€)",
                    width: "160px",
                    aggregates: ["sum"],
                    template: "#= (totalCosmeticNetPrice == null) ? '' : kendo.format('{0:c}', totalCosmeticNetPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesCosmetics",
                    title: "Τεμάχια COSMETIC",
                    width: "160px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesCosmetics",
                    title: "Εκτελ. Τεμάχια COSMETIC",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "totalFSupplementsNetPrice",
                    title: "Τζίρος F Supplements (€)",
                    width: "210px",
                    aggregates: ["sum"],
                    template: "#= (totalFSupplementsNetPrice == null) ? '' : kendo.format('{0:c}', totalFSupplementsNetPrice)#",
                    footerTemplate: "#=kendo.toString(sum, 'C')#"
                },
                {
                    field: "execQuantitiesFSupplements",
                    title: "Τεμάχια F Supplements",
                    width: "200px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                },
                {
                    field: "trueExecQuantitiesFSupplements",
                    title: "Εκτελ. Τεμάχια F Supplements",
                    width: "220px",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.format('{0:n0}', sum)#"
                }
            ],
            excel: {
                allPages: true,
                fileName: "Σύνολα Παραγγελιών ανά Ιατρικό Επισκέπτη.xlsx"
            },
            excelExport: function (e) {
                var footerCells = $filter('filter')(e.workbook.sheets[0].rows, {type: "footer"}, true)[0].cells;
                for(var i = 1; i < footerCells.length; i++) {
                    if (footerCells[i].value.includes("€")) {
                        footerCells[i].value.replace(' €','');
                        footerCells[i].format = "#,##0.00 €";
                    }
                    footerCells[i].hAlign = "right";
                    CustomDataUtils.convertToNumberFormat(footerCells[i].value);
                }
            },
            dataBound: function () {
                $timeout(function() {
                    kendo.resize($("#mainGrid"));
                });
            },
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click ok when screen opens
        $timeout(function () {
            $("#today").click();
        });
    }
})();
;
/**
 * Created by Teo on 25/07/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patchReportsAll', {
                parent: 'adminIndex',
                url: '/patchReports/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/patchReportsAll/patchReportsAll.html',
                        controller: 'PatchReportsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 25/07/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportsAllController', PatchReportsAllController);

    PatchReportsAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'MasterFiltersService', 'employee', 'CustomUtils'];

    function PatchReportsAllController ($scope, $filter, $http, $timeout, KendoFilter, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                          MasterToKendoFiltersService, MasterFiltersService, employee, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Αναφορα Γνωματευσεων";
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(56);
        vm.employee = employee;
        vm.masterFilters = { selectedCallTypes: [], hospitalizations: false};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'patchReports';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" },
                        { text: "Έτος", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "year" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' onkeydown='return false' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' onkeydown='return false' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        $http.get('/api/patch-report-items/all', {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        if(data !== null && data !== undefined) {
                            data.forEach(function(item){
                                if (!item.patchReport) {
                                    item.patchReport = {
                                        patchCustomer: {},
                                        employee: {},
                                        materialCategory: {},
                                        customerSector: {}
                                    };
                                }else {
                                    if (!item.patchReport.patchCustomer) item.patchReport.patchCustomer = {};
                                    if (!item.patchReport.employee) item.patchReport.employee = {};
                                    if (!item.patchReport.materialCategory) item.patchReport.materialCategory = {};
                                    if (!item.patchReport.customerSector) item.patchReport.customerSector = {};
                                }

                                if (!item.icd10) item.icd10 = {}
                            });
                        }
                        return data;
                    },
                    parse: function (data) {
                        angular.forEach(data, function (item) {
                            item.issueDate = kendo.toString(kendo.parseDate(item.patchReport.issueDate), 'dd/MM/yyyy');
                            item.approvalDate = kendo.toString(kendo.parseDate(item.patchReport.approvalDate), 'dd/MM/yyyy');
                            item.executedDate = kendo.toString(kendo.parseDate(item.patchReport.executedDate), 'dd/MM/yyyy');
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            issueDate: { type: "date" },
                            approvalDate: { type: "date" },
                            executedDate: { type: "date" }
                        }
                    }
                }
            }),
            sortable: true,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: [
                {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                    template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                    filterable: {
                        cell: {
                            operator: "eq", // Put 'eqdateonly' if you enable server filtering
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.patchCustomer.firstName", title: "Όνομα Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.customerSector.sector.address", title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.customerSector.sector.cityName", title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.barcode", title: "Barcode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.materialCategory.name", title: "Κατηγορία Υλικού",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "approvalDate", title: "Ημερ/νια Έγκρισης",
                    template: "#= approvalDate ? kendo.toString(kendo.parseDate(approvalDate), 'dddd, dd/MM/yyyy') : ''#",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {field: "patchReport.checkDoctor", title: "Ελεγκτής Επαγγελματίας Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "icd10.code", title: "Κωδικός Διάγνωσης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "icd10.title", title: "Όνομα Διάγνωσης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αναφορά Γνωματεύσεων.xlsx"
            },
            dataBound: function () {
                vm.masterFiltersEdited();
                $timeout(function() {
                    kendo.resize($("#mainGrid"));
                });
            }
        };

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click week when screen opens
        $timeout(function () {
            $("#week").click();
        });
    }
})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider

            .state('medReportsWithLines', {
                parent: 'medReport',
                url: '/with-lines',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminIndex/medReport/medReportWithLines/medReportWithLines.html',
                controller: 'MedReportWithLinesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportWithLinesController', MedReportWithLinesController);

    MedReportWithLinesController.$inject = ['$scope', '$filter', '$timeout','$http', 'employee', 'favouriteFilters', 'FavouriteFiltersService', 'MasterFiltersService', 'KendoFilter', 'MasterToKendoFiltersService', 'CustomUtils', 'Principal', 'ApplicationParameters', 'KendoService'];

    function MedReportWithLinesController ($scope, $filter, $timeout, $http, employee, favouriteFilters, FavouriteFiltersService, MasterFiltersService, KendoFilter, MasterToKendoFiltersService, CustomUtils, Principal, ApplicationParameters, KendoService) {
        var vm = this;
        vm.url = '/api/me/med-reports';
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(57);
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { selectedEmployees: [], selectedCustomers: [], selectedMonths: [], selectedYears: [], selectedMedicines: [], isActive: true };
        vm.pageHeading = 'Συνολα & Συγκριτικα';
        vm.disabled = true;
        vm.isEdited = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.showProgress = false;
        vm.principal = Principal;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        var exportFlag = false;
        var detailExportPromises = [];
        vm.view = 'medReport';

        vm.hasMedReport = false;
        ApplicationParameters.hasModule('Med_Report', false).then(function (response) {
            vm.hasMedReport = response.data.content[0].value === "1";
        });
        ApplicationParameters.hasModule('Med_Report', true);

        var setView = function() {
            var filterable = vm.masterFilters.selectedMonths.length && vm.masterFilters.selectedYears.length ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.selectedMonths.length && vm.masterFilters.selectedYears.length ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.selectedMonths.length || !vm.masterFilters.selectedYears.length;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.selectedMonths.length && vm.masterFilters.selectedYears.length,
                filterable: filterable
            });
        };

        $scope.$watchGroup(["vm.masterFilters.selectedMonths", "vm.masterFilters.selectedYears"], function () { setView(); });
        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        vm.customersMultiOptions = MasterFiltersService.getCustomersComboBoxOptions(["all"]);
        vm.customersMultiOptions.dataSource.filter({});

        vm.medicinesDataSource = KendoService.initDataSource('/api/medicines/search', 1, 100);
        vm.medicinesMultiOptions = KendoService.initDefaultOptions(vm.medicinesDataSource, "startswith", "name", "id");
        vm.medicinesMultiOptions.placeholder = "Επιλογή Φαρμάκου";

        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.monthsMultiOptions.placeholder = "Επιλογή Μήνα";
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.yearsMultiOptions.placeholder = "Επιλογή Έτους";
        vm.masterFilters.selectedYears.push(years[0].value); //2020
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτη: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.yearsMultiOptions' k-ng-model='vm.masterFilters.selectedYears'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                        "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.customersMulti' multiple='multiple' " +
                        "k-options='vm.customersMultiOptions' k-ng-model='vm.masterFilters.selectedCustomers'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Φάρμακο: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.medicineMulti' multiple='multiple' " +
                        "k-options='vm.medicinesMultiOptions' k-ng-model='vm.masterFilters.selectedMedicines'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ενεργό: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read();' ng-disabled='vm.disabled'>" +
                        "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get(vm.url, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content) {
                            angular.forEach(data.content, function (item) {
                                if (!item.customer) item.customer = {lastName: ""};
                            });
                        }
                        return data.content;
                    },
                    parse: function(data) {
                        if(data.content) {
                            angular.forEach(data.content, function (item) {
                                if (item.fromDate) item.month = kendo.toString(kendo.parseDate(item.fromDate), 'MMMM');
                                if (item.fromDate) item.year = kendo.toString(kendo.parseDate(item.fromDate), 'yyyy');
                            });
                        }
                        return data;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: true},
                            fromDate: {type: 'date'},
                            toDate: {type: 'date'},
                            checkDigit1: {type: 'number'},
                            checkDigit2: {type: 'number'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50
            }),
            height: CustomUtils.getHeightPixelsFromPercentage(55),
            sortable: true,
            groupable: false,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Αναφορές", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν αναφορές",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            filterable: false,
            resizable: true,
            columns: [
                {
                    field: "month",
                    title: "Μήνας",
                    filterable: false,
                    sortable: false
                },
                {
                    field: "year",
                    title: "Έτος",
                    filterable: false,
                    sortable: false
                },
                {
                    field: "checkDigit1", title: "Check Digit",
                    filterable: false,
                    width: 140
                },
                {
                    field: "checkDigit2", title: "Check Digit 2",
                    filterable: false,
                    width: 140
                },
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                },
                {
                    field: "customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Σύμπτυξη όλων</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Επέκταση Όλων</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                        "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            noRecords: {
                template: "Δεν βρέθηκαν εγγραφές"
            },
            excel: {
                allPages: true,
                fileName: "MedReports.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); },
            excelExport: function (e) {
                if (!exportFlag){
                    e.preventDefault();
                    exportFlag = true;
                    var workbook = e.workbook;

                    detailExportPromises = [];

                    var masterData = e.data;

                    for (var rowIndex = 0; rowIndex < masterData.length; rowIndex++) {
                        vm.exportChildData(masterData[rowIndex], rowIndex, e.sender._data[rowIndex]);
                    }

                    $.when.apply(null, detailExportPromises)
                        .then(function() {
                            // get the export results
                            var detailExports = $.makeArray(arguments);

                            // sort by masterRowIndex
                            detailExports.sort(function(a, b) {
                                return a.masterRowIndex - b.masterRowIndex;
                            });

                            // add an empty column
                            workbook.sheets[0].columns.unshift({
                                width: 30
                            });

                            // prepend an empty cell to each row
                            for (var i = 0; i < workbook.sheets[0].rows.length; i++) {
                                workbook.sheets[0].rows[i].cells.unshift({});
                            }
                            var totalDataLength = 0;
                            // merge the detail export sheet rows with the master sheet rows
                            for (var i = 0; i < detailExports.length; i++) {
                                var findByType = detailExports[i-1] ? $filter('filter')(detailExports[i-1].sheet.rows, {type: "data"}, true) : [];
                                totalDataLength += findByType.length;
                                var masterRowIndex;
                                if (e.sender.dataSource.group().length) {
                                    masterRowIndex = detailExports[i].masterRowIndex + 1
                                        + e.sender.dataSource.group().length + (i * 2) + (i * e.sender.dataSource.group().length)
                                        + totalDataLength;
                                } else {
                                    masterRowIndex = detailExports[i].masterRowIndex + 1 + (i * 2) + totalDataLength;
                                }

                                var sheet = detailExports[i].sheet;

                                // prepend an empty cell to each row
                                for (var ci = 0; ci < sheet.rows.length; ci++) {
                                    if (sheet.rows[ci].cells[0].value) {
                                        sheet.rows[ci].cells.unshift({});
                                    }
                                }

                                // insert the detail sheet rows after the master row
                                [].splice.apply(workbook.sheets[0].rows, [masterRowIndex + 1, 0].concat(sheet.rows));
                            }

                            // save the workbook
                            kendo.saveAs({
                                dataURI: new kendo.ooxml.Workbook(workbook).toDataURL(),
                                fileName: "Αναφορά Med.xlsx"
                            });
                            exportFlag = false;
                        });
                }else {
                    exportFlag = false;
                    vm.showProgress = false;
                }
            }
        };

        vm.medReportLinesGridOptions = function (dataItem) {
            if (dataItem !== undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                vm.showProgress = true;
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "medReport.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/med-report-lines/search',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        vm.showProgress = false;
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                if(data != undefined) {
                                    data.content.forEach(function(item){
                                    });
                                }
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    sum: { type: "number" },
                                    marketSharePercentage: { type: "number" },
                                    numberOfChanges: { type: "number" }
                                }
                            }
                        },
                        aggregate: [{field: "sum", aggregate: "sum"}],
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: {
                        messages: {
                            display: "{0} - {1} από {2} Αναφορές", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                            empty: "Δεν βρέθηκαν αναφορές",
                            page: "Σελίδα",
                            allPages: "Όλα",
                            of: "από {0}", // {0} is total amount of pages.
                            itemsPerPage: "εγγραφές ανά σελίδα",
                            first: "Πήγαινε στη πρώτη σελίδα",
                            previous: "Πήγαινε στη τελευταία σελίδα",
                            next: "Πήγαινε στην επόμενη σελίδα",
                            last: "Πήγαινε στη τελευταία σελίδα",
                            refresh: "Ανανέωση"
                        }
                    },
                    sortable: true,
                    filterable: false,
                    columns: [
                        {
                            field: "medicine.barcode", title: "Barcode",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            footerTemplate: "Σύνολο:"
                        },
                        {
                            field: "medicine.name", title: "Φάρμακο",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "sum", title: "Σύνολο",
                            filterable: {
                                operators: {
                                    number: {
                                        eq: 'Ίσο',
                                        gte: 'Μεγαλύτερο ή Ίσο',
                                        lte: 'Μικρότερο ή Ίσο'
                                    }
                                },
                                cell: {
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "n0",
                                            decimals: 0,
                                            min: 0
                                        });

                                    }
                                }
                            },
                            aggregates: ["sum"],
                            footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : ''#"
                        },
                        // {
                        //     field: "marketSharePercentage",
                        //     title: "Μερίδιο Αγοράς (%)",
                        //     attributes:{style:"text-align:right;"},
                        //     template: "#= (marketSharePercentage == null) ? '' : kendo.format('{0:p0}', marketSharePercentage / 100)#",
                        //     filterable: {
                        //         cell: {
                        //             operator: "eq",
                        //             template: function (args) {
                        //                 args.element.kendoNumericTextBox({
                        //                     format: "{0:n0}"
                        //                 });
                        //             },
                        //             showOperators: false
                        //         }
                        //     }
                        // },
                        // {
                        //     field: "numberOfChanges", title: "Αριθμός Αλλαγών",
                        //     filterable: {
                        //         operators: {
                        //             number: {
                        //                 eq: 'Ίσο',
                        //                 gte: 'Μεγαλύτερο ή Ίσο',
                        //                 lte: 'Μικρότερο ή Ίσο'
                        //             }
                        //         },
                        //         cell: {
                        //             template: function (args) {
                        //                 args.element.kendoNumericTextBox({
                        //                     format: "n0",
                        //                     decimals: 0,
                        //                     min: 0
                        //                 });
                        //
                        //             }
                        //         }
                        //     }
                        // }
                    ],
                    editable: false
                };
            }
        };

        vm.exportChildData = function (dataItem, rowIndex, masterItem) {
            var deferred = $.Deferred();

            detailExportPromises.push(deferred);

            var exporter = new kendo.ExcelExporter({
                columns: vm.medReportLinesGridOptions(masterItem).columns,
                dataSource: vm.medReportLinesGridOptions(masterItem).dataSource
            });

            exporter.workbook().then(function(book, data) {
                deferred.resolve({
                    masterRowIndex: rowIndex,
                    sheet: book.sheets[0]
                });
            });
        };
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportsSumsPerMonth', {
                parent: 'medReport',
                url: '/per-month',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminIndex/medReport/medReportSumsPerMonth/medReportSumsPerMonth.html',
                controller: 'MedReportsSumsPerMonthController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "medReportSumsPerMonth"
                                    }] } }} );
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportsSumsPerMonthController', MedReportsSumsPerMonthController);

    MedReportsSumsPerMonthController.$inject = ['$scope', '$http','$state', 'employee', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'CustomUtils', 'KendoService', 'Alerts', '$timeout', 'MasterFiltersService', 'favouriteFilters', 'FavouriteFiltersService', 'MasterToKendoFiltersService'];

    function MedReportsSumsPerMonthController ($scope, $http, $state, employee, $stateParams, $filter, Principal, KendoFilter, CustomUtils, KendoService, Alerts, $timeout, MasterFiltersService, favouriteFilters, FavouriteFiltersService, MasterToKendoFiltersService) {
        var vm = this;
        vm.isEdited = false;
        vm.employee = employee;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.view = 'medReportSumsPerMonth';
        vm.selectedFilter = {};
        var aggregates = [];
        vm.selectedUserId = $stateParams.id;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        vm.masterFilters = { selectedMonths: [], selectedMedicines: [], selectedEmployees: [], isActive: true, selectedYear: null };
        angular.forEach(moment.months(), function (value, key) {
            if (key <= new Date().getMonth()) {
                vm.masterFilters.selectedMonths.push(key + 1);
            }
        });
        vm.pageHeading = 'Συνολα & Συγκριτικα'.toUpperCase();
        var medicinesDatasource = KendoService.initDataSource('/api/medicines/search', 1, 50);
        vm.medicinesMultiOptions = KendoService.initDefaultOptions(medicinesDatasource, "startswith", "name", "id", true);
        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.masterFilters.selectedYear = years[0].value; //2020
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions([]);
        vm.employeesMultiOptions.dataSource.filter({});
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Σκευάσματα: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.medicinesMultiOptions' k-ng-model='vm.masterFilters.selectedMedicines'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτος: </label><select id='comboBox' name='comboBox' class='inline widgets-s' kendo-combo-box k-options='vm.yearsMultiOptions' " +
                        "k-ng-model='vm.masterFilters.selectedYear'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Ιατρικοί Επισκέπτες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                // {
                //     template: "<label>Ενεργό: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                //     overflow: "never", attributes: {class: "left"}
                // },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.getData()' ng-disabled='!vm.masterFilters.selectedYear'>" +
                        "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.getData = function () {
            $("#mainGrid").data().kendoGrid.destroy();
            $("#mainGrid").empty();
            vm.showProgress = true;
            $http.get("/api/med-reports/sums/per-medicine/all?years=" + vm.masterFilters.selectedYear + "&months=" + vm.masterFilters.selectedMonths
                + "&medicines=" + vm.masterFilters.selectedMedicines
                + "&employeeIds=" + vm.masterFilters.selectedEmployees)
                .success(function (response) {
                    vm.showProgress = false;
                    generateGrid(response);
                })
                .error(function (error) {
                    vm.showProgress = false;
                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                });
        };

        function generateGrid(response){
            aggregates = [];
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            if (data !== null && data !== undefined && data.length > 0){
                                for ( var i=0; i < data.length; i++) {
                                    data[i].total = 0;
                                    for ( var j=0; j < data[i].results.length; j++) {
                                        if (!data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month])
                                            data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month] = 0;
                                        data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month] += data[i].results[j].sum;
                                        data[i].total += data[i].results[j].sum;
                                    }
                                }
                            }
                            return data;
                        },
                        model: {
                            id: "id",
                            fields: {
                                id: { editable: false, nullable: false }
                            }
                        }
                    },
                    sort: { field: "total", dir: "desc" },
                    aggregate: aggregates
                },
                selectable: "cell",
                columns: generateColumns(response),
                toolbar: [
                    { name: "excel", template: "<div class='right'><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                            "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
                ],
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Φαρμάκων.xlsx"
                },
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));

                        // angular.forEach(angular.element("#mainGrid").data("kendoGrid").columns, function(mainColumn) {
                        //     angular.forEach(mainColumn.columns, function (column) {
                        //         angular.element("#mainGrid").data("kendoGrid").dataSource.options.schema.model.fields[column.field] = {defaultValue : 0};
                        //     })
                        // });
                    });
                }
            });
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "customer.lastName",
                template: "#=customer.lastName + ' ' + customer.firstName#",
                title: "Επαγγελματίας Υγείας",
                footerTemplate: "Σύνολο: ",
                width: "370px"
            });
            var date = new Date();
            var medicineIterations = []; // dummy initial medicine
            for (var k=0; k<response.length; k++) {
                for (var i = 0; i < response[k].results.length; i++) {
                    vm.result = response[k].results[i];
                    if (!medicineIterations.includes(response[k].results[i].medicine.id)) {

                        // Add a new title column
                        date.setMonth(response[k].results[i].month - 1);
                        aggregates.push({
                            field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                            aggregate: "sum"
                        });
                        // angular.element("#mainGrid").data("kendoGrid").dataSource.options.schema.model.fields["medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month] = {defaultValue : 0};
                        columns.push({
                            title: response[k].results[i].medicine.name,
                            columns: [{
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            }]
                        });
                    } else {
                        date.setMonth(response[k].results[i].month - 1);
                        var foundColumnByTitle = $filter('filter')(columns, {title: response[k].results[i].medicine.name}, true)[0];
                        var foundInnerColumnByField = $filter('filter')(columns[columns.indexOf(foundColumnByTitle)].columns,
                            {field:  "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month}, true)[0];

                        if (!columns[columns.indexOf(foundColumnByTitle)].columns[columns[columns.indexOf(foundColumnByTitle)].columns.indexOf(foundInnerColumnByField)]) {
                            aggregates.push({
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                                aggregate: "sum"
                            });
                            columns[columns.indexOf(foundColumnByTitle)].columns.push({
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month ,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            });
                        }
                    }

                    medicineIterations.push(response[k].results[i].medicine.id); // hold medicine.id, to know if new
                }
            }
            aggregates.push({ field: "total", aggregate: "sum" });
            columns.push({
                field: "total",
                title: "Σύνολο",
                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#",
                width: "100px"
            });

            return columns;
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 13/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportSumsPerCustomerAndMonth', {
                parent: 'medReport',
                url: '/per-customer',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminIndex/medReport/medReportSumsPerCustomerAndMonth/medReportSumsPerCustomerAndMonth.html',
                controller: 'MedReportSumsCustomerAndMonthController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "medReportSumsPerCustomerAndMonth"
                                    }] } }} );
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 13/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportSumsCustomerAndMonthController', MedReportSumsCustomerAndMonthController);

    MedReportSumsCustomerAndMonthController.$inject = ['$scope', '$http','$state', '$stateParams', '$filter', 'Principal', 'employee', 'KendoFilter', 'CustomUtils', 'KendoService', 'Alerts', '$timeout', 'MasterFiltersService', 'favouriteFilters', 'FavouriteFiltersService', 'MasterToKendoFiltersService'];

    function MedReportSumsCustomerAndMonthController ($scope, $http, $state, $stateParams, $filter, Principal, employee, KendoFilter, CustomUtils, KendoService, Alerts, $timeout, MasterFiltersService, favouriteFilters, FavouriteFiltersService, MasterToKendoFiltersService ) {
        var vm = this;
        vm.isEdited = false;
        vm.employee = employee;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.view = 'medReportSumsPerCustomerAndMonth';
        vm.selectedFilter = {};
        var aggregates = [];
        vm.selectedUserId = $stateParams.id;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        vm.masterFilters = { selectedMonths: [], selectedMedicines: [], selectedEmployees: [], isActive: true, selectedYear: null };
        angular.forEach(moment.months(), function (value, key) {
            if (key <= new Date().getMonth()) {
                vm.masterFilters.selectedMonths.push(key + 1);
            }
        });
        vm.pageHeading = 'Συνολα & Συγκριτικα'.toUpperCase();
        var medicinesDatasource = KendoService.initDataSource('/api/medicines/search', 1, 50);
        vm.medicinesMultiOptions = KendoService.initDefaultOptions(medicinesDatasource, "startswith", "name", "id", true);
        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.masterFilters.selectedYear = years[0].value; //2020
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions([]);
        vm.employeesMultiOptions.dataSource.filter({});
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Σκευάσματα: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.medicinesMultiOptions' k-ng-model='vm.masterFilters.selectedMedicines'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτος: </label><select id='comboBox' name='comboBox' class='inline widgets-s' kendo-combo-box k-options='vm.yearsMultiOptions' " +
                        "k-ng-model='vm.masterFilters.selectedYear'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Ιατρικοί Επισκέπτες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.getData()' ng-disabled='!vm.masterFilters.selectedYear'>" +
                        "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.getData = function () {
            $("#mainGrid").data().kendoGrid.destroy();
            $("#mainGrid").empty();
            vm.showProgress = true;
            $http.get("/api/med-reports/sums/per-customer/all?years=" + vm.masterFilters.selectedYear + "&months=" + vm.masterFilters.selectedMonths
                + "&medicines=" + vm.masterFilters.selectedMedicines
                + "&employeeIds=" + vm.masterFilters.selectedEmployees)
                .success(function (response) {
                    vm.showProgress = false;
                    generateGrid(response);
                })
                .error(function (error) {
                    vm.showProgress = false;
                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                });
        };

        function generateGrid(response){
            aggregates = [];
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            if (data !== null && data !== undefined && data.length > 0){
                                for ( var i=0; i < data.length; i++) {
                                    data[i].total = 0;
                                    for ( var j=0; j < data[i].results.length; j++) {
                                        if (!data[i]["customer" + data[i].results[j].customer.id + "month" + data[i].results[j].month])
                                            data[i]["customer" + data[i].results[j].customer.id + "month" + data[i].results[j].month] = 0;
                                        data[i]["customer" + data[i].results[j].customer.id + "month" + data[i].results[j].month] += data[i].results[j].sum;
                                        data[i].total += data[i].results[j].sum;
                                    }
                                }
                            }
                            return data;
                        }
                    },
                    sort: { field: "total", dir: "desc" },
                    aggregate: aggregates
                },
                selectable: "cell",
                columns: generateColumns(response),
                toolbar: [
                    { name: "excel", template: "<div class='right'><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                            "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
                ],
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Φαρμάκων.xlsx"
                },
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                }
            });
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "medicine.name",
                title: "Σκέυασμα",
                footerTemplate: "Σύνολο: ",
                width: "370px"
            });
            var date = new Date();
            var customerIterations = []; // dummy initial customer
            for (var k=0; k<response.length; k++) {
                for (var i = 0; i < response[k].results.length; i++) {
                    vm.result = response[k].results[i];
                    if (!customerIterations.includes(response[k].results[i].customer.id)) {

                        // Add a new title column
                        date.setMonth(response[k].results[i].month - 1);
                        aggregates.push({
                            field: "customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month,
                            aggregate: "sum"
                        });
                        // angular.element("#mainGrid").data("kendoGrid").dataSource.options.schema.model.fields["customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month] = {defaultValue : 0};
                        columns.push({
                            title: response[k].results[i].customer.lastName + " " + response[k].results[i].customer.firstName,
                            columns: [{
                                field: "customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            }]
                        });
                    } else {
                        date.setMonth(response[k].results[i].month - 1);
                        var foundColumnByTitle = $filter('filter')(columns, {title: response[k].results[i].customer.lastName + " " + response[k].results[i].customer.firstName}, true)[0];
                        var foundInnerColumnByField = $filter('filter')(columns[columns.indexOf(foundColumnByTitle)].columns,
                            {field:  "customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month}, true)[0];

                        if (!columns[columns.indexOf(foundColumnByTitle)].columns[columns[columns.indexOf(foundColumnByTitle)].columns.indexOf(foundInnerColumnByField)]) {
                            aggregates.push({
                                field: "customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month,
                                aggregate: "sum"
                            });
                            columns[columns.indexOf(foundColumnByTitle)].columns.push({
                                field: "customer" + response[k].results[i].customer.id + "month" + response[k].results[i].month ,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            });
                        }
                    }

                    customerIterations.push(response[k].results[i].customer.id); // hold customer.id, to know if new
                }
            }
            aggregates.push({ field: "total", aggregate: "sum" });
            columns.push({
                field: "total",
                title: "Σύνολο",
                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#",
                width: "100px"
            });

            return columns;
        }
    }

})();
;
/**
 * Created by Kristy on 22/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReport', {
                parent: 'adminIndex',
                url: '/medReport',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/medReport/medReport.html',
                        controller: 'MedReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "medReport"
                        }] } }} );
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 29/1/2020.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportController', MedReportController);

    MedReportController.$inject = [ '$state' ];

    function MedReportController ( $state ) {
        var vm = this;
        vm.$state = $state;
        vm.pageHeading = "Συνολα & Συγκριτικα";
    }
})();
;
/**
 * Created by Teo on 23/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAll', {
                parent: 'adminIndex',
                url: '/leadManagement/all',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/leadManagementAll/leadManagementAll.html',
                        controller: 'LeadManagementAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "leadManagement"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 23/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadManagementAllController', LeadManagementAllController);

    LeadManagementAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'favouriteFilters','KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'MasterFiltersService', 'employee', 'CustomUtils'];

    function LeadManagementAllController ($scope, $filter, $http, $timeout, KendoFilter, favouriteFilters, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                          MasterToKendoFiltersService, MasterFiltersService, employee, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Αναφορές Κλήσεων";
        vm.contentWidth = CustomUtils.getWidthPixelsFromPercentage(84);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(51);
        vm.url = '/api/lead-calls/all';
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { selectedCallTypes: [], hospitalizations: false/*, bookedAppointment: false */};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'leadManagement';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.callTypesMultiOptions = MasterFiltersService.getCallTypeComboBoxOptions();

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" },
                        { text: "Έτος", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "year" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' onkeydown='return false' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' onkeydown='return false' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Έγινε Εισαγωγή: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.hospitalizations'>" +
                    "<md-radio-button ng-value=false class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=true class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Τύπος Κλήσης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.callTypesMultiOptions' k-ng-model='vm.masterFilters.selectedCallTypes'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                // Remove bookedAppointment filter ECRM-337
                /*{type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Δια Ζώσης: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.bookedAppointment' ng-change='vm.onBookedAppointmentChange();'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Ημ/νία Ραντεβού:</label><label>Από: </label><input class='inline' kendo-date-picker id='from1' onkeydown='return false' options='vm.fromOptions1' k-ng-model='vm.masterFilters.from1' ng-disabled='!vm.masterFilters.bookedAppointment'/>" +
                                                             "<label>Εώς: </label><input class='inline' kendo-date-picker id='to1' onkeydown='return false' options='vm.toOptions1' k-ng-model='vm.masterFilters.to1' ng-disabled='!vm.masterFilters.bookedAppointment'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },*/
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        vm.fromOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from1 = value;
                } else {
                    vm.masterFilters.from1 = null;
                }
            }
        };

        vm.toOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to1 = value;
                } else {
                    vm.masterFilters.to1 = null;
                }
            }
        };

        // Not used
        vm.onBookedAppointmentChange = function () {
            if (vm.masterFilters.bookedAppointment === true){
                // do nothing
            }else {
                vm.masterFilters.from1 = "";
                vm.masterFilters.to1 = "";
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var grid = {};
        grid.columns = [
            {
                title: "Στοιχεία Κλήσης",
                columns: [
                    {
                        field: "dateTime",
                        title: "Ημερομηνία",
                        //template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy, HH:mm') : ''#",
                        template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "callType.name",
                        title: "Τύπος Κλήσης",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Πιθανού Ασθενή",
                columns: [
                    {
                        field: "prospectivePatient.firstName",
                        title: "Όνομα Πιθανού Ασθενή",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "prospectivePatient.lastName",
                        title: "Επώνυμο Πιθανού Ασθενή",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "prospectivePatient.phone",
                        title: "Τηλέφωνο Πιθανού Ασθενή",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "prospectivePatient.age",
                        title: "Ηλικία",
                        filterable: {
                            cell: {
                                //operator: "startswithnum",
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Συνοδού",
                columns: [
                    {
                        field: "prospectivePatient.attendant.firstName",
                        title: "Όνομα Συνοδού",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "prospectivePatient.attendant.lastName",
                        title: "Επώνυμο Συνοδού",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "prospectivePatient.attendant.phone",
                        title: "Τηλέφωνο Συνοδού",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Νοσηλείας",
                columns: [
                    {
                        field: "leadHospitalizations.hospitalizationType.name",
                        title: "Ασφάλιση",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadHospitalizations.sector.name",
                        title: "Νοσοκομείο",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadHospitalizations.clinicName.name",
                        title: "Κλινική",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        //field: "leadHospitalizations.possibleDischargeDate",
                        field: "possibleDischargeDate",
                        title: "Πιθανή Ημερ/νια Εξιτηρίου",
                        template: "#= possibleDischargeDate ? kendo.toString(kendo.parseDate(possibleDischargeDate), 'dddd, dd/MM/yyyy') : ''#",
                        //template: "#= value ? kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Προσφοράς/FollowUp",
                columns: [
                    {
                        field: "leadOffers.offerStatus.name",
                        title: "Προσφορά",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "nextFollowUpDate",
                        title: "FollowUp - Ημερ/νία",
                        template: "#= nextFollowUpDate ? kendo.toString(kendo.parseDate(nextFollowUpDate), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                    o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                    angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                            case "appointmentDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                            case "leadHospitalizations.possibleDischargeDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                    });

                    $http.get('/api/lead-calls/all', {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data !== null && data !== undefined) {
                        data.forEach(function(item){
                            if (!item.callType) item.callType = {};
                            if (!item.prospectivePatient) item.prospectivePatient = {};
                            if (item.prospectivePatient && !item.prospectivePatient.attendant) item.prospectivePatient.attendant = {};
                            if (!item.oldPatient) item.oldPatient = {};
                            if (!item.oldPatientDoctor) item.oldPatientDoctor = {};
                            if (!item.leadOffers) item.leadOffers = {};
                            if (!item.leadOffers.offerStatus) item.leadOffers.offerStatus = {};
                            if (!item.leadHospitalizations) item.leadHospitalizations = {};
                            if (item.leadHospitalizations && !item.leadHospitalizations.hospitalizationType) item.leadHospitalizations.hospitalizationType = {};
                            if (item.leadHospitalizations && !item.leadHospitalizations.sector) item.leadHospitalizations.sector = {};
                            if (item.leadHospitalizations && !item.leadHospitalizations.clinicName) item.leadHospitalizations.clinicName = {};
                        });
                    }
                    return data;
                },
                parse: function (data) {
                    angular.forEach(data, function (item) {
                        item.possibleDischargeDate = kendo.toString(kendo.parseDate(item.leadHospitalizations.possibleDischargeDate), 'dd/MM/yyyy');
                        item.dateTime = kendo.toString(kendo.parseDate(item.dateTime), 'dd/MM/yyyy');
                    });
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: {editable: false, nullable: false},
                        dateTime: { type: "date" },
                        nextFollowUpDate: { type: "date" },
                        "prospectivePatient.age": { type: "number" },
                        //'leadHospitalizations.possibleDischargeDate': {type: 'date'},
                        possibleDischargeDate: { type: "date" }
                    }
                }
            }
        });
        vm.mainGridOptions = {
            autoBind: false,
            dataSource: grid.dataSource,
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: grid.columns,
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αναφορές Κλήσεων.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };
    }
})();
;
/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAggregatedPie', {
                parent: 'leadManagementAggregated',
                url: '/pie',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadManagementAggregated/pie/pie.html',
                controller: 'LeadManagementAggregatedPieController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadManagementAggregatedPieController', LeadManagementAggregatedPieController);

    LeadManagementAggregatedPieController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadManagementAggregatedPieController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.data1 = []; vm.data2 = []; vm.data3 = []; vm.data4 = [];
        var colors1 = [], colors2 = [], colors3 = [], colors4 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = ""; vm.sum2Label = ""; vm.sum3Label = ""; vm.sum4Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                getData();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                getData();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        getData();
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#pieChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις που κατέληξαν σε Εισαγωγή"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            o.success(vm.data1);
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "total",//"rrp",
                    categoryField: "label",//"monthyear",
                    name:"RRP"
                }]
            });

            $("#chart2").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ΔιαΖώσης"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            o.success(vm.data2);
                        }
                    }
                },
                seriesColors: colors2,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "total",//"rrp",
                    categoryField: "label",//"monthyear",
                    name:"RRP"
                }]
            });

            $("#chart3").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ανά Κύριο Τύπο Ασφάλισης"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            o.success(vm.data3);
                        }
                    }
                },
                seriesColors: colors3,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "total",//"rrp",
                    categoryField: "label",//"monthyear",
                    name:"RRP"
                }]
            });

            $("#chart4").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ΔιαΖώσης #2"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            o.success(vm.data4);
                        }
                    }
                },
                seriesColors: colors4,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "total",//"rrp",
                    categoryField: "label",//"monthyear",
                    name:"RRP"
                }]
            });
        }

        function getData(){
            vm.data1 = []; vm.data2 = []; vm.data3 = []; vm.data4 = [];
            vm.sumLabel = ""; vm.sum1Label = ""; vm.sum2Label = ""; vm.sum3Label = ""; vm.sum4Label = "";
            //colors1 = []; colors2 = []; colors3 = []; colors4 = [];
            $http.get("/api/lead-calls/analytics?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                .success(function (response) {
                    console.log(response);
                    if (response && response.length > 0){
                        // 1st Graph
                        if (response[0].total > 0 && response[1].total > 0){
                            vm.data1.push({
                                // Δεν κατέληξαν σε Εισαγωγή
                                label: "Δεν κατέληξαν σε Εισαγωγή - " + (((response[0].total - response[1].total) / response[0].total) * 100).toFixed(2) + "%",
                                total: response[0].total - response[1].total
                            });
                            colors1.push(CustomUtils.getRandomColor());
                            vm.data1.push({
                                // Ενημερώσεις που κατέληξαν σε Εισαγωγή
                                label: response[1].label + " - " + ((response[1].total / response[0].total) * 100).toFixed(2) + "%",
                                total: response[1].total
                            });
                            colors1.push(CustomUtils.getRandomColor());

                            vm.sumLabel = "Σύνολο Ενημερώσεων: " + response[0].total;
                            vm.sum1Label = "Σύνολο: " + response[0].total;
                        }

                        // 2nd Graph
                        if (response[0].total > 0 && response[response.length - 4].total > 0){
                            vm.data2.push({
                                // Υπόλοιπες Ενημερώσεις
                                label: "Τηλεφωνικές Ενημερώσεις - " + (((response[0].total - response[response.length - 4].total) / response[0].total) * 100).toFixed(2) + "%",
                                total: response[0].total - response[response.length - 4].total
                            });
                            colors2.push(CustomUtils.getRandomColor());
                            vm.data2.push({
                                // Ενημερώσεις που έγιναν διαζώσης
                                label: response[response.length - 4].label + " - " + ((response[response.length - 4].total / response[0].total) * 100).toFixed(2) + "%",
                                total: response[response.length - 4].total
                            });
                            colors2.push(CustomUtils.getRandomColor());

                            vm.sum2Label = "Σύνολο: " + response[0].total;
                        }

                        // 3rd Graph
                        var count = 0;
                        for (var i=2; i<=response.length - 5; i++){
                            // Calculate sum for setting percentage later below
                            count += response[i].total;
                        }
                        for (var j=2; j<=response.length - 5; j++){
                            vm.data3.push({
                                // Ενημερώσεις ΙΔΙΩΤΙΚΑ/../TAMEIO που κατέληξαν σε εισαγωγή
                                label: response[j].label + " - " + ((response[j].total / count) * 100).toFixed(2) + "%",
                                total: response[j].total
                            });
                            colors3.push(CustomUtils.getRandomColor());
                        }
                        count > 0 ? vm.sum3Label = "Σύνολο: " + count : vm.sum3Label = "";

                        // 4th Graph
                        if (response[0].total > 0 && response[response.length - 2].total > 0 &&
                            response[response.length - 3].total > 0){
                            vm.data4.push({
                                // Ενημερώσεις δια ζώσης που ΔΕΝ έγιναν εισαγωγή
                                label: response[response.length - 2].label + " - " +
                                        ((response[response.length - 2].total / (response[response.length - 2].total + response[response.length - 3].total)) * 100).toFixed(2) + "%",
                                total: response[response.length - 2].total
                            });
                            colors4.push(CustomUtils.getRandomColor());
                            vm.data4.push({
                                // Από τις διαζώσης πόσες έγιναν εισαγωγή
                                label: response[response.length - 3].label + " - " +
                                        ((response[response.length - 3].total / (response[response.length - 2].total + response[response.length - 3].total)) * 100).toFixed(2) + "%",
                                total: response[response.length - 3].total
                            });
                            colors4.push(CustomUtils.getRandomColor());

                            vm.sum4Label = "Σύνολο: " + (response[response.length - 2].total + response[response.length - 3].total);
                        }
                    }else {
                        vm.sumLabel = ""; vm.sum1Label = ""; vm.sum2Label = ""; vm.sum3Label = ""; vm.sum4Label = "";
                    }

                    $("#chart1").data("kendoChart").dataSource.read();
                    //$("#chart1").data("kendoChart").refresh();

                    $("#chart2").data("kendoChart").dataSource.read();
                    //$("#chart2").data("kendoChart").refresh();

                    $("#chart3").data("kendoChart").dataSource.read();
                    //$("#chart3").data("kendoChart").refresh();

                    $("#chart4").data("kendoChart").dataSource.read();
                    //$("#chart4").data("kendoChart").refresh();
                })
                .error(function (error) {
                    console.log(error);
                    vm.sumLabel = ""; vm.sum1Label = ""; vm.sum2Label = ""; vm.sum3Label = ""; vm.sum4Label = "";
                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 24/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAggregated', {
                    abstract: true,
                    parent: 'app',
                    url: '/leadManagement/aggregated',
                    data: {
                        authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                        pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/displays/adminIndex/leadManagementAggregated/leadManagementAggregated.html',
                            controller: 'LeadManagementAggregatedController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        search: null
                    },
                    resolve: {
                        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                            return {
                                search: $stateParams.search
                            };
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                })

    }

})();
;
/**
 * Created by Teo on 24/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadManagementAggregatedController', LeadManagementAggregatedController);

    LeadManagementAggregatedController.$inject = ['$state'];

    function LeadManagementAggregatedController ($state) {
        var vm = this;
        vm.$state = $state;
        vm.pageHeading = "Συνολα Lead Management";
    }
})();
;
/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAggregatedGrid', {
                parent: 'leadManagementAggregated',
                url: '',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadManagementAggregated/grid/grid.html',
                controller: 'LeadManagementAggregatedGridController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadManagementAggregatedGridController', LeadManagementAggregatedGridController);

    LeadManagementAggregatedGridController.$inject = ['$http', 'KendoGrid', 'CustomUtils', 'Alerts'];

    function LeadManagementAggregatedGridController ($http, KendoGrid, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.results = [];

        var dataSource = {};
        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                KendoGrid.refresh(vm.mainGridOptions);
                // This how you update grid title, but when export to excel, the title remains the same
                //vm.gridColumns[0].title = "Συγκεντρωτικά Lead Management για το έτος " + vm.year.value;
                //$("#mainGrid th[data-field=gridTitle]").contents().last().replaceWith("Συγκεντρωτικά Lead Management για το έτος " + vm.year.value);
            }
        };

        vm.gridColumns = [
            {
                //field: "gridTitle",
                //title: "Συγκεντρωτικά Lead Management για το έτος " + vm.year.value,
                columns: [
                    {
                        field: "label",
                        title: " ",
                        filterable: false
                    },
                    {
                        field: "total",
                        title: "Σύνολο",
                        filterable: false
                    },
                    {
                        field: "january",
                        title: "Ιανουάριος",
                        filterable: false
                    },
                    {
                        field: "february",
                        title: "Φεβρουάριος",
                        filterable: false
                    },
                    {
                        field: "march",
                        title: "Μάρτιος",
                        filterable: false
                    },
                    {
                        field: "april",
                        title: "Απρίλιος",
                        filterable: false
                    },
                    {
                        field: "may",
                        title: "Μάιος",
                        filterable: false
                    },
                    {
                        field: "june",
                        title: "Ιούνιος",
                        filterable: false
                    },
                    {
                        field: "july",
                        title: "Ιούλιος",
                        filterable: false
                    },
                    {
                        field: "august",
                        title: "Αύγουστος",
                        filterable: false
                    },
                    {
                        field: "september",
                        title: "Σεπτέμβριος",
                        filterable: false
                    },
                    {
                        field: "october",
                        title: "Οκτώβριος",
                        filterable: false
                    },
                    {
                        field: "november",
                        title: "Νοέμβριος",
                        filterable: false
                    },
                    {
                        field: "december",
                        title: "Δεκέμβριος",
                        filterable: false
                    }
                ]
            }
        ];
        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get("/api/lead-calls/analytics?year=" + vm.year.value)
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (error) {
                                console.log(error);
                                Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                            });
                    }
                },
                schema: {
                    /*parse: function(data) {
                        angular.forEach( data, function( item ) {
                            switch (item.label){
                                case "countLeadCalls":
                                    item.label = "Σύνολο Ενημερώσεων";
                                    break;
                                case "countLeadCallsWithHospitalization":
                                    item.label = "Ενημερώσεις που κατέληξαν σε Εισαγωγή";
                                    break;
                                case "countEopyyLeadCallsWithHospitalization":
                                    item.label = "Ενημερώσεις ΕΟΠΥΥ που κατέληξαν σε εισαγωγή";
                                    break;
                                case "countPrivateLeadCallsWithHospitalization":
                                    item.label = "Ενημερώσεις Ιδιωτικά που κατέληξαν σε εισαγωγή";
                                    break;
                                case "countInPersonLeadCalls":
                                    item.label = "Ενημερώσεις που έγιναν διαζώσης";
                                    break;
                                case "countInPersonLeadCallsWithHospitalization":
                                    item.label = "Από τις διαζώσης πόσες έγιναν εισαγωγή";
                                    break;
                                case "countInPersonLeadCallsWithoutHospitalization":
                                    item.label = "Ενημερώσεις δια ζώσης που ΔΕΝ έγιναν εισαγωγή";
                                    break;
                                case "countInPersonLeadCallsWithoutHospitalizationWithFollowupCall":
                                    item.label = "Ενημερώσεις δια ζώσης που ΔΕΝ έγιναν εισαγωγή και έγινε Follow UP";
                                    break;
                            }
                        });
                        return data;
                    },*/
                    model: {}
                }
            }),
            resizable: true,
            columns: vm.gridColumns,
            toolbar: [
                { name: "period", template: "<label style='padding-left: 5px;'>Έτος: </label><select id='year' name='year' class='inline' kendo-drop-down-list " +
                    "k-options='vm.yearsOptions' k-ng-model='vm.year' style='padding-left: 10px;'></select>" },
                { name: "excel", template: "<div class='right'><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Συγκεντρωτικά Lead Management_" + vm.year.value + ".xlsx"
            }
        };
    }
})();
;
/**
 * Created by Teo on 26/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadHospitalizationDiseasesAll', {
                parent: 'adminIndex',
                url: '/leadHospitalizationDiseases/all',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/leadHospitalizationDiseasesAll/leadHospitalizationDiseasesAll.html',
                        controller: 'LeadHospitalizationDiseasesAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "leadHospitalizations"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 26/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadHospitalizationDiseasesAllController', LeadHospitalizationDiseasesAllController);

    LeadHospitalizationDiseasesAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'favouriteFilters','KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'employee', 'CustomUtils'];

    function LeadHospitalizationDiseasesAllController ($scope, $filter, $http, $timeout, KendoFilter, favouriteFilters, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                          MasterToKendoFiltersService, employee, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Αναφορές Νοσηλειών";
        vm.contentWidth = CustomUtils.getWidthPixelsFromPercentage(84);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(51);
        vm.url = '/api/lead-calls/all';
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { hospitalizations: true/*, bookedAppointment: false */};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'leadHospitalizations';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        var booleanFilterTemplate = function (args) {
            KendoFilter.getBooleanTemplate(args);
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" },
                        { text: "Έτος", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "year" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' onkeydown='return false' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' onkeydown='return false' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Έγινε Εισαγωγή: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.hospitalizations'>" +
                    "<md-radio-button ng-value=false class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=true class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                // Remove bookedAppointment filter ECRM-337
                /*{type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Δια Ζώσης: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.bookedAppointment' ng-change='vm.onBookedAppointmentChange();'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Ημ/νία Ραντεβού:</label><label>Από: </label><input class='inline' kendo-date-picker id='from1' options='vm.fromOptions1' k-ng-model='vm.masterFilters.from1' ng-disabled='!vm.masterFilters.bookedAppointment'/>" +
                                                             "<label>Εώς: </label><input class='inline' kendo-date-picker id='to1' options='vm.toOptions1' k-ng-model='vm.masterFilters.to1' ng-disabled='!vm.masterFilters.bookedAppointment'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },*/
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        vm.fromOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from1 = value;
                } else {
                    vm.masterFilters.from1 = null;
                }
            }
        };

        vm.toOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to1 = value;
                } else {
                    vm.masterFilters.to1 = null;
                }
            }
        };

        // Not used
        vm.onBookedAppointmentChange = function () {
            if (vm.masterFilters.bookedAppointment === true){
                // do nothing
            }else {
                vm.masterFilters.from1 = "";
                vm.masterFilters.to1 = "";
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var grid = {};
        grid.columns = [
            {
               title: "Στοιχεία Νοσηλείας",
               columns: [
                   {
                       field: "possibleDischargeDate",
                       title: "Πιθανή Ημερ/νια Εξιτηρίου",
                       width: "110px",
                       template: "#= possibleDischargeDate ? kendo.toString(kendo.parseDate(possibleDischargeDate), 'dddd, dd/MM/yyyy') : ''#",
                       filterable: {
                           cell: {
                               operator: "eq",
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.surgeryType",
                       title: "Είδος Επέμβασης",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.addDiseaseOther",
                       title: "Άλλο Νόσημα",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.sector.name",
                       title: "Νοσοκοκείο",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.competitor.name",
                       title: "Άλλο Κ.Α.",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.hospitalizationType.name",
                       title: "Ασφάλιση",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   },
                   {
                       field: "leadHospitalization.clinicName.name",
                       title: "Κλινική",
                       width: "90px",
                       filterable: {
                           cell: {
                               operator: "startswith",
                               template: function (args) {
                                   KendoFilter.getTemplate(args);
                               },
                               showOperators: false
                           }
                       },
                       aggregates: ["count"],
                       groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                   }
               ]
            },
            {
                title: "Στοιχεία Πιθανού Ασθενή",
                columns: [
                    {
                        field: "leadHospitalization.leadCalls.prospectivePatient.firstName",
                        title: "Όνομα Πιθανού Ασθενή",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadHospitalization.leadCalls.prospectivePatient.lastName",
                        title: "Επώνυμο Πιθανού Ασθενή",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadHospitalization.leadCalls.prospectivePatient.age",
                        title: "Ηλικία",
                        width: "110px",
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                field: "disease.name",
                title: "Ασθένια",
                width: "90px",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "isClosedHospitalization",
                title: "Είδος Νοσηλείας",
                template: "#= (isClosedHospitalization == 'true') ? 'Ανοιχτή' : 'Κλειστή' #",
                width: "110px",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind: false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{text: "Ανοιχτή", value: "true"},
                                        {text: "Κλειστή", value: "false"}]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= (value == 'true') ? 'Είδος Νοσηλείας: Ανοιχτή' : (value == 'false') ? 'Είδος Νοσηλείας: Κλειστή' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "hadSurgery",
                title: "Χειρουργείο",
                template: "#= (hadSurgery == 'true') ? 'Ναι' : 'Όχι' #",
                width: "110px",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false,
                        template: booleanFilterTemplate
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= (value == 'true') ? 'Χειρουργείο: Ναι' : (value == 'false') ? 'Χειρουργείο: Όχι' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "isFollowingHospitalization",
                title: "Συνέχεια Νοσ.",
                template: "#= (isFollowingHospitalization == 'true') ? 'Ναι' : 'Όχι' #",
                width: "110px",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false,
                        template: booleanFilterTemplate
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= (value == 'true') ? 'Συνέχεια Νοσηλείας: Ναι' : (value == 'false') ? 'Συνέχεια Νοσηλείας: Όχι' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            }

        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                    o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                    /*angular.forEach( o.data.filter.filters, function(item) {
                        switch (item.field){
                            case "dateTime":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                                break;
                            case "nextFollowUpDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            case "leadHospitalizations.possibleDischargeDate":
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                                }
                                break;
                            default:
                                break;
                        }
                        // if ( item.value instanceof Date) {
                        //     item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        // }
                    });*/

                    $http.get('/api/lead-hospitalization-diseases/all', {params: o.data})
                        .success(function (response) {
                            console.log(response);
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data !== null && data !== undefined) {
                        data.forEach(function(item){
                            if (!item.leadHospitalization){
                                item.leadHospitalization = {
                                    sector: {},
                                    competitor: {},
                                    hospitalizationType: {},
                                    clinicName: {},
                                    leadCalls: {
                                        prospectivePatient: {},
                                        leadOffers: {},
                                        leadHospitalizations: {},
                                        callType: {}
                                    }
                                };
                            }else {
                                if (!item.leadHospitalization.sector) item.leadHospitalization.sector = {};
                                if (!item.leadHospitalization.competitor) item.leadHospitalization.competitor = {};
                                if (!item.leadHospitalization.hospitalizationType) item.leadHospitalization.hospitalizationType = {};
                                if (!item.leadHospitalization.clinicName) item.leadHospitalization.clinicName = {};
                                if (!item.leadHospitalization.leadCalls){
                                    item.leadHospitalization.leadCalls = {
                                        prospectivePatient: {},
                                        leadOffers: {},
                                        leadHospitalizations: {},
                                        callType: {}
                                    }
                                }else {
                                    if (!item.leadHospitalization.leadCalls.prospectivePatient) item.leadHospitalization.leadCalls.prospectivePatient = {};
                                    if (!item.leadHospitalization.leadCalls.leadOffers) item.leadHospitalization.leadCalls.leadOffers = {};
                                    if (!item.leadHospitalization.leadCalls.leadHospitalizations) item.leadHospitalization.leadCalls.leadHospitalizations = {};
                                    if (!item.leadHospitalization.leadCalls.callType) item.leadHospitalization.leadCalls.callType = {};
                                }
                            }
                        });
                    }
                    return data;
                },
                parse: function (data) {
                    angular.forEach(data, function (item) {
                        item.possibleDischargeDate = kendo.toString(kendo.parseDate(item.leadHospitalization.possibleDischargeDate), 'dd/MM/yyyy');
                        item.diagnosisDate = kendo.toString(kendo.parseDate(item.leadHospitalization.diagnosisDate), 'dd/MM/yyyy');
                        item.isClosedHospitalization = item.leadHospitalization.isClosedHospitalization === true ? "true" : "false";
                        item.hadSurgery = item.leadHospitalization.hadSurgery === true ? "true" : "false";
                        item.isFollowingHospitalization = item.leadHospitalization.isFollowingHospitalization === true ? "true" : "false";
                    });
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: {editable: false, nullable: false},
                        diagnosisDate: { type: "date" },
                        possibleDischargeDate: { type: "date" },
                        "leadHospitalization.leadCalls.prospectivePatient.age": { type: "number" },
                    }
                }
            }
        });
        vm.mainGridOptions = {
            autoBind: false,
            dataSource: grid.dataSource,
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: grid.columns,
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αναφορές Κλήσεων.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };
    }
})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedPerUser', {
                parent: 'leadCallsAggregated',
                url: '/perUser',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/perUser/leadCallsAggregatedPerUser.html',
                controller: 'LeadCallsAggregatedPerUserController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedPerUserController', LeadCallsAggregatedPerUserController);

    LeadCallsAggregatedPerUserController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedPerUserController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.pageHeading = "Ενημερωσεις ανα Χρηστη";
        vm.data1 = []; vm.data2 = []; vm.data3 = [];
        var colors1 = [], colors2 = [], colors3 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = ""; vm.sum2Label = ""; vm.sum3Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                $('#chart2').data('kendoChart').dataSource.read();
                $('#chart3').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                $('#chart2').data('kendoChart').dataSource.read();
                $('#chart3').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#pieChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management ανά Χρήστη_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ανά Χρήστη"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/1/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });

            $("#chart2").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ΔιαΖώσης ανά Χρήστη"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum2Label = "";
                            $http.get("/api/lead-calls/analytics/2/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors2.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum2Label = "Σύνολο: " + count : vm.sum2Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum2Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors2,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });

            $("#chart3").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις που κατέληξαν σε Εισαγωγή ανά Χρήστη"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum3Label = "";
                            $http.get("/api/lead-calls/analytics/3/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors3.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum3Label = "Σύνολο: " + count : vm.sum3Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum3Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors3,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedPerParentHospitalizationType', {
                parent: 'leadCallsAggregated',
                url: '/perParentHospitalizationType',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/perParentHospitalizationType/leadCallsAggregatedPerParentHospitalizationType.html',
                controller: 'LeadCallsAggregatedPerParentHospitalizationTypeController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedPerParentHospitalizationTypeController', LeadCallsAggregatedPerParentHospitalizationTypeController);

    LeadCallsAggregatedPerParentHospitalizationTypeController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedPerParentHospitalizationTypeController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(47);
        vm.pageHeading = "Ενημερωσεις ανα Παθηση";
        vm.data1 = []; vm.data2 = []; vm.data3 = [];
        var colors1 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#barChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management ανά Πάθηση_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις που ΔΕΝ κατέληξαν σε Εισαγωγή ανά Είδος Ασφάλισης"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/4/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedPerDisease', {
                parent: 'leadCallsAggregated',
                url: '/perDisease',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/perDisease/leadCallsAggregatedPerDisease.html',
                controller: 'LeadCallsAggregatedPerDiseaseController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedPerDiseaseController', LeadCallsAggregatedPerDiseaseController);

    LeadCallsAggregatedPerDiseaseController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedPerDiseaseController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(47);
        vm.pageHeading = "Ενημερωσεις ανα Παθηση";
        vm.data1 = []; vm.data2 = []; vm.data3 = [];
        var colors1 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#barChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management ανά Πάθηση_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ανά Πάθηση"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/5/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }

                                        count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                        o.success(response);
                                    }else {
                                        // bind empty dummy array for updating categoryAxis
                                        vm.sum1Label = "";
                                        o.success([{
                                            columnName: "",
                                            percentage: 0,
                                            value: 0
                                        }]);
                                    }
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                valueAxis: {
                    max: 600,
                    line: {
                        visible: false
                    },
                    minorGridLines: {
                        visible: true
                    },
                    labels: {
                        rotation: "auto"
                    },
                    axisCrossingValue: 0
                },
                categoryAxis: {
                    majorGridLines: {
                        visible: true
                    }
                },
                seriesDefaults: {
                    type: "bar",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= value ? value : ''#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",
                    categoryField: "columnName"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedPerAgeGroup', {
                parent: 'leadCallsAggregated',
                url: '/perAgeGroup',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/perAgeGroup/leadCallsAggregatedPerAgeGroup.html',
                controller: 'LeadCallsAggregatedPerAgeGroupController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 10/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedPerAgeGroupController', LeadCallsAggregatedPerAgeGroupController);

    LeadCallsAggregatedPerAgeGroupController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedPerAgeGroupController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(47);
        vm.pageHeading = "Ενημερωσεις ανα Ηλικιακο Group";
        vm.data1 = [];
        var colors1 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#barChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management ανά Ηλικιακό Group_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις ανά Ηλικιακό Group"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/6/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregated', {
                abstract: true,
                parent: 'app',
                url: '/leadCalls/aggregated',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/leadCallsAggregated/leadCallsAggregated.html',
                        controller: 'LeadCallsAggregatedController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on Σεπ, 2018
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedController', LeadCallsAggregatedController);

    LeadCallsAggregatedController.$inject = ['$state'];

    function LeadCallsAggregatedController ($state) {
        var vm = this;
        vm.$state = $state;
        vm.pageHeading = "Συγκεντρωτικα Lead Management";
    }
})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedHeldFollowUpRejectionReasons', {
                parent: 'leadCallsAggregated',
                url: '/heldFollowUpRejectionReasons',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/heldFollowUpRejectionReasons/leadCallsAggregatedHeldFollowUpRejectionReasons.html',
                controller: 'LeadCallsAggregatedHeldFollowUpRejectionReasonsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedHeldFollowUpRejectionReasonsController', LeadCallsAggregatedHeldFollowUpRejectionReasonsController);

    LeadCallsAggregatedHeldFollowUpRejectionReasonsController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedHeldFollowUpRejectionReasonsController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(47);
        vm.pageHeading = "Ενημερωσεις ανα Παθηση";
        vm.data1 = []; vm.data2 = []; vm.data3 = [];
        var colors1 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#barChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management Λόγοι Απόρριψης_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Λόγοι Απόρριψης για Ενημερώσεις που ΔΕΝ κατέληξαν σε Εισαγωγή και έγινε FollowUp"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/8/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }

                                        count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                        o.success(response);
                                    }else {
                                        // bind empty dummy array for updating categoryAxis
                                        vm.sum1Label = "";
                                        o.success([{
                                            columnName: "",
                                            percentage: 0,
                                            value: 0
                                        }]);
                                    }
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                valueAxis: {
                    max: 100,
                    line: {
                        visible: false
                    },
                    minorGridLines: {
                        visible: true
                    },
                    labels: {
                        rotation: "auto"
                    },
                    axisCrossingValue: 0
                },
                categoryAxis: {
                    majorGridLines: {
                        visible: true
                    }
                },
                seriesDefaults: {
                    type: "bar",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= value ? value : ''#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",
                    categoryField: "columnName"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedHeldFollowUp', {
                parent: 'leadCallsAggregated',
                url: '/heldFollowUp',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/heldFollowUp/leadCallsAggregatedHeldFollowUp.html',
                controller: 'LeadCallsAggregatedHeldFollowUpController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallsAggregatedHeldFollowUpController', LeadCallsAggregatedHeldFollowUpController);

    LeadCallsAggregatedHeldFollowUpController.$inject = ['$http', 'CustomUtils', 'Alerts'];

    function LeadCallsAggregatedHeldFollowUpController ($http, CustomUtils, Alerts) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(47);
        vm.data1 = []; vm.data2 = []; vm.data3 = [];
        var colors1 = [];
        var dataSource = {};
        var allMonths = CustomUtils.getMonths(false);
        vm.sumLabel = ""; vm.sum1Label = "";
        vm.selectedLabelMonths = []; // Holds month labels for chips

        dataSource.yearsData = CustomUtils.getYears(2017, true);
        vm.year = dataSource.yearsData[0];
        vm.yearsOptions = {
            dataSource: {
                data: dataSource.yearsData
            },
            dataTextField: "value",
            dataValueField: "value",
            change: function() {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος",
            change: function (e) {
                $('#chart1').data('kendoChart').dataSource.read();
                monthsIndexToLabels();
            }
        };

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        monthsIndexToLabels();

        vm.exportPDF = function () {
            console.log("export");
            kendo.drawing.drawDOM($("#barChartsContainer"), {
                paperSize: "auto",//"A3",
                landscape: true
                // margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
                //template: $("#page-template").html()
            })
                .then(function (group) {
                    return kendo.drawing.exportPDF(group);
                })
                .done(function (data) {
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "Συγκεντρωτικά Lead Management Δεν κατέλξαν σε Εισαγωγή_" + vm.year.value + ".pdf"
                    });
                });
        };

        function createCharts() {
            $("#chart1").kendoChart({
                title: {
                    position: "top",
                    text: "Ενημερώσεις που ΔΕΝ κατέληξαν σε Εισαγωγή με Ολοκληρωμένο / Μή Ολοκληρωμένο FollowUp"
                },
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.sum1Label = "";
                            $http.get("/api/lead-calls/analytics/7/?year=" + vm.year.value + "&months=" + vm.selectedMonths)
                                .success(function (response) {
                                    var count = 0;
                                    if (response && response.length > 0){
                                        for (var i=0; i < response.length; i++){
                                            response[i].columnName = response[i].columnName + " - " + (response[i].percentage).toFixed(2) + "%";
                                            colors1.push(CustomUtils.getRandomColor());
                                            count += response[i].value;
                                        }
                                    }
                                    count > 0 ? vm.sum1Label = "Σύνολο: " + count : vm.sum1Label = "";
                                    o.success(response);
                                })
                                .error(function (error) {
                                    console.log(response);
                                    vm.sum1Label = "";
                                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                                });
                        }
                    }
                },
                seriesColors: colors1,
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "pie",
                    labels: {
                        visible: true,
                        background: "transparent",
                        template: "#= category #: \n #= value#"
                    }
                },
                tooltip: {
                    visible: true,
                    format: "{0}"
                },
                series: [{
                    field: "value",//"rrp",
                    categoryField: "columnName",//"monthyear",
                    name:"RRP"
                }]
            });
        }

        function monthsIndexToLabels() {
            if (vm.selectedMonths.length === 0){
                vm.selectedLabelMonths = ["Όλος ο χρόνος"];
                vm.selectedLabelMonths.push("#" + vm.year.value)
            }else {
                vm.selectedLabelMonths = ["#" + vm.year.value];
                angular.forEach(vm.selectedMonths, function (value, key) {
                    vm.selectedLabelMonths.push(allMonths[value - 1].value);
                });
            }
        }
    }
})();
;
/**
 * Created by Kristy on 19/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsReport', {
                parent: 'adminIndex',
                url: '/hospitalizations/report',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsReport/hospitalizationsReport.html',
                        controller: 'HospitalizationsReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 19/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsReportController', HospitalizationsReportController);

    HospitalizationsReportController.$inject = ['$filter','$http', 'KendoFilter'];

    function HospitalizationsReportController ($filter, $http, KendoFilter) {
        var vm = this;

        vm.pageHeading = $filter('translate')('sigmasfApp.hospitalization.report.title');
        vm.url = '/api/hospitalizations/analytics';

        var dataSource = {};
        vm.period = {};

        vm.filterGrid = function() {
            if (vm.period) {
                var filter = {};
                switch (vm.period.id) {
                    case 2:
                        filter = {
                            logic: "and",
                            filters: [
                                {field: "total", operator: "gte", value: 3},
                                {field: "total", operator: "lte", value: 9}
                            ]
                        };
                        break;
                    case 3:
                        filter = {
                            field: "total", operator: "gte", value: 10
                        };
                }
                vm.mainGridOptions.dataSource.filter(filter);
            }
        };

        //Period dropdown edit configuration
        dataSource.periodData = [
            {id: 1, name: $filter('translate')('sigmasfApp.hospitalization.report.all')},
            {id: 2, name: "3-9"}, {id: 3, name: ">=10"}];

        vm.periodOptions = {
            dataSource: {
                data: dataSource.periodData
            },
            dataTextField: "name",
            dataValueField: "id",
            change: function() {
                vm.filterGrid()
            }
        };

        var date = new Date();
        date.setDate(1); // going to 1st of the month
        date.setHours(-1); // going to last hour before this date even started.

        vm.gridColumns = [
            {
                title: "ΣΥΝΟΛΟ ΑΞΙΟΛΟΓΗΣΕΩΝ ΕΩΣ " + kendo.toString(date, 'dd-MM-yyyy'),
                columns: [
                    {
                        field: "customer",
                        title: "Επαγγελματίας Υγείας",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        width: 200
                    },
                    {
                        field: "specialty",
                        title: "Ειδικότητα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "sector",
                        title: "Προέλευση",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        width: 200
                    },
                    {
                        field: "total",
                        title: "Σύνολο",
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        attributes:{class:"numbers"}
                    }
                ]
            }
        ];

        var year = new Date();
        year.setFullYear(2011);
        var years = "";
        while ( year.getFullYear() <= new Date().getFullYear()) {
            years += year.getFullYear();
            if(year.getFullYear() !== new Date().getFullYear()) years += ",";
            vm.gridColumns[0].columns.push({
                field: "count" + year.getFullYear().toString(),
                title: year.getFullYear().toString(),
                filterable: {
                    cell: {
                        operator: "eq",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                attributes:{class:"numbers"}
            });
            year.setFullYear(year.getFullYear() + 1);
        }

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.years = years;
                        o.data.stopAtPreviousMonth = true;
                        $http.get(vm.url, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function(data) {
                        var modifiedData = [];
                        angular.forEach( data, function( item ) {
                            var found = $filter('filter')(modifiedData, {customerId: item.customerId}, true);
                            if (found.length) {
                                modifiedData[modifiedData.indexOf(found[0])].total += item.count;
                                if (modifiedData[modifiedData.indexOf(found[0])]["count" + item.year]) {
                                    modifiedData[modifiedData.indexOf(found[0])]["count" + item.year] += item.count;
                                } else {
                                    modifiedData[modifiedData.indexOf(found[0])]["count" + item.year] = item.count
                                }
                            } else {
                                item.total = item.count;
                                item["count" + item.year] =  item.count;
                                modifiedData.push(item);
                            }
                        });
                        return modifiedData;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: "id"
                        }
                    }
                }
            }),
            sortable: {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            },
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            toolbar: [
                { name: "period", template: "<label>Σύνολο αξιολογήσεων: </label><select id='period' name='period' class='inline' kendo-drop-down-list " +
                    "k-options='vm.periodOptions' k-ng-model='vm.period'></select>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Σύνολο Αξιολογήσεων ανά Επαγγελματία Υγείας ανά έτος.xlsx"
            }
        };
    }
})();
;
/**
 * Created by Kristy on 21/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsComparisonReport', {
                parent: 'adminIndex',
                url: '/hospitalizations/comparisonReport',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsComparisonReport/hospitalizationsComparisonReport.html',
                        controller: 'HospitalizationsComparisonReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 21/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsComparisonReportController', HospitalizationsComparisonReportController);

    HospitalizationsComparisonReportController.$inject = ['$filter','$http', '$timeout', 'KendoFilter', 'KendoGrid'];

    function HospitalizationsComparisonReportController ($filter, $http, $timeout, KendoFilter, KendoGrid) {
        var vm = this;
        console.log(new Date());
        vm.pageHeading = $filter('translate')('sigmasfApp.hospitalization.comparisonReport.title');
        vm.url = '/api/hospitalizations/analytics/comparison';
        vm.period = {};
        var dataSource = {};
        vm.date = new Date();
        vm.date.setMonth(vm.date.getMonth() - 1);
        var month = new Date().getMonth();
        if (month === 0) {
            month = 12
        }

        var today = new Date();
        today.setMonth(today.getMonth() - 1);
        var lastYear = today.getFullYear() - 1;
        var currentYear = today.getFullYear();

        var getMonthlyFilter = function () {
            return {
                analyticsType: "clinics",
                period1: lastYear + "," + month,
                period2: currentYear + "," + month
            }
        };
        var monthly = getMonthlyFilter();

        vm.monthOptions = {
            start: "year",
            depth: "year",
            format: "MMMM",
            change: function () {
                vm.period = { id: 1 };
                month = this.value().getMonth() + 1;
                monthly = getMonthlyFilter();
                vm.filterGrid()
            }
        };

        vm.periodFilter = monthly;

        vm.filterGrid = function() {
            if (vm.period) {
                vm.periodFilter = {};
                var gridElement = angular.element("#mainGrid").data("kendoGrid");
                switch (vm.period.id) {
                    case 1:
                        vm.periodFilter = monthly;
                        grid.columns[0].title = kendo.toString(vm.date, "MMMM");
                        gridElement.setOptions({
                            columns: grid.columns
                        });
                        break;
                    case 2:
                        vm.periodFilter = {
                            analyticsType: "clinics",
                            period1: lastYear + ",Q1",
                            period2: currentYear + ",Q1"
                        };
                        grid.columns[0].title =
                            $filter('translate')('sigmasfApp.hospitalization.comparisonReport.Quarter');
                        gridElement.setOptions({
                            columns: grid.columns
                        });
                        break;
                    case 3:
                        vm.periodFilter = {
                            analyticsType: "clinics",
                            period1: lastYear + ",S1",
                            period2: currentYear + ",S1"
                        };
                        grid.columns[0].title =
                            $filter('translate')('sigmasfApp.hospitalization.comparisonReport.Semester');
                        gridElement.setOptions({
                            columns: grid.columns
                        });
                        break;
                    case 4:
                        vm.periodFilter = {
                            analyticsType: "clinics",
                            period1: lastYear + ",N",
                            period2: currentYear + ",N"
                        };
                        grid.columns[0].title =
                            $filter('translate')('sigmasfApp.hospitalization.comparisonReport.Nine Months');
                        gridElement.setOptions({
                            columns: grid.columns
                        });
                        break;
                    case 5:
                        vm.periodFilter = {
                            analyticsType: "clinics",
                            period1: lastYear,
                            period2: currentYear
                        };
                        grid.columns[0].title =
                            $filter('translate')('sigmasfApp.hospitalization.comparisonReport.year');
                        gridElement.setOptions({
                            columns: grid.columns
                        });
                        break;
                }
                KendoGrid.refresh(vm.mainGridOptions);
            }
        };

        //Period dropdown edit configuration
        dataSource.periodData = [
            {id: 1, name: $filter('translate')('sigmasfApp.hospitalization.comparisonReport.monthly')},
            {id: 2, name: $filter('translate')('sigmasfApp.hospitalization.comparisonReport.3months')},
            {id: 3, name: $filter('translate')('sigmasfApp.hospitalization.comparisonReport.6months')},
            {id: 4, name: $filter('translate')('sigmasfApp.hospitalization.comparisonReport.9months')},
            {id: 5, name: $filter('translate')('sigmasfApp.hospitalization.comparisonReport.year')}
        ];
        vm.periodOptions = {
            dataSource: {
                data: dataSource.periodData
            },
            dataTextField: "name",
            dataValueField: "id",
            change: function() {
                var value = this.value();
                vm.date = null;
                if (value === '1') {
                    vm.date = new Date();
                    vm.date.setMonth(vm.date.getMonth() - 1);
                    month = vm.date.getMonth() + 1;
                    monthly = getMonthlyFilter();
                }
                vm.filterGrid();
            }
        };

        var computePercentage = function (dataItem) {
            var value  = dataItem.difference.sum / (dataItem.count1.sum !== 0 ? dataItem.count1.sum : 1) * 100;
            return Math.round(value);
        };

        var grid = {};
        grid.columns = [
            {
                title: kendo.toString(vm.date, "MMMM"),
                columns: [
                    {
                        field: "sector",
                        title: "Νοσοκομείο",
                        filterable: {
                            cell: {
                                operator: "contains",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "clinic",
                        title: "Κλινική",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        groupFooterTemplate: "ΣΥΝΟΛΟ",
                        footerTemplate: "ΣΥΝΟΛΟ ΑΞΙΟΛΟΓΗΣΕΩΝ"
                    },
                    {
                        field: "count1",
                        title: lastYear.toString(),
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        attributes: {class: "numbers"},
                        groupFooterTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>",
                        footerTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>"
                    },
                    {
                        field: "count2",
                        title: currentYear.toString(),
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        attributes: {class: "numbers"},
                        groupFooterTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>",
                        footerTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>"
                    },
                    {
                        field: "difference",
                        title: "Διαφορά",
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        attributes: {class: "numbers"},
                        groupFooterTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>",
                        footerTemplate: "<div class='numbers'>#=sum ? sum : 0#</div>"
                    },
                    {
                        field: "percentage",
                        template: "#=percentage + '%'#",
                        title: "Ποσοστό",
                        filterable: {
                            cell: {
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        attributes: {class: "numbers"},
                        groupFooterTemplate: function(dataItem) { return '<div class="numbers">' + computePercentage(dataItem) + '%</div>' },
                        footerTemplate: function(dataItem) { return '<div class="numbers">' + computePercentage(dataItem) + '%</div>' }
                    }
                ]
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = { filters: [] };
                    }
                    angular.extend(o.data, vm.periodFilter);

                    $http.get(vm.url, {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                model: {
                    id: "id",
                    fields: {
                        id: "id"
                    }
                }
            },
            group: {
                field: "sector", aggregates: [
                    { field: "count1", aggregate: "sum" },
                    { field: "count2", aggregate: "sum"},
                    { field: "difference", aggregate: "sum" },
                    { field: "percentage", aggregate: "sum" }
                ]
            },
            aggregate: [
                { field: "count1", aggregate: "sum" },
                { field: "count2", aggregate: "sum" },
                { field: "difference", aggregate: "sum" },
                { field: "percentage", aggregate: "sum" }
            ]
        });

        vm.mainGridOptions = {
            dataSource: grid.dataSource,
            sortable: {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            },
            filterable: {
                mode: "row"
            },
            groupable: true,
            columns: grid.columns,
            toolbar: [
                { name: "period", template: "<label>Χρονικό Διάστημα: </label><select id='period' name='period' class='inline' kendo-drop-down-list " +
                    "k-options='vm.periodOptions' k-ng-model='vm.period'></select>" },
                { name: "month", template: "<input kendo-date-picker ng-show='vm.date' k-ng-model='vm.date' k-options='vm.monthOptions'/>"},
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Σύγκριση Αξιολογήσεων ανά Κλινική.xlsx"
            },
            excelExport: function(e) {
                //Remove html tags from excel workbook
                var rows = e.workbook.sheets[0].rows;

                for (var ri = 0; ri < rows.length; ri++) {
                    var row = rows[ri];
                    if (row.type === "group-footer" || row.type === "footer") {
                        for (var ci = 0; ci < row.cells.length; ci++) {
                            var cell = row.cells[ci];
                            if (cell.value) {
                                if (angular.element(cell.value).text()) {
                                    cell.value = angular.element(cell.value).text();
                                    // Set the alignment
                                    cell.hAlign = "right";
                                } else {
                                    cell.value = angular.element(cell.value).selector;
                                }
                            }
                        }
                    }
                }
            }
        };
    }
})();
;
/**
 * Created by Kristy on 22/3/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAll', {
                parent: 'adminIndex',
                url: '/hospitalizations/all',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsAll/hospitalizationsAll.html',
                        controller: 'HospitalizationsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "hospitalizations"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 22/3/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsAllController', HospitalizationsAllController);

    HospitalizationsAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'favouriteFilters','KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'CustomDateUtils', 'CustomDataUtils', 'employee'];
    function HospitalizationsAllController ($scope, $filter, $http, $timeout, KendoFilter, favouriteFilters, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                            MasterToKendoFiltersService, CustomDateUtils, CustomDataUtils, employee) {
        var vm = this;
        vm.pageHeading = $filter('translate')('sigmasfApp.hospitalization.hospitalizationsAll.title');
        vm.url = '/api/hospitalizations/analytics/comparison';
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = {};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.exportOnlyTotals = true;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'hospitalizations';


        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        vm.toolbarOptions = {
            items: KendoToolbar.getOptions(["buttonGroup", "year", "masterFilterFrom", "masterFilterTo", "search"], vm)
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var grid = {};
        grid.columns = [
            {
                field: "patient.lastName",
                title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "patient.firstName",
                title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            /*{
                field: "customer.lastName",
                title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                }
            },
            {
                field: "customer.firstName",
                title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                }
            },*/
            {
                field: "sector.name",
                title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "sector.sectorType.name",
                title: "Τύπος Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "customer.customerTitle.name",
                title: "Τύπος Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "clinicName.name",
                title: "Κλινική",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "roomType.name",
                title: "Επιθυμητός Τύπος Δωματίου",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "finalRoomType.name",
                title: "Τελική Τοποθέτηση",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "hospitalizationType.name",
                title: "Παρατηρήσεις",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            /*{
                field: "notes",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: filterTemplate,
                        showOperators: false
                    }
                }
            },*/
            {field: "dateIssue", title: "Ημερομηνία Εισαγωγής", template: "#= dateIssue ? kendo.toString(kendo.parseDate(dateIssue), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "month", title: "Μήνας",
                filterable: false,
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "customerFullName", title: "Επαγγελματίας Υγείας",
                filterable: false,
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            },
            {
                field: "customer.doctorSpecialty.name", title: "Ειδικότητα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: filterTemplate,
                        showOperators: false
                    }
                },
                aggregates: ["count"],
                groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                    o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/hospitalizations/all', {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    data.forEach(function(item){
                        if (!item.sector) item.sector = {};
                        if (!item.sector.sectorType) item.sector.sectorType = {};
                        if (!item.clinicName) item.clinicName = {};
                        if (!item.roomType) item.roomType = {};
                        if (!item.finalRoomType) item.finalRoomType = {};
                        if (!item.hospitalizationType) item.hospitalizationType = {};
                        if (!item.patient) item.patient = {};
                        if (!item.customer) item.customer = { customerTitle: {} };
                        if (!item.customer.customerTitle) item.customer.customerTitle = {};
                        if (!item.customer.doctorSpecialty) item.customer.doctorSpecialty = {};
                    });
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: {editable: false, nullable: false},
                        dateIssue: { type: "date" }
                    }
                }
            }
        });
        vm.mainGridOptions = {
            autoBind: false,
            dataSource: grid.dataSource,
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: grid.columns,
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                {
                    name: "onlyTotals", template: "<div style='float: right; margin-right: 10px;'><md-switch class='md-primary' style='top: 0' ng-model='vm.exportOnlyTotals'><label>Εξαγωγή μόνο σύνολα</label></md-switch></div>"
                },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Ευρετήριο Εισαγωγών.xlsx"
            },
            dataBound: function (e) {
                vm.masterFiltersEdited();
                var data = e.sender.dataSource.data();
                if (data !== null && data !== undefined){
                    angular.forEach(data, function (item) {
                        if (item.dateIssue){
                            var monthIndex = item.dateIssue.getMonth() + 1;
                            item.month = (monthIndex > 9 ? monthIndex : '0' + monthIndex) + '. ' + CustomDateUtils.numberToMonth(item.dateIssue.getMonth());
                        }else {
                            item.month = '';
                        }

                        if (item.customer){
                            item.customerFullName = item.customer.lastName + " " + item.customer.firstName;
                        }else {
                            item.customerFullName = "";
                        }
                    });
                }
            },
            excelExport: function (e) {
                if (vm.exportOnlyTotals){
                    var result = CustomDataUtils.arrayRemove(e.workbook.sheets[0].rows, 'data'); // remove data
                    result[0].cells = []; // remove columns from header
                    for (var i=0; i<result.length; i++){
                        if (result[i].type === 'group-header'){
                            var val = result[i].cells[result[i].cells.length - 1].value;
                            var _val = angular.copy(val);

                            // push a new cell only with the value
                            result[i].cells.push({
                                value: CustomDataUtils.getValueFromHeaderLabel(String(val)),
                                background: "#dfdfdf",
                                color: "#333",
                                colSpan: 1
                            });

                            // Keep only month in header labels
                            result[i].cells[result[i].cells.length - 2].value = CustomDataUtils.removeTotalsFromHeaderLabel(String(_val));
                        }
                    }
                    e.workbook.sheets[0].rows = angular.copy(result);
                }
            }
        };
    }
})();
;
/**
 * Created by Teo on 28/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregatedPerSector', {
                parent: 'hospitalizationsAggregated',
                url: '/perSector',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated Per Sector'
                },
                templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/perSector/hospitalizationsAggregatedPerSector.html',
                controller: 'HospitalizationsAggregatedPerSectorController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 28/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsAggregatedPerSectorController', HospitalizationsAggregatedPerSectorController);

    HospitalizationsAggregatedPerSectorController.$inject = ['$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout'];

    function HospitalizationsAggregatedPerSectorController ($http, KendoGrid, CustomUtils, Alerts, $timeout) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);
        vm.sumLabel = "";
        vm.showProgress = false;

        var allYears = CustomUtils.getYears(2016, true);
        vm.selectedYears = [allYears[0]];
        vm.yearsOptions = {
            dataSource: {
                data: allYears
            },
            dataTextField: "value",
            dataValueField: "value",
            maxSelectedItems: 2
        };

        var allMonths = CustomUtils.getMonths(false);
        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος"
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            if (vm.selectedYears.length < 1){
                Alerts.showAlert("Sigma SalesForce", "Επιλέξτε ένα ή δύο έτη", "ΟΚ");
            }else {
                $("#mainGrid").data().kendoGrid.destroy();
                $("#mainGrid").empty();
                vm.showProgress = true;
                $http.get("/api/hospitalizations/totals?type=sectors&years=" + yearObjectsToArray(vm.selectedYears) + "&months=" + vm.selectedMonths)
                    .success(function (response) {
                        vm.showProgress = false;
                        generateGrid(response);
                    })
                    .error(function (error) {
                        vm.showProgress = false;
                        console.log(error);
                        Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                    });
            }
        };

        function generateGrid(response){
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    }
                },
                columns: generateColumns(response),
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                },
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Εισαγωγών ανά Νοσοκομείο.xlsx"
                }
            });
            vm.sumLabel = "Σύνολο: " + response.length;
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "label",
                title: "'Ονομα Κλινικής",
                width: 140
            });
            for (var i=0; i<response[0].results.length; i++){
                columns.push({
                    field: "results[" + i + "].value",
                    title: response[0].results[i].key,
                    width: 95
                })
            }
            return columns;
        }

        function yearObjectsToArray(selectedYears){
            var arr = [];
            angular.forEach(selectedYears, function (yearObject) {
                arr.push(yearObject.value);
            });
            return arr;
        }

        $(window).on("resize", function() {
            console.log("resize");
            kendo.resize($("#mainGrid"));
        });
    }
})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregatedPerDoctor', {
                parent: 'hospitalizationsAggregated',
                url: '/perDoctor',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated Per Doctor'
                },
                templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/perDoctor/hospitalizationsAggregatedPerDoctor.html',
                controller: 'HospitalizationsAggregatedPerDoctorController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsAggregatedPerDoctorController', HospitalizationsAggregatedPerDoctorController);

    HospitalizationsAggregatedPerDoctorController.$inject = ['$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout'];

    function HospitalizationsAggregatedPerDoctorController ($http, KendoGrid, CustomUtils, Alerts, $timeout) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);
        vm.sumLabel = "";
        vm.showProgress = false;

        var allYears = CustomUtils.getYears(2016, true);
        vm.selectedYears = [allYears[0]];
        vm.yearsOptions = {
            dataSource: {
                data: allYears
            },
            dataTextField: "value",
            dataValueField: "value",
            maxSelectedItems: 2
        };

        var allMonths = CustomUtils.getMonths(false);
        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος"
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            if (vm.selectedYears.length < 1){
                Alerts.showAlert("Sigma SalesForce", "Επιλέξτε ένα ή δύο έτη", "ΟΚ");
            }else {
                $("#mainGrid").data().kendoGrid.destroy();
                $("#mainGrid").empty();
                vm.showProgress = true;
                $http.get("/api/hospitalizations/totals?type=doctors&years=" + yearObjectsToArray(vm.selectedYears) + "&months=" + vm.selectedMonths)
                    .success(function (response) {
                        vm.showProgress = false;
                        generateGrid(response);
                    })
                    .error(function (error) {
                        vm.showProgress = false;
                        console.log(error);
                        Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε", "ΟΚ");
                    });
            }
        };

        function generateGrid(response){
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    }
                },
                columns: generateColumns(response),
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                },
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Εισαγωγών ανά Επαγγελματία Υγείας.xlsx"
                }
            });
            vm.sumLabel = "Σύνολο: " + response.length;
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "label",
                title: "'Ονομα Κλινικής",
                width: 140
            });
            for (var i=0; i<response[0].results.length; i++){
                columns.push({
                    field: "results[" + i + "].value",
                    title: response[0].results[i].key,
                    width: 95
                })
            }
            return columns;
        }

        function yearObjectsToArray(selectedYears){
            var arr = [];
            angular.forEach(selectedYears, function (yearObject) {
                arr.push(yearObject.value);
            });
            return arr;
        }

        $(window).on("resize", function() {
            console.log("resize");
            kendo.resize($("#mainGrid"));
        });
    }
})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregatedPerClinic', {
                parent: 'hospitalizationsAggregated',
                url: '/perClinic',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated Per Clinic'
                },
                templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/perClinic/hospitalizationsAggregatedPerClinic.html',
                controller: 'HospitalizationsAggregatedPerClinicController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsAggregatedPerClinicController', HospitalizationsAggregatedPerClinicController);

    HospitalizationsAggregatedPerClinicController.$inject = ['$http', 'KendoGrid', 'CustomUtils', 'Alerts', '$timeout'];

    function HospitalizationsAggregatedPerClinicController ($http, KendoGrid, CustomUtils, Alerts, $timeout) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);
        vm.sumLabel = "";
        vm.showProgress = false;

        var allYears = CustomUtils.getYears(2016, true);
        vm.selectedYears = [allYears[0]];
        vm.yearsOptions = {
            dataSource: {
                data: allYears
            },
            dataTextField: "value",
            dataValueField: "value",
            maxSelectedItems: 2
        };

        var allMonths = CustomUtils.getMonths(false);
        vm.selectedMonths = [];
        vm.monthsOptions = {
            dataSource: {
                data: allMonths
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "value",
            dataValueField: "id",
            placeholder: "Όλος ο χρόνος"
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.getData = function () {
            if (vm.selectedYears.length < 1){
                Alerts.showAlert("Sigma SalesForce", "Επιλέξτε ένα ή δύο έτη", "ΟΚ");
            }else {
                $("#mainGrid").data().kendoGrid.destroy();
                $("#mainGrid").empty();
                vm.showProgress = true;
                $http.get("/api/hospitalizations/totals?type=clinics&years=" + yearObjectsToArray(vm.selectedYears) + "&months=" + vm.selectedMonths)
                    .success(function (response) {
                        vm.showProgress = false;
                        generateGrid(response);
                    })
                    .error(function (error) {
                        vm.showProgress = false;
                        console.log(error);
                        Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                    });
            }
        };

        function generateGrid(response){
            $("#mainGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    }
                },
                columns: generateColumns(response),
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                },
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Εισαγωγών ανά Κλινική.xlsx"
                }
            });
            vm.sumLabel = "Σύνολο: " + response.length;
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "label",
                title: "'Ονομα Κλινικής",
                width: 140
            });
            for (var i=0; i<response[0].results.length; i++){
                columns.push({
                    field: "results[" + i + "].value",
                    title: response[0].results[i].key,
                    width: 95
                })
            }
            return columns;
        }

        function yearObjectsToArray(selectedYears){
            var arr = [];
            angular.forEach(selectedYears, function (yearObject) {
                 arr.push(yearObject.value);
            });
            return arr;
        }

        $(window).on("resize", function() {
            console.log("resize");
            kendo.resize($("#mainGrid"));
        });
    }
})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregated', {
                abstract: true,
                parent: 'app',
                url: '/hospitalizations/aggregated',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/hospitalizationsAggregated.html',
                        controller: 'HospitalizationsAggregatedController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 26/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationsAggregatedController', HospitalizationsAggregatedController);

    HospitalizationsAggregatedController.$inject = ['$state'];

    function HospitalizationsAggregatedController ($state) {
        var vm = this;
        vm.$state = $state;
        vm.pageHeading = "Συνολα Εισαγωγων";
    }
})();
;
/**
 * Created by Teo on 25/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('followUpAll', {
                parent: 'adminIndex',
                url: '/followUp/all',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/followUpAll/followUpAll.html',
                        controller: 'FollowUpAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "followUp"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Teo on 25/07/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowUpAllController', FollowUpAllController);

    FollowUpAllController.$inject = ['$scope', '$filter','$http', '$timeout', 'KendoFilter', 'favouriteFilters','KendoToolbar', 'FavouriteFiltersService',
        'KendoGrid', 'MasterToKendoFiltersService', 'employee', 'CustomUtils'];

    function FollowUpAllController ($scope, $filter, $http, $timeout, KendoFilter, favouriteFilters, KendoToolbar, FavouriteFiltersService, KendoGrid,
                                          MasterToKendoFiltersService, employee, CustomUtils) {
        var vm = this;
        vm.pageHeading = "Αναφορές Follow Up";
        vm.contentWidth = CustomUtils.getWidthPixelsFromPercentage(84);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(51);
        console.log(vm.contentWidth);
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { hospitalizations: true/*, bookedAppointment: false */};

        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'followUp';

        var setView = function() {
            var filterable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            var sortable = vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            } : false;

            vm.disabled = !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: sortable,
                groupable: vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };
        $scope.$watchGroup(["vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        //Date Filter
        vm.masterFiltersOnClick = function(e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');
            if (e.id === "today") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            }
            else if (e.id === "week") {
                KendoToolbar.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6
                $timeout(function () {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id === "month") {
                KendoToolbar.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $timeout(function () {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
            else if (e.id === "year") {
                KendoToolbar.clearDatePickers();
                $timeout(function () {
                    vm.masterFilters.from = new Date(date.getFullYear(), 0, 1);
                    vm.masterFilters.to = new Date();
                });
            }
        };

        var booleanFilterTemplate = function (args) {
            KendoFilter.getBooleanTemplate(args);
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" },
                        { text: "Έτος", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "year" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' onkeydown='return false' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' onkeydown='return false' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Έγινε Εισαγωγή: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.hospitalizations'>" +
                    "<md-radio-button ng-value=false class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=true class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                // Remove bookedAppointment filter ECRM-337
                /*{type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Δια Ζώσης: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.bookedAppointment' ng-change='vm.onBookedAppointmentChange();'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Ημ/νία Ραντεβού:</label><label>Από: </label><input class='inline' kendo-date-picker id='from1' onkeydown='return false' options='vm.fromOptions1' k-ng-model='vm.masterFilters.from1' ng-disabled='!vm.masterFilters.bookedAppointment'/>" +
                                                             "<label>Εώς: </label><input class='inline' kendo-date-picker id='to1' onkeydown='return false' options='vm.toOptions1' k-ng-model='vm.masterFilters.to1' ng-disabled='!vm.masterFilters.bookedAppointment'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },*/
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        vm.fromOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from1 = value;
                } else {
                    vm.masterFilters.from1 = null;
                }
            }
        };

        vm.toOptions1 = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to1 = value;
                } else {
                    vm.masterFilters.to1 = null;
                }
            }
        };

        // Not used
        vm.onBookedAppointmentChange = function () {
            if (vm.masterFilters.bookedAppointment === true){
                // do nothing
            }else {
                vm.masterFilters.from1 = "";
                vm.masterFilters.to1 = "";
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var grid = {};
        grid.columns = [
            {
                title: "Στοιχεία FollowUp",
                columns: [
                    {
                        field: "date",
                        title: "Ημερ/νία",
                        width: "110px",
                        template: "#= date ? kendo.toString(kendo.parseDate(date), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "followupType.name",
                        title: "Τύπος",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "completed",
                        title: "Ολοκληρωμένο",
                        template: "#= (completed == 'true') ? 'Ναι' : 'Όχι' #",
                        width: "100px",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false,
                                template: booleanFilterTemplate
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= (value == 'true') ? 'Ολοκληρωμένο: Ναι' : (value == 'false') ? 'Ολοκληρωμένο: Όχι' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "rejectionReason.name",
                        title: "Λόγος Απόρρ.",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "followupStatus.name",
                        title: "Κατάσταση",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "anotherRehubCenter.name",
                        title: "Ανταγων.",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Κλήσης",
                columns: [
                    {
                        field: "dateTime",
                        title: "Ημερ/νία",
                        width: "110px",
                        template: "#= dateTime ? kendo.toString(kendo.parseDate(dateTime), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.callType.name",
                        title: "Τύπος Κλήσης",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.leadOffers.offerStatus.name",
                        title: "Προσφορά",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Πιθανού Ασθενή",
                columns: [
                    {
                        field: "leadCall.prospectivePatient.firstName",
                        title: "Όνομα Πιθανού Ασθενή",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.prospectivePatient.lastName",
                        title: "Επώνυμο Πιθανού Ασθενή",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.prospectivePatient.phone",
                        title: "Τηλέφωνο Πιθανού Ασθενή",
                        width: "100px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.prospectivePatient.age",
                        title: "Ηλικία",
                        width: "70px",
                        filterable: {
                            cell: {
                                //operator: "startswithnum",
                                operator: "eq",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Νοσηλείας",
                columns: [
                    {
                        field: "leadCall.leadHospitalizations.hospitalizationType.name",
                        title: "Ασφάλιση",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.leadHospitalizations.sector.name",
                        title: "Νοσοκομείο",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.leadHospitalizations.clinicName.name",
                        title: "Κλινική",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "possibleDischargeDate",
                        title: "Πιθανή Ημερ/νια Εξιτηρίου",
                        width: "110px",
                        template: "#= possibleDischargeDate ? kendo.toString(kendo.parseDate(possibleDischargeDate), 'dddd, dd/MM/yyyy') : ''#",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            },
            {
                title: "Στοιχεία Συνοδού",
                columns: [
                    {
                        field: "leadCall.prospectivePatient.attendant.firstName",
                        title: "Όνομα Συνοδού",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.prospectivePatient.attendant.lastName",
                        title: "Επώνυμο Συνοδού",
                        width: "90px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    },
                    {
                        field: "leadCall.prospectivePatient.attendant.phone",
                        title: "Τηλέφωνο Συνοδού",
                        width: "100px",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        aggregates: ["count"],
                        groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                    }
                ]
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                    o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                    // angular.forEach( o.data.filter.filters, function(item) {
                    //     switch (item.field){
                    //         case "dateTime":
                    //             if (item.value instanceof Date) {
                    //                 item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                    //             }
                    //             break;
                    //         case "nextFollowUpDate":
                    //             if (item.value instanceof Date) {
                    //                 item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                    //             }
                    //             break;
                    //         case "leadHospitalizations.possibleDischargeDate":
                    //             if (item.value instanceof Date) {
                    //                 item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                    //             }
                    //             break;
                    //         default:
                    //             break;
                    //     }
                    //     // if ( item.value instanceof Date) {
                    //     //     item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                    //     // }
                    // });

                    $http.get('/api/followup-calls/all', {params: o.data})
                        .success(function (response) {
                            // console.log(response);
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data !== null && data !== undefined) {
                        data.forEach(function(item){
                            if (!item.leadCall) {
                                item.leadCall = {
                                    callType: {},
                                    prospectivePatient: {
                                        attendant: {}
                                    },
                                    oldPatient: {},
                                    oldPatientDoctor: {},
                                    leadOffers: {},
                                    offerStatus: {},
                                    leadHospitalizations: {
                                        hospitalizationType: {},
                                        sector: {},
                                        clinicName: {}
                                    }
                                };
                            }else {
                                if (!item.leadCall.callType) item.leadCall.callType = {};
                                if (!item.leadCall.prospectivePatient) {
                                    item.leadCall.prospectivePatient = {attendant: {}};
                                }else {
                                    if (!item.leadCall.prospectivePatient.attendant) item.leadCall.prospectivePatient.attendant = {}
                                }
                                if (!item.leadCall.oldPatient) item.leadCall.oldPatient = {};
                                if (!item.leadCall.oldPatientDoctor) item.leadCall.oldPatientDoctor = {};
                                if (!item.leadCall.leadOffers){
                                    item.leadCall.leadOffers = {offerStatus: {}};
                                }else {
                                    if (!item.leadCall.leadOffers.offerStatus) item.leadCall.leadOffers.offerStatus = {};
                                }
                                if (!item.leadCall.leadHospitalizations){
                                    item.leadCall.leadHospitalizations = {
                                        hospitalizationType: {},
                                        sector: {},
                                        clinicName: {}
                                    }
                                }else {
                                    if (!item.leadCall.leadHospitalizations.hospitalizationType) item.leadCall.leadHospitalizations.hospitalizationType = {};
                                    if (!item.leadCall.leadHospitalizations.sector) item.leadCall.leadHospitalizations.sector = {};
                                    if (!item.leadCall.leadHospitalizations.clinicName) item.leadCall.leadHospitalizations.clinicName = {};
                                }
                            }

                            if (!item.followupType) item.followupType = {name: "-"};
                            if (!item.rejectionReason) item.rejectionReason = {name: "-"};
                            if (!item.followupStatus) item.followupStatus = {name: "-"};
                            if (!item.anotherRehubCenter) item.anotherRehubCenter = {name: "-"};


                           /* if (!item.leadCall) item.leadCall = {};
                            if (item.leadCall && !item.leadCall.callType) item.leadCall.callType = {};
                            if (item.leadCall && !item.leadCall.prospectivePatient) item.leadCall.prospectivePatient = {};
                            if (item.leadCall && item.leadCall.prospectivePatient && !item.leadCall.prospectivePatient.attendant) item.prospectivePatient.attendant = {};
                            if (item.leadCall && !item.leadCall.oldPatient) item.leadCall.oldPatient = {};
                            if (item.leadCall && !item.leadCall.oldPatientDoctor) item.leadCall.oldPatientDoctor = {};
                            if (item.leadCall && !item.leadCall.leadOffers) item.leadCall.leadOffers = {};
                            if (item.leadCall && item.leadCall.leadOffers.offerStatus && !item.leadCall.leadOffers.offerStatus) item.leadCall.leadOffers.offerStatus = {};
                            if (item.leadCall && !item.leadCall.leadHospitalizations) item.leadCall.leadHospitalizations = {};
                            if (item.leadCall && item.leadCall.leadHospitalizations && !item.leadCall.leadHospitalizations.hospitalizationType) item.leadCall.leadHospitalizations.hospitalizationType = {};
                            if (item.leadCall && item.leadCall.leadHospitalizations && !item.leadCall.leadHospitalizations.sector) item.leadCall.leadHospitalizations.sector = {};
                            if (item.leadCall && item.leadCall.leadHospitalizations && !item.leadCall.leadHospitalizations.clinicName) item.leadCall.leadHospitalizations.clinicName = {};*/
                        });
                    }
                    return data;
                },
                parse: function (data) {
                    angular.forEach(data, function (item) {
                        item.completed = item.completed === true ? "true" : "false";
                        if (item.leadCall){
                            if (item.leadCall.leadHospitalizations){
                                item.possibleDischargeDate = kendo.toString(kendo.parseDate(item.leadCall.leadHospitalizations.possibleDischargeDate), 'dd/MM/yyyy');
                            }else {
                                item.possibleDischargeDate = "";
                            }
                            item.dateTime = kendo.toString(kendo.parseDate(item.leadCall.dateTime), 'dd/MM/yyyy');
                        }else {
                            item.possibleDischargeDate = "";
                            item.dateTime = "";
                        }

                        item.date = kendo.toString(kendo.parseDate(item.date), 'dd/MM/yyyy');
                    });
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: {editable: false, nullable: false},
                        dateTime: { type: "date" },
                        date: { type: "date" },
                        possibleDischargeDate: { type: "date" },
                        "leadCall.prospectivePatient.age": { type: "number" },
                        /*completed: {
                            type: "boolean",
                            defaultValue: false,
                            parse: function (value) {
                                return !!(value == "1" || value == "true" || value == true);
                            }
                        }*/
                    }
                }
            }
        });
        vm.mainGridOptions = {
            autoBind: false,
            scrollable: true,
            dataSource: grid.dataSource,
            //sortable: false,
            //groupable: false,
            resizable: true,
            //filterable: false,
            columns: grid.columns,
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αναφορές FollowUp.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('adminIndex', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEventsOther', {
                parent: 'adminIndex',
                url: '/events/other',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminEventsOther/adminEventsOther.html',
                        controller: 'adminEventsOtherController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "otherEvents"
                        }] } }} );
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('adminEventsOtherController', adminEventsOtherController);

    adminEventsOtherController.$inject = ['$scope', 'favouriteFilters', '$timeout', 'employee','$http', 'KendoService', 'KendoFilter', 'SupervisorsService', 'MasterFiltersService', 'FavouriteFiltersService', 'MasterToKendoFiltersService', 'customersView'];

    function adminEventsOtherController ($scope, favouriteFilters, $timeout, employee, $http, KendoService, KendoFilter, SupervisorsService, MasterFiltersService, FavouriteFiltersService, MasterToKendoFiltersService, customersView) {
        var vm = this;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.customerView = customersView.data.content[0].value;
        vm.employee = employee;
        SupervisorsService.setSelectedSupervisors([]);
        vm.masterFilters = { selectedSupervisors: SupervisorsService.getSelectedSupervisors(), selectedEmployees: [] };
        vm.pageHeading = 'Άλλα Συμβάντα';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'otherEvents';
        vm.exportFlag = false;

        var setView = function() {
            var filterable = vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedEmployees.length && !SupervisorsService.getSelectedSupervisors().length;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                groupable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                filterable: filterable
            });
        };

        $scope.$watch("vm.masterFilters.selectedSupervisors", function (value) {
            SupervisorsService.setSelectedSupervisors(value);
            setView();
            vm.employeesMulti.enable(!vm.masterFilters.selectedSupervisors.length);
        });
        $scope.$watch("vm.masterFilters.selectedEmployees", function () {
            setView();
            vm.supervisorsMulti.enable(!vm.masterFilters.selectedEmployees.length);
        });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.supervisorsMultiOptions = MasterFiltersService.getSupervisorsComboBoxOptions();
        vm.supervisorsMultiOptions.change = function () {
            vm.employeesMulti.value('');
            vm.employeesMultiOptions.dataSource.filter({});
            vm.masterFilters.selectedEmployees = [];
            vm.employeesMulti.dataSource.read();
        };
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        //refresh filters
        var masterFilters = [vm.employeesMultiOptions];
        angular.forEach(masterFilters, function(masterFilter) {
            masterFilter.dataSource.filter({});
        });

        //Date Filter

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {
                vm.clearDatePickers();
                $timeout(function() {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });

            }
            else if (e.id == "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function() {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });

            }
            else if (e.id == "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function() {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ],
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.supervisorsMulti' multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.masterFilters.selectedSupervisors'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label>" +
                        "<select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                        "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" },
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.searchEventsUrl = '/api/other-events/all';
                        if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                        $http.get(vm.searchEventsUrl, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            if (item.employee === null) item.employee = { account: {} };

                            if(item.eventCategoryType === null){
                                item.eventCategoryType = {};
                                if(item.eventCategory === null){
                                    item.eventCategory = {};
                                }
                            }else{
                                if(item.eventCategory === null) item.eventCategory = {};
                            }

                        });
                        return data;
                    },
                    parse: function (data) {
                        angular.forEach(data, function (item) {
                            item.eventDate = kendo.parseDate(kendo.toString(kendo.parseDate(item.dateFrom), 'dd/MM/yyyy'));
                            item.eventDateSort = kendo.toString(kendo.parseDate(item.dateFrom), 'dd/MM/yyyy HH:mm');
                            item.endDate = kendo.parseDate(kendo.toString(kendo.parseDate(item.dateTo), 'dd/MM/yyyy'));
                            item.endDateSort = kendo.toString(kendo.parseDate(item.dateTo), 'dd/MM/yyyy HH:mm');
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            // eventDate: { type: 'date' },
                            // 'eventCustomerSector.agreedPercent': { type: "number" }
                        }
                    }
                },
                group: [{field: "eventDate", dir: "desc", aggregates: [{field: "eventDate", aggregate: "count"}]}],
                aggregate: [{field: "id", aggregate: "count"}]
            }),
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    title: "Στοιχεία Επίσκεψης",
                    columns: [
                        {
                            field: "eventDate",
                            title: "Ημερομηνία Έναρξης",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(dateFrom), 'dddd, dd/MM/yyyy HH:mm')#",
                            groupHeaderTemplate: "Ημερομηνία Έναρξης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')# (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: true,
                            field: "eventDateSort",
                            title: "Ημερομηνία Έναρξης",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(dateFrom), 'dddd, dd/MM/yyyy HH:mm')# ",
                            aggregates: ["count"]
                        },
                        {
                            field: "endDate",
                            title: "Ημερομηνία Λήξης",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(dateTo), 'dddd, dd/MM/yyyy HH:mm')#",
                            groupHeaderTemplate: "Ημερομηνία Λήξης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')# (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: true,
                            field: "endDateSort",
                            title: "Ημερομηνία Λήξης",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(dateTo), 'dddd, dd/MM/yyyy HH:mm')# ",
                            aggregates: ["count"]
                        },
                        {
                            field: "eventCategoryType.eventType.name",
                            title: "Κατηγορία",
                            attributes: {
                                class: "#=eventCategoryType.eventCategory.id == '1' ? 'red' : 'green' #"
                            },
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "title",
                            title: "Τίτλος",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "description",
                            title: "Περιγραφή",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {
                    title: "Στοιχεία Ιατρικού Επισκέπτη",
                    columns: [
                        {
                            field: "employee.account.lastName",
                            title: "Επώνυμο",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "employee.account.firstName",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        }
                    ]
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: false,
                fileName: "Άλλα Συμβάντα.xlsx"
            },
            excelExport: function(e) {
                if(!vm.exportFlag){
                    e.sender.hideColumn("eventDate");
                    e.sender.showColumn("eventDateSort");
                    e.sender.hideColumn("endDate");
                    e.sender.showColumn("endDateSort");
                    e.preventDefault();
                    vm.exportFlag = true;
                    setTimeout(function () {
                        e.sender.saveAsExcel();
                    })
                } else {
                    e.sender.hideColumn("eventDateSort");
                    e.sender.showColumn("eventDate");
                    e.sender.hideColumn("endDateSort");
                    e.sender.showColumn("endDate");
                    vm.exportFlag = false;
                }
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEventsAll', {
                parent: 'adminIndex',
                url: '/events/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminEventsAll/adminEventsAll.html',
                        controller: 'adminEventsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "events_filter"
                        }] } }} );
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('adminEventsAllController', adminEventsAllController);

    adminEventsAllController.$inject = ['$scope', 'favouriteFilters', '$timeout', 'employee','$http', 'KendoService', 'KendoFilter', 'SupervisorsService', 'MasterFiltersService', 'FavouriteFiltersService', 'MasterToKendoFiltersService', 'customersView'];

    function adminEventsAllController ($scope, favouriteFilters, $timeout, employee, $http, KendoService, KendoFilter, SupervisorsService, MasterFiltersService, FavouriteFiltersService, MasterToKendoFiltersService, customersView) {
        var vm = this;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.customerView = customersView.data.content[0].value;
        vm.employee = employee;
        SupervisorsService.setSelectedSupervisors([]);
        vm.masterFilters = { selectedSupervisors: SupervisorsService.getSelectedSupervisors(), selectedEmployees: [], selectedCustomers: [], selectedAgreementValuations: [] };
        vm.pageHeading = 'Επισκέψεις';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'events';
        vm.exportFlag = false;

        var setView = function() {
            var filterable = vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedEmployees.length && !SupervisorsService.getSelectedSupervisors().length;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                groupable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                filterable: filterable
            });
        };

        $scope.$watch("vm.masterFilters.selectedSupervisors", function (value) {
            SupervisorsService.setSelectedSupervisors(value);
            setView();
            vm.employeesMulti.enable(!vm.masterFilters.selectedSupervisors.length);
        });
        $scope.$watch("vm.masterFilters.selectedEmployees", function () {
            setView();
            vm.supervisorsMulti.enable(!vm.masterFilters.selectedEmployees.length);
        });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.supervisorsMultiOptions = MasterFiltersService.getSupervisorsComboBoxOptions();
        vm.supervisorsMultiOptions.change = function () {
            vm.employeesMulti.value('');
            vm.employeesMultiOptions.dataSource.filter({});
            vm.masterFilters.selectedEmployees = [];
            vm.employeesMulti.dataSource.read();
        };
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        vm.customersMultiOptions = MasterFiltersService.getCustomersComboBoxOptions();

        vm.eventStatusesDataSource = KendoService.initDataSource('/api/masterdata/event-statuses', 1, 100, []);
        vm.eventStatusesComboBoxOptions = KendoService.initDefaultOptions( vm.eventStatusesDataSource, "startswith", "name", "id");

        vm.agreementValuationsComboBoxOptions = MasterFiltersService.getAgreementValuationsComboBoxOptions();

        //refresh filters
        var masterFilters = [vm.employeesMultiOptions, vm.customersMultiOptions, vm.agreementValuationsComboBoxOptions];
        angular.forEach(masterFilters, function(masterFilter) {
            masterFilter.dataSource.filter({});
        });

        //Date Filter

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {
                vm.clearDatePickers();
                $timeout(function() {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });

            }
            else if (e.id == "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function() {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });

            }
            else if (e.id == "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function() {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ],
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.supervisorsMulti' multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.masterFilters.selectedSupervisors'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select id='multiSelectCustomers' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.customersMultiOptions' k-ng-model='vm.masterFilters.selectedCustomers'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Αξιολόγηση: </label><select id='multiSelectAgreementValuations' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.agreementValuationsComboBoxOptions' k-ng-model='vm.masterFilters.selectedAgreementValuations'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Κατάσταση Επίσκεψης: </label><select id='eventStatuses' name='eventStatuses' class='inline' kendo-combo-box " +
                    "k-options='vm.eventStatusesComboBoxOptions' k-ng-model='vm.masterFilters.eventStatus'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" },
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.searchEventsUrl = '/api/events/all';
                        if (o.data.filter === undefined) { o.data.filter = { filters: [] }; }
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        // o.data.filter.filters.push({
                        //     field: "eventCustomerSector.customerSector",
                        //     operator: "isnotnull",
                        //     value: "null"
                        // });

                        $http.get(vm.searchEventsUrl, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            item.active = 'Όχι';
                            item.myTarget = 'Όχι';

                            if (item.eventCustomerSector === null) {
                                item.eventCustomerSector = {
                                    customerSector: {
                                        customer: { doctorSpecialty: {} },
                                        sector: { city: {} }
                                    },
                                    agreementValuation: {}
                                };
                            } else {
                                if (item.eventCustomerSector.customerSector == null) {
                                    item.eventCustomerSector.customerSector = {
                                        customer: { doctorSpecialty: {},
                                                    customerCategory: {},
                                                    customerSubCategory: {}},
                                        sector: { city: {} }
                                    };
                                }else {
                                    if (item.eventCustomerSector.customerSector.customer == null){
                                        item.eventCustomerSector.customerSector.customer = { doctorSpecialty: {} }
                                    }else {
                                        if (item.eventCustomerSector.customerSector.customer.doctorSpecialty == null){
                                            item.eventCustomerSector.customerSector.customer.doctorSpecialty = {}
                                        }

                                        if (item.eventCustomerSector.customerSector.customer.customerCategory == null){
                                            item.eventCustomerSector.customerSector.customer.customerCategory = {}
                                        }

                                        if (item.eventCustomerSector.customerSector.customer.customerSubCategory == null){
                                            item.eventCustomerSector.customerSector.customer.customerSubCategory = {}
                                        }
                                    }

                                    if (item.eventCustomerSector.customerSector.employeeCustomerSectors !== null &&
                                        item.eventCustomerSector.customerSector.employeeCustomerSectors !== undefined &&
                                        item.eventCustomerSector.customerSector.employeeCustomerSectors.length > 0){
                                        item.eventCustomerSector.customerSector.employeeCustomerSectors.forEach(function (employeeCustomerSector) {
                                            if (employeeCustomerSector.employee.id === item.employee.id) {
                                                item.active = employeeCustomerSector.active === true ? 'Ναι' : 'Όχι';
                                                item.myTarget = employeeCustomerSector.myTarget === true ? 'Ναι' : 'Όχι';
                                            }else {
                                                item.active = 'Όχι';
                                                item.myTarget = 'Όχι';
                                            }
                                        });
                                    }else {
                                        item.myTarget = 'Όχι';
                                        item.active = 'Όχι';
                                    }
                                }

                                if (item.eventCustomerSector.agreementValuation === null)
                                    item.eventCustomerSector.agreementValuation = {};
                            }

                            if (item.eventCustomerSector.sector == null) {
                                item.eventCustomerSector.sector = { sectorType: {} };
                            }

                            if (item.eventCustomerSector.sector.sectorType == null)
                                item.eventCustomerSector.sector.sectorType = {};

                            if (item.eventStatus === null) item.eventStatus = {};

                            if (item.employee === null) item.employee = { account: {} };

                            if(item.eventCategoryType === null){
                                item.eventCategoryType = {};
                                if(item.eventCategory === null){
                                    item.eventCategory = {};
                                }
                            }else{
                                if(item.eventCategory === null) item.eventCategory = {};
                            }

                        });
                        return data;
                    },
                    parse: function (data) {
                        angular.forEach(data, function (item) {
                            item.eventDate = kendo.parseDate(kendo.toString(kendo.parseDate(item.startedAt), 'dd/MM/yyyy'));
                            item.eventDateSort = kendo.toString(kendo.parseDate(item.startedAt), 'dd/MM/yyyy HH:mm');
                            item.lastName = (item.eventCustomerSector.customerSector == null) ? "-" : item.eventCustomerSector.customerSector.customer.lastName;
                            item.firstName = (item.eventCustomerSector.customerSector == null) ? "-" : item.eventCustomerSector.customerSector.customer.firstName;
                            item.customerCategory = (item.eventCustomerSector.customerSector == null) ? "-" :
                                ((item.eventCustomerSector.customerSector.customer.customerCategory == null) ? "-" : item.eventCustomerSector.customerSector.customer.customerCategory.name);
                            item.customerSubCategory = (item.eventCustomerSector.customerSector != null)
                                ? (item.eventCustomerSector.customerSector.customer.customerSubCategory != null
                                    ? item.eventCustomerSector.customerSector.customer.customerSubCategory.name
                                    : "-")
                                : "-";
                            item.doctorSpecialty = (item.eventCustomerSector.customerSector != null)
                                ? (item.eventCustomerSector.customerSector.customer != null
                                    ? (item.eventCustomerSector.customerSector.customer.doctorSpecialty != null
                                        ? item.eventCustomerSector.customerSector.customer.doctorSpecialty.name
                                        : "-")
                                    : "-")
                                : "-";
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            // eventDate: { type: 'date' },
                            'eventCustomerSector.agreedPercent': { type: "number" }
                        }
                    }
                },
                group: [{field: "eventDate", dir: "desc", aggregates: [{field: "eventDate", aggregate: "count"}]}],
                aggregate: [{field: "id", aggregate: "count"}]
            }),
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                // {
                //     field: "eventDateHeader", title: "Ημερομηνία Επίσκεψης", hidden: true,
                //     groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')#"
                // },
                {
                    title: "Στοιχεία Επαγγελματία Υγείας",
                    columns: [
                        {
                            field: "lastName",
                            title: "Επώνυμο",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "firstName",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerCategory",
                            title: "Κατηγορία",
                            aggregates: ["count"],
                            width: "80px",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSubCategory",
                            title: "Υποκατηγορία",
                            width: "80px",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "doctorSpecialty",
                            title: "Ειδικοτητα 1η",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        }
                    ]
                },
                {
                    title: "Στοιχεία Μονάδας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView === '1' || vm.customerView === '6'
                        },
                        {field: "eventCustomerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "contains",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                            hidden: vm.customerView === '1' || vm.customerView === '6'

                        },
                        {
                            field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "eventCustomerSector.sector.prefectureName", title: "Νομός",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        }
                    ]
                },
                {
                    title: "Στοιχεία Επίσκεψης",
                    columns: [
                        {
                            field: "eventDate",
                            title: "Ημερομηνία",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                            groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')# (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: true,
                            field: "eventDateSort",
                            title: "Ημερομηνία",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            },
                            template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')# ",
                            aggregates: ["count"]
                        },
                        {
                            field: "eventStatus.name",
                            title: "Κατάσταση",
                            attributes: {
                                class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                            },
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "eventCustomerSector.agreementValuation.name",
                            title: "Αξιολόγηση",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null) ? ' ' : eventCustomerSector.agreementValuation.name #",
                            attributes: {
                                class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                            }
                        },
                        {
                            hidden: vm.customerView !== '6',
                            field: "eventCustomerSector.communicationType.name",
                            title: "Τύπος Επικοινωνίας",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            hidden: vm.customerView !== '6',
                            field: "description",
                            title: "Σημειώσεις",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            hidden: vm.customerView !== '6',
                            field: "double",
                            title: "Διπλή Επίσκεψη",
                            template: "#= double ? 'Ναι' : 'Όχι' #",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {
                    title: "Στοιχεία Ιατρικού Επισκέπτη",
                    columns: [
                        {
                            field: "employee.account.lastName",
                            title: "Επώνυμο",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "employee.account.firstName",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {
                    title: "MyTarget",
                    field: "myTarget",
                    template: "#= (myTarget == 'Ναι') ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "Ναι", value: "Ναι"},
                                            {text: "Όχι", value: "Όχι"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#=  (value == 'Ναι') ? 'Ναι'  : 'Οχι' # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 80,
                    hidden: vm.customerView !== '1'
                },
                {
                    title: "Ενεργή Μ.Υ.",
                    field: "active",
                    template: "#= (active == 'Ναι') ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "Ναι", value: "Ναι"},
                                            {text: "Όχι", value: "Όχι"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    aggregates: ["count"],
                    groupHeaderTemplate: "#=  (value == 'Ναι') ? 'Ναι'  : 'Οχι' # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 80,
                    hidden: vm.customerView !== '1'
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: false,
                fileName: "Επισκέψεις.xlsx"
            },
            excelExport: function(e) {
                if(!vm.exportFlag){
                    e.sender.hideColumn("eventDate");
                    e.sender.showColumn("eventDateSort");
                    e.preventDefault();
                    vm.exportFlag = true;
                    setTimeout(function () {
                        e.sender.saveAsExcel();
                    })
                } else {
                    e.sender.hideColumn("eventDateSort");
                    e.sender.showColumn("eventDate");
                    vm.exportFlag = false;
                }
                // let sheet = e.workbook.sheets[0];
                //
                // for( let rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {
                //     let row = sheet.rows[rowIndex];
                //     for( let cellIndex = 0; cellIndex < row.cells.length; cellIndex ++) {
                //         row.cells[cellIndex].format = 'dd/MM/yyyy HH:mm'
                //     }
                // }
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Kristy on 21/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEmployeeVisitsAll', {
                parent: 'adminIndex',
                url: '/employeeVisits/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminEmployeeVisitsAll/adminEmployeeVisitsAll.html',
                        controller: 'AdminEmployeeVisitsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    healthVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_HEALTH_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Recreated by Teo on 04/09/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeVisitsAllController', AdminEmployeeVisitsAllController);

    AdminEmployeeVisitsAllController.$inject = ['$http', 'KendoGrid', 'KendoService', 'CustomUtils', 'Alerts', '$timeout', '$filter', 'CustomDataUtils', 'KendoFilter', 'healthVisitors', 'customersView'];

    function AdminEmployeeVisitsAllController ($http, KendoGrid, KendoService, CustomUtils, Alerts, $timeout, $filter, CustomDataUtils, KendoFilter, healthVisitors, customersView) {
        var vm = this;
        vm.pageHeading = 'Εργαλείο Απολογισμού Επισκέψεων ανά Ιατρικό Επισκέπτη';
        vm.showProgress = false;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(58);
        vm.masterFilters = {};
        vm.customerView = customersView !== null && customersView.data !== null && customersView.data.content !== null ? customersView.data.content[0].value : null;
        vm.selectedEmployeeId = null;
        vm.selectedSoftwares = [];
        vm.isActive = true;
        vm.myTarget = true;
        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        vm.employeeOptions = {
            dataSource: {
                data: healthVisitors
            },
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "fullName",
            dataValueField: "id",
            placeholder: "Επιλέξτε Ιατρικό Επισκέπτη"
        };

        vm.fromOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }

                var startDate = vm.masterFilters.from,
                    endDate = vm.masterFilters.to;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());
                    end.min(startDate);

                    //set range to year
                    var maxDate = new Date(startDate);
                    maxDate = new Date(maxDate.setFullYear(startDate.getFullYear() + 1));
                    end.max(maxDate);
                } else if (endDate) {
                    start.max(new Date(endDate));
                    end.max(new Date(2099, 11, 31));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    end.max(new Date(2099, 11, 31));
                }
            }
        };

        vm.toOptions = {
            change: function() {
                var start = angular.element("#from").data("kendoDatePicker");
                var end = angular.element("#to").data("kendoDatePicker");
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }

                var endDate = vm.masterFilters.to,
                    startDate = vm.masterFilters.from;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());
                    start.max(endDate);

                    //set range to year
                    var minDate = new Date(endDate);
                    minDate = new Date(minDate.setFullYear(endDate.getFullYear() - 1));
                    start.min(minDate);
                } else if (startDate) {
                    end.min(new Date(startDate));
                    start.min(new Date(1900, 0, 1));
                } else {
                    endDate = new Date();
                    start.max(endDate);
                    end.min(endDate);
                    start.min(new Date(1900, 0, 1));
                }
            }
        };

        vm.softwareOptions = {
            dataSource: [
                // {text: 'Επιλογή όλων', value: 'all'},
                {text: 'Χωρίς Λογισμικό', value: 'none'},
                {text: $filter('translate')('global.field.software.medexpress'), value: 'medexpress'},
                {text: $filter('translate')('global.field.software.medmobile'), value: 'medmobile'},
                {text: $filter('translate')('global.field.software.other'), value: 'other'}
                ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            placeholder: "Επιλογή λογισμικού",
            select: function (e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();

                if (dataItem.value === "all" || dataItem.value === "none") {
                    this.value("");
                } else if (values.indexOf("all") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "all";
                    });
                    this.value(values);
                } else if (values.indexOf("none") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "none";
                    });
                    this.value(values);
                }
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id === "today") {
                vm.clearDatePickers();

                $timeout(function (){
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });
            } else if (e.id === "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function (){
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            } else if (e.id === "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function (){
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.exportData = function () {
            var grid = $("#mainGrid").data("kendoGrid");
            grid.saveAsExcel();
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        /*{ text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },*/
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>", overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select name='employeeSelect' id='employeeSelect' kendo-combo-box k-ng-model='vm.selectedEmployeeId' k-options='vm.employeeOptions' style='width: 72%'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<div style='padding-top: 6px;'><label>My Target: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Ενεργός: </label><md-checkbox aria-label='isActive' ng-model='vm.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"' style='padding-top: 2px;'><label>Λογισμικό: </label><select kendo-multi-select multiple='multiple' id='multiSelect' name='multiSelect' class='inline' k-ng-model='vm.selectedSoftwares' " +
                    "                            k-options='vm.softwareOptions' class='col-fix'></select></div>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    type: "separator", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.getData();' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel' aria-label='search' ng-click='vm.exportData();' ng-disabled='vm.disabled'>" +
                    "<span class='k-icon k-i-excel'></span>EXPORT</md-button>", overflow: "never", attributes: { class: "right" }
                }
            ]
        };

        vm.getData = function () {
            var cancel = false;
            var message = "";
            if (vm.masterFilters.from === null || vm.masterFilters.to === null ||
                vm.masterFilters.from === undefined || vm.masterFilters.to === undefined){
                cancel = true;
                message = "Επιλέξτε ημερομηνίες";
            }

            if (!cancel && (vm.masterFilters.from > vm.masterFilters.to)){
                cancel = true;
                message = "Η ημερομηνία 'Από' πρέπει να είναι μικρότερη από την ημερομηνία 'Εώς'"
            }

            if (!cancel && (vm.selectedEmployeeId === null || vm.selectedEmployeeId === undefined)) {
                cancel = true;
                message = "Επιλέξτε Ιατρικό Επισκέπτη"
            }

            if (cancel){
                Alerts.showAlert("Sigma SalesForce", message, "ΟΚ");
            }else {
                $("#mainGrid").data().kendoGrid.destroy();
                $("#mainGrid").empty();
                vm.showProgress = true;
                $http.get(constructUrl())
                    .success(function (response) {
                        vm.showProgress = false;
                        generateGrid(response);
                    })
                    .error(function (error) {
                        vm.showProgress = false;
                        console.log(error);
                        Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                    });
            }
        };

        function constructUrl() {
            var url = "/api/events/count-events-in-period";
            url += "?dateFrom=" + $filter('date')(vm.masterFilters.from, 'yyyy-MM-dd');
            url += "&dateTo=" + $filter('date')(vm.masterFilters.to, 'yyyy-MM-dd');
            url += "&employeeId=" + vm.selectedEmployeeId;
            url += "&active=" + vm.isActive;
            if (vm.myTarget === true || vm.myTarget === false) {
                url += "&myTarget=" + vm.myTarget;
            }
            if (vm.selectedSoftwares.length > 0) {
                url += "&softwares=" + vm.selectedSoftwares;
            }

            return url;
        }

        function generateGrid(response) {
            $("#mainGrid").kendoGrid({
                dataSource: {
                    batch: true,
                    serverFiltering: false,
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            if (data !== null && data !== undefined && data.length > 0){
                                angular.forEach(data, function(item) {
                                    if (!item.rowObject.customerSector.customer) {
                                        item.rowObject.customerSector.customer = {
                                            doctorSpecialty: {},
                                            customerCategory: {},
                                            customerSubCategory: {},
                                            collaboration: {}
                                        }
                                    }else {
                                        if (!item.rowObject.customerSector.customer.doctorSpecialty) item.rowObject.customerSector.customer.doctorSpecialty = {};
                                        if (!item.rowObject.customerSector.customer.customerCategory) item.rowObject.customerSector.customer.customerCategory = {};
                                        if (!item.rowObject.customerSector.customer.customerSubCategory) item.rowObject.customerSector.customer.customerSubCategory = {};
                                        if (!item.rowObject.customerSector.customer.collaboration) item.rowObject.customerSector.customer.collaboration = {};

                                        if (item.rowObject.customerSector.customer.software === "other") {
                                            item.rowObject.customerSector.customer.software = $filter('translate')('global.field.software.other')
                                        }else if (item.rowObject.customerSector.customer.software === "medexpress") {
                                            item.rowObject.customerSector.customer.software = $filter('translate')('global.field.software.medexpress')
                                        }else if (item.rowObject.customerSector.customer.software === "medmobile") {
                                            item.rowObject.customerSector.customer.software = $filter('translate')('global.field.software.medmobile')
                                        }
                                    }

                                    if (!item.rowObject.customerSector.sector) {
                                        item.rowObject.customerSector.sector = {
                                            sectorType: {}
                                        }
                                    }else {
                                        if (!item.rowObject.customerSector.sector.sectorType) item.rowObject.customerSector.sector.sectorType = {};
                                    }

                                    item.rowObject.myTarget = item.rowObject.myTarget === true ? 'Ναι' : 'Όχι';
                                });
                            }
                            return data;
                        },
                        model: {
                            id: "rowObject.customerSector.customer.id"
                        }
                    }
                },
                columns: generateColumns(response),
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                filterable: {
                    mode: "row"
                },
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#mainGrid"));
                    });
                },
                excel: {
                    allPages: true,
                    fileName: "Απολογισμός Επισκέψεων ανά Ιατρικό Επισκέπτη.xlsx"
                },
                noRecords: {
                    template: "Δεν βρέθηκαν εγγραφές"
                }
            });
        }

        function generateColumns(response) {
            var columns = [];
            if (response !== null && response !== undefined && response.length > 0) {
                columns = [
                    {
                        field: "rowObject.customerSector.customer.lastName",
                        title: "Επώνυμο",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 120
                    },
                    {
                        field: "rowObject.customerSector.customer.firstName",
                        title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 130
                    },
                    {
                        field: "rowObject.customerSector.customer.doctorSpecialty.name",
                        title: "Ειδικότητα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 100
                    },
                    {
                        field: "rowObject.customerSector.customer.customerCategory.name",
                        title: "Κατηγορία",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 70
                    },
                    {
                        field: "rowObject.customerSector.customer.customerSubCategory.name",
                        title: "ΥποΚατηγορία",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 70
                    },
                    {
                        field: "rowObject.customerSector.customer.collaboration.name",
                        title: "Συνεργασία",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 90,
                        hidden: vm.customerView === '1' || vm.customerView === '6'
                    },
                    {
                        field: "rowObject.customerSector.customer.software",
                        title: "Λογισμικό",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 80,
                        hidden: vm.customerView === '1' || vm.customerView === '6'
                    },
                    {
                        field: "rowObject.customerSector.sector.cityName",
                        title: "Πόλη",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 120
                    },
                    {
                        field: "rowObject.customerSector.sector.prefectureName",
                        title: "Νομός",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 120
                    },
                    {
                        field: "rowObject.customerSector.sector.sectorType.name",
                        title: "Τύπος Μ.Υ.",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 90,
                        hidden: vm.customerView === '1' || vm.customerView === '6'
                    },
                    {
                        field: "rowObject.customerSector.sector.name",
                        title: "Kύρια Μ.Υ.",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 120
                    },
                    {
                        field: "rowObject.customerSector.sector.osfeBrick",
                        title: "Brick ΟΣΦΦΕ",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: filterTemplate,
                                showOperators: false
                            }
                        },
                        width: 120,
                        hidden: vm.customerView !== '1'
                    },
                    {
                        field: "rowObject.myTarget",
                        title: "MyTarget",
                        filterable: {
                            cell: {
                                operator: "eq",
                                showOperators: false,
                                template: function (args) {
                                    args.element.kendoDropDownList({
                                        autoBind: false,
                                        dataTextField: "text",
                                        dataValueField: "value",
                                        dataSource: new kendo.data.DataSource({
                                            data: [{text: "Ναι", value: "Ναι"},
                                                {text: "Όχι", value: "Όχι"}]
                                        }),
                                        valuePrimitive: true
                                    });
                                }
                            }
                        },
                        width: 70
                    }
                ];
                angular.forEach(response[0].rowValues, function (item, index) {
                    columns.push({
                        field: "rowValues[" + index + "].value",
                        title: item.columnName,
                        filterable: false,
                        width: 40
                    });
                });

                columns.push({
                    field: "rowTotal",
                    title: "Σύνολο",
                    filterable: false,
                    width: 50
                });
            }

            return columns;
        }

        $(window).on("resize", function() {
            kendo.resize($("#mainGrid"));
        });

        // Click month when screen opens
        $timeout(function () {
            $("#month").click();
        });
    }
})();
;
/**
 * Created by Maria on 24/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEmployeesAll', {
                parent: 'adminIndex',
                url: '/employees/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminEmployeesAll/adminEmployeesAll.html',
                        controller: 'adminEmployeesAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 24/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('adminEmployeesAllController', adminEmployeesAllController);

    adminEmployeesAllController.$inject = ['$http', 'KendoFilter'];

    function adminEmployeesAllController ($http, KendoFilter) {
        var vm = this;

        vm.pageHeading = 'Ευρετηριο Ιατρικων Επισκεπτων';
        vm.employeeUrl = '/api/employees/all';
        vm.selectedProductCategories = [];

        vm.collapseAll = function() {
            angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click");
        };

        vm.expandAll = function() {
            angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click");
        };

        function productCategoriesDisplay(data, container) {
            if(data.productCategories) {
                return data.productCategories.map(function(elem) {
                    return elem.name
                }).join(', ');
            }
            return "";
        }

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        if(vm.selectedProductCategories.length) {
                            o.data.filter.filters.push(
                                { "field": "productCategories.id", "operator": "in",
                                    "value": vm.selectedProductCategories.toString() }
                            );
                        }
                        $http.get(vm.employeeUrl, { params: o.data })
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            //if(!item.productCategories.length) { item.productCategories = []; item.productCategories[0] = {name: ""} }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false}
                        }
                    }
                },
                filter: {field: "account.activated", operator: "eqbool", value: true},
                aggregate: [{field: "active", aggregate: "count"}]
            }),
            sortable: true,
            groupable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "account.login",
                    title: "Όνομα σύνδεσης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "account.firstName",
                    title: "Όνομα",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "account.lastName",
                    title: "Επώνυμο",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "phone",
                    title: "Τηλέφωνο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "district",
                    title: "Περιοχή",
                    template: "#= (district == 'north') ? 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ' : (district == 'south') ? 'ΝΟΤΙΑ ΕΛΛΑΔΑ' : (district == 'westAndPeloponnese') ? 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ' : '' #",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Βόρεια Ελλάδα", value: "north" },
                                            { text: "Νότια Ελλάδα", value: "south" },
                                            { text: "Δυτ. Ελλάδος & Πελοποννήσου", value: "westAndPeloponnese" }]
                                    }),
                                    valuePrimitive: true

                                })
                            }
                        }
                    },
                    groupHeaderTemplate: "#=  (value == 'north') ? 'Βόρεια Ελλάδα' : (value == 'south') ? 'Νότια Ελλάδα'  : (value == 'westAndPeloponnese') ? 'Δυτ. Ελλάδος & Πελοποννήσου' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "account.email",
                    title: "Email",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "account.activated",
                    title: "Ενεργός",
                    template: "#= (account.activated == '1') ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            }
                        }
                    },
                    groupHeaderTemplate: "#= (value == true) ? 'Ενεργός: Ναι' : (value == false) ? 'Ενεργός: Όχι' : ''#"
                },
                {
                    field: "mobileVersion",
                    title: "Mobile Έκδοση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "productCategories.id",
                    title: "Κατηγορίες Προϊόντων",
                    filterable: {
                        cell: {
                            operator: "in",
                            showOperators: false,
                            template: function (args) {
                                args.element.removeAttr('data-bind').kendoMultiSelect({
                                    dataSource: new kendo.data.DataSource({
                                        serverFiltering: true,
                                        transport: {
                                            read: function (o) {
                                                if (o.data.filter == undefined) {
                                                    o.data.filter = {filters: []};
                                                }
                                                o.data.page = 1;
                                                o.data.pageSize = 10000;
                                                $http.get('/api/masterdata/product-categories',
                                                    {params: o.data})
                                                    .success(function (response, status, headers) {
                                                        response.content.unshift({id:"none", name :"(Κενό)"});
                                                        o.success(response.content);
                                                    })
                                                    .error(function (response) {
                                                        console.log(response);
                                                    });
                                            }
                                        }
                                    }),
                                    valuePrimitive: true,
                                    dataTextField: "name",
                                    dataValueField: "id",
                                    change: function () {
                                        vm.selectedProductCategories = this.value();
                                        vm.mainGridOptions.dataSource.read();
                                    },
                                    select: function (e) {
                                        var dataItem = this.dataSource.view()[e.item.index()];
                                        var values = this.value();

                                        if (dataItem.id === "none") {
                                            this.value("");
                                        } else if (values.indexOf("none") !== -1) {
                                            values = angular.element.grep(values, function (value) {
                                                return value !== "none";
                                            });
                                            this.value(values);
                                        }
                                    }
                                })
                            }
                        }
                    },
                    groupable: false,
                    template: productCategoriesDisplay,
                    editor: function (container, options) {
                        angular.element('<select id="productCategories" multiple="multiple" data-bind="value: productCategories"/>')
                            .appendTo(container)
                            .kendoMultiSelect({
                                dataSource: new kendo.data.DataSource({
                                    serverFiltering: true,
                                    transport: {
                                        read: function (o) {
                                            if (o.data.filter == undefined) {
                                                o.data.filter = {filters: []};
                                            }

                                            o.data.page = 1;
                                            o.data.pageSize = 10000;
                                            $http.get('/api/masterdata/product-categories',
                                                {params: o.data})
                                                .success(function (response, status, headers) {
                                                    o.success(response.content);
                                                })
                                                .error(function (response) {
                                                    console.log(response);
                                                });
                                        }
                                    }
                                }),
                                valuePrimitive: false,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    }
                    //groupHeaderTemplate: "#= !value ? '(Κενό)' : 'Με τιμή'#"
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Ιατρικοί Επισκέπτες.xlsx"
            }
        }
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCustomerSectorsAll', {
                parent: 'adminIndex',
                url: '/customerSectors/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminCustomerSectorsAll/adminCustomerSectorsAll.html',
                        controller: 'AdminCustomerSectorsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [ {
                            "field": "viewName", "operator": "eq",
                            "value": "customerSectors"
                        }]}}});
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 15/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerSectorsAllController', AdminCustomerSectorsAllController);

    AdminCustomerSectorsAllController.$inject = ['$scope', '$filter', '$timeout','$http', 'favouriteFilters', 'employee', 'customersView', 'SupervisorsService', 'MasterFiltersService', 'KendoFilter', 'FavouriteFiltersService', 'MasterToKendoFiltersService', 'KendoService'];

    function AdminCustomerSectorsAllController ($scope, $filter, $timeout, $http, favouriteFilters, employee, customersView, SupervisorsService, MasterFiltersService, KendoFilter, FavouriteFiltersService, MasterToKendoFiltersService, KendoService) {
        var vm = this;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        SupervisorsService.setSelectedSupervisors([]);
        vm.masterFilters = { selectedSupervisors: SupervisorsService.getSelectedSupervisors(), selectedCustomerSectors: [], selectedCities: [],
            selectedPrefectures: [], selectedSectorTypes: [], myTarget: true, selectedSoftwares: [], isActive: true, lastVisitDate: { operator: 'eqdate' } };
        vm.pageHeading = 'Ευρετήριο Μονάδων Υγείας Επαγγελματία Υγείας';
        vm.customersURL = '/api/customer-sectors/all';
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.disabled = true;
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'customerSectors';
        vm.customerView = customersView.data.content[0].value;

        var setView = function() {
            var filterable = vm.masterFilters.selectedCustomerSectors.length || SupervisorsService.getSelectedSupervisors().length ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedCustomerSectors.length && !SupervisorsService.getSelectedSupervisors().length;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedCustomerSectors.length || SupervisorsService.getSelectedSupervisors().length,
                groupable: vm.masterFilters.selectedCustomerSectors.length || SupervisorsService.getSelectedSupervisors().length,
                filterable: filterable
            });
        };

        $scope.$watch("vm.masterFilters.selectedSupervisors",function(value){
            SupervisorsService.setSelectedSupervisors(value);
            setView();
            vm.employeesMulti.enable(!vm.masterFilters.selectedSupervisors.length);
        });
        $scope.$watch("vm.masterFilters.selectedCustomerSectors", function () {
            setView();
            vm.supervisorsMulti.enable(!vm.masterFilters.selectedCustomerSectors.length);
        });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.supervisorsMultiOptions = MasterFiltersService.getSupervisorsComboBoxOptions();
        vm.supervisorsMultiOptions.change = function () {
            vm.employeesMulti.value('');
            vm.employeesMultiOptions.dataSource.filter({});
            vm.selectedCustomerSectors = [];
            vm.employeesMulti.dataSource.read();
            $timeout(function (){ vm.disabled = !vm.masterFilters.selectedCustomerSectors.length && !SupervisorsService.getSelectedSupervisors().length; });
        };
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "none", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        vm.citiesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) o.data.filter = {filters: []};

                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/cities', {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"none", name:"(Κενό)", prefecture: {}}, {id:"all", name:"Επιλογή όλων", prefecture: {}});
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.citiesMultiOptions = {
            dataSource: vm.citiesMultiDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id",
            template: "<table>${name} &nbsp;" +
            "<span ng-if=\"this.dataItem.id != 'all' && this.dataItem.id != 'none'\" class='hint'>(${prefecture.name})</span></table>",
            select: function(e) {
                var dataItem = this.dataSource.view()[e.item.index()];//
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["all", "none"]);
            }
        };

        vm.prefecturesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) o.data.filter = {filters: []};

                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/prefectures', {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"none", name:"(Κενό)"}, {id:"all", name:"Επιλογή όλων"});
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.prefecturesMultiOptions = {
            dataSource: vm.prefecturesMultiDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id",
            select: function(e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["all", "none"]);
            }
        };

        vm.sectorTypesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) o.data.filter = {filters: []};

                    o.data.page = 1;
                    o.data.pageSize = 100;
                    $http.get('/api/masterdata/sector-types', {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"none", name:"(Κενό)"}, {id:"all", name:"Επιλογή όλων"});
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.sectorTypesMultiOptions = {
            dataSource: vm.sectorTypesMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            select: function(e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["all", "none"]);
            }
        };

        var softwareDataSource = [{text: 'Επιλογή όλων', value: 'all'}, {text: 'Όχι', value: 'none'},
            {text: $filter('translate')('global.field.software.medexpress'), value: 'medexpress'},
            {text: $filter('translate')('global.field.software.medmobile'), value: 'medmobile'},
            {text: $filter('translate')('global.field.software.other'), value: 'other'}];
        vm.softwareOptions = {
            dataSource: softwareDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            placeholder: "Επιλογή λογισμικού",
            select: function (e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();

                if (dataItem.value === "all" || dataItem.value === "none") {
                    this.value("");
                } else if (values.indexOf("all") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "all";
                    });
                    this.value(values);
                } else if (values.indexOf("none") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "none";
                    });
                    this.value(values);
                } else if (values.indexOf("other") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "other";
                    });
                    this.value(values);
                }
            }
        };

        vm.openMenu = function($mdOpenMenu, ev) { $mdOpenMenu(ev); };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();
                $timeout(function() {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function() {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function() {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.supervisorsMulti' multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.masterFilters.selectedSupervisors'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedCustomerSectors'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Πόλη: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.citiesMultiOptions' k-ng-model='vm.masterFilters.selectedCities'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Νομός: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.prefecturesMultiOptions' k-ng-model='vm.masterFilters.selectedPrefectures'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Τύπος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.sectorTypesMultiOptions' k-ng-model='vm.masterFilters.selectedSectorTypes'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>My Target: </label><div class='inline'><md-radio-group layout='row' ng-model='vm.masterFilters.myTarget' ng-disabled='vm.disabled'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<label>Ενεργός: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' ng-change='vm.onFilterChange()' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"'><label>Λογισμικό: </label><select kendo-multi-select multiple='multiple' id='multiSelect' name='multiSelect' class='inline' k-ng-model='vm.masterFilters.selectedSoftwares' " +
                    "                            k-options='vm.softwareOptions' class='col-fix'></select></div>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"'><label>Ημέρες Τελ. Επίσκεψης: </label>" +
                    "<input id='lastVisitDate' style='width: 5em;' kendo-numeric-text-box min='0' k-ng-model='vm.masterFilters.lastVisitDate.value' k-format='\"n0\"'/>" +
                    "<md-menu class='master-filter-btn'> <md-button aria-label='Open filter operators menu' class='md-icon-button' ng-click='vm.openMenu($mdOpenMenu, $event)'> " +
                    "<md-icon class='filter-list-icon'></md-icon> </md-button> " +
                    "<md-menu-content width='4'> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"eqdate\" '> Ίσο</md-button></md-menu-item> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"gte\" '> Μικρότερο ή Ίσο</md-button></md-menu-item> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"lte\" '> Μεγαλύτερο ή Ίσο</md-button></md-menu-item> " +
                    "</md-menu-content> </md-menu></div>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" },
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function() {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function() {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var dayTimeFilterTemplate = function (args) {
            KendoFilter.getDayTimeTemplate(args);
        };

        var booleanFilterTemplate = function (args) {
            KendoFilter.getBooleanTemplate(args);
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) o.data.filter = {filters: []};
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                        var foundCitiesByField = $filter('filter')(o.data.filter.filters, {field: "sector.cityName"}, true)[0];
                        if (vm.masterFilters.selectedCities.length) {
                            if (foundCitiesByField.value !== "" && foundCitiesByField.value !== "none") {
                                var cityArray = [];

                                angular.forEach(vm.masterFilters.selectedCities, function (city) {
                                    cityArray.push(city.name);
                                });
                                foundCitiesByField.value = cityArray.toString();
                            }
                        }

                        var foundPrefecturesByField = $filter('filter')(o.data.filter.filters, {field: "sector.prefectureName"}, true)[0];
                        if (vm.masterFilters.selectedPrefectures.length) {
                            if (foundPrefecturesByField.value !== "" && foundPrefecturesByField.value !== "none") {

                                var prefectureArray = [];
                                angular.forEach(vm.masterFilters.selectedPrefectures, function (prefecture) {
                                    prefectureArray.push(prefecture.name);
                                });
                                foundPrefecturesByField.value = prefectureArray.toString();
                            }
                        }

                        if(vm.masterFilters.selectedSoftwares.length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "customer.software", "operator":  vm.masterFilters.selectedSoftwares.indexOf('none') > -1 ? "isnull" : "in",
                                        "value": vm.masterFilters.selectedSoftwares.indexOf('all') > -1 ? "medexpress,medmobile,other" :
                                            vm.masterFilters.selectedSoftwares.indexOf('none') > -1 ? null :
                                                vm.masterFilters.selectedSoftwares.toString() }
                                ]
                            );
                        }

                        if(vm.masterFilters.lastVisitDate.value) {
                            var dt = new Date();
                            dt.setDate( dt.getDate() - vm.masterFilters.lastVisitDate.value );

                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "customer.lastVisitDate", "operator":  vm.masterFilters.lastVisitDate.operator ? vm.masterFilters.lastVisitDate.operator : 'eqdate',
                                        "value": dt }
                                ]
                            );
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "customer.isActive",
                                    "operator":  "eqbool",
                                    "value": vm.masterFilters.isActive }
                            ]
                        );

                        o.data.filter.filters.push({
                            field: "employeeCustomerSectors.active",
                            operator: "eqbool",
                            value: true
                        });

                        angular.forEach(o.data.filter.filters, function (item) {
                            if ( item.field === 'lastVisitDate' ) {
                                var dt = new Date();
                                dt.setDate( dt.getDate() - item.value );
                                item.value = dt;
                            }
                        });

                        if (vm.customerView === '3') {
                            // Cross, fetch only not expired customerSectors
                            o.data.filter.filters.push({
                                field: "endedAt",
                                operator: "null_or_greater",
                                value: $filter('date')(Date.now(), 'yyyy-MM-dd')
                            });
                        }

                        if(vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '5' || vm.customerView === '6') {
                            vm.customersURL = '/api/customer-sectors/employees/all';
                        }
                        $http.get(vm.customersURL, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            if (item.customer === null) item.customer = {};
                            if (item.customer !== null) {
                                if (item.customer.customerCategory === null) item.customer.customerCategory = {};
                                if (item.customer.customerSubCategory === null) item.customer.customerSubCategory = {};
                                if (item.customer.doctorSpecialty === null) item.customer.doctorSpecialty = {}
                            }
                            if (item.sector === null) item.sector = {};
                            if (item.sector !== null) {
                                if (item.sector.city === null) item.sector.city = {};
                                if (item.sector.prefecture === null) item.sector.prefecture = {};
                                if (item.sector.sectorType === null) item.sector.sectorType = {};
                            }
                            item.employeesString = "";
                            if (item.employees) {
                                item.employees.forEach(function (employeeName) {
                                    item.employeesString += "[" + employeeName + "] ";
                                });
                            }
                        });
                        return data;
                    },
                    parse: function (data) {
                        var dt = new Date();
                        dt.setHours(23, 59, 59);
                        data.forEach(function (item) {
                            if (item.customer) {
                                item.customer.lastVisitDate =
                                    item.customer.lastVisitDate ? Math.floor(Math.abs(new Date(item.customer.lastVisitDate).getTime() - dt.getTime()) / (1000 * 60 * 60 * 24)) : '';
                            }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            isActive: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            'customer.lastVisitDate': { type: 'number', editable: false}
                        }
                    }
                },
                aggregate: [{field: "customer.lastName", aggregate: "count"},
                    {field: "customer.firstName", aggregate: "count"},
                    {field: "customer.doctorSpecialty.name", aggregate: "count"},
                    {field: "customer.customerCategory.name", aggregate: "count"},
                    {field: "customer.customerSubCategory.name", aggregate: "count"},
                    {field: "customer.dayTime", aggregate: "count"},
                    {field: "customer.title", aggregate: "count"},
                    {field: "sector.name", aggregate: "count"},
                    {field: "sector.sectorType.name", aggregate: "count"},
                    {field: "sector.address", aggregate: "count"},
                    {field: "sector.osfeBrick", aggregate: "count"},
                    {field: "sector.prefectureName", aggregate: "count"},
                    {field: "sector.cityName", aggregate: "count"},
                    {field: "main", aggregate: "count"}]
            }),
            sortable: false,
            groupable: false,
            filterable: false,
            resizable: true,
            columns: [
                {
                    title: "Στοιχεία Επαγγελματία Υγείας",
                    columns: [
                        {
                            field: "customer.lastName",
                            title: "Επώνυμο",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customer.firstName",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customer.doctorSpecialty.name",
                            title: "Ειδικοτητα 1η",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customer.customerCategory.name",
                            title: "Κατηγορία",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#=  typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customer.customerSubCategory.name",
                            title: "Υποκατηγορία",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#=  typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customer.dayTime",
                            title: "Ωράριο",
                            aggregates: ["count"],
                            template: "#= (customer.dayTime == 'day') ? 'ΠΡΩΙΝΌ' : (customer.dayTime == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false,
                                    template: dayTimeFilterTemplate
                                }
                            },
                            groupHeaderTemplate: "#= typeof value !== 'undefined' ? ((value == 'day') ? 'ΠΡΩΙΝΟ' : (value == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΟ' : '') : '' #(Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: vm.customerView === '1' || vm.customerView === '6',
                            field: "customer.title",
                            title: "Τίτλος",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#=typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: vm.customerView !== '3',
                            field: "customer.software",
                            title: "Λογισμικό",
                            template: function (dataItem) {
                                return dataItem.customer.software ? $filter('translate')('global.field.software.' + dataItem.customer.software ) : 'Όχι';
                            },
                            filterable: false
                        },
                        {
                            hidden: vm.customerView !== '3',
                            field: "customer.lastVisitDate", title: "Ημέρες Τελ. Επίσκεψης",
                            filterable: {
                                operators: {
                                    number: {
                                        eq: 'Ίσο',
                                        gte: 'Μεγαλύτερο ή Ίσο',
                                        lte: 'Μικρότερο ή Ίσο'
                                    }
                                },
                                cell: {
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "n0",
                                            decimals: 0,
                                            min: 0
                                        });

                                    }
                                }
                            },
                            width: 150
                        }
                    ]
                },
                {
                    title: "Στοιχεία Μονάδας Υγείας",
                    columns: [
                        {
                            field: "sector.name",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "contains",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.sectorType.name",
                            title: "Τύπος",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.address",
                            title: "Διεύθυνση",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.addressNum",
                            title: "Αριθμός",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#=  (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.osfeBrick",
                            title: "Brick ΟΣΦΕ",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#=  (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.prefectureName",
                            title: "Νομός",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "sector.cityName",
                            title: "Πόλη",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            hidden: vm.customerView === '1' || vm.customerView === '6',
                            field: "main",
                            title: "Κύρια Μ.Υ.",
                            aggregates: ["count"],
                            template: "#= (main == true) ? 'Ναι' : 'Όχι' #",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false,
                                    template: booleanFilterTemplate
                                }
                            },
                            groupHeaderTemplate: "#= (value == true) ? 'Κύρια Μ.Υ.: Ναι' : (value == false) ? 'Κύρια Μ.Υ.: Όχι' : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        }
                    ]
                },
                {
                    hidden: vm.customerView !== '3' && vm.customerView !== '1' && vm.customerView !== '5',
                    field: "employeesString", title: "Ιατρικοι Επισκεπτες",
                    filterable: false,
                    sortable: false
                }

            ],
            toolbar: [
                {template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>"},
                {template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>"},
                {
                    name: "excel",
                    template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>"
                }
            ],
            excel: {
                allPages: true,
                fileName: "Επαγγελματίες ΥγείαςΜονάδες.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCustomersAll', {
                parent: 'adminIndex',
                url: '/customers/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminCustomersAll/adminCustomersAll.html',
                        controller: 'adminCustomersAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "customers"
                        }] } }} );
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('adminCustomersAllController', adminCustomersAllController);

    adminCustomersAllController.$inject = ['$scope', 'employee', 'customersView', 'favouriteFilters', '$filter','$http', 'SupervisorsService', 'MasterFiltersService', 'KendoFilter', '$timeout', 'FavouriteFiltersService', 'MasterToKendoFiltersService'];

    function adminCustomersAllController ($scope, employee, customersView, favouriteFilters, $filter, $http, SupervisorsService, MasterFiltersService, KendoFilter, $timeout, FavouriteFiltersService, MasterToKendoFiltersService) {
        var vm = this;
        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        SupervisorsService.setSelectedSupervisors([]);
        vm.masterFilters = { selectedSupervisors: SupervisorsService.getSelectedSupervisors(), selectedCustomers: [], selectedSpecialties: [], saw: true,
            isActive: true, selectedSoftwares: [], lastVisitDate: { operator: 'eqdate' } };
        vm.pageHeading = 'Ευρετήριο Γενικών Στοιχείων Επαγγελματία Υγείας';
        vm.customersURL = '/api/customers/all';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'customers';
        vm.customerView = customersView.data.content[0].value;

        var setView = function() {
            var filterable = vm.masterFilters.selectedCustomers.length || SupervisorsService.getSelectedSupervisors().length ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedCustomers.length && !SupervisorsService.getSelectedSupervisors().length;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedCustomers.length || SupervisorsService.getSelectedSupervisors().length,
                groupable: vm.masterFilters.selectedCustomers.length || SupervisorsService.getSelectedSupervisors().length,
                filterable: filterable
            });
        };

        $scope.$watch("vm.masterFilters.selectedSupervisors", function (value) {
            SupervisorsService.setSelectedSupervisors(value);
            setView();
            vm.employeesMulti.enable(!vm.masterFilters.selectedSupervisors.length);
        });
        $scope.$watch("vm.masterFilters.selectedCustomers", function () {
            setView();
            vm.supervisorsMulti.enable(!vm.masterFilters.selectedCustomers.length);
        });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.supervisorsMultiOptions = MasterFiltersService.getSupervisorsComboBoxOptions();
        vm.supervisorsMultiOptions.change = function () {
            vm.employeesMulti.value('');
            vm.employeesMultiOptions.dataSource.filter({});
            vm.masterFilters.selectedCustomers = [];
            vm.employeesMulti.dataSource.read();
        };

        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "none", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});

        vm.specialtiesMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    var url = '/api/masterdata/doctor-specialties';
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10000;
                    $http.get(url,
                        {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id: "none", name: "(Κενό)"});
                            o.success(response.content);
                        })
                        .error(function (response) {
                        });
                }
            }
        });
        vm.specialtiesMultiOptions = {
            dataSource: vm.specialtiesMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή Ειδικότητας",
            select: function (e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["none"]);
            }
        };

        var softwareDataSource = [{text: 'Επιλογή όλων', value: 'all'}, {text: 'Όχι', value: 'none'},
            {text: $filter('translate')('global.field.software.medexpress'), value: 'medexpress'},
            {text: $filter('translate')('global.field.software.medmobile'), value: 'medmobile'},
            {text: $filter('translate')('global.field.software.other'), value: 'other'}];
        vm.softwareOptions = {
            dataSource: softwareDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            placeholder: "Επιλογή λογισμικού",
            select: function (e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();

                if (dataItem.value === "all" || dataItem.value === "none") {
                    this.value("");
                } else if (values.indexOf("all") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "all";
                    });
                    this.value(values);
                } else if (values.indexOf("none") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "none";
                    });
                    this.value(values);
                } else if (values.indexOf("other") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "other";
                    });
                    this.value(values);
                }
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {
                vm.clearDatePickers();
                $timeout(function(){
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                },0);
            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function(){
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                },0);
            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function(){
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                },0);
            }
        };

        vm.search = function () {
            if (vm.masterFilters.selectedCustomers.length || SupervisorsService.getSelectedSupervisors().length) {
                vm.mainGridOptions.dataSource.read();
            }
        };

        vm.openMenu = function($mdOpenMenu, ev) { $mdOpenMenu(ev); };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never",
                    attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.supervisorsMulti' multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.masterFilters.selectedSupervisors'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {type: "separator", overflow: "never", attributes: {class: "left"}},
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedCustomers'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Ειδικότητα: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.specialtiesMultiOptions' k-ng-model='vm.masterFilters.selectedSpecialties'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>My Target: </label><md-checkbox aria-label='saw' ng-model='vm.masterFilters.saw' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Ενεργός: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"'><label>Λογισμικό: </label><select kendo-multi-select multiple='multiple' id='multiSelect' name='multiSelect' class='inline' k-ng-model='vm.masterFilters.selectedSoftwares' " +
                    "                            k-options='vm.softwareOptions' class='col-fix'></select></div>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"'><label>Ημέρες Τελ. Επίσκεψης: </label>" +
                    "<input id='lastVisitDate' style='width: 5em;' kendo-numeric-text-box min='0' k-ng-model='vm.masterFilters.lastVisitDate.value' k-format='\"n0\"'/>" +
                    "<md-menu class='master-filter-btn'> <md-button aria-label='Open filter operators menu' class='md-icon-button' ng-click='vm.openMenu($mdOpenMenu, $event)'> " +
                    "<md-icon class='filter-list-icon'></md-icon> </md-button> " +
                    "<md-menu-content width='4'> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"eqdate\" '> Ίσο</md-button></md-menu-item> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"gte\" '> Μικρότερο ή Ίσο</md-button></md-menu-item> " +
                    "<md-menu-item> <md-button ng-click='vm.masterFilters.lastVisitDate.operator = \"lte\" '> Μεγαλύτερο ή Ίσο</md-button></md-menu-item> " +
                    "</md-menu-content> </md-menu></div>",
                    overflow: "never", attributes: {class: "left left-space"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.search()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.fromOptions = {
            change: function (e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    $timeout(function(){
                        vm.masterFilters.from = value;
                    },0);
                } else {
                    $timeout(function(){
                        vm.masterFilters.from = null;
                    },0);
                }
            }
        };

        vm.toOptions = {
            change: function (e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    $timeout(function(){
                        vm.masterFilters.to = value;
                    },0);
                } else {
                    $timeout(function(){
                        vm.masterFilters.to = null;
                    },0);
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        var dayTimeFilterTemplate = function (args) {
            KendoFilter.getDayTimeTemplate(args);
        };

        var booleanFilterTemplate = function (args) {
            KendoFilter.getBooleanTemplate(args);
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) o.data.filter = {filters: []};
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);

                        angular.forEach(o.data.filter.filters, function (item) {
                            if ( item.field === 'lastVisitDate' ) {
                                var dt = new Date();
                                dt.setDate( dt.getDate() - item.value );
                                item.value = dt;
                            }
                            if (item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        if(vm.customerView === '3') {
                            vm.customersURL = '/api/customers/main/all';
                        }

                        $http.get(vm.customersURL, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            if (item.customerCategory === null) item.customerCategory = {};
                            if (item.customerSubCategory === null) item.customerSubCategory = {};
                            if (item.doctorSpecialty === null) item.doctorSpecialty = {};
                            if (item.customerTitle === null) item.customerTitle = {};
                            if (item.sector === null || !item.sector) item.sector = {};
                            if (item.sector.sectorType === null || !item.sector.sectorType) item.sector.sectorType = {};
                            item.employeesString = "";
                            if (item.employees) {
                                item.employees.forEach(function (employeeName) {
                                    item.employeesString += "[" + employeeName + "] ";
                                });
                            }
                        });
                        return data;
                    },
                    parse: function (data) {
                        var dt = new Date();
                        dt.setHours(23, 59, 59);
                        data.forEach(function (item) {
                            item.lastVisitDate =
                                item.lastVisitDate ? Math.floor(Math.abs(new Date(item.lastVisitDate).getTime() - dt.getTime()) / (1000 * 60 * 60 * 24)) : '';
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            saw: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            isActive: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);
                                }
                            },
                            gdpr: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            lastVisitDate: { type: 'number', editable: false}
                        }
                    }
                },
                aggregate: [{field: "lastName", aggregate: "count"},
                    {field: "firstName", aggregate: "count"},
                    {field: "doctorSpecialty.name", aggregate: "count"},
                    {field: "customerCategory.name", aggregate: "count"},
                    {field: "customerSubCategory.name", aggregate: "count"},
                    {field: "cellPhone", aggregate: "count"},
                    {field: "phone", aggregate: "count"},
                    {field: "email", aggregate: "count"},
                    {field: "dayTime", aggregate: "count"},
                    {field: "customerTitle.name", aggregate: "count"},
                    {field: "isActive", aggregate: "count"},
                    {field: "gdpr", aggregate: "count"}]
            }),
            sortable: false,
            groupable: false,
            filterable: false,
            resizable: true,
            columns: [
                {
                    field: "lastName",
                    title: "Επώνυμο",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 120
                },
                {
                    field: "firstName",
                    title: "Όνομα",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 100
                },
                {
                    field: "doctorSpecialty.name",
                    title: "Ειδικοτητα 1η",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 130
                },
                {
                    field: "customerCategory.name",
                    title: "Κατηγορία",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#=  (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 70
                },
                {
                    field: "customerSubCategory.name",
                    title: "Υποκατηγορία",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= (value == null) ? '' : value #(Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 90
                },
                {
                    field: "cellPhone",
                    title: "Κινητό",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    width: 92
                },
                {
                    field: "phone",
                    title: "Σταθερό Τηλ.",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    width: 92
                },
                {
                    hidden: vm.customerView === '3',
                    field: "email",
                    title: "Email",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    width: 151
                },
                {
                    hidden: vm.customerView === '3',
                    field: "dayTime",
                    title: "Ωράριο",
                    aggregates: ["count"],
                    template: "#= (dayTime == 'day') ? 'ΠΡΩΙΝΌ' : (dayTime == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: dayTimeFilterTemplate
                        }
                    },
                    groupHeaderTemplate: "#= (value == 'day') ? 'ΠΡΩΙΝΌ' : (value == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #(Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 120
                },
                {
                    hidden: vm.customerView === '3',
                    field: "customerTitle.name",
                    title: "Τίτλος",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 120
                },
                {
                    hidden: vm.customerView === '3',
                    field: "isActive",
                    title: "Ενεργός",
                    aggregates: ["count"],
                    template: "#= (isActive == '1') ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: booleanFilterTemplate
                        }
                    },
                    groupHeaderTemplate: "#=  (value == true) ? 'Ναι'  : 'Οχι' # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 110
                },
                {
                    hidden: vm.customerView !== '6',
                    field: "gdpr",
                    title: "GDPR",
                    aggregates: ["count"],
                    template: "#= (gdpr == '1') ? 'Ναι' : 'Όχι' #",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: booleanFilterTemplate
                        }
                    },
                    groupHeaderTemplate: "#=  (value == true) ? 'Ναι'  : 'Οχι' # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    width: 110
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "sector.sectorType.name",
                    title: "Τύπος",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 105
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "sector.name", title: "Μονάδα",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 140
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "sector.osfeBrick",
                    title: "Brick ΟΣΦΕ",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 115
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "sector.cityName",
                    title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 110
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "sector.prefectureName",
                    title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 110
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "software",
                    title: "Λογισμικό",
                    template: function (dataItem) {
                        return dataItem.software ? $filter('translate')('global.field.software.' + dataItem.software ) : 'Όχι';
                    },
                    filterable: false,
                    width: 100
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "lastVisitDate", title: "Ημέρες Τελ. Επίσκεψης",
                    filterable: {
                        operators: {
                            number: {
                                eq: 'Ίσο',
                                gte: 'Μεγαλύτερο ή Ίσο',
                                lte: 'Μικρότερο ή Ίσο'
                            }
                        },
                        cell: {
                            template: function (args) {
                                args.element.kendoNumericTextBox({
                                    format: "n0",
                                    decimals: 0,
                                    min: 0
                                });

                            }
                        }
                    },
                    width: 140
                },
                {
                    hidden: vm.customerView !== '3',
                    field: "employeesString", title: "Ιατρικοί Επισκέπτες",
                    filterable: false,
                    sortable: false,
                    width: 140
                }
            ],
            toolbar: [
                {template: "<md-button class='md-raised md-mini md-primary md-primary-light' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>"},
                {template: "<md-button class='md-raised md-mini md-primary md-primary-light' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>"},
                {
                    name: "excel",
                    template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary md-primary-light k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>"
                }
            ],
            excel: {
                allPages: true,
                fileName: "Επαγγελματίες Υγείας.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Kristy on 21/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCustomerProductsAll', {
                parent: 'adminIndex',
                url: '/customerProducts/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminCustomerProductsAll/adminCustomerProductsAll.html',
                        controller: 'AdminCustomerProductsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "customerProducts"
                        }] } }} );
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 21/12/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerProductsAllController', AdminCustomerProductsAllController);

    AdminCustomerProductsAllController.$inject = ['$scope', 'employee', '$timeout', 'favouriteFilters','$http', 'FavouriteFiltersService', 'MasterToKendoFiltersService', 'KendoFilter', 'MasterFiltersService'];

    function AdminCustomerProductsAllController ($scope, employee, $timeout, favouriteFilters, $http, FavouriteFiltersService, MasterToKendoFiltersService, KendoFilter, MasterFiltersService) {
        var vm = this;

        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        vm.masterFilters = { selectedEmployees: [], selectedCustomers: [], selectedProducts: [] };
        vm.pageHeading = 'Ενημέρωση ανά Επαγγελματία Υγείας για Φαρμακα';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'customerProducts';

        var setView = function() {
            var filterable = vm.masterFilters.selectedEmployees.length && vm.masterFilters.from && vm.masterFilters.to ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedEmployees.length || !vm.masterFilters.from || !vm.masterFilters.to;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedEmployees.length && vm.masterFilters.from && vm.masterFilters.to,
                filterable: filterable
            });
        };

        $scope.$watchGroup(["vm.masterFilters.selectedEmployees", "vm.masterFilters.from", "vm.masterFilters.to"], function () { setView(); });
        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "me"]);
        vm.productsMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 150;
                    $http.get('/api/masterdata/products',
                        {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"all", name:"Επιλογή όλων", prefecture: {}});
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.productsMultiOptions = {
            dataSource: vm.productsMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            select: function(e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["all"]);
            }
        };
        vm.customersMultiOptions = MasterFiltersService.getCustomersComboBoxOptions();

        //refresh filters
        var masterFilters = [vm.employeesMultiOptions, vm.customersMultiOptions];
        angular.forEach(masterFilters, function(masterFilter) {
            masterFilter.dataSource.filter({});
        });

        //Date Filter

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.toolbarOptions = {
            items: [
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προϊόν: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.productsMultiOptions' k-ng-model='vm.masterFilters.selectedProducts'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select id='multiSelectCustomers' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.customersMultiOptions' k-ng-model='vm.masterFilters.selectedCustomers'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" }
                }
            ]
        };

        vm.fromOptions = {
            change: function() {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function() {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        vm.resetGridColumns = function() {
             return [
                {
                    field: "rowObject.name",
                    title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ];
        };

        vm.gridColumns = vm.resetGridColumns();

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) o.data.filter = { filters: [] };
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        o.data.filter.filters.push({
                            field: "event.eventCustomerSector.customerSector",
                            operator: "isnotnull",
                            value: "null"
                        });

                        $http.get('api/agreements/count-stats', {params: o.data})
                            .success(function (response) {
                                vm.gridColumns = vm.resetGridColumns();
                                o.success(response);
                                if (response.length) {
                                    angular.forEach(response[0].rowValues, function (item, index) {
                                        vm.gridColumns.push({
                                            field: "rowValues[" + index + "].value",
                                            title: "Εβδομάδα " + item.columnName.match(/[a-zA-Z]+|[0-9]+/g)[1],
                                            filterable: false
                                        });
                                    });

                                    var grid = $('#mainGrid').data('kendoGrid');
                                    grid.setOptions({
                                        columns: vm.gridColumns
                                    });
                                }
                                angular.element("#mainGrid").data("kendoGrid").refresh();
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.forEach(function(item){
                                if (!item.rowValues.length) {
                                    angular.forEach( data[0].rowValues, function (rowValue) {
                                        item.rowValues.push({columnName: rowValue.columnName, value: null})
                                    })
                                }
                            });
                        }
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false }
                        }
                    }
                }
            }),
            sortable: false,
            resizable: true,
            filterable: false,
            columns: vm.gridColumns,
            toolbar: [
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Επισκέψεις ανά Ιατρικό Επισκέπτη.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminAgreementsAll', {
                parent: 'adminIndex',
                url: '/agreements/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/adminAgreementsAll/adminAgreementsAll.html',
                        controller: 'AdminAgreementsAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "agreements"
                        }] } }} );
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 13/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminAgreementsAllController', AdminAgreementsAllController);

    AdminAgreementsAllController.$inject = ['$scope', 'employee', '$timeout', 'favouriteFilters','$http', 'FavouriteFiltersService', 'MasterToKendoFiltersService', 'SupervisorsService', 'MasterFiltersService', 'KendoFilter'];

    function AdminAgreementsAllController ($scope, employee, $timeout, favouriteFilters, $http, FavouriteFiltersService, MasterToKendoFiltersService, SupervisorsService, MasterFiltersService, KendoFilter) {
        var vm = this;

        vm.favouriteFilters = favouriteFilters.data.content;
        vm.employee = employee;
        SupervisorsService.setSelectedSupervisors([]);
        vm.masterFilters = { selectedSupervisors: SupervisorsService.getSelectedSupervisors(), selectedEmployees: [], selectedCustomers: [], selectedProducts: [], selectedAgreementValuations: [] };
        vm.pageHeading = 'Αξιολόγηση';
        vm.disabled = true;
        vm.isEdited = vm.isRenameMode = false;
        vm.selectedFilter = {};
        vm.mainGrid = {};
        vm.masterOptions = [];
        vm.filter = {};
        vm.view = 'agreements';

        var setView = function() {
            var filterable = vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length ? {
                mode: "row"
            } : false;

            vm.disabled = !vm.masterFilters.selectedEmployees.length && !SupervisorsService.getSelectedSupervisors().length;
            vm.mainGrid.setOptions({
                sortable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                groupable: vm.masterFilters.selectedEmployees.length || SupervisorsService.getSelectedSupervisors().length,
                filterable: filterable
            });
        };

        $scope.$watch("vm.masterFilters.selectedSupervisors", function (value) {
            SupervisorsService.setSelectedSupervisors(value);
            setView();
            vm.employeesMulti.enable(!vm.masterFilters.selectedSupervisors.length);
        });
        $scope.$watch("vm.masterFilters.selectedEmployees", function () {
            setView();
            vm.supervisorsMulti.enable(!vm.masterFilters.selectedEmployees.length);
        });

        vm.masterFiltersEdited = function(){
            var gridOptions = FavouriteFiltersService.getKendoOptions(vm.mainGrid);
            $timeout(function(){
                vm.isEdited = !!(vm.selectedFilter.kendoOptions && vm.masterOptions.length &&
                    (!angular.equals(vm.masterOptions, MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.view)) || !angular.equals(JSON.parse(vm.selectedFilter.kendoOptions), gridOptions)) );
            });
        };
        $scope.$watch("vm.masterFilters", vm.masterFiltersEdited, true);

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        vm.supervisorsMultiOptions = MasterFiltersService.getSupervisorsComboBoxOptions();
        vm.supervisorsMultiOptions.change = function () {
            vm.employeesMulti.value('');
            vm.employeesMultiOptions.dataSource.filter({});
            vm.masterFilters.selectedCustomers = [];
            vm.employeesMulti.dataSource.read();
        };
        vm.employeesMultiOptions = MasterFiltersService.getEmployeesComboBoxOptions(["all", "me"]);
        vm.employeesMultiOptions.dataSource.filter({});
        vm.customersMultiOptions = vm.customersMultiOptions = MasterFiltersService.getCustomersComboBoxOptions();

        vm.productsMultiDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter === undefined) o.data.filter = {filters: []};

                    o.data.page = 1;
                    o.data.pageSize = 150;
                    $http.get('/api/masterdata/products',
                        {params: o.data})
                        .success(function (response) {
                            response.content.unshift({id:"all", name:"Επιλογή όλων", prefecture: {}});
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.productsMultiOptions = {
            dataSource: vm.productsMultiDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            select: function(e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();
                var self = this;

                MasterFiltersService.selectAllNone(self, dataItem, values, ["all"]);
            }
        };

        vm.agreementValuationsMultiOptions = MasterFiltersService.getAgreementValuationsComboBoxOptions();
        //refresh filters
        var masterFilters = [vm.employeesMultiOptions, vm.customersMultiOptions, vm.agreementValuationsMultiOptions];
        angular.forEach(masterFilters, function(masterFilter) {
            masterFilter.dataSource.filter({});
        });

        //Date Filter
        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {
                vm.clearDatePickers();
                $timeout(function() {
                    vm.masterFilters.from = date;
                    vm.masterFilters.to = date;
                });

            }
            else if (e.id == "week") {
                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                $timeout(function() {
                    vm.masterFilters.from = firstWeekDay;
                    vm.masterFilters.to = lastWeekDay;
                });
            }
            else if (e.id == "month") {
                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                $timeout(function() {
                    vm.masterFilters.from = firstMonthDay;
                    vm.masterFilters.to = lastMonthDay;
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Από: </label><input class='inline' kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Εώς: </label><input class='inline' kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.supervisorsMulti' multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.masterFilters.selectedSupervisors'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.masterFilters.selectedEmployees'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Επαγγελματίας Υγείας: </label><select id='multiSelectCustomers' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.customersMultiOptions' k-ng-model='vm.masterFilters.selectedCustomers'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Προϊόν: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.productsMultiOptions' k-ng-model='vm.masterFilters.selectedProducts'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                { type: "separator", overflow: "never", attributes: { class: "left" } },
                {
                    template: "<label>Αξιολόγηση: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.agreementValuationsMultiOptions' k-ng-model='vm.masterFilters.selectedAgreementValuations'></select>",
                    overflow: "never", attributes: { class: "left" }
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" }
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.from = value;
                } else {
                    vm.masterFilters.from = null;
                }
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.masterFilters.to = value;
                } else {
                    vm.masterFilters.to = null;
                }
            }
        };

        var filterTemplate = function (args) {
            KendoFilter.getTemplate(args);
        };

        vm.mainGridOptions = {
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        vm.searchAgreementsUrl = '/api/agreements/all';
                        if (o.data.filter === undefined) o.data.filter = { filters: [] };
                        o.data.filter.filters = MasterToKendoFiltersService.getMasterFilters(o.data.filter.filters, vm.masterFilters, vm.view);
                        o.data.filter.filters.push({
                            field: "event.eventCustomerSector.customerSector",
                            operator: "isnotnull",
                            value: "null"
                        });

                        $http.get(vm.searchAgreementsUrl, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.forEach(function(item){
                                if (item.event === null) {
                                    item.event = {
                                        employee: { account: {} },
                                        eventCustomerSector: { customerSector: { customer: {} } }
                                    };
                                } else {
                                    if (item.event.eventCustomerSector === null) {
                                        item.event.eventCustomerSector = {
                                            customerSector: { customer: {} }
                                        };
                                    }
                                }
                            });
                        }
                        return data;
                    },
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            if (event != undefined) {
                                item.event_date = kendo.toString(kendo.parseDate(item.event.startedAt), 'dd/MM/yyyy');
                            }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            event_date: { type: 'date'},
                            promisedQuantity: { type: 'string'}
                        }
                    }
                },
                group: [ { field: "event_date", dir: "desc" }, { field: "event.eventCustomerSector.customerSector.customer.lastName", dir: "asc" } ]
            }),
            sortable: false,
            groupable: false,
            resizable: true,
            filterable: false,
            columns: [
                {field: "event_date", title: "Ημερομηνία Επίσκεψης", hidden: true,
                    groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')#"
                },
                {
                    field: "event_date", title: "Ημερομηνία Επίσκεψης", template: "#= kendo.toString(kendo.parseDate(event.startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.name", title: "Προϊόν",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "promisedQuantity", title: "Προβλεπόμενη Συχνότητα",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "priority", title: "Σειρά προτεραιότητας",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "agreementValuation.name", title: "Αξιολόγηση",attributes: {
                    class: "#=agreementValuation.id == '1' ? 'red' : agreementValuation.id == '2' ? 'orange' : agreementValuation.id == '3' ? 'purple' : agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                },
                {
                    field: "event.eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {field: "description", title: "Περιγραφή Αξιολόγησης",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: filterTemplate,
                            showOperators: false
                        }
                    },
                    groupable: false
                }
            ],
            toolbar: [
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>" },
                { template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>" },
                { name: "excel", template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
            ],
            excel: {
                allPages: true,
                fileName: "Αξιολόγηση.xlsx"
            },
            dataBound: function () { vm.masterFiltersEdited(); }
        };

        $timeout(function () {
            MasterFiltersService.clearFilterEvent()
        });
    }
})();
;
/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEvents', {
                parent: 'app',
                url: '/events',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminEvents/adminEvents.html',
                        controller: 'AdminEventsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEventsController', AdminEventsController);

    AdminEventsController.$inject = ['$scope', '$state','$http', '$rootScope', '$location', '$filter', 'KendoFilter', 'CustomUtils', 'customersView'];

    function AdminEventsController ($scope, $state, $http, $rootScope, $location, $filter, KendoFilter, CustomUtils, customersView) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(67);
        vm.pageHeading = 'Επισκεψεις';
        vm.eventTarget = 'all';
        vm.customerView = customersView.data.content[0].value;

        vm.toolTipOptions = {
            filter: "td span",
            position: "top",
            content: function(e){
                var element = e.target[0];
                e.sender.popup.element.css("visibility", "hidden");

                if (element.offsetWidth < element.scrollWidth) {

                    e.sender.popup.element.css("visibility", "visible");

                    return element.innerText;
                }

                return "";
            }
        };

        function onChange(arg) {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if((cellIndex === 1 || cellIndex === 2) &&
                this.dataItem(row).eventCustomerSector.sector.sectorType.sectorTypeCategory === 'hcu') {
                var customerId = this.dataItem(row).eventCustomerSector.customerSector.customer.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = customerId;
                    $state.go('customerInfo', {id: customerId, stateFrom: 'adminEvents'});
                });
            } else if(cellIndex === 13 || cellIndex === 14) {
                var userId = this.dataItem(row).employee.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = userId;
                    // $location.path('/employees/search').search({id:userId});
                    $state.go('userInfo', {id: userId, stateFrom: 'adminEvents'});
                });
            } else {
                //this.clearSelection(row); //this throws error
                this.saveChanges();
            }
        }

        $scope.googleMapsRedirect = function(dataItem) {
            if (dataItem.latitude != 0 && dataItem.longitude != 0) {
                window.open(
                    'http://maps.google.com/maps?q=' + dataItem.latitude + ',' + dataItem.longitude,
                    '_blank' //This is what makes it open in a new window.
                );
            }
        };

        $scope.imageChoice = function(dataItem) {

            if(dataItem.latitude == 0 && dataItem.latitude == 0){
                return $scope.image = "content/images/error_icon.png";
            }
            else{
                return $scope.image = "content/images/google_map.png";
            }
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        if (vm.eventTarget === 'customers'){
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnotnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        if (vm.eventTarget === 'sectors') {
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        $http.get('/api/me/events',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (options.data.filter != undefined) {
                                angular.forEach(options.data.filter.filters, function (item) {
                                    if (item.field === "startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventCustomerSector == null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                doctorSpecialty: {}
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        },
                                        sector: {
                                            address: "",
                                            city: {
                                                name: ""
                                            }
                                        },
                                        agreementValuation: {
                                            name: ""
                                        },
                                        communicationType: {
                                            name: ""
                                        }
                                    };
                                } else {
                                    if (item.eventCustomerSector.customerSector == null) {
                                        item.eventCustomerSector.customerSector = {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                doctorSpecialty: {}
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    } else {
                                        if (item.eventCustomerSector.customerSector.customer == null) {
                                            item.eventCustomerSector.customerSector.customer = {doctorSpecialty: {}}
                                        } else {
                                            if (item.eventCustomerSector.customerSector.customer.doctorSpecialty == null)
                                                item.eventCustomerSector.customerSector.customer.doctorSpecialty = {}
                                        }
                                    }

                                    if (item.eventCustomerSector.agreementValuation === null) {
                                        item.eventCustomerSector.agreementValuation = {};
                                        item.eventCustomerSector.agreementValuation.name = "";
                                    }

                                    if (item.eventCustomerSector.communicationType === null) {
                                        item.eventCustomerSector.communicationType = {};
                                        item.eventCustomerSector.communicationType.name = "";
                                    }
                                }

                                if (item.eventCustomerSector.sector == null) {
                                    item.eventCustomerSector.sector = {
                                        sectorType: {}
                                    };
                                }

                                if (item.eventCustomerSector.sector.sectorType == null) {
                                    item.eventCustomerSector.sector.sectorType = {
                                        name: ""
                                    };
                                }

                                if (item.eventStatus === null) {
                                    item.eventStatus = {};
                                    item.eventStatus.name = "";
                                }

                                if (item.eventPlace === null) {
                                    item.eventPlace = {};
                                    item.eventPlace.name = "";
                                }
                                if (item.employee === null) {
                                    item.employee = { account: { lastName: ""}};
                                }else {
                                    if (item.employee.account === null) {
                                        item.employee.account = { lastName: "" };
                                    }
                                }

                                if(item.eventCategoryType === null){
                                    item.eventCategoryType = {};
                                    if(item.eventCategory === null){
                                        item.eventCategory = {};
                                        item.eventCategory.name = "";
                                    }
                                }else{
                                    if(item.eventCategory === null){
                                        item.eventCategory = {};
                                        item.eventCategory.name = "";
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            startedAt: { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 100
            }),
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Επισκέψεις", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Επισκέψεις",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Επισκέψεις"
            },
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : ''#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : ''#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "eventCustomerSector.customerSector.customer.doctorSpecialty.name",
                            title: "Ειδικοτητα 1η",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width: 155
                        }
                    ]
                },
                {field: "startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= startedAt ? kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {field: "eventStatus.name", title: "Κατάσταση Επίσκεψης",attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                // {field: "eventCategoryType.eventCategory.name", title: "Κατηγορία Επίσκεψης",
                //     filterable: {
                //         cell: {
                //             operator: "startswith",
                //             template: function (args) {
                //                 KendoFilter.getTemplate(args);
                //             },
                //             showOperators: false
                //         }
                //     }
                // },
                {field: "eventCustomerSector.communicationType.name", title: "Τύπος Επικοινωνίας",
                    hidden: vm.customerView !== '3',
                    template: "#= (eventCustomerSector.communicationType == null || eventCustomerSector.communicationType.name == null) ? ' ' " +
                        ": eventCustomerSector.communicationType.name #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 100
                },
                {field: "eventCustomerSector.agreementValuation.name", title: "Αξιολόγηση", template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null) ? ' ' : eventCustomerSector.agreementValuation.name #",attributes: {
                    class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 100
                },
                {
                    command:[
                        {name:"map", template: "<input type='image' ng-src={{imageChoice(dataItem.eventCustomerSector)}} ng-click='googleMapsRedirect(dataItem.eventCustomerSector)' style='width: 30px;height: 30px;'/>"}
                    ],
                    attributes: { class: "#= 'link-cell-color' #" },
                    title: "Τοποθεσία",
                    width:90
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.name",
                            template: "<span>#: eventCustomerSector.sector.name # </span>", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:120
                        },
                        {field: "eventCustomerSector.sector.prefectureName", title: "Νομός",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:120
                        }
                    ]
                },
                //{field: "customer.address", title: "Διεύθυνση",
                //    filterable: {
                //        cell: {
                //            operator: "startswith",
                //            showOperators: false
                //        }
                //    }
                //},
                //{field: "customer.city.name", title: "Πόλη",
                //    filterable: {
                //        cell: {
                //            operator: "startswith",
                //            showOperators: false
                //        }
                //    }
                //},
                //{field: "customer.city.county.name", title: "Νομός",
                //    filterable: {
                //        cell: {
                //            operator: "startswith",
                //            showOperators: false
                //        }
                //    }
                //},
                // {field: "eventCustomerSector.agreedPercent", title: "Ποσοστό Συχνότητας", template: "#= (eventCustomerSector.agreedPercent == null) ? ' ' : kendo.format('{0:p0}', eventCustomerSector.agreedPercent / 100)#",
                //     filterable: {
                //         cell: {
                //             operator: "startswith",
                //             template: function (args) {
                //                 KendoFilter.getTemplate(args);
                //             },
                //             showOperators: false
                //         }
                //     }
                // },
                {
                    title: "Ιατρικός Επισκέπτης",
                    columns: [
                        {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                // {field: "description", title: "Σημειώσεις Ραντεβού",
                //     filterable: {
                //         cell: {
                //             operator: "like",
                //             template: function (args) {
                //                 KendoFilter.getTemplate(args);
                //             },
                //             showOperators: false
                //         }
                //     }
                // }
            ],
            editable: "inline",
            height: vm.contentHeight,
            selectable: "cell",
            change: onChange
        };

        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/me/agreements';
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({ "field": "event.id", "operator": "eq", "value": dataItem.id});
                                $http.get(url, {params: o.data })
                                    .success(function (response,status,headers) {
                                        vm.total = headers()['x-total-count'];
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    name: {validation: {required: true, validation: {required: true, min: 3}}}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {field: "product.name", title: "Προϊόν"},
                        {field: "description", title: "Περιγραφή Αξιολόγησης", template: "#= description == null ? ' ' : description #"},
                        {field: "promisedQuantity", title: "Προβλεπόμενη Συχνότητα"},
                        {field: "priority", title: "Σειρά προτεραιότητας"}
                    ]
                };
            }
        };

        vm.onEventTargetChange = function () {
            vm.mainGridOptions.dataSource.read();
        };
    }
})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .service('EmployeeViewService', EmployeeViewService);

    EmployeeViewService.$inject = ['$filter'];
    function EmployeeViewService ($filter) {
        var selectedUser = {};

        return {
            getSelectedUser: function () {
                return selectedUser;
            },
            setSelectedUser: function (value) {
                selectedUser = value;
            }
        };

    }
})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeSectors', {
                parent: 'adminEmployeeView',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/sectors/sectors.html',
                controller: 'AdminEmployeeViewSectorsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewSectorsController', AdminEmployeeViewSectorsController);

    AdminEmployeeViewSectorsController.$inject = ['$http', '$filter', 'KendoFilter', 'EmployeeViewService', 'CustomUtils', 'customersView'];

    function AdminEmployeeViewSectorsController ($http, $filter, KendoFilter, EmployeeViewService, CustomUtils, customersView) {
        var vm = this;
        vm.customerView = customersView.data.content[0].value;
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.selectedAssignees = [];
        vm.massSelect = vm.myTarget = true;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);

        vm.openWindow = function(){
            vm.selectedEmployees = [];

            vm.customerSectorSuggestGridOptions.dataSource.page(1);
            vm.customerSectorSuggestGridOptions.dataSource.filter({});
            vm.customerSectorSuggestGridOptions.dataSource.read();

            var wdw = angular.element("#popup-customer-sector").data("kendoWindow");
            wdw.center().open();
        };

        vm.reAssign = function () {

            vm.saveAssignees = [];

            vm.selectedAssignees.forEach(function(item,key){

                if(item.customerSector.sectorPosition) {
                    if(!item.customerSector.sectorPosition.name)
                        item.customerSector.sectorPosition = null;
                }

                vm.saveAssignees.push(
                    {
                        id: item.customerSector.id,
                        customer : {
                            id : item.customerSector.customer.id
                        },
                        sector : {
                            id : item.customerSector.sector.id
                        },
                        sectorPosition : item.customerSector.sectorPosition,
                        startedAt :  kendo.toString(item.customerSector.startedAt,"yyyy-MM-dd"),
                        endedAt : kendo.toString(item.customerSector.endedAt,"yyyy-MM-dd"),
                        phone : item.customerSector.phone,
                        employeeCustomerSectors :[
                            {active: false,
                                employee: {
                                    id: vm.selectedUser.id
                                },
                                id: item.id
                            }
                        ]
                    }
                )
            });

            var url = 'api/customer-sectors/all';

            $http.post(url, vm.saveAssignees)
                .success(function (response) {
                    angular.element("#customerSectorsGrid").data("kendoGrid").dataSource.read();
                    vm.selectedAssignees = [];
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.customerSectorGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "active", "operator": "eqbool",  "value": true }
                            ]
                        );

                        var url = "/api/employee/"+vm.selectedUser.id+"/customer-sectors";

                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(options.data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if(item.customerSector === null){
                                    item.customerSector = {};
                                }

                                if(item.customerSector.sector === null){
                                    item.customerSector.sector = {};
                                    item.customerSector.sector.name = "";
                                    item.customerSector.sector.parent = {}
                                } else if (item.customerSector.sector.parent === null) {
                                    item.customerSector.sector.parent = { name: "" };
                                }

                                if(item.customerSector.sectorType === null){
                                    item.customerSector.sectorType = {};
                                    item.customerSector.sectorType.name = "";
                                }

                                if(item.customerSector.sectorPosition === null){
                                    item.customerSector.sectorPosition = {};
                                    item.customerSector.sectorPosition.name = "";
                                }

                                if(item.customerSector.customer === null){
                                    item.customerSector.customer = {};
                                    item.customerSector.customer.lastName = "";
                                    item.customerSector.customer.firstName = "";
                                    item.customerSector.customer.doctorSpecialty = {};
                                    item.customerSector.customer.doctorSpecialty.name = "";
                                }

                                if (item.customerSector.customer.doctorSpecialty === null){
                                    item.customerSector.customer.doctorSpecialty = {};
                                    item.customerSector.customer.doctorSpecialty.name = "";
                                }

                                if (item.customerSector.customer.customerCategory === null) {
                                    item.customerSector.customer.customerCategory = {};
                                    item.customerSector.customer.customerCategory.name = "";
                                }

                                if (item.customerSector.customer.customerSubCategory === null) {
                                    item.customerSector.customer.customerSubCategory = {};
                                    item.customerSector.customer.customerSubCategory.name = "";
                                }

                                if (item.myTarget === null || item.myTarget === undefined) {
                                    item.myTarget = false;
                                }

                            });
                        }

                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            'customerSector.startedAt': { type: 'date'},
                            'customerSector.endedAt': { type: 'date'},
                            sectorParent: { from: "customerSector.sector.parent", defaultValue : { id : null, name : null} }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            height: vm.contentHeight,
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας", width: 150,
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "customerSector.sector.sectorType.name",
                    title: "Τύπος",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {
                            field: "customerSector.customer.lastName",
                            title: "Επώνυμο",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "customerSector.customer.firstName",
                            title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "customerSector.customer.doctorSpecialty.name",
                            title: "Ειδικότητα",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "customerSector.customer.customerCategory.name",
                            title: "Κατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        },
                        {
                            field: "customerSector.customer.customerSubCategory.name",
                            title: "Υποκατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        }
                    ]
                },
                {
                    field: "sectorParent.name", title: "Ανήκει στη Μ.Υ.",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                },
                {field: "customerSector.sector.address", title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.addressNum", title: "Αριθμός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "customerSector.sector.postalCode", title: "T.K.",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                },
                {field: "customerSector.sector.cityName", title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.prefectureName", title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.brick", title: "Brick",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.osfeBrick", title: "Brick ΟΣΦΕ",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sectorPosition.name", title: "Νοσοκομειακή Θέση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                },
                {field: "customerSector.phone", title: "Τηλέφωνο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                },
                {field: "customerSector.startedAt", title: "Ημερομηνία Έναρξης", template: "#= (customerSector.startedAt == null) ? '' : kendo.toString(kendo.parseDate(customerSector.startedAt), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.endedAt", title: "Ημερομηνία Λήξης", template: "#= (customerSector.endedAt == null) ? '' : kendo.toString(kendo.parseDate(customerSector.endedAt), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "myTarget",
                    title: "MyTarget",
                    filterable: {
                        cell: {
                            operator: "eqbool",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true
                                })
                            }
                        }
                    },
                    template: "#= (myTarget == '1') ? 'Ναι' : 'Όχι' #",
                    hidden: vm.customerView !== '1'
                }
            ],
            toolbar: [
                {
                    name: "Assign",
                    text: "Assign Customer Sector",
                    template: "<input id='assignToSectorsBtn' type='button' class='k-button' value = 'Ανάθεση σε Μονάδες Υγείας' ng-click='vm.openWindow()' />"//ng-if='vm.canEdit'
                },
                {
                    name: "ReAssign",
                    text: "ReAssign",
                    template: function (dataItem) {
                        return "<input type='button' class='k-button' value = 'Διαγραφή Ιατρικού Επισκέπτη από Μονάδα Υγείας' ng-click='vm.reAssign()' />" ;//ng-if='vm.canEdit'
                    }
                },
                { template: "<div class='right'><label>Σύνολο: {{vm.customerSectorGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            selectedItems: function(dataItems) {
                vm.selectedAssignees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#customerSectorsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedAssigneesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedAssignees, {id: item.id}, true)[0];
                    if(vm.selectedAssignees.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedAssigneesViewCounter++
                    }
                });
                if(selectedAssigneesViewCounter == view.length) {
                    angular.element("#customerSectorsGridcheckbox").prop('checked', true);
                }
            }
        };

        vm.gridColumns = [
            {
                field: "sector.name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.sectorType.name", title: "Τύπος",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                title: "Επαγγελματίας Υγείας",
                columns: [
                    {
                        field: "customer.lastName",
                        title: "Επώνυμο Επαγγελματία Υγείας",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "customer.firstName",
                        title: "Όνομα Επαγγελματία Υγείας",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "customer.doctorSpecialty.name",
                        title: "Ειδικότητα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            {field: "sector.postalCode", title: "T.K.",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.brick", title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.osfeBrick", title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sectorPosition.name", title: "Νοσοκομειακή Θέση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "startedAt", title: "Ημερομηνία Έναρξης", template: "#= (startedAt == null) ? '' : kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            },
            {field: "endedAt", title: "Ημερομηνία Λήξης", template: "#= (endedAt == null) ? '' : kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            }
        ];

        //This is the POPUP grid
        vm.customerSectorSuggestGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        // if(vm.canEdit) {
                        $http.get('/api/customer-sectors/employees/' + vm.selectedUser.id + '/customer-sectors/suggest',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                        // }
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){


                                if(item.sector === null){
                                    item.sector = {};
                                    item.sector.name = ""
                                }

                                if(item.sector.sectorType === null){
                                    item.sector.sectorType = {};
                                    item.sector.sectorType.name = "";
                                }

                                if(item.sectorPosition === null){
                                    item.sectorPosition = {};
                                    item.sectorPosition.name = "";
                                }


                                if(item.customer === null){
                                    item.customer = {};
                                    item.customer.lastName = "";
                                    item.customer.firstName = "";
                                    item.customer.doctorSpecialty = {};
                                    item.customer.doctorSpecialty.name = "";
                                }

                                if (item.customer.doctorSpecialty === null){
                                    item.customer.doctorSpecialty = {};
                                    item.customer.doctorSpecialty.name = "";
                                }

                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            sector: {defaultValue : { id : null, name : null}},
                            sectorPosition: {defaultValue : { id : null, name : null}},
                            startedAt: { type: 'date'},
                            endedAt: { type: 'date', defaultValue : null},
                            customer: { defaultValue : { id : null, firstName : null, lastName : null}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 10
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            selectedItems: function(dataItems) {
                vm.selectedEmployees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#customerSectorSuggestGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedEmployees) {
                    var selectedEmployeesViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedEmployees, {id: item.id}, true)[0];
                        if(vm.selectedEmployees.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedEmployeesViewCounter++
                        }
                    });
                    if(selectedEmployeesViewCounter == view.length) {
                        angular.element("#customerSectorSuggestGridcheckbox").prop('checked', true);
                    }
                }
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.customerSectorSuggestGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.closeWindow = function() {
            var wdw = angular.element("#popup-customer-sector").data("kendoWindow");
            wdw.close();
        };

        vm.saveCustomerSectors = function() {
            var wdw = angular.element("#popup-customer-sector").data("kendoWindow");


            angular.forEach( vm.selectedEmployees, function(selectedEmployee) {
                selectedEmployee.myTarget = vm.myTarget;
            });

            $http.post(' api/customer-sectors/employee/'+ vm.selectedUser.id, vm.selectedEmployees)
                .success(function (response) {
                    wdw.close();
                    vm.selectedEmployees = [];
                    angular.element("#customerSectorsGrid").data("kendoGrid").dataSource.read();
                    angular.element("#customerSectorsGrid").data("kendoGrid").refresh();
                })
                .error(function (response) {
                    console.log(response);
                });

        };
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeSchedules', {
                parent: 'adminEmployeeView',
                url: '/employeeSchedules',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/schedules/schedules.html',
                controller: 'AdminEmployeeViewEmployeeSchedulesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewEmployeeSchedulesController', AdminEmployeeViewEmployeeSchedulesController);

    AdminEmployeeViewEmployeeSchedulesController.$inject = ['ApplicationParameters', '$http', '$filter', 'EmployeeViewService', 'KendoFilter', 'CustomUtils'];

    function AdminEmployeeViewEmployeeSchedulesController (ApplicationParameters, $http, $filter, EmployeeViewService, KendoFilter, CustomUtils) {
        var vm = this;
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        ApplicationParameters.hasModule('Scheduling', true);
        vm.schedulesGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "employee.id", "operator": "eq",  "value": vm.selectedUser.id}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('/api/me/schedules',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (options.data.filter != undefined) {
                                angular.forEach(options.data.filter.filters, function (item) {
                                    if (item.field === "eventSchedule.startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventCustomerSector === null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            customer: {
                                                last_name: "",
                                                first_name: ""
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        },
                                        sector: {
                                            address: "",
                                            sectorType: {}
                                        }
                                    };
                                } else {
                                    if (item.eventCustomerSector.customerSector === null) {
                                        item.eventCustomerSector.customerSector = {
                                            customer: {
                                                last_name: "",
                                                first_name: ""
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    }

                                    if (item.eventCustomerSector.sector == null) {
                                        item.eventCustomerSector.sector = {
                                            sectorType: {}
                                        };
                                    }

                                    if (item.eventCustomerSector.sector.sectorType == null) {
                                        item.eventCustomerSector.sector.sectorType = {
                                            name: ""
                                        };
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            'eventSchedule.startedAt': { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            height: vm.contentHeight,
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "eventSchedule.startedAt", title: "Ημερομηνία Ραντεβού", template: "#= eventSchedule.startedAt ? kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        { field: "eventCustomerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "title", title: "Τίτλος",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "eventSchedule.description", title: "Σημειώσεις Ραντεβού",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.schedulesGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePurchases', {
                parent: 'adminEmployeeView',
                url: '/employeePurchases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/purchases/purchases.html',
                controller: 'AdminEmployeeViewEmployeePurchasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewEmployeePurchasesController', AdminEmployeeViewEmployeePurchasesController);

    AdminEmployeeViewEmployeePurchasesController.$inject = ['$state', '$http', '$filter', 'EmployeeViewService', 'KendoFilter', 'CustomUtils'];

    function AdminEmployeeViewEmployeePurchasesController ($state, $http, $filter, EmployeeViewService, KendoFilter, CustomUtils) {
        var vm = this;
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);

        vm.purchasesColumns = [
            {
                field: "issueDate",
                title: "Ημερομηνία",
                template: "#= kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eqdateonly",
                        showOperators: false
                    }
                }
            },
            {
                field: "purchaseStatus.name",
                title: "Κατάσταση",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.name",
                title: "Φαρμακείο",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "comment",
                title: "Σχόλια",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            },
            {
                field: "finalPrice",
                title: "Σύνολο σε €",
                filterable: {
                    cell: {
                        operator: "contains",
                        showOperators: false
                    }
                }
            }

        ];

        vm.purchasesDatasource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.filter.filters = o.data.filter.filters.concat(
                        [
                            { "field": "employee.id", "operator": "eq",  "value": vm.selectedUser.id }
                        ]
                    );

                    angular.forEach( o.data.filter.filters, function(item) {
                        if ( item.value instanceof Date) {
                            item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                        }
                    });

                    $http.get('/api/purchases/search',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema : {
                data: function (data) {
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: "id",
                        issueDate: { type: 'date', editable: false}
                    }
                }
            },
            pageSize: 100,
            serverPaging: true,
            serverSorting: true,
            scrollable:false,
            serverFiltering :true
        });

        vm.purchasesGridOptions = {
            dataSource: vm.purchasesDatasource,
            height: vm.contentHeight,
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: true,
            columns:  vm.purchasesColumns
        };

        vm.onPurchasesSelection = function(data) {
            console.log(data);
            var selectedId = data.id;
            $state.go('purchaseItems', {id: selectedId});
        };
    }

})();
;
/**
 * Created by Kristy on 22/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePharmacies', {
                parent: 'adminEmployeeView',
                url: '/pharmacies',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/pharmacies/pharmacies.html',
                controller: 'AdminEmployeeViewPharmaciesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 22/3/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewPharmaciesController', AdminEmployeeViewPharmaciesController);

    AdminEmployeeViewPharmaciesController.$inject = ['$http','KendoGrid', '$stateParams', '$filter', 'KendoFilter', 'ApplicationParameters', 'Principal', '$timeout', 'CustomUtils'];

    function AdminEmployeeViewPharmaciesController ($http, KendoGrid, $stateParams, $filter, KendoFilter, ApplicationParameters, Principal, $timeout, CustomUtils) {
        var vm = this;
        ApplicationParameters.hasModule('Visit_Pharmacies', true);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.selectedEmployees =
            vm.selectedAssignees = [];
        vm.massSelect = true;
        vm.showProgress = false;
        vm.showDeleteProgress = false;

        vm.selectedUser = {};
        vm.selectedUser.id = $stateParams.id;

        vm.sectorGrid = {};
        vm.customerSectorSuggestGrid = {};

        vm.sectorGrid.columns = [
            {
                field: "sector.name", title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.postalCode", title: "T.K.",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.brick", title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.osfeBrick", title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        vm.sectorGrid.options = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "active", "operator": "eqbool",  "value": true }
                            ]
                        );

                        var url = "/api/employee/"+vm.selectedUser.id+"/sectors";

                        o.data.sectorTypeCategory = "pharmacy";

                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if(item.customerSector === null) item.customerSector = {};
                                if (item.sector) {
                                    if(!item.sector.companyType) item.sector.companyType = {};
                                    if(!item.sector.taxOffice) item.sector.taxOffice = {};
                                } else {
                                    item.sector = {
                                        companyType: {},
                                        taxOffice: {}
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 100
            }),
            height: vm.contentHeight,
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.sectorGrid.columns,
            toolbar: [
                {
                    name: "Assign",
                    text: "Assign Customer Sector",
                    template: "<input id='assignToSectorsBtn' type='button' class='k-button' value = 'Ανάθεση σε Φαρμακεία' ng-click='vm.openWindow()' />"
                },
                {
                    name: "ReAssign",
                    text: "ReAssign",
                    template: function (dataItem) {
                        return "<input type='button' class='k-button' value = 'Διαγραφή Ιατρικού Επισκέπτη από Φαρμακεία' ng-click='vm.reAssign()' ng-show='!vm.showDeleteProgress' />" +
                            "<div class='inline' ng-show='vm.showDeleteProgress' layout-align='space-around'>" +
                            "<md-progress-circular md-mode='indeterminate' md-diameter='20px'></md-progress-circular>" +
                            "</div>" ;
                    }
                },
                { template: "<div class='right'><label>Σύνολο: {{vm.sectorGrid.options.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            selectedItems: function(dataItems) {
                vm.selectedAssignees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#sectorsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedAssigneesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedAssignees, {id: item.id}, true)[0];
                    if(vm.selectedAssignees.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedAssigneesViewCounter++
                    }
                });
                if(selectedAssigneesViewCounter == view.length) {
                    angular.element("#sectorsGridcheckbox").prop('checked', true);
                }
            }
        };

        vm.customerSectorSuggestGrid.columns = [
            {
                field: "name", title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "T.K.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "brick", title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "osfeBrick", title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        vm.customerSectorSuggestGrid.options = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        //filter pharmacies
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType.sectorTypeCategory", "operator": "eq",  "value": 'pharmacy'}
                            ]
                        );

                        $http.get('/api/customer-sectors/employees/' + vm.selectedUser.id + '/sectors/suggest',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){
                                if(!item.companyType) item.companyType = {};
                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            sector: {defaultValue : { id : null, name : null}},
                            sectorPosition: {defaultValue : { id : null, name : null}},
                            startedAt: { type: 'date'},
                            endedAt: { type: 'date', defaultValue : null},
                            customer: { defaultValue : { id : null, firstName : null, lastName : null}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                scrollable: false,
                pageSize: 100
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.customerSectorSuggestGrid.columns,
            selectedItems: function(dataItems) {
                vm.selectedEmployees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#customerSectorSuggestGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedEmployees) {
                    var selectedEmployeesViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedEmployees, {id: item.id}, true)[0];
                        if(vm.selectedEmployees.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedEmployeesViewCounter++
                        }
                    });
                    if(selectedEmployeesViewCounter == view.length) {
                        angular.element("#customerSectorSuggestGridcheckbox").prop('checked', true);
                    }
                }
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.customerSectorSuggestGrid.options.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.openWindow = function(){
            //clear selected list
            vm.statusChanged = '';
            vm.selectedEmployees = [];

            vm.customerSectorSuggestGrid.options.dataSource.page(1);
            vm.customerSectorSuggestGrid.options.dataSource.filter({});
            vm.customerSectorSuggestGrid.options.dataSource.read();

            var wdw = angular.element("#popup-sector").kendoWindow({
                close: onWindowClose
            }).data("kendoWindow");

            wdw.title("Ανάθεση Φαρμακείων");
            wdw.center().open();
        };

        vm.closeWindow = function() {
            var wdw = angular.element("#popup-sector").data("kendoWindow");
            wdw.close();
        };

        /**
         * Triggered when kendo window #popup-sector closes.
         * Used for destroying window's grid datasource for
         * performance issues.
         */
        function onWindowClose(e) {
            // Destroy dataSource before open window SIGMASF-2162
            vm.statusChanged = 'statusChanged';
            $("#customerSectorSuggestGrid").data('kendoGrid').dataSource.data([]);
        }

        var url = 'api/employee-customer-sectors/mass';

        vm.saveSectors = function() {
            vm.showProgress = true;
            var wdw = angular.element("#popup-sector").data("kendoWindow");
            var postData = [];

            vm.selectedEmployees.forEach(function(item,key){
                var newPost = {};
                newPost.active = true;
                newPost.sector = {};
                newPost.sector.id = item.id;
                newPost.employee = {};
                newPost.employee.id = vm.selectedUser.id;
                postData.push(newPost)
            });

            $http.post(url, postData, {})
                .success(function (response) {
                    vm.showProgress = false;
                    wdw.close();
                    vm.selectedEmployees = [];
                    // KendoGrid.refresh(vm.customerSectorSuggestGrid.οptions);
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    angular.element("#sectorsGrid").data("kendoGrid").refresh();
                })
                .error(function (response) {
                    vm.showProgress = false;
                    console.log(response);
                });
        };

        vm.reAssign = function () {
            vm.showDeleteProgress = true;
            var postData = [];

            vm.selectedAssignees.forEach(function(item,key){
                var newPost = {};
                newPost.active = false;
                newPost.sector = {};
                newPost.sector.id = item.sector.id;
                newPost.employee = {};
                newPost.employee.id = vm.selectedUser.id;
                postData.push(newPost)
            });

            $http.post(url, postData, {})
                .success(function (response) {
                    vm.showDeleteProgress = false;
                    vm.selectedAssignees = [];
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    angular.element("#sectorsGrid").data("kendoGrid").refresh();
                    // KendoGrid.refresh(vm.sectorGrid.οptions);
                })
                .error(function (response) {
                    vm.showDeleteProgress = false;
                    console.log(response);
                });

        };

        if (!Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR'])){
            $timeout(function (){
                angular.element("#sectorsGrid .k-grid-toolbar").hide();
            }, 0);
        }
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePatchReports.pendingHistory', {
                parent: 'employeePatchReports',
                url: '/pendingHistory',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR']
                },
                templateUrl: 'app/displays/adminEmployees/patchReports/pendingHistory/pendingHistory.html',
                controller: 'AdminEmployeesPendingHistoryPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeesPendingHistoryPatchReportsController', AdminEmployeesPendingHistoryPatchReportsController);

    AdminEmployeesPendingHistoryPatchReportsController.$inject = ['$http','$state', '$q', '$stateParams','$filter', '$timeout', 'PatchItemMasterFilter', 'DetailGridsService'];

    function AdminEmployeesPendingHistoryPatchReportsController ($http, $state, $q, $stateParams, $filter, $timeout, PatchItemMasterFilter, DetailGridsService) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;
        vm.detailGridsService = DetailGridsService;
        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.pendingHistoryGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "patchStatus", "operator": "eq",
                                    "value": 'executed' },
                                { "field": "employee.id", "operator": "eq",
                                    "value": vm.selectedUserId }
                            ]
                        );

                        if(PatchItemMasterFilter.getSelectedPatchItems().length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "patchReportItems.patchItem.id", "operator": "in",
                                        "value": PatchItemMasterFilter.getSelectedPatchItems().toString() }
                                ]
                            );
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/me/patch-reports',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.materialCategory === null)
                                    item.materialCategory = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            issueDate: { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                    template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.address", title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.cityName", title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.firstName", title: "Όνομα Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "barcode", title: "Barcode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "materialCategory.name", title: "Κατηγορία Υλικού",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                },
                {field: "submitPoint", title: "Σημείο Υποβολής",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false
                        }
                    }
                }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingHistoryGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.patchReportItemsGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/me/patch-report-items';
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                $http.get(url, {params: o.data })
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {field: "patchItem.name", title: "Περιγραφή Υλικού",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "monthlyQuantity", title: "Μηνιαία Ποσότητα σε τεμάχια",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "icd10.code", title: "Κωδικός Διάγνωσης",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "icd10.description", title: "Περιγραφή Διάγνωσης",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        }
                    ]
                };
            }
        };

        vm.patchReportPhotosGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/me/patch-report-photos';
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                $http.get(url, {params: o.data })
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {field: "patchPhotoName", title: "Όνομα αρχείου",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                            template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            }
                        },
                        {
                            command:[
                                { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                            ],
                            title: "&nbsp",
                            width:90
                        }
                    ]
                };
            }
        };
    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePatchReports.pending', {
                parent: 'employeePatchReports',
                url: '/pending',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR']
                },
                templateUrl: 'app/displays/adminEmployees/patchReports/pending/pending.html',
                controller: 'AdminEmployeesPendingPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeesPendingPatchReportsController', AdminEmployeesPendingPatchReportsController);

    AdminEmployeesPendingPatchReportsController.$inject = ['$http', '$q','$filter', '$stateParams', 'NotificationOptions', 'DetailGridsService', 'Principal', 'PatchItemMasterFilter'];

    function AdminEmployeesPendingPatchReportsController ($http, $q, $filter, $stateParams, NotificationOptions, DetailGridsService, Principal, PatchItemMasterFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;
        vm.selectedUserId = $stateParams.id;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.executePatchReport = function(e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            var data = this.dataItem(tr);

            $http.put('api/patch-reports/' + data.id + '/execute', data)
                .success(function (response,status,headers) {
                    notification.show({
                        message: "Η εγγραφή εκτελέστηκε με επιτυχία!"
                    }, "success");
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });
        };

        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.gridColumns = [
            {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.firstName", title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "barcode", title: "Barcode",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "materialCategory.name", title: "Κατηγορία Υλικού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            },
            {field: "submitPoint", title: "Σημείο Υποβολής",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false
                    }
                }
            }
        ];

        vm.pendingGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "patchStatus", "operator": "eq",
                                    "value": 'pending' },
                                { "field": "employee.id", "operator": "eq",
                                    "value": vm.selectedUserId }
                            ]
                        );

                        if(PatchItemMasterFilter.getSelectedPatchItems().length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "patchReportItems.patchItem.id", "operator": "in",
                                        "value": PatchItemMasterFilter.getSelectedPatchItems().toString() }
                                ]
                            );
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/me/patch-reports',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.materialCategory === null)
                                    item.materialCategory = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            issueDate: { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.patchReportPhotosGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function (o) {
                                var url = '/api/me/patch-report-photos';
                                if (o.data.filter == undefined) {
                                    o.data.filter = {filters: []};
                                }
                                o.data.filter.filters.push({
                                    "field": "patchReport.id",
                                    "operator": "eq",
                                    "value": dataItem.id
                                });
                                $http.get(url, {params: o.data})
                                    .success(function (response, status, headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {
                            field: "patchPhotoName", title: "Όνομα αρχείου",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                            template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#",
                            filterable: {
                                cell: {
                                    operator: "eq",
                                    showOperators: false
                                }
                            }
                        },
                        {
                            command: [
                                {name: "show", text: "Προβολή", click: vm.openPhotoWindow}
                            ],
                            title: "&nbsp",
                            width: 90
                        }
                    ]
                };
            }
        }

        Principal.hasAuthority('ROLE_MANAGEMENT').then( function (result) {
            if (result) {
                vm.gridColumns.unshift({
                    command:[
                        { name:"execute", text: "Εκτέλεση", click: vm.executePatchReport }
                    ],
                    attributes: { class: "#= 'green-color' #" },
                    title: "&nbsp",
                    width:90
                });

                vm.pendingGrid.setOptions({
                    columns: vm.gridColumns
                });
            }
        });
    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePatchReports', {
                parent: 'adminEmployeeView',
                url: '/patchReports',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/patchReports/patchReports.html',
                controller: 'AdminEmployeeViewPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewPatchReportsController', AdminEmployeeViewPatchReportsController);

    AdminEmployeeViewPatchReportsController.$inject = ['$http','$state', '$stateParams', '$filter', 'PatchItemMasterFilter', 'ApplicationParameters'];

    function AdminEmployeeViewPatchReportsController ($http, $state, $stateParams, $filter, PatchItemMasterFilter, ApplicationParameters) {
        var vm = this;
        vm.selectedPatchItems = PatchItemMasterFilter.getSelectedPatchItems();
        ApplicationParameters.hasModule('Patches', true);

        vm.patchItemsMultiOptions = PatchItemMasterFilter.getPatchItemsMultiOptions();

        vm.toolbarOptions = {
            items: [
                { template: "<label>Επίθεμα: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.patchItemsMulti' multiple='multiple' " +
                "k-options='vm.patchItemsMultiOptions' k-ng-model='vm.selectedPatchItems'></select>", overflow: "never" }
            ]
        };
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider

            .state('employeeMedReportsWithLines', {
                parent: 'employeeMedReports',
                url: '/with-lines',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/medReports/medReportWithLines/medReportWithLines.html',
                controller: 'AdminEmployeeViewMedReportsWithLinesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewMedReportsWithLinesController', AdminEmployeeViewMedReportsWithLinesController);

    AdminEmployeeViewMedReportsWithLinesController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'CustomUtils', 'KendoService', 'MasterFilters'];

    function AdminEmployeeViewMedReportsWithLinesController ($http, $state, $stateParams, $filter, Principal, KendoFilter, CustomUtils, KendoService, MasterFilters) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        vm.masterFilters = { selectedMonths: [], selectedYears: [], isActive: true };

        vm.medReportsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "isActive", "operator": "eqbool", "value": vm.masterFilters.isActive }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "employee.id", "operator": "eq",  "value": vm.selectedUserId}
                            ]
                        );

                        if (vm.masterFilters.selectedMonths.length > 0) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "fromDate", "operator": "inMonths",
                                        "value": vm.masterFilters.selectedMonths.toString() },
                                    { "field": "toDate", "operator": "inMonths",
                                        "value": vm.masterFilters.selectedMonths.toString() }
                                ]
                            );
                        }

                        if (vm.masterFilters.selectedYears.length > 0) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "fromDate", "operator": "inYears",
                                        "value": vm.masterFilters.selectedYears.toString() },
                                    { "field": "toDate", "operator": "inYears",
                                        "value": vm.masterFilters.selectedYears.toString() }
                                ]
                            );
                        }

                        $http.get('/api/me/med-reports',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){
                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            fromDate: { type: 'date'},
                            toDate: { type: 'date'},
                            checkDigit1: { type: 'number'},
                            checkDigit2: { type: 'number'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50
            }),
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "cell",
            columns: [
                {
                    field: "fromDate",
                    title: "Μήνας",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'MMMM')#",
                    filterable: false
                },
                {
                    field: "toDate",
                    title: "Έτος",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'yyyy')#",
                    filterable: false
                },
                {
                    field: "checkDigit1", title: "Check Digit",
                    filterable: false,
                    width: 140
                },
                {
                    field: "checkDigit2", title: "Check Digit 2",
                    filterable: false,
                    width: 140
                },
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                },
                {field: "customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.medReportsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }],
            change: onChange
        };

        vm.medReportLinesGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                vm.showProgress = true;
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "medReport.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/med-report-lines/search',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                        vm.showProgress = false;
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                if(data != undefined) {
                                    data.content.forEach(function(item){
                                    });
                                }
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    sum: { type: "number" },
                                    marketSharePercentage: { type: "number" },
                                    numberOfChanges: { type: "number" }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {field: "medicine.name", title: "Όνομα Σκευάσματος",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "medicine.barcode", title: "Barcode Σκευάσματος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "sum", title: "Σύνολο",
                            filterable: {
                                operators: {
                                    number: {
                                        eq: 'Ίσο',
                                        gte: 'Μεγαλύτερο ή Ίσο',
                                        lte: 'Μικρότερο ή Ίσο'
                                    }
                                },
                                cell: {
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "n0",
                                            decimals: 0,
                                            min: 0
                                        });

                                    }
                                }
                            }
                        },
                        // {
                        //     field: "marketSharePercentage",
                        //     title: "Μερίδιο Αγοράς (%)",
                        //     attributes:{style:"text-align:right;"},
                        //     template: "#= (marketSharePercentage == null) ? '' : kendo.format('{0:p0}', marketSharePercentage / 100)#",
                        //     filterable: {
                        //         cell: {
                        //             operator: "eq",
                        //             template: function (args) {
                        //                 args.element.kendoNumericTextBox({
                        //                     format: "{0:n0}"
                        //                 });
                        //             },
                        //             showOperators: false
                        //         }
                        //     }
                        // },
                        // {
                        //     field: "numberOfChanges", title: "Αριθμός Αλλαγών",
                        //     filterable: {
                        //         operators: {
                        //             number: {
                        //                 eq: 'Ίσο',
                        //                 gte: 'Μεγαλύτερο ή Ίσο',
                        //                 lte: 'Μικρότερο ή Ίσο'
                        //             }
                        //         },
                        //         cell: {
                        //             template: function (args) {
                        //                 args.element.kendoNumericTextBox({
                        //                     format: "n0",
                        //                     decimals: 0,
                        //                     min: 0
                        //                 });
                        //
                        //             }
                        //         }
                        //     }
                        // }
                    ],
                    editable: false
                };
            }
        };

        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.masterFilters.selectedYears.push(years[0].value); //2020
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτη: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.yearsMultiOptions' k-ng-model='vm.masterFilters.selectedYears'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Ενεργό: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.search()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.search = function () {
            vm.medReportsGridOptions.dataSource.read();
        };

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 5 || cellIndex === 6) {
                $state.go('customerInfo', {id: this.dataItem(row).customer.id});
            }
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeMedReportsSumsPerMonth', {
                parent: 'employeeMedReports',
                url: '/per-month',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/medReports/medReportSumsPerMonth/medReportSumsPerMonth.html',
                controller: 'AdminEmployeeViewMedReportsSumsPerMonthController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 11/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewMedReportsSumsPerMonthController', AdminEmployeeViewMedReportsSumsPerMonthController);

    AdminEmployeeViewMedReportsSumsPerMonthController.$inject = ['$scope', '$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'CustomUtils', 'KendoService', 'Alerts', '$timeout'];

    function AdminEmployeeViewMedReportsSumsPerMonthController ($scope, $http, $state, $stateParams, $filter, Principal, KendoFilter, CustomUtils, KendoService, Alerts, $timeout) {
        var vm = this;
        var aggregates = [];
        vm.selectedUserId = $stateParams.id;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        vm.masterFilters = { selectedMonths: [], selectedMedicines: [], isActive: true };
        angular.forEach(moment.months(), function (value, key) {
            if (key <= new Date().getMonth()) {
                vm.masterFilters.selectedMonths.push(key + 1);
            }
        });

        var medicinesDatasource = KendoService.initDataSource('/api/medicines/search', 1, 50);
        vm.medicinesMultiOptions = KendoService.initDefaultOptions(medicinesDatasource, "startswith", "name", "id", true);
        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.masterFilters.selectedYear = years[0].value; //2020
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Σκευάσματα: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.medicinesMultiOptions' k-ng-model='vm.masterFilters.selectedMedicines'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτος: </label><select id='comboBox' name='comboBox' class='inline widgets-s' kendo-combo-box k-options='vm.yearsMultiOptions' " +
                        "k-ng-model='vm.masterFilters.selectedYear'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                // {
                //     template: "<label>Ενεργό: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                //     overflow: "never", attributes: {class: "left"}
                // },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.getData()' ng-disabled='!vm.masterFilters.selectedYear'>" +
                        "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.getData = function () {
            $("#medReportSumsGrid").data().kendoGrid.destroy();
            $("#medReportSumsGrid").empty();
            vm.showProgress = true;
            $http.get("/api/med-reports/employee/sums-per-month?years=" + vm.masterFilters.selectedYear + "&months=" + vm.masterFilters.selectedMonths
                + "&medicines=" + vm.masterFilters.selectedMedicines
                + "&employee=" + vm.selectedUserId)
                .success(function (response) {
                    vm.showProgress = false;
                    generateGrid(response);
                })
                .error(function (error) {
                    vm.showProgress = false;
                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                });
        };

        function generateGrid(response){
            aggregates = [];
            $("#medReportSumsGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            if (data !== null && data !== undefined && data.length > 0){
                                for ( var i=0; i < data.length; i++) {
                                    data[i].total = 0;
                                    for ( var j=0; j < data[i].results.length; j++) {
                                        if (!data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month])
                                            data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month] = 0;
                                        data[i]["medicine" + data[i].results[j].medicine.id + "month" + data[i].results[j].month] += data[i].results[j].sum;
                                        data[i].total += data[i].results[j].sum;
                                    }
                                }
                            }
                            return data;
                        }
                    },
                    sort: { field: "total", dir: "desc" },
                    aggregate: aggregates
                },
                selectable: "cell",
                columns: generateColumns(response),
                toolbar: [
                    { name: "excel", template: "<div class='right'><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                            "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
                ],
                change: onChange,
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Σκευασμάτων.xlsx"
                },
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#medReportSumsGrid"));
                    });
                }
            });
        }

        function generateColumns(response){
            var columns = [];
            columns.push({
                field: "customer.lastName",
                attributes: {
                    class: "link-cell link-cell-color"
                },
                template: "#=customer.lastName + ' ' + customer.firstName#",
                title: "Επαγγελματίας Υγείας",
                footerTemplate: "Σύνολο: ",
                width: "370px"
            });
            var date = new Date();
            var medicineIterations = []; // dummy initial medicine
            for (var k=0; k<response.length; k++) {
                for (var i = 0; i < response[k].results.length; i++) {
                    vm.result = response[k].results[i];
                    if (!medicineIterations.includes(response[k].results[i].medicine.id)) {

                        // Add a new title column
                        date.setMonth(response[k].results[i].month - 1);
                        aggregates.push({
                            field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                            aggregate: "sum"
                        });
                        // angular.element("#mainGrid").data("kendoGrid").dataSource.options.schema.model.fields["medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month] = {defaultValue : 0};
                        columns.push({
                            title: response[k].results[i].medicine.name,
                            columns: [{
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            }]
                        });
                    } else {
                        date.setMonth(response[k].results[i].month - 1);
                        var foundColumnByTitle = $filter('filter')(columns, {title: response[k].results[i].medicine.name}, true)[0];
                        var foundInnerColumnByField = $filter('filter')(columns[columns.indexOf(foundColumnByTitle)].columns,
                            {field:  "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month}, true)[0];

                        if (!columns[columns.indexOf(foundColumnByTitle)].columns[columns[columns.indexOf(foundColumnByTitle)].columns.indexOf(foundInnerColumnByField)]) {
                            aggregates.push({
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month,
                                aggregate: "sum"
                            });
                            columns[columns.indexOf(foundColumnByTitle)].columns.push({
                                field: "medicine" + response[k].results[i].medicine.id + "month" + response[k].results[i].month ,
                                aggregates: ["sum"],
                                title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                            });
                        }
                    }

                    medicineIterations.push(response[k].results[i].medicine.id); // hold medicine.id, to know if new
                }
            }
            aggregates.push({ field: "total", aggregate: "sum" });
            columns.push({
                field: "total",
                title: "Σύνολο",
                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#",
                width: "100px"
            });

            return columns;
        }

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 0) {
                $state.go('customerInfo', {id: this.dataItem(row).customer.id});
            }
        }
    }

})();
;
/**
 * Created by Kristy on 20/1/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeMedReports', {
                parent: 'adminEmployeeView',
                url: '/medReports',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/medReports/medReports.html',
                controller: 'AdminEmployeeViewMedReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 20/1/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewMedReportsController', AdminEmployeeViewMedReportsController);

    AdminEmployeeViewMedReportsController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'CustomUtils', 'KendoService', 'MasterFilters'];

    function AdminEmployeeViewMedReportsController ($http, $state, $stateParams, $filter, Principal, KendoFilter, CustomUtils, KendoService, MasterFilters) {
        var vm = this;
        vm.$state = $state;
    }

})();
;
/**
 * Created by Teo on 07/08/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('userInfo', {
                parent: 'adminEmployeeView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/info/info.html',
                controller: 'AdminEmployeeViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    selectedEmployee: ['$http', '$stateParams', function ($http, $stateParams) {
                        return $http.get('api/employees/' + $stateParams.id).then(function (response) {
                            return response.data;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 07/08/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewInfoController', AdminEmployeeViewInfoController);

    AdminEmployeeViewInfoController.$inject = ['$http', '$window', 'EmployeeViewService', 'NotificationOptions', 'ApplicationParameters', 'Principal', 'selectedEmployee', '$mdToast'];

    function AdminEmployeeViewInfoController ($http, $window, EmployeeViewService, NotificationOptions, ApplicationParameters, Principal, selectedEmployee, $mdToast) {
        var vm = this;
        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN']);
        ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
            vm.hasModulePurchasePharmacies = response.data.content[0].value === "1";
        });
        vm.productCategoriesOptions = {
            placeholder: "Επιλέξτε κατηγορίες...",
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        o.data.page = 1;
                        o.data.pageSize = 10000;
                        $http.get('/api/masterdata/product-categories',
                            {params: o.data})
                            .success(function (response) {
                                response.content.unshift({id:"none", name :"(Κενό)"});
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            }),
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.purchaseNumberingRowsOptions = {
            placeholder: "Επιλέξτε σειρές αρίθμησης...",
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        o.data.page = 1;
                        o.data.pageSize = 10000;
                        $http.get('/api/purchase-numbering-rows/search',
                            {params: o.data})
                            .success(function (response) {
                                response.content.unshift({id:"none", name :"(Κενό)"});
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            }),
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.authoritiesOptions = {
            placeholder: "Επιλέξτε ρόλους...",
            dataSource: [
                "ROLE_USER",
                "ROLE_HEALTH_VISITOR",
                "ROLE_ADMIN",
                "ROLE_MANAGEMENT",
                "ROLE_SUPERVISOR",
                "ROLE_PATCH_VISITOR",
                "ROLE_PHARM_VISITOR",
                "ROLE_ACCOUNTING_DEP",
                "ROLE_STOREHOUSE",
                "ROLE_REC_HEALTH_VISITOR",
                "ROLE_REC_MANAGEMENT",
                "ROLE_REC_ADMINISTRATOR",
                "ROLE_REC_FRONT_DESK",
                "ROLE_BC_VISITOR",
                "ROLE_PHARM_SUPERVISOR",
                "ROLE_BI_VIEWER",
                "ROLE_CHECKER"
            ]
        };
        vm.districtComboBoxOptions = {
            dataSource: [
                { id: 1, name: 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ' },
                { id: 2, name: 'ΝΟΤΙΑ ΕΛΛΑΔΑ' },
                { id: 3, name: 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ' }
            ],
            valuePrimitive: false,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή περιοχής..."
        };
        vm.employeesComboBoxOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function(o) {
                        var url = '/api/employees/available-supervisors';

                        $http.get(url, {params: {id: selectedEmployee.id}})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    parse: function (data) {
                        data.forEach( function (item) {
                            item.name = item.account.lastName + " " + item.account.firstName;
                        });
                        return data;
                    }
                },
                sort:{field:"account.lastName", dir:"asc"}
            }),
            filter: "contains",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };
        vm.employee = selectedEmployee;
        setDistinct();
        setSupervisor();
        $http.get('api/users/' + vm.employee.account.login).success(function (response) {
            vm.employee.account = response;
        }).error(function (error) {
            console.log(error);
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Κάποιο σφάλμα προέκυψε κατά την λήψη Πληρφοριών Χρήστη!')
                    .position('bottom right')
                    .hideDelay(2500));
        });

        var userValidator = angular.element("#form").kendoValidator({}).data("kendoValidator");
        vm.updateUser = function() {
            var updatedUser = angular.copy(vm.employee.account);
            if (userValidator.validate()) {
                $http.put('/api/users', updatedUser)
                    .success(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Επιτυχής ενημέρωση Χρήστη')
                                .position('bottom right')
                                .hideDelay(2000));
                    })
                    .error(function (error) {
                        console.log(error);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Κάποιο σφάλμα προέκυψε κατά την ενημέρωση Χρήστη!')
                                .position('bottom right')
                                .hideDelay(2500));
                    });
            }
        };

        var employeeValidator = angular.element("#form").kendoValidator({
            rules: {
                custom: function (input) {

                    if (input.data('custom')) {
                        console.log("-=-=-=-=-");
                        console.log(input.data('custom'));
                        if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
            messages: {
                custom: "Πρέπει να επιλέξετε από την λίστα",
                maxlength: "Το Τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
            }
        }).data("kendoValidator");
        vm.updateEmployee = function () {
            var updatedEmployee = angular.copy(vm.employee);
            if(updatedEmployee.district) {
                if (updatedEmployee.district.id === 1) {
                    updatedEmployee.district = 'north';
                } else if (updatedEmployee.district.id === 2) {
                    updatedEmployee.district = 'south';
                } else if (updatedEmployee.district.id === 3) {
                    updatedEmployee.district = 'westAndPeloponnese';
                }
            }

            if (updatedEmployee.supervisor === null || updatedEmployee.supervisor === undefined ||
                updatedEmployee.supervisor.id === null || updatedEmployee.supervisor.id === undefined) {
                updatedEmployee.supervisor = null;
            }

            if (employeeValidator.validate()) {
                $http.put('/api/employees', updatedEmployee)
                    .success(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Επιτυχής ενημέρωση Ιατρικού Επισκέπτη')
                                .position('bottom right')
                                .hideDelay(2000));
                    })
                    .error(function (error) {
                        console.log(error);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Κάποιο σφάλμα προέκυψε κατά την ενημέρωση Ιατρικού Επισκέπτη!')
                                .position('bottom right')
                                .hideDelay(2500));
                    });
            }
        };

        vm.onOsVersionInfoClick = function () {
            $window.open('https://el.wikipedia.org/wiki/%CE%99%CF%83%CF%84%CE%BF%CF%81%CE%AF%CE%B1_%CE%B5%CE%BA%CE%B4%CF%8C%CF%83%CE%B5%CF%89%CE%BD_%CF%84%CE%BF%CF%85_Android', '_blank');
        };

        function setDistinct() {
            if(vm.employee.district === 'north') {
                vm.employee.district = { id: 1, name: vm.north };
            } else if(vm.employee.district === 'south') {
                vm.employee.district = { id: 2, name: vm.south };
            } else if(vm.employee.district === 'westAndPeloponnese') {
                vm.employee.district = { id: 3, name: vm.westAndPeloponnese };
            }
        }

        function setSupervisor() {
            if (vm.employee.supervisor) {
                vm.employee.supervisor.name =
                    vm.employee.supervisor.account.lastName + " " + vm.employee.supervisor.account.firstName;
            }
        }
    }
})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeEvents', {
                parent: 'adminEmployeeView',
                url: '/employeeEvents',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/events/events.html',
                controller: 'AdminEmployeeViewEmployeeEventsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewEmployeeEventsController', AdminEmployeeViewEmployeeEventsController);

    AdminEmployeeViewEmployeeEventsController.$inject = ['$scope', '$http', '$filter', 'EmployeeViewService', 'KendoFilter', 'CustomUtils', 'customersView'];

    function AdminEmployeeViewEmployeeEventsController ($scope, $http, $filter, EmployeeViewService, KendoFilter, CustomUtils, customersView) {
        var vm = this;
        vm.customerView = customersView.data.content[0].value;
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);
        vm.myTarget = true;

        vm.clearDatePickers = function () {
            angular.element('#masterFiltersEvents').find('#from').data('kendoDatePicker').value("");
            angular.element('#masterFiltersEvents').find('#to').data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = $filter('date')(date, 'yyyy-MM-dd');
                vm.to = $filter('date')(date, 'yyyy-MM-dd');

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = $filter('date')(firstWeekDay, 'yyyy-MM-dd');
                vm.to = $filter('date')(lastWeekDay, 'yyyy-MM-dd');

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = $filter('date')(firstMonthDay, 'yyyy-MM-dd');
                vm.to = $filter('date')(lastMonthDay, 'yyyy-MM-dd');
            }

            if ( e.target != undefined) {
                angular.element("#eventsGrid").data("kendoGrid").dataSource.read();
            } else {
                angular.element("#eventsGrid").data("kendoGrid").dataSource.read();
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], attributes: { class: "buttonGroup" }
                },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions' class='from'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions' class='to'/>",
                    overflow: "never"
                },
                { type: "separator" },
                {
                    template: "<label class='left-space'>My Target: </label><div class='inline'>" +
                    "<md-radio-group class='left-space' layout='row' ng-change='vm.eventsGridOptions.dataSource.page(1).read()' ng-model='vm.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value=null class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left-space"}
                },
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('.buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                vm.from = $filter('date')(value, 'yyyy-MM-dd');
                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('.buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                vm.to = $filter('date')(value, 'yyyy-MM-dd');
                vm.masterFiltersOnClick(e);
            }
        };

        $scope.googleMapsRedirect = function(dataItem) {
            if (dataItem.latitude != 0 && dataItem.longitude != 0) {
                window.open(
                    'http://maps.google.com/maps?q=' + dataItem.latitude + ',' + dataItem.longitude,
                    '_blank' //This is what makes it open in a new window.
                );
            }
        };

        $scope.imageChoice = function(dataItem) {
            if(dataItem.latitude == 0 && dataItem.latitude == 0){
                return $scope.image = "content/images/error_icon.png";
            }
            else{
                return $scope.image = "content/images/google_map.png";
            }
        };

        vm.eventsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "employee.id", "operator": "eq",  "value": vm.selectedUser.id}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        //master filters functionality
                        if(vm.from && vm.to) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "startedAt", "operator": "from",  "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "startedAt", "operator": "to",  "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ]
                            );
                        }

                        // MyTarget
                        if (vm.myTarget !== null) {
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector.employeeCustomerSectors.myTarget",
                                operator: "eqbool",
                                "value": vm.myTarget // vm.myTarget === null ? 'all' : vm.myTarget
                            });
                        }

                        $http.get('/api/me/events',
                            {params: o.data})
                            .success(function (response) {
                                console.log(response);
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        if(data !== undefined) {
                            data.content.forEach(function(item){

                                if (item.eventStatus === null) {
                                    item.eventStatus = {};
                                    item.eventStatus.name = "";
                                }

                                if (item.eventCustomerSector === null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                customerCategory: {
                                                    name: ""
                                                },
                                                customerSubCategory: {
                                                    name: ""
                                                }
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        },
                                        agreementValuation: {
                                            name: ""
                                        }
                                    };
                                } else {
                                    if (item.eventCustomerSector.agreementValuation === null) {
                                        item.eventCustomerSector.agreementValuation = {
                                            name: ""
                                        };
                                    }
                                    if (item.eventCustomerSector.customerSector === null) {
                                        item.eventCustomerSector.customerSector = {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                customerCategory: {
                                                    name: ""
                                                },
                                                customerSubCategory: {
                                                    name: ""
                                                }
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    }else {
                                        if (item.eventCustomerSector.customerSector.customer === null) {
                                            item.eventCustomerSector.customerSector.customer = {
                                                last_name: "",
                                                first_name: "",
                                                customerCategory: {
                                                    name: ""
                                                },
                                                customerSubCategory: {
                                                    name: ""
                                                }
                                            };
                                        }else {
                                            if (item.eventCustomerSector.customerSector.customer.customerCategory === null) {
                                                item.eventCustomerSector.customerSector.customer.customerCategory = {
                                                    name: ""
                                                }
                                            }

                                            if (item.eventCustomerSector.customerSector.customer.customerSubCategory === null) {
                                                item.eventCustomerSector.customerSector.customer.customerSubCategory = {
                                                    name: ""
                                                }
                                            }
                                        }

                                        if (item.eventCustomerSector.customerSector.sector === null) {
                                            item.eventCustomerSector.customerSector.sector = {
                                                address: "",
                                                    city: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    }
                                }

                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}} },
                            startedAt: { type: 'date'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50,
            }),
            height: vm.contentHeight,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Επισκέψεις", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Επισκέψεις",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.customerCategory.name", title: "Κατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        },
                        {field: "eventCustomerSector.customerSector.customer.customerSubCategory.name", title: "Υποκατηγορία",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        }
                    ]
                },
                {field: "startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }},
                {field: "eventStatus.name", title: "Κατάσταση Επίσκεψης",attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "eventCustomerSector.agreementValuation.name", title: "Αξιολόγηση", template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null ) ? ' ' : eventCustomerSector.agreementValuation.name #",
                    attributes: {   class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {
                    command:[
                        {name:"map", template: "<input type='image' ng-src={{imageChoice(dataItem.eventCustomerSector)}} ng-click='googleMapsRedirect(dataItem.eventCustomerSector)' style='width: 30px;height: 30px;'/>"} ],
                    attributes: { class: "#= 'link-cell-color' #" },
                    title: "Τοποθεσία",
                    width:120
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView === '1' || vm.customerView === '6'
                        },
                        {field: "eventCustomerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.prefectureName", title: "Νομός",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        },
                        {field: "eventCustomerSector.sector.osfeBrick", title: "Brick ΟΣΦΕ",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            hidden: vm.customerView !== '1'
                        }
                    ]
                },
                {
                    field: "eventCustomerSector.agreedPercent",
                    title: "Ποσοστό Συχνότητας",
                    template: "#= (eventCustomerSector.agreedPercent == null) ? ' ' : kendo.format('{0:p0}', eventCustomerSector.agreedPercent / 100)#",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                 },
                {field: "description", title: "Σημειώσεις",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    hidden: vm.customerView === '1' || vm.customerView === '6'}
            ],
            noRecords: {
                template: "Δεν βρέθηκαν Επισκέψεις"
            }
        };
    }
})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeInfo', {
                parent: 'adminEmployeeView',
                url: '/employeeInfo',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/employeeInfo/info.html',
                controller: 'AdminEmployeeViewEmployeeInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewEmployeeInfoController', AdminEmployeeViewEmployeeInfoController);

    AdminEmployeeViewEmployeeInfoController.$inject = ['$http', '$window', 'EmployeeViewService', 'NotificationOptions', 'ApplicationParameters', 'Principal'];

    function AdminEmployeeViewEmployeeInfoController ($http, $window, EmployeeViewService, NotificationOptions, ApplicationParameters, Principal) {
        var vm = this;
        vm.north = 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ';
        vm.south = 'ΝΟΤΙΑ ΕΛΛΑΔΑ';
        vm.westAndPeloponnese = 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ';

        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN']);

        $http.get('api/employees/' + EmployeeViewService.getSelectedUser().id)
            .success(function (response) {
                vm.employee = response;

                if(vm.employee.district === 'north') {
                    vm.employee.district = { id: 1, name: vm.north };
                } else if(vm.employee.district === 'south') {
                    vm.employee.district = { id: 2, name: vm.south };
                } else if(vm.employee.district === 'westAndPeloponnese') {
                    vm.employee.district = { id: 3, name: vm.westAndPeloponnese };
                }

                if (vm.employee.supervisor) {
                    vm.employee.supervisor.name =
                        vm.employee.supervisor.account.lastName + " " + vm.employee.supervisor.account.firstName;
                }

                $http.get('api/users/' + vm.employee.account.login)
                    .success(function (response) {
                        vm.user = response;
                    })
                    .error(function (response) {
                        console.log(response);
                    });
            })
            .error(function (response) {
                console.log(response);
            });

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.districtDataSource = [
            { id: 1, name: vm.north },
            { id: 2, name: vm.south },
            { id: 3, name: vm.westAndPeloponnese }
        ];

        vm.districtComboBoxOptions = {
            dataSource: vm.districtDataSource,
            valuePrimitive: false,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή κατηγορίας..."
        };

        vm.employeesComboBoxDataSource= new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    var url = '/api/employees/available-supervisors';

                    $http.get(url, {params: {id: EmployeeViewService.getSelectedUser().id}})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            },
            schema: {
                parse: function (data) {
                    data.forEach( function (item) {
                        item.name = item.account.lastName + " " + item.account.firstName;
                    });
                    return data;
                }
            },
            sort:{field:"account.lastName", dir:"asc"}
        });

        vm.employeesComboBoxOptions = {
            dataSource: vm.employeesComboBoxDataSource,
            filter: "contains",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        var employeeValidator = angular.element("#form").kendoValidator({
            rules: {
                custom: function (input) {

                    if (input.data('custom')) {
                        if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
            messages: {
                custom: "Πρέπει να επιλέξετε από την λίστα",
                maxlength: "Το κινητό τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
            }
        }).data("kendoValidator");

        vm.updateEmployee = function() {
            vm.updatedEmployee = angular.copy(vm.employee);
            vm.updatedUser = angular.copy(vm.user);

            if(vm.updatedEmployee.district) {
                if (vm.updatedEmployee.district.id == 1) {
                    vm.updatedEmployee.district = 'north';
                } else if (vm.updatedEmployee.district.id == 2) {
                    vm.updatedEmployee.district = 'south';
                } else if (vm.updatedEmployee.district.id == 3) {
                    vm.updatedEmployee.district = 'westAndPeloponnese';
                }
            }

            if (!vm.updatedEmployee.supervisor.id) {
                vm.updatedEmployee.supervisor = null;
            }

            if (employeeValidator.validate()) {
                $http.put('/api/employees', vm.updatedEmployee)
                    .success(function (response) {
                        if (employeeValidator.validate()) {
                            $http.put('/api/users', vm.updatedUser)
                                .success(function (response) {
                                    notification.show({
                                        message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                                    }, "success");
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        }else{
                            notification.show({
                                message: "Η ενημέρωση των στοιχείων απέτυχε!"
                            }, "error");
                        }
                    })
                    .error(function (response) {
                        console.log(response);
                    });
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }
        };
    }

})();
;
/**
 * Created by Teo on 07/08/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeCustomerSectors', {
                parent: 'adminEmployeeView',
                url: '/customer-sectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/customerSectors/customerSectors.html',
                controller: 'AdminEmployeeViewCustomerSectorsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    selectedEmployee: ['$http', '$stateParams', function ($http, $stateParams) {
                        return $http.get('api/employees/' + $stateParams.id).then(function (response) {
                            return response.data;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 07/08/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewCustomerSectorsController', AdminEmployeeViewCustomerSectorsController);

    AdminEmployeeViewCustomerSectorsController.$inject = ['$http', '$filter', '$state', 'customersView', 'KendoFilter', 'EmployeeViewService', 'CustomUtils', 'selectedEmployee'];

    function AdminEmployeeViewCustomerSectorsController ($http, $filter, $state, customersView, KendoFilter, EmployeeViewService, CustomUtils, selectedEmployee) {
        var vm = this;
        vm.customerView = customersView.data.content[0].value;
        vm.selectedEmployee = selectedEmployee;
        vm.masterFilters = { myTarget: true };

        vm.collapseAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-collapse").trigger("click"); };
        vm.expandAll = function () { angular.element("#mainGrid").find(".k-icon.k-i-expand").trigger("click"); };

        var filterTemplate = function (args) { KendoFilter.getTemplate(args); };

        vm.mainGridOptions = {
            autoBind: true,
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.filter = {filters: []};

                        o.data.filter.filters.push({
                            field: "employee.id",
                            operator: "eq",
                            value: vm.selectedEmployee.id
                        });

                        // MyTarget
                        o.data.filter.filters.push({
                            field: "myTarget",
                            operator: "eqbool",
                            "value": vm.masterFilters.myTarget
                        });

                        // Ενεργοί
                        o.data.filter.filters.push({
                            field: "active",
                            operator: "eqbool",
                            value: true
                        });

                        if (vm.customerView === '3') {
                            // Cross, fetch only not expired customerSectors
                            o.data.filter.filters.push({
                                field: "customerSector.endedAt",
                                operator: "null_or_greater",
                                value: $filter('date')(Date.now(), 'yyyy-MM-dd')
                            });
                        }

                        o.data.sort = {
                            field: "customerSector.customer.lastName",
                            dir: "asc"
                        };

                        $http.get('/api/employee-customer-sectors/all', {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                o.error(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        data.forEach(function (item) {
                            if (item.customerSector === null) {
                                item.customerSector = {
                                    customer: {
                                        customerCategory: {},
                                        customerSubCategory: {},
                                        doctorSpecialty: {}
                                    },
                                    sector: {
                                        city: {},
                                        prefecture: {},
                                        sectorType: {}
                                    },
                                    main: 'false',
                                    dayTime: ''
                                }
                            }else {
                                if (item.customerSector.customer === null) item.customerSector.customer = {};
                                if (item.customerSector.customer !== null) {
                                    if (item.customerSector.customer.customerCategory === null) item.customerSector.customer.customerCategory = {};
                                    if (item.customerSector.customer.customerSubCategory === null) item.customerSector.customer.customerSubCategory = {};
                                    if (item.customerSector.customer.doctorSpecialty === null) item.customerSector.customer.doctorSpecialty = {}
                                }
                                if (item.customerSector.sector === null) item.customerSector.sector = {};
                                if (item.customerSector.sector !== null) {
                                    if (item.customerSector.sector.city === null) item.customerSector.sector.city = {};
                                    if (item.customerSector.sector.prefecture === null) item.customerSector.sector.prefecture = {};
                                    if (item.customerSector.sector.sectorType === null) item.customerSector.sector.sectorType = {};
                                }
                                item.main = item.customerSector.main === true ? "true" : "false";
                                item.dayTime = item.customerSector.customer !== null ? (item.customerSector.customer.dayTime === 'day' ? 'ΠΡΩΙΝΌ' : item.customerSector.customer.dayTime === 'night' ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '') : '';
                                item.myTarget = item.myTarget === true ? 'Ναι' : 'Όχι';
                            }
                        });
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            isActive: {
                                type: "boolean",
                                defaultValue: true,
                                parse: function (value) {
                                    return !!(value == "1" || value == "true" || value == true);
                                }
                            }
                        }
                    }
                },
                aggregate: [
                    {field: "customerSector.customer.lastName", aggregate: "count"},
                    {field: "customerSector.customer.firstName", aggregate: "count"},
                    {field: "customerSector.customer.doctorSpecialty.name", aggregate: "count"},
                    {field: "customerSector.customer.customerCategory.name", aggregate: "count"},
                    {field: "customerSector.customer.customerSubCategory.name", aggregate: "count"},
                    {field: "customerSector.customer.dayTime", aggregate: "count"},
                    {field: "customerSector.sector.name", aggregate: "count"},
                    {field: "customerSector.sector.sectorType.name", aggregate: "count"},
                    {field: "customerSector.sector.address", aggregate: "count"},
                    {field: "customerSector.sector.prefectureName", aggregate: "count"},
                    {field: "customerSector.sector.cityName", aggregate: "count"},
                    {field: "main", aggregate: "count"},
                    {field: "myTarget", aggregate: "count"}
                ]
            }),
            sortable: true,
            groupable: {
                messages: {
                    empty: "Σύρετε μια στήλη εδώ για εφαρμογή ομαδοποίησησς σε αυτή τη στήλη"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Επαγγελματίες Υγείας"
            },
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "cell",
            columns: [
                {
                    title: "Στοιχεία Επαγγελματία Υγείας",
                    columns: [
                        {
                            field: "customerSector.customer.lastName",
                            title: "Επώνυμο",
                            attributes: {
                                class: "link-cell link-cell-color"
                            },
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 140,
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.customer.firstName",
                            title: "Όνομα",
                            attributes: {
                                class: "link-cell link-cell-color"
                            },
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.customer.doctorSpecialty.name",
                            title: "Ειδικοτητα 1η",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 130,
                            groupHeaderTemplate: "#= typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.customer.customerCategory.name",
                            title: "Κατηγορία",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 60,
                            groupHeaderTemplate: "#=  typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.customer.customerSubCategory.name",
                            title: "Υποκατηγορία",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 60,
                            groupHeaderTemplate: "#=  typeof value !== 'undefined' ? value : '' # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        }
                    ]
                },
                {
                    title: "Στοιχεία Μονάδας Υγείας",
                    columns: [
                        {
                            field: "customerSector.sector.sectorType.name",
                            title: "Τύπος",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.sector.name",
                            title: "Όνομα",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "contains",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 190,
                            groupHeaderTemplate: "#= value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.sector.address",
                            title: "Διεύθυνση",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 120,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.sector.cityName",
                            title: "Πόλη",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 90,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.sector.prefectureName",
                            title: "Νομός",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 80,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)"
                        },
                        {
                            field: "customerSector.sector.osfeBrick",
                            title: "Brick ΟΣΦΕ",
                            aggregates: ["count"],
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: filterTemplate,
                                    showOperators: false
                                }
                            },
                            width: 80,
                            groupHeaderTemplate: "#= (value == null) ? '' : value # (Σύνολο: #=kendo.format('{0:n0}', count)#)",
                            hidden: vm.customerView !== '1'
                        }
                    ]
                },
                {
                    field: "dayTime",
                    title: "Ωράριο",
                    aggregates: ["count"],
                    template: "#= (dayTime == 'ΠΡΩΙΝΌ') ? 'ΠΡΩΙΝΌ' : (dayTime == 'ΑΠΟΓΕΥΜΑΤΙΝΌ') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "ΠΡΩΙΝΌ", value: "ΠΡΩΙΝΌ"},
                                            {text: "ΑΠΟΓΕΥΜΑΤΙΝΌ", value: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    width: 100,
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? ((value == 'ΠΡΩΙΝΟ') ? 'ΠΡΩΙΝΟ' : (value == 'ΑΠΟΓΕΥΜΑΤΙΝΟ') ? 'ΑΠΟΓΕΥΜΑΤΙΝΟ' : '') : '' #(Σύνολο: #=kendo.format('{0:n0}', count)#)",
                    hidden: vm.customerView === '1' || vm.customerView === '6'
                },
                {
                    field: "myTarget",
                    title: "MyTarget",
                    aggregates: ["count"],
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind: false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{text: "Ναι", value: "Ναι"},
                                            {text: "Όχι", value: "Όχι"}]
                                    }),
                                    valuePrimitive: true
                                });
                            }
                        }
                    },
                    width: 100,
                    groupHeaderTemplate: "#= typeof value !== 'undefined' ? ((value == 'Ναι') ? 'MyTarget: Ναι' : (value == 'Όχι') ? 'MyTarget: Όχι' : '') : '' #(Σύνολο: #=kendo.format('{0:n0}', count)#)"
                }
            ],
            toolbar: [
                {template: "<md-button class='md-raised md-mini md-primary' aria-label='collapseAll' ng-click='vm.collapseAll()'>Collapse All</md-button>"},
                {template: "<md-button class='md-raised md-mini md-primary' aria-label='expandAll' ng-click='vm.expandAll()'>Expand All</md-button>"},
                {
                    template: "<label class='left-space'>My Target: </label><div class='inline'>" +
                    "<md-radio-group class='left-space' layout='row' ng-change='vm.mainGridOptions.dataSource.read()' ng-model='vm.masterFilters.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                {
                    name: "excel",
                    template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                    "<span class='k-icon k-i-excel'></span>Export</md-button></div>"
                }
            ],
            height: CustomUtils.getHeightPixelsFromPercentage(57),
            excel: {
                allPages: true,
                fileName: "Επαγγελματίες Υγείας_" + vm.selectedEmployee.account.lastName + " " + vm.selectedEmployee.account.firstName + ".xlsx"
            },
            change: onChange,
        };

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 0 || cellIndex === 1) {
                $state.go('customerInfo', {id: this.dataItem(row).customerSector.customer.id});
            }
        }
    }
})();
;
/**
 * Created by Kristy Kavvada on 5/12/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeBeautyCenters', {
                parent: 'adminEmployeeView',
                url: '/beautyCenters',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/beautyCenters/beautyCenters.html',
                controller: 'AdminEmployeeViewBeautyCentersController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 5/12/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewBeautyCentersController', AdminEmployeeViewBeautyCentersController);

    AdminEmployeeViewBeautyCentersController.$inject = ['$http','KendoGrid', '$stateParams', '$filter', 'KendoFilter', 'ApplicationParameters', 'CustomUtils'];

    function AdminEmployeeViewBeautyCentersController ($http, KendoGrid, $stateParams, $filter, KendoFilter, ApplicationParameters, CustomUtils) {
        var vm = this;
        ApplicationParameters.hasModule('Visit_Beauty_Centers', true);
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.selectedEmployees =
            vm.selectedAssignees = [];
        vm.massSelect = true;

        vm.selectedUser = {};
        vm.selectedUser.id = $stateParams.id;

        vm.sectorGrid = {};
        vm.customerSectorSuggestGrid = {};

        vm.sectorGrid.columns = [
            {
                field: "sector.name", title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "sector.companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.postalCode", title: "T.K.",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        vm.sectorGrid.options = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {

                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "active", "operator": "eqbool",  "value": true }
                            ]
                        );

                        var url = "/api/employee/"+vm.selectedUser.id+"/sectors";

                        o.data.sectorTypeCategory = "beautyCenter";

                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if(item.customerSector === null) item.customerSector = {};
                                if (item.sector) {
                                    if(!item.sector.companyType) item.sector.companyType = {};
                                    if(!item.sector.taxOffice) item.sector.taxOffice = {};
                                } else {
                                    item.sector = {
                                        companyType: {},
                                        taxOffice: {}
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            height: vm.contentHeight,
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.sectorGrid.columns,
            toolbar: [
                {
                    name: "Assign",
                    text: "Assign Customer Sector",
                    template: "<input id='assignToSectorsBtn' type='button' class='k-button' value = 'Ανάθεση σε Κέντρα Αισθητικής' ng-click='vm.openWindow()' />"
                },
                {
                    name: "ReAssign",
                    text: "ReAssign",
                    template: function (dataItem) {
                        return "<input type='button' class='k-button' value = 'Διαγραφή Ιατρικού Επισκέπτη από Κέντρα Αισθητικής' ng-click='vm.reAssign()' />" ;
                    }
                },
                { template: "<div class='right'><label>Σύνολο: {{vm.sectorGrid.options.dataSource.total()}}</label></div>",
                    overflow: "never" }
            ],
            selectedItems: function(dataItems) {
                vm.selectedAssignees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#sectorsGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                var selectedAssigneesViewCounter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(vm.selectedAssignees, {id: item.id}, true)[0];
                    if(vm.selectedAssignees.indexOf(foundItemById) !== -1){
                        me.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        selectedAssigneesViewCounter++
                    }
                });
                if(selectedAssigneesViewCounter == view.length) {
                    angular.element("#sectorsGridcheckbox").prop('checked', true);
                }
            }
        };

        vm.customerSectorSuggestGrid.columns = [
            {
                field: "name", title: "Επωνυμία",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "vat",
                title: "Α.Φ.Μ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "companyType.name",
                title: "Εταιρική Μορφή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "T.K.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        vm.customerSectorSuggestGrid.options = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        //filter beautyCenters
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType.sectorTypeCategory", "operator": "eq",  "value": 'beautyCenter'}
                            ]
                        );

                        $http.get('/api/customer-sectors/employees/' + vm.selectedUser.id + '/sectors/suggest',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){
                                if(!item.companyType) item.companyType = {};
                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            sector: {defaultValue : { id : null, name : null}},
                            sectorPosition: {defaultValue : { id : null, name : null}},
                            startedAt: { type: 'date'},
                            endedAt: { type: 'date', defaultValue : null},
                            customer: { defaultValue : { id : null, firstName : null, lastName : null}}
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 10
            }),
            sortable: true,
            pageable: true,
            selectable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.customerSectorSuggestGrid.columns,
            selectedItems: function(dataItems) {
                vm.selectedEmployees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#customerSectorSuggestGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedEmployees) {
                    var selectedEmployeesViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedEmployees, {id: item.id}, true)[0];
                        if(vm.selectedEmployees.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedEmployeesViewCounter++
                        }
                    });
                    if(selectedEmployeesViewCounter == view.length) {
                        angular.element("#customerSectorSuggestGridcheckbox").prop('checked', true);
                    }
                }
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.customerSectorSuggestGrid.options.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.openWindow = function(){
            vm.selectedEmployees = [];

            vm.customerSectorSuggestGrid.options.dataSource.page(1);
            vm.customerSectorSuggestGrid.options.dataSource.filter({});
            vm.customerSectorSuggestGrid.options.dataSource.read();

            var wdw = angular.element("#popup-sector").data("kendoWindow");
            wdw.center().open();
        };

        vm.closeWindow = function() {
            var wdw = angular.element("#popup-sector").data("kendoWindow");
            wdw.close();
        };

        var url = 'api/employee-customer-sectors/mass';

        vm.saveSectors = function() {
            var wdw = angular.element("#popup-sector").data("kendoWindow");
            var postData = [];

            vm.selectedEmployees.forEach(function(item,key){
                var newPost = {};
                newPost.active = true;
                newPost.sector = {};
                newPost.sector.id = item.id;
                newPost.employee = {};
                newPost.employee.id = vm.selectedUser.id;
                postData.push(newPost)
            });

            $http.post(url, postData, {})
                .success(function (response) {
                    wdw.close();
                    vm.selectedEmployees = [];
                    // KendoGrid.refresh(vm.customerSectorSuggestGrid.οptions);
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    angular.element("#sectorsGrid").data("kendoGrid").refresh();
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.reAssign = function () {
            var postData = [];

            vm.selectedAssignees.forEach(function(item,key){
                var newPost = {};
                newPost.active = false;
                newPost.sector = {};
                newPost.sector.id = item.sector.id;
                newPost.employee = {};
                newPost.employee.id = vm.selectedUser.id;
                postData.push(newPost)
            });

            $http.post(url, postData, {})
                .success(function (response) {
                    vm.selectedAssignees = [];
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    angular.element("#sectorsGrid").data("kendoGrid").refresh();
                    // KendoGrid.refresh(vm.sectorGrid.οptions);
                })
                .error(function (response) {
                    console.log(response);
                });

        };
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeeAgreements', {
                parent: 'adminEmployeeView',
                url: '/employeeAgreements',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/agreements/agreements.html',
                controller: 'AdminEmployeeViewEmployeeAgreementsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 24/5/2017.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewEmployeeAgreementsController', AdminEmployeeViewEmployeeAgreementsController);

    AdminEmployeeViewEmployeeAgreementsController.$inject = ['$scope', '$http', '$filter', 'EmployeeViewService', 'KendoFilter', 'CustomUtils'];

    function AdminEmployeeViewEmployeeAgreementsController ($scope, $http, $filter, EmployeeViewService, KendoFilter, CustomUtils) {
        var vm = this;
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(55);

        vm.clearDatePickers = function () {
            angular.element('#masterFiltersAgreements').find('#from').data('kendoDatePicker').value("");
            angular.element('#masterFiltersAgreements').find('#to').data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = $filter('date')(date, 'yyyy-MM-dd');
                vm.to = $filter('date')(date, 'yyyy-MM-dd');

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = $filter('date')(firstWeekDay, 'yyyy-MM-dd');
                vm.to = $filter('date')(lastWeekDay, 'yyyy-MM-dd');

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = $filter('date')(firstMonthDay, 'yyyy-MM-dd');
                vm.to = $filter('date')(lastMonthDay, 'yyyy-MM-dd');
            }

            if ( e.target != undefined) {
                angular.element("#agreementsGrid").data("kendoGrid").dataSource.read();
            } else {
                angular.element("#agreementsGrid").data("kendoGrid").dataSource.read();
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ], attributes: { class: "buttonGroup" }
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions' class='from'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions' class='to'/>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('.buttonGroup').find('.k-state-active').removeClass('k-state-active');
                var value = this.value();
                vm.from = $filter('date')(value, 'yyyy-MM-dd');
                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('.buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                vm.to = $filter('date')(value, 'yyyy-MM-dd');
                vm.masterFiltersOnClick(e);
            }
        };

        vm.agreementsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "event.employee.id", "operator": "eq",  "value": vm.selectedUser.id}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        //master filters functionality
                        if(vm.from && vm.to) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "event.startedAt", "operator": "from",  "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "event.startedAt", "operator": "to",  "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ]
                            );
                        }

                        $http.get('/api/me/agreements',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        return data;
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50,
                group: {field:  'event_date'},
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){

                                if (item.event === null) {
                                    item.event = {
                                        startedAt: '',
                                        eventCustomerSector: {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            }
                                        }
                                    };
                                } else {
                                    if (item.event.eventCustomerSector === null) {
                                        item.event.eventCustomerSector = {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            }
                                        };
                                    } else {
                                        if (item.event.eventCustomerSector.customerSector === null) {
                                            item.event.eventCustomerSector.customerSector = {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            };
                                        }
                                    }
                                }

                                if (item.product === null) {
                                    item.product = { name: ''};
                                }

                                if (item.agreementValuation === null) {
                                    item.agreementValuation = { name: ''};
                                }

                                if (item.eventPlace === null) {
                                    item.eventPlace = {};
                                    item.eventPlace.name = "";
                                }
                            });
                        }
                        return data.content;
                    },
                    parse: function(data) {
                        angular.forEach(data.content, function(item) {
                            if (item.event != undefined) {
                                item.event_date = kendo.toString(kendo.parseDate(item.event.startedAt), 'dd/MM/yyyy');
                            }

                        });
                        return data;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            promisedQuantity: { type:'number' },
                            priority: { type:'number' },
                            //agreed_price: { type:'number' },
                            event_date: { type: 'date'},
                            'event.startedAt': { type: 'date' }
                        }
                    }
                }
            }),
            height: vm.contentHeight,
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {field: "event_date", hidden: true,
                    groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy')#"
                },
                {field: "event.startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= kendo.toString(kendo.parseDate(event.startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }},
                {field: "product.name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "promisedQuantity", title: "Προβλεπόμενη Συχνότητα",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "priority", title: "Σειρά προτεραιότητας",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "agreementValuation.name", title: "Αξιολόγηση",attributes: {
                    class: "#=agreementValuation.id == '1' ? 'red' : agreementValuation.id == '2' ? 'orange' : agreementValuation.id == '3' ? 'purple' : agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "event.eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "event.eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }}
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.agreementsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Maria on 17/5/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeeViewController', AdminEmployeeViewController);

    AdminEmployeeViewController.$inject = ['$http', '$state', '$stateParams', '$filter','$scope', 'NotificationOptions', 'KendoFilter', 'EmployeeViewService', 'ApplicationParameters'];

    function AdminEmployeeViewController ($http, $state, $stateParams, $filter, $scope, NotificationOptions, KendoFilter, EmployeeViewService, ApplicationParameters) {
        var vm = this;
        vm.$state = $state;
        vm.stateFrom = $stateParams.stateFrom;
        vm.pageHeading = 'Καρτέλα Ιατρικού Επισκέπτη';
        vm.profilePicture = "employee_icon.png";

        EmployeeViewService.setSelectedUser({ id: $stateParams.id });
        vm.selectedUser = EmployeeViewService.getSelectedUser();
        vm.hasMedReport = false;
        ApplicationParameters.hasModule('Med_Report', false).then(function(response) {
            vm.hasMedReport  = response.data.content[0].value === "1";
        });

        $http.get('api/employees/' + vm.selectedUser.id)
            .success(function (response) {
                vm.employee = response;
                $http.get('api/users/' + vm.employee.account.login)
                    .success(function (response) {
                        vm.user = response;
                    })
                    .error(function (response) {
                        console.log(response);
                    });
            })
            .error(function (response) {
                console.log(response);
            });

        vm.goBack = function () {
            $state.go(vm.stateFrom !== null && vm.stateFrom !== undefined ? vm.stateFrom : 'adminEmployees');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adminEmployees', {
            parent: 'app',
            url: '/employees',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminEmployees/adminEmployees.html',
                    controller: 'AdminEmployeesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('adminEmployeeView', {
                abstract: true,
                parent: 'app',
                url: '/employees/search?id:employeeId:stateFrom',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminEmployees/adminEmployeeView.html',
                        controller: 'AdminEmployeeViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminEmployeesController', AdminEmployeesController);

    AdminEmployeesController.$inject = ['$scope', '$state', 'Principal', '$filter', 'ParseLinks', 'KendoGrid', 'ApplicationParameters', 'KendoFilter','$http', 'CustomUtils'];

    function AdminEmployeesController ($scope, $state, Principal, $filter, ParseLinks, KendoGrid, ApplicationParameters, KendoFilter, $http, CustomUtils) {
        var vm = this;
        vm.principal = Principal;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(65);
        vm.pageHeading = 'Ιατρικοι Επισκεπτες';
        vm.north = 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ';
        vm.south = 'ΝΟΤΙΑ ΕΛΛΑΔΑ';
        vm.westAndPeloponnese = 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ';
        vm.selectedProductCategories = [];
        vm.purchaseNumberingRows = [];
        vm.isActive = true;

        var districtDataSource = new kendo.data.DataSource({
            data: [
                { id: 1, name: vm.north},
                { id: 2,  name: vm.south},
                { id: 3,  name: vm.westAndPeloponnese}
            ]
        });

        vm.usersComboBoxDataSource= new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    var url = '/api/employees/users/not-mapped';
                    $http.get(url)
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        function productCategoriesDisplay(data, container) {
            if(data.productCategories) {
                return data.productCategories.map(function(elem) {
                    return elem.name
                }).join(', ');
            }
            return "";
        }

        function purchaseNumberingRowsDisplay(data, container) {
            if(data.purchaseNumberingRows) {
                return data.purchaseNumberingRows.map(function(elem) {
                    return elem.name
                }).join(', ');
            }
            return "";
        }

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Ενεργός: </label><md-checkbox aria-label='isActive' ng-model='vm.isActive' ng-change='vm.onFilterChange()' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left left-space"}
                }
            ]
        };

        vm.onFilterChange = function () { angular.element("#mainGrid").data("kendoGrid").dataSource.read(); };

        vm.gridColumns = [
            {
                title: "Στοιχεία Χρήστη",
                columns: [
                    {
                        field: "account.lastName",
                        title: "Επώνυμο",
                        attributes: {
                            class: "link-cell link-cell-color"
                        },
                        editor: function(container, options) {
                            angular.element('<select id="lastName" data-bind="value:account.lastName"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    enable: false,
                                    dataSource: vm.usersComboBoxDataSource,
                                    dataTextField: "lastName"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        width: 200
                    },
                    {
                        field: "account.firstName",
                        title: "Όνομα",
                        attributes: {
                            class: "link-cell link-cell-color"
                        },
                        editor: function(container, options) {
                            angular.element('<select id="firstName" data-bind="value:account.firstName"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    enable: false,
                                    dataSource: vm.usersComboBoxDataSource,
                                    dataTextField: "firstName"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        width: 200
                    },
                    {
                        field: "account.login",
                        title: "Όνομα σύνδεσης",
                        editor: function(container, options) {
                            angular.element('<select id="comboBox" data-bind="value:account.id"></select>')
                                .appendTo(container)
                                .kendoComboBox({
                                    dataSource: vm.usersComboBoxDataSource,
                                    filter: "startswith",
                                    change: function(e) {
                                        var index = e.sender.selectedIndex;
                                        $('#firstName').data('kendoComboBox').select(index);
                                        $('#lastName').data('kendoComboBox').select(index);
                                    },
                                    valuePrimitive: true,
                                    dataTextField: "login",
                                    dataValueField: "id",
                                    template: "<table><span width='100px'><strong>(${login}) </strong></span>" +
                                    "<span width='50px'>${firstName} </span>" +
                                    "<span width='50px'>${lastName}</span></table>"
                                });
                        },
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        },
                        width: 170
                    },
                    // {
                    //     field: "account.activated",
                    //     title: "Ενεργός",
                    //     filterable: {
                    //         cell: {
                    //             operator: "eqbool",
                    //             showOperators: false,
                    //             template: function (args) {
                    //                 args.element.kendoDropDownList({
                    //                     autoBind:false,
                    //                     dataTextField: "text",
                    //                     dataValueField: "value",
                    //                     dataSource: new kendo.data.DataSource({
                    //                         data: [{ text: "Ναι", value: "true" },
                    //                             { text: "Όχι", value: "false" }]
                    //                     }),
                    //                     valuePrimitive: true
                    //
                    //                 })
                    //             }
                    //         }
                    //     },
                    //     width: 133,
                    //     template: "#= (account.activated == '1') ? 'Ναι' : 'Όχι' #"
                    // }
                ]
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 160
            },
            {
                field: "district",
                title: "Περιοχή",
                editor: function(container, options) {
                    if (options.model.district == 'north') {
                        options.model.district = { id:1, name:'ΒΟΡΕΙΑ ΕΛΛΑΔΑ' }
                    } else if (options.model.district == 'south'){
                        options.model.district = { id:2, name:'ΝΟΤΙΑ ΕΛΛΑΔΑ' }
                    } else if (options.model.district == 'westAndPeloponnese'){
                        options.model.district = { id:3, name:'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ' }
                    }

                    angular.element('<input data-bind="value: district.id" k-ng-model="district"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: districtDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                template: "#= (district == 'north') ? 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ' : (district == 'south') ? 'ΝΟΤΙΑ ΕΛΛΑΔΑ' : (district == 'westAndPeloponnese') ? 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ' : '' #",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: vm.north, value: "north" },
                                        { text: vm.south, value: "south" },
                                        { text: vm.westAndPeloponnese, value: "westAndPeloponnese" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                }
            },
            {
                field: "mobileVersion",
                title: "Mobile Έκδοση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 100
            },
            {
                field: "supervisor.account.fullName",
                title: "Προϊστάμενος",
                editor: function(container, options) {
                    vm.employeesComboBoxDataSource= new kendo.data.DataSource({
                        transport: {
                            read: function(o) {
                                var url = '/api/employees/available-supervisors';
                                $http.get(url, {params: {id: options.model.id}})
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            parse: function (data) {
                                data.forEach( function (item) {
                                    item.fullName = item.account.lastName + " " + item.account.firstName;
                                });
                                return data;
                            }
                        }
                    });

                    angular.element('<select data-bind="value:supervisor.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: vm.employeesComboBoxDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "fullName",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 300
            },
            {
                field: "productCategories.id",
                title: "Κατηγορίες Προϊόντων",
                filterable: {
                    cell: {
                        operator: "in",
                        showOperators: false,
                        template: function (args) {
                            args.element.removeAttr('data-bind').kendoMultiSelect({
                                dataSource: new kendo.data.DataSource({
                                    serverFiltering: true,
                                    transport: {
                                        read: function (o) {
                                            if (o.data.filter == undefined) {
                                                o.data.filter = {filters: []};
                                            }
                                            o.data.page = 1;
                                            o.data.pageSize = 10000;
                                            $http.get('/api/masterdata/product-categories',
                                                {params: o.data})
                                                .success(function (response, status, headers) {
                                                    response.content.unshift({id:"none", name :"(Κενό)"});
                                                    o.success(response.content);
                                                })
                                                .error(function (response) {
                                                    console.log(response);
                                                });
                                        }
                                    }
                                }),
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id",
                                change: function () {
                                    vm.selectedProductCategories = this.value();
                                    vm.mainGridOptions.dataSource.read();
                                },
                                select: function (e) {
                                    var dataItem = this.dataSource.view()[e.item.index()];
                                    var values = this.value();

                                    if (dataItem.id === "none") {
                                        this.value("");
                                    } else if (values.indexOf("none") !== -1) {
                                        values = angular.element.grep(values, function (value) {
                                            return value !== "none";
                                        });
                                        this.value(values);
                                    }
                                }
                            })
                        }
                    }
                },
                template: productCategoriesDisplay,
                editor: function (container, options) {
                    angular.element('<select id="productCategories" multiple="multiple" data-bind="value: productCategories"/>')
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function (o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = {filters: []};
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 10000;
                                        $http.get('/api/masterdata/product-categories',
                                            {params: o.data})
                                            .success(function (response, status, headers) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                }
                            }),
                            valuePrimitive: false,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "purchaseNumberingRows.id",
                title: "Σειρές Αρίθμησης",
                filterable: {
                    cell: {
                        operator: "in",
                        showOperators: false,
                        template: function (args) {
                            args.element.removeAttr('data-bind').kendoMultiSelect({
                                dataSource: new kendo.data.DataSource({
                                    serverFiltering: true,
                                    transport: {
                                        read: function (o) {
                                            if (o.data.filter == undefined) {
                                                o.data.filter = {filters: []};
                                            }
                                            o.data.page = 1;
                                            o.data.pageSize = 10000;
                                            $http.get('/api/purchase-numbering-rows/search',
                                                {params: o.data})
                                                .success(function (response, status, headers) {
                                                    response.content.unshift({id:"none", name :"(Κενό)"});
                                                    o.success(response.content);
                                                })
                                                .error(function (response) {
                                                    console.log(response);
                                                });
                                        }
                                    }
                                }),
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id",
                                change: function () {
                                    vm.purchaseNumberingRows = this.value();
                                    vm.mainGridOptions.dataSource.read();
                                },
                                select: function (e) {
                                    var dataItem = this.dataSource.view()[e.item.index()];
                                    var values = this.value();

                                    if (dataItem.id === "none") {
                                        this.value("");
                                    } else if (values.indexOf("none") !== -1) {
                                        values = angular.element.grep(values, function (value) {
                                            return value !== "none";
                                        });
                                        this.value(values);
                                    }
                                }
                            })
                        }
                    }
                },
                template: purchaseNumberingRowsDisplay,
                editor: function (container, options) {
                    angular.element('<select id="purchaseNumberingRows" multiple="multiple" data-bind="value: purchaseNumberingRows"/>')
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function (o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = {filters: []};
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 10000;
                                        $http.get('/api/purchase-numbering-rows/search',
                                            {params: o.data})
                                            .success(function (response, status, headers) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {
                                                console.log(response);
                                            });
                                    }
                                }
                            }),
                            valuePrimitive: false,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                }
            },
            {
                field: "code",
                title: "Κωδικός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.onAddEmployeeClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        if(vm.selectedProductCategories.length) {
                            o.data.filter.filters.push(
                                { "field": "productCategories.id", "operator": "in",
                                    "value": vm.selectedProductCategories.toString() }
                            );
                        }

                        if(vm.purchaseNumberingRows.length) {
                            o.data.filter.filters.push(
                                { "field": "purchaseNumberingRows.id", "operator": "in",
                                    "value": vm.purchaseNumberingRows.toString() }
                            );
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "account.activated",
                                    "operator": "eqbool",
                                    "value": vm.isActive
                                }
                            ]
                        );

                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    create: function (o){

                        var data = o.data.models[0];

                        if (data.district.id == 1) {
                            data.district = 'north';
                        } else if (data.district.id == 2) {
                            data.district = 'south';
                        } else if (data.district.id == 3) {
                            data.district = 'westAndPeloponnese';
                        } else {
                            data.district = null;
                        }

                        if (!data.supervisor.id) {
                            data.supervisor = null;
                        }

                        $http.post('/api/employees', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    update: function (o){

                        var data = o.data.models[0];
                        data.account.authorities = [];

                        if(data.district) {
                            if (data.district.id == 1) {
                                data.district = 'north';
                            } else if (data.district.id == 2) {
                                data.district = 'south';
                            } else if (data.district.id == 3) {
                                data.district = 'westAndPeloponnese';
                            } else {
                                data.district = null;
                            }
                        }

                        if (!data.supervisor.id) {
                            data.supervisor = null;
                        }

                        $http.put('/api/employees', data)
                            .success(function (response) {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){

                                if (!item.account) {
                                    item.account = {
                                        firstName: "",
                                        lastName: "",
                                        login: ""
                                    };
                                }

                                if (!item.district) {
                                    item.district = {};
                                }

                                if (!item.supervisor) {
                                    item.supervisor = {
                                        account: {fullName: ""}
                                    }
                                } else {
                                    if (item.supervisor.account.lastName && item.supervisor.account.firstName) {
                                        item.supervisor.account.fullName =
                                            item.supervisor.account.lastName + " " + item.supervisor.account.firstName;
                                    } else if (!item.supervisor.account.firstName) {
                                        item.supervisor.account.fullName = item.supervisor.account.lastName;
                                    } else if (!item.supervisor.account.lastName) {
                                        item.supervisor.account.fullName = item.supervisor.account.firstName;
                                    }
                                }
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            district : { defaultValue: {} },
                            password: { type: 'password', editable: true, nullable: false, defaultValue: null },
                            supervisor: { defaultValue: { account: { defaultValue: {}} }},
                            account: { defaultValue: {} },
                            mobileVersion: {editable:false},
                            'account.activated':{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return (value === "1" || value === "true" || value === true);

                                }
                            }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 100
            }),
            dataBound: function() {
                var grid = $('#mainGrid').data('kendoGrid');

                ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
                    if (response.data.content[0].value != 1) {
                        angular.forEach( grid.columns, function (item, index) {
                            if( item.field == "purchaseNumberingRows.id" ) {
                                grid.hideColumn(index);
                            }
                        });
                    }
                });
            },
            sortable: true,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Ιατρικοί Επισκέπτες", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκαν Ιατρικοί Επισκέπτες",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκαν Ιατρικοί Επισκέπτες"
            },
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "cell",
            columns: vm.gridColumns,
            height: vm.contentHeight,
            change: onChange,
            edit: function(e) {
                ApplicationParameters.hasModule('Purchase_Pharmacies', false).then(function(response) {
                    if (response.data.content[0].value != 1) {
                        e.container.find("[data-container-for='purchaseNumberingRows.id']").remove();
                        e.container.find("[for='purchaseNumberingRows.id']").parent().remove();
                    }
                });
                if (e.model.isNew() == false) {
                    $("#comboBox").kendoComboBox({ enable: false });
                }

                KendoGrid.defaultEditPopup(this._editContainer);

                //fix css
                angular.element( "div[data-container-for='productCategories.id']" ).addClass("k-multi-custom");
                angular.element( "label[for='mobileVersion']" ).parent().next().addClass("k-text-custom");
            },
            editable: {
                mode: "popup"
            }
        };

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 0 || cellIndex === 1) {
                $state.go('userInfo', {id: this.dataItem(row).id});
            }
        }
    }
})();
;
/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCycleReport', {
                parent: 'app',
                url: '/cycle/report',
                data: {
                    authorities: ['ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminCycleReport/adminCycleReport.html',
                        controller: 'AdminCycleReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 11/5/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCycleReportController', AdminCycleReportController);

    AdminCycleReportController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','$http', '$rootScope', '$location', 'KendoFilter'];

    function AdminCycleReportController ($scope, $state, $filter, ParseLinks, AlertService, pagingParams, paginationConstants, $http, $rootScope, $location, KendoFilter) {
        var vm = this;

        vm.pageHeading = 'Πλανο Ενημερωσης';

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('/api/customers/cycle/report',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if(item.doctorSpecialty === null){
                                    item.doctorSpecialty = {};
                                    item.doctorSpecialty.name = "";
                                }

                                if(item.customerCategory === null){
                                    item.customerCategory = {};
                                    item.customerCategory.name = "";
                                }

                                if(item.dayTime !== null){
                                    if(item.dayTime === "day") {
                                        item.dayTime = "ΠΡΩΙΝΌ";
                                    }else if(item.dayTime === "night"){
                                        item.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                                    }
                                }

                                if(item.subcategory !== null){
                                    if(item.subcategory === "one") {
                                        item.subcategory = 1;
                                    }else if(item.subcategory === "two"){
                                        item.subcategory = 2;
                                    }
                                }

                                if(item.lastEventStartedAt && item.customerCategory){
                                    if(item.customerCategory.circleDaysNo) {
                                        var newDate = new Date();
                                        item.lastEventStartedAt = new Date(item.lastEventStartedAt);
                                        newDate.setDate(newDate.getDate()-item.customerCategory.circleDaysNo);

                                        var timeDiff = Math.abs(newDate.getTime() - item.lastEventStartedAt.getTime());
                                        item.circleDaysNoEvent = Math.ceil(timeDiff / (1000 * 3600 * 24));
                                    }
                                }

                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true},
                            isActive:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            saw:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            doctorSpecialty:{defaultValue: {id: null, name : null}},
                            customerCategory:{defaultValue: { id : null, name : null}},
                            subcategory:{defaultValue: null},
                            dayTime:{defaultValue: null},
                            lastEventStartedAt: { type: 'date'},
                            circleDaysNoEvent: { type: 'number', defaultValue: null }
                        }
                    }
                },
                pageSize: 100,
                serverPaging: true,
                serverSorting: true,
                scrollable:false,
                serverFiltering :true
            }),
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {
                    field: "lastName",
                    title: "Επώνυμο",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:140
                },
                {
                    field: "firstName",
                    title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "doctorSpecialty.name",
                    title: "Ειδικοτητα 1η",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "customerCategory.name",
                    title: "Κατηγορία",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "subcategory",
                    title: "Υποκατηγορία",
                    template: "#= (subcategory == 1) ? '1' : (subcategory == 2) ? '2' : '' #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "1", value: "one" },
                                            { text: "2", value: "two" }]
                                    }),
                                    valuePrimitive: true

                                })
                            }
                        }
                    }
                },
                { field: "lastEventStartedAt", title: "Ημερομηνία Τελευταίας Επίσκεψης",
                    template: "#= lastEventStartedAt ? kendo.toString(kendo.parseDate(lastEventStartedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: false,
                    sortable: false
                },
                { field: "circleDaysNoEvent", title: "Ημέρες Χωρίς Επίσκεψης",
                    filterable: false,
                    sortable: false }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.detailedGridOptions = function (dataItem) {

            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/customers/' + dataItem.id + '/employees';

                                $http.get(url)
                                    .success(function (response,status,headers) {
                                        vm.total = headers()['x-total-count'];
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                if (data != undefined) {
                                    data.forEach(function (item) {

                                        if (!item.account) {
                                            item.account = {
                                                firstName: "",
                                                lastName: "",
                                                login: ""
                                            };
                                        }

                                        if(item.lastEventStartedAt && dataItem.customerCategory){
                                            if(dataItem.customerCategory.circleDaysNo) {
                                                var newDate = new Date();
                                                item.lastEventStartedAt = new Date(item.lastEventStartedAt);
                                                newDate.setDate(newDate.getDate()-dataItem.customerCategory.circleDaysNo);

                                                var timeDiff = Math.abs(newDate.getTime() - item.lastEventStartedAt.getTime());
                                                item.circleDaysNoEvent = Math.ceil(timeDiff / (1000 * 3600 * 24));
                                            }
                                        }
                                    });
                                }
                                return data;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: false },
                                    account: { defaultValue: {} },
                                    lastEventStartedAt: { type: 'date'},
                                    circleDaysNoEvent: { type: 'number', defaultValue: null }
                                }
                            }
                        },
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {
                            field: "account.login",
                            title: "Όνομα σύνδεσης"
                        },
                        {
                            field: "account.firstName",
                            title: "Όνομα"
                        },
                        {
                            field: "account.lastName",
                            title: "Επώνυμο"
                        },
                        { field: "lastEventStartedAt", title: "Ημερομηνία Τελευταίας Επίσκεψης",
                            template: "#= lastEventStartedAt ? kendo.toString(kendo.parseDate(lastEventStartedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                            filterable: false,
                            sortable: false
                        },
                        { field: "circleDaysNoEvent", title: "Ημέρες Χωρίς Επίσκεψης",
                            filterable: false,
                            sortable: false }
                    ]
                };
            }
        };
    }
})();
;
/**
 * Created by Kristy on 28/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EmployeesService', EmployeesService);

    EmployeesService.$inject = ['KendoFilter', '$filter'];

    function EmployeesService(KendoFilter, $filter) {
        var hasAssignations = false;
        var popupGrid = false;
        var employeesGridColumns = [
            {
                title: "Στοιχεία Χρήστη",
                columns: [
                    {
                        field: "account.login",
                        title: "Όνομα σύνδεσης",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "account.firstName",
                        title: "Όνομα",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    },
                    {
                        field: "account.lastName",
                        title: "Επώνυμο",
                        filterable: {
                            cell: {
                                operator: "startswith",
                                template: function (args) {
                                    KendoFilter.getTemplate(args);
                                },
                                showOperators: false
                            }
                        }
                    }
                ]
            },
            {
                field: "phone",
                title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "district",
                title: "Περιοχή",
                template: "#= (district == 'north') ? 'ΒΟΡΕΙΑ ΕΛΛΑΔΑ' : (district == 'south') ? 'ΝΟΤΙΑ ΕΛΛΑΔΑ' : (district == 'westAndPeloponnese') ? 'ΔΥΤ. ΕΛΛΑΔΟΣ & ΠΕΛΟΠΟΝΝΗΣΟΥ' : '' #",
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: $filter('translate')('sigmasfApp.customer.districts.north'), value: "north" },
                                        { text: $filter('translate')('sigmasfApp.customer.districts.south'), value: "south" },
                                        { text: $filter('translate')('sigmasfApp.customer.districts.westAndPeloponnese'), value: "westAndPeloponnese" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                }
            },
            {
                field: "mobileVersion",
                title: "Mobile Έκδοση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {
                field: "supervisor.account.fullName",
                title: "Προϊστάμενος",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        return {
            getHasAssignations: getHasAssignations,
            setHasAssignations: setHasAssignations,
            getInitPopupGrid: getInitPopupGrid,
            setInitPopupGrid: setInitPopupGrid,
            getEmployeesOptions: getEmployeesOptions
        };

        function getHasAssignations() {
            return hasAssignations;
        }

        function setHasAssignations(value) {
            hasAssignations = value;
        }

        function getInitPopupGrid() {
            return popupGrid;
        }

        function setInitPopupGrid(value) {
            popupGrid = value;
        }

        function getEmployeesOptions(datasource) {
            return {
                dataSource: datasource,
                sortable: true,
                pageable: true,
                selectable: true,
                scrolable: true,
                filterable: {
                    mode: "row"
                },
                resizable: true,
                columns: employeesGridColumns
            };
        }
    }
})();
;
/**
 * Created by Kristy on 28/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSectorsService', CustomerSectorsService);

    CustomerSectorsService.$inject = ['KendoFilter'];

    function CustomerSectorsService(KendoFilter) {
        var savedSector = false;
        var sector = {};
        var customerSector = {};
        var citiesComboboxOptions = {};
        var prefecturesComboboxOptions = {};

        return {
            getSectorsGridColumns: getSectorsGridColumns,
            getSectorsOptions: getSectorsOptions,

            getTimeEditor: getTimeEditor,
            getDateEditor: getDateEditor,
            setIsSectorSaved: setIsSectorSaved,
            getIsSectorSaved: getIsSectorSaved,
            getSector: getSector,
            setSector: setSector,
            getCustomerSector: getCustomerSector,
            setCustomerSector: setCustomerSector,
            getCitiesComboboxOptions: getCitiesComboboxOptions,
            setCitiesComboboxOptions: setCitiesComboboxOptions,
            getPrefecturesComboboxOptions: getPrefecturesComboboxOptions,
            setPrefecturesComboboxOptions: setPrefecturesComboboxOptions
        };

        function getSectorsGridColumns(combobox) {
            return [
                {command:[{name:"edit", text: ""}], attributes: {
                        "class": "smaller-k-edit-btn"
                    }, title: "&nbsp;", width:57},
                {
                    field: "sector.name", title: "Μονάδα Υγείας",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 155
                },
                {
                    field: "sector.sectorType.name",
                    title: "Τύπος",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 110
                },
                {field: "sectorParent.name", title: "Ανήκει στη Μ.Υ.",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 145
                },
                {field: "sector.address", title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 100
                },
                {field: "sector.addressNum", title: "Αριθμός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 40
                },
                {field: "sector.postalCode", title: "Τ.Κ.",
                    filterable: {
                        cell: {
                            operator: "contains",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 45
                },
                {field: "sector.cityName", title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 120
                },
                {field: "sector.prefectureName", title: "Νομός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 120
                },
                {field: "sector.brick", title: "Brick", hidden: true,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "sector.osfeBrick", title: "Brick ΟΣΦΕ",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 100
                },
                {field: "monday", title: "Δευτέρα",
                    filterable: false,
                    sortable: false,
                    width: 35,
                    editor: function(container, options) {
                        if (options.model.monday === 'morning') {
                            options.model.monday = { value: 'morning', text: 'Πρωί' };
                        } else if (options.model.monday === 'afternoon'){
                            options.model.monday = { value: 'afternoon', text: 'Απόγευμα' };
                        } else if (options.model.monday === 'morningAfternoon'){
                            options.model.monday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                        }

                        angular.element('<input data-bind="value: monday.value" k-ng-model="monday"/>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: new kendo.data.DataSource({
                                    data: [
                                        { value: 'morning', text: 'Πρωί'},
                                        { value: 'afternoon', text: 'Απόγευμα'},
                                        { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                    ]
                                }),
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    template: "#= (monday == 'morning') ? 'Π' : (monday == 'afternoon') ? 'Α' : (monday == 'morningAfternoon') ? 'Π/Α' : '' #"
                },
                {field: "tuesday", title: "Τρίτη",
                    filterable: false,
                    sortable: false,
                    width: 35,
                    editor: function(container, options) {
                        if (options.model.tuesday === 'morning') {
                            options.model.tuesday = { value: 'morning', text: 'Πρωί' };
                        } else if (options.model.tuesday === 'afternoon'){
                            options.model.tuesday = { value: 'afternoon', text: 'Απόγευμα' };
                        } else if (options.model.tuesday === 'morningAfternoon'){
                            options.model.tuesday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                        }

                        angular.element('<input data-bind="value: tuesday.value" k-ng-model="tuesday"/>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: new kendo.data.DataSource({
                                    data: [
                                        { value: 'morning', text: 'Πρωί'},
                                        { value: 'afternoon', text: 'Απόγευμα'},
                                        { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                    ]
                                }),
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    template: "#= (tuesday == 'morning') ? 'Π' : (tuesday == 'afternoon') ? 'Α' : (tuesday == 'morningAfternoon') ? 'Π/Α' : '' #"
                },
                {field: "wednesday", title: "Τετάρτη",
                    filterable: false,
                    sortable: false,
                    width: 35,
                    editor: function(container, options) {
                        if (options.model.wednesday === 'morning') {
                            options.model.wednesday = { value: 'morning', text: 'Πρωί' };
                        } else if (options.model.wednesday === 'afternoon'){
                            options.model.wednesday = { value: 'afternoon', text: 'Απόγευμα' };
                        } else if (options.model.wednesday === 'morningAfternoon'){
                            options.model.wednesday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                        }

                        angular.element('<input data-bind="value: wednesday.value" k-ng-model="wednesday"/>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: new kendo.data.DataSource({
                                    data: [
                                        { value: 'morning', text: 'Πρωί'},
                                        { value: 'afternoon', text: 'Απόγευμα'},
                                        { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                    ]
                                }),
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    template: "#= (wednesday == 'morning') ? 'Π' : (wednesday == 'afternoon') ? 'Α' : (wednesday == 'morningAfternoon') ? 'Π/Α' : '' #"
                },
                {field: "thursday", title: "Πέμπτη",
                    filterable: false,
                    sortable: false,
                    width: 35,
                    editor: function(container, options) {
                        if (options.model.thursday === 'morning') {
                            options.model.thursday = { value: 'morning', text: 'Πρωί' };
                        } else if (options.model.thursday === 'afternoon'){
                            options.model.thursday = { value: 'afternoon', text: 'Απόγευμα' };
                        } else if (options.model.thursday === 'morningAfternoon'){
                            options.model.thursday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                        }

                        angular.element('<input data-bind="value: thursday.value" k-ng-model="thursday"/>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: new kendo.data.DataSource({
                                    data: [
                                        { value: 'morning', text: 'Πρωί'},
                                        { value: 'afternoon', text: 'Απόγευμα'},
                                        { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                    ]
                                }),
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    template: "#= (thursday == 'morning') ? 'Π' : (thursday == 'afternoon') ? 'Α' : (thursday == 'morningAfternoon') ? 'Π/Α' : '' #"
                },
                {field: "friday", title: "Παρασκευή",
                    filterable: false,
                    sortable: false,
                    width: 35,
                    editor: function(container, options) {
                        if (options.model.friday === 'morning') {
                            options.model.friday = { value: 'morning', text: 'Πρωί' };
                        } else if (options.model.friday === 'afternoon'){
                            options.model.friday = { value: 'afternoon', text: 'Απόγευμα' };
                        } else if (options.model.friday === 'morningAfternoon'){
                            options.model.friday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                        }

                        angular.element('<input data-bind="value: friday.value" k-ng-model="friday"/>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: new kendo.data.DataSource({
                                    data: [
                                        { value: 'morning', text: 'Πρωί'},
                                        { value: 'afternoon', text: 'Απόγευμα'},
                                        { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                    ]
                                }),
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "text",
                                dataValueField: "value"
                            });
                    },
                    template: "#= (friday == 'morning') ? 'Π' : (friday == 'afternoon') ? 'Α' : (friday == 'morningAfternoon') ? 'Π/Α' : '' #"
                },
                {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="main" ng-model="dataItem.main" ng-disabled="true"></md-checkbox>',
                    field: "main", title: "Βασική Μονάδα",
                    // editor: function(container){
                    //     angular.element('<md-checkbox ng-model="dataItem.main"  aria-label="main" ' +
                    //         'class="checkbox-toolbar green inline"></md-checkbox>')
                    //         .appendTo(container);
                    // },
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    dataSource: new kendo.data.DataSource({
                                        data: [{ text: "Ναι", value: "true" },
                                            { text: "Όχι", value: "false" }]
                                    }),
                                    valuePrimitive: true

                                })
                            },
                            showOperators: false
                        }
                    }, width: 70
                },
                {field: "sectorPosition.name", title: "Νοσοκομειακή Θέση", hidden: true,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    editor: function(container) {
                        angular.element('<select id="sector-position" data-bind="value:sectorPosition.id"></select>')
                            .appendTo(container)
                            .kendoComboBox(combobox);
                    }
                },
                {
                    field: "phone", title: "Τηλέφωνο", hidden: true,
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "startedAt", title: "Ημερομηνία Έναρξης", hidden: true, template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                },
                {field: "endedAt", title: "Ημερομηνία Λήξης", hidden: true, template: "#= (endedAt == null) ? '' : kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy')#",
                    filterable: {
                        cell: {
                            operator: "eq",
                            showOperators: false
                        }
                    }
                }
            ];
        }

        function getSectorsOptions(datasource, columns) {
            return {
                dataSource: datasource,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                resizable: true,
                columns: columns,
                toolbar: [{ name: "New Customer Sector",
                    text: "New Customer Sector", template: "<input type='button' class='k-button' value = 'Προσθήκη Μονάδας Υγείας' ui-sref='customerSectorAssignation' ng-click='vm.openWindow()' />" },
                    { template: "<div class='right'><label>Σύνολο: {{vm.sectorsGridOptions.dataSource.total()}}</label></div>",
                        overflow: "never" }],
                editable: {
                    mode: "popup"
                }
            };
        }

        function getTimeEditor(container, options) {
            return angular.element('<input data-text-field="' + options.field + '" data-value-field="' + options.field + '" data-bind="value:' + options.field + '" data-format="' + options.format + '"/>')
                .appendTo(container)
                .kendoTimePicker({});
        }

        function getDateEditor(container, options) {
            return angular.element('<input data-bind="value:' + options.field + '"/>')
                .appendTo(container)
                .kendoDropDownList({
                    dataSource: [
                        {id:1, name:'Δευτέρα'},
                        {id:2, name:'Τρίτη'},
                        {id:3, name:'Τετάρτη'},
                        {id:4, name:'Πέμπτη'},
                        {id:5, name:'Παρασκευή'}
                    ],
                    valuePrimitive: true,
                    dataTextField: "name",
                    dataValueField: "id"

                });
        }

        function setIsSectorSaved(value) {
            savedSector = value;
        }

        function getIsSectorSaved() {
            return savedSector;
        }

        function getSector() {
            return sector;
        }

        function setSector(value) {
            sector = value;
        }

        function getCustomerSector() {
            return customerSector;
        }

        function setCustomerSector(value) {
            customerSector = value;
        }

        function getCitiesComboboxOptions() {
            return citiesComboboxOptions;
        }

        function setCitiesComboboxOptions(value) {
            citiesComboboxOptions = value;
        }

        function getPrefecturesComboboxOptions() {
            return prefecturesComboboxOptions;
        }

        function setPrefecturesComboboxOptions(value) {
            prefecturesComboboxOptions = value;
        }
    }
})();
;
/**
 * Created by Kristy on 26/7/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerSectors', {
                parent: 'adminCustomerView',
                url: '/sectors',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/sectors/sectors.html',
                controller: 'CustomerSectorsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 26/7/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorsController', CustomerSectorsController);

    CustomerSectorsController.$inject = ['$http','$compile', '$state', '$stateParams', '$filter', 'Alerts', 'KendoGrid', 'NotificationOptions', '$scope', 'KendoFilter', 'KendoService', 'CustomerSector', 'CustomerSectorsService', 'WorkingDay', 'EmployeesService', 'CustomDataUtils', 'Principal', '$mdDialog', 'employee'];

    function CustomerSectorsController ($http, $compile, $state, $stateParams, $filter, Alerts, KendoGrid, NotificationOptions, $scope, KendoFilter, KendoService, CustomerSector, CustomerSectorsService, WorkingDay, EmployeesService, CustomDataUtils, Principal, $mdDialog, employee) {
        var vm = this;
        vm.employee = employee.data;
        vm.$state = $state;
        vm.selectedUserId = $stateParams.id;
        vm.kendoGrid = KendoGrid;
        EmployeesService.setHasAssignations(true);
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var comboBoxes = ["#masterFilter","#sectorPosition", "#sectorType", "#prefectures", "#cities"]; //add "#regions" if wanted

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        var employeeCustomerSectorsDisplay = function (data) {
            return data.employeeCustomerSectors.map(function(elem) {
                return elem.employee.account.fullName
            }).join(', ');
        };
        var timeToString = function(date) {
            return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        };

        //SectorPositions Combobox
        var sectorPositionsDataSource = KendoService.initDefaultDataSource('/api/masterdata/sector-positions');
        vm.sectorPositionComboBoxOptions = KendoService.initDefaultOptions(sectorPositionsDataSource, "startswith", "name", "id");

        vm.onNavigateToSectorClick = function (e) {
            e.preventDefault();
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            if (CustomDataUtils.isNotNil(dataItem.sector)) {
                if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR'])){
                    // Navigate to Sector details
                    $state.go('sectorInfo', {id: dataItem.sector.id});
                }else {
                    // Only navigate if sector isPrivate
                    if (CustomDataUtils.isNotNil(dataItem.sector.sectorType) && dataItem.sector.sectorType.isPrivate === true) {
                        $state.go('sectorInfo', {id: dataItem.sector.id});
                    }else {
                        Alerts.showAlert("Sigma SalesForce", "Η μετάβαση στη καρτέλα της Μονάδας Υγείας ισχύει μόνο για Ιδιωτικές Μονάδες Υγείας", "ΟΚ");
                    }
                }
            }
        };

        vm.showEditCustomerSectorDialog = function (e) {
            e.preventDefault();
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            if (CustomDataUtils.isNotNil(dataItem.id)) {
                $http.get('/api/customer-sectors/' + dataItem.id)
                    .success(function (response) {
                        $mdDialog.show({
                            controller: 'EditCustomerSectorDialogCtrl',
                            templateUrl: 'app/components/edit-customer-sector-dialog/edit-customer-sector-dialog.html',
                            clickOutsideToClose: false,
                            locals: {customerSector: response}
                        }).then(function (result) {
                            // Success callback
                            if (CustomDataUtils.isNotNil(result)) {
                                notification.show({
                                    message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                                }, "success");
                                // Refresh Grid
                                vm.sectorsGridOptions.dataSource.read();
                            }
                        }, function (error) {
                            // Error callback
                            notification.show({
                                message: "Η ενημέρωση των στοιχείων απέτυχε!"
                            }, "error");
                        });
                    })
                    .error(function () {
                        Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά τη λήψη Μονάδας Υγείας", "ΟΚ");
                    });
            }
        };

        var grids = { sectorsGrid: {}, employeesGrid: {} };
        grids.sectorsGrid.columns = [
            {command:[{name:"customEdit", text: "Επεξ.", click: vm.showEditCustomerSectorDialog}], attributes: {
                    "class": "smaller-k-edit-btn"
                }, title: "&nbsp;", width:57},
            {
                command:[
                    { name:"view", text: "Μ.Υ.", click: vm.onNavigateToSectorClick }
                ],
                attributes: { class: "smaller-k-edit-btn" },
                title: "&nbsp",
                width: 57
            },
            {
                field: "sector.name", title: "Μονάδα Υγείας",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 155
            },
            {
                field: "sector.sectorType.name",
                title: "Τύπος",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }, width: 110
            },
            {field: "sectorParent.name", title: "Ανήκει στη Μ.Υ.",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {field: "sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 100
            },
            {field: "sector.addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 40
            },
            {field: "sector.postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 45
            },
            {field: "sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 120
            },
            {field: "sector.prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 120
            },
            {field: "sector.brick", title: "Brick", hidden: true,
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sector.osfeBrick", title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 100
            },
            {field: "monday", title: "Δευτέρα",
                filterable: false,
                sortable: false,
                width: 35,
                editor: function(container, options) {
                    if (options.model.monday === 'morning') {
                        options.model.monday = { value: 'morning', text: 'Πρωί' };
                    } else if (options.model.monday === 'afternoon'){
                        options.model.monday = { value: 'afternoon', text: 'Απόγευμα' };
                    } else if (options.model.monday === 'morningAfternoon'){
                        options.model.monday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                    }

                    angular.element('<input data-bind="value: monday.value" k-ng-model="monday"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    { value: 'morning', text: 'Πρωί'},
                                    { value: 'afternoon', text: 'Απόγευμα'},
                                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                ]
                            }),
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                template: "#= (monday == 'morning') ? 'Π' : (monday == 'afternoon') ? 'Α' : (monday == 'morningAfternoon') ? 'Π/Α' : '' #"
            },
            {field: "tuesday", title: "Τρίτη",
                filterable: false,
                sortable: false,
                width: 35,
                editor: function(container, options) {
                    if (options.model.tuesday === 'morning') {
                        options.model.tuesday = { value: 'morning', text: 'Πρωί' };
                    } else if (options.model.tuesday === 'afternoon'){
                        options.model.tuesday = { value: 'afternoon', text: 'Απόγευμα' };
                    } else if (options.model.tuesday === 'morningAfternoon'){
                        options.model.tuesday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                    }

                    angular.element('<input data-bind="value: tuesday.value" k-ng-model="tuesday"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    { value: 'morning', text: 'Πρωί'},
                                    { value: 'afternoon', text: 'Απόγευμα'},
                                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                ]
                            }),
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                template: "#= (tuesday == 'morning') ? 'Π' : (tuesday == 'afternoon') ? 'Α' : (tuesday == 'morningAfternoon') ? 'Π/Α' : '' #"
            },
            {field: "wednesday", title: "Τετάρτη",
                filterable: false,
                sortable: false,
                width: 35,
                editor: function(container, options) {
                    if (options.model.wednesday === 'morning') {
                        options.model.wednesday = { value: 'morning', text: 'Πρωί' };
                    } else if (options.model.wednesday === 'afternoon'){
                        options.model.wednesday = { value: 'afternoon', text: 'Απόγευμα' };
                    } else if (options.model.wednesday === 'morningAfternoon'){
                        options.model.wednesday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                    }

                    angular.element('<input data-bind="value: wednesday.value" k-ng-model="wednesday"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    { value: 'morning', text: 'Πρωί'},
                                    { value: 'afternoon', text: 'Απόγευμα'},
                                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                ]
                            }),
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                template: "#= (wednesday == 'morning') ? 'Π' : (wednesday == 'afternoon') ? 'Α' : (wednesday == 'morningAfternoon') ? 'Π/Α' : '' #"
            },
            {field: "thursday", title: "Πέμπτη",
                filterable: false,
                sortable: false,
                width: 35,
                editor: function(container, options) {
                    if (options.model.thursday === 'morning') {
                        options.model.thursday = { value: 'morning', text: 'Πρωί' };
                    } else if (options.model.thursday === 'afternoon'){
                        options.model.thursday = { value: 'afternoon', text: 'Απόγευμα' };
                    } else if (options.model.thursday === 'morningAfternoon'){
                        options.model.thursday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                    }

                    angular.element('<input data-bind="value: thursday.value" k-ng-model="thursday"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    { value: 'morning', text: 'Πρωί'},
                                    { value: 'afternoon', text: 'Απόγευμα'},
                                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                ]
                            }),
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                template: "#= (thursday == 'morning') ? 'Π' : (thursday == 'afternoon') ? 'Α' : (thursday == 'morningAfternoon') ? 'Π/Α' : '' #"
            },
            {field: "friday", title: "Παρασκευή",
                filterable: false,
                sortable: false,
                width: 35,
                editor: function(container, options) {
                    if (options.model.friday === 'morning') {
                        options.model.friday = { value: 'morning', text: 'Πρωί' };
                    } else if (options.model.friday === 'afternoon'){
                        options.model.friday = { value: 'afternoon', text: 'Απόγευμα' };
                    } else if (options.model.friday === 'morningAfternoon'){
                        options.model.friday = { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα' }
                    }

                    angular.element('<input data-bind="value: friday.value" k-ng-model="friday"/>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: new kendo.data.DataSource({
                                data: [
                                    { value: 'morning', text: 'Πρωί'},
                                    { value: 'afternoon', text: 'Απόγευμα'},
                                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                                ]
                            }),
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                template: "#= (friday == 'morning') ? 'Π' : (friday == 'afternoon') ? 'Α' : (friday == 'morningAfternoon') ? 'Π/Α' : '' #"
            },
            {template: '<md-checkbox class="checkbox-toolbar customers green inline"  aria-label="main" ng-model="dataItem.main" ng-disabled="true"></md-checkbox>',
                field: "main", title: "Βασική Μονάδα",
                // editor: function(container){
                //     angular.element('<md-checkbox ng-model="dataItem.main"  aria-label="main" ' +
                //         'class="checkbox-toolbar green inline"></md-checkbox>')
                //         .appendTo(container);
                // },
                filterable: {
                    cell: {
                        operator: "eq",
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ text: "Ναι", value: "true" },
                                        { text: "Όχι", value: "false" }]
                                }),
                                valuePrimitive: true

                            })
                        },
                        showOperators: false
                    }
                }, width: 70
            },
            {field: "sectorPosition.name", title: "Νοσοκομειακή Θέση", hidden: true,
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                editor: function(container) {
                    angular.element('<select id="sector-position" data-bind="value:sectorPosition.id"></select>')
                        .appendTo(container)
                        .kendoComboBox(vm.sectorPositionComboBoxOptions);
                }
            },
            {
                field: "phone", title: "Τηλέφωνο", hidden: true,
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "startedAt", title: "Ημερομηνία Έναρξης", hidden: true, template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            },
            {field: "endedAt", title: "Ημερομηνία Λήξης", hidden: true, template: "#= (endedAt == null) ? '' : kendo.toString(kendo.parseDate(endedAt), 'dddd, dd/MM/yyyy')#",
                filterable: {
                    cell: {
                        operator: "eq",
                        showOperators: false
                    }
                }
            }
        ];

        grids.sectorsGrid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    $http.get('/api/customers/' + vm.selectedUserId + '/me/customer-sectors')
                        .success(function (response) {
                            vm.checkEmployeeCustomerSectors(response);
                            o.success(response);
                        })
                        .error(function (response) {});
                },
                update: function(o) {
                    vm.saveSector = o.data.models[0];

                    //if deleted make active false
                    angular.forEach(vm.saveSector.employeeCustomerSectorsAll, function(item) {
                        var notFound = $filter('filter')(vm.saveSector.employeeCustomerSectors, {id: item.id}, true)[0];
                        if (vm.saveSector.employeeCustomerSectors.indexOf(notFound) === -1) {
                            item.active = false;
                            vm.saveSector.employeeCustomerSectors.push(item);
                        }
                    });

                    if(!vm.saveSector.sectorPosition.id) vm.saveSector.sectorPosition = null;
                    if(!vm.saveSector.sector.parent.id) vm.saveSector.sector.parent = null;

                    vm.saveSector.startedAt = kendo.toString(vm.saveSector.startedAt,"yyyy-MM-dd");
                    vm.saveSector.endedAt = kendo.toString(vm.saveSector.endedAt,"yyyy-MM-dd");

                    if (vm.saveSector.monday) {
                        vm.saveSector.monday = vm.saveSector.monday.value;
                    }
                    if (vm.saveSector.tuesday) {
                        vm.saveSector.tuesday = vm.saveSector.tuesday.value;
                    }
                    if (vm.saveSector.wednesday) {
                        vm.saveSector.wednesday = vm.saveSector.wednesday.value;
                    }
                    if (vm.saveSector.thursday) {
                        vm.saveSector.thursday = vm.saveSector.thursday.value;
                    }
                    if (vm.saveSector.friday) {
                        vm.saveSector.friday = vm.saveSector.friday.value;
                    }

                    CustomerSector.update({}, vm.saveSector,
                        function () {
                            angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                        });
                }
            },
            schema: {
                data: function (data) {
                    if(data.length) {
                        data.forEach(function(item){
                            if(item.sector === null) item.sector = {};
                            else if (item.sector.parent === null) item.sector.parent = {};

                            if(item.sector.sectorType === null) item.sector.sectorType = {};
                            if(item.sectorPosition === null) item.sectorPosition = {};
                            if(item.employeeCustomerSectors === null){
                                item.employeeCustomerSectors = {
                                    employee: {
                                        account: {}
                                    }
                                };
                            }

                            if (!item.monday) item.monday = {};
                            if (!item.tuesday) item.tuesday = {};
                            if (!item.wednesday) item.wednesday = {};
                            if (!item.thursday) item.thursday = {};
                            if (!item.friday) item.friday = {};
                        });
                    }
                    return data;
                },
                parse: function(data) {
                    angular.forEach(data, function(item) {
                        if (item.startedAt != undefined) item.startedAt = kendo.toString(kendo.parseDate(item.startedAt), 'dd/MM/yyyy');
                        if (item.endedAt != undefined) item.endedAt = kendo.toString(kendo.parseDate(item.endedAt), 'dd/MM/yyyy');

                        //copy employeeCustomerSectors so to splice in foreach
                        var employeeCustomerSectorsToShow = angular.copy(item.employeeCustomerSectors);
                        //copy for backup
                        item.employeeCustomerSectorsAll = angular.copy(item.employeeCustomerSectors);
                        if(item.employeeCustomerSectors != null) {
                            angular.forEach(item.employeeCustomerSectors, function(employeeCustomerSector) {
                                if(employeeCustomerSector.active == false) {
                                    var foundItemById = $filter('filter')(employeeCustomerSectorsToShow, {id: employeeCustomerSector.id}, true)[0];
                                    employeeCustomerSectorsToShow.splice(employeeCustomerSectorsToShow.indexOf(foundItemById), 1);
                                }
                            });

                            item.employeeCustomerSectors = employeeCustomerSectorsToShow;
                            angular.forEach(item.employeeCustomerSectors, function(employeeCustomerSector) {
                                employeeCustomerSector.employee.account.fullName =
                                    employeeCustomerSector.employee.account.lastName + " " + employeeCustomerSector.employee.account.firstName;
                            });
                        }
                    });
                    return data;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: true },
                        sector: { defaultValue : { id : null, name : null} },
                        'sector.name': { editable: false },
                        sectorPosition: {defaultValue : { id : null, name : null}},
                        phone : { defaultValue : null},
                        startedAt: { type: 'date'},
                        endedAt: { type: 'date', defaultValue : null},
                        'employeeCustomerSectors': {},
                        sectorParent: { from: "sector.parent", defaultValue : { id : null, name : null} },
                        'sectorParent.name': { editable: false },
                        'sector.address': { editable: false },
                        'sector.addressNum': { editable: false },
                        'sector.postalCode': { editable: false },
                        'sector.brick': { editable: false },
                        'sector.osfeBrick': { editable: false },
                        'sector.cityName': { editable: false },
                        'sector.prefectureName': { editable: false },
                        main: { editable: true, type:"boolean" },
                        monday: { editable: true},
                        tuesday: { editable: true},
                        wednesday: { editable: true},
                        thursday: { editable: true},
                        friday: { editable: true}
                    }
                }
            }
        });
        vm.sectorsGridOptions = CustomerSectorsService.getSectorsOptions(grids.sectorsGrid.dataSource, grids.sectorsGrid.columns);
        angular.extend( vm.sectorsGridOptions, {
            edit: function(e) {
                // Fired when edit a row (pencil) from main grid)
                e.model.dirty = true;
                vm.employeeDataItems = angular.copy(e.model);

                if(!e.model.isNew()) {
                    if (e.model.main) angular.element("[name=main]").prop("disabled", true);
                }

                this._editContainer.addClass("default-popup");
                this._editContainer.addClass("two-columns");
                vm.kendoGrid.defaultCustomEditPopup(this._editContainer, 1000, 470);
                angular.element(e.container).data("kendoWindow").center();
            },
            save: function () {
                var customerSectorsGrid = angular.element("#sectorsGrid").data("kendoGrid");
                customerSectorsGrid.refresh();
            }
        });

        vm.windowOptions = {
            appendTo: '#customSectorWindow'
        };

        vm.openWindow = function(){
            EmployeesService.setInitPopupGrid(true);
            var wdw = angular.element("#popup-new-customSector").data("kendoWindow");
            vm.clearWindow();
            wdw.center().open();

            //fix position
            angular.element("#popup-new-customSector").closest(".k-window")
                .css({ top: angular.element(window).height()/8 });

            CustomerSectorsService.setIsSectorSaved(false);

            //clear dataItems selected
            vm.statusChanged = "opened";
        };

        vm.clearWindow = function () {
            //clear kendoComboBox
            angular.forEach(comboBoxes, function (item) {
                var filter = {};
                var comboBox = angular.element(item).data("kendoComboBox");
                if(comboBox) {
                    comboBox.value("");
                    if (item == "#cities") vm.refreshCombobox(filter, CustomerSectorsService.getCitiesComboboxOptions().dataSource);
                    else if (item == "#prefectures") vm.refreshCombobox(filter,  CustomerSectorsService.getPrefecturesComboboxOptions().dataSource);
                }
            });
        };

        // Not used
        vm.detailedGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                $http.get('api/customer-sectors/' + dataItem.id + '/working-days', {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {});
                            },
                            create: function(o) {
                                vm.newWorkingHour = {
                                    firstShiftFrom : null,
                                    firstShiftTo : null,
                                    secondShiftFrom : null,
                                    secondShiftTo : null,
                                    weekDayNo : null,
                                    customerSector : { id : dataItem.id }
                                };

                                vm.saveWorkingHour = o.data.models[0];

                                if(vm.saveWorkingHour.firstShiftFrom != null)
                                    vm.newWorkingHour.firstShiftFrom = timeToString(vm.saveWorkingHour.firstShiftFrom);
                                if(vm.saveWorkingHour.firstShiftTo != null)
                                    vm.newWorkingHour.firstShiftTo = timeToString(vm.saveWorkingHour.firstShiftTo);
                                if(vm.saveWorkingHour.secondShiftFrom != null)
                                    vm.newWorkingHour.secondShiftFrom = timeToString(vm.saveWorkingHour.secondShiftFrom);
                                if(vm.saveWorkingHour.secondShiftTo != null)
                                    vm.newWorkingHour.secondShiftTo = timeToString(vm.saveWorkingHour.secondShiftTo);
                                if(vm.saveWorkingHour.weekDayNo != null)
                                    vm.newWorkingHour.weekDayNo = vm.saveWorkingHour.weekDayNo;

                                WorkingDay.update({}, vm.newWorkingHour,
                                    function () {
                                        angular.element("#workingHoursGrid").data("kendoGrid").dataSource.read();
                                    });
                            },
                            update: function(o) {
                                vm.saveWorkingHour = o.data.models[0];
                                WorkingDay.update({}, vm.saveWorkingHour,
                                    function () {
                                        angular.element("#workingHoursGrid").data("kendoGrid").dataSource.read();
                                    });
                            },
                            destroy: function(o) {
                                vm.deleteWorkingHourId = o.data.models[0].id;
                                var url = 'api/working-days/' + vm.deleteWorkingHourId;
                                $http.delete(url)
                                    .success(function (response) {
                                        o.success(response);
                                    })
                                    .error(function (response) {});
                            }
                        },
                        schema: {
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    weekDayNo: { editable: true, nullable: false, validation: { min:1, max:7} },
                                    firstShiftFrom: { editable: true, nullable: false },
                                    firstShiftTo: { editable: true, nullable: false },
                                    secondShiftFrom: { editable: true, nullable: true },
                                    secondShiftTo: { editable: true, nullable: true }
                                }
                            }
                        }
                    },
                    columns: [
                        {field: "weekDayNo", title: "Ημέρα", decimals: 0, step: 1, format: "{0:n0}", editor: CustomerSectorsService.getDateEditor, template: "#= weekDayNo == '1' ? 'Δευτέρα' : weekDayNo == '2' ? 'Τρίτη': weekDayNo == '3' ? 'Τετάρτη': weekDayNo == '4' ? 'Πέμπτη': weekDayNo == '5' ? 'Παρασκευή': weekDayNo == '6' ? 'Σάββατο': weekDayNo == '7' ? 'Κυριακή' : null #"},
                        {field: "firstShiftFrom", title: "1η βάρδια από", format:"{0:HH:mm}", editor: CustomerSectorsService.getTimeEditor, template: "#= kendo.toString(kendo.parseDate(firstShiftFrom), 'HH:mm') #"},
                        {field: "firstShiftTo", title: "1η βάρδια έως", format:"{0:HH:mm}", editor: CustomerSectorsService.getTimeEditor, template: "#= kendo.toString(kendo.parseDate(firstShiftTo), 'HH:mm') #"},
                        {field: "secondShiftFrom", title: "2η βάρδια από", format:"{0:HH:mm}", editor: CustomerSectorsService.getTimeEditor, template: "#= secondShiftFrom == null ? '' : kendo.toString(kendo.parseDate(secondShiftFrom), 'HH:mm') #"},
                        {field: "secondShiftTo", title: "2η βάρδια έως", format:"{0:HH:mm}", editor: CustomerSectorsService.getTimeEditor, template: "#= secondShiftTo == null ? '' : kendo.toString(kendo.parseDate(secondShiftTo), 'HH:mm') #"},
                        {command:[{name:"edit", text: "Επεξεργασία"}], title: "&nbsp;", width:140},
                        {command:[{name:"destroy", text: "Διαγραφή"}], title: "&nbsp;", width:140}
                    ],
                    toolbar: [{name :"create", text: "Προσθήκη Νέου Ωραρίου"}],
                    edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
                    editable: {
                        confirmation: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την εγγραφή;",
                        mode: "popup"
                    }
                };
            }
        };

        vm.toggleSelectAll = function (ev) {
            vm.allSelected = !vm.allSelected;
            var grid = angular.element(ev.target).closest("[kendo-grid]").data("kendoGrid");
            angular.forEach( grid.dataSource.data(), function( dataItem ) {
                dataItem.myTarget = vm.allSelected;
            });
        };

        vm.onMyTargetClick = function (dataItem) {
            dataItem.myTarget = !dataItem.myTarget;
            if (!dataItem.myTarget) {
                vm.allSelected = dataItem.myTarget;
            }
        };

        var customersPromise = $http.get('api/customers/' + vm.selectedUserId);
        customersPromise.then(function(response) {
            vm.customer = response.data;
            vm.allSelected = false;
            var foundItemById = $filter('filter')(vm.customer.customerTypes, {id: 1}, true)[0];

            if ( vm.customer.customerTypes.indexOf(foundItemById) !== -1) vm.extendSectorsGridColumns();
            else EmployeesService.setHasAssignations(false);
        });

        vm.extendSectorsGridColumns = function () {
            // Comment-out this because it makes grid to make a double get request SIGMASF-2407
            /*var grid = angular.element("#sectorsGrid").data("kendoGrid");
            grids.sectorsGrid.columns.push({
                field: "employeeCustomerSectors",
                title: "Ιατρικοί Επισκέπτες", hidden: true,
                filterable: false,
                template: employeeCustomerSectorsDisplay,
                editor: function (container, options) {
                    angular.element('<select id="employeeCustomerSectors" style="width:800px;" multiple="multiple" data-bind="value: employeeCustomerSectors"/>')
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: new kendo.data.DataSource({
                                serverFiltering: true,
                                transport: {
                                    read: function (o) {
                                        if (o.data.filter == undefined) {
                                            o.data.filter = {filters: []};
                                        }

                                        o.data.page = 1;
                                        o.data.pageSize = 10000;
                                        $http.get('/api/me/employees',
                                            {params: o.data})
                                            .success(function (response) {
                                                o.success(response.content);
                                            })
                                            .error(function (response) {});
                                    }
                                },
                                schema: {
                                    parse: function(data) {
                                        angular.forEach(data, function(item) {
                                            //define object for data binding
                                            if(item.account != null) {
                                                item.active = item.myTarget = true;
                                                item.employee = {
                                                    account : {
                                                        fullName: item.account.lastName + " " + item.account.firstName
                                                    },
                                                    id: item.id
                                                }
                                            }
                                            //if exists but active false keep employeeCustomerSectors id
                                            if ( vm.employeeDataItems.employeeCustomerSectorsAll ) {
                                                if (vm.employeeDataItems.employeeCustomerSectorsAll.length) {
                                                    var foundItemByEmployeeId = $filter('filter')(vm.employeeDataItems.employeeCustomerSectorsAll, {employee: {id: item.id}}, true)[0];
                                                    if (vm.employeeDataItems.employeeCustomerSectorsAll.indexOf(foundItemByEmployeeId) !== -1) {
                                                        item.id = foundItemByEmployeeId.id
                                                    } else {
                                                        item.id = null;
                                                    }
                                                } else {
                                                    item.id = null;
                                                }
                                            }

                                        });
                                        return data;
                                    }
                                }
                            }),
                            valuePrimitive: false,
                            dataTextField: "employee.account.fullName",
                            dataValueField: "employee.id"
                        });

                    vm.myTargetGridOptions = {
                        dataSource : new kendo.data.DataSource({
                            data: angular.element("#employeeCustomerSectors").data("kendoMultiSelect").dataItems(),
                            pageSize: 10,
                            schema: {
                                model: {
                                    id: "id",
                                    fields: {
                                        id: { editable: false, nullable: true },
                                        'employee.account.fullName': { editable: false },
                                        myTarget: { type: "boolean" }
                                    }
                                }
                            }
                        }),
                        sortable: true,
                        pageable: true,
                        scrolable: true,
                        editable: true,
                        filterable: false/!*{
                            mode: "row"
                        }*!/,
                        resizable: true,
                        columns: [
                            {
                                field: "employee.account.fullName",
                                title: "Επιλεγμένοι Ιατρικοί Επισκέπτες"/!*,
                                filterable: {
                                    cell: {
                                        operator: "startswith",
                                        template: function (args) {
                                            KendoFilter.getTemplate(args);
                                        },
                                        showOperators: false
                                    }
                                }*!/
                            },
                            {
                                template: '<input type="checkbox" ng-click="vm.onMyTargetClick( dataItem );" ng-checked="dataItem.myTarget" class="checkbox"/>', //
                                title: "<label>myTarget </label>" +
                                "<input id='checkboxMyTarget' type='checkbox' class='checkbox' ng-checked='vm.allSelected' " +
                                "ng-click='vm.toggleSelectAll($event)'/>",
                                width: 100,
                                filterable: false
                            }
                        ]
                    };

                    angular.element($compile('<div kendo-grid id="employeeCustomerSectorsGrid" style="width:800px;" k-options="vm.myTargetGridOptions" ' +
                        'data-bind="source: employeeCustomerSectors"></div>')($scope))
                        .appendTo(container);
                }
            });

            grid.setOptions({
                columns: grids.sectorsGrid.columns
            });*/
        };

        /**
         * Gets a list of customerSectors (sectorsGrid) and search if at least one CustomerSector
         * belongs to current logged Employee. CustomerSector.employeeCustomerSectors contains employee with id equals
         * to current logged employee. If it has not, it navigates user to /customers screen.
         * The check runs only for user that is not ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
         * @param customerSectorList A list of CustomerSectors
         */
        vm.checkEmployeeCustomerSectors = function (customerSectorList) {
            if (!Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR'])) {
                var mineEcs = 0;
                if (CustomDataUtils.isNotEmpty(customerSectorList)) {
                    customerSectorList.forEach(function (cs) {
                        if (CustomDataUtils.isNotEmpty(cs.employeeCustomerSectors)) {
                            cs.employeeCustomerSectors.forEach(function (ecs) {
                                if (CustomDataUtils.isNotNil(ecs.employee) && ecs.active === true && ecs.employee.id === vm.employee.id ) {
                                    mineEcs++;
                                }
                            });
                        }
                    });
                }

                if (mineEcs === 0) {
                    $state.go('adminCustomers');
                }
            }
        }
    }
})();
;
/**
 * Created by Kristy on 27/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeesAssignation', {
                parent: 'customerSectors',
                url: 'employeesAssignation',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR']
                },
                templateUrl: 'app/displays/adminCustomers/sectors/employees/employees.html',
                controller: 'EmployeesAssignationController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 27/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeesAssignationController', EmployeesAssignationController);

    EmployeesAssignationController.$inject = ['$http', '$filter', '$stateParams', 'Sector', 'EmployeesService', 'KendoNotifications', 'KendoValidator', 'NotificationOptions', 'KendoGrid', 'CustomerSectorsService', 'CustomerSector'];

    function EmployeesAssignationController ($http, $filter, $stateParams, Sector, EmployeesService, KendoNotifications, KendoValidator, NotificationOptions, KendoGrid, CustomerSectorsService, CustomerSector) {
        var vm = this;
        vm.massSelect = true;
        vm.employeesService = EmployeesService;
        vm.hasAssignations = vm.employeesService.getHasAssignations();
        vm.selectedEmployees = [];
        vm.myTarget = true;
        vm.selectedUserId = $stateParams.id;
        vm.customerSectorsService = CustomerSectorsService;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        var validator = angular.element("#form").kendoValidator(KendoValidator.getCustomValidatorOptions).data("kendoValidator");
        vm.sector = vm.customerSectorsService.getSector();

        //POPUP grid
        var grid = {};
        grid.dataSource = new kendo.data.DataSource({
            batch: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    $http.get('/api/me/employees',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                },
                parameterMap: function (data, operation) {
                    if (operation !== 'read') {
                        return JSON.stringify(data.models);
                    } else {
                        return data;
                    }
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.content.forEach(function(item){

                            if (!item.account) {
                                item.account = {
                                    firstName: "",
                                    lastName: "",
                                    login: ""
                                };
                            }

                            if (!item.supervisor) {
                                item.supervisor = {
                                    account: {fullName: ""}
                                }
                            } else {
                                if (item.supervisor.account.lastName && item.supervisor.account.firstName) {
                                    item.supervisor.account.fullName =
                                        item.supervisor.account.lastName + " " + item.supervisor.account.firstName;
                                } else if (!item.supervisor.account.firstName) {
                                    item.supervisor.account.fullName = item.supervisor.account.lastName;
                                } else if (!item.supervisor.account.lastName) {
                                    item.supervisor.account.fullName = item.supervisor.account.firstName;
                                }
                            }
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: false },
                        district : {defaultValue: {}},
                        password: { type: 'password', editable: true, nullable: false, defaultValue: null },
                        supervisor: { defaultValue: { account: { defaultValue: {}} }},
                        account: { defaultValue: {} },
                        mobileVersion: {editable:false}
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20
        });
        vm.employeeAllGridOptions = vm.employeesService.getEmployeesOptions(grid.dataSource);
        angular.extend(vm.employeeAllGridOptions, {
            selectedItems: function(dataItems) {
                vm.selectedEmployees = dataItems;
            },
            dataBound: function (e) {
                angular.element("#employeeAllGridcheckbox").prop('checked', false);
                //toggle class on click
                angular.element(".checkbox").bind("change", function (e) {
                    angular.element(e.target).closest("tr").toggleClass("k-state-selected");
                });

                var view = this.dataSource.data();
                var me = this;

                if (vm.selectedEmployees) {
                    var selectedEmployeesViewCounter = 0;
                    angular.forEach( view, function(item) {
                        var foundItemById = $filter('filter')(vm.selectedEmployees, {id: item.id}, true)[0];
                        if(vm.selectedEmployees.indexOf(foundItemById) !== -1){
                            me.tbody.find("tr[data-uid='" + item.uid + "']")
                                .addClass("k-state-selected");
                            item.selected = true;
                            selectedEmployeesViewCounter++
                        }
                    });
                    if(selectedEmployeesViewCounter == view.length) {
                        angular.element("#employeeAllGridcheckbox").prop('checked', true);
                    }
                }
            }
        });
        KendoGrid.refresh(vm.employeeAllGridOptions)

        vm.updateSector = function(){
            if (!vm.customerSectorsService.getSector().id) {
                if (validator.validate()) {
                    Sector.update({}, vm.customerSectorsService.getSector(),
                        function (response) {
                            KendoNotifications.onSave(notification, "Η Μονάδα Υγείας προστέθηκε με επιτυχία", "success");
                            vm.savedSector = true;
                            vm.customerSectorsService.setIsSectorSaved(true);
                            vm.customerSectorsService.setSector(response);
                            vm.saveCustomerSectors();
                        },
                        function () {
                            KendoNotifications.onSave(notification, "Η προσθήκη της Μονάδα Υγείας απέτυχε", "error");
                        });
                } else {
                    KendoNotifications.onSave(notification, "Η προσθήκη της Μονάδα Υγείας απέτυχε", "error");
                }
            } else {
                vm.saveCustomerSectors();
            }
        };

        vm.saveCustomerSectors = function() {
            var wdw = angular.element("#popup-new-customSector").data("kendoWindow");
            vm.choices = [];
            angular.forEach( vm.selectedEmployees, function(item) {
                var modifiedItem = {
                    active: true,
                    myTarget: vm.myTarget,
                    employee: { id: item.id },
                    id: null
                };
                vm.choices.push(modifiedItem)
            });
            var modifiedCustomerSector = {
                id: null,
                employeeCustomerSectors: vm.choices,
                customer: { id: vm.selectedUserId },
                startedAt: new Date(),
                sector: vm.customerSectorsService.getSector()
            };

            vm.newCustomerSector = vm.customerSectorsService.getCustomerSector();
            angular.extend(vm.newCustomerSector, modifiedCustomerSector);

            if(!vm.newCustomerSector.sectorPosition.id) vm.newCustomerSector.sectorPosition = null;

            CustomerSector.update({}, vm.newCustomerSector,
                function () {
                    KendoNotifications.onSave(notification, "Η ανάθεση Μονάδα Υγείας πραγματοποιήθηκε με επιτυχία!", "success");
                    angular.element("#sectorsGrid").data("kendoGrid").dataSource.read();
                    delete vm.newSectorObj;
                    wdw.close();
                },
                function () {
                    KendoNotifications.onSave(notification, "Η ανάθεση Μονάδα Υγείας απέτυχε", "error");
                });

            //clear dataItems selected
            vm.statusChanged = "saved";
        };
    }
})();
;
/**
 * Created by Kristy on 27/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerSectorAssignation', {
                parent: 'customerSectors',
                url: '/customerSectorAssignation',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR']
                },
                templateUrl: 'app/displays/adminCustomers/sectors/customerSector/customerSector.html',
                controller: 'CustomerSectorAssignationController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy on 27/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSectorAssignationController', CustomerSectorAssignationController);

    CustomerSectorAssignationController.$inject = ['$stateParams', '$timeout','$http', 'KendoService', 'CustomerSectorsService', 'KendoFilter'];

    function CustomerSectorAssignationController ($stateParams, $timeout, $http, KendoService, CustomerSectorsService, KendoFilter) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;
        vm.customerSectorsService = CustomerSectorsService;
        vm.customerSectorsService.setIsSectorSaved(false);
        vm.sectorIsSaved = vm.newSector =false;
        vm.newCustomerSector = { startedAt: new Date(), main: true };
        var dataSource = {};

        /**
         * Get selected Customer for autocomplete his
         * name when a private SectorType is selected
         */
        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {
                console.log(response);
            });

        var promise = $http.get('/api/employees/me');
        promise.then(function(response) {
            vm.geodata = response.data.geodata;
            if(!vm.geodata) vm.initializeMasterData();
            else vm.initializeGeodata();
        });

        vm.refreshCombobox = function(filter, combobox) {
            combobox.filter(filter);
            combobox.read();
        };

        vm.initializeMasterData = function() {
            //Prefectures Combobox
            dataSource.prefecturesDataSource = KendoService.initDefaultDataSource('/api/masterdata/prefectures');
            vm.prefecturesComboBoxOptions = KendoService.initDefaultOptions(dataSource.prefecturesDataSource, "startswith", "name", "id");
            vm.prefecturesComboBoxOptions.valuePrimitive = false;
            vm.prefecturesComboBoxOptions.change = function() {
                var filter = {};
                if(this.value() && !isNaN(this.value())) {
                    filter = {
                        "field": "prefecture.id",
                        "operator": "eq",
                        "value": this.value()
                    };
                }
                vm.refreshCombobox(filter, vm.citiesComboBoxOptions.dataSource);
            };
            vm.customerSectorsService.setPrefecturesComboboxOptions(vm.prefecturesComboBoxOptions);

            //Cities Combobox
            dataSource.citiesDataSource = KendoService.initDataSource('/api/masterdata/cities', 1, 50);
            vm.citiesComboBoxOptions = KendoService.initDefaultOptions(dataSource.citiesDataSource, "startswith", "name", "id");
            vm.citiesComboBoxOptions.valuePrimitive = false;
            vm.citiesComboBoxOptions.template = "<table>${name} &nbsp;<span class='hint'>(${prefecture.name})</span></table>";
            vm.citiesComboBoxOptions.change = function() {
                var filter = {};
                if(this.dataItem(this.select())) {
                    filter = {
                        "field"   : "id",
                        "operator": "eq",
                        "value"   : this.dataItem(this.select()).prefecture.id
                    };
                    vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                } else {
                    vm.refreshCombobox(filter, vm.prefecturesComboBoxOptions.dataSource);
                }
            };
            vm.customerSectorsService.setCitiesComboboxOptions(vm.citiesComboBoxOptions);
        };

        vm.initializeGeodata = function() {
            dataSource.geodataDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.page = 1;
                        o.data.pageSize = 100;
                        $http.get('/api/masterdata/geodata',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            item.masterFilter = "";
                            if(item.street !==null) {
                                item.masterFilter =  item.street + ", ";
                            }
                            item.masterFilter = item.masterFilter + item.city + ", " + item.postalCode + ", " + item.prefecture;
                        });
                        return data;
                    }
                }
            });

            vm.masterFilterComboBoxOptions = KendoService.initDefaultOptions(dataSource.geodataDataSource, "search", "masterFilter", "id");
            vm.masterFilterComboBoxOptions.headerTemplate = "<div class='dropdown-header k-widget k-header'>" +
                "<span>Διεύθυνση</span>"+
                "<span>Πόλη</span>"+
                "<span>Τ.Κ.</span>"+
                "<span>Νομός</span></div>";
            vm.masterFilterComboBoxOptions.template = "#= street != null ? street + ', ' + city + ', ' + postalCode + ', ' + prefecture : city + ', ' + postalCode + ', ' + prefecture #";
            vm.masterFilterComboBoxOptions.placeholder =   "Αναζητήστε Διεύθυνση, Πόλη, Τ.Κ., Νομό";
            vm.masterFilterComboBoxOptions.change = function(){
                //initialize inputs (autocomplete)
                if(this.dataItem(this.select())) {
                    var self = this;
                    //using $timeout to trigger the change
                    $timeout(function(){
                        vm.sector.prefectureName = self.dataItem(self.select()).prefecture;
                        vm.sector.cityName = self.dataItem(self.select()).city;
                        vm.sector.address = self.dataItem(self.select()).street;
                        vm.sector.postalCode = self.dataItem(self.select()).postalCode;
                        vm.suggestBricks(vm.sector.postalCode);
                    },0);
                }
            };
        };

        //SectorPositions Combobox
        dataSource.sectorPositionsDataSource = KendoService.initDefaultDataSource('/api/masterdata/sector-positions');
        vm.sectorPositionComboBoxOptions = KendoService.initDefaultOptions(dataSource.sectorPositionsDataSource, "startswith", "name", "id");

        //SectorTypes Combobox
        dataSource.sectorTypesDataSource = new kendo.data.DataSource({
            // filter: sectorTypeFilter(),
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }
                    o.data.filter.filters.push({ "field": "sectorTypeCategory", "operator": "startswith", "value": 'hcu'});

                    o.data.page = 1;
                    o.data.pageSize = 100000;
                    $http.get('/api/masterdata/sector-types',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response.content);
                        })
                        .error(function (response) {});
                }
            }
        });
        vm.sectorTypeComboBoxOptions = KendoService.initDefaultOptions(dataSource.sectorTypesDataSource, "startswith", "name", "id");
        vm.sectorTypeComboBoxOptions.suggest = true;
        vm.sectorTypeComboBoxOptions.change = function() {
            var value = this.value();
            var obj = this.dataItem();
            if (obj.isPrivate) {
                $timeout(function() {
                    vm.newSector = true;
                    vm.sector = { sectorType: { id: value} };
                    vm.sector.name = obj.name + " " + vm.customer.lastName + " " + vm.customer.firstName;
                });
            } else {
                $timeout(function() {
                    vm.newSector = false;
                    vm.sector.name = "";
                });
                vm.sectorsGridOptions.dataSource.filter(
                    { field: "sectorType.id", operator: "eq", value: parseInt(value) }
                );
            }
        };

        vm.suggestBricks = function($value) {
            var data = {};
            data.filter ={
                filters: [
                    {
                        "field": "postalCode",
                        "operator": "eq",
                        "value": $value,
                        "ignoreCase": true
                    }
                ]};
            data.page = 1;
            data.pageSize = 1;


            $http.get('/api/masterdata/bricks',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.brick = response.content[0].territoryNo;
                    }
                })
                .error(function (response) {});


            $http.get('/api/masterdata/brick-osfes',
                {params: data})
                .success(function (response) {
                    if (response.content != null
                        && response.content instanceof Array
                        && response.content.length > 0) {
                        vm.sector.osfeBrick = response.content[0].territoryName;
                    }
                })
                .error(function (response) {});
        };

        var grid = {};
        grid.columns = [
            {field: "name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sectorType.name", title: "Τύπος Μονάδας Υγείας",
                filterable: false
            },
            {field: "doctorSpecialty.name", title: "Ειδικότητες στη ΜΣ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "addressNum", title: "Αριθμός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "postalCode", title: "Τ.Κ.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "prefectureName", title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "brick", title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "osfeBrick", title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "phone", title: "Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "sectorParent.name", title: "Ανήκει στη ΜΣ",
                filterable: {
                    cell: {
                        field : "parent.name",
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];
        grid.dataSource = new kendo.data.DataSource({
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    if(o.data.filter != undefined && o.data.filter.filters != undefined){
                        angular.forEach(o.data.filter.filters, function(item) {
                            if (item.field === "sectorParent.name"){
                                item.field = "parent.name"
                            }
                        });
                    }

                    if(o.data.sort != undefined){
                        angular.forEach(o.data.sort, function(item) {
                            if (item.field === "sectorParent.name"){
                                item.field = "parent.name"
                            }
                        });
                    }

                    $http.get('api/customer-sectors/customers/' + vm.selectedUserId +'/sectors/suggest',
                        {params: o.data})
                        .success(function (response) {
                            o.success(response);
                        })
                        .error(function (response) {});
                }
            },
            schema: {
                data: function (data) {
                    if(data != undefined) {
                        data.content.forEach(function(item){
                            if(item.name === null) item.name = "";
                            if(item.sectorType === null) item.sectorType = {};
                            if(item.doctorSpecialty === null) item.doctorSpecialty = {};
                            if(item.parent === null) item.parent = {};
                        });
                    }
                    return data.content;
                },
                total: function (data) {
                    return data.totalEntries;
                },
                model: {
                    id: "id",
                    fields: {
                        id: { editable: false, nullable: false },
                        sectorParent: { from: "parent", defaultValue : { id : null, name : null} }
                    }
                }
            },
            serverFiltering: true,
            serverSorting: true,
            serverPaging: true,
            pageSize: 20
        });
        vm.sectorsGridOptions = {
            dataSource: grid.dataSource,
            sortable: true,
            pageable: true,
            selectable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: grid.columns,
            change: function() {
                var selectedItem = this.dataItem(this.select());
                $timeout( function() { vm.sector = selectedItem; });
                vm.customerSectorsService.setSector(selectedItem);
            }
        };

        vm.nextView = function() {
            vm.customerSectorsService.setSector(vm.sector);
            vm.customerSectorsService.setCustomerSector(vm.newCustomerSector);
        }
    }
})();
;
/**
 * Created by Maria on 30/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerSchedulerGrid', {
                parent: 'adminCustomerView',
                url: '/schedulerGrid',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/schedulesGrid/schedulesGrid.html',
                controller: 'CustomerSchedulesGridController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Maria on 30/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSchedulesGridController', CustomerSchedulesGridController);

    CustomerSchedulesGridController.$inject = ['$http','$state', '$stateParams','$filter', 'Principal'];

    function CustomerSchedulesGridController ($http, $state, $stateParams, $filter, Principal) {
        var vm = this;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }

        vm.customer = {};
        vm.selectedUserId = $stateParams.id;
        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {
                console.log(response);
            });

        vm.mainGridOptions = {
            dataSource: {
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "eventCustomerSector.customerSector.customer.id", "operator": "eq",  "value": vm.selectedUserId}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('/api/me/schedules',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                console.log(response)
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (options.data.filter != undefined) {
                                angular.forEach(options.data.filter.filters, function (item) {
                                    if (item.field === "eventSchedule.startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventCustomerSector === null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                },
                                                sectorType: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    };
                                }

                                if (item.eventCustomerSector.customerSector == null) {
                                    item.eventCustomerSector.customerSector = {
                                        sector: {
                                            sectorType: {
                                                name: ""
                                            }
                                        }
                                    };
                                }

                                if (item.eventCustomerSector.customerSector.sector == null) {
                                    item.eventCustomerSector.customerSector.sector = {
                                        name: "",
                                        sectorType: {
                                            name: ""
                                        }
                                    };
                                }

                                if (item.eventCustomerSector.customerSector.sector.sectorType == null) {
                                    item.eventCustomerSector.customerSector.sector.sectorType = {
                                            name: ""
                                    };
                                }

                                if (item.employee === null) {
                                    item.employee = { account: { lastName: ""}};
                                }else {
                                    if (item.employee.account === null) {
                                        item.employee.account = { lastName: "" };
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            'eventSchedule.startedAt': { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            },
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {field: "eventSchedule.startedAt", title: "Ημερομηνία Ραντεβού", template: "#= eventSchedule.startedAt ? kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        { field: "eventCustomerSector.customerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {
                    title: "Ιατρικός Επισκέπτης",
                    columns: [
                        {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        },
                        {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "title", title: "Τίτλος",
                    filterable: {
                        cell: {
                            operator: "like",
                            showOperators: false
                        }
                    }
                },
                {field: "eventSchedule.description", title: "Σημειώσεις Ραντεβού",
                    filterable: {
                        cell: {
                            operator: "like",
                            showOperators: false
                        }
                    }
                }
            ]
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerScheduler', {
                parent: 'adminCustomerView',
                url: '/scheduler',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/scheduler/scheduler.html',
                controller: 'CustomerSchedulerController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSchedulerController', CustomerSchedulerController);

    CustomerSchedulerController.$inject = ['$http','$state', '$stateParams','$filter', 'Principal', 'ApplicationParameters'];

    function CustomerSchedulerController ($http, $state, $stateParams, $filter, Principal, ApplicationParameters) {
        var vm = this;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }
        ApplicationParameters.hasModule('Scheduling', true);
        vm.customer = {};
        vm.selectedUserId = $stateParams.id;
        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {
                console.log(response);
            });

        vm.tooltipContent = kendo.template($("#template").html());
        if (vm.readOnly) {
            var startTime = new Date();
            startTime.setHours(8,0,0,0);

            var viewModel2 = new kendo.observable({
                schedulerData: new kendo.data.SchedulerDataSource ({
                    batch: true,
                    transport: {
                        read: function(o){
                            var scheduler = $("#scheduler").data("kendoScheduler");
                            var view = scheduler.view();

                            if (o.data.filter == undefined) {
                                o.data.filter = { filters: [
                                    { "field": "eventCustomerSector.customerSector.customer.id", "operator": "eq",
                                        "value": vm.selectedUserId },
                                    { "field": "startedAt", "operator": "from",
                                        "value": $filter('date')(view.startDate(), 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "startedAt", "operator": "to",
                                        "value": $filter('date')(view.endDate(), 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ] };
                            }

                            $http.get('/api/me/events-and-schedules/all', { params: o.data })
                                .success(function (response,status,headers) {
                                    o.success(response);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        },
                        create: function(o){
                            var data = o.data.models[0];
                            data.eventCategoryType = {
                                id: 1
                            };

                            var date = new Date(data.start);
                            date.setTime(date.getTime() + (data.duration*60*1000));
                            angular.extend(data.eventSchedule, {
                                startedAt: data.start,
                                finishedAt: date
                            });

                            data.id = null;
                            data.eventCustomerSector.id = null;

                            $http.post('/api/events', data)
                                .success(function (response,status,headers) {
                                    o.success([response]);
                                    var scheduler = $("#scheduler").data("kendoScheduler");
                                    scheduler.dataSource.read();
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        },
                        update: function(o){
                            var data = o.data.models[0];
                            data.eventCategoryType = {
                                id: 1
                            };
                            var date = new Date(data.start);
                            date.setTime(date.getTime() + (data.duration*60*1000));
                            if(!data.startedAt) {
                                data.eventSchedule.startedAt = data.start;
                                data.eventSchedule.finishedAt = date;
                            } else {
                                data.startedAt = data.start;
                                data.finishedAt = date;
                            }

                            data.eventCustomerSector.agreementValuation = null;

                            $http.put('/api/events', data)
                                .success(function (response,status,headers) {
                                    o.success([response]);
                                    var scheduler = $("#scheduler").data("kendoScheduler");
                                    scheduler.dataSource.read();
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        }
                    },
                    schema: {
                        data: function (data) {
                            if(data) {
                                data.forEach( function (item) {
                                    if (!item.eventCustomerSector) {
                                        item.eventCustomerSector = {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                },
                                                sector: {
                                                    address: "",
                                                    city: {
                                                        name: ""
                                                    }
                                                }
                                            },
                                            agreementValuation: {
                                                name: ""
                                            },
                                            communicationType: {
                                                name: ""
                                            }
                                        };
                                    } else {
                                        if (item.eventCustomerSector.agreementValuation === null) {
                                            item.eventCustomerSector.agreementValuation = {};
                                            item.eventCustomerSector.agreementValuation.name = "";
                                        }
                                        if (item.eventCustomerSector.communicationType === null) {
                                            item.eventCustomerSector.communicationType = {};
                                            item.eventCustomerSector.communicationType.name = "";
                                        }
                                    }

                                    if (item.eventSchedule === null) {
                                        item.eventSchedule = {
                                            description: ""
                                        };
                                    }
                                });
                            }

                            return data;
                        },
                        parse: function (data) {
                            if(data) {
                                data.forEach( function (item) {
                                    if (item.startedAt === null) {
                                        item.isSchedule = true;
                                        item.start = item.eventSchedule.startedAt;
                                        item.end = item.eventSchedule.finishedAt;
                                    } else {
                                        item.isSchedule = false;
                                        item.start = item.startedAt;
                                        item.end = item.finishedAt;
                                    }

                                    item.duration = ((new Date(item.end) - new Date(item.start))/1000/60) << 0;
                                });
                            }
                            return data;
                        },
                        model: {
                            id: "taskId",
                            fields: {
                                taskId: { from: "id", type: "number", editable: false },
                                start: { type: "date", from: "start" },
                                end: { type: "date", from: "end" },
                                durationTime: { type: "number", defaultValue: 15, from: "duration" },
                                title: { from: "title", defaultValue: "ΠΡΟΣΩΠΙΚΗ ΕΠΙΣΚΕΨΗ", validation: { required: true } },
                                eventSchedule: { defaultValue: {} },
                                eventCustomerSector: {
                                    defaultValue: {
                                        communicationType: { defaultValue: {} },
                                        customerSector: {
                                            defaultValue: { customer: {defaultValue: {}}, sector: {defaultValue: {}}}
                                        }
                                    }
                                }
                            }
                        }
                    },
                    serverFiltering: true
                })
            });

            //vm.checkAvailability = function (e) {
            //    if (e.event.eventCustomerSector.customerSector.customer) {
            //        if (e.event.eventCustomerSector.customerSector.customer.id != vm.selectedUserId) {
            //            e.preventDefault();
            //        }
            //    }
            //};

            vm.schedulerOptions = {
                dataSource: viewModel2.schedulerData,
                dataBound: function(e) {
                    if (this.view().name === "day") {
                        vm.view = "day";
                    } else if (this.view().name === "workWeek" || this.view().name === "week") {
                        vm.view = "week";
                    } else if (this.view().name === "month") {
                        vm.view = "month";
                    }
                },
                resources: [
                    {
                        field: "isSchedule",
                        dataSource: [
                            { text: "Event", value: true, color: "#007fff!important" },
                            { text: "Schedule", value: false, color: "#ff5c33!important" }
                        ]
                    }
                ],
                date: new Date(),
                startTime: startTime,
                allDaySlot: false,
                messages: {
                    today: "Τρέχουσα Ημέρα",
                    showFullDay: "Προβολή ολόκληρης της ημέρας",
                    showWorkDay: "Προβολή ωραρίου εργασίας",
                    "cancel": "Κλείσιμο",
                    "save": "Αποθήκευση",
                    "editor": {
                        "title": "Τίτλος Ραντεβού",
                        "start": "Ημερομηνία",
                        "end": "Τελειώνει"
                    }
                },
                height: 600,
                views: [
                    { type: "day", title: "Ημέρα" },
                    { type: "workWeek", title: "Εργάσιμες Ημέρες", selected: true },
                    { type: "week", title: "Εβδομάδα" },
                    { type: "month", title: "Μήνας" }
                ],
                editable: {
                    destroy: false,
                    mode: "popup",
                    template: kendo.template(angular.element("#popup_editor2").html())
                },
                //resize: function(e) {
                //    vm.checkAvailability(e);
                //},
                //move: function(e) {
                //    vm.checkAvailability(e);
                //},
                //save: function(e) {
                //    vm.checkAvailability(e);
                //},
                edit: function(e) {
                    $("div.k-edit-form-container").width(1000);
                    var wnd = $(e.container).data("kendoWindow");
                    wnd.setOptions({
                        title: "Ραντεβού"
                    });

                    e.container
                        .find("[name=isAllDay]") // find the all day checkbox
                        .parent() // get its wrapper
                        .prev() // get the label wrapper
                        .remove() // remove the label wrapper
                        .end() // get back to the checkbox wrapper
                        .remove(); // remove the checkbox wrapper

                    e.container
                        .find("[name=recurrenceRule]") // find the recurrence rule
                        .parent() // get its wrapper
                        .prev() // get the label wrapper
                        .remove() // remove the label wrapper
                        .end() // get back to the checkbox wrapper
                        .remove(); // remove the checkbox wrapper

                    vm.currentCustomer = e.event.eventCustomerSector.customerSector.customer;
                    vm.currentSector = e.event.eventCustomerSector.customerSector.sector;

                    //choose readonly editor if is not a schedule
                    if(!e.event.isNew()) {
                        vm.customerChanged = false;
                        vm.isSchedule = !e.event.startedAt;

                        if(!vm.isSchedule) {
                            wnd.setOptions({
                                title: "Δραστηριότητα"
                            });
                        }

                        if(!vm.isSchedule || vm.currentCustomer.id != vm.selectedUserId) {
                            e.container
                                .find(".k-edit-buttons") // find edit buttons
                                .remove(); // remove the checkbox wrapper
                        }

                        //read customerSectors
                        var sector = $("#sector").data("kendoComboBox");
                        sector.dataSource.read();
                    } else {
                        vm.customerChanged = true;
                        vm.currentCustomer = vm.customer;
                        vm.isSchedule = true;
                    }
                }
            };

            vm.customerSectorComboBoxDataSource= new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if(vm.currentCustomer) {
                            var filter =  { "filters" : [ { "field": "customer.id", "operator": "eq",  "value": vm.currentCustomer.id } ] }
                        }
                        var url = '/api/me/customer-sectors';
                        o.data.page = 1;
                        o.data.pageSize = 1000;
                        o.data.filter = filter;
                        $http.get(url, {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            });

            vm.communicationTypesComboBoxDataSource= new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        var url = '/api/masterdata/communication-types';
                        o.data.page = 1;
                        o.data.pageSize = 1000;
                        $http.get(url, {params: o.data })
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            });

            vm.communicationTypesComboBoxOptions = {
                dataSource: vm.communicationTypesComboBoxDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "name",
                dataValueField: "id",
                dataBound: function() {
                    if (!this.value() && this.selectedIndex == -1) {
                        this.select(0);
                        this.trigger("change");
                    }
                }
            };

            vm.sectorComboBoxOptions = {
                dataSource: vm.customerSectorComboBoxDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "sector.name",
                dataValueField: "id",
                dataBound: function() {
                    if (vm.customerChanged) {
                        this.select(0);
                        this.trigger("change");
                    }
                }
            };
        }

    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerPatchReports.pendingHistory', {
                parent: 'customerPatchReports',
                url: '/pendingHistory',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR']
                },
                templateUrl: 'app/displays/adminCustomers/patchReports/pendingHistory/pendingHistory.html',
                controller: 'AdminCustomersPendingHistoryPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomersPendingHistoryPatchReportsController', AdminCustomersPendingHistoryPatchReportsController);

    AdminCustomersPendingHistoryPatchReportsController.$inject = ['$http','$state', '$q', '$stateParams','$filter', '$timeout', 'PatchItemMasterFilter', 'DetailGridsService', 'KendoFilter'];

    function AdminCustomersPendingHistoryPatchReportsController ($http, $state, $q, $stateParams, $filter, $timeout, PatchItemMasterFilter, DetailGridsService, KendoFilter) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;
        vm.detailGridsService = DetailGridsService;
        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.pendingHistoryGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "patchStatus", "operator": "eq",
                                    "value": 'executed' },
                                { "field": "customerSector.customer.id", "operator": "eq",
                                    "value": vm.selectedUserId }
                            ]
                        );

                        if(PatchItemMasterFilter.getSelectedPatchItems().length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "patchReportItems.patchItem.id", "operator": "in",
                                        "value": PatchItemMasterFilter.getSelectedPatchItems().toString() }
                                ]
                            );
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/me/patch-reports',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.materialCategory === null)
                                    item.materialCategory = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            issueDate: { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                    template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.address", title: "Διεύθυνση",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "customerSector.sector.cityName", title: "Πόλη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.firstName", title: "Όνομα Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "barcode", title: "Barcode",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "materialCategory.name", title: "Κατηγορία Υλικού",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "submitPoint", title: "Σημείο Υποβολής",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingHistoryGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.patchReportItemsGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/me/patch-report-items';
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                $http.get(url, {params: o.data })
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {field: "patchItem.name", title: "Περιγραφή Υλικού"},
                        {field: "monthlyQuantity", title: "Μηνιαία Ποσότητα σε τεμάχια"},
                        {field: "icd10.code", title: "Κωδικός Διάγνωσης"},
                        {field: "icd10.description", title: "Περιγραφή Διάγνωσης"}
                    ]
                };
            }
        };

        vm.patchReportPhotosGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                var url = '/api/me/patch-report-photos';
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }
                                o.data.filter.filters.push({ "field": "patchReport.id", "operator": "eq", "value": dataItem.id});
                                $http.get(url, {params: o.data })
                                    .success(function (response,status,headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {field: "patchPhotoName", title: "Όνομα αρχείου"},
                        {field: "patchPhotoType", title: "Τύπος φωτογραφίας"},
                        {
                            command:[
                                { name:"show", text: "Προβολή", click: vm.openPhotoWindow }
                            ],
                            title: "&nbsp",
                            width:90
                        }
                    ]
                };
            }
        };
    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerPatchReports.pending', {
                parent: 'customerPatchReports',
                url: '/pending',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR']
                },
                templateUrl: 'app/displays/adminCustomers/patchReports/pending/pending.html',
                controller: 'AdminCustomersPendingPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomersPendingPatchReportsController', AdminCustomersPendingPatchReportsController);

    AdminCustomersPendingPatchReportsController.$inject = ['$http', '$q','$filter', '$stateParams', 'NotificationOptions', 'DetailGridsService', 'Principal', 'PatchItemMasterFilter', 'KendoFilter'];

    function AdminCustomersPendingPatchReportsController ($http, $q, $filter, $stateParams, NotificationOptions, DetailGridsService, Principal, PatchItemMasterFilter, KendoFilter) {
        var vm = this;
        vm.detailGridsService = DetailGridsService;
        vm.selectedUserId = $stateParams.id;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        vm.executePatchReport = function(e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            var data = this.dataItem(tr);

            $http.put('api/patch-reports/' + data.id + '/execute', data)
                .success(function (response,status,headers) {
                    notification.show({
                        message: "Η εγγραφή εκτελέστηκε με επιτυχία!"
                    }, "success");
                    vm.pendingGridOptions.dataSource.read();
                })
                .error(function (response) {
                    notification.show({
                        message: "Η ενημέρωση των στοιχείων απέτυχε!"
                    }, "error");
                    console.log(response);
                });
        };

        vm.openPhotoWindow = function (e) {
            e.preventDefault();
            // e.target is the DOM element representing the button
            var tr = $(e.target).closest("tr"); // get the current table row (tr)
            // get the data bound to the current table row
            vm.photo = this.dataItem(tr);

            vm.photoWindow.title(vm.photo.patchPhotoName);
            vm.photoWindow.center().open();
            vm.canceler = $q.defer();
            $http.get('api/patch-photos/' + vm.photo.patchPhotoName, {timeout: vm.canceler.promise})
                .success(function (response,status,headers) {
                    vm.patchPhoto = response;
                })
                .error(function (response) {
                    console.log(response);
                });
        };

        vm.closePhotoWindow = function () {
            vm.canceler.resolve();
            delete vm.patchPhoto;
        };

        vm.savePhoto = function () {
            var dataURI = "data:image/png;base64," + vm.patchPhoto;
            kendo.saveAs({
                dataURI: dataURI,
                fileName: vm.photo.patchPhotoName
            });
        };

        vm.gridColumns = [
            {field: "issueDate", title: "Ημερ/νια Γνωμάτευσης",
                template: "#= issueDate ? kendo.toString(kendo.parseDate(issueDate), 'dddd, dd/MM/yyyy') : ''#",
                filterable: {
                    cell: {
                        operator: "eqdate",
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.name", title: "Όνομα Μονάδας Υγείας",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.address", title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "customerSector.sector.cityName", title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.lastName", title: "Επώνυμο Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.firstName", title: "Όνομα Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "patchCustomer.amka", title: "ΑΜΚΑ Ασθενή",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "barcode", title: "Barcode",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "materialCategory.name", title: "Κατηγορία Υλικού",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            },
            {field: "submitPoint", title: "Σημείο Υποβολής",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                }
            }
        ];

        vm.pendingGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "patchStatus", "operator": "eq",
                                    "value": 'pending' },
                                { "field": "customerSector.customer.id", "operator": "eq",
                                    "value": vm.selectedUserId }
                            ]
                        );

                        if(PatchItemMasterFilter.getSelectedPatchItems().length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "patchReportItems.patchItem.id", "operator": "in",
                                        "value": PatchItemMasterFilter.getSelectedPatchItems().toString() }
                                ]
                            );
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-dd');
                            }
                        });

                        $http.get('/api/me/patch-reports',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                if (item.materialCategory === null)
                                    item.materialCategory = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            issueDate: { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: vm.gridColumns,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.patchReportPhotosGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function (o) {
                                var url = '/api/me/patch-report-photos';
                                if (o.data.filter == undefined) {
                                    o.data.filter = {filters: []};
                                }
                                o.data.filter.filters.push({
                                    "field": "patchReport.id",
                                    "operator": "eq",
                                    "value": dataItem.id
                                });
                                $http.get(url, {params: o.data})
                                    .success(function (response, status, headers) {
                                        o.success(response);
                                    })
                                    .error(function (response) {
                                        console.log(response);
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: {editable: false, nullable: true},
                                    monthlyQuantity: {type: 'number'}
                                }
                            }
                        },
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    columns: [
                        {
                            field: "patchPhotoName", title: "Όνομα αρχείου"
                        },
                        {
                            field: "patchPhotoType", title: "Τύπος φωτογραφίας",
                            template: "#= (patchPhotoType == 'injury') ? 'Τραύμα' : (patchPhotoType == 'booklet') ? 'Βιβλιάριο' : (patchPhotoType == 'report') ? 'Χαρτί γνωμάτευσης' : ''#"
                        },
                        {
                            command: [
                                {name: "show", text: "Προβολή", click: vm.openPhotoWindow}
                            ],
                            title: "&nbsp",
                            width: 90
                        }
                    ]
                };
            }
        };

        Principal.hasAuthority('ROLE_MANAGEMENT').then( function (result) {
            if (result) {
                vm.gridColumns.unshift({
                    command:[
                        { name:"execute", text: "Εκτέλεση", click: vm.executePatchReport }
                    ],
                    attributes: { class: "#= 'green-color' #" },
                    title: "&nbsp",
                    width:90
                });

                vm.pendingGrid.setOptions({
                    columns: vm.gridColumns
                });
            }
        });
    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerPatchReports', {
                parent: 'adminCustomerView',
                url: '/patchReports',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_PATCH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/patchReports/patchReports.html',
                controller: 'AdminCustomerViewPatchReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 4/10/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewPatchReportsController', AdminCustomerViewPatchReportsController);

    AdminCustomerViewPatchReportsController.$inject = ['$http','$state', 'ApplicationParameters', 'PatchItemMasterFilter'];

    function AdminCustomerViewPatchReportsController ($http, $state, ApplicationParameters, PatchItemMasterFilter) {
        var vm = this;
        vm.selectedPatchItems = PatchItemMasterFilter.getSelectedPatchItems();
        ApplicationParameters.hasModule('Patches', true);

        vm.patchItemsMultiOptions = PatchItemMasterFilter.getPatchItemsMultiOptions();

        vm.toolbarOptions = {
            items: [
                { template: "<label>Επίθεμα: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.patchItemsMulti' multiple='multiple' " +
                "k-options='vm.patchItemsMultiOptions' k-ng-model='vm.selectedPatchItems'></select>", overflow: "never" }
            ]
        };
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerNotes', {
                parent: 'adminCustomerView',
                url: '/notes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/notes/notes.html',
                controller: 'AdminCustomerViewNotesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewNotesController', AdminCustomerViewNotesController);

    AdminCustomerViewNotesController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'NotificationOptions'];

    function AdminCustomerViewNotesController ($http, $state, $stateParams, $filter, Principal, NotificationOptions) {
        var vm = this;

        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }

        vm.customer = {};
        vm.selectedUserId = $stateParams.id;

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
            })
            .error(function (response) {
                console.log(response);
            });

        var validator = angular.element("#form").kendoValidator({}).data("kendoValidator");
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        vm.update = function() {
            if (validator.validate()) {
                $http.put('api/customers', vm.customer)
                    .success(function (response) {
                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                    })
                    .error(function (response) {
                        notification.show({
                            message: "Η ενημέρωση των στοιχείων απέτυχε!"
                        }, "error");
                        console.log(response);
                    });
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }

        };
    }

})();
;
/**
 * Created by Kristy Kavvada on 27/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MedReportService', MedReportService);

    MedReportService.$inject = ['$rootScope', '$http'];

    function MedReportService($rootScope, $http) {

        return {
            getEmployeesDatasource: getEmployeesDatasource,
            setMedReport: setMedReport
        };

        function getEmployeesDatasource() {
            return new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) o.data.filter = { filters: [] };
                        if (o.data.sort == undefined || !o.data.sort.length) o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                        o.data.page = 1;
                        o.data.pageSize = 20;

                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function () {});
                    }
                },
                schema: {
                    parse: function (data) {
                        data.forEach(function (item) {
                            item.fullName = item.account.lastName + " " + item.account.firstName;
                        });
                        return data;
                    }
                }
            });
        }

        function setMedReport(value) {
            $rootScope.$broadcast('medReport:updated',value);
        }
    }
})();
;
/**
 * Created by Kristy Kavvada on 07/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerMedReportsWithLines', {
                parent: 'customerMedReports',
                url: '/with-lines',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportWithLines/medReportWithLines.html',
                controller: 'AdminCustomerViewMedReportsWithLinesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    medReportMedicine: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.getParameter('Med_Report_Medicine');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 07/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewMedReportsWithLinesController', AdminCustomerViewMedReportsWithLinesController);

    AdminCustomerViewMedReportsWithLinesController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'KendoChangeEvent', 'medReportMedicine', 'MedReportService'];

    function AdminCustomerViewMedReportsWithLinesController ($http, $state, $stateParams, $filter, Principal, KendoFilter, KendoChangeEvent, medReportMedicine, MedReportService) {
        var vm = this;
        vm.medReportMedicine = medReportMedicine.data.content[0];
        vm.selectedUserId = $stateParams.id;
        vm.windowOptions = {
            appendTo: '#custom-med-report-window'
        };
        vm.medReportService = MedReportService;
        vm.medReportsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "isActive", "operator": "eqbool", "value": true }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "eq", "value": "approved" }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "customer.id", "operator": "eq",  "value": vm.selectedUserId}
                            ]
                        );

                        $http.get('/api/me/med-reports',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){
                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            fromDate: { type: 'date'},
                            toDate: { type: 'date'},
                            checkDigit1: { type: 'number'},
                            checkDigit2: { type: 'number'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50
            }),
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "cell",
            columns: [
                {command:[{
                    name:"customEdit",
                    template: "<a role='button' class='k-button smaller-k-edit-btn' ui-sref='medReportPopup' ng-click='vm.openWindow($event, dataItem)'>" +
                        "<span class='k-icon k-i-edit'></span></a>", text: ""
                    }],
                    attributes: {
                        "class": "smaller-k-edit-btn"
                    }, title: "&nbsp;", width:57
                },
                {
                    field: "fromDate",
                    title: "Μήνας",
                    template: "#= fromDate == null ? '' : kendo.toString(kendo.parseDate(fromDate), 'MMMM')#",
                    filterable: false
                },
                {
                    field: "toDate",
                    title: "Έτος",
                    template: "#= toDate == null ? '' : kendo.toString(kendo.parseDate(toDate), 'yyyy')#",
                    filterable: false
                },
                {
                    field: "checkDigit1", title: "Check Digit",
                    filterable: false,
                    width: 140
                },
                {
                    field: "checkDigit2", title: "Check Digit 2",
                    filterable: false,
                    width: 140
                },
                {
                    field: "code", title: "Κωδικός",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                }
            ],
            toolbar: [{ name: "New Med Report",
                text: "New Med Report", template: "<input type='button' class='k-button' value = 'Προσθήκη Report' ui-sref='medReportPopup' ng-click='vm.openWindow($event)' />" },
                { template: "<div class='right'><label>Σύνολο: {{vm.medReportsGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            editable: {
                mode: "popup"
            },
            change: function () { KendoChangeEvent.onChange(this, [5, 6], "employee"); }
        };

        vm.medReportLinesGridOptions = function (dataItem) {
            if (dataItem != undefined) {
                return {
                    dataSource: {
                        batch: true,
                        transport: {
                            read: function(o) {
                                vm.showProgress = true;
                                if (o.data.filter == undefined) {
                                    o.data.filter = { filters: [] };
                                }

                                o.data.filter.filters.push({field: "medReport.id", operator: "eq", value: dataItem.id});
                                $http.get('/api/med-report-lines/search',
                                    {params: o.data})
                                    .success(function (response) {
                                        o.success(response);
                                        vm.showProgress = false;
                                    })
                                    .error(function (response) {
                                        vm.showProgress = false;
                                    });
                            }
                        },
                        schema: {
                            data: function (data) {
                                if(data != undefined) {
                                    data.content.forEach(function(item){
                                    });
                                }
                                return data.content;
                            },
                            total: function (data) {
                                return data.totalEntries;
                            },
                            model: {
                                id: "id",
                                fields: {
                                    id: { editable: false, nullable: true },
                                    sum: { type: "number" },
                                    marketSharePercentage: { type: "number" },
                                    numberOfChanges: { type: "number" }
                                }
                            }
                        },
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 15
                    },
                    pageable: true,
                    sortable: true,
                    filterable: {
                        mode: "row"
                    },
                    columns: [
                        {field: "medicine.name", title: "Όνομα Σκευάσματος",
                            hidden: vm.medReportMedicine.value !== 'name',
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "medicine.pairCode", title: "Σκεύασμα",
                            hidden: vm.medReportMedicine.value !== 'pairCode',
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "medicine.barcode", title: "Barcode Σκευάσματος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {
                            field: "sum", title: "Σύνολο",
                            filterable: {
                                operators: {
                                    number: {
                                        eq: 'Ίσο',
                                        gte: 'Μεγαλύτερο ή Ίσο',
                                        lte: 'Μικρότερο ή Ίσο'
                                    }
                                },
                                cell: {
                                    template: function (args) {
                                        args.element.kendoNumericTextBox({
                                            format: "n0",
                                            decimals: 0,
                                            min: 0
                                        });

                                    }
                                }
                            }
                        }
                    ],
                    editable: false
                };
            }
        };

        vm.openWindow = function(e, dataItem){
            console.log(dataItem);
            MedReportService.setMedReport(dataItem);
            var wdw = angular.element("#popup-new-medReport").data("kendoWindow");
            wdw.center().open();
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 26/2/2020.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportPopup', {
                parent: 'customerMedReportsWithLines',
                url: '/add-med-report',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportWithLines/medReportPopup/medReportPopup.html',
                controller: 'MedReportPopupController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy Kavvada on 26/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportPopupController', MedReportPopupController);

    MedReportPopupController.$inject = ['$scope', '$timeout','$http', 'MedReportService', 'KendoService'];

    function MedReportPopupController ($scope, $timeout, $http, MedReportService, KendoService) {
        var vm = this;
        vm.medReport = {};

        $scope.$on('medReport:updated', function(event,data) {
            vm.medReport = data ? data : {};
            vm.medReport.fromToDate = vm.medReport.toDate;
            vm.medReport.customer ?
                vm.medReport.customer.fullName = vm.medReport.customer.lastName + " " + vm.medReport.customer.firstName :  {};
            console.log(vm.medReport);
        });

        vm.employeesComboBoxOptions = KendoService.initDefaultOptions(MedReportService.getEmployeesDatasource(),
            "startswith", "fullName", "id", false);

        vm.dateSelectorOptions = {
            start: "year",
            depth: "year"
        };
    }
})();
;
/**
 * Created by Kristy Kavvada on 07/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerMedReportsSumsPerMonth', {
                parent: 'customerMedReports',
                url: '/per-month',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportSumsPerMonth/medReportSumsPerMonth.html',
                controller: 'AdminCustomerViewMedReportsSumsPerMonthController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy Kavvada on 07/2/2020.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewMedReportsSumsPerMonthController', AdminCustomerViewMedReportsSumsPerMonthController);

    AdminCustomerViewMedReportsSumsPerMonthController.$inject = ['$scope', '$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter', 'CustomUtils', 'KendoService', 'Alerts', '$timeout'];

    function AdminCustomerViewMedReportsSumsPerMonthController ($scope, $http, $state, $stateParams, $filter, Principal, KendoFilter, CustomUtils, KendoService, Alerts, $timeout) {
        var vm = this;
        var aggregates = [];
        vm.selectedUserId = $stateParams.id;
        var months = CustomUtils.getMonths(false);
        var years = CustomUtils.getYears(2017, true);
        vm.masterFilters = { selectedMonths: [], selectedMedicines: [], isActive: true };
        angular.forEach(moment.months(), function (value, key) {
            if (key <= new Date().getMonth()) {
                vm.masterFilters.selectedMonths.push(key + 1);
            }
        });

        var medicinesDatasource = KendoService.initDataSource('/api/medicines/search', 1, 50);
        vm.medicinesMultiOptions = KendoService.initDefaultOptions(medicinesDatasource, "startswith", "name", "id", true);
        vm.monthsMultiOptions = KendoService.initDefaultOptions(months, "startswith", "value", "id");
        vm.yearsMultiOptions = KendoService.initDefaultOptions(years, "startswith", "value", "value");
        vm.masterFilters.selectedYear = years[0].value; //2020
        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Σκευάσματα: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                        "k-options='vm.medicinesMultiOptions' k-ng-model='vm.masterFilters.selectedMedicines'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Μήνες: </label><select id='multiSelect' name='multiSelect' class='inline widgets-l' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.monthsMultiOptions' k-ng-model='vm.masterFilters.selectedMonths'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                {
                    template: "<label>Έτος: </label><select id='comboBox' name='comboBox' class='inline widgets-s' kendo-combo-box k-options='vm.yearsMultiOptions' " +
                        "k-ng-model='vm.masterFilters.selectedYear'></select>",
                    overflow: "never", attributes: {class: "left"}
                },
                // {
                //     template: "<label>Ενεργό: </label><md-checkbox aria-label='isActive' ng-model='vm.masterFilters.isActive' class='checkbox-toolbar green inline'></md-checkbox>",
                //     overflow: "never", attributes: {class: "left"}
                // },
                {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary md-primary-light' aria-label='search' ng-click='vm.getData()' ng-disabled='!vm.masterFilters.selectedYear'>" +
                        "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>",
                    overflow: "never",
                    attributes: {class: "right"}
                }
            ]
        };

        vm.getData = function () {
            $("#medReportSumsGrid").data().kendoGrid.destroy();
            $("#medReportSumsGrid").empty();
            vm.showProgress = true;
            $http.get("/api/med-reports/sums-per-month?years=" + vm.masterFilters.selectedYear + "&months=" + vm.masterFilters.selectedMonths
                + "&medicines=" + vm.masterFilters.selectedMedicines
                + "&customer=" + vm.selectedUserId)
                .success(function (response) {
                    vm.showProgress = false;
                    generateGrid(response);
                })
                .error(function (error) {
                    vm.showProgress = false;
                    Alerts.showAlert("Sigma SalesForce", "Λυπούμαστε. Κάποιο σφάλμα προσέκυψε!", "ΟΚ");
                });
        };

        function generateGrid(response){
            aggregates = [];
            $("#medReportSumsGrid").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(response);
                        }
                    },
                    schema: {
                        parse: function (data) {
                            var columnFields = vm.masterFilters.selectedMonths;
                            if (columnFields.length === 0) columnFields = [1,2,3,4,5,6,7,8,9,10,11,12];

                            if (data !== null && data !== undefined && data.length > 0){
                                for ( var i=0; i < data.length; i++) {
                                    data[i].total = 0;
                                    for ( var j=0; j < data[i].results.length; j++) {
                                        data[i]["month" + data[i].results[j].month] = data[i].results[j].sum;
                                        data[i].total += data[i].results[j].sum;
                                    }
                                    for ( var k=0; k < columnFields.length; k++) {
                                        if (!data[i]["month" + columnFields[k]]) data[i]["month" + columnFields[k]] = 0;
                                    }
                                }
                            }
                            return data;
                        }
                    },
                    sort: { field: "total", dir: "desc" },
                    aggregate: aggregates
                },
                columns: generateColumns(),
                toolbar: [
                    { name: "excel", template: "<div class='right'><md-button class='md-raised md-mini md-primary k-button-icontext k-grid-excel' aria-label='excel'>" +
                            "<span class='k-icon k-i-excel'></span>Export</md-button></div>" }
                ],
                excel: {
                    allPages: true,
                    fileName: "Σύνολα Σκευασμάτων.xlsx"
                },
                height: vm.contentHeight,
                pageable: false,
                editable: false,
                resizable: true,
                scrollable: true,
                sortable: true,
                dataBound: function () {
                    $timeout(function() {
                        kendo.resize($("#medReportSumsGrid"));
                    });
                }
            });
        }

        function generateColumns(){
            var columns = [];
            var columnFields = vm.masterFilters.selectedMonths;
            if (columnFields.length === 0) {
                columnFields = [1,2,3,4,5,6,7,8,9,10,11,12]
            }
            columns.push({
                field: "medicine.name",
                title: "Σκέυασμα",
                footerTemplate: "Σύνολο: ",
                width: "370px"
            });
            angular.forEach(columnFields, function (columnField) {
                var date = new Date();
                date.setMonth(columnField-1);
                aggregates.push({ field: "month" + columnField, aggregate: "sum" });
                columns.push({
                    field: "month" + columnField,
                    title: kendo.toString(kendo.parseDate(date), 'MMMM'),
                    footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#"
                });
            });
            aggregates.push({ field: "total", aggregate: "sum" });
            columns.push({
                field: "total",
                title: "Σύνολο",
                footerTemplate: "#=sum ? kendo.format('{0:n0}', sum) : 0#",
                width: "100px"
            });

            return columns;
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 07/02/2020.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerMedReports', {
                abstract: true,
                parent: 'adminCustomerView',
                url: '/medReports',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReports.html',
                controller: 'AdminCustomerViewMedReportsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Kristy Kavvada on 07/02/2020.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewMedReportsController', AdminCustomerViewMedReportsController);

    AdminCustomerViewMedReportsController.$inject = ['$state'];

    function AdminCustomerViewMedReportsController ($state) {
        var vm = this;
        vm.$state = $state;
    }
})();
;
/**
 * Created by Kristy on 2/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerInfo', {
                parent: 'adminCustomerView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/info/info.html',
                controller: 'AdminCustomerViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewInfoController', AdminCustomerViewInfoController);

    AdminCustomerViewInfoController.$inject = ['$http','$state', '$stateParams', '$filter', 'customersView', 'Principal', 'KendoService', 'NotificationOptions'];

    function AdminCustomerViewInfoController ($http, $state, $stateParams, $filter, customersView, Principal, KendoService, NotificationOptions) {
        var vm = this;

        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }

        vm.customerView = customersView.data.content[0].value;

        vm.customer = { customerTypes: []};
        vm.selectedUserId = $stateParams.id;

        var validator = angular.element("#form").kendoValidator({
            rules: {
                custom: function (input) {

                    if (input.data('custom')) {
                        if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
            messages: {
                custom: "Πρέπει να επιλέξετε από την λίστα",
                maxlength: "Το κινητό τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
            }
        }).data("kendoValidator");

        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");

        var dayTimeDataSource = new kendo.data.DataSource({
            data: [
                { id: 1, name: "ΠΡΩΙΝΌ"},
                { id: 2,  name: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}
            ]
        });

        vm.dayTimeDropDownOptions = {
            dataSource: dayTimeDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Ωράριο"

        };

        var collaborationDatasource = KendoService.initDefaultDataSource('/api/collaborations/search');
        vm.collaborationOptions = KendoService.initDefaultOptions(collaborationDatasource, 'startswith', 'name', 'id');

        var softwareDatasource = [{text: $filter('translate')('global.field.software.medexpress'), value: 'medexpress'},
            {text: $filter('translate')('global.field.software.medmobile'), value: 'medmobile'}, {text: $filter('translate')('global.field.software.other'), value: 'other'}];
        vm.softwareOptions = KendoService.initDefaultOptions(softwareDatasource, 'startswith', 'text', 'value');

        var customerTitlesDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 20;
                    $http.get('/api/masterdata/customer-titles',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        //DropDown Options
        vm.customerTitleComboBoxOptions = {
            dataSource: customerTitlesDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.customerTypeDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            var customerTypes = response.content;
                            var filteredCustomerTypes = [];

                            // Add only specific customerTypes
                            customerTypes.forEach(function (currentValue) {
                                if (currentValue.id === 1) {
                                    filteredCustomerTypes.push(currentValue);
                                }
                            });

                            // check application parameter Approvals
                            $http.get('/api/masterdata/application-parameters',
                                {params:{
                                    page: 1,
                                    pageSize: 1,
                                    filter : { filters: [{field: "name", operator: "eq",  value: "Patches"}] }}})
                                .success(function (response,status,headers) {
                                    if (response.content.length > 0 && response.content[0].value == '1') {
                                        customerTypes.forEach(function (currentValue) {
                                            if (currentValue.id === 2) {
                                                filteredCustomerTypes.push(currentValue);
                                            }
                                        });
                                    }
                                    o.success(filteredCustomerTypes);
                                })
                                .error(function (response) {
                                    console.log(response);
                                });
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        //DropDown Options
        vm.customerTypesMultiOptions = {
            dataSource: vm.customerTypeDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;

                if (vm.customer.saw == 1) {
                    vm.isViewing = true;
                }

                if (vm.customer.isActive == 1) {
                    vm.isCustomerActive = true;
                }

                if (vm.customer.gdpr == 1) {
                    vm.isCustomerGDPR = true;
                }

                if(vm.customer.dayTime !== null){
                    if(vm.customer.dayTime === "day") {
                        vm.customer.dayTime = "ΠΡΩΙΝΌ";
                    }else if(vm.customer.dayTime === "night"){
                        vm.customer.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                    }
                }
            })
            .error(function (response) {
                console.log(response);
            });

        var specialtyDataSource = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function(o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = { filters: [] };
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10000;
                    $http.get('/api/masterdata/doctor-specialties',
                        {params: o.data})
                        .success(function (response,status,headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        //DropDown Options
        vm.specialtyComboBoxOptions = {
            dataSource: specialtyDataSource,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.subCategoryComboBoxOptions = {
            autoBind: false,
            dataSource: new kendo.Backbone.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get('/api/masterdata/customer-sub-categories',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            }),
            valuePrimitive: true,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή Υποκατηγορίας..."
        };

        vm.categoryComboBoxOptions = {
            autoBind: false,
            dataSource: new kendo.Backbone.DataSource({
                serverFiltering: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get('/api/masterdata/customer-categories',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    }
                }
            }),
            valuePrimitive: true,
            filter: "startswith",
            dataTextField: "name",
            dataValueField: "id",
            placeholder: "Επιλογή κατηγορίας..."
        };

        vm.update = function() {

            if (vm.isViewing == true) {
                vm.customer.saw = 1;
            } else {
                vm.customer.saw = 0;
            }

            if (vm.isCustomerActive == true) {
                vm.customer.isActive = 1;
            } else {
                vm.customer.isActive = 0;
            }

            if (vm.isCustomerGDPR == true) {
                vm.customer.gdpr = 1;
            } else {
                vm.customer.gdpr = 0;
            }

            if(vm.customer.dayTime !== null){
                if(vm.customer.dayTime === 1 || vm.customer.dayTime === "ΠΡΩΙΝΌ" ) {
                    vm.customer.dayTime = "day";
                }else if(vm.customer.dayTime === 2 || vm.customer.dayTime === "ΑΠΟΓΕΥΜΑΤΙΝΌ"){
                    vm.customer.dayTime = "night";
                }
            }

            if(vm.customer.customerSubCategory !== null){
                if(vm.customer.customerSubCategory.id === null) {
                    vm.customer.customerSubCategory = null;
                }
            }

            if(vm.customer.doctorSpecialty !== null){
                if(vm.customer.doctorSpecialty.id === null) {
                    vm.customer.doctorSpecialty = null;
                }
            }

            if(vm.customer.customerCategory !== null) {
                if (vm.customer.customerCategory.id === null) {
                    vm.customer.customerCategory = null;
                }
            }

            if (validator.validate()) {
                $http.put('api/customers', vm.customer)
                    .success(function (response) {

                        if(response.dayTime !== null){
                            if(response.dayTime === "day") {
                                vm.customer.dayTime = "ΠΡΩΙΝΌ";
                            }else if(vm.customer.dayTime === "night"){
                                vm.customer.dayTime = "ΑΠΟΓΕΥΜΑΤΙΝΌ";
                            }
                        }

                        notification.show({
                            message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
                        }, "success");
                    })
                    .error(function (response) {
                        console.log(response);
                    });
            }else{
                notification.show({
                    message: "Η ενημέρωση των στοιχείων απέτυχε!"
                }, "error");
            }

        };
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerEvents', {
                parent: 'adminCustomerView',
                url: '/events',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/events/events.html',
                controller: 'AdminCustomerViewEventsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewEventsController', AdminCustomerViewEventsController);

    AdminCustomerViewEventsController.$inject = ['$http','$state', '$stateParams', '$filter', 'Principal', 'KendoFilter'];

    function AdminCustomerViewEventsController ($http, $state, $stateParams, $filter, Principal, KendoFilter) {
        var vm = this;
        vm.selectedUserId = $stateParams.id;

        vm.googleMapsRedirect = function(dataItem) {
            if (dataItem.latitude != 0 && dataItem.longitude != 0) {
                window.open(
                    'http://maps.google.com/maps?q=' + dataItem.latitude + ',' + dataItem.longitude,
                    '_blank' //This is what makes it open in a new window.
                );
            }
        };

        vm.imageChoice = function(dataItem) {
            return !(dataItem.latitude == 0 && dataItem.longitude == 0);
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            if ( e.target != undefined) {
                if (e.target[0].offsetParent.id == 'masterFiltersEvents') {
                    vm.eventsFrom = vm.from;
                    vm.eventsTo = vm.to;
                    vm.eventsGridOptions.dataSource.read();
                    //angular.element("#eventsGrid").data("kendoGrid").dataSource.read();
                }
            } else {
                if ( vm.selectedTabStrip == 2) {
                    vm.eventsFrom = vm.from;
                    vm.eventsTo = vm.to;
                    vm.eventsGridOptions.dataSource.read();
                    angular.element("#eventsGrid").data("kendoGrid").dataSource.read();
                }
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value) {
                    if (vm.selectedTabStrip == 2) {
                        vm.eventsFrom = value;
                    }
                }
                vm.from = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value) {
                    if ( vm.selectedTabStrip == 2) {
                        vm.eventsTo = value;
                    }
                }
                vm.to = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.eventsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "eventCustomerSector.customerSector.customer.id", "operator": "eq",  "value": vm.selectedUserId}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        //master filters functionality
                        if(vm.eventsFrom && vm.eventsTo) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "startedAt", "operator": "from",  "value": $filter('date')(vm.eventsFrom, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "startedAt", "operator": "to",  "value": $filter('date')(vm.eventsTo, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ]
                            );
                        }

                        $http.get('/api/me/events',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        return data;
                    }
                },
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventStatus === null) {
                                    item.eventStatus = {};
                                    item.eventStatus.name = "";
                                }

                                if(item.employee === null){
                                    item.employee = {
                                        account : {
                                            lastName : ""
                                        }
                                    }
                                }

                                if (item.eventCustomerSector === null) {
                                    if (item.agreementValuation === null) {
                                        item.agreementValuation = {
                                            name: ""
                                        };
                                    }

                                    if (item.customerSector === null) {
                                        item.customerSector = {
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    if (item.eventCustomerSector.agreementValuation === null) {
                                        item.eventCustomerSector.agreementValuation = {
                                            name: ""
                                        };
                                    }

                                    if (item.eventCustomerSector.customerSector == null) {
                                        item.eventCustomerSector.customerSector = {
                                            sector: {
                                                sectorType: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    } else {
                                        if (item.eventCustomerSector.customerSector.sector == null) {
                                            item.eventCustomerSector.customerSector.sector = {
                                                name: "",
                                                sectorType: {
                                                    name: ""
                                                }
                                            };
                                        } else {
                                            if (item.eventCustomerSector.customerSector.sector.sectorType == null) {
                                                item.eventCustomerSector.customerSector.sector.sectorType = {
                                                    name: ""
                                                };
                                            }
                                        }
                                    }
                                }

                            });
                        }
                        return data.content;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}} },
                            startedAt: { type: 'date'}
                        }
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50
            }),
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            selectable: "cell",
            columns: [
                {field: "startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= kendo.toString(kendo.parseDate(startedAt), 'dddd, dd/MM/yyyy HH:mm')#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }, width: 220 },
                {field: "eventStatus.name", title: "Κατάσταση Επίσκεψης",attributes: {
                    class: "#=eventStatus.id == '1' ? 'red' : 'green' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 190},
                {field: "eventCustomerSector.agreementValuation.name", title: "Αξιολόγηση", template: "#= (eventCustomerSector.agreementValuation == null || eventCustomerSector.agreementValuation.name == null ) ? ' ' : eventCustomerSector.agreementValuation.name #",
                    attributes: {   class: "#=eventCustomerSector.agreementValuation.id == '1' ? 'red' : eventCustomerSector.agreementValuation.id == '2' ? 'orange' : eventCustomerSector.agreementValuation.id == '3' ? 'purple' : eventCustomerSector.agreementValuation.id == '4' ? 'green' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 150},
                {
                    command:[
                        {name:"map2", template: "<md-button class='md-fab md-mini md-primary' aria-label='Google Maps' " +
                        "ng-class='{googlemap: vm.imageChoice(dataItem.eventCustomerSector), errormap: !vm.imageChoice(dataItem.eventCustomerSector)}' ng-click='vm.googleMapsRedirect(dataItem.eventCustomerSector)'>" +
                        "</md-button>"
                        }
                    ],
                    attributes: { class: "#= 'link-cell-color' #" },
                    title: "Τοποθεσία",
                    width: 85
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }, width: 150
                        },
                        { field: "eventCustomerSector.customerSector.sector.name", title: "Όνομα",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }, width: 170
                        }
                    ]
                },
                // {field: "eventCustomerSector.agreedPercent", title: "Ποσοστό Συχνότητας", template: "#= (eventCustomerSector.agreedPercent == null) ? ' ' : kendo.format('{0:p0}', eventCustomerSector.agreedPercent / 100)#",
                //     filterable: {
                //         cell: {
                //             operator: "startswith",
                //             template: function (args) {
                //                 KendoFilter.getTemplate(args);
                //             },
                //             showOperators: false
                //         }
                //     }},
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    attributes: {
                        class: "link-cell link-cell-color"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }, width: 200
                }
                // {field: "description", title: "Σημειώσεις",
                //     filterable: {
                //         cell: {
                //             operator: "like",
                //             template: function (args) {
                //                 KendoFilter.getTemplate(args);
                //             },
                //             showOperators: false
                //         }
                //     }}
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.eventsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }],
            change: onChange
        };

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 8) {
                $state.go('userInfo', {id: this.dataItem(row).employee.id});
            }
        }
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerAgreements', {
                parent: 'adminCustomerView',
                url: '/agreements',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/agreements/agreements.html',
                controller: 'AdminCustomerViewAgreementsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Kristy on 2/9/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewAgreementsController', AdminCustomerViewAgreementsController);

    AdminCustomerViewAgreementsController.$inject = ['$http','$state', '$stateParams', '$filter', 'KendoFilter', '$scope'];

    function AdminCustomerViewAgreementsController ($http, $state, $stateParams, $filter, KendoFilter, $scope) {
        var vm = this;

        vm.selectedUserId = $stateParams.id;

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {

                vm.clearDatePickers();

                vm.from = date;
                vm.to = date;

            }
            else if (e.id == "week") {

                vm.clearDatePickers();

                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;

            }
            else if (e.id == "month") {

                vm.clearDatePickers();

                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }

            if ( e.target != undefined) {
                vm.agreementsFrom = vm.from;
                vm.agreementsTo = vm.to;
                vm.agreementsGridOptions.dataSource.read();
            } else {
                vm.agreementsFrom = vm.from;
                vm.agreementsTo = vm.to;
                vm.agreementsGridOptions.dataSource.read();
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                        { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                        { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                    ]
                },
                { type: "separator" },
                { type: "separator" },
                { template: "<label>Από: </label>" },
                {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>" },
                {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                }
            ]
        };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value) {
                    vm.agreementsFrom = value;
                }
                vm.from = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                vm.selectedTabStrip = angular.element("#tabstrip2").kendoTabStrip().data("kendoTabStrip").select().index();
                var value = this.value();
                if (value) {
                    vm.agreementsTo = value;
                }
                vm.to = value;

                vm.masterFiltersOnClick(e);
            }
        };

        vm.agreementsGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "event.eventCustomerSector.customerSector.customer.id", "operator": "eq",  "value":  vm.selectedUserId}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        //master filters functionality
                        if(vm.agreementsFrom && vm.agreementsTo) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "event.startedAt", "operator": "from",  "value": $filter('date')(vm.agreementsFrom, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                                    { "field": "event.startedAt", "operator": "to",  "value": $filter('date')(vm.agreementsTo, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
                                ]
                            );
                        }

                        o.data.page = 1;
                        $http.get('/api/me/agreements',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        return data;
                    }
                },
                serverSorting: true,
                serverFiltering: true,
                serverPaging: true,
                pageSize: 50,
                group: {field:  'event_date'},
                schema: {
                    data: function (data) {
                        if(data != undefined) {
                            data.content.forEach(function(item){

                                if (item.event === null) {
                                    item.event = {
                                        startedAt: '',
                                        employee : {
                                            account : {
                                                lastName : ""
                                            }
                                        }
                                    };
                                }

                                if (item.product === null) {
                                    item.product = { name: ''};
                                }

                                if (item.agreementValuation === null) {
                                    item.agreementValuation = { name: ''};
                                }

                                if (item.eventPlace === null) {
                                    item.eventPlace = {};
                                    item.eventPlace.name = "";
                                }
                            });
                        }
                        return data.content;
                    },
                    parse: function(data) {
                        angular.forEach(data.content, function(item) {
                            if (item.event != undefined) {
                                item.event_date = kendo.toString(kendo.parseDate(item.event.startedAt), 'dd/MM/yyyy');
                            }

                        });
                        return data;
                    },
                    total : function(data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: false },
                            promisedQuantity: { type:'number' },
                            priority: { type:'number' },
                            //agreed_price: { type:'number' },
                            event_date: { type: 'date'},
                            'event.startedAt': { type: 'date' }
                        }
                    }
                }
            }),
            pageable: true,
            sortable: true,
            filterable: {
                mode: "row"
            },
            resizable: true,
            columns: [
                {field: "event_date", hidden: true,
                    groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= value ? kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy') : ''#"
                },
                {field: "event.startedAt", title: "Ημερομηνία Επίσκεψης", template: "#= event.startedAt ? kendo.toString(kendo.parseDate(event.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }},
                {field: "product.name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "promisedQuantity", title: "Προβλεπόμενη Συχνότητα",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "priority", title: "Σειρά προτεραιότητας",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "agreementValuation.name", title: "Αξιολόγηση",attributes: {
                    class: "#=agreementValuation.id == '1' ? 'red' : agreementValuation.id == '2' ? 'orange' : agreementValuation.id == '3' ? 'purple' : agreementValuation.id == '4' ? 'green' : 'black' #"
                },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }},
                {field: "event.employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }}
            ],
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.agreementsGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };
    }

})();
;
/**
 * Created by Maria on 16/5/2016.
 */


(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomerViewController', AdminCustomerViewController);

    AdminCustomerViewController.$inject = ['DataUtils', '$http','$state', '$stateParams', '$filter', 'Principal', '$scope', 'NotificationOptions', 'ApplicationParameters', 'healthVisitorEditSector', 'CustomDataUtils'];

    function AdminCustomerViewController (DataUtils, $http, $state, $stateParams, $filter, Principal, $scope, NotificationOptions, ApplicationParameters, healthVisitorEditSector, CustomDataUtils) {
        var vm = this;
        var notification = angular.element("#notification").kendoNotification(NotificationOptions).data("kendoNotification");
        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.canEdit = true;
        }else {
            vm.readOnly = true;
        }

        vm.showCustomerSectorsTab = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR']) ||
            (CustomDataUtils.isNotEmpty(healthVisitorEditSector.data.content) && healthVisitorEditSector.data.content[0].value === '1');

        vm.pageHeading = 'Επαγγελματίας Υγείας';
        vm.customer = {};
        vm.profilePicture = "customer_icon.png";
        vm.selectedUserId = $stateParams.id;
        vm.stateFrom = $stateParams.stateFrom;
        vm.$state = $state;
        vm.canPatchReport = false;
        vm.hasMedReport = false;
        ApplicationParameters.hasModule('Med_Report', false).then(function(response) {
            vm.hasMedReport  = response.data.content[0].value === "1";
        });

        $http.get('api/customers/' + vm.selectedUserId)
            .success(function (response) {
                vm.customer = response;
                var foundItemById = $filter('filter')(vm.customer.customerTypes, {id: 2}, true)[0];
                vm.canPatchReport = vm.customer.customerTypes.indexOf(foundItemById) !== -1;
            })
            .error(function (response) {
                console.log(response);
            });

        kendo.Backbone = kendo.Backbone || {};

        kendo.Backbone.DataSource = kendo.data.DataSource.extend({
            init: function(options) {
                if (options.transport && options.transport.read) {
                    options.transport.read.type = 'GET';
                    options.transport.read.dataType = 'json';
                    options.transport.read.contentType = 'application/json;charset=UTF-8';
                    options.transport.read.parameterMap = function (data, operation) {
                        return JSON.stringify(data);
                    }
                }
                kendo.data.DataSource.fn.init.call(this, options);
            }
        });

        vm.setProfilePhoto = function ($file, customer) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        customer.profilePhoto = base64Data;
                        customer.profilePhotoContentType = $file.type;
                    });

                    $http.put('api/customers', customer)
                        .success(function (response) {
                            notification.show({
                                message: "Η ενημέρωση της φωτογραφίας ήταν επιτυχής!"
                            }, "success");
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                });
            }
        };

        vm.goBack = function () {
            $state.go(vm.stateFrom !== null && vm.stateFrom !== undefined ? vm.stateFrom : 'adminCustomers');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminCustomers', {
                parent: 'app',
                url: '/customers',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminCustomers/adminCustomers.html',
                        controller: 'AdminCustomersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    eventCycle: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.eventCycle();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    .state('adminCustomerView', {
            abstract: true,
            parent: 'app',
            url: '/customers/search?id:customerId:stateFrom',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR'],
                pageTitle: 'sigmaCrmApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/adminCustomers/adminCustomerView.html',
                    controller: 'AdminCustomerViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                healthVisitorEditSector: ['ApplicationParameters', function (ApplicationParameters) {
                    return ApplicationParameters.getParameter('Health_Visitor_Edit_Sector');
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminCustomersController', AdminCustomersController);

    AdminCustomersController.$inject = ['$http', '$filter', '$state', 'Principal', '$timeout', 'KendoGrid', 'customersView', 'eventCycle', 'MasterFiltersService', '$mdDialog', 'KendoService', 'KendoFilter', 'CustomUtils'];

    function AdminCustomersController ($http, $filter, $state, Principal, $timeout, KendoGrid, customersView, eventCycle, MasterFiltersService, $mdDialog, KendoService, KendoFilter, CustomUtils) {
        var vm = this;
        vm.customerUrl = "/api/customers";
        vm.pageHeading = 'Επαγγελματιες Υγειας';
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(60);
        vm.principal = Principal;
        vm.selectedEmployees = [];
        vm.selectedSupervisors = [];
        vm.selectedSoftwares = [];
        vm.customerView = customersView.data.content[0].value;
        vm.eventCycle = eventCycle.data !== null && eventCycle.data.content !== null && eventCycle.data.content.length > 0 ? eventCycle.data.content[0] : null;
        vm.messageWnd = {};
        vm.myTarget = true;
        vm.isActive = true;
        vm.employeeCustomerSectorActive = true;

        var softwareEnumValues = ['none', 'medexpress', 'medmobile', 'other'];

        var enumerationFilterTemplate = function (args) {
            KendoFilter.getEnumerationTemplate(args, 'software', softwareEnumValues);
        };
        var dataSource = {};
        dataSource.doctorSpecialty = KendoService.initDefaultDataSource('/api/masterdata/doctor-specialties');
        dataSource.category = KendoService.initDefaultDataSource('/api/masterdata/customer-categories');
        dataSource.subCategory = KendoService.initDefaultDataSource('/api/masterdata/customer-sub-categories');
        dataSource.title = KendoService.initDefaultDataSource('/api/masterdata/customer-titles');
        dataSource.customerType = new kendo.data.DataSource({
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) o.data.filter = {filters: []};

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            var customerTypes = response.content;
                            var filteredCustomerTypes = [];

                            // Add only specific customerTypes
                            customerTypes.forEach(function (currentValue) {
                                if (currentValue.id === 1) {
                                    filteredCustomerTypes.push(currentValue);
                                }
                            });

                            // check application parameter Approvals
                            $http.get('/api/masterdata/application-parameters',
                                {params:{
                                    page: 1,
                                    pageSize: 1,
                                    filter : { filters: [{field: "name", operator: "eq",  value: "Patches"}] }}})
                                .success(function (response,status,headers) {
                                    if (response.content.length > 0 && response.content[0].value == '1') {
                                        customerTypes.forEach(function (currentValue) {
                                            if (currentValue.id === 2) {
                                                filteredCustomerTypes.push(currentValue);
                                            }
                                        });
                                    }
                                    o.success(filteredCustomerTypes);
                                })
                                .error(function (response) {});
                        })
                        .error(function (response) {});
                }
            }
        });
        dataSource.dayTimeDataSource = new kendo.data.DataSource({
            data: [
                { value: 'day', text: "ΠΡΩΙΝΌ"},
                { value: 'night',  text: "ΑΠΟΓΕΥΜΑΤΙΝΌ"}
            ]
        });

        dataSource.software = [{text: 'Επιλογή όλων', value: 'all'}, {text: 'Όχι', value: 'none'},
            {text: $filter('translate')('global.field.software.medexpress'), value: 'medexpress'},
            {text: $filter('translate')('global.field.software.medmobile'), value: 'medmobile'},
            {text: $filter('translate')('global.field.software.other'), value: 'other'}];

        vm.softwareOptions = {
            dataSource: dataSource.software,
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            placeholder: "Επιλογή λογισμικού",
            select: function (e) {
                var dataItem = this.dataSource.view()[e.item.index()];
                var values = this.value();

                if (dataItem.value === "all" || dataItem.value === "none") {
                    this.value("");
                } else if (values.indexOf("all") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "all";
                    });
                    this.value(values);
                } else if (values.indexOf("none") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "none";
                    });
                    this.value(values);
                } else if (values.indexOf("other") !== -1) {
                    values = angular.element.grep(values, function(value) {
                        return value !== "other";
                    });
                    this.value(values);
                }
            },
            change: function () {
                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
            }
        };

        vm.toolTipOptions = {
            filter: "td span",
            position: "top",
            content: function(e){
                var element = e.target[0];
                e.sender.popup.element.css("visibility", "hidden");

                if (element.offsetWidth < element.scrollWidth) {

                    e.sender.popup.element.css("visibility", "visible");

                    return element.innerText;
                }

                return "";
            }
        };

        vm.clearDatePickers = function () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        };

        vm.masterFiltersOnClick = function (e) {
            var date = new Date();
            angular.element(e.target).addClass('k-state-active');

            if (e.id == "today") {
                vm.clearDatePickers();
                vm.from = date;
                vm.to = date;
            }
            else if (e.id == "week") {
                vm.clearDatePickers();
                var first = date.getDate() - date.getDay() + 1;
                var firstWeekDay = new Date(new Date().setDate(first)); // First day is the day of the month - the day of the week + 1
                var lastWeekDay = new Date(new Date().setDate(first + 6)); // last day is the first day + 6

                vm.from = firstWeekDay;
                vm.to = lastWeekDay;
            }
            else if (e.id == "month") {
                vm.clearDatePickers();
                var firstMonthDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastMonthDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                vm.from = firstMonthDay;
                vm.to = lastMonthDay;
            }
            angular.element("#mainGrid").data("kendoGrid").dataSource.read();
        };

        vm.toolbarOptions = {
            items: [
                // {
                //     type: "buttonGroup", id:"buttonGroup",
                //     buttons: [
                //         { text: "Σήμερα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "today" },
                //         { text: "Εβδομάδα", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "week" },
                //         { text: "Μήνας", toggle: vm.masterFiltersOnClick, togglable: true, group: "text-align", icon: "refresh", id: "month" }
                //     ], overflow: "never"
                // },
                { type: "separator", overflow: "never" },
                { type: "separator", overflow: "never" },
                { template: "<label>Από: </label>", overflow: "never" },
                {
                    template: "<input kendo-date-picker id='from' class='smaller-8em-k-datepicker' options='vm.fromOptions'/>",
                    overflow: "never"
                },
                { template: "<label>Εώς: </label>", overflow: "never" },
                {
                    template: "<input kendo-date-picker id='to' class='smaller-8em-k-datepicker' options='vm.toOptions'/>",
                    overflow: "never"
                },
                {
                    template: "<label>My Target: </label><div class='inline'><md-radio-group layout='row' ng-change='vm.onFilterChange()' ng-model='vm.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                {
                    template: "<label>Ενεργός: </label><md-checkbox aria-label='isActive' ng-model='vm.isActive' ng-change='vm.onFilterChange()' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                {
                    template: "<label>Ενεργή ΜΥ: </label><md-checkbox aria-label='employeeCustomerSectorActive' ng-model='vm.employeeCustomerSectorActive' ng-change='vm.onFilterChange()' class='checkbox-toolbar green inline'></md-checkbox>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                {
                    template: "<div ng-if='vm.customerView === \"3\"'><label>Λογισμικό: </label><select kendo-multi-select multiple='multiple' id='multiSelect' name='multiSelect' class='inline' k-ng-model='vm.selectedSoftwares' " +
                    "                            k-options='vm.softwareOptions' class='col-fix'></select></div>",
                    overflow: "never", attributes: {class: "left-space"}
                },
                // {
                //     template: "<label>Τ.Κ.: </label><input class='k-textbox' id='postalCode' ng-change='vm.onFilterChange()' ng-model='vm.postalCode'>",
                //     overflow: "never"
                // },
                {
                    template: "<div ng-if='vm.customerView !== \"6\"'>" +
                        "<label>Brick ΟΣΦΕ: </label>" +
                        "<input class='k-textbox' id='osfeBrick' ng-change='vm.onFilterChange()' ng-model='vm.osfeBrick'>" +
                        "</div>",
                    overflow: "never"
                },
                {
                    template: "<div ng-if='vm.customerView === \"6\"'>" +
                        "<label>Brick: </label>" +
                        "<input class='k-textbox' id='brick' ng-change='vm.onFilterChange()' ng-model='vm.brick'>" +
                        "</div>",
                    overflow: "never"
                },
                { type: "separator", overflow: "never" },
                { type: "separator", overflow: "never" }
            ]
        };

        vm.onFilterChange = function () { angular.element("#mainGrid").data("kendoGrid").dataSource.read(); };

        vm.fromOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.from = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.toOptions = {
            change: function(e) {
                angular.element('#buttonGroup').find('.k-state-active').removeClass('k-state-active');

                var value = this.value();
                if (value) {
                    vm.to = value;
                }

                vm.masterFiltersOnClick(e);
            }
        };

        vm.gridColumns = [
            {
                field: "lastName",
                attributes: {
                    class: "link-cell link-cell-color"
                },
                title: "Επώνυμο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 140
            },
            {
                field: "firstName",
                attributes: {
                    class: "link-cell link-cell-color"
                },
                title: "Όνομα",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 140
            },
            {
                field: "doctorSpecialty.name",
                title: "Ειδικότητα 1η",
                editor: function(container, options) {
                    angular.element('<select id="doctor-specialty" name="doctorSpecialty" required data-required-msg="Επιλέξτε Ειδικότητα" data-bind="value:doctorSpecialty.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.doctorSpecialty,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        }).kendoValidator().data("kendoValidator");
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                hidden: vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6',
                field: "doctorSpecificSpecialty.name",
                title: "Ειδικότητα 2η",
                editor: function(container) {
                    angular.element('<select id="doctor-specific-specialty" data-bind="value:doctorSpecificSpecialty.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.doctorSpecialty,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 145
            },
            {
                hidden: vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6',
                field: "amka",
                title: "A.M.K.A.",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 80
            },
            {
                field: "customerCategory.name",
                title: "Κατηγορία",
                editor: function(container) {
                    angular.element('<select id="customer-category" data-bind="value:customerCategory.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.category,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 70
            },
            {
                field: "customerSubCategory.name",
                title: "Υποκατηγορία",
                editor: function(container) {
                    angular.element('<select id="customer-subcategory" data-bind="value:customerSubCategory.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.subCategory,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 90
            },
            {
                hidden: vm.customerView === '1' || vm.customerView === '6',
                field: "cellPhone",
                title: "Κινητό",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 79
            },
            {
                hidden: vm.customerView === '1' || vm.customerView === '6',
                field: "phone",
                title: "Σταθερό Τηλέφωνο",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 110
            },
            // {
            //     field: "email",
            //     title: "Email",
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             template: function (args) {
            //                 KendoFilter.getTemplate(args);
            //             },
            //             showOperators: false
            //         }
            //     },
            //     width: 151
            // },
            {
                hidden: vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6',
                field: "dayTime",
                title: "Ωράριο",
                template: "#= (dayTime == 'day') ? 'ΠΡΩΙΝΌ' : (dayTime == 'night') ? 'ΑΠΟΓΕΥΜΑΤΙΝΌ' : '' #",
                editor: function(container) {
                    angular.element('<select id="day-time" data-bind="value:dayTime"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.dayTimeDataSource,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "text",
                            dataValueField: "value"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                autoBind:false,
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: new kendo.data.DataSource({
                                    data: [{ value: "day", text: "ΠΡΩΙΝΌ" },
                                        { value: "night", text: "ΑΠΟΓΕΥΜΑΤΙΝΌ" }]
                                }),
                                valuePrimitive: true

                            })
                        }
                    }
                },
                width: 120
            },
            {
                hidden: vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6',
                field: "customerTitle.name",
                title: "Τίτλος",
                editor: function(container) {
                    angular.element('<select id="customer-title" data-bind="value:customerTitle.id"></select>')
                        .appendTo(container)
                        .kendoComboBox({
                            dataSource: dataSource.title,
                            filter: "startswith",
                            valuePrimitive: true,
                            dataTextField: "name",
                            dataValueField: "id"
                        });
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 120
            },
            // {
            //     field: "isActive",
            //     title: "Ενεργός",
            //     filterable: {
            //         cell: {
            //             operator: "eqbool",
            //             showOperators: false,
            //             template: function (args) {
            //                 args.element.kendoDropDownList({
            //                     autoBind:false,
            //                     dataTextField: "text",
            //                     dataValueField: "value",
            //                     dataSource: new kendo.data.DataSource({
            //                         data: [{ text: "Ναι", value: "true" },
            //                             { text: "Όχι", value: "false" }]
            //                     }),
            //                     valuePrimitive: true
            //
            //                 })
            //             }
            //         }
            //     },
            //     width: 110,
            //     template: "#= (isActive == '1') ? 'Ναι' : 'Όχι' #"
            // },
            {
                hidden: vm.customerView !== '3',
                field: "sector.sectorType.name",
                title: "Τύπος",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 190
            },
            {
                hidden: vm.customerView !== '3' && vm.customerView !== '1' && vm.customerView !== '6',
                field: "sector.name", title: "Μονάδα",
                filterable: {
                    cell: {
                        operator: "like",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 200
            },
            {
                hidden: vm.customerView !== '3' && vm.customerView !== '1',
                field: "sector.osfeBrick",
                title: "Brick ΟΣΦΕ",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 120
            },
            {
                hidden: vm.customerView !== '6',
                field: "sector.brick",
                title: "Brick",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 80
            },
            // {
            //     field: "sector.osfeBrick",
            //     title: "Brick",
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             template: function (args) {
            //                 KendoFilter.getTemplate(args);
            //             },
            //             showOperators: false
            //         }
            //     },
            //     width: 115
            // },
            {
                hidden: vm.customerView !== '3' && vm.customerView !== '1' && vm.customerView !== '6',
                field: "sector.cityName",
                title: "Πόλη",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 190
            },
            {
                hidden: vm.customerView !== '3' && vm.customerView !== '1' && vm.customerView !== '6',
                field: "sector.prefectureName",
                title: "Νομός",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 190
            },
            {
                hidden: true,
                field: "sector.address",
                title: "Διεύθυνση",
                filterable: {
                    cell: {
                        operator: "startswith",
                        template: function (args) {
                            KendoFilter.getTemplate(args);
                        },
                        showOperators: false
                    }
                },
                width: 190
            },
            {
                hidden: vm.customerView !== '3',
                field: "software",
                title: "Λογισμικό",
                template: function (dataItem) {
                    return dataItem.software ? $filter('translate')('global.field.software.' + dataItem.software ) : 'Όχι';
                },
                filterable: {
                    cell: {
                        operator: "startswith",
                        showOperators: false,
                        template: enumerationFilterTemplate
                    }
                },
                width: 100
            },
            {
                hidden: vm.customerView !== '3',
                field: "lastVisitDate", title: "Ημέρες Τελ. Επίσκεψης",
                filterable: {
                    operators: {
                        number: {
                            eqdate: 'Ίσο',
                            gte: 'Μικρότερο ή Ίσο',
                            lte: 'Μεγαλύτερο ή Ίσο'
                        }
                    },
                    cell: {
                        template: function (args) {
                            args.element.kendoNumericTextBox({
                                format: "n0",
                                decimals: 0,
                                min: 0
                            });
                        }
                    }
                },
                template: function (dataItem) {
                    if (vm.eventCycle !== null && vm.eventCycle.value !== null &&
                        dataItem.lastVisitDate !== null && dataItem.lastVisitDate !== undefined){
                        if (Number(dataItem.lastVisitDate) > Number(vm.eventCycle.value)) {
                            return "<strong style='color: red'>" + kendo.htmlEncode(dataItem.lastVisitDate) + "</strong>"
                        }else {
                            return kendo.htmlEncode(dataItem.lastVisitDate)
                        }
                    }else {
                        return dataItem.lastVisitDate !== null && dataItem.lastVisitDate !== undefined ? dataItem.lastVisitDate : '';
                    }
                },
                width: 150
            },
            {
                hidden: vm.customerView !== '3' && vm.customerView !== '1' && vm.customerView !== '6',
                field: "employeeCustomerSectors", title: "Ιατρικοί Επισκέπτες",
                template: function (dataItem) {
                    return KendoFilter.getEmployeeCustomerSectorsTemplate(dataItem);
                },
                filterable: false,
                sortable: false
            },
            {
                hidden: true,
                field: "customerTypes",
                title: "Τύποι Επαγγελματία Υγείας",
                filterable: false,
                editor: function (container) {
                    angular.element('<select id="customerTypes" name="customerTypes" multiple="multiple" required data-required-msg="Επιλέξτε Τύπο Επαγγελματία Υγείας" data-bind="value: customerTypes"/>')
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataSource: dataSource.customerType,
                            valuePrimitive: false,
                            dataTextField: "name",
                            dataValueField: "id"
                        }).kendoValidator().data("kendoValidator");
                },
                width: 120
            },
            {
                hidden: true,
                field: "gdpr",
                title: "GDPR",
                filterable: false,
                width: 120
            }
            // {
            //     hidden: vm.customerView !== '3',
            //     field: "collaboration.name",
            //     title: "Συνεργασία",
            //     editor: function(container) {
            //         var collaborationDatasource = KendoService.initDefaultDataSource('/api/collaborations/search');
            //         angular.element('<select id="collaboration" data-bind="value:collaboration.id"></select>')
            //             .appendTo(container)
            //             .kendoComboBox({
            //                 dataSource: collaborationDatasource,
            //                 filter: "startswith",
            //                 valuePrimitive: true,
            //                 dataTextField: "name",
            //                 dataValueField: "id"
            //             });
            //     },
            //     filterable: {
            //         cell: {
            //             operator: "startswith",
            //             template: function (args) {
            //                 KendoFilter.getTemplate(args);
            //             },
            //             showOperators: false
            //         }
            //     },
            //     width: 100
            // },
            // {field: "createdDate", title: "Ημερομηνία Εισαγωγής", template: "#= kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm')#",
            //     filterable: {
            //         cell: {
            //             operator: "eqdate",
            //             showOperators: false
            //         }
            //     },
            //     width: 140
            // }
        ];

        vm.showConfirm = function() {
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl : 'app/components/md-dialog/dialog-template.html',
                controller  : 'mdDialogCtrl',
                controllerAs: 'vm',
                fullscreen: true,
                locals : {
                    existedCustomers : vm.existedCustomers,
                    confirmSaveCustomer : function(){
                        $mdDialog.hide();
                        vm.saveCustomer(vm.customerToSave);
                    },
                    closeDialog : function(){
                        $mdDialog.hide();
                        KendoGrid.refresh(vm.mainGridOptions);
                    }
                }
            });
        };

        vm.saveCustomer = function(customer) {
            $http.post(vm.customerUrl, customer)
                .success(function (response) {
                    var newCustomerId = response.id;
                    $state.go('customerInfo', {id: newCustomerId});
                })
                .error(function (response) {});
        };

        vm.onAddCustomerClick = function () {
            const grid = $("#mainGrid").data("kendoGrid");
            grid.addRow();
        };

        vm.mainGridOptions = {};

        if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR'])) {
            vm.supervisorsMultiDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                transport: {
                    read: function (o) {
                        var url = '/api/me/employees';
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }
                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                        }
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "account.authorities", "operator": "eq",
                                    "value": "ROLE_SUPERVISOR" },
                                { "field": "account.activated", "operator": "eqbool",
                                    "value": true }
                            ]
                        );
                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get(url,
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function (data) {
                        data.forEach(function (item) {
                            item.employee = {
                                account: {
                                    fullName: item.account.lastName + " " + item.account.firstName
                                }
                            };
                        });
                        return data;
                    }
                }
            });
            vm.supervisorsMultiOptions = {
                dataSource: vm.supervisorsMultiDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "employee.account.fullName",
                dataValueField: "id",
                placeholder: "Επιλογή προισταμένου",
                change: function (e) {
                    vm.employeesMulti.value('');
                    vm.selectedEmployees = [];
                    vm.employeesMulti.dataSource.read();
                    angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                }
            };

            vm.employeesMultiDataSource = new kendo.data.DataSource({
                serverFiltering: true,
                serverSorting: true,
                transport: {
                    read: function (o) {
                        var url = '/api/me/employees';
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }
                        if (o.data.sort == undefined || !o.data.sort.length) {
                            o.data.sort = { "field": "account.lastName",  "dir": "asc" };
                        }
                        if(vm.selectedSupervisors.length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "supervisor.id", "operator": "in",
                                        "value": vm.selectedSupervisors.toString() }
                                ]
                            );
                        }
                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "account.activated", "operator": "eqbool",
                                    "value": true }
                            ]
                        );
                        o.data.page = 1;
                        o.data.pageSize = 20;
                        $http.get(url, {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function (data) {
                        data.forEach(function (item) {
                            item.employee = {
                                account: {
                                    fullName: item.account.lastName + " " + item.account.firstName
                                }
                            };
                        });
                        return data;
                    }
                }
            });
            vm.employeesMultiOptions = {
                dataSource: vm.employeesMultiDataSource,
                filter: "startswith",
                valuePrimitive: true,
                dataTextField: "employee.account.fullName",
                dataValueField: "id",
                placeholder: "Επιλογή Ιατρικού Επισκέπτη",
                change: function (e) {
                    angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                }
            };

            vm.mainGridOptions = {
                dataSource: new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        if (o.data.filter == undefined) o.data.filter = {filters: []};

                        //master filters functionality
                        if (vm.from && vm.to) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "createdDate", "operator": "from",
                                        "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                    },
                                    {
                                        "field": "createdDate", "operator": "to",
                                        "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                    }
                                ]
                            );
                        }

                        if (vm.selectedEmployees.length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.employeeCustomerSectors.employee.id",
                                        "operator": "in",
                                        "value": vm.selectedEmployees.toString()
                                    }
                                ]
                            );
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "customerSectors.employeeCustomerSectors.myTarget",
                                    "operator": "eqbool",
                                    "value": vm.myTarget
                                }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "isActive",
                                    "operator": "eqbool",
                                    "value": vm.isActive
                                }
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                {
                                    "field": "customerSectors.employeeCustomerSectors.active",
                                    "operator": "eqbool",
                                    "value": vm.employeeCustomerSectorActive
                                }
                            ]
                        );

                        // if (vm.postalCode && vm.postalCode != "" && vm.postalCode != null) {
                        //     o.data.filter.filters = o.data.filter.filters.concat(
                        //         [
                        //             {
                        //                 "field": "customerSectors.sector.postalCode", "operator": "startswith",
                        //                 "value": vm.postalCode
                        //             }
                        //         ]
                        //     );
                        // }
                        //
                        if (vm.osfeBrick && vm.osfeBrick != "" && vm.osfeBrick != null) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.sector.osfeBrick", "operator": "startswith",
                                        "value": vm.osfeBrick
                                    }
                                ]
                            );
                        }

                        if (vm.brick && vm.brick != "" && vm.brick != null) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.sector.brick", "operator": "startswith",
                                        "value": vm.brick
                                    }
                                ]
                            );
                        }

                        if (vm.selectedSupervisors.length && !vm.selectedEmployees.length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.employeeCustomerSectors.employee.id",
                                        "operator": "in_with_hierarchy",
                                        "value": vm.selectedSupervisors.toString()
                                    }
                                ]
                            );
                        }

                        if(vm.selectedSoftwares.length) {
                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    { "field": "software", "operator":  vm.selectedSoftwares.indexOf('none') > -1 ? "isnull" : "in",
                                        "value": vm.selectedSoftwares.indexOf('all') > -1 ? "medexpress,medmobile,other" :
                                                vm.selectedSoftwares.indexOf('none') > -1 ? null :
                                                vm.selectedSoftwares.toString() }
                                ]
                            );
                        }

                        angular.forEach(o.data.filter.filters, function (item) {
                            if ( item.field === 'software' && item.value === 'none' ) {
                                item.operator = "isnull";
                                item.value = null;
                            }
                            if ( item.field === 'lastVisitDate' ) {
                                var dt = new Date();
                                dt.setDate( dt.getDate() - item.value );
                                item.value = dt;
                            }
                            if (item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        if (vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6') {
                            vm.url = "/api/me/customers/main";
                        } else {
                            vm.url = "/api/me/customers";
                        }

                        $http.get(vm.url, {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function (o) {
                        var data = o.data.models[0];

                        if (data.customerCategory && !data.customerCategory.id)
                            data.customerCategory = null;

                        if (data.customerSubCategory && !data.customerSubCategory.id)
                            data.customerSubCategory = null;

                        if (data.customerTitle && !data.customerTitle.id)
                            data.customerTitle = null;

                        if (data.doctorSpecialty && !data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        if (data.doctorSpecificSpecialty && !data.doctorSpecificSpecialty.id)
                            data.doctorSpecificSpecialty = null;

                        if (data.collaboration && !data.collaboration.id)
                            data.collaboration = null;

                        $http.post('/api/customers/exists', data)
                            .success(function (response) {
                                vm.existedCustomers = response;
                                vm.customerToSave = data;
                                if (vm.existedCustomers.length) {
                                    vm.showConfirm();
                                } else {
                                    vm.saveCustomer(data);
                                }
                            })
                            .error(function (response) {});
                    },
                    update: function (o) {
                        var data = o.data.models[0];

                        if (data.customerCategory && !data.customerCategory.id)
                            data.customerCategory = null;

                        if (data.customerSubCategory && !data.customerSubCategory.id)
                            data.customerSubCategory = null;

                        if (data.customerTitle && !data.customerTitle.id)
                            data.customerTitle = null;

                        if (data.doctorSpecialty && !data.doctorSpecialty.id)
                            data.doctorSpecialty = null;

                        if (data.doctorSpecificSpecialty && !data.doctorSpecificSpecialty.id)
                            data.doctorSpecificSpecialty = null;

                        if (data.collaboration && !data.collaboration.id)
                            data.collaboration = null;

                        $http.put(vm.customerUrl, data)
                            .success(function () {
                                angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                            })
                            .error(function (response) {});
                    }
                },
                batch: true,
                schema: {
                    data: function (data) {
                        if (data.content !== undefined) {
                            data.content.forEach(function (item) {
                                if (item.doctorSpecialty === null) item.doctorSpecialty = {};
                                if (item.doctorSpecificSpecialty === null) item.doctorSpecificSpecialty = {};
                                if (item.customerCategory === null) item.customerCategory = {};
                                if (item.customerSubCategory === null) item.customerSubCategory = {};
                                if (item.customerTitle === null) item.customerTitle = {};
                                if (item.collaboration === null) item.collaboration = {};
                                if (item.sector === null || !item.sector) item.sector = {};
                                if (item.sector.sectorType === null || !item.sector.sectorType) item.sector.sectorType = {};

                                item.employeesString = "";
                                if (item.employees) {
                                    item.employees.forEach(function (employeeName) {
                                        item.employeesString += "[" + employeeName + "] ";
                                    });
                                }



                            });
                        }
                        return data.content;

                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    parse: function (data) {
                        if (data.content !== undefined) {
                            var dt = new Date();
                            dt.setHours(23, 59, 59);
                            data.content.forEach(function (item) {
                                item.lastVisitDate =
                                    item.lastVisitDate ? Math.floor(Math.abs(new Date(item.lastVisitDate).getTime() - dt.getTime()) / (1000 * 60 * 60 * 24)) : '';
                            });
                        }
                        return data;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true},
                            firstName: {type: "string", validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                            lastName: {type: "string", validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                            isActive:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            saw:{
                                type: "boolean",
                                defaultValue: true,
                                parse: function(value) {
                                    return !!(value == "1" || value == "true" || value == true);

                                }
                            },
                            doctorSpecialty:{defaultValue: {id: null, name : null}},
                            doctorSpecificSpecialty:{defaultValue: {id: null, name : null}},
                            customerCategory:{defaultValue: { id : null, name : null}},
                            customerTitle:{defaultValue: { id : null, name : null}},
                            customerSubCategory:{defaultValue: { id : null, name : null}},
                            collaboration:{defaultValue: { id : null, name : null}},
                            dayTime:{defaultValue: null},
                            createdDate: { type: 'date', editable: false},
                            lastVisitDate: { type: 'number', editable: false },
                            customerTypes: {},
                            gdpr: { type: "boolean" },
                            sector: {
                                defaultValue:
                                    {
                                        id: null,
                                        sectorType: {defaultValue: {id: null, name: null}}
                                    }
                            }
                        }
                    }
                },
                pageSize: 50,
                serverPaging: true,
                serverSorting: true,
                scrollable: false,
                serverFiltering: true
            }),
                sortable: true,
                pageable: {
                    messages: {
                        display: "{0} - {1} από {2} Επαγγελματίες Υγείας", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                        empty: "Δεν βρέθηκαν Επαγγελματίες Υγείας",
                        page: "Σελίδα",
                        allPages: "Όλα",
                        of: "από {0}", // {0} is total amount of pages.
                        itemsPerPage: "εγγραφές ανά σελίδα",
                        first: "Πήγαινε στη πρώτη σελίδα",
                        previous: "Πήγαινε στη τελευταία σελίδα",
                        next: "Πήγαινε στην επόμενη σελίδα",
                        last: "Πήγαινε στη τελευταία σελίδα",
                        refresh: "Ανανέωση"
                    }
                },
                noRecords: {
                    template: "Δεν βρέθηκαν Επαγγελματίες Υγείας"
                },
                filterable: {
                mode: "row"
            },
                resizable: true,
                selectable: "cell",
                columns: vm.gridColumns,
                save: function () {
                var customersGrid = angular.element("#mainGrid").data("kendoGrid");
                customersGrid.refresh();
            },
                change: onChange,
                toolbar: vm.gridToolbar,
                editable: {
                    mode: "popup"
                },
                edit: function(e) {
                    KendoGrid.defaultEditPopup(this._editContainer);
                    //fix css
                    angular.element("input[name='isActive']").parent().addClass("k-checkbox-custom");
                    angular.element("div[data-container-for='customerTypes']").addClass("k-multi-custom");
                    angular.element("label[for='createdDate']").parent().next().addClass("k-text-custom");
                    e.container.find("[data-container-for='sector.sectorType.name']").prev().remove().end().remove();
                    e.container.find("[data-container-for='sector.osfeBrick']").prev().remove().end().remove();
                    e.container.find("[data-container-for='sector.brick']").prev().remove().end().remove();
                    e.container.find("[data-container-for='sector.cityName']").prev().remove().end().remove();
                    e.container.find("[data-container-for='sector.name']").prev().remove().end().remove();
                    e.container.find("[data-container-for='sector.prefectureName']").prev().remove().end().remove();
                    e.container.find("[data-container-for='employeesString']").prev().remove().end().remove();
                    e.container.find("[data-container-for='software']").prev().remove().end().remove();
                    e.container.find("label[for='lastVisitDate']").parent().next().remove().end().remove();
                    e.container.find("label[for='lastVisitDate']").prev().remove().end().remove();

                    if (vm.customerView === '3') {
                        e.container.find("[data-container-for='customerTitle.name']").prev().remove().end().remove();
                        e.container.find("[data-container-for='doctorSpecificSpecialty.name']").prev().remove().end().remove();
                        e.container.find("[data-container-for='amka']").prev().remove().end().remove();
                        e.container.find("[data-container-for='dayTime']").prev().remove().end().remove();
                    } else {
                        e.container.find("[data-container-for='collaboration.name']").prev().remove().end().remove();
                    }
                }
            };

            $timeout(function () {
                var toolbar = angular.element("#master_filters_customers").data("kendoToolBar");
                toolbar.add({
                    template: "<label>Προιστάμενος: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select multiple='multiple' " +
                    "k-options='vm.supervisorsMultiOptions' k-ng-model='vm.selectedSupervisors'></select>",
                    overflow: "never"
                });
                toolbar.add({
                    template: "<label>Ιατρικός Επισκέπτης: </label><select id='multiSelect' name='multiSelect' class='inline' kendo-multi-select='vm.employeesMulti' multiple='multiple' " +
                    "k-options='vm.employeesMultiOptions' k-ng-model='vm.selectedEmployees'></select>",
                    overflow: "never"
                });

                MasterFiltersService.clearFilterEvent()
            });
        }else {
            vm.mainGridOptions = {
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (o) {
                            if (o.data.filter == undefined) o.data.filter = {filters: []};

                            //master filters functionality
                            if (vm.from && vm.to) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        {
                                            "field": "createdDate", "operator": "from",
                                            "value": $filter('date')(vm.from, 'yyyy-MM-ddT00:00:00.000') + 'Z'
                                        },
                                        {
                                            "field": "createdDate", "operator": "to",
                                            "value": $filter('date')(vm.to, 'yyyy-MM-ddT23:59:59.000') + 'Z'
                                        }
                                    ]
                                );
                            }

                            if (vm.selectedEmployees.length) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        {
                                            "field": "customerSectors.employeeCustomerSectors.employee.id",
                                            "operator": "in",
                                            "value": vm.selectedEmployees.toString()
                                        }
                                    ]
                                );
                            }

                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.employeeCustomerSectors.myTarget",
                                        "operator": "eqbool",
                                        "value": vm.myTarget
                                    }
                                ]
                            );

                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "isActive",
                                        "operator": "eqbool",
                                        "value": vm.isActive
                                    }
                                ]
                            );

                            o.data.filter.filters = o.data.filter.filters.concat(
                                [
                                    {
                                        "field": "customerSectors.employeeCustomerSectors.active",
                                        "operator": "eqbool",
                                        "value": vm.employeeCustomerSectorActive
                                    }
                                ]
                            );
                            // if (vm.postalCode && vm.postalCode != "" && vm.postalCode != null) {
                            //     o.data.filter.filters = o.data.filter.filters.concat(
                            //         [
                            //             {
                            //                 "field": "customerSectors.sector.postalCode", "operator": "startswith",
                            //                 "value": vm.postalCode
                            //             }
                            //         ]
                            //     );
                            // }
                            //
                            if (vm.osfeBrick && vm.osfeBrick != "" && vm.osfeBrick != null) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        {
                                            "field": "customerSectors.sector.osfeBrick", "operator": "startswith",
                                            "value": vm.osfeBrick
                                        }
                                    ]
                                );
                            }

                            if (vm.brick && vm.brick != "" && vm.brick != null) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        {
                                            "field": "customerSectors.sector.brick", "operator": "startswith",
                                            "value": vm.brick
                                        }
                                    ]
                                );
                            }

                            if(vm.selectedSoftwares.length) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        { "field": "software", "operator":  vm.selectedSoftwares.indexOf('none') > -1 ? "isnull" : "in",
                                            "value": vm.selectedSoftwares.indexOf('all') > -1 ? "medexpress,medmobile,other" :
                                                vm.selectedSoftwares.indexOf('none') > -1 ? null :
                                                    vm.selectedSoftwares.toString() }
                                    ]
                                );
                            }

                            if (vm.selectedSupervisors.length && !vm.selectedEmployees.length) {
                                o.data.filter.filters = o.data.filter.filters.concat(
                                    [
                                        {
                                            "field": "customerSectors.employeeCustomerSectors.employee.id",
                                            "operator": "in_with_hierarchy",
                                            "value": vm.selectedSupervisors.toString()
                                        }
                                    ]
                                );
                            }

                            angular.forEach(o.data.filter.filters, function (item) {
                                if ( item.field === 'software' && item.value === 'none' ) {
                                    item.operator = "isnull";
                                    item.value = null;
                                }
                                if ( item.field === 'lastVisitDate' ) {
                                    var dt = new Date();
                                    dt.setDate( dt.getDate() - item.value );
                                    item.value = dt;
                                }
                                if (item.value instanceof Date) {
                                    item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                                }
                            });

                            if (vm.customerView === '3' || vm.customerView === '1' || vm.customerView === '6') {
                                vm.url = "/api/me/customers/main";
                            } else {
                                vm.url = "/api/me/customers";
                            }

                            $http.get(vm.url, {params: o.data})
                                .success(function (response) {
                                    o.success(response);
                                })
                                .error(function (response) {});
                        },
                        create: function (o) {
                            var data = o.data.models[0];

                            if (data.customerCategory && !data.customerCategory.id)
                                data.customerCategory = null;

                            if (data.customerSubCategory && !data.customerSubCategory.id)
                                data.customerSubCategory = null;

                            if (data.customerTitle && !data.customerTitle.id)
                                data.customerTitle = null;

                            if (data.doctorSpecialty && !data.doctorSpecialty.id)
                                data.doctorSpecialty = null;

                            if (data.doctorSpecificSpecialty && !data.doctorSpecificSpecialty.id)
                                data.doctorSpecificSpecialty = null;

                            if (data.collaboration && !data.collaboration.id)
                                data.collaboration = null;

                            $http.post('/api/customers/exists', data)
                                .success(function (response) {
                                    vm.existedCustomers = response;
                                    vm.customerToSave = data;
                                    if (vm.existedCustomers.length) {
                                        vm.showConfirm();
                                    } else {
                                        vm.saveCustomer(data);
                                    }
                                })
                                .error(function (response) {});
                        },
                        update: function (o) {
                            var data = o.data.models[0];

                            if (data.customerCategory && !data.customerCategory.id)
                                data.customerCategory = null;

                            if (data.customerSubCategory && !data.customerSubCategory.id)
                                data.customerSubCategory = null;

                            if (data.customerTitle && !data.customerTitle.id)
                                data.customerTitle = null;

                            if (data.doctorSpecialty && !data.doctorSpecialty.id)
                                data.doctorSpecialty = null;

                            if (data.doctorSpecificSpecialty && !data.doctorSpecificSpecialty.id)
                                data.doctorSpecificSpecialty = null;

                            if (data.collaboration && !data.collaboration.id)
                                data.collaboration = null;

                            $http.put(vm.customerUrl, data)
                                .success(function () {
                                    angular.element("#mainGrid").data("kendoGrid").dataSource.read();
                                })
                                .error(function (response) {});
                        }
                    },
                    batch: true,
                    schema: {
                        data: function (data) {
                            if (data.content !== undefined) {
                                data.content.forEach(function (item) {
                                    if (item.doctorSpecialty === null) item.doctorSpecialty = {};
                                    if (item.doctorSpecificSpecialty === null) item.doctorSpecificSpecialty = {};
                                    if (item.customerCategory === null) item.customerCategory = {};
                                    if (item.customerSubCategory === null) item.customerSubCategory = {};
                                    if (item.customerTitle === null) item.customerTitle = {};
                                    if (item.collaboration === null) item.collaboration = {};
                                    if (item.sector === null || !item.sector) item.sector = {};
                                    if (item.sector.sectorType === null || !item.sector.sectorType) item.sector.sectorType = {};
                                    item.employeesString = "";
                                    if (item.employees) {
                                        item.employees.forEach(function (employeeName) {
                                            item.employeesString += "[" + employeeName + "] ";
                                        });
                                    }
                                });
                            }
                            return data.content;

                        },
                        parse: function (data) {
                            if (data.content !== undefined) {
                                data.content.forEach(function (item) {
                                    var dt = new Date();
                                    dt.setHours(23, 59, 59);
                                    item.lastVisitDate =
                                        item.lastVisitDate ? Math.floor(Math.abs(new Date(item.lastVisitDate).getTime() - dt.getTime()) / (1000 * 60 * 60 * 24)) : '';
                                });
                            }
                            return data;
                        },
                        total: function (data) {
                            return data.totalEntries;
                        },
                        model: {
                            id: "id",
                            fields: {
                                id: { editable: false, nullable: true},
                                firstName: {type: "string", validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                lastName: {type: "string", validation: {required: { message: "Απαραίτητο Πεδίο" } } },
                                isActive:{
                                    type: "boolean",
                                    defaultValue: true,
                                    parse: function(value) {
                                        return !!(value == "1" || value == "true" || value == true);

                                    }
                                },
                                saw:{
                                    type: "boolean",
                                    defaultValue: true,
                                    parse: function(value) {
                                        return !!(value == "1" || value == "true" || value == true);

                                    }
                                },
                                doctorSpecialty:{defaultValue: {id: null, name : null}},
                                doctorSpecificSpecialty:{defaultValue: {id: null, name : null}},
                                customerCategory:{defaultValue: { id : null, name : null}},
                                customerTitle:{defaultValue: { id : null, name : null}},
                                customerSubCategory:{defaultValue: { id : null, name : null}},
                                collaboration:{defaultValue: { id : null, name : null}},
                                dayTime:{defaultValue: null},
                                createdDate: { type: 'date', editable: false},
                                lastVisitDate: { type: 'number', editable: false },
                                customerTypes: {},
                                gdpr: { type: 'boolean' },
                                sector: {
                                    defaultValue:
                                        {
                                            id: null,
                                            sectorType: {defaultValue: {id: null, name: null}}
                                        }
                                }
                            }
                        }
                    },
                    pageSize: 50,
                    serverPaging: true,
                    serverSorting: true,
                    scrollable: false,
                    serverFiltering: true
                }),
                sortable: true,
                pageable: true,
                filterable: {
                    mode: "row"
                },
                resizable: true,
                selectable: "cell",
                columns: vm.gridColumns,
                save: function () {
                    var customersGrid = angular.element("#mainGrid").data("kendoGrid");
                    customersGrid.refresh();
                },
                change: onChange,
                toolbar: vm.gridToolbar
            }
        }

        function onChange() {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndex === 0 || cellIndex === 1) {
                $state.go('customerInfo', {id: this.dataItem(row).id});
            }
        }
    }
})();
;
/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminAgreements', {
                parent: 'app',
                url: '/agreements',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminAgreements/adminAgreements.html',
                        controller: 'AdminAgreementsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
;
/**
 * Created by Maria on 11/5/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminAgreementsController', AdminAgreementsController);

    AdminAgreementsController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'pagingParams', 'KendoFilter','$http', '$rootScope', '$location', 'CustomUtils'];

    function AdminAgreementsController ($scope, $state, $filter, ParseLinks, AlertService, pagingParams, KendoFilter, $http, $rootScope, $location, CustomUtils) {
        var vm = this;
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(67);
        vm.pageHeading = 'Αξιολογηση';

        function onChange(arg) {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            // Get cell index (column number)
            var idx = selected.index();
            // Get column name from Grid column definition
            var col = this.options.columns[idx-1].field;

            if (col === 'event.eventCustomerSector.customerSector.customer.firstName' || col === 'event.eventCustomerSector.customerSector.customer.lastName') {
                var customerId = this.dataItem(row).event.eventCustomerSector.customerSector.customer.id;
                $rootScope.$apply(function () {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = customerId;
                    $state.go('customerInfo', {id: customerId, stateFrom: 'adminAgreements'});
                });
            } else if (col === 'event.employee.account.lastName') {
                var userId = this.dataItem(row).event.employee.id;
                $rootScope.$apply(function () {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = userId;
                    // $location.path('/employees/search').search({id: userId});
                    $state.go('userInfo', {id: userId, stateFrom: 'adminAgreements'});
                });
            } else {
                //this.clearSelection(); //his throws error
                this.saveChanges();
            }
        }

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('/api/me/agreements',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (data.filter != undefined) {
                                angular.forEach(data.filter.filters, function (item) {
                                    if (item.field === "event.startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.event === null) {
                                    item.event = {
                                        startedAt: '',
                                        employee: {
                                            account: {
                                                lastName: ""
                                            }
                                        },
                                        eventCustomerSector: {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            }
                                        }
                                    };
                                } else {
                                    if (item.event.eventCustomerSector === null) {
                                        item.event.eventCustomerSector = {
                                            customerSector: {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            }
                                        };
                                    } else {
                                        if (item.event.eventCustomerSector.customerSector === null) {
                                            item.event.eventCustomerSector.customerSector = {
                                                customer: {
                                                    last_name: "",
                                                    first_name: ""
                                                }
                                            };
                                        } else {
                                            if (item.event.eventCustomerSector.customerSector.customer === null) {
                                                item.event.eventCustomerSector.customerSector.customer = {
                                                    last_name: "",
                                                    first_name: ""
                                                };
                                            }
                                        }
                                    }
                                }
                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: {editable: false, nullable: false},
                            'event.startedAt': {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 100,
                group: [{field: "event.startedAt", dir: "desc"}]
            }),
            groupable: false,
            pageable: {
                messages: {
                    display: "{0} - {1} από {2} Αξιολόγηση", // {0} is the index of the first record on the page, {1} - the index of the last record on the page, {2} is the total amount of records.
                    empty: "Δεν βρέθηκε Αξιολόγηση",
                    page: "Σελίδα",
                    allPages: "Όλα",
                    of: "από {0}", // {0} is total amount of pages.
                    itemsPerPage: "εγγραφές ανά σελίδα",
                    first: "Πήγαινε στη πρώτη σελίδα",
                    previous: "Πήγαινε στη τελευταία σελίδα",
                    next: "Πήγαινε στην επόμενη σελίδα",
                    last: "Πήγαινε στη τελευταία σελίδα",
                    refresh: "Ανανέωση"
                }
            },
            noRecords: {
                template: "Δεν βρέθηκε Αξιολόγηση"
            },
            resizable: true,
            filterable: {
                mode: "row"
            },
            sortable: true,
            columns: [
                {
                    field: "event.startedAt", hidden: true,
                    groupHeaderTemplate: "Ημερομηνία Επίσκεψης: #= value ? kendo.toString(kendo.parseDate(value), 'dddd, dd/MM/yyyy') : ''#"
                },
                {
                    field: "event.startedAt",
                    title: "Ημερομηνία Επίσκεψης",
                    template: "#= event.startedAt ? kendo.toString(kendo.parseDate(event.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    }
                },
                {
                    field: "product.name", title: "Προϊόν",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "description",
                    title: "Περιγραφή Αξιολόγησης",
                    template: "#= description == null ? ' ' : description #",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "promisedQuantity", title: "Προβλεπόμενη Συχνότητα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 160
                },
                {
                    field: "priority",
                    title: "Σειρά προτεραιότητας",
                    template: "#=priority != null ? priority + 1 : ''#",
                    filterable: {
                        cell: {
                            operator: "eq",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width: 140
                },
                //{field: "agreedPrice", title: "Αξία που Συμφωνήθηκε",
                //    filterable: {
                //        cell: {
                //            operator: "startswith",
                //            showOperators: false
                //        }
                //    },
                //    format: "{0:c}"
                //},
                {
                    field: "agreementValuation.name", title: "Αξιολόγηση", attributes: {
                        class: "#=agreementValuation.id == '1' ? 'red' : agreementValuation.id == '2' ? 'orange' : agreementValuation.id == '3' ? 'purple' : agreementValuation.id == '4' ? 'green' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας", attributes: {
                        class: "#= 'link-cell link-cell-color' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας", attributes: {
                        class: "#= 'link-cell link-cell-color' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "event.employee.account.lastName", title: "Όνομα Ιατρικού Επισκέπτη", attributes: {
                        class: "#= 'link-cell link-cell-color' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            editable: "inline",
            selectable: "cell",
            height: vm.contentHeight,
            change: onChange
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
/**
 * Created by Kristy on 15/7/2016.
 */
(function(){
    angular
        .module('sigmasfApp')
        .directive('selectableGrid', selectableGrid);

    // Activate it by passing selectable-grid attribute to
    // the div which constructs the grid.
    selectableGrid.$inject = ['$compile'];

    function selectableGrid ($compile) {
        return {
            restrict: 'A',
            scope: true,
            controller: function ($scope, $filter) {
                var items = [];
                var kendoPageData = [];

                $scope.$watch("vm.statusChanged",function(newValue,oldValue) {
                    //This gets called when status changes.
                    //clear selected items
                    items = [];
                });

                $scope.toggleSelectAll = function(ev) {
                    var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid");
                    var me = this;

                    var dataSource = grid.dataSource;
                    var filters = dataSource.filter();
                    var query = new kendo.data.Query(dataSource.data());
                    var filteredData = query.data;

                    if(filters) {
                        if(filters.filters[0].operator !== "like" && filters.filters[0].operator !== "eqdate") {
                            filteredData = query.filter(filters).data;
                        }
                    }

                    angular.copy(filteredData, kendoPageData);

                    filteredData.forEach(function (item) {
                        item.selected = ev.target.checked;
                        var itemByUID = $(ev.target).closest("[kendo-grid]").find("tr[data-uid='" + item.uid + "']");
                        if(me.allSelected) {
                            itemByUID.addClass("k-state-selected");
                        } else {
                            itemByUID.removeClass("k-state-selected");
                        }
                    });

                    if(this.allSelected) {
                        angular.forEach(kendoPageData, function (kendoPageDataItem) {
                            var foundItemById = $filter('filter')(items, {id: kendoPageDataItem.id}, true)[0];
                            if ( !foundItemById ) items = items.concat(kendoPageDataItem);
                        });
                        grid.options.selectedItems(items);
                    } else {
                        items = items.filter(function(item) {
                            var foundItemById = $filter('filter')(kendoPageData, {id: item.id}, true)[0];
                            return kendoPageData.indexOf(foundItemById) === -1;
                        });
                        grid.options.selectedItems(items);
                    }
                };

                $scope.onSelectItem = function(ev, dataItem){
                    var grid;
                    if (ev.target) {
                        grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid");
                    } else {
                        grid = ev;
                    }

                    var foundItemById = $filter('filter')(items, {id: dataItem.id}, true)[0];

                    if(items.indexOf(foundItemById) !== -1){
                        items.splice(items.indexOf(foundItemById), 1);
                        dataItem.selected = false;
                    }else{
                        items.push(dataItem);
                        dataItem.selected = true;
                    }

                    grid.options.selectedItems(items);
                };
            },
            link: function (scope, $element, $attrs) {
                scope.checkboxTitle = $attrs.id+"checkbox";
                var options = scope.$eval($attrs.kOptions);
                if (options && options.columns[0].name !== 'checkbox') {
                    options.columns.unshift({
                        name: "checkbox",
                        template: "<input type='checkbox' class='checkbox' ng-model='dataItem.selected' ng-click='onSelectItem($event, dataItem)'/>",
                        title: "<label>Επιλογή <br>όλων</label><input id='{{ checkboxTitle }}' type='checkbox' class='checkbox' ng-show='vm.massSelect' ng-model='this.allSelected' ng-click='toggleSelectAll($event)'/>",
                        width: 70
                    });
                }
            }
        };
    }
})();
;
/**
 * Created by Teo on 23/05/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PdfBuilder', PdfBuilder);

    PdfBuilder.$inject = [];

    function PdfBuilder () {
        const LINEBREAK = '%0D%0A';

        return {
            createOffer : createOffer,
            makeFundOffer : makeFundOffer,
            makeFundOfferWithImages : makeFundOfferWithImages,
            makePrivateOffer: makePrivateOffer,
            makePrivateOfferWithImages: makePrivateOfferWithImages,
            makeReliefTherapyOffer : makeReliefTherapyOffer,
            makeReliefTherapyOfferWithImages : makeReliefTherapyOfferWithImages,
            makeDemoOffer : makeDemoOffer,
            makeLeadManagementAggregatedReport: makeLeadManagementAggregatedReport
        };

        function createOffer(object) {
            var lorem = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam in suscipit purus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Vivamus nec hendrerit felis. Morbi aliquam facilisis risus eu lacinia. Sed eu leo in turpis fringilla hendrerit. Ut nec accumsan nisl. Suspendisse rhoncus nisl posuere tortor tempus et dapibus elit porta. Cras leo neque, elementum a rhoncus ut, vestibulum non nibh. Phasellus pretium justo turpis. Etiam vulputate, odio vitae tincidunt ultricies, eros odio dapibus nisi, ut tincidunt lacus arcu eu elit. Aenean velit erat, vehicula eget lacinia ut, dignissim non tellus. Aliquam nec lacus mi, sed vestibulum nunc. Suspendisse potenti. Curabitur vitae sem turpis. Vestibulum sed neque eget dolor dapibus porttitor at sit amet sem. Fusce a turpis lorem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;\nMauris at ante tellus. Vestibulum a metus lectus. Praesent tempor purus a lacus blandit eget gravida ante hendrerit. Cras et eros metus. Sed commodo malesuada eros, vitae interdum augue semper quis. Fusce id magna nunc. Curabitur sollicitudin placerat semper. Cras et mi neque, a dignissim risus. Nulla venenatis porta lacus, vel rhoncus lectus tempor vitae. Duis sagittis venenatis rutrum. Curabitur tempor massa tortor.';
            // create a document and pipe to a blob
            var doc = new PDFDocument();
            var stream = doc.pipe(blobStream());

            // draw some text
            doc.fontSize(25)
                .text('Here is some vector graphics...', 100, 80);

            // some vector graphics
            doc.save()
                .moveTo(100, 150)
                .lineTo(100, 250)
                .lineTo(200, 250)
                .fill("#FF3300");

            doc.circle(280, 200, 50)
                .fill("#6600FF");

            // an SVG path
            doc.scale(0.6)
                .translate(470, 130)
                .path('M 250,75 L 323,301 131,161 369,161 177,301 z')
                .fill('red', 'even-odd')
                .restore();

            // and some justified text wrapped into columns
            doc.text('And here is some wrapped text...', 100, 300)
                .font('Times-Roman', 13)
                .moveDown()
                .text(lorem, {
                    width: 412,
                    align: 'justify',
                    indent: 30,
                    columns: 2,
                    height: 300,
                    ellipsis: true
                });

            // end and display the document in the iframe to the right
            doc.end();
            stream.on('finish', function() {
                var file = stream.toBlobURL('application/pdf');
                window.open(file);
            });
        }

        /**
         * Builds a pdf document depending on values of object and
         * displays it in new browser tab. Original doc: fund_hospitalization.pdf.
         * @param object The offer object. Object's structure should be:
         * object {
         *   date: Date
         *   fullName: String,
         *   pdfPronouncement: String,
         *   attendantMealPrice: Double
         *   transportation: Transportation object
         *   roomCost: RoomCost object
         *   finalDiscount: DiscountRate object
         * }
         */
        function makeFundOffer(object)  {
            var doc = new PDFDocument({
                margin: 50
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;
            var statsImage = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            //oReq.open("GET", "content/fonts/NotoSans-Regular.ttf", true);
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            toDataURL('content/images/arogi_stats.jpg', function (dataUrl) {
                                statsImage = dataUrl;
                                // Got all images, build the document
                                /****************
                                 *** 1st Page ***
                                 ****************/
                                doc.image(logoImage, {
                                    fit: [160, 210],
                                    align: 'left'
                                });
                                doc.image(certImage, 450, 40, {
                                    fit: [80, 80],
                                    align: 'right'
                                });

                                doc.font('mArial', 11)
                                    .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                                //doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text(object.pdfPronouncement, 30, 170);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Αρχικά θα θέλαμε να σας ευχαριστήσουμε για την εμπιστοσύνη σας στις υπηρεσίες του κέντρου' +
                                        ' Αποκατάστασης και Αποθεραπείας Euromedica – Αρωγή Θεσσαλονίκης.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Στη συνέχεια ακολουθεί μια σύντομη παρουσίαση του Κέντρου και περιγραφή των παροχών αυτού,' +
                                        ' προς τους νοσηλευόμενους ασθενείς.');
                                doc.moveDown(2);
                                doc.font('mArial', 15)
                                    .text('Πρότυπο Κέντρο στην Αποκατάσταση και Αποθεραπεία.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Η Euromedica-Αρωγή Θεσσαλονίκης, το πρώτο και μοναδικό Κέντρο Αποκατάστασης στην' +
                                        ' περιοχή της Νοτιοανατολικής Ευρώπης, ανήκει στην επίλεκτη παγκόσμια ομάδα των 543 Κέντρων' +
                                        ' Αποκατάστασης, εκ των οποίων τα 517 στις Ηνωμένες Πολιτείες Αμερικής, τα οποία έχουν λάβει τη' +
                                        ' Διεθνή Διαπίστευση CARF, στην κατηγορία:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('«Inpatient Rehabilitation Programmes – Hospital»', {align: 'center'});
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Η διαπίστευση αυτή, αποτελεί το υψηλότερο επίπεδο παγκόσμιας πιστοποίησης που απονέμεται σε' +
                                        ' ένα Κέντρο Αποκατάστασης και καταδεικνύει την υψηλή ποιότητα παρεχόμενων προγραμμάτων' +
                                        ' αποκατάστασης.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Στο Κέντρο Αποκατάστασης και Αποθεραπείας Euromedica–Αρωγή Θεσσαλονίκης προσφέρουμε' +
                                        ' από το 2010 εξατομικευμένα προγράμματα αποκατάστασης και αποθεραπείας, προσεγγίζοντας' +
                                        ' ολιστικά τους ασθενείς με οξείες ή χρόνιες παθήσεις.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Ως κύριο στόχο μας θέσαμε την ανάπτυξη μίας σύγχρονης αντίληψης για την Αποκατάσταση που' +
                                        ' θα συνεισφέρει στην προαγωγή της καλής υγείας και στον σεβασμό των ανθρώπων που πάσχουν' +
                                        ' και συγχρόνως, πασχίζουν να γίνουν καλά.');
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('Euromedica-Αρωγή ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 2nd Page ***
                                 ****************/

                                doc.font('mArial', 15)
                                    .text('Οραμά μας είναι η Καλύτερη Υγεία για Ολους.', 30);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Θέλουμε να ξεπερνούμε τις στατιστικές και τα προγνωστικά, εμπνέοντας δύναμη και ελπίδα. Να' +
                                        ' θέτουμε ρεαλιστικούς στόχους προόδου και να τους υπερβαίνουμε. Να είμαστε για τους ασθενείς' +
                                        ' μας, τις οικογένειές τους και την ιατρική κοινότητα σημείο αναφοράς στη φυσική ιατρική και' +
                                        ' Αποκατάσταση στην Ελλάδα και στη Νοτιοανατολική Ευρώπη.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Η ειδική Ιατρική Ομάδα Αποκατάστασης σχεδιάζει και κάνει πράξη την αποθεραπεία των ασθενών' +
                                        ' μας. Τα μέλη της συνεδριάζουν εβδομαδιαία και συνεργάζονται στενά γιa την πρόοδο κάθε' +
                                        ' ασθενούς.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Ο φυσίατρος είναι ο επικεφαλής ειδικός Επαγγελματίας Υγείας της Ομάδας Αποκατάστασης, ο οποίος' +
                                        ' προσεγγίζει ολιστικά τους ασθενείς, εκτιμά την κατάστασή τους, θέτει μαζί τους στόχους και' +
                                        ' επιβλέπει την εξέλιξη της αποθεραπείας τους, συντονίζοντας την ειδική Ιατρική Ομάδα' +
                                        ' Αποκατάστασης που αποτελείται από Ιατρό φυσικής Αποκατάστασης σε κάθε πτέρυγα νοσηλείας,' +
                                        ' Παθολόγο σε κάθε πτέρυγα νοσηλείας, Καρδιολόγο, Ορθοπεδικό, Εντατικολόγο, Νευρολόγο και' +
                                        ' συνεργαζόμενους εξωτερικούς επαγγελματίες υγείας όλων των ειδικοτήτων ανάλογα με την ανάγκη που θα' +
                                        ' προκύψει για κάθε ασθενή.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Στο κέντρο Euromedica-Αρωγή Θεσσαλονίκης κάθε πρόγραμμα φυσικής Ιατρικής και' +
                                        ' Αποκατάστασης που εφαρμόζεται σχεδιάζεται με επίκεντρο τον ασθενή και τις ανάγκες του και' +
                                        ' μπορεί να συνδυάσει ένα εύρος υπηρεσιών από τα διαφορετικά τμήματα του Κέντρου:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας φυσιοθεραπείας');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας υδροθεραπείας');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας εργοθεραπείας');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας λογοθεραπείας');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας ψυχολογικής υποστήριξης');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- τομέας διατροφής');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('το κέντρο Euromedica-Αρωγή Θεσσαλονίκης βρίσκεται σε απόσταση 10 λεπτών από το εμπορικό κέντρο' +
                                        ' της πόλης σε έναν κτίριο ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('15.947 ', {continued: true})
                                    .font('mArial', 11)
                                    .text('τ.μ. που διαθέτει:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 200 κλίνες');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 4.500 τ.μ. χώρους θεραπειών');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 1.200 κλειστούς χώρους αθλητικών δραστηριοτήτων ΑΜΕΑ');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 3 πισίνες και 1 υδατοδιάδρομος');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 170 θέσεις στάθμευσης');
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                //doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('Euromedica-Αρωγή ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 3rd Page ***
                                 ****************/

                                doc.font('mArial', 11)
                                    .text('Σε συνέχεια της επικοινωνίας μας , σας ενημερώνω ότι το κόστος της ημερήσιας συμμετοχής' +
                                        ' σχετικά με την νοσηλεία ασθενούς στο Κέντρο μας καθορίζεται ανάλογα με την επιλογή του τύπου' +
                                        ' του δωματίου και διαμορφώνεται ως εξής:', 30);
                                doc.moveDown(1);

                                // Draw a table
                                doc.lineCap('butt')
                                    .moveTo(270, 100)
                                    .lineTo(270, 240)
                                    .stroke();

                                var coordinates = {
                                    rowHeight: 100,
                                    leftHeight: 105,
                                    rightHeight: 105
                                };

                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Υπηρεσίες / Δωμάτιο', coordinates.leftHeight, 90);
                                textInRowSecond(doc, 'χρέωση / ημερα', coordinates.rightHeight, 350);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Νοσηλεία σε τρίκλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€39', coordinates.rightHeight, 390);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Νοσηλεία σε δίκλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€49', coordinates.rightHeight, 390);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Νοσηλεία σε μονόκλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€110', coordinates.rightHeight, 390);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Νοσηλεία σε μονόκλινο δωμάτιο με συνοδό', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€135', coordinates.rightHeight, 390);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Γεύμα συνοδού', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€15', coordinates.rightHeight, 390);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'Νοσηλεία σε ΧΑΦ', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€220', coordinates.rightHeight, 390);

                                doc.font('mArial', 11)
                                    .text('Στις παραπάνω τιμές συμπεριλαμβάνεται ο Φ.Π.Α. ', 30, 250, {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('(24%)', {continued: true})
                                    .font('mArial', 11)
                                    .text('. Η εξόφληση των νοσηλίων\nπραγματοποιείται κάθε 10 ημέρες νοσηλείας.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Στο αναγραφόμενο κόστος συμπεριλαμβάνονται:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Η διαμονή');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Πλήρης διατροφή με 3 γεύματα την ημέρα');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 24ωρη νοσηλευτική φροντίδα');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Η φαρμακευτική αγωγή που συνταγογραφείται');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Υγειονομικό υλικό όπως πάνες, γάζες, σύριγγες κ.τ.λ.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Οι διαγνωστικές εξετάσεις ρουτίνας καθ’ όλη τη διάρκεια νοσηλείας');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Συμμετοχή σε καθημερινό πρόγραμμα φυσιοθεραπευτικής αποκατάστασης Δευτέρα έως');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Συμμετοχή σε καθημερινό πρόγραμμα φυσιοθεραπευτικής αποκατάστασης Δευτέρα έως και Σάββατο, με    4-5 συνεδρίες την ημέρα το οποίο μπορεί να περιλαμβάνει:');
                                doc.moveDown(1);
                                // inside list
                                doc.font('mArial', 11)
                                    .text('  - Φυσιοθεραπεία: Τεχνικές: ', 70, 447, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('BOBATH – PNF - MANUAL – MULLIGAN', 70, 449);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('  - Εργοθεραπεία: Ρομποτικό ', 70, 461, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('ARMEO (', 70, 463, {continued: true})
                                    .font('mArial', 11)
                                    .text('κινητοποίηση άνω άκρου', 70, 461, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text(')', 70, 463, {continued: true});
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('  – Αισθητηριακή Ολοκλήρωση', 70, 461);
                                doc.moveDown(1);
                                doc.font('Times-Roman', 11)
                                    .text('- LOKOMAT: ', 70, 476, {continued: true})
                                    .font('mArial', 11)
                                    .text('Ρομποτικό κινητοποίησης κάτω άκρων', 70, 474);

                                doc.font('Times-Roman', 11)
                                    .text('- REHACOM: ', 70, 489, {continued: true})
                                    .font('mArial', 11)
                                    .text('Αξιολόγηση και θεραπεία γνωσιακών ελλειμμάτων', 70, 487);

                                doc.font('Times-Roman', 11)
                                    .text('- BALANCE: ', 70, 501, {continued: true})
                                    .font('mArial', 11)
                                    .text('Εκπαίδευση ιδιοδεκτικότητας και συντονισμού στην όρθια θέση', 70, 499);

                                doc.font('mArial', 11)
                                    .text('- Άσκηση σε εικονικό περιβάλλον ', 70, 511, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('(Wii):', 70, 514, {continued: true})
                                    .font('mArial', 11)
                                    .text(' Επανεκπαίδευση χρονισμού των κινητικών αλυσίδων', 70, 511);

                                /*doc.font('mArial', 11)
                                    .text('- Λογοθεραπεία: Εκπαίδευση κατάποσης και διαχείριση τραχειοστομίας', 70, 523);

                                doc.font('mArial', 11)
                                    .text('- Υδροθεραπεία: Τεχνικές: ', 70, 535, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('HALLIWICK – BAD RAGAZ RING METHOD', 70, 537);

                                doc.font('mArial', 11)
                                    .text('- Χρήση εξειδικευμένων μηχανημάτων: ', 70, 547, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('TILT, CPM, ROLLATOR', 70, 549);

                                doc.font('mArial', 11)
                                    .text('- Πλήρως εξοπλισμένο γυμναστήριο', 70, 559);

                                doc.font('mArial', 11)
                                    .text('- Θεραπευτική άσκηση : ', 70, 571, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('YOGA, PILATES', 70, 573);

                                doc.font('mArial', 11)
                                    .text('Ο αριθμός και το είδος των θεραπειών καθορίζεται σύμφωνα με τις ανάγκες του ατόμου και' +
                                        ' κατόπιν αξιολόγησης της Ομάδας Αποκατάστασης.', 36);
                                doc.font('mArial', 11)
                                    .text('- Καθημερινή ιατρική παρακολούθηση από Ιατρό Φυσικής Αποκατάστασης και Παθολόγο' +
                                        ' και στην αξιολόγηση που απαιτείται από Νευρολόγο, Καρδιολόγο και Ορθοπεδικό' +
                                        ' - Διατροφολογική και ψυχολογική υποστήριξη', 30);*/

                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('Euromedica-Αρωγή ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 4th Page ***
                                 ****************/
                                doc.font('mArial', 11)
                                    .text('Δεν συμπεριλαμβάνονται στα ημερήσια νοσήλια:', 30);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Εξειδικευμένες διαγνωστικές εξετάσεις που τυχόν απαιτηθούν κατά τη διάρκεια της' +
                                        '  όπως νοσηλείας καλλιέργειες, αντιβιογράμματα, ακτινογραφίες κ.τ.λ.' +
                                        ' - Η φαρμακευτική αγωγή που δεν συνταγογραφείται' +
                                        ' - Νοσηλεία στο Χώρο Αυξημένης Φροντίδας' +
                                        ' - Μεταφορά με ασθενοφόρο' +
                                        ' - Οι επισκέψεις εξωτερικών συνεργαζόμενων επαγγελματιών υγείας' +
                                        ' - Γεύματα συνοδών όπως ημερήσια χρέωση €15 για 3 γεύματα' +
                                        ' - Αναλώσιμα υλικά όπως αλλαγή γαστροστομίας, τραχειοστομίας κ.τ.λ.' +
                                        ' - Τυχόν βοηθήματα βάδισης' +
                                        ' - Η χρήση αποκλειστικής νοσοκόμας');
                                doc.moveDown(1);

                                doc.font('mArial', 11)
                                    .text("", 30);
                                doc.font('mArial', 11)
                                    .text('Η διάρκεια παραμονής των ασθενών στο Κέντρο Euromedica Αρωγή κυμαίνεται από μερικές' +
                                        ' ημέρες έως αρκετές εβδομάδες, ανάλογα με τις ατομικές ανάγκες και την πρόοδο που' +
                                        ' παρουσιάζουν. Το Κέντρο Euromedica Αρωγή τηρεί για τον κάθε ασθενή τα χρονοδιαγράμματα' +
                                        ' που έχουν καθοριστεί από τον Εθνικό Οργανισμό Παροχής Υπηρεσιών Υγείας ΕΟΠΥΥ. Σύμφωνα' +
                                        ' με τα επίσημα στοιχεία του κέντρου, το 2017, η μέση διάρκεια παραμονής ήταν ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('29,99 ', {continued: true})
                                    .font('mArial', 11)
                                    .text('ημέρες,\n' +
                                        ' δηλαδή αρκετά κάτω από τις κατευθυντήριες γραμμές του ΕΟΠΥΥ, χαμηλότερα και από τις 31,01' +
                                        ' ημέρες του έτους 2016.');
                                doc.moveDown(1);
                                doc.image(statsImage, {
                                    fit: [450, 750],
                                    align: 'left'
                                });
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('Euromedica-Αρωγή ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 5th Page ***
                                 ****************/
                                doc.font('mArial', 11)
                                    .text('Το πρόγραμμα αποκατάστασης που θα ακολουθηθεί και ο τύπος και ο αριθμός των θεραπειών' +
                                        ' καθορίζεται σύμφωνα με τις ανάγκες του εκάστοτε ασθενούς και κατόπιν αξιολόγησης της Ομάδας' +
                                        ' Αποκατάστασης κατά την εισαγωγή του ασθενούς. Το ατομικό πρόγραμμα αποκατάστασης' +
                                        ' κοινοποιείται εγγράφως στον ασθενή και στους συνοδούς σε εβδομαδιαία βάση.', 30);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Είμαι στη διάθεσή σας για οποιαδήποτε διευκρίνιση ή απορία προκύπτει από την ως άνω' +
                                        ' πληροφόρηση στην ηλεκτρονική διεύθυνση ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text("s.bakatselou@euromedica.gr ", {continued: true})
                                    .font('mArial', 11)
                                    .text("ή στα τηλέφωνα ", {continued: true})
                                    .font("Times-Roman", 13)
                                    .text("\n2310 986150.");
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Με εκτίμηση,');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Σταυριάνα Μπακατσέλου' +
                                        ' Διευθύντρια Υποδοχής και Κίνησης Ασθενών');
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('Euromedica-Αρωγή ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                doc.end();
                                stream.on('finish', function() {
                                    var file = stream.toBlobURL('application/pdf');
                                    window.open(file);
                                });
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        function makeFundOfferWithImages(object) {
            var doc = new PDFDocument({
                margin: 45
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;
            var page1Image = null;
            var page2Image = null;
            var page3Image = null;
            var page4Image = null;
            var page5Image = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            toDataURL('content/images/fund_page1.jpg', function (dataUrl) {
                                page1Image = dataUrl;
                                toDataURL('content/images/fund_page2.jpg', function (dataUrl) {
                                    page2Image = dataUrl;
                                    toDataURL('content/images/fund_page3.jpg', function (dataUrl) {
                                        page3Image = dataUrl;
                                        toDataURL('content/images/fund_page4.jpg', function (dataUrl) {
                                            page4Image = dataUrl;
                                            toDataURL('content/images/fund_page5.jpg', function (dataUrl) {
                                                page5Image = dataUrl;
                                                /****************
                                                 *** 1st Page ***
                                                 ****************/
                                                doc.image(logoImage, {
                                                    fit: [160, 210],
                                                    align: 'left'
                                                });
                                                doc.image(certImage, 450, 40, {
                                                    fit: [80, 80],
                                                    align: 'right'
                                                });

                                                doc.font('mArial', 11)
                                                    .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                                                //doc.moveDown(2);
                                                doc.font('mArial', 11)
                                                    .text(object.pdfPronouncement, 55, 170);
                                                doc.moveDown(1);
                                                doc.image(page1Image, {
                                                    fit: [550, 600],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 2nd Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page2Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 3rd Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page3Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 4th Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page4Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 5th Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page5Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });


                                                doc.end();
                                                stream.on('finish', function() {
                                                    var file = stream.toBlobURL('application/pdf');
                                                    window.open(file);
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        /**
         * Builds a pdf document depending on values of object and
         * displays it in new browser tab. Original doc: private_hospitalization.pdf
         * @param object The offer object. Object's structure should be:
         * object {
         *   date: Date
         *   fullName: String,
         *   pdfPronouncement: String,
         *   attendantMealPrice: Double
         *   transportation: Transportation object
         *   roomCost: RoomCost object
         *   finalDiscount: DiscountRate object
         * }
         */
        function makePrivateOffer(object) {
            var doc = new PDFDocument({
                margin: 50
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;
            var statsImage = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            toDataURL('content/images/arogi_stats.jpg', function (dataUrl) {
                                statsImage = dataUrl;
                                // Got all images, build the document
                                /****************
                                 *** 1st Page ***
                                 ****************/
                                doc.image(logoImage, {
                                    fit: [160, 210],
                                    align: 'left'
                                });
                                doc.image(certImage, 450, 40, {
                                    fit: [80, 80],
                                    align: 'right'
                                });

                                doc.font('mArial', 11)
                                    .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                                //doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text(object.pdfPronouncement, 30, 170);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Αρχικά θα θέλαμε να σας ευχαριστήσουμε για την εμπιστοσύνη σας στις υπηρεσίες του κέντρου' +
                                        ' Αποκατάστασης και Αποθεραπείας Euromedica – Αρωγή Θεσσαλονίκης.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Στη συνέχεια ακολουθεί μια σύντομη παρουσίαση του Κέντρου και περιγραφή των παροχών αυτού,' +
                                        ' προς τους νοσηλευόμενους ασθενείς.');
                                doc.moveDown(2);
                                doc.font('mArial', 15)
                                    .text('Πρότυπο Κέντρο στην Αποκατάσταση και Αποθεραπεία.');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Η Euromedica-Αρωγή Θεσσαλονίκης, το πρώτο και μοναδικό Κέντρο Αποκατάστασης στην' +
                                        ' περιοχή της Νοτιοανατολικής Ευρώπης, ανήκει στην επίλεκτη παγκόσμια ομάδα των 543 Κέντρων' +
                                        ' Αποκατάστασης, εκ των οποίων τα 517 στις Ηνωμένες Πολιτείες Αμερικής, τα οποία έχουν λάβει τη' +
                                        ' Διεθνή Διαπίστευση CARF, στην κατηγορία:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('«Inpatient Rehabilitation Programmes – Hospital»', {align: 'center'});
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Η διαπίστευση αυτή, αποτελεί το υψηλότερο επίπεδο παγκόσμιας πιστοποίησης που απονέμεται σε' +
                                        ' ένα Κέντρο Αποκατάστασης και καταδεικνύει την υψηλή ποιότητα παρεχόμενων προγραμμάτων' +
                                        ' αποκατάστασης.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Στο Κέντρο Αποκατάστασης και Αποθεραπείας Euromedica–Αρωγή Θεσσαλονίκης προσφέρουμε' +
                                        ' από το 2010 εξατομικευμένα προγράμματα αποκατάστασης και αποθεραπείας, προσεγγίζοντας' +
                                        ' ολιστικά τους ασθενείς με οξείες ή χρόνιες παθήσεις.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Ως κύριο στόχο μας θέσαμε την ανάπτυξη μίας σύγχρονης αντίληψης για την Αποκατάσταση που' +
                                        ' θα συνεισφέρει στην προαγωγή της καλής υγείας και στον σεβασμό των ανθρώπων που πάσχουν' +
                                        ' και συγχρόνως, πασχίζουν να γίνουν καλά.');
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 2nd Page ***
                                 ****************/

                                doc.font('mArial', 15)
                                    .text('Όραμά μας είναι η Καλύτερη Υγεία για Όλους.', 30);
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Θέλουμε να ξεπερνούμε τις στατιστικές και τα προγνωστικά, εμπνέοντας δύναμη και ελπίδα. Να\n' +
                                        'θέτουμε ρεαλιστικούς στόχους προόδου και να τους υπερβαίνουμε. Να είμαστε για τους ασθενείς\n' +
                                        'μας, τις οικογένειές τους και την ιατρική κοινότητα σημείο αναφοράς στη Φυσική Ιατρική και\n' +
                                        'Αποκατάσταση στην Ελλάδα και στη Νοτιοανατολική Ευρώπη.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Η ειδική Ιατρική Ομάδα Αποκατάστασης σχεδιάζει και κάνει πράξη την αποθεραπεία των ασθενών\n' +
                                        'μας. Τα μέλη της συνεδριάζουν εβδομαδιαία και συνεργάζονται στενά γιa την πρόοδο κάθε\n' +
                                        'ασθενούς.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Ο Φυσίατρος είναι ο επικεφαλής ειδικός Επαγγελματίας Υγείας της Ομάδας Αποκατάστασης, ο οποίος\n' +
                                        'προσεγγίζει ολιστικά τους ασθενείς, εκτιμά την κατάστασή τους, θέτει μαζί τους στόχους και\n' +
                                        'επιβλέπει την εξέλιξη της αποθεραπείας τους, συντονίζοντας την ειδική Ιατρική Ομάδα\n' +
                                        'Αποκατάστασης που αποτελείται από Ιατρό Φυσικής Αποκατάστασης σε κάθε πτέρυγα νοσηλείας,\n' +
                                        'Παθολόγο σε κάθε πτέρυγα νοσηλείας, Καρδιολόγο, Ορθοπεδικό, Εντατικολόγο, Νευρολόγο και\n' +
                                        'συνεργαζόμενους εξωτερικούς επαγγελματίες υγείας όλων των ειδικοτήτων ανάλογα με την ανάγκη που θα\n' +
                                        'προκύψει για κάθε ασθενή.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Στο κέντρο Euromedica-Αρωγή Θεσσαλονίκης κάθε πρόγραμμα Φυσικής Ιατρικής και\n' +
                                        'Αποκατάστασης που εφαρμόζεται σχεδιάζεται με επίκεντρο τον ασθενή και τις ανάγκες του και\n' +
                                        'μπορεί να συνδυάσει ένα εύρος υπηρεσιών από τα διαφορετικά Τμήματα του Κέντρου:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Τομέας Φυσιοθεραπείας\n' +
                                        '- Τομέας Υδροθεραπείας\n' +
                                        '- Τομέας Εργοθεραπείας\n' +
                                        '- Τομέας Λογοθεραπείας\n' +
                                        '- Τομέας Ψυχολογικής Υποστήριξης\n' +
                                        '- Τομέας Διατροφής');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Το κέντρο Euromedica-Αρωγή Θεσσαλονίκης βρίσκεται σε απόσταση 10’ από το εμπορικό κέντρο\n' +
                                        'της πόλης σε έναν κτίριο ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('15.947 ', {continued: true})
                                    .font('mArial', 11)
                                    .text('τ.μ. που διαθέτει:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- 200 κλίνες\n' +
                                        '- 4.500 τ.μ. χώρους θεραπειών\n' +
                                        '- 1.200 κλειστούς χώρους αθλητικών δραστηριοτήτων ΑΜΕΑ\n' +
                                        '- 3 πισίνες και 1 υδατοδιάδρομος\n' +
                                        '- 170 θέσεις στάθμευσης\n');
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                //doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 3rd Page ***
                                 ****************/

                                doc.font('mArial', 11)
                                    .text('Το ημερήσιο ιδιωτικό κόστος ασθενούς στο Τμήμα Κλειστής Νοσηλείας του Κέντρου μας\n' +
                                        'καθορίζεται ανάλογα με την επιλογή του τύπου του δωματίου και διαμορφώνεται ως εξής:\n', 30);
                                doc.moveDown(1);

                                // Draw a table
                                doc.lineCap('butt')
                                    .moveTo(210, 100)
                                    .lineTo(210, 220)
                                    .stroke();

                                doc.lineCap('butt')
                                    .moveTo(350, 100)
                                    .lineTo(350, 220)
                                    .stroke();

                                var coordinates = {
                                    rowHeight: 100,
                                    leftHeight: 105,
                                    rightHeight: 105
                                };

                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'ΤΥΠΟΣ ΔΩΜΑΤΙΟΥ', coordinates.leftHeight, 60);
                                textInRowSecond(doc, 'ΧΡΕΩΣΗ / ΗΜΕΡΑ', coordinates.rightHeight, 230);
                                textInRowSecond(doc, 'ΔΙΑΜΟΝΗ ΣΥΝΟΔΟΥ', coordinates.rightHeight, 380);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, '3κλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€190', coordinates.rightHeight, 260);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, '2κλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€230', coordinates.rightHeight, 260);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, '1κλινο δωμάτιο', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€270', coordinates.rightHeight, 260);
                                textInRowSecondForNumbers(doc, '€25', coordinates.rightHeight, 420);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, '1κλινο δωμάτιο Λουξ', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€340', coordinates.rightHeight, 260);
                                textInRowSecondForNumbers(doc, '€25', coordinates.rightHeight, 420);
                                coordinates = addToCoordinates(coordinates, 20);
                                row(doc, coordinates.rowHeight);
                                textInRowFirst(doc, 'ΧΑΦ', coordinates.leftHeight, 30);
                                textInRowSecondForNumbers(doc, '€370', coordinates.rightHeight, 260);

                                doc.font('mArial', 11)
                                    .text('Στις παραπάνω τιμές συμπεριλαμβάνεται ο Φ.Π.Α. ', 30, 240, {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('(24%)', {continued: true})
                                    .font('mArial', 11)
                                    .text('. Η εξόφληση των νοσηλίων\nπραγματοποιείται κάθε 10 ημέρες νοσηλείας.');
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Στο αναγραφόμενο κόστος συμπεριλαμβάνονται:');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Η διαμονή\n' +
                                        '- Πλήρης διατροφή με 3 γεύματα την ημέρα\n' +
                                        '- 24ωρη νοσηλευτική φροντίδα\n' +
                                        '- Η φαρμακευτική αγωγή που συνταγογραφείται\n' +
                                        '- Υγειονομικό υλικό όπως πάνες, γάζες, σύριγγες κ.τ.λ.\n' +
                                        '- Οι διαγνωστικές εξετάσεις ρουτίνας καθ’ όλη τη διάρκεια νοσηλείας\n' +
                                        '- Συμμετοχή σε καθημερινό πρόγραμμα φυσιοθεραπευτικής αποκατάστασης Δευτέρα έως\n' +
                                        '  και Σάββατο, με 4-5 συνεδρίες την ημέρα το οποίο μπορεί να περιλαμβάνει:');
                                doc.moveDown(1);
                                // inside list
                                doc.font('mArial', 11)
                                    .text('- Φυσιοθεραπεία: Τεχνικές: ', 70, 447, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('BOBATH – PNF - MANUAL – MULLIGAN', 70, 449);

                                doc.font('mArial', 11)
                                    .text('- Εργοθεραπεία: Ρομποτικό ', 70, 461, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('ARMEO (', 70, 463, {continued: true})
                                    .font('mArial', 11)
                                    .text('κινητοποίηση άνω άκρου', 70, 461, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text(')', 70, 463, {continued: true})
                                    .font('mArial', 11)
                                    .text(' – Αισθητηριακή Ολοκλήρωση', 70, 461);

                                doc.font('Times-Roman', 11)
                                    .text('- LOKOMAT: ', 70, 476, {continued: true})
                                    .font('mArial', 11)
                                    .text('Ρομποτικό κινητοποίησης κάτω άκρων', 70, 474);

                                doc.font('Times-Roman', 11)
                                    .text('- REHACOM: ', 70, 489, {continued: true})
                                    .font('mArial', 11)
                                    .text('Αξιολόγηση και θεραπεία γνωσιακών ελλειμμάτων', 70, 487);

                                doc.font('Times-Roman', 11)
                                    .text('- BALANCE: ', 70, 501, {continued: true})
                                    .font('mArial', 11)
                                    .text('Εκπαίδευση ιδιοδεκτικότητας και συντονισμού στην όρθια θέση', 70, 499);

                                doc.font('mArial', 11)
                                    .text('- Άσκηση σε εικονικό περιβάλλον ', 70, 511, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('(Wii):', 70, 514, {continued: true})
                                    .font('mArial', 11)
                                    .text(' Επανεκπαίδευση χρονισμού των κινητικών αλυσίδων', 70, 511);

                                doc.font('mArial', 11)
                                    .text('- Λογοθεραπεία: Εκπαίδευση κατάποσης και διαχείριση τραχειοστομίας', 70, 523);

                                doc.font('mArial', 11)
                                    .text('- Υδροθεραπεία: Τεχνικές: ', 70, 535, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('HALLIWICK – BAD RAGAZ RING METHOD', 70, 537);

                                doc.font('mArial', 11)
                                    .text('- Χρήση εξειδικευμένων μηχανημάτων: ', 70, 547, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('TILT, CPM, ROLLATOR', 70, 549);

                                doc.font('mArial', 11)
                                    .text('- Πλήρως εξοπλισμένο γυμναστήριο', 70, 559);

                                doc.font('mArial', 11)
                                    .text('- Θεραπευτική άσκηση : ', 70, 571, {continued: true})
                                    .font('Times-Roman', 11)
                                    .text('YOGA, PILATES', 70, 573);

                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Ο αριθμός και το είδος των θεραπειών καθορίζεται σύμφωνα με τις ανάγκες του ατόμου και\n' +
                                        'κατόπιν αξιολόγησης της Ομάδας Αποκατάστασης.', 36);
                                doc.font('mArial', 11)
                                    .text('- Καθημερινή ιατρική παρακολούθηση από Ιατρό Φυσικής Αποκατάστασης και Παθολόγο\n' +
                                        'και στην αξιολόγηση που απαιτείται από Νευρολόγο, Καρδιολόγο και Ορθοπεδικό\n' +
                                        '- Διατροφολογική και ψυχολογική υποστήριξη', 30);

                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 4th Page ***
                                 ****************/
                                doc.font('mArial', 11)
                                    .text('Δεν συμπεριλαμβάνονται στα ημερήσια νοσήλια:', 30);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('- Εξειδικευμένες διαγνωστικές εξετάσεις που τυχόν απαιτηθούν κατά τη διάρκεια της\n' +
                                        ' όπως νοσηλείας καλλιέργειες, αντιβιογράμματα, ακτινογραφίες κ.τ.λ.\n' +
                                        '- Η φαρμακευτική αγωγή που δεν συνταγογραφείται\n' +
                                        '- Νοσηλεία στο Χώρο Αυξημένης Φροντίδας\n' +
                                        '- Μεταφορά με ασθενοφόρο\n' +
                                        '- Οι επισκέψεις εξωτερικών συνεργαζόμενων επαγγελματιών υγείας\n' +
                                        '- Γεύματα συνοδών όπως ημερήσια χρέωση €15 για 3 γεύματα\n' +
                                        '- Αναλώσιμα υλικά όπως αλλαγή γαστροστομίας, τραχειοστομίας κ.τ.λ.\n' +
                                        '- Τυχόν βοηθήματα βάδισης\n' +
                                        '- Η χρήση αποκλειστικής νοσοκόμας');
                                doc.moveDown(1);

                                doc.font('mArial', 11)
                                    .text("", 30);
                                doc.font('mArial', 11)
                                    .text('Η διάρκεια παραμονής των ασθενών στο Κέντρο Euromedica Αρωγή κυμαίνεται από μερικές\n' +
                                        'ημέρες έως αρκετές εβδομάδες, ανάλογα με τις ατομικές ανάγκες και την πρόοδο που\n' +
                                        'παρουσιάζουν. Το Κέντρο Euromedica Αρωγή τηρεί για τον κάθε ασθενή τα χρονοδιαγράμματα\n' +
                                        'που έχουν καθοριστεί από τον Εθνικό Οργανισμό Παροχής Υπηρεσιών Υγείας ΕΟΠΥΥ. Σύμφωνα\n' +
                                        'με τα επίσημα στοιχεία του κέντρου, το 2017, η μέση διάρκεια παραμονής ήταν ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text('29,99 ', {continued: true})
                                    .font('mArial', 11)
                                    .text('ημέρες,\n' +
                                        'δηλαδή αρκετά κάτω από τις κατευθυντήριες γραμμές του ΕΟΠΥΥ, χαμηλότερα και από τις 31,01\n' +
                                        'ημέρες του έτους 2016.');
                                doc.moveDown(1);
                                doc.image(statsImage, {
                                    fit: [450, 750],
                                    align: 'left'
                                });
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                /****************
                                 *** 5th Page ***
                                 ****************/
                                doc.font('mArial', 11)
                                    .text('Το πρόγραμμα αποκατάστασης που θα ακολουθηθεί και ο τύπος και ο αριθμός των θεραπειών\n' +
                                        'καθορίζεται σύμφωνα με τις ανάγκες του εκάστοτε ασθενούς και κατόπιν αξιολόγησης της Ομάδας\n' +
                                        'Αποκατάστασης κατά την εισαγωγή του ασθενούς. Το ατομικό πρόγραμμα αποκατάστασης\n' +
                                        'κοινοποιείται εγγράφως στον ασθενή και στους συνοδούς σε εβδομαδιαία βάση.', 30);
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Είμαι στη διάθεσή σας για οποιαδήποτε διευκρίνιση ή απορία προκύπτει από την ως άνω\n' +
                                        'πληροφόρηση στην ηλεκτρονική διεύθυνση ', {continued: true})
                                    .font('Times-Roman', 13)
                                    .text("s.bakatselou@euromedica.gr ", {continued: true})
                                    .font('mArial', 11)
                                    .text("ή στα τηλέφωνα ", {continued: true})
                                    .font("Times-Roman", 13)
                                    .text("\n2310 986150.");
                                doc.moveDown(2);
                                doc.font('mArial', 11)
                                    .text('Με εκτίμηση,');
                                doc.moveDown(1);
                                doc.font('mArial', 11)
                                    .text('Σταυριάνα Μπακατσέλου\n' +
                                        'Διευθύντρια Υποδοχής και Κίνησης Ασθενών');
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('ΔΔ/36.2/01.03.2017', 30, 700);
                                doc.moveDown(1);
                                doc.font('mArial', 8)
                                    .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                                doc.font('mArial', 8)
                                    .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                    .font('Times-Roman', 8)
                                    .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                                doc.end();
                                stream.on('finish', function() {
                                    var file = stream.toBlobURL('application/pdf');
                                    window.open(file);
                                });
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        function makePrivateOfferWithImages(object){
            var doc = new PDFDocument({
                margin: 45
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;
            var page1Image = null;
            var page2Image = null;
            var page3Image = null;
            var page4Image = null;
            var page5Image = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            toDataURL('content/images/private_page1.jpg', function (dataUrl) {
                                page1Image = dataUrl;
                                toDataURL('content/images/private_page2.jpg', function (dataUrl) {
                                    page2Image = dataUrl;
                                    toDataURL('content/images/private_page3.jpg', function (dataUrl) {
                                        page3Image = dataUrl;
                                        toDataURL('content/images/private_page4.jpg', function (dataUrl) {
                                            page4Image = dataUrl;
                                            toDataURL('content/images/private_page5.jpg', function (dataUrl) {
                                                page5Image = dataUrl;
                                                /****************
                                                 *** 1st Page ***
                                                 ****************/
                                                doc.image(logoImage, {
                                                    fit: [160, 210],
                                                    align: 'left'
                                                });
                                                doc.image(certImage, 450, 40, {
                                                    fit: [80, 80],
                                                    align: 'right'
                                                });

                                                doc.font('mArial', 11)
                                                    .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                                                //doc.moveDown(2);
                                                doc.font('mArial', 11)
                                                    .text(object.pdfPronouncement, 55, 170);
                                                doc.moveDown(1);
                                                doc.image(page1Image, {
                                                    fit: [550, 600],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 2nd Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page2Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 3rd Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page3Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 4th Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page4Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });
                                                /****************
                                                 *** 5th Page ***
                                                 ****************/
                                                doc.addPage();
                                                doc.image(page5Image, {
                                                    fit: [800, 730],
                                                    align: 'left'
                                                });


                                                doc.end();
                                                stream.on('finish', function() {
                                                    var file = stream.toBlobURL('application/pdf');
                                                    window.open(file);
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        /**
         * Builds a pdf document depending on values of object and
         * displays it in new browser tab. Original doc: relief_treatment.pdf.
         * @param object The offer object. Object's structure should be:
         * object {
         *   date: Date
         *   fullName: String,
         *   pdfPronouncement: String,
         *   attendantMealPrice: Double
         *   transportation: Transportation object
         *   roomCost: RoomCost object
         *   finalDiscount: DiscountRate object
         * }
         */
        function makeReliefTherapyOffer(object) {
            var doc = new PDFDocument({
                margin: 50
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/NotoSans-Regular.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            // Got all images, build the document
                            /****************
                             *** 1st Page ***
                             ****************/
                            doc.image(logoImage, {
                                fit: [160, 210],
                                align: 'left'
                            });
                            doc.image(certImage, 450, 40, {
                                fit: [80, 80],
                                align: 'right'
                            });

                            doc.font('mArial', 11)
                                .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                            //doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Αξιότιμη / Αξιότιμε κ. ' + object.fullName, 30, 170);
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Αρχικά θα θέλαμε να σας ευχαριστήσουμε για την εμπιστοσύνη σας στις υπηρεσίες του κέντρου' +
                                    ' Αποκατάστασης και Αποθεραπείας Euromedica – Αρωγή Θεσσαλονίκης.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Στη συνέχεια ακολουθεί μια σύντομη παρουσίαση του Κέντρου και περιγραφή των παροχών αυτού,' +
                                    ' προς τους νοσηλευόμενους ασθενείς.');
                            doc.moveDown(2);
                            doc.font('mArial', 15)
                                .text('Πρότυπο Κέντρο στην Αποκατάσταση και Αποθεραπεία.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Η Euromedica-Αρωγή Θεσσαλονίκης, το πρώτο και μοναδικό Κέντρο Αποκατάστασης στην' +
                                    ' περιοχή της Νοτιοανατολικής Ευρώπης, ανήκει στην επίλεκτη παγκόσμια ομάδα των 543 Κέντρων' +
                                    ' Αποκατάστασης, εκ των οποίων τα 517 στις Ηνωμένες Πολιτείες Αμερικής, τα οποία έχουν λάβει τη' +
                                    ' Διεθνή Διαπίστευση CARF, στην κατηγορία:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('«Inpatient Rehabilitation Programmes – Hospital»', {align: 'center'});
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Η διαπίστευση αυτή, αποτελεί το υψηλότερο επίπεδο παγκόσμιας πιστοποίησης που απονέμεται σε' +
                                    ' ένα Κέντρο Αποκατάστασης και καταδεικνύει την υψηλή ποιότητα παρεχόμενων προγραμμάτων' +
                                    ' αποκατάστασης.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Στο Κέντρο Αποκατάστασης και Αποθεραπείας Euromedica–Αρωγή Θεσσαλονίκης προσφέρουμε' +
                                    ' από το 2010 εξατομικευμένα προγράμματα αποκατάστασης και αποθεραπείας, προσεγγίζοντας' +
                                    ' ολιστικά τους ασθενείς με οξείες ή χρόνιες παθήσεις.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Ως κύριο στόχο μας θέσαμε την ανάπτυξη μίας σύγχρονης αντίληψης για την Αποκατάσταση που' +
                                    ' θα συνεισφέρει στην προαγωγή της καλής υγείας και στον σεβασμό των ανθρώπων που πάσχουν' +
                                    ' και συγχρόνως, πασχίζουν να γίνουν καλά.');
                            doc.font('mArial', 8)
                                .text('ΔΔ/36.2/01.03.2017', 30, 700);
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                            doc.font('mArial', 8)
                                .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                .font('Times-Roman', 8)
                                .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                            /****************
                             *** 2nd Page ***
                             ****************/

                            doc.font('mArial', 15)
                                .text('Ανακουφιστική Φροντίδα στη Euromedica-Αρωγή', 30);
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Σύμφωνα με τον Παγκόσμιο Οργανισμό Υγείας η Ανακουφιστική Φροντίδα είναι η προσέγγιση' +
                                    ' που επιδιώκει τη βελτίωση της ποιότητας ζωής τόσο των ασθενών που πάσχουν από νοσήματα' +
                                    ' απειλητικά για τη ζωή τους, όσο και των οικογενειών τους, μέσω της πρόληψης και της' +
                                    ' ανακούφισης από το «υποφέρειν». Επιτυγχάνεται με την αντιμετώπιση των συμπτωμάτων που' +
                                    ' επιφέρει η ασθένεια ή η θεραπεία αυτής. Συχνά είναι δυνατόν να βελτιωθεί η ποιότητα ζωής των' +
                                    ' ασθενών, ανεξάρτητα από την πρόγνωση της ασθένειας τους, βοηθώντας τους να επιτύχουν' +
                                    ' τη μέγιστη λειτουργική τους ικανότητα και την αυτοτέλεια ή να αποκτήσουν την ανακούφιση από τα' +
                                    ' συμπτώματα δυσφορίας.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Απευθύνεται σε ασθενείς τελικού σταδίου και σε ανθρώπους που πάσχουν από σοβαρά και' +
                                    ' προοδευτικά επιδεινούμενα νοσήματα ή καταστάσεις, καθώς και από καταστροφικές βλάβες,' +
                                    ' κάποιες από τις οποίες  είναι δυνατόν να αποβούν απειλητικές για τη ζωή, όπως:');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('- Νεοπλασματικά νοσήματα\n' +
                                    '- Βαριά καρδιακή ανεπάρκεια\n' +
                                    '- Χρόνια αναπνευστική ανεπάρκεια\n');
                            doc.font('Times-Roman', 11)
                                .text('- HIV-AIDS\n');
                            doc.font('mArial', 11)
                                .text('- Νευρολογικά και νευρομυϊκά νοσήματα. Παραπληγία, Τετραπληγία, Σκλήρυνση κατά Πλάκας, Μυασθένεια\n' +
                                    '- Ρευματικές και αυτοάνοσες παθήσεις κ.α.\n' +
                                    '- Χρόνια νεφρική ανεπάρκεια');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Η Ανακουφιστική Φροντίδα Euromedica-Αρωγή αποτελεί έργο μιας διεπιστημονικής ομάδας' +
                                    ' διάφορων ειδικοτήτων. Εκτός από τον επικεφαλής Ιατρό παθολόγο, φυσίατρο, αναισθησιολόγο και' +
                                    ' νευρολόγο, η ομάδα αποτελείται από  κλινικό ψυχολόγο, κλινικό φαρμακοποιό, νοσηλευτές με' +
                                    ' προϋπηρεσία σε Χώρο Αυξημένης Φροντίδας, εξειδικευμένους φυσιοθεραπευτές, κοινωνικούς' +
                                    ' λειτουργούς, διατροφολόγους και θρησκευτικό αντιπρόσωπο.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Η διεπιστημονική ομάδα της Euromedica-Αρωγή συνεργάζεται με τους θεράποντες επαγγελματίες υγείας και την' +
                                    ' οικογένεια συντονίζοντας τις  προσπάθειες για παροχή φροντίδας, ώστε να κινητοποιήσει και να' +
                                    ' ανακουφίσει τον ασθενή από τα συμπτώματα της νόσου, πετυχαίνωντας καλύτερη ποιότητα ζωής.');
                            doc.font('mArial', 8)
                                .text('ΔΔ/36.2/01.03.2017', 30, 700);
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                            doc.font('mArial', 8)
                                .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                .font('Times-Roman', 8)
                                .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                            /****************
                             *** 3rd Page ***
                             ****************/

                            doc.font('mArial', 11)
                                .text('Η υπηρεσία της Ανακουφιστικής Φροντίδας Euromedica – Αρωγή απευθύνεται σε ιδιώτες ασθενείς,' +
                                    ' στην Κλειστή Νοσηλεία, χωρίς χρήση ασφαλιστικού ταμείου. Το Ημερήσιο Κόστος διαμορφώνεται' +
                                    ' ως εξής:', 30);
                            doc.moveDown(1);

                            // Draw a table
                            doc.lineCap('butt')
                                .moveTo(270, 100)
                                .lineTo(270, 200)
                                .stroke();

                            var coordinates = {
                                rowHeight: 100,
                                leftHeight: 105,
                                rightHeight: 105
                            };

                            row(doc, coordinates.rowHeight);
                            textInRowFirst(doc, 'ΤΥΠΟΣ ΔΩΜΑΤΙΟΥ', coordinates.leftHeight, 90);
                            textInRowSecond(doc, 'ΧΡΕΩΣΗ / ΗΜΕΡΑ', coordinates.rightHeight, 350);
                            coordinates = addToCoordinates(coordinates, 20);
                            row(doc, coordinates.rowHeight);
                            textInRowFirst(doc, 'Νοσηλεία σε 2κλινο δωμάτιο', coordinates.leftHeight, 30);
                            textInRowSecondForNumbers(doc, '€160', coordinates.rightHeight, 390);
                            coordinates = addToCoordinates(coordinates, 20);
                            row(doc, coordinates.rowHeight);
                            textInRowFirst(doc, 'Νοσηλεία σε 1κλινο δωμάτιο', coordinates.leftHeight, 30);
                            textInRowSecondForNumbers(doc, '€220', coordinates.rightHeight, 390);
                            coordinates = addToCoordinates(coordinates, 20);
                            row(doc, coordinates.rowHeight);
                            textInRowFirst(doc, 'Νοσηλεία σε μονόκλινο δωμάτιο με συνοδό', coordinates.leftHeight, 30);
                            textInRowSecondForNumbers(doc, '€245', coordinates.rightHeight, 390);
                            coordinates = addToCoordinates(coordinates, 20);
                            row(doc, coordinates.rowHeight);
                            textInRowFirst(doc, 'Νοσηλεία στη μονάδα Αυξημένης Φροντίδας', coordinates.leftHeight, 30);
                            textInRowSecondForNumbers(doc, '€370', coordinates.rightHeight, 390);

                            doc.font('mArial', 11)
                                .text('Στις παραπάνω τιμές συμπεριλαμβάνεται ο Φ.Π.Α. ', 30, 250, {continued: true})
                                .font('Times-Roman', 13)
                                .text('(24%)', {continued: true})
                                .font('mArial', 11)
                                .text('. Η εξόφληση των νοσηλίων\nπραγματοποιείται κάθε 10 ημέρες νοσηλείας.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Στο παραπάνω κόστος συμπεριλαμβάνονται:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- Η διαμονή σε κλίνη επιλογής του ασθενούς\n' +
                                    '- Πλήρης διατροφή με 3 γεύματα την ημέρα\n' +
                                    '- 24ωρη νοσηλευτική φροντίδα\n' +
                                    '- Το Υγειονομικό υλικό όπως πάνες, γάζες, σύριγγες κ.τ.λ.\n' +
                                    '- Οι διαγνωστικές εξετάσεις ρουτίνας καθ’ όλη τη διάρκεια νοσηλείας\n' +
                                    '- Συμμετοχή σε καθημερινό πρόγραμμα φυσιοθεραπευτικής αποκατάστασης Δευτέρα έως\n' +
                                    '  και Σάββατο, με 4-5 συνεδρίες την ημέρα. Το πρόγραμμα καθορίζεταθ σύμφωνα με τις ανάγκες\n' +
                                    '  του ασθενή και κατόπιν αξιολόγησης της Ομάδας Αποκατάστασης\n' +
                                    '- Καθημερινή ιατρική παρακολούθηση από Ιατρό Φυσικής Αποκατάστασης και Παθολόγο\n' +
                                    '  και στην αξιολόγηση που απαιτείται από νευρολογικό και ορθοπεδικό\n' +
                                    '- Διατροφολογική και ψυχολογική υποστήριξη');

                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Δεν συμπεριλαμβάνονται στα ημερήσια νοσήλια:', 30);
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- Η φαρμακευτική αγωγή\n' +
                                    '- Εξειδικευμένες εργαστηριακές και απεικονιστικές εξετάσεις που τυχόν απαιτηθούν κατά τη\n' +
                                    '- διάρκεια της νοσηλείας όπως καλλιέργεις, αντιβιογράμματα, αξονικές, μαγνητικές.\n' +
                                    '- Οι επισκέψεις εξωτερικών επαγγελματιών υγείας άλλων ειδικοτήτων που δεν καλύπτονται από το Κέντρο.\n' +
                                    '- Γεύματα συνοδφών. Ημερήσια χρέωση €15 για 3 γεύματα.\n' +
                                    '- Αναλώσιμα υλικά όπως αλλαγή γαστρονομίας, τραχειοστομίας κ.τ.λ.\n');
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('ΔΔ/36.2/01.03.2017', 30, 700);
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                            doc.font('mArial', 8)
                                .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                .font('Times-Roman', 8)
                                .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                            /****************
                             *** 4th Page ***
                             ****************/

                            doc.addPage();
                            doc.font('mArial', 11)
                                .text('Είμαι στη διάθεσή σας για οποιαδήποτε διευκρίνιση ή απορία προκύπτει από την ως άνω\n' +
                                    'πληροφόρηση στην ηλεκτρονική διεύθυνση ', 30, 40, {continued: true})
                                .font('Times-Roman', 13)
                                .text("s.bakatselou@euromedica.gr ", {continued: true})
                                .font('mArial', 11)
                                .text("ή στα τηλέφωνα ", {continued: true})
                                .font("Times-Roman", 13)
                                .text("\n2310 986150.");
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Με εκτίμηση,');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Σταυριάνα Μπακατσέλου\n' +
                                    'Διευθύντρια Υποδοχής και Κίνησης Ασθενών');
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('ΔΔ/36.2/01.03.2017', 30, 700);
                            doc.moveDown(1);
                            doc.font('mArial', 8)
                                .text('EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε., Κέντρο Ιατρικής Αποθεραπείας και Αποκατάστασης', {align: 'center'});
                            doc.font('mArial', 8)
                                .text('Τέρμα 17ης Νοέμβρη, Πυλαία 54301 Θεσσαλονίκη', 100, 730, {continued: true})
                                .font('Times-Roman', 8)
                                .text('T. 2310986000 F. 2310986080 www.euromedica-arogi.gr', 104, 732);

                            doc.end();
                            stream.on('finish', function() {
                                var file = stream.toBlobURL('application/pdf');
                                window.open(file);
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        function makeReliefTherapyOfferWithImages(object){
            var doc = new PDFDocument({
                margin: 45
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'EUROMEDICA-ΑΡΩΓΗ ΘΕΣΣΑΛΟΝΙΚΗΣ Α.Ε.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var certImage = null;
            var page1Image = null;
            var page2Image = null;
            var page3Image = null;
            var page4Image = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/arogi_logo.jpg', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_cert.jpg', function (dataUrl) {
                            certImage = dataUrl;
                            toDataURL('content/images/reliefTreatment_page1.jpg', function (dataUrl) {
                                page1Image = dataUrl;
                                toDataURL('content/images/reliefTreatment_page2.jpg', function (dataUrl) {
                                    page2Image = dataUrl;
                                    toDataURL('content/images/reliefTreatment_page3.jpg', function (dataUrl) {
                                        page3Image = dataUrl;
                                        toDataURL('content/images/reliefTreatment_page4.jpg', function (dataUrl) {
                                            page4Image = dataUrl;
                                            /****************
                                             *** 1st Page ***
                                             ****************/
                                            doc.image(logoImage, {
                                                fit: [160, 210],
                                                align: 'left'
                                            });
                                            doc.image(certImage, 450, 40, {
                                                fit: [80, 80],
                                                align: 'right'
                                            });

                                            doc.font('mArial', 11)
                                                .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                                            //doc.moveDown(2);
                                            doc.font('mArial', 11)
                                                .text(object.pdfPronouncement, 55, 170);
                                            doc.moveDown(1);
                                            doc.image(page1Image, {
                                                fit: [550, 600],
                                                align: 'left'
                                            });
                                            /****************
                                             *** 2nd Page ***
                                             ****************/
                                            doc.addPage();
                                            doc.image(page2Image, {
                                                fit: [800, 730],
                                                align: 'left'
                                            });
                                            /****************
                                             *** 3rd Page ***
                                             ****************/
                                            doc.addPage();
                                            doc.image(page3Image, {
                                                fit: [800, 730],
                                                align: 'left'
                                            });
                                            /****************
                                             *** 4th Page ***
                                             ****************/
                                            doc.addPage();
                                            doc.image(page4Image, {
                                                fit: [800, 730],
                                                align: 'left'
                                            });


                                            doc.end();
                                            stream.on('finish', function() {
                                                var file = stream.toBlobURL('application/pdf');
                                                window.open(file);
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        /**
         * Builds a pdf document depending on values of object and
         * displays it in new browser tab. Used ONLY for demonstration.
         * @param object The offer object. Object's structure should be:
         * object {
         *   date: Date
         *   fullName: String
         *   attendantMealPrice: Double
         *   transportation: Transportation object
         *   roomCost: RoomCost object
         *   finalDiscount: DiscountRate object
         * }
         */
        function makeDemoOffer(object){
            var doc = new PDFDocument({
                margin: 50
            });
            doc.info['Title'] = 'Προσφορά ' + object.fullName;
            doc.info['Author'] = 'SigmaSoft S.A.';
            var stream = doc.pipe(blobStream());
            var logoImage = null;
            var statsImage = null;

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    toDataURL('content/images/SigmaSoft_logo-top.png', function (dataUrl) {
                        logoImage = dataUrl;
                        toDataURL('content/images/arogi_stats.jpg', function (dataUrl) {
                            statsImage = dataUrl;
                            // Got all images, build the document
                            /****************
                             *** 1st Page ***
                             ****************/
                            doc.image(logoImage, {
                                fit: [120, 170],
                                align: 'left'
                            });

                            doc.font('mArial', 11)
                                .text('Θεσσαλονίκη, ' + moment(object.date).format('DD/MM/YYYY'), 400, 140);
                            doc.font('mArial', 11)
                                .text('Αξιότιμη / Αξιότιμε κ. ' + object.fullName, 30, 170);
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Αρχικά θα θέλαμε να σας ευχαριστήσουμε για την εμπιστοσύνη σας στις υπηρεσίες του κέντρου' +
                                    ' Αποκατάστασης και Αποθεραπείας SigmaSoft Θεσσαλονίκης.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Στη συνέχεια ακολουθεί μια σύντομη παρουσίαση του Κέντρου και περιγραφή των παροχών αυτού,' +
                                    ' προς τους νοσηλευόμενους ασθενείς.');
                            doc.moveDown(4);
                            doc.font('mArial', 15)
                                .text('Πρότυπο Κέντρο στην Αποκατάσταση και Αποθεραπεία.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Η SigmaSoft Θεσσαλονίκης, το πρώτο και μοναδικό Κέντρο Αποκατάστασης στην' +
                                    ' περιοχή της Νοτιοανατολικής Ευρώπης, ανήκει στην επίλεκτη παγκόσμια ομάδα των 543 Κέντρων' +
                                    ' Αποκατάστασης, εκ των οποίων τα 517 στις Ηνωμένες Πολιτείες Αμερικής, τα οποία έχουν λάβει τη' +
                                    ' Διεθνή Διαπίστευση CARF, στην κατηγορία:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('«Inpatient Rehabilitation Programmes – Hospital»', {align: 'center'});
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Η διαπίστευση αυτή, αποτελεί το υψηλότερο επίπεδο παγκόσμιας πιστοποίησης που απονέμεται σε' +
                                    ' ένα Κέντρο Αποκατάστασης και καταδεικνύει την υψηλή ποιότητα παρεχόμενων προγραμμάτων' +
                                    ' αποκατάστασης.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Στο Κέντρο Αποκατάστασης και Αποθεραπείας SigmaSoft Θεσσαλονίκης προσφέρουμε' +
                                    ' από το 2010 εξατομικευμένα προγράμματα αποκατάστασης και αποθεραπείας, προσεγγίζοντας' +
                                    ' ολιστικά τους ασθενείς με οξείες ή χρόνιες παθήσεις.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Ως κύριο στόχο μας θέσαμε την ανάπτυξη μίας σύγχρονης αντίληψης για την Αποκατάσταση που' +
                                    ' θα συνεισφέρει στην προαγωγή της καλής υγείας και στον σεβασμό των ανθρώπων που πάσχουν' +
                                    ' και συγχρόνως, πασχίζουν να γίνουν καλά.');

                            /****************
                             *** 2nd Page ***
                             ****************/
                            doc.addPage();
                            doc.font('mArial', 15)
                                .text('Όραμά μας είναι η Καλύτερη Υγεία για Όλους.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Θέλουμε να ξεπερνούμε τις στατιστικές και τα προγνωστικά, εμπνέοντας δύναμη και ελπίδα. Να\n' +
                                    'θέτουμε ρεαλιστικούς στόχους προόδου και να τους υπερβαίνουμε. Να είμαστε για τους ασθενείς\n' +
                                    'μας, τις οικογένειές τους και την ιατρική κοινότητα σημείο αναφοράς στη Φυσική Ιατρική και\n' +
                                    'Αποκατάσταση στην Ελλάδα και στη Νοτιοανατολική Ευρώπη.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Η ειδική Ιατρική Ομάδα Αποκατάστασης σχεδιάζει και κάνει πράξη την αποθεραπεία των ασθενών\n' +
                                    'μας. Τα μέλη της συνεδριάζουν εβδομαδιαία και συνεργάζονται στενά γιa την πρόοδο κάθε\n' +
                                    'ασθενούς.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Ο Φυσίατρος είναι ο επικεφαλής ειδικός Επαγγελματίας Υγείας της Ομάδας Αποκατάστασης, ο οποίος\n' +
                                    'προσεγγίζει ολιστικά τους ασθενείς, εκτιμά την κατάστασή τους, θέτει μαζί τους στόχους και\n' +
                                    'επιβλέπει την εξέλιξη της αποθεραπείας τους, συντονίζοντας την ειδική Ιατρική Ομάδα\n' +
                                    'Αποκατάστασης που αποτελείται από Ιατρό Φυσικής Αποκατάστασης σε κάθε πτέρυγα νοσηλείας,\n' +
                                    'Παθολόγο σε κάθε πτέρυγα νοσηλείας, Καρδιολόγο, Ορθοπεδικό, Εντατικολόγο, Νευρολόγο και\n' +
                                    'συνεργαζόμενους εξωτερικούς επαγγελματίες υγείας όλων των ειδικοτήτων ανάλογα με την ανάγκη που θα\n' +
                                    'προκύψει για κάθε ασθενή.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Στο κέντρο SigmaSoft Θεσσαλονίκης κάθε πρόγραμμα Φυσικής Ιατρικής και\n' +
                                    'Αποκατάστασης που εφαρμόζεται σχεδιάζεται με επίκεντρο τον ασθενή και τις ανάγκες του και\n' +
                                    'μπορεί να συνδυάσει ένα εύρος υπηρεσιών από τα διαφορετικά Τμήματα του Κέντρου:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- Τομέας Φυσιοθεραπείας\n' +
                                    '- Τομέας Υδροθεραπείας\n' +
                                    '- Τομέας Εργοθεραπείας\n' +
                                    '- Τομέας Λογοθεραπείας\n' +
                                    '- Τομέας Ψυχολογικής Υποστήριξης\n' +
                                    '- Τομέας Διατροφής');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Το κέντρο SigmaSoft Θεσσαλονίκης βρίσκεται σε απόσταση 5’ από το εμπορικό κέντρο\n' +
                                    'της πόλης σε έναν κτίριο 15.947 τ.μ. που διαθέτει:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- 200 κλίνες\n' +
                                    '- 4.500 τ.μ. χώρους θεραπειών\n' +
                                    '- 1.200 κλειστούς χώρους αθλητικών δραστηριοτήτων ΑΜΕΑ\n' +
                                    '- 3 πισίνες και 1 υδατοδιάδρομος\n' +
                                    '- 170 θέσεις στάθμευσης\n');

                            /****************
                             *** 3rd Page ***
                             ****************/
                            doc.addPage();
                            doc.font('mArial', 11)
                                .text('Σε συνέχεια της επικοινωνίας μας , σας ενημερώνω ότι το κόστος της ημερήσιας συμμετοχής\n' +
                                    'σχετικά με την νοσηλεία ασθενούς στο Κέντρο μας καθορίζεται ανάλογα με την επιλογή του τύπου\n' +
                                    'του δωματίου και διαμορφώνεται ως εξής:');
                            doc.moveDown(3);

                            // Draw a table
                            /*doc.lineCap('butt')
                                .moveTo(270, 100)
                                .lineTo(270, 240)
                                .stroke();*/

                            var sum = 0;
                            var totalSum = 0; // includes discount

                            // Headers row
                            row(doc, 100);
                            textInRowFirst(doc, 'ΥΠΗΡΕΣΙΕΣ / ΔΩΜΑΤΙΟ', 105);
                            textInRowSecond(doc, 'ΧΡΕΩΣΗ / ΗΜΕΡΑ', 105);
                            if (object.attendantMealPrice){
                                sum += object.attendantMealPrice;
                                row(doc, 120);
                                textInRowFirst(doc, 'Γεύμα Συνοδού', 125);
                                textInRowSecond(doc, '€ ' + object.attendantMealPrice.toString(), 125);
                            }
                            if (object.transportation){
                                sum += object.transportation.cost;
                                row(doc, 140);
                                textInRowFirst(doc, 'Μεταφορά', 145);
                                textInRowSecond(doc, '€ ' + object.transportation.cost.toString(), 145);
                            }
                            if (object.roomCost){
                                sum += object.roomCost.cost;
                                row(doc, 160);
                                textInRowFirst(doc, 'Νοσηλεία σε ' + object.roomCost.roomType.name + ' δωμάτιο', 165);
                                textInRowSecond(doc, '€ ' + object.roomCost.cost.toString(), 165);
                            }
                            row(doc, 180);
                            textInRowFirst(doc, 'Σύνολο', 185);
                            textInRowSecond(doc, '€ ' + sum.toString(), 185);
                            if (object.finalDiscount){
                                totalSum = sum - ((object.finalDiscount.value / 100) * sum);
                                row(doc, 200);
                                textInRowFirst(doc, 'Σύνολο με Έκπτωση - ' + object.finalDiscount.name, 205);
                                textInRowSecond(doc, '€ ' + totalSum.toString(), 205);
                            }

                            doc.font('mArial', 11)
                                .text('Στις παραπάνω τιμές συμπεριλαμβάνεται ο Φ.Π.Α.(24%). Η εξόφληση των νοσηλίων\n' +
                                    'πραγματοποιείται κάθε 10 ημέρες νοσηλείας.', 30, 250);
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Στο αναγραφόμενο κόστος συμπεριλαμβάνονται:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- Η διαμονή\n' +
                                    '- Πλήρης διατροφή με 3 γεύματα την ημέρα\n' +
                                    '- 24ωρη νοσηλευτική φροντίδα\n' +
                                    '- Η φαρμακευτική αγωγή που συνταγογραφείται\n' +
                                    '- Υγειονομικό υλικό (πάνες, γάζες, σύριγγες κ.τ.λ.)\n' +
                                    '- Οι διαγνωστικές εξετάσεις ρουτίνας καθ’ όλη τη διάρκεια νοσηλείας\n' +
                                    '- Συμμετοχή σε καθημερινό πρόγραμμα φυσιοθεραπευτικής αποκατάστασης (Δευτέρα έως\n' +
                                    '  και Σάββατο), με 4-5 συνεδρίες την ημέρα. Το πρόγραμμα καθορίζεται σύμφωνα με τις\n' +
                                    '  ανάγκες του ατόμου και κατόπιν αξιολόγησης της Ομάδας Αποκατάστασης.\n' +
                                    '- Καθημερινή ιατρική παρακολούθηση από Ιατρό Φυσικής Αποκατάστασης και Παθολόγο\n' +
                                    '- και στην αξιολόγηση που απαιτείται από Νευρολόγο, Καρδιολόγο και Ορθοπεδικό\n' +
                                    '- Διατροφολογική και ψυχολογική υποστήριξη');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Δεν συμπεριλαμβάνονται στα ημερήσια νοσήλια:');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('- Εξειδικευμένες διαγνωστικές εξετάσεις που τυχόν απαιτηθούν κατά τη διάρκεια της\n' +
                                    '- νοσηλείας (καλλιέργειες, αντιβιογράμματα, ακτινογραφίες κ.τ.λ.)\n' +
                                    '- Η φαρμακευτική αγωγή που δεν συνταγογραφείται\n' +
                                    '- Νοσηλεία στο Χώρο Αυξημένης Φροντίδας\n' +
                                    '- Μεταφορά με ασθενοφόρο\n' +
                                    '- Οι επισκέψεις εξωτερικών συνεργαζόμενων επαγγελματιών υγείας\n' +
                                    '- Γεύματα συνοδών (ημερήσια χρέωση €15 για 3 γεύματα)\n' +
                                    '- Αναλώσιμα υλικά (αλλαγή γαστροστομίας, τραχειοστομίας κ.τ.λ.)\n' +
                                    '- Τυχόν βοηθήματα βάδισης\n' +
                                    '- Η χρήση αποκλειστικής νοσοκόμας');

                            /****************
                             *** 4th Page ***
                             ****************/
                            doc.addPage();
                            doc.font('mArial', 11)
                                .text('Η διάρκεια παραμονής των ασθενών στο Κέντρο SigmaSoft κυμαίνεται από μερικές\n' +
                                    'ημέρες έως αρκετές εβδομάδες, ανάλογα με τις ατομικές ανάγκες και την πρόοδο που\n' +
                                    'παρουσιάζουν. Το Κέντρο SigmaSoft τηρεί για τον κάθε ασθενή τα χρονοδιαγράμματα\n' +
                                    'που έχουν καθοριστεί από τον Εθνικό Οργανισμό Παροχής Υπηρεσιών Υγείας (ΕΟΠΥΥ). Σύμφωνα\n' +
                                    'με τα επίσημα στοιχεία του κέντρου, το 2017, η μέση διάρκεια παραμονής ήταν 29,99 ημέρες,\n' +
                                    'δηλαδή αρκετά κάτω από τις κατευθυντήριες γραμμές του ΕΟΠΥΥ, χαμηλότερα και από τις 31,01\n' +
                                    'ημέρες του έτους 2016.');
                            doc.moveDown(1);
                            doc.image(statsImage, {
                                fit: [450, 750],
                                align: 'left'
                            });
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Το πρόγραμμα αποκατάστασης που θα ακολουθηθεί και ο τύπος και ο αριθμός των θεραπειών\n' +
                                    'καθορίζεται σύμφωνα με τις ανάγκες του εκάστοτε ασθενούς και κατόπιν αξιολόγησης της Ομάδας\n' +
                                    'Αποκατάστασης κατά την εισαγωγή του ασθενούς. Το ατομικό πρόγραμμα αποκατάστασης\n' +
                                    'κοινοποιείται εγγράφως στον ασθενή και στους συνοδούς σε εβδομαδιαία βάση.');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Είμαι στη διάθεσή σας για οποιαδήποτε διευκρίνιση ή απορία προκύπτει από την ως άνω\n' +
                                    'πληροφόρηση στην ηλεκτρονική διεύθυνση info@sigmasoft.gr ή στα τηλέφωνα\n' +
                                    '2310 986150.');
                            doc.moveDown(2);
                            doc.font('mArial', 11)
                                .text('Με εκτίμηση,');
                            doc.moveDown(1);
                            doc.font('mArial', 11)
                                .text('Γιώργος Παπαδόπουλος\n' +
                                    'Διευθύντής Υποδοχής και Κίνησης Ασθενών');

                            doc.end();
                            stream.on('finish', function() {
                                var file = stream.toBlobURL('application/pdf');
                                window.open(file);
                            });
                        });
                    });
                }
            };
            oReq.send(null);
        }

        /**
         * Builds a pdf document depending on values of array and
         * displays it in new browser tab. It is strict for
         * Lead Management Aggregated Statistics.
         * @param array Array with values.
         *        array[index].label Is the row label
         *        array[index].value Is the row value
         * @param from Date string from in DD-MM-YYYY format
         * @param to Date string to in DD-MM-YYYY format
         */
        function makeLeadManagementAggregatedReport(array, from, to) {
            var doc = new PDFDocument({
                margin: 50
            });
            doc.info['Title'] = "Συγκεντρωτικά Lead Management";
            doc.info['Author'] = 'SigmaSalesForce';
            var stream = doc.pipe(blobStream());

            // Load custom font for Greek chars encoding problem
            var oReq = new XMLHttpRequest();
            oReq.open("GET", "content/fonts/arial.ttf", true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    doc.registerFont('mArial', arrayBuffer);
                    doc.font('mArial');

                    doc.font('mArial', 15)
                        .text("Συγκεντρωτικά Lead Management    " + from.toString() + " με " + to.toString());
                    doc.moveDown(3);

                    var coordinates = {
                        rowHeight: 100,
                        leftHeight: 105,
                        rightHeight: 105
                    };
                    for (var i=0; i<array.length; i++){
                        coordinates = addToCoordinates(coordinates, 20);
                        row(doc, coordinates.rowHeight);
                        textInRowFirst(doc, i + 1 + ". " + array[i].label, coordinates.leftHeight, 30);
                        textInRowSecond(doc, array[i].value, coordinates.rightHeight, 480)
                    }

                    doc.end();
                    stream.on('finish', function() {
                        var file = stream.toBlobURL('application/pdf');
                        window.open(file);
                    });
                }
            };
            oReq.send(null);
        }

        function textInRowFirst(doc, text, height, width) {
            doc.y = height;
            doc.x = width; //30;
            doc.fillColor('black');
            doc.font('mArial', 11)
                .text(text, {
                paragraphGap: 5,
                indent: 5,
                align: 'justify',
                columns: 1
            });
            return doc
        }

        function textInRowFirstForPercentage(doc, text, height) {
            doc.y = height;
            doc.x = 30;
            doc.fillColor('black');
            doc.font('mArial', 11)
                .text(text, {
                    paragraphGap: 5,
                    indent: 5,
                    align: 'justify',
                    columns: 1,
                    continued: true
                })
                .font('Times-Roman', 12)
                .text(' %');
            return doc
        }

        function textInRowSecond(doc, text, height, width) {
            doc.y = height;
            doc.x = width; //270;
            doc.fillColor('black');
            doc.text(text, {
                paragraphGap: 5,
                indent: 5,
                align: 'justify',
                columns: 1
            });
            return doc
        }

        function textInRowSecondForNumbers(doc, text, height, width) {
            doc.y = height;
            doc.x = width; //270;
            doc.fillColor('black');
            doc.font('Times-Roman', 13)
                .text(text, {
                    paragraphGap: 5,
                    indent: 5,
                    align: 'justify',
                    columns: 1
                });
            return doc
        }

        function row(doc, height) {
            doc.lineJoin('miter')
                .rect(30, height, 500, 20)
                .stroke();
            return doc
        }

        function addToCoordinates(coordinatesObj, number){
            coordinatesObj.rowHeight += number;
            coordinatesObj.leftHeight += number;
            coordinatesObj.rightHeight += number;

            return coordinatesObj
        }

        // Converts image to base64 url string (pdfKit need it this way)
        function toDataURL(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }
    }

})();
;
(function(){
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
/**
 * Created by Kristy on 30/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('notificationsTemplate', notificationsTemplate);

    function notificationsTemplate () {

        return {
            restrict: 'A',
            template: "<script id=\"errorTemplate\" type=\"text/x-kendo-template\">\n" +
            "    <div class=\"wrong-pass\">\n" +
            "        <i class=\"material-icons fixed-icons\">assignment_late</i>\n" +
            "        <h6>#= message #</h6>\n" +
            "    </div>\n" +
            "</script>\n" +
            "\n" +
            "<script id=\"successTemplate\" type=\"text/x-kendo-template\">\n" +
            "    <div class=\"upload-success\">\n" +
            "        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n" +
            "        <h6>#= message #</h6>\n" +
            "    </div>\n" +
            "</script>\n" +
            "<span id=\"notification\" style=\"display:none;\"></span>"
        };
    }
})();
;
/**
 * Created by Kristy on 5/9/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('NotificationOptions', NotificationOptions);

    NotificationOptions.$inject = ['$filter'];

    function NotificationOptions ($filter) {

        return {
                autoHideAfter: 4000,
                templates: [{
                    type: "error",
                    template: angular.element("#errorTemplate").html()
                }, {
                    type: "success",
                    template: angular.element("#successTemplate").html()
                }]
            };
    }

})();
;
/**
 * Created by Kristy on 23/6/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MasterFilters', MasterFilters);

    MasterFilters.$inject = [ '$filter' ];

    function MasterFilters ( $filter ) {

        return {
            addDateFilter : addDateFilter,
            addDateFilterGMT : addDateFilterGMT,
            addDateOnlyFilter : addDateOnlyFilter,
            addMasterFilter : addMasterFilter
        };

        function addDateFilter ( field, from, to ) {
            return [
                { "field": field, "operator": "from",
                    "value": $filter('date')(from, 'yyyy-MM-ddT00:00:00.000') + 'Z' },
                { "field": field, "operator": "to",
                    "value": $filter('date')(to, 'yyyy-MM-ddT23:59:59.000') + 'Z' }
            ]
        }

        function addDateFilterGMT ( field, from, to ) {
            const fromDate = new Date(from.toLocaleString("en-US", {timeZone: 'Europe/London'}));
            return [
                { "field": field, "operator": "from",
                    "value": $filter('date')(fromDate, 'yyyy-MM-ddT21:00:00.000') + 'Z'},
                { "field": field, "operator": "to",
                    "value": $filter('date')(to, 'yyyy-MM-ddT20:59:59.000') + 'Z'}
            ]
        }

        function addDateOnlyFilter ( field, from, to ) {
            return [
                { "field": field, "operator": "from",
                    "value": $filter('date')(from, 'yyyy-MM-dd') },
                { "field": field, "operator": "to",
                    "value": $filter('date')(to, 'yyyy-MM-dd') }
            ]
        }

        function addMasterFilter ( field, operator, value ) {
            return [
                {
                    "field": field, "operator": operator,
                    "value": value
                }
            ]
        }
    }

})();
;
/**
 * Created by Kristy on 28/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoValidator', KendoValidator);

    KendoValidator.$inject = [];

    function KendoValidator () {

        return {
            getCustomValidatorOptions : getCustomValidatorOptions
        };

        function getCustomValidatorOptions() {
            return {
                rules: {
                    custom: function (input) {

                        if (input.data('custom')) {
                            if (input.val() !== null && input.val() !== "" && angular.element(input.data('custom')).data("kendoComboBox").selectedIndex === -1) {
                                return false;
                            }
                        }
                        return true;
                    }
                },
                messages: {
                    custom: "Πρέπει να επιλέξετε από την λίστα",
                    maxlength: "Το κινητό τηλέφωνο θα πρέπει να περιέχει 10 χαρακτήρες."
                }
            }
        }
    }

})();
;
/**
 * Created by Kristy on 4/7/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoToolbar', KendoToolbar);

    KendoToolbar.$inject = ['$filter'];

    function KendoToolbar ($filter) {

        return {
            getOptions: getOptions,
            clearDatePickers: clearDatePickers,
            setFrom: setFrom,
            setTo: setTo
        };

        function getOptions (args, vm) {
            var items = [];
            var label = {};

            if (args.indexOf("buttonGroup") > -1) {
                var buttonGroup = {
                    type: "buttonGroup", id:"buttonGroup",
                    buttons: [
                        { text: $filter('translate')('global.toolbar.today'), toggle: vm.masterFiltersOnClick, togglable: true,
                            group: "text-align", icon: "refresh", id: "today" },
                        { text: $filter('translate')('global.toolbar.week'), toggle: vm.masterFiltersOnClick, togglable: true,
                            group: "text-align", icon: "refresh", id: "week" },
                        { text: $filter('translate')('global.toolbar.month'), toggle: vm.masterFiltersOnClick, togglable: true,
                            group: "text-align", icon: "refresh", id: "month" }
                    ]
                };

                if (args.indexOf("year") > -1) {
                    buttonGroup.buttons.push({ text: $filter('translate')('global.toolbar.year'), toggle: vm.masterFiltersOnClick, togglable: true,
                        group: "text-align", icon: "refresh", id: "year" });
                }

                items.push(buttonGroup);
                items.push({ type: "separator" });
            }
            if (args.indexOf("from") > -1) {
                label = { template: "<label translate='global.toolbar.from'>From: </label>" };
                var from = {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions'/>",
                    overflow: "never"
                };
                items.push(label);
                items.push(from);
            }
            if (args.indexOf("to") > -1) {
                label = { template: "<label translate='global.toolbar.to'>To: </label>" };
                var to = {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions'/>",
                    overflow: "never"
                };
                items.push(label);
                items.push(to);
            }
            if (args.indexOf("masterFilterFrom") > -1) {
                label = { template: "<label translate='global.toolbar.from'>From: </label>" };
                var from = {
                    template: "<input kendo-date-picker id='from' options='vm.fromOptions' k-ng-model='vm.masterFilters.from'/>",
                    overflow: "never"
                };
                items.push(label);
                items.push(from);
            }
            if (args.indexOf("masterFilterTo") > -1) {
                label = { template: "<label translate='global.toolbar.to'>To: </label>" };
                var to = {
                    template: "<input kendo-date-picker id='to' options='vm.toOptions' k-ng-model='vm.masterFilters.to'/>",
                    overflow: "never"
                };
                items.push(label);
                items.push(to);
            }
            if (args.indexOf("search") > -1) {
                var search = {
                    template: "<md-button class='next-button-toolbar md-raised md-mini md-primary' aria-label='search' ng-click='vm.mainGridOptions.dataSource.read()' ng-disabled='vm.disabled'>" +
                    "<md-icon class='search-refresh'></md-icon>Αναζήτηση</md-button>", attributes: { class: "right" },
                    overflow: "never"
                };
                items.push(search);
            }
            if (args.indexOf("myTarget") > -1) {
                var myTarget = {
                    template: "<label>My Target: </label><div class='inline'><md-radio-group layout='row' ng-change='vm.mainGridOptions.dataSource.read()' ng-model='vm.masterFilters.myTarget'>" +
                    "<md-radio-button ng-value=true class='md-primary'> Ναι </md-radio-button>" +
                    "<md-radio-button ng-value=false class='md-primary'> Όχι </md-radio-button>" +
                    "<md-radio-button ng-value='' class='md-primary'> Όλα </md-radio-button></md-radio-group></div>",
                    overflow: "never", attributes: {class: "left-space"}
                };
                items.push(myTarget);
            }

            return items;
        }

        function clearDatePickers () {
            angular.element("#from").data('kendoDatePicker').value("");
            angular.element("#to").data('kendoDatePicker').value("");
        }

        function setFrom(date){
            $("#from").data("kendoDatePicker").value(date);
        }

        function setTo(date){
            $("#to").data("kendoDatePicker").value(date);
        }
    }

})();
;
/**
 * Created by Kristy on 12/4/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoNotifications', KendoNotifications);

    KendoNotifications.$inject = ['$filter'];

    function KendoNotifications ($filter) {

        var service = {
            onShow : onShow,
            onSaveSuccess : onSaveSuccess,
            onSaveError : onSaveError,
            onSave : onSave,
            onDeleteSuccess : onDeleteSuccess,
            onDeleteError : onDeleteError,
            showSuccessNotification : showSuccessNotification,
            showErrorNotification : showErrorNotification
        };

        return service;

        function onShow(e) {
            if (e.sender.getNotifications().length == 1) {
                var element = e.element.parent(),
                    eWidth = element.width(),
                    eHeight = element.height(),
                    wWidth = $(window).width(),
                    wHeight = $(window).height(),
                    newTop, newLeft;

                newLeft = Math.floor(wWidth / 2 - eWidth / 2);
                newTop = Math.floor(wHeight / 2 - eHeight / 2);

                e.element.parent().css({top: newTop, left: newLeft, zIndex: 22222});
            }
        }

        function onSaveSuccess( notification ) {
            notification.show({
                message: "Η ενημέρωση των στοιχείων ήταν επιτυχής!"
            }, "success");
        }

        function onSaveError( notification ) {
            notification.show({
                message: "Η ενημέρωση των στοιχείων απέτυχε!"
            }, "error");
        }

        function onSave( notification, message, status ) {
            notification.show({
                message: message
            }, status);
        }

        function onDeleteSuccess( notification ) {
            notification.show({
                message: "Η εγγραφή διαγράφηκε με επιτυχία!"
            }, "success");
        }

        function onDeleteError( notification ) {
            notification.show({
                message: "Η διαγραφή της εγγραφής απέτυχε!"
            }, "error");
        }

        function showSuccessNotification (notification, message){
            notification.show({
                message: message
            }, "success");
        }

        function showErrorNotification (notification, message){
            notification.show({
                message: message
            }, "error");
        }
    }

})();
;
/**
 * Created by Kristy on 25/7/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoGrid', KendoGrid);

    KendoGrid.$inject = ['$filter'];

    function KendoGrid ($filter) {

        return {
            refresh : refresh,
            refreshList : refreshList,
            refreshWithFilter : refreshWithFilter,
            defaultEditInline: defaultEditInline,
            defaultEditPopup: defaultEditPopup,
            defaultCustomEditPopup: defaultCustomEditPopup,
            initSelected : initSelected
        };

        function refresh (grid) {
            if (grid.dataSource.page() > 1){
                grid.dataSource.page(1);
                grid.dataSource.filter({});
            }
            grid.dataSource.read();
        }

        function refreshList (grid, newData) {
            grid.dataSource.data(newData);
        }

        function refreshWithFilter (grid, filter) {
            grid.dataSource.page(1);
            grid.dataSource.filter(filter);
            grid.dataSource.read();
        }

        function defaultEditInline (container) {
            var updateBtnTxt = $filter('translate')('global.form.updateBtnTxt'),
                cancelBtnTxt = $filter('translate')('global.form.cancelBtnTxt');

            //sets the text of the "Update" button
            angular.element(container).find("a.k-grid-update").text(updateBtnTxt);
            //sets the text of the "Cancel" button
            angular.element(container).find("a.k-grid-cancel").text(cancelBtnTxt);
        }

        function defaultEditPopup (container) {
            var updateBtnTxt = $filter('translate')('global.form.updateBtnTxt'),
                cancelBtnTxt = $filter('translate')('global.form.cancelBtnTxt');

            //sets the text of the "Update" button
            angular.element(container).find("a.k-grid-update").text(updateBtnTxt);
            //sets the text of the "Cancel" button
            angular.element(container).find("a.k-grid-cancel").text(cancelBtnTxt);

            angular.element(container).kendoWindow("title",$filter('translate')('entity.action.edit'));
        }

        function defaultCustomEditPopup (container, width, formWidth) {
            defaultEditPopup(container);

            //for large edit window
            angular.element(container).width(width).data("kendoWindow").center();
            angular.element(".k-edit-form-container").width(formWidth);
            angular.element(".k-edit-form-container").css({"margin-left": "10px"});
        }

        function initSelected (gridId, self, array) {
            angular.element("#"+gridId+"checkbox").prop('checked', false);
            //toggle class on click
            angular.element(".checkbox").bind("change", function (e) {
                angular.element(e.target).closest("tr").toggleClass("k-state-selected");
            });

            var view = self.dataSource.data();

            if (array.length) {
                var counter = 0;
                angular.forEach( view, function(item) {
                    var foundItemById = $filter('filter')(array, {id: item.id}, true)[0];
                    if(array.indexOf(foundItemById) !== -1){
                        self.tbody.find("tr[data-uid='" + item.uid + "']")
                            .addClass("k-state-selected");
                        item.selected = true;
                        counter++
                    }
                });
                if(counter == view.length) {
                    angular.element("#"+gridId+"checkbox").prop('checked', true);
                }
            }
        }
    }

})();
;
/**
 * Created by Kristy on 22/12/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoFilter', KendoFilter);

    KendoFilter.$inject = ['$filter'];

    const excludedKeys = ["Shift", "CapsLock", "Control", "Alt", "Meta", "F1", "F2",
        "F3", "F4", "F5", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "Escape", "ContextMenu",
        "ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown", "NumLock", "Home", "Insert", "PageUp",
        "PageDown", "End", "ScrollLock", "Pause", "Enter"];

    function KendoFilter ($filter) {

        return {
            getTemplate : getTemplate,
            getDayTimeTemplate : getDayTimeTemplate,
            getBooleanTemplate : getBooleanTemplate,
            getEnumerationTemplate : getEnumerationTemplate,
            getEmployeeCustomerSectorsTemplate: getEmployeeCustomerSectorsTemplate
        };

        function getTemplate (args) {
            args.element.css("width", "90%").addClass("k-textbox").keydown(function(e){
                if (excludedKeys.indexOf(e.key) === -1) {
                    setTimeout(function(){
                        $(e.target).trigger("change");
                    });
                }
            });
        }

        function getDayTimeTemplate (args) {
            args.element.kendoDropDownList({
                autoBind: false,
                dataTextField: "text",
                dataValueField: "value",
                dataSource: new kendo.data.DataSource({
                    data: [{text: "ΠΡΩΙΝΌ", value: "day"},
                        {text: "ΑΠΟΓΕΥΜΑΤΙΝΌ", value: "night"}]
                }),
                valuePrimitive: true

            })
        }

        function getEnumerationTemplate (args, field, values) {
            var data = [];
            angular.forEach(values, function (value) {
                data.push({text: value !== 'none' ? $filter('translate')('global.field.' + field + '.' + value) : 'Όχι', value: value});
            });
            args.element.kendoDropDownList({
                autoBind: false,
                dataTextField: "text",
                dataValueField: "value",
                dataSource: new kendo.data.DataSource({
                    data: data
                }),
                valuePrimitive: true

            })
        }

        function getBooleanTemplate (args) {
            args.element.kendoDropDownList({
                autoBind: false,
                dataTextField: "text",
                dataValueField: "value",
                dataSource: new kendo.data.DataSource({
                    data: [{text: "Ναι", value: "true"},
                        {text: "Όχι", value: "false"}]
                }),
                valuePrimitive: true

            })
        }

        function getEmployeeCustomerSectorsTemplate(dataItem) {
            var template = "";

            if (dataItem.employeeCustomerSectors !== null &&
                dataItem.employeeCustomerSectors !== undefined &&
                dataItem.employeeCustomerSectors.length > 0) {
                dataItem.employeeCustomerSectors.forEach(function (employeeCustomerSector) {
                    if (employeeCustomerSector.employee !== null &&
                        employeeCustomerSector.employee !== undefined &&
                        employeeCustomerSector.employee.account !== null &&
                        employeeCustomerSector.employee.account !== undefined) {
                        if (employeeCustomerSector.myTarget === true) {
                            template += "[" + "<strong>" + kendo.htmlEncode(employeeCustomerSector.employee.account.lastName) + " " + kendo.htmlEncode(employeeCustomerSector.employee.account.firstName) + "</strong>" + "]" + "<br/>";
                        }else {
                            template += "[" + kendo.htmlEncode(employeeCustomerSector.employee.account.lastName) + " " + kendo.htmlEncode(employeeCustomerSector.employee.account.firstName) + "]" + "<br/>";
                        }
                    }
                });
            }

            return template;
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 27/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('KendoChangeEvent', KendoChangeEvent);

    KendoChangeEvent.$inject = ['$state'];

    function KendoChangeEvent ($state) {

        return {
            onChange : onChange
        };

        function onChange (self, cellIndexes, view) {
            // Get selected cell
            var selected = self.select();
            // Get the row that the cell belongs to.
            var row = self.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if(cellIndexes.includes(cellIndex)) {
                switch (view) {
                    case 'employee':
                        $state.go('userInfo', {id: self.dataItem(row).employee.id});
                        break;
                    default:
                        break;
                }
            }
        }
    }

})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('sigmasfApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
/**
 * Created by Kristy on 29/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('HasAuthorizationByUser', HasAuthorizationByUser);

    HasAuthorizationByUser.$inject = ['$http', '$state'];

    function HasAuthorizationByUser ($http, $state) {
        var url = "/api/employees/me";

        return {
                hasAuthority: hasAuthority
            };

        function hasAuthority() {
            $http.get( url )
                .success(function ( response ) {
                    var unauthorizedUsers = [ 'kksilouri', 'mathanasiou' ];
                    if ( unauthorizedUsers.indexOf(response.account.login) !== -1 ) {
                        $state.go('accessdenied');
                    }
                })
                .error(function (response) {
                    console.log(response);
                });
        }
    }

})();
;
/**
 * Created by Kristy on 12/9/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('favouriteFiltersWindow', favouriteFiltersWindow);

    function favouriteFiltersWindow () {

        return {
            restrict: 'A',
            template: "<div kendo-window=\"vm.window\" k-width=\"600\" k-height=\"180\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\"\n" +
            "     k-on-close=\"vm.filter = {};vm.isRenameMode = false\" k-title=\"'Αποθήκευση Φίλτρου'\">\n" +
            "    <div id=\"addView\" style=\"margin-top: 5%;\">\n" +
            "        <div class=\"k-edit-label\" style=\"margin-left: 12%;margin-right: 2%;\">\n" +
            "            <label>* Όνομα Φίλτρου </label>\n" +
            "        </div>\n" +
            "        <input id=\"filterName\" name=\"filterName\" ng-model=\"vm.filter.name\" class=\"k-textbox info pull-left\"/>\n" +
            "    </div>\n" +
            "    <div>\n" +
            "        <div class=\"buttons-wrap pull-right\" style=\"clear: both;margin-top: 30px;\">\n" +
            "            <md-button class=\"blue-color-md-button md-raised md-mini md-primary md-primary-light\" aria-label=\"add\" ng-click=\"vm.saveFilter(vm.isRenameMode ? vm.filter : {name: vm.filter.name})\">\n" +
            "                <i class=\"material-icons fixed-icons fixed-icons-2\">save</i>Αποθήκευση</md-button>\n" +
            "            <md-button class=\"md-raised md-mini\" aria-label=\"cancel\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.window.close()\">\n" +
            "                <i class=\"material-icons fixed-icons fixed-icons-2\">clear</i>Ακύρωση</md-button>\n" +
            "        </div>\n" +
            "    </div>\n" +
            "</div>"
        };
    }
})();
;
/**
 * Created by Teo on 05/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('favouriteFiltersTitleMdToolbar', favouriteFiltersTitleMdToolbar);

    function favouriteFiltersTitleMdToolbar () {

        return {
            restrict: 'A',
            template: "<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\">\n" +
            "<div layout=\"row\">" +
            "<md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\">\n" +
            "            <md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon>\n" +
            "        </md-toolbar-filler>" +
            "    <h2 class=\"md-toolbar-tools\">\n" +
            "        <md-card-title-text flex>\n" +
            "            <span class=\"md-headline\">{{ vm.pageHeading }}\n" +
            "                <span ng-if=\"vm.selectedFilter.name\"> /\n" +
            "                    <span class=\"fav-filter-title\" style='color: #469AD4'> {{vm.selectedFilter.name}} <!--alert alert-info-->\n" +
            "                        <span ng-if=\"vm.selectedFilter.name && vm.isEdited\" class=\"filter-edited-item\"><span style='color: #F9A22E'>Edited</span></span>\n" +
            "\n" +
            "                        <div ng-if=\"vm.selectedFilter.name && vm.isEdited\" class=\"btn-group\" style=\"margin-left: 10px;\">\n" +
            "                            <button ng-click=\"vm.saveFilter(vm.selectedFilter)\" ng-disabled=\"vm.disabled\" type=\"button\" class=\"btn btn-default\">Αποθήκευση</button>\n" +
            "                            <button ng-disabled=\"vm.disabled\" type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n" +
            "                                <span class=\"caret\"></span>\n" +
            "                                <span class=\"sr-only\"></span>\n" +
            "                            </button>\n" +
            "                            <ul class=\"dropdown-menu fix-dropdown-menu\">\n" +
            "                                <li><a ng-click=\"vm.window.open().center()\">Αποθήκευση ως</a></li>\n" +
            "                            </ul>\n" +
            "                        </div>\n" +
            "                        <button ng-if=\"vm.selectedFilter.name && !vm.isEdited\" ng-click=\"vm.window.open().center()\" ng-disabled=\"vm.disabled\"\n" +
            "                                type=\"button\" class=\"btn btn-default\">Αποθήκευση ως</button>\n" +
            "                    </span>\n" +
            "                </span>\n" +
            "            </span>\n" +
            "        </md-card-title-text>\n" +
            "\n" +
            "<div>" +
            "        <md-button ng-if=\"!vm.selectedFilter.name\" ng-disabled=\"vm.disabled\" class=\"next-button-toolbar md-raised md-mini\" aria-label=\"savefilter\" ng-click=\"vm.window.open().center()\">\n" +
            "            <md-icon class=\"material-icons\">filter_list</md-icon>Αποθήκευση Φίλτρου</md-button>\n" +
            "\n" +
            "        <md-button class=\"next-button-toolbar md-raised md-mini\" aria-label=\"savefilter\" ng-click=\"vm.clearAllOptions()\">\n" +
            "            <md-icon class=\"material-icons\">clear</md-icon>Καθαρισμός Φίλτρων</md-button>\n" +
            "\n" +
            "</div>" +
            "    </h2>\n" +
            "</div>" +
            "</md-toolbar>"
        };
    }
})();
;
/**
 * Created by Kristy on 12/9/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('favouriteFiltersTitleCard', favouriteFiltersTitleCard);

    function favouriteFiltersTitleCard () {

        return {
            restrict: 'A',
            template: "<md-card md-theme=\"default\" md-theme-watch>\n" +
            "    <md-card-title>\n" +
            "        <md-card-title-text>\n" +
            "            <span class=\"md-headline\">{{ vm.pageHeading }}\n" +
            "                <span ng-if=\"vm.selectedFilter.name\"> /\n" +
            "                    <span class=\"fav-filter-title\"> {{vm.selectedFilter.name}} <!--alert alert-info-->\n" +
            "                        <span ng-if=\"vm.selectedFilter.name && vm.isEdited\" class=\"filter-edited-item\"><span>Edited</span></span>\n" +
            "\n" +
            "                        <div ng-if=\"vm.selectedFilter.name && vm.isEdited\" class=\"btn-group\" style=\"margin-left: 10px;\">\n" +
            "                            <button ng-click=\"vm.saveFilter(vm.selectedFilter)\" ng-disabled=\"vm.disabled\" type=\"button\" class=\"btn btn-default\">Αποθήκευση</button>\n" +
            "                            <button ng-disabled=\"vm.disabled\" type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n" +
            "                                <span class=\"caret\"></span>\n" +
            "                                <span class=\"sr-only\"></span>\n" +
            "                            </button>\n" +
            "                            <ul class=\"dropdown-menu fix-dropdown-menu\">\n" +
            "                                <li><a ng-click=\"vm.window.open().center()\">Αποθήκευση ως</a></li>\n" +
            "                            </ul>\n" +
            "                        </div>\n" +
            "                        <button ng-if=\"vm.selectedFilter.name && !vm.isEdited\" ng-click=\"vm.window.open().center()\" ng-disabled=\"vm.disabled\"\n" +
            "                                type=\"button\" class=\"btn btn-default\">Αποθήκευση ως</button>\n" +
            "                    </span>\n" +
            "                </span>\n" +
            "            </span>\n" +
            "        </md-card-title-text>\n" +
            "\n" +
            "        <md-button ng-if=\"!vm.selectedFilter.name\" ng-disabled=\"vm.disabled\" class=\"next-button-toolbar md-raised md-mini\" aria-label=\"savefilter\" ng-click=\"vm.window.open().center()\">\n" +
            "            <md-icon class=\"material-icons\">filter_list</md-icon>Αποθήκευση Φίλτρου</md-button>\n" +
            "\n" +
            "        <md-button class=\"next-button-toolbar md-raised md-mini\" aria-label=\"savefilter\" ng-click=\"vm.clearAllOptions()\">\n" +
            "            <md-icon class=\"material-icons\">clear</md-icon>Καθαρισμός Φίλτρων</md-button>\n" +
            "\n" +
            "    </md-card-title>\n" +
            "</md-card>"
        };
    }
})();
;
/**
 * Created by Kristy on 12/9/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('favouriteFiltersMain', favouriteFiltersMain);
    favouriteFiltersMain.$inject = ['FavouriteFiltersService', 'MasterToKendoFiltersService', 'FavouriteFilter'];
    function favouriteFiltersMain (FavouriteFiltersService, MasterToKendoFiltersService, FavouriteFilter) {

        return {
            restrict: 'A',
            scope: true,
            template: "<div id=\"favourite-filters\" resizable r-directions=\"['right']\" style=\"width: 200px;min-width: 200px!important;max-width: 500px;\">\n" +
            "        <div class=\"filter-panel-favourites-container\">\n" +
            "            <div class=\"filter-panel-section\">\n" +
            "                <h4 class=\"filter-title\">Αγαπημένα Φίλτρα</h4>\n" +
            "                <div class=\"filter-content\">\n" +
            "                    <ul ng-repeat=\"favouriteFilter in vm.favouriteFilters\" class=\"saved-filter filter-list favourite-filters\">\n" +
            "                        <li ng-mouseenter=\"hover=true\" ng-mouseleave=\"hover=false\">\n" +
            "                            <a ng-class=\"{'fav-filter-active': vm.selectedFilter.name === favouriteFilter.name}\" class=\"filter-link\"\n" +
            "                               ng-click=\"vm.favouriteFilterSelected(favouriteFilter);\">{{favouriteFilter.name}}</a>\n" +
            "                            <span ng-show=\"hover || vm.selectedFilter.name === favouriteFilter.name\">\n" +
            "                                <md-menu>\n" +
            "                                  <md-button class=\"md-icon-button filter-actions\" aria-label=\"clear\" ng-click=\"$mdOpenMenu($event);\">\n" +
            "                                    <md-icon ng-class=\"{'fav-filter-active': vm.selectedFilter.name === favouriteFilter.name}\"\n" +
            "                                             class=\"material-icons small-md-icon\">arrow_drop_down</md-icon>\n" +
            "                                  </md-button>\n" +
            "                                  <md-menu-content width=\"2\" id=\"fav-filter-menu-content\">\n" +
            "                                    <md-menu-item>\n" +
            "                                      <md-button ng-click=\"vm.deleteFavouriteFilter(favouriteFilter, $index)\" aria-label=\"clear\">\n" +
            "                                        <md-icon class=\"material-icons small-md-icon\">clear</md-icon> Διαγραφή\n" +
            "                                      </md-button>\n" +
            "                                    </md-menu-item>\n" +
            "                                    <md-menu-item>\n" +
            "                                      <md-button ng-click=\"vm.isRenameMode = true;vm.filter=favouriteFilter;vm.window.open().center()\" aria-label=\"rename\">\n" +
            "                                        <md-icon class=\"material-icons small-md-icon\">edit_mode</md-icon> Μετονομασία\n" +
            "                                      </md-button>\n" +
            "                                    </md-menu-item>\n" +
            "                                  </md-menu-content>\n" +
            "                                </md-menu>\n" +
            "                            </span>\n" +
            "                        </li>\n" +
            "\n" +
            "                    </ul>\n" +
            "                </div>\n" +
            "            </div>\n" +
            "        </div>\n" +
            "    </div>",
            controller: function ($scope) {
                var vm = $scope.$parent.vm;

                vm.favouriteFilterSelected = function (filter) {
                    vm.selectedFilter = filter;
                    vm.masterOptions = JSON.parse(filter.masterOptions);
                    vm.masterFilters = FavouriteFiltersService.clearMasterFilters();
                    vm.masterFilters = FavouriteFiltersService.setMasterOptions(vm.masterOptions, vm.masterFilters);
                    FavouriteFiltersService.setKendoOptions(JSON.parse(filter.kendoOptions), vm.mainGrid);
                    if (vm.mainGridOptions) {
                        vm.mainGridOptions.dataSource.read();
                    }
                };

                vm.saveFilter = function (selectedFilter) {
                    vm.filter = selectedFilter;
                    if (!vm.isRenameMode) {
                        vm.filter.employee = vm.employee.data;
                        if(vm.view === "events") {
                            vm.filter.viewName = vm.view + "_filter";
                        } else {
                            vm.filter.viewName = vm.view;
                        }

                        vm.masterOptions = MasterToKendoFiltersService.getMasterFilters([], vm.masterFilters, vm.filter.viewName);
                        vm.filter.kendoOptions = JSON.stringify(FavouriteFiltersService.getKendoOptions(vm.mainGrid));
                        vm.filter.masterOptions = JSON.stringify(vm.masterOptions);
                    }
                    FavouriteFilter.update({}, vm.filter,
                        function (result) {
                            if (!vm.isRenameMode) {

                                if(!vm.filter.id) vm.favouriteFilters.push(result);
                                else vm.masterFiltersEdited();
                                vm.favouriteFilterSelected(result);
                            }
                            vm.window.close()
                        });
                };

                vm.clearAllOptions = function() {
                    vm.masterFilters = FavouriteFiltersService.clearMasterFilters();
                    FavouriteFiltersService.setKendoOptions(null, vm.mainGrid);
                };

                vm.deleteFavouriteFilter = function(filter, index) {
                    FavouriteFilter.delete({id: filter.id},
                        function () { vm.favouriteFilters.splice(index, 1); });
                };
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertDateFromServer: convertDateFromServer,
            convertTimeFromServer: convertTimeFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            convertTimeToServer: convertTimeToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertDateFromServer (date) {
            if (date) {
                return new Date(date);
            }else {
                return null;
            }
        }

        function convertTimeFromServer (time) {
            if (time) {
                var dateWithTime = new Date();
                var parts = time.split(':');
                dateWithTime.setHours(+parts[0]);
                dateWithTime.setMinutes(parts[1]);
                dateWithTime.setSeconds(parts[2]);
                return dateWithTime;
            }else {
                return null;
            }
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function convertTimeToServer(time) {
            if (time) {
                return new Date(time).getTime();
            }else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
/**
 * Created by Teo on Ιούλ, 2018
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomUtils', CustomUtils);

    CustomUtils.$inject = [];

    function CustomUtils () {

        return {
            getHeightPixelsFromPercentage: heightPixelsFromPercentage,
            getWidthPixelsFromPercentage: widthPixelsFromPercentage,
            getRandomColor: getRandomColor,
            getYears: getYears,
            getMonths: getMonths
        };

        /**
         * Get height pixels from given percentage.
         * This helps to give direct height on a div
         * and be responsive in all screens.
         * @param percentage How much percentage of screen
         *        height you want to cover
         * @returns {number} Result in pixels
         */
        function heightPixelsFromPercentage(percentage){
            var screenHeight = window.screen.height;
            return (screenHeight * percentage) / 100;
        }

        /**
         * Get width pixels from given percentage.
         * This helps to give direct width on a div
         * and be responsive in all screens.
         * @param percentage How much percentage of screen
         *        width you want to cover
         * @returns {number} Result in pixels
         */
        function widthPixelsFromPercentage(percentage){
            var screenWidth = window.screen.width;
            return (screenWidth * percentage) / 100;
        }

        /**
         * Get a random generated color in hex
         * @returns {string} Color in #hex format
         */
        function getRandomColor(){
            return '#' + (function co(lor) {
                return (lor +=
                    [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                && (lor.length === 6) ?  lor : co(lor);
            })('')
        }

        /**
         * Get an array with years.
         * @param startYear The year to start from.
         * @param reversed Boolean indicating if results should be sorted in reverse.
         * @returns {any} An array with years.
         */
        function getYears(startYear, reversed){
            var currentYear = new Date().getFullYear(), years = [];
            startYear = startYear || 2015;

            while ( startYear <= currentYear ) {
                years.push({value: startYear++});
            }

            return reversed === true ? years.reverse() : years;
        }

        /**
         * Get an array with months. Each object has this struct:
         * {
         *  id: 1,
         *  name: 'Ιανουάριος'
         * }
         * @param defaultItem Boolean indicating if array has a default 1st item
         * @returns {Array} An array with months.
         */
        function getMonths(defaultItem) {
            var months = [];
            moment.locale('el');
            if (defaultItem === true){
                months.push({
                    id: 0,
                    value: "Επιλογή Μήνα"
                });
            }
            angular.forEach(moment.months(), function (value, key) {
                months.push({
                    id: key + 1,
                    value: value
                });
            });
            return months;
        }
    }
})();
;
/**
 * Created by Teo on 18/01/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomDateUtils', CustomDateUtils);

    CustomDateUtils.$inject = [];

    function CustomDateUtils () {

        var service = {
            toServerDateFormat : toServerDateFormat,
            fromServerDateFormat : fromServerDateFormat,
            getDiffInMinutes : getDiffInMinutes,
            getDateTime : getDateTime,
            numberToMonth : numberToMonth
        };

        return service;

        /**
         * Convert a date with hours and minutes in
         * server's ZonedDateTime format.
         * @param date Should be in 'YYYY-MM-DD' format
         * @param hours Given hours, number
         * @param minutes Given minutes, number
         */
        function toServerDateFormat(date, hours, minutes){
            var mDate;

            if (hours < 10){
                hours = "0" + hours;
            }

            if (minutes < 10){
                minutes = "0" + minutes;
            }

            mDate = date + "T" + hours + ":" + minutes + ":00.000Z";
            return mDate;
        }

        /**
         * Convert server ZonedDateTime date object to Date and Time
         * @param serverDate A Date object in "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'" format
         */
        function fromServerDateFormat(serverDate) {
            serverDate.setHours(serverDate.getHours() - 2);
            return serverDate;
        }

        /**
         * Get a difference between 2 Dates in minutes.
         * @param date1 Should be a Date object
         * @param date2 Should be a Date object
         */
        function getDiffInMinutes(date1, date2){
            var result;
            var bDate, sDate;

            if (date1 > date2){
                bDate = date1;
                sDate = date2;
            }else if (date1 < date2){
                bDate = date2;
                sDate = date1;
            }else {
                return 0;
            }

            var diff = bDate.getTime() - sDate.getTime();
            result = Math.round(diff / 60000);

            return result;
        }

        /**
         * Merge date and time in a Date object. This is useful
         * when you have 1 control for date and 1 control for time
         * and API wants a ZonedDateTime object.
         * @param date The actual date. Should be Date object
         * @param time The actual time. Should be Date object
         * @returns {Date} Date with proper time in a Date object
         */
        function getDateTime(date, time) {
            var dateTime = new Date(date);
            dateTime.setHours(time.getHours());
            dateTime.setMinutes(time.getMinutes());
            dateTime.setSeconds(time.getSeconds());
            dateTime.setMilliseconds(time.getMilliseconds());
            return dateTime;
        }

        function numberToMonth(number) {
            switch (number){
                case 0:
                    return "Ιανουαρίος";
                case 1:
                    return "Φεβρουάριος";
                case 2:
                    return "Μάρτιος";
                case 3:
                    return "Απρίλιος";
                case 4:
                    return "Μάιος";
                case 5:
                    return "Ιούνιος";
                case 6:
                    return "Ιούλιος";
                case 7:
                    return "Αύγουστος";
                case 8:
                    return "Σεπτέμβριος";
                case 9:
                    return "Οκτώβριος";
                case 10:
                    return "Νοέμβριος";
                case 11:
                    return "Δεκέμβριος";
                default:
                    return "";
            }
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomDataUtils', CustomDataUtils);

    CustomDataUtils.$inject = ['$window'];

    function CustomDataUtils ($window) {

        var service = {
            openWindow: openWindow,
            openDocument: openDocument,
            base64toBlob: base64toBlob,
            toDataURL: toDataURL,
            Base64EncodeUrl: Base64EncodeUrl,
            Base64DecodeUrl: Base64DecodeUrl,
            arrayRemove: arrayRemove,
            getValueFromHeaderLabel: getValueFromHeaderLabel,
            removeTotalsFromHeaderLabel: removeTotalsFromHeaderLabel,
            getGroupColumn: getGroupColumn,
            convertToNumberFormat: convertToNumberFormat,
            isNotNil: isNotNil,
            isNotEmpty: isNotEmpty
        };

        return service;

        function openWindow (type, data) {
            $window.open('data:' + type + ';base64,' + data);
        }

        function openDocument (action, title, type, base64data) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = base64toBlob(base64data, type);

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.setAttribute("type", "hidden");
            link.href = data;

            switch (action) {
                case 'preview':
                    link.target = "title";
                    break;
                case 'download':
                    link.download = title + type.replace(new RegExp("^[^/].*/"), ".");
                    break;
            }

            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(function(){
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
                    , 100});
        }

        function base64toBlob(base64data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(base64data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        // Converts image to base64 url string (pdfKit need it this way)
        function toDataURL(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        /**
         * use this to make a Base64 encoded string URL friendly,
         * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
         * characters are removed
         *
         * @param {String} str the encoded string
         * @returns {String} the URL friendly encoded String
         */
        function Base64EncodeUrl(str){
            return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
        }

        /**
         * Use this to recreate a Base64 encoded string that was made URL friendly
         * using Base64EncodeurlFriendly.
         * '-' and '_' are replaced with '+' and '/' and also it is padded with '+'
         *
         * @param {String} str the encoded string
         * @returns {String} the URL friendly encoded String
         */
        function Base64DecodeUrl(str){
            str = (str + '===').slice(0, str.length + (str.length % 4));
            return str.replace(/-/g, '+').replace(/_/g, '/');
        }

        /**
         * Filters an array and returns an array with elements that not matching the value.
         * @param arr The array to be filtered.
         * @param value The value that elements should not match
         */
        function arrayRemove(arr, value){
            return arr.filter(function (ele) {
                return ele.type !== value;
            });
        }

        /**
         * Gets the value from an excel header label.
         * Format of the header label should be like this 'Blah blah (Σύνολο: 117)'
         * It extracts 117 value from the header label
         * @param headerLabel The label of excel header
         */
        function getValueFromHeaderLabel(headerLabel) {
            return headerLabel.match(/[0-9]*(\.?[0-9]*)*,?[0-9]*[0-9]/g); // get all numbers from string
        }

        /**
         * Gets the value name of the grouped column.
         * Format of the header label should be like this 'Blah blah (Blah blah)'
         * @param value The label of excel header
         */
        function getGroupColumn(value) {
            return value.match(/(.*)\(/).pop();
        }

        /**
         * Removes the totals from an excel header label
         * Format of the header label should be like this 'Blah blah (Σύνολο: 117)'
         * It extracts Blah blah from the header label
         * @param headerLabel
         * @returns {string}
         */
        function removeTotalsFromHeaderLabel(headerLabel) {
            var striped = headerLabel.match(/^(.*)\(/).pop(); // start of string till first '('
            return striped.substring(0, striped.length -1); // remove last char '('
        }

        /**
         * Converts the value given to float format
         * It extracts the float number
         * @param value
         * @returns {number}
         */
        function convertToNumberFormat(value) {
            return parseFloat(value.replace(/\./g, '').replace(/,/g, '.').replace(/ €/g, ''));
        }

        function isNotNil(value) {
            return !(value === null || value === undefined);
        }

        function isNotEmpty(arrayValue) {
            return isNotNil(arrayValue) && arrayValue.length > 0;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
/**
 * Created by Kristy on 12/6/2017.
 */

(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CalculateAge', CalculateAge);

    function CalculateAge () {

        return {
            getAgeFromBirthYear : getAgeFromBirthYear,
            getBirthYearFromAge : getBirthYearFromAge
        };

        function getAgeFromBirthYear (birthYear) {
            var ageDif = Date.now() - birthYear.getTime();
            var ageDate = new Date(ageDif);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        function getBirthYearFromAge (age) {
            var date = new Date();
            date.setFullYear(date.getFullYear() - age);
            return date;
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
/**
 * Created by gmogas on 8/7/2016.
 */
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ArraysUtil', ArraysUtil);

    function ArraysUtil () {
        var service = {
            isValueInArray : isValueInArray
        };

        return service;

        function isValueInArray (value, array) {
            for (var i=0, len=array.length;i<len;i++) {
                console.log(array[i] + " " + value);
                if (array[i] == value) return true;
            }
            return false;
        }
    }
})();
;
/**
 * Created by Kristy on 4/10/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ApplicationParameters', ApplicationParameters);

    ApplicationParameters.$inject = ['$http', '$state'];

    function ApplicationParameters ($http, $state) {
        var url = "/api/masterdata/application-parameters";

        return {
            hasModule: hasModule,
            customersView: customersView,
            eventCycle: eventCycle,
            getParameter: getParameter
        };

        function hasModule(module, access) {
            if (access) {
                $http.get(url,
                    {
                        params: {
                            page: 1,
                            pageSize: 1,
                            filter: {filters: [{field: "name", operator: "eq", value: module}]}
                        }
                    })
                    .success(function (response, status, headers) {
                        if (response.content[0].value != 1) {
                                $state.go('accessdenied');
                        }
                    })
                    .error(function (response) {
                        console.log(response);
                    });
            } else {
                return $http.get(url,
                    {
                        params: {
                            page: 1,
                            pageSize: 1,
                            filter: {filters: [{field: "name", operator: "eq", value: module}]}
                        }
                    })
            }
        }

        function getParameter(parameterName) {
            return $http.get(url,
                {
                    params: {
                        page: 1,
                        pageSize: 1,
                        filter: {filters: [{field: "name", operator: "eq", value: parameterName}]}
                    }
                });
        }

        function customersView() {
            return $http.get(url,
                {
                    params: {
                        page: 1,
                        pageSize: 1,
                        filter: {filters: [{field: "name", operator: "eq", value: 'Customers_View'}]}
                    }
                });
        }

        function eventCycle() {
            return $http.get(url,
                {
                    params: {
                        page: 1,
                        pageSize: 1,
                        filter: {filters: [{field: "name", operator: "eq", value: 'Event_Cycle'}]}
                    }
                });
        }
    }

})();
;
/**
 * Created by Kristy Kavvada on 4/1/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('Alerts', Alerts);

    Alerts.$inject = ['$mdDialog'];

    function Alerts ($mdDialog) {

        return {
            showAlert: showAlert,
            showAlertWithCloseCallback: showAlertWithCloseCallback,
            showConfirmDialog : showConfirmDialog,
            showPromptDialog: showPromptDialog
        };

        function showAlert (title, message, buttonOk) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ariaLabel('Sigma Salesfoce App Dialog')
                    .ok(buttonOk)
            );
        }

        /**
         * Displays a Dialog
         * @param title Dialog's title
         * @param message Dialog's message
         * @param buttonOk Dialog's button label
         * @param onDismissCallback A callback to run when dialog will be dismissed.
         */
        function showAlertWithCloseCallback (title, message, buttonOk, onDismissCallback){
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .onRemove(onDismissCallback)
                    .title(title)
                    .textContent(message)
                    .ariaLabel('Sigma Salesfoce App Dialog')
                    .ok(buttonOk)
            );
        }

        /**
         * Displays a confirm Dialog with custom actions onConfirm and onCancel.
         * @param ev Event, usually $event from html. Can be null. If set, dialog comes animated from the button that clicked
         * @param title Dialog's title
         * @param message Dialog's message
         * @param clickOutsideToClose Whether to click outside of dialog to close
         * @param buttonOkLabel Dialog's label for confirm button
         * @param buttonCancelLabel Dialog's label for cancel button
         * @param onConfirmCallback Function to run onConfirm
         * @param onCancelCallback Function to run onCancel
         */
        function showConfirmDialog(ev, title, message, clickOutsideToClose, buttonOkLabel, buttonCancelLabel, onConfirmCallback, onCancelCallback) {
            var confirm = $mdDialog.confirm()
                .clickOutsideToClose(clickOutsideToClose)
                .title(title)
                .textContent(message)
                .ariaLabel('Sigma SalesForce')
                //.targetEvent(ev)
                .ok(buttonOkLabel)
                .cancel(buttonCancelLabel);
            if (ev !== null){ confirm.targetEvent(ev); }
            $mdDialog.show(confirm).then(onConfirmCallback, onCancelCallback);
        }

        /**
         * Displays a prompt dialog for user input. It has custom actions onConfirm and onCancel.
         * @param ev Event, usually $event from html. Can be null. If set, dialog comes animated from the button that clicked
         * @param title Dialog's title
         * @param message Dialog's message
         * @param placeHolder Input's placeholder text
         * @param initValue Input's initial value
         * @param buttonOkLabel Dialog's label for confirm button
         * @param buttonCancelLabel Dialog's label for cancel button
         * @param onConfirmCallback Function to run onConfirm
         * @param onCancelCallback Function to run onCancel
         */
        function showPromptDialog(ev, title, message, placeHolder, initValue, buttonOkLabel, buttonCancelLabel, onConfirmCallback, onCancelCallback){
            var confirm = $mdDialog.prompt()
                .title(title)
                .textContent(message)
                .placeholder(placeHolder)
                .ariaLabel(placeHolder)
                .initialValue(initValue)
                .targetEvent(ev)
                .ok(buttonOkLabel)
                .cancel(buttonCancelLabel);
            $mdDialog.show(confirm).then(onConfirmCallback, onCancelCallback);
        }
    }

})();
;
/**
 * Created by Kristy on 29/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ToastCtrl', ToastCtrl);

    ToastCtrl.$inject = ['$mdToast'];

    function ToastCtrl ($mdToast) {
        var vm = this;

        //vm.closeToast = function () {
        //    $mdToast
        //        .hide()
        //        .then(function () {
        //        });
        //};
    }
})();
;
/**
 * Created by Kristy on 3/11/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('mdDialogCtrl', mdDialogCtrl);

    mdDialogCtrl.$inject = ['confirmSaveCustomer', 'existedCustomers', 'closeDialog', '$http'];

    function mdDialogCtrl (confirmSaveCustomer, existedCustomers, closeDialog, $http) {
        var vm = this;
        vm.clicked = [];
        vm.existedCustomers = existedCustomers;
        vm.closeDialog = closeDialog;
        vm.confirmSave = confirmSaveCustomer;
        vm.getSectors =  function(idx, item) {
            if (!item.sectors) {
                $http.get('/api/customers/' + item.id + '/me/customer-sectors')
                    .success(function (response) {
                        vm.existedCustomers[idx].sectors = response;
                    });
            }
            vm.clicked[idx] = !vm.clicked[idx];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', '$mdToast', '$http'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, $mdToast, $http) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                showFollowUpsToast();
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

        function showFollowUpsToast(){
            var filters = {
                data: {
                    "page": 1,
                    "pageSize": 1, // lightweight request
                    filter: {
                        logic: "and",
                        filters: [{
                            "operator": "eqdateonly",
                            "value": moment(new Date()).format('YYYY-MM-DD'),
                            "field": "date"
                        }, {
                            "field": "completed",
                            "operator": "eqbool",
                            "value": "false"
                        },{
                            "field": "leadCall.leadOffers.offerStatus.id",
                            "operator": "noteq",
                            "value": 3
                        }]
                    }
                }
            };
            $http.get('/api/followup-calls/search',
                {params: filters.data})
                .success(function (response) {
                    //console.log(response);
                    if (response.content !== null && response.content !== undefined && response.content.length > 0){
                        $mdToast.show({
                            hideDelay   : false,
                            position    : 'top right',
                            controller  : 'MdToastCtrl',
                            templateUrl : 'app/components/follow-ups-md-toast/md-toast-template.html'
                        });
                    }
                })
                .error(function (error) {
                    //console.log(error);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'el',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
/**
 * Created by Teo on 02/07/2018.
 */

(function() {
    'use strict';
    var isDlgOpen;

    angular
        .module('sigmasfApp')
        .controller('MdToastCtrl', MdToastCtrl);

    MdToastCtrl.$inject = ['$scope', '$mdToast', '$state'];

    function MdToastCtrl ($scope, $mdToast, $state) {
        $scope.closeToast = function() {
            if (isDlgOpen) return;

            $mdToast
                .hide()
                .then(function() {
                    isDlgOpen = false;
                });
        };

        $scope.showFollowUps = function(){
            $mdToast
                .hide()
                .then(function() {
                    isDlgOpen = false;
                    $state.go("followUpCalls");
                });
        };
    }
})();
;
/**
 * Created by Teo on 04/09/2019.
 */

(function() {
    'use strict';
    var isDlgOpen;

    angular
        .module('sigmasfApp')
        .controller('EventCycleMdDialogCtrl', EventCycleMdDialogCtrl);

    EventCycleMdDialogCtrl.$inject = ['$scope', '$mdDialog', '$http'];

    function EventCycleMdDialogCtrl ($scope, $mdDialog, $http) {
        $scope.eventCycle = null;
        $scope.message = "";

        $http.get('/api/masterdata/application-parameters',
            {params:{
                    page: 1,
                    pageSize: 1,
                    filter : { filters: [{field: "name", operator: "eq",  value: "Event_Cycle"}] }}})
            .success(function (response) {
                if (response.content.length > 0) {
                    if (response.content[0].value !== null && response.content[0].value !== undefined) {
                        response.content[0].value = Number(response.content[0].value);
                    }else {
                        response.content[0].value = 0;
                    }

                    $scope.eventCycle = response.content[0];
                }
            })
            .error(function (error) {
                $scope.message = error;
            });


        $scope.cancelDialog = function () {
            if (isDlgOpen) return;

            isDlgOpen = false;
            $mdDialog.cancel();
        };

        $scope.update = function () {
            $scope.message = "";
            if ($scope.eventCycle.value == null || $scope.eventCycle.value === undefined) {
                $scope.message = "Η τιμή δεν μπορεί να είναι κενή";
                return;
            }

            if ($scope.eventCycle.value < 0) {
                $scope.message = "Η τιμή δεν μπορεί να είναι μικρότερη του μηδενός";
                return;
            }

            if ($scope.eventCycle.id == null || $scope.eventCycle.id === undefined) {
                $scope.message = "Κάποιο σφάλμα προέκυψε. Η παράμετρος δεν έχει id. Επικοινωνήστε με τον διαχειριστή του συστήματος";
                return;
            }

            $http.put('/api/application-parameters', $scope.eventCycle).success(function () {
                isDlgOpen = false;
                $mdDialog.hide();
            }).error(function () {
                $scope.message = "Κάποιο σφάλμα προέκυψε";
            });
        };
    }
})();
;
/**
 * Created by Teo on 11/05/2020.
 */

(function() {
    'use strict';
    var isDlgOpen;

    angular
        .module('sigmasfApp')
        .controller('EditCustomerSectorDialogCtrl', EditCustomerSectorDialogCtrl);

    EditCustomerSectorDialogCtrl.$inject = ['$scope', '$mdDialog', '$http', '$state', 'Alerts', 'customerSector', 'KendoService', 'CustomDataUtils', 'Principal'];

    function EditCustomerSectorDialogCtrl ($scope, $mdDialog, $http, $state, Alerts, customerSector, KendoService, CustomDataUtils, Principal) {
        $scope.customerSector = {
            sector: {
                sectorType: {}
            },
            customer: {}
        };
        $scope.fullEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']);
        $http.get('/api/employees/me')
            .success(function (response) {
                $scope.employee = response;
                $scope.customerSector = prepare(customerSector);
            })
            .error(function () {
                Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε κατά τη ταυτοποίηση χρήστη", "ΟΚ");
            });

        $scope.sectorPositionComboBoxOptions = KendoService.initDefaultOptions(KendoService.initDefaultDataSource('/api/masterdata/sector-positions'), "startswith", "name", "id");
        $scope.workingHoursComboBoxOptions = {
            dataSource: new kendo.data.DataSource({
                data: [
                    { value: 'morning', text: 'Πρωί'},
                    { value: 'afternoon', text: 'Απόγευμα'},
                    { value: 'morningAfternoon', text: 'Πρωί/Απόγευμα'}
                ]
            }),
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value"
        };
        $scope.searchEmployeesComboBoxOptions = {
            placeholder: "Αναζήτηση Ιατρικού Επισκέπτη",
            /*filter: "contains",*/
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = {filters: []};
                        }

                        o.data.page = 1;
                        o.data.pageSize = 10000;
                        $http.get('/api/me/employees',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response.content);
                            })
                            .error(function (response) {});
                    }
                },
                schema: {
                    parse: function(data) {
                        angular.forEach(data, function(item) {
                            //define object for data binding
                            if(item.account != null) {
                                item.active = item.myTarget = true;
                                item.employee = {
                                    account : {
                                        fullName: item.account.lastName + " " + item.account.firstName
                                    },
                                    id: item.id
                                }
                            }
                        });
                        return data;
                    }
                }
            }),
            valuePrimitive: false,
            dataTextField: "employee.account.fullName",
            dataValueField: "employee.id",
            select: function (e) {
                const ecs = {
                    id: null,
                    active: true,
                    myTarget: true,
                    employee: e.dataItem,
                    // customerSector: angular.copy($scope.customerSector), // this gives circular reference
                    sector: null
                };

                $scope.addEmployeeCustomerSector(ecs);
                setTimeout(function () {
                    angular.element("#employees").data("kendoComboBox").value("");
                });
            }
        };

        $scope.addEmployeeCustomerSector = function (ecs) {
            if (CustomDataUtils.isNotNil(ecs)) {
                if ($scope.customerSector.employeeCustomerSectors.filter(function (e) { return e.employee.id === ecs.employee.id }).length < 1) {
                    // Not exist, add it
                    $scope.customerSector.employeeCustomerSectors.push(ecs);
                }else {
                    // Exist, make it active
                    for (var i=0; i<$scope.customerSector.employeeCustomerSectors.length; i++) {
                        if ($scope.customerSector.employeeCustomerSectors[i].employee.id === ecs.employee.id) {
                            $scope.customerSector.employeeCustomerSectors[i].active = true;
                            break;
                        }
                    }
                }
                angular.element(window).triggerHandler('resize'); // this refresh md-list
            }
        };

        $scope.removeEmployeeCustomerSector = function (ecs) {
            if (CustomDataUtils.isNotNil(ecs)) {
                ecs.active = false;
                angular.element(window).triggerHandler('resize'); // this refresh md-list
            }
        };

        $scope.getTotalActiveEmployees = function () {
            var total = 0;
            if (CustomDataUtils.isNotEmpty($scope.customerSector.employeeCustomerSectors)){
                $scope.customerSector.employeeCustomerSectors.forEach(function (ecs) {
                    if (ecs.active === true) {
                        total++;
                    }
                })
            }

            return total;

        };

        $scope.isMyTargetDisabled = function (ecs) {
            if ($scope.fullEdit) {
                return false;
            }else {
                return ecs.employee.id !== $scope.employee.id;
            }
        };

        $scope.onEmployeeCustomerSectorClick = function (ecs) {
            // exist to make md-list clickable
        };

        $scope.navigateToSector = function () {
            $state.go('sectorInfo', {id: $scope.customerSector.sector.id});
            $scope.closeDialog(null);
        };

        $scope.showNavigateToSectorButton = function () {
            if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR'])){
                return true;
            }else {
                return CustomDataUtils.isNotNil($scope.customerSector.sector.sectorType) && $scope.customerSector.sector.sectorType.isPrivate === true;
            }
        };

        /**
         * Closes the dialog.
         * @param result Should be 'success', 'error', null
         */
        $scope.closeDialog = function (result) {
            if (isDlgOpen) return;

            isDlgOpen = false;

            if (CustomDataUtils.isNotNil(result)) {
                switch(result) {
                    case 'success':
                        // hide calls the success callback
                        $mdDialog.hide(result);
                        break;
                    case 'error':
                        // cancel calls the error callback
                        $mdDialog.cancel(result);
                        break
                }
            }else {
                // hide calls the success callback
                $mdDialog.hide(null);
            }
        };

        $scope.update = function () {
            if (CustomDataUtils.isNotNil($scope.customerSector.id)) {
                if (CustomDataUtils.isNotNil($scope.customerSector.startedAt)) {
                    $scope.customerSector.startedAt = kendo.toString(formatLocalDateToServer($scope.customerSector.startedAt), "yyyy-MM-dd");
                }
                if (CustomDataUtils.isNotNil($scope.customerSector.endedAt)) {
                    $scope.customerSector.endedAt = kendo.toString(formatLocalDateToServer($scope.customerSector.endedAt), "yyyy-MM-dd");
                }

                $http.put('/api/customer-sectors', $scope.customerSector).success(function () {
                    $scope.closeDialog('success');
                }).error(function () {
                    $scope.closeDialog('error');
                    // Alerts.showAlert("Sigma SalesForce", "Κάποιο σφάλμα προέκυψε", "ΟΚ");
                });
            }
        };

        function prepare(customerSectorObject) {
            var result = angular.copy(customerSectorObject);
            if (CustomDataUtils.isNotNil(result)) {
                if (CustomDataUtils.isNotNil(result.startedAt)) {
                    result.startedAt = kendo.toString(kendo.parseDate(result.startedAt), 'dd/MM/yyyy');
                }
                if (CustomDataUtils.isNotNil(result.endedAt)) {
                    result.endedAt = kendo.toString(kendo.parseDate(result.endedAt), 'dd/MM/yyyy');
                }
                if (!CustomDataUtils.isNotNil(result.sector)) {
                    result.sector = {};
                }
                if (!CustomDataUtils.isNotNil(result.customer)) {
                    result.customer = {};
                }
                if (!CustomDataUtils.isNotEmpty(result.employeeCustomerSectors)) {
                    result.employeeCustomerSectors = [];
                }
            }

            return result;
        }

        /**
         * Converts a date string to Date object
         * @param dateString The date string in dd/MM/yyyy format
         * @returns A Date object
         */
        function formatLocalDateToServer(dateString) {
            if (CustomDataUtils.isNotNil(dateString)) {
                var dateParts = dateString.split("/");
                return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            }

            return dateString;
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('sigmasfApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('sigmasfApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-sigmasfApp-error');
                var entityKey = httpResponse.headers('X-sigmasfApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('sigmasfApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('sigmasfApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-sigmasfApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-sigmasfApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('sigmasfApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "el"');
                $cookies.putObject(name, 'el');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('el');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('sigmasfApp')
        .constant('VERSION', "0.0.2-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR',
            'ROLE_HEALTH_VISITOR', 'ROLE_PATCH_VISITOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE',
            'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_FRONT_DESK', 'ROLE_BC_VISITOR',
            'ROLE_PHARM_SUPERVISOR', 'ROLE_SYSTEM', 'ROLE_BI_VIEWER', 'ROLE_CHECKER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR',
            'ROLE_HEALTH_VISITOR', 'ROLE_PATCH_VISITOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE',
            'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_REC_FRONT_DESK', 'ROLE_BC_VISITOR',
            'ROLE_PHARM_SUPERVISOR', 'ROLE_BI_VIEWER', 'ROLE_CHECKER'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.setActive = setActive;
        vm.totalItems = null;
        vm.users = [];


        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function loadAll () {
            User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

                //hide anonymous user from user management: it's a required user for Spring Security
                for(var i in result) {
                    if(result[i]['login'] === 'anonymoususer') {
                        result.splice(i,1);
                    }
                }
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('sigmasfApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
/**
 * Created by Teo on 03/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('custom-procedures', {
                parent: 'admin',
                url: '/custom-procedures',
                data: {
                    authorities: ['ROLE_SYSTEM'],
                    pageTitle: 'Διαδικασίες'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/custom-procedures/custom-procedures.html',
                        controller: 'CustomProceduresController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
;
/**
 * Created by Teo on 03/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomProceduresController', CustomProceduresController);

    CustomProceduresController.$inject = ['$http', '$filter', 'CustomUtils'];

    function CustomProceduresController ($http, $filter, CustomUtils) {
        var vm = this;
        vm.pageHeading = $filter('translate')('global.menu.admin.custom-procedures');
        vm.contentHeight = CustomUtils.getHeightPixelsFromPercentage(64);
        vm.showProgress = false;

        vm.startProcess = function () {
            vm.showProgress = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$http', 'Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController ($http, Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        $http.get('/api/employees/me')
            .success(function (response,status,headers) {
                vm.user = response;
            })
            .error(function (response) {
                console.log(response);
            });

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                $http.put('/api/employees', vm.user)
                    .success(function (response) {
                        vm.error = null;
                        vm.success = 'OK';
                    })
                    .error(function (response) {
                        vm.success = null;
                        vm.error = 'ERROR';
                        console.log(response);
                    });
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("sigmasfApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div id=\"home\"><div class=\"pull-left home-image\"><div class=\"image-responsive\"></div></div><div class=\"pull-right contact-form\"><div class=\"home-title\">Τμήμα Υποστήριξης Επαγγελματιών Υγείας</div><div class=\"full-width\"><div class=\"contact-label\"><i class=\"material-icons label-icon\" style=\"color: #0074bc\">phone</i><label style=\"color: #0074bc\">Αστική Χρέωση Πανελλαδικά</label></div><div class=\"addressWrap\"><div class=\"number\"><a href=\"tel:8011165100\">801 11 65100</a></div></div></div><div class=\"\"><i class=\"material-icons label-icon\">phone</i><label>Αθήνα</label></div><div class=\"addressWrap\"><div class=\"number\"><a href=\"tel:2107470040\">210 74 700 40</a></div></div><div class=\"\"><i class=\"material-icons label-icon\">phone</i><label>Θεσσαλονίκη</label></div><div class=\"addressWrap\"><div class=\"number\"><a href=\"tel:2310482300\">2310 482 300</a></div><div class=\"number\"><a href=\"tel:2310935340\">2310 935 340</a></div><div class=\"number\"><a href=\"tel:2310935490\">2310 935 490</a></div></div></div><div class=\"clearfix\"></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/custom-procedures/custom-procedures.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-build-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div flex-xs flex-gt-xs=\"33\" layout=\"column\"><md-card md-theme=\"\'default\'\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">Παραγγελίες</span> <span class=\"md-subhead\">Διόρθωση Τιμών/Αξιών Παραγγελιών</span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" ng-show=\"vm.showProgress\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><!--<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\">\n                        <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n                    </div>--></md-card-title-media></md-card-title><md-card-actions layout=\"row\" layout-align=\"end center\"><!--<md-button>Action 1</md-button>--><md-button ng-click=\"vm.startProcess();\">Έναρξη</md-button></md-card-actions></md-card></div></md-content>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/entity-audit/entity-audit.detail.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Audit Details</h4></div><div class=\"modal-body pad\"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class=\"diff diff-key\">Old/Removed value</del> &nbsp; <ins class=\"diff diff-key\">New/Added value</ins></div><br><label>Changed Fields</label><pre id=\"resultChanges\" ng-bind-html=\"vm.diffValueChanges\"></pre><label>All Fields</label><pre id=\"result\" ng-bind-html=\"vm.diffValue\"></pre></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/entity-audit/entity-audits.html","<div ng-cloak class=\"pad\"><div class=\"row\"><h3 class=\"col-sm-12\">Entity Audits</h3></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 pad\"><h4>Filter</h4><form name=\"auditForm\" role=\"form\" novalidate show-validation><div class=\"row\"><div class=\"col-md-8 form-group\"><label>Entity/Table</label><select class=\"input-sm form-control\" name=\"qualifiedName\" id=\"qualifiedName\" required ng-options=\"vm.getEntityName(entity) for entity in vm.entities\" ng-model=\"vm.qualifiedName\"></select><div ng-show=\"auditForm.qualifiedName.$invalid\"><p class=\"help-block\" ng-show=\"auditForm.qualifiedName.$error.required\">This field is required</p></div></div><div class=\"col-md-4 form-group\"><label>Limit to</label><select class=\"input-sm form-control\" name=\"limit\" id=\"limit\" required ng-options=\"option for option in vm.limits\" ng-model=\"vm.limit\"></select></div></div><div class=\"row pad\"><button ng-disabled=\"auditForm.$invalid\" class=\"btn btn-primary pull-right\" ng-click=\"vm.loadChanges()\"><i class=\"glyphicon glyphicon-import\"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show=\"!vm.loading\"><div class=\"table-responsive\" ng-if=\"vm.audits.length > 0\"><p ng-if=\"vm.qualifiedName\">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class=\"form-inline\"><div class=\"form-group\"><label for=\"searchField\">Filter:</label><input type=\"text\" class=\"form-control\" id=\"searchField\" ng-model=\"filter.$\" placeholder=\"global filter\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"searchFieldEntityId\" ng-model=\"filter.entityId\" placeholder=\"entity id filter\"></div></form><table class=\"table table-bordered table-hover table-striped\"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class=\"glyphicon glyphicon-eye-open\"></i></th></tr></thead><tbody><tr ng-repeat=\"audit in vm.audits | filter:filter\"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class=\"audit-obj\" ng-bind-html=\"vm.format(audit.entityValue)\"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class=\"no-pad\">\n                        <div class=\"audit-obj\">\n                            <table class=\"table table-bordered table-hover no-margin\">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                                <tr ng-repeat=\"(k,v) in audit.entityValue\" ng-if=\"!vm.isObject(v)\">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if=\"vm.isDate(k)\">{{v | date:\'medium\'}}</span>\n                                        <span ng-if=\"!vm.isDate(k)\">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type=\"button\" ng-click=\"vm.openChange(audit)\" uib-tooltip=\"View Audit Change Details\" uib-tooltip-placement=\"auto\" class=\"btn btn-info btn-xs\"><i class=\"glyphicon glyphicon-eye-open\"></i></button></td></tr></tbody></table></div><p ng-if=\"vm.displayedChanges.length == 0\">No Data found for the filters</p></div></div>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"multiple\" name=\"authority\" ng-model=\"vm.user.authorities\" ng-options=\"authority for authority in vm.authorities\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"global.field.id\">ID</th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th></th><th translate=\"userManagement.langKey\">Lang Key</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.createdDate\">Created Date</th><th translate=\"userManagement.lastModifiedBy\">Last Modified By</th><th translate=\"userManagement.lastModifiedDate\">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"settings.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"settings.messages.error.fail\"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\">Χρήση γεωγραφικών δεδομένων:</label><div class=\"btn-group no-outline\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.user.geodata\" uib-btn-radio=\"true\">Ναι</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.user.geodata\" uib-btn-radio=\"false\">Όχι</label></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/components/edit-customer-sector-dialog/edit-customer-sector-dialog.html","<md-dialog aria-label=\"Edit Customer Sector\" style=\"max-height: 100%\"><md-toolbar style=\"background-color: #0074BC\"><div class=\"md-toolbar-tools\"><h2>Επεξεργασία Μονάδας Υγείας</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(null)\"><md-icon md-svg-src=\"content/images/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"edit-cs-dialog-content\"><div layout=\"column\"><div flex=\"33\" style=\"padding-bottom: 6px\"><div class=\"md-primary edit-cs-section-header\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">business</i></md-icon>Στοιχεία Μονάδας Υγείας</div><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorName\" name=\"sectorName\" value=\"{{customerSector.sector.name}}\" ng-model=\"customerSector.sector.name\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Όνομα\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τύπος:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorType\" name=\"sectorType\" value=\"{{customerSector.sector.sectorType.name}}\" ng-model=\"customerSector.sector.sectorType.name\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Τύπος\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ανήκει στη Μ.Υ.:</label></div><div flex=\"60\"><input type=\"text\" id=\"parentSector\" name=\"parentSector\" value=\"{{customerSector.sector.parent.name}}\" ng-model=\"customerSector.sector.parent.name\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Ανήκει στη Μ.Υ.\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorBrick\" name=\"sectorBrick\" value=\"{{customerSector.sector.brick}}\" ng-model=\"customerSector.sector.brick\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Brick\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick ΟΣΦΕ:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorBrickOsfe\" name=\"sectorBrickOsfe\" value=\"{{customerSector.sector.brick}}\" ng-model=\"customerSector.sector.osfeBrick\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Brick ΟΣΦΕ\" ng-disabled=\"true\"></div></div></div><div flex=\"50\" style=\"padding-left: 20px\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorCityName\" name=\"sectorCityName\" value=\"{{customerSector.sector.cityName}}\" ng-model=\"customerSector.sector.cityName\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Πόλη\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorPrefectureName\" name=\"sectorPrefectureName\" value=\"{{customerSector.sector.prefectureName}}\" ng-model=\"customerSector.sector.prefectureName\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Νομός\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>ΤΚ:</label></div><div flex=\"60\"><input type=\"text\" id=\"sectorPostalCode\" name=\"sectorPostalCode\" value=\"{{customerSector.sector.postalCode}}\" ng-model=\"customerSector.sector.postalCode\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"ΤΚ\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση / Αριθμός:</label></div><div flex=\"50\"><input type=\"text\" id=\"sectorAddress\" name=\"sectorAddress\" value=\"{{customerSector.sector.address}}\" ng-model=\"customerSector.sector.address\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Διεύθυνση\" ng-disabled=\"true\"></div><div flex=\"10\"><input type=\"text\" id=\"sectorAddressNum\" name=\"sectorAddressNum\" value=\"{{customerSector.sector.addressNum}}\" ng-model=\"customerSector.sector.addressNum\" class=\"k-textbox\" style=\"width: 100%\" ng-disabled=\"true\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"></div><div flex=\"60\"><md-button ng-click=\"navigateToSector()\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" ng-if=\"showNavigateToSectorButton()\">Μετάβαση στη Καρτέλα Μ.Υ.</md-button></div></div></div></div></div><md-divider></md-divider><div flex=\"33\"><div class=\"md-primary edit-cs-section-header\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">account_circle</i></md-icon>Στοιχεία Επικοινωνίας με Επαγγελματία Υγείας</div><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ημερ. Έναρξης:</label></div><div flex=\"60\"><input id=\"startedAt\" name=\"startedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" ng-model=\"customerSector.startedAt\" style=\"width: 100%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ημερ. Λήξης:</label></div><div flex=\"60\"><input id=\"endedAt\" name=\"endedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" ng-model=\"customerSector.endedAt\" style=\"width: 100%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Θέση:</label></div><div flex=\"60\"><select id=\"sectorPosition\" name=\"sectorPosition\" kendo-combo-box k-ng-model=\"customerSector.sectorPosition.id\" k-options=\"sectorPositionComboBoxOptions\" style=\"width: 100%\"></select><span class=\"k-invalid-msg\" data-for=\"district\"></span></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"text\" id=\"phone\" name=\"phone\" value=\"{{customerSector.phone}}\" ng-model=\"customerSector.phone\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Τηλέφωνο\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Βασική Μονάδα:</label></div><div flex=\"60\"><md-checkbox class=\"green\" ng-model=\"customerSector.main\" aria-label=\"Βασική Μονάδα\"></md-checkbox></div></div></div><div flex=\"50\" style=\"padding-left: 20px\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Δευτέρα:</label></div><div flex=\"60\"><select id=\"wh-monday\" name=\"wh-monday\" kendo-combo-box k-ng-model=\"customerSector.monday\" k-options=\"workingHoursComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τρίτη:</label></div><div flex=\"60\"><select id=\"wh-tuesday\" name=\"wh-tuesday\" kendo-combo-box k-ng-model=\"customerSector.tuesday\" k-options=\"workingHoursComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τετάρτη:</label></div><div flex=\"60\"><select id=\"wh-wednesday\" name=\"wh-wednesday\" kendo-combo-box k-ng-model=\"customerSector.wednesday\" k-options=\"workingHoursComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πέμπτη:</label></div><div flex=\"60\"><select id=\"wh-thursday\" name=\"wh-thursday\" kendo-combo-box k-ng-model=\"customerSector.thursday\" k-options=\"workingHoursComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Παρασκευή:</label></div><div flex=\"60\"><select id=\"wh-friday\" name=\"wh-friday\" kendo-combo-box k-ng-model=\"customerSector.friday\" k-options=\"workingHoursComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div></div></div></div><md-divider></md-divider><div flex=\"33\"><div class=\"md-primary edit-cs-section-header\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">assignment_ind</i></md-icon>Ιατρικοί Επισκέπτες σε αυτή τη Μονάδα Υγείας</div><div layout=\"row\"><div flex=\"50\"><md-list style=\"height: 150px; overflow-y: scroll; width: 100%\" flex><md-list-item ng-repeat=\"ecs in customerSector.employeeCustomerSectors track by ecs.employee.id\" ng-if=\"ecs.active === true\" ng-click=\"onEmployeeCustomerSectorClick(ecs)\"><md-icon md-svg-icon=\"content/images/account_box-24px.svg\"></md-icon><p>{{ ecs.employee.account.lastName + \" \" + ecs.employee.account.firstName }}</p><md-checkbox class=\"md-secondary green\" ng-model=\"ecs.myTarget\" ng-disabled=\"isMyTargetDisabled(ecs)\">MyTarget</md-checkbox><md-icon ng-show=\"fullEdit || ecs.employee.id === employee.id\" class=\"md-secondary\" ng-click=\"removeEmployeeCustomerSector(ecs)\" md-svg-icon=\"content/images/baseline-clear-24px.svg\"><md-tooltip md-direction=\"bottom\">Αφαίρεση</md-tooltip></md-icon></md-list-item></md-list><span>Σύνολο: {{ getTotalActiveEmployees() }} Ιατρικοί Επισκέπτες</span></div><div flex=\"50\" style=\"padding-left: 20px\"><select id=\"employees\" name=\"employees\" kendo-combo-box k-options=\"searchEmployeesComboBoxOptions\" class=\"col-fix\" style=\"width: 100%\"></select></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"closeDialog(null)\">Ακυρο</md-button><md-button ng-click=\"update()\">Ενημέρωση</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/event-cycle-md-dialog/event-cycle-md-dialog-template.html","<md-dialog aria-label=\"Event Cycle\"><form ng-cloak name=\"eventCycleForm\"><md-toolbar style=\"background-color: #0074BC\"><div class=\"md-toolbar-tools\"><h2>Κύκλος Επισκέψεων</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon md-svg-src=\"content/images/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><h4>Εισάγεται τον αριθμό για τον Κύκλο Επισκέψεων. Καθορίζει πότε οι ημέρες της τελευταίας επίσκεψης ξεπερνούν το όριο και εμφανίζοντε με κόκκινο χρώμα.</h4><p style=\"padding-top: 5px\"><md-input-container class=\"md-block\"><label>Αριθμός Κύκλου Επισκέψεων</label><input type=\"number\" min=\"0\" id=\"eventCycleValue\" name=\"eventCycleValue\" ng-model=\"eventCycle.value\" required><div><div style=\"color: red\">{{ message }}</div></div></md-input-container></p></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancelDialog()\">Ακυρο</md-button><md-button ng-click=\"update()\">Ενημέρωση</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/follow-ups-md-toast/md-toast-template.html","<md-toast><div layout=\"row\" layout-wrap layout-align=\"center center\"><div layout-align=\"center\"><md-icon><i class=\"material-icons\" style=\"color: white\">settings_phone</i></md-icon></div><div><span class=\"md-toast-text\" flex>Υπάρχουν νέες Εκκρεμότητες!</span></div><div><md-button class=\"md-highlight\" style=\"color: #F9A22E\" ng-click=\"showFollowUps();\">Προβολή</md-button></div><div><md-button ng-click=\"closeToast()\">Κλείσιμο</md-button></div></div><!--<span class=\"md-toast-text\" flex>Custom toast!</span>\n    <md-button class=\"md-highlight\" ng-click=\"openMoreInfo($event)\">\n        More info\n    </md-button>\n    <md-button ng-click=\"closeToast()\">\n        Κλείσιμο\n    </md-button>--></md-toast>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\" style=\"background-color: #0074bc\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\" style=\"color: white!important\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\" style=\"color: white\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><!--<div class=\"col-md-4 col-md-offset-4\">\n            <h1 translate=\"login.title\">Sign in</h1>\n        </div>--><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!--<div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>\n                You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a>\n            </div>--></div></div></div>");
$templateCache.put("app/components/md-dialog/dialog-template.html","<div class=\"md-dialog-container\"><md-dialog aria-label=\"Customer Already Exists\"><div layout=\"row\"><h3 style=\"padding: 15px\" flex>Ο επαγγελματίας υγείας υπάρχει ήδη! Θέλετε να συνεχίσετε?</h3></div><md-dialog-content><md-list flex><div ng-repeat=\"item in vm.existedCustomers\"><md-list-item class=\"md-3-line\" ng-click=\"vm.getSectors($index, item)\"><img data-ng-src=\"{{\'data:\' + item.profilePhotoContentType + \';base64,\' + item.profilePhoto}}\" class=\"md-avatar\" ng-if=\"item.profilePhoto\"> <img ng-src=\"content/images/customer_icon.png\" alt=\"Profile Picture\" class=\"md-avatar\" ng-if=\"!item.profilePhoto\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.lastName }} {{ item.firstName }}</h3><p>{{ item.doctorSpecialty.name }}</p></div><i ng-show=\"vm.clicked[$index]\" class=\"material-icons\">keyboard_arrow_up</i> <i ng-show=\"!vm.clicked[$index]\" class=\"material-icons\">keyboard_arrow_down</i></md-list-item><md-card md-theme=\"\'default\'\" md-theme-watch style=\"margin-left: 10%\"><div ng-show=\"vm.clicked[$index] && item.sectors.length\"><md-subheader class=\"md-no-sticky\">Μονάδες Υγείας</md-subheader><md-list-item class=\"md-3-line\" ng-repeat=\"sector in item.sectors\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ sector.sector.name }}</h3><h4>{{ sector.sector.prefectureName }}</h4><p>{{ sector.sector.sectorType.name }}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></div></md-card></div></md-list></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\">Άκυρο</md-button><md-button ng-click=\"vm.confirmSave()\" class=\"md-primary\">Αποθήκευση</md-button></md-dialog-actions></md-dialog></div>");
$templateCache.put("app/components/md-toast/toast-template.html","<md-toast><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\" md-diameter=\"20px\"></md-progress-circular></div><span class=\"md-toast-text\" flex>Οι εγγραφές ενημερώνονται, παρακαλώ περιμένετε...</span><!--<md-button class=\'md-icon-button\' aria-label=\'Remove\' ng-click=\'vm.closeToast()\'>--><!--<md-icon class=\'remove-white\'></md-icon>--><!--</md-button>--></md-toast>");
$templateCache.put("app/displays/adminAgreements/adminAgreements.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-feedback-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminCustomers/adminCustomers.html","<div id=\"customers\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-account_circle-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddCustomerClick()\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_ADMIN\", \"ROLE_MANAGEMENT\", \"ROLE_SUPERVISOR\"])\'><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Επαγγελματία Υγείας</span></md-button></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_customers\"></div><div kendo-tooltip k-options=\"vm.toolTipOptions\"><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid></div></div>");
$templateCache.put("app/displays/adminCustomers/adminCustomerView.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-account_circle-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex>{{vm.customer.firstName}} {{vm.customer.lastName}}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <div class=\"md-media-lg card-media\">\n                                        <img data-ng-src=\"{{\'data:\' + vm.customer.profilePhotoContentType + \';base64,\' + vm.customer.profilePhoto}}\" style=\"max-width: 100%;\" ng-if=\"vm.customer.profilePhoto\"/>\n                                        <img ng-src=\"content/images/customer_icon.png\" alt=\"Profile Picture\" style=\"width:150px;height:150px;\" ng-if=\"!vm.customer.profilePhoto\" />\n                                    </div>\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-headline\">{{vm.customer.firstName}} {{vm.customer.lastName}}</span>\n                                    <span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Ειδικότητα : </b>{{vm.customer.doctorSpecialty.name}}</span></span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Κατηγορία :</b> {{vm.customer.customerCategory.name}}</span></span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Υποκατηγορία :</b> {{vm.customer.customerSubCategory.name}}</span></span>\n                                    <span class=\"md-subhead\"><md-button style=\"margin-left: 0;\">\n                                        <a type=\"file\" ngf-select ngf-change=\"vm.setProfilePhoto($file, vm.customer)\" accept=\"image/*\">\n                                            {{ (vm.customer.profilePhoto == null) ? \"Προσθήκη εικόνας\" : \"Αλλαγή εικόνας\" }}\n                                        </a>\n                                    </md-button></span>\n                                </md-card-title-text>\n\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"customerInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Επαγγελματία Υγείας</li><li ng-show=\"vm.showCustomerSectorsTab\" ui-sref=\"customerSectors\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerSectors\')}\"><i class=\"material-icons\">business</i>Μονάδες Υγείας</li><li ui-sref=\"customerEvents\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerEvents\')}\"><i class=\"material-icons\">date_range</i>Επισκέψεις</li><li has-authority=\"ROLE_HEALTH_VISITOR\" ui-sref=\"customerScheduler\" application-parameters=\"Scheduling\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT,ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR, ROLE_PATCH_VISITOR\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerScheduler\')}\"><i class=\"material-icons\">today</i>Ατζέντα</li><li ui-sref=\"customerAgreements\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerAgreements\')}\"><i class=\"material-icons\">announcement</i>Αξιολόγηση</li><li has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PATCH_VISITOR\" ng-show=\"vm.canPatchReport\" application-parameters=\"Patches\" ui-sref=\"customerPatchReports.pending\" ng-class=\"{\'k-state-active\': vm.$state.includes(\'customerPatchReports\')}\"><i class=\"material-icons\">description</i>Γνωματεύσεις</li><li has-any-authority=\"ROLE_CHECKER\" ng-show=\"vm.hasMedReport\" ui-sref=\"customerMedReportsWithLines\" ng-class=\"{\'k-state-active\': vm.$state.includes(\'customerMedReportsWithLines\')}\"><i class=\"material-icons\">description</i>Report</li><li ui-sref=\"customerNotes\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerNotes\')}\"><i class=\"material-icons\">event_note</i>Σημειώσεις</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/adminCycleReport/adminCycleReport.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\">Ιατρικοί Επισκέπτες</li></ul><div><div kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid>");
$templateCache.put("app/displays/adminEvents/adminEvents.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-date_range-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span> <span flex></span><label style=\"padding-right: 20px; font-weight: normal\">Επισκέψεις σε:</label><md-select ng-model=\"vm.eventTarget\" id=\"eventTargetSelect\" ng-change=\"vm.onEventTargetChange()\" style=\"min-width: 190px\"><md-option value=\"all\">Όλα</md-option><md-option value=\"customers\">Επαγγελματίες Υγείας</md-option><md-option value=\"sectors\">Μονάδες Υγείας</md-option></md-select></h2></div></md-toolbar><div kendo-tooltip k-options=\"vm.toolTipOptions\"><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\">Αξιολόγηση Επισκέψεων</li></ul><div><div kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid></div>");
$templateCache.put("app/displays/adminEmployees/adminEmployees.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment_ind-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-checkbox aria-label=\"isActive\" ng-model=\"vm.isActive\" ng-change=\"vm.onFilterChange()\" class=\"checkbox-toolbar green inline\"><label style=\"color: white; font-size: 14px\">Ενεργός</label></md-checkbox><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddEmployeeClick()\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_ADMIN\", \"ROLE_REC_ADMINISTRATOR\"])\'><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Ιατρικού Επισκέπτη</span></md-button></h2></div></md-toolbar><!--<div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_customers\"></div>--><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\" class=\"multi-filter-column\"></kendo-grid>");
$templateCache.put("app/displays/adminEmployees/adminEmployeeView.html","<div class=\"entity-view clearfix\"><div id=\"employee\" class=\"tabstrip-custom\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><!--<md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\">\n                        <md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility_new-24px.svg\"></md-icon>\n                    </md-toolbar-filler>--><h2 class=\"md-toolbar-tools\"><span>{{ vm.user ? vm.user.lastName + \" \" + vm.user.firstName : \"Ιατρικός Επισκέπτης Χωρίς Όνομα\" }}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <img ng-src=\"content/images/{{vm.profilePicture}}\" alt=\"Profile Picture\" style=\"width:150px;height:150px;\">\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-headline\">{{vm.user.firstName}} {{vm.user.lastName}}</span>\n                                    <span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Email : </b>{{vm.user.email}}</span></span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Τηλέφωνο :</b> {{vm.employee.phone}}</span></span>\n                                </md-card-title-text>\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"userInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'userInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Ιατρικού Επισκέπτη</li><!--<li ui-sref=\"employeeInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Ιατρικού Επισκέπτη</li>--><li ng-hide=\"!vm.user.authorities.includes(\'ROLE_HEALTH_VISITOR\')\" ui-sref=\"employeeCustomerSectors\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeCustomerSectors\')}\"><i class=\"material-icons\">account_circle</i>Επαγγελματίες Υγείας</li><li ng-hide=\"!vm.user.authorities.includes(\'ROLE_HEALTH_VISITOR\')\" ui-sref=\"employeeSectors\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeSectors\')}\"><i class=\"material-icons\">business</i>Διαχείριση Μονάδων Υγείας</li><li has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PHARM_SUPERVISOR\" ng-hide=\"!vm.user.authorities.includes(\'ROLE_PHARM_VISITOR\')\" ui-sref=\"employeePharmacies\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeePharmacies\')}\" application-parameters=\"Visit_Pharmacies\"><i class=\"material-icons\">business</i>Φαρμακεία</li><li has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" ng-hide=\"!vm.user.authorities.includes(\'ROLE_BC_VISITOR\')\" ui-sref=\"employeeBeautyCenters\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeBeautyCenters\')}\" application-parameters=\"Visit_Beauty_Centers\"><i class=\"material-icons\">spa</i>Κέντρα Αισθητικής</li><li ui-sref=\"employeeEvents\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeEvents\')}\"><i class=\"material-icons\">date_range</i>Επισκέψεις</li><li ui-sref=\"employeeSchedules\" application-parameters=\"Scheduling\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_PHARM_SUPERVISOR\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeSchedules\')}\"><i class=\"material-icons md-light md-26\">alarm</i>Ραντεβού</li><li ui-sref=\"employeeAgreements\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeAgreements\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP\"><i class=\"material-icons\">announcement</i>Αξιολόγηση</li><li has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Patches\" ui-sref=\"employeePatchReports.pending\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeePatchReports\')}\"><i class=\"material-icons\">description</i>Γνωματεύσεις</li><li ui-sref=\"employeePurchases\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeePurchases\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\" extra-application-parameters=\"Purchase_Pharmacies\"><i class=\"material-icons\">add_shopping_cart</i>Παραγγελίες</li><li has-any-authority=\"ROLE_CHECKER\" ng-show=\"vm.hasMedReport\" ui-sref=\"employeeMedReportsSumsPerMonth\" ng-class=\"{\'k-state-active\': vm.$state.includes(\'employeeMedReportsSumsPerMonth\')}\"><i class=\"material-icons\">description</i>Report</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"userNotification\" style=\"display:none\"></span> <span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/adminPatchCustomers/adminPatchCustomers.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminPatchDoctors/adminPatchDoctors.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-group-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" k-on-change=\"vm.onSelection(data)\"></kendo-grid>");
$templateCache.put("app/displays/adminPharmacies/adminPharmacies.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-business-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button class=\"md-raised md-mini md-primary k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_SYSTEM\", \"ROLE_ADMIN\", \"ROLE_MANAGEMENT\", \"ROLE_SUPERVISOR\", \"ROLE_ACCOUNTING_DEP\", \"ROLE_PHARM_SUPERVISOR\"])\' ng-click=\"vm.onExcelExportClick()\" ng-disabled=\"vm.showProgress === true\"><span class=\"k-icon k-i-excel\"></span>Export</md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddPharmacyClick()\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_SYSTEM\", \"ROLE_ADMIN\", \"ROLE_MANAGEMENT\", \"ROLE_SUPERVISOR\", \"ROLE_ACCOUNTING_DEP\", \"ROLE_PHARM_SUPERVISOR\"])\' ng-disabled=\"vm.showProgress === true\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Φαρμακείου</span></md-button></h2></div></md-toolbar><div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_pharmacies\"></div><kendo-grid id=\"pharmaciesGrid\" options=\"vm.pharmaciesGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.pharmaciesGridOptions\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"padding-top: 70px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor_pharmacies\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"sector-info full-width\"><h5>Στοιχεία Φαρμακείου</h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"name\" ng-model=\"dataItem.name\" data-bind=\"value:name\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Α.Φ.Μ. *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"vat\" ng-model=\"dataItem.vat\" data-bind=\"value:vat\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Εταιρική Μορφή:</label></div><div flex=\"60\"><select name=\"companyType\" id=\"companyTypeEdit\" kendo-combo-box data-bind=\"value:companyType.id\" k-options=\"vm.companyTypesComboBoxOptions\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Καθεστώς Φ.Π.Α.:</label></div><div flex=\"60\"><select name=\"taxStatus\" id=\"taxStatus\" kendo-combo-box data-bind=\"value:taxStatus.id\" k-options=\"vm.taxStatusesComboBoxOptions\" required></select></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"brick\" ng-model=\"vm.sector.brick\" data-bind=\"value:brick\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>OSFE Brick:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"osfeBrick\" ng-model=\"vm.sector.osfeBrick\" data-bind=\"value:osfeBrick\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κωδικός Ε.Ε.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"code\" ng-model=\"vm.sector.code\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πιστωτικός Έλεγχος:</label></div><div flex=\"60\"><input id=\"creditControlCheck\" name=\"creditControlCheck\" type=\"checkbox\" ng-model=\"vm.sector.creditControlCheck\" class=\"checkbox inline info\" placeholder=\"Πιστωτικός Έλεγχος\"></div></div></div></div><h5>Στοιχεία Διεύθυνσης</h5><div layout=\"column\"><div layout=\"row\" ng-show=\"!vm.geodata\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectures\" kendo-combo-box k-ng-model=\"vm.selectedSector.prefecture\" ng-model=\"vm.selectedSector.prefectureName\" k-options=\"vm.prefecturesComboBoxOptions\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cities\" kendo-combo-box k-ng-model=\"vm.selectedSector.city\" ng-model=\"vm.selectedSector.cityName\" k-options=\"vm.citiesComboBoxOptions\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.selectedSector.address\" name=\"address\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-change=\"vm.suggestBricks(dataItem.postalCode)\" ng-model=\"dataItem.postalCode\" data-bind=\"value:postalCode\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.selectedSector.addressNum\" name=\"addressNum\"></div></div></div></div><div layout=\"column\" ng-show=\"vm.geodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 80%\"><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"prefectureName\" ng-model=\"vm.sector.prefectureName\" data-bind=\"value:prefectureName\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"cityName\" ng-model=\"vm.sector.cityName\" data-bind=\"value:cityName\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.address\" data-bind=\"value:address\" required></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\" ng-model=\"vm.sector.addressNum\" data-bind=\"value:addressNum\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" ng-model=\"vm.sector.postalCode\" data-bind=\"value:postalCode\"></div></div></div></div></div><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\" ng-model=\"dataItem.phone\" data-bind=\"value:phone\" required></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο 2:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone2\" ng-model=\"dataItem.phone2\" data-bind=\"value:phone2\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/displays/adminPharmacies/adminPharmacyView.html","<div class=\"entity-view clearfix\"><div id=\"pharmacy\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-business-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <img ng-src=\"content/images/{{vm.profilePicture}}\" alt=\"MS Picture\" style=\"width:150px;height:150px;\">\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Όνομα : </b>{{vm.sector.name}}</span></span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Τηλέφωνο :</b> {{vm.sector.phone}}</span></span>\n                                </md-card-title-text>\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"pharmacyInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'pharmacyInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Φαρμακείου</li><li ui-sref=\"pharmacyCustomers\" ng-class=\"{\'k-state-active\': vm.$state.is(\'pharmacyCustomers\')}\"><i class=\"material-icons\">face</i>Επαφές</li><li ui-sref=\"pharmacyEmployees\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_ACCOUNTING_DEP, ROLE_MANAGEMENT, ROLE_PHARM_SUPERVISOR\" ng-class=\"{\'k-state-active\': vm.$state.is(\'pharmacyEmployees\')}\"><i class=\"material-icons\">assignment_ind</i>Ιατρικοί Επισκέπτες</li><li ui-sref=\"pharmacyEvents\" ng-class=\"{\'k-state-active\': vm.$state.is(\'pharmacyEvents\')}\"><i class=\"material-icons\">date_range</i>Επισκέψεις</li><li ui-sref=\"pharmacyPurchases\" ng-class=\"{\'k-state-active\': vm.$state.is(\'pharmacyPurchases\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\" extra-application-parameters=\"Purchase_Pharmacies\"><i class=\"material-icons\">add_shopping_cart</i>Παραγγελίες</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/adminSchedules/adminSchedules.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-today-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div ng-switch on=\"vm.userAuth\"><div ng-switch-when=\"ROLE_MANAGEMENT\"><div id=\"schedules\"><select kendo-multi-select id=\"ownerMultiSelect\" multiple=\"multiple\" k-options=\"vm.ownerMultiOptions\" k-ng-model=\"vm.selectedCustomers\"></select></div><div style=\"padding: 1em\"><div kendo-tooltip k-content=\"vm.tooltipContent\" k-filter=\"\'.k-event\'\" class=\"k-group\"><kendo-scheduler id=\"scheduler\" k-options=\"vm.schedulerOptions\"><span k-event-template class=\"custom-event\"><span ng-show=\"vm.view == \'day\'\"><span ng-if=\"!dataItem.startedAt\"><i class=\"material-icons md-13\">alarm</i> ΡΑΝΤΕΒΟΥ,&nbsp;&nbsp; </span><span ng-if=\"dataItem.startedAt\"><i class=\"material-icons md-13\">date_range</i> {{dataItem.eventCategoryType.eventCategory.name}},&nbsp;&nbsp; </span><span class=\"glyphicon glyphicon-time\"></span> <span>{{dataItem.start | date : \'HH:mm\'}}</span> <span>&nbsp;-&nbsp;</span> <span>{{dataItem.end | date : \'HH:mm\'}},&nbsp;&nbsp;</span> <span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 1 && dataItem.eventCustomerSector.customerSector !== null && dataItem.eventCustomerSector.customerSector !== undefined\"><i class=\"material-icons md-13\">account_circle</i> {{dataItem.eventCustomerSector.customerSector.customer.lastName}}&nbsp;{{dataItem.eventCustomerSector.customerSector.customer.firstName}}, </span><span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 1 && dataItem.eventCustomerSector.sector !== null && dataItem.eventCustomerSector.sector !== undefined\"><i class=\"material-icons md-13\">business</i> {{dataItem.eventCustomerSector.sector.name}},&nbsp;&nbsp; </span><span class=\"glyphicon glyphicon-user\"></span> <span>{{dataItem.employee.account.lastName}}&nbsp;{{dataItem.employee.account.firstName}}</span> </span><span ng-show=\"vm.view == \'week\' || vm.view == \'month\'\"><span ng-if=\"dataItem.eventCustomerSector.customerSector.sector.sectorType.sectorTypeCategory === \'hcu\'\">{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span> <span>{{dataItem.eventCustomerSector.customerSector.customer.doctorSpecialty.name}}</span> <span ng-if=\"dataItem.eventCustomerSector.customerSector.customer.customerCategory\"><span>{{dataItem.eventCustomerSector.customerSector.customer.customerCategory.name}}</span> </span><span ng-if=\"dataItem.eventCustomerSector.customerSector.customer.customerSubCategory\"><span>, {{dataItem.eventCustomerSector.customerSector.customer.customerSubCategory.name}}<br></span></span><span ng-if=\"dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'beautyCenter\' ||\n                                         dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'pharmacy\' ||\n                                         dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'hcu\'\">{{dataItem.eventCustomerSector.sector.sectorType.name}}, {{dataItem.eventCustomerSector.sector.name}}&nbsp;&nbsp;</span> <span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 2\">{{ dataItem.eventCategoryType.eventType.name }}</span></span></span></kendo-scheduler></div></div><!-- ΕΠΙΣΚΕΨΗ --><div ng-if=\"vm.event && vm.event.eventCategoryType.eventCategory.id == 1\" class=\"clearfix\" style=\"padding-left: 1em; padding-right: 1em; padding-bottom: 1em\"><h3 ng-if=\"!vm.event.startedAt\" style=\"text-align: center; padding-bottom: 1em\">ΡΑΝΤΕΒΟΥ</h3><h3 ng-if=\"vm.event.startedAt\" style=\"text-align: center; padding-bottom: 1em\">{{ vm.event.eventCategoryType.eventType.name }}</h3><section class=\"well\"><div id=\"event\"><div class=\"form-horizontal form-widgets col-md-4\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας: MM</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.eventCustomerSector.communicationType.name }}</span></span><div class=\"k-edit-label\"><label>Τίτλος:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.title }}</span></span><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span ng-show=\"vm.event.isSchedule == \'1\'\" class=\"k-input k-textbox\">{{ vm.event.eventSchedule.description }}</span> <span ng-show=\"vm.event.isSchedule != \'1\'\" class=\"k-input k-textbox\">{{ vm.event.description }}</span></span></div><div class=\"form-horizontal form-widgets col-md-4\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.start | date : \'EEEE, d MMMM y\' }}</span></span><div class=\"k-edit-label\"><label>Ώρα:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.start | date : \'HH:mm\' }}</span></span><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.durationTime }}</span></span></div><div class=\"form-horizontal form-widgets col-md-4\"><div ng-if=\"vm.event.eventCustomerSector.customerSector !== null && vm.event.eventCustomerSector.customerSector !== undefined\"><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.eventCustomerSector.customerSector.customer.lastName}} {{ vm.event.eventCustomerSector.customerSector.customer.firstName}}</span></span><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.eventCustomerSector.customerSector.sector.name}}</span></span></div><div ng-if=\"vm.event.eventCustomerSector.sector !== null && vm.event.eventCustomerSector.sector !== undefined &&\n                                    (vm.event.eventCustomerSector.customerSector === null || vm.event.eventCustomerSector.customerSector === undefined)\"><div ng-if=\"vm.event.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'hcu\'\"><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\">{{ vm.event.eventCustomerSector.sector.name}}</span></div><div ng-if=\"vm.event.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'pharmacy\' || vm.event.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'beautyCenter\'\"><div class=\"k-edit-label\"><label>Κατάστημα:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\">{{ vm.event.eventCustomerSector.sector.name}}</span></div></div></div></div></section></div><!-- ΕΚΤΟΣ ΠΕΔΙΟΥ --><div ng-if=\"vm.event && vm.event.eventCategoryType.eventCategory.id == 2\" class=\"clearfix\" style=\"padding-left: 1em; padding-right: 1em; padding-bottom: 1em\"><h3 style=\"text-align: center; padding-bottom: 1em\">Άλλο Συμβάν - {{ vm.event.eventCategoryType.eventType.name }}</h3><section class=\"well\"><div id=\"otherEvent\"><div class=\"form-horizontal form-widgets col-md-4\"><div class=\"k-edit-label\"><label>Τίτλος:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.title }}</span></span><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.description }}</span></span><div class=\"k-edit-label\"><label>Ιατρικός Επισκέπτης:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.employee.account.lastName}} {{ vm.event.employee.account.firstName}}</span></span></div><div class=\"form-horizontal form-widgets col-md-4\"><div class=\"k-edit-label\"><label>Ημερομηνία Από:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.startedAt | date : \'EEEE, d MMMM y\' }}</span></span><div class=\"k-edit-label\"><label>Ώρα Από:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.startedAt | date : \'HH:mm\' }}</span></span></div><div class=\"form-horizontal form-widgets col-md-4\"><div class=\"k-edit-label\"><label>Ημερομηνία Εώς:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.finishedAt | date : \'EEEE, d MMMM y\' }}</span></span><div class=\"k-edit-label\"><label>Ώρα Εώς:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{ vm.event.finishedAt | date : \'HH:mm\' }}</span></span></div></div></section></div></div><div ng-switch-when=\"ROLE_HEALTH_VISITOR\"><div id=\"schedules2\"><select id=\"ownerMultiSelect2\" kendo-multi-select multiple=\"multiple\" k-options=\"vm.ownerMultiOptions\" k-ng-model=\"vm.selectedCustomers\"></select></div><div style=\"padding: 1em\"><div kendo-tooltip k-content=\"vm.tooltipContent\" k-filter=\"\'.k-event\'\" class=\"k-group\"><kendo-scheduler id=\"scheduler2\" k-options=\"vm.schedulerOptions\"><span k-event-template class=\"custom-event\"><span ng-show=\"vm.view == \'day\'\"><span ng-if=\"!dataItem.startedAt\"><i class=\"material-icons md-13\">alarm</i> ΡΑΝΤΕΒΟΥ,&nbsp;&nbsp; </span><span ng-if=\"dataItem.startedAt\"><i class=\"material-icons md-13\">date_range</i> {{dataItem.eventCategoryType.eventCategory.name}},&nbsp;&nbsp; </span><span class=\"glyphicon glyphicon-time\"></span> <span>{{dataItem.start | date : \'HH:mm\'}}</span> <span>&nbsp;-&nbsp;</span> <span>{{dataItem.end | date : \'HH:mm\'}},&nbsp;&nbsp;</span> <span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 1 && dataItem.eventCustomerSector.customerSector !== null && dataItem.eventCustomerSector.customerSector !== undefined\"><i class=\"material-icons md-13\">account_circle</i> {{dataItem.eventCustomerSector.customerSector.customer.lastName}}&nbsp;{{dataItem.eventCustomerSector.customerSector.customer.firstName}},&nbsp;&nbsp; </span><span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 1 && dataItem.eventCustomerSector.sector !== null && dataItem.eventCustomerSector.sector !== undefined\"><i class=\"material-icons md-13\">business</i> {{dataItem.eventCustomerSector.sector.name}},&nbsp;&nbsp; </span><span class=\"glyphicon glyphicon-user\"></span> <span>{{dataItem.employee.account.lastName}}&nbsp;{{dataItem.employee.account.firstName}}</span> </span><span ng-show=\"vm.view == \'week\' || vm.view == \'month\'\"><span ng-if=\"dataItem.eventCustomerSector.customerSector.sector.sectorType.sectorTypeCategory === \'hcu\'\">{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span> <span>{{dataItem.eventCustomerSector.customerSector.customer.doctorSpecialty.name}}</span> <span ng-if=\"dataItem.eventCustomerSector.customerSector.customer.customerCategory\"><span>{{dataItem.eventCustomerSector.customerSector.customer.customerCategory.name}}</span> </span><span ng-if=\"dataItem.eventCustomerSector.customerSector.customer.customerSubCategory\"><span>, {{dataItem.eventCustomerSector.customerSector.customer.customerSubCategory.name}}<br></span></span><span ng-if=\"dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'beautyCenter\' ||\n                                         dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'pharmacy\' ||\n                                         dataItem.eventCustomerSector.sector.sectorType.sectorTypeCategory === \'hcu\'\">{{dataItem.eventCustomerSector.sector.sectorType.name}}, {{dataItem.eventCustomerSector.sector.name}}&nbsp;&nbsp;</span> <span ng-if=\"dataItem.eventCategoryType.eventCategory.id == 2\">{{ dataItem.eventCategoryType.eventType.name }}</span></span></span></kendo-scheduler></div></div></div><!--Tooltip Template--><script id=\"template\" type=\"text/x-kendo-template\">#var uid = target.attr(\"data-uid\");#\n        #var scheduler = target.closest(\"[data-role=scheduler]\").data(\"kendoScheduler\");#\n        #if (scheduler) {#\n        #var model = scheduler.occurrenceByUid(uid);#\n\n        #if(model) {#\n        <div class=\"schedule-tooltip\">\n            #if(model.eventCategoryType.eventCategory.id === 2) {#\n            <span>Από&nbsp;#=kendo.toString(kendo.parseDate(model.start), \'dddd, dd/MM/yyyy HH:mm\')#<br></span>\n            <span>Εώς&nbsp;#=kendo.toString(kendo.parseDate(model.end), \'dddd, dd/MM/yyyy HH:mm\')#<br></span>\n            <i ng-if=\"vm.customerView !== \'3\'\" class=\"material-icons md-13\">lens</i>\n            #if(model.startedAt) {#\n            <span ng-if=\"vm.customerView !== \'3\'\">#= model.eventCategoryType.eventCategory.name#&nbsp;&nbsp;</span>\n            <span ng-if=\"vm.customerView !== \'3\'\">#= model.eventCategoryType.eventType.name#<br></span>\n            #}#\n            #if(!model.startedAt) {#\n            <span ng-if=\"vm.customerView !== \'3\'\">ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;</span>\n            <span ng-if=\"vm.customerView !== \'3\'\">ΡΑΝΤΕΒΟΥ<br></span>\n            #}#\n            <i class=\"material-icons md-13\">assignment_ind</i>\n            <span>#= model.employee.account.lastName#, #= model.employee.account.firstName#</span>\n            #}else{#\n            <i class=\"material-icons md-13\">schedule</i>\n            <span>#=kendo.toString(model.start, \"HH:mm\")#&nbsp;&nbsp;</span>\n            <span>#=kendo.toString(model.end, \"HH:mm\")#<br></span>\n\n            <!--<i class=\"material-icons md-13\">account_circle</i>-->\n            #if(model.eventCustomerSector.customerSector !== null &&\n            model.eventCustomerSector.customerSector.sector.sectorType.sectorTypeCategory === \'hcu\') {#\n            <i class=\"material-icons md-13\">account_circle</i>\n            <span>#= model.eventCustomerSector.customerSector.customer.lastName#, #= model.eventCustomerSector.customerSector.customer.firstName#<br></span>\n            <i class=\"material-icons md-13\">local_hospital </i>\n            <span>#= model.eventCustomerSector.customerSector.customer.doctorSpecialty.name#</span>\n            #if(model.eventCustomerSector.customerSector.customer.customerCategory != null){#\n            <span>, #= model.eventCustomerSector.customerSector.customer.customerCategory.name#</span>\n            #}#\n            #if(model.eventCustomerSector.customerSector.customer.customerSubCategory != null){#\n            <span>, #= model.eventCustomerSector.customerSector.customer.customerSubCategory.name#<br> </span>\n            #}else{#\n            <br>\n            #}#\n            #}#\n            #if(model.eventCustomerSector.sector !== null) {#\n            <i class=\"material-icons md-13\">business</i>\n            <span>#= model.eventCustomerSector.sector.sectorType.name#, #= model.eventCustomerSector.sector.name# <br></span>\n            #}#\n\n            <i ng-if=\"vm.customerView !== \'3\'\" class=\"material-icons md-13\">lens</i>\n            #if(model.startedAt) {#\n            <span ng-if=\"vm.customerView !== \'3\'\">#= model.eventCategoryType.eventCategory.name#&nbsp;&nbsp;</span>\n            <span ng-if=\"vm.customerView !== \'3\'\">#= model.eventCategoryType.eventType.name#<br></span>\n            #}#\n            #if(!model.startedAt) {#\n            <span ng-if=\"vm.customerView !== \'3\'\">ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;</span>\n            <span ng-if=\"vm.customerView !== \'3\'\">ΡΑΝΤΕΒΟΥ<br></span>\n            #}#\n            <i class=\"material-icons md-13\">assignment_ind</i>\n            <span>#= model.employee.account.lastName#, #= model.employee.account.firstName#</span>\n\n            #}#\n        </div>\n        #}#\n        #}#</script><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div ng-show=\"vm.isSchedule == \'1\'\"><div ng-show=\"vm.page == \'firstPage\'\" class=\"full-width\"><div class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><select name=\"communication_type\" id=\"communicationType\" kendo-combo-box k-ng-model=\"eventCustomerSector.communicationType\" data-bind=\"value:eventCustomerSector.communicationType.id\" k-options=\"vm.communicationTypesComboBoxOptions\"></select><div class=\"k-edit-label\"><label>Τίτλος:</label></div><input name=\"eventTitle\" type=\"text\" class=\"k-input k-textbox\" name=\"title\" data-bind=\"value:title\"><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"description\" data-bind=\"value:eventSchedule.description\"><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomerSector.customer.lastName}} {{vm.currentCustomerSector.customer.firstName}}</span></span></div><div class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><input name=\"start\" id=\"startDate\" class=\"half-width pull-right\" kendo-date-picker data-bind=\"value:start\"><div ng-show=\"!vm.massSelect\"><div class=\"k-edit-label\"><label>Ώρα:</label></div><div class=\"time-width pull-right\"><input name=\"start\" id=\"startTime\" kendo-time-picker k-format=\"\'HH:mm\'\" data-bind=\"value:start\"></div></div><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><input type=\"number\" class=\"k-input pull-right\" name=\"duration\" data-bind=\"value:durationTime\"><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox pull-right\"><span class=\"k-input k-textbox\">{{vm.currentCustomerSector.sector.name}}</span></span><div class=\"k-edit-label\"></div><div ng-show=\"vm.canMasSchedule\" ng-click=\"vm.toggleMassSchedules()\" class=\"btn-group margin-multi-events pull-right no-outline\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.massSelect\" uib-btn-radio=\"false\">Απλό Ραντεβού</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.massSelect\" uib-btn-radio=\"true\">Μαζικά Ραντεβου</label></div></div></div><div ng-show=\"vm.massSelect && vm.page == \'firstPage\'\" class=\"full-width pull-left multi-events\"><hr><div class=\"pull-left width-25\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.shiftType\" uib-btn-radio=\"\'day\'\">Πρωινή Βάρδια</label><label class=\"btn btn-radio btn-primary margin-top-sm\" ng-model=\"vm.shiftType\" uib-btn-radio=\"\'night\'\">Απογευματινή Βάρδια</label><label class=\"btn btn-radio btn-primary margin-top-sm\" ng-model=\"vm.shiftType\" uib-btn-radio=\"\'dayNight\'\">Πρωινή/Απογευματινή Βάρδια</label></div><div class=\"width-60 pull-right\"><div ng-show=\"vm.shiftType === \'day\' || vm.shiftType === \'dayNight\'\" class=\"full-width\"><label ng-show=\"vm.shiftType === \'dayNight\'\" class=\"pull-left events-title\">Πρωινή Βάρδια</label><div class=\"pull-left half-width\"><span class=\"k-edit-label\"><label>Ώρα Έναρξης:</label></span><span class=\"time-width pull-right\"><input name=\"firstShiftFrom\" id=\"firstShiftFrom\" kendo-time-picker k-format=\"\'HH:mm\'\" data-bind=\"value:firstShiftFrom\"></span></div><div class=\"pull-right half-width\"><span class=\"k-edit-label\"><label>Ώρα Λήξης:</label></span><span class=\"time-width pull-right\"><input name=\"firstShiftTo\" id=\"firstShiftTo\" kendo-time-picker k-format=\"\'HH:mm\'\" data-bind=\"value:firstShiftTo\" ng-disabled=\"!vm.massSelect\"></span></div></div><div ng-show=\"vm.shiftType === \'night\' || vm.shiftType === \'dayNight\'\" class=\"full-width\"><label ng-show=\"vm.shiftType === \'dayNight\'\" class=\"pull-left events-title voffset6\">Απογευματινή Βάρδια</label><div class=\"pull-left half-width\"><span class=\"k-edit-label\"><label>Ώρα Έναρξης:</label></span><span class=\"time-width pull-right\"><input name=\"secondShiftFrom\" id=\"secondShiftFrom\" kendo-time-picker k-format=\"\'HH:mm\'\" data-bind=\"value:secondShiftFrom\" ng-disabled=\"!vm.massSelect\"></span></div><div class=\"pull-right half-width\"><span class=\"k-edit-label\"><label>Ώρα Λήξης:</label></span><span class=\"time-width pull-right\"><input name=\"secondShiftTo\" id=\"secondShiftTo\" kendo-time-picker k-format=\"\'HH:mm\'\" data-bind=\"value:secondShiftTo\" ng-disabled=\"!vm.massSelect\"></span></div></div></div></div><div ng-show=\"!vm.massSelect || vm.page == \'secondPage\'\" class=\"employee-assign\"><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"master_filters_customers\"></div><div selectable-grid kendo-grid id=\"customersMeGrid\" k-options=\"vm.customerSectorGridOptions\" k-on-change=\"vm.massSelect ? onSelectItem(kendoEvent.sender, dataItem) : vm.onChange(kendoEvent, dataItem)\" k-ng-delay=\"vm.initPopupGrid\"></div></div><div ng-show=\"vm.massSelect && vm.page == \'thirdPage\'\" class=\"employee-assign\"><div ng-show=\"vm.validationError\" class=\"alert alert-danger\"><strong>ΠΡΟΣΟΧΗ!</strong> Έχετε ξεπεράσει το όριο της επιλεγμένης βάρδιας.</div><h5>Δημιουργία Ραντεβού στις #: kendo.toString(kendo.parseDate(start), \'dd/MM/yyyy\')#</h5><kendo-sortable options=\"vm.sortableOptions\"><kendo-grid id=\"previewGrid\" k-scope-field=\"vm.sortableGrid\" k-options=\"vm.previewGridOptions\"></kendo-grid></kendo-sortable></div></div><div ng-show=\"vm.isSchedule != \'1\'\"><div class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: eventCustomerSector.communicationType.name#</span></span><div class=\"k-edit-label\"><label>Τίτλος:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: title#</span></span><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: eventSchedule.description#</span></span><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomerSector.lastName}} {{vm.currentCustomerSector.firstName}}</span></span></div><div class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'dd/MM/yyyy\')#</span></span><div class=\"k-edit-label\"><label>Ώρα:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'HH:mm\')#</span></span><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: durationTime#</span></span><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentSector.name}}</span></span></div></div></div></div></div></div>");
$templateCache.put("app/displays/adminPatchReports/adminPatchReports.html","<div class=\"clearfix\"><ul class=\"nav nav-pills nav-stacked sub-nav-custom custom-nav-pills\"><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"adminPatchReports.pending\" class=\"md-raised md-button\" style=\"padding: 2%\">Προς Εκτέλεση</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"adminPatchReports.pendingHistory\" class=\"md-raised md-button\" style=\"padding: 2%\">Εκτελεσμένες</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"adminPatchReports.partExecuted\" class=\"md-raised md-button\" style=\"padding: 2%\">Μερικώς Εκτελεσμένες</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"adminPatchReports.cancelled\" class=\"md-raised md-button\" style=\"padding: 2%\">Ακυρωμένες</md-button></li></ul><div style=\"padding: 1em;width: 87%;margin-top: 1%\" class=\"pull-left\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\" class=\"patches-toolbar\" style=\"margin: 0!important\"></div><div class=\"clearfix\" ui-view></div></div></div>");
$templateCache.put("app/displays/adminUsers/adminUsers.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddUserClick()\" ng-if=\"vm.canEdit\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Νέου Χρήστη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/analytics/analytics.html","<div id=\"iFrameContent\" ng-cloak><div class=\"row\"><div class=\"col-lg-12 col-sm-2\"><md-button id=\"print\" type=\"button\" class=\"k-button k-primary k-state-default pull-right\" ng-click=\"vm.printIframe(\'#iFrameContent\')\"><i class=\"material-icons md-light md-26\">print</i> <span class=\"hidden-sm\">Εκτύπωση</span></md-button></div><div id=\"iFrameWrap\" name=\"iFrameWrap\"><iframe id=\"iFrameEmbedReport\" name=\"iFrameEmbedReport\" frameborder=\"0\" allowfullscreen=\"true\" media=\"print\"></iframe></div></div></div>");
$templateCache.put("app/displays/adminSchedulesGrid/adminSchedulesGrid.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-alarm-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span> <span flex></span><label style=\"padding-right: 20px; font-weight: normal\">Ραντεβού σε:</label><md-select ng-model=\"vm.eventTarget\" id=\"eventTargetSelect\" ng-change=\"vm.onEventTargetChange()\" style=\"min-width: 190px\"><md-option value=\"all\">Όλα</md-option><md-option value=\"customers\">Επαγγελματίες Υγείας</md-option><md-option value=\"sectors\">Μονάδες Υγείας</md-option></md-select></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/analyticsNew/analyticsNew.html","<div id=\"iFrameContent\" ng-cloak><div class=\"row\"><div class=\"col-lg-12 col-sm-2\"><md-button id=\"print\" type=\"button\" class=\"k-button k-primary k-state-default pull-right\" ng-click=\"vm.printIframe(\'#iFrameContent\')\"><i class=\"material-icons md-light md-26\">print</i> <span class=\"hidden-sm\">Εκτύπωση</span></md-button></div><div id=\"iFrameWrap\" name=\"iFrameWrap\"><iframe id=\"iFrameEmbedReport\" name=\"iFrameEmbedReport\" frameborder=\"0\" allowfullscreen=\"true\" media=\"print\"></iframe></div></div></div>");
$templateCache.put("app/displays/applicationParameters/applicationParameters.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-lock-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddApplicationParameterClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/approvals/approvals.html","<div ng-cloak class=\"approvals-tabs\"><md-tab-group><md-tabs md-dynamic-height md-border-bottom><md-tab md-active=\"vm.$state.includes(\'approvals.newRecords\')\" ui-sref=\"approvals.newRecords.pending\"><md-tab-label><span class=\"material-icons fixed-icons fixed-icons-3\">chrome_reader_mode</span>Νέες Εγγραφές</md-tab-label><md-tab-body><div style=\"padding: 1em 1em 1em 0\"><div ui-view></div></div></md-tab-body></md-tab><md-tab md-active=\"vm.$state.includes(\'approvals.changedRecords\')\" ui-sref=\"approvals.changedRecords.pending\"><md-tab-label><span class=\"material-icons fixed-icons fixed-icons-3\">description</span>Αλλαγές</md-tab-label><md-tab-body><div style=\"padding: 1em 1em 1em 0\"><div ui-view></div></div></md-tab-body></md-tab></md-tabs></md-tab-group></div>");
$templateCache.put("app/displays/assignations/assignations.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/group-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex translate=\"global.menu.assignations.TITLE\">Mass Customer Management</span></h2></div></md-toolbar><div kendo-tab-strip id=\"tabstrip\" k-content-urls=\"[ null, null]\" style=\"width: 99.9%\"><ul><li ui-sref=\"customerSectorsAssignations\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerSectorsAssignations\')}\"><i class=\"material-icons\">compare_arrows</i>Μεταφορά Πελατολογίου</li><li ui-sref=\"deletions\" ng-class=\"{\'k-state-active\': vm.$state.is(\'deletions\')}\"><i class=\"material-icons\">delete_sweep</i>Διαγραφή Πελατολογίου</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div>");
$templateCache.put("app/displays/beautyCenters/beautyCenters.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-spa-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_beautyCenters\"></div><kendo-grid id=\"beautyCentersGrid\" options=\"vm.beautyCentersGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.beautyCentersGridOptions\"></kendo-grid><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor_beautyCenters\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"sector-info pull-left full-width\"><h5>Στοιχεία Κέντρου Αισθητικής</h5><div class=\"pull-left left-section\"><div class=\"k-edit-label\"><label>Όνομα:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"name\" ng-model=\"dataItem.name\" data-bind=\"value:name\"></div><div class=\"sector-info pull-left left-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Α.Φ.Μ.:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"vat\" ng-model=\"dataItem.vat\" data-bind=\"value:vat\"></div><div><div class=\"k-edit-label\"><label>Εταιρική Μορφή:</label></div><select name=\"companyType\" id=\"companyTypeEdit\" kendo-combo-box data-bind=\"value:companyType.id\" k-options=\"vm.companyTypesComboBoxOptions\"></select></div><div><div class=\"k-edit-label\"><label>Καθεστώς Φ.Π.Α.:</label></div><select name=\"taxStatus\" id=\"taxStatus\" kendo-combo-box data-bind=\"value:taxStatus.id\" k-options=\"vm.taxStatusesComboBoxOptions\"></select></div><!--<div>--><!--<div class=\"k-edit-label\">--><!--<label>Δ.Ο.Υ. </label>--><!--</div>--><!--<select name=\"taxOffice\" id=\"taxOfficeEdit\" kendo-combo-box data-bind=\"value:taxOffice.id\"--><!--k-options=\"vm.taxOfficesComboBoxOptions\"></select>--><!--</div>--></div><div class=\"minus-margin-top pull-right right-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Κωδικός Ε.Ε.:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"code\" ng-model=\"vm.sector.code\"></div><div><div class=\"k-edit-label\"><label>Πιστωτικός Έλεγχος:</label></div><input id=\"creditControlCheck\" name=\"creditControlCheck\" type=\"checkbox\" ng-model=\"vm.sector.creditControlCheck\" class=\"checkbox inline info checkbox-editor-custom\" placeholder=\"Πιστωτικός Έλεγχος\"></div></div><div class=\"sector-info pull-left full-width\"><h5>Στοιχεία Διεύθυνσης</h5></div><div ng-show=\"!vm.geodata\" class=\"sector-info pull-left left-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Νομός:</label></div><input id=\"prefectures\" class=\"custom-combobox\" kendo-combo-box k-ng-model=\"vm.selectedSector.prefecture\" ng-model=\"vm.selectedSector.prefectureName\" k-options=\"vm.prefecturesComboBoxOptions\"></div><div><div class=\"k-edit-label\"><label>Πόλη:</label></div><input id=\"cities\" class=\"custom-combobox\" kendo-combo-box k-ng-model=\"vm.selectedSector.city\" ng-model=\"vm.selectedSector.cityName\" k-options=\"vm.citiesComboBoxOptions\"></div><div><div class=\"k-edit-label\"><label>Διεύθυνση:</label></div><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.selectedSector.address\" name=\"address\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Τ.Κ.:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-model=\"dataItem.postalCode\" data-bind=\"value:postalCode\"></div><div><div class=\"k-edit-label\"><label>Αριθμός:</label></div><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.selectedSector.addressNum\" name=\"addressNum\"></div></div><div ng-show=\"vm.geodata\"><div id=\"masterFilterGeodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\"></div><div class=\"sector-info pull-left left-section\"><div><div class=\"k-edit-label\"><label>Νομός:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"prefectureName\" ng-model=\"vm.sector.prefectureName\" data-bind=\"value:prefectureName\"></div><div><div class=\"k-edit-label\"><label>Πόλη:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"cityName\" ng-model=\"vm.sector.cityName\" data-bind=\"value:cityName\"></div><div><div class=\"k-edit-label\"><label>Διεύθυνση:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.address\" data-bind=\"value:address\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Τ.Κ.:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-model=\"vm.sector.postalCode\" data-bind=\"value:postalCode\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Αριθμός:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\" ng-model=\"vm.sector.addressNum\" data-bind=\"value:addressNum\"></div></div></div><div class=\"pull-right right-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Τηλέφωνο:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\" ng-model=\"dataItem.phone\" data-bind=\"value:phone\"></div><div><div class=\"k-edit-label\"><label>Τηλέφωνο 2:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"phone2\" ng-model=\"dataItem.phone2\" data-bind=\"value:phone2\"></div></div></div></div></div></div>");
$templateCache.put("app/displays/beautyCenters/beautyCenterView.html","<div class=\"entity-view clearfix\"><div id=\"beautyCenter\"><form id=\"form\" name=\"form\"><div class=\"well clearfix\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"30\" layout=\"column\"><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-media><img ng-src=\"content/images/{{vm.profilePicture}}\" alt=\"MS Picture\" style=\"width:150px;height:150px\"></md-card-title-media><md-card-title-text style=\"margin-left: 15px\"><span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Όνομα : </b>{{vm.sector.name}}</span></span> <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Τηλέφωνο :</b> {{vm.sector.phone}}</span></span></md-card-title-text></md-card-title></md-card></div></md-content></div><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"beautyCenterInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'beautyCenterInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Κέντρου Αισθητικής</li><li ui-sref=\"beautyCenterCustomers\" ng-class=\"{\'k-state-active\': vm.$state.is(\'beautyCenterCustomers\')}\"><i class=\"material-icons\">face</i>Επαφές</li><li ui-sref=\"beautyCenterEmployees\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_MANAGEMENT\" ng-class=\"{\'k-state-active\': vm.$state.is(\'beautyCenterEmployees\')}\"><i class=\"material-icons\">assignment_ind</i>Ιατρικοί Επισκέπτες</li><li ui-sref=\"beautyCenterEvents\" ng-class=\"{\'k-state-active\': vm.$state.is(\'beautyCenterEvents\')}\"><i class=\"material-icons\">date_range</i>Επισκέψεις</li><li ui-sref=\"beautyCenterPurchases\" ng-class=\"{\'k-state-active\': vm.$state.is(\'beautyCenterPurchases\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Visit_Beauty_Centers\" extra-application-parameters=\"Purchase_Pharmacies\"><i class=\"material-icons\">add_shopping_cart</i>Παραγγελίες</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/brick-osfes/brick-osfes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid><div class=\"clearfix\"></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div>");
$templateCache.put("app/displays/followUpCalls/followUpCalls.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-settings_phone-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"followUpCallsGrid\" options=\"vm.followUpCallsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.followUpCallsGridOptions\" style=\"height: 800px\" ng-style=\"{height: vm.contentHeight + \'px\'}\"></kendo-grid><div id=\"popup-follow-up-call\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div class=\"box\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"popup-info pull-left full-width\"><h5>Στοιχεία Ασθενή & Συνοδού</h5><div><div class=\"popup-info pull-left left-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Επώνυμο Ασθενή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.lastName\" disabled=\"disabled\"></div><div><div class=\"k-edit-label\"><label>Όνομα Ασθενή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.firstName\" disabled=\"disabled\"></div><div><div class=\"k-edit-label\"><label>Τηλ. Ασθενή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.phone\" disabled=\"disabled\"></div></div><div class=\"pull-right right-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Επώνυμο Συνοδού:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.attendant.lastName\" disabled=\"disabled\"></div><div><div class=\"k-edit-label\"><label>Όνομα Συνοδού:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.attendant.firstName\" disabled=\"disabled\"></div><div><div class=\"k-edit-label\"><label>Τηλ. Συνοδού:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"leadCall.prospectivePatient.attendant.phone\" disabled=\"disabled\"></div></div><div class=\"popup-info pull-left full-width\"><h5>Στοιχεία Εκκρεμότητας</h5></div><div><div class=\"popup-info left-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><span style=\"padding-left: 122px;!important\"><input name=\"date\" id=\"date\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" onkeydown=\"return false\"></span></div><div><div class=\"k-edit-label\"><label>Τύπος Κλήσης:</label></div><div style=\"padding-left: 276px;!important;padding-top: 12px;!important\"><select id=\"followupType\" name=\"followupType\" kendo-combo-box k-ng-model=\"vm.selectedItem.followupType\" k-options=\"vm.followUpTypeOptions\"></select><!-- class=\"col-fix-2\" --></div></div><div><div class=\"k-edit-label\"><label>Λόγος Απόρριψης:</label></div><div style=\"padding-left: 276px;!important;padding-top: 12px;!important\"><select id=\"rejectionReason\" name=\"rejectionReason\" kendo-combo-box k-ng-model=\"vm.selectedItem.rejectionReason\" k-options=\"vm.rejectionReasonOptions\"></select></div></div><div><div class=\"k-edit-label\"><label>Κατάσταση:</label></div><div style=\"padding-left: 276px;!important;padding-top: 12px;!important\"><select id=\"followupStatus\" name=\"followupStatus\" kendo-combo-box k-ng-model=\"vm.selectedItem.followupStatus\" k-options=\"vm.followupStatuses\"></select></div></div></div><div class=\"pull-right right-section popup-new-sector\"><div><div class=\"k-edit-label\"><label>Θα Καλέσουν:</label></div><input type=\"checkbox\" class=\"k-input\" name=\"willTheyCall\" style=\"float: right; margin-right: 190px\"></div><div><div class=\"k-edit-label\"><label>Ολοκληρωμένο:</label></div><input type=\"checkbox\" class=\"k-input\" name=\"completed\" style=\"float: right; margin-right: 190px\"></div><div><div class=\"k-edit-label\"><label>Σχόλια:</label></div><textarea class=\"k-textbox custom-popup-textarea pull-right\" name=\"comments\" style=\"width: auto!important; margin-right: 30px; padding: 0 0 .6em!important\">\n                                    </textarea></div></div></div></div></div></div></div></div></div><!-- Custom Kendo Grid row template --><script id=\"rowTemplate\" type=\"text/x-kendo-template\"><tr role=\"row\" class=\"ng-scope\" data-uid=\"#= uid #\">\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <md-button class=\'md-raised md-mini\' style=\'min-width: 50px;margin: 0;\' aria-label=\'edit\' ng-click=\'vm.customEdit($event)\'>\n                <i class=\'dark-grey material-icons fixed-icons-2\'>edit</i>\n            </md-button>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= date ? kendo.toString(kendo.parseDate(date), \'dddd, dd/MM/yyyy\') : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.firstName ? leadCall.prospectivePatient.firstName : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.lastName ? leadCall.prospectivePatient.lastName : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.phone ? leadCall.prospectivePatient.phone : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.attendant.firstName ? leadCall.prospectivePatient.attendant.firstName : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.attendant.lastName ? leadCall.prospectivePatient.attendant.lastName : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.prospectivePatient.attendant.phone ? leadCall.prospectivePatient.attendant.phone : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <md-checkbox class=\"checkbox-toolbar inline\" aria-label=\"selectable\" ng-model=\"dataItem.leadCall.isImportant\" ng-disabled=\"true\"></md-checkbox>\n            <label>#= leadCall.isImportant ? \'Ναι\' : \'Όχι\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <label>#= leadCall.leadHospitalizations[0].possibleDischargeDate ? kendo.toString(kendo.parseDate(leadCall.leadHospitalizations[0].possibleDischargeDate), \'dddd, dd/MM/yyyy\') : \'\' #</label>\n        </td>\n        <td role=\"gridcell\" class=\'ng-scope #= leadCall.isImportant === true ? \" importantRedFont\" : \"\"#\'>\n            <md-button class=\'md-raised md-mini\' style=\'min-width: 50px;margin: 0;\' ui-sref=\'leadCallView({id:dataItem.leadCall.id})\'>\n                Μετάβαση στην Κλήση\n            </md-button>\n        </td>\n    </tr></script>");
$templateCache.put("app/displays/bricks/bricks.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid><div class=\"clearfix\"></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div>");
$templateCache.put("app/displays/leadCalls/leadCalls.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-call-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex>{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.addNew();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθηκη Κλησης</span></md-button></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"leadCallsGrid\" options=\"vm.leadCallsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.leadCallsGridOptions\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"height: 800px\"><!-- add fixed height to show progress on first load --></kendo-grid><!-- Edit LeadCall Dialog --><div id=\"leadCallWnd\" kendo-window=\"vm.leadCallWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"true\"><div id=\"leadCallWindow\" class=\"middle\"><!--<kendo-grid id=\"patientsPopupGrid\" options=\"vm.patientsPopUpGriOptions\"  k-on-change=\"vm.onSelection(data)\"  k-ng-delay=\"vm.patientsPopUpGriOptions\"--><!--k-rebind=\"vm.patientsPopUpGriOptions.columns\"></kendo-grid>--><md-button id=\"save_button\" ng-click=\"vm.patientSelected()\" class=\"md-raised md-primary\" style=\"float: right\">Ενημέρωση</md-button><md-button class=\"md-raised\" style=\"float: right\" ng-click=\"vm.leadCallWindow.close()\">Άκυρο</md-button></div></div>");
$templateCache.put("app/displays/leadCalls/leadCallsView.html","<md-toolbar style=\"background-color: #0074BC\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack($event);\">Πίσω</md-button><h2 flex md-truncate>{{vm.title}}</h2><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.save(false);\" ng-show=\"vm.showSaveButton\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">{{vm.saveButtonLabel}}</span></md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.saveDiseases();\" ng-show=\"vm.showDiseasesTabButtons\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">Αποθήκευση Ιστορικού</span></md-button><div id=\"offerButtonsLayout\" layout=\"row\" layout-align=\"center\"><div flex=\"33\"><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.printOffer($event);\" ng-show=\"vm.showChargesTabButtons\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">print</i> <span class=\"hidden-sm\">Εκτύπωση Προσφοράς</span></md-button></div><div flex=\"33\"><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.shareWithEmail();\" ng-show=\"vm.showChargesTabButtons\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">email</i> <span class=\"hidden-sm\">Email Προσφοράς</span></md-button></div><div flex=\"33\"><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.saveLeadOffer();\" ng-show=\"vm.showChargesTabButtons\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">Αποθήκευση Χρέωσης</span></md-button></div></div></div></md-toolbar><div id=\"hospitalization\"><md-tabs md-dynamic-height md-selected=\"vm.tabIndex\" md-align-tabs=\"top\"><md-tab id=\"tabLeadCall\" ng-click=\"vm.tabHeaderClick(\'tabLeadCall\', $event)\"><md-tab-label>Κλήση</md-tab-label><md-tab-body><md-content layout-padding ng-cloak ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div id=\"leadCallForm\" name=\"leadCallForm\" ng-form><div class=\"popup-info full-width\" style=\"padding: 1em\"><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">today</i><label class=\"leadCalls-label\">Ημερομηνία & Ώρα:</label></div><input name=\"dateIssue\" id=\"dateIssue\" class=\"margin-left-10\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.startDate\" onkeydown=\"return false\" ng-disabled=\"vm.leadCall.id > 0\"> <input name=\"start\" id=\"startTime\" kendo-time-picker class=\"margin-left-10\" onkeydown=\"return false\" ng-disabled=\"vm.leadCall.id > 0\" k-format=\"\'HH:mm\'\" data-bind=\"value:start\" k-ng-model=\"vm.startTime\"><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">phone</i><label class=\"leadCalls-label\">Τύπος Κλήσης:</label></div><md-radio-group layout=\"row\" id=\"callType\" name=\"callType\" ng-model=\"vm.leadCall.callType\" class=\"md-primary\" style=\"padding-left: 60px; padding-top: 5px\"><md-radio-button ng-repeat=\"d in vm.callTypes\" ng-value=\"d\" id=\"{{\'mdRad\' + d.id}}\">{{ d.name }}</md-radio-button></md-radio-group><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">book</i><label class=\"leadCalls-label\">Προσέλευση για δια ζώσης ενημέρωση:</label></div><md-switch id=\"bookedAppointment\" ng-model=\"vm.leadCall.bookedAppointment\" aria-label=\"Παραπομπή στην Ανοιχτή Νοσηλεία\" md-no-ink style=\"padding-left: 62px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'bookedAppointment\', vm.leadCall.bookedAppointment)\">{{ vm.leadCall.bookedAppointment == true ? \'Ναι\' : \'Όχι\' }}</md-switch><div ng-if=\"vm.leadCall.bookedAppointment\"><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">today</i><label class=\"leadCalls-label\">Ραντεβού για δια ζώσης ενημέρωση:</label></div><input name=\"appointmentDate\" id=\"appointmentDate\" class=\"pull-left margin-left-10\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.appointmentDate\" onkeydown=\"return false\" ng-disabled=\"!vm.leadCall.bookedAppointment\"><!-- ng-disabled=\"vm.leadCall.id > 0\" --> <input name=\"start\" id=\"appointmentTime\" kendo-time-picker class=\"pull-left margin-left-10\" onkeydown=\"return false\" k-format=\"\'HH:mm\'\" data-bind=\"value:start\" k-ng-model=\"vm.appointmentTime\" ng-disabled=\"!vm.leadCall.bookedAppointment\"></div><div class=\"separator\"></div><!-- Prospective Patient --><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">accessibility_new</i><label class=\"leadCalls-label\">Πιθανός Ασθενής:</label></div><input name=\"prospectivePatient\" id=\"prospectivePatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.prospectivePatient.fullName\" ng-disabled=\"vm.editProspectivePatientMode\" required data-required-msg=\"Παρακαλούμε εισάγετε Υποψήφιο Ασθενή.\"><md-button ng-if=\"true\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'prospectivePatient\')\"><!-- !vm.editProspectivePatientMode - changed to true for ECRM-280 --><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editProspectivePatientMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'prospectivePatient\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editProspectivePatientMode && vm.leadCall.prospectivePatient.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'prospectivePatient\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"false\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'prospectivePatient\')\"><!-- ng-if=\"vm.editProspectivePatientMode\" --><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editProspectivePatientMode && vm.prospectivePatient.id > 0\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'convertToPatient\')\"><md-icon class=\"material-icons\">accessibility<md-tooltip md-direction=\"bottom\">Εισαγωγή Πιθανού Ασθενή</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editProspectivePatientMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" style=\"margin-left: 15px\" aria-label=\"clear\" ng-click=\"vm.toggle(\'prospectivePatient\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Άκυρο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editProspectivePatientMode && vm.leadCall.prospectivePatient.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'prospectivePatient\', \'erase\')\"><md-icon class=\"material-icons\">delete<md-tooltip md-direction=\"bottom\">Εκκαθάριση</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editProspectivePatientMode && vm.leadCall.prospectivePatient.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'prospectivePatient\', \'go\')\"><md-icon class=\"material-icons\" style=\"color: #f6931f\">arrow_forward<md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div id=\"fieldsContainer\" ng-if=\"vm.editProspectivePatientMode\" style=\"height: 170px; overflow: hidden; margin-bottom: 0px; padding-bottom: 0px\" kendo-validator=\"vm.validator\" k-options=\"vm.validatorOptions\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επώνυμο:</label></div><input id=\"prospectivePatientLastName\" name=\"prospectivePatientLastName\" ng-model=\"vm.prospectivePatient.lastName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του πιθανού ασθενή.\"><div class=\"k-edit-label\"><label>* Όνομα:</label></div><input id=\"prospectivePatientFirstName\" name=\"prospectivePatientFirstName\" ng-model=\"vm.prospectivePatient.firstName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του πιθανού ασθενή.\"><div class=\"k-edit-label\"><label>Έτος Γέννησης:</label></div><input id=\"yearOfBirth\" name=\"yearOfBirth\" ng-model=\"vm.prospectivePatient.birthYear\" class=\"k-textbox pull-left margin-left-10\" ng-change=\"vm.prospectivePatientBirthYearOnChange(vm.prospectivePatient.birthYear)\" min=\"0\" maxlength=\"4\"> <input name=\"age\" ng-model=\"vm.prospectivePatientAge\" class=\"k-textbox info pull-left margin-left-10\" placeholder=\"Ηλικία\" style=\"width: 10%\" ng-change=\"vm.prospectivePatientAgeChange(vm.prospectivePatientAge)\" min=\"0\" max=\"130\" maxlength=\"3\"><div class=\"k-edit-label\"><label>Τηλ. Επικοινωνίας:</label></div><md-select ng-model=\"vm.prospectivePatient.countryPhoneCode\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important; width: auto\" aria-label=\"Κωδικός Τηλεφώνου\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"countryPhoneCode in vm.countryPhoneCodes\" ng-value=\"countryPhoneCode\">{{countryPhoneCode.description + \" (\" + countryPhoneCode.code + \")\"}}</md-option></md-select><input id=\"prospectivePatientPhone\" name=\"prospectivePatientPhone\" ng-model=\"vm.prospectivePatient.phone\" data-custom=\"#prospectivePatientPhone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email Επικοινωνίας:</label></div><input id=\"prospectivePatientEmail\" name=\"prospectivePatientEmail\" type=\"email\" ng-model=\"vm.prospectivePatient.email\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"40\" pattern=\".+\\@.+\\..+\" title=\"Λάθος μορφή email\" validationmessage=\"Λάθος μορφή email\"><div class=\"k-edit-label\"><label>ΑΜΚΑ:</label></div><input id=\"prospectivePatientAmka\" name=\"prospectivePatientAmka\" type=\"text\" ng-model=\"vm.prospectivePatient.amka\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"11\"><div class=\"k-edit-label\"><label>Επάγγελμα:</label></div><md-select ng-model=\"vm.prospectivePatient.profession\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important\" aria-label=\"Επάγγελμα\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"profession in vm.professions\" ng-value=\"profession\">{{profession.name}}</md-option></md-select><div class=\"k-edit-label\"><label>Μητρική Γλώσσα:</label></div><md-select ng-model=\"vm.prospectivePatient.nativeLanguage\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important\" aria-label=\"Μητρική Γλώσσα\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"nativeLanguage in vm.nativeLanguages\" ng-value=\"nativeLanguage\">{{nativeLanguage.name}}</md-option></md-select><div class=\"k-edit-label\"><label>Περιοχή:</label></div><div class=\"info pull-left margin-left-10\" style=\"width: 45%; margin-left: 28px\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 100%\" class=\"info\"></div><div class=\"k-edit-label\"><label>Νομός</label></div><input name=\"prefectureName\" ng-model=\"vm.prospectivePatient.prefectureName\" class=\"k-textbox info pull-left margin-left-10\"><div class=\"k-edit-label\"><label>Πόλη</label></div><input name=\"cityName\" ng-model=\"vm.prospectivePatient.cityName\" class=\"k-textbox info pull-left margin-left-10\"><div class=\"k-edit-label\"><label>Διεύθυνση</label></div><input name=\"address\" ng-model=\"vm.prospectivePatient.address\" class=\"k-textbox info pull-left margin-left-10\"> <input name=\"addressNum\" ng-model=\"vm.prospectivePatient.addressNum\" placeholder=\"Αριθμός\" class=\"k-textbox info pull-left margin-left-10\" style=\"width: 10%\"><div class=\"k-edit-label\"><label>Λάθος στοιχεία επικοινωνίας:</label></div><md-checkbox ng-model=\"vm.prospectivePatient.isWrongContact\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος στοιχεία επικοινωνίας\"></md-checkbox><div class=\"k-edit-label\"><label>Λάθος τηλέφωνο:</label></div><md-checkbox ng-model=\"vm.prospectivePatient.isWrongPhone\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος τηλέφωνο\"></md-checkbox><!--<div class=\"k-edit-label\">\n                                    <label>Σχόλια: </label>\n                                </div>\n                                <textarea id=\"prospectivePatientNotes\" name=\"prospectivePatientNotes\" rows=\"3\" cols=\"150\" ng-model=\"vm.prospectivePatient.notes\" class=\"k-textbox info pull-left margin-left-10\"\n                                          style=\"margin-bottom: 30px;\"></textarea>--></div><div ng-if=\"vm.editProspectivePatientMode\" style=\"height: 5px; margin-top: 0px; padding-top: 0px; border-top: 3px solid #FAFAFA\" ng-click=\"vm.expandClick(\'prospectivePatient\');\" class=\"clearfix add-panel leadCalls-expander\"><div layout=\"row\"><div flex=\"30\"><md-icon class=\"material-icons\" style=\"float: left\">{{ vm.expandCollapseIcon }}</md-icon></div><div flex=\"40\" style=\"text-align: center; font-size: small; color: #696969\"><b>{{ vm.expandCollapseButtonLabel }}</b></div><div flex=\"30\" style=\"margin: auto\"><md-icon class=\"material-icons\" style=\"float: right\">{{ vm.expandCollapseIcon }}</md-icon></div></div></div><!-- /Prospective Patient --><!-- Attendant --><div><!-- style=\"background-color: rgba(129, 203, 241, 0.06); margin-left: 27%; margin-right: 23%;\" --><div class=\"k-edit-label\"><!-- style=\"margin-left: 11%;\" --> <i class=\"material-icons label-icon\">supervised_user_circle</i><label class=\"leadCalls-label\">Συνοδός:</label></div><input name=\"attendant\" id=\"attendant\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.prospectivePatient.attendant.fullName\" ng-disabled=\"vm.editAttendantMode\"><!-- required data-required-msg=\"Παρακαλούμε εισάγετε Συνοδό.\" --><md-button ng-if=\"true\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'attendant\')\"><!-- !vm.editAttendantMode - changed to true for ECRM-280 --><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editAttendantMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'attendant\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editAttendantMode && vm.leadCall.prospectivePatient.attendant.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'attendant\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"false\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'attendant\')\"><!-- ng-if=\"vm.editAttendantMode\" --><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editAttendantMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" style=\"margin-left: 15px\" aria-label=\"clear\" ng-click=\"vm.toggle(\'attendant\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Άκυρο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editAttendantMode && vm.leadCall.prospectivePatient.attendant.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'attendant\', \'erase\')\"><md-icon class=\"material-icons\">delete<md-tooltip md-direction=\"bottom\">Εκκαθάριση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div id=\"fieldsContainerAttendant\" ng-if=\"vm.editAttendantMode\" style=\"height: 280px; overflow: hidden; margin-bottom: 0px; padding-bottom: 0px\" kendo-validator=\"vm.validator\" k-options=\"vm.validatorOptions\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>Επώνυμο:</label></div><input id=\"attendantLastName\" name=\"attendantLastName\" ng-model=\"vm.attendant.lastName\" class=\"k-textbox info pull-left margin-left-10\" data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του Συνοδού.\"><div class=\"k-edit-label\"><label>Όνομα:</label></div><input id=\"attendantFirstName\" name=\"attendantFirstName\" ng-model=\"vm.attendant.firstName\" class=\"k-textbox info pull-left margin-left-10\" data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του Συνοδού.\"><div class=\"k-edit-label\"><label>Τηλ. Επικοινωνίας:</label></div><md-select ng-model=\"vm.attendant.countryPhoneCode\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important; width: auto\" aria-label=\"Κωδικός Τηλεφώνου\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"countryPhoneCode in vm.countryPhoneCodes\" ng-value=\"countryPhoneCode\">{{countryPhoneCode.description + \" (\" + countryPhoneCode.code + \")\"}}</md-option></md-select><input id=\"attendantPhone\" name=\"attendantPhone\" ng-model=\"vm.attendant.phone\" data-custom=\"#attendantPhone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email Επικοινωνίας:</label></div><input id=\"attendantEmail\" name=\"attendantEmail\" type=\"email\" ng-model=\"vm.attendant.email\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"40\" pattern=\".+\\@.+\\..+\" title=\"Λάθος μορφή email\" validationmessage=\"Λάθος μορφή email\"><div class=\"k-edit-label\"><label>Βαθμός Συγγένειας:</label></div><md-select ng-model=\"vm.attendant.relationshipType\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important\" aria-label=\"Βαθμός Συγγένειας\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"relationshipType in vm.relationshipTypes\" ng-value=\"relationshipType\">{{relationshipType.name}}</md-option></md-select><div class=\"k-edit-label\"><label>Επάγγελμα:</label></div><md-select ng-model=\"vm.attendant.profession\" class=\"k-textbox pull-left margin-left-10\" style=\"margin-top: 0px; background-color: white!important\" aria-label=\"Επάγγελμα\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"profession in vm.professions\" ng-value=\"profession\">{{profession.name}}</md-option></md-select><div class=\"k-edit-label\"><label>Λάθος στοιχεία επικοινωνίας:</label></div><md-checkbox ng-model=\"vm.attendant.isWrongContact\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος στοιχεία επικοινωνίας\"></md-checkbox><div class=\"k-edit-label\"><label>Λάθος τηλέφωνο:</label></div><md-checkbox ng-model=\"vm.attendant.isWrongPhone\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος τηλέφωνο\"></md-checkbox></div><div ng-if=\"vm.editAttendantMode\" style=\"height: 5px; margin-top: 0px; padding-top: 0px; border-top: 3px solid #FAFAFA\" ng-click=\"vm.expandClick(\'attendant\');\" class=\"clearfix add-panel leadCalls-expander\"><div layout=\"row\"><div flex=\"30\"><md-icon class=\"material-icons\" style=\"float: left\">{{ vm.expandCollapseIcon_attendant }}</md-icon></div><div flex=\"40\" style=\"text-align: center; font-size: small; color: #696969\"><b>{{ vm.expandCollapseButtonLabel_attendant }}</b></div><div flex=\"30\" style=\"margin: auto\"><md-icon class=\"material-icons\" style=\"float: right\">{{ vm.expandCollapseIcon_attendant }}</md-icon></div></div></div><!-- / Attendant --><md-button class=\"md-raised md-primary\" style=\"float: right; margin-right: 23%; margin-bottom: 13px\" ng-click=\"vm.updateProspectivePatientAndAttendant();\">Αποθήκευση Π.Ασθενη & Συνοδου</md-button><div class=\"separator\"></div><!-- OLd Patient --><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">supervisor_account</i><label class=\"leadCalls-label\">Συγγενής - Φίλος παλιού ασθενή:</label></div><md-switch id=\"isOldPatientRelative\" ng-model=\"vm.leadCall.isOldPatientRelative\" aria-label=\"Συγγενείς - Φίλος παλιού ασθενή\" md-no-ink style=\"padding-left: 62px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'isOldPatientRelative\', vm.leadCall.isOldPatientRelative)\">{{ vm.leadCall.isOldPatientRelative == true ? \'Ναι\' : \'Όχι\' }}</md-switch><div id=\"oldPatientDiv\" ng-if=\"vm.leadCall.isOldPatientRelative\"><div><div class=\"k-edit-label\"><!--<i class=\"material-icons label-icon\">account_circle</i>--><label class=\"leadCalls-label\">Παλιός Ασθενής:</label></div><input name=\"oldPatient\" id=\"oldPatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.oldPatient.fullName\" ng-disabled=\"vm.editOldPatientMode\" required data-required-msg=\"Παρακαλούμε εισάγετε Παλιό Ασθενή.\"><md-button ng-if=\"!vm.editOldPatientMode\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'oldPatient\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'oldPatient\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientMode && vm.leadCall.oldPatient.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'oldPatient\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editOldPatientMode\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'oldPatient\')\"><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editOldPatientMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" aria-label=\"clear\" ng-click=\"vm.toggle(\'oldPatient\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Άκυρο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientMode && vm.leadCall.oldPatient.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'oldPatient\', \'erase\')\"><md-icon class=\"material-icons\">delete<md-tooltip md-direction=\"bottom\">Εκκαθάριση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div ng-if=\"vm.editOldPatientMode\" kendo-validator=\"vm.oldPatientValidator\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επώνυμο:</label></div><input id=\"oldPatientLastName\" name=\"oldPatientLastName\" ng-model=\"vm.oldPatient.lastName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του Παλιού Ασθενή.\"><div class=\"k-edit-label\"><label>* Όνομα:</label></div><input id=\"oldPatientFirstName\" name=\"oldPatientFirstName\" ng-model=\"vm.oldPatient.firstName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του Παλιού Ασθενή.\"><div class=\"k-edit-label\"><label>Α.Μ.Κ.Α:</label></div><input id=\"oldPatientAmka\" name=\"oldPatientAmka\" ng-model=\"vm.oldPatient.amka\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"11\"><div class=\"k-edit-label\"><label>Τηλ. Επικοινωνίας:</label></div><input id=\"oldPatientPhone\" name=\"phone\" ng-model=\"vm.oldPatient.phone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email Επικοινωνίας:</label></div><input id=\"oldPatientEmail\" name=\"phone\" ng-model=\"vm.oldPatient.email\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"40\"><div class=\"k-edit-label\"><label>Έτος Γέννησης:</label></div><input id=\"oldPatientYearOfBirth\" name=\"oldPatientYearOfBirth\" ng-model=\"vm.oldPatient.yearOfBirth\" class=\"k-textbox pull-left margin-left-10\" maxlength=\"4\" ng-change=\"vm.oldPatientBirthYearOnChange(vm.oldPatient.yearOfBirth)\"> <i ng-if=\"vm.oldPatientAge !== null;\" class=\"pull-left margin-left-10\" style=\"margin-left: 5px; margin-top: 3px\"><small>{{vm.oldPatientAge}} χρονών</small></i><!-- This with keypad and age calculation --><!--<input id=\"oldPatientYearOfBirth\" name=\"oldPatientYearOfBirth\" ng-change=\"vm.calculateAge(\'oldPatient\')\" ng-model=\"vm.oldPatient.yearOfBirth\"--><!--ng-focus=\"vm.toggleKeypad(\'oldPatientYearOfBirth\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'oldPatientYearOfBirth\')\" class=\"k-textbox pull-left margin-left-10\"--><!--maxlength=\"4\"/>--><!--<bc-keypad id=\"oldPatientYearOfBirthKeypad\" ng-show=\"vm.oldPatientFocusYearOfBirth\" bc-number-model=\"vm.oldPatient.yearOfBirth\" bc-max-length=\"4\"--><!--ng-click=\"vm.calculateAge(\'oldPatient\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'oldPatientYearOfBirthKeypad\')\" bc-left-button=\"backspace\" class=\"year-of-birth\"></bc-keypad>--><!--<div class=\"k-edit-label\">\n                                        <label>Ηλικία: </label>\n                                    </div>\n                                    <input id=\"oldPatientAge\" name=\"age\" ng-change=\"vm.calculateYearOfBirth(\'oldPatient\')\" ng-model=\"vm.oldPatient.age\"\n                                           ng-focus=\"vm.toggleKeypad(\'oldPatientAge\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'oldPatientAge\')\" class=\"k-textbox pull-left margin-left-10\"\n                                           min=\"0\" maxlength=\"2\"/>\n                                    <bc-keypad id=\"oldPatientAgeKeypad\" ng-show=\"vm.oldPatientFocusAge\" bc-number-model=\"vm.oldPatient.age\" bc-max-length=\"2\" bc-left-button=\"backspace\"\n                                               ng-click=\"vm.calculateYearOfBirth(\'oldPatient\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'oldPatientAgeKeypad\')\" class=\"age\"></bc-keypad>--><div class=\"k-edit-label\"><label>Σχόλια:</label></div><textarea id=\"oldPatientNotes\" name=\"oldPatientNotes\" rows=\"3\" cols=\"150\" ng-model=\"vm.oldPatient.notes\" class=\"k-textbox info pull-left margin-left-10\"></textarea></div><!-- k-options=\"vm.validatorOptions\" --></div><!-- /Old Patient --><div class=\"separator\"></div><!-- Old Patient Doctor --><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">account_circle</i><label class=\"leadCalls-label\">Επαγγελματίας Υγείας:</label></div><input name=\"oldPatientDoctor\" id=\"oldPatientDoctor\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.oldPatientDoctor.fullName\" ng-disabled=\"vm.editOldPatientDoctorMode\" required data-required-msg=\"Παρακαλούμε εισάγετε Συνοδό.\"><md-button ng-if=\"!vm.editOldPatientDoctorMode\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'oldPatientDoctor\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientDoctorMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'oldPatientDoctor\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientDoctorMode && vm.leadCall.oldPatientDoctor.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'oldPatientDoctor\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editOldPatientDoctorMode\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'oldPatientDoctor\')\"><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editOldPatientDoctorMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" aria-label=\"clear\" ng-click=\"vm.toggle(\'oldPatientDoctor\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Άκυρο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editOldPatientDoctorMode && vm.leadCall.oldPatientDoctor.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'oldPatientDoctor\', \'erase\')\"><md-icon class=\"material-icons\">delete<md-tooltip md-direction=\"bottom\">Εκκαθάριση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div ng-if=\"vm.editOldPatientDoctorMode\" kendo-validator=\"vm.oldPatientDoctorValidator\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επώνυμο:</label></div><input id=\"oldPatientDoctorLastName\" name=\"oldPatientDoctorLastName\" ng-model=\"vm.oldPatientDoctor.lastName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του Επαγγελματία Υγείας.\"><div class=\"k-edit-label\"><label>* Όνομα:</label></div><input id=\"oldPatientDoctorFirstName\" name=\"oldPatientDoctorFirstName\" ng-model=\"vm.oldPatientDoctor.firstName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του Επαγγελματία Υγείας.\"><div class=\"k-edit-label\"><label>Α.Μ.Κ.Α:</label></div><input id=\"oldPatientDoctorAmka\" name=\"oldPatientDoctorAmka\" ng-model=\"vm.oldPatientDoctor.amka\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"11\"><div class=\"k-edit-label\"><label>Τηλ. Επικοινωνίας:</label></div><input id=\"oldPatientDoctorPhone\" name=\"oldPatientDoctorPhone\" ng-model=\"vm.oldPatientDoctor.phone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email Επικοινωνίας:</label></div><input id=\"oldPatientDoctorEmail\" name=\"oldPatientDoctorEmail\" ng-model=\"vm.oldPatientDoctor.email\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"40\"><div class=\"k-edit-label\"><label>Σχόλια:</label></div><textarea id=\"oldPatientDoctorNotes\" name=\"oldPatientDoctorNotes\" rows=\"3\" cols=\"150\" ng-model=\"vm.oldPatientDoctor.notes\" class=\"k-textbox info pull-left margin-left-10\"></textarea></div><!-- k-options=\"vm.validatorOptions\" --><!-- /Old Patient Doctor --><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\" style=\"color: #999999\">accessibility</i><label class=\"leadCalls-label\">Παλιός Ασθενής:</label></div><md-switch id=\"isOldPatient\" ng-model=\"vm.leadCall.isOldPatient\" aria-label=\"Παλιός Ασθενής\" md-no-ink style=\"padding-left: 62px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">{{ vm.leadCall.isOldPatient == true ? \'Ναι\' : \'Όχι\' }}</md-switch><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">warning</i><label class=\"leadCalls-label\">Σημαντικό:</label></div><md-switch id=\"isImportant\" ng-model=\"vm.leadCall.isImportant\" aria-label=\"Σημαντικό\" md-no-ink style=\"padding-left: 62px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">{{ vm.leadCall.isImportant == true ? \'Ναι\' : \'Όχι\' }}</md-switch><!--<div class=\"k-edit-label\">\n                                <i class=\"material-icons label-icon\">speaker_notes_off</i>\n                                <label class=\"leadCalls-label\">Δεν άφησε στοιχεία: </label>\n                            </div>\n                            <md-switch id=\"noContact\" ng-model=\"vm.leadCall.noContact\" aria-label=\"Δεν άφησε στοιχεία\"\n                                       md-no-ink style=\"padding-left: 62px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">\n                                {{ vm.leadCall.noContact == true ? \'Ναι\' : \'Όχι\' }}\n                            </md-switch>--></div></div></md-content></md-tab-body></md-tab><md-tab id=\"tabHospitalization\" ng-click=\"vm.tabHeaderClick(\'tabHospitalization\', $event)\"><md-tab-label>Στοιχεία Νοσηλείας</md-tab-label><md-tab-body><md-content layout-padding class=\"md-no-momentum\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div layout=\"row\" id=\"leadHospitalizationForm\" name=\"leadHospitalizationForm\" ng-form><div flex style=\"padding-right: 30px\"><!-- 1st column --><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">security</i></md-icon></span><span style=\"padding-left: 5px\"><label>Ασφάλιση:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><!--<label>Ασφάλιση</label>--><md-select ng-model=\"vm.leadHospitalization.hospitalizationType\" aria-label=\"Ασφάλιση\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.onHospitalizationTypeChange();\"><md-option ng-repeat=\"hospitalizationType in vm.hospitalizationTypes\" ng-value=\"hospitalizationType\"><!-- ng-selected=\"hospitalizationType.id == 1\" --> {{hospitalizationType.name}}</md-option></md-select></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">hotel</i></md-icon></span><span style=\"padding-left: 5px\"><label>Είδος Νοσηλείας:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-radio-group layout=\"row\" id=\"isClosedHospitalization\" name=\"callType\" ng-model=\"vm.leadHospitalization.isClosedHospitalization\" class=\"md-primary\"><!-- style=\"padding-left: 60px; padding-top: 5px;\" --><md-radio-button ng-value=\"false\" class=\"md-primary\">Ανοιχτή</md-radio-button><md-radio-button ng-value=\"true\">Κλειστή</md-radio-button></md-radio-group></div></div></div><md-divider></md-divider><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">healing</i></md-icon></span><span style=\"padding-left: 5px\"><label>Χειρουργείο:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"hadSurgery\" md-invert ng-model=\"vm.leadHospitalization.hadSurgery\" aria-label=\"Χειρουργείο\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'hadSurgery\', vm.leadHospitalization.hadSurgery)\">{{ vm.leadHospitalization.hadSurgery == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadHospitalization.hadSurgery\"><md-input-container style=\"width: 100%\"><label>Είδος Επέμβασης</label><textarea id=\"surgeryType\" name=\"surgeryType\" ng-model=\"vm.leadHospitalization.surgeryType\" md-maxlength=\"150\" maxlength=\"150\" rows=\"2\" cols=\"150\" md-select-on-focus></textarea></md-input-container></div></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">local_hospital</i></md-icon></span><span style=\"padding-left: 5px\"><label>Νοσοκομείο:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><select name=\"sector\" id=\"sector\" class=\"sector\" style=\"width: 100%\" kendo-combo-box k-ng-model=\"vm.leadHospitalization.sector\" k-options=\"vm.sectorOptions\" ng-disabled=\"vm.editSectorMode\" data-custom=\"#sector\" ng-required=\"vm.isCustomerSectorRequired\" data-required-msg=\"Παρακαλούμε εισάγετε Μονάδα Υγείας.\"></select></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">local_hospital</i></md-icon></span><span style=\"padding-left: 5px\"><label>Κλινικη Νοσηλείας:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><select name=\"clinicName\" id=\"clinicName\" class=\"clinicName\" style=\"width: 100%\" kendo-combo-box k-ng-model=\"vm.leadHospitalization.clinicName\" k-options=\"vm.clinicNamesOptions\" data-custom=\"#sector\"></select></div></div></div><md-divider style=\"margin-bottom: 30px\"></md-divider><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">event</i></md-icon></span><span style=\"padding-left: 5px\"><label>Πιθανή Ημερ/νία Εξιτηρίου:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><input name=\"possibleDischargeDate\" id=\"possibleDischargeDate\" kendo-date-picker style=\"width: 100%\" placeholder=\"Επιλέξτε Ημερομηνία\" k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.leadHospitalization.possibleDischargeDate\" onkeydown=\"return false\"></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">comment</i></md-icon></span><span style=\"padding-left: 5px\"><label>Παρατηρήσεις:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-input-container style=\"width: 100%\"><textarea id=\"leadHospitalizationComments\" name=\"leadHospitalizationComments\" rows=\"3\" cols=\"150\" md-maxlength=\"500\" maxlength=\"500\" ng-model=\"vm.leadHospitalization.comments\" aria-label=\"Παρατηρήσεις\" style=\"border:solid 1px #9E9E9E\"></textarea></md-input-container></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">compare_arrows</i></md-icon></span><span style=\"padding-left: 5px\"><label>Συνέχεια Νοσηλείας από Άλλο K.A.:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"isFollowingHospitalization\" md-invert ng-model=\"vm.leadHospitalization.isFollowingHospitalization\" aria-label=\"Συνέχεια Νοσηλείας από Άλλο\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">{{ vm.leadHospitalization.isFollowingHospitalization == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadHospitalization.isFollowingHospitalization\"><md-input-container style=\"width: 100%\"><label>Άλλο Κ.Α.:</label><md-select aria-label=\"Ανταγωνισμός\" style=\"margin-top: 0px\" ng-model=\"vm.leadHospitalization.competitor\" ng-model-options=\"{trackBy: \'$value.id\'}\"><!-- ng-model=\"vm.leadHospitalization.competitor\" --><md-option ng-repeat=\"competitor in vm.competitors\" ng-value=\"competitor\">{{competitor.name}}</md-option></md-select></md-input-container></div></div></div></div></div><div class=\"verticalDivider\" ng-style=\"{minHeight: vm.leadHospitalizationContentScrollHeight + \'px\'}\"></div><div flex style=\"padding-left: 30px\"><!-- 2nd column --><div flex><div layout=\"row\" layout-align=\"start top\" class=\"leadHospitalizationFormRows\"><div flex=\"40\" style=\"padding-top: 40px\"><span><md-icon class=\"name\"><i class=\"material-icons\">format_list_bulleted</i></md-icon></span><span style=\"padding-left: 5px\"><label>Κατάσταση Ασθενή:</label></span></div><div flex=\"60\" layout-padding=\"30px;\"><md-list style=\"height: 250px; overflow-y: scroll\" flex><md-list-item ng-repeat=\"addCondition in vm.addConditions\"><md-checkbox class=\"md-secondary\" ng-model=\"addCondition.selected\"></md-checkbox><p>{{ addCondition.name }}</p><md-icon class=\"md-secondary\" ng-click=\"vm.showInfo(\'Πληροφορίες\', addCondition.information)\" aria-label=\"Chat\" md-svg-icon=\"content/images/baseline-info-24px.svg\"></md-icon></md-list-item></md-list></div></div></div><md-divider></md-divider><div flex><div layout=\"row\" layout-align=\"start top\" class=\"leadHospitalizationFormRows\"><div flex=\"40\" style=\"padding-top: 40px\"><span><md-icon class=\"name\"><i class=\"material-icons\">format_list_bulleted</i></md-icon></span><span style=\"padding-left: 5px\"><label>Συνοδά Νοσήματα:</label></span></div><div flex=\"60\" layout-padding=\"30px;\"><md-list style=\"height: 250px; overflow-y: scroll\" flex><md-list-item ng-repeat=\"addDisease in vm.addDiseases\"><md-checkbox class=\"md-secondary\" ng-model=\"addDisease.selected\" ng-change=\"vm.onAddDiseaseChange(addDisease)\"></md-checkbox><p>{{ addDisease.name }}</p><md-icon class=\"md-secondary\" ng-click=\"vm.showInfo(\'Πληροφορίες\', addDisease.information)\" aria-label=\"Chat\" md-svg-icon=\"content/images/baseline-info-24px.svg\"></md-icon></md-list-item></md-list></div></div></div><div flex ng-if=\"vm.showAddDiseaseOther\"><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"40\"><span><md-icon class=\"name\"><i class=\"material-icons\">add_circle_outline</i></md-icon></span><span style=\"padding-left: 5px\"><label>Άλλο Νόσημα:</label></span></div><div flex=\"60\" layout-padding=\"30px;\"><md-input-container style=\"width: 100%\"><textarea id=\"leadHospitalizationΑddDiseaseOther\" name=\"leadHospitalizationΑddDiseaseOther\" rows=\"3\" cols=\"150\" md-maxlength=\"150\" maxlength=\"150\" ng-model=\"vm.leadHospitalization.addDiseaseOther\" aria-label=\"Άλλο Νόσημα\" style=\"border:solid 1px #9E9E9E\"></textarea></md-input-container></div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">forum</i></md-icon></span><span style=\"padding-left: 5px\"><label>Κατάσταση επικοινωνίας:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-select ng-model=\"vm.leadHospitalization.communicationStatus\" aria-label=\"Κατάσταση επικοινωνίας\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"communicationStatus in vm.communicationStatuses\" ng-value=\"communicationStatus\"><!-- ng-selected=\"hospitalizationType.id == 1\" --> {{communicationStatus.name}}</md-option></md-select></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">today</i></md-icon></span><span style=\"padding-left: 5px\"><label>Ημερομηνία Εισαγωγής:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><input name=\"hospitalizationDate\" id=\"hospitalizationDate\" kendo-date-picker style=\"width: 100%\" placeholder=\"Επιλέξτε Ημερομηνία\" k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.leadHospitalization.hospitalizationDate\" onkeydown=\"return false\"></div></div></div></div></div></md-content></md-tab-body></md-tab><md-tab id=\"tabDiseases\" ng-disabled=\"vm.leadCall.leadHospitalizations[0].id === null || vm.leadCall.leadHospitalizations[0].id === undefined\" ng-click=\"vm.tabHeaderClick(\'tabDiseases\', $event)\"><md-tab-label>Ιατρικό Ιστορικό</md-tab-label><md-tab-body><md-content ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div id=\"diseasesForm\" name=\"diseasesForm\" ng-form><md-list style=\"height: 650px; overflow-y: scroll; padding: 0px\"><div ng-repeat=\"diseaseType in vm.diseaseTypes\" style=\"background-color: yellow\"><!-- ng-click=\"console.log(\'md-list-item-click\');\" --><section class=\"md-list-item-text\"><md-subheader class=\"md-primary\" style=\"font-size: medium; background-color: #E0E0E0\"><div style=\"display: inline-block\"><b>{{ diseaseType.name.toUpperCase(); }}</b></div><div style=\"display: inline-block; margin-left: 10px\"><md-icon class=\"name\" ng-click=\"vm.showInfo(diseaseType.name + \' - Πλεονεκτήματα\', diseaseType.advantages)\"><i class=\"material-icons\" style=\"color: #0074BC\">done_all</i><md-tooltip md-direction=\"bottom\">Πλεονεκτήματα</md-tooltip></md-icon></div><div style=\"display: inline-block; margin-left: 10px\"><md-icon class=\"name\" ng-click=\"vm.showInfo(diseaseType.name + \' - Προσφορά\', diseaseType.offer)\"><i class=\"material-icons\" style=\"color: #0074BC\">local_offer</i><md-tooltip md-direction=\"bottom\">Προσφορά</md-tooltip></md-icon></div><div style=\"display: inline-block; margin-left: 10px\"><md-icon class=\"name\" ng-click=\"vm.showInfo(diseaseType.name + \' - Έγγραφα\', diseaseType.documents)\"><i class=\"material-icons\" style=\"color: #0074BC\">description</i><md-tooltip md-direction=\"bottom\">Έγγραφα</md-tooltip></md-icon></div></md-subheader><div ng-if=\"diseaseType.diseases.length == 0\" style=\"height: 60px; background-color: white\"></div><div ng-if=\"diseaseType.diseases.length > 0\" style=\"padding-left: 5%; background-color: white\"><md-list layout=\"column\"><md-list-item ng-repeat=\"dis in diseaseType.diseases\"><md-checkbox ng-model=\"dis.selected\" ng-change=\"vm.onDiseaseChange(dis)\"></md-checkbox><p>{{dis.name}}</p></md-list-item></md-list></div></section></div></md-list></div></md-content><!--<md-button ng-click=\"vm.saveDiseases();\" class=\"md-fab md-fab-bottom-right\" aria-label=\"Back\" style=\"background-color: #F9A22E; color: #0074BC; margin-right: 30px;\">\n                    <md-tooltip md-direction=\"left\">{{ vm.saveDiseasesButtonLabel }}</md-tooltip>\n                    <md-icon style=\"color: #0074BC\"><i class=\"material-icons\">save</i></md-icon>\n                </md-button>--></md-tab-body></md-tab><md-tab id=\"tabCharges\" ng-disabled=\"vm.leadCall.leadHospitalizations[0].id === null || vm.leadCall.leadHospitalizations[0].id === undefined\" ng-click=\"vm.tabHeaderClick(\'tabCharges\', $event)\"><md-tab-label>Χρεώσεις</md-tab-label><md-tab-body><md-content id=\"chargesContent\" layout-padding class=\"md-no-momentum\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div layout=\"row\" id=\"chargesForm\" name=\"chargesForm\" ng-form><div flex style=\"padding-right: 30px\"><!-- 1st column --><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">euro_symbol</i></md-icon></span><span style=\"padding-left: 5px\"><label>Κόστος:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-select ng-model=\"vm.leadOffer.costType\" aria-label=\"Κόστος\" ng-disabled=\"vm.disableCostType\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.onCostTypeChange();\"><md-option ng-repeat=\"costType in vm.costTypes\" ng-value=\"costType\">{{costType.name}}</md-option></md-select></div></div><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">card_giftcard</i></md-icon></span><span style=\"padding-left: 5px\"><label>Προσφορά:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-select ng-model=\"vm.leadOffer.offerStatus\" aria-label=\"Προσφορά\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"offerStatus in vm.offerStatuses\" ng-value=\"offerStatus\">{{offerStatus.name}}</md-option></md-select></div></div><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">hotel</i></md-icon></span><span style=\"padding-left: 5px\"><label>Ενδιαφέρον Επαγγελματία Υγείας για Κλίνη:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-select ng-model=\"vm.leadOffer.desirableRoomType\" aria-label=\"Ενδιαφέρον Επαγγελματία Υγείας για Κλίνη\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"desirableRoomType in vm.roomTypes\" ng-value=\"desirableRoomType\">{{desirableRoomType.name}}</md-option></md-select></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\" style=\"padding-top: 25px\"><div flex=\"50\" style=\"padding-top: 40px\"><span><md-icon class=\"name\"><i class=\"material-icons\">hotel</i></md-icon></span><span style=\"padding-left: 5px\"><label>Προσφορές Κλινών:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-list style=\"height: auto; padding-left: 20px\" flex><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"roomType in vm.roomTypes\" style=\"height: 40px; margin-bottom: 15px\"><div flex=\"10\"><md-checkbox ng-model=\"roomType.selected\" style=\"padding-top: 10px\" ng-change=\"vm.leadOfferRoomTypeChange(roomType)\"></md-checkbox></div><div flex=\"40\"><p>{{ roomType.name }}</p></div><div flex=\"40\"><input id=\"roomTypePrice{{roomType.id}}\" ng-model=\"roomType.price\" type=\"number\" class=\"k-textbox\" ng-disabled=\"!roomType.selected\" style=\"width: 90%; margin-bottom: 7px; text-align: right\" placeholder=\"Τιμή\"></div><div flex=\"10\"><p>€</p></div></div></md-list></div></div><md-divider></md-divider><div flex style=\"padding-top: 30px\"><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">format_quote</i></md-icon></span><span style=\"padding-left: 5px\"><label>Παραπομπή στην Ανοιχτή Νοσηλεία:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-switch id=\"openHospitalizationReference\" ng-model=\"vm.leadOffer.openHospitalizationReference\" aria-label=\"Παραπομπή στην Ανοιχτή Νοσηλεία\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">{{ vm.leadOffer.openHospitalizationReference == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div></div></div><!--<div flex>\n                                <div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\">\n                                    <div flex=\"50\">\n                                    <span>\n                                        <md-icon class=\"name\">\n                                            <i class=\"material-icons\">event</i>\n                                        </md-icon>\n                                    </span>\n                                        <span style=\"padding-left: 5px;\">\n                                        <label>Ραντεβού Αρχικής Εκτίμησης:</label>\n                                    </span>\n                                    </div>\n                                    <div flex=\"50\" layout-padding=\"30px;\" >\n                                        <div>\n                                            <md-switch id=\"isFirstEstimationDate\" ng-model=\"vm.isFirstEstimationDate\" aria-label=\"Ραντεβού Αρχικής Εκτίμησης\"\n                                                       md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\"\n                                                       ng-change=\"vm.toggleSwitch(\'isFirstEstimationDate\', vm.isFirstEstimationDate)\">\n                                                {{ vm.isFirstEstimationDate == true ? \'Ναι\' : \'Όχι\' }}\n                                            </md-switch>\n                                        </div>\n                                        <div ng-if=\"vm.isFirstEstimationDate\">\n                                            <input  name=\"firstEstimationDate\" id=\"firstEstimationDate\" kendo-date-picker\n                                                    k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.leadOffer.firstEstimationDate\" onkeydown=\"return false\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>--></div><div class=\"verticalDivider\" ng-style=\"{minHeight: vm.chargesFormContentScrollHeight + \'px\'}\"></div><div flex style=\"padding-left: 30px\"><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\" style=\"padding-top: 30px\"><div flex=\"40\"><span><md-icon class=\"name\"><i class=\"material-icons\">record_voice_over</i></md-icon></span><span style=\"padding-left: 5px\"><label>Κλητική Προσφώνηση:</label></span></div><div flex=\"60\" layout-padding=\"30px;\"><md-input-container style=\"width: 100%\"><textarea id=\"leadOfferInvitationText\" name=\"leadOfferInvitationText\" rows=\"3\" cols=\"150\" md-maxlength=\"250\" maxlength=\"250\" ng-model=\"vm.leadOffer.invitationText\" aria-label=\"Κλητική Προσφώνηση\" style=\"border:solid 1px #9E9E9E\"></textarea></md-input-container></div></div></div><md-divider></md-divider><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #BDBDBD\">local_offer</i></md-icon></span><span style=\"padding-left: 5px\"><label>Αίτημα Έκπτωσης:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"hasRequestedDiscount\" ng-model=\"vm.leadDiscount.hasRequestedDiscount\" aria-label=\"Αίτημα Έκπτωσης\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'hasRequestedDiscount\', vm.leadDiscount.hasRequestedDiscount)\">{{ vm.leadDiscount.hasRequestedDiscount == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadDiscount.hasRequestedDiscount\"><md-input-container style=\"width: 100%\"><label>Αιτιολογία:</label><md-select ng-model=\"vm.leadDiscount.requestedReason\" aria-label=\"Αιτιολογία\" style=\"margin-top: 0px\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"requestedReason in vm.discountReasons\" ng-value=\"requestedReason\">{{requestedReason.name}}</md-option></md-select></md-input-container></div></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #999999\">local_offer</i></md-icon></span><span style=\"padding-left: 5px\"><label>Δικαίωμα Έκπτωσης:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"isEntitledToDiscount\" ng-model=\"vm.leadDiscount.isEntitledToDiscount\" aria-label=\"Δικαίωμα Έκπτωσης\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'isEntitledToDiscount\', vm.leadDiscount.isEntitledToDiscount)\">{{ vm.leadDiscount.isEntitledToDiscount == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadDiscount.isEntitledToDiscount\"><md-input-container style=\"width: 100%\"><label>Αιτιολογία:</label><md-select ng-model=\"vm.leadDiscount.entitledToReason\" aria-label=\"Αιτιολογία\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"entitledToReason in vm.discountReasons\" ng-value=\"entitledToReason\">{{entitledToReason.name}}</md-option></md-select></md-input-container></div></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">local_offer</i></md-icon></span><span style=\"padding-left: 5px\"><label>Τελική Έκπτωση:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"hasFinalDiscount\" ng-model=\"vm.hasFinalDiscount\" aria-label=\"Τελική Έκπτωση\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'hasFinalDiscount\', vm.hasFinalDiscount)\">{{ vm.hasFinalDiscount == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.hasFinalDiscount\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"70\"><md-input-container style=\"width: 100%\"><label>Έκπτωση</label><md-select ng-model=\"vm.leadDiscount.finalDiscount\" aria-label=\"Τελική Έκπτωση\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.onFinalDiscountChange();\"><md-option ng-repeat=\"finalDiscount in vm.discountRates\" ng-value=\"finalDiscount\">{{finalDiscount.name}}</md-option></md-select></md-input-container></div><div flex=\"30\"><i ng-if=\"vm.roomCostWithDiscount !== null;\" style=\"margin-left: 15px; margin-top: 3px\"><small>{{vm.roomCostWithDiscount}}€</small><small style=\"font-size: xx-small\"> με έκτπωση</small></i></div></div><div><md-input-container style=\"width: 100%\"><label>Αιτιολογία</label><md-select ng-model=\"vm.leadDiscount.finalReason\" aria-label=\"Αιτιολογία\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"finalReason in vm.discountReasons\" ng-value=\"finalReason\">{{finalReason.name}}</md-option></md-select></md-input-container></div></div></div></div></div></div><md-divider></md-divider><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\" style=\"padding-top: 30px\"><div flex=\"40\"><span><md-icon class=\"name\"><i class=\"material-icons\">comment</i></md-icon></span><span style=\"padding-left: 5px\"><label>Σχόλια:</label></span></div><div flex=\"60\" layout-padding=\"30px;\"><md-input-container style=\"width: 100%\"><textarea id=\"leadHospitalizationRoomServices\" name=\"leadHospitalizationRoomServices\" rows=\"3\" cols=\"150\" md-maxlength=\"250\" maxlength=\"250\" ng-model=\"vm.leadOffer.roomServices\" aria-label=\"Παροχές\" style=\"border:solid 1px #9E9E9E\"></textarea></md-input-container></div></div></div><md-divider></md-divider><!--<div flex>\n                                <div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\">\n                                    <div flex=\"50\">\n                                    <span>\n                                        <md-icon class=\"name\">\n                                            <i class=\"material-icons\">hotel</i>\n                                        </md-icon>\n                                    </span>\n                                        <span style=\"padding-left: 5px;\">\n                                        <label>Ενδιαφέρον Επαγγελματία Υγείας για Κλίνη:</label>\n                                    </span>\n                                    </div>\n                                    <div flex=\"50\" layout-padding=\"30px;\" >\n                                        <md-select ng-model=\"vm.leadOffer.desirableRoomType\"\n                                                   aria-label=\"Ενδιαφέρον Επαγγελματία Υγείας για Κλίνη\"\n                                                   ng-model-options=\"{trackBy: \'$value.id\'}\">\n                                            <md-option ng-repeat=\"desirableRoomType in vm.roomTypes\" ng-value=\"desirableRoomType\">\n                                                {{desirableRoomType.name}}\n                                            </md-option>\n                                        </md-select>\n                                    </div>\n                                </div>\n                            </div>--><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">airport_shuttle</i></md-icon></span><span style=\"padding-left: 5px\"><label>Ενδιαφέρον για Μεταφορά:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"wantsTransportation\" ng-model=\"vm.leadOffer.wantsTransportation\" aria-label=\"Ενδιαφέρον για Μεταφορά\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'wantsTransportation\', vm.leadOffer.wantsTransportation)\">{{ vm.leadOffer.wantsTransportation == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadOffer.wantsTransportation\"><md-input-container style=\"width: 100%\"><label>Μεταφορά:</label><md-select ng-model=\"vm.leadOffer.transportation\" aria-label=\"Μεταφορά\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"transportation in vm.transportations\" ng-value=\"transportation\">{{transportation.name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.leadOffer.wantsTransportation\"><md-input-container style=\"width: 100%\"><label>Σχόλια</label><textarea id=\"wantsTransportationComments\" name=\"wantsTransportationComments\" ng-model=\"vm.leadOffer.comments\" md-maxlength=\"150\" maxlength=\"150\" rows=\"2\" cols=\"150\" md-select-on-focus></textarea></md-input-container></div></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">room_service</i></md-icon></span><span style=\"padding-left: 5px\"><label>Ενδιαφέρον για Γεύμα Συνοδού:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><md-switch id=\"attendantMeal\" ng-model=\"vm.leadOffer.attendantMeal\" aria-label=\"Ενδιαφέρον για Γεύμα Συνοδού\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\">{{ vm.leadOffer.attendantMeal == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div></div></div><md-divider></md-divider><div flex><div layout=\"row\" layout-align=\"start center\" class=\"leadHospitalizationFormRows\"><div flex=\"50\"><span><md-icon class=\"name\"><i class=\"material-icons\">local_offer</i></md-icon></span><span style=\"padding-left: 5px\"><label>Λήψη Προσφοράς Ανταγωνισμού:</label></span></div><div flex=\"50\" layout-padding=\"30px;\"><div><md-switch id=\"hasCompetitiveBid\" ng-model=\"vm.leadOffer.hasCompetitiveBid\" aria-label=\"Λήψη Προσφοράς Ανταγωνισμού\" md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'hasCompetitiveBid\', vm.leadOffer.hasCompetitiveBid)\">{{ vm.leadOffer.hasCompetitiveBid == true ? \'Ναι\' : \'Όχι\' }}</md-switch></div><div ng-if=\"vm.leadOffer.hasCompetitiveBid\"><md-input-container style=\"width: 100%\"><label>Ανταγωνισμός</label><md-select ng-model=\"vm.leadOffer.competitor\" aria-label=\"Ανταγωνισμός\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"competitor in vm.competitors\" ng-value=\"competitor\">{{competitor.name}}</md-option></md-select></md-input-container></div></div></div></div></div></div></md-content><!--<div style=\"display: block; margin-bottom: 5px; margin-right: 5px; background-color: yellow\">\n                    <md-button ng-click=\"vm.saveLeadOffer();\" class=\"md-fab md-fab-bottom-right\" aria-label=\"Back\" style=\"background-color: #F9A22E; color: #0074BC; margin-right: 30px;\">\n                        <md-tooltip md-direction=\"left\">{{vm.saveLeadOfferButtonLabel}}</md-tooltip>\n                        <md-icon style=\"color: #0074BC\"><i class=\"material-icons\">save</i></md-icon>\n                    </md-button>\n                </div>--></md-tab-body></md-tab><md-tab id=\"tabFollowup\" ng-disabled=\"vm.leadCall.id === null || vm.leadCall.id === undefined\" ng-click=\"vm.tabHeaderClick(\'tabFollowup\', $event)\"><md-tab-label>Follow Up</md-tab-label><md-tab-body><md-content layout-padding ng-cloak ng-style=\"{height: vm.contentHeight, overflow: hidden}\"><kendo-grid id=\"followUpsGrid\" style=\"height: 95%\" k-options=\"vm.followUpGridOptions\"></kendo-grid></md-content></md-tab-body></md-tab></md-tabs><!-- Kendo Notifications --><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div><div id=\"wnd\" kendo-window=\"vm.window\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\"><div id=\"window\" class=\"middle\"><kendo-grid id=\"popupGrid\" options=\"vm.popupGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.popupGridOptions\" k-rebind=\"vm.popupGridOptions.columns\"></kendo-grid><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-button md-primary pull-right\" style=\"padding-right: 25px!important; background: #F9A22E; color: #0074BC\" ng-click=\"vm.dataItemSelected()\"><span class=\"hidden-sm\">Επιλογή</span></md-button></div></div>");
$templateCache.put("app/displays/hospitalizations/hospitalizations.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-location_city-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.addNew();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθηκη Εισαγωγής</span></md-button></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"hospitalizationsGrid\" options=\"vm.hospitalizationsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.hospitalizationsGridOptions\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"height: 800px\"></kendo-grid>");
$templateCache.put("app/displays/hospitalizations/hospitalizationView.html","<div class=\"entity-view clearfix\"><div id=\"hospitalization\"><div id=\"form\" name=\"form\" ng-form kendo-validator=\"vm.validator\" k-options=\"vm.validatorOptions\"><div class=\"columns\"><h3 class=\"bordered\"><span>{{ vm.pageHeading }}</span></h3></div><div class=\"popup-info full-width\" style=\"padding: 1em\"><!--<h5>Εισαγωγή</h5>--><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">today</i><label>Ημερομηνία Εισαγωγής:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><input name=\"dateIssue\" id=\"dateIssue\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.hospitalization.dateIssue\"><!--k-on-change=\"vm.dateIssueOnChange()\"--></div><div class=\"separator\"></div><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">account_circle</i><label>* Ονοματεπώνυμο Ασθενή:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><input name=\"patient\" id=\"patient\" class=\"k-input k-textbox patient\" ng-model=\"vm.hospitalization.patient.fullName\" ng-disabled=\"vm.editPatientMode\" required data-required-msg=\"Παρακαλούμε εισάγετε Ασθενή.\"></div><md-button ng-if=\"!vm.editPatientMode\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'patient\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση Ασθενή</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editPatientMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.openWindow(\'leadCall\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση Ασθενή από LeadManagement</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editPatientMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'patient\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editPatientMode && vm.hospitalization.patient.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'patient\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editPatientMode\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'patient\')\"><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editPatientMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" aria-label=\"clear\" ng-click=\"vm.toggle(\'patient\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Κλείσιμο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editPatientMode && vm.hospitalization.patient.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'patient\', \'erase\')\"><md-icon class=\"eraser-svg\"><md-tooltip md-direction=\"bottom\">Διαγραφή</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div ng-if=\"vm.editPatientMode\" kendo-validator=\"vm.patientValidator\" k-options=\"vm.validatorOptions\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επώνυμο:</label></div><input id=\"lastName\" name=\"lastName\" ng-model=\"vm.patient.lastName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του ασθενή.\"><div class=\"k-edit-label\"><label>* Όνομα:</label></div><input id=\"firstName\" name=\"firstName\" ng-model=\"vm.patient.firstName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του ασθενή.\"><div class=\"k-edit-label\"><label>Έτος Γέννησης:</label></div><input id=\"yearOfBirth\" name=\"yearOfBirth\" ng-change=\"vm.calculateAge()\" ng-model=\"vm.patient.yearOfBirth\" ng-focus=\"vm.toggleKeypad(\'yearOfBirth\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'yearOfBirth\')\" class=\"k-textbox pull-left margin-left-10\" maxlength=\"4\"><bc-keypad id=\"yearOfBirthKeypad\" ng-show=\"vm.focusYearOfBirth\" bc-number-model=\"vm.patient.yearOfBirth\" bc-max-length=\"4\" ng-click=\"vm.calculateAge()\" ng-blur=\"vm.hideKeypadOnBlur($event, \'yearOfBirthKeypad\')\" bc-left-button=\"backspace\" class=\"year-of-birth\"></bc-keypad><div class=\"k-edit-label\"><label>Ηλικία:</label></div><input id=\"age\" name=\"age\" ng-change=\"vm.calculateYearOfBirth()\" ng-model=\"vm.patient.age\" ng-focus=\"vm.toggleKeypad(\'age\')\" ng-blur=\"vm.hideKeypadOnBlur($event, \'age\')\" class=\"k-textbox pull-left margin-left-10\" min=\"0\" maxlength=\"2\"><bc-keypad id=\"ageKeypad\" ng-show=\"vm.focusAge\" bc-number-model=\"vm.patient.age\" bc-max-length=\"2\" bc-left-button=\"backspace\" ng-click=\"vm.calculateYearOfBirth()\" ng-blur=\"vm.hideKeypadOnBlur($event, \'ageKeypad\')\" class=\"age\"></bc-keypad><div class=\"k-edit-label\"><label>Α.Μ.Κ.Α:</label></div><input id=\"amka\" name=\"amka\" ng-model=\"vm.patient.amka\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"11\"><div class=\"k-edit-label\"><label>Τηλ. Επικοινωνίας:</label></div><input id=\"phone\" name=\"phone\" ng-model=\"vm.patient.phone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email Επικοινωνίας:</label></div><input id=\"patientEmail\" name=\"phone\" ng-model=\"vm.patient.email\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"40\"><div class=\"k-edit-label\"><label>Σχόλια:</label></div><textarea id=\"notes2\" name=\"notes2\" rows=\"3\" cols=\"150\" ng-model=\"vm.patient.notes\" class=\"k-textbox info pull-left margin-left-10\"></textarea></div><!--<div>--><!--<div class=\"k-edit-label\">--><!--<label>Ηλικία ασθενή κατά την εισαγωγή: </label>--><!--</div>--><!--<input id=\"patientAge\" name=\"patientAge\" kendo-numeric-text-box ng-readonly=\"true\" k-format=\"\'n0\'\"--><!--k-ng-model=\"vm.hospitalization.patientAge\" class=\"pull-left margin-left-10\" min=\"0\"/>--><!--</div>--><div class=\"separator\"></div><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">person</i><label><span ng-show=\"vm.isCustomerSectorRequired\">* </span>Ονοματεπώνυμο Επαγγελματία Υγείας:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><input name=\"customer\" id=\"customer\" class=\"k-input k-textbox customer\" ng-model=\"vm.hospitalization.customer.fullName\" ng-disabled=\"vm.editCustomerMode\" ng-required=\"vm.isCustomerSectorRequired\" data-required-msg=\"Παρακαλούμε εισάγετε Επαγγελματία Υγείας.\"></div><md-button ng-if=\"!vm.editCustomerMode\" class=\"pull-left orange-md-button md-icon-button md-button md-ink-ripple md-warn search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'customer\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση Επαγγελματία Υγείας</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editCustomerMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'customer\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editCustomerMode && vm.hospitalization.customer.fullName\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'customer\', \'edit\')\"><md-icon class=\"material-icons pencil\">mode_edit<md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editCustomerMode\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'customer\')\"><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editCustomerMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" aria-label=\"clear\" ng-click=\"vm.toggle(\'customer\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Κλείσιμο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editCustomerMode && vm.hospitalization.customer.fullName\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'customer\', \'erase\')\"><md-icon class=\"eraser-svg\"><md-tooltip md-direction=\"bottom\">Διαγραφή</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><div ng-if=\"vm.editCustomerMode\" kendo-validator=\"vm.customerValidator\" k-options=\"vm.validatorOptions\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επώνυμο:</label></div><input id=\"customerLastName\" name=\"lastName\" ng-model=\"vm.customer.lastName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του επαγγελματία υγείας.\"><div class=\"k-edit-label\"><label>* Όνομα:</label></div><input id=\"customerFirstName\" name=\"firstName\" ng-model=\"vm.customer.firstName\" class=\"k-textbox info pull-left margin-left-10\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του επαγγελματία υγείας.\"><div class=\"k-edit-label\"><label>* Ειδικότητα:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 25px\"><select name=\"doctorSpecialty\" id=\"doctorSpecialty\" kendo-combo-box k-ng-model=\"vm.customer.doctorSpecialty.id\" k-options=\"vm.doctorSpecialtyOptions\" data-custom=\"#doctorSpecialty\" required data-required-msg=\"Παρακαλούμε εισάγετε την ειδικότητα του επαγγελματία υγείας.\"></select></div><div class=\"k-edit-label\"><label>Κινητό:</label></div><input id=\"customerCellPhone\" name=\"cellPhone\" ng-model=\"vm.customer.cellPhone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Α.Μ.Κ.Α.:</label></div><input id=\"customerAmka\" name=\"amka\" ng-model=\"vm.customer.amka\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"11\"><div class=\"k-edit-label\"><label>Σταθερό Τηλέφωνο:</label></div><input id=\"customerPhone\" name=\"phone\" ng-model=\"vm.customer.phone\" class=\"k-textbox info pull-left margin-left-10\" maxlength=\"10\"><div class=\"k-edit-label\"><label>Email:</label></div><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"vm.customer.email\" class=\"k-textbox info pull-left margin-left-10\" placeholder=\"example@example.gr\"></div><!--<div>--><!--<div class=\"k-edit-label\">--><!--<label>Τύπος Επαγγελματία Υγείας: </label>--><!--</div>--><!--<select name=\"customerTitle\" id=\"customerTitle\" class=\"pull-left margin-left-10\" kendo-combo-box--><!--k-ng-model=\"vm.hospitalization.customerTitle\" k-options=\"vm.customerTitleOptions\"></select>--><!--</div>--><div class=\"separator\"></div><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">local_hospital</i><label><span ng-show=\"vm.isCustomerSectorRequired\">* </span>Νοσοκομείο:</label></div><div class=\"pull-left margin-left-10 sector\" style=\"margin-left: 25px\"><select name=\"sector\" id=\"sector\" kendo-combo-box k-ng-model=\"vm.hospitalization.sector\" k-options=\"vm.sectorOptions\" ng-disabled=\"vm.editSectorMode\" data-custom=\"#sector\" ng-required=\"vm.isCustomerSectorRequired\" data-required-msg=\"Παρακαλούμε εισάγετε Μονάδα Υγείας.\"></select></div><md-button ng-if=\"!vm.editSectorMode\" class=\"pull-left orange-md-button md-icon-button md-warn md-button md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openWindow(\'sector\')\"><md-icon class=\"material-icons\">search<md-tooltip md-direction=\"bottom\">Αναζήτηση Μ.Υ.</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editSectorMode\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"add\" ng-click=\"vm.toggle(\'sector\', \'add\')\"><md-icon class=\"material-icons\">add<md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></md-button><!--<md-button ng-if=\"!vm.editSectorMode && vm.hospitalization.sector\" class=\"pull-left md-icon-button md-primary md-button md-ink-ripple add-btn\" aria-label=\"edit\" ng-click=\"vm.toggle(\'sector\', \'edit\')\">\n                        <md-icon class=\'material-icons pencil\'>mode_edit</md-icon></md-button>--><!-- Commented out for ECRM-373 --><md-button ng-if=\"vm.editSectorMode\" class=\"pull-left save-btn md-icon-button md-primary md-button md-ink-ripple\" aria-label=\"save\" ng-click=\"vm.update(\'sector\')\"><md-icon class=\"material-icons\">save<md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></md-button><md-button ng-if=\"vm.editSectorMode\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple clear-btn\" aria-label=\"clear\" ng-click=\"vm.toggle(\'sector\', \'clear\')\"><md-icon class=\"material-icons\">clear<md-tooltip md-direction=\"bottom\">Κλείσιμο</md-tooltip></md-icon></md-button><md-button ng-if=\"!vm.editSectorMode && vm.hospitalization.sector\" class=\"pull-left md-icon-button md-warn md-hue-2 md-button md-ink-ripple erase-btn\" aria-label=\"erase\" ng-click=\"vm.toggle(\'sector\', \'erase\')\"><md-icon class=\"eraser-svg\"><md-tooltip md-direction=\"bottom\">Διαγραφή</md-tooltip></md-icon></md-button><div ng-if=\"!vm.isCustomerSectorConnected\" class=\"connect\"><div class=\"clearfix\"></div><h6 class=\"pull-left margin-left-10 info-text-color\" translate=\"global.messages.info.customerSector\">Sector is not connected with customer.<br>Would you like to connect them?</h6><md-button class=\"md-button md-primary pull-left smaller-md-button\" aria-label=\"clear\" ng-click=\"vm.addCustomerSector()\"><i class=\"material-icons fixed-icons-smaller-md-button pull-left\">add</i>Σύνδεση</md-button></div><div class=\"clearfix\"></div></div><div ng-if=\"vm.editSectorMode\" kendo-validator=\"vm.sectorValidator\" k-options=\"vm.validatorOptions\" class=\"clearfix add-panel fade-element-in\"><div class=\"k-edit-label\"><label>* Επωνυμία Νοσοκομείου:</label></div><input id=\"sectorName\" name=\"sectorName\" ng-model=\"vm.sector.name\" class=\"k-textbox info pull-left margin-left-10 sector\" required data-required-msg=\"Παρακαλούμε εισάγετε την επωνυμία του Νοσοκομείου.\"><div class=\"k-edit-label\"><label>Τύπος:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><select name=\"sectorType\" id=\"sectorType\" kendo-combo-box k-ng-model=\"vm.sector.sectorType.id\" k-options=\"vm.sectorTypeOptions\"></select></div></div><div><div class=\"k-edit-label\"><label>Κλινική:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><select name=\"clinicName\" id=\"clinicName\" kendo-combo-box ng-disabled=\"!vm.hospitalization.sector\" k-ng-model=\"vm.hospitalization.clinicName\" k-options=\"vm.clinicNameOptions\"></select></div></div><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">info</i><label>Επιθυμ. Τύπος Δωματίου:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><select name=\"roomType\" id=\"roomType\" kendo-combo-box k-ng-model=\"vm.hospitalization.roomType.id\" k-options=\"vm.roomTypeOptions\"></select></div><div class=\"k-edit-label\"><!--<i class=\"material-icons label-icon\">info</i>--><label>Τελική Τοποθέτηση:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><select name=\"finalRoomType\" id=\"finalRoomType\" kendo-combo-box k-ng-model=\"vm.hospitalization.finalRoomType.id\" k-options=\"vm.finalRoomTypeOptions\"></select></div><div class=\"k-edit-label\"><label>* Παρατηρήσεις:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><select name=\"hospitalizationType\" id=\"hospitalizationType\" kendo-combo-box k-ng-model=\"vm.hospitalization.hospitalizationType.id\" k-options=\"vm.hospitalizationTypeOptions\" data-custom=\"#hospitalizationType\" required data-required-msg=\"Παρακαλούμε εισάγετε Παρατηρήσεις.\"></select></div><div class=\"k-edit-label\"><label>Σχόλια:</label></div><div class=\"pull-left margin-left-10\" style=\"margin-left: 26px\"><textarea name=\"note\" id=\"note\" class=\"k-textbox info notes\" rows=\"6\" cols=\"150\" ng-model=\"vm.hospitalization.notes\"></textarea></div><div class=\"buttons-wrap full-width\" style=\"clear: both\"><md-button class=\"blue-color-md-button md-raised md-mini md-primary pull-right\" aria-label=\"add\" ng-click=\"vm.save()\"><i class=\"material-icons fixed-icons fixed-icons-2\">save</i>Αποθήκευση</md-button></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></div><div id=\"wnd\" kendo-window=\"vm.window\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\"><div id=\"window\" class=\"middle\"><kendo-grid id=\"popupGrid\" options=\"vm.popupGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.popupGridOptions\" k-rebind=\"vm.popupGridOptions.columns\"></kendo-grid><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised light-green-color-md-button md-primary pull-right\" style=\"padding-right: 25px!important\" ng-click=\"vm.dataItemSelected()\"><i class=\"material-icons md-light md-26 md-margin\">content_copy</i> <span class=\"hidden-sm\">Επιλογή</span></md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised blue-color-md-button md-primary pull-right\" style=\"padding-right: 25px!important\" ng-click=\"vm.toggle(null, \'add\')\" ng-if=\"vm.selectedGrid !== \'leadCall\'\"><i class=\"material-icons md-light md-26 md-margin\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></div></div></div></div>");
$templateCache.put("app/displays/leadEvents/leadEvents.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-event-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"leadCallsGrid\" options=\"vm.leadCallsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.leadCallsGridOptions\" data-ng-init=\"vm.onPageLoad()\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"height: 800px\"></kendo-grid>");
$templateCache.put("app/displays/patients/patients.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddPatientClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Ασθενή</span></md-button></h2></div></md-toolbar><kendo-grid id=\"patientsGrid\" options=\"vm.patientsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.patientsGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/patients/patientView.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex>{{vm.patient.lastName + \" \" + vm.patient.firstName}}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <div class=\"md-media-lg card-media\">\n                                        <img ng-src=\"content/images/patient_icon.png\" alt=\"Profile Picture\" style=\"width:150px;height:150px;\" />\n                                    </div>\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-headline\">{{vm.patient.lastName + \" \" + vm.patient.firstName}}</span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Έτος Γέννηση :</b> {{vm.patient.yearOfBirth}}</span></span>\n                                </md-card-title-text>\n\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"patientInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'patientInfo\')}\"><i class=\"material-icons\">info_outline</i>Βασικά Στοιχεία</li><li ui-sref=\"patientHospitalization\" ng-class=\"{\'k-state-active\': vm.$state.is(\'patientHospitalization\')}\"><i class=\"material-icons\">location_city</i>Δεδομένα εισαγωγών</li><!-- This will be added later --><!--<li ui-sref=\"patientLeadCalls\" ng-class=\"{\'k-state-active\': vm.$state.is(\'patientLeadCalls\')}\">\n                        <i class=\"material-icons\">contact_phone</i>Κλήσεις</li>--></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/medReportApprovals/medReportApprovals.html","<div ng-cloak class=\"approvals-tabs\"><md-tab-group><md-tabs md-dynamic-height md-border-bottom><md-tab md-active=\"vm.$state.includes(\'medReportApprovals.pending\')\" ui-sref=\"medReportApprovals.pending\"><md-tab-label><span class=\"material-icons fixed-icons fixed-icons-3\">update</span>Προς Έγκριση</md-tab-label><md-tab-body><div style=\"padding: 1em 1em 1em 0\"><div ui-view></div></div></md-tab-body></md-tab><md-tab md-active=\"vm.$state.includes(\'medReportApprovals.history\')\" ui-sref=\"medReportApprovals.history\"><md-tab-label><span class=\"material-icons fixed-icons fixed-icons-3\">history</span>Ιστορικό</md-tab-label><md-tab-body><div style=\"padding: 1em 1em 1em 0\"><div ui-view></div></div></md-tab-body></md-tab></md-tabs></md-tab-group></div>");
$templateCache.put("app/displays/prospectivePatients/prospectivePatients.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility_new-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex>{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.customAdd();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθηκη Πιθανου Ασθενη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"prospectivePatientsGrid\" k-options=\"vm.prospectivePatientsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.prospectivePatientsGridOptions\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"cursor: pointer; height: 800px\"></kendo-grid><div id=\"popup-prospective-patient\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div class=\"box\"><form name=\"form\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"popup-info full-width\"><h5>Στοιχεία Ασθενή</h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Επώνυμο:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"lastName\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"firstName\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Έτος Γέννησης:</label></div><div flex=\"60\"><input id=\"birthYear\" k-textbox min=\"0\" name=\"birthYear\" k-format=\"\'n0\'\" min=\"0\" maxlength=\"4\" class=\"k-input k-textbox\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Email:</label></div><div flex=\"60\"><input type=\"email\" class=\"k-input k-textbox\" name=\"email\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κινητό:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"mobile\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Λάθος<br>Τηλέφωνο:</label></div><div flex=\"60\"><div class=\"margin-left-10 btn-group no-outline pull-left margin-top-2\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.selectedItem.isWrongPhone\" uib-btn-radio=\"true\">Ναι</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.selectedItem.isWrongPhone\" uib-btn-radio=\"false\">Όχι</label></div></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Λάθος Στοιχεία Επικοινωνίας:</label></div><div flex=\"60\"><div class=\"margin-left-10 btn-group no-outline pull-left margin-top-2\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.selectedItem.isWrongContact\" uib-btn-radio=\"true\">Ναι</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.selectedItem.isWrongContact\" uib-btn-radio=\"false\">Όχι</label></div></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Επάγγελμα:</label></div><div flex=\"60\"><select id=\"profession\" name=\"profession\" kendo-combo-box k-ng-model=\"vm.selectedItem.profession\" k-options=\"vm.professionOptions\" class=\"col-fix-2\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Συνοδός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" style=\"margin-right: 80px\" ng-disabled=\"true\" ng-model=\"vm.selectedItem.attendant.fullName\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>ΑΜΚΑ:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" style=\"margin-right: 80px\" name=\"amka\"><!-- ng-model=\"vm.selectedItem.attendant.fullName\" --></div></div></div></div><h5>Στοιχεία Διεύθυνσης</h5><div layout=\"row\" ng-show=\"!vm.geodata\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectures\" kendo-combo-box k-ng-model=\"vm.selectedItem.prefecture\" ng-model=\"vm.selectedItem.prefectureName\" k-options=\"vm.prefecturesComboBoxOptions\" k-ng-delay=\"vm.initPrefecturesComboBox\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cities\" kendo-combo-box k-ng-model=\"vm.selectedItem.city\" ng-model=\"vm.selectedItem.cityName\" k-options=\"vm.citiesComboBoxOptions\" k-ng-delay=\"vm.initCitiesComboBox\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"dataItem.postalCode\" name=\"postalCode\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\"></div></div></div></div><div layout=\"column\" ng-show=\"vm.geodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 60%\"><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"prefectureName\" data-bind=\"value: prefectureName\" ng-model=\"vm.selectedItem.prefectureName\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"cityName\" data-bind=\"value: cityName\" ng-model=\"vm.selectedItem.cityName\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" data-bind=\"value: address\" ng-model=\"vm.selectedItem.address\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\" data-bind=\"value: addressNum\" ng-model=\"vm.selectedItem.addressNum\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-model=\"vm.selectedItem.postalCode\" data-bind=\"value: postalCode\"></div></div></div></div></div></div></div></form></div></div>");
$templateCache.put("app/displays/prospectivePatients/prospectivePatientView.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><!--<md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\">\n                        <md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility_new-24px.svg\"></md-icon>\n                    </md-toolbar-filler>--><h2 class=\"md-toolbar-tools\"><span>{{vm.prospectivePatient.lastName + \" \" + vm.prospectivePatient.firstName}}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\" style=\"background-color: yellow\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <div class=\"md-media-lg card-media\">\n                                        <img ng-src=\"content/images/patient_icon.png\" alt=\"Profile Picture\" style=\"width:150px;height:150px;\" />\n                                    </div>\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-headline\">{{vm.prospectivePatient.lastName + \" \" + vm.prospectivePatient.firstName}}</span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Ηλικία :</b> {{vm.prospectivePatient.age}}</span></span>\n                                </md-card-title-text>\n\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"prospectivePatientInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'prospectivePatientInfo\')}\"><i class=\"material-icons\">info_outline</i>Βασικά Στοιχεία</li><li ui-sref=\"prospectivePatientLeadCalls\" ng-class=\"{\'k-state-active\': vm.$state.is(\'prospectivePatientLeadCalls\')}\"><i class=\"material-icons\">contact_phone</i>Κλήσεις</li><li ui-sref=\"prospectivePatientLeadHospitalizationDiseases\" ng-class=\"{\'k-state-active\': vm.$state.is(\'prospectivePatientLeadHospitalizationDiseases\')}\"><i class=\"material-icons\">assignment</i>Ιατρικό Ιστορικό</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/recDoctors/recDoctors.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-account_box-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_customers\"></div><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" k-on-change=\"vm.onSelection(data)\"></kendo-grid>");
$templateCache.put("app/displays/recDoctors/recDoctorView.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><div class=\"well clearfix\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"30\" layout=\"column\"><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-media><div class=\"md-media-lg card-media\"><img data-ng-src=\"{{\'data:\' + vm.customer.profilePhotoContentType + \';base64,\' + vm.customer.profilePhoto}}\" style=\"max-width: 100%\" ng-if=\"vm.customer.profilePhoto\"> <img ng-src=\"content/images/customer_icon.png\" alt=\"Profile Picture\" style=\"width:150px;height:150px\" ng-if=\"!vm.customer.profilePhoto\"></div></md-card-title-media><md-card-title-text style=\"margin-left: 15px\"><span class=\"md-headline\">{{vm.customer.firstName}} {{vm.customer.lastName}}</span> <span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Ειδικότητα : </b>{{vm.customer.doctorSpecialty.name}}</span></span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"start  center\"><md-button><a type=\"file\" ngf-select ngf-change=\"vm.setProfilePhoto($file, vm.customer)\" accept=\"image/*\">{{ (vm.customer.profilePhoto == null) ? \"Προσθήκη εικόνας\" : \"Αλλαγή εικόνας\" }}</a></md-button></md-card-actions></md-card></div></md-content></div><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"recDoctorInfo\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Επαγγελματία Υγείας</li><li has-any-authority=\"ROLE_REC_ADMINISTRATOR, ROLE_REC_HEALTH_VISITOR, ROLE_REC_MANAGEMENT\" ui-sref=\"recDoctorSectors\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorSectors\')}\"><i class=\"material-icons\">business</i>Μονάδες Υγείας</li><li ui-sref=\"recDoctorEvents\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorEvents\')}\"><i class=\"material-icons\">date_range</i>Επισκέψεις</li><li has-any-authority=\"ROLE_REC_HEALTH_VISITOR\" ui-sref=\"recDoctorScheduler\" application-parameters=\"Scheduling\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorScheduler\')}\"><i class=\"material-icons\">today</i>Ατζέντα</li><li ui-sref=\"recDoctorNotes\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorNotes\')}\"><i class=\"material-icons\">event_note</i>Σημειώσεις</li><li ui-sref=\"recDoctorHospitalization\" ng-class=\"{\'k-state-active\': vm.$state.is(\'recDoctorHospitalization\')}\"><i class=\"material-icons\">location_city</i>Δεδομένα εισαγωγών</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                    <i class=\"material-icons fixed-icons\">assignment_late</i>\n                    <h6>#= message #</h6>\n                </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                    <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                    <h6>#= message #</h6>\n                </div></script><span id=\"notification\" style=\"display:none\"></span></form></div></div>");
$templateCache.put("app/displays/purchases/purchaseAccountingView.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-add_shopping_cart-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex=\"\">ΕΠΕΞΕΡΓΑΣΙΑ ΠΑΡΑΓΓΕΛΙΑΣ ΑΠΟ <span style=\"color: #F9A22E\">ΛΟΓΙΣΤΗΡΙΟ</span>: {{vm.selectedPurchaseId}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.goBack();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">clear</i> <span class=\"hidden-sm\">Ακύρωση</span></md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" ng-click=\"vm.update($event);\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></h2></div></md-toolbar><div layout=\"column\"><div flex><!-- Purchase Header Container --><md-subheader class=\"md-primary\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">info_outline</i></md-icon>Στοιχεία Παραγγελίας</md-subheader><div class=\"separator full-width-separator\"></div><form id=\"form\" name=\"form\" kendo-validator=\"vm.validator\"><div layout=\"row\" style=\"margin: 30px\"><div flex=\"33\"><div class=\"form-group\"><label for=\"issueDate\" style=\"width: 130px\">Ημερομηνία:</label><input id=\"issueDate\" name=\"issueDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" ng-model=\"vm.purchase.issueDate\"></div><div class=\"form-group\"><label class=\"control-label col-sm-4\" for=\"sectorName\" style=\"width: 130px; padding-left: 0\">Επαγγελματίας Υγείας:</label><div layout=\"column\"><div flex><div layout=\"row\"><div flex=\"80\"><select id=\"sectorName\" name=\"sectorName\" required data-required-msg=\"Παρακαλούμε εισάγετε επαγγελματία υγείας.\" kendo-combo-box k-options=\"vm.sectorsComboBoxOptions\" k-ng-model=\"vm.purchase.sector\" style=\"width: 100%\"></select></div><div flex=\"20\"><md-button class=\"orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openSectorsGrid();\"><md-icon class=\"material-icons\">search</md-icon><md-tooltip md-direction=\"bottom\">Αναζήτηση Επαγγελματία Υγείας</md-tooltip></md-button></div></div></div><div flex><span class=\"k-invalid-msg\" data-for=\"sectorName\"></span></div></div></div><div class=\"form-group\"><div layout=\"row\"><label flex=\"25\">ΑΦΜ Επαγγελματία Υγείας:</label><div flex=\"75\">{{ vm.purchase.sector.vat }}</div></div></div><div class=\"form-group\"><label for=\"employee\" style=\"width: 130px\">Ιατρικός Επισκέπτης:</label><!--<input id=\"employee\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.employee.fullName\" readonly>--><!-- Commented-out for SIGMASF-2029 --><select id=\"employee\" name=\"employee\" required data-required-msg=\"Παρακαλούμε εισάγετε Ιατρικό Επισκέπτη.\" kendo-combo-box k-options=\"vm.employeesComboBoxOptions\" k-ng-model=\"vm.purchase.employee\"></select></div><div class=\"form-group\"><!-- ng-show=\"vm.priceCalculation\" --><label for=\"sectorAddress\" style=\"width: 130px\">Διεύθυνση Επαγγελματία Υγείας:</label><input id=\"sectorAddress\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.sector.address\" readonly=\"readonly\"></div><div class=\"form-group\"><!-- ng-show=\"vm.priceCalculation\" --><label for=\"sectorShippingAddress\" style=\"width: 130px\">Διεύθυνση Αποστολής:</label><input id=\"sectorShippingAddress\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.sector.shippingAddress\"></div></div><div flex=\"33\"><div class=\"form-group\"><!-- ng-show=\"vm.priceCalculation\" --><label for=\"purchaseStatus\" style=\"width: 170px\">Κατάσταση:</label><select id=\"purchaseStatus\" name=\"purchaseStatus\" k-ng-model=\"vm.purchase.purchaseStatus.id\" kendo-combo-box k-options=\"vm.purchaseStatusOptions\"></select></div><div class=\"form-group\"><!-- ng-show=\"vm.priceCalculation\" --><label for=\"picker\" style=\"width: 170px\">Αποθηκάριος:</label><select id=\"picker\" name=\"picker\" ng-model=\"vm.purchase.picker.id\" kendo-combo-box=\"vm.picker\" k-options=\"vm.pickerOptions\"></select></div><div class=\"form-group\"><label for=\"paymentMethod\" style=\"width: 170px\">Τρόπος Πληρωμής:</label><select id=\"paymentMethod\" name=\"paymentMethod\" k-ng-model=\"vm.purchase.paymentMethod.id\" kendo-combo-box k-options=\"vm.paymentMethodOptions\"></select></div><div class=\"form-group\"><label for=\"purchaseNumberingRow\" style=\"width: 170px\">Σειρά Αρίθμησης:</label><select id=\"purchaseNumberingRow\" name=\"purchaseNumberingRow\" required data-required-msg=\"Η σειρά αρίθμησης είναι υποχρεωτική.\" kendo-combo-box k-ng-model=\"vm.purchase.purchaseNumberingRow.id\" k-options=\"vm.purchaseNumberingRowOptions\"></select><span class=\"k-invalid-msg\" data-for=\"purchaseNumberingRow\"></span></div><div class=\"form-group\"><!-- ng-show=\"vm.priceCalculation\" --><label for=\"comment\" style=\"width: 170px\">Σημειώσεις:</label><textarea id=\"comment\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox\" name=\"comment\" ng-model=\"vm.purchase.comment\"></textarea></div></div><div flex=\"33\"><div class=\"form-group\"><label for=\"desirableExecutionDate\">Επιθυμητή Ημερ/νία Εκτέλεσης:</label><input id=\"desirableExecutionDate\" name=\"desirableExecutionDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.purchase.desirableExecutionDate\"></div><div class=\"form-group\"><label for=\"eventComments\" style=\"width: 224px\">Σχόλια Event:</label><textarea id=\"eventComments\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox\" name=\"eventComments\" ng-model=\"vm.purchase.eventComments\"></textarea></div></div></div></form></div><div flex><!-- Purchase Items Container --><md-subheader class=\"md-primary\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">list</i></md-icon>Γραμμές Παραγγελίας</md-subheader><div class=\"separator full-width-separator\" style=\"padding: 0; margin: 0\"></div><md-tabs md-dynamic-height md-align-tabs=\"top\"><!-- md-selected=\"vm.tabIndex\" --><md-tab id=\"purchaseItemsTab\"><!-- ng-click=\"vm.tabHeaderClick(\'tabLeadCall\', $event)\" --><md-tab-label>Γραμμές Προιόντων</md-tab-label><md-tab-body><kendo-grid id=\"purchaseItemsGrid\" options=\"vm.purchaseItemsOptions\" k-ng-delay=\"vm.purchaseItemsOptions\"><div k-detail-template id=\"template\"><div class=\"pull-left\" style=\"width: 25%\"><label style=\"margin-right: 1%\">Barcode Είδους:</label>#= product.barcode #</div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Έκπτωση Είδους:</label>#= product.defaultDiscount ? kendo.format(\'{0:p}\', product.defaultDiscount / 100) : kendo.format(\'{0:p}\', 0) #</div><div><label style=\"margin-right: 1%\">Αξία Έκπτωσης Είδους:</label>#= product.defaultDiscount ? kendo.format(\'{0:c}\', totalPrice * product.defaultDiscount / 100): kendo.format(\'{0:c}\', 0) #</div></div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Έκπτωση Παραστατικού:</label>#= kendo.format(\'{0:p}\', discountPurchasePercent / 100) #</div><div><label style=\"margin-right: 1%\">Αξία Έκπτωσης Παραστατικού:</label>#= kendo.format(\'{0:c}\', (totalPrice - discountPrice - discountLinePrice) * discountPurchasePercent/100) #</div></div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Φ.Π.Α. Είδους:</label>#= kendo.format(\'{0:p}\', taxPercent / 100) #</div></div></div></kendo-grid></md-tab-body></md-tab><md-tab id=\"purchasePresentItemsTab\"><md-tab-label>Γραμμές Δώρων</md-tab-label><md-tab-body><div class=\"form-group\" style=\"margin-top: 5px\"><label for=\"presentList\" style=\"margin: 0.6%\">Επιλογή λίστας δώρου:</label><select id=\"presentList\" name=\"presentList\" kendo-combo-box k-options=\"vm.presentListsComboBoxOptions\" k-ng-model=\"vm.purchase.presentList\"></select><md-button class=\"blue-color-md-button md-raised md-mini md-primary\" aria-label=\"add\" ng-click=\"vm.addPresentList()\" ng-disabled=\"!vm.purchase.presentList || !vm.purchase.sector\"><i class=\"material-icons fixed-icons fixed-icons-2\">add</i>Προσθήκη Δώρων</md-button></div><kendo-grid id=\"purchasePresentItemsGrid\" options=\"vm.purchasePresentItemsOptions\"></kendo-grid></md-tab-body></md-tab></md-tabs></div><div flex><!-- Purchase Footer Container --><md-subheader class=\"md-primary\"><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #0074BC\">add_box</i></md-icon>Συνολικές Αξίες</md-subheader><div class=\"separator full-width-separator\"></div><div layout=\"row\" style=\"margin: 30px\"><div flex=\"33\"><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Αξία προ έκπτωσης:</label><input kendo-numeric-text-box id=\"totalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.totalPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Εκπτώσεις:</label><input kendo-numeric-text-box id=\"discountFinalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.discountFinalPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Καθαρή Αξία:</label><input kendo-numeric-text-box id=\"netPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.netPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Φ.Π.Α.:</label><input kendo-numeric-text-box id=\"taxPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.taxPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Υπέρ Π.Φ.Σ.:</label><input kendo-numeric-text-box id=\"pfs\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.pfs\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Πληρωτέο:</label><input kendo-numeric-text-box id=\"finalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.finalPrice\" readonly=\"readonly\"></div></div><div flex=\"33\"><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Έκπτωση Παραγγελίας (%):</label><input kendo-numeric-text-box id=\"discountPercent\" k-options=\"vm.percentOptions\" k-ng-model=\"vm.purchase.discountPercent\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Αξία Έκπτωσης Παραγγελίας:</label><input kendo-numeric-text-box id=\"discountPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.discountPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Έκπτωση σε Δώρα (%):</label><input kendo-numeric-text-box id=\"presentPercent\" k-options=\"vm.percentOptions\" k-ng-model=\"vm.purchase.presentPercent\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Αξία Έκπτωσης σε Δώρα :</label><input kendo-numeric-text-box id=\"presentPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.presentPrice\" readonly=\"readonly\"></div></div></div></div><!-- Kendo Notifications --><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div><!-- Sectors Window --><div id=\"wnd\" kendo-window=\"vm.window\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\"><kendo-grid id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\" k-ng-delay=\"vm.sectorsGridOptions\" k-rebind=\"vm.sectorsGridOptions.columns\"></kendo-grid></div><!-- Products window for Presents --><div id=\"popup-sector\" kendo-window=\"vm.presentListProductsWindow\" k-visible=\"false\" k-modal=\"true\" k-title=\"\'Επιλέξτε Προϊόντα\'\" k-on-close=\"vm.clearPopUpGrid(\'closed\')\"><div class=\"box\"><div kendo-grid selectable-grid id=\"productsGrid\" k-options=\"vm.productsGridOptions\" k-ng-delay=\"vm.initPopupGrid\" class=\"pull-left\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div><div class=\"window-footer\"><md-button class=\"md-raised md-mini\" aria-label=\"cancel\" ng-click=\"vm.closeProductsWindow()\"><i class=\"material-icons fixed-icons fixed-icons-2\">clear</i>Ακύρωση</md-button><md-button class=\"blue-color-md-button md-raised md-mini md-primary\" aria-label=\"add\" ng-click=\"vm.addProducts()\"><i class=\"material-icons fixed-icons fixed-icons-2\">add</i>Προσθήκη</md-button></div></div>");
$templateCache.put("app/displays/purchases/purchaseBacklog.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><kendo-grid id=\"purchaseItemsGrid\" k-options=\"vm.purchaseItemsGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/purchases/purchaseNew.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-add_shopping_cart-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-select ng-model=\"vm.priceCalculation\" ng-change=\"vm.setView()\" aria-label=\"priceCalculation\" style=\"padding-right: 25px!important; color: white\"><md-option ng-value=\"true\">Με υπολογισμό τιμών</md-option><md-option ng-value=\"false\">Χωρίς υπολογισμό τιμών</md-option></md-select><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"cancel\" ng-click=\"vm.cancel();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">clear</i> <span class=\"hidden-sm\">Ακύρωση</span></md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.save();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></h2></div></md-toolbar><div class=\"entity-view clearfix\"><div id=\"addView\"><!--<div class=\"columns\" style=\"padding-left: 2em;padding-right: 2em\"><h3 class=\"bordered\"><span class=\"title-box\">Νέα παραγγελία\n            <md-select ng-model=\"vm.priceCalculation\" ng-change=\"vm.setView()\" aria-label=\"priceCalculation\" >\n                <md-option ng-value=true>Με υπολογισμό τιμών</md-option>\n                <md-option ng-value=false>Χωρίς υπολογισμό τιμών</md-option>\n            </md-select>\n        </span></h3></div>--><div class=\"popup-info pull-left\" style=\"padding-left: 2em;padding-right: 2em;width:100%\"><form id=\"form\" name=\"form\" kendo-validator=\"vm.validator\"><div class=\"pull-left\" style=\"width:100%;margin-top: 1em\"><i class=\"material-icons label-icon\">info_outline</i><h5>Στοιχεία Παραγγελίας</h5><div class=\"separator full-width-separator\"></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"issueDate\" style=\"width: 130px\">Ημερομηνία:</label><input id=\"issueDate\" name=\"issueDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" ng-model=\"vm.purchase.issueDate\"></div><div class=\"form-group\"><label for=\"sectorName\" style=\"width: 130px\">Επαγγελματίας Υγείας:</label><select id=\"sectorName\" name=\"sectorName\" required data-required-msg=\"Παρακαλούμε εισάγετε επαγγελματία υγείας.\" kendo-combo-box k-options=\"vm.sectorsComboBoxOptions\" k-ng-model=\"vm.purchase.sector\"></select><md-button class=\"orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.openSectorsGrid()\"><md-icon class=\"material-icons\">search</md-icon><md-tooltip md-direction=\"bottom\">Αναζήτηση Επαγγελματία Υγείας</md-tooltip></md-button><span class=\"k-invalid-msg\" data-for=\"sectorName\"></span></div><div class=\"form-group\"><label for=\"employee\" style=\"width: 130px\">Ιατρικός Επισκέπτης:</label><!--<input id=\"employee\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.employee.fullName\" readonly>--><!-- Commented-out for SIGMASF-2029 --><select id=\"employee\" name=\"employee\" required data-required-msg=\"Παρακαλούμε εισάγετε Ιατρικό Επισκέπτη.\" kendo-combo-box k-options=\"vm.employeesComboBoxOptions\" k-ng-model=\"vm.purchase.employee\"></select></div><div class=\"form-group\" ng-show=\"vm.priceCalculation\"><label for=\"sectorAddress\" style=\"width: 130px\">Διεύθυνση Επαγγελματία Υγείας:</label><input id=\"sectorAddress\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.sector.address\" readonly=\"readonly\"></div><div class=\"form-group\" ng-show=\"vm.priceCalculation\"><label for=\"sectorShippingAddress\" style=\"width: 130px\">Διεύθυνση Αποστολής:</label><input id=\"sectorShippingAddress\" type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.purchase.sector.shippingAddress\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-show=\"vm.priceCalculation\"><label for=\"purchaseStatus\" style=\"width: 170px\">Κατάσταση:</label><select id=\"purchaseStatus\" name=\"purchaseStatus\" ng-model=\"vm.purchase.purchaseStatus.id\" kendo-combo-box k-options=\"vm.purchaseStatusOptions\"></select></div><div class=\"form-group\" ng-show=\"vm.priceCalculation\"><label for=\"picker\" style=\"width: 170px\">Αποθηκάριος:</label><select id=\"picker\" name=\"picker\" ng-model=\"vm.purchase.picker.id\" kendo-combo-box=\"vm.picker\" k-options=\"vm.pickerOptions\"></select></div><div class=\"form-group\"><label for=\"paymentMethod\" style=\"width: 170px\">Τρόπος Πληρωμής:</label><select id=\"paymentMethod\" name=\"paymentMethod\" ng-model=\"vm.purchase.paymentMethod.id\" kendo-combo-box k-options=\"vm.paymentMethodOptions\"></select></div><div class=\"form-group\"><label for=\"purchaseNumberingRow\" style=\"width: 170px\">Σειρά Αρίθμησης:</label><select id=\"purchaseNumberingRow\" name=\"purchaseNumberingRow\" required data-required-msg=\"Η σειρά αρίθμησης είναι υποχρεωτική.\" kendo-combo-box ng-model=\"vm.purchase.purchaseNumberingRow.id\" k-options=\"vm.purchaseNumberingRowOptions\"></select><span class=\"k-invalid-msg\" data-for=\"purchaseNumberingRow\"></span></div><div class=\"form-group\" ng-show=\"vm.priceCalculation\"><label for=\"comment\" style=\"width: 170px\">Σημειώσεις:</label><textarea id=\"comment\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox\" name=\"comment\" ng-model=\"vm.purchase.comment\"></textarea></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"desirableExecutionDate\" style=\"width: 180px\">Επιθυμητή Ημερ/νία Εκτέλεσης:</label><input id=\"desirableExecutionDate\" name=\"desirableExecutionDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" ng-model=\"vm.purchase.desirableExecutionDate\"></div><div class=\"form-group\"><label for=\"eventComments\" style=\"width: 180px\">Σχόλια Event:</label><textarea id=\"eventComments\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox\" name=\"comment\" ng-model=\"vm.purchase.eventComments\"></textarea></div></div></div></div><div class=\"pull-left\" style=\"width:100%;margin-top: 2em\"><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab><md-tab-label><span class=\"material-icons label-icon\">list</span>Γραμμές Παραγγελίας</md-tab-label><md-tab-body class=\"md-padding\"><kendo-grid id=\"purchaseItemsGrid\" options=\"vm.purchaseItemsOptions\" k-ng-delay=\"vm.purchaseItemsOptions\"><div k-detail-template id=\"template\"><div class=\"pull-left\" style=\"width: 25%\"><label style=\"margin-right: 1%\">Barcode Είδους:</label>#= product.barcode #</div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Έκπτωση Είδους:</label>#= product.defaultDiscount ? kendo.format(\'{0:p}\', product.defaultDiscount / 100) : kendo.format(\'{0:p}\', 0) #</div><div><label style=\"margin-right: 1%\">Αξία Έκπτωσης Είδους:</label>#= product.defaultDiscount ? kendo.format(\'{0:c}\', totalPrice * product.defaultDiscount / 100): kendo.format(\'{0:c}\', 0) #</div></div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Έκπτωση Παραστατικού:</label>#= kendo.format(\'{0:p}\', discountPurchasePercent / 100) #</div><div><label style=\"margin-right: 1%\">Αξία Έκπτωσης Παραστατικού:</label>#= kendo.format(\'{0:c}\', (totalPrice - discountPrice - discountLinePrice) * discountPurchasePercent/100) #</div></div><div class=\"pull-left\" style=\"width: 25%\"><div><label style=\"margin-right: 1%\">Φ.Π.Α. Είδους:</label>#= kendo.format(\'{0:p}\', taxPercent / 100) #</div><!--<div><label style=\"margin-right: 1%;\">Υπέρ Π.Φ.Σ.:</label>#= kendo.format(\'{0:c}\', (totalPrice * 0.004)) #</div>--></div></div></kendo-grid></md-tab-body></md-tab><md-tab ng-if=\"vm.priceCalculation\"><md-tab-label><span class=\"material-icons label-icon\">card_giftcard</span>Γραμμές Δώρων</md-tab-label><md-tab-body class=\"md-padding\"><div class=\"form-group\"><label for=\"presentList\" style=\"margin: 0.6%\">Επιλογή λίστας δώρου:</label><select id=\"presentList\" name=\"presentList\" kendo-combo-box k-options=\"vm.presentListsComboBoxOptions\" k-ng-model=\"vm.purchase.presentList\"></select><md-button class=\"blue-color-md-button md-raised md-mini md-primary\" aria-label=\"add\" ng-click=\"vm.addPresentList()\" ng-disabled=\"!vm.purchase.presentList || !vm.purchase.sector\"><i class=\"material-icons fixed-icons fixed-icons-2\">add</i>Προσθήκη Δώρων</md-button></div><kendo-grid id=\"purchasePresentItemsGrid\" options=\"vm.purchasePresentItemsOptions\"></kendo-grid></md-tab-body></md-tab></md-tabs></md-content></div><div class=\"pull-left\" style=\"width:100%;margin-top: 2em\" ng-show=\"vm.priceCalculation\"><i class=\"material-icons label-icon\">add_box</i><h5>Συνολικές Αξίες</h5><div class=\"separator full-width-separator\"></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Αξία προ έκπτωσης:</label><input kendo-numeric-text-box id=\"totalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.totalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Εκπτώσεις:</label><input kendo-numeric-text-box id=\"discountFinalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.discountFinalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Καθαρή Αξία:</label><input kendo-numeric-text-box id=\"netPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.netPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Φ.Π.Α.:</label><input kendo-numeric-text-box id=\"taxPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.taxPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Υπέρ Π.Φ.Σ.:</label><input kendo-numeric-text-box id=\"pfs\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.pfs\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 200px\">Πληρωτέο:</label><input kendo-numeric-text-box id=\"finalPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.finalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Έκπτωση Παραγγελίας (%):</label><input kendo-numeric-text-box id=\"discountPercent\" k-options=\"vm.percentOptions\" k-ng-model=\"vm.purchase.discountPercent\" class=\"currency-alignment\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Αξία Έκπτωσης Παραγγελίας:</label><input kendo-numeric-text-box id=\"discountPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.discountPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Έκπτωση σε Δώρα (%):</label><input kendo-numeric-text-box id=\"presentPercent\" k-options=\"vm.percentOptions\" k-ng-model=\"vm.purchase.presentPercent\" class=\"currency-alignment\"></div><div class=\"form-group\"><label for=\"totalPrice\" style=\"width: 250px\">Αξία Έκπτωσης σε Δώρα :</label><input kendo-numeric-text-box id=\"presentPrice\" k-options=\"vm.options\" k-ng-model=\"vm.purchase.presentPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div></div></div><div ng-show=\"!vm.validation\" class=\"header-info pull-left full-width\"><div class=\"k-widget k-notification k-notification-error\" style=\"display: block; opacity: 1\"><div class=\"k-notification-wrap\"><strong class=\"pull-left\" style=\"margin-right: 5px\" translate=\"global.messages.error.attention\">Attention!</strong><p translate=\"global.messages.error.purchaseItemNotNull\">Product description can\'t be empty.</p></div></div></div><div class=\"clearfix\"></div></form></div></div></div><div id=\"sectorSearchWindow\" kendo-window=\"sectorSearchWindow\" k-options=\"vm.sectorSearchWindowOptions\"><kendo-grid id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\"></kendo-grid></div><div id=\"popup-sector\" kendo-window=\"vm.presentListProductsWindow\" k-visible=\"false\" k-modal=\"true\" k-title=\"\'Επιλέξτε Προϊόντα\'\" k-on-close=\"vm.clearPopUpGrid(\'closed\')\"><div class=\"box\"><div kendo-grid selectable-grid id=\"productsGrid\" k-options=\"vm.productsGridOptions\" k-ng-delay=\"vm.initPopupGrid\" class=\"pull-left\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div><div class=\"window-footer\"><md-button class=\"md-raised md-mini\" aria-label=\"cancel\" ng-click=\"vm.closeProductsWindow()\"><i class=\"material-icons fixed-icons fixed-icons-2\">clear</i>Ακύρωση</md-button><md-button class=\"blue-color-md-button md-raised md-mini md-primary\" aria-label=\"add\" ng-click=\"vm.addProducts()\"><i class=\"material-icons fixed-icons fixed-icons-2\">add</i>Προσθήκη</md-button></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/purchases/purchases.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-add_shopping_cart-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button class=\"md-raised md-mini md-primary k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_ACCOUNTING_DEP\", \"ROLE_SYSTEM\"])\' ng-click=\"vm.onExcelExportClick()\" ng-disabled=\"vm.showProgress === true\"><span class=\"k-icon k-i-excel\"></span>Export</md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddPurchaseClick()\" ng-if=\'vm.principal.hasAnyAuthority([\"ROLE_ACCOUNTING_DEP\", \"ROLE_SYSTEM\"])\' ng-disabled=\"vm.showProgress === true\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Παραγγελίας</span></md-button></h2></div></md-toolbar><div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"purchasesGrid\" options=\"vm.purchasesGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.purchasesGridOptions\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"padding-top: 70px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/purchases/purchaseView.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-add_shopping_cart-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button id=\"exportPDF\" class=\"md-warn md-raised md-hue-2 md-button md-ink-ripple\" ng-click=\"vm.exportPDF()\" ng-disabled=\"vm.purchaseGrids.getExportState();\" ng-show=\"vm.selectedTab === \'purchaseItems\'\"><i class=\"material-icons\" style=\"vertical-align: inherit;margin-right: 5px\">picture_as_pdf</i>Export σε PDF</md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"cancel\" ng-click=\"vm.goBack();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">clear</i> <span class=\"hidden-sm\">Ακύρωση</span></md-button><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.update();\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">save</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></h2></div></md-toolbar><!--<div class=\"buttons-wrap\">\n    <md-button id=\"exportPDF\" class=\'md-warn md-raised md-hue-2 md-button md-ink-ripple\' ng-click=\'vm.exportPDF()\' ng-disabled=\"vm.purchaseGrids.getExportState();\">\n        <i class=\"material-icons\" style=\"vertical-align: inherit;margin-right: 5px;\">picture_as_pdf</i>Export σε PDF\n    </md-button>\n</div>--><div id=\"sectorSearchWindow\" kendo-window=\"sectorSearchWindow\" k-options=\"vm.sectorSearchWindowOptions\"><kendo-grid id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\"></kendo-grid></div><div id=\"pdf-wrapper\"><div class=\"well clearfix\"><!--<h4>{{ vm.pageHeading }}</h4>--><div class=\"form-horizontal form-widgets col-sm-12\" kendo-validator=\"vm.validator\" style=\"padding-top: 10px; padding-bottom: 10px\"><div id=\"sectorFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ημερομηνία:</label><div class=\"col-sm-6 col-lg-3\"><input id=\"issueDate\" name=\"issueDate\" ng-model=\"vm.purchase.issueDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Αριθμός Παραγγελίας:</label><div class=\"col-sm-6 col-lg-3\"><input id=\"code\" class=\"k-textbox info\" name=\"code\" ng-model=\" vm.purchase.code\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\" for=\"sectorName\">Επαγγελματίας Υγείας:</label><div layout=\"column\" style=\"padding-left: 15px\"><div flex><div layout=\"row\"><div flex=\"75\"><select id=\"sectorName\" name=\"sectorName\" required data-required-msg=\"Παρακαλούμε εισάγετε επαγγελματία υγείας.\" kendo-combo-box k-options=\"vm.sectorsComboBoxOptions\" k-ng-model=\"vm.purchase.sector\" ng-disabled=\"vm.isStorehouse\" style=\"width: 100%\"></select></div><div flex=\"25\"><md-button class=\"orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-show=\"!vm.isStorehouse\" ng-click=\"vm.openSectorsGrid()\"><md-icon class=\"material-icons\">search</md-icon><md-tooltip md-direction=\"bottom\">Αναζήτηση Επαγγελματία Υγείας</md-tooltip></md-button></div></div></div><div flex><span class=\"k-invalid-msg\" data-for=\"sectorName\"></span></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\" for=\"sectorVat\">ΑΦΜ Επαγγελματία Υγείας:</label><div class=\"col-sm-6 col-lg-3\"><div id=\"sectorVat\" style=\"width: 100%; padding-top: 7px\">{{ vm.purchase.sector.vat }}</div></div></div><div class=\"form-group\" ng-show=\"!vm.purchaseGrids.getExportState()\"><label class=\"control-label col-sm-4\">Ιατρικός Επισκέπτης:</label><div class=\"col-sm-6 col-lg-3\"><!--<a ng-if=\"!vm.isStorehouse\" ui-sref=\"userInfo({id: vm.purchase.employee.id })\">\n                            {{ vm.purchase.employee.account.firstName }} {{ vm.purchase.employee.account.lastName }}</a>\n                        <div ng-if=\"vm.isStorehouse\">{{ vm.purchase.employee.account.firstName }} {{ vm.purchase.employee.account.lastName }}</div>--><!-- Commented-out for SIGMASF-2029 --><select id=\"employee\" name=\"employee\" required data-required-msg=\"Παρακαλούμε εισάγετε Ιατρικό Επισκέπτη.\" kendo-combo-box k-options=\"vm.employeesComboBoxOptions\" k-ng-model=\"vm.purchase.employee\"></select></div></div><div class=\"form-group\" ng-show=\"!vm.purchaseGrids.getExportState()\"><label class=\"control-label col-sm-4\">Διεύθυνση Αποστολής:</label><div class=\"col-sm-6 col-lg-3\"><input id=\"address\" style=\"width: 250%\" class=\"k-textbox info\" name=\"address\" ng-model=\"vm.purchase.fullAddress\" readonly=\"readonly\"></div></div></div><div id=\"sectorSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κατάσταση:</label><div class=\"col-sm-8 col-md-6\"><select id=\"purchaseStatus\" name=\"purchaseStatus\" kendo-combo-box k-ng-model=\"vm.purchase.purchaseStatus.id\" k-options=\"vm.purchaseStatusOptions\" class=\"col-fix\"></select><!--<input id=\"purchaseStatus\" class = \"k-textbox info custom-combobox\" name=\"purchaseStatus\" ng-model=\"vm.purchase.purchaseStatus.name\" readonly/>--></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Αποθηκάριος:</label><div class=\"col-sm-8 col-md-6\"><select id=\"picker\" name=\"picker\" kendo-combo-box k-ng-model=\"vm.purchase.picker.fullName\" k-options=\"vm.pickerOptions\" class=\"col-fix\"></select></div></div><div class=\"form-group\" ng-show=\"!vm.purchaseGrids.getExportState()\"><label class=\"control-label col-sm-4\">Τρόπος Πληρωμής:</label><div class=\"col-sm-8 col-md-6\"><select id=\"paymentMethod\" name=\"paymentMethod\" kendo-combo-box k-ng-model=\"vm.purchase.paymentMethod.id\" k-options=\"vm.paymentMethodOptions\" class=\"col-fix\" data-required-msg=\"Παρακαλούμε εισάγετε τρόπο πληρωμής.\"></select></div></div><div class=\"form-group\" ng-show=\"!vm.purchaseGrids.getExportState()\"><label class=\"control-label col-sm-4\">Σχόλια:</label><div class=\"col-sm-8 col-md-6\"><textarea id=\"comment\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox info\" name=\"comment\" ng-model=\"vm.purchase.comment\"></textarea></div></div></div><div id=\"sectorThird\" class=\"form-horizontal form-widgets col-sm-3\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επιθυμητή Ημερ/νία Εκτέλεσης:</label><div class=\"col-sm-6 col-lg-3\" style=\"margin-top: 17px\"><input id=\"desirableExecutionDate\" name=\"issueDate\" ng-model=\"vm.purchase.desirableExecutionDate\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σχόλια Event:</label><div class=\"col-sm-8 col-md-6\"><textarea id=\"eventComments\" maxlength=\"255\" rows=\"3\" cols=\"150\" class=\"k-textbox info\" name=\"eventComments\" ng-model=\"vm.purchase.eventComments\"></textarea></div></div></div></div></div><div class=\"well clearfix\"><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"purchaseItems\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchaseItems\')}\" ng-click=\"vm.onTabStripClick(\'purchaseItems\')\"><i class=\"material-icons\">list</i>Γραμμές Παραγγελιών</li><li ui-sref=\"purchasePresentItems\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasePresentItems\')}\" ng-click=\"vm.onTabStripClick(\'purchasePresentItems\')\"><i class=\"material-icons\">card_giftcard</i>Γραμμές Δώρων</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></div><div class=\"well clearfix\" ng-show=\"!vm.purchaseGrids.getExportState() && !vm.isStorehouse\"><h4 class=\"no-span col-sm-12\">Συνολικές Αξίες</h4><div class=\"col-sm-7\"><div class=\"form-group col-sm-12\"><label class=\"control-label col-sm-2\">Αξία προ έκπτωσης:</label><div class=\"col-sm-6 col-lg-3\"><input kendo-numeric-text-box id=\"totalPrice\" k-options=\"vm.options\" ng-model=\"vm.totalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div><div class=\"form-group col-sm-12\"><label class=\"control-label col-sm-2\">Εκπτώσεις:</label><div class=\"col-sm-6 col-lg-3\"><input kendo-numeric-text-box id=\"discountFinalPrice\" k-options=\"vm.options\" ng-model=\"vm.discountFinalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div><div class=\"form-group col-sm-12\"><label class=\"control-label col-sm-2\">Καθαρή Αξία:</label><div class=\"col-sm-6 col-lg-3\"><input kendo-numeric-text-box id=\"netPrice\" k-options=\"vm.options\" ng-model=\"vm.netPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div><div class=\"form-group col-sm-12\"><label class=\"control-label col-sm-2\">Φ.Π.Α.:</label><div class=\"col-sm-6 col-lg-3\"><input kendo-numeric-text-box id=\"taxPrice\" k-options=\"vm.options\" ng-model=\"vm.taxPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div><div class=\"form-group col-sm-12\"><label class=\"control-label col-sm-2\"><strong>Πληρωτέο:</strong></label><div class=\"col-sm-6 col-lg-3\"><input kendo-numeric-text-box id=\"finalPrice\" k-options=\"vm.options\" ng-model=\"vm.finalPrice\" class=\"currency-alignment\" readonly=\"readonly\"></div></div></div></div><div notifications-template></div></div>");
$templateCache.put("app/displays/sectors/sectors.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><div><label style=\"font-size: 14px\">Ιατρικός Επισκέπτης:</label><select id=\"multiSelect\" name=\"multiSelect\" class=\"inline\" kendo-multi-select=\"vm.employeesMulti\" multiple=\"multiple\" k-options=\"vm.employeesMultiOptions\" k-ng-model=\"vm.selectedEmployees\" style=\"font-size: 12px\"></select></div><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddSectorClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Μονάδας Υγείας</span></md-button></h2></div></md-toolbar><!--<div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div>--><div kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.mainGridOptions\"></div><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div class=\"box\"><form name=\"sectorForm\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"sector-info full-width\"><h5>Στοιχεία Μονάδας Υγείας</h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τύπος Μονάδας Υγείας:</label></div><div flex=\"60\"><input id=\"sectorType\" kendo-combo-box data-bind=\"value:sectorType.id\" k-options=\"vm.sectorTypeComboBoxOptions\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα Μονάδας Υγείας:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"name\" required></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ειδικότητες στη ΜY:</label></div><div flex=\"60\"><input kendo-combo-box=\"vm.specialtyComboBox\" data-bind=\"value:doctorSpecialty.id\" k-options=\"vm.specialtyComboBoxOptions\" ng-disabled=\"vm.isPrivate\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ανήκει στη ΜY:</label></div><div flex=\"60\"><input id=\"parentSector\" kendo-combo-box=\"vm.sectorsComboBox\" data-bind=\"value: sectorParent.id\" ng-model=\"vm.sectorParent.name\" k-options=\"vm.sectorsAllComboBoxOptions\" ng-disabled=\"vm.isPrivate\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.brick\" name=\"brick\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick ΟΣΦΕ:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.osfeBrick\" name=\"osfeBrick\"></div></div></div></div><h5>Στοιχεία Διεύθυνσης</h5><div layout=\"column\"><div layout=\"row\" ng-show=\"!vm.geodata\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectures\" kendo-combo-box k-ng-model=\"vm.selectedSector.prefecture\" ng-model=\"vm.selectedSector.prefectureName\" k-options=\"vm.prefecturesComboBoxOptions\" k-ng-delay=\"vm.initPrefecturesComboBox\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cities\" kendo-combo-box k-ng-model=\"vm.selectedSector.city\" ng-model=\"vm.selectedSector.cityName\" k-options=\"vm.citiesComboBoxOptions\" k-ng-delay=\"vm.initCitiesComboBox\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"dataItem.postalCode\" ng-change=\"vm.suggestBricks(dataItem.postalCode)\" name=\"postalCode\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\"></div></div></div></div><div layout=\"column\" ng-show=\"vm.geodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 80%\"><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"prefectureName\" data-bind=\"value: prefectureName\" ng-model=\"vm.saveNewSector.prefectureName\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"cityName\" data-bind=\"value: cityName\" ng-model=\"vm.saveNewSector.cityName\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" data-bind=\"value: address\" ng-model=\"vm.saveNewSector.address\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"addressNum\" data-bind=\"value: addressNum\" ng-model=\"vm.saveNewSector.addressNum\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"postalCode\" ng-model=\"vm.saveNewSector.postalCode\" ng-change=\"vm.suggestBricks(vm.saveNewSector.postalCode)\" data-bind=\"value: postalCode\"></div></div></div></div></div><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο *:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο 2:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone2\"></div></div></div></div></div></div></div></form></div></div>");
$templateCache.put("app/displays/sectors/sectorView.html","<div class=\"entity-view clearfix\"><div class=\"tabstrip-custom\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-button aria-label=\"Go Back\" style=\"color: #F9A22E\" ng-click=\"vm.goBack();\">Πίσω</md-button><!--<md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\">\n                        <md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-accessibility_new-24px.svg\"></md-icon>\n                    </md-toolbar-filler>--><h2 class=\"md-toolbar-tools\"><span>{{ vm.sector.name ? vm.sector.name : \"Μ.Υ. Χωρίς Όνομα\" }}</span></h2></div></md-toolbar><!--<div class=\"well clearfix\">\n                <md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\">\n                    <div flex-xs flex-gt-xs=\"30\" layout=\"column\">\n                        <md-card md-theme=\"default\" md-theme-watch>\n                            <md-card-title>\n                                <md-card-title-media>\n                                    <img ng-src=\"content/images/{{vm.profilePicture}}\" alt=\"MS Picture\" style=\"width:150px;height:150px;\">\n                                </md-card-title-media>\n                                <md-card-title-text style=\"margin-left: 15px;\">\n                                    <span class=\"md-subhead\"><span class=\"ra-specialty-name\"><b>Όνομα ΜΣ: </b>{{vm.sector.name}}</span></span>\n                                    <span class=\"md-subhead\"><span class=\"ra-category-name\"><b>Τύπος ΜΣ:</b> {{vm.sector.sectorType.name}}</span></span>\n                                </md-card-title-text>\n                            </md-card-title>\n                        </md-card>\n                    </div>\n                </md-content>\n            </div>--><div kendo-tab-strip id=\"tabstrip\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"sectorInfo\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK, ROLE_HEALTH_VISITOR\" ng-class=\"{\'k-state-active\': vm.$state.is(\'sectorInfo\')}\"><i class=\"material-icons\">info_outline</i>Στοιχεία Μονάδας Υγείας</li><li ui-sref=\"sectorCustomers\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\" ng-class=\"{\'k-state-active\': vm.$state.is(\'sectorCustomers\')}\"><i class=\"material-icons\">schedule</i>Επαγγελματίες Υγείας σε Μονάδα Υγείας</li><li has-any-authority=\"ROLE_ADMIN, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\" ui-sref=\"sectorClinicNames\" ng-class=\"{\'k-state-active\': vm.$state.is(\'sectorClinicNames\')}\"><i class=\"material-icons\">local_hospital</i>Κλινικές</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-3\"><span class=\"sigmasf-logo-cloud img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand logo\" href=\"#/\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" src=\"content/images/sigma-salesforce_logo_new.png\" style=\"margin: 5px 0px 0px 10px\"><!-- top right bottom left --></a></div><div class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=\"active\"><a ui-sref=\"home\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_BI_VIEWER\"><a ui-sref=\"analytics\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">insert_chart</i> <span class=\"hidden-sm\">Στατιστικά</span></a></li><li ui-sref-active=\"active\" ng-show=\"vm.user.account.login == \'gstefanidis\'\"><a ui-sref=\"analyticsNew\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">insert_chart</i> <span class=\"hidden-sm\">Στατιστικά New</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR\"><a ui-sref=\"adminCustomers\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">account_circle</i> <span class=\"hidden-sm\">Επαγγελματίες Υγείας</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_REC_ADMINISTRATOR, ROLE_REC_HEALTH_VISITOR, ROLE_REC_MANAGEMENT\"><a ui-sref=\"recDoctors\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">account_box</i> <span class=\"hidden-sm\">Επαγγελματίες Υγείας</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_REC_MANAGEMENT\"><a ui-sref=\"patients\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">accessibility</i> <span class=\"hidden-sm\">Ασθενείς</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a ui-sref=\"hospitalizations\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">location_city</i> <span class=\"hidden-sm\">Εισαγωγές</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PHARM_VISITOR, ROLE_ACCOUNTING_DEP, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"><a ui-sref=\"adminPharmacies\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">business</i> <span class=\"hidden-sm\">Φαρμακεία</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_BC_VISITOR\" application-parameters=\"Visit_Beauty_Centers\"><a ui-sref=\"beautyCenters\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">spa</i> <span class=\"hidden-sm\">Κέντρα Αισθητικής</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PATCH_VISITOR\" application-parameters=\"Patches\"><a ui-sref=\"adminPatchDoctors\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">group</i> <span class=\"hidden-sm\">Συστήσαντες Επαγγελματίες Υγείας</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_PHARM_SUPERVISOR\"><a ui-sref=\"adminEmployees\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">assignment_ind</i> <span class=\"hidden-sm\">Ιατρικοί Επισκέπτες</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PATCH_VISITOR, ROLE_STOREHOUSE\" application-parameters=\"Patches\"><a ui-sref=\"adminPatchCustomers\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">accessibility</i> <span class=\"hidden-sm\">Ασθενείς</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Scheduling\"><a ui-sref=\"adminSchedulesGrid\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">alarm</i> <span class=\"hidden-sm\">Ραντεβού</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR, ROLE_REC_MANAGEMENT, ROLE_REC_HEALTH_VISITOR, ROLE_PHARM_SUPERVISOR\"><a ui-sref=\"adminEvents\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">date_range</i> <span class=\"hidden-sm\">Επισκέψεις</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR\"><a ui-sref=\"adminAgreements\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">announcement</i> <span class=\"hidden-sm\">Αξιολόγηση</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_HEALTH_VISITOR, ROLE_REC_MANAGEMENT, ROLE_REC_HEALTH_VISITOR, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Scheduling\"><a ui-sref=\"adminSchedules\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">today</i> <span class=\"hidden-sm\">Ατζέντα</span></a></li><!----------------------------------------><li uib-dropdown class=\"dropdown pointer\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"index-menu-lead-management\"><span><i class=\"material-icons md-light md-26\">contact_phone</i> <span class=\"hidden-sm\" translate=\"global.menu.lead-management.title\">Lead Management </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a ui-sref=\"prospectivePatients\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.lead-management.prospective-patients\">Prospective Patients</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a ui-sref=\"leadCalls\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.lead-management.lead-calls\">Κλήσεις</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a ui-sref=\"followUpCalls\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.lead-management.followup-calls\">Εκκρεμότητες</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a ui-sref=\"leadEvents\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.lead-management.lead-events\">Ραντεβού</span></a></li></ul></li><!----------------------------------------><li ng-class=\"{active: vm.$state.includes(\'approvals\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Approvals\"><a ui-sref=\"approvals.newRecords.pending\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">verified_user</i> <span class=\"hidden-sm\">Εγκρίσεις</span></a></li><li ng-class=\"{active: vm.$state.includes(\'medReportApprovals\')}\" has-any-authority=\"ROLE_CHECKER\" application-parameters=\"Med_Report\"><a ui-sref=\"medReportApprovals.pending\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">verified_user</i> <span class=\"hidden-sm\">Εγκρίσεις Report</span></a></li><li ng-class=\"{active: vm.$state.includes(\'adminPatchReports\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_PATCH_VISITOR, ROLE_STOREHOUSE\" application-parameters=\"Patches\"><a ui-sref=\"adminPatchReports.pending\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">description</i> <span class=\"hidden-sm\">Γνωματεύσεις</span></a></li><li ng-class=\"{active: vm.$state.includes(\'purchases\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_STOREHOUSE, ROLE_ACCOUNTING_DEP, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Purchase_Pharmacies\"><a ui-sref=\"purchases\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">add_shopping_cart</i> <span class=\"hidden-sm\">Παραγγελίες</span></a></li><li ng-class=\"{active: vm.$state.includes(\'adminIndex\')}\" uib-dropdown class=\"dropdown pointer\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_STOREHOUSE, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"index-menu\"><span><i class=\"material-icons md-light md-26\">find_in_page</i> <span class=\"hidden-sm\">Αναφορές </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminEmployeesAll\" ng-click=\"vm.collapseNavbar()\"><span>Ευρετήριο Ιατρικών Επισκεπτών</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminCustomersAll\" ng-click=\"vm.collapseNavbar()\"><span>Ευρετήριο Γενικών Στοιχείων Επαγγελματία Υγείας</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminCustomerSectorsAll\" ng-click=\"vm.collapseNavbar()\"><span>Ευρετήριο Μονάδων Υγείας Επαγγελματία Υγείας</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminEventsAll\" ng-click=\"vm.collapseNavbar()\"><span>Επισκέψεις</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminEventsOther\" ng-click=\"vm.collapseNavbar()\"><span>Άλλα Συμβάντα</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminAgreementsAll\" ng-click=\"vm.collapseNavbar()\"><span>Αξιολόγηση</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"schedulesAll\" ng-click=\"vm.collapseNavbar()\"><span>Ραντεβού</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminEmployeeVisitsAll\" ng-click=\"vm.collapseNavbar()\"><span>Εργαλείο Απολογισμού Επισκέψεων ανά Ιατρικό Επισκέπτη</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"adminCustomerProductsAll\" ng-click=\"vm.collapseNavbar()\"><span>Ενημέρωση ανά Επαγγελματία Υγείας για Φαρμακα</span></a></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\">Παραγγελίες</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"purchasesReport\" ng-click=\"vm.collapseNavbar()\"><span>Αναφορά Παραγγελιών</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"purchasesAggregatedPerEmployee\" ng-click=\"vm.collapseNavbar()\"><span>Σύνολα & Συγκριτικά</span></a></li></ul></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_STOREHOUSE, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a ui-sref=\"purchasesBacklog\" ng-click=\"vm.collapseNavbar()\"><span>Ανεκτέλεστες ποσότητες</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT\"><a ui-sref=\"hospitalizationsReport\" ng-click=\"vm.collapseNavbar()\"><span>Σύνολο Αξιολογήσεων ανά Επαγγελματία Υγείας ανά έτος</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT\"><a ui-sref=\"hospitalizationsComparisonReport\" ng-click=\"vm.collapseNavbar()\"><span>Σύγκριση Αξιολογήσεων ανά Κλινική</span></a></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\">Ευρετήριο Εισαγωγών</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"hospitalizationsAll\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Αναφορές Εισαγωγών</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"hospitalizationsAggregatedPerSector\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Σύνολα</span></a></li></ul></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Patches\"><a ui-sref=\"patchReportsAll\" ng-click=\"vm.collapseNavbar()\"><span>Αναφορά Γνωματεύσεων</span></a></li><!----------------------------------><!--<li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\">\n                            <a ui-sref=\"leadManagementAll\" ng-click=\"vm.collapseNavbar()\">\n                                <span>Ευρετήριο Lead Management</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\">\n                            <a ui-sref=\"#\" ng-click=\"vm.collapseNavbar()\">\n                                <span>Ευρετήριο Follow Up</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_FRONT_DESK, ROLE_REC_ADMINISTRATOR\">\n                            <a ui-sref=\"leadManagementAggregated\" ng-click=\"vm.collapseNavbar()\">\n                                <span>Συγκεντρωτικά Lead Management</span>\n                            </a>\n                        </li>--><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\">Ευρετήριο Lead Management</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\" ui-sref=\"leadManagementAll\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Αναφορές Κλήσεων</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\" ui-sref=\"followUpAll\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Αναφορές FollowUp</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\" ui-sref=\"leadHospitalizationDiseasesAll\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Αναφορές Νοσηλειών</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"leadManagementAggregatedGrid\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Σύνολα</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_MANAGEMENT, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"leadCallsAggregatedPerUser\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Συγκεντρωτικά Ενημερώσεων</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_CHECKER\" application-parameters=\"Med_Report\"><a tabindex=\"-1\">Report</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_CHECKER\" application-parameters=\"Med_Report\"><a tabindex=\"-1\" ui-sref=\"medReportsSumsPerMonth\" ng-click=\"vm.collapseNavbar()\"><span>Σύνολα ανά Σκέυασμα</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_CHECKER\" application-parameters=\"Med_Report\"><a tabindex=\"-1\" ui-sref=\"medReportSumsPerCustomerAndMonth\" ng-click=\"vm.collapseNavbar()\"><span>Σύνολα ανά Επαγγελματία Υγείας</span></a></li></ul></li><!----------------------------------></ul></li><li ng-class=\"{active: vm.$state.includes(\'assignations\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR\"><a ui-sref=\"customerSectorsAssignations\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">group</i> <span class=\"hidden-sm\">Μαζική Διαχείριση Επαγγελματιών Υγείας</span></a></li><li ng-class=\"{active: vm.$state.includes(\'pharmacyAssignations\')}\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_SUPERVISOR, ROLE_ACCOUNTING_DEP, ROLE_PHARM_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"><a ui-sref=\"sectorsPharmacyAssignations\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">group</i> <span class=\"hidden-sm\">Μαζική Διαχείριση Φαρμακείων</span></a></li><li ng-class=\"{active: vm.$state.includes(\'masterData\') && !vm.activeMasterDataState()}\" uib-dropdown class=\"dropdown pointer\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"products-menu\"><span><i class=\"material-icons md-light md-26\">shopping_basket</i> <span class=\"hidden-sm\" translate=\"global.menu.settings.products\">Products </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a tabindex=\"-1\" ui-sref=\"products\" ng-click=\"vm.collapseNavbar()\"><span>Προϊόντα</span></a></li><li ui-sref-active=\"active\"><a tabindex=\"-1\" ui-sref=\"productCategories\" ng-click=\"vm.collapseNavbar()\"><span>Κατηγορίες Προϊόντων</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"sortOrders\" ng-click=\"vm.collapseNavbar()\"><span>Σειρές Εμφάνισης</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"productLots\" ng-click=\"vm.collapseNavbar()\"><span>Παρτίδες Προϊόντων</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"productLotMass\" ng-click=\"vm.collapseNavbar()\"><span>Παρτίδες Προϊόντων (Excel)</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'masterData\') && vm.activeMasterDataState()}\" uib-dropdown class=\"dropdown pointer\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"master-data-menu\"><span><i class=\"material-icons md-light md-26\">assignment</i> <span class=\"hidden-sm\" translate=\"global.menu.settings.main\">Description </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><!--<li ui-sref-active=\"active\" >--><!--<a ui-sref=\"products\" ng-click=\"vm.collapseNavbar()\">--><!--<span translate=\"global.menu.settings.products\">Products</span>--><!--</a>--><!--</li>--><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\">Διαχείριση Επαγγελματιών Υγείας</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" ui-sref=\"customerCategories\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.customerCategories\">Customer Categories</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\" ui-sref=\"doctorSpecialties\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.doctorSpecialties\">Doctor Specialties</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\" ui-sref=\"customerTitles\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.customerTitles\">Customer Titles</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a ui-sref=\"sectorPositions\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.sectorPositions\">Sector Positions</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a ui-sref=\"collaborations\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.collaborations\">Collaborations</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\">Διαχείριση Επισκέψεων</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"eventStatuses\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.eventStatuses\">Event Statuses</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"eventTypes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.eventTypes\">Event Types</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agreementValuations\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.agreementValuations\">Agreement Valuations</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"eventPlaces\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.eventPlaces\">Event Places</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"communicationTypes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.communicationTypes\">Communication Types</span></a></li><li ui-sref-active=\"active\"><a ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.eventCycle\" ng-click=\"vm.onEventCycleClick($event)\">Event Cycle</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\">Διαχείριση Γεωγραφικών Στοιχείων</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a ui-sref=\"prefectures\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.prefectures\">Prefectures</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a ui-sref=\"regions\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.regions\">Regions</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a ui-sref=\"bricks\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.bricks\">Bricks</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a ui-sref=\"brick-osfes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.brickOsfes\">Brick Osfes</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\">Διαχείριση Μονάδων Υγείας</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"sectorTypes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.sectorTypes\">Sector Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a ui-sref=\"sectors\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Μονάδες Υγείας</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a tabindex=\"-1\">Διαχείριση Γραφείου Κίνησης</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"roomTypes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.roomTypes\">Room Types</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"hospitalizationTypes\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.hospitalizationTypes\">Hospitalization Types</span></a></li></ul></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a ui-sref=\"clinicNames\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Διαχείριση Κλινικών</span></a></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Patches\"><a tabindex=\"-1\">Διαχείριση Γνωματεύσεων</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\"><a tabindex=\"-1\" ui-sref=\"patchItems\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.patchItems\">patchItems</span></a></li><li ui-sref-active=\"active\"><a tabindex=\"-1\" ui-sref=\"materialCategories\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.materialCategories\">materialCategories</span></a></li><li ui-sref-active=\"active\"><a tabindex=\"-1\" ui-sref=\"socialInsurances\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.settings.socialInsurances\">socialInsurances</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" translate=\"global.menu.settings.purchases\">Purchases</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"purchaseNumberingRows\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.purchaseNumberingRows\">Purchase Numbering Rows</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"presentLists\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.presentLists\">Present Gifts</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"tradePolicies\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.tradePolicies\">Trade Policies</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"paymentMethods\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.paymentMethods\">Payment Methods</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><a tabindex=\"-1\" ui-sref=\"purchaseStatuses\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.purchaseStatuses\">Purchase Statuses</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" translate=\"global.menu.settings.tax\">Tax</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" ui-sref=\"taxClasses\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.taxClasses\">Tax Classes</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" ui-sref=\"taxStatuses\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.taxStatuses\">Tax Statuses</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" ui-sref=\"taxStatusClasses\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.taxStatusClasses\">Tax Status Classes</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP\"><a tabindex=\"-1\" ui-sref=\"measurementUnits\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.measurementUnits\">Μeasurement Units</span></a></li></ul></li><li class=\"dropdown-submenu\" has-any-authority=\"ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" translate=\"global.menu.settings.leadManagement\">Lead Management</a><ul class=\"dropdown-menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"professions\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.professions\">Professions</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"nativeLanguages\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.nativeLanguages\">Native Languages</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"callTypes\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.callTypes\">Call Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"followupTypes\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.followupTypes\">Followup Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"rejectionReasons\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.rejectionReasons\">Rejection Reasons</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"relationshipTypes\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.relationshipTypes\">Relationship Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"diseaseTypes\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.diseaseTypes\">Disease Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"addConditions\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.addConditions\">Additional Conditions</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"addDiseases\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.addDiseases\">Additional Diseases</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"diseases\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.diseases\">Diseases</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"discountReasons\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.discountReasons\">Discount Reasons</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"discountRates\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.discountRates\">Discount Rates</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"transportations\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.transportations\">Transportations</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"competitors\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.competitors\">Competitors</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"roomCosts\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.roomCosts\">Room Costs</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"costTypes\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.costTypes\">Cost Types</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"leadParameters\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.leadParameters\">Lead Parameters</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"communicationStatuses\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.communicationStatuses\">Communication Statuses</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_REC_ADMINISTRATOR\"><a tabindex=\"-1\" ui-sref=\"hospitalizationTypeParents\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\" translate=\"global.menu.settings.hospitalizationTypeParents\">Hospitalization Type Parents</span></a></li></ul></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ROLE_ACCOUNTING_DEP, ROLE_REC_ADMINISTRATOR, ROLE_REC_FRONT_DESK\"><a ui-sref=\"adminUsers\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Διαχείριση Χρηστών</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\"><a ui-sref=\"adminCycleReport\" ng-click=\"vm.collapseNavbar()\"><span class=\"hidden-sm\">Πλάνο Ενημέρωσης</span></a></li></ul></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SYSTEM\"><a ui-sref=\"applicationParameters\" ng-click=\"vm.collapseNavbar()\"><i class=\"material-icons md-light md-26\">lock</i> <span class=\"hidden-sm\">Παράμετροι Συστήματος</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ROLE_SYSTEM\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"city\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.city\">City</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"application-parameter\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.applicationParameter\">Application Parameter</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agreement-valuation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.agreementValuation\">Agreement Valuation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerCategory\">Customer Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"doctor-specialty\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.doctorSpecialty\">Doctor Specialty</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-place\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventPlace\">Event Place</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventStatus\">Event Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.product\">Product</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sector-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sectorType\">Sector Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sector\">Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"subcategory\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.subcategory\">Subcategory</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"employee\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.employee\">Employee</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customer\">Customer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.event\">Event</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agreement\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.agreement\">Agreement</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"working-day\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.workingDay\">Working Day</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sector-position\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sectorPosition\">Sector Position</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-title\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerTitle\">Customer Title</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventType\">Event Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventCategory\">Event Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"communication-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.communicationType\">Communication Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-category-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventCategoryType\">Event Category Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-schedule\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventSchedule\">Event Schedule</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"event-customer-sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.eventCustomerSector\">Event Customer Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-sub-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerSubCategory\">Customer Sub Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"region\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.region\">Region</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"temp-customer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tempCustomer\">Temp Customer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"temp-sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tempSector\">Temp Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"employee-customer-sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.employeeCustomerSector\">Employee Customer Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"first-name\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.firstName\">First Name</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"last-name\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.lastName\">Last Name</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"prefecture\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.prefecture\">Prefecture</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"country\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.country\">Country</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"geodata\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.geodata\">Geodata</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"change-field\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.changeField\">Change Field</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"change-table\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.changeTable\">Change Table</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"changes\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.changes\">Changes</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"social-insurance\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.socialInsurance\">Social Insurance</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"measurement-unit\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.measurementUnit\">Measurement Unit</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-customer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchCustomer\">Patch Customer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchItem\">Patch Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-report\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchReport\">Patch Report</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-report-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchReportItem\">Patch Report Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productCategory\">Product Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"icd-10\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.icd10\">Icd 10</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-report-material-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchReportMaterialCategory\">Patch Report Material Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerType\">Customer Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patch-report-photo\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patchReportPhoto\">Patch Report Photo</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyType\">Company Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"tax-office\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.taxOffice\">Tax Office</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"brick\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.brick\">Brick</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"brick-osfe\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.brickOsfe\">Brick Osfe</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchaseStatus\">Purchase Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchase\">Purchase</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchaseItem\">Purchase Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"payment-method\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.paymentMethod\">Payment Method</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"tax-class\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.taxClass\">Tax Class</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"tax-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.taxStatus\">Tax Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"tax-status-class\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.taxStatusClass\">Tax Status Class</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-price\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productPrice\">Product Price</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"trade-policy\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tradePolicy\">Trade Policy</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"trade-policy-rule\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tradePolicyRule\">Trade Policy Rule</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"present-list\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.presentList\">Present List</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"present-list-product\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.presentListProduct\">Present List Product</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"trade-policy-rule-effect\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tradePolicyRuleEffect\">Trade Policy Rule Effect</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-numbering-row\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchaseNumberingRow\">Purchase Numbering Row</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-present-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchasePresentItem\">Purchase Present Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-item-lot\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchaseItemLot\">Purchase Item Lot</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-category-product\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productCategoryProduct\">Product Category Product</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-lot\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productLot\">Product Lot</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"purchase-present-item-lot\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.purchasePresentItemLot\">Purchase Present Item Lot</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"room-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.roomType\">Room Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"hospitalization-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.hospitalizationType\">Hospitalization Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"clinic-name\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.clinicName\">Clinic Name</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"patient\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.patient\">Patient</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"hospitalization\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.hospitalization\">Hospitalization</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sector-clinic-name\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sectorClinicName\">Sector Clinic Name</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span data-translate=\"global.menu.entities.customerSector\">Customer Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"temp-customer-sector\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span data-translate=\"global.menu.entities.tempCustomerSector\">Temp Customer Sector</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"favourite-filter\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.favouriteFilter\">Favourite Filter</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"collaboration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.collaboration\">Collaboration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sector-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sectorCategory\">Sector Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"rejection-reason\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.rejectionReason\">Rejection Reason</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"followup-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.followupType\">Followup Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"call-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.callType\">Call Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"profession\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.profession\">Profession</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"native-language\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.nativeLanguage\">Native Language</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"relationship-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.relationshipType\">Relationship Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"prospective-patient\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.prospectivePatient\">Prospective Patient</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-call\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadCall\">Lead Call</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"followup-call\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.followupCall\">Followup Call</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"add-disease\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.addDisease\">Add Disease</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"add-condition\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.addCondition\">Add Condition</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"disease-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.diseaseType\">Disease Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"disease\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.disease\">Disease</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-hospitalization\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadHospitalization\">Lead Hospitalization</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-parameter\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadParameter\">Lead Parameter</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"cost-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.costType\">Cost Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"competitor\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.competitor\">Competitor</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"discount-reason\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.discountReason\">Discount Reason</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"transportation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.transportation\">Transportation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"discount-rate\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.discountRate\">Discount Rate</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-discount\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadDiscount\">Lead Discount</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"room-cost\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.roomCost\">Room Cost</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-offer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadOffer\">Lead Offer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-hospitalization-disease\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadHospitalizationDisease\">Lead Hospitalization Disease</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"attendant\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.attendant\">Attendant</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"followup-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.followupStatus\">Followup Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"offer-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.offerStatus\">Offer Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"country-phone-code\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.countryPhoneCode\">Country Phone Code</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"lead-offer-room-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.leadOfferRoomType\">Lead Offer Room Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"communication-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.communicationStatus\">Communication Status</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"hospitalization-type-parent\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.hospitalizationTypeParent\">Hospitalization Type Parent</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"other-event\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.otherEvent\">Other Event</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"med-report\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.medReport\">Med Report</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"med-report-line\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.medReportLine\">Med Report Line</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"medicine\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.medicine\">Medicine</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\" ng-click=\"vm.getCurrentUserInfo();\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"><span><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm\" translate=\"global.menu.account.main\">Account </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"inactive\" ng-switch-when=\"true\" style=\"padding-bottom: 5px\"><md-list-item class=\"md-2-line\"><img ng-src=\"content/images/baseline_account_circle_blue_96dp.png\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3 style=\"color: #0074BC\">{{vm.currentUser.$$state.value.lastName}} {{vm.currentUser.$$state.value.firstName}}</h3><p style=\"color: #F9A22E\">{{vm.currentUser.$$state.value.login}}</p></div></md-list-item><md-divider style=\"background-color: #0074BC\"></md-divider></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_SYSTEM\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><!--<span class=\"glyphicon glyphicon-tower\"></span>--> <i class=\"material-icons md-light md-26\">settings_applications</i> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"entity-audit\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.entity-audit\">Entity Audit</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"custom-procedures\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.admin.custom-procedures\">Custom Procedures</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\" has-any-authority=\"ROLE_ADMIN\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/entities/add-condition/add-condition-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.addCondition.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.addCondition.delete.question\" translate-values=\"{id: \'{{vm.addCondition.id}}\'}\">Are you sure you want to delete this Add Condition?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/add-condition/add-condition-detail.html","<div><h2><span translate=\"sigmasfApp.addCondition.detail.title\">Add Condition</span> {{vm.addCondition.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.addCondition.name\">Name</span></dt><dd><span>{{vm.addCondition.name}}</span></dd><dt><span translate=\"sigmasfApp.addCondition.information\">Information</span></dt><dd><span>{{vm.addCondition.information}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/add-condition/add-condition-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAddConditionLabel\" translate=\"sigmasfApp.addCondition.home.createOrEditLabel\">Create or edit a Add Condition</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.addCondition.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.addCondition.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.addCondition.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.addCondition.name\" ng-maxlength=\"50\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.addCondition.information\" for=\"field_information\">Information</label><input type=\"text\" class=\"form-control\" name=\"information\" id=\"field_information\" ng-model=\"vm.addCondition.information\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/add-condition/add-conditions.html","<div><h2 translate=\"sigmasfApp.addCondition.home.title\">Add Conditions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"add-condition.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.addCondition.home.createLabel\">Create new Add Condition</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.addCondition.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"information\"><span translate=\"sigmasfApp.addCondition.information\">Information</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"addCondition in vm.addConditions track by addCondition.id\"><td><a ui-sref=\"add-condition-detail({id:addCondition.id})\">{{addCondition.id}}</a></td><td>{{addCondition.name}}</td><td>{{addCondition.information}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"add-condition-detail({id:addCondition.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"add-condition.edit({id:addCondition.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"add-condition.delete({id:addCondition.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/add-disease/add-disease-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.addDisease.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.addDisease.delete.question\" translate-values=\"{id: \'{{vm.addDisease.id}}\'}\">Are you sure you want to delete this Add Disease?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/add-disease/add-disease-detail.html","<div><h2><span translate=\"sigmasfApp.addDisease.detail.title\">Add Disease</span> {{vm.addDisease.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.addDisease.name\">Name</span></dt><dd><span>{{vm.addDisease.name}}</span></dd><dt><span translate=\"sigmasfApp.addDisease.information\">Information</span></dt><dd><span>{{vm.addDisease.information}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/add-disease/add-disease-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAddDiseaseLabel\" translate=\"sigmasfApp.addDisease.home.createOrEditLabel\">Create or edit a Add Disease</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.addDisease.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.addDisease.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.addDisease.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.addDisease.name\" ng-maxlength=\"50\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.addDisease.information\" for=\"field_information\">Information</label><input type=\"text\" class=\"form-control\" name=\"information\" id=\"field_information\" ng-model=\"vm.addDisease.information\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/add-disease/add-diseases.html","<div><h2 translate=\"sigmasfApp.addDisease.home.title\">Add Diseases</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"add-disease.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.addDisease.home.createLabel\">Create new Add Disease</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.addDisease.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"information\"><span translate=\"sigmasfApp.addDisease.information\">Information</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"addDisease in vm.addDiseases track by addDisease.id\"><td><a ui-sref=\"add-disease-detail({id:addDisease.id})\">{{addDisease.id}}</a></td><td>{{addDisease.name}}</td><td>{{addDisease.information}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"add-disease-detail({id:addDisease.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"add-disease.edit({id:addDisease.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"add-disease.delete({id:addDisease.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agreement/agreement-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agreement.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.agreement.delete.question\" translate-values=\"{id: \'{{vm.agreement.id}}\'}\">Are you sure you want to delete this Agreement?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agreement/agreement-detail.html","<div><h2><span translate=\"sigmasfApp.agreement.detail.title\">Agreement</span> {{vm.agreement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.agreement.promisedQuantity\">Promised Quantity</span></dt><dd><span>{{vm.agreement.promisedQuantity}}</span></dd><dt><span translate=\"sigmasfApp.agreement.agreedPrice\">Agreed Price</span></dt><dd><span>{{vm.agreement.agreedPrice}}</span></dd><dt><span translate=\"sigmasfApp.agreement.description\">Description</span></dt><dd><span>{{vm.agreement.description}}</span></dd><dt><span translate=\"sigmasfApp.agreement.priority\">Priority</span></dt><dd><span>{{vm.agreement.priority}}</span></dd><dt><span translate=\"sigmasfApp.agreement.event\">Event</span></dt><dd><a ui-sref=\"event-detail({id:vm.agreement.event.id})\">{{vm.agreement.event.id}}</a></dd><dt><span translate=\"sigmasfApp.agreement.agreementValuation\">Agreement Valuation</span></dt><dd><a ui-sref=\"agreement-valuation-detail({id:vm.agreement.agreementValuation.id})\">{{vm.agreement.agreementValuation.name}}</a></dd><dt><span translate=\"sigmasfApp.agreement.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.agreement.product.id})\">{{vm.agreement.product.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agreement/agreement-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgreementLabel\" translate=\"sigmasfApp.agreement.home.createOrEditLabel\">Create or edit a Agreement</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agreement.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agreement.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreement.promisedQuantity\" for=\"field_promisedQuantity\">Promised Quantity</label><input type=\"number\" class=\"form-control\" name=\"promisedQuantity\" id=\"field_promisedQuantity\" ng-model=\"vm.agreement.promisedQuantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreement.agreedPrice\" for=\"field_agreedPrice\">Agreed Price</label><input type=\"number\" class=\"form-control\" name=\"agreedPrice\" id=\"field_agreedPrice\" ng-model=\"vm.agreement.agreedPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreement.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.agreement.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreement.priority\" for=\"field_priority\">Priority</label><input type=\"number\" class=\"form-control\" name=\"priority\" id=\"field_priority\" ng-model=\"vm.agreement.priority\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.agreement.event\" for=\"field_event\">Event</label><select class=\"form-control\" id=\"field_event\" name=\"event\" ng-model=\"vm.agreement.event\" ng-options=\"event as event.id for event in vm.events track by event.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.agreement.agreementValuation\" for=\"field_agreementValuation\">Agreement Valuation</label><select class=\"form-control\" id=\"field_agreementValuation\" name=\"agreementValuation\" ng-model=\"vm.agreement.agreementValuation\" ng-options=\"agreementValuation as agreementValuation.name for agreementValuation in vm.agreementvaluations track by agreementValuation.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.agreement.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.agreement.product\" ng-options=\"product as product.name for product in vm.products track by product.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agreement/agreements.html","<div><h2 translate=\"sigmasfApp.agreement.home.title\">Agreements</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agreement.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.agreement.home.createLabel\">Create new Agreement</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"promisedQuantity\"><span translate=\"sigmasfApp.agreement.promisedQuantity\">Promised Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreedPrice\"><span translate=\"sigmasfApp.agreement.agreedPrice\">Agreed Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.agreement.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"priority\"><span translate=\"sigmasfApp.agreement.priority\">Priority</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"event.id\"><span translate=\"sigmasfApp.agreement.event\">Event</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreementValuation.name\"><span translate=\"sigmasfApp.agreement.agreementValuation\">Agreement Valuation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.name\"><span translate=\"sigmasfApp.agreement.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agreement in vm.agreements track by agreement.id\"><td><a ui-sref=\"agreement-detail({id:agreement.id})\">{{agreement.id}}</a></td><td>{{agreement.promisedQuantity}}</td><td>{{agreement.agreedPrice}}</td><td>{{agreement.description}}</td><td>{{agreement.priority}}</td><td><a ui-sref=\"event-detail({id:agreement.event.id})\">{{agreement.event.id}}</a></td><td><a ui-sref=\"agreement-valuation-detail({id:agreement.agreementValuation.id})\">{{agreement.agreementValuation.name}}</a></td><td><a ui-sref=\"product-detail({id:agreement.product.id})\">{{agreement.product.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agreement-detail({id:agreement.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agreement.edit({id:agreement.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agreement.delete({id:agreement.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agreement-valuation/agreement-valuation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agreementValuation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.agreementValuation.delete.question\" translate-values=\"{id: \'{{vm.agreementValuation.id}}\'}\">Are you sure you want to delete this Agreement Valuation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agreement-valuation/agreement-valuation-detail.html","<div><h2><span translate=\"sigmasfApp.agreementValuation.detail.title\">Agreement Valuation</span> {{vm.agreementValuation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.agreementValuation.name\">Name</span></dt><dd><span>{{vm.agreementValuation.name}}</span></dd><dt><span translate=\"sigmasfApp.agreementValuation.nameEn\">Name En</span></dt><dd><span>{{vm.agreementValuation.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agreement-valuation/agreement-valuation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgreementValuationLabel\" translate=\"sigmasfApp.agreementValuation.home.createOrEditLabel\">Create or edit a Agreement Valuation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agreementValuation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agreementValuation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreementValuation.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.agreementValuation.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.agreementValuation.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.agreementValuation.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agreement-valuation/agreement-valuations.html","<div><h2 translate=\"sigmasfApp.agreementValuation.home.title\">Agreement Valuations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agreement-valuation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.agreementValuation.home.createLabel\">Create new Agreement Valuation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.agreementValuation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.agreementValuation.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.agreementValuation.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agreementValuation in vm.agreementValuations track by agreementValuation.id\"><td><a ui-sref=\"agreement-valuation-detail({id:agreementValuation.id})\">{{agreementValuation.id}}</a></td><td>{{agreementValuation.name}}</td><td>{{agreementValuation.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agreement-valuation-detail({id:agreementValuation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agreement-valuation.edit({id:agreementValuation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agreement-valuation.delete({id:agreementValuation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/application-parameter/application-parameter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.applicationParameter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.applicationParameter.delete.question\" translate-values=\"{id: \'{{vm.applicationParameter.id}}\'}\">Are you sure you want to delete this Application Parameter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/application-parameter/application-parameter-detail.html","<div><h2><span translate=\"sigmasfApp.applicationParameter.detail.title\">Application Parameter</span> {{vm.applicationParameter.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.applicationParameter.name\">Name</span></dt><dd><span>{{vm.applicationParameter.name}}</span></dd><dt><span translate=\"sigmasfApp.applicationParameter.value\">Value</span></dt><dd><span>{{vm.applicationParameter.value}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/application-parameter/application-parameter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationParameterLabel\" translate=\"sigmasfApp.applicationParameter.home.createOrEditLabel\">Create or edit a Application Parameter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.applicationParameter.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.applicationParameter.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.applicationParameter.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.applicationParameter.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.applicationParameter.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.applicationParameter.value\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/application-parameter/application-parameters.html","<div><h2 translate=\"sigmasfApp.applicationParameter.home.title\">Application Parameters</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"application-parameter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.applicationParameter.home.createLabel\">Create new Application Parameter</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.applicationParameter.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.applicationParameter.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sigmasfApp.applicationParameter.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"applicationParameter in vm.applicationParameters track by applicationParameter.id\"><td><a ui-sref=\"application-parameter-detail({id:applicationParameter.id})\">{{applicationParameter.id}}</a></td><td>{{applicationParameter.name}}</td><td>{{applicationParameter.value}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"application-parameter-detail({id:applicationParameter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"application-parameter.edit({id:applicationParameter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"application-parameter.delete({id:applicationParameter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/brick/brick-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.brick.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.brick.delete.question\" translate-values=\"{id: \'{{vm.brick.id}}\'}\">Are you sure you want to delete this Brick?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/brick/brick-detail.html","<div><h2><span translate=\"sigmasfApp.brick.detail.title\">Brick</span> {{vm.brick.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.brick.areaNo\">Area No</span></dt><dd><span>{{vm.brick.areaNo}}</span></dd><dt><span translate=\"sigmasfApp.brick.areaName\">Area Name</span></dt><dd><span>{{vm.brick.areaName}}</span></dd><dt><span translate=\"sigmasfApp.brick.territoryNo\">Territory No</span></dt><dd><span>{{vm.brick.territoryNo}}</span></dd><dt><span translate=\"sigmasfApp.brick.territoryName\">Territory Name</span></dt><dd><span>{{vm.brick.territoryName}}</span></dd><dt><span translate=\"sigmasfApp.brick.postalCode\">Postal Code</span></dt><dd><span>{{vm.brick.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.brick.municipality\">Municipality</span></dt><dd><span>{{vm.brick.municipality}}</span></dd><dt><span translate=\"sigmasfApp.brick.microCode\">Micro Code</span></dt><dd><span>{{vm.brick.microCode}}</span></dd><dt><span translate=\"sigmasfApp.brick.code\">Code</span></dt><dd><span>{{vm.brick.code}}</span></dd><dt><span translate=\"sigmasfApp.brick.name\">Name</span></dt><dd><span>{{vm.brick.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/brick/brick-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBrickLabel\" translate=\"sigmasfApp.brick.home.createOrEditLabel\">Create or edit a Brick</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.brick.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.brick.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.areaNo\" for=\"field_areaNo\">Area No</label><input type=\"text\" class=\"form-control\" name=\"areaNo\" id=\"field_areaNo\" ng-model=\"vm.brick.areaNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.areaName\" for=\"field_areaName\">Area Name</label><input type=\"text\" class=\"form-control\" name=\"areaName\" id=\"field_areaName\" ng-model=\"vm.brick.areaName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.territoryNo\" for=\"field_territoryNo\">Territory No</label><input type=\"text\" class=\"form-control\" name=\"territoryNo\" id=\"field_territoryNo\" ng-model=\"vm.brick.territoryNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.territoryName\" for=\"field_territoryName\">Territory Name</label><input type=\"text\" class=\"form-control\" name=\"territoryName\" id=\"field_territoryName\" ng-model=\"vm.brick.territoryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.brick.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.municipality\" for=\"field_municipality\">Municipality</label><input type=\"text\" class=\"form-control\" name=\"municipality\" id=\"field_municipality\" ng-model=\"vm.brick.municipality\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.microCode\" for=\"field_microCode\">Micro Code</label><input type=\"text\" class=\"form-control\" name=\"microCode\" id=\"field_microCode\" ng-model=\"vm.brick.microCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.brick.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brick.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.brick.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/brick/bricks.html","<div><h2 translate=\"sigmasfApp.brick.home.title\">Bricks</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"brick.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.brick.home.createLabel\">Create new Brick</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"areaNo\"><span translate=\"sigmasfApp.brick.areaNo\">Area No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"areaName\"><span translate=\"sigmasfApp.brick.areaName\">Area Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"territoryNo\"><span translate=\"sigmasfApp.brick.territoryNo\">Territory No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"territoryName\"><span translate=\"sigmasfApp.brick.territoryName\">Territory Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.brick.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"municipality\"><span translate=\"sigmasfApp.brick.municipality\">Municipality</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"microCode\"><span translate=\"sigmasfApp.brick.microCode\">Micro Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.brick.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.brick.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"brick in vm.bricks track by brick.id\"><td><a ui-sref=\"brick-detail({id:brick.id})\">{{brick.id}}</a></td><td>{{brick.areaNo}}</td><td>{{brick.areaName}}</td><td>{{brick.territoryNo}}</td><td>{{brick.territoryName}}</td><td>{{brick.postalCode}}</td><td>{{brick.municipality}}</td><td>{{brick.microCode}}</td><td>{{brick.code}}</td><td>{{brick.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"brick-detail({id:brick.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"brick.edit({id:brick.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"brick.delete({id:brick.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/attendant/attendant-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.attendant.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.attendant.delete.question\" translate-values=\"{id: \'{{vm.attendant.id}}\'}\">Are you sure you want to delete this Attendant?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/attendant/attendant-detail.html","<div><h2><span translate=\"sigmasfApp.attendant.detail.title\">Attendant</span> {{vm.attendant.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.attendant.firstName\">First Name</span></dt><dd><span>{{vm.attendant.firstName}}</span></dd><dt><span translate=\"sigmasfApp.attendant.lastName\">Last Name</span></dt><dd><span>{{vm.attendant.lastName}}</span></dd><dt><span translate=\"sigmasfApp.attendant.phone\">Phone</span></dt><dd><span>{{vm.attendant.phone}}</span></dd><dt><span translate=\"sigmasfApp.attendant.email\">Email</span></dt><dd><span>{{vm.attendant.email}}</span></dd><dt><span translate=\"sigmasfApp.attendant.isWrongPhone\">Is Wrong Phone</span></dt><dd><span>{{vm.attendant.isWrongPhone}}</span></dd><dt><span translate=\"sigmasfApp.attendant.isWrongContact\">Is Wrong Contact</span></dt><dd><span>{{vm.attendant.isWrongContact}}</span></dd><dt><span translate=\"sigmasfApp.attendant.profession\">Profession</span></dt><dd><a ui-sref=\"profession-detail({id:vm.attendant.profession.id})\">{{vm.attendant.profession.id}}</a></dd><dt><span translate=\"sigmasfApp.attendant.relationshipType\">Relationship Type</span></dt><dd><a ui-sref=\"relationship-type-detail({id:vm.attendant.relationshipType.id})\">{{vm.attendant.relationshipType.id}}</a></dd><dt><span translate=\"sigmasfApp.attendant.countryPhoneCode\">Country Phone Code</span></dt><dd><a ui-sref=\"country-phone-code-detail({id:vm.attendant.countryPhoneCode.id})\">{{vm.attendant.countryPhoneCode.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/attendant/attendant-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAttendantLabel\" translate=\"sigmasfApp.attendant.home.createOrEditLabel\">Create or edit a Attendant</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.attendant.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.attendant.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.firstName\" for=\"field_firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.attendant.firstName\" ng-maxlength=\"35\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"35\">This field cannot be longer than 35 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.attendant.lastName\" ng-maxlength=\"35\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"35\">This field cannot be longer than 35 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.attendant.phone\" ng-maxlength=\"15\"><div ng-show=\"editForm.phone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.phone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.attendant.email\" ng-minlength=\"6\" ng-maxlength=\"254\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.minlength\" translate=\"entity.validation.minlength\" translate-value-min=\"6\">This field is required to be at least 6 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"254\">This field cannot be longer than 254 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.isWrongPhone\" for=\"field_isWrongPhone\">Is Wrong Phone</label><input type=\"checkbox\" class=\"form-control\" name=\"isWrongPhone\" id=\"field_isWrongPhone\" ng-model=\"vm.attendant.isWrongPhone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.attendant.isWrongContact\" for=\"field_isWrongContact\">Is Wrong Contact</label><input type=\"checkbox\" class=\"form-control\" name=\"isWrongContact\" id=\"field_isWrongContact\" ng-model=\"vm.attendant.isWrongContact\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.attendant.profession\" for=\"field_profession\">Profession</label><select class=\"form-control\" id=\"field_profession\" name=\"profession\" ng-model=\"vm.attendant.profession\" ng-options=\"profession as profession.id for profession in vm.professions track by profession.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.attendant.relationshipType\" for=\"field_relationshipType\">Relationship Type</label><select class=\"form-control\" id=\"field_relationshipType\" name=\"relationshipType\" ng-model=\"vm.attendant.relationshipType\" ng-options=\"relationshipType as relationshipType.id for relationshipType in vm.relationshiptypes track by relationshipType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.attendant.countryPhoneCode\" for=\"field_countryPhoneCode\">Country Phone Code</label><select class=\"form-control\" id=\"field_countryPhoneCode\" name=\"countryPhoneCode\" ng-model=\"vm.attendant.countryPhoneCode\" ng-options=\"countryPhoneCode as countryPhoneCode.id for countryPhoneCode in vm.countryphonecodes track by countryPhoneCode.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/attendant/attendants.html","<div><h2 translate=\"sigmasfApp.attendant.home.title\">Attendants</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"attendant.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.attendant.home.createLabel\">Create new Attendant</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.attendant.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.attendant.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.attendant.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span translate=\"sigmasfApp.attendant.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isWrongPhone\"><span translate=\"sigmasfApp.attendant.isWrongPhone\">Is Wrong Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isWrongContact\"><span translate=\"sigmasfApp.attendant.isWrongContact\">Is Wrong Contact</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"profession.id\"><span translate=\"sigmasfApp.attendant.profession\">Profession</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"relationshipType.id\"><span translate=\"sigmasfApp.attendant.relationshipType\">Relationship Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryPhoneCode.id\"><span translate=\"sigmasfApp.attendant.countryPhoneCode\">Country Phone Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"attendant in vm.attendants track by attendant.id\"><td><a ui-sref=\"attendant-detail({id:attendant.id})\">{{attendant.id}}</a></td><td>{{attendant.firstName}}</td><td>{{attendant.lastName}}</td><td>{{attendant.phone}}</td><td>{{attendant.email}}</td><td>{{attendant.isWrongPhone}}</td><td>{{attendant.isWrongContact}}</td><td><a ui-sref=\"profession-detail({id:attendant.profession.id})\">{{attendant.profession.id}}</a></td><td><a ui-sref=\"relationship-type-detail({id:attendant.relationshipType.id})\">{{attendant.relationshipType.id}}</a></td><td><a ui-sref=\"country-phone-code-detail({id:attendant.countryPhoneCode.id})\">{{attendant.countryPhoneCode.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"attendant-detail({id:attendant.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"attendant.edit({id:attendant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"attendant.delete({id:attendant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/brick-osfe/brick-osfe-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.brickOsfe.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.brickOsfe.delete.question\" translate-values=\"{id: \'{{vm.brickOsfe.id}}\'}\">Are you sure you want to delete this Brick Osfe?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/brick-osfe/brick-osfe-detail.html","<div><h2><span translate=\"sigmasfApp.brickOsfe.detail.title\">Brick Osfe</span> {{vm.brickOsfe.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.brickOsfe.areaName\">Area Name</span></dt><dd><span>{{vm.brickOsfe.areaName}}</span></dd><dt><span translate=\"sigmasfApp.brickOsfe.territoryName\">Territory Name</span></dt><dd><span>{{vm.brickOsfe.territoryName}}</span></dd><dt><span translate=\"sigmasfApp.brickOsfe.codeGroup\">Code Group</span></dt><dd><span>{{vm.brickOsfe.codeGroup}}</span></dd><dt><span translate=\"sigmasfApp.brickOsfe.code\">Code</span></dt><dd><span>{{vm.brickOsfe.code}}</span></dd><dt><span translate=\"sigmasfApp.brickOsfe.postalCode\">Postal Code</span></dt><dd><span>{{vm.brickOsfe.postalCode}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/brick-osfe/brick-osfe-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBrickOsfeLabel\" translate=\"sigmasfApp.brickOsfe.home.createOrEditLabel\">Create or edit a Brick Osfe</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.brickOsfe.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.brickOsfe.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brickOsfe.areaName\" for=\"field_areaName\">Area Name</label><input type=\"text\" class=\"form-control\" name=\"areaName\" id=\"field_areaName\" ng-model=\"vm.brickOsfe.areaName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brickOsfe.territoryName\" for=\"field_territoryName\">Territory Name</label><input type=\"text\" class=\"form-control\" name=\"territoryName\" id=\"field_territoryName\" ng-model=\"vm.brickOsfe.territoryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brickOsfe.codeGroup\" for=\"field_codeGroup\">Code Group</label><input type=\"text\" class=\"form-control\" name=\"codeGroup\" id=\"field_codeGroup\" ng-model=\"vm.brickOsfe.codeGroup\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brickOsfe.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.brickOsfe.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.brickOsfe.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.brickOsfe.postalCode\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/brick-osfe/brick-osfes.html","<div><h2 translate=\"sigmasfApp.brickOsfe.home.title\">Brick Osfes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"brick-osfe.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.brickOsfe.home.createLabel\">Create new Brick Osfe</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"areaName\"><span translate=\"sigmasfApp.brickOsfe.areaName\">Area Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"territoryName\"><span translate=\"sigmasfApp.brickOsfe.territoryName\">Territory Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"codeGroup\"><span translate=\"sigmasfApp.brickOsfe.codeGroup\">Code Group</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.brickOsfe.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.brickOsfe.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"brickOsfe in vm.brickOsfes track by brickOsfe.id\"><td><a ui-sref=\"brick-osfe-detail({id:brickOsfe.id})\">{{brickOsfe.id}}</a></td><td>{{brickOsfe.areaName}}</td><td>{{brickOsfe.territoryName}}</td><td>{{brickOsfe.codeGroup}}</td><td>{{brickOsfe.code}}</td><td>{{brickOsfe.postalCode}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"brick-osfe-detail({id:brickOsfe.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"brick-osfe.edit({id:brickOsfe.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"brick-osfe.delete({id:brickOsfe.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/call-type/call-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.callType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.callType.delete.question\" translate-values=\"{id: \'{{vm.callType.id}}\'}\">Are you sure you want to delete this Call Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/call-type/call-type-detail.html","<div><h2><span translate=\"sigmasfApp.callType.detail.title\">Call Type</span> {{vm.callType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.callType.name\">Name</span></dt><dd><span>{{vm.callType.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/call-type/call-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCallTypeLabel\" translate=\"sigmasfApp.callType.home.createOrEditLabel\">Create or edit a Call Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.callType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.callType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.callType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.callType.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/call-type/call-types.html","<div><h2 translate=\"sigmasfApp.callType.home.title\">Call Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"call-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.callType.home.createLabel\">Create new Call Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.callType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"callType in vm.callTypes track by callType.id\"><td><a ui-sref=\"call-type-detail({id:callType.id})\">{{callType.id}}</a></td><td>{{callType.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"call-type-detail({id:callType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"call-type.edit({id:callType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"call-type.delete({id:callType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/change-table/change-table-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.changeTable.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.changeTable.delete.question\" translate-values=\"{id: \'{{vm.changeTable.id}}\'}\">Are you sure you want to delete this Change Table?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/change-table/change-table-detail.html","<div><h2><span translate=\"sigmasfApp.changeTable.detail.title\">Change Table</span> {{vm.changeTable.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.changeTable.name\">Name</span></dt><dd><span>{{vm.changeTable.name}}</span></dd><dt><span translate=\"sigmasfApp.changeTable.nameGr\">Name Gr</span></dt><dd><span>{{vm.changeTable.nameGr}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/change-table/change-table-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myChangeTableLabel\" translate=\"sigmasfApp.changeTable.home.createOrEditLabel\">Create or edit a Change Table</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.changeTable.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.changeTable.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeTable.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.changeTable.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeTable.nameGr\" for=\"field_nameGr\">Name Gr</label><input type=\"text\" class=\"form-control\" name=\"nameGr\" id=\"field_nameGr\" ng-model=\"vm.changeTable.nameGr\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/change-table/change-tables.html","<div><h2 translate=\"sigmasfApp.changeTable.home.title\">Change Tables</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"change-table.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.changeTable.home.createLabel\">Create new Change Table</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.changeTable.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.changeTable.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameGr\"><span translate=\"sigmasfApp.changeTable.nameGr\">Name Gr</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"changeTable in vm.changeTables track by changeTable.id\"><td><a ui-sref=\"change-table-detail({id:changeTable.id})\">{{changeTable.id}}</a></td><td>{{changeTable.name}}</td><td>{{changeTable.nameGr}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"change-table-detail({id:changeTable.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"change-table.edit({id:changeTable.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"change-table.delete({id:changeTable.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/change-field/change-field-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.changeField.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.changeField.delete.question\" translate-values=\"{id: \'{{vm.changeField.id}}\'}\">Are you sure you want to delete this Change Field?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/change-field/change-field-detail.html","<div><h2><span translate=\"sigmasfApp.changeField.detail.title\">Change Field</span> {{vm.changeField.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.changeField.name\">Name</span></dt><dd><span>{{vm.changeField.name}}</span></dd><dt><span translate=\"sigmasfApp.changeField.nameGr\">Name Gr</span></dt><dd><span>{{vm.changeField.nameGr}}</span></dd><dt><span translate=\"sigmasfApp.changeField.isRelationship\">Is Relationship</span></dt><dd><span>{{vm.changeField.isRelationship}}</span></dd><dt><span translate=\"sigmasfApp.changeField.nameEn\">Name En</span></dt><dd><span>{{vm.changeField.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/change-field/change-field-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myChangeFieldLabel\" translate=\"sigmasfApp.changeField.home.createOrEditLabel\">Create or edit a Change Field</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.changeField.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.changeField.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeField.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.changeField.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeField.nameGr\" for=\"field_nameGr\">Name Gr</label><input type=\"text\" class=\"form-control\" name=\"nameGr\" id=\"field_nameGr\" ng-model=\"vm.changeField.nameGr\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeField.isRelationship\" for=\"field_isRelationship\">Is Relationship</label><input type=\"checkbox\" class=\"form-control\" name=\"isRelationship\" id=\"field_isRelationship\" ng-model=\"vm.changeField.isRelationship\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changeField.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.changeField.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/change-field/change-fields.html","<div><h2 translate=\"sigmasfApp.changeField.home.title\">Change Fields</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"change-field.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.changeField.home.createLabel\">Create new Change Field</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.changeField.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.changeField.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameGr\"><span translate=\"sigmasfApp.changeField.nameGr\">Name Gr</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isRelationship\"><span translate=\"sigmasfApp.changeField.isRelationship\">Is Relationship</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.changeField.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"changeField in vm.changeFields track by changeField.id\"><td><a ui-sref=\"change-field-detail({id:changeField.id})\">{{changeField.id}}</a></td><td>{{changeField.name}}</td><td>{{changeField.nameGr}}</td><td>{{changeField.isRelationship}}</td><td>{{changeField.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"change-field-detail({id:changeField.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"change-field.edit({id:changeField.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"change-field.delete({id:changeField.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/city/cities.html","<div><h2 translate=\"sigmasfApp.city.home.title\">Cities</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"city.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.city.home.createLabel\">Create new City</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.city.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.city.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.city.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture.name\"><span translate=\"sigmasfApp.city.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"city in vm.cities track by city.id\"><td><a ui-sref=\"city-detail({id:city.id})\">{{city.id}}</a></td><td>{{city.name}}</td><td>{{city.nameEn}}</td><td><a ui-sref=\"prefecture-detail({id:city.prefecture.id})\">{{city.prefecture.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"city-detail({id:city.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"city.edit({id:city.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"city.delete({id:city.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/city/city-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.city.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.city.delete.question\" translate-values=\"{id: \'{{vm.city.id}}\'}\">Are you sure you want to delete this City?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/city/city-detail.html","<div><h2><span translate=\"sigmasfApp.city.detail.title\">City</span> {{vm.city.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.city.name\">Name</span></dt><dd><span>{{vm.city.name}}</span></dd><dt><span translate=\"sigmasfApp.city.nameEn\">Name En</span></dt><dd><span>{{vm.city.nameEn}}</span></dd><dt><span translate=\"sigmasfApp.city.prefecture\">Prefecture</span></dt><dd><a ui-sref=\"prefecture-detail({id:vm.city.prefecture.id})\">{{vm.city.prefecture.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/city/city-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCityLabel\" translate=\"sigmasfApp.city.home.createOrEditLabel\">Create or edit a City</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.city.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.city.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.city.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.city.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.city.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.city.nameEn\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.city.prefecture\" for=\"field_prefecture\">Prefecture</label><select class=\"form-control\" id=\"field_prefecture\" name=\"prefecture\" ng-model=\"vm.city.prefecture\" ng-options=\"prefecture as prefecture.name for prefecture in vm.prefectures track by prefecture.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/changes/changes-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.changes.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.changes.delete.question\" translate-values=\"{id: \'{{vm.changes.id}}\'}\">Are you sure you want to delete this Changes?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/changes/changes-detail.html","<div><h2><span translate=\"sigmasfApp.changes.detail.title\">Changes</span> {{vm.changes.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.changes.value\">Value</span></dt><dd><span>{{vm.changes.value}}</span></dd><dt><span translate=\"sigmasfApp.changes.oldValue\">Old Value</span></dt><dd><span>{{vm.changes.oldValue}}</span></dd><dt><span translate=\"sigmasfApp.changes.valueId\">Value Id</span></dt><dd><span>{{vm.changes.valueId}}</span></dd><dt><span translate=\"sigmasfApp.changes.oldValueId\">Old Value Id</span></dt><dd><span>{{vm.changes.oldValueId}}</span></dd><dt><span translate=\"sigmasfApp.changes.issuedBy\">Issued By</span></dt><dd><span>{{vm.changes.issuedBy}}</span></dd><dt><span translate=\"sigmasfApp.changes.issuedDate\">Issued Date</span></dt><dd><span>{{vm.changes.issuedDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.changes.status\">Status</span></dt><dd><span translate=\"{{\'sigmasfApp.Status.\' + vm.changes.status}}\">{{vm.changes.status}}</span></dd><dt><span translate=\"sigmasfApp.changes.changeField\">Change Field</span></dt><dd><a ui-sref=\"change-field-detail({id:vm.changes.changeField.id})\">{{vm.changes.changeField.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.changeTable\">Change Table</span></dt><dd><a ui-sref=\"change-table-detail({id:vm.changes.changeTable.id})\">{{vm.changes.changeTable.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.changes.customer.id})\">{{vm.changes.customer.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.changes.sector.id})\">{{vm.changes.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.customerSector\">Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.changes.customerSector.id})\">{{vm.changes.customerSector.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.workingDay\">Working Day</span></dt><dd><a ui-sref=\"working-day-detail({id:vm.changes.workingDay.id})\">{{vm.changes.workingDay.id}}</a></dd><dt><span translate=\"sigmasfApp.changes.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.changes.employee.id})\">{{vm.changes.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/changes/changes-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myChangesLabel\" translate=\"sigmasfApp.changes.home.createOrEditLabel\">Create or edit a Changes</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.changes.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.changes.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.changes.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.oldValue\" for=\"field_oldValue\">Old Value</label><input type=\"text\" class=\"form-control\" name=\"oldValue\" id=\"field_oldValue\" ng-model=\"vm.changes.oldValue\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.valueId\" for=\"field_valueId\">Value Id</label><input type=\"number\" class=\"form-control\" name=\"valueId\" id=\"field_valueId\" ng-model=\"vm.changes.valueId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.oldValueId\" for=\"field_oldValueId\">Old Value Id</label><input type=\"number\" class=\"form-control\" name=\"oldValueId\" id=\"field_oldValueId\" ng-model=\"vm.changes.oldValueId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.issuedBy\" for=\"field_issuedBy\">Issued By</label><input type=\"text\" class=\"form-control\" name=\"issuedBy\" id=\"field_issuedBy\" ng-model=\"vm.changes.issuedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.issuedDate\" for=\"field_issuedDate\">Issued Date</label><div class=\"input-group\"><input id=\"field_issuedDate\" type=\"text\" class=\"form-control\" name=\"issuedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.changes.issuedDate\" is-open=\"vm.datePickerOpenStatus.issuedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issuedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.changes.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.changes.status\" id=\"field_status\"><option value=\"pending\" translate=\"sigmasfApp.Status.pending\">pending</option><option value=\"approved\" translate=\"sigmasfApp.Status.approved\">approved</option><option value=\"rejected\" translate=\"sigmasfApp.Status.rejected\">rejected</option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.changeField\" for=\"field_changeField\">Change Field</label><select class=\"form-control\" id=\"field_changeField\" name=\"changeField\" ng-model=\"vm.changes.changeField\" ng-options=\"changeField as changeField.id for changeField in vm.changefields track by changeField.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.changeTable\" for=\"field_changeTable\">Change Table</label><select class=\"form-control\" id=\"field_changeTable\" name=\"changeTable\" ng-model=\"vm.changes.changeTable\" ng-options=\"changeTable as changeTable.id for changeTable in vm.changetables track by changeTable.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.changes.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.changes.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.customerSector\" for=\"field_customerSector\">Customer Sector</label><select class=\"form-control\" id=\"field_customerSector\" name=\"customerSector\" ng-model=\"vm.changes.customerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.customersectors track by customerSector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.workingDay\" for=\"field_workingDay\">Working Day</label><select class=\"form-control\" id=\"field_workingDay\" name=\"workingDay\" ng-model=\"vm.changes.workingDay\" ng-options=\"workingDay as workingDay.id for workingDay in vm.workingdays track by workingDay.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.changes.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.changes.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/changes/changes.html","<div><h2 translate=\"sigmasfApp.changes.home.title\">Changes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"changes.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.changes.home.createLabel\">Create new Changes</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.changes.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sigmasfApp.changes.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"oldValue\"><span translate=\"sigmasfApp.changes.oldValue\">Old Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"valueId\"><span translate=\"sigmasfApp.changes.valueId\">Value Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"oldValueId\"><span translate=\"sigmasfApp.changes.oldValueId\">Old Value Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedBy\"><span translate=\"sigmasfApp.changes.issuedBy\">Issued By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedDate\"><span translate=\"sigmasfApp.changes.issuedDate\">Issued Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sigmasfApp.changes.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"changeField.id\"><span translate=\"sigmasfApp.changes.changeField\">Change Field</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"changeTable.id\"><span translate=\"sigmasfApp.changes.changeTable\">Change Table</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span translate=\"sigmasfApp.changes.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.changes.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSector.id\"><span translate=\"sigmasfApp.changes.customerSector\">Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"workingDay.id\"><span translate=\"sigmasfApp.changes.workingDay\">Working Day</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.changes.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"changes in vm.changes track by changes.id\"><td><a ui-sref=\"changes-detail({id:changes.id})\">{{changes.id}}</a></td><td>{{changes.value}}</td><td>{{changes.oldValue}}</td><td>{{changes.valueId}}</td><td>{{changes.oldValueId}}</td><td>{{changes.issuedBy}}</td><td>{{changes.issuedDate | date:\'medium\'}}</td><td translate=\"{{\'sigmasfApp.Status.\' + changes.status}}\">{{changes.status}}</td><td><a ui-sref=\"change-field-detail({id:changes.changeField.id})\">{{changes.changeField.id}}</a></td><td><a ui-sref=\"change-table-detail({id:changes.changeTable.id})\">{{changes.changeTable.id}}</a></td><td><a ui-sref=\"customer-detail({id:changes.customer.id})\">{{changes.customer.id}}</a></td><td><a ui-sref=\"sector-detail({id:changes.sector.id})\">{{changes.sector.id}}</a></td><td><a ui-sref=\"customer-sector-detail({id:changes.customerSector.id})\">{{changes.customerSector.id}}</a></td><td><a ui-sref=\"working-day-detail({id:changes.workingDay.id})\">{{changes.workingDay.id}}</a></td><td><a ui-sref=\"employee-detail({id:changes.employee.id})\">{{changes.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"changes-detail({id:changes.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"changes.edit({id:changes.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"changes.delete({id:changes.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/clinic-name/clinic-name-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.clinicName.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.clinicName.delete.question\" translate-values=\"{id: \'{{vm.clinicName.id}}\'}\">Are you sure you want to delete this Clinic Name?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/clinic-name/clinic-name-detail.html","<div><h2><span translate=\"sigmasfApp.clinicName.detail.title\">Clinic Name</span> {{vm.clinicName.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.clinicName.name\">Name</span></dt><dd><span>{{vm.clinicName.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/clinic-name/clinic-name-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myClinicNameLabel\" translate=\"sigmasfApp.clinicName.home.createOrEditLabel\">Create or edit a Clinic Name</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.clinicName.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.clinicName.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.clinicName.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.clinicName.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/clinic-name/clinic-names.html","<div><h2 translate=\"sigmasfApp.clinicName.home.title\">Clinic Names</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"clinic-name.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.clinicName.home.createLabel\">Create new Clinic Name</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.clinicName.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"clinicName in vm.clinicNames track by clinicName.id\"><td><a ui-sref=\"clinic-name-detail({id:clinicName.id})\">{{clinicName.id}}</a></td><td>{{clinicName.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"clinic-name-detail({id:clinicName.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"clinic-name.edit({id:clinicName.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"clinic-name.delete({id:clinicName.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/collaboration/collaboration-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.collaboration.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.collaboration.delete.question\" translate-values=\"{id: \'{{vm.collaboration.id}}\'}\">Are you sure you want to delete this Collaboration?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/collaboration/collaboration-detail.html","<div><h2><span translate=\"sigmasfApp.collaboration.detail.title\">Collaboration</span> {{vm.collaboration.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.collaboration.name\">Name</span></dt><dd><span>{{vm.collaboration.name}}</span></dd><dt><span translate=\"sigmasfApp.collaboration.nameEn\">Name En</span></dt><dd><span>{{vm.collaboration.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/collaboration/collaboration-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCollaborationLabel\" translate=\"sigmasfApp.collaboration.home.createOrEditLabel\">Create or edit a Collaboration</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.collaboration.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.collaboration.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.collaboration.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.collaboration.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.collaboration.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.collaboration.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/collaboration/collaborations.html","<div><h2 translate=\"sigmasfApp.collaboration.home.title\">Collaborations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"collaboration.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.collaboration.home.createLabel\">Create new Collaboration</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.collaboration.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.collaboration.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"collaboration in vm.collaborations track by collaboration.id\"><td><a ui-sref=\"collaboration-detail({id:collaboration.id})\">{{collaboration.id}}</a></td><td>{{collaboration.name}}</td><td>{{collaboration.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"collaboration-detail({id:collaboration.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"collaboration.edit({id:collaboration.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"collaboration.delete({id:collaboration.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/communication-status/communication-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.communicationStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.communicationStatus.delete.question\" translate-values=\"{id: \'{{vm.communicationStatus.id}}\'}\">Are you sure you want to delete this Communication Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/communication-status/communication-status-detail.html","<div><h2><span translate=\"sigmasfApp.communicationStatus.detail.title\">Communication Status</span> {{vm.communicationStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.communicationStatus.name\">Name</span></dt><dd><span>{{vm.communicationStatus.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/communication-status/communication-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCommunicationStatusLabel\" translate=\"sigmasfApp.communicationStatus.home.createOrEditLabel\">Create or edit a Communication Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.communicationStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.communicationStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.communicationStatus.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/communication-status/communication-statuses.html","<div><h2 translate=\"sigmasfApp.communicationStatus.home.title\">Communication Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"communication-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.communicationStatus.home.createLabel\">Create new Communication Status</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.communicationStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationStatus in vm.communicationStatuses track by communicationStatus.id\"><td><a ui-sref=\"communication-status-detail({id:communicationStatus.id})\">{{communicationStatus.id}}</a></td><td>{{communicationStatus.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"communication-status-detail({id:communicationStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"communication-status.edit({id:communicationStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-status.delete({id:communicationStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/competitor/competitor-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.competitor.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.competitor.delete.question\" translate-values=\"{id: \'{{vm.competitor.id}}\'}\">Are you sure you want to delete this Competitor?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/competitor/competitor-detail.html","<div><h2><span translate=\"sigmasfApp.competitor.detail.title\">Competitor</span> {{vm.competitor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.competitor.name\">Name</span></dt><dd><span>{{vm.competitor.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/competitor/competitor-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompetitorLabel\" translate=\"sigmasfApp.competitor.home.createOrEditLabel\">Create or edit a Competitor</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.competitor.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.competitor.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.competitor.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.competitor.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/competitor/competitors.html","<div><h2 translate=\"sigmasfApp.competitor.home.title\">Competitors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"competitor.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.competitor.home.createLabel\">Create new Competitor</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.competitor.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"competitor in vm.competitors track by competitor.id\"><td><a ui-sref=\"competitor-detail({id:competitor.id})\">{{competitor.id}}</a></td><td>{{competitor.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"competitor-detail({id:competitor.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"competitor.edit({id:competitor.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"competitor.delete({id:competitor.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-type/company-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companyType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.companyType.delete.question\" translate-values=\"{id: \'{{vm.companyType.id}}\'}\">Are you sure you want to delete this Company Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-type/company-type-detail.html","<div><h2><span translate=\"sigmasfApp.companyType.detail.title\">Company Type</span> {{vm.companyType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.companyType.name\">Name</span></dt><dd><span>{{vm.companyType.name}}</span></dd><dt><span translate=\"sigmasfApp.companyType.nameEn\">Name En</span></dt><dd><span>{{vm.companyType.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-type/company-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyTypeLabel\" translate=\"sigmasfApp.companyType.home.createOrEditLabel\">Create or edit a Company Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.companyType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.companyType.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.companyType.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.companyType.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-type/company-types.html","<div><h2 translate=\"sigmasfApp.companyType.home.title\">Company Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.companyType.home.createLabel\">Create new Company Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.companyType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.companyType.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyType in vm.companyTypes track by companyType.id\"><td><a ui-sref=\"company-type-detail({id:companyType.id})\">{{companyType.id}}</a></td><td>{{companyType.name}}</td><td>{{companyType.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-type-detail({id:companyType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company-type.edit({id:companyType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-type.delete({id:companyType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/cost-type/cost-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.costType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.costType.delete.question\" translate-values=\"{id: \'{{vm.costType.id}}\'}\">Are you sure you want to delete this Cost Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/cost-type/cost-type-detail.html","<div><h2><span translate=\"sigmasfApp.costType.detail.title\">Cost Type</span> {{vm.costType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.costType.name\">Name</span></dt><dd><span>{{vm.costType.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/cost-type/cost-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCostTypeLabel\" translate=\"sigmasfApp.costType.home.createOrEditLabel\">Create or edit a Cost Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.costType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.costType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.costType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.costType.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/cost-type/cost-types.html","<div><h2 translate=\"sigmasfApp.costType.home.title\">Cost Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"cost-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.costType.home.createLabel\">Create new Cost Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.costType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"costType in vm.costTypes track by costType.id\"><td><a ui-sref=\"cost-type-detail({id:costType.id})\">{{costType.id}}</a></td><td>{{costType.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cost-type-detail({id:costType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"cost-type.edit({id:costType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"cost-type.delete({id:costType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/communication-type/communication-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.communicationType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.communicationType.delete.question\" translate-values=\"{id: \'{{vm.communicationType.id}}\'}\">Are you sure you want to delete this Communication Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/communication-type/communication-type-detail.html","<div><h2><span translate=\"sigmasfApp.communicationType.detail.title\">Communication Type</span> {{vm.communicationType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.communicationType.name\">Name</span></dt><dd><span>{{vm.communicationType.name}}</span></dd><dt><span translate=\"sigmasfApp.communicationType.nameEn\">Name En</span></dt><dd><span>{{vm.communicationType.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/communication-type/communication-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCommunicationTypeLabel\" translate=\"sigmasfApp.communicationType.home.createOrEditLabel\">Create or edit a Communication Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.communicationType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.communicationType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.communicationType.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.communicationType.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.communicationType.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/communication-type/communication-types.html","<div><h2 translate=\"sigmasfApp.communicationType.home.title\">Communication Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"communication-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.communicationType.home.createLabel\">Create new Communication Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.communicationType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.communicationType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.communicationType.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationType in vm.communicationTypes track by communicationType.id\"><td><a ui-sref=\"communication-type-detail({id:communicationType.id})\">{{communicationType.id}}</a></td><td>{{communicationType.name}}</td><td>{{communicationType.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"communication-type-detail({id:communicationType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"communication-type.edit({id:communicationType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-type.delete({id:communicationType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer/customer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.customer.delete.question\" translate-values=\"{id: \'{{vm.customer.id}}\'}\">Are you sure you want to delete this Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer/customer-detail.html","<div><h2><span translate=\"sigmasfApp.customer.detail.title\">Customer</span> {{vm.customer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.customer.firstName\">First Name</span></dt><dd><span>{{vm.customer.firstName}}</span></dd><dt><span translate=\"sigmasfApp.customer.lastName\">Last Name</span></dt><dd><span>{{vm.customer.lastName}}</span></dd><dt><span translate=\"sigmasfApp.customer.fatherName\">Father Name</span></dt><dd><span>{{vm.customer.fatherName}}</span></dd><dt><span translate=\"sigmasfApp.customer.cellPhone\">Cell Phone</span></dt><dd><span>{{vm.customer.cellPhone}}</span></dd><dt><span translate=\"sigmasfApp.customer.phone\">Phone</span></dt><dd><span>{{vm.customer.phone}}</span></dd><dt><span translate=\"sigmasfApp.customer.isMale\">Is Male</span></dt><dd><span>{{vm.customer.isMale}}</span></dd><dt><span translate=\"sigmasfApp.customer.email\">Email</span></dt><dd><span>{{vm.customer.email}}</span></dd><dt><span translate=\"sigmasfApp.customer.notes\">Notes</span></dt><dd><span>{{vm.customer.notes}}</span></dd><dt><span translate=\"sigmasfApp.customer.saw\">Saw</span></dt><dd><span>{{vm.customer.saw}}</span></dd><dt><span translate=\"sigmasfApp.customer.isActive\">Is Active</span></dt><dd><span>{{vm.customer.isActive}}</span></dd><dt><span translate=\"sigmasfApp.customer.dayTime\">Day Time</span></dt><dd><span translate=\"{{\'sigmasfApp.DayTimeEnum.\' + vm.customer.dayTime}}\">{{vm.customer.dayTime}}</span></dd><dt><span translate=\"sigmasfApp.customer.lCode\">L Code</span></dt><dd><span>{{vm.customer.lCode}}</span></dd><dt><span translate=\"sigmasfApp.customer.vatNumber\">Vat Number</span></dt><dd><span>{{vm.customer.vatNumber}}</span></dd><dt><span translate=\"sigmasfApp.customer.etaaNumber\">Etaa Number</span></dt><dd><span>{{vm.customer.etaaNumber}}</span></dd><dt><span translate=\"sigmasfApp.customer.amka\">Amka</span></dt><dd><span>{{vm.customer.amka}}</span></dd><dt><span translate=\"sigmasfApp.customer.profilePhoto\">Profile Photo</span></dt><dd><div ng-if=\"vm.customer.profilePhoto\"><a ng-click=\"vm.openFile(vm.customer.profilePhotoContentType, vm.customer.profilePhoto)\"><img data-ng-src=\"{{\'data:\' + vm.customer.profilePhotoContentType + \';base64,\' + vm.customer.profilePhoto}}\" style=\"max-width: 100%\"> </a>{{vm.customer.profilePhotoContentType}}, {{vm.byteSize(vm.customer.profilePhoto)}}</div></dd><dt><span translate=\"sigmasfApp.customer.software\">Software</span></dt><dd><span translate=\"{{\'sigmasfApp.Software.\' + vm.customer.software}}\">{{vm.customer.software}}</span></dd><dt><span translate=\"sigmasfApp.customer.lastVisitDate\">Last Visit Date</span></dt><dd><span>{{vm.customer.lastVisitDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.customer.docId\">Doc Id</span></dt><dd><span>{{vm.customer.docId}}</span></dd><dt><span translate=\"sigmasfApp.customer.doctorSpecialty\">Doctor Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.customer.doctorSpecialty.id})\">{{vm.customer.doctorSpecialty.name}}</a></dd><dt><span translate=\"sigmasfApp.customer.customerCategory\">Customer Category</span></dt><dd><a ui-sref=\"customer-category-detail({id:vm.customer.customerCategory.id})\">{{vm.customer.customerCategory.name}}</a></dd><dt><span translate=\"sigmasfApp.customer.customerTitle\">Customer Title</span></dt><dd><a ui-sref=\"customer-title-detail({id:vm.customer.customerTitle.id})\">{{vm.customer.customerTitle.name}}</a></dd><dt><span translate=\"sigmasfApp.customer.doctorSpecificSpecialty\">Doctor Specific Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.customer.doctorSpecificSpecialty.id})\">{{vm.customer.doctorSpecificSpecialty.id}}</a></dd><dt><span translate=\"sigmasfApp.customer.customerSubCategory\">Customer Sub Category</span></dt><dd><a ui-sref=\"customer-sub-category-detail({id:vm.customer.customerSubCategory.id})\">{{vm.customer.customerSubCategory.name}}</a></dd><dt><span translate=\"sigmasfApp.customer.customerType\">Customer Type</span></dt><dd><span ng-repeat=\"customerType in vm.customer.customerTypes\"><a ui-sref=\"customer-type-detail({id: {{customerType.id}}})\">{{customerType.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.customer.collaboration\">Collaboration</span></dt><dd><a ui-sref=\"collaboration-detail({id:vm.customer.collaboration.id})\">{{vm.customer.collaboration.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer/customer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerLabel\" translate=\"sigmasfApp.customer.home.createOrEditLabel\">Create or edit a Customer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.firstName\" for=\"field_firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.customer.firstName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.customer.lastName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.fatherName\" for=\"field_fatherName\">Father Name</label><input type=\"text\" class=\"form-control\" name=\"fatherName\" id=\"field_fatherName\" ng-model=\"vm.customer.fatherName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.cellPhone\" for=\"field_cellPhone\">Cell Phone</label><input type=\"text\" class=\"form-control\" name=\"cellPhone\" id=\"field_cellPhone\" ng-model=\"vm.customer.cellPhone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.customer.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.isMale\" for=\"field_isMale\">Is Male</label><input type=\"checkbox\" class=\"form-control\" name=\"isMale\" id=\"field_isMale\" ng-model=\"vm.customer.isMale\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.customer.email\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.notes\" for=\"field_notes\">Notes</label><input type=\"text\" class=\"form-control\" name=\"notes\" id=\"field_notes\" ng-model=\"vm.customer.notes\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.saw\" for=\"field_saw\">Saw</label><input type=\"checkbox\" class=\"form-control\" name=\"saw\" id=\"field_saw\" ng-model=\"vm.customer.saw\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.isActive\" for=\"field_isActive\">Is Active</label><input type=\"checkbox\" class=\"form-control\" name=\"isActive\" id=\"field_isActive\" ng-model=\"vm.customer.isActive\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.dayTime\" for=\"field_dayTime\">Day Time</label><select class=\"form-control\" name=\"dayTime\" ng-model=\"vm.customer.dayTime\" id=\"field_dayTime\"><option value=\"day\" translate=\"sigmasfApp.DayTimeEnum.day\">day</option><option value=\"night\" translate=\"sigmasfApp.DayTimeEnum.night\">night</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.lCode\" for=\"field_lCode\">L Code</label><input type=\"text\" class=\"form-control\" name=\"lCode\" id=\"field_lCode\" ng-model=\"vm.customer.lCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.vatNumber\" for=\"field_vatNumber\">Vat Number</label><input type=\"text\" class=\"form-control\" name=\"vatNumber\" id=\"field_vatNumber\" ng-model=\"vm.customer.vatNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.etaaNumber\" for=\"field_etaaNumber\">Etaa Number</label><input type=\"text\" class=\"form-control\" name=\"etaaNumber\" id=\"field_etaaNumber\" ng-model=\"vm.customer.etaaNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.amka\" for=\"field_amka\">Amka</label><input type=\"text\" class=\"form-control\" name=\"amka\" id=\"field_amka\" ng-model=\"vm.customer.amka\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setProfilePhoto($file, vm.customer)\" ngf-pattern=\"\'image/*\'\"><label class=\"control-label\" translate=\"sigmasfApp.customer.profilePhoto\" for=\"field_profilePhoto\">Profile Photo</label><div><img data-ng-src=\"{{\'data:\' + vm.customer.profilePhotoContentType + \';base64,\' + vm.customer.profilePhoto}}\" style=\"max-height: 100px\" ng-if=\"vm.customer.profilePhoto\"><div ng-if=\"vm.customer.profilePhoto\" class=\"help-block clearfix\"><span class=\"pull-left\">{{vm.customer.profilePhotoContentType}}, {{vm.byteSize(vm.customer.profilePhoto)}}</span> <button ng-click=\"vm.customer.profilePhoto=null;vm.customer.profilePhotoContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setProfilePhoto($file, vm.customer)\" accept=\"image/*\" translate=\"entity.action.addimage\">Add image</button></div><input type=\"hidden\" class=\"form-control\" name=\"profilePhoto\" id=\"field_profilePhoto\" ng-model=\"vm.customer.profilePhoto\"> <input type=\"hidden\" class=\"form-control\" name=\"profilePhotoContentType\" id=\"field_profilePhotoContentType\" ng-model=\"vm.customer.profilePhotoContentType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.software\" for=\"field_software\">Software</label><select class=\"form-control\" name=\"software\" ng-model=\"vm.customer.software\" id=\"field_software\"><option value=\"medexpress\" translate=\"sigmasfApp.Software.medexpress\">medexpress</option><option value=\"medmobile\" translate=\"sigmasfApp.Software.medmobile\">medmobile</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.lastVisitDate\" for=\"field_lastVisitDate\">Last Visit Date</label><div class=\"input-group\"><input id=\"field_lastVisitDate\" type=\"text\" class=\"form-control\" name=\"lastVisitDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.customer.lastVisitDate\" is-open=\"vm.datePickerOpenStatus.lastVisitDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastVisitDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customer.docId\" for=\"field_docId\">Doc Id</label><input type=\"number\" class=\"form-control\" name=\"docId\" id=\"field_docId\" ng-model=\"vm.customer.docId\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.doctorSpecialty\" for=\"field_doctorSpecialty\">Doctor Specialty</label><select class=\"form-control\" id=\"field_doctorSpecialty\" name=\"doctorSpecialty\" ng-model=\"vm.customer.doctorSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.name for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.customerCategory\" for=\"field_customerCategory\">Customer Category</label><select class=\"form-control\" id=\"field_customerCategory\" name=\"customerCategory\" ng-model=\"vm.customer.customerCategory\" ng-options=\"customerCategory as customerCategory.name for customerCategory in vm.customercategories track by customerCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.customerTitle\" for=\"field_customerTitle\">Customer Title</label><select class=\"form-control\" id=\"field_customerTitle\" name=\"customerTitle\" ng-model=\"vm.customer.customerTitle\" ng-options=\"customerTitle as customerTitle.name for customerTitle in vm.customertitles track by customerTitle.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.doctorSpecificSpecialty\" for=\"field_doctorSpecificSpecialty\">Doctor Specific Specialty</label><select class=\"form-control\" id=\"field_doctorSpecificSpecialty\" name=\"doctorSpecificSpecialty\" ng-model=\"vm.customer.doctorSpecificSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.id for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.customerSubCategory\" for=\"field_customerSubCategory\">Customer Sub Category</label><select class=\"form-control\" id=\"field_customerSubCategory\" name=\"customerSubCategory\" ng-model=\"vm.customer.customerSubCategory\" ng-options=\"customerSubCategory as customerSubCategory.name for customerSubCategory in vm.customersubcategories track by customerSubCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.customerType\" for=\"field_customerType\">Customer Type</label><select class=\"form-control\" id=\"field_customerType\" multiple=\"multiple\" name=\"customerType\" ng-model=\"vm.customer.customerTypes\" ng-options=\"customerType as customerType.name for customerType in vm.customertypes track by customerType.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.customer.collaboration\" for=\"field_collaboration\">Collaboration</label><select class=\"form-control\" id=\"field_collaboration\" name=\"collaboration\" ng-model=\"vm.customer.collaboration\" ng-options=\"collaboration as collaboration.id for collaboration in vm.collaborations track by collaboration.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer/customers.html","<div><h2 translate=\"sigmasfApp.customer.home.title\">Customers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.customer.home.createLabel\">Create new Customer</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.customer.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.customer.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fatherName\"><span translate=\"sigmasfApp.customer.fatherName\">Father Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cellPhone\"><span translate=\"sigmasfApp.customer.cellPhone\">Cell Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.customer.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isMale\"><span translate=\"sigmasfApp.customer.isMale\">Is Male</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span translate=\"sigmasfApp.customer.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notes\"><span translate=\"sigmasfApp.customer.notes\">Notes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"saw\"><span translate=\"sigmasfApp.customer.saw\">Saw</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isActive\"><span translate=\"sigmasfApp.customer.isActive\">Is Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dayTime\"><span translate=\"sigmasfApp.customer.dayTime\">Day Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lCode\"><span translate=\"sigmasfApp.customer.lCode\">L Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vatNumber\"><span translate=\"sigmasfApp.customer.vatNumber\">Vat Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etaaNumber\"><span translate=\"sigmasfApp.customer.etaaNumber\">Etaa Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amka\"><span translate=\"sigmasfApp.customer.amka\">Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"profilePhoto\"><span translate=\"sigmasfApp.customer.profilePhoto\">Profile Photo</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"software\"><span translate=\"sigmasfApp.customer.software\">Software</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastVisitDate\"><span translate=\"sigmasfApp.customer.lastVisitDate\">Last Visit Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"docId\"><span translate=\"sigmasfApp.customer.docId\">Doc Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecialty.name\"><span translate=\"sigmasfApp.customer.doctorSpecialty\">Doctor Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerCategory.name\"><span translate=\"sigmasfApp.customer.customerCategory\">Customer Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerTitle.name\"><span translate=\"sigmasfApp.customer.customerTitle\">Customer Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecificSpecialty.id\"><span translate=\"sigmasfApp.customer.doctorSpecificSpecialty\">Doctor Specific Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSubCategory.name\"><span translate=\"sigmasfApp.customer.customerSubCategory\">Customer Sub Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collaboration.id\"><span translate=\"sigmasfApp.customer.collaboration\">Collaboration</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customer in vm.customers track by customer.id\"><td><a ui-sref=\"customer-detail({id:customer.id})\">{{customer.id}}</a></td><td>{{customer.firstName}}</td><td>{{customer.lastName}}</td><td>{{customer.fatherName}}</td><td>{{customer.cellPhone}}</td><td>{{customer.phone}}</td><td>{{customer.isMale}}</td><td>{{customer.email}}</td><td>{{customer.notes}}</td><td>{{customer.saw}}</td><td>{{customer.isActive}}</td><td translate=\"{{\'sigmasfApp.DayTimeEnum.\' + customer.dayTime}}\">{{customer.dayTime}}</td><td>{{customer.lCode}}</td><td>{{customer.vatNumber}}</td><td>{{customer.etaaNumber}}</td><td>{{customer.amka}}</td><td><a ng-if=\"customer.profilePhoto\" ng-click=\"vm.openFile(customer.profilePhotoContentType, customer.profilePhoto)\"><img data-ng-src=\"{{\'data:\' + customer.profilePhotoContentType + \';base64,\' + customer.profilePhoto}}\" style=\"max-height: 30px\"> </a><span ng-if=\"customer.profilePhoto\">{{customer.profilePhotoContentType}}, {{vm.byteSize(customer.profilePhoto)}}</span></td><td translate=\"{{\'sigmasfApp.Software.\' + customer.software}}\">{{customer.software}}</td><td>{{customer.lastVisitDate | date:\'medium\'}}</td><td>{{customer.docId}}</td><td><a ui-sref=\"doctor-specialty-detail({id:customer.doctorSpecialty.id})\">{{customer.doctorSpecialty.name}}</a></td><td><a ui-sref=\"customer-category-detail({id:customer.customerCategory.id})\">{{customer.customerCategory.name}}</a></td><td><a ui-sref=\"customer-title-detail({id:customer.customerTitle.id})\">{{customer.customerTitle.name}}</a></td><td><a ui-sref=\"doctor-specialty-detail({id:customer.doctorSpecificSpecialty.id})\">{{customer.doctorSpecificSpecialty.id}}</a></td><td><a ui-sref=\"customer-sub-category-detail({id:customer.customerSubCategory.id})\">{{customer.customerSubCategory.name}}</a></td><td><a ui-sref=\"collaboration-detail({id:customer.collaboration.id})\">{{customer.collaboration.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-detail({id:customer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer.edit({id:customer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer.delete({id:customer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/country/countries.html","<div><h2 translate=\"sigmasfApp.country.home.title\">Countries</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"country.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.country.home.createLabel\">Create new Country</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.country.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.country.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isoSymbol\"><span translate=\"sigmasfApp.country.isoSymbol\">Iso Symbol</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.country.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"country in vm.countries track by country.id\"><td><a ui-sref=\"country-detail({id:country.id})\">{{country.id}}</a></td><td>{{country.name}}</td><td>{{country.isoSymbol}}</td><td>{{country.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"country-detail({id:country.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"country.edit({id:country.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"country.delete({id:country.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/country/country-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.country.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.country.delete.question\" translate-values=\"{id: \'{{vm.country.id}}\'}\">Are you sure you want to delete this Country?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/country/country-detail.html","<div><h2><span translate=\"sigmasfApp.country.detail.title\">Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.country.name\">Name</span></dt><dd><span>{{vm.country.name}}</span></dd><dt><span translate=\"sigmasfApp.country.isoSymbol\">Iso Symbol</span></dt><dd><span>{{vm.country.isoSymbol}}</span></dd><dt><span translate=\"sigmasfApp.country.nameEn\">Name En</span></dt><dd><span>{{vm.country.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/country/country-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCountryLabel\" translate=\"sigmasfApp.country.home.createOrEditLabel\">Create or edit a Country</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.country.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.country.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.country.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.country.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.country.isoSymbol\" for=\"field_isoSymbol\">Iso Symbol</label><input type=\"text\" class=\"form-control\" name=\"isoSymbol\" id=\"field_isoSymbol\" ng-model=\"vm.country.isoSymbol\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.country.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.country.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/country-phone-code/country-phone-code-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.countryPhoneCode.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.countryPhoneCode.delete.question\" translate-values=\"{id: \'{{vm.countryPhoneCode.id}}\'}\">Are you sure you want to delete this Country Phone Code?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/country-phone-code/country-phone-code-detail.html","<div><h2><span translate=\"sigmasfApp.countryPhoneCode.detail.title\">Country Phone Code</span> {{vm.countryPhoneCode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.countryPhoneCode.description\">Description</span></dt><dd><span>{{vm.countryPhoneCode.description}}</span></dd><dt><span translate=\"sigmasfApp.countryPhoneCode.code\">Code</span></dt><dd><span>{{vm.countryPhoneCode.code}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/country-phone-code/country-phone-code-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCountryPhoneCodeLabel\" translate=\"sigmasfApp.countryPhoneCode.home.createOrEditLabel\">Create or edit a Country Phone Code</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.countryPhoneCode.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.countryPhoneCode.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.countryPhoneCode.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.countryPhoneCode.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.countryPhoneCode.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.countryPhoneCode.code\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/country-phone-code/country-phone-codes.html","<div><h2 translate=\"sigmasfApp.countryPhoneCode.home.title\">Country Phone Codes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"country-phone-code.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.countryPhoneCode.home.createLabel\">Create new Country Phone Code</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.countryPhoneCode.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.countryPhoneCode.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"countryPhoneCode in vm.countryPhoneCodes track by countryPhoneCode.id\"><td><a ui-sref=\"country-phone-code-detail({id:countryPhoneCode.id})\">{{countryPhoneCode.id}}</a></td><td>{{countryPhoneCode.description}}</td><td>{{countryPhoneCode.code}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"country-phone-code-detail({id:countryPhoneCode.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"country-phone-code.edit({id:countryPhoneCode.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"country-phone-code.delete({id:countryPhoneCode.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-category/customer-categories.html","<div><h2 translate=\"sigmasfApp.customerCategory.home.title\">Customer Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.customerCategory.home.createLabel\">Create new Customer Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.customerCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.customerCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"circleDaysNo\"><span translate=\"sigmasfApp.customerCategory.circleDaysNo\">Circle Days No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.customerCategory.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerCategory in vm.customerCategories track by customerCategory.id\"><td><a ui-sref=\"customer-category-detail({id:customerCategory.id})\">{{customerCategory.id}}</a></td><td>{{customerCategory.name}}</td><td>{{customerCategory.circleDaysNo}}</td><td>{{customerCategory.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-category-detail({id:customerCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-category.edit({id:customerCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-category.delete({id:customerCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-category/customer-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.customerCategory.delete.question\" translate-values=\"{id: \'{{vm.customerCategory.id}}\'}\">Are you sure you want to delete this Customer Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-category/customer-category-detail.html","<div><h2><span translate=\"sigmasfApp.customerCategory.detail.title\">Customer Category</span> {{vm.customerCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.customerCategory.name\">Name</span></dt><dd><span>{{vm.customerCategory.name}}</span></dd><dt><span translate=\"sigmasfApp.customerCategory.circleDaysNo\">Circle Days No</span></dt><dd><span>{{vm.customerCategory.circleDaysNo}}</span></dd><dt><span translate=\"sigmasfApp.customerCategory.nameEn\">Name En</span></dt><dd><span>{{vm.customerCategory.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-category/customer-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerCategoryLabel\" translate=\"sigmasfApp.customerCategory.home.createOrEditLabel\">Create or edit a Customer Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.customerCategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerCategory.circleDaysNo\" for=\"field_circleDaysNo\">Circle Days No</label><input type=\"number\" class=\"form-control\" name=\"circleDaysNo\" id=\"field_circleDaysNo\" ng-model=\"vm.customerCategory.circleDaysNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerCategory.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.customerCategory.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-sub-category/customer-sub-categories.html","<div><h2 translate=\"sigmasfApp.customerSubCategory.home.title\">Customer Sub Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-sub-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.customerSubCategory.home.createLabel\">Create new Customer Sub Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.customerSubCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.customerSubCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.customerSubCategory.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerSubCategory in vm.customerSubCategories track by customerSubCategory.id\"><td><a ui-sref=\"customer-sub-category-detail({id:customerSubCategory.id})\">{{customerSubCategory.id}}</a></td><td>{{customerSubCategory.name}}</td><td>{{customerSubCategory.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-sub-category-detail({id:customerSubCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-sub-category.edit({id:customerSubCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-sub-category.delete({id:customerSubCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-sub-category/customer-sub-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerSubCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.customerSubCategory.delete.question\" translate-values=\"{id: \'{{vm.customerSubCategory.id}}\'}\">Are you sure you want to delete this Customer Sub Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-sub-category/customer-sub-category-detail.html","<div><h2><span translate=\"sigmasfApp.customerSubCategory.detail.title\">Customer Sub Category</span> {{vm.customerSubCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.customerSubCategory.name\">Name</span></dt><dd><span>{{vm.customerSubCategory.name}}</span></dd><dt><span translate=\"sigmasfApp.customerSubCategory.nameEn\">Name En</span></dt><dd><span>{{vm.customerSubCategory.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-sub-category/customer-sub-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerSubCategoryLabel\" translate=\"sigmasfApp.customerSubCategory.home.createOrEditLabel\">Create or edit a Customer Sub Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerSubCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerSubCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSubCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.customerSubCategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSubCategory.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.customerSubCategory.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-type/customer-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.customerType.delete.question\" translate-values=\"{id: \'{{vm.customerType.id}}\'}\">Are you sure you want to delete this Customer Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-type/customer-type-detail.html","<div><h2><span translate=\"sigmasfApp.customerType.detail.title\">Customer Type</span> {{vm.customerType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.customerType.name\">Name</span></dt><dd><span>{{vm.customerType.name}}</span></dd><dt><span translate=\"sigmasfApp.customerType.nameEn\">Name En</span></dt><dd><span>{{vm.customerType.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-type/customer-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerTypeLabel\" translate=\"sigmasfApp.customerType.home.createOrEditLabel\">Create or edit a Customer Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.customerType.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerType.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.customerType.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-type/customer-types.html","<div><h2 translate=\"sigmasfApp.customerType.home.title\">Customer Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.customerType.home.createLabel\">Create new Customer Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.customerType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.customerType.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerType in vm.customerTypes track by customerType.id\"><td><a ui-sref=\"customer-type-detail({id:customerType.id})\">{{customerType.id}}</a></td><td>{{customerType.name}}</td><td>{{customerType.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-type-detail({id:customerType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-type.edit({id:customerType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-type.delete({id:customerType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-sector/customer-sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerSector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"sigmasfApp.customerSector.delete.question\" translate-values=\"{id: \'{{vm.customerSector.id}}\'}\">Are you sure you want to delete this Customer Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-sector/customer-sector-detail.html","<div><h2><span data-translate=\"sigmasfApp.customerSector.detail.title\">Customer Sector</span> {{vm.customerSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"sigmasfApp.customerSector.startedAt\">Started At</span></dt><dd><span>{{vm.customerSector.startedAt | date:\'mediumDate\'}}</span></dd><dt><span data-translate=\"sigmasfApp.customerSector.endedAt\">Ended At</span></dt><dd><span>{{vm.customerSector.endedAt | date:\'mediumDate\'}}</span></dd><dt><span data-translate=\"sigmasfApp.customerSector.phone\">Phone</span></dt><dd><span>{{vm.customerSector.phone}}</span></dd><dt><span data-translate=\"sigmasfApp.customerSector.main\">Main</span></dt><dd><span>{{vm.customerSector.main}}</span></dd><dt><span translate=\"sigmasfApp.customerSector.monday\">Monday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.customerSector.monday}}\">{{vm.customerSector.monday}}</span></dd><dt><span translate=\"sigmasfApp.customerSector.tuesday\">Tuesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.customerSector.tuesday}}\">{{vm.customerSector.tuesday}}</span></dd><dt><span translate=\"sigmasfApp.customerSector.wednesday\">Wednesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.customerSector.wednesday}}\">{{vm.customerSector.wednesday}}</span></dd><dt><span translate=\"sigmasfApp.customerSector.thursday\">Thursday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.customerSector.thursday}}\">{{vm.customerSector.thursday}}</span></dd><dt><span translate=\"sigmasfApp.customerSector.friday\">Friday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.customerSector.friday}}\">{{vm.customerSector.friday}}</span></dd><dt><span data-translate=\"sigmasfApp.customerSector.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.customerSector.customer.id})\">{{vm.customerSector.customer.id}}</a></dd><dt><span data-translate=\"sigmasfApp.customerSector.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.customerSector.sector.id})\">{{vm.customerSector.sector.id}}</a></dd><dt><span data-translate=\"sigmasfApp.customerSector.sectorPosition\">Sector Position</span></dt><dd><a ui-sref=\"sector-position-detail({id:vm.customerSector.sectorPosition.id})\">{{vm.customerSector.sectorPosition.name}}</a></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"customer-sector-detail.edit({id:vm.customerSector.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/customer-sector/customer-sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerSectorLabel\" data-translate=\"sigmasfApp.customerSector.home.createOrEditLabel\">Create or edit a Customer Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerSector.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerSector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sigmasfApp.customerSector.startedAt\" for=\"field_startedAt\">Started At</label><div class=\"input-group\"><input id=\"field_startedAt\" type=\"text\" class=\"form-control\" name=\"startedAt\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.customerSector.startedAt\" is-open=\"vm.datePickerOpenStatus.startedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sigmasfApp.customerSector.endedAt\" for=\"field_endedAt\">Ended At</label><div class=\"input-group\"><input id=\"field_endedAt\" type=\"text\" class=\"form-control\" name=\"endedAt\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.customerSector.endedAt\" is-open=\"vm.datePickerOpenStatus.endedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sigmasfApp.customerSector.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.customerSector.phone\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sigmasfApp.customerSector.main\" for=\"field_main\">Main</label><input type=\"checkbox\" name=\"main\" id=\"field_main\" ng-model=\"vm.customerSector.main\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSector.monday\" for=\"field_monday\">Monday</label><select class=\"form-control\" name=\"monday\" ng-model=\"vm.customerSector.monday\" id=\"field_monday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSector.tuesday\" for=\"field_tuesday\">Tuesday</label><select class=\"form-control\" name=\"tuesday\" ng-model=\"vm.customerSector.tuesday\" id=\"field_tuesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSector.wednesday\" for=\"field_wednesday\">Wednesday</label><select class=\"form-control\" name=\"wednesday\" ng-model=\"vm.customerSector.wednesday\" id=\"field_wednesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSector.thursday\" for=\"field_thursday\">Thursday</label><select class=\"form-control\" name=\"thursday\" ng-model=\"vm.customerSector.thursday\" id=\"field_thursday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerSector.friday\" for=\"field_friday\">Friday</label><select class=\"form-control\" name=\"friday\" ng-model=\"vm.customerSector.friday\" id=\"field_friday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label data-translate=\"sigmasfApp.customerSector.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.customerSector.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label data-translate=\"sigmasfApp.customerSector.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.customerSector.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label data-translate=\"sigmasfApp.customerSector.sectorPosition\" for=\"field_sectorPosition\">Sector Position</label><select class=\"form-control\" id=\"field_sectorPosition\" name=\"sectorPosition\" ng-model=\"vm.customerSector.sectorPosition\" ng-options=\"sectorPosition as sectorPosition.name for sectorPosition in vm.sectorpositions track by sectorPosition.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-sector/customer-sectors.html","<div><h2 data-translate=\"sigmasfApp.customerSector.home.title\">Customer Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"sigmasfApp.customerSector.home.createLabel\">Create new Customer Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedAt\"><span data-translate=\"sigmasfApp.customerSector.startedAt\">Started At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endedAt\"><span data-translate=\"sigmasfApp.customerSector.endedAt\">Ended At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span data-translate=\"sigmasfApp.customerSector.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"main\"><span data-translate=\"sigmasfApp.customerSector.main\">Main</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"monday\"><span translate=\"sigmasfApp.customerSector.monday\">Monday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tuesday\"><span translate=\"sigmasfApp.customerSector.tuesday\">Tuesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wednesday\"><span translate=\"sigmasfApp.customerSector.wednesday\">Wednesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"thursday\"><span translate=\"sigmasfApp.customerSector.thursday\">Thursday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"friday\"><span translate=\"sigmasfApp.customerSector.friday\">Friday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span data-translate=\"sigmasfApp.customerSector.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span data-translate=\"sigmasfApp.customerSector.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorPosition.name\"><span data-translate=\"sigmasfApp.customerSector.sectorPosition\">Sector Position</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerSector in vm.customerSectors track by customerSector.id\"><td><a ui-sref=\"customer-sector-detail({id:customerSector.id})\">{{customerSector.id}}</a></td><td>{{customerSector.startedAt | date:\'mediumDate\'}}</td><td>{{customerSector.endedAt | date:\'mediumDate\'}}</td><td>{{customerSector.phone}}</td><td>{{customerSector.main}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + customerSector.monday}}\">{{customerSector.monday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + customerSector.tuesday}}\">{{customerSector.tuesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + customerSector.wednesday}}\">{{customerSector.wednesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + customerSector.thursday}}\">{{customerSector.thursday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + customerSector.friday}}\">{{customerSector.friday}}</td><td><a ui-sref=\"customer-detail({id:customerSector.customer.id})\">{{customerSector.customer.id}}</a></td><td><a ui-sref=\"sector-detail({id:customerSector.sector.id})\">{{customerSector.sector.id}}</a></td><td><a ui-sref=\"sector-position-detail({id:customerSector.sectorPosition.id})\">{{customerSector.sectorPosition.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-sector-detail({id:customerSector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-sector.edit({id:customerSector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-sector.delete({id:customerSector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-title/customer-title-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerTitle.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.customerTitle.delete.question\" translate-values=\"{id: \'{{vm.customerTitle.id}}\'}\">Are you sure you want to delete this Customer Title?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-title/customer-title-detail.html","<div><h2><span translate=\"sigmasfApp.customerTitle.detail.title\">Customer Title</span> {{vm.customerTitle.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.customerTitle.name\">Name</span></dt><dd><span>{{vm.customerTitle.name}}</span></dd><dt><span translate=\"sigmasfApp.customerTitle.nameEn\">Name En</span></dt><dd><span>{{vm.customerTitle.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-title/customer-title-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerTitleLabel\" translate=\"sigmasfApp.customerTitle.home.createOrEditLabel\">Create or edit a Customer Title</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerTitle.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerTitle.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerTitle.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.customerTitle.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.customerTitle.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.customerTitle.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-title/customer-titles.html","<div><h2 translate=\"sigmasfApp.customerTitle.home.title\">Customer Titles</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-title.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.customerTitle.home.createLabel\">Create new Customer Title</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.customerTitle.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.customerTitle.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.customerTitle.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerTitle in vm.customerTitles track by customerTitle.id\"><td><a ui-sref=\"customer-title-detail({id:customerTitle.id})\">{{customerTitle.id}}</a></td><td>{{customerTitle.name}}</td><td>{{customerTitle.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-title-detail({id:customerTitle.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-title.edit({id:customerTitle.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-title.delete({id:customerTitle.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/discount-rate/discount-rate-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.discountRate.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.discountRate.delete.question\" translate-values=\"{id: \'{{vm.discountRate.id}}\'}\">Are you sure you want to delete this Discount Rate?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/discount-rate/discount-rate-detail.html","<div><h2><span translate=\"sigmasfApp.discountRate.detail.title\">Discount Rate</span> {{vm.discountRate.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.discountRate.name\">Name</span></dt><dd><span>{{vm.discountRate.name}}</span></dd><dt><span translate=\"sigmasfApp.discountRate.value\">Value</span></dt><dd><span>{{vm.discountRate.value}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/discount-rate/discount-rate-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDiscountRateLabel\" translate=\"sigmasfApp.discountRate.home.createOrEditLabel\">Create or edit a Discount Rate</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.discountRate.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.discountRate.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.discountRate.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.discountRate.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.discountRate.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.discountRate.value\" max=\"100\"><div ng-show=\"editForm.value.$invalid\"><p class=\"help-block\" ng-show=\"editForm.value.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"100\">This field cannot be more than 100.</p><p class=\"help-block\" ng-show=\"editForm.value.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/discount-rate/discount-rates.html","<div><h2 translate=\"sigmasfApp.discountRate.home.title\">Discount Rates</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"discount-rate.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.discountRate.home.createLabel\">Create new Discount Rate</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.discountRate.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sigmasfApp.discountRate.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"discountRate in vm.discountRates track by discountRate.id\"><td><a ui-sref=\"discount-rate-detail({id:discountRate.id})\">{{discountRate.id}}</a></td><td>{{discountRate.name}}</td><td>{{discountRate.value}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"discount-rate-detail({id:discountRate.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"discount-rate.edit({id:discountRate.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"discount-rate.delete({id:discountRate.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/discount-reason/discount-reason-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.discountReason.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.discountReason.delete.question\" translate-values=\"{id: \'{{vm.discountReason.id}}\'}\">Are you sure you want to delete this Discount Reason?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/discount-reason/discount-reason-detail.html","<div><h2><span translate=\"sigmasfApp.discountReason.detail.title\">Discount Reason</span> {{vm.discountReason.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.discountReason.name\">Name</span></dt><dd><span>{{vm.discountReason.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/discount-reason/discount-reason-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDiscountReasonLabel\" translate=\"sigmasfApp.discountReason.home.createOrEditLabel\">Create or edit a Discount Reason</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.discountReason.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.discountReason.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.discountReason.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.discountReason.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/discount-reason/discount-reasons.html","<div><h2 translate=\"sigmasfApp.discountReason.home.title\">Discount Reasons</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"discount-reason.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.discountReason.home.createLabel\">Create new Discount Reason</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.discountReason.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"discountReason in vm.discountReasons track by discountReason.id\"><td><a ui-sref=\"discount-reason-detail({id:discountReason.id})\">{{discountReason.id}}</a></td><td>{{discountReason.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"discount-reason-detail({id:discountReason.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"discount-reason.edit({id:discountReason.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"discount-reason.delete({id:discountReason.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/disease-type/disease-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.diseaseType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.diseaseType.delete.question\" translate-values=\"{id: \'{{vm.diseaseType.id}}\'}\">Are you sure you want to delete this Disease Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/disease-type/disease-type-detail.html","<div><h2><span translate=\"sigmasfApp.diseaseType.detail.title\">Disease Type</span> {{vm.diseaseType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.diseaseType.name\">Name</span></dt><dd><span>{{vm.diseaseType.name}}</span></dd><dt><span translate=\"sigmasfApp.diseaseType.advantages\">Advantages</span></dt><dd><span>{{vm.diseaseType.advantages}}</span></dd><dt><span translate=\"sigmasfApp.diseaseType.offer\">Offer</span></dt><dd><span>{{vm.diseaseType.offer}}</span></dd><dt><span translate=\"sigmasfApp.diseaseType.documents\">Documents</span></dt><dd><span>{{vm.diseaseType.documents}}</span></dd><dt><span translate=\"sigmasfApp.diseaseType.sortOrder\">Sort Order</span></dt><dd><span>{{vm.diseaseType.sortOrder}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/disease-type/disease-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDiseaseTypeLabel\" translate=\"sigmasfApp.diseaseType.home.createOrEditLabel\">Create or edit a Disease Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.diseaseType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.diseaseType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.diseaseType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.diseaseType.name\" ng-maxlength=\"150\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.diseaseType.advantages\" for=\"field_advantages\">Advantages</label><input type=\"text\" class=\"form-control\" name=\"advantages\" id=\"field_advantages\" ng-model=\"vm.diseaseType.advantages\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.diseaseType.offer\" for=\"field_offer\">Offer</label><input type=\"text\" class=\"form-control\" name=\"offer\" id=\"field_offer\" ng-model=\"vm.diseaseType.offer\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.diseaseType.documents\" for=\"field_documents\">Documents</label><input type=\"text\" class=\"form-control\" name=\"documents\" id=\"field_documents\" ng-model=\"vm.diseaseType.documents\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.diseaseType.sortOrder\" for=\"field_sortOrder\">Sort Order</label><input type=\"number\" class=\"form-control\" name=\"sortOrder\" id=\"field_sortOrder\" ng-model=\"vm.diseaseType.sortOrder\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/disease-type/disease-types.html","<div><h2 translate=\"sigmasfApp.diseaseType.home.title\">Disease Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"disease-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.diseaseType.home.createLabel\">Create new Disease Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.diseaseType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"advantages\"><span translate=\"sigmasfApp.diseaseType.advantages\">Advantages</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"offer\"><span translate=\"sigmasfApp.diseaseType.offer\">Offer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"documents\"><span translate=\"sigmasfApp.diseaseType.documents\">Documents</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sortOrder\"><span translate=\"sigmasfApp.diseaseType.sortOrder\">Sort Order</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"diseaseType in vm.diseaseTypes track by diseaseType.id\"><td><a ui-sref=\"disease-type-detail({id:diseaseType.id})\">{{diseaseType.id}}</a></td><td>{{diseaseType.name}}</td><td>{{diseaseType.advantages}}</td><td>{{diseaseType.offer}}</td><td>{{diseaseType.documents}}</td><td>{{diseaseType.sortOrder}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"disease-type-detail({id:diseaseType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"disease-type.edit({id:diseaseType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"disease-type.delete({id:diseaseType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/disease/disease-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.disease.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.disease.delete.question\" translate-values=\"{id: \'{{vm.disease.id}}\'}\">Are you sure you want to delete this Disease?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/disease/disease-detail.html","<div><h2><span translate=\"sigmasfApp.disease.detail.title\">Disease</span> {{vm.disease.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.disease.name\">Name</span></dt><dd><span>{{vm.disease.name}}</span></dd><dt><span translate=\"sigmasfApp.disease.diseaseType\">Disease Type</span></dt><dd><a ui-sref=\"disease-type-detail({id:vm.disease.diseaseType.id})\">{{vm.disease.diseaseType.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/disease/disease-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDiseaseLabel\" translate=\"sigmasfApp.disease.home.createOrEditLabel\">Create or edit a Disease</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.disease.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.disease.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.disease.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.disease.name\" ng-maxlength=\"150\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</p></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.disease.diseaseType\" for=\"field_diseaseType\">Disease Type</label><select class=\"form-control\" id=\"field_diseaseType\" name=\"diseaseType\" ng-model=\"vm.disease.diseaseType\" ng-options=\"diseaseType as diseaseType.name for diseaseType in vm.diseasetypes track by diseaseType.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/disease/diseases.html","<div><h2 translate=\"sigmasfApp.disease.home.title\">Diseases</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"disease.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.disease.home.createLabel\">Create new Disease</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.disease.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"diseaseType.name\"><span translate=\"sigmasfApp.disease.diseaseType\">Disease Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"disease in vm.diseases track by disease.id\"><td><a ui-sref=\"disease-detail({id:disease.id})\">{{disease.id}}</a></td><td>{{disease.name}}</td><td><a ui-sref=\"disease-type-detail({id:disease.diseaseType.id})\">{{disease.diseaseType.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"disease-detail({id:disease.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"disease.edit({id:disease.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"disease.delete({id:disease.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/doctor-specialty/doctor-specialties.html","<div><h2 translate=\"sigmasfApp.doctorSpecialty.home.title\">Doctor Specialties</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"doctor-specialty.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.doctorSpecialty.home.createLabel\">Create new Doctor Specialty</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.doctorSpecialty.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.doctorSpecialty.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.doctorSpecialty.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"doctorSpecialty in vm.doctorSpecialties track by doctorSpecialty.id\"><td><a ui-sref=\"doctor-specialty-detail({id:doctorSpecialty.id})\">{{doctorSpecialty.id}}</a></td><td>{{doctorSpecialty.name}}</td><td>{{doctorSpecialty.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"doctor-specialty-detail({id:doctorSpecialty.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"doctor-specialty.edit({id:doctorSpecialty.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"doctor-specialty.delete({id:doctorSpecialty.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/doctor-specialty/doctor-specialty-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.doctorSpecialty.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.doctorSpecialty.delete.question\" translate-values=\"{id: \'{{vm.doctorSpecialty.id}}\'}\">Are you sure you want to delete this Doctor Specialty?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/doctor-specialty/doctor-specialty-detail.html","<div><h2><span translate=\"sigmasfApp.doctorSpecialty.detail.title\">Doctor Specialty</span> {{vm.doctorSpecialty.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.doctorSpecialty.name\">Name</span></dt><dd><span>{{vm.doctorSpecialty.name}}</span></dd><dt><span translate=\"sigmasfApp.doctorSpecialty.nameEn\">Name En</span></dt><dd><span>{{vm.doctorSpecialty.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/doctor-specialty/doctor-specialty-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDoctorSpecialtyLabel\" translate=\"sigmasfApp.doctorSpecialty.home.createOrEditLabel\">Create or edit a Doctor Specialty</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.doctorSpecialty.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.doctorSpecialty.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.doctorSpecialty.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.doctorSpecialty.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.doctorSpecialty.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.doctorSpecialty.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/employee-customer-sector/employee-customer-sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.employeeCustomerSector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.employeeCustomerSector.delete.question\" translate-values=\"{id: \'{{vm.employeeCustomerSector.id}}\'}\">Are you sure you want to delete this Employee Customer Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/employee-customer-sector/employee-customer-sector-detail.html","<div><h2><span translate=\"sigmasfApp.employeeCustomerSector.detail.title\">Employee Customer Sector</span> {{vm.employeeCustomerSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.employeeCustomerSector.active\">Active</span></dt><dd><span>{{vm.employeeCustomerSector.active}}</span></dd><dt><span translate=\"sigmasfApp.employeeCustomerSector.myTarget\">My Target</span></dt><dd><span>{{vm.employeeCustomerSector.myTarget}}</span></dd><dt><span translate=\"sigmasfApp.employeeCustomerSector.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.employeeCustomerSector.employee.id})\">{{vm.employeeCustomerSector.employee.id}}</a></dd><dt><span translate=\"sigmasfApp.employeeCustomerSector.customerSector\">Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.employeeCustomerSector.customerSector.id})\">{{vm.employeeCustomerSector.customerSector.id}}</a></dd><dt><span translate=\"sigmasfApp.employeeCustomerSector.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.employeeCustomerSector.sector.id})\">{{vm.employeeCustomerSector.sector.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/employee-customer-sector/employee-customer-sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEmployeeCustomerSectorLabel\" translate=\"sigmasfApp.employeeCustomerSector.home.createOrEditLabel\">Create or edit a Employee Customer Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.employeeCustomerSector.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.employeeCustomerSector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employeeCustomerSector.active\" for=\"field_active\">Active</label><input type=\"checkbox\" class=\"form-control\" name=\"active\" id=\"field_active\" ng-model=\"vm.employeeCustomerSector.active\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employeeCustomerSector.myTarget\" for=\"field_myTarget\">My Target</label><input type=\"checkbox\" class=\"form-control\" name=\"myTarget\" id=\"field_myTarget\" ng-model=\"vm.employeeCustomerSector.myTarget\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.employeeCustomerSector.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.employeeCustomerSector.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.employeeCustomerSector.customerSector\" for=\"field_customerSector\">Customer Sector</label><select class=\"form-control\" id=\"field_customerSector\" name=\"customerSector\" ng-model=\"vm.employeeCustomerSector.customerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.customersectors track by customerSector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.employeeCustomerSector.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.employeeCustomerSector.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/employee-customer-sector/employee-customer-sectors.html","<div><h2 translate=\"sigmasfApp.employeeCustomerSector.home.title\">Employee Customer Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"employee-customer-sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.employeeCustomerSector.home.createLabel\">Create new Employee Customer Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"active\"><span translate=\"sigmasfApp.employeeCustomerSector.active\">Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"myTarget\"><span translate=\"sigmasfApp.employeeCustomerSector.myTarget\">My Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.employeeCustomerSector.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSector.id\"><span translate=\"sigmasfApp.employeeCustomerSector.customerSector\">Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.employeeCustomerSector.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"employeeCustomerSector in vm.employeeCustomerSectors track by employeeCustomerSector.id\"><td><a ui-sref=\"employee-customer-sector-detail({id:employeeCustomerSector.id})\">{{employeeCustomerSector.id}}</a></td><td>{{employeeCustomerSector.active}}</td><td>{{employeeCustomerSector.myTarget}}</td><td><a ui-sref=\"employee-detail({id:employeeCustomerSector.employee.id})\">{{employeeCustomerSector.employee.id}}</a></td><td><a ui-sref=\"customer-sector-detail({id:employeeCustomerSector.customerSector.id})\">{{employeeCustomerSector.customerSector.id}}</a></td><td><a ui-sref=\"sector-detail({id:employeeCustomerSector.sector.id})\">{{employeeCustomerSector.sector.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"employee-customer-sector-detail({id:employeeCustomerSector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"employee-customer-sector.edit({id:employeeCustomerSector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"employee-customer-sector.delete({id:employeeCustomerSector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/employee/employee-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.employee.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.employee.delete.question\" translate-values=\"{id: \'{{vm.employee.id}}\'}\">Are you sure you want to delete this Employee?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/employee/employee-detail.html","<div><h2><span translate=\"sigmasfApp.employee.detail.title\">Employee</span> {{vm.employee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.employee.phone\">Phone</span></dt><dd><span>{{vm.employee.phone}}</span></dd><dt><span translate=\"sigmasfApp.employee.mobileVersion\">Mobile Version</span></dt><dd><span>{{vm.employee.mobileVersion}}</span></dd><dt><span translate=\"sigmasfApp.employee.district\">District</span></dt><dd><span translate=\"{{\'sigmasfApp.DistrictEnum.\' + vm.employee.district}}\">{{vm.employee.district}}</span></dd><dt><span translate=\"sigmasfApp.employee.pin\">Pin</span></dt><dd><span>{{vm.employee.pin}}</span></dd><dt><span translate=\"sigmasfApp.employee.geodata\">Geodata</span></dt><dd><span>{{vm.employee.geodata}}</span></dd><dt><span translate=\"sigmasfApp.employee.code\">Code</span></dt><dd><span>{{vm.employee.code}}</span></dd><dt><span translate=\"sigmasfApp.employee.osVersion\">OS Version</span></dt><dd><span>{{vm.employee.osVersion}}</span></dd><dt><span translate=\"sigmasfApp.employee.device\">Device</span></dt><dd><span>{{vm.employee.device}}</span></dd><dt><span translate=\"sigmasfApp.employee.account\">Account</span></dt><dd>{{vm.employee.account.login}}</dd><dt><span translate=\"sigmasfApp.employee.supervisor\">Supervisor</span></dt><dd><a ui-sref=\"employee-detail({id:vm.employee.supervisor.id})\">{{vm.employee.supervisor.id}}</a></dd><dt><span translate=\"sigmasfApp.employee.productCategory\">Product Category</span></dt><dd><span ng-repeat=\"productCategory in vm.employee.productCategories\"><a ui-sref=\"product-category-detail({id: {{productCategory.id}}})\">{{productCategory.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.employee.purchaseNumberingRow\">Purchase Numbering Row</span></dt><dd><span ng-repeat=\"purchaseNumberingRow in vm.employee.purchaseNumberingRows\"><a ui-sref=\"purchase-numbering-row-detail({id: {{purchaseNumberingRow.id}}})\">{{purchaseNumberingRow.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/employee/employee-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEmployeeLabel\" translate=\"sigmasfApp.employee.home.createOrEditLabel\">Create or edit a Employee</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.employee.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.employee.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.employee.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.mobileVersion\" for=\"field_mobileVersion\">Mobile Version</label><input type=\"text\" class=\"form-control\" name=\"mobileVersion\" id=\"field_mobileVersion\" ng-model=\"vm.employee.mobileVersion\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.district\" for=\"field_district\">District</label><select class=\"form-control\" name=\"district\" ng-model=\"vm.employee.district\" id=\"field_district\"><option value=\"north\" translate=\"sigmasfApp.DistrictEnum.north\">north</option><option value=\"south\" translate=\"sigmasfApp.DistrictEnum.south\">south</option><option value=\"westAndPeloponnese\" translate=\"sigmasfApp.DistrictEnum.westAndPeloponnese\">westAndPeloponnese</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.pin\" for=\"field_pin\">Pin</label><input type=\"text\" class=\"form-control\" name=\"pin\" id=\"field_pin\" ng-model=\"vm.employee.pin\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.geodata\" for=\"field_geodata\">Geodata</label><input type=\"checkbox\" class=\"form-control\" name=\"geodata\" id=\"field_geodata\" ng-model=\"vm.employee.geodata\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.employee.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.osVersion\" for=\"field_osVersion\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_osVersion\" ng-model=\"vm.employee.osVersion\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.employee.device\" for=\"field_device\">Device</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_device\" ng-model=\"vm.employee.device\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.employee.account\" for=\"field_account\">Account</label><select class=\"form-control\" id=\"field_account\" name=\"account\" ng-model=\"vm.employee.account\" ng-options=\"user as user.login for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.employee.supervisor\" for=\"field_supervisor\">Supervisor</label><select class=\"form-control\" id=\"field_supervisor\" name=\"supervisor\" ng-model=\"vm.employee.supervisor\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.employee.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" multiple=\"multiple\" name=\"productCategory\" ng-model=\"vm.employee.productCategories\" ng-options=\"productCategory as productCategory.id for productCategory in vm.productcategories track by productCategory.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.employee.purchaseNumberingRow\" for=\"field_purchaseNumberingRow\">Purchase Numbering Row</label><select class=\"form-control\" id=\"field_purchaseNumberingRow\" multiple=\"multiple\" name=\"purchaseNumberingRow\" ng-model=\"vm.employee.purchaseNumberingRows\" ng-options=\"purchaseNumberingRow as purchaseNumberingRow.id for purchaseNumberingRow in vm.purchasenumberingrows track by purchaseNumberingRow.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/employee/employees.html","<div><h2 translate=\"sigmasfApp.employee.home.title\">Employees</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"employee.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.employee.home.createLabel\">Create new Employee</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.employee.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mobileVersion\"><span translate=\"sigmasfApp.employee.mobileVersion\">Mobile Version</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"district\"><span translate=\"sigmasfApp.employee.district\">District</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pin\"><span translate=\"sigmasfApp.employee.pin\">Pin</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"geodata\"><span translate=\"sigmasfApp.employee.geodata\">Geodata</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.employee.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"account.login\"><span translate=\"sigmasfApp.employee.account\">Account</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"supervisor.id\"><span translate=\"sigmasfApp.employee.supervisor\">Supervisor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.employee.osVersion\">OS Version</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.employee.device\">Device</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"employee in vm.employees track by employee.id\"><td><a ui-sref=\"employee-detail({id:employee.id})\">{{employee.id}}</a></td><td>{{employee.phone}}</td><td>{{employee.mobileVersion}}</td><td translate=\"{{\'sigmasfApp.DistrictEnum.\' + employee.district}}\">{{employee.district}}</td><td>{{employee.pin}}</td><td>{{employee.geodata}}</td><td>{{employee.code}}</td><td>{{employee.account.login}}</td><td><a ui-sref=\"employee-detail({id:employee.supervisor.id})\">{{employee.supervisor.id}}</a></td><td>{{employee.osVersion}}</td><td>{{employee.device}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"employee-detail({id:employee.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"employee.edit({id:employee.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"employee.delete({id:employee.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event/event-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.event.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.event.delete.question\" translate-values=\"{id: \'{{vm.event.id}}\'}\">Are you sure you want to delete this Event?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event/event-detail.html","<div><h2><span translate=\"sigmasfApp.event.detail.title\">Event</span> {{vm.event.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.event.startedAt\">Started At</span></dt><dd><span>{{vm.event.startedAt | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.event.finishedAt\">Finished At</span></dt><dd><span>{{vm.event.finishedAt | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.event.title\">Title</span></dt><dd><span>{{vm.event.title}}</span></dd><dt><span translate=\"sigmasfApp.event.description\">Description</span></dt><dd><span>{{vm.event.description}}</span></dd><dt><span translate=\"sigmasfApp.event.eventStatus\">Event Status</span></dt><dd><a ui-sref=\"event-status-detail({id:vm.event.eventStatus.id})\">{{vm.event.eventStatus.name}}</a></dd><dt><span translate=\"sigmasfApp.event.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.event.employee.id})\">{{vm.event.employee.id}}</a></dd><dt><span translate=\"sigmasfApp.event.eventCategoryType\">Event Category Type</span></dt><dd><a ui-sref=\"event-category-type-detail({id:vm.event.eventCategoryType.id})\">{{vm.event.eventCategoryType.id}}</a></dd><dt><span translate=\"sigmasfApp.event.eventCustomerSector\">Event Customer Sector</span></dt><dd><a ui-sref=\"event-customer-sector-detail({id:vm.event.eventCustomerSector.id})\">{{vm.event.eventCustomerSector.id}}</a></dd><dt><span translate=\"sigmasfApp.event.eventSchedule\">Event Schedule</span></dt><dd><a ui-sref=\"event-schedule-detail({id:vm.event.eventSchedule.id})\">{{vm.event.eventSchedule.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event/event-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventLabel\" translate=\"sigmasfApp.event.home.createOrEditLabel\">Create or edit a Event</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.event.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.event.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.event.startedAt\" for=\"field_startedAt\">Started At</label><div class=\"input-group\"><input id=\"field_startedAt\" type=\"text\" class=\"form-control\" name=\"startedAt\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.event.startedAt\" is-open=\"vm.datePickerOpenStatus.startedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.event.finishedAt\" for=\"field_finishedAt\">Finished At</label><div class=\"input-group\"><input id=\"field_finishedAt\" type=\"text\" class=\"form-control\" name=\"finishedAt\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.event.finishedAt\" is-open=\"vm.datePickerOpenStatus.finishedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'finishedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.event.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.event.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.event.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.event.description\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.event.eventStatus\" for=\"field_eventStatus\">Event Status</label><select class=\"form-control\" id=\"field_eventStatus\" name=\"eventStatus\" ng-model=\"vm.event.eventStatus\" ng-options=\"eventStatus as eventStatus.name for eventStatus in vm.eventstatuses track by eventStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.event.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.event.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.event.eventCategoryType\" for=\"field_eventCategoryType\">Event Category Type</label><select class=\"form-control\" id=\"field_eventCategoryType\" name=\"eventCategoryType\" ng-model=\"vm.event.eventCategoryType\" ng-options=\"eventCategoryType as eventCategoryType.id for eventCategoryType in vm.eventcategorytypes track by eventCategoryType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.event.eventCustomerSector\" for=\"field_eventCustomerSector\">Event Customer Sector</label><select class=\"form-control\" id=\"field_eventCustomerSector\" name=\"eventCustomerSector\" ng-model=\"vm.event.eventCustomerSector\" ng-options=\"eventCustomerSector as eventCustomerSector.id for eventCustomerSector in vm.eventcustomersectors track by eventCustomerSector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.event.eventSchedule\" for=\"field_eventSchedule\">Event Schedule</label><select class=\"form-control\" id=\"field_eventSchedule\" name=\"eventSchedule\" ng-model=\"vm.event.eventSchedule\" ng-options=\"eventSchedule as eventSchedule.id for eventSchedule in vm.eventschedules track by eventSchedule.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event/events.html","<div><h2 translate=\"sigmasfApp.event.home.title\">Events</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.event.home.createLabel\">Create new Event</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.event.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedAt\"><span translate=\"sigmasfApp.event.startedAt\">Started At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finishedAt\"><span translate=\"sigmasfApp.event.finishedAt\">Finished At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"sigmasfApp.event.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.event.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventStatus.name\"><span translate=\"sigmasfApp.event.eventStatus\">Event Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.event.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventCategoryType.id\"><span translate=\"sigmasfApp.event.eventCategoryType\">Event Category Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventCustomerSector.id\"><span translate=\"sigmasfApp.event.eventCustomerSector\">Event Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventSchedule.id\"><span translate=\"sigmasfApp.event.eventSchedule\">Event Schedule</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"event in vm.events track by event.id\"><td><a ui-sref=\"event-detail({id:event.id})\">{{event.id}}</a></td><td>{{event.startedAt | date:\'medium\'}}</td><td>{{event.finishedAt | date:\'medium\'}}</td><td>{{event.title}}</td><td>{{event.description}}</td><td><a ui-sref=\"event-status-detail({id:event.eventStatus.id})\">{{event.eventStatus.name}}</a></td><td><a ui-sref=\"employee-detail({id:event.employee.id})\">{{event.employee.id}}</a></td><td><a ui-sref=\"event-category-type-detail({id:event.eventCategoryType.id})\">{{event.eventCategoryType.id}}</a></td><td><a ui-sref=\"event-customer-sector-detail({id:event.eventCustomerSector.id})\">{{event.eventCustomerSector.id}}</a></td><td><a ui-sref=\"event-schedule-detail({id:event.eventSchedule.id})\">{{event.eventSchedule.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-detail({id:event.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event.edit({id:event.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event.delete({id:event.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-category/event-categories.html","<div><h2 translate=\"sigmasfApp.eventCategory.home.title\">Event Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventCategory.home.createLabel\">Create new Event Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.eventCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.eventCategory.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventCategory in vm.eventCategories track by eventCategory.id\"><td><a ui-sref=\"event-category-detail({id:eventCategory.id})\">{{eventCategory.id}}</a></td><td>{{eventCategory.name}}</td><td>{{eventCategory.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-category-detail({id:eventCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-category.edit({id:eventCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-category.delete({id:eventCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-category/event-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventCategory.delete.question\" translate-values=\"{id: \'{{vm.eventCategory.id}}\'}\">Are you sure you want to delete this Event Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-category/event-category-detail.html","<div><h2><span translate=\"sigmasfApp.eventCategory.detail.title\">Event Category</span> {{vm.eventCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventCategory.name\">Name</span></dt><dd><span>{{vm.eventCategory.name}}</span></dd><dt><span translate=\"sigmasfApp.eventCategory.nameEn\">Name En</span></dt><dd><span>{{vm.eventCategory.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-category/event-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventCategoryLabel\" translate=\"sigmasfApp.eventCategory.home.createOrEditLabel\">Create or edit a Event Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.eventCategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventCategory.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.eventCategory.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-category-type/event-category-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventCategoryType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventCategoryType.delete.question\" translate-values=\"{id: \'{{vm.eventCategoryType.id}}\'}\">Are you sure you want to delete this Event Category Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-category-type/event-category-type-detail.html","<div><h2><span translate=\"sigmasfApp.eventCategoryType.detail.title\">Event Category Type</span> {{vm.eventCategoryType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventCategoryType.eventCategory\">Event Category</span></dt><dd><a ui-sref=\"event-category-detail({id:vm.eventCategoryType.eventCategory.id})\">{{vm.eventCategoryType.eventCategory.name}}</a></dd><dt><span translate=\"sigmasfApp.eventCategoryType.eventType\">Event Type</span></dt><dd><a ui-sref=\"event-type-detail({id:vm.eventCategoryType.eventType.id})\">{{vm.eventCategoryType.eventType.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-category-type/event-category-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventCategoryTypeLabel\" translate=\"sigmasfApp.eventCategoryType.home.createOrEditLabel\">Create or edit a Event Category Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventCategoryType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventCategoryType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCategoryType.eventCategory\" for=\"field_eventCategory\">Event Category</label><select class=\"form-control\" id=\"field_eventCategory\" name=\"eventCategory\" ng-model=\"vm.eventCategoryType.eventCategory\" ng-options=\"eventCategory as eventCategory.name for eventCategory in vm.eventcategories track by eventCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCategoryType.eventType\" for=\"field_eventType\">Event Type</label><select class=\"form-control\" id=\"field_eventType\" name=\"eventType\" ng-model=\"vm.eventCategoryType.eventType\" ng-options=\"eventType as eventType.name for eventType in vm.eventtypes track by eventType.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-category-type/event-category-types.html","<div><h2 translate=\"sigmasfApp.eventCategoryType.home.title\">Event Category Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-category-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventCategoryType.home.createLabel\">Create new Event Category Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventCategoryType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventCategory.name\"><span translate=\"sigmasfApp.eventCategoryType.eventCategory\">Event Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventType.name\"><span translate=\"sigmasfApp.eventCategoryType.eventType\">Event Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventCategoryType in vm.eventCategoryTypes track by eventCategoryType.id\"><td><a ui-sref=\"event-category-type-detail({id:eventCategoryType.id})\">{{eventCategoryType.id}}</a></td><td><a ui-sref=\"event-category-detail({id:eventCategoryType.eventCategory.id})\">{{eventCategoryType.eventCategory.name}}</a></td><td><a ui-sref=\"event-type-detail({id:eventCategoryType.eventType.id})\">{{eventCategoryType.eventType.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-category-type-detail({id:eventCategoryType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-category-type.edit({id:eventCategoryType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-category-type.delete({id:eventCategoryType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-customer-sector/event-customer-sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventCustomerSector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventCustomerSector.delete.question\" translate-values=\"{id: \'{{vm.eventCustomerSector.id}}\'}\">Are you sure you want to delete this Event Customer Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-customer-sector/event-customer-sector-detail.html","<div><h2><span translate=\"sigmasfApp.eventCustomerSector.detail.title\">Event Customer Sector</span> {{vm.eventCustomerSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventCustomerSector.latitude\">Latitude</span></dt><dd><span>{{vm.eventCustomerSector.latitude}}</span></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.longitude\">Longitude</span></dt><dd><span>{{vm.eventCustomerSector.longitude}}</span></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.agreedPercent\">Agreed Percent</span></dt><dd><span>{{vm.eventCustomerSector.agreedPercent}}</span></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.communicationType\">Communication Type</span></dt><dd><a ui-sref=\"communication-type-detail({id:vm.eventCustomerSector.communicationType.id})\">{{vm.eventCustomerSector.communicationType.name}}</a></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.customerSector\">Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.eventCustomerSector.customerSector.id})\">{{vm.eventCustomerSector.customerSector.id}}</a></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.agreementValuation\">Agreement Valuation</span></dt><dd><a ui-sref=\"agreement-valuation-detail({id:vm.eventCustomerSector.agreementValuation.id})\">{{vm.eventCustomerSector.agreementValuation.name}}</a></dd><dt><span translate=\"sigmasfApp.eventCustomerSector.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.eventCustomerSector.sector.id})\">{{vm.eventCustomerSector.sector.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-customer-sector/event-customer-sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventCustomerSectorLabel\" translate=\"sigmasfApp.eventCustomerSector.home.createOrEditLabel\">Create or edit a Event Customer Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventCustomerSector.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventCustomerSector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventCustomerSector.latitude\" for=\"field_latitude\">Latitude</label><input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.eventCustomerSector.latitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventCustomerSector.longitude\" for=\"field_longitude\">Longitude</label><input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.eventCustomerSector.longitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventCustomerSector.agreedPercent\" for=\"field_agreedPercent\">Agreed Percent</label><input type=\"number\" class=\"form-control\" name=\"agreedPercent\" id=\"field_agreedPercent\" ng-model=\"vm.eventCustomerSector.agreedPercent\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCustomerSector.communicationType\" for=\"field_communicationType\">Communication Type</label><select class=\"form-control\" id=\"field_communicationType\" name=\"communicationType\" ng-model=\"vm.eventCustomerSector.communicationType\" ng-options=\"communicationType as communicationType.name for communicationType in vm.communicationtypes track by communicationType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCustomerSector.customerSector\" for=\"field_customerSector\">Customer Sector</label><select class=\"form-control\" id=\"field_customerSector\" name=\"customerSector\" ng-model=\"vm.eventCustomerSector.customerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.customersectors track by customerSector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCustomerSector.agreementValuation\" for=\"field_agreementValuation\">Agreement Valuation</label><select class=\"form-control\" id=\"field_agreementValuation\" name=\"agreementValuation\" ng-model=\"vm.eventCustomerSector.agreementValuation\" ng-options=\"agreementValuation as agreementValuation.name for agreementValuation in vm.agreementvaluations track by agreementValuation.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventCustomerSector.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.eventCustomerSector.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-customer-sector/event-customer-sectors.html","<div><h2 translate=\"sigmasfApp.eventCustomerSector.home.title\">Event Customer Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-customer-sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.eventCustomerSector.home.createLabel\">Create new Event Customer Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span translate=\"sigmasfApp.eventCustomerSector.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span translate=\"sigmasfApp.eventCustomerSector.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreedPercent\"><span translate=\"sigmasfApp.eventCustomerSector.agreedPercent\">Agreed Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"communicationType.name\"><span translate=\"sigmasfApp.eventCustomerSector.communicationType\">Communication Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSector.id\"><span translate=\"sigmasfApp.eventCustomerSector.customerSector\">Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreementValuation.name\"><span translate=\"sigmasfApp.eventCustomerSector.agreementValuation\">Agreement Valuation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.eventCustomerSector.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventCustomerSector in vm.eventCustomerSectors track by eventCustomerSector.id\"><td><a ui-sref=\"event-customer-sector-detail({id:eventCustomerSector.id})\">{{eventCustomerSector.id}}</a></td><td>{{eventCustomerSector.latitude}}</td><td>{{eventCustomerSector.longitude}}</td><td>{{eventCustomerSector.agreedPercent}}</td><td><a ui-sref=\"communication-type-detail({id:eventCustomerSector.communicationType.id})\">{{eventCustomerSector.communicationType.name}}</a></td><td><a ui-sref=\"customer-sector-detail({id:eventCustomerSector.customerSector.id})\">{{eventCustomerSector.customerSector.id}}</a></td><td><a ui-sref=\"agreement-valuation-detail({id:eventCustomerSector.agreementValuation.id})\">{{eventCustomerSector.agreementValuation.name}}</a></td><td><a ui-sref=\"sector-detail({id:eventCustomerSector.sector.id})\">{{eventCustomerSector.sector.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-customer-sector-detail({id:eventCustomerSector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-customer-sector.edit({id:eventCustomerSector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-customer-sector.delete({id:eventCustomerSector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-schedule/event-schedule-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventSchedule.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventSchedule.delete.question\" translate-values=\"{id: \'{{vm.eventSchedule.id}}\'}\">Are you sure you want to delete this Event Schedule?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-schedule/event-schedule-detail.html","<div><h2><span translate=\"sigmasfApp.eventSchedule.detail.title\">Event Schedule</span> {{vm.eventSchedule.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventSchedule.startedAt\">Started At</span></dt><dd><span>{{vm.eventSchedule.startedAt | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.eventSchedule.finishedAt\">Finished At</span></dt><dd><span>{{vm.eventSchedule.finishedAt | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.eventSchedule.reminder\">Reminder</span></dt><dd><span>{{vm.eventSchedule.reminder}}</span></dd><dt><span translate=\"sigmasfApp.eventSchedule.description\">Description</span></dt><dd><span>{{vm.eventSchedule.description}}</span></dd><dt><span translate=\"sigmasfApp.eventSchedule.scheduledBy\">Scheduled By</span></dt><dd><a ui-sref=\"employee-detail({id:vm.eventSchedule.scheduledBy.id})\">{{vm.eventSchedule.scheduledBy.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-schedule/event-schedule-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventScheduleLabel\" translate=\"sigmasfApp.eventSchedule.home.createOrEditLabel\">Create or edit a Event Schedule</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventSchedule.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventSchedule.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventSchedule.startedAt\" for=\"field_startedAt\">Started At</label><div class=\"input-group\"><input id=\"field_startedAt\" type=\"text\" class=\"form-control\" name=\"startedAt\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.eventSchedule.startedAt\" is-open=\"vm.datePickerOpenStatus.startedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventSchedule.finishedAt\" for=\"field_finishedAt\">Finished At</label><div class=\"input-group\"><input id=\"field_finishedAt\" type=\"text\" class=\"form-control\" name=\"finishedAt\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.eventSchedule.finishedAt\" is-open=\"vm.datePickerOpenStatus.finishedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'finishedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventSchedule.reminder\" for=\"field_reminder\">Reminder</label><input type=\"number\" class=\"form-control\" name=\"reminder\" id=\"field_reminder\" ng-model=\"vm.eventSchedule.reminder\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventSchedule.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.eventSchedule.description\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventSchedule.scheduledBy\" for=\"field_scheduledBy\">Scheduled By</label><select class=\"form-control\" id=\"field_scheduledBy\" name=\"scheduledBy\" ng-model=\"vm.eventSchedule.scheduledBy\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-schedule/event-schedules.html","<div><h2 translate=\"sigmasfApp.eventSchedule.home.title\">Event Schedules</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-schedule.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventSchedule.home.createLabel\">Create new Event Schedule</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventSchedule.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedAt\"><span translate=\"sigmasfApp.eventSchedule.startedAt\">Started At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finishedAt\"><span translate=\"sigmasfApp.eventSchedule.finishedAt\">Finished At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reminder\"><span translate=\"sigmasfApp.eventSchedule.reminder\">Reminder</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.eventSchedule.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"scheduledBy.id\"><span translate=\"sigmasfApp.eventSchedule.scheduledBy\">Scheduled By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventSchedule in vm.eventSchedules track by eventSchedule.id\"><td><a ui-sref=\"event-schedule-detail({id:eventSchedule.id})\">{{eventSchedule.id}}</a></td><td>{{eventSchedule.startedAt | date:\'medium\'}}</td><td>{{eventSchedule.finishedAt | date:\'medium\'}}</td><td>{{eventSchedule.reminder}}</td><td>{{eventSchedule.description}}</td><td><a ui-sref=\"employee-detail({id:eventSchedule.scheduledBy.id})\">{{eventSchedule.scheduledBy.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-schedule-detail({id:eventSchedule.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-schedule.edit({id:eventSchedule.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-schedule.delete({id:eventSchedule.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-status/event-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventStatus.delete.question\" translate-values=\"{id: \'{{vm.eventStatus.id}}\'}\">Are you sure you want to delete this Event Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-status/event-status-detail.html","<div><h2><span translate=\"sigmasfApp.eventStatus.detail.title\">Event Status</span> {{vm.eventStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventStatus.name\">Name</span></dt><dd><span>{{vm.eventStatus.name}}</span></dd><dt><span translate=\"sigmasfApp.eventStatus.nameEn\">Name En</span></dt><dd><span>{{vm.eventStatus.nameEn}}</span></dd><dt><span translate=\"sigmasfApp.eventStatus.eventType\">Event Type</span></dt><dd><a ui-sref=\"event-type-detail({id:vm.eventStatus.eventType.id})\">{{vm.eventStatus.eventType.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-status/event-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventStatusLabel\" translate=\"sigmasfApp.eventStatus.home.createOrEditLabel\">Create or edit a Event Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.eventStatus.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventStatus.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.eventStatus.nameEn\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.eventStatus.eventType\" for=\"field_eventType\">Event Type</label><select class=\"form-control\" id=\"field_eventType\" name=\"eventType\" ng-model=\"vm.eventStatus.eventType\" ng-options=\"eventType as eventType.name for eventType in vm.eventtypes track by eventType.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-status/event-statuses.html","<div><h2 translate=\"sigmasfApp.eventStatus.home.title\">Event Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventStatus.home.createLabel\">Create new Event Status</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventStatus.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.eventStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.eventStatus.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventType.name\"><span translate=\"sigmasfApp.eventStatus.eventType\">Event Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventStatus in vm.eventStatuses track by eventStatus.id\"><td><a ui-sref=\"event-status-detail({id:eventStatus.id})\">{{eventStatus.id}}</a></td><td>{{eventStatus.name}}</td><td>{{eventStatus.nameEn}}</td><td><a ui-sref=\"event-type-detail({id:eventStatus.eventType.id})\">{{eventStatus.eventType.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-status-detail({id:eventStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-status.edit({id:eventStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-status.delete({id:eventStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-place/event-place-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventPlace.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventPlace.delete.question\" translate-values=\"{id: \'{{vm.eventPlace.id}}\'}\">Are you sure you want to delete this Event Place?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-place/event-place-detail.html","<div><h2><span translate=\"sigmasfApp.eventPlace.detail.title\">Event Place</span> {{vm.eventPlace.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventPlace.name\">Name</span></dt><dd><span>{{vm.eventPlace.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-place/event-place-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventPlaceLabel\" translate=\"sigmasfApp.eventPlace.home.createOrEditLabel\">Create or edit a Event Place</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventPlace.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventPlace.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventPlace.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.eventPlace.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-place/event-places.html","<div><h2 translate=\"sigmasfApp.eventPlace.home.title\">Event Places</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-place.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventPlace.home.createLabel\">Create new Event Place</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventPlace.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.eventPlace.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventPlace in vm.eventPlaces track by eventPlace.id\"><td><a ui-sref=\"event-place-detail({id:eventPlace.id})\">{{eventPlace.id}}</a></td><td>{{eventPlace.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-place-detail({id:eventPlace.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-place.edit({id:eventPlace.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-place.delete({id:eventPlace.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/first-name/first-name-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.firstName.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.firstName.delete.question\" translate-values=\"{id: \'{{vm.firstName.id}}\'}\">Are you sure you want to delete this First Name?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/first-name/first-name-detail.html","<div><h2><span translate=\"sigmasfApp.firstName.detail.title\">First Name</span> {{vm.firstName.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.firstName.name\">Name</span></dt><dd><span>{{vm.firstName.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/first-name/first-name-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFirstNameLabel\" translate=\"sigmasfApp.firstName.home.createOrEditLabel\">Create or edit a First Name</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.firstName.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.firstName.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.firstName.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.firstName.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/first-name/first-names.html","<div><h2 translate=\"sigmasfApp.firstName.home.title\">First Names</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"first-name.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.firstName.home.createLabel\">Create new First Name</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.firstName.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.firstName.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"firstName in vm.firstNames track by firstName.id\"><td><a ui-sref=\"first-name-detail({id:firstName.id})\">{{firstName.id}}</a></td><td>{{firstName.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"first-name-detail({id:firstName.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"first-name.edit({id:firstName.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"first-name.delete({id:firstName.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/event-type/event-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.eventType.delete.question\" translate-values=\"{id: \'{{vm.eventType.id}}\'}\">Are you sure you want to delete this Event Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/event-type/event-type-detail.html","<div><h2><span translate=\"sigmasfApp.eventType.detail.title\">Event Type</span> {{vm.eventType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.eventType.name\">Name</span></dt><dd><span>{{vm.eventType.name}}</span></dd><dt><span translate=\"sigmasfApp.eventType.nameEn\">Name En</span></dt><dd><span>{{vm.eventType.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/event-type/event-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventTypeLabel\" translate=\"sigmasfApp.eventType.home.createOrEditLabel\">Create or edit a Event Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.eventType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.eventType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.eventType.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.eventType.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.eventType.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/event-type/event-types.html","<div><h2 translate=\"sigmasfApp.eventType.home.title\">Event Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"event-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.eventType.home.createLabel\">Create new Event Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.eventType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.eventType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.eventType.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventType in vm.eventTypes track by eventType.id\"><td><a ui-sref=\"event-type-detail({id:eventType.id})\">{{eventType.id}}</a></td><td>{{eventType.name}}</td><td>{{eventType.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-type-detail({id:eventType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-type.edit({id:eventType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-type.delete({id:eventType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/favourite-filter/favourite-filter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.favouriteFilter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.favouriteFilter.delete.question\" translate-values=\"{id: \'{{vm.favouriteFilter.id}}\'}\">Are you sure you want to delete this Favourite Filter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/favourite-filter/favourite-filter-detail.html","<div><h2><span translate=\"sigmasfApp.favouriteFilter.detail.title\">Favourite Filter</span> {{vm.favouriteFilter.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.favouriteFilter.viewName\">View Name</span></dt><dd><span>{{vm.favouriteFilter.viewName}}</span></dd><dt><span translate=\"sigmasfApp.favouriteFilter.name\">Name</span></dt><dd><span>{{vm.favouriteFilter.name}}</span></dd><dt><span translate=\"sigmasfApp.favouriteFilter.kendoOptions\">Kendo Options</span></dt><dd><span>{{vm.favouriteFilter.kendoOptions}}</span></dd><dt><span translate=\"sigmasfApp.favouriteFilter.masterOptions\">Master Options</span></dt><dd><span>{{vm.favouriteFilter.masterOptions}}</span></dd><dt><span translate=\"sigmasfApp.favouriteFilter.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.favouriteFilter.employee.id})\">{{vm.favouriteFilter.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/favourite-filter/favourite-filter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFavouriteFilterLabel\" translate=\"sigmasfApp.favouriteFilter.home.createOrEditLabel\">Create or edit a Favourite Filter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.favouriteFilter.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.favouriteFilter.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.favouriteFilter.viewName\" for=\"field_viewName\">View Name</label><input type=\"text\" class=\"form-control\" name=\"viewName\" id=\"field_viewName\" ng-model=\"vm.favouriteFilter.viewName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.favouriteFilter.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.favouriteFilter.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.favouriteFilter.kendoOptions\" for=\"field_kendoOptions\">Kendo Options</label><textarea class=\"form-control\" name=\"kendoOptions\" id=\"field_kendoOptions\" ng-model=\"vm.favouriteFilter.kendoOptions\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"sigmasfApp.favouriteFilter.masterOptions\" for=\"field_masterOptions\">Master Options</label>\n                <textarea class=\"form-control\" name=\"masterOptions\" id=\"field_masterOptions\" ng-model=\"vm.favouriteFilter.masterOptions\">\n        </div>\n\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.favouriteFilter.employee\" for=\"field_employee\">Employee</label>\n            <select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.favouriteFilter.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>");
$templateCache.put("app/entities/favourite-filter/favourite-filters.html","<div><h2 translate=\"sigmasfApp.favouriteFilter.home.title\">Favourite Filters</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"favourite-filter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.favouriteFilter.home.createLabel\">Create new Favourite Filter</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"viewName\"><span translate=\"sigmasfApp.favouriteFilter.viewName\">View Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.favouriteFilter.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kendoOptions\"><span translate=\"sigmasfApp.favouriteFilter.kendoOptions\">Kendo Options</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"masterOptions\"><span translate=\"sigmasfApp.favouriteFilter.masterOptions\">Master Options</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.favouriteFilter.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"favouriteFilter in vm.favouriteFilters track by favouriteFilter.id\"><td><a ui-sref=\"favourite-filter-detail({id:favouriteFilter.id})\">{{favouriteFilter.id}}</a></td><td>{{favouriteFilter.viewName}}</td><td>{{favouriteFilter.name}}</td><td>{{favouriteFilter.kendoOptions}}</td><td>{{favouriteFilter.masterOptions}}</td><td><a ui-sref=\"employee-detail({id:favouriteFilter.employee.id})\">{{favouriteFilter.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"favourite-filter-detail({id:favouriteFilter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"favourite-filter.edit({id:favouriteFilter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"favourite-filter.delete({id:favouriteFilter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/followup-call/followup-call-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.followupCall.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.followupCall.delete.question\" translate-values=\"{id: \'{{vm.followupCall.id}}\'}\">Are you sure you want to delete this Followup Call?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/followup-call/followup-call-detail.html","<div><h2><span translate=\"sigmasfApp.followupCall.detail.title\">Followup Call</span> {{vm.followupCall.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.followupCall.date\">Date</span></dt><dd><span>{{vm.followupCall.date | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.followupCall.willTheyCall\">Will They Call</span></dt><dd><span>{{vm.followupCall.willTheyCall}}</span></dd><dt><span translate=\"sigmasfApp.followupCall.comments\">Comments</span></dt><dd><span>{{vm.followupCall.comments}}</span></dd><dt><span translate=\"sigmasfApp.followupCall.completed\">Completed</span></dt><dd><span>{{vm.followupCall.completed}}</span></dd><dt><span translate=\"sigmasfApp.followupCall.wentToAnotherRehubCenter\">Went To Another Rehub Center</span></dt><dd><span>{{vm.followupCall.wentToAnotherRehubCenter}}</span></dd><dt><span translate=\"sigmasfApp.followupCall.followupType\">Followup Type</span></dt><dd><a ui-sref=\"followup-type-detail({id:vm.followupCall.followupType.id})\">{{vm.followupCall.followupType.id}}</a></dd><dt><span translate=\"sigmasfApp.followupCall.leadCall\">Lead Call</span></dt><dd><a ui-sref=\"lead-call-detail({id:vm.followupCall.leadCall.id})\">{{vm.followupCall.leadCall.id}}</a></dd><dt><span translate=\"sigmasfApp.followupCall.rejectionReason\">Rejection Reason</span></dt><dd><a ui-sref=\"rejection-reason-detail({id:vm.followupCall.rejectionReason.id})\">{{vm.followupCall.rejectionReason.id}}</a></dd><dt><span translate=\"sigmasfApp.followupCall.followupStatus\">Followup Status</span></dt><dd><a ui-sref=\"followup-status-detail({id:vm.followupCall.followupStatus.id})\">{{vm.followupCall.followupStatus.id}}</a></dd><dt><span translate=\"sigmasfApp.followupCall.anotherRehubCenter\">Another Rehub Center</span></dt><dd><a ui-sref=\"competitor-detail({id:vm.followupCall.anotherRehubCenter.id})\">{{vm.followupCall.anotherRehubCenter.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/followup-call/followup-call-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFollowupCallLabel\" translate=\"sigmasfApp.followupCall.home.createOrEditLabel\">Create or edit a Followup Call</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.followupCall.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.followupCall.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupCall.date\" for=\"field_date\">Date</label><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.followupCall.date\" is-open=\"vm.datePickerOpenStatus.date\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupCall.willTheyCall\" for=\"field_willTheyCall\">Will They Call</label><input type=\"checkbox\" class=\"form-control\" name=\"willTheyCall\" id=\"field_willTheyCall\" ng-model=\"vm.followupCall.willTheyCall\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupCall.comments\" for=\"field_comments\">Comments</label><input type=\"text\" class=\"form-control\" name=\"comments\" id=\"field_comments\" ng-model=\"vm.followupCall.comments\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupCall.completed\" for=\"field_completed\">Completed</label><input type=\"checkbox\" class=\"form-control\" name=\"completed\" id=\"field_completed\" ng-model=\"vm.followupCall.completed\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupCall.wentToAnotherRehubCenter\" for=\"field_wentToAnotherRehubCenter\">Went To Another Rehub Center</label><input type=\"checkbox\" class=\"form-control\" name=\"wentToAnotherRehubCenter\" id=\"field_wentToAnotherRehubCenter\" ng-model=\"vm.followupCall.wentToAnotherRehubCenter\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.followupCall.followupType\" for=\"field_followupType\">Followup Type</label><select class=\"form-control\" id=\"field_followupType\" name=\"followupType\" ng-model=\"vm.followupCall.followupType\" ng-options=\"followupType as followupType.id for followupType in vm.followuptypes track by followupType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.followupCall.leadCall\" for=\"field_leadCall\">Lead Call</label><select class=\"form-control\" id=\"field_leadCall\" name=\"leadCall\" ng-model=\"vm.followupCall.leadCall\" ng-options=\"leadCall as leadCall.id for leadCall in vm.leadcalls track by leadCall.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.followupCall.rejectionReason\" for=\"field_rejectionReason\">Rejection Reason</label><select class=\"form-control\" id=\"field_rejectionReason\" name=\"rejectionReason\" ng-model=\"vm.followupCall.rejectionReason\" ng-options=\"rejectionReason as rejectionReason.id for rejectionReason in vm.rejectionreasons track by rejectionReason.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.followupCall.followupStatus\" for=\"field_followupStatus\">Followup Status</label><select class=\"form-control\" id=\"field_followupStatus\" name=\"followupStatus\" ng-model=\"vm.followupCall.followupStatus\" ng-options=\"followupStatus as followupStatus.id for followupStatus in vm.followupstatuses track by followupStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.followupCall.anotherRehubCenter\" for=\"field_anotherRehubCenter\">Another Rehub Center</label><select class=\"form-control\" id=\"field_anotherRehubCenter\" name=\"anotherRehubCenter\" ng-model=\"vm.followupCall.anotherRehubCenter\" ng-options=\"competitor as competitor.id for competitor in vm.competitors track by competitor.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/followup-call/followup-calls.html","<div><h2 translate=\"sigmasfApp.followupCall.home.title\">Followup Calls</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"followup-call.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.followupCall.home.createLabel\">Create new Followup Call</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"date\"><span translate=\"sigmasfApp.followupCall.date\">Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"willTheyCall\"><span translate=\"sigmasfApp.followupCall.willTheyCall\">Will They Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comments\"><span translate=\"sigmasfApp.followupCall.comments\">Comments</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"completed\"><span translate=\"sigmasfApp.followupCall.completed\">Completed</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wentToAnotherRehubCenter\"><span translate=\"sigmasfApp.followupCall.wentToAnotherRehubCenter\">Went To Another Rehub Center</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"followupType.id\"><span translate=\"sigmasfApp.followupCall.followupType\">Followup Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadCall.id\"><span translate=\"sigmasfApp.followupCall.leadCall\">Lead Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"rejectionReason.id\"><span translate=\"sigmasfApp.followupCall.rejectionReason\">Rejection Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"followupStatus.id\"><span translate=\"sigmasfApp.followupCall.followupStatus\">Followup Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"anotherRehubCenter.id\"><span translate=\"sigmasfApp.followupCall.anotherRehubCenter\">Another Rehub Center</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"followupCall in vm.followupCalls track by followupCall.id\"><td><a ui-sref=\"followup-call-detail({id:followupCall.id})\">{{followupCall.id}}</a></td><td>{{followupCall.date | date:\'mediumDate\'}}</td><td>{{followupCall.willTheyCall}}</td><td>{{followupCall.comments}}</td><td>{{followupCall.completed}}</td><td>{{followupCall.wentToAnotherRehubCenter}}</td><td><a ui-sref=\"followup-type-detail({id:followupCall.followupType.id})\">{{followupCall.followupType.id}}</a></td><td><a ui-sref=\"lead-call-detail({id:followupCall.leadCall.id})\">{{followupCall.leadCall.id}}</a></td><td><a ui-sref=\"rejection-reason-detail({id:followupCall.rejectionReason.id})\">{{followupCall.rejectionReason.id}}</a></td><td><a ui-sref=\"followup-status-detail({id:followupCall.followupStatus.id})\">{{followupCall.followupStatus.id}}</a></td><td><a ui-sref=\"competitor-detail({id:followupCall.anotherRehubCenter.id})\">{{followupCall.anotherRehubCenter.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"followup-call-detail({id:followupCall.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"followup-call.edit({id:followupCall.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"followup-call.delete({id:followupCall.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/followup-status/followup-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.followupStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.followupStatus.delete.question\" translate-values=\"{id: \'{{vm.followupStatus.id}}\'}\">Are you sure you want to delete this Followup Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/followup-status/followup-status-detail.html","<div><h2><span translate=\"sigmasfApp.followupStatus.detail.title\">Followup Status</span> {{vm.followupStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.followupStatus.name\">Name</span></dt><dd><span>{{vm.followupStatus.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/followup-status/followup-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFollowupStatusLabel\" translate=\"sigmasfApp.followupStatus.home.createOrEditLabel\">Create or edit a Followup Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.followupStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.followupStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.followupStatus.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/followup-status/followup-statuses.html","<div><h2 translate=\"sigmasfApp.followupStatus.home.title\">Followup Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"followup-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.followupStatus.home.createLabel\">Create new Followup Status</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.followupStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"followupStatus in vm.followupStatuses track by followupStatus.id\"><td><a ui-sref=\"followup-status-detail({id:followupStatus.id})\">{{followupStatus.id}}</a></td><td>{{followupStatus.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"followup-status-detail({id:followupStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"followup-status.edit({id:followupStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"followup-status.delete({id:followupStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/followup-type/followup-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.followupType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.followupType.delete.question\" translate-values=\"{id: \'{{vm.followupType.id}}\'}\">Are you sure you want to delete this Followup Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/followup-type/followup-type-detail.html","<div><h2><span translate=\"sigmasfApp.followupType.detail.title\">Followup Type</span> {{vm.followupType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.followupType.name\">Name</span></dt><dd><span>{{vm.followupType.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/followup-type/followup-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFollowupTypeLabel\" translate=\"sigmasfApp.followupType.home.createOrEditLabel\">Create or edit a Followup Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.followupType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.followupType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.followupType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.followupType.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/followup-type/followup-types.html","<div><h2 translate=\"sigmasfApp.followupType.home.title\">Followup Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"followup-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.followupType.home.createLabel\">Create new Followup Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.followupType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"followupType in vm.followupTypes track by followupType.id\"><td><a ui-sref=\"followup-type-detail({id:followupType.id})\">{{followupType.id}}</a></td><td>{{followupType.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"followup-type-detail({id:followupType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"followup-type.edit({id:followupType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"followup-type.delete({id:followupType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/geodata/geodata-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.geodata.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.geodata.delete.question\" translate-values=\"{id: \'{{vm.geodata.id}}\'}\">Are you sure you want to delete this Geodata?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/geodata/geodata-detail.html","<div><h2><span translate=\"sigmasfApp.geodata.detail.title\">Geodata</span> {{vm.geodata.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.geodata.country\">Country</span></dt><dd><span>{{vm.geodata.country}}</span></dd><dt><span translate=\"sigmasfApp.geodata.region\">Region</span></dt><dd><span>{{vm.geodata.region}}</span></dd><dt><span translate=\"sigmasfApp.geodata.prefecture\">Prefecture</span></dt><dd><span>{{vm.geodata.prefecture}}</span></dd><dt><span translate=\"sigmasfApp.geodata.city\">City</span></dt><dd><span>{{vm.geodata.city}}</span></dd><dt><span translate=\"sigmasfApp.geodata.street\">Street</span></dt><dd><span>{{vm.geodata.street}}</span></dd><dt><span translate=\"sigmasfApp.geodata.postalCode\">Postal Code</span></dt><dd><span>{{vm.geodata.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.geodata.fromNum1\">From Num 1</span></dt><dd><span>{{vm.geodata.fromNum1}}</span></dd><dt><span translate=\"sigmasfApp.geodata.toNum1\">To Num 1</span></dt><dd><span>{{vm.geodata.toNum1}}</span></dd><dt><span translate=\"sigmasfApp.geodata.fromNum2\">From Num 2</span></dt><dd><span>{{vm.geodata.fromNum2}}</span></dd><dt><span translate=\"sigmasfApp.geodata.toNum2\">To Num 2</span></dt><dd><span>{{vm.geodata.toNum2}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/geodata/geodata-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myGeodataLabel\" translate=\"sigmasfApp.geodata.home.createOrEditLabel\">Create or edit a Geodata</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.geodata.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.geodata.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.country\" for=\"field_country\">Country</label><input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" ng-model=\"vm.geodata.country\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.region\" for=\"field_region\">Region</label><input type=\"text\" class=\"form-control\" name=\"region\" id=\"field_region\" ng-model=\"vm.geodata.region\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.prefecture\" for=\"field_prefecture\">Prefecture</label><input type=\"text\" class=\"form-control\" name=\"prefecture\" id=\"field_prefecture\" ng-model=\"vm.geodata.prefecture\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.city\" for=\"field_city\">City</label><input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" ng-model=\"vm.geodata.city\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.street\" for=\"field_street\">Street</label><input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" ng-model=\"vm.geodata.street\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.geodata.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.fromNum1\" for=\"field_fromNum1\">From Num 1</label><input type=\"text\" class=\"form-control\" name=\"fromNum1\" id=\"field_fromNum1\" ng-model=\"vm.geodata.fromNum1\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.toNum1\" for=\"field_toNum1\">To Num 1</label><input type=\"text\" class=\"form-control\" name=\"toNum1\" id=\"field_toNum1\" ng-model=\"vm.geodata.toNum1\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.fromNum2\" for=\"field_fromNum2\">From Num 2</label><input type=\"text\" class=\"form-control\" name=\"fromNum2\" id=\"field_fromNum2\" ng-model=\"vm.geodata.fromNum2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.geodata.toNum2\" for=\"field_toNum2\">To Num 2</label><input type=\"text\" class=\"form-control\" name=\"toNum2\" id=\"field_toNum2\" ng-model=\"vm.geodata.toNum2\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/geodata/geodata.html","<div><h2 translate=\"sigmasfApp.geodata.home.title\">Geodata</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"geodata.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.geodata.home.createLabel\">Create new Geodata</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.geodata.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country\"><span translate=\"sigmasfApp.geodata.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region\"><span translate=\"sigmasfApp.geodata.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture\"><span translate=\"sigmasfApp.geodata.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city\"><span translate=\"sigmasfApp.geodata.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"street\"><span translate=\"sigmasfApp.geodata.street\">Street</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.geodata.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromNum1\"><span translate=\"sigmasfApp.geodata.fromNum1\">From Num 1</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toNum1\"><span translate=\"sigmasfApp.geodata.toNum1\">To Num 1</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromNum2\"><span translate=\"sigmasfApp.geodata.fromNum2\">From Num 2</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toNum2\"><span translate=\"sigmasfApp.geodata.toNum2\">To Num 2</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"geodata in vm.geodata track by geodata.id\"><td><a ui-sref=\"geodata-detail({id:geodata.id})\">{{geodata.id}}</a></td><td>{{geodata.country}}</td><td>{{geodata.region}}</td><td>{{geodata.prefecture}}</td><td>{{geodata.city}}</td><td>{{geodata.street}}</td><td>{{geodata.postalCode}}</td><td>{{geodata.fromNum1}}</td><td>{{geodata.toNum1}}</td><td>{{geodata.fromNum2}}</td><td>{{geodata.toNum2}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"geodata-detail({id:geodata.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"geodata.edit({id:geodata.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"geodata.delete({id:geodata.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/hospitalization/hospitalization-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.hospitalization.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.hospitalization.delete.question\" translate-values=\"{id: \'{{vm.hospitalization.id}}\'}\">Are you sure you want to delete this Hospitalization?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/hospitalization/hospitalization-detail.html","<div><h2><span translate=\"sigmasfApp.hospitalization.detail.title\">Hospitalization</span> {{vm.hospitalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.hospitalization.pagientAge\">Pagient Age</span></dt><dd><span>{{vm.hospitalization.pagientAge}}</span></dd><dt><span translate=\"sigmasfApp.hospitalization.notes\">Notes</span></dt><dd><span>{{vm.hospitalization.notes}}</span></dd><dt><span translate=\"sigmasfApp.hospitalization.dateIssue\">Date Issue</span></dt><dd><span>{{vm.hospitalization.dateIssue | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.hospitalization.patient\">Patient</span></dt><dd><a ui-sref=\"patient-detail({id:vm.hospitalization.patient.id})\">{{vm.hospitalization.patient.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.hospitalization.customer.id})\">{{vm.hospitalization.customer.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.hospitalization.sector.id})\">{{vm.hospitalization.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.customerTitle\">Customer Title</span></dt><dd><a ui-sref=\"customer-title-detail({id:vm.hospitalization.customerTitle.id})\">{{vm.hospitalization.customerTitle.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.clinicName\">Clinic Name</span></dt><dd><a ui-sref=\"clinic-name-detail({id:vm.hospitalization.clinicName.id})\">{{vm.hospitalization.clinicName.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.roomType\">Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.hospitalization.roomType.id})\">{{vm.hospitalization.roomType.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.hospitalizationType\">Hospitalization Type</span></dt><dd><a ui-sref=\"hospitalization-type-detail({id:vm.hospitalization.hospitalizationType.id})\">{{vm.hospitalization.hospitalizationType.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.finalRoomType\">Final Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.hospitalization.finalRoomType.id})\">{{vm.hospitalization.finalRoomType.id}}</a></dd><dt><span translate=\"sigmasfApp.hospitalization.leadCall\">Lead Call</span></dt><dd><a ui-sref=\"lead-call-detail({id:vm.hospitalization.leadCall.id})\">{{vm.hospitalization.leadCall.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/hospitalization/hospitalization-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myHospitalizationLabel\" translate=\"sigmasfApp.hospitalization.home.createOrEditLabel\">Create or edit a Hospitalization</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.hospitalization.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.hospitalization.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.hospitalization.pagientAge\" for=\"field_pagientAge\">Pagient Age</label><input type=\"number\" class=\"form-control\" name=\"pagientAge\" id=\"field_pagientAge\" ng-model=\"vm.hospitalization.pagientAge\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.hospitalization.notes\" for=\"field_notes\">Notes</label><textarea class=\"form-control\" name=\"notes\" id=\"field_notes\" ng-model=\"vm.hospitalization.notes\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"sigmasfApp.hospitalization.dateIssue\" for=\"field_dateIssue\">Date Issue</label>\n                <div class=\"input-group\">\n                    <input id=\"field_dateIssue\" type=\"text\" class=\"form-control\" name=\"dateIssue\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.hospitalization.dateIssue\" is-open=\"vm.datePickerOpenStatus.dateIssue\">\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateIssue\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.patient\" for=\"field_patient\">Patient</label>\n            <select class=\"form-control\" id=\"field_patient\" name=\"patient\" ng-model=\"vm.hospitalization.patient\" ng-options=\"patient as patient.id for patient in vm.patients track by patient.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.customer\" for=\"field_customer\">Customer</label>\n            <select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.hospitalization.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.sector\" for=\"field_sector\">Sector</label>\n            <select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.hospitalization.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.customerTitle\" for=\"field_customerTitle\">Customer Title</label>\n            <select class=\"form-control\" id=\"field_customerTitle\" name=\"customerTitle\" ng-model=\"vm.hospitalization.customerTitle\" ng-options=\"customerTitle as customerTitle.id for customerTitle in vm.customertitles track by customerTitle.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.clinicName\" for=\"field_clinicName\">Clinic Name</label>\n            <select class=\"form-control\" id=\"field_clinicName\" name=\"clinicName\" ng-model=\"vm.hospitalization.clinicName\" ng-options=\"clinicName as clinicName.id for clinicName in vm.clinicnames track by clinicName.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.roomType\" for=\"field_roomType\">Room Type</label>\n            <select class=\"form-control\" id=\"field_roomType\" name=\"roomType\" ng-model=\"vm.hospitalization.roomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.hospitalizationType\" for=\"field_hospitalizationType\">Hospitalization Type</label>\n            <select class=\"form-control\" id=\"field_hospitalizationType\" name=\"hospitalizationType\" ng-model=\"vm.hospitalization.hospitalizationType\" ng-options=\"hospitalizationType as hospitalizationType.id for hospitalizationType in vm.hospitalizationtypes track by hospitalizationType.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.finalRoomType\" for=\"field_finalRoomType\">Final Room Type</label>\n            <select class=\"form-control\" id=\"field_finalRoomType\" name=\"finalRoomType\" ng-model=\"vm.hospitalization.finalRoomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.hospitalization.leadCall\" for=\"field_leadCall\">Lead Call</label>\n            <select class=\"form-control\" id=\"field_leadCall\" name=\"leadCall\" ng-model=\"vm.hospitalization.leadCall\" ng-options=\"leadCall as leadCall.id for leadCall in vm.leadcalls track by leadCall.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>");
$templateCache.put("app/entities/hospitalization/hospitalizations.html","<div><h2 translate=\"sigmasfApp.hospitalization.home.title\">Hospitalizations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"hospitalization.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.hospitalization.home.createLabel\">Create new Hospitalization</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pagientAge\"><span translate=\"sigmasfApp.hospitalization.pagientAge\">Pagient Age</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notes\"><span translate=\"sigmasfApp.hospitalization.notes\">Notes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateIssue\"><span translate=\"sigmasfApp.hospitalization.dateIssue\">Date Issue</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patient.id\"><span translate=\"sigmasfApp.hospitalization.patient\">Patient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span translate=\"sigmasfApp.hospitalization.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.hospitalization.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerTitle.id\"><span translate=\"sigmasfApp.hospitalization.customerTitle\">Customer Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"clinicName.id\"><span translate=\"sigmasfApp.hospitalization.clinicName\">Clinic Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roomType.id\"><span translate=\"sigmasfApp.hospitalization.roomType\">Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hospitalizationType.id\"><span translate=\"sigmasfApp.hospitalization.hospitalizationType\">Hospitalization Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalRoomType.id\"><span translate=\"sigmasfApp.hospitalization.finalRoomType\">Final Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadCall.id\"><span translate=\"sigmasfApp.hospitalization.leadCall\">Lead Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"hospitalization in vm.hospitalizations track by hospitalization.id\"><td><a ui-sref=\"hospitalization-detail({id:hospitalization.id})\">{{hospitalization.id}}</a></td><td>{{hospitalization.pagientAge}}</td><td>{{hospitalization.notes}}</td><td>{{hospitalization.dateIssue | date:\'mediumDate\'}}</td><td><a ui-sref=\"patient-detail({id:hospitalization.patient.id})\">{{hospitalization.patient.id}}</a></td><td><a ui-sref=\"customer-detail({id:hospitalization.customer.id})\">{{hospitalization.customer.id}}</a></td><td><a ui-sref=\"sector-detail({id:hospitalization.sector.id})\">{{hospitalization.sector.id}}</a></td><td><a ui-sref=\"customer-title-detail({id:hospitalization.customerTitle.id})\">{{hospitalization.customerTitle.id}}</a></td><td><a ui-sref=\"clinic-name-detail({id:hospitalization.clinicName.id})\">{{hospitalization.clinicName.id}}</a></td><td><a ui-sref=\"room-type-detail({id:hospitalization.roomType.id})\">{{hospitalization.roomType.id}}</a></td><td><a ui-sref=\"hospitalization-type-detail({id:hospitalization.hospitalizationType.id})\">{{hospitalization.hospitalizationType.id}}</a></td><td><a ui-sref=\"room-type-detail({id:hospitalization.finalRoomType.id})\">{{hospitalization.finalRoomType.id}}</a></td><td><a ui-sref=\"lead-call-detail({id:hospitalization.leadCall.id})\">{{hospitalization.leadCall.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"hospitalization-detail({id:hospitalization.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization.edit({id:hospitalization.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization.delete({id:hospitalization.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/hospitalization-type-parent/hospitalization-type-parent-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.hospitalizationTypeParent.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.hospitalizationTypeParent.delete.question\" translate-values=\"{id: \'{{vm.hospitalizationTypeParent.id}}\'}\">Are you sure you want to delete this Hospitalization Type Parent?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/hospitalization-type-parent/hospitalization-type-parent-detail.html","<div><h2><span translate=\"sigmasfApp.hospitalizationTypeParent.detail.title\">Hospitalization Type Parent</span> {{vm.hospitalizationTypeParent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.hospitalizationTypeParent.name\">Name</span></dt><dd><span>{{vm.hospitalizationTypeParent.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/hospitalization-type-parent/hospitalization-type-parent-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myHospitalizationTypeParentLabel\" translate=\"sigmasfApp.hospitalizationTypeParent.home.createOrEditLabel\">Create or edit a Hospitalization Type Parent</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.hospitalizationTypeParent.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.hospitalizationTypeParent.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.hospitalizationTypeParent.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.hospitalizationTypeParent.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/hospitalization-type-parent/hospitalization-type-parents.html","<div><h2 translate=\"sigmasfApp.hospitalizationTypeParent.home.title\">Hospitalization Type Parents</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"hospitalization-type-parent.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.hospitalizationTypeParent.home.createLabel\">Create new Hospitalization Type Parent</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.hospitalizationTypeParent.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"hospitalizationTypeParent in vm.hospitalizationTypeParents track by hospitalizationTypeParent.id\"><td><a ui-sref=\"hospitalization-type-parent-detail({id:hospitalizationTypeParent.id})\">{{hospitalizationTypeParent.id}}</a></td><td>{{hospitalizationTypeParent.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"hospitalization-type-parent-detail({id:hospitalizationTypeParent.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization-type-parent.edit({id:hospitalizationTypeParent.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization-type-parent.delete({id:hospitalizationTypeParent.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/hospitalization-type/hospitalization-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.hospitalizationType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.hospitalizationType.delete.question\" translate-values=\"{id: \'{{vm.hospitalizationType.id}}\'}\">Are you sure you want to delete this Hospitalization Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/hospitalization-type/hospitalization-type-detail.html","<div><h2><span translate=\"sigmasfApp.hospitalizationType.detail.title\">Hospitalization Type</span> {{vm.hospitalizationType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.hospitalizationType.name\">Name</span></dt><dd><span>{{vm.hospitalizationType.name}}</span></dd><dt><span translate=\"sigmasfApp.hospitalizationType.hospitalizationTypeParent\">Hospitalization Type Parent</span></dt><dd><a ui-sref=\"hospitalization-type-parent-detail({id:vm.hospitalizationType.hospitalizationTypeParent.id})\">{{vm.hospitalizationType.hospitalizationTypeParent.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/hospitalization-type/hospitalization-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myHospitalizationTypeLabel\" translate=\"sigmasfApp.hospitalizationType.home.createOrEditLabel\">Create or edit a Hospitalization Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.hospitalizationType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.hospitalizationType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.hospitalizationType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.hospitalizationType.name\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.hospitalizationType.hospitalizationTypeParent\" for=\"field_hospitalizationTypeParent\">Hospitalization Type Parent</label><select class=\"form-control\" id=\"field_hospitalizationTypeParent\" name=\"hospitalizationTypeParent\" ng-model=\"vm.hospitalizationType.hospitalizationTypeParent\" ng-options=\"HospitalizationTypeParent as HospitalizationTypeParent.id for HospitalizationTypeParent in vm.hospitalizationtypeparents track by HospitalizationTypeParent.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/hospitalization-type/hospitalization-types.html","<div><h2 translate=\"sigmasfApp.hospitalizationType.home.title\">Hospitalization Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"hospitalization-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.hospitalizationType.home.createLabel\">Create new Hospitalization Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.hospitalizationType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hospitalizationTypeParent.id\"><span translate=\"sigmasfApp.hospitalizationType.hospitalizationTypeParent\">Hospitalization Type Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"hospitalizationType in vm.hospitalizationTypes track by hospitalizationType.id\"><td><a ui-sref=\"hospitalization-type-detail({id:hospitalizationType.id})\">{{hospitalizationType.id}}</a></td><td>{{hospitalizationType.name}}</td><td><a ui-sref=\"hospitalization-type-parent-detail({id:hospitalizationType.hospitalizationTypeParent.id})\">{{hospitalizationType.hospitalizationTypeParent.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"hospitalization-type-detail({id:hospitalizationType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization-type.edit({id:hospitalizationType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"hospitalization-type.delete({id:hospitalizationType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/last-name/last-name-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.lastName.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.lastName.delete.question\" translate-values=\"{id: \'{{vm.lastName.id}}\'}\">Are you sure you want to delete this Last Name?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/last-name/last-name-detail.html","<div><h2><span translate=\"sigmasfApp.lastName.detail.title\">Last Name</span> {{vm.lastName.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.lastName.name\">Name</span></dt><dd><span>{{vm.lastName.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/last-name/last-name-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLastNameLabel\" translate=\"sigmasfApp.lastName.home.createOrEditLabel\">Create or edit a Last Name</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.lastName.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.lastName.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.lastName.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.lastName.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/last-name/last-names.html","<div><h2 translate=\"sigmasfApp.lastName.home.title\">Last Names</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"last-name.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.lastName.home.createLabel\">Create new Last Name</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.lastName.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.lastName.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"lastName in vm.lastNames track by lastName.id\"><td><a ui-sref=\"last-name-detail({id:lastName.id})\">{{lastName.id}}</a></td><td>{{lastName.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"last-name-detail({id:lastName.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"last-name.edit({id:lastName.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"last-name.delete({id:lastName.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/icd-10/icd-10-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.icd10.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.icd10.delete.question\" translate-values=\"{id: \'{{vm.icd10.id}}\'}\">Are you sure you want to delete this Icd 10?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/icd-10/icd-10-detail.html","<div><h2><span translate=\"sigmasfApp.icd10.detail.title\">Icd 10</span> {{vm.icd10.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.icd10.code\">Code</span></dt><dd><span>{{vm.icd10.code}}</span></dd><dt><span translate=\"sigmasfApp.icd10.title\">Title</span></dt><dd><span>{{vm.icd10.title}}</span></dd><dt><span translate=\"sigmasfApp.icd10.description\">Description</span></dt><dd><span>{{vm.icd10.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/icd-10/icd-10-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myIcd10Label\" translate=\"sigmasfApp.icd10.home.createOrEditLabel\">Create or edit a Icd 10</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.icd10.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.icd10.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.icd10.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.icd10.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.icd10.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.icd10.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.icd10.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.icd10.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/icd-10/icd-10-s.html","<div><h2 translate=\"sigmasfApp.icd10.home.title\">Icd 10 S</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"icd-10.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.icd10.home.createLabel\">Create new Icd 10</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.icd10.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"sigmasfApp.icd10.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.icd10.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"icd10 in vm.icd10S track by icd10.id\"><td><a ui-sref=\"icd-10-detail({id:icd10.id})\">{{icd10.id}}</a></td><td>{{icd10.code}}</td><td>{{icd10.title}}</td><td>{{icd10.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"icd-10-detail({id:icd10.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"icd-10.edit({id:icd10.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"icd-10.delete({id:icd10.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-discount/lead-discount-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadDiscount.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadDiscount.delete.question\" translate-values=\"{id: \'{{vm.leadDiscount.id}}\'}\">Are you sure you want to delete this Lead Discount?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-discount/lead-discount-detail.html","<div><h2><span translate=\"sigmasfApp.leadDiscount.detail.title\">Lead Discount</span> {{vm.leadDiscount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadDiscount.hasRequestedDiscount\">Has Requested Discount</span></dt><dd><span>{{vm.leadDiscount.hasRequestedDiscount}}</span></dd><dt><span translate=\"sigmasfApp.leadDiscount.requestedReasonOther\">Requested Reason Other</span></dt><dd><span>{{vm.leadDiscount.requestedReasonOther}}</span></dd><dt><span translate=\"sigmasfApp.leadDiscount.isEntitledToDiscount\">Is Entitled To Discount</span></dt><dd><span>{{vm.leadDiscount.isEntitledToDiscount}}</span></dd><dt><span translate=\"sigmasfApp.leadDiscount.entitledToReasonOther\">Entitled To Reason Other</span></dt><dd><span>{{vm.leadDiscount.entitledToReasonOther}}</span></dd><dt><span translate=\"sigmasfApp.leadDiscount.finalReasonOther\">Final Reason Other</span></dt><dd><span>{{vm.leadDiscount.finalReasonOther}}</span></dd><dt><span translate=\"sigmasfApp.leadDiscount.requestedReason\">Requested Reason</span></dt><dd><a ui-sref=\"discount-reason-detail({id:vm.leadDiscount.requestedReason.id})\">{{vm.leadDiscount.requestedReason.id}}</a></dd><dt><span translate=\"sigmasfApp.leadDiscount.entitledToReason\">Entitled To Reason</span></dt><dd><a ui-sref=\"discount-reason-detail({id:vm.leadDiscount.entitledToReason.id})\">{{vm.leadDiscount.entitledToReason.id}}</a></dd><dt><span translate=\"sigmasfApp.leadDiscount.finalDiscount\">Final Discount</span></dt><dd><a ui-sref=\"discount-rate-detail({id:vm.leadDiscount.finalDiscount.id})\">{{vm.leadDiscount.finalDiscount.id}}</a></dd><dt><span translate=\"sigmasfApp.leadDiscount.finalReason\">Final Reason</span></dt><dd><a ui-sref=\"discount-reason-detail({id:vm.leadDiscount.finalReason.id})\">{{vm.leadDiscount.finalReason.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-discount/lead-discount-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadDiscountLabel\" translate=\"sigmasfApp.leadDiscount.home.createOrEditLabel\">Create or edit a Lead Discount</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadDiscount.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadDiscount.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadDiscount.hasRequestedDiscount\" for=\"field_hasRequestedDiscount\">Has Requested Discount</label><input type=\"checkbox\" class=\"form-control\" name=\"hasRequestedDiscount\" id=\"field_hasRequestedDiscount\" ng-model=\"vm.leadDiscount.hasRequestedDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadDiscount.requestedReasonOther\" for=\"field_requestedReasonOther\">Requested Reason Other</label><input type=\"text\" class=\"form-control\" name=\"requestedReasonOther\" id=\"field_requestedReasonOther\" ng-model=\"vm.leadDiscount.requestedReasonOther\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadDiscount.isEntitledToDiscount\" for=\"field_isEntitledToDiscount\">Is Entitled To Discount</label><input type=\"checkbox\" class=\"form-control\" name=\"isEntitledToDiscount\" id=\"field_isEntitledToDiscount\" ng-model=\"vm.leadDiscount.isEntitledToDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadDiscount.entitledToReasonOther\" for=\"field_entitledToReasonOther\">Entitled To Reason Other</label><input type=\"text\" class=\"form-control\" name=\"entitledToReasonOther\" id=\"field_entitledToReasonOther\" ng-model=\"vm.leadDiscount.entitledToReasonOther\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadDiscount.finalReasonOther\" for=\"field_finalReasonOther\">Final Reason Other</label><input type=\"text\" class=\"form-control\" name=\"finalReasonOther\" id=\"field_finalReasonOther\" ng-model=\"vm.leadDiscount.finalReasonOther\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadDiscount.requestedReason\" for=\"field_requestedReason\">Requested Reason</label><select class=\"form-control\" id=\"field_requestedReason\" name=\"requestedReason\" ng-model=\"vm.leadDiscount.requestedReason\" ng-options=\"discountReason as discountReason.id for discountReason in vm.discountreasons track by discountReason.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadDiscount.entitledToReason\" for=\"field_entitledToReason\">Entitled To Reason</label><select class=\"form-control\" id=\"field_entitledToReason\" name=\"entitledToReason\" ng-model=\"vm.leadDiscount.entitledToReason\" ng-options=\"discountReason as discountReason.id for discountReason in vm.discountreasons track by discountReason.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadDiscount.finalDiscount\" for=\"field_finalDiscount\">Final Discount</label><select class=\"form-control\" id=\"field_finalDiscount\" name=\"finalDiscount\" ng-model=\"vm.leadDiscount.finalDiscount\" ng-options=\"discountRate as discountRate.id for discountRate in vm.discountrates track by discountRate.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadDiscount.finalReason\" for=\"field_finalReason\">Final Reason</label><select class=\"form-control\" id=\"field_finalReason\" name=\"finalReason\" ng-model=\"vm.leadDiscount.finalReason\" ng-options=\"discountReason as discountReason.id for discountReason in vm.discountreasons track by discountReason.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-discount/lead-discounts.html","<div><h2 translate=\"sigmasfApp.leadDiscount.home.title\">Lead Discounts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-discount.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadDiscount.home.createLabel\">Create new Lead Discount</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hasRequestedDiscount\"><span translate=\"sigmasfApp.leadDiscount.hasRequestedDiscount\">Has Requested Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestedReasonOther\"><span translate=\"sigmasfApp.leadDiscount.requestedReasonOther\">Requested Reason Other</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isEntitledToDiscount\"><span translate=\"sigmasfApp.leadDiscount.isEntitledToDiscount\">Is Entitled To Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"entitledToReasonOther\"><span translate=\"sigmasfApp.leadDiscount.entitledToReasonOther\">Entitled To Reason Other</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalReasonOther\"><span translate=\"sigmasfApp.leadDiscount.finalReasonOther\">Final Reason Other</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestedReason.id\"><span translate=\"sigmasfApp.leadDiscount.requestedReason\">Requested Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"entitledToReason.id\"><span translate=\"sigmasfApp.leadDiscount.entitledToReason\">Entitled To Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalDiscount.id\"><span translate=\"sigmasfApp.leadDiscount.finalDiscount\">Final Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalReason.id\"><span translate=\"sigmasfApp.leadDiscount.finalReason\">Final Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadDiscount in vm.leadDiscounts track by leadDiscount.id\"><td><a ui-sref=\"lead-discount-detail({id:leadDiscount.id})\">{{leadDiscount.id}}</a></td><td>{{leadDiscount.hasRequestedDiscount}}</td><td>{{leadDiscount.requestedReasonOther}}</td><td>{{leadDiscount.isEntitledToDiscount}}</td><td>{{leadDiscount.entitledToReasonOther}}</td><td>{{leadDiscount.finalReasonOther}}</td><td><a ui-sref=\"discount-reason-detail({id:leadDiscount.requestedReason.id})\">{{leadDiscount.requestedReason.id}}</a></td><td><a ui-sref=\"discount-reason-detail({id:leadDiscount.entitledToReason.id})\">{{leadDiscount.entitledToReason.id}}</a></td><td><a ui-sref=\"discount-rate-detail({id:leadDiscount.finalDiscount.id})\">{{leadDiscount.finalDiscount.id}}</a></td><td><a ui-sref=\"discount-reason-detail({id:leadDiscount.finalReason.id})\">{{leadDiscount.finalReason.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-discount-detail({id:leadDiscount.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-discount.edit({id:leadDiscount.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-discount.delete({id:leadDiscount.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-call/lead-call-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadCall.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadCall.delete.question\" translate-values=\"{id: \'{{vm.leadCall.id}}\'}\">Are you sure you want to delete this Lead Call?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-call/lead-call-detail.html","<div><h2><span translate=\"sigmasfApp.leadCall.detail.title\">Lead Call</span> {{vm.leadCall.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadCall.dateTime\">Date Time</span></dt><dd><span>{{vm.leadCall.dateTime | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.noContact\">No Contact</span></dt><dd><span>{{vm.leadCall.noContact}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.isOldPatient\">Is Old Patient</span></dt><dd><span>{{vm.leadCall.isOldPatient}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.isOldPatientRelative\">Is Old Patient Relative</span></dt><dd><span>{{vm.leadCall.isOldPatientRelative}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.appointmentDate\">Appointment Date</span></dt><dd><span>{{vm.leadCall.appointmentDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.bookedAppointment\">Booked Appointment</span></dt><dd><span>{{vm.leadCall.bookedAppointment}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.isImportant\">Is Important</span></dt><dd><span>{{vm.leadCall.isImportant}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.callType\">Call Type</span></dt><dd><a ui-sref=\"call-type-detail({id:vm.leadCall.callType.id})\">{{vm.leadCall.callType.id}}</a></dd><dt><span translate=\"sigmasfApp.leadCall.prospectivePatient\">Prospective Patient</span></dt><dd><a ui-sref=\"prospective-patient-detail({id:vm.leadCall.prospectivePatient.id})\">{{vm.leadCall.prospectivePatient.id}}</a></dd><dt><span translate=\"sigmasfApp.leadCall.oldPatient\">Old Patient</span></dt><dd><a ui-sref=\"patient-detail({id:vm.leadCall.oldPatient.id})\">{{vm.leadCall.oldPatient.id}}</a></dd><dt><span translate=\"sigmasfApp.leadCall.leadHospitalizations\">Lead Hospitalizations</span></dt><dd><span ng-repeat=\"leadHospitalizations in vm.leadCall.leadHospitalizations\"><a ui-sref=\"lead-hospitalization-detail({id: {{leadHospitalizations.id}}})\">{{leadHospitalizations.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.leadCall.oldPatientDoctor\">Old Patient Doctor</span></dt><dd><a ui-sref=\"customer-detail({id:vm.leadCall.oldPatientDoctor.id})\">{{vm.leadCall.oldPatientDoctor.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-call/lead-call-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadCallLabel\" translate=\"sigmasfApp.leadCall.home.createOrEditLabel\">Create or edit a Lead Call</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadCall.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadCall.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.dateTime\" for=\"field_dateTime\">Date Time</label><div class=\"input-group\"><input id=\"field_dateTime\" type=\"text\" class=\"form-control\" name=\"dateTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.leadCall.dateTime\" is-open=\"vm.datePickerOpenStatus.dateTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.noContact\" for=\"field_noContact\">No Contact</label><input type=\"checkbox\" class=\"form-control\" name=\"noContact\" id=\"field_noContact\" ng-model=\"vm.leadCall.noContact\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.isOldPatient\" for=\"field_isOldPatient\">Is Old Patient</label><input type=\"checkbox\" class=\"form-control\" name=\"isOldPatient\" id=\"field_isOldPatient\" ng-model=\"vm.leadCall.isOldPatient\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.isOldPatientRelative\" for=\"field_isOldPatientRelative\">Is Old Patient Relative</label><input type=\"checkbox\" class=\"form-control\" name=\"isOldPatientRelative\" id=\"field_isOldPatientRelative\" ng-model=\"vm.leadCall.isOldPatientRelative\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.appointmentDate\" for=\"field_appointmentDate\">Appointment Date</label><div class=\"input-group\"><input id=\"field_appointmentDate\" type=\"text\" class=\"form-control\" name=\"appointmentDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.leadCall.appointmentDate\" is-open=\"vm.datePickerOpenStatus.appointmentDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'appointmentDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.bookedAppointment\" for=\"field_bookedAppointment\">Booked Appointment</label><input type=\"checkbox\" class=\"form-control\" name=\"bookedAppointment\" id=\"field_bookedAppointment\" ng-model=\"vm.leadCall.bookedAppointment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadCall.isImportant\" for=\"field_isImportant\">Is Important</label><input type=\"checkbox\" class=\"form-control\" name=\"isImportant\" id=\"field_isImportant\" ng-model=\"vm.leadCall.isImportant\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadCall.callType\" for=\"field_callType\">Call Type</label><select class=\"form-control\" id=\"field_callType\" name=\"callType\" ng-model=\"vm.leadCall.callType\" ng-options=\"callType as callType.id for callType in vm.calltypes track by callType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadCall.prospectivePatient\" for=\"field_prospectivePatient\">Prospective Patient</label><select class=\"form-control\" id=\"field_prospectivePatient\" name=\"prospectivePatient\" ng-model=\"vm.leadCall.prospectivePatient\" ng-options=\"prospectivePatient as prospectivePatient.id for prospectivePatient in vm.prospectivepatients track by prospectivePatient.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadCall.oldPatient\" for=\"field_oldPatient\">Old Patient</label><select class=\"form-control\" id=\"field_oldPatient\" name=\"oldPatient\" ng-model=\"vm.leadCall.oldPatient\" ng-options=\"patient as patient.id for patient in vm.patients track by patient.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadCall.leadHospitalizations\" for=\"field_leadHospitalizations\">Lead Hospitalizations</label><select class=\"form-control\" id=\"field_leadHospitalizations\" multiple=\"multiple\" name=\"leadHospitalizations\" ng-model=\"vm.leadCall.leadHospitalizations\" ng-options=\"leadHospitalization as leadHospitalization.id for leadHospitalization in vm.leadhospitalizations track by leadHospitalization.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadCall.oldPatientDoctor\" for=\"field_oldPatientDoctor\">Old Patient Doctor</label><select class=\"form-control\" id=\"field_oldPatientDoctor\" name=\"oldPatientDoctor\" ng-model=\"vm.leadCall.oldPatientDoctor\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-call/lead-calls.html","<div><h2 translate=\"sigmasfApp.leadCall.home.title\">Lead Calls</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-call.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadCall.home.createLabel\">Create new Lead Call</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateTime\"><span translate=\"sigmasfApp.leadCall.dateTime\">Date Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"noContact\"><span translate=\"sigmasfApp.leadCall.noContact\">No Contact</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isOldPatient\"><span translate=\"sigmasfApp.leadCall.isOldPatient\">Is Old Patient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isOldPatientRelative\"><span translate=\"sigmasfApp.leadCall.isOldPatientRelative\">Is Old Patient Relative</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"appointmentDate\"><span translate=\"sigmasfApp.leadCall.appointmentDate\">Appointment Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bookedAppointment\"><span translate=\"sigmasfApp.leadCall.bookedAppointment\">Booked Appointment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isImportant\"><span translate=\"sigmasfApp.leadCall.isImportant\">Is Important</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"callType.id\"><span translate=\"sigmasfApp.leadCall.callType\">Call Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prospectivePatient.id\"><span translate=\"sigmasfApp.leadCall.prospectivePatient\">Prospective Patient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"oldPatient.id\"><span translate=\"sigmasfApp.leadCall.oldPatient\">Old Patient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"oldPatientDoctor.id\"><span translate=\"sigmasfApp.leadCall.oldPatientDoctor\">Old Patient Doctor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadCall in vm.leadCalls track by leadCall.id\"><td><a ui-sref=\"lead-call-detail({id:leadCall.id})\">{{leadCall.id}}</a></td><td>{{leadCall.dateTime | date:\'medium\'}}</td><td>{{leadCall.noContact}}</td><td>{{leadCall.isOldPatient}}</td><td>{{leadCall.isOldPatientRelative}}</td><td>{{leadCall.appointmentDate | date:\'medium\'}}</td><td>{{leadCall.bookedAppointment}}</td><td>{{leadCall.isImportant}}</td><td><a ui-sref=\"call-type-detail({id:leadCall.callType.id})\">{{leadCall.callType.id}}</a></td><td><a ui-sref=\"prospective-patient-detail({id:leadCall.prospectivePatient.id})\">{{leadCall.prospectivePatient.id}}</a></td><td><a ui-sref=\"patient-detail({id:leadCall.oldPatient.id})\">{{leadCall.oldPatient.id}}</a></td><td><a ui-sref=\"customer-detail({id:leadCall.oldPatientDoctor.id})\">{{leadCall.oldPatientDoctor.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-call-detail({id:leadCall.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-call.edit({id:leadCall.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-call.delete({id:leadCall.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-hospitalization-disease/lead-hospitalization-disease-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadHospitalizationDisease.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadHospitalizationDisease.delete.question\" translate-values=\"{id: \'{{vm.leadHospitalizationDisease.id}}\'}\">Are you sure you want to delete this Lead Hospitalization Disease?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-hospitalization-disease/lead-hospitalization-disease-detail.html","<div><h2><span translate=\"sigmasfApp.leadHospitalizationDisease.detail.title\">Lead Hospitalization Disease</span> {{vm.leadHospitalizationDisease.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadHospitalizationDisease.comments\">Comments</span></dt><dd><span>{{vm.leadHospitalizationDisease.comments}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalizationDisease.disease\">Disease</span></dt><dd><a ui-sref=\"disease-detail({id:vm.leadHospitalizationDisease.disease.id})\">{{vm.leadHospitalizationDisease.disease.id}}</a></dd><dt><span translate=\"sigmasfApp.leadHospitalizationDisease.leadHospitalization\">Lead Hospitalization</span></dt><dd><a ui-sref=\"lead-hospitalization-detail({id:vm.leadHospitalizationDisease.leadHospitalization.id})\">{{vm.leadHospitalizationDisease.leadHospitalization.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-hospitalization-disease/lead-hospitalization-disease-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadHospitalizationDiseaseLabel\" translate=\"sigmasfApp.leadHospitalizationDisease.home.createOrEditLabel\">Create or edit a Lead Hospitalization Disease</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadHospitalizationDisease.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadHospitalizationDisease.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalizationDisease.comments\" for=\"field_comments\">Comments</label><input type=\"text\" class=\"form-control\" name=\"comments\" id=\"field_comments\" ng-model=\"vm.leadHospitalizationDisease.comments\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalizationDisease.disease\" for=\"field_disease\">Disease</label><select class=\"form-control\" id=\"field_disease\" name=\"disease\" ng-model=\"vm.leadHospitalizationDisease.disease\" ng-options=\"disease as disease.id for disease in vm.diseases track by disease.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalizationDisease.leadHospitalization\" for=\"field_leadHospitalization\">Lead Hospitalization</label><select class=\"form-control\" id=\"field_leadHospitalization\" name=\"leadHospitalization\" ng-model=\"vm.leadHospitalizationDisease.leadHospitalization\" ng-options=\"leadHospitalization as leadHospitalization.name for leadHospitalization in vm.leadhospitalizations track by leadHospitalization.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-hospitalization-disease/lead-hospitalization-diseases.html","<div><h2 translate=\"sigmasfApp.leadHospitalizationDisease.home.title\">Lead Hospitalization Diseases</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-hospitalization-disease.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadHospitalizationDisease.home.createLabel\">Create new Lead Hospitalization Disease</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comments\"><span translate=\"sigmasfApp.leadHospitalizationDisease.comments\">Comments</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"disease.id\"><span translate=\"sigmasfApp.leadHospitalizationDisease.disease\">Disease</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadHospitalization.name\"><span translate=\"sigmasfApp.leadHospitalizationDisease.leadHospitalization\">Lead Hospitalization</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadHospitalizationDisease in vm.leadHospitalizationDiseases track by leadHospitalizationDisease.id\"><td><a ui-sref=\"lead-hospitalization-disease-detail({id:leadHospitalizationDisease.id})\">{{leadHospitalizationDisease.id}}</a></td><td>{{leadHospitalizationDisease.comments}}</td><td><a ui-sref=\"disease-detail({id:leadHospitalizationDisease.disease.id})\">{{leadHospitalizationDisease.disease.id}}</a></td><td><a ui-sref=\"lead-hospitalization-detail({id:leadHospitalizationDisease.leadHospitalization.id})\">{{leadHospitalizationDisease.leadHospitalization.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-hospitalization-disease-detail({id:leadHospitalizationDisease.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-hospitalization-disease.edit({id:leadHospitalizationDisease.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-hospitalization-disease.delete({id:leadHospitalizationDisease.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-hospitalization/lead-hospitalization-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadHospitalization.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadHospitalization.delete.question\" translate-values=\"{id: \'{{vm.leadHospitalization.id}}\'}\">Are you sure you want to delete this Lead Hospitalization?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-hospitalization/lead-hospitalization-detail.html","<div><h2><span translate=\"sigmasfApp.leadHospitalization.detail.title\">Lead Hospitalization</span> {{vm.leadHospitalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadHospitalization.isClosedHospitalization\">Is Closed Hospitalization</span></dt><dd><span>{{vm.leadHospitalization.isClosedHospitalization}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.hadSurgery\">Had Surgery</span></dt><dd><span>{{vm.leadHospitalization.hadSurgery}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.surgeryType\">Surgery Type</span></dt><dd><span>{{vm.leadHospitalization.surgeryType}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.sectorOther\">Sector Other</span></dt><dd><span>{{vm.leadHospitalization.sectorOther}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.diagnosisDate\">Diagnosis Date</span></dt><dd><span>{{vm.leadHospitalization.diagnosisDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.possibleDischargeDate\">Possible Discharge Date</span></dt><dd><span>{{vm.leadHospitalization.possibleDischargeDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.isFollowingHospitalization\">Is Following Hospitalization</span></dt><dd><span>{{vm.leadHospitalization.isFollowingHospitalization}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.comments\">Comments</span></dt><dd><span>{{vm.leadHospitalization.comments}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.addDiseaseOther\">Add Disease Other</span></dt><dd><span>{{vm.leadHospitalization.addDiseaseOther}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.hospitalizationDate\">Hospitalization Date</span></dt><dd><span>{{vm.leadHospitalization.hospitalizationDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.Sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.leadHospitalization.sector.id})\">{{vm.leadHospitalization.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.leadHospitalization.competitor\">Competitor</span></dt><dd><a ui-sref=\"competitor-detail({id:vm.leadHospitalization.competitor.id})\">{{vm.leadHospitalization.competitor.id}}</a></dd><dt><span translate=\"sigmasfApp.leadHospitalization.hospitalizationType\">Hospitalization Type</span></dt><dd><a ui-sref=\"hospitalization-type-detail({id:vm.leadHospitalization.hospitalizationType.id})\">{{vm.leadHospitalization.hospitalizationType.name}}</a></dd><dt><span translate=\"sigmasfApp.leadHospitalization.clinicName\">Clinic Name</span></dt><dd><a ui-sref=\"clinic-name-detail({id:vm.leadHospitalization.clinicName.id})\">{{vm.leadHospitalization.clinicName.id}}</a></dd><dt><span translate=\"sigmasfApp.leadHospitalization.addDiseases\">Add Diseases</span></dt><dd><span ng-repeat=\"addDiseases in vm.leadHospitalization.addDiseases\"><a ui-sref=\"add-disease-detail({id: {{addDiseases.id}}})\">{{addDiseases.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.addConditions\">Add Conditions</span></dt><dd><span ng-repeat=\"addConditions in vm.leadHospitalization.addConditions\"><a ui-sref=\"add-condition-detail({id: {{addConditions.id}}})\">{{addConditions.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.leadHospitalization.communicationStatus\">Communication Status</span></dt><dd><a ui-sref=\"communication-status-detail({id:vm.leadHospitalization.communicationStatus.id})\">{{vm.leadHospitalization.communicationStatus.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-hospitalization/lead-hospitalization-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadHospitalizationLabel\" translate=\"sigmasfApp.leadHospitalization.home.createOrEditLabel\">Create or edit a Lead Hospitalization</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadHospitalization.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadHospitalization.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.isClosedHospitalization\" for=\"field_isClosedHospitalization\">Is Closed Hospitalization</label><input type=\"checkbox\" class=\"form-control\" name=\"isClosedHospitalization\" id=\"field_isClosedHospitalization\" ng-model=\"vm.leadHospitalization.isClosedHospitalization\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.hadSurgery\" for=\"field_hadSurgery\">Had Surgery</label><input type=\"checkbox\" class=\"form-control\" name=\"hadSurgery\" id=\"field_hadSurgery\" ng-model=\"vm.leadHospitalization.hadSurgery\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.surgeryType\" for=\"field_surgeryType\">Surgery Type</label><input type=\"text\" class=\"form-control\" name=\"surgeryType\" id=\"field_surgeryType\" ng-model=\"vm.leadHospitalization.surgeryType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.sectorOther\" for=\"field_sectorOther\">Sector Other</label><input type=\"text\" class=\"form-control\" name=\"sectorOther\" id=\"field_sectorOther\" ng-model=\"vm.leadHospitalization.sectorOther\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.diagnosisDate\" for=\"field_diagnosisDate\">Diagnosis Date</label><div class=\"input-group\"><input id=\"field_diagnosisDate\" type=\"text\" class=\"form-control\" name=\"diagnosisDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.leadHospitalization.diagnosisDate\" is-open=\"vm.datePickerOpenStatus.diagnosisDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'diagnosisDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.possibleDischargeDate\" for=\"field_possibleDischargeDate\">Possible Discharge Date</label><div class=\"input-group\"><input id=\"field_possibleDischargeDate\" type=\"text\" class=\"form-control\" name=\"possibleDischargeDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.leadHospitalization.possibleDischargeDate\" is-open=\"vm.datePickerOpenStatus.possibleDischargeDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'possibleDischargeDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.isFollowingHospitalization\" for=\"field_isFollowingHospitalization\">Is Following Hospitalization</label><input type=\"checkbox\" class=\"form-control\" name=\"isFollowingHospitalization\" id=\"field_isFollowingHospitalization\" ng-model=\"vm.leadHospitalization.isFollowingHospitalization\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.comments\" for=\"field_comments\">Comments</label><input type=\"text\" class=\"form-control\" name=\"comments\" id=\"field_comments\" ng-model=\"vm.leadHospitalization.comments\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.addDiseaseOther\" for=\"field_addDiseaseOther\">Add Disease Other</label><input type=\"text\" class=\"form-control\" name=\"addDiseaseOther\" id=\"field_addDiseaseOther\" ng-model=\"vm.leadHospitalization.addDiseaseOther\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadHospitalization.hospitalizationDate\" for=\"field_hospitalizationDate\">Hospitalization Date</label><div class=\"input-group\"><input id=\"field_hospitalizationDate\" type=\"text\" class=\"form-control\" name=\"hospitalizationDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.leadHospitalization.hospitalizationDate\" is-open=\"vm.datePickerOpenStatus.hospitalizationDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'hospitalizationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.Sector\" for=\"field_Sector\">Sector</label><select class=\"form-control\" id=\"field_Sector\" name=\"Sector\" ng-model=\"vm.leadHospitalization.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.competitor\" for=\"field_competitor\">Competitor</label><select class=\"form-control\" id=\"field_competitor\" name=\"competitor\" ng-model=\"vm.leadHospitalization.competitor\" ng-options=\"competitor as competitor.id for competitor in vm.competitors track by competitor.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.hospitalizationType\" for=\"field_hospitalizationType\">Hospitalization Type</label><select class=\"form-control\" id=\"field_hospitalizationType\" name=\"hospitalizationType\" ng-model=\"vm.leadHospitalization.hospitalizationType\" ng-options=\"hospitalizationType as hospitalizationType.name for hospitalizationType in vm.hospitalizationtypes track by hospitalizationType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.clinicName\" for=\"field_clinicName\">Clinic Name</label><select class=\"form-control\" id=\"field_clinicName\" name=\"clinicName\" ng-model=\"vm.leadHospitalization.clinicName\" ng-options=\"clinicName as clinicName.id for clinicName in vm.clinicnames track by clinicName.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.addDiseases\" for=\"field_addDiseases\">Add Diseases</label><select class=\"form-control\" id=\"field_addDiseases\" multiple=\"multiple\" name=\"addDiseases\" ng-model=\"vm.leadHospitalization.addDiseases\" ng-options=\"addDisease as addDisease.id for addDisease in vm.adddiseases track by addDisease.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.addConditions\" for=\"field_addConditions\">Add Conditions</label><select class=\"form-control\" id=\"field_addConditions\" multiple=\"multiple\" name=\"addConditions\" ng-model=\"vm.leadHospitalization.addConditions\" ng-options=\"addCondition as addCondition.id for addCondition in vm.addconditions track by addCondition.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadHospitalization.communicationStatus\" for=\"field_communicationStatus\">Communication Status</label><select class=\"form-control\" id=\"field_communicationStatus\" name=\"communicationStatus\" ng-model=\"vm.leadHospitalization.communicationStatus\" ng-options=\"communicationStatus as communicationStatus.id for communicationStatus in vm.communicationstatuses track by communicationStatus.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-hospitalization/lead-hospitalizations.html","<div><h2 translate=\"sigmasfApp.leadHospitalization.home.title\">Lead Hospitalizations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-hospitalization.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadHospitalization.home.createLabel\">Create new Lead Hospitalization</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isClosedHospitalization\"><span translate=\"sigmasfApp.leadHospitalization.isClosedHospitalization\">Is Closed Hospitalization</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hadSurgery\"><span translate=\"sigmasfApp.leadHospitalization.hadSurgery\">Had Surgery</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surgeryType\"><span translate=\"sigmasfApp.leadHospitalization.surgeryType\">Surgery Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorOther\"><span translate=\"sigmasfApp.leadHospitalization.sectorOther\">Sector Other</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"diagnosisDate\"><span translate=\"sigmasfApp.leadHospitalization.diagnosisDate\">Diagnosis Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"possibleDischargeDate\"><span translate=\"sigmasfApp.leadHospitalization.possibleDischargeDate\">Possible Discharge Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isFollowingHospitalization\"><span translate=\"sigmasfApp.leadHospitalization.isFollowingHospitalization\">Is Following Hospitalization</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comments\"><span translate=\"sigmasfApp.leadHospitalization.comments\">Comments</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addDiseaseOther\"><span translate=\"sigmasfApp.leadHospitalization.addDiseaseOther\">Add Disease Other</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hospitalizationDate\"><span translate=\"sigmasfApp.leadHospitalization.hospitalizationDate\">Hospitalization Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"Sector.id\"><span translate=\"sigmasfApp.leadHospitalization.Sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"competitor.id\"><span translate=\"sigmasfApp.leadHospitalization.competitor\">Competitor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hospitalizationType.name\"><span translate=\"sigmasfApp.leadHospitalization.hospitalizationType\">Hospitalization Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"clinicName.id\"><span translate=\"sigmasfApp.leadHospitalization.clinicName\">Clinic Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"communicationStatus.id\"><span translate=\"sigmasfApp.leadHospitalization.communicationStatus\">Communication Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadHospitalization in vm.leadHospitalizations track by leadHospitalization.id\"><td><a ui-sref=\"lead-hospitalization-detail({id:leadHospitalization.id})\">{{leadHospitalization.id}}</a></td><td>{{leadHospitalization.isClosedHospitalization}}</td><td>{{leadHospitalization.hadSurgery}}</td><td>{{leadHospitalization.surgeryType}}</td><td>{{leadHospitalization.sectorOther}}</td><td>{{leadHospitalization.diagnosisDate | date:\'mediumDate\'}}</td><td>{{leadHospitalization.possibleDischargeDate | date:\'mediumDate\'}}</td><td>{{leadHospitalization.isFollowingHospitalization}}</td><td>{{leadHospitalization.comments}}</td><td>{{leadHospitalization.addDiseaseOther}}</td><td>{{leadHospitalization.hospitalizationDate | date:\'mediumDate\'}}</td><td><a ui-sref=\"sector-detail({id:leadHospitalization.sector.id})\">{{leadHospitalization.sector.id}}</a></td><td><a ui-sref=\"competitor-detail({id:leadHospitalization.competitor.id})\">{{leadHospitalization.competitor.id}}</a></td><td><a ui-sref=\"hospitalization-type-detail({id:leadHospitalization.hospitalizationType.id})\">{{leadHospitalization.hospitalizationType.name}}</a></td><td><a ui-sref=\"clinic-name-detail({id:leadHospitalization.clinicName.id})\">{{leadHospitalization.clinicName.id}}</a></td><td><a ui-sref=\"communication-status-detail({id:leadHospitalization.communicationStatus.id})\">{{leadHospitalization.communicationStatus.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-hospitalization-detail({id:leadHospitalization.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-hospitalization.edit({id:leadHospitalization.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-hospitalization.delete({id:leadHospitalization.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-offer-room-type/lead-offer-room-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadOfferRoomType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadOfferRoomType.delete.question\" translate-values=\"{id: \'{{vm.leadOfferRoomType.id}}\'}\">Are you sure you want to delete this Lead Offer Room Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-offer-room-type/lead-offer-room-type-detail.html","<div><h2><span translate=\"sigmasfApp.leadOfferRoomType.detail.title\">Lead Offer Room Type</span> {{vm.leadOfferRoomType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadOfferRoomType.discussedPrice\">Discussed Price</span></dt><dd><span>{{vm.leadOfferRoomType.discussedPrice}}</span></dd><dt><span translate=\"sigmasfApp.leadOfferRoomType.leadOffer\">Lead Offer</span></dt><dd><a ui-sref=\"lead-offer-detail({id:vm.leadOfferRoomType.leadOffer.id})\">{{vm.leadOfferRoomType.leadOffer.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOfferRoomType.roomType\">Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.leadOfferRoomType.roomType.id})\">{{vm.leadOfferRoomType.roomType.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-offer-room-type/lead-offer-room-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadOfferRoomTypeLabel\" translate=\"sigmasfApp.leadOfferRoomType.home.createOrEditLabel\">Create or edit a Lead Offer Room Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadOfferRoomType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadOfferRoomType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOfferRoomType.discussedPrice\" for=\"field_discussedPrice\">Discussed Price</label><input type=\"number\" class=\"form-control\" name=\"discussedPrice\" id=\"field_discussedPrice\" ng-model=\"vm.leadOfferRoomType.discussedPrice\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOfferRoomType.leadOffer\" for=\"field_leadOffer\">Lead Offer</label><select class=\"form-control\" id=\"field_leadOffer\" name=\"leadOffer\" ng-model=\"vm.leadOfferRoomType.leadOffer\" ng-options=\"leadOffer as leadOffer.id for leadOffer in vm.leadoffers track by leadOffer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOfferRoomType.roomType\" for=\"field_roomType\">Room Type</label><select class=\"form-control\" id=\"field_roomType\" name=\"roomType\" ng-model=\"vm.leadOfferRoomType.roomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-offer-room-type/lead-offer-room-types.html","<div><h2 translate=\"sigmasfApp.leadOfferRoomType.home.title\">Lead Offer Room Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-offer-room-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadOfferRoomType.home.createLabel\">Create new Lead Offer Room Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discussedPrice\"><span translate=\"sigmasfApp.leadOfferRoomType.discussedPrice\">Discussed Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadOffer.id\"><span translate=\"sigmasfApp.leadOfferRoomType.leadOffer\">Lead Offer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roomType.id\"><span translate=\"sigmasfApp.leadOfferRoomType.roomType\">Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadOfferRoomType in vm.leadOfferRoomTypes track by leadOfferRoomType.id\"><td><a ui-sref=\"lead-offer-room-type-detail({id:leadOfferRoomType.id})\">{{leadOfferRoomType.id}}</a></td><td>{{leadOfferRoomType.discussedPrice}}</td><td><a ui-sref=\"lead-offer-detail({id:leadOfferRoomType.leadOffer.id})\">{{leadOfferRoomType.leadOffer.id}}</a></td><td><a ui-sref=\"room-type-detail({id:leadOfferRoomType.roomType.id})\">{{leadOfferRoomType.roomType.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-offer-room-type-detail({id:leadOfferRoomType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-offer-room-type.edit({id:leadOfferRoomType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-offer-room-type.delete({id:leadOfferRoomType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-parameter/lead-parameter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadParameter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadParameter.delete.question\" translate-values=\"{id: \'{{vm.leadParameter.id}}\'}\">Are you sure you want to delete this Lead Parameter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-parameter/lead-parameter-detail.html","<div><h2><span translate=\"sigmasfApp.leadParameter.detail.title\">Lead Parameter</span> {{vm.leadParameter.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadParameter.name\">Name</span></dt><dd><span>{{vm.leadParameter.name}}</span></dd><dt><span translate=\"sigmasfApp.leadParameter.value\">Value</span></dt><dd><span>{{vm.leadParameter.value}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-parameter/lead-parameter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadParameterLabel\" translate=\"sigmasfApp.leadParameter.home.createOrEditLabel\">Create or edit a Lead Parameter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadParameter.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadParameter.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadParameter.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.leadParameter.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadParameter.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.leadParameter.value\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-parameter/lead-parameters.html","<div><h2 translate=\"sigmasfApp.leadParameter.home.title\">Lead Parameters</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-parameter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadParameter.home.createLabel\">Create new Lead Parameter</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.leadParameter.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sigmasfApp.leadParameter.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadParameter in vm.leadParameters track by leadParameter.id\"><td><a ui-sref=\"lead-parameter-detail({id:leadParameter.id})\">{{leadParameter.id}}</a></td><td>{{leadParameter.name}}</td><td>{{leadParameter.value}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-parameter-detail({id:leadParameter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-parameter.edit({id:leadParameter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-parameter.delete({id:leadParameter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/lead-offer/lead-offer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.leadOffer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.leadOffer.delete.question\" translate-values=\"{id: \'{{vm.leadOffer.id}}\'}\">Are you sure you want to delete this Lead Offer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/lead-offer/lead-offer-detail.html","<div><h2><span translate=\"sigmasfApp.leadOffer.detail.title\">Lead Offer</span> {{vm.leadOffer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.leadOffer.firstEstimationDate\">First Estimation Date</span></dt><dd><span>{{vm.leadOffer.firstEstimationDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.wantsTransportation\">Wants Transportation</span></dt><dd><span>{{vm.leadOffer.wantsTransportation}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.attendantMeal\">Attendant Meal</span></dt><dd><span>{{vm.leadOffer.attendantMeal}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.hasCompetitiveBid\">Has Competitive Bid</span></dt><dd><span>{{vm.leadOffer.hasCompetitiveBid}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.openHospitalizationReference\">Open Hospitalization Reference</span></dt><dd><span>{{vm.leadOffer.openHospitalizationReference}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.roomServices\">Room Services</span></dt><dd><span>{{vm.leadOffer.roomServices}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.comments\">Comments</span></dt><dd><span>{{vm.leadOffer.comments}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.invitationText\">Invitation Text</span></dt><dd><span>{{vm.leadOffer.invitationText}}</span></dd><dt><span translate=\"sigmasfApp.leadOffer.costType\">Cost Type</span></dt><dd><a ui-sref=\"cost-type-detail({id:vm.leadOffer.costType.id})\">{{vm.leadOffer.costType.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.roomType\">Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.leadOffer.roomType.id})\">{{vm.leadOffer.roomType.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.transportation\">Transportation</span></dt><dd><a ui-sref=\"transportation-detail({id:vm.leadOffer.transportation.id})\">{{vm.leadOffer.transportation.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.competitor\">Competitor</span></dt><dd><a ui-sref=\"competitor-detail({id:vm.leadOffer.competitor.id})\">{{vm.leadOffer.competitor.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.desirableRoomType\">Desirable Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.leadOffer.desirableRoomType.id})\">{{vm.leadOffer.desirableRoomType.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.upgradedRoomType\">Upgraded Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.leadOffer.upgradedRoomType.id})\">{{vm.leadOffer.upgradedRoomType.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.leadDiscount\">Lead Discount</span></dt><dd><a ui-sref=\"lead-discount-detail({id:vm.leadOffer.leadDiscount.id})\">{{vm.leadOffer.leadDiscount.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.leadCall\">Lead Call</span></dt><dd><a ui-sref=\"lead-call-detail({id:vm.leadOffer.leadCall.id})\">{{vm.leadOffer.leadCall.id}}</a></dd><dt><span translate=\"sigmasfApp.leadOffer.offerStatus\">Offer Status</span></dt><dd><a ui-sref=\"offer-status-detail({id:vm.leadOffer.offerStatus.id})\">{{vm.leadOffer.offerStatus.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/lead-offer/lead-offer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLeadOfferLabel\" translate=\"sigmasfApp.leadOffer.home.createOrEditLabel\">Create or edit a Lead Offer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.leadOffer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.leadOffer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.firstEstimationDate\" for=\"field_firstEstimationDate\">First Estimation Date</label><div class=\"input-group\"><input id=\"field_firstEstimationDate\" type=\"text\" class=\"form-control\" name=\"firstEstimationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.leadOffer.firstEstimationDate\" is-open=\"vm.datePickerOpenStatus.firstEstimationDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'firstEstimationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.wantsTransportation\" for=\"field_wantsTransportation\">Wants Transportation</label><input type=\"checkbox\" class=\"form-control\" name=\"wantsTransportation\" id=\"field_wantsTransportation\" ng-model=\"vm.leadOffer.wantsTransportation\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.attendantMeal\" for=\"field_attendantMeal\">Attendant Meal</label><input type=\"checkbox\" class=\"form-control\" name=\"attendantMeal\" id=\"field_attendantMeal\" ng-model=\"vm.leadOffer.attendantMeal\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.hasCompetitiveBid\" for=\"field_hasCompetitiveBid\">Has Competitive Bid</label><input type=\"checkbox\" class=\"form-control\" name=\"hasCompetitiveBid\" id=\"field_hasCompetitiveBid\" ng-model=\"vm.leadOffer.hasCompetitiveBid\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.openHospitalizationReference\" for=\"field_openHospitalizationReference\">Open Hospitalization Reference</label><input type=\"checkbox\" class=\"form-control\" name=\"openHospitalizationReference\" id=\"field_openHospitalizationReference\" ng-model=\"vm.leadOffer.openHospitalizationReference\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.roomServices\" for=\"field_roomServices\">Room Services</label><input type=\"text\" class=\"form-control\" name=\"roomServices\" id=\"field_roomServices\" ng-model=\"vm.leadOffer.roomServices\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.comments\" for=\"field_comments\">Comments</label><input type=\"text\" class=\"form-control\" name=\"comments\" id=\"field_comments\" ng-model=\"vm.leadOffer.comments\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.leadOffer.invitationText\" for=\"field_invitationText\">Invitation Text</label><input type=\"text\" class=\"form-control\" name=\"invitationText\" id=\"field_invitationText\" ng-model=\"vm.leadOffer.invitationText\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.costType\" for=\"field_costType\">Cost Type</label><select class=\"form-control\" id=\"field_costType\" name=\"costType\" ng-model=\"vm.leadOffer.costType\" ng-options=\"costType as costType.id for costType in vm.costtypes track by costType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.roomType\" for=\"field_roomType\">Room Type</label><select class=\"form-control\" id=\"field_roomType\" name=\"roomType\" ng-model=\"vm.leadOffer.roomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.transportation\" for=\"field_transportation\">Transportation</label><select class=\"form-control\" id=\"field_transportation\" name=\"transportation\" ng-model=\"vm.leadOffer.transportation\" ng-options=\"transportation as transportation.id for transportation in vm.transportations track by transportation.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.competitor\" for=\"field_competitor\">Competitor</label><select class=\"form-control\" id=\"field_competitor\" name=\"competitor\" ng-model=\"vm.leadOffer.competitor\" ng-options=\"competitor as competitor.id for competitor in vm.competitors track by competitor.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.desirableRoomType\" for=\"field_desirableRoomType\">Desirable Room Type</label><select class=\"form-control\" id=\"field_desirableRoomType\" name=\"desirableRoomType\" ng-model=\"vm.leadOffer.desirableRoomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.upgradedRoomType\" for=\"field_upgradedRoomType\">Upgraded Room Type</label><select class=\"form-control\" id=\"field_upgradedRoomType\" name=\"upgradedRoomType\" ng-model=\"vm.leadOffer.upgradedRoomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.leadDiscount\" for=\"field_leadDiscount\">Lead Discount</label><select class=\"form-control\" id=\"field_leadDiscount\" name=\"leadDiscount\" ng-model=\"vm.leadOffer.leadDiscount\" ng-options=\"leadDiscount as leadDiscount.id for leadDiscount in vm.leaddiscounts track by leadDiscount.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.leadCall\" for=\"field_leadCall\">Lead Call</label><select class=\"form-control\" id=\"field_leadCall\" name=\"leadCall\" ng-model=\"vm.leadOffer.leadCall\" ng-options=\"leadCall as leadCall.id for leadCall in vm.leadcalls track by leadCall.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.leadOffer.offerStatus\" for=\"field_offerStatus\">Offer Status</label><select class=\"form-control\" id=\"field_offerStatus\" name=\"offerStatus\" ng-model=\"vm.leadOffer.offerStatus\" ng-options=\"offerStatus as offerStatus.id for offerStatus in vm.offerstatuses track by offerStatus.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/lead-offer/lead-offers.html","<div><h2 translate=\"sigmasfApp.leadOffer.home.title\">Lead Offers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"lead-offer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.leadOffer.home.createLabel\">Create new Lead Offer</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstEstimationDate\"><span translate=\"sigmasfApp.leadOffer.firstEstimationDate\">First Estimation Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wantsTransportation\"><span translate=\"sigmasfApp.leadOffer.wantsTransportation\">Wants Transportation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"attendantMeal\"><span translate=\"sigmasfApp.leadOffer.attendantMeal\">Attendant Meal</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hasCompetitiveBid\"><span translate=\"sigmasfApp.leadOffer.hasCompetitiveBid\">Has Competitive Bid</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"openHospitalizationReference\"><span translate=\"sigmasfApp.leadOffer.openHospitalizationReference\">Open Hospitalization Reference</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roomServices\"><span translate=\"sigmasfApp.leadOffer.roomServices\">Room Services</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comments\"><span translate=\"sigmasfApp.leadOffer.comments\">Comments</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"invitationText\"><span translate=\"sigmasfApp.leadOffer.invitationText\">Invitation Text</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"costType.id\"><span translate=\"sigmasfApp.leadOffer.costType\">Cost Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roomType.id\"><span translate=\"sigmasfApp.leadOffer.roomType\">Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"transportation.id\"><span translate=\"sigmasfApp.leadOffer.transportation\">Transportation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"competitor.id\"><span translate=\"sigmasfApp.leadOffer.competitor\">Competitor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"desirableRoomType.id\"><span translate=\"sigmasfApp.leadOffer.desirableRoomType\">Desirable Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"upgradedRoomType.id\"><span translate=\"sigmasfApp.leadOffer.upgradedRoomType\">Upgraded Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadDiscount.id\"><span translate=\"sigmasfApp.leadOffer.leadDiscount\">Lead Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"leadCall.id\"><span translate=\"sigmasfApp.leadOffer.leadCall\">Lead Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"offerStatus.id\"><span translate=\"sigmasfApp.leadOffer.offerStatus\">Offer Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"leadOffer in vm.leadOffers track by leadOffer.id\"><td><a ui-sref=\"lead-offer-detail({id:leadOffer.id})\">{{leadOffer.id}}</a></td><td>{{leadOffer.firstEstimationDate | date:\'medium\'}}</td><td>{{leadOffer.wantsTransportation}}</td><td>{{leadOffer.attendantMeal}}</td><td>{{leadOffer.hasCompetitiveBid}}</td><td>{{leadOffer.openHospitalizationReference}}</td><td>{{leadOffer.roomServices}}</td><td>{{leadOffer.comments}}</td><td>{{leadOffer.invitationText}}</td><td><a ui-sref=\"cost-type-detail({id:leadOffer.costType.id})\">{{leadOffer.costType.id}}</a></td><td><a ui-sref=\"room-type-detail({id:leadOffer.roomType.id})\">{{leadOffer.roomType.id}}</a></td><td><a ui-sref=\"transportation-detail({id:leadOffer.transportation.id})\">{{leadOffer.transportation.id}}</a></td><td><a ui-sref=\"competitor-detail({id:leadOffer.competitor.id})\">{{leadOffer.competitor.id}}</a></td><td><a ui-sref=\"room-type-detail({id:leadOffer.desirableRoomType.id})\">{{leadOffer.desirableRoomType.id}}</a></td><td><a ui-sref=\"room-type-detail({id:leadOffer.upgradedRoomType.id})\">{{leadOffer.upgradedRoomType.id}}</a></td><td><a ui-sref=\"lead-discount-detail({id:leadOffer.leadDiscount.id})\">{{leadOffer.leadDiscount.id}}</a></td><td><a ui-sref=\"lead-call-detail({id:leadOffer.leadCall.id})\">{{leadOffer.leadCall.id}}</a></td><td><a ui-sref=\"offer-status-detail({id:leadOffer.offerStatus.id})\">{{leadOffer.offerStatus.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"lead-offer-detail({id:leadOffer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"lead-offer.edit({id:leadOffer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"lead-offer.delete({id:leadOffer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/measurement-unit/measurement-unit-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.measurementUnit.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.measurementUnit.delete.question\" translate-values=\"{id: \'{{vm.measurementUnit.id}}\'}\">Are you sure you want to delete this Measurement Unit?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/measurement-unit/measurement-unit-detail.html","<div><h2><span translate=\"sigmasfApp.measurementUnit.detail.title\">Measurement Unit</span> {{vm.measurementUnit.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.measurementUnit.name\">Name</span></dt><dd><span>{{vm.measurementUnit.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/measurement-unit/measurement-unit-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMeasurementUnitLabel\" translate=\"sigmasfApp.measurementUnit.home.createOrEditLabel\">Create or edit a Measurement Unit</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.measurementUnit.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.measurementUnit.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.measurementUnit.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.measurementUnit.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/measurement-unit/measurement-units.html","<div><h2 translate=\"sigmasfApp.measurementUnit.home.title\">Measurement Units</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"measurement-unit.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.measurementUnit.home.createLabel\">Create new Measurement Unit</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.measurementUnit.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.measurementUnit.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"measurementUnit in vm.measurementUnits track by measurementUnit.id\"><td><a ui-sref=\"measurement-unit-detail({id:measurementUnit.id})\">{{measurementUnit.id}}</a></td><td>{{measurementUnit.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"measurement-unit-detail({id:measurementUnit.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"measurement-unit.edit({id:measurementUnit.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"measurement-unit.delete({id:measurementUnit.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/med-report/med-report-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.medReport.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.medReport.delete.question\" translate-values=\"{id: \'{{vm.medReport.id}}\'}\">Are you sure you want to delete this Med Report?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/med-report/med-report-detail.html","<div><h2><span translate=\"sigmasfApp.medReport.detail.title\">Med Report</span> {{vm.medReport.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.medReport.fromDate\">From Date</span></dt><dd><span>{{vm.medReport.fromDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.medReport.toDate\">To Date</span></dt><dd><span>{{vm.medReport.toDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.medReport.code\">Code</span></dt><dd><span>{{vm.medReport.code}}</span></dd><dt><span translate=\"sigmasfApp.medReport.checkDigit1\">Check Digit 1</span></dt><dd><span>{{vm.medReport.checkDigit1}}</span></dd><dt><span translate=\"sigmasfApp.medReport.checkDigit2\">Check Digit 2</span></dt><dd><span>{{vm.medReport.checkDigit2}}</span></dd><dt><span translate=\"sigmasfApp.medReport.isActive\">Is Active</span></dt><dd><span>{{vm.medReport.isActive}}</span></dd><dt><span translate=\"sigmasfApp.medReport.status\">Status</span></dt><dd><span translate=\"{{\'sigmasfApp.Status.\' + vm.medReport.status}}\">{{vm.medReport.status}}</span></dd><dt><span translate=\"sigmasfApp.medReport.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.medReport.customer.id})\">{{vm.medReport.customer.id}}</a></dd><dt><span translate=\"sigmasfApp.medReport.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.medReport.employee.id})\">{{vm.medReport.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/med-report/med-report-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMedReportLabel\" translate=\"sigmasfApp.medReport.home.createOrEditLabel\">Create or edit a Med Report</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.medReport.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.medReport.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.fromDate\" for=\"field_fromDate\">From Date</label><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.medReport.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.toDate\" for=\"field_toDate\">To Date</label><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.medReport.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.code\" for=\"field_code\">Code</label><input type=\"number\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.medReport.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.checkDigit1\" for=\"field_checkDigit1\">Check Digit 1</label><input type=\"number\" class=\"form-control\" name=\"checkDigit1\" id=\"field_checkDigit1\" ng-model=\"vm.medReport.checkDigit1\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.checkDigit2\" for=\"field_checkDigit2\">Check Digit 2</label><input type=\"number\" class=\"form-control\" name=\"checkDigit2\" id=\"field_checkDigit2\" ng-model=\"vm.medReport.checkDigit2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.isActive\" for=\"field_isActive\">Is Active</label><input type=\"checkbox\" class=\"form-control\" name=\"isActive\" id=\"field_isActive\" ng-model=\"vm.medReport.isActive\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReport.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.medReport.status\" id=\"field_status\"><option value=\"pending\" translate=\"sigmasfApp.Status.pending\">pending</option><option value=\"approved\" translate=\"sigmasfApp.Status.approved\">approved</option><option value=\"rejected\" translate=\"sigmasfApp.Status.rejected\">rejected</option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.medReport.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.medReport.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.medReport.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.medReport.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/med-report/med-reports.html","<div><h2 translate=\"sigmasfApp.medReport.home.title\">Med Reports</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"med-report.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.medReport.home.createLabel\">Create new Med Report</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromDate\"><span translate=\"sigmasfApp.medReport.fromDate\">From Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toDate\"><span translate=\"sigmasfApp.medReport.toDate\">To Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.medReport.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"checkDigit1\"><span translate=\"sigmasfApp.medReport.checkDigit1\">Check Digit 1</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"checkDigit2\"><span translate=\"sigmasfApp.medReport.checkDigit2\">Check Digit 2</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isActive\"><span translate=\"sigmasfApp.medReport.isActive\">Is Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sigmasfApp.medReport.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span translate=\"sigmasfApp.medReport.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.medReport.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"medReport in vm.medReports track by medReport.id\"><td><a ui-sref=\"med-report-detail({id:medReport.id})\">{{medReport.id}}</a></td><td>{{medReport.fromDate | date:\'mediumDate\'}}</td><td>{{medReport.toDate | date:\'mediumDate\'}}</td><td>{{medReport.code}}</td><td>{{medReport.checkDigit1}}</td><td>{{medReport.checkDigit2}}</td><td>{{medReport.isActive}}</td><td translate=\"{{\'sigmasfApp.Status.\' + medReport.status}}\">{{medReport.status}}</td><td><a ui-sref=\"customer-detail({id:medReport.customer.id})\">{{medReport.customer.id}}</a></td><td><a ui-sref=\"employee-detail({id:medReport.employee.id})\">{{medReport.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"med-report-detail({id:medReport.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"med-report.edit({id:medReport.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"med-report.delete({id:medReport.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/med-report-line/med-report-line-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.medReportLine.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.medReportLine.delete.question\" translate-values=\"{id: \'{{vm.medReportLine.id}}\'}\">Are you sure you want to delete this Med Report Line?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/med-report-line/med-report-line-detail.html","<div><h2><span translate=\"sigmasfApp.medReportLine.detail.title\">Med Report Line</span> {{vm.medReportLine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.medReportLine.code\">Code</span></dt><dd><span>{{vm.medReportLine.code}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.aQuantity\">A Quantity</span></dt><dd><span>{{vm.medReportLine.aQuantity}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.bQuantity\">B Quantity</span></dt><dd><span>{{vm.medReportLine.bQuantity}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.sum\">Sum</span></dt><dd><span>{{vm.medReportLine.sum}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.marketSharePercentage\">Market Share Percentage</span></dt><dd><span>{{vm.medReportLine.marketSharePercentage}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.numberOfChanges\">Number Of Changes</span></dt><dd><span>{{vm.medReportLine.numberOfChanges}}</span></dd><dt><span translate=\"sigmasfApp.medReportLine.medReport\">Med Report</span></dt><dd><a ui-sref=\"med-report-detail({id:vm.medReportLine.medReport.id})\">{{vm.medReportLine.medReport.id}}</a></dd><dt><span translate=\"sigmasfApp.medReportLine.medicine\">Medicine</span></dt><dd><a ui-sref=\"medicine-detail({id:vm.medReportLine.medicine.id})\">{{vm.medReportLine.medicine.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/med-report-line/med-report-line-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMedReportLineLabel\" translate=\"sigmasfApp.medReportLine.home.createOrEditLabel\">Create or edit a Med Report Line</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.medReportLine.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.medReportLine.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.medReportLine.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.aQuantity\" for=\"field_aQuantity\">A Quantity</label><input type=\"number\" class=\"form-control\" name=\"aQuantity\" id=\"field_aQuantity\" ng-model=\"vm.medReportLine.aQuantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.bQuantity\" for=\"field_bQuantity\">B Quantity</label><input type=\"number\" class=\"form-control\" name=\"bQuantity\" id=\"field_bQuantity\" ng-model=\"vm.medReportLine.bQuantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.sum\" for=\"field_sum\">Sum</label><input type=\"number\" class=\"form-control\" name=\"sum\" id=\"field_sum\" ng-model=\"vm.medReportLine.sum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.marketSharePercentage\" for=\"field_marketSharePercentage\">Market Share Percentage</label><input type=\"number\" class=\"form-control\" name=\"marketSharePercentage\" id=\"field_marketSharePercentage\" ng-model=\"vm.medReportLine.marketSharePercentage\" min=\"0\" max=\"100\"><div ng-show=\"editForm.marketSharePercentage.$invalid\"><p class=\"help-block\" ng-show=\"editForm.marketSharePercentage.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.marketSharePercentage.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"100\">This field cannot be more than 100.</p><p class=\"help-block\" ng-show=\"editForm.marketSharePercentage.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medReportLine.numberOfChanges\" for=\"field_numberOfChanges\">Number Of Changes</label><input type=\"number\" class=\"form-control\" name=\"numberOfChanges\" id=\"field_numberOfChanges\" ng-model=\"vm.medReportLine.numberOfChanges\" min=\"0\"><div ng-show=\"editForm.numberOfChanges.$invalid\"><p class=\"help-block\" ng-show=\"editForm.numberOfChanges.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.numberOfChanges.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.medReportLine.medReport\" for=\"field_medReport\">Med Report</label><select class=\"form-control\" id=\"field_medReport\" name=\"medReport\" ng-model=\"vm.medReportLine.medReport\" ng-options=\"medReport as medReport.id for medReport in vm.medreports track by medReport.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.medReportLine.medicine\" for=\"field_medicine\">Medicine</label><select class=\"form-control\" id=\"field_medicine\" name=\"medicine\" ng-model=\"vm.medReportLine.medicine\" ng-options=\"medicine as medicine.name for medicine in vm.medicines track by medicine.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/med-report-line/med-report-lines.html","<div><h2 translate=\"sigmasfApp.medReportLine.home.title\">Med Report Lines</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"med-report-line.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.medReportLine.home.createLabel\">Create new Med Report Line</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.medReportLine.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"aQuantity\"><span translate=\"sigmasfApp.medReportLine.aQuantity\">A Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bQuantity\"><span translate=\"sigmasfApp.medReportLine.bQuantity\">B Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sum\"><span translate=\"sigmasfApp.medReportLine.sum\">Sum</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"marketSharePercentage\"><span translate=\"sigmasfApp.medReportLine.marketSharePercentage\">Market Share Percentage</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"numberOfChanges\"><span translate=\"sigmasfApp.medReportLine.numberOfChanges\">Number Of Changes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"medReport.id\"><span translate=\"sigmasfApp.medReportLine.medReport\">Med Report</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"medicine.name\"><span translate=\"sigmasfApp.medReportLine.medicine\">Medicine</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"medReportLine in vm.medReportLines track by medReportLine.id\"><td><a ui-sref=\"med-report-line-detail({id:medReportLine.id})\">{{medReportLine.id}}</a></td><td>{{medReportLine.code}}</td><td>{{medReportLine.aQuantity}}</td><td>{{medReportLine.bQuantity}}</td><td>{{medReportLine.sum}}</td><td>{{medReportLine.marketSharePercentage}}</td><td>{{medReportLine.numberOfChanges}}</td><td><a ui-sref=\"med-report-detail({id:medReportLine.medReport.id})\">{{medReportLine.medReport.id}}</a></td><td><a ui-sref=\"medicine-detail({id:medReportLine.medicine.id})\">{{medReportLine.medicine.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"med-report-line-detail({id:medReportLine.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"med-report-line.edit({id:medReportLine.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"med-report-line.delete({id:medReportLine.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/native-language/native-language-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.nativeLanguage.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.nativeLanguage.delete.question\" translate-values=\"{id: \'{{vm.nativeLanguage.id}}\'}\">Are you sure you want to delete this Native Language?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/native-language/native-language-detail.html","<div><h2><span translate=\"sigmasfApp.nativeLanguage.detail.title\">Native Language</span> {{vm.nativeLanguage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.nativeLanguage.name\">Name</span></dt><dd><span>{{vm.nativeLanguage.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/native-language/native-language-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myNativeLanguageLabel\" translate=\"sigmasfApp.nativeLanguage.home.createOrEditLabel\">Create or edit a Native Language</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.nativeLanguage.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.nativeLanguage.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.nativeLanguage.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.nativeLanguage.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/native-language/native-languages.html","<div><h2 translate=\"sigmasfApp.nativeLanguage.home.title\">Native Languages</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"native-language.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.nativeLanguage.home.createLabel\">Create new Native Language</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.nativeLanguage.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"nativeLanguage in vm.nativeLanguages track by nativeLanguage.id\"><td><a ui-sref=\"native-language-detail({id:nativeLanguage.id})\">{{nativeLanguage.id}}</a></td><td>{{nativeLanguage.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"native-language-detail({id:nativeLanguage.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"native-language.edit({id:nativeLanguage.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"native-language.delete({id:nativeLanguage.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/other-event/other-event-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.otherEvent.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.otherEvent.delete.question\" translate-values=\"{id: \'{{vm.otherEvent.id}}\'}\">Are you sure you want to delete this Other Event?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/other-event/other-event-detail.html","<div><h2><span translate=\"sigmasfApp.otherEvent.detail.title\">Other Event</span> {{vm.otherEvent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.otherEvent.title\">Title</span></dt><dd><span>{{vm.otherEvent.title}}</span></dd><dt><span translate=\"sigmasfApp.otherEvent.description\">Description</span></dt><dd><span>{{vm.otherEvent.description}}</span></dd><dt><span translate=\"sigmasfApp.otherEvent.dateFrom\">Date From</span></dt><dd><span>{{vm.otherEvent.dateFrom | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.otherEvent.dateTo\">Date To</span></dt><dd><span>{{vm.otherEvent.dateTo | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.otherEvent.eventCategoryType\">Event Category Type</span></dt><dd><a ui-sref=\"event-category-type-detail({id:vm.otherEvent.eventCategoryType.id})\">{{vm.otherEvent.eventCategoryType.id}}</a></dd><dt><span translate=\"sigmasfApp.otherEvent.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.otherEvent.employee.id})\">{{vm.otherEvent.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/other-event/other-event-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOtherEventLabel\" translate=\"sigmasfApp.otherEvent.home.createOrEditLabel\">Create or edit a Other Event</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.otherEvent.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.otherEvent.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.otherEvent.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.otherEvent.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.otherEvent.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.otherEvent.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.otherEvent.dateFrom\" for=\"field_dateFrom\">Date From</label><div class=\"input-group\"><input id=\"field_dateFrom\" type=\"text\" class=\"form-control\" name=\"dateFrom\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.otherEvent.dateFrom\" is-open=\"vm.datePickerOpenStatus.dateFrom\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateFrom.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.otherEvent.dateTo\" for=\"field_dateTo\">Date To</label><div class=\"input-group\"><input id=\"field_dateTo\" type=\"text\" class=\"form-control\" name=\"dateTo\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.otherEvent.dateTo\" is-open=\"vm.datePickerOpenStatus.dateTo\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateTo.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateTo.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.dateTo.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.otherEvent.eventCategoryType\" for=\"field_eventCategoryType\">Event Category Type</label><select class=\"form-control\" id=\"field_eventCategoryType\" name=\"eventCategoryType\" ng-model=\"vm.otherEvent.eventCategoryType\" ng-options=\"eventCategoryType as eventCategoryType.id for eventCategoryType in vm.eventcategorytypes track by eventCategoryType.id\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.eventCategoryType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.eventCategoryType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"sigmasfApp.otherEvent.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.otherEvent.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/other-event/other-events.html","<div><h2 translate=\"sigmasfApp.otherEvent.home.title\">Other Events</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"other-event.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.otherEvent.home.createLabel\">Create new Other Event</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"sigmasfApp.otherEvent.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.otherEvent.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateFrom\"><span translate=\"sigmasfApp.otherEvent.dateFrom\">Date From</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateTo\"><span translate=\"sigmasfApp.otherEvent.dateTo\">Date To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventCategoryType.id\"><span translate=\"sigmasfApp.otherEvent.eventCategoryType\">Event Category Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.otherEvent.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"otherEvent in vm.otherEvents track by otherEvent.id\"><td><a ui-sref=\"other-event-detail({id:otherEvent.id})\">{{otherEvent.id}}</a></td><td>{{otherEvent.title}}</td><td>{{otherEvent.description}}</td><td>{{otherEvent.dateFrom | date:\'medium\'}}</td><td>{{otherEvent.dateTo | date:\'medium\'}}</td><td><a ui-sref=\"event-category-type-detail({id:otherEvent.eventCategoryType.id})\">{{otherEvent.eventCategoryType.id}}</a></td><td><a ui-sref=\"employee-detail({id:otherEvent.employee.id})\">{{otherEvent.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"other-event-detail({id:otherEvent.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"other-event.edit({id:otherEvent.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"other-event.delete({id:otherEvent.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/medicine/medicine-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.medicine.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.medicine.delete.question\" translate-values=\"{id: \'{{vm.medicine.id}}\'}\">Are you sure you want to delete this Medicine?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/medicine/medicine-detail.html","<div><h2><span translate=\"sigmasfApp.medicine.detail.title\">Medicine</span> {{vm.medicine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.medicine.barcode\">Barcode</span></dt><dd><span>{{vm.medicine.barcode}}</span></dd><dt><span translate=\"sigmasfApp.medicine.pairCode\">Pair Code</span></dt><dd><span>{{vm.medicine.pairCode}}</span></dd><dt><span translate=\"sigmasfApp.medicine.name\">Name</span></dt><dd><span>{{vm.medicine.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/medicine/medicine-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMedicineLabel\" translate=\"sigmasfApp.medicine.home.createOrEditLabel\">Create or edit a Medicine</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.medicine.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.medicine.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medicine.barcode\" for=\"field_barcode\">Barcode</label><input type=\"text\" class=\"form-control\" name=\"barcode\" id=\"field_barcode\" ng-model=\"vm.medicine.barcode\" required><div ng-show=\"editForm.barcode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.barcode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medicine.pairCode\" for=\"field_pairCode\">Pair Code</label><input type=\"text\" class=\"form-control\" name=\"pairCode\" id=\"field_pairCode\" ng-model=\"vm.medicine.pairCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.medicine.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.medicine.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/medicine/medicines.html","<div><h2 translate=\"sigmasfApp.medicine.home.title\">Medicines</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"medicine.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.medicine.home.createLabel\">Create new Medicine</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"barcode\"><span translate=\"sigmasfApp.medicine.barcode\">Barcode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pairCode\"><span translate=\"sigmasfApp.medicine.pairCode\">Pair Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.medicine.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"medicine in vm.medicines track by medicine.id\"><td><a ui-sref=\"medicine-detail({id:medicine.id})\">{{medicine.id}}</a></td><td>{{medicine.barcode}}</td><td>{{medicine.pairCode}}</td><td>{{medicine.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"medicine-detail({id:medicine.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"medicine.edit({id:medicine.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"medicine.delete({id:medicine.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/offer-status/offer-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.offerStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.offerStatus.delete.question\" translate-values=\"{id: \'{{vm.offerStatus.id}}\'}\">Are you sure you want to delete this Offer Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/offer-status/offer-status-detail.html","<div><h2><span translate=\"sigmasfApp.offerStatus.detail.title\">Offer Status</span> {{vm.offerStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.offerStatus.name\">Name</span></dt><dd><span>{{vm.offerStatus.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/offer-status/offer-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOfferStatusLabel\" translate=\"sigmasfApp.offerStatus.home.createOrEditLabel\">Create or edit a Offer Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.offerStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.offerStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.offerStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.offerStatus.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/offer-status/offer-statuses.html","<div><h2 translate=\"sigmasfApp.offerStatus.home.title\">Offer Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"offer-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.offerStatus.home.createLabel\">Create new Offer Status</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.offerStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"offerStatus in vm.offerStatuses track by offerStatus.id\"><td><a ui-sref=\"offer-status-detail({id:offerStatus.id})\">{{offerStatus.id}}</a></td><td>{{offerStatus.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"offer-status-detail({id:offerStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"offer-status.edit({id:offerStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"offer-status.delete({id:offerStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-customer/patch-customer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchCustomer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchCustomer.delete.question\" translate-values=\"{id: \'{{vm.patchCustomer.id}}\'}\">Are you sure you want to delete this Patch Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-customer/patch-customer-detail.html","<div><h2><span translate=\"sigmasfApp.patchCustomer.detail.title\">Patch Customer</span> {{vm.patchCustomer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchCustomer.amka\">Amka</span></dt><dd><span>{{vm.patchCustomer.amka}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.dateOfBirth\">Date Of Birth</span></dt><dd><span>{{vm.patchCustomer.dateOfBirth | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.firstName\">First Name</span></dt><dd><span>{{vm.patchCustomer.firstName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.lastName\">Last Name</span></dt><dd><span>{{vm.patchCustomer.lastName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.directName\">Direct Name</span></dt><dd><span>{{vm.patchCustomer.directName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.directAmka\">Direct Amka</span></dt><dd><span>{{vm.patchCustomer.directAmka}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.directAma\">Direct Ama</span></dt><dd><span>{{vm.patchCustomer.directAma}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.phone\">Phone</span></dt><dd><span>{{vm.patchCustomer.phone}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.mobile\">Mobile</span></dt><dd><span>{{vm.patchCustomer.mobile}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.addressNum\">Address Num</span></dt><dd><span>{{vm.patchCustomer.addressNum}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.address\">Address</span></dt><dd><span>{{vm.patchCustomer.address}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.postalCode\">Postal Code</span></dt><dd><span>{{vm.patchCustomer.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.cityName\">City Name</span></dt><dd><span>{{vm.patchCustomer.cityName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.prefectureName\">Prefecture Name</span></dt><dd><span>{{vm.patchCustomer.prefectureName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.regionName\">Region Name</span></dt><dd><span>{{vm.patchCustomer.regionName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.countryName\">Country Name</span></dt><dd><span>{{vm.patchCustomer.countryName}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.legacyCode\">Legacy Code</span></dt><dd><span>{{vm.patchCustomer.legacyCode}}</span></dd><dt><span translate=\"sigmasfApp.patchCustomer.socialInsurance\">Social Insurance</span></dt><dd><a ui-sref=\"social-insurance-detail({id:vm.patchCustomer.socialInsurance.id})\">{{vm.patchCustomer.socialInsurance.id}}</a></dd><dt><span translate=\"sigmasfApp.patchCustomer.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.patchCustomer.country.id})\">{{vm.patchCustomer.country.id}}</a></dd><dt><span translate=\"sigmasfApp.patchCustomer.region\">Region</span></dt><dd><a ui-sref=\"region-detail({id:vm.patchCustomer.region.id})\">{{vm.patchCustomer.region.id}}</a></dd><dt><span translate=\"sigmasfApp.patchCustomer.prefecture\">Prefecture</span></dt><dd><a ui-sref=\"prefecture-detail({id:vm.patchCustomer.prefecture.id})\">{{vm.patchCustomer.prefecture.id}}</a></dd><dt><span translate=\"sigmasfApp.patchCustomer.city\">City</span></dt><dd><a ui-sref=\"city-detail({id:vm.patchCustomer.city.id})\">{{vm.patchCustomer.city.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-customer/patch-customer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchCustomerLabel\" translate=\"sigmasfApp.patchCustomer.home.createOrEditLabel\">Create or edit a Patch Customer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchCustomer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchCustomer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.amka\" for=\"field_amka\">Amka</label><input type=\"text\" class=\"form-control\" name=\"amka\" id=\"field_amka\" ng-model=\"vm.patchCustomer.amka\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.dateOfBirth\" for=\"field_dateOfBirth\">Date Of Birth</label><div class=\"input-group\"><input id=\"field_dateOfBirth\" type=\"text\" class=\"form-control\" name=\"dateOfBirth\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.patchCustomer.dateOfBirth\" is-open=\"vm.datePickerOpenStatus.dateOfBirth\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateOfBirth\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.firstName\" for=\"field_firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.patchCustomer.firstName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.patchCustomer.lastName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.directName\" for=\"field_directName\">Direct Name</label><input type=\"text\" class=\"form-control\" name=\"directName\" id=\"field_directName\" ng-model=\"vm.patchCustomer.directName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.directAmka\" for=\"field_directAmka\">Direct Amka</label><input type=\"text\" class=\"form-control\" name=\"directAmka\" id=\"field_directAmka\" ng-model=\"vm.patchCustomer.directAmka\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.directAma\" for=\"field_directAma\">Direct Ama</label><input type=\"text\" class=\"form-control\" name=\"directAma\" id=\"field_directAma\" ng-model=\"vm.patchCustomer.directAma\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.patchCustomer.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.mobile\" for=\"field_mobile\">Mobile</label><input type=\"text\" class=\"form-control\" name=\"mobile\" id=\"field_mobile\" ng-model=\"vm.patchCustomer.mobile\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.addressNum\" for=\"field_addressNum\">Address Num</label><input type=\"text\" class=\"form-control\" name=\"addressNum\" id=\"field_addressNum\" ng-model=\"vm.patchCustomer.addressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.patchCustomer.address\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.patchCustomer.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.cityName\" for=\"field_cityName\">City Name</label><input type=\"text\" class=\"form-control\" name=\"cityName\" id=\"field_cityName\" ng-model=\"vm.patchCustomer.cityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.prefectureName\" for=\"field_prefectureName\">Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"prefectureName\" id=\"field_prefectureName\" ng-model=\"vm.patchCustomer.prefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.regionName\" for=\"field_regionName\">Region Name</label><input type=\"text\" class=\"form-control\" name=\"regionName\" id=\"field_regionName\" ng-model=\"vm.patchCustomer.regionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.countryName\" for=\"field_countryName\">Country Name</label><input type=\"text\" class=\"form-control\" name=\"countryName\" id=\"field_countryName\" ng-model=\"vm.patchCustomer.countryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchCustomer.legacyCode\" for=\"field_legacyCode\">Legacy Code</label><input type=\"text\" class=\"form-control\" name=\"legacyCode\" id=\"field_legacyCode\" ng-model=\"vm.patchCustomer.legacyCode\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchCustomer.socialInsurance\" for=\"field_socialInsurance\">Social Insurance</label><select class=\"form-control\" id=\"field_socialInsurance\" name=\"socialInsurance\" ng-model=\"vm.patchCustomer.socialInsurance\" ng-options=\"socialInsurance as socialInsurance.id for socialInsurance in vm.socialinsurances track by socialInsurance.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchCustomer.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.patchCustomer.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchCustomer.region\" for=\"field_region\">Region</label><select class=\"form-control\" id=\"field_region\" name=\"region\" ng-model=\"vm.patchCustomer.region\" ng-options=\"region as region.id for region in vm.regions track by region.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchCustomer.prefecture\" for=\"field_prefecture\">Prefecture</label><select class=\"form-control\" id=\"field_prefecture\" name=\"prefecture\" ng-model=\"vm.patchCustomer.prefecture\" ng-options=\"prefecture as prefecture.id for prefecture in vm.prefectures track by prefecture.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchCustomer.city\" for=\"field_city\">City</label><select class=\"form-control\" id=\"field_city\" name=\"city\" ng-model=\"vm.patchCustomer.city\" ng-options=\"city as city.id for city in vm.cities track by city.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-customer/patch-customers.html","<div><h2 translate=\"sigmasfApp.patchCustomer.home.title\">Patch Customers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-customer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.patchCustomer.home.createLabel\">Create new Patch Customer</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.patchCustomer.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amka\"><span translate=\"sigmasfApp.patchCustomer.amka\">Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateOfBirth\"><span translate=\"sigmasfApp.patchCustomer.dateOfBirth\">Date Of Birth</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.patchCustomer.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.patchCustomer.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"directName\"><span translate=\"sigmasfApp.patchCustomer.directName\">Direct Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"directAmka\"><span translate=\"sigmasfApp.patchCustomer.directAmka\">Direct Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"directAma\"><span translate=\"sigmasfApp.patchCustomer.directAma\">Direct Ama</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.patchCustomer.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mobile\"><span translate=\"sigmasfApp.patchCustomer.mobile\">Mobile</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressNum\"><span translate=\"sigmasfApp.patchCustomer.addressNum\">Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"sigmasfApp.patchCustomer.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.patchCustomer.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cityName\"><span translate=\"sigmasfApp.patchCustomer.cityName\">City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefectureName\"><span translate=\"sigmasfApp.patchCustomer.prefectureName\">Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"regionName\"><span translate=\"sigmasfApp.patchCustomer.regionName\">Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryName\"><span translate=\"sigmasfApp.patchCustomer.countryName\">Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"legacyCode\"><span translate=\"sigmasfApp.patchCustomer.legacyCode\">Legacy Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"socialInsurance.id\"><span translate=\"sigmasfApp.patchCustomer.socialInsurance\">Social Insurance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country.id\"><span translate=\"sigmasfApp.patchCustomer.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region.id\"><span translate=\"sigmasfApp.patchCustomer.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture.id\"><span translate=\"sigmasfApp.patchCustomer.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city.id\"><span translate=\"sigmasfApp.patchCustomer.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchCustomer in vm.patchCustomers track by patchCustomer.id\"><td><a ui-sref=\"patch-customer-detail({id:patchCustomer.id})\">{{patchCustomer.id}}</a></td><td>{{patchCustomer.amka}}</td><td>{{patchCustomer.dateOfBirth | date:\'mediumDate\'}}</td><td>{{patchCustomer.firstName}}</td><td>{{patchCustomer.lastName}}</td><td>{{patchCustomer.directName}}</td><td>{{patchCustomer.directAmka}}</td><td>{{patchCustomer.directAma}}</td><td>{{patchCustomer.phone}}</td><td>{{patchCustomer.mobile}}</td><td>{{patchCustomer.addressNum}}</td><td>{{patchCustomer.address}}</td><td>{{patchCustomer.postalCode}}</td><td>{{patchCustomer.cityName}}</td><td>{{patchCustomer.prefectureName}}</td><td>{{patchCustomer.regionName}}</td><td>{{patchCustomer.countryName}}</td><td>{{patchCustomer.legacyCode}}</td><td><a ui-sref=\"social-insurance-detail({id:patchCustomer.socialInsurance.id})\">{{patchCustomer.socialInsurance.id}}</a></td><td><a ui-sref=\"country-detail({id:patchCustomer.country.id})\">{{patchCustomer.country.id}}</a></td><td><a ui-sref=\"region-detail({id:patchCustomer.region.id})\">{{patchCustomer.region.id}}</a></td><td><a ui-sref=\"prefecture-detail({id:patchCustomer.prefecture.id})\">{{patchCustomer.prefecture.id}}</a></td><td><a ui-sref=\"city-detail({id:patchCustomer.city.id})\">{{patchCustomer.city.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-customer-detail({id:patchCustomer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-customer.edit({id:patchCustomer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-customer.delete({id:patchCustomer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-item/patch-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchItem.delete.question\" translate-values=\"{id: \'{{vm.patchItem.id}}\'}\">Are you sure you want to delete this Patch Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-item/patch-item-detail.html","<div><h2><span translate=\"sigmasfApp.patchItem.detail.title\">Patch Item</span> {{vm.patchItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchItem.name\">Name</span></dt><dd><span>{{vm.patchItem.name}}</span></dd><dt><span translate=\"sigmasfApp.patchItem.legacyCode\">Legacy Code</span></dt><dd><span>{{vm.patchItem.legacyCode}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-item/patch-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchItemLabel\" translate=\"sigmasfApp.patchItem.home.createOrEditLabel\">Create or edit a Patch Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchItem.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.patchItem.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchItem.legacyCode\" for=\"field_legacyCode\">Legacy Code</label><input type=\"text\" class=\"form-control\" name=\"legacyCode\" id=\"field_legacyCode\" ng-model=\"vm.patchItem.legacyCode\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-item/patch-items.html","<div><h2 translate=\"sigmasfApp.patchItem.home.title\">Patch Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.patchItem.home.createLabel\">Create new Patch Item</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.patchItem.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.patchItem.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"legacyCode\"><span translate=\"sigmasfApp.patchItem.legacyCode\">Legacy Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchItem in vm.patchItems track by patchItem.id\"><td><a ui-sref=\"patch-item-detail({id:patchItem.id})\">{{patchItem.id}}</a></td><td>{{patchItem.name}}</td><td>{{patchItem.legacyCode}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-item-detail({id:patchItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-item.edit({id:patchItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-item.delete({id:patchItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-report/patch-report-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchReport.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchReport.delete.question\" translate-values=\"{id: \'{{vm.patchReport.id}}\'}\">Are you sure you want to delete this Patch Report?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-report/patch-report-detail.html","<div><h2><span translate=\"sigmasfApp.patchReport.detail.title\">Patch Report</span> {{vm.patchReport.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchReport.barcode\">Barcode</span></dt><dd><span>{{vm.patchReport.barcode}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.issueDate\">Issue Date</span></dt><dd><span>{{vm.patchReport.issueDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.submitPoint\">Submit Point</span></dt><dd><span>{{vm.patchReport.submitPoint}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.durationInMonths\">Duration In Months</span></dt><dd><span>{{vm.patchReport.durationInMonths}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.comment\">Comment</span></dt><dd><span>{{vm.patchReport.comment}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.patchStatus\">Patch Status</span></dt><dd><span translate=\"{{\'sigmasfApp.PatchStatus.\' + vm.patchReport.patchStatus}}\">{{vm.patchReport.patchStatus}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.executedBy\">Executed By</span></dt><dd><span>{{vm.patchReport.executedBy}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.executedDate\">Executed Date</span></dt><dd><span>{{vm.patchReport.executedDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.latitude\">Latitude</span></dt><dd><span>{{vm.patchReport.latitude}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.longitude\">Longitude</span></dt><dd><span>{{vm.patchReport.longitude}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.checkDoctor\">Check Doctor</span></dt><dd><span>{{vm.patchReport.checkDoctor}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.approvalDate\">Approval Date</span></dt><dd><span>{{vm.patchReport.approvalDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.patchReport.patchCustomer\">Patch Customer</span></dt><dd><a ui-sref=\"patch-customer-detail({id:vm.patchReport.patchCustomer.id})\">{{vm.patchReport.patchCustomer.id}}</a></dd><dt><span translate=\"sigmasfApp.patchReport.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.patchReport.employee.id})\">{{vm.patchReport.employee.id}}</a></dd><dt><span translate=\"sigmasfApp.patchReport.materialCategory\">Material Category</span></dt><dd><a ui-sref=\"patch-report-material-category-detail({id:vm.patchReport.materialCategory.id})\">{{vm.patchReport.materialCategory.id}}</a></dd><dt><span translate=\"sigmasfApp.patchReport.customerSector\">Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.patchReport.customerSector.id})\">{{vm.patchReport.customerSector.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-report/patch-report-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchReportLabel\" translate=\"sigmasfApp.patchReport.home.createOrEditLabel\">Create or edit a Patch Report</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchReport.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchReport.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.barcode\" for=\"field_barcode\">Barcode</label><input type=\"text\" class=\"form-control\" name=\"barcode\" id=\"field_barcode\" ng-model=\"vm.patchReport.barcode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.issueDate\" for=\"field_issueDate\">Issue Date</label><div class=\"input-group\"><input id=\"field_issueDate\" type=\"text\" class=\"form-control\" name=\"issueDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.patchReport.issueDate\" is-open=\"vm.datePickerOpenStatus.issueDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issueDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.submitPoint\" for=\"field_submitPoint\">Submit Point</label><input type=\"text\" class=\"form-control\" name=\"submitPoint\" id=\"field_submitPoint\" ng-model=\"vm.patchReport.submitPoint\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.durationInMonths\" for=\"field_durationInMonths\">Duration In Months</label><input type=\"number\" class=\"form-control\" name=\"durationInMonths\" id=\"field_durationInMonths\" ng-model=\"vm.patchReport.durationInMonths\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.patchReport.comment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.patchStatus\" for=\"field_patchStatus\">Patch Status</label><select class=\"form-control\" name=\"patchStatus\" ng-model=\"vm.patchReport.patchStatus\" id=\"field_patchStatus\"><option value=\"pending\" translate=\"sigmasfApp.PatchStatus.pending\">pending</option><option value=\"executed\" translate=\"sigmasfApp.PatchStatus.executed\">executed</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.executedBy\" for=\"field_executedBy\">Executed By</label><input type=\"text\" class=\"form-control\" name=\"executedBy\" id=\"field_executedBy\" ng-model=\"vm.patchReport.executedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.executedDate\" for=\"field_executedDate\">Executed Date</label><div class=\"input-group\"><input id=\"field_executedDate\" type=\"text\" class=\"form-control\" name=\"executedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.patchReport.executedDate\" is-open=\"vm.datePickerOpenStatus.executedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'executedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.latitude\" for=\"field_latitude\">Latitude</label><input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.patchReport.latitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.longitude\" for=\"field_longitude\">Longitude</label><input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.patchReport.longitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.checkDoctor\" for=\"field_checkDoctor\">Check Doctor</label><input type=\"text\" class=\"form-control\" name=\"checkDoctor\" id=\"field_checkDoctor\" ng-model=\"vm.patchReport.checkDoctor\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReport.approvalDate\" for=\"field_approvalDate\">Approval Date</label><div class=\"input-group\"><input id=\"field_approvalDate\" type=\"text\" class=\"form-control\" name=\"approvalDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.patchReport.approvalDate\" is-open=\"vm.datePickerOpenStatus.approvalDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'approvalDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReport.patchCustomer\" for=\"field_patchCustomer\">Patch Customer</label><select class=\"form-control\" id=\"field_patchCustomer\" name=\"patchCustomer\" ng-model=\"vm.patchReport.patchCustomer\" ng-options=\"patchCustomer as patchCustomer.id for patchCustomer in vm.patchcustomers track by patchCustomer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReport.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.patchReport.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReport.materialCategory\" for=\"field_materialCategory\">Material Category</label><select class=\"form-control\" id=\"field_materialCategory\" name=\"materialCategory\" ng-model=\"vm.patchReport.materialCategory\" ng-options=\"patchReportMaterialCategory as patchReportMaterialCategory.id for patchReportMaterialCategory in vm.patchreportmaterialcategories track by patchReportMaterialCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReport.customerSector\" for=\"field_customerSector\">Customer Sector</label><select class=\"form-control\" id=\"field_customerSector\" name=\"customerSector\" ng-model=\"vm.patchReport.customerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.customersectors track by customerSector.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-report/patch-reports.html","<div><h2 translate=\"sigmasfApp.patchReport.home.title\">Patch Reports</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-report.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.patchReport.home.createLabel\">Create new Patch Report</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"barcode\"><span translate=\"sigmasfApp.patchReport.barcode\">Barcode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issueDate\"><span translate=\"sigmasfApp.patchReport.issueDate\">Issue Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"submitPoint\"><span translate=\"sigmasfApp.patchReport.submitPoint\">Submit Point</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"durationInMonths\"><span translate=\"sigmasfApp.patchReport.durationInMonths\">Duration In Months</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comment\"><span translate=\"sigmasfApp.patchReport.comment\">Comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchStatus\"><span translate=\"sigmasfApp.patchReport.patchStatus\">Patch Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"executedBy\"><span translate=\"sigmasfApp.patchReport.executedBy\">Executed By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"executedDate\"><span translate=\"sigmasfApp.patchReport.executedDate\">Executed Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span translate=\"sigmasfApp.patchReport.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span translate=\"sigmasfApp.patchReport.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"checkDoctor\"><span translate=\"sigmasfApp.patchReport.checkDoctor\">Check Doctor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"approvalDate\"><span translate=\"sigmasfApp.patchReport.approvalDate\">Approval Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchCustomer.id\"><span translate=\"sigmasfApp.patchReport.patchCustomer\">Patch Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.patchReport.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"materialCategory.id\"><span translate=\"sigmasfApp.patchReport.materialCategory\">Material Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSector.id\"><span translate=\"sigmasfApp.patchReport.customerSector\">Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchReport in vm.patchReports track by patchReport.id\"><td><a ui-sref=\"patch-report-detail({id:patchReport.id})\">{{patchReport.id}}</a></td><td>{{patchReport.barcode}}</td><td>{{patchReport.issueDate | date:\'mediumDate\'}}</td><td>{{patchReport.submitPoint}}</td><td>{{patchReport.durationInMonths}}</td><td>{{patchReport.comment}}</td><td translate=\"{{\'sigmasfApp.PatchStatus.\' + patchReport.patchStatus}}\">{{patchReport.patchStatus}}</td><td>{{patchReport.executedBy}}</td><td>{{patchReport.executedDate | date:\'medium\'}}</td><td>{{patchReport.latitude}}</td><td>{{patchReport.longitude}}</td><td>{{patchReport.checkDoctor}}</td><td>{{patchReport.approvalDate | date:\'medium\'}}</td><td><a ui-sref=\"patch-customer-detail({id:patchReport.patchCustomer.id})\">{{patchReport.patchCustomer.id}}</a></td><td><a ui-sref=\"employee-detail({id:patchReport.employee.id})\">{{patchReport.employee.id}}</a></td><td><a ui-sref=\"patch-report-material-category-detail({id:patchReport.materialCategory.id})\">{{patchReport.materialCategory.id}}</a></td><td><a ui-sref=\"customer-sector-detail({id:patchReport.customerSector.id})\">{{patchReport.customerSector.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-report-detail({id:patchReport.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-report.edit({id:patchReport.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-report.delete({id:patchReport.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-report-item/patch-report-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchReportItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchReportItem.delete.question\" translate-values=\"{id: \'{{vm.patchReportItem.id}}\'}\">Are you sure you want to delete this Patch Report Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-report-item/patch-report-item-detail.html","<div><h2><span translate=\"sigmasfApp.patchReportItem.detail.title\">Patch Report Item</span> {{vm.patchReportItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchReportItem.monthlyQuantity\">Monthly Quantity</span></dt><dd><span>{{vm.patchReportItem.monthlyQuantity}}</span></dd><dt><span translate=\"sigmasfApp.patchReportItem.durationInMonths\">Duration In Months</span></dt><dd><span>{{vm.patchReportItem.durationInMonths}}</span></dd><dt><span translate=\"sigmasfApp.patchReportItem.bodyArea\">Body Area</span></dt><dd><span>{{vm.patchReportItem.bodyArea}}</span></dd><dt><span translate=\"sigmasfApp.patchReportItem.participationPercent\">Participation Percent</span></dt><dd><span>{{vm.patchReportItem.participationPercent}}</span></dd><dt><span translate=\"sigmasfApp.patchReportItem.comment\">Comment</span></dt><dd><span>{{vm.patchReportItem.comment}}</span></dd><dt><span translate=\"sigmasfApp.patchReportItem.patchReport\">Patch Report</span></dt><dd><a ui-sref=\"patch-report-detail({id:vm.patchReportItem.patchReport.id})\">{{vm.patchReportItem.patchReport.id}}</a></dd><dt><span translate=\"sigmasfApp.patchReportItem.patchItem\">Patch Item</span></dt><dd><a ui-sref=\"patch-item-detail({id:vm.patchReportItem.patchItem.id})\">{{vm.patchReportItem.patchItem.id}}</a></dd><dt><span translate=\"sigmasfApp.patchReportItem.icd10\">Icd 10</span></dt><dd><a ui-sref=\"icd-10-detail({id:vm.patchReportItem.icd10.id})\">{{vm.patchReportItem.icd10.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-report-item/patch-report-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchReportItemLabel\" translate=\"sigmasfApp.patchReportItem.home.createOrEditLabel\">Create or edit a Patch Report Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchReportItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchReportItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportItem.monthlyQuantity\" for=\"field_monthlyQuantity\">Monthly Quantity</label><input type=\"number\" class=\"form-control\" name=\"monthlyQuantity\" id=\"field_monthlyQuantity\" ng-model=\"vm.patchReportItem.monthlyQuantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportItem.durationInMonths\" for=\"field_durationInMonths\">Duration In Months</label><input type=\"number\" class=\"form-control\" name=\"durationInMonths\" id=\"field_durationInMonths\" ng-model=\"vm.patchReportItem.durationInMonths\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportItem.bodyArea\" for=\"field_bodyArea\">Body Area</label><input type=\"text\" class=\"form-control\" name=\"bodyArea\" id=\"field_bodyArea\" ng-model=\"vm.patchReportItem.bodyArea\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportItem.participationPercent\" for=\"field_participationPercent\">Participation Percent</label><input type=\"number\" class=\"form-control\" name=\"participationPercent\" id=\"field_participationPercent\" ng-model=\"vm.patchReportItem.participationPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportItem.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.patchReportItem.comment\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReportItem.patchReport\" for=\"field_patchReport\">Patch Report</label><select class=\"form-control\" id=\"field_patchReport\" name=\"patchReport\" ng-model=\"vm.patchReportItem.patchReport\" ng-options=\"patchReport as patchReport.id for patchReport in vm.patchreports track by patchReport.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReportItem.patchItem\" for=\"field_patchItem\">Patch Item</label><select class=\"form-control\" id=\"field_patchItem\" name=\"patchItem\" ng-model=\"vm.patchReportItem.patchItem\" ng-options=\"patchItem as patchItem.id for patchItem in vm.patchitems track by patchItem.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReportItem.icd10\" for=\"field_icd10\">Icd 10</label><select class=\"form-control\" id=\"field_icd10\" name=\"icd10\" ng-model=\"vm.patchReportItem.icd10\" ng-options=\"icd10 as icd10.id for icd10 in vm.icd10s track by icd10.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-report-item/patch-report-items.html","<div><h2 translate=\"sigmasfApp.patchReportItem.home.title\">Patch Report Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-report-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.patchReportItem.home.createLabel\">Create new Patch Report Item</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"monthlyQuantity\"><span translate=\"sigmasfApp.patchReportItem.monthlyQuantity\">Monthly Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"durationInMonths\"><span translate=\"sigmasfApp.patchReportItem.durationInMonths\">Duration In Months</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bodyArea\"><span translate=\"sigmasfApp.patchReportItem.bodyArea\">Body Area</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"participationPercent\"><span translate=\"sigmasfApp.patchReportItem.participationPercent\">Participation Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comment\"><span translate=\"sigmasfApp.patchReportItem.comment\">Comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchReport.id\"><span translate=\"sigmasfApp.patchReportItem.patchReport\">Patch Report</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchItem.id\"><span translate=\"sigmasfApp.patchReportItem.patchItem\">Patch Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"icd10.id\"><span translate=\"sigmasfApp.patchReportItem.icd10\">Icd 10</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchReportItem in vm.patchReportItems track by patchReportItem.id\"><td><a ui-sref=\"patch-report-item-detail({id:patchReportItem.id})\">{{patchReportItem.id}}</a></td><td>{{patchReportItem.monthlyQuantity}}</td><td>{{patchReportItem.durationInMonths}}</td><td>{{patchReportItem.bodyArea}}</td><td>{{patchReportItem.participationPercent}}</td><td>{{patchReportItem.comment}}</td><td><a ui-sref=\"patch-report-detail({id:patchReportItem.patchReport.id})\">{{patchReportItem.patchReport.id}}</a></td><td><a ui-sref=\"patch-item-detail({id:patchReportItem.patchItem.id})\">{{patchReportItem.patchItem.id}}</a></td><td><a ui-sref=\"icd-10-detail({id:patchReportItem.icd10.id})\">{{patchReportItem.icd10.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-report-item-detail({id:patchReportItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-item.edit({id:patchReportItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-item.delete({id:patchReportItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-report-material-category/patch-report-material-categories.html","<div><h2 translate=\"sigmasfApp.patchReportMaterialCategory.home.title\">Patch Report Material Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-report-material-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.patchReportMaterialCategory.home.createLabel\">Create new Patch Report Material Category</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.patchReportMaterialCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchReportMaterialCategory in vm.patchReportMaterialCategories track by patchReportMaterialCategory.id\"><td><a ui-sref=\"patch-report-material-category-detail({id:patchReportMaterialCategory.id})\">{{patchReportMaterialCategory.id}}</a></td><td>{{patchReportMaterialCategory.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-report-material-category-detail({id:patchReportMaterialCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-material-category.edit({id:patchReportMaterialCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-material-category.delete({id:patchReportMaterialCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patch-report-material-category/patch-report-material-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchReportMaterialCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchReportMaterialCategory.delete.question\" translate-values=\"{id: \'{{vm.patchReportMaterialCategory.id}}\'}\">Are you sure you want to delete this Patch Report Material Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-report-material-category/patch-report-material-category-detail.html","<div><h2><span translate=\"sigmasfApp.patchReportMaterialCategory.detail.title\">Patch Report Material Category</span> {{vm.patchReportMaterialCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchReportMaterialCategory.name\">Name</span></dt><dd><span>{{vm.patchReportMaterialCategory.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-report-material-category/patch-report-material-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchReportMaterialCategoryLabel\" translate=\"sigmasfApp.patchReportMaterialCategory.home.createOrEditLabel\">Create or edit a Patch Report Material Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchReportMaterialCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchReportMaterialCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportMaterialCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.patchReportMaterialCategory.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-report-photo/patch-report-photo-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patchReportPhoto.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patchReportPhoto.delete.question\" translate-values=\"{id: \'{{vm.patchReportPhoto.id}}\'}\">Are you sure you want to delete this Patch Report Photo?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patch-report-photo/patch-report-photo-detail.html","<div><h2><span translate=\"sigmasfApp.patchReportPhoto.detail.title\">Patch Report Photo</span> {{vm.patchReportPhoto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patchReportPhoto.patchPhotoName\">Patch Photo Name</span></dt><dd><span>{{vm.patchReportPhoto.patchPhotoName}}</span></dd><dt><span translate=\"sigmasfApp.patchReportPhoto.patchPhotoType\">Patch Photo Type</span></dt><dd><span translate=\"{{\'sigmasfApp.PatchPhotoType.\' + vm.patchReportPhoto.patchPhotoType}}\">{{vm.patchReportPhoto.patchPhotoType}}</span></dd><dt><span translate=\"sigmasfApp.patchReportPhoto.patchPhoto\">Patch Photo</span></dt><dd><div ng-if=\"vm.patchReportPhoto.patchPhoto\"><a ng-click=\"vm.openFile(vm.patchReportPhoto.patchPhotoContentType, vm.patchReportPhoto.patchPhoto)\"><img data-ng-src=\"{{\'data:\' + vm.patchReportPhoto.patchPhotoContentType + \';base64,\' + vm.patchReportPhoto.patchPhoto}}\" style=\"max-width: 100%\"> </a>{{vm.patchReportPhoto.patchPhotoContentType}}, {{vm.byteSize(vm.patchReportPhoto.patchPhoto)}}</div></dd><dt><span translate=\"sigmasfApp.patchReportPhoto.patchReport\">Patch Report</span></dt><dd><a ui-sref=\"patch-report-detail({id:vm.patchReportPhoto.patchReport.id})\">{{vm.patchReportPhoto.patchReport.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patch-report-photo/patch-report-photo-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatchReportPhotoLabel\" translate=\"sigmasfApp.patchReportPhoto.home.createOrEditLabel\">Create or edit a Patch Report Photo</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patchReportPhoto.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patchReportPhoto.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportPhoto.patchPhotoName\" for=\"field_patchPhotoName\">Patch Photo Name</label><input type=\"text\" class=\"form-control\" name=\"patchPhotoName\" id=\"field_patchPhotoName\" ng-model=\"vm.patchReportPhoto.patchPhotoName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportPhoto.patchPhotoType\" for=\"field_patchPhotoType\">Patch Photo Type</label><select class=\"form-control\" name=\"patchPhotoType\" ng-model=\"vm.patchReportPhoto.patchPhotoType\" id=\"field_patchPhotoType\"><option value=\"injury\" translate=\"sigmasfApp.PatchPhotoType.injury\">injury</option><option value=\"booklet\" translate=\"sigmasfApp.PatchPhotoType.booklet\">booklet</option><option value=\"report\" translate=\"sigmasfApp.PatchPhotoType.report\">report</option></select></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setPatchPhoto($file, vm.patchReportPhoto)\" ngf-pattern=\"\'image/*\'\"><label class=\"control-label\" translate=\"sigmasfApp.patchReportPhoto.patchPhoto\" for=\"field_patchPhoto\">Patch Photo</label><div><img data-ng-src=\"{{\'data:\' + vm.patchReportPhoto.patchPhotoContentType + \';base64,\' + vm.patchReportPhoto.patchPhoto}}\" style=\"max-height: 100px\" ng-if=\"vm.patchReportPhoto.patchPhoto\"><div ng-if=\"vm.patchReportPhoto.patchPhoto\" class=\"help-block clearfix\"><span class=\"pull-left\">{{vm.patchReportPhoto.patchPhotoContentType}}, {{vm.byteSize(vm.patchReportPhoto.patchPhoto)}}</span> <button ng-click=\"vm.patchReportPhoto.patchPhoto=null;vm.patchReportPhoto.patchPhotoContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setPatchPhoto($file, vm.patchReportPhoto)\" accept=\"image/*\" translate=\"entity.action.addimage\">Add image</button></div><input type=\"hidden\" class=\"form-control\" name=\"patchPhoto\" id=\"field_patchPhoto\" ng-model=\"vm.patchReportPhoto.patchPhoto\" required maxbytes=\"1000000\"> <input type=\"hidden\" class=\"form-control\" name=\"patchPhotoContentType\" id=\"field_patchPhotoContentType\" ng-model=\"vm.patchReportPhoto.patchPhotoContentType\"><div ng-show=\"editForm.patchPhoto.$invalid\"><p class=\"help-block\" ng-show=\"editForm.patchPhoto.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.patchPhoto.$error.maxbytes\" translate=\"entity.validation.maxbytes\" translate-value-max=\"1000000\">This field cannot be more than 1000000.</p></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.patchReportPhoto.patchReport\" for=\"field_patchReport\">Patch Report</label><select class=\"form-control\" id=\"field_patchReport\" name=\"patchReport\" ng-model=\"vm.patchReportPhoto.patchReport\" ng-options=\"patchReport as patchReport.id for patchReport in vm.patchreports track by patchReport.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/patch-report-photo/patch-report-photos.html","<div><h2 translate=\"sigmasfApp.patchReportPhoto.home.title\">Patch Report Photos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patch-report-photo.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.patchReportPhoto.home.createLabel\">Create new Patch Report Photo</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchPhotoName\"><span translate=\"sigmasfApp.patchReportPhoto.patchPhotoName\">Patch Photo Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchPhotoType\"><span translate=\"sigmasfApp.patchReportPhoto.patchPhotoType\">Patch Photo Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchPhoto\"><span translate=\"sigmasfApp.patchReportPhoto.patchPhoto\">Patch Photo</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"patchReport.id\"><span translate=\"sigmasfApp.patchReportPhoto.patchReport\">Patch Report</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patchReportPhoto in vm.patchReportPhotos track by patchReportPhoto.id\"><td><a ui-sref=\"patch-report-photo-detail({id:patchReportPhoto.id})\">{{patchReportPhoto.id}}</a></td><td>{{patchReportPhoto.patchPhotoName}}</td><td translate=\"{{\'sigmasfApp.PatchPhotoType.\' + patchReportPhoto.patchPhotoType}}\">{{patchReportPhoto.patchPhotoType}}</td><td><a ng-if=\"patchReportPhoto.patchPhoto\" ng-click=\"vm.openFile(patchReportPhoto.patchPhotoContentType, patchReportPhoto.patchPhoto)\"><img data-ng-src=\"{{\'data:\' + patchReportPhoto.patchPhotoContentType + \';base64,\' + patchReportPhoto.patchPhoto}}\" style=\"max-height: 30px\"> </a><span ng-if=\"patchReportPhoto.patchPhoto\">{{patchReportPhoto.patchPhotoContentType}}, {{vm.byteSize(patchReportPhoto.patchPhoto)}}</span></td><td><a ui-sref=\"patch-report-detail({id:patchReportPhoto.patchReport.id})\">{{patchReportPhoto.patchReport.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patch-report-photo-detail({id:patchReportPhoto.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-photo.edit({id:patchReportPhoto.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patch-report-photo.delete({id:patchReportPhoto.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/patient/patient-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.patient.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.patient.delete.question\" translate-values=\"{id: \'{{vm.patient.id}}\'}\">Are you sure you want to delete this Patient?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/patient/patient-detail.html","<div><h2><span translate=\"sigmasfApp.patient.detail.title\">Patient</span> {{vm.patient.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.patient.yearOfBirth\">Year Of Birth</span></dt><dd><span>{{vm.patient.yearOfBirth}}</span></dd><dt><span translate=\"sigmasfApp.patient.amka\">Amka</span></dt><dd><span>{{vm.patient.amka}}</span></dd><dt><span translate=\"sigmasfApp.patient.phone\">Phone</span></dt><dd><span>{{vm.patient.phone}}</span></dd><dt><span translate=\"sigmasfApp.patient.notes\">Notes</span></dt><dd><span>{{vm.patient.notes}}</span></dd><dt><span translate=\"sigmasfApp.patient.firstName\">First Name</span></dt><dd><span>{{vm.patient.firstName}}</span></dd><dt><span translate=\"sigmasfApp.patient.lastName\">Last Name</span></dt><dd><span>{{vm.patient.lastName}}</span></dd><dt><span translate=\"sigmasfApp.patient.email\">Email</span></dt><dd><span>{{vm.patient.email}}</span></dd><dt><span translate=\"sigmasfApp.patient.prospectivePatient\">Prospective Patient</span></dt><dd><a ui-sref=\"prospective-patient-detail({id:vm.patient.prospectivePatient.id})\">{{vm.patient.prospectivePatient.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/patient/patient-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPatientLabel\" translate=\"sigmasfApp.patient.home.createOrEditLabel\">Create or edit a Patient</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.patient.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.patient.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patient.yearOfBirth\" for=\"field_yearOfBirth\">Year Of Birth</label><input type=\"number\" class=\"form-control\" name=\"yearOfBirth\" id=\"field_yearOfBirth\" ng-model=\"vm.patient.yearOfBirth\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patient.amka\" for=\"field_amka\">Amka</label><input type=\"text\" class=\"form-control\" name=\"amka\" id=\"field_amka\" ng-model=\"vm.patient.amka\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patient.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.patient.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.patient.notes\" for=\"field_notes\">Notes</label><textarea class=\"form-control\" name=\"notes\" id=\"field_notes\" ng-model=\"vm.patient.notes\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"sigmasfApp.patient.firstName\" for=\"field_firstName\">First Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.patient.firstName\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"sigmasfApp.patient.lastName\" for=\"field_lastName\">Last Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.patient.lastName\">\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"sigmasfApp.patient.email\" for=\"field_email\">Email</label>\n            <input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.patient.email\">\n        </div>\n\n        <div class=\"form-group\">\n            <label translate=\"sigmasfApp.patient.prospectivePatient\" for=\"field_prospectivePatient\">Prospective Patient</label>\n            <select class=\"form-control\" id=\"field_prospectivePatient\" name=\"prospectivePatient\" ng-model=\"vm.patient.prospectivePatient\" ng-options=\"ProspectivePatient as ProspectivePatient.id for ProspectivePatient in vm.prospectivepatients | orderBy:\'id\' track by ProspectivePatient.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>");
$templateCache.put("app/entities/patient/patients.html","<div><h2 translate=\"sigmasfApp.patient.home.title\">Patients</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"patient.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.patient.home.createLabel\">Create new Patient</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"yearOfBirth\"><span translate=\"sigmasfApp.patient.yearOfBirth\">Year Of Birth</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amka\"><span translate=\"sigmasfApp.patient.amka\">Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.patient.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notes\"><span translate=\"sigmasfApp.patient.notes\">Notes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.patient.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.patient.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span translate=\"sigmasfApp.patient.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prospectivePatient.id\"><span translate=\"sigmasfApp.patient.prospectivePatient\">Prospective Patient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patient in vm.patients track by patient.id\"><td><a ui-sref=\"patient-detail({id:patient.id})\">{{patient.id}}</a></td><td>{{patient.yearOfBirth}}</td><td>{{patient.amka}}</td><td>{{patient.phone}}</td><td>{{patient.notes}}</td><td>{{patient.firstName}}</td><td>{{patient.lastName}}</td><td>{{patient.email}}</td><td><a ui-sref=\"prospective-patient-detail({id:patient.prospectivePatient.id})\">{{patient.prospectivePatient.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"patient-detail({id:patient.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"patient.edit({id:patient.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"patient.delete({id:patient.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/payment-method/payment-method-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.paymentMethod.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.paymentMethod.delete.question\" translate-values=\"{id: \'{{vm.paymentMethod.id}}\'}\">Are you sure you want to delete this Payment Method?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/payment-method/payment-method-detail.html","<div><h2><span translate=\"sigmasfApp.paymentMethod.detail.title\">Payment Method</span> {{vm.paymentMethod.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.paymentMethod.name\">Name</span></dt><dd><span>{{vm.paymentMethod.name}}</span></dd><dt><span translate=\"sigmasfApp.paymentMethod.code\">Code</span></dt><dd><span>{{vm.paymentMethod.code}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/payment-method/payment-method-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaymentMethodLabel\" translate=\"sigmasfApp.paymentMethod.home.createOrEditLabel\">Create or edit a Payment Method</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.paymentMethod.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.paymentMethod.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.paymentMethod.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.paymentMethod.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.paymentMethod.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.paymentMethod.code\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/payment-method/payment-methods.html","<div><h2 translate=\"sigmasfApp.paymentMethod.home.title\">Payment Methods</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"payment-method.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.paymentMethod.home.createLabel\">Create new Payment Method</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.paymentMethod.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.paymentMethod.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"paymentMethod in vm.paymentMethods track by paymentMethod.id\"><td><a ui-sref=\"payment-method-detail({id:paymentMethod.id})\">{{paymentMethod.id}}</a></td><td>{{paymentMethod.name}}</td><td>{{paymentMethod.code}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"payment-method-detail({id:paymentMethod.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"payment-method.edit({id:paymentMethod.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"payment-method.delete({id:paymentMethod.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/present-list/present-list-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.presentList.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.presentList.delete.question\" translate-values=\"{id: \'{{vm.presentList.id}}\'}\">Are you sure you want to delete this Present List?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/present-list/present-list-detail.html","<div><h2><span translate=\"sigmasfApp.presentList.detail.title\">Present List</span> {{vm.presentList.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.presentList.code\">Code</span></dt><dd><span>{{vm.presentList.code}}</span></dd><dt><span translate=\"sigmasfApp.presentList.description\">Description</span></dt><dd><span>{{vm.presentList.description}}</span></dd><dt><span translate=\"sigmasfApp.presentList.selectable\">Selectable</span></dt><dd><span>{{vm.presentList.selectable}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/present-list/present-list-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPresentListLabel\" translate=\"sigmasfApp.presentList.home.createOrEditLabel\">Create or edit a Present List</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.presentList.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.presentList.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.presentList.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.presentList.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.presentList.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.presentList.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.presentList.selectable\" for=\"field_selectable\">Selectable</label><input type=\"checkbox\" class=\"form-control\" name=\"selectable\" id=\"field_selectable\" ng-model=\"vm.presentList.selectable\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/present-list/present-lists.html","<div><h2 translate=\"sigmasfApp.presentList.home.title\">Present Lists</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"present-list.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.presentList.home.createLabel\">Create new Present List</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.presentList.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.presentList.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"selectable\"><span translate=\"sigmasfApp.presentList.selectable\">Selectable</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"presentList in vm.presentLists track by presentList.id\"><td><a ui-sref=\"present-list-detail({id:presentList.id})\">{{presentList.id}}</a></td><td>{{presentList.code}}</td><td>{{presentList.description}}</td><td>{{presentList.selectable}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"present-list-detail({id:presentList.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"present-list.edit({id:presentList.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"present-list.delete({id:presentList.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/prefecture/prefecture-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.prefecture.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.prefecture.delete.question\" translate-values=\"{id: \'{{vm.prefecture.id}}\'}\">Are you sure you want to delete this Prefecture?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/prefecture/prefecture-detail.html","<div><h2><span translate=\"sigmasfApp.prefecture.detail.title\">Prefecture</span> {{vm.prefecture.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.prefecture.name\">Name</span></dt><dd><span>{{vm.prefecture.name}}</span></dd><dt><span translate=\"sigmasfApp.prefecture.nameEn\">Name En</span></dt><dd><span>{{vm.prefecture.nameEn}}</span></dd><dt><span translate=\"sigmasfApp.prefecture.region\">Region</span></dt><dd><a ui-sref=\"region-detail({id:vm.prefecture.region.id})\">{{vm.prefecture.region.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/prefecture/prefecture-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrefectureLabel\" translate=\"sigmasfApp.prefecture.home.createOrEditLabel\">Create or edit a Prefecture</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.prefecture.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.prefecture.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prefecture.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.prefecture.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prefecture.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.prefecture.nameEn\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.prefecture.region\" for=\"field_region\">Region</label><select class=\"form-control\" id=\"field_region\" name=\"region\" ng-model=\"vm.prefecture.region\" ng-options=\"region as region.id for region in vm.regions track by region.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/prefecture/prefectures.html","<div><h2 translate=\"sigmasfApp.prefecture.home.title\">Prefectures</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"prefecture.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.prefecture.home.createLabel\">Create new Prefecture</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.prefecture.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.prefecture.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.prefecture.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region.id\"><span translate=\"sigmasfApp.prefecture.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"prefecture in vm.prefectures track by prefecture.id\"><td><a ui-sref=\"prefecture-detail({id:prefecture.id})\">{{prefecture.id}}</a></td><td>{{prefecture.name}}</td><td>{{prefecture.nameEn}}</td><td><a ui-sref=\"region-detail({id:prefecture.region.id})\">{{prefecture.region.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"prefecture-detail({id:prefecture.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"prefecture.edit({id:prefecture.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"prefecture.delete({id:prefecture.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/present-list-product/present-list-product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.presentListProduct.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.presentListProduct.delete.question\" translate-values=\"{id: \'{{vm.presentListProduct.id}}\'}\">Are you sure you want to delete this Present List Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/present-list-product/present-list-product-detail.html","<div><h2><span translate=\"sigmasfApp.presentListProduct.detail.title\">Present List Product</span> {{vm.presentListProduct.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.presentListProduct.quantity\">Quantity</span></dt><dd><span>{{vm.presentListProduct.quantity}}</span></dd><dt><span translate=\"sigmasfApp.presentListProduct.active\">Active</span></dt><dd><span>{{vm.presentListProduct.active}}</span></dd><dt><span translate=\"sigmasfApp.presentListProduct.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.presentListProduct.product.id})\">{{vm.presentListProduct.product.id}}</a></dd><dt><span translate=\"sigmasfApp.presentListProduct.presentList\">Present List</span></dt><dd><a ui-sref=\"present-list-detail({id:vm.presentListProduct.presentList.id})\">{{vm.presentListProduct.presentList.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/present-list-product/present-list-product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPresentListProductLabel\" translate=\"sigmasfApp.presentListProduct.home.createOrEditLabel\">Create or edit a Present List Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.presentListProduct.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.presentListProduct.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.presentListProduct.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.presentListProduct.quantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.presentListProduct.active\" for=\"field_active\">Active</label><input type=\"checkbox\" class=\"form-control\" name=\"active\" id=\"field_active\" ng-model=\"vm.presentListProduct.active\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.presentListProduct.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.presentListProduct.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.presentListProduct.presentList\" for=\"field_presentList\">Present List</label><select class=\"form-control\" id=\"field_presentList\" name=\"presentList\" ng-model=\"vm.presentListProduct.presentList\" ng-options=\"presentList as presentList.id for presentList in vm.presentlists track by presentList.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/present-list-product/present-list-products.html","<div><h2 translate=\"sigmasfApp.presentListProduct.home.title\">Present List Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"present-list-product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.presentListProduct.home.createLabel\">Create new Present List Product</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantity\"><span translate=\"sigmasfApp.presentListProduct.quantity\">Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"active\"><span translate=\"sigmasfApp.presentListProduct.active\">Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.presentListProduct.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"presentList.id\"><span translate=\"sigmasfApp.presentListProduct.presentList\">Present List</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"presentListProduct in vm.presentListProducts track by presentListProduct.id\"><td><a ui-sref=\"present-list-product-detail({id:presentListProduct.id})\">{{presentListProduct.id}}</a></td><td>{{presentListProduct.quantity}}</td><td>{{presentListProduct.active}}</td><td><a ui-sref=\"product-detail({id:presentListProduct.product.id})\">{{presentListProduct.product.id}}</a></td><td><a ui-sref=\"present-list-detail({id:presentListProduct.presentList.id})\">{{presentListProduct.presentList.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"present-list-product-detail({id:presentListProduct.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"present-list-product.edit({id:presentListProduct.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"present-list-product.delete({id:presentListProduct.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product/product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.product.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.product.delete.question\" translate-values=\"{id: \'{{vm.product.id}}\'}\">Are you sure you want to delete this Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product/product-detail.html","<div><h2><span translate=\"sigmasfApp.product.detail.title\">Product</span> {{vm.product.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.product.name\">Name</span></dt><dd><span>{{vm.product.name}}</span></dd><dt><span translate=\"sigmasfApp.product.activeSubstance\">Active Substance</span></dt><dd><span>{{vm.product.activeSubstance}}</span></dd><dt><span translate=\"sigmasfApp.product.image\">Image</span></dt><dd><div ng-if=\"vm.product.image\"><a ng-click=\"vm.openFile(vm.product.imageContentType, vm.product.image)\"><img data-ng-src=\"{{\'data:\' + vm.product.imageContentType + \';base64,\' + vm.product.image}}\" style=\"max-width: 100%\"> </a>{{vm.product.imageContentType}}, {{vm.byteSize(vm.product.image)}}</div></dd><dt><span translate=\"sigmasfApp.product.barcode\">Barcode</span></dt><dd><span>{{vm.product.barcode}}</span></dd><dt><span translate=\"sigmasfApp.product.code\">Code</span></dt><dd><span>{{vm.product.code}}</span></dd><dt><span translate=\"sigmasfApp.product.supplierCode\">Supplier Code</span></dt><dd><span>{{vm.product.supplierCode}}</span></dd><dt><span translate=\"sigmasfApp.product.atcCode\">Atc Code</span></dt><dd><span>{{vm.product.atcCode}}</span></dd><dt><span translate=\"sigmasfApp.product.packaging\">Packaging</span></dt><dd><span>{{vm.product.packaging}}</span></dd><dt><span translate=\"sigmasfApp.product.defaultDiscount\">Default Discount</span></dt><dd><span>{{vm.product.defaultDiscount}}</span></dd><dt><span translate=\"sigmasfApp.product.availableForVisit\">Available For Visit</span></dt><dd><span>{{vm.product.availableForVisit}}</span></dd><dt><span translate=\"sigmasfApp.product.availableForPurchase\">Available For Purchase</span></dt><dd><span>{{vm.product.availableForPurchase}}</span></dd><dt><span translate=\"sigmasfApp.product.calcPFS\">Calc PFS</span></dt><dd><span>{{vm.product.calcPFS}}</span></dd><dt><span translate=\"sigmasfApp.product.productCategory\">Product Category</span></dt><dd><span ng-repeat=\"productCategory in vm.product.productCategories\"><a ui-sref=\"product-category-detail({id: {{productCategory.id}}})\">{{productCategory.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.product.taxClass\">Tax Class</span></dt><dd><a ui-sref=\"tax-class-detail({id:vm.product.taxClass.id})\">{{vm.product.taxClass.name}}</a></dd><dt><span translate=\"sigmasfApp.product.measurementUnit\">Measurement Unit</span></dt><dd><a ui-sref=\"measurement-unit-detail({id:vm.product.measurementUnit.id})\">{{vm.product.measurementUnit.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product/product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductLabel\" translate=\"sigmasfApp.product.home.createOrEditLabel\">Create or edit a Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.product.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.product.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.product.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.activeSubstance\" for=\"field_activeSubstance\">Active Substance</label><input type=\"text\" class=\"form-control\" name=\"activeSubstance\" id=\"field_activeSubstance\" ng-model=\"vm.product.activeSubstance\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setImage($file, vm.product)\" ngf-pattern=\"\'image/*\'\"><label class=\"control-label\" translate=\"sigmasfApp.product.image\" for=\"field_image\">Image</label><div><img data-ng-src=\"{{\'data:\' + vm.product.imageContentType + \';base64,\' + vm.product.image}}\" style=\"max-height: 100px\" ng-if=\"vm.product.image\"><div ng-if=\"vm.product.image\" class=\"help-block clearfix\"><span class=\"pull-left\">{{vm.product.imageContentType}}, {{vm.byteSize(vm.product.image)}}</span> <button ng-click=\"vm.product.image=null;vm.product.imageContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setImage($file, vm.product)\" accept=\"image/*\" translate=\"entity.action.addimage\">Add image</button></div><input type=\"hidden\" class=\"form-control\" name=\"image\" id=\"field_image\" ng-model=\"vm.product.image\"> <input type=\"hidden\" class=\"form-control\" name=\"imageContentType\" id=\"field_imageContentType\" ng-model=\"vm.product.imageContentType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.barcode\" for=\"field_barcode\">Barcode</label><input type=\"text\" class=\"form-control\" name=\"barcode\" id=\"field_barcode\" ng-model=\"vm.product.barcode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.product.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.supplierCode\" for=\"field_supplierCode\">Supplier Code</label><input type=\"text\" class=\"form-control\" name=\"supplierCode\" id=\"field_supplierCode\" ng-model=\"vm.product.supplierCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.atcCode\" for=\"field_atcCode\">Atc Code</label><input type=\"text\" class=\"form-control\" name=\"atcCode\" id=\"field_atcCode\" ng-model=\"vm.product.atcCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.packaging\" for=\"field_packaging\">Packaging</label><input type=\"text\" class=\"form-control\" name=\"packaging\" id=\"field_packaging\" ng-model=\"vm.product.packaging\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.defaultDiscount\" for=\"field_defaultDiscount\">Default Discount</label><input type=\"number\" class=\"form-control\" name=\"defaultDiscount\" id=\"field_defaultDiscount\" ng-model=\"vm.product.defaultDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.availableForVisit\" for=\"field_availableForVisit\">Available For Visit</label><input type=\"checkbox\" class=\"form-control\" name=\"availableForVisit\" id=\"field_availableForVisit\" ng-model=\"vm.product.availableForVisit\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.availableForPurchase\" for=\"field_availableForPurchase\">Available For Purchase</label><input type=\"checkbox\" class=\"form-control\" name=\"availableForPurchase\" id=\"field_availableForPurchase\" ng-model=\"vm.product.availableForPurchase\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.product.calcPFS\" for=\"field_calcPFS\">Calc PFS</label><input type=\"checkbox\" class=\"form-control\" name=\"calcPFS\" id=\"field_calcPFS\" ng-model=\"vm.product.calcPFS\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.product.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" multiple=\"multiple\" name=\"productCategory\" ng-model=\"vm.product.productCategories\" ng-options=\"productCategory as productCategory.id for productCategory in vm.productcategories track by productCategory.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.product.taxClass\" for=\"field_taxClass\">Tax Class</label><select class=\"form-control\" id=\"field_taxClass\" name=\"taxClass\" ng-model=\"vm.product.taxClass\" ng-options=\"taxClass as taxClass.name for taxClass in vm.taxclasses track by taxClass.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.product.measurementUnit\" for=\"field_measurementUnit\">Measurement Unit</label><select class=\"form-control\" id=\"field_measurementUnit\" name=\"measurementUnit\" ng-model=\"vm.product.measurementUnit\" ng-options=\"measurementUnit as measurementUnit.name for measurementUnit in vm.measurementunits track by measurementUnit.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product/products.html","<div><h2 translate=\"sigmasfApp.product.home.title\">Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.product.home.createLabel\">Create new Product</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.product.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activeSubstance\"><span translate=\"sigmasfApp.product.activeSubstance\">Active Substance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"image\"><span translate=\"sigmasfApp.product.image\">Image</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"barcode\"><span translate=\"sigmasfApp.product.barcode\">Barcode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.product.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"supplierCode\"><span translate=\"sigmasfApp.product.supplierCode\">Supplier Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"atcCode\"><span translate=\"sigmasfApp.product.atcCode\">Atc Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"packaging\"><span translate=\"sigmasfApp.product.packaging\">Packaging</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"defaultDiscount\"><span translate=\"sigmasfApp.product.defaultDiscount\">Default Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"availableForVisit\"><span translate=\"sigmasfApp.product.availableForVisit\">Available For Visit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"availableForPurchase\"><span translate=\"sigmasfApp.product.availableForPurchase\">Available For Purchase</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"calcPFS\"><span translate=\"sigmasfApp.product.calcPFS\">Calc PFS</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxClass.name\"><span translate=\"sigmasfApp.product.taxClass\">Tax Class</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"measurementUnit.name\"><span translate=\"sigmasfApp.product.measurementUnit\">Measurement Unit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products track by product.id\"><td><a ui-sref=\"product-detail({id:product.id})\">{{product.id}}</a></td><td>{{product.name}}</td><td>{{product.activeSubstance}}</td><td><a ng-if=\"product.image\" ng-click=\"vm.openFile(product.imageContentType, product.image)\"><img data-ng-src=\"{{\'data:\' + product.imageContentType + \';base64,\' + product.image}}\" style=\"max-height: 30px\"> </a><span ng-if=\"product.image\">{{product.imageContentType}}, {{vm.byteSize(product.image)}}</span></td><td>{{product.barcode}}</td><td>{{product.code}}</td><td>{{product.supplierCode}}</td><td>{{product.atcCode}}</td><td>{{product.packaging}}</td><td>{{product.defaultDiscount}}</td><td>{{product.availableForVisit}}</td><td>{{product.availableForPurchase}}</td><td>{{product.calcPFS}}</td><td><a ui-sref=\"tax-class-detail({id:product.taxClass.id})\">{{product.taxClass.name}}</a></td><td><a ui-sref=\"measurement-unit-detail({id:product.measurementUnit.id})\">{{product.measurementUnit.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-detail({id:product.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product.edit({id:product.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product.delete({id:product.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-category/product-categories.html","<div><h2 translate=\"sigmasfApp.productCategory.home.title\">Product Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.productCategory.home.createLabel\">Create new Product Category</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.productCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isSalesCategory\"><span translate=\"sigmasfApp.productCategory.isSalesCategory\">Is Sales Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sortOrder\"><span translate=\"sigmasfApp.productCategory.sortOrder\">Sort Order</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"productCategory in vm.productCategories track by productCategory.id\"><td><a ui-sref=\"product-category-detail({id:productCategory.id})\">{{productCategory.id}}</a></td><td>{{productCategory.name}}</td><td>{{productCategory.isSalesCategory}}</td><td>{{productCategory.sortOrder}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-category-detail({id:productCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product-category.edit({id:productCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product-category.delete({id:productCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-category/product-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.productCategory.delete.question\" translate-values=\"{id: \'{{vm.productCategory.id}}\'}\">Are you sure you want to delete this Product Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-category/product-category-detail.html","<div><h2><span translate=\"sigmasfApp.productCategory.detail.title\">Product Category</span> {{vm.productCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.productCategory.name\">Name</span></dt><dd><span>{{vm.productCategory.name}}</span></dd><dt><span translate=\"sigmasfApp.productCategory.isSalesCategory\">Is Sales Category</span></dt><dd><span>{{vm.productCategory.isSalesCategory}}</span></dd><dt><span translate=\"sigmasfApp.productCategory.sortOrder\">Sort Order</span></dt><dd><span>{{vm.productCategory.sortOrder}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-category/product-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductCategoryLabel\" translate=\"sigmasfApp.productCategory.home.createOrEditLabel\">Create or edit a Product Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.productCategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productCategory.isSalesCategory\" for=\"field_isSalesCategory\">Is Sales Category</label><input type=\"checkbox\" class=\"form-control\" name=\"isSalesCategory\" id=\"field_isSalesCategory\" ng-model=\"vm.productCategory.isSalesCategory\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productCategory.sortOrder\" for=\"field_sortOrder\">Sort Order</label><input type=\"number\" class=\"form-control\" name=\"sortOrder\" id=\"field_sortOrder\" ng-model=\"vm.productCategory.sortOrder\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-lot/product-lot-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productLot.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.productLot.delete.question\" translate-values=\"{id: \'{{vm.productLot.id}}\'}\">Are you sure you want to delete this Product Lot?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-lot/product-lot-detail.html","<div><h2><span translate=\"sigmasfApp.productLot.detail.title\">Product Lot</span> {{vm.productLot.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.productLot.referenceNumber\">Reference Number</span></dt><dd><span>{{vm.productLot.referenceNumber}}</span></dd><dt><span translate=\"sigmasfApp.productLot.expirationMonth\">Expiration Month</span></dt><dd><span>{{vm.productLot.expirationMonth}}</span></dd><dt><span translate=\"sigmasfApp.productLot.fromIdNumber\">From Id Number</span></dt><dd><span>{{vm.productLot.fromIdNumber}}</span></dd><dt><span translate=\"sigmasfApp.productLot.toIdNumber\">To Id Number</span></dt><dd><span>{{vm.productLot.toIdNumber}}</span></dd><dt><span translate=\"sigmasfApp.productLot.registrationDate\">Registration Date</span></dt><dd><span>{{vm.productLot.registrationDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.productLot.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.productLot.product.id})\">{{vm.productLot.product.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-lot/product-lot-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductLotLabel\" translate=\"sigmasfApp.productLot.home.createOrEditLabel\">Create or edit a Product Lot</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productLot.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productLot.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productLot.referenceNumber\" for=\"field_referenceNumber\">Reference Number</label><input type=\"text\" class=\"form-control\" name=\"referenceNumber\" id=\"field_referenceNumber\" ng-model=\"vm.productLot.referenceNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productLot.expirationMonth\" for=\"field_expirationMonth\">Expiration Month</label><input type=\"text\" class=\"form-control\" name=\"expirationMonth\" id=\"field_expirationMonth\" ng-model=\"vm.productLot.expirationMonth\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productLot.fromIdNumber\" for=\"field_fromIdNumber\">From Id Number</label><input type=\"text\" class=\"form-control\" name=\"fromIdNumber\" id=\"field_fromIdNumber\" ng-model=\"vm.productLot.fromIdNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productLot.toIdNumber\" for=\"field_toIdNumber\">To Id Number</label><input type=\"text\" class=\"form-control\" name=\"toIdNumber\" id=\"field_toIdNumber\" ng-model=\"vm.productLot.toIdNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productLot.registrationDate\" for=\"field_registrationDate\">Registration Date</label><div class=\"input-group\"><input id=\"field_registrationDate\" type=\"text\" class=\"form-control\" name=\"registrationDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.productLot.registrationDate\" is-open=\"vm.datePickerOpenStatus.registrationDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'registrationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"sigmasfApp.productLot.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.productLot.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-lot/product-lots.html","<div><h2 translate=\"sigmasfApp.productLot.home.title\">Product Lots</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-lot.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.productLot.home.createLabel\">Create new Product Lot</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"referenceNumber\"><span translate=\"sigmasfApp.productLot.referenceNumber\">Reference Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expirationMonth\"><span translate=\"sigmasfApp.productLot.expirationMonth\">Expiration Month</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromIdNumber\"><span translate=\"sigmasfApp.productLot.fromIdNumber\">From Id Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toIdNumber\"><span translate=\"sigmasfApp.productLot.toIdNumber\">To Id Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"registrationDate\"><span translate=\"sigmasfApp.productLot.registrationDate\">Registration Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.productLot.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"productLot in vm.productLots track by productLot.id\"><td><a ui-sref=\"product-lot-detail({id:productLot.id})\">{{productLot.id}}</a></td><td>{{productLot.referenceNumber}}</td><td>{{productLot.expirationMonth}}</td><td>{{productLot.fromIdNumber}}</td><td>{{productLot.toIdNumber}}</td><td>{{productLot.registrationDate | date:\'mediumDate\'}}</td><td><a ui-sref=\"product-detail({id:productLot.product.id})\">{{productLot.product.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-lot-detail({id:productLot.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product-lot.edit({id:productLot.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product-lot.delete({id:productLot.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-price/product-price-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productPrice.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.productPrice.delete.question\" translate-values=\"{id: \'{{vm.productPrice.id}}\'}\">Are you sure you want to delete this Product Price?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-price/product-price-detail.html","<div><h2><span translate=\"sigmasfApp.productPrice.detail.title\">Product Price</span> {{vm.productPrice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.productPrice.startedDate\">Started Date</span></dt><dd><span>{{vm.productPrice.startedDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.productPrice.endedDate\">Ended Date</span></dt><dd><span>{{vm.productPrice.endedDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.productPrice.retailPrice\">Retail Price</span></dt><dd><span>{{vm.productPrice.retailPrice}}</span></dd><dt><span translate=\"sigmasfApp.productPrice.wholesalePrice\">Wholesale Price</span></dt><dd><span>{{vm.productPrice.wholesalePrice}}</span></dd><dt><span translate=\"sigmasfApp.productPrice.costPrice\">Cost Price</span></dt><dd><span>{{vm.productPrice.costPrice}}</span></dd><dt><span translate=\"sigmasfApp.productPrice.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.productPrice.product.id})\">{{vm.productPrice.product.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-price/product-price-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductPriceLabel\" translate=\"sigmasfApp.productPrice.home.createOrEditLabel\">Create or edit a Product Price</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productPrice.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productPrice.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productPrice.startedDate\" for=\"field_startedDate\">Started Date</label><div class=\"input-group\"><input id=\"field_startedDate\" type=\"text\" class=\"form-control\" name=\"startedDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.productPrice.startedDate\" is-open=\"vm.datePickerOpenStatus.startedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productPrice.endedDate\" for=\"field_endedDate\">Ended Date</label><div class=\"input-group\"><input id=\"field_endedDate\" type=\"text\" class=\"form-control\" name=\"endedDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.productPrice.endedDate\" is-open=\"vm.datePickerOpenStatus.endedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productPrice.retailPrice\" for=\"field_retailPrice\">Retail Price</label><input type=\"number\" class=\"form-control\" name=\"retailPrice\" id=\"field_retailPrice\" ng-model=\"vm.productPrice.retailPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productPrice.wholesalePrice\" for=\"field_wholesalePrice\">Wholesale Price</label><input type=\"number\" class=\"form-control\" name=\"wholesalePrice\" id=\"field_wholesalePrice\" ng-model=\"vm.productPrice.wholesalePrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productPrice.costPrice\" for=\"field_costPrice\">Cost Price</label><input type=\"number\" class=\"form-control\" name=\"costPrice\" id=\"field_costPrice\" ng-model=\"vm.productPrice.costPrice\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.productPrice.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.productPrice.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-price/product-prices.html","<div><h2 translate=\"sigmasfApp.productPrice.home.title\">Product Prices</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-price.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.productPrice.home.createLabel\">Create new Product Price</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedDate\"><span translate=\"sigmasfApp.productPrice.startedDate\">Started Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endedDate\"><span translate=\"sigmasfApp.productPrice.endedDate\">Ended Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"retailPrice\"><span translate=\"sigmasfApp.productPrice.retailPrice\">Retail Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wholesalePrice\"><span translate=\"sigmasfApp.productPrice.wholesalePrice\">Wholesale Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"costPrice\"><span translate=\"sigmasfApp.productPrice.costPrice\">Cost Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.productPrice.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"productPrice in vm.productPrices track by productPrice.id\"><td><a ui-sref=\"product-price-detail({id:productPrice.id})\">{{productPrice.id}}</a></td><td>{{productPrice.startedDate | date:\'mediumDate\'}}</td><td>{{productPrice.endedDate | date:\'mediumDate\'}}</td><td>{{productPrice.retailPrice}}</td><td>{{productPrice.wholesalePrice}}</td><td>{{productPrice.costPrice}}</td><td><a ui-sref=\"product-detail({id:productPrice.product.id})\">{{productPrice.product.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-price-detail({id:productPrice.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product-price.edit({id:productPrice.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product-price.delete({id:productPrice.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/profession/profession-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.profession.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.profession.delete.question\" translate-values=\"{id: \'{{vm.profession.id}}\'}\">Are you sure you want to delete this Profession?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/profession/profession-detail.html","<div><h2><span translate=\"sigmasfApp.profession.detail.title\">Profession</span> {{vm.profession.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.profession.name\">Name</span></dt><dd><span>{{vm.profession.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/profession/profession-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProfessionLabel\" translate=\"sigmasfApp.profession.home.createOrEditLabel\">Create or edit a Profession</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.profession.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.profession.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.profession.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.profession.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/profession/professions.html","<div><h2 translate=\"sigmasfApp.profession.home.title\">Professions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"profession.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.profession.home.createLabel\">Create new Profession</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.profession.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"profession in vm.professions track by profession.id\"><td><a ui-sref=\"profession-detail({id:profession.id})\">{{profession.id}}</a></td><td>{{profession.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"profession-detail({id:profession.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"profession.edit({id:profession.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"profession.delete({id:profession.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-category-product/product-category-product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productCategoryProduct.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.productCategoryProduct.delete.question\" translate-values=\"{id: \'{{vm.productCategoryProduct.id}}\'}\">Are you sure you want to delete this Product Category Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-category-product/product-category-product-detail.html","<div><h2><span translate=\"sigmasfApp.productCategoryProduct.detail.title\">Product Category Product</span> {{vm.productCategoryProduct.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.productCategoryProduct.sortOrder\">Sort Order</span></dt><dd><span>{{vm.productCategoryProduct.sortOrder}}</span></dd><dt><span translate=\"sigmasfApp.productCategoryProduct.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.productCategoryProduct.product.id})\">{{vm.productCategoryProduct.product.id}}</a></dd><dt><span translate=\"sigmasfApp.productCategoryProduct.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.productCategoryProduct.productCategory.id})\">{{vm.productCategoryProduct.productCategory.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-category-product/product-category-product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductCategoryProductLabel\" translate=\"sigmasfApp.productCategoryProduct.home.createOrEditLabel\">Create or edit a Product Category Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productCategoryProduct.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productCategoryProduct.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.productCategoryProduct.sortOrder\" for=\"field_sortOrder\">Sort Order</label><input type=\"number\" class=\"form-control\" name=\"sortOrder\" id=\"field_sortOrder\" ng-model=\"vm.productCategoryProduct.sortOrder\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.productCategoryProduct.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.productCategoryProduct.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.productCategoryProduct.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" name=\"productCategory\" ng-model=\"vm.productCategoryProduct.productCategory\" ng-options=\"productCategory as productCategory.id for productCategory in vm.productcategories track by productCategory.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-category-product/product-category-products.html","<div><h2 translate=\"sigmasfApp.productCategoryProduct.home.title\">Product Category Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-category-product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.productCategoryProduct.home.createLabel\">Create new Product Category Product</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"sigmasfApp.productCategoryProduct.sortOrder\">Sort Order</span></th><th><span translate=\"sigmasfApp.productCategoryProduct.product\">Product</span></th><th><span translate=\"sigmasfApp.productCategoryProduct.productCategory\">Product Category</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"productCategoryProduct in vm.productCategoryProducts track by productCategoryProduct.id\"><td><a ui-sref=\"product-category-product-detail({id:productCategoryProduct.id})\">{{productCategoryProduct.id}}</a></td><td>{{productCategoryProduct.sortOrder}}</td><td><a ui-sref=\"product-detail({id:productCategoryProduct.product.id})\">{{productCategoryProduct.product.id}}</a></td><td><a ui-sref=\"product-category-detail({id:productCategoryProduct.productCategory.id})\">{{productCategoryProduct.productCategory.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-category-product-detail({id:productCategoryProduct.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product-category-product.edit({id:productCategoryProduct.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product-category-product.delete({id:productCategoryProduct.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/prospective-patient/prospective-patient-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.prospectivePatient.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.prospectivePatient.delete.question\" translate-values=\"{id: \'{{vm.prospectivePatient.id}}\'}\">Are you sure you want to delete this Prospective Patient?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/prospective-patient/prospective-patient-detail.html","<div><h2><span translate=\"sigmasfApp.prospectivePatient.detail.title\">Prospective Patient</span> {{vm.prospectivePatient.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.prospectivePatient.firstName\">First Name</span></dt><dd><span>{{vm.prospectivePatient.firstName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.lastName\">Last Name</span></dt><dd><span>{{vm.prospectivePatient.lastName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.phone\">Phone</span></dt><dd><span>{{vm.prospectivePatient.phone}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.email\">Email</span></dt><dd><span>{{vm.prospectivePatient.email}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.mobile\">Mobile</span></dt><dd><span>{{vm.prospectivePatient.mobile}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.birthYear\">Birth Year</span></dt><dd><span>{{vm.prospectivePatient.birthYear}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.countryName\">Country Name</span></dt><dd><span>{{vm.prospectivePatient.countryName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.regionName\">Region Name</span></dt><dd><span>{{vm.prospectivePatient.regionName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.prefectureName\">Prefecture Name</span></dt><dd><span>{{vm.prospectivePatient.prefectureName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.cityName\">City Name</span></dt><dd><span>{{vm.prospectivePatient.cityName}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.postalCode\">Postal Code</span></dt><dd><span>{{vm.prospectivePatient.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.address\">Address</span></dt><dd><span>{{vm.prospectivePatient.address}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.addressNum\">Address Num</span></dt><dd><span>{{vm.prospectivePatient.addressNum}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.isWrongPhone\">Is Wrong Phone</span></dt><dd><span>{{vm.prospectivePatient.isWrongPhone}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.isWrongContact\">Is Wrong Contact</span></dt><dd><span>{{vm.prospectivePatient.isWrongContact}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.amka\">Amka</span></dt><dd><span>{{vm.prospectivePatient.amka}}</span></dd><dt><span translate=\"sigmasfApp.prospectivePatient.attendant\">Attendant</span></dt><dd><a ui-sref=\"attendant-detail({id:vm.prospectivePatient.attendant.id})\">{{vm.prospectivePatient.attendant.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.profession\">Profession</span></dt><dd><a ui-sref=\"profession-detail({id:vm.prospectivePatient.profession.id})\">{{vm.prospectivePatient.profession.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.nativeLanguage\">Native Language</span></dt><dd><a ui-sref=\"native-language-detail({id:vm.prospectivePatient.nativeLanguage.id})\">{{vm.prospectivePatient.nativeLanguage.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.prospectivePatient.country.id})\">{{vm.prospectivePatient.country.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.region\">Region</span></dt><dd><a ui-sref=\"region-detail({id:vm.prospectivePatient.region.id})\">{{vm.prospectivePatient.region.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.prefecture\">Prefecture</span></dt><dd><a ui-sref=\"prefecture-detail({id:vm.prospectivePatient.prefecture.id})\">{{vm.prospectivePatient.prefecture.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.city\">City</span></dt><dd><a ui-sref=\"city-detail({id:vm.prospectivePatient.city.id})\">{{vm.prospectivePatient.city.id}}</a></dd><dt><span translate=\"sigmasfApp.prospectivePatient.countryPhoneCode\">Country Phone Code</span></dt><dd><a ui-sref=\"country-phone-code-detail({id:vm.prospectivePatient.countryPhoneCode.id})\">{{vm.prospectivePatient.countryPhoneCode.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/prospective-patient/prospective-patient-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProspectivePatientLabel\" translate=\"sigmasfApp.prospectivePatient.home.createOrEditLabel\">Create or edit a Prospective Patient</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.prospectivePatient.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.prospectivePatient.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.firstName\" for=\"field_firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.prospectivePatient.firstName\" ng-maxlength=\"35\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"35\">This field cannot be longer than 35 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.prospectivePatient.lastName\" ng-maxlength=\"35\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"35\">This field cannot be longer than 35 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.prospectivePatient.phone\" ng-maxlength=\"15\"><div ng-show=\"editForm.phone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.phone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.prospectivePatient.email\" ng-minlength=\"6\" ng-maxlength=\"254\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.minlength\" translate=\"entity.validation.minlength\" translate-value-min=\"6\">This field is required to be at least 6 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"254\">This field cannot be longer than 254 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.mobile\" for=\"field_mobile\">Mobile</label><input type=\"text\" class=\"form-control\" name=\"mobile\" id=\"field_mobile\" ng-model=\"vm.prospectivePatient.mobile\" ng-maxlength=\"15\"><div ng-show=\"editForm.mobile.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mobile.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.birthYear\" for=\"field_birthYear\">Birth Year</label><input type=\"number\" class=\"form-control\" name=\"birthYear\" id=\"field_birthYear\" ng-model=\"vm.prospectivePatient.birthYear\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.countryName\" for=\"field_countryName\">Country Name</label><input type=\"text\" class=\"form-control\" name=\"countryName\" id=\"field_countryName\" ng-model=\"vm.prospectivePatient.countryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.regionName\" for=\"field_regionName\">Region Name</label><input type=\"text\" class=\"form-control\" name=\"regionName\" id=\"field_regionName\" ng-model=\"vm.prospectivePatient.regionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.prefectureName\" for=\"field_prefectureName\">Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"prefectureName\" id=\"field_prefectureName\" ng-model=\"vm.prospectivePatient.prefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.cityName\" for=\"field_cityName\">City Name</label><input type=\"text\" class=\"form-control\" name=\"cityName\" id=\"field_cityName\" ng-model=\"vm.prospectivePatient.cityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.prospectivePatient.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.prospectivePatient.address\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.addressNum\" for=\"field_addressNum\">Address Num</label><input type=\"text\" class=\"form-control\" name=\"addressNum\" id=\"field_addressNum\" ng-model=\"vm.prospectivePatient.addressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.isWrongPhone\" for=\"field_isWrongPhone\">Is Wrong Phone</label><input type=\"checkbox\" class=\"form-control\" name=\"isWrongPhone\" id=\"field_isWrongPhone\" ng-model=\"vm.prospectivePatient.isWrongPhone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.isWrongContact\" for=\"field_isWrongContact\">Is Wrong Contact</label><input type=\"checkbox\" class=\"form-control\" name=\"isWrongContact\" id=\"field_isWrongContact\" ng-model=\"vm.prospectivePatient.isWrongContact\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.prospectivePatient.amka\" for=\"field_amka\">Amka</label><input type=\"text\" class=\"form-control\" name=\"amka\" id=\"field_amka\" ng-model=\"vm.prospectivePatient.amka\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.attendant\" for=\"field_attendant\">Attendant</label><select class=\"form-control\" id=\"field_attendant\" name=\"attendant\" ng-model=\"vm.prospectivePatient.attendant\" ng-options=\"attendant as attendant.id for attendant in vm.attendants track by attendant.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.profession\" for=\"field_profession\">Profession</label><select class=\"form-control\" id=\"field_profession\" name=\"profession\" ng-model=\"vm.prospectivePatient.profession\" ng-options=\"profession as profession.id for profession in vm.professions track by profession.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.nativeLanguage\" for=\"field_nativeLanguage\">Native Language</label><select class=\"form-control\" id=\"field_nativeLanguage\" name=\"nativeLanguage\" ng-model=\"vm.prospectivePatient.nativeLanguage\" ng-options=\"nativeLanguage as nativeLanguage.id for nativeLanguage in vm.nativelanguages track by nativeLanguage.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.prospectivePatient.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.region\" for=\"field_region\">Region</label><select class=\"form-control\" id=\"field_region\" name=\"region\" ng-model=\"vm.prospectivePatient.region\" ng-options=\"region as region.id for region in vm.regions track by region.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.prefecture\" for=\"field_prefecture\">Prefecture</label><select class=\"form-control\" id=\"field_prefecture\" name=\"prefecture\" ng-model=\"vm.prospectivePatient.prefecture\" ng-options=\"prefecture as prefecture.id for prefecture in vm.prefectures track by prefecture.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.city\" for=\"field_city\">City</label><select class=\"form-control\" id=\"field_city\" name=\"city\" ng-model=\"vm.prospectivePatient.city\" ng-options=\"city as city.id for city in vm.cities track by city.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.prospectivePatient.countryPhoneCode\" for=\"field_countryPhoneCode\">Country Phone Code</label><select class=\"form-control\" id=\"field_countryPhoneCode\" name=\"countryPhoneCode\" ng-model=\"vm.prospectivePatient.countryPhoneCode\" ng-options=\"countryPhoneCode as countryPhoneCode.id for countryPhoneCode in vm.countryphonecodes track by countryPhoneCode.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/prospective-patient/prospective-patients.html","<div><h2 translate=\"sigmasfApp.prospectivePatient.home.title\">Prospective Patients</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"prospective-patient.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.prospectivePatient.home.createLabel\">Create new Prospective Patient</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.prospectivePatient.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.prospectivePatient.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.prospectivePatient.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span translate=\"sigmasfApp.prospectivePatient.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mobile\"><span translate=\"sigmasfApp.prospectivePatient.mobile\">Mobile</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"birthYear\"><span translate=\"sigmasfApp.prospectivePatient.birthYear\">Birth Year</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryName\"><span translate=\"sigmasfApp.prospectivePatient.countryName\">Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"regionName\"><span translate=\"sigmasfApp.prospectivePatient.regionName\">Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefectureName\"><span translate=\"sigmasfApp.prospectivePatient.prefectureName\">Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cityName\"><span translate=\"sigmasfApp.prospectivePatient.cityName\">City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.prospectivePatient.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"sigmasfApp.prospectivePatient.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressNum\"><span translate=\"sigmasfApp.prospectivePatient.addressNum\">Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isWrongPhone\"><span translate=\"sigmasfApp.prospectivePatient.isWrongPhone\">Is Wrong Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isWrongContact\"><span translate=\"sigmasfApp.prospectivePatient.isWrongContact\">Is Wrong Contact</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amka\"><span translate=\"sigmasfApp.prospectivePatient.amka\">Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"attendant.id\"><span translate=\"sigmasfApp.prospectivePatient.attendant\">Attendant</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"profession.id\"><span translate=\"sigmasfApp.prospectivePatient.profession\">Profession</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nativeLanguage.id\"><span translate=\"sigmasfApp.prospectivePatient.nativeLanguage\">Native Language</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country.id\"><span translate=\"sigmasfApp.prospectivePatient.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region.id\"><span translate=\"sigmasfApp.prospectivePatient.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture.id\"><span translate=\"sigmasfApp.prospectivePatient.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city.id\"><span translate=\"sigmasfApp.prospectivePatient.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryPhoneCode.id\"><span translate=\"sigmasfApp.prospectivePatient.countryPhoneCode\">Country Phone Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"prospectivePatient in vm.prospectivePatients track by prospectivePatient.id\"><td><a ui-sref=\"prospective-patient-detail({id:prospectivePatient.id})\">{{prospectivePatient.id}}</a></td><td>{{prospectivePatient.firstName}}</td><td>{{prospectivePatient.lastName}}</td><td>{{prospectivePatient.phone}}</td><td>{{prospectivePatient.email}}</td><td>{{prospectivePatient.mobile}}</td><td>{{prospectivePatient.birthYear}}</td><td>{{prospectivePatient.countryName}}</td><td>{{prospectivePatient.regionName}}</td><td>{{prospectivePatient.prefectureName}}</td><td>{{prospectivePatient.cityName}}</td><td>{{prospectivePatient.postalCode}}</td><td>{{prospectivePatient.address}}</td><td>{{prospectivePatient.addressNum}}</td><td>{{prospectivePatient.isWrongPhone}}</td><td>{{prospectivePatient.isWrongContact}}</td><td>{{prospectivePatient.amka}}</td><td><a ui-sref=\"attendant-detail({id:prospectivePatient.attendant.id})\">{{prospectivePatient.attendant.id}}</a></td><td><a ui-sref=\"profession-detail({id:prospectivePatient.profession.id})\">{{prospectivePatient.profession.id}}</a></td><td><a ui-sref=\"native-language-detail({id:prospectivePatient.nativeLanguage.id})\">{{prospectivePatient.nativeLanguage.id}}</a></td><td><a ui-sref=\"country-detail({id:prospectivePatient.country.id})\">{{prospectivePatient.country.id}}</a></td><td><a ui-sref=\"region-detail({id:prospectivePatient.region.id})\">{{prospectivePatient.region.id}}</a></td><td><a ui-sref=\"prefecture-detail({id:prospectivePatient.prefecture.id})\">{{prospectivePatient.prefecture.id}}</a></td><td><a ui-sref=\"city-detail({id:prospectivePatient.city.id})\">{{prospectivePatient.city.id}}</a></td><td><a ui-sref=\"country-phone-code-detail({id:prospectivePatient.countryPhoneCode.id})\">{{prospectivePatient.countryPhoneCode.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"prospective-patient-detail({id:prospectivePatient.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"prospective-patient.edit({id:prospectivePatient.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"prospective-patient.delete({id:prospectivePatient.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-item/purchase-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchaseItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchaseItem.delete.question\" translate-values=\"{id: \'{{vm.purchaseItem.id}}\'}\">Are you sure you want to delete this Purchase Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-item/purchase-item-detail.html","<div><h2><span translate=\"sigmasfApp.purchaseItem.detail.title\">Purchase Item</span> {{vm.purchaseItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchaseItem.quantity\">Quantity</span></dt><dd><span>{{vm.purchaseItem.quantity}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.productPrice\">Product Price</span></dt><dd><span>{{vm.purchaseItem.productPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.netPrice\">Net Price</span></dt><dd><span>{{vm.purchaseItem.netPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountPercent\">Discount Percent</span></dt><dd><span>{{vm.purchaseItem.discountPercent}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountPrice\">Discount Price</span></dt><dd><span>{{vm.purchaseItem.discountPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountLinePercent\">Discount Line Percent</span></dt><dd><span>{{vm.purchaseItem.discountLinePercent}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountLinePrice\">Discount Line Price</span></dt><dd><span>{{vm.purchaseItem.discountLinePrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.totalPrice\">Total Price</span></dt><dd><span>{{vm.purchaseItem.totalPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.taxPrice\">Tax Price</span></dt><dd><span>{{vm.purchaseItem.taxPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.finalPrice\">Final Price</span></dt><dd><span>{{vm.purchaseItem.finalPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.comment\">Comment</span></dt><dd><span>{{vm.purchaseItem.comment}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.quantityExecuted\">Quantity Executed</span></dt><dd><span>{{vm.purchaseItem.quantityExecuted}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountPurchasePercent\">Discount Purchase Percent</span></dt><dd><span>{{vm.purchaseItem.discountPurchasePercent}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountPurchasePrice\">Discount Purchase Price</span></dt><dd><span>{{vm.purchaseItem.discountPurchasePrice}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.discountSummary\">Discount Summary</span></dt><dd><span>{{vm.purchaseItem.discountSummary}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.taxPercent\">Tax Percent</span></dt><dd><span>{{vm.purchaseItem.taxPercent}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.lotNumber\">Lot Number</span></dt><dd><span>{{vm.purchaseItem.lotNumber}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.pfs\">Pfs</span></dt><dd><span>{{vm.purchaseItem.pfs}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.executedDiscountSummary\">Executed Discount Summary</span></dt><dd><span>{{vm.purchaseItem.executedDiscountSummary}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItem.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.purchaseItem.product.id})\">{{vm.purchaseItem.product.id}}</a></dd><dt><span translate=\"sigmasfApp.purchaseItem.purchase\">Purchase</span></dt><dd><a ui-sref=\"purchase-detail({id:vm.purchaseItem.purchase.id})\">{{vm.purchaseItem.purchase.id}}</a></dd><dt><span translate=\"sigmasfApp.purchaseItem.measurementUnit\">Measurement Unit</span></dt><dd><a ui-sref=\"measurement-unit-detail({id:vm.purchaseItem.measurementUnit.id})\">{{vm.purchaseItem.measurementUnit.name}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-item/purchase-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchaseItemLabel\" translate=\"sigmasfApp.purchaseItem.home.createOrEditLabel\">Create or edit a Purchase Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchaseItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchaseItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.purchaseItem.quantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.productPrice\" for=\"field_productPrice\">Product Price</label><input type=\"number\" class=\"form-control\" name=\"productPrice\" id=\"field_productPrice\" ng-model=\"vm.purchaseItem.productPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.netPrice\" for=\"field_netPrice\">Net Price</label><input type=\"number\" class=\"form-control\" name=\"netPrice\" id=\"field_netPrice\" ng-model=\"vm.purchaseItem.netPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountPercent\" for=\"field_discountPercent\">Discount Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPercent\" id=\"field_discountPercent\" ng-model=\"vm.purchaseItem.discountPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountPrice\" for=\"field_discountPrice\">Discount Price</label><input type=\"number\" class=\"form-control\" name=\"discountPrice\" id=\"field_discountPrice\" ng-model=\"vm.purchaseItem.discountPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountLinePercent\" for=\"field_discountLinePercent\">Discount Line Percent</label><input type=\"number\" class=\"form-control\" name=\"discountLinePercent\" id=\"field_discountLinePercent\" ng-model=\"vm.purchaseItem.discountLinePercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountLinePrice\" for=\"field_discountLinePrice\">Discount Line Price</label><input type=\"number\" class=\"form-control\" name=\"discountLinePrice\" id=\"field_discountLinePrice\" ng-model=\"vm.purchaseItem.discountLinePrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.totalPrice\" for=\"field_totalPrice\">Total Price</label><input type=\"number\" class=\"form-control\" name=\"totalPrice\" id=\"field_totalPrice\" ng-model=\"vm.purchaseItem.totalPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.taxPrice\" for=\"field_taxPrice\">Tax Price</label><input type=\"number\" class=\"form-control\" name=\"taxPrice\" id=\"field_taxPrice\" ng-model=\"vm.purchaseItem.taxPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.finalPrice\" for=\"field_finalPrice\">Final Price</label><input type=\"number\" class=\"form-control\" name=\"finalPrice\" id=\"field_finalPrice\" ng-model=\"vm.purchaseItem.finalPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.purchaseItem.comment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.quantityExecuted\" for=\"field_quantityExecuted\">Quantity Executed</label><input type=\"number\" class=\"form-control\" name=\"quantityExecuted\" id=\"field_quantityExecuted\" ng-model=\"vm.purchaseItem.quantityExecuted\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountPurchasePercent\" for=\"field_discountPurchasePercent\">Discount Purchase Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPurchasePercent\" id=\"field_discountPurchasePercent\" ng-model=\"vm.purchaseItem.discountPurchasePercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountPurchasePrice\" for=\"field_discountPurchasePrice\">Discount Purchase Price</label><input type=\"number\" class=\"form-control\" name=\"discountPurchasePrice\" id=\"field_discountPurchasePrice\" ng-model=\"vm.purchaseItem.discountPurchasePrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.discountSummary\" for=\"field_discountSummary\">Discount Summary</label><input type=\"number\" class=\"form-control\" name=\"discountSummary\" id=\"field_discountSummary\" ng-model=\"vm.purchaseItem.discountSummary\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.taxPercent\" for=\"field_taxPercent\">Tax Percent</label><input type=\"number\" class=\"form-control\" name=\"taxPercent\" id=\"field_taxPercent\" ng-model=\"vm.purchaseItem.taxPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.lotNumber\" for=\"field_lotNumber\">Lot Number</label><input type=\"text\" class=\"form-control\" name=\"lotNumber\" id=\"field_lotNumber\" ng-model=\"vm.purchaseItem.lotNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.pfs\" for=\"field_pfs\">Pfs</label><input type=\"number\" class=\"form-control\" name=\"pfs\" id=\"field_pfs\" ng-model=\"vm.purchaseItem.pfs\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItem.executedDiscountSummary\" for=\"field_executedDiscountSummary\">Executed Discount Summary</label><input type=\"number\" class=\"form-control\" name=\"executedDiscountSummary\" id=\"field_executedDiscountSummary\" ng-model=\"vm.purchaseItem.executedDiscountSummary\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchaseItem.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.purchaseItem.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchaseItem.purchase\" for=\"field_purchase\">Purchase</label><select class=\"form-control\" id=\"field_purchase\" name=\"purchase\" ng-model=\"vm.purchaseItem.purchase\" ng-options=\"purchase as purchase.id for purchase in vm.purchases track by purchase.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchaseItem.measurementUnit\" for=\"field_measurementUnit\">Measurement Unit</label><select class=\"form-control\" id=\"field_measurementUnit\" name=\"measurementUnit\" ng-model=\"vm.purchaseItem.measurementUnit\" ng-options=\"measurementUnit as measurementUnit.name for measurementUnit in vm.measurementunits track by measurementUnit.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-item/purchase-items.html","<div><h2 translate=\"sigmasfApp.purchaseItem.home.title\">Purchase Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchaseItem.home.createLabel\">Create new Purchase Item</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantity\"><span translate=\"sigmasfApp.purchaseItem.quantity\">Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productPrice\"><span translate=\"sigmasfApp.purchaseItem.productPrice\">Product Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"netPrice\"><span translate=\"sigmasfApp.purchaseItem.netPrice\">Net Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPercent\"><span translate=\"sigmasfApp.purchaseItem.discountPercent\">Discount Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPrice\"><span translate=\"sigmasfApp.purchaseItem.discountPrice\">Discount Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountLinePercent\"><span translate=\"sigmasfApp.purchaseItem.discountLinePercent\">Discount Line Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountLinePrice\"><span translate=\"sigmasfApp.purchaseItem.discountLinePrice\">Discount Line Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalPrice\"><span translate=\"sigmasfApp.purchaseItem.totalPrice\">Total Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxPrice\"><span translate=\"sigmasfApp.purchaseItem.taxPrice\">Tax Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalPrice\"><span translate=\"sigmasfApp.purchaseItem.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comment\"><span translate=\"sigmasfApp.purchaseItem.comment\">Comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantityExecuted\"><span translate=\"sigmasfApp.purchaseItem.quantityExecuted\">Quantity Executed</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPurchasePercent\"><span translate=\"sigmasfApp.purchaseItem.discountPurchasePercent\">Discount Purchase Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPurchasePrice\"><span translate=\"sigmasfApp.purchaseItem.discountPurchasePrice\">Discount Purchase Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountSummary\"><span translate=\"sigmasfApp.purchaseItem.discountSummary\">Discount Summary</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxPercent\"><span translate=\"sigmasfApp.purchaseItem.taxPercent\">Tax Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lotNumber\"><span translate=\"sigmasfApp.purchaseItem.lotNumber\">Lot Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pfs\"><span translate=\"sigmasfApp.purchaseItem.pfs\">Pfs</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"executedDiscountSummary\"><span translate=\"sigmasfApp.purchaseItem.executedDiscountSummary\">Executed Discount Summary</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.purchaseItem.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"purchase.id\"><span translate=\"sigmasfApp.purchaseItem.purchase\">Purchase</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"measurementUnit.name\"><span translate=\"sigmasfApp.purchaseItem.measurementUnit\">Measurement Unit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchaseItem in vm.purchaseItems track by purchaseItem.id\"><td><a ui-sref=\"purchase-item-detail({id:purchaseItem.id})\">{{purchaseItem.id}}</a></td><td>{{purchaseItem.quantity}}</td><td>{{purchaseItem.productPrice}}</td><td>{{purchaseItem.netPrice}}</td><td>{{purchaseItem.discountPercent}}</td><td>{{purchaseItem.discountPrice}}</td><td>{{purchaseItem.discountLinePercent}}</td><td>{{purchaseItem.discountLinePrice}}</td><td>{{purchaseItem.totalPrice}}</td><td>{{purchaseItem.taxPrice}}</td><td>{{purchaseItem.finalPrice}}</td><td>{{purchaseItem.comment}}</td><td>{{purchaseItem.quantityExecuted}}</td><td>{{purchaseItem.discountPurchasePercent}}</td><td>{{purchaseItem.discountPurchasePrice}}</td><td>{{purchaseItem.discountSummary}}</td><td>{{purchaseItem.taxPercent}}</td><td>{{purchaseItem.lotNumber}}</td><td>{{purchaseItem.pfs}}</td><td>{{purchaseItem.executedDiscountSummary}}</td><td><a ui-sref=\"product-detail({id:purchaseItem.product.id})\">{{purchaseItem.product.id}}</a></td><td><a ui-sref=\"purchase-detail({id:purchaseItem.purchase.id})\">{{purchaseItem.purchase.id}}</a></td><td><a ui-sref=\"measurement-unit-detail({id:purchaseItem.measurementUnit.id})\">{{purchaseItem.measurementUnit.name}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-item-detail({id:purchaseItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-item.edit({id:purchaseItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-item.delete({id:purchaseItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase/purchase-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchase.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchase.delete.question\" translate-values=\"{id: \'{{vm.purchase.id}}\'}\">Are you sure you want to delete this Purchase?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase/purchase-detail.html","<div><h2><span translate=\"sigmasfApp.purchase.detail.title\">Purchase</span> {{vm.purchase.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchase.issueDate\">Issue Date</span></dt><dd><span>{{vm.purchase.issueDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.purchase.desirableExecutionDate\">Desirable Execution Date</span></dt><dd><span>{{vm.purchase.desirableExecutionDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingAddressNum\">Shipping Address Num</span></dt><dd><span>{{vm.purchase.shippingAddressNum}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingAddress\">Shipping Address</span></dt><dd><span>{{vm.purchase.shippingAddress}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingCityName\">Shipping City Name</span></dt><dd><span>{{vm.purchase.shippingCityName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingPrefectureName\">Shipping Prefecture Name</span></dt><dd><span>{{vm.purchase.shippingPrefectureName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingRegionName\">Shipping Region Name</span></dt><dd><span>{{vm.purchase.shippingRegionName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingCountryName\">Shipping Country Name</span></dt><dd><span>{{vm.purchase.shippingCountryName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.shippingPostalCode\">Shipping Postal Code</span></dt><dd><span>{{vm.purchase.shippingPostalCode}}</span></dd><dt><span translate=\"sigmasfApp.purchase.netPrice\">Net Price</span></dt><dd><span>{{vm.purchase.netPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.discountPrice\">Discount Price</span></dt><dd><span>{{vm.purchase.discountPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.totalPrice\">Total Price</span></dt><dd><span>{{vm.purchase.totalPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.taxPrice\">Tax Price</span></dt><dd><span>{{vm.purchase.taxPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.finalPrice\">Final Price</span></dt><dd><span>{{vm.purchase.finalPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.comment\">Comment</span></dt><dd><span>{{vm.purchase.comment}}</span></dd><dt><span translate=\"sigmasfApp.purchase.previousBalance\">Previous Balance</span></dt><dd><span>{{vm.purchase.previousBalance}}</span></dd><dt><span translate=\"sigmasfApp.purchase.creditLimit\">Credit Limit</span></dt><dd><span>{{vm.purchase.creditLimit}}</span></dd><dt><span translate=\"sigmasfApp.purchase.newBalance\">New Balance</span></dt><dd><span>{{vm.purchase.newBalance}}</span></dd><dt><span translate=\"sigmasfApp.purchase.discountPercent\">Discount Percent</span></dt><dd><span>{{vm.purchase.discountPercent}}</span></dd><dt><span translate=\"sigmasfApp.purchase.presentPrice\">Present Price</span></dt><dd><span>{{vm.purchase.presentPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorAddressNum\">Sector Address Num</span></dt><dd><span>{{vm.purchase.sectorAddressNum}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorAddress\">Sector Address</span></dt><dd><span>{{vm.purchase.sectorAddress}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorCityName\">Sector City Name</span></dt><dd><span>{{vm.purchase.sectorCityName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorPrefectureName\">Sector Prefecture Name</span></dt><dd><span>{{vm.purchase.sectorPrefectureName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorRegionName\">Sector Region Name</span></dt><dd><span>{{vm.purchase.sectorRegionName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorCountryName\">Sector Country Name</span></dt><dd><span>{{vm.purchase.sectorCountryName}}</span></dd><dt><span translate=\"sigmasfApp.purchase.sectorPostalCode\">Sector Postal Code</span></dt><dd><span>{{vm.purchase.sectorPostalCode}}</span></dd><dt><span translate=\"sigmasfApp.purchase.code\">Code</span></dt><dd><span>{{vm.purchase.code}}</span></dd><dt><span translate=\"sigmasfApp.purchase.presentPercent\">Present Percent</span></dt><dd><span>{{vm.purchase.presentPercent}}</span></dd><dt><span translate=\"sigmasfApp.purchase.discountFinalPrice\">Discount Final Price</span></dt><dd><span>{{vm.purchase.discountFinalPrice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.createdFromBackOffice\">Created From Back Office</span></dt><dd><span>{{vm.purchase.createdFromBackOffice}}</span></dd><dt><span translate=\"sigmasfApp.purchase.eventComments\">Event Comments</span></dt><dd><span>{{vm.purchase.eventComments}}</span></dd><dt><span translate=\"sigmasfApp.purchase.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.purchase.employee.id})\">{{vm.purchase.employee.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.purchaseStatus\">Purchase Status</span></dt><dd><a ui-sref=\"purchase-status-detail({id:vm.purchase.purchaseStatus.id})\">{{vm.purchase.purchaseStatus.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.purchase.sector.id})\">{{vm.purchase.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.purchase.customer.id})\">{{vm.purchase.customer.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.paymentMethod\">Payment Method</span></dt><dd><a ui-sref=\"payment-method-detail({id:vm.purchase.paymentMethod.id})\">{{vm.purchase.paymentMethod.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.taxStatus\">Tax Status</span></dt><dd><a ui-sref=\"tax-status-detail({id:vm.purchase.taxStatus.id})\">{{vm.purchase.taxStatus.name}}</a></dd><dt><span translate=\"sigmasfApp.purchase.purchaseNumberingRow\">Purchase Numbering Row</span></dt><dd><a ui-sref=\"purchase-numbering-row-detail({id:vm.purchase.purchaseNumberingRow.id})\">{{vm.purchase.purchaseNumberingRow.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.tradePolicy\">Trade Policy</span></dt><dd><a ui-sref=\"trade-policy-detail({id:vm.purchase.tradePolicy.id})\">{{vm.purchase.tradePolicy.id}}</a></dd><dt><span translate=\"sigmasfApp.purchase.picker\">Picker</span></dt><dd><a ui-sref=\"employee-detail({id:vm.purchase.picker.id})\">{{vm.purchase.picker.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase/purchase-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchaseLabel\" translate=\"sigmasfApp.purchase.home.createOrEditLabel\">Create or edit a Purchase</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchase.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchase.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.issueDate\" for=\"field_issueDate\">Issue Date</label><div class=\"input-group\"><input id=\"field_issueDate\" type=\"text\" class=\"form-control\" name=\"issueDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.purchase.issueDate\" is-open=\"vm.datePickerOpenStatus.issueDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issueDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.desirableExecutionDate\" for=\"field_desirableExecutionDate\">Desirable Execution Date</label><div class=\"input-group\"><input id=\"field_desirableExecutionDate\" type=\"text\" class=\"form-control\" name=\"desirableExecutionDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.purchase.desirableExecutionDate\" is-open=\"vm.datePickerOpenStatus.desirableExecutionDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'desirableExecutionDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingAddressNum\" for=\"field_shippingAddressNum\">Shipping Address Num</label><input type=\"text\" class=\"form-control\" name=\"shippingAddressNum\" id=\"field_shippingAddressNum\" ng-model=\"vm.purchase.shippingAddressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingAddress\" for=\"field_shippingAddress\">Shipping Address</label><input type=\"text\" class=\"form-control\" name=\"shippingAddress\" id=\"field_shippingAddress\" ng-model=\"vm.purchase.shippingAddress\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingCityName\" for=\"field_shippingCityName\">Shipping City Name</label><input type=\"text\" class=\"form-control\" name=\"shippingCityName\" id=\"field_shippingCityName\" ng-model=\"vm.purchase.shippingCityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingPrefectureName\" for=\"field_shippingPrefectureName\">Shipping Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"shippingPrefectureName\" id=\"field_shippingPrefectureName\" ng-model=\"vm.purchase.shippingPrefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingRegionName\" for=\"field_shippingRegionName\">Shipping Region Name</label><input type=\"text\" class=\"form-control\" name=\"shippingRegionName\" id=\"field_shippingRegionName\" ng-model=\"vm.purchase.shippingRegionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingCountryName\" for=\"field_shippingCountryName\">Shipping Country Name</label><input type=\"text\" class=\"form-control\" name=\"shippingCountryName\" id=\"field_shippingCountryName\" ng-model=\"vm.purchase.shippingCountryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.shippingPostalCode\" for=\"field_shippingPostalCode\">Shipping Postal Code</label><input type=\"text\" class=\"form-control\" name=\"shippingPostalCode\" id=\"field_shippingPostalCode\" ng-model=\"vm.purchase.shippingPostalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.netPrice\" for=\"field_netPrice\">Net Price</label><input type=\"number\" class=\"form-control\" name=\"netPrice\" id=\"field_netPrice\" ng-model=\"vm.purchase.netPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.discountPrice\" for=\"field_discountPrice\">Discount Price</label><input type=\"number\" class=\"form-control\" name=\"discountPrice\" id=\"field_discountPrice\" ng-model=\"vm.purchase.discountPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.totalPrice\" for=\"field_totalPrice\">Total Price</label><input type=\"number\" class=\"form-control\" name=\"totalPrice\" id=\"field_totalPrice\" ng-model=\"vm.purchase.totalPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.taxPrice\" for=\"field_taxPrice\">Tax Price</label><input type=\"number\" class=\"form-control\" name=\"taxPrice\" id=\"field_taxPrice\" ng-model=\"vm.purchase.taxPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.finalPrice\" for=\"field_finalPrice\">Final Price</label><input type=\"number\" class=\"form-control\" name=\"finalPrice\" id=\"field_finalPrice\" ng-model=\"vm.purchase.finalPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.purchase.comment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.previousBalance\" for=\"field_previousBalance\">Previous Balance</label><input type=\"number\" class=\"form-control\" name=\"previousBalance\" id=\"field_previousBalance\" ng-model=\"vm.purchase.previousBalance\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.creditLimit\" for=\"field_creditLimit\">Credit Limit</label><input type=\"number\" class=\"form-control\" name=\"creditLimit\" id=\"field_creditLimit\" ng-model=\"vm.purchase.creditLimit\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.newBalance\" for=\"field_newBalance\">New Balance</label><input type=\"number\" class=\"form-control\" name=\"newBalance\" id=\"field_newBalance\" ng-model=\"vm.purchase.newBalance\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.discountPercent\" for=\"field_discountPercent\">Discount Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPercent\" id=\"field_discountPercent\" ng-model=\"vm.purchase.discountPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.presentPrice\" for=\"field_presentPrice\">Present Price</label><input type=\"number\" class=\"form-control\" name=\"presentPrice\" id=\"field_presentPrice\" ng-model=\"vm.purchase.presentPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorAddressNum\" for=\"field_sectorAddressNum\">Sector Address Num</label><input type=\"text\" class=\"form-control\" name=\"sectorAddressNum\" id=\"field_sectorAddressNum\" ng-model=\"vm.purchase.sectorAddressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorAddress\" for=\"field_sectorAddress\">Sector Address</label><input type=\"text\" class=\"form-control\" name=\"sectorAddress\" id=\"field_sectorAddress\" ng-model=\"vm.purchase.sectorAddress\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorCityName\" for=\"field_sectorCityName\">Sector City Name</label><input type=\"text\" class=\"form-control\" name=\"sectorCityName\" id=\"field_sectorCityName\" ng-model=\"vm.purchase.sectorCityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorPrefectureName\" for=\"field_sectorPrefectureName\">Sector Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"sectorPrefectureName\" id=\"field_sectorPrefectureName\" ng-model=\"vm.purchase.sectorPrefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorRegionName\" for=\"field_sectorRegionName\">Sector Region Name</label><input type=\"text\" class=\"form-control\" name=\"sectorRegionName\" id=\"field_sectorRegionName\" ng-model=\"vm.purchase.sectorRegionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorCountryName\" for=\"field_sectorCountryName\">Sector Country Name</label><input type=\"text\" class=\"form-control\" name=\"sectorCountryName\" id=\"field_sectorCountryName\" ng-model=\"vm.purchase.sectorCountryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.sectorPostalCode\" for=\"field_sectorPostalCode\">Sector Postal Code</label><input type=\"text\" class=\"form-control\" name=\"sectorPostalCode\" id=\"field_sectorPostalCode\" ng-model=\"vm.purchase.sectorPostalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.purchase.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.presentPercent\" for=\"field_presentPercent\">Present Percent</label><input type=\"number\" class=\"form-control\" name=\"presentPercent\" id=\"field_presentPercent\" ng-model=\"vm.purchase.presentPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.discountFinalPrice\" for=\"field_discountFinalPrice\">Discount Final Price</label><input type=\"number\" class=\"form-control\" name=\"discountFinalPrice\" id=\"field_discountFinalPrice\" ng-model=\"vm.purchase.discountFinalPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.createdFromBackOffice\" for=\"field_createdFromBackOffice\">Created From Back Office</label><input type=\"checkbox\" class=\"form-control\" name=\"createdFromBackOffice\" id=\"field_createdFromBackOffice\" ng-model=\"vm.purchase.createdFromBackOffice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchase.eventComments\" for=\"field_eventComments\">Event Comments</label><input type=\"text\" class=\"form-control\" name=\"eventComments\" id=\"field_eventComments\" ng-model=\"vm.purchase.eventComments\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.purchase.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.purchaseStatus\" for=\"field_purchaseStatus\">Purchase Status</label><select class=\"form-control\" id=\"field_purchaseStatus\" name=\"purchaseStatus\" ng-model=\"vm.purchase.purchaseStatus\" ng-options=\"purchaseStatus as purchaseStatus.id for purchaseStatus in vm.purchasestatuses track by purchaseStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.purchase.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.purchase.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.paymentMethod\" for=\"field_paymentMethod\">Payment Method</label><select class=\"form-control\" id=\"field_paymentMethod\" name=\"paymentMethod\" ng-model=\"vm.purchase.paymentMethod\" ng-options=\"paymentMethod as paymentMethod.id for paymentMethod in vm.paymentmethods track by paymentMethod.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.taxStatus\" for=\"field_taxStatus\">Tax Status</label><select class=\"form-control\" id=\"field_taxStatus\" name=\"taxStatus\" ng-model=\"vm.purchase.taxStatus\" ng-options=\"taxStatus as taxStatus.name for taxStatus in vm.taxstatuses track by taxStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.purchaseNumberingRow\" for=\"field_purchaseNumberingRow\">Purchase Numbering Row</label><select class=\"form-control\" id=\"field_purchaseNumberingRow\" name=\"purchaseNumberingRow\" ng-model=\"vm.purchase.purchaseNumberingRow\" ng-options=\"purchaseNumberingRow as purchaseNumberingRow.id for purchaseNumberingRow in vm.purchasenumberingrows track by purchaseNumberingRow.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.tradePolicy\" for=\"field_tradePolicy\">Trade Policy</label><select class=\"form-control\" id=\"field_tradePolicy\" name=\"tradePolicy\" ng-model=\"vm.purchase.tradePolicy\" ng-options=\"tradePolicy as tradePolicy.id for tradePolicy in vm.tradepolicies track by tradePolicy.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchase.picker\" for=\"field_picker\">Picker</label><select class=\"form-control\" id=\"field_picker\" name=\"picker\" ng-model=\"vm.purchase.picker\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase/purchases.html","<div><h2 translate=\"sigmasfApp.purchase.home.title\">Purchases</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchase.home.createLabel\">Create new Purchase</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issueDate\"><span translate=\"sigmasfApp.purchase.issueDate\">Issue Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"desirableExecutionDate\"><span translate=\"sigmasfApp.purchase.desirableExecutionDate\">Desirable Execution Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingAddressNum\"><span translate=\"sigmasfApp.purchase.shippingAddressNum\">Shipping Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingAddress\"><span translate=\"sigmasfApp.purchase.shippingAddress\">Shipping Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingCityName\"><span translate=\"sigmasfApp.purchase.shippingCityName\">Shipping City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingPrefectureName\"><span translate=\"sigmasfApp.purchase.shippingPrefectureName\">Shipping Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingRegionName\"><span translate=\"sigmasfApp.purchase.shippingRegionName\">Shipping Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingCountryName\"><span translate=\"sigmasfApp.purchase.shippingCountryName\">Shipping Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shippingPostalCode\"><span translate=\"sigmasfApp.purchase.shippingPostalCode\">Shipping Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"netPrice\"><span translate=\"sigmasfApp.purchase.netPrice\">Net Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPrice\"><span translate=\"sigmasfApp.purchase.discountPrice\">Discount Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalPrice\"><span translate=\"sigmasfApp.purchase.totalPrice\">Total Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxPrice\"><span translate=\"sigmasfApp.purchase.taxPrice\">Tax Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"finalPrice\"><span translate=\"sigmasfApp.purchase.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comment\"><span translate=\"sigmasfApp.purchase.comment\">Comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"previousBalance\"><span translate=\"sigmasfApp.purchase.previousBalance\">Previous Balance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creditLimit\"><span translate=\"sigmasfApp.purchase.creditLimit\">Credit Limit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"newBalance\"><span translate=\"sigmasfApp.purchase.newBalance\">New Balance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPercent\"><span translate=\"sigmasfApp.purchase.discountPercent\">Discount Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"presentPrice\"><span translate=\"sigmasfApp.purchase.presentPrice\">Present Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorAddressNum\"><span translate=\"sigmasfApp.purchase.sectorAddressNum\">Sector Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorAddress\"><span translate=\"sigmasfApp.purchase.sectorAddress\">Sector Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorCityName\"><span translate=\"sigmasfApp.purchase.sectorCityName\">Sector City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorPrefectureName\"><span translate=\"sigmasfApp.purchase.sectorPrefectureName\">Sector Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorRegionName\"><span translate=\"sigmasfApp.purchase.sectorRegionName\">Sector Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorCountryName\"><span translate=\"sigmasfApp.purchase.sectorCountryName\">Sector Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorPostalCode\"><span translate=\"sigmasfApp.purchase.sectorPostalCode\">Sector Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.purchase.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"presentPercent\"><span translate=\"sigmasfApp.purchase.presentPercent\">Present Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountFinalPrice\"><span translate=\"sigmasfApp.purchase.discountFinalPrice\">Discount Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdFromBackOffice\"><span translate=\"sigmasfApp.purchase.createdFromBackOffice\">Created From Back Office</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventComments\"><span translate=\"sigmasfApp.purchase.eventComments\">Event Comments</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.purchase.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"purchaseStatus.id\"><span translate=\"sigmasfApp.purchase.purchaseStatus\">Purchase Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.purchase.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span translate=\"sigmasfApp.purchase.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paymentMethod.id\"><span translate=\"sigmasfApp.purchase.paymentMethod\">Payment Method</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxStatus.name\"><span translate=\"sigmasfApp.purchase.taxStatus\">Tax Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"purchaseNumberingRow.id\"><span translate=\"sigmasfApp.purchase.purchaseNumberingRow\">Purchase Numbering Row</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tradePolicy.id\"><span translate=\"sigmasfApp.purchase.tradePolicy\">Trade Policy</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"picker.id\"><span translate=\"sigmasfApp.purchase.picker\">Picker</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchase in vm.purchases track by purchase.id\"><td><a ui-sref=\"purchase-detail({id:purchase.id})\">{{purchase.id}}</a></td><td>{{purchase.issueDate | date:\'mediumDate\'}}</td><td>{{purchase.desirableExecutionDate | date:\'mediumDate\'}}</td><td>{{purchase.shippingAddressNum}}</td><td>{{purchase.shippingAddress}}</td><td>{{purchase.shippingCityName}}</td><td>{{purchase.shippingPrefectureName}}</td><td>{{purchase.shippingRegionName}}</td><td>{{purchase.shippingCountryName}}</td><td>{{purchase.shippingPostalCode}}</td><td>{{purchase.netPrice}}</td><td>{{purchase.discountPrice}}</td><td>{{purchase.totalPrice}}</td><td>{{purchase.taxPrice}}</td><td>{{purchase.finalPrice}}</td><td>{{purchase.comment}}</td><td>{{purchase.previousBalance}}</td><td>{{purchase.creditLimit}}</td><td>{{purchase.newBalance}}</td><td>{{purchase.discountPercent}}</td><td>{{purchase.presentPrice}}</td><td>{{purchase.sectorAddressNum}}</td><td>{{purchase.sectorAddress}}</td><td>{{purchase.sectorCityName}}</td><td>{{purchase.sectorPrefectureName}}</td><td>{{purchase.sectorRegionName}}</td><td>{{purchase.sectorCountryName}}</td><td>{{purchase.sectorPostalCode}}</td><td>{{purchase.code}}</td><td>{{purchase.presentPercent}}</td><td>{{purchase.discountFinalPrice}}</td><td>{{purchase.createdFromBackOffice}}</td><td>{{purchase.eventComments}}</td><td><a ui-sref=\"employee-detail({id:purchase.employee.id})\">{{purchase.employee.id}}</a></td><td><a ui-sref=\"purchase-status-detail({id:purchase.purchaseStatus.id})\">{{purchase.purchaseStatus.id}}</a></td><td><a ui-sref=\"sector-detail({id:purchase.sector.id})\">{{purchase.sector.id}}</a></td><td><a ui-sref=\"customer-detail({id:purchase.customer.id})\">{{purchase.customer.id}}</a></td><td><a ui-sref=\"payment-method-detail({id:purchase.paymentMethod.id})\">{{purchase.paymentMethod.id}}</a></td><td><a ui-sref=\"tax-status-detail({id:purchase.taxStatus.id})\">{{purchase.taxStatus.name}}</a></td><td><a ui-sref=\"purchase-numbering-row-detail({id:purchase.purchaseNumberingRow.id})\">{{purchase.purchaseNumberingRow.id}}</a></td><td><a ui-sref=\"trade-policy-detail({id:purchase.tradePolicy.id})\">{{purchase.tradePolicy.id}}</a></td><td><a ui-sref=\"employee-detail({id:purchase.picker.id})\">{{purchase.picker.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-detail({id:purchase.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase.edit({id:purchase.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase.delete({id:purchase.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-numbering-row/purchase-numbering-row-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchaseNumberingRow.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchaseNumberingRow.delete.question\" translate-values=\"{id: \'{{vm.purchaseNumberingRow.id}}\'}\">Are you sure you want to delete this Purchase Numbering Row?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-numbering-row/purchase-numbering-row-detail.html","<div><h2><span translate=\"sigmasfApp.purchaseNumberingRow.detail.title\">Purchase Numbering Row</span> {{vm.purchaseNumberingRow.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchaseNumberingRow.name\">Name</span></dt><dd><span>{{vm.purchaseNumberingRow.name}}</span></dd><dt><span translate=\"sigmasfApp.purchaseNumberingRow.lastUsedNumber\">Last Used Number</span></dt><dd><span>{{vm.purchaseNumberingRow.lastUsedNumber}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-numbering-row/purchase-numbering-row-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchaseNumberingRowLabel\" translate=\"sigmasfApp.purchaseNumberingRow.home.createOrEditLabel\">Create or edit a Purchase Numbering Row</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchaseNumberingRow.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchaseNumberingRow.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseNumberingRow.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.purchaseNumberingRow.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseNumberingRow.lastUsedNumber\" for=\"field_lastUsedNumber\">Last Used Number</label><input type=\"number\" class=\"form-control\" name=\"lastUsedNumber\" id=\"field_lastUsedNumber\" ng-model=\"vm.purchaseNumberingRow.lastUsedNumber\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-numbering-row/purchase-numbering-rows.html","<div><h2 translate=\"sigmasfApp.purchaseNumberingRow.home.title\">Purchase Numbering Rows</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-numbering-row.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchaseNumberingRow.home.createLabel\">Create new Purchase Numbering Row</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.purchaseNumberingRow.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastUsedNumber\"><span translate=\"sigmasfApp.purchaseNumberingRow.lastUsedNumber\">Last Used Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchaseNumberingRow in vm.purchaseNumberingRows track by purchaseNumberingRow.id\"><td><a ui-sref=\"purchase-numbering-row-detail({id:purchaseNumberingRow.id})\">{{purchaseNumberingRow.id}}</a></td><td>{{purchaseNumberingRow.name}}</td><td>{{purchaseNumberingRow.lastUsedNumber}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-numbering-row-detail({id:purchaseNumberingRow.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-numbering-row.edit({id:purchaseNumberingRow.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-numbering-row.delete({id:purchaseNumberingRow.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-present-item/purchase-present-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchasePresentItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchasePresentItem.delete.question\" translate-values=\"{id: \'{{vm.purchasePresentItem.id}}\'}\">Are you sure you want to delete this Purchase Present Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-present-item/purchase-present-item-detail.html","<div><h2><span translate=\"sigmasfApp.purchasePresentItem.detail.title\">Purchase Present Item</span> {{vm.purchasePresentItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchasePresentItem.quantity\">Quantity</span></dt><dd><span>{{vm.purchasePresentItem.quantity}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.price\">Price</span></dt><dd><span>{{vm.purchasePresentItem.price}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.quantityExecuted\">Quantity Executed</span></dt><dd><span>{{vm.purchasePresentItem.quantityExecuted}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.ruleType\">Rule Type</span></dt><dd><span translate=\"{{\'sigmasfApp.TradePolicyRuleTypeEnum.\' + vm.purchasePresentItem.ruleType}}\">{{vm.purchasePresentItem.ruleType}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.purchase\">Purchase</span></dt><dd><a ui-sref=\"purchase-detail({id:vm.purchasePresentItem.purchase.id})\">{{vm.purchasePresentItem.purchase.id}}</a></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.purchasePresentItem.product.id})\">{{vm.purchasePresentItem.product.id}}</a></dd><dt><span translate=\"sigmasfApp.purchasePresentItem.presentListProduct\">Present List Product</span></dt><dd><a ui-sref=\"present-list-product-detail({id:vm.purchasePresentItem.presentListProduct.id})\">{{vm.purchasePresentItem.presentListProduct.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-present-item/purchase-present-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchasePresentItemLabel\" translate=\"sigmasfApp.purchasePresentItem.home.createOrEditLabel\">Create or edit a Purchase Present Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchasePresentItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchasePresentItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItem.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.purchasePresentItem.quantity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItem.price\" for=\"field_price\">Price</label><input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"vm.purchasePresentItem.price\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItem.quantityExecuted\" for=\"field_quantityExecuted\">Quantity Executed</label><input type=\"number\" class=\"form-control\" name=\"quantityExecuted\" id=\"field_quantityExecuted\" ng-model=\"vm.purchasePresentItem.quantityExecuted\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItem.ruleType\" for=\"field_ruleType\">Rule Type</label><select class=\"form-control\" name=\"ruleType\" ng-model=\"vm.purchasePresentItem.ruleType\" id=\"field_ruleType\"><option value=\"purchasePrice\" translate=\"sigmasfApp.TradePolicyRuleTypeEnum.purchasePrice\">purchasePrice</option><option value=\"quantityPerRow\" translate=\"sigmasfApp.TradePolicyRuleTypeEnum.quantityPerRow\">quantityPerRow</option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchasePresentItem.purchase\" for=\"field_purchase\">Purchase</label><select class=\"form-control\" id=\"field_purchase\" name=\"purchase\" ng-model=\"vm.purchasePresentItem.purchase\" ng-options=\"purchase as purchase.id for purchase in vm.purchases track by purchase.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchasePresentItem.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.purchasePresentItem.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchasePresentItem.presentListProduct\" for=\"field_presentListProduct\">Present List Product</label><select class=\"form-control\" id=\"field_presentListProduct\" name=\"presentListProduct\" ng-model=\"vm.purchasePresentItem.presentListProduct\" ng-options=\"presentListProduct as presentListProduct.id for presentListProduct in vm.presentlistproducts track by presentListProduct.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-present-item/purchase-present-items.html","<div><h2 translate=\"sigmasfApp.purchasePresentItem.home.title\">Purchase Present Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-present-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchasePresentItem.home.createLabel\">Create new Purchase Present Item</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantity\"><span translate=\"sigmasfApp.purchasePresentItem.quantity\">Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"sigmasfApp.purchasePresentItem.price\">Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantityExecuted\"><span translate=\"sigmasfApp.purchasePresentItem.quantityExecuted\">Quantity Executed</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ruleType\"><span translate=\"sigmasfApp.purchasePresentItem.ruleType\">Rule Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"purchase.id\"><span translate=\"sigmasfApp.purchasePresentItem.purchase\">Purchase</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.purchasePresentItem.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"presentListProduct.id\"><span translate=\"sigmasfApp.purchasePresentItem.presentListProduct\">Present List Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchasePresentItem in vm.purchasePresentItems track by purchasePresentItem.id\"><td><a ui-sref=\"purchase-present-item-detail({id:purchasePresentItem.id})\">{{purchasePresentItem.id}}</a></td><td>{{purchasePresentItem.quantity}}</td><td>{{purchasePresentItem.price}}</td><td>{{purchasePresentItem.quantityExecuted}}</td><td translate=\"{{\'sigmasfApp.TradePolicyRuleTypeEnum.\' + purchasePresentItem.ruleType}}\">{{purchasePresentItem.ruleType}}</td><td><a ui-sref=\"purchase-detail({id:purchasePresentItem.purchase.id})\">{{purchasePresentItem.purchase.id}}</a></td><td><a ui-sref=\"product-detail({id:purchasePresentItem.product.id})\">{{purchasePresentItem.product.id}}</a></td><td><a ui-sref=\"present-list-product-detail({id:purchasePresentItem.presentListProduct.id})\">{{purchasePresentItem.presentListProduct.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-present-item-detail({id:purchasePresentItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-present-item.edit({id:purchasePresentItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-present-item.delete({id:purchasePresentItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-item-lot/purchase-item-lot-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchaseItemLot.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchaseItemLot.delete.question\" translate-values=\"{id: \'{{vm.purchaseItemLot.id}}\'}\">Are you sure you want to delete this Purchase Item Lot?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-item-lot/purchase-item-lot-detail.html","<div><h2><span translate=\"sigmasfApp.purchaseItemLot.detail.title\">Purchase Item Lot</span> {{vm.purchaseItemLot.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchaseItemLot.name\">Name</span></dt><dd><span>{{vm.purchaseItemLot.name}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItemLot.quantity\">Quantity</span></dt><dd><span>{{vm.purchaseItemLot.quantity}}</span></dd><dt><span translate=\"sigmasfApp.purchaseItemLot.purchaseItem\">Purchase Item</span></dt><dd><a ui-sref=\"purchase-item-detail({id:vm.purchaseItemLot.purchaseItem.id})\">{{vm.purchaseItemLot.purchaseItem.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-item-lot/purchase-item-lot-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchaseItemLotLabel\" translate=\"sigmasfApp.purchaseItemLot.home.createOrEditLabel\">Create or edit a Purchase Item Lot</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchaseItemLot.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchaseItemLot.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItemLot.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.purchaseItemLot.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseItemLot.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.purchaseItemLot.quantity\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchaseItemLot.purchaseItem\" for=\"field_purchaseItem\">Purchase Item</label><select class=\"form-control\" id=\"field_purchaseItem\" name=\"purchaseItem\" ng-model=\"vm.purchaseItemLot.purchaseItem\" ng-options=\"purchaseItem as purchaseItem.id for purchaseItem in vm.purchaseItems track by purchaseItem.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-item-lot/purchase-item-lots.html","<div><h2 translate=\"sigmasfApp.purchaseItemLot.home.title\">Purchase Item Lots</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-item-lot.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchaseItemLot.home.createLabel\">Create new Purchase Item Lot</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"sigmasfApp.purchaseItemLot.name\">Name</span></th><th><span translate=\"sigmasfApp.purchaseItemLot.quantity\">Quantity</span></th><th><span translate=\"sigmasfApp.purchaseItemLot.purchaseItem\">Purchase Item</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchaseItemLot in vm.purchaseItemLots track by purchaseItemLot.id\"><td><a ui-sref=\"purchase-item-lot-detail({id:purchaseItemLot.id})\">{{purchaseItemLot.id}}</a></td><td>{{purchaseItemLot.name}}</td><td>{{purchaseItemLot.quantity}}</td><td><a ui-sref=\"purchase-item-detail({id:purchaseItemLot.purchaseItem.id})\">{{purchaseItemLot.purchaseItem.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-item-lot-detail({id:purchaseItemLot.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-item-lot.edit({id:purchaseItemLot.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-item-lot.delete({id:purchaseItemLot.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/region/region-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.region.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.region.delete.question\" translate-values=\"{id: \'{{vm.region.id}}\'}\">Are you sure you want to delete this Region?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/region/region-detail.html","<div><h2><span translate=\"sigmasfApp.region.detail.title\">Region</span> {{vm.region.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.region.name\">Name</span></dt><dd><span>{{vm.region.name}}</span></dd><dt><span translate=\"sigmasfApp.region.nameEn\">Name En</span></dt><dd><span>{{vm.region.nameEn}}</span></dd><dt><span translate=\"sigmasfApp.region.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.region.country.id})\">{{vm.region.country.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/region/region-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRegionLabel\" translate=\"sigmasfApp.region.home.createOrEditLabel\">Create or edit a Region</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.region.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.region.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.region.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.region.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.region.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.region.nameEn\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.region.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.region.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/region/regions.html","<div><h2 translate=\"sigmasfApp.region.home.title\">Regions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"region.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.region.home.createLabel\">Create new Region</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.region.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.region.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.region.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country.id\"><span translate=\"sigmasfApp.region.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"region in vm.regions track by region.id\"><td><a ui-sref=\"region-detail({id:region.id})\">{{region.id}}</a></td><td>{{region.name}}</td><td>{{region.nameEn}}</td><td><a ui-sref=\"country-detail({id:region.country.id})\">{{region.country.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"region-detail({id:region.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"region.edit({id:region.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"region.delete({id:region.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-present-item-lot/purchase-present-item-lot-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchasePresentItemLot.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchasePresentItemLot.delete.question\" translate-values=\"{id: \'{{vm.purchasePresentItemLot.id}}\'}\">Are you sure you want to delete this Purchase Present Item Lot?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-present-item-lot/purchase-present-item-lot-detail.html","<div><h2><span translate=\"sigmasfApp.purchasePresentItemLot.detail.title\">Purchase Present Item Lot</span> {{vm.purchasePresentItemLot.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchasePresentItemLot.name\">Name</span></dt><dd><span>{{vm.purchasePresentItemLot.name}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItemLot.quantity\">Quantity</span></dt><dd><span>{{vm.purchasePresentItemLot.quantity}}</span></dd><dt><span translate=\"sigmasfApp.purchasePresentItemLot.purchasePresentItem\">Purchase Present Item</span></dt><dd><a ui-sref=\"purchase-present-item-detail({id:vm.purchasePresentItemLot.purchasePresentItem.id})\">{{vm.purchasePresentItemLot.purchasePresentItem.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-present-item-lot/purchase-present-item-lot-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchasePresentItemLotLabel\" translate=\"sigmasfApp.purchasePresentItemLot.home.createOrEditLabel\">Create or edit a Purchase Present Item Lot</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchasePresentItemLot.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchasePresentItemLot.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItemLot.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.purchasePresentItemLot.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchasePresentItemLot.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.purchasePresentItemLot.quantity\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.purchasePresentItemLot.purchasePresentItem\" for=\"field_purchasePresentItem\">Purchase Present Item</label><select class=\"form-control\" id=\"field_purchasePresentItem\" name=\"purchasePresentItem\" ng-model=\"vm.purchasePresentItemLot.purchasePresentItem\" ng-options=\"purchasePresentItem as purchasePresentItem.id for purchasePresentItem in vm.purchasepresentitems track by purchasePresentItem.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-present-item-lot/purchase-present-item-lots.html","<div><h2 translate=\"sigmasfApp.purchasePresentItemLot.home.title\">Purchase Present Item Lots</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-present-item-lot.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchasePresentItemLot.home.createLabel\">Create new Purchase Present Item Lot</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.purchasePresentItemLot.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantity\"><span translate=\"sigmasfApp.purchasePresentItemLot.quantity\">Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"purchasePresentItem.id\"><span translate=\"sigmasfApp.purchasePresentItemLot.purchasePresentItem\">Purchase Present Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchasePresentItemLot in vm.purchasePresentItemLots track by purchasePresentItemLot.id\"><td><a ui-sref=\"purchase-present-item-lot-detail({id:purchasePresentItemLot.id})\">{{purchasePresentItemLot.id}}</a></td><td>{{purchasePresentItemLot.name}}</td><td>{{purchasePresentItemLot.quantity}}</td><td><a ui-sref=\"purchase-present-item-detail({id:purchasePresentItemLot.purchasePresentItem.id})\">{{purchasePresentItemLot.purchasePresentItem.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-present-item-lot-detail({id:purchasePresentItemLot.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-present-item-lot.edit({id:purchasePresentItemLot.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-present-item-lot.delete({id:purchasePresentItemLot.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/purchase-status/purchase-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.purchaseStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.purchaseStatus.delete.question\" translate-values=\"{id: \'{{vm.purchaseStatus.id}}\'}\">Are you sure you want to delete this Purchase Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/purchase-status/purchase-status-detail.html","<div><h2><span translate=\"sigmasfApp.purchaseStatus.detail.title\">Purchase Status</span> {{vm.purchaseStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.purchaseStatus.name\">Name</span></dt><dd><span>{{vm.purchaseStatus.name}}</span></dd><dt><span translate=\"sigmasfApp.purchaseStatus.cancellable\">Cancellable</span></dt><dd><span>{{vm.purchaseStatus.cancellable}}</span></dd><dt><span translate=\"sigmasfApp.purchaseStatus.code\">Code</span></dt><dd><span>{{vm.purchaseStatus.code}}</span></dd><dt><span translate=\"sigmasfApp.purchaseStatus.isEditable\">Is Editable</span></dt><dd><span>{{vm.purchaseStatus.isEditable}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/purchase-status/purchase-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPurchaseStatusLabel\" translate=\"sigmasfApp.purchaseStatus.home.createOrEditLabel\">Create or edit a Purchase Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.purchaseStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.purchaseStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.purchaseStatus.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseStatus.cancellable\" for=\"field_cancellable\">Cancellable</label><input type=\"checkbox\" class=\"form-control\" name=\"cancellable\" id=\"field_cancellable\" ng-model=\"vm.purchaseStatus.cancellable\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseStatus.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.purchaseStatus.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.purchaseStatus.isEditable\" for=\"field_isEditable\">Is Editable</label><input type=\"checkbox\" class=\"form-control\" name=\"isEditable\" id=\"field_isEditable\" ng-model=\"vm.purchaseStatus.isEditable\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/purchase-status/purchase-statuses.html","<div><h2 translate=\"sigmasfApp.purchaseStatus.home.title\">Purchase Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"purchase-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.purchaseStatus.home.createLabel\">Create new Purchase Status</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.purchaseStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cancellable\"><span translate=\"sigmasfApp.purchaseStatus.cancellable\">Cancellable</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.purchaseStatus.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isEditable\"><span translate=\"sigmasfApp.purchaseStatus.isEditable\">Is Editable</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"purchaseStatus in vm.purchaseStatuses track by purchaseStatus.id\"><td><a ui-sref=\"purchase-status-detail({id:purchaseStatus.id})\">{{purchaseStatus.id}}</a></td><td>{{purchaseStatus.name}}</td><td>{{purchaseStatus.cancellable}}</td><td>{{purchaseStatus.code}}</td><td>{{purchaseStatus.isEditable}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"purchase-status-detail({id:purchaseStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"purchase-status.edit({id:purchaseStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"purchase-status.delete({id:purchaseStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/relationship-type/relationship-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.relationshipType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.relationshipType.delete.question\" translate-values=\"{id: \'{{vm.relationshipType.id}}\'}\">Are you sure you want to delete this Relationship Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/relationship-type/relationship-type-detail.html","<div><h2><span translate=\"sigmasfApp.relationshipType.detail.title\">Relationship Type</span> {{vm.relationshipType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.relationshipType.name\">Name</span></dt><dd><span>{{vm.relationshipType.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/relationship-type/relationship-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRelationshipTypeLabel\" translate=\"sigmasfApp.relationshipType.home.createOrEditLabel\">Create or edit a Relationship Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.relationshipType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.relationshipType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.relationshipType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.relationshipType.name\" ng-maxlength=\"35\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"35\">This field cannot be longer than 35 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/relationship-type/relationship-types.html","<div><h2 translate=\"sigmasfApp.relationshipType.home.title\">Relationship Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"relationship-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.relationshipType.home.createLabel\">Create new Relationship Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.relationshipType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"relationshipType in vm.relationshipTypes track by relationshipType.id\"><td><a ui-sref=\"relationship-type-detail({id:relationshipType.id})\">{{relationshipType.id}}</a></td><td>{{relationshipType.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"relationship-type-detail({id:relationshipType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"relationship-type.edit({id:relationshipType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"relationship-type.delete({id:relationshipType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/rejection-reason/rejection-reason-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.rejectionReason.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.rejectionReason.delete.question\" translate-values=\"{id: \'{{vm.rejectionReason.id}}\'}\">Are you sure you want to delete this Rejection Reason?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/rejection-reason/rejection-reason-detail.html","<div><h2><span translate=\"sigmasfApp.rejectionReason.detail.title\">Rejection Reason</span> {{vm.rejectionReason.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.rejectionReason.name\">Name</span></dt><dd><span>{{vm.rejectionReason.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/rejection-reason/rejection-reason-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRejectionReasonLabel\" translate=\"sigmasfApp.rejectionReason.home.createOrEditLabel\">Create or edit a Rejection Reason</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.rejectionReason.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.rejectionReason.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.rejectionReason.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.rejectionReason.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/rejection-reason/rejection-reasons.html","<div><h2 translate=\"sigmasfApp.rejectionReason.home.title\">Rejection Reasons</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"rejection-reason.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.rejectionReason.home.createLabel\">Create new Rejection Reason</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.rejectionReason.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"rejectionReason in vm.rejectionReasons track by rejectionReason.id\"><td><a ui-sref=\"rejection-reason-detail({id:rejectionReason.id})\">{{rejectionReason.id}}</a></td><td>{{rejectionReason.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"rejection-reason-detail({id:rejectionReason.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"rejection-reason.edit({id:rejectionReason.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"rejection-reason.delete({id:rejectionReason.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/room-cost/room-cost-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.roomCost.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.roomCost.delete.question\" translate-values=\"{id: \'{{vm.roomCost.id}}\'}\">Are you sure you want to delete this Room Cost?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/room-cost/room-cost-detail.html","<div><h2><span translate=\"sigmasfApp.roomCost.detail.title\">Room Cost</span> {{vm.roomCost.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.roomCost.cost\">Cost</span></dt><dd><span>{{vm.roomCost.cost}}</span></dd><dt><span translate=\"sigmasfApp.roomCost.costType\">Cost Type</span></dt><dd><a ui-sref=\"cost-type-detail({id:vm.roomCost.costType.id})\">{{vm.roomCost.costType.id}}</a></dd><dt><span translate=\"sigmasfApp.roomCost.roomType\">Room Type</span></dt><dd><a ui-sref=\"room-type-detail({id:vm.roomCost.roomType.id})\">{{vm.roomCost.roomType.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/room-cost/room-cost-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRoomCostLabel\" translate=\"sigmasfApp.roomCost.home.createOrEditLabel\">Create or edit a Room Cost</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.roomCost.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.roomCost.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.roomCost.cost\" for=\"field_cost\">Cost</label><input type=\"number\" class=\"form-control\" name=\"cost\" id=\"field_cost\" ng-model=\"vm.roomCost.cost\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.roomCost.costType\" for=\"field_costType\">Cost Type</label><select class=\"form-control\" id=\"field_costType\" name=\"costType\" ng-model=\"vm.roomCost.costType\" ng-options=\"costType as costType.id for costType in vm.costtypes track by costType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.roomCost.roomType\" for=\"field_roomType\">Room Type</label><select class=\"form-control\" id=\"field_roomType\" name=\"roomType\" ng-model=\"vm.roomCost.roomType\" ng-options=\"roomType as roomType.id for roomType in vm.roomtypes track by roomType.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/room-cost/room-costs.html","<div><h2 translate=\"sigmasfApp.roomCost.home.title\">Room Costs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"room-cost.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.roomCost.home.createLabel\">Create new Room Cost</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cost\"><span translate=\"sigmasfApp.roomCost.cost\">Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"costType.id\"><span translate=\"sigmasfApp.roomCost.costType\">Cost Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"roomType.id\"><span translate=\"sigmasfApp.roomCost.roomType\">Room Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"roomCost in vm.roomCosts track by roomCost.id\"><td><a ui-sref=\"room-cost-detail({id:roomCost.id})\">{{roomCost.id}}</a></td><td>{{roomCost.cost}}</td><td><a ui-sref=\"cost-type-detail({id:roomCost.costType.id})\">{{roomCost.costType.id}}</a></td><td><a ui-sref=\"room-type-detail({id:roomCost.roomType.id})\">{{roomCost.roomType.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"room-cost-detail({id:roomCost.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"room-cost.edit({id:roomCost.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"room-cost.delete({id:roomCost.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/room-type/room-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.roomType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.roomType.delete.question\" translate-values=\"{id: \'{{vm.roomType.id}}\'}\">Are you sure you want to delete this Room Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/room-type/room-type-detail.html","<div><h2><span translate=\"sigmasfApp.roomType.detail.title\">Room Type</span> {{vm.roomType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.roomType.name\">Name</span></dt><dd><span>{{vm.roomType.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/room-type/room-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRoomTypeLabel\" translate=\"sigmasfApp.roomType.home.createOrEditLabel\">Create or edit a Room Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.roomType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.roomType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.roomType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.roomType.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/room-type/room-types.html","<div><h2 translate=\"sigmasfApp.roomType.home.title\">Room Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"room-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.roomType.home.createLabel\">Create new Room Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.roomType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"roomType in vm.roomTypes track by roomType.id\"><td><a ui-sref=\"room-type-detail({id:roomType.id})\">{{roomType.id}}</a></td><td>{{roomType.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"room-type-detail({id:roomType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"room-type.edit({id:roomType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"room-type.delete({id:roomType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sector/sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.sector.delete.question\" translate-values=\"{id: \'{{vm.sector.id}}\'}\">Are you sure you want to delete this Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sector/sector-detail.html","<div><h2><span translate=\"sigmasfApp.sector.detail.title\">Sector</span> {{vm.sector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.sector.name\">Name</span></dt><dd><span>{{vm.sector.name}}</span></dd><dt><span translate=\"sigmasfApp.sector.brick\">Brick</span></dt><dd><span>{{vm.sector.brick}}</span></dd><dt><span translate=\"sigmasfApp.sector.osfeBrick\">Osfe Brick</span></dt><dd><span>{{vm.sector.osfeBrick}}</span></dd><dt><span translate=\"sigmasfApp.sector.phone\">Phone</span></dt><dd><span>{{vm.sector.phone}}</span></dd><dt><span translate=\"sigmasfApp.sector.phone2\">Phone 2</span></dt><dd><span>{{vm.sector.phone2}}</span></dd><dt><span translate=\"sigmasfApp.sector.countryName\">Country Name</span></dt><dd><span>{{vm.sector.countryName}}</span></dd><dt><span translate=\"sigmasfApp.sector.regionName\">Region Name</span></dt><dd><span>{{vm.sector.regionName}}</span></dd><dt><span translate=\"sigmasfApp.sector.prefectureName\">Prefecture Name</span></dt><dd><span>{{vm.sector.prefectureName}}</span></dd><dt><span translate=\"sigmasfApp.sector.cityName\">City Name</span></dt><dd><span>{{vm.sector.cityName}}</span></dd><dt><span translate=\"sigmasfApp.sector.postalCode\">Postal Code</span></dt><dd><span>{{vm.sector.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.sector.address\">Address</span></dt><dd><span>{{vm.sector.address}}</span></dd><dt><span translate=\"sigmasfApp.sector.addressNum\">Address Num</span></dt><dd><span>{{vm.sector.addressNum}}</span></dd><dt><span translate=\"sigmasfApp.sector.vat\">Vat</span></dt><dd><span>{{vm.sector.vat}}</span></dd><dt><span translate=\"sigmasfApp.sector.creditControlCheck\">Credit Control Check</span></dt><dd><span>{{vm.sector.creditControlCheck}}</span></dd><dt><span translate=\"sigmasfApp.sector.code\">Code</span></dt><dd><span>{{vm.sector.code}}</span></dd><dt><span translate=\"sigmasfApp.sector.monday\">Monday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.sector.monday}}\">{{vm.sector.monday}}</span></dd><dt><span translate=\"sigmasfApp.sector.tuesday\">Tuesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.sector.tuesday}}\">{{vm.sector.tuesday}}</span></dd><dt><span translate=\"sigmasfApp.sector.wednesday\">Wednesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.sector.wednesday}}\">{{vm.sector.wednesday}}</span></dd><dt><span translate=\"sigmasfApp.sector.thursday\">Thursday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.sector.thursday}}\">{{vm.sector.thursday}}</span></dd><dt><span translate=\"sigmasfApp.sector.friday\">Friday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.sector.friday}}\">{{vm.sector.friday}}</span></dd><dt><span translate=\"sigmasfApp.sector.sectorType\">Sector Type</span></dt><dd><a ui-sref=\"sector-type-detail({id:vm.sector.sectorType.id})\">{{vm.sector.sectorType.name}}</a></dd><dt><span translate=\"sigmasfApp.sector.doctorSpecialty\">Doctor Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.sector.doctorSpecialty.id})\">{{vm.sector.doctorSpecialty.name}}</a></dd><dt><span translate=\"sigmasfApp.sector.parent\">Parent</span></dt><dd><a ui-sref=\"sector-detail({id:vm.sector.parent.id})\">{{vm.sector.parent.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.sector.country.id})\">{{vm.sector.country.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.region\">Region</span></dt><dd><a ui-sref=\"region-detail({id:vm.sector.region.id})\">{{vm.sector.region.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.prefecture\">Prefecture</span></dt><dd><a ui-sref=\"prefecture-detail({id:vm.sector.prefecture.id})\">{{vm.sector.prefecture.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.city\">City</span></dt><dd><a ui-sref=\"city-detail({id:vm.sector.city.id})\">{{vm.sector.city.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.companyType\">Company Type</span></dt><dd><a ui-sref=\"company-type-detail({id:vm.sector.companyType.id})\">{{vm.sector.companyType.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.taxOffice\">Tax Office</span></dt><dd><a ui-sref=\"tax-office-detail({id:vm.sector.taxOffice.id})\">{{vm.sector.taxOffice.id}}</a></dd><dt><span translate=\"sigmasfApp.sector.taxStatus\">Tax Status</span></dt><dd><a ui-sref=\"tax-status-detail({id:vm.sector.taxStatus.id})\">{{vm.sector.taxStatus.name}}</a></dd><dt><span translate=\"sigmasfApp.sector.clinicName\">Clinic Name</span></dt><dd><span ng-repeat=\"clinicName in vm.sector.clinicNames\"><a ui-sref=\"clinic-name-detail({id: {{clinicName.id}}})\">{{clinicName.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.sector.sectorCategory\">Sector Category</span></dt><dd><a ui-sref=\"sector-category-detail({id:vm.sector.sectorCategory.id})\">{{vm.sector.sectorCategory.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sector/sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectorLabel\" translate=\"sigmasfApp.sector.home.createOrEditLabel\">Create or edit a Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sector.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.sector.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.brick\" for=\"field_brick\">Brick</label><input type=\"text\" class=\"form-control\" name=\"brick\" id=\"field_brick\" ng-model=\"vm.sector.brick\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.osfeBrick\" for=\"field_osfeBrick\">Osfe Brick</label><input type=\"text\" class=\"form-control\" name=\"osfeBrick\" id=\"field_osfeBrick\" ng-model=\"vm.sector.osfeBrick\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.sector.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.phone2\" for=\"field_phone2\">Phone 2</label><input type=\"text\" class=\"form-control\" name=\"phone2\" id=\"field_phone2\" ng-model=\"vm.sector.phone2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.countryName\" for=\"field_countryName\">Country Name</label><input type=\"text\" class=\"form-control\" name=\"countryName\" id=\"field_countryName\" ng-model=\"vm.sector.countryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.regionName\" for=\"field_regionName\">Region Name</label><input type=\"text\" class=\"form-control\" name=\"regionName\" id=\"field_regionName\" ng-model=\"vm.sector.regionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.prefectureName\" for=\"field_prefectureName\">Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"prefectureName\" id=\"field_prefectureName\" ng-model=\"vm.sector.prefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.cityName\" for=\"field_cityName\">City Name</label><input type=\"text\" class=\"form-control\" name=\"cityName\" id=\"field_cityName\" ng-model=\"vm.sector.cityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.sector.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.sector.address\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.addressNum\" for=\"field_addressNum\">Address Num</label><input type=\"text\" class=\"form-control\" name=\"addressNum\" id=\"field_addressNum\" ng-model=\"vm.sector.addressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.vat\" for=\"field_vat\">Vat</label><input type=\"text\" class=\"form-control\" name=\"vat\" id=\"field_vat\" ng-model=\"vm.sector.vat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.creditControlCheck\" for=\"field_creditControlCheck\">Credit Control Check</label><input type=\"checkbox\" class=\"form-control\" name=\"creditControlCheck\" id=\"field_creditControlCheck\" ng-model=\"vm.sector.creditControlCheck\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.sector.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.monday\" for=\"field_monday\">Monday</label><select class=\"form-control\" name=\"monday\" ng-model=\"vm.sector.monday\" id=\"field_monday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.tuesday\" for=\"field_tuesday\">Tuesday</label><select class=\"form-control\" name=\"tuesday\" ng-model=\"vm.sector.tuesday\" id=\"field_tuesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.wednesday\" for=\"field_wednesday\">Wednesday</label><select class=\"form-control\" name=\"wednesday\" ng-model=\"vm.sector.wednesday\" id=\"field_wednesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.thursday\" for=\"field_thursday\">Thursday</label><select class=\"form-control\" name=\"thursday\" ng-model=\"vm.sector.thursday\" id=\"field_thursday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sector.friday\" for=\"field_friday\">Friday</label><select class=\"form-control\" name=\"friday\" ng-model=\"vm.sector.friday\" id=\"field_friday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.sectorType\" for=\"field_sectorType\">Sector Type</label><select class=\"form-control\" id=\"field_sectorType\" name=\"sectorType\" ng-model=\"vm.sector.sectorType\" ng-options=\"sectorType as sectorType.name for sectorType in vm.sectortypes track by sectorType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.doctorSpecialty\" for=\"field_doctorSpecialty\">Doctor Specialty</label><select class=\"form-control\" id=\"field_doctorSpecialty\" name=\"doctorSpecialty\" ng-model=\"vm.sector.doctorSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.name for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.sector.parent\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.sector.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.region\" for=\"field_region\">Region</label><select class=\"form-control\" id=\"field_region\" name=\"region\" ng-model=\"vm.sector.region\" ng-options=\"region as region.id for region in vm.regions track by region.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.prefecture\" for=\"field_prefecture\">Prefecture</label><select class=\"form-control\" id=\"field_prefecture\" name=\"prefecture\" ng-model=\"vm.sector.prefecture\" ng-options=\"prefecture as prefecture.id for prefecture in vm.prefectures track by prefecture.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.city\" for=\"field_city\">City</label><select class=\"form-control\" id=\"field_city\" name=\"city\" ng-model=\"vm.sector.city\" ng-options=\"city as city.id for city in vm.cities track by city.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.companyType\" for=\"field_companyType\">Company Type</label><select class=\"form-control\" id=\"field_companyType\" name=\"companyType\" ng-model=\"vm.sector.companyType\" ng-options=\"companyType as companyType.id for companyType in vm.companytypes track by companyType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.taxOffice\" for=\"field_taxOffice\">Tax Office</label><select class=\"form-control\" id=\"field_taxOffice\" name=\"taxOffice\" ng-model=\"vm.sector.taxOffice\" ng-options=\"taxOffice as taxOffice.id for taxOffice in vm.taxoffices track by taxOffice.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.taxStatus\" for=\"field_taxStatus\">Tax Status</label><select class=\"form-control\" id=\"field_taxStatus\" name=\"taxStatus\" ng-model=\"vm.sector.taxStatus\" ng-options=\"taxStatus as taxStatus.name for taxStatus in vm.taxstatuses track by taxStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.clinicName\" for=\"field_clinicName\">Clinic Name</label><select class=\"form-control\" id=\"field_clinicName\" multiple=\"multiple\" name=\"clinicName\" ng-model=\"vm.sector.clinicNames\" ng-options=\"clinicName as clinicName.id for clinicName in vm.clinicnames track by clinicName.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sector.sectorCategory\" for=\"field_sectorCategory\">Sector Category</label><select class=\"form-control\" id=\"field_sectorCategory\" name=\"sectorCategory\" ng-model=\"vm.sector.sectorCategory\" ng-options=\"sectorCategory as sectorCategory.id for sectorCategory in vm.sectorcategories track by sectorCategory.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sector/sectors.html","<div><h2 translate=\"sigmasfApp.sector.home.title\">Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.sector.home.createLabel\">Create new Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.sector.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"brick\"><span translate=\"sigmasfApp.sector.brick\">Brick</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"osfeBrick\"><span translate=\"sigmasfApp.sector.osfeBrick\">Osfe Brick</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.sector.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone2\"><span translate=\"sigmasfApp.sector.phone2\">Phone 2</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryName\"><span translate=\"sigmasfApp.sector.countryName\">Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"regionName\"><span translate=\"sigmasfApp.sector.regionName\">Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefectureName\"><span translate=\"sigmasfApp.sector.prefectureName\">Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cityName\"><span translate=\"sigmasfApp.sector.cityName\">City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.sector.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"sigmasfApp.sector.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressNum\"><span translate=\"sigmasfApp.sector.addressNum\">Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vat\"><span translate=\"sigmasfApp.sector.vat\">Vat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creditControlCheck\"><span translate=\"sigmasfApp.sector.creditControlCheck\">Credit Control Check</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.sector.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"monday\"><span translate=\"sigmasfApp.sector.monday\">Monday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tuesday\"><span translate=\"sigmasfApp.sector.tuesday\">Tuesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wednesday\"><span translate=\"sigmasfApp.sector.wednesday\">Wednesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"thursday\"><span translate=\"sigmasfApp.sector.thursday\">Thursday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"friday\"><span translate=\"sigmasfApp.sector.friday\">Friday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorType.name\"><span translate=\"sigmasfApp.sector.sectorType\">Sector Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecialty.name\"><span translate=\"sigmasfApp.sector.doctorSpecialty\">Doctor Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parent.id\"><span translate=\"sigmasfApp.sector.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country.id\"><span translate=\"sigmasfApp.sector.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region.id\"><span translate=\"sigmasfApp.sector.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture.id\"><span translate=\"sigmasfApp.sector.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city.id\"><span translate=\"sigmasfApp.sector.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyType.id\"><span translate=\"sigmasfApp.sector.companyType\">Company Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxOffice.id\"><span translate=\"sigmasfApp.sector.taxOffice\">Tax Office</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxStatus.name\"><span translate=\"sigmasfApp.sector.taxStatus\">Tax Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorCategory.id\"><span translate=\"sigmasfApp.sector.sectorCategory\">Sector Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sector in vm.sectors track by sector.id\"><td><a ui-sref=\"sector-detail({id:sector.id})\">{{sector.id}}</a></td><td>{{sector.name}}</td><td>{{sector.brick}}</td><td>{{sector.osfeBrick}}</td><td>{{sector.phone}}</td><td>{{sector.phone2}}</td><td>{{sector.countryName}}</td><td>{{sector.regionName}}</td><td>{{sector.prefectureName}}</td><td>{{sector.cityName}}</td><td>{{sector.postalCode}}</td><td>{{sector.address}}</td><td>{{sector.addressNum}}</td><td>{{sector.vat}}</td><td>{{sector.creditControlCheck}}</td><td>{{sector.code}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + sector.monday}}\">{{sector.monday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + sector.tuesday}}\">{{sector.tuesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + sector.wednesday}}\">{{sector.wednesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + sector.thursday}}\">{{sector.thursday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + sector.friday}}\">{{sector.friday}}</td><td><a ui-sref=\"sector-type-detail({id:sector.sectorType.id})\">{{sector.sectorType.name}}</a></td><td><a ui-sref=\"doctor-specialty-detail({id:sector.doctorSpecialty.id})\">{{sector.doctorSpecialty.name}}</a></td><td><a ui-sref=\"sector-detail({id:sector.parent.id})\">{{sector.parent.id}}</a></td><td><a ui-sref=\"country-detail({id:sector.country.id})\">{{sector.country.id}}</a></td><td><a ui-sref=\"region-detail({id:sector.region.id})\">{{sector.region.id}}</a></td><td><a ui-sref=\"prefecture-detail({id:sector.prefecture.id})\">{{sector.prefecture.id}}</a></td><td><a ui-sref=\"city-detail({id:sector.city.id})\">{{sector.city.id}}</a></td><td><a ui-sref=\"company-type-detail({id:sector.companyType.id})\">{{sector.companyType.id}}</a></td><td><a ui-sref=\"tax-office-detail({id:sector.taxOffice.id})\">{{sector.taxOffice.id}}</a></td><td><a ui-sref=\"tax-status-detail({id:sector.taxStatus.id})\">{{sector.taxStatus.name}}</a></td><td><a ui-sref=\"sector-category-detail({id:sector.sectorCategory.id})\">{{sector.sectorCategory.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sector-detail({id:sector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sector.edit({id:sector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sector.delete({id:sector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sector-clinic-name/sector-clinic-name-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sectorClinicName.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.sectorClinicName.delete.question\" translate-values=\"{id: \'{{vm.sectorClinicName.id}}\'}\">Are you sure you want to delete this Sector Clinic Name?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sector-clinic-name/sector-clinic-name-detail.html","<div><h2><span translate=\"sigmasfApp.sectorClinicName.detail.title\">Sector Clinic Name</span> {{vm.sectorClinicName.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.sectorClinicName.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.sectorClinicName.sector.id})\">{{vm.sectorClinicName.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.sectorClinicName.clinicName\">Clinic Name</span></dt><dd><a ui-sref=\"clinic-name-detail({id:vm.sectorClinicName.clinicName.id})\">{{vm.sectorClinicName.clinicName.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sector-clinic-name/sector-clinic-name-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectorClinicNameLabel\" translate=\"sigmasfApp.sectorClinicName.home.createOrEditLabel\">Create or edit a Sector Clinic Name</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sectorClinicName.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sectorClinicName.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.sectorClinicName.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.sectorClinicName.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.sectorClinicName.clinicName\" for=\"field_clinicName\">Clinic Name</label><select class=\"form-control\" id=\"field_clinicName\" name=\"clinicName\" ng-model=\"vm.sectorClinicName.clinicName\" ng-options=\"clinicName as clinicName.id for clinicName in vm.clinicnames track by clinicName.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sector-clinic-name/sector-clinic-names.html","<div><h2 translate=\"sigmasfApp.sectorClinicName.home.title\">Sector Clinic Names</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sector-clinic-name.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.sectorClinicName.home.createLabel\">Create new Sector Clinic Name</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.sectorClinicName.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"clinicName.id\"><span translate=\"sigmasfApp.sectorClinicName.clinicName\">Clinic Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sectorClinicName in vm.sectorClinicNames track by sectorClinicName.id\"><td><a ui-sref=\"sector-clinic-name-detail({id:sectorClinicName.id})\">{{sectorClinicName.id}}</a></td><td><a ui-sref=\"sector-detail({id:sectorClinicName.sector.id})\">{{sectorClinicName.sector.id}}</a></td><td><a ui-sref=\"clinic-name-detail({id:sectorClinicName.clinicName.id})\">{{sectorClinicName.clinicName.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sector-clinic-name-detail({id:sectorClinicName.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sector-clinic-name.edit({id:sectorClinicName.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sector-clinic-name.delete({id:sectorClinicName.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sector-category/sector-categories.html","<div><h2 translate=\"sigmasfApp.sectorCategory.home.title\">Sector Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sector-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.sectorCategory.home.createLabel\">Create new Sector Category</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.sectorCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorTypeCategory\"><span translate=\"sigmasfApp.sectorCategory.sectorTypeCategory\">Sector Type Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.sectorCategory.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sectorCategory in vm.sectorCategories track by sectorCategory.id\"><td><a ui-sref=\"sector-category-detail({id:sectorCategory.id})\">{{sectorCategory.id}}</a></td><td>{{sectorCategory.name}}</td><td translate=\"{{\'sigmasfApp.SectorTypeCategory.\' + sectorCategory.sectorTypeCategory}}\">{{sectorCategory.sectorTypeCategory}}</td><td>{{sectorCategory.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sector-category-detail({id:sectorCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sector-category.edit({id:sectorCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sector-category.delete({id:sectorCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sector-category/sector-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sectorCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.sectorCategory.delete.question\" translate-values=\"{id: \'{{vm.sectorCategory.id}}\'}\">Are you sure you want to delete this Sector Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sector-category/sector-category-detail.html","<div><h2><span translate=\"sigmasfApp.sectorCategory.detail.title\">Sector Category</span> {{vm.sectorCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.sectorCategory.name\">Name</span></dt><dd><span>{{vm.sectorCategory.name}}</span></dd><dt><span translate=\"sigmasfApp.sectorCategory.sectorTypeCategory\">Sector Type Category</span></dt><dd><span translate=\"{{\'sigmasfApp.SectorTypeCategory.\' + vm.sectorCategory.sectorTypeCategory}}\">{{vm.sectorCategory.sectorTypeCategory}}</span></dd><dt><span translate=\"sigmasfApp.sectorCategory.nameEn\">Name En</span></dt><dd><span>{{vm.sectorCategory.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sector-category/sector-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectorCategoryLabel\" translate=\"sigmasfApp.sectorCategory.home.createOrEditLabel\">Create or edit a Sector Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sectorCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sectorCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.sectorCategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorCategory.sectorTypeCategory\" for=\"field_sectorTypeCategory\">Sector Type Category</label><select class=\"form-control\" name=\"sectorTypeCategory\" ng-model=\"vm.sectorCategory.sectorTypeCategory\" id=\"field_sectorTypeCategory\"><option value=\"hcu\" translate=\"sigmasfApp.SectorTypeCategory.hcu\">hcu</option><option value=\"pharmacy\" translate=\"sigmasfApp.SectorTypeCategory.pharmacy\">pharmacy</option><option value=\"beautyCenter\" translate=\"sigmasfApp.SectorTypeCategory.beautyCenter\">beautyCenter</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorCategory.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.sectorCategory.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sector-type/sector-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sectorType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.sectorType.delete.question\" translate-values=\"{id: \'{{vm.sectorType.id}}\'}\">Are you sure you want to delete this Sector Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sector-type/sector-type-detail.html","<div><h2><span translate=\"sigmasfApp.sectorType.detail.title\">Sector Type</span> {{vm.sectorType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.sectorType.name\">Name</span></dt><dd><span>{{vm.sectorType.name}}</span></dd><dt><span translate=\"sigmasfApp.sectorType.sectorTypeCategory\">Sector Type Category</span></dt><dd><span translate=\"{{\'sigmasfApp.SectorTypeCategory.\' + vm.sectorType.sectorTypeCategory}}\">{{vm.sectorType.sectorTypeCategory}}</span></dd><dt><span translate=\"sigmasfApp.sectorType.isPrivate\">Is Private</span></dt><dd><span>{{vm.sectorType.isPrivate}}</span></dd><dt><span translate=\"sigmasfApp.sectorType.nameEn\">Name En</span></dt><dd><span>{{vm.sectorType.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sector-type/sector-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectorTypeLabel\" translate=\"sigmasfApp.sectorType.home.createOrEditLabel\">Create or edit a Sector Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sectorType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sectorType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.sectorType.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorType.sectorTypeCategory\" for=\"field_sectorTypeCategory\">Sector Type Category</label><select class=\"form-control\" name=\"sectorTypeCategory\" ng-model=\"vm.sectorType.sectorTypeCategory\" id=\"field_sectorTypeCategory\"><option value=\"hcu\" translate=\"sigmasfApp.SectorTypeCategory.hcu\">hcu</option><option value=\"pharmacy\" translate=\"sigmasfApp.SectorTypeCategory.pharmacy\">pharmacy</option><option value=\"beautyCenter\" translate=\"sigmasfApp.SectorTypeCategory.beautyCenter\">beautyCenter</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorType.isPrivate\" for=\"field_isPrivate\">Is Private</label><input type=\"checkbox\" class=\"form-control\" name=\"isPrivate\" id=\"field_isPrivate\" ng-model=\"vm.sectorType.isPrivate\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorType.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.sectorType.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sector-type/sector-types.html","<div><h2 translate=\"sigmasfApp.sectorType.home.title\">Sector Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sector-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.sectorType.home.createLabel\">Create new Sector Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.sectorType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.sectorType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorTypeCategory\"><span translate=\"sigmasfApp.sectorType.sectorTypeCategory\">Sector Type Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isPrivate\"><span translate=\"sigmasfApp.sectorType.isPrivate\">Is Private</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.sectorType.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sectorType in vm.sectorTypes track by sectorType.id\"><td><a ui-sref=\"sector-type-detail({id:sectorType.id})\">{{sectorType.id}}</a></td><td>{{sectorType.name}}</td><td translate=\"{{\'sigmasfApp.SectorTypeCategory.\' + sectorType.sectorTypeCategory}}\">{{sectorType.sectorTypeCategory}}</td><td>{{sectorType.isPrivate}}</td><td>{{sectorType.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sector-type-detail({id:sectorType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sector-type.edit({id:sectorType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sector-type.delete({id:sectorType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sector-position/sector-position-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sectorPosition.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.sectorPosition.delete.question\" translate-values=\"{id: \'{{vm.sectorPosition.id}}\'}\">Are you sure you want to delete this Sector Position?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sector-position/sector-position-detail.html","<div><h2><span translate=\"sigmasfApp.sectorPosition.detail.title\">Sector Position</span> {{vm.sectorPosition.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.sectorPosition.name\">Name</span></dt><dd><span>{{vm.sectorPosition.name}}</span></dd><dt><span translate=\"sigmasfApp.sectorPosition.nameEn\">Name En</span></dt><dd><span>{{vm.sectorPosition.nameEn}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sector-position/sector-position-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySectorPositionLabel\" translate=\"sigmasfApp.sectorPosition.home.createOrEditLabel\">Create or edit a Sector Position</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sectorPosition.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sectorPosition.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorPosition.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.sectorPosition.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.sectorPosition.nameEn\" for=\"field_nameEn\">Name En</label><input type=\"text\" class=\"form-control\" name=\"nameEn\" id=\"field_nameEn\" ng-model=\"vm.sectorPosition.nameEn\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sector-position/sector-positions.html","<div><h2 translate=\"sigmasfApp.sectorPosition.home.title\">Sector Positions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sector-position.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.sectorPosition.home.createLabel\">Create new Sector Position</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.sectorPosition.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.sectorPosition.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nameEn\"><span translate=\"sigmasfApp.sectorPosition.nameEn\">Name En</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sectorPosition in vm.sectorPositions track by sectorPosition.id\"><td><a ui-sref=\"sector-position-detail({id:sectorPosition.id})\">{{sectorPosition.id}}</a></td><td>{{sectorPosition.name}}</td><td>{{sectorPosition.nameEn}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sector-position-detail({id:sectorPosition.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sector-position.edit({id:sectorPosition.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sector-position.delete({id:sectorPosition.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/social-insurance/social-insurance-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.socialInsurance.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.socialInsurance.delete.question\" translate-values=\"{id: \'{{vm.socialInsurance.id}}\'}\">Are you sure you want to delete this Social Insurance?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/social-insurance/social-insurance-detail.html","<div><h2><span translate=\"sigmasfApp.socialInsurance.detail.title\">Social Insurance</span> {{vm.socialInsurance.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.socialInsurance.name\">Name</span></dt><dd><span>{{vm.socialInsurance.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/social-insurance/social-insurance-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySocialInsuranceLabel\" translate=\"sigmasfApp.socialInsurance.home.createOrEditLabel\">Create or edit a Social Insurance</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.socialInsurance.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.socialInsurance.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.socialInsurance.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.socialInsurance.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/social-insurance/social-insurances.html","<div><h2 translate=\"sigmasfApp.socialInsurance.home.title\">Social Insurances</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"social-insurance.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.socialInsurance.home.createLabel\">Create new Social Insurance</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.socialInsurance.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.socialInsurance.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"socialInsurance in vm.socialInsurances track by socialInsurance.id\"><td><a ui-sref=\"social-insurance-detail({id:socialInsurance.id})\">{{socialInsurance.id}}</a></td><td>{{socialInsurance.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"social-insurance-detail({id:socialInsurance.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"social-insurance.edit({id:socialInsurance.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"social-insurance.delete({id:socialInsurance.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/tax-class/tax-class-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.taxClass.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.taxClass.delete.question\" translate-values=\"{id: \'{{vm.taxClass.id}}\'}\">Are you sure you want to delete this Tax Class?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/tax-class/tax-class-detail.html","<div><h2><span translate=\"sigmasfApp.taxClass.detail.title\">Tax Class</span> {{vm.taxClass.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.taxClass.name\">Name</span></dt><dd><span>{{vm.taxClass.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/tax-class/tax-class-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaxClassLabel\" translate=\"sigmasfApp.taxClass.home.createOrEditLabel\">Create or edit a Tax Class</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.taxClass.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.taxClass.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.taxClass.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.taxClass.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/tax-class/tax-classes.html","<div><h2 translate=\"sigmasfApp.taxClass.home.title\">Tax Classes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"tax-class.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.taxClass.home.createLabel\">Create new Tax Class</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.taxClass.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taxClass in vm.taxClasses track by taxClass.id\"><td><a ui-sref=\"tax-class-detail({id:taxClass.id})\">{{taxClass.id}}</a></td><td>{{taxClass.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"tax-class-detail({id:taxClass.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"tax-class.edit({id:taxClass.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"tax-class.delete({id:taxClass.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/tax-office/tax-office-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.taxOffice.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.taxOffice.delete.question\" translate-values=\"{id: \'{{vm.taxOffice.id}}\'}\">Are you sure you want to delete this Tax Office?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/tax-office/tax-office-detail.html","<div><h2><span translate=\"sigmasfApp.taxOffice.detail.title\">Tax Office</span> {{vm.taxOffice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.taxOffice.name\">Name</span></dt><dd><span>{{vm.taxOffice.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/tax-office/tax-office-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaxOfficeLabel\" translate=\"sigmasfApp.taxOffice.home.createOrEditLabel\">Create or edit a Tax Office</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.taxOffice.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.taxOffice.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.taxOffice.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.taxOffice.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/tax-office/tax-offices.html","<div><h2 translate=\"sigmasfApp.taxOffice.home.title\">Tax Offices</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"tax-office.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.taxOffice.home.createLabel\">Create new Tax Office</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.taxOffice.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taxOffice in vm.taxOffices track by taxOffice.id\"><td><a ui-sref=\"tax-office-detail({id:taxOffice.id})\">{{taxOffice.id}}</a></td><td>{{taxOffice.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"tax-office-detail({id:taxOffice.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"tax-office.edit({id:taxOffice.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"tax-office.delete({id:taxOffice.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/tax-status/tax-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.taxStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.taxStatus.delete.question\" translate-values=\"{id: \'{{vm.taxStatus.id}}\'}\">Are you sure you want to delete this Tax Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/tax-status/tax-status-detail.html","<div><h2><span translate=\"sigmasfApp.taxStatus.detail.title\">Tax Status</span> {{vm.taxStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.taxStatus.name\">Name</span></dt><dd><span>{{vm.taxStatus.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/tax-status/tax-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaxStatusLabel\" translate=\"sigmasfApp.taxStatus.home.createOrEditLabel\">Create or edit a Tax Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.taxStatus.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.taxStatus.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.taxStatus.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.taxStatus.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/tax-status/tax-statuses.html","<div><h2 translate=\"sigmasfApp.taxStatus.home.title\">Tax Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"tax-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.taxStatus.home.createLabel\">Create new Tax Status</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.taxStatus.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taxStatus in vm.taxStatuses track by taxStatus.id\"><td><a ui-sref=\"tax-status-detail({id:taxStatus.id})\">{{taxStatus.id}}</a></td><td>{{taxStatus.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"tax-status-detail({id:taxStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"tax-status.edit({id:taxStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"tax-status.delete({id:taxStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/tax-status-class/tax-status-class-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.taxStatusClass.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.taxStatusClass.delete.question\" translate-values=\"{id: \'{{vm.taxStatusClass.id}}\'}\">Are you sure you want to delete this Tax Status Class?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/tax-status-class/tax-status-class-detail.html","<div><h2><span translate=\"sigmasfApp.taxStatusClass.detail.title\">Tax Status Class</span> {{vm.taxStatusClass.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.taxStatusClass.value\">Value</span></dt><dd><span>{{vm.taxStatusClass.value}}</span></dd><dt><span translate=\"sigmasfApp.taxStatusClass.taxClass\">Tax Class</span></dt><dd><a ui-sref=\"tax-class-detail({id:vm.taxStatusClass.taxClass.id})\">{{vm.taxStatusClass.taxClass.id}}</a></dd><dt><span translate=\"sigmasfApp.taxStatusClass.taxStatus\">Tax Status</span></dt><dd><a ui-sref=\"tax-status-detail({id:vm.taxStatusClass.taxStatus.id})\">{{vm.taxStatusClass.taxStatus.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/tax-status-class/tax-status-class-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaxStatusClassLabel\" translate=\"sigmasfApp.taxStatusClass.home.createOrEditLabel\">Create or edit a Tax Status Class</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.taxStatusClass.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.taxStatusClass.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.taxStatusClass.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.taxStatusClass.value\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.taxStatusClass.taxClass\" for=\"field_taxClass\">Tax Class</label><select class=\"form-control\" id=\"field_taxClass\" name=\"taxClass\" ng-model=\"vm.taxStatusClass.taxClass\" ng-options=\"taxClass as taxClass.id for taxClass in vm.taxclasses track by taxClass.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.taxStatusClass.taxStatus\" for=\"field_taxStatus\">Tax Status</label><select class=\"form-control\" id=\"field_taxStatus\" name=\"taxStatus\" ng-model=\"vm.taxStatusClass.taxStatus\" ng-options=\"taxStatus as taxStatus.id for taxStatus in vm.taxstatuses track by taxStatus.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/tax-status-class/tax-status-classes.html","<div><h2 translate=\"sigmasfApp.taxStatusClass.home.title\">Tax Status Classes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"tax-status-class.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.taxStatusClass.home.createLabel\">Create new Tax Status Class</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sigmasfApp.taxStatusClass.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxClass.id\"><span translate=\"sigmasfApp.taxStatusClass.taxClass\">Tax Class</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxStatus.id\"><span translate=\"sigmasfApp.taxStatusClass.taxStatus\">Tax Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taxStatusClass in vm.taxStatusClasses track by taxStatusClass.id\"><td><a ui-sref=\"tax-status-class-detail({id:taxStatusClass.id})\">{{taxStatusClass.id}}</a></td><td>{{taxStatusClass.value}}</td><td><a ui-sref=\"tax-class-detail({id:taxStatusClass.taxClass.id})\">{{taxStatusClass.taxClass.id}}</a></td><td><a ui-sref=\"tax-status-detail({id:taxStatusClass.taxStatus.id})\">{{taxStatusClass.taxStatus.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"tax-status-class-detail({id:taxStatusClass.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"tax-status-class.edit({id:taxStatusClass.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"tax-status-class.delete({id:taxStatusClass.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/temp-customer/temp-customer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tempCustomer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tempCustomer.delete.question\" translate-values=\"{id: \'{{vm.tempCustomer.id}}\'}\">Are you sure you want to delete this Temp Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/temp-customer/temp-customer-detail.html","<div><h2><span translate=\"sigmasfApp.tempCustomer.detail.title\">Temp Customer</span> {{vm.tempCustomer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tempCustomer.firstName\">First Name</span></dt><dd><span>{{vm.tempCustomer.firstName}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.lastName\">Last Name</span></dt><dd><span>{{vm.tempCustomer.lastName}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.fatherName\">Father Name</span></dt><dd><span>{{vm.tempCustomer.fatherName}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.cellPhone\">Cell Phone</span></dt><dd><span>{{vm.tempCustomer.cellPhone}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.phone\">Phone</span></dt><dd><span>{{vm.tempCustomer.phone}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.isMale\">Is Male</span></dt><dd><span>{{vm.tempCustomer.isMale}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.email\">Email</span></dt><dd><span>{{vm.tempCustomer.email}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.notes\">Notes</span></dt><dd><span>{{vm.tempCustomer.notes}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.saw\">Saw</span></dt><dd><span>{{vm.tempCustomer.saw}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.isActive\">Is Active</span></dt><dd><span>{{vm.tempCustomer.isActive}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.dayTime\">Day Time</span></dt><dd><span translate=\"{{\'sigmasfApp.DayTimeEnum.\' + vm.tempCustomer.dayTime}}\">{{vm.tempCustomer.dayTime}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.status\">Status</span></dt><dd><span translate=\"{{\'sigmasfApp.Status.\' + vm.tempCustomer.status}}\">{{vm.tempCustomer.status}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.issuedDate\">Issued Date</span></dt><dd><span>{{vm.tempCustomer.issuedDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.issuedBy\">Issued By</span></dt><dd><span>{{vm.tempCustomer.issuedBy}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.lCode\">L Code</span></dt><dd><span>{{vm.tempCustomer.lCode}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.vatNumber\">Vat Number</span></dt><dd><span>{{vm.tempCustomer.vatNumber}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.etaaNumber\">Etaa Number</span></dt><dd><span>{{vm.tempCustomer.etaaNumber}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.amka\">Amka</span></dt><dd><span>{{vm.tempCustomer.amka}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.doctorSpecialty\">Doctor Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.tempCustomer.doctorSpecialty.id})\">{{vm.tempCustomer.doctorSpecialty.name}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.customerCategory\">Customer Category</span></dt><dd><a ui-sref=\"customer-category-detail({id:vm.tempCustomer.customerCategory.id})\">{{vm.tempCustomer.customerCategory.name}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.customerTitle\">Customer Title</span></dt><dd><a ui-sref=\"customer-title-detail({id:vm.tempCustomer.customerTitle.id})\">{{vm.tempCustomer.customerTitle.name}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.doctorSpecificSpecialty\">Doctor Specific Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.tempCustomer.doctorSpecificSpecialty.id})\">{{vm.tempCustomer.doctorSpecificSpecialty.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.customerSubCategory\">Customer Sub Category</span></dt><dd><a ui-sref=\"customer-sub-category-detail({id:vm.tempCustomer.customerSubCategory.id})\">{{vm.tempCustomer.customerSubCategory.name}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.approvedCustomer\">Approved Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.tempCustomer.approvedCustomer.id})\">{{vm.tempCustomer.approvedCustomer.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.tempCustomer.employee.id})\">{{vm.tempCustomer.employee.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.tempCustomer.customer.id})\">{{vm.tempCustomer.customer.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomer.customerTypes\">Customer Types</span></dt><dd><span ng-repeat=\"customerTypes in vm.tempCustomer.customerTypes\"><a ui-sref=\"customer-type-detail({id: {{customerTypes.id}}})\">{{customerTypes.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomer.collaboration\">Collaboration</span></dt><dd><a ui-sref=\"collaboration-detail({id:vm.tempCustomer.collaboration.id})\">{{vm.tempCustomer.collaboration.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/temp-customer/temp-customer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTempCustomerLabel\" translate=\"sigmasfApp.tempCustomer.home.createOrEditLabel\">Create or edit a Temp Customer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tempCustomer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tempCustomer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.firstName\" for=\"field_firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"field_firstName\" ng-model=\"vm.tempCustomer.firstName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.tempCustomer.lastName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.fatherName\" for=\"field_fatherName\">Father Name</label><input type=\"text\" class=\"form-control\" name=\"fatherName\" id=\"field_fatherName\" ng-model=\"vm.tempCustomer.fatherName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.cellPhone\" for=\"field_cellPhone\">Cell Phone</label><input type=\"text\" class=\"form-control\" name=\"cellPhone\" id=\"field_cellPhone\" ng-model=\"vm.tempCustomer.cellPhone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.tempCustomer.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.isMale\" for=\"field_isMale\">Is Male</label><input type=\"checkbox\" class=\"form-control\" name=\"isMale\" id=\"field_isMale\" ng-model=\"vm.tempCustomer.isMale\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.tempCustomer.email\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.notes\" for=\"field_notes\">Notes</label><input type=\"text\" class=\"form-control\" name=\"notes\" id=\"field_notes\" ng-model=\"vm.tempCustomer.notes\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.saw\" for=\"field_saw\">Saw</label><input type=\"checkbox\" class=\"form-control\" name=\"saw\" id=\"field_saw\" ng-model=\"vm.tempCustomer.saw\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.isActive\" for=\"field_isActive\">Is Active</label><input type=\"checkbox\" class=\"form-control\" name=\"isActive\" id=\"field_isActive\" ng-model=\"vm.tempCustomer.isActive\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.dayTime\" for=\"field_dayTime\">Day Time</label><select class=\"form-control\" name=\"dayTime\" ng-model=\"vm.tempCustomer.dayTime\" id=\"field_dayTime\"><option value=\"day\" translate=\"sigmasfApp.DayTimeEnum.day\">day</option><option value=\"night\" translate=\"sigmasfApp.DayTimeEnum.night\">night</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.tempCustomer.status\" id=\"field_status\"><option value=\"pending\" translate=\"sigmasfApp.Status.pending\">pending</option><option value=\"approved\" translate=\"sigmasfApp.Status.approved\">approved</option><option value=\"rejected\" translate=\"sigmasfApp.Status.rejected\">rejected</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.issuedDate\" for=\"field_issuedDate\">Issued Date</label><div class=\"input-group\"><input id=\"field_issuedDate\" type=\"text\" class=\"form-control\" name=\"issuedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.tempCustomer.issuedDate\" is-open=\"vm.datePickerOpenStatus.issuedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issuedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.issuedBy\" for=\"field_issuedBy\">Issued By</label><input type=\"text\" class=\"form-control\" name=\"issuedBy\" id=\"field_issuedBy\" ng-model=\"vm.tempCustomer.issuedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.lCode\" for=\"field_lCode\">L Code</label><input type=\"text\" class=\"form-control\" name=\"lCode\" id=\"field_lCode\" ng-model=\"vm.tempCustomer.lCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.vatNumber\" for=\"field_vatNumber\">Vat Number</label><input type=\"text\" class=\"form-control\" name=\"vatNumber\" id=\"field_vatNumber\" ng-model=\"vm.tempCustomer.vatNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.etaaNumber\" for=\"field_etaaNumber\">Etaa Number</label><input type=\"text\" class=\"form-control\" name=\"etaaNumber\" id=\"field_etaaNumber\" ng-model=\"vm.tempCustomer.etaaNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomer.amka\" for=\"field_amka\">Amka</label><input type=\"text\" class=\"form-control\" name=\"amka\" id=\"field_amka\" ng-model=\"vm.tempCustomer.amka\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.doctorSpecialty\" for=\"field_doctorSpecialty\">Doctor Specialty</label><select class=\"form-control\" id=\"field_doctorSpecialty\" name=\"doctorSpecialty\" ng-model=\"vm.tempCustomer.doctorSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.name for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.customerCategory\" for=\"field_customerCategory\">Customer Category</label><select class=\"form-control\" id=\"field_customerCategory\" name=\"customerCategory\" ng-model=\"vm.tempCustomer.customerCategory\" ng-options=\"customerCategory as customerCategory.name for customerCategory in vm.customercategories track by customerCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.customerTitle\" for=\"field_customerTitle\">Customer Title</label><select class=\"form-control\" id=\"field_customerTitle\" name=\"customerTitle\" ng-model=\"vm.tempCustomer.customerTitle\" ng-options=\"customerTitle as customerTitle.name for customerTitle in vm.customertitles track by customerTitle.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.doctorSpecificSpecialty\" for=\"field_doctorSpecificSpecialty\">Doctor Specific Specialty</label><select class=\"form-control\" id=\"field_doctorSpecificSpecialty\" name=\"doctorSpecificSpecialty\" ng-model=\"vm.tempCustomer.doctorSpecificSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.id for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.customerSubCategory\" for=\"field_customerSubCategory\">Customer Sub Category</label><select class=\"form-control\" id=\"field_customerSubCategory\" name=\"customerSubCategory\" ng-model=\"vm.tempCustomer.customerSubCategory\" ng-options=\"customerSubCategory as customerSubCategory.name for customerSubCategory in vm.customersubcategories track by customerSubCategory.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.approvedCustomer\" for=\"field_approvedCustomer\">Approved Customer</label><select class=\"form-control\" id=\"field_approvedCustomer\" name=\"approvedCustomer\" ng-model=\"vm.tempCustomer.approvedCustomer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.tempCustomer.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.tempCustomer.customer\" ng-options=\"customer as customer.id for customer in vm.customers track by customer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.customerTypes\" for=\"field_customerTypes\">Customer Types</label><select class=\"form-control\" id=\"field_customerTypes\" multiple=\"multiple\" name=\"customerTypes\" ng-model=\"vm.tempCustomer.customerTypes\" ng-options=\"customerType as customerType.id for customerType in vm.customertypes track by customerType.id\"></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomer.collaboration\" for=\"field_collaboration\">Collaboration</label><select class=\"form-control\" id=\"field_collaboration\" name=\"collaboration\" ng-model=\"vm.tempCustomer.collaboration\" ng-options=\"collaboration as collaboration.id for collaboration in vm.collaborations track by collaboration.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/temp-customer/temp-customers.html","<div><h2 translate=\"sigmasfApp.tempCustomer.home.title\">Temp Customers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"temp-customer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tempCustomer.home.createLabel\">Create new Temp Customer</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"sigmasfApp.tempCustomer.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"sigmasfApp.tempCustomer.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fatherName\"><span translate=\"sigmasfApp.tempCustomer.fatherName\">Father Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cellPhone\"><span translate=\"sigmasfApp.tempCustomer.cellPhone\">Cell Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.tempCustomer.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isMale\"><span translate=\"sigmasfApp.tempCustomer.isMale\">Is Male</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"email\"><span translate=\"sigmasfApp.tempCustomer.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notes\"><span translate=\"sigmasfApp.tempCustomer.notes\">Notes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"saw\"><span translate=\"sigmasfApp.tempCustomer.saw\">Saw</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isActive\"><span translate=\"sigmasfApp.tempCustomer.isActive\">Is Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dayTime\"><span translate=\"sigmasfApp.tempCustomer.dayTime\">Day Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sigmasfApp.tempCustomer.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedDate\"><span translate=\"sigmasfApp.tempCustomer.issuedDate\">Issued Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedBy\"><span translate=\"sigmasfApp.tempCustomer.issuedBy\">Issued By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lCode\"><span translate=\"sigmasfApp.tempCustomer.lCode\">L Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vatNumber\"><span translate=\"sigmasfApp.tempCustomer.vatNumber\">Vat Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etaaNumber\"><span translate=\"sigmasfApp.tempCustomer.etaaNumber\">Etaa Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amka\"><span translate=\"sigmasfApp.tempCustomer.amka\">Amka</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecialty.name\"><span translate=\"sigmasfApp.tempCustomer.doctorSpecialty\">Doctor Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerCategory.name\"><span translate=\"sigmasfApp.tempCustomer.customerCategory\">Customer Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerTitle.name\"><span translate=\"sigmasfApp.tempCustomer.customerTitle\">Customer Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecificSpecialty.id\"><span translate=\"sigmasfApp.tempCustomer.doctorSpecificSpecialty\">Doctor Specific Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSubCategory.name\"><span translate=\"sigmasfApp.tempCustomer.customerSubCategory\">Customer Sub Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"approvedCustomer.id\"><span translate=\"sigmasfApp.tempCustomer.approvedCustomer\">Approved Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.id\"><span translate=\"sigmasfApp.tempCustomer.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customer.id\"><span translate=\"sigmasfApp.tempCustomer.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collaboration.id\"><span translate=\"sigmasfApp.tempCustomer.collaboration\">Collaboration</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tempCustomer in vm.tempCustomers track by tempCustomer.id\"><td><a ui-sref=\"temp-customer-detail({id:tempCustomer.id})\">{{tempCustomer.id}}</a></td><td>{{tempCustomer.firstName}}</td><td>{{tempCustomer.lastName}}</td><td>{{tempCustomer.fatherName}}</td><td>{{tempCustomer.cellPhone}}</td><td>{{tempCustomer.phone}}</td><td>{{tempCustomer.isMale}}</td><td>{{tempCustomer.email}}</td><td>{{tempCustomer.notes}}</td><td>{{tempCustomer.saw}}</td><td>{{tempCustomer.isActive}}</td><td translate=\"{{\'sigmasfApp.DayTimeEnum.\' + tempCustomer.dayTime}}\">{{tempCustomer.dayTime}}</td><td translate=\"{{\'sigmasfApp.Status.\' + tempCustomer.status}}\">{{tempCustomer.status}}</td><td>{{tempCustomer.issuedDate | date:\'medium\'}}</td><td>{{tempCustomer.issuedBy}}</td><td>{{tempCustomer.lCode}}</td><td>{{tempCustomer.vatNumber}}</td><td>{{tempCustomer.etaaNumber}}</td><td>{{tempCustomer.amka}}</td><td><a ui-sref=\"doctor-specialty-detail({id:tempCustomer.doctorSpecialty.id})\">{{tempCustomer.doctorSpecialty.name}}</a></td><td><a ui-sref=\"customer-category-detail({id:tempCustomer.customerCategory.id})\">{{tempCustomer.customerCategory.name}}</a></td><td><a ui-sref=\"customer-title-detail({id:tempCustomer.customerTitle.id})\">{{tempCustomer.customerTitle.name}}</a></td><td><a ui-sref=\"doctor-specialty-detail({id:tempCustomer.doctorSpecificSpecialty.id})\">{{tempCustomer.doctorSpecificSpecialty.id}}</a></td><td><a ui-sref=\"customer-sub-category-detail({id:tempCustomer.customerSubCategory.id})\">{{tempCustomer.customerSubCategory.name}}</a></td><td><a ui-sref=\"customer-detail({id:tempCustomer.approvedCustomer.id})\">{{tempCustomer.approvedCustomer.id}}</a></td><td><a ui-sref=\"employee-detail({id:tempCustomer.employee.id})\">{{tempCustomer.employee.id}}</a></td><td><a ui-sref=\"customer-detail({id:tempCustomer.customer.id})\">{{tempCustomer.customer.id}}</a></td><td><a ui-sref=\"collaboration-detail({id:tempCustomer.collaboration.id})\">{{tempCustomer.collaboration.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"temp-customer-detail({id:tempCustomer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"temp-customer.edit({id:tempCustomer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"temp-customer.delete({id:tempCustomer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/subcategory/subcategories.html","<div><h2 translate=\"sigmasfApp.subcategory.home.title\">Subcategories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"subcategory.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.subcategory.home.createLabel\">Create new Subcategory</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.subcategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.subcategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"updatedAt\"><span translate=\"sigmasfApp.subcategory.updatedAt\">Updated At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"subcategory in vm.subcategories track by subcategory.id\"><td><a ui-sref=\"subcategory-detail({id:subcategory.id})\">{{subcategory.id}}</a></td><td>{{subcategory.name}}</td><td>{{subcategory.updatedAt | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"subcategory-detail({id:subcategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"subcategory.edit({id:subcategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"subcategory.delete({id:subcategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/subcategory/subcategory-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.subcategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.subcategory.delete.question\" translate-values=\"{id: \'{{vm.subcategory.id}}\'}\">Are you sure you want to delete this Subcategory?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/subcategory/subcategory-detail.html","<div><h2><span translate=\"sigmasfApp.subcategory.detail.title\">Subcategory</span> {{vm.subcategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.subcategory.name\">Name</span></dt><dd><span>{{vm.subcategory.name}}</span></dd><dt><span translate=\"sigmasfApp.subcategory.updatedAt\">Updated At</span></dt><dd><span>{{vm.subcategory.updatedAt | date:\'medium\'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/subcategory/subcategory-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySubcategoryLabel\" translate=\"sigmasfApp.subcategory.home.createOrEditLabel\">Create or edit a Subcategory</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.subcategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.subcategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.subcategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.subcategory.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.subcategory.updatedAt\" for=\"field_updatedAt\">Updated At</label><div class=\"input-group\"><input id=\"field_updatedAt\" type=\"text\" class=\"form-control\" name=\"updatedAt\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.subcategory.updatedAt\" is-open=\"vm.datePickerOpenStatus.updatedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'updatedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/temp-customer-sector/temp-customer-sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tempCustomerSector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tempCustomerSector.delete.question\" translate-values=\"{id: \'{{vm.tempCustomerSector.id}}\'}\">Are you sure you want to delete this Temp Customer Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/temp-customer-sector/temp-customer-sector-detail.html","<div><h2><span translate=\"sigmasfApp.tempCustomerSector.detail.title\">Temp Customer Sector</span> {{vm.tempCustomerSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tempCustomerSector.startedAt\">Started At</span></dt><dd><span>{{vm.tempCustomerSector.startedAt | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.endedAt\">Ended At</span></dt><dd><span>{{vm.tempCustomerSector.endedAt | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.status\">Status</span></dt><dd><span translate=\"{{\'sigmasfApp.Status.\' + vm.tempCustomerSector.status}}\">{{vm.tempCustomerSector.status}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.issuedDate\">Issued Date</span></dt><dd><span>{{vm.tempCustomerSector.issuedDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.issuedBy\">Issued By</span></dt><dd><span>{{vm.tempCustomerSector.issuedBy}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.main\">Main</span></dt><dd><span>{{vm.tempCustomerSector.main}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.phone\">Phone</span></dt><dd><span>{{vm.tempCustomerSector.phone}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.monday\">Monday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.tempCustomerSector.monday}}\">{{vm.tempCustomerSector.monday}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.tuesday\">Tuesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.tempCustomerSector.tuesday}}\">{{vm.tempCustomerSector.tuesday}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.wednesday\">Wednesday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.tempCustomerSector.wednesday}}\">{{vm.tempCustomerSector.wednesday}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.thursday\">Thursday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.tempCustomerSector.thursday}}\">{{vm.tempCustomerSector.thursday}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.friday\">Friday</span></dt><dd><span translate=\"{{\'sigmasfApp.WorkingHours.\' + vm.tempCustomerSector.friday}}\">{{vm.tempCustomerSector.friday}}</span></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.tempCustomer\">Temp Customer</span></dt><dd><a ui-sref=\"temp-customer-detail({id:vm.tempCustomerSector.tempCustomer.id})\">{{vm.tempCustomerSector.tempCustomer.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.sector\">Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.tempCustomerSector.sector.id})\">{{vm.tempCustomerSector.sector.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.tempSector\">Temp Sector</span></dt><dd><a ui-sref=\"temp-sector-detail({id:vm.tempCustomerSector.tempSector.id})\">{{vm.tempCustomerSector.tempSector.id}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.sectorPosition\">Sector Position</span></dt><dd><a ui-sref=\"sector-position-detail({id:vm.tempCustomerSector.sectorPosition.id})\">{{vm.tempCustomerSector.sectorPosition.name}}</a></dd><dt><span translate=\"sigmasfApp.tempCustomerSector.approvedCustomerSector\">Approved Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.tempCustomerSector.approvedCustomerSector.id})\">{{vm.tempCustomerSector.approvedCustomerSector.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/temp-customer-sector/temp-customer-sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTempCustomerSectorLabel\" translate=\"sigmasfApp.tempCustomerSector.home.createOrEditLabel\">Create or edit a Temp Customer Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tempCustomerSector.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tempCustomerSector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.startedAt\" for=\"field_startedAt\">Started At</label><div class=\"input-group\"><input id=\"field_startedAt\" type=\"text\" class=\"form-control\" name=\"startedAt\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.tempCustomerSector.startedAt\" is-open=\"vm.datePickerOpenStatus.startedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.endedAt\" for=\"field_endedAt\">Ended At</label><div class=\"input-group\"><input id=\"field_endedAt\" type=\"text\" class=\"form-control\" name=\"endedAt\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.tempCustomerSector.endedAt\" is-open=\"vm.datePickerOpenStatus.endedAt\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endedAt\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.tempCustomerSector.status\" id=\"field_status\"><option value=\"pending\" translate=\"sigmasfApp.Status.pending\">pending</option><option value=\"approved\" translate=\"sigmasfApp.Status.approved\">approved</option><option value=\"rejected\" translate=\"sigmasfApp.Status.rejected\">rejected</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.issuedDate\" for=\"field_issuedDate\">Issued Date</label><div class=\"input-group\"><input id=\"field_issuedDate\" type=\"text\" class=\"form-control\" name=\"issuedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.tempCustomerSector.issuedDate\" is-open=\"vm.datePickerOpenStatus.issuedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issuedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.issuedBy\" for=\"field_issuedBy\">Issued By</label><input type=\"text\" class=\"form-control\" name=\"issuedBy\" id=\"field_issuedBy\" ng-model=\"vm.tempCustomerSector.issuedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.main\" for=\"field_main\">Main</label><input type=\"checkbox\" class=\"form-control\" name=\"main\" id=\"field_main\" ng-model=\"vm.tempCustomerSector.main\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.tempCustomerSector.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.monday\" for=\"field_monday\">Monday</label><select class=\"form-control\" name=\"monday\" ng-model=\"vm.tempCustomerSector.monday\" id=\"field_monday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.tuesday\" for=\"field_tuesday\">Tuesday</label><select class=\"form-control\" name=\"tuesday\" ng-model=\"vm.tempCustomerSector.tuesday\" id=\"field_tuesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.wednesday\" for=\"field_wednesday\">Wednesday</label><select class=\"form-control\" name=\"wednesday\" ng-model=\"vm.tempCustomerSector.wednesday\" id=\"field_wednesday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.thursday\" for=\"field_thursday\">Thursday</label><select class=\"form-control\" name=\"thursday\" ng-model=\"vm.tempCustomerSector.thursday\" id=\"field_thursday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempCustomerSector.friday\" for=\"field_friday\">Friday</label><select class=\"form-control\" name=\"friday\" ng-model=\"vm.tempCustomerSector.friday\" id=\"field_friday\"><option value=\"morning\" translate=\"sigmasfApp.WorkingHours.morning\">morning</option><option value=\"afternoon\" translate=\"sigmasfApp.WorkingHours.afternoon\">afternoon</option><option value=\"morningAfternoon\" translate=\"sigmasfApp.WorkingHours.morningAfternoon\">morningAfternoon</option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomerSector.tempCustomer\" for=\"field_tempCustomer\">Temp Customer</label><select class=\"form-control\" id=\"field_tempCustomer\" name=\"tempCustomer\" ng-model=\"vm.tempCustomerSector.tempCustomer\" ng-options=\"tempCustomer as tempCustomer.id for tempCustomer in vm.tempcustomers track by tempCustomer.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomerSector.sector\" for=\"field_sector\">Sector</label><select class=\"form-control\" id=\"field_sector\" name=\"sector\" ng-model=\"vm.tempCustomerSector.sector\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomerSector.tempSector\" for=\"field_tempSector\">Temp Sector</label><select class=\"form-control\" id=\"field_tempSector\" name=\"tempSector\" ng-model=\"vm.tempCustomerSector.tempSector\" ng-options=\"tempSector as tempSector.id for tempSector in vm.tempsectors track by tempSector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomerSector.sectorPosition\" for=\"field_sectorPosition\">Sector Position</label><select class=\"form-control\" id=\"field_sectorPosition\" name=\"sectorPosition\" ng-model=\"vm.tempCustomerSector.sectorPosition\" ng-options=\"sectorPosition as sectorPosition.name for sectorPosition in vm.sectorpositions track by sectorPosition.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempCustomerSector.approvedCustomerSector\" for=\"field_approvedCustomerSector\">Approved Customer Sector</label><select class=\"form-control\" id=\"field_approvedCustomerSector\" name=\"approvedCustomerSector\" ng-model=\"vm.tempCustomerSector.approvedCustomerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.approvedcustomersectors | orderBy:\'id\' track by customerSector.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/temp-customer-sector/temp-customer-sectors.html","<div><h2 translate=\"sigmasfApp.tempCustomerSector.home.title\">Temp Customer Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"temp-customer-sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tempCustomerSector.home.createLabel\">Create new Temp Customer Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startedAt\"><span translate=\"sigmasfApp.tempCustomerSector.startedAt\">Started At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endedAt\"><span translate=\"sigmasfApp.tempCustomerSector.endedAt\">Ended At</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sigmasfApp.tempCustomerSector.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedDate\"><span translate=\"sigmasfApp.tempCustomerSector.issuedDate\">Issued Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedBy\"><span translate=\"sigmasfApp.tempCustomerSector.issuedBy\">Issued By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"main\"><span translate=\"sigmasfApp.tempCustomerSector.main\">Main</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.tempCustomerSector.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"monday\"><span translate=\"sigmasfApp.tempCustomerSector.monday\">Monday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tuesday\"><span translate=\"sigmasfApp.tempCustomerSector.tuesday\">Tuesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wednesday\"><span translate=\"sigmasfApp.tempCustomerSector.wednesday\">Wednesday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"thursday\"><span translate=\"sigmasfApp.tempCustomerSector.thursday\">Thursday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"friday\"><span translate=\"sigmasfApp.tempCustomerSector.friday\">Friday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tempCustomer.id\"><span translate=\"sigmasfApp.tempCustomerSector.tempCustomer\">Temp Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sector.id\"><span translate=\"sigmasfApp.tempCustomerSector.sector\">Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tempSector.id\"><span translate=\"sigmasfApp.tempCustomerSector.tempSector\">Temp Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorPosition.name\"><span translate=\"sigmasfApp.tempCustomerSector.sectorPosition\">Sector Position</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"approvedCustomerSector.id\"><span translate=\"sigmasfApp.tempCustomerSector.approvedCustomerSector\">Approved Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tempCustomerSector in vm.tempCustomerSectors track by tempCustomerSector.id\"><td><a ui-sref=\"temp-customer-sector-detail({id:tempCustomerSector.id})\">{{tempCustomerSector.id}}</a></td><td>{{tempCustomerSector.startedAt | date:\'mediumDate\'}}</td><td>{{tempCustomerSector.endedAt | date:\'mediumDate\'}}</td><td translate=\"{{\'sigmasfApp.Status.\' + tempCustomerSector.status}}\">{{tempCustomerSector.status}}</td><td>{{tempCustomerSector.issuedDate | date:\'medium\'}}</td><td>{{tempCustomerSector.issuedBy}}</td><td>{{tempCustomerSector.main}}</td><td>{{tempCustomerSector.phone}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + tempCustomerSector.monday}}\">{{tempCustomerSector.monday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + tempCustomerSector.tuesday}}\">{{tempCustomerSector.tuesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + tempCustomerSector.wednesday}}\">{{tempCustomerSector.wednesday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + tempCustomerSector.thursday}}\">{{tempCustomerSector.thursday}}</td><td translate=\"{{\'sigmasfApp.WorkingHours.\' + tempCustomerSector.friday}}\">{{tempCustomerSector.friday}}</td><td><a ui-sref=\"temp-customer-detail({id:tempCustomerSector.tempCustomer.id})\">{{tempCustomerSector.tempCustomer.id}}</a></td><td><a ui-sref=\"sector-detail({id:tempCustomerSector.sector.id})\">{{tempCustomerSector.sector.id}}</a></td><td><a ui-sref=\"temp-sector-detail({id:tempCustomerSector.tempSector.id})\">{{tempCustomerSector.tempSector.id}}</a></td><td><a ui-sref=\"sector-position-detail({id:tempCustomerSector.sectorPosition.id})\">{{tempCustomerSector.sectorPosition.name}}</a></td><td><a ui-sref=\"customer-sector-detail({id:tempCustomerSector.approvedCustomerSector.id})\">{{tempCustomerSector.approvedCustomerSector.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"temp-customer-sector-detail({id:tempCustomerSector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"temp-customer-sector.edit({id:tempCustomerSector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"temp-customer-sector.delete({id:tempCustomerSector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/temp-sector/temp-sector-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tempSector.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tempSector.delete.question\" translate-values=\"{id: \'{{vm.tempSector.id}}\'}\">Are you sure you want to delete this Temp Sector?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/temp-sector/temp-sector-detail.html","<div><h2><span translate=\"sigmasfApp.tempSector.detail.title\">Temp Sector</span> {{vm.tempSector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tempSector.name\">Name</span></dt><dd><span>{{vm.tempSector.name}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.brick\">Brick</span></dt><dd><span>{{vm.tempSector.brick}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.osfeBrick\">Osfe Brick</span></dt><dd><span>{{vm.tempSector.osfeBrick}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.phone\">Phone</span></dt><dd><span>{{vm.tempSector.phone}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.phone2\">Phone 2</span></dt><dd><span>{{vm.tempSector.phone2}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.countryName\">Country Name</span></dt><dd><span>{{vm.tempSector.countryName}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.regionName\">Region Name</span></dt><dd><span>{{vm.tempSector.regionName}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.prefectureName\">Prefecture Name</span></dt><dd><span>{{vm.tempSector.prefectureName}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.cityName\">City Name</span></dt><dd><span>{{vm.tempSector.cityName}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.postalCode\">Postal Code</span></dt><dd><span>{{vm.tempSector.postalCode}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.address\">Address</span></dt><dd><span>{{vm.tempSector.address}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.addressNum\">Address Num</span></dt><dd><span>{{vm.tempSector.addressNum}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.status\">Status</span></dt><dd><span translate=\"{{\'sigmasfApp.Status.\' + vm.tempSector.status}}\">{{vm.tempSector.status}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.issuedDate\">Issued Date</span></dt><dd><span>{{vm.tempSector.issuedDate | date:\'medium\'}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.issuedBy\">Issued By</span></dt><dd><span>{{vm.tempSector.issuedBy}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.autoapprove\">Autoapprove</span></dt><dd><span>{{vm.tempSector.autoapprove}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.vat\">Vat</span></dt><dd><span>{{vm.tempSector.vat}}</span></dd><dt><span translate=\"sigmasfApp.tempSector.sectorType\">Sector Type</span></dt><dd><a ui-sref=\"sector-type-detail({id:vm.tempSector.sectorType.id})\">{{vm.tempSector.sectorType.name}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.doctorSpecialty\">Doctor Specialty</span></dt><dd><a ui-sref=\"doctor-specialty-detail({id:vm.tempSector.doctorSpecialty.id})\">{{vm.tempSector.doctorSpecialty.name}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.parent\">Parent</span></dt><dd><a ui-sref=\"sector-detail({id:vm.tempSector.parent.id})\">{{vm.tempSector.parent.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.country\">Country</span></dt><dd><a ui-sref=\"country-detail({id:vm.tempSector.country.id})\">{{vm.tempSector.country.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.region\">Region</span></dt><dd><a ui-sref=\"region-detail({id:vm.tempSector.region.id})\">{{vm.tempSector.region.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.prefecture\">Prefecture</span></dt><dd><a ui-sref=\"prefecture-detail({id:vm.tempSector.prefecture.id})\">{{vm.tempSector.prefecture.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.city\">City</span></dt><dd><a ui-sref=\"city-detail({id:vm.tempSector.city.id})\">{{vm.tempSector.city.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.approvedSector\">Approved Sector</span></dt><dd><a ui-sref=\"sector-detail({id:vm.tempSector.approvedSector.id})\">{{vm.tempSector.approvedSector.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.companyType\">Company Type</span></dt><dd><a ui-sref=\"company-type-detail({id:vm.tempSector.companyType.id})\">{{vm.tempSector.companyType.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.taxOffice\">Tax Office</span></dt><dd><a ui-sref=\"tax-office-detail({id:vm.tempSector.taxOffice.id})\">{{vm.tempSector.taxOffice.id}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.taxStatus\">Tax Status</span></dt><dd><a ui-sref=\"tax-status-detail({id:vm.tempSector.taxStatus.id})\">{{vm.tempSector.taxStatus.name}}</a></dd><dt><span translate=\"sigmasfApp.tempSector.sectorCategory\">Sector Category</span></dt><dd><a ui-sref=\"sector-category-detail({id:vm.tempSector.sectorCategory.id})\">{{vm.tempSector.sectorCategory.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/temp-sector/temp-sector-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTempSectorLabel\" translate=\"sigmasfApp.tempSector.home.createOrEditLabel\">Create or edit a Temp Sector</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tempSector.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tempSector.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.tempSector.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.brick\" for=\"field_brick\">Brick</label><input type=\"text\" class=\"form-control\" name=\"brick\" id=\"field_brick\" ng-model=\"vm.tempSector.brick\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.osfeBrick\" for=\"field_osfeBrick\">Osfe Brick</label><input type=\"text\" class=\"form-control\" name=\"osfeBrick\" id=\"field_osfeBrick\" ng-model=\"vm.tempSector.osfeBrick\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.tempSector.phone\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.phone2\" for=\"field_phone2\">Phone 2</label><input type=\"text\" class=\"form-control\" name=\"phone2\" id=\"field_phone2\" ng-model=\"vm.tempSector.phone2\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.countryName\" for=\"field_countryName\">Country Name</label><input type=\"text\" class=\"form-control\" name=\"countryName\" id=\"field_countryName\" ng-model=\"vm.tempSector.countryName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.regionName\" for=\"field_regionName\">Region Name</label><input type=\"text\" class=\"form-control\" name=\"regionName\" id=\"field_regionName\" ng-model=\"vm.tempSector.regionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.prefectureName\" for=\"field_prefectureName\">Prefecture Name</label><input type=\"text\" class=\"form-control\" name=\"prefectureName\" id=\"field_prefectureName\" ng-model=\"vm.tempSector.prefectureName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.cityName\" for=\"field_cityName\">City Name</label><input type=\"text\" class=\"form-control\" name=\"cityName\" id=\"field_cityName\" ng-model=\"vm.tempSector.cityName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"text\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.tempSector.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.tempSector.address\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.addressNum\" for=\"field_addressNum\">Address Num</label><input type=\"text\" class=\"form-control\" name=\"addressNum\" id=\"field_addressNum\" ng-model=\"vm.tempSector.addressNum\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.tempSector.status\" id=\"field_status\"><option value=\"pending\" translate=\"sigmasfApp.Status.pending\">pending</option><option value=\"approved\" translate=\"sigmasfApp.Status.approved\">approved</option><option value=\"rejected\" translate=\"sigmasfApp.Status.rejected\">rejected</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.issuedDate\" for=\"field_issuedDate\">Issued Date</label><div class=\"input-group\"><input id=\"field_issuedDate\" type=\"text\" class=\"form-control\" name=\"issuedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.tempSector.issuedDate\" is-open=\"vm.datePickerOpenStatus.issuedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'issuedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.issuedBy\" for=\"field_issuedBy\">Issued By</label><input type=\"text\" class=\"form-control\" name=\"issuedBy\" id=\"field_issuedBy\" ng-model=\"vm.tempSector.issuedBy\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.autoapprove\" for=\"field_autoapprove\">Autoapprove</label><input type=\"checkbox\" class=\"form-control\" name=\"autoapprove\" id=\"field_autoapprove\" ng-model=\"vm.tempSector.autoapprove\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tempSector.vat\" for=\"field_vat\">Vat</label><input type=\"text\" class=\"form-control\" name=\"vat\" id=\"field_vat\" ng-model=\"vm.tempSector.vat\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.sectorType\" for=\"field_sectorType\">Sector Type</label><select class=\"form-control\" id=\"field_sectorType\" name=\"sectorType\" ng-model=\"vm.tempSector.sectorType\" ng-options=\"sectorType as sectorType.name for sectorType in vm.sectortypes track by sectorType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.doctorSpecialty\" for=\"field_doctorSpecialty\">Doctor Specialty</label><select class=\"form-control\" id=\"field_doctorSpecialty\" name=\"doctorSpecialty\" ng-model=\"vm.tempSector.doctorSpecialty\" ng-options=\"doctorSpecialty as doctorSpecialty.name for doctorSpecialty in vm.doctorspecialties track by doctorSpecialty.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.tempSector.parent\" ng-options=\"sector as sector.id for sector in vm.sectors track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.tempSector.country\" ng-options=\"country as country.id for country in vm.countries track by country.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.region\" for=\"field_region\">Region</label><select class=\"form-control\" id=\"field_region\" name=\"region\" ng-model=\"vm.tempSector.region\" ng-options=\"region as region.id for region in vm.regions track by region.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.prefecture\" for=\"field_prefecture\">Prefecture</label><select class=\"form-control\" id=\"field_prefecture\" name=\"prefecture\" ng-model=\"vm.tempSector.prefecture\" ng-options=\"prefecture as prefecture.id for prefecture in vm.prefectures track by prefecture.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.city\" for=\"field_city\">City</label><select class=\"form-control\" id=\"field_city\" name=\"city\" ng-model=\"vm.tempSector.city\" ng-options=\"city as city.id for city in vm.cities track by city.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.approvedSector\" for=\"field_approvedSector\">Approved Sector</label><select class=\"form-control\" id=\"field_approvedSector\" name=\"approvedSector\" ng-model=\"vm.tempSector.approvedSector\" ng-options=\"sector as sector.id for sector in vm.approvedsectors | orderBy:\'id\' track by sector.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.companyType\" for=\"field_companyType\">Company Type</label><select class=\"form-control\" id=\"field_companyType\" name=\"companyType\" ng-model=\"vm.tempSector.companyType\" ng-options=\"companyType as companyType.id for companyType in vm.companytypes track by companyType.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.taxOffice\" for=\"field_taxOffice\">Tax Office</label><select class=\"form-control\" id=\"field_taxOffice\" name=\"taxOffice\" ng-model=\"vm.tempSector.taxOffice\" ng-options=\"taxOffice as taxOffice.id for taxOffice in vm.taxoffices track by taxOffice.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.taxStatus\" for=\"field_taxStatus\">Tax Status</label><select class=\"form-control\" id=\"field_taxStatus\" name=\"taxStatus\" ng-model=\"vm.tempSector.taxStatus\" ng-options=\"taxStatus as taxStatus.name for taxStatus in vm.taxstatuses track by taxStatus.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tempSector.sectorCategory\" for=\"field_sectorCategory\">Sector Category</label><select class=\"form-control\" id=\"field_sectorCategory\" name=\"sectorCategory\" ng-model=\"vm.tempSector.sectorCategory\" ng-options=\"sectorCategory as sectorCategory.id for sectorCategory in vm.sectorcategories track by sectorCategory.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/temp-sector/temp-sectors.html","<div><h2 translate=\"sigmasfApp.tempSector.home.title\">Temp Sectors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"temp-sector.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tempSector.home.createLabel\">Create new Temp Sector</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.tempSector.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"brick\"><span translate=\"sigmasfApp.tempSector.brick\">Brick</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"osfeBrick\"><span translate=\"sigmasfApp.tempSector.osfeBrick\">Osfe Brick</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone\"><span translate=\"sigmasfApp.tempSector.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phone2\"><span translate=\"sigmasfApp.tempSector.phone2\">Phone 2</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryName\"><span translate=\"sigmasfApp.tempSector.countryName\">Country Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"regionName\"><span translate=\"sigmasfApp.tempSector.regionName\">Region Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefectureName\"><span translate=\"sigmasfApp.tempSector.prefectureName\">Prefecture Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cityName\"><span translate=\"sigmasfApp.tempSector.cityName\">City Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span translate=\"sigmasfApp.tempSector.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"sigmasfApp.tempSector.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressNum\"><span translate=\"sigmasfApp.tempSector.addressNum\">Address Num</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sigmasfApp.tempSector.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedDate\"><span translate=\"sigmasfApp.tempSector.issuedDate\">Issued Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"issuedBy\"><span translate=\"sigmasfApp.tempSector.issuedBy\">Issued By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"autoapprove\"><span translate=\"sigmasfApp.tempSector.autoapprove\">Autoapprove</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vat\"><span translate=\"sigmasfApp.tempSector.vat\">Vat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorType.name\"><span translate=\"sigmasfApp.tempSector.sectorType\">Sector Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"doctorSpecialty.name\"><span translate=\"sigmasfApp.tempSector.doctorSpecialty\">Doctor Specialty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parent.id\"><span translate=\"sigmasfApp.tempSector.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"country.id\"><span translate=\"sigmasfApp.tempSector.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"region.id\"><span translate=\"sigmasfApp.tempSector.region\">Region</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"prefecture.id\"><span translate=\"sigmasfApp.tempSector.prefecture\">Prefecture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city.id\"><span translate=\"sigmasfApp.tempSector.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"approvedSector.id\"><span translate=\"sigmasfApp.tempSector.approvedSector\">Approved Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyType.id\"><span translate=\"sigmasfApp.tempSector.companyType\">Company Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxOffice.id\"><span translate=\"sigmasfApp.tempSector.taxOffice\">Tax Office</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxStatus.name\"><span translate=\"sigmasfApp.tempSector.taxStatus\">Tax Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sectorCategory.id\"><span translate=\"sigmasfApp.tempSector.sectorCategory\">Sector Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tempSector in vm.tempSectors track by tempSector.id\"><td><a ui-sref=\"temp-sector-detail({id:tempSector.id})\">{{tempSector.id}}</a></td><td>{{tempSector.name}}</td><td>{{tempSector.brick}}</td><td>{{tempSector.osfeBrick}}</td><td>{{tempSector.phone}}</td><td>{{tempSector.phone2}}</td><td>{{tempSector.countryName}}</td><td>{{tempSector.regionName}}</td><td>{{tempSector.prefectureName}}</td><td>{{tempSector.cityName}}</td><td>{{tempSector.postalCode}}</td><td>{{tempSector.address}}</td><td>{{tempSector.addressNum}}</td><td translate=\"{{\'sigmasfApp.Status.\' + tempSector.status}}\">{{tempSector.status}}</td><td>{{tempSector.issuedDate | date:\'medium\'}}</td><td>{{tempSector.issuedBy}}</td><td>{{tempSector.autoapprove}}</td><td>{{tempSector.vat}}</td><td><a ui-sref=\"sector-type-detail({id:tempSector.sectorType.id})\">{{tempSector.sectorType.name}}</a></td><td><a ui-sref=\"doctor-specialty-detail({id:tempSector.doctorSpecialty.id})\">{{tempSector.doctorSpecialty.name}}</a></td><td><a ui-sref=\"sector-detail({id:tempSector.parent.id})\">{{tempSector.parent.id}}</a></td><td><a ui-sref=\"country-detail({id:tempSector.country.id})\">{{tempSector.country.id}}</a></td><td><a ui-sref=\"region-detail({id:tempSector.region.id})\">{{tempSector.region.id}}</a></td><td><a ui-sref=\"prefecture-detail({id:tempSector.prefecture.id})\">{{tempSector.prefecture.id}}</a></td><td><a ui-sref=\"city-detail({id:tempSector.city.id})\">{{tempSector.city.id}}</a></td><td><a ui-sref=\"sector-detail({id:tempSector.approvedSector.id})\">{{tempSector.approvedSector.id}}</a></td><td><a ui-sref=\"company-type-detail({id:tempSector.companyType.id})\">{{tempSector.companyType.id}}</a></td><td><a ui-sref=\"tax-office-detail({id:tempSector.taxOffice.id})\">{{tempSector.taxOffice.id}}</a></td><td><a ui-sref=\"tax-status-detail({id:tempSector.taxStatus.id})\">{{tempSector.taxStatus.name}}</a></td><td><a ui-sref=\"sector-category-detail({id:tempSector.sectorCategory.id})\">{{tempSector.sectorCategory.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"temp-sector-detail({id:tempSector.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"temp-sector.edit({id:tempSector.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"temp-sector.delete({id:tempSector.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/trade-policy/trade-policies.html","<div><h2 translate=\"sigmasfApp.tradePolicy.home.title\">Trade Policies</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"trade-policy.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tradePolicy.home.createLabel\">Create new Trade Policy</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sigmasfApp.tradePolicy.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sigmasfApp.tradePolicy.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromDate\"><span translate=\"sigmasfApp.tradePolicy.fromDate\">From Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toDate\"><span translate=\"sigmasfApp.tradePolicy.toDate\">To Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tradePolicy in vm.tradePolicies track by tradePolicy.id\"><td><a ui-sref=\"trade-policy-detail({id:tradePolicy.id})\">{{tradePolicy.id}}</a></td><td>{{tradePolicy.code}}</td><td>{{tradePolicy.description}}</td><td>{{tradePolicy.fromDate | date:\'mediumDate\'}}</td><td>{{tradePolicy.toDate | date:\'mediumDate\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"trade-policy-detail({id:tradePolicy.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy.edit({id:tradePolicy.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy.delete({id:tradePolicy.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/trade-policy/trade-policy-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tradePolicy.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tradePolicy.delete.question\" translate-values=\"{id: \'{{vm.tradePolicy.id}}\'}\">Are you sure you want to delete this Trade Policy?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/trade-policy/trade-policy-detail.html","<div><h2><span translate=\"sigmasfApp.tradePolicy.detail.title\">Trade Policy</span> {{vm.tradePolicy.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tradePolicy.code\">Code</span></dt><dd><span>{{vm.tradePolicy.code}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicy.description\">Description</span></dt><dd><span>{{vm.tradePolicy.description}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicy.fromDate\">From Date</span></dt><dd><span>{{vm.tradePolicy.fromDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicy.toDate\">To Date</span></dt><dd><span>{{vm.tradePolicy.toDate | date:\'mediumDate\'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/trade-policy/trade-policy-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTradePolicyLabel\" translate=\"sigmasfApp.tradePolicy.home.createOrEditLabel\">Create or edit a Trade Policy</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tradePolicy.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tradePolicy.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicy.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.tradePolicy.code\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicy.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.tradePolicy.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicy.fromDate\" for=\"field_fromDate\">From Date</label><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.tradePolicy.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicy.toDate\" for=\"field_toDate\">To Date</label><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.tradePolicy.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/trade-policy-rule/trade-policy-rule-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tradePolicyRule.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tradePolicyRule.delete.question\" translate-values=\"{id: \'{{vm.tradePolicyRule.id}}\'}\">Are you sure you want to delete this Trade Policy Rule?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/trade-policy-rule/trade-policy-rule-detail.html","<div><h2><span translate=\"sigmasfApp.tradePolicyRule.detail.title\">Trade Policy Rule</span> {{vm.tradePolicyRule.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tradePolicyRule.ruleType\">Rule Type</span></dt><dd><span translate=\"{{\'sigmasfApp.TradePolicyRuleTypeEnum.\' + vm.tradePolicyRule.ruleType}}\">{{vm.tradePolicyRule.ruleType}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRule.fromValue\">From Value</span></dt><dd><span>{{vm.tradePolicyRule.fromValue}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRule.toValue\">To Value</span></dt><dd><span>{{vm.tradePolicyRule.toValue}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRule.tradePolicy\">Trade Policy</span></dt><dd><a ui-sref=\"trade-policy-detail({id:vm.tradePolicyRule.tradePolicy.id})\">{{vm.tradePolicyRule.tradePolicy.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/trade-policy-rule/trade-policy-rule-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTradePolicyRuleLabel\" translate=\"sigmasfApp.tradePolicyRule.home.createOrEditLabel\">Create or edit a Trade Policy Rule</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tradePolicyRule.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tradePolicyRule.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRule.ruleType\" for=\"field_ruleType\">Rule Type</label><select class=\"form-control\" name=\"ruleType\" ng-model=\"vm.tradePolicyRule.ruleType\" id=\"field_ruleType\"><option value=\"purchasePrice\" translate=\"sigmasfApp.TradePolicyRuleTypeEnum.purchasePrice\">purchasePrice</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRule.fromValue\" for=\"field_fromValue\">From Value</label><input type=\"number\" class=\"form-control\" name=\"fromValue\" id=\"field_fromValue\" ng-model=\"vm.tradePolicyRule.fromValue\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRule.toValue\" for=\"field_toValue\">To Value</label><input type=\"number\" class=\"form-control\" name=\"toValue\" id=\"field_toValue\" ng-model=\"vm.tradePolicyRule.toValue\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.tradePolicyRule.tradePolicy\" for=\"field_tradePolicy\">Trade Policy</label><select class=\"form-control\" id=\"field_tradePolicy\" name=\"tradePolicy\" ng-model=\"vm.tradePolicyRule.tradePolicy\" ng-options=\"tradePolicy as tradePolicy.id for tradePolicy in vm.tradepolicies track by tradePolicy.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/trade-policy-rule/trade-policy-rules.html","<div><h2 translate=\"sigmasfApp.tradePolicyRule.home.title\">Trade Policy Rules</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"trade-policy-rule.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tradePolicyRule.home.createLabel\">Create new Trade Policy Rule</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ruleType\"><span translate=\"sigmasfApp.tradePolicyRule.ruleType\">Rule Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromValue\"><span translate=\"sigmasfApp.tradePolicyRule.fromValue\">From Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toValue\"><span translate=\"sigmasfApp.tradePolicyRule.toValue\">To Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tradePolicy.id\"><span translate=\"sigmasfApp.tradePolicyRule.tradePolicy\">Trade Policy</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tradePolicyRule in vm.tradePolicyRules track by tradePolicyRule.id\"><td><a ui-sref=\"trade-policy-rule-detail({id:tradePolicyRule.id})\">{{tradePolicyRule.id}}</a></td><td translate=\"{{\'sigmasfApp.TradePolicyRuleTypeEnum.\' + tradePolicyRule.ruleType}}\">{{tradePolicyRule.ruleType}}</td><td>{{tradePolicyRule.fromValue}}</td><td>{{tradePolicyRule.toValue}}</td><td><a ui-sref=\"trade-policy-detail({id:tradePolicyRule.tradePolicy.id})\">{{tradePolicyRule.tradePolicy.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"trade-policy-rule-detail({id:tradePolicyRule.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy-rule.edit({id:tradePolicyRule.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy-rule.delete({id:tradePolicyRule.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/trade-policy-rule-effect/trade-policy-rule-effect-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tradePolicyRuleEffect.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.tradePolicyRuleEffect.delete.question\" translate-values=\"{id: \'{{vm.tradePolicyRuleEffect.id}}\'}\">Are you sure you want to delete this Trade Policy Rule Effect?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/trade-policy-rule-effect/trade-policy-rule-effect-detail.html","<div><h2><span translate=\"sigmasfApp.tradePolicyRuleEffect.detail.title\">Trade Policy Rule Effect</span> {{vm.tradePolicyRuleEffect.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.effectType\">Effect Type</span></dt><dd><span translate=\"{{\'sigmasfApp.TradePolicyRuleEffectTypeEnum.\' + vm.tradePolicyRuleEffect.effectType}}\">{{vm.tradePolicyRuleEffect.effectType}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.severity\">Severity</span></dt><dd><span translate=\"{{\'sigmasfApp.TradePolicyRuleEffectSeverityEnum.\' + vm.tradePolicyRuleEffect.severity}}\">{{vm.tradePolicyRuleEffect.severity}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.discountPercent\">Discount Percent</span></dt><dd><span>{{vm.tradePolicyRuleEffect.discountPercent}}</span></dd><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.tradePolicyRule\">Trade Policy Rule</span></dt><dd><a ui-sref=\"trade-policy-rule-detail({id:vm.tradePolicyRuleEffect.tradePolicyRule.id})\">{{vm.tradePolicyRuleEffect.tradePolicyRule.id}}</a></dd><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.tradePolicyRuleEffect.product.id})\">{{vm.tradePolicyRuleEffect.product.id}}</a></dd><dt><span translate=\"sigmasfApp.tradePolicyRuleEffect.presentList\">Present List</span></dt><dd><a ui-sref=\"present-list-detail({id:vm.tradePolicyRuleEffect.presentList.id})\">{{vm.tradePolicyRuleEffect.presentList.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/trade-policy-rule-effect/trade-policy-rule-effect-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTradePolicyRuleEffectLabel\" translate=\"sigmasfApp.tradePolicyRuleEffect.home.createOrEditLabel\">Create or edit a Trade Policy Rule Effect</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tradePolicyRuleEffect.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tradePolicyRuleEffect.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRuleEffect.effectType\" for=\"field_effectType\">Effect Type</label><select class=\"form-control\" name=\"effectType\" ng-model=\"vm.tradePolicyRuleEffect.effectType\" id=\"field_effectType\"><option value=\"discount\" translate=\"sigmasfApp.TradePolicyRuleEffectTypeEnum.discount\">discount</option><option value=\"present\" translate=\"sigmasfApp.TradePolicyRuleEffectTypeEnum.present\">present</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRuleEffect.severity\" for=\"field_severity\">Severity</label><select class=\"form-control\" name=\"severity\" ng-model=\"vm.tradePolicyRuleEffect.severity\" id=\"field_severity\"><option value=\"recommend\" translate=\"sigmasfApp.TradePolicyRuleEffectSeverityEnum.recommend\">recommend</option><option value=\"strict\" translate=\"sigmasfApp.TradePolicyRuleEffectSeverityEnum.strict\">strict</option><option value=\"limit\" translate=\"sigmasfApp.TradePolicyRuleEffectSeverityEnum.limit\">limit</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.tradePolicyRuleEffect.discountPercent\" for=\"field_discountPercent\">Discount Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPercent\" id=\"field_discountPercent\" ng-model=\"vm.tradePolicyRuleEffect.discountPercent\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.tradePolicyRuleEffect.tradePolicyRule\" for=\"field_tradePolicyRule\">Trade Policy Rule</label><select class=\"form-control\" id=\"field_tradePolicyRule\" name=\"tradePolicyRule\" ng-model=\"vm.tradePolicyRuleEffect.tradePolicyRule\" ng-options=\"tradePolicyRule as tradePolicyRule.id for tradePolicyRule in vm.tradepolicyrules track by tradePolicyRule.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tradePolicyRuleEffect.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.tradePolicyRuleEffect.product\" ng-options=\"product as product.id for product in vm.products track by product.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sigmasfApp.tradePolicyRuleEffect.presentList\" for=\"field_presentList\">Present List</label><select class=\"form-control\" id=\"field_presentList\" name=\"presentList\" ng-model=\"vm.tradePolicyRuleEffect.presentList\" ng-options=\"presentList as presentList.id for presentList in vm.presentlists track by presentList.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/trade-policy-rule-effect/trade-policy-rule-effects.html","<div><h2 translate=\"sigmasfApp.tradePolicyRuleEffect.home.title\">Trade Policy Rule Effects</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"trade-policy-rule-effect.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.tradePolicyRuleEffect.home.createLabel\">Create new Trade Policy Rule Effect</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"effectType\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.effectType\">Effect Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"severity\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.severity\">Severity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPercent\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.discountPercent\">Discount Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tradePolicyRule.id\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.tradePolicyRule\">Trade Policy Rule</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"product.id\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"presentList.id\"><span translate=\"sigmasfApp.tradePolicyRuleEffect.presentList\">Present List</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tradePolicyRuleEffect in vm.tradePolicyRuleEffects track by tradePolicyRuleEffect.id\"><td><a ui-sref=\"trade-policy-rule-effect-detail({id:tradePolicyRuleEffect.id})\">{{tradePolicyRuleEffect.id}}</a></td><td translate=\"{{\'sigmasfApp.TradePolicyRuleEffectTypeEnum.\' + tradePolicyRuleEffect.effectType}}\">{{tradePolicyRuleEffect.effectType}}</td><td translate=\"{{\'sigmasfApp.TradePolicyRuleEffectSeverityEnum.\' + tradePolicyRuleEffect.severity}}\">{{tradePolicyRuleEffect.severity}}</td><td>{{tradePolicyRuleEffect.discountPercent}}</td><td><a ui-sref=\"trade-policy-rule-detail({id:tradePolicyRuleEffect.tradePolicyRule.id})\">{{tradePolicyRuleEffect.tradePolicyRule.id}}</a></td><td><a ui-sref=\"product-detail({id:tradePolicyRuleEffect.product.id})\">{{tradePolicyRuleEffect.product.id}}</a></td><td><a ui-sref=\"present-list-detail({id:tradePolicyRuleEffect.presentList.id})\">{{tradePolicyRuleEffect.presentList.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"trade-policy-rule-effect-detail({id:tradePolicyRuleEffect.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy-rule-effect.edit({id:tradePolicyRuleEffect.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"trade-policy-rule-effect.delete({id:tradePolicyRuleEffect.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/working-day/working-day-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.workingDay.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.workingDay.delete.question\" translate-values=\"{id: \'{{vm.workingDay.id}}\'}\">Are you sure you want to delete this Working Day?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/working-day/working-day-detail.html","<div><h2><span translate=\"sigmasfApp.workingDay.detail.title\">Working Day</span> {{vm.workingDay.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.workingDay.weekDayNo\">Week Day No</span></dt><dd><span>{{vm.workingDay.weekDayNo}}</span></dd><dt><span translate=\"sigmasfApp.workingDay.firstShiftFrom\">First Shift From</span></dt><dd><span>{{vm.workingDay.firstShiftFrom}}</span></dd><dt><span translate=\"sigmasfApp.workingDay.firstShiftTo\">First Shift To</span></dt><dd><span>{{vm.workingDay.firstShiftTo}}</span></dd><dt><span translate=\"sigmasfApp.workingDay.secondShiftFrom\">Second Shift From</span></dt><dd><span>{{vm.workingDay.secondShiftFrom}}</span></dd><dt><span translate=\"sigmasfApp.workingDay.secondShiftTo\">Second Shift To</span></dt><dd><span>{{vm.workingDay.secondShiftTo}}</span></dd><dt><span translate=\"sigmasfApp.workingDay.customerSector\">Customer Sector</span></dt><dd><a ui-sref=\"customer-sector-detail({id:vm.workingDay.customerSector.id})\">{{vm.workingDay.customerSector.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/working-day/working-day-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myWorkingDayLabel\" translate=\"sigmasfApp.workingDay.home.createOrEditLabel\">Create or edit a Working Day</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.workingDay.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.workingDay.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.workingDay.weekDayNo\" for=\"field_weekDayNo\">Week Day No</label><input type=\"number\" class=\"form-control\" name=\"weekDayNo\" id=\"field_weekDayNo\" ng-model=\"vm.workingDay.weekDayNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.workingDay.firstShiftFrom\" for=\"field_firstShiftFrom\">First Shift From</label><input type=\"text\" class=\"form-control\" name=\"firstShiftFrom\" id=\"field_firstShiftFrom\" ng-model=\"vm.workingDay.firstShiftFrom\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.workingDay.firstShiftTo\" for=\"field_firstShiftTo\">First Shift To</label><input type=\"text\" class=\"form-control\" name=\"firstShiftTo\" id=\"field_firstShiftTo\" ng-model=\"vm.workingDay.firstShiftTo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.workingDay.secondShiftFrom\" for=\"field_secondShiftFrom\">Second Shift From</label><input type=\"text\" class=\"form-control\" name=\"secondShiftFrom\" id=\"field_secondShiftFrom\" ng-model=\"vm.workingDay.secondShiftFrom\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.workingDay.secondShiftTo\" for=\"field_secondShiftTo\">Second Shift To</label><input type=\"text\" class=\"form-control\" name=\"secondShiftTo\" id=\"field_secondShiftTo\" ng-model=\"vm.workingDay.secondShiftTo\"></div><div class=\"form-group\"><label translate=\"sigmasfApp.workingDay.customerSector\" for=\"field_customerSector\">Customer Sector</label><select class=\"form-control\" id=\"field_customerSector\" name=\"customerSector\" ng-model=\"vm.workingDay.customerSector\" ng-options=\"customerSector as customerSector.id for customerSector in vm.customersectors track by customerSector.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/working-day/working-days.html","<div><h2 translate=\"sigmasfApp.workingDay.home.title\">Working Days</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"working-day.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sigmasfApp.workingDay.home.createLabel\">Create new Working Day</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sigmasfApp.workingDay.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"weekDayNo\"><span translate=\"sigmasfApp.workingDay.weekDayNo\">Week Day No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstShiftFrom\"><span translate=\"sigmasfApp.workingDay.firstShiftFrom\">First Shift From</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstShiftTo\"><span translate=\"sigmasfApp.workingDay.firstShiftTo\">First Shift To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"secondShiftFrom\"><span translate=\"sigmasfApp.workingDay.secondShiftFrom\">Second Shift From</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"secondShiftTo\"><span translate=\"sigmasfApp.workingDay.secondShiftTo\">Second Shift To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerSector.id\"><span translate=\"sigmasfApp.workingDay.customerSector\">Customer Sector</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"workingDay in vm.workingDays track by workingDay.id\"><td><a ui-sref=\"working-day-detail({id:workingDay.id})\">{{workingDay.id}}</a></td><td>{{workingDay.weekDayNo}}</td><td>{{workingDay.firstShiftFrom}}</td><td>{{workingDay.firstShiftTo}}</td><td>{{workingDay.secondShiftFrom}}</td><td>{{workingDay.secondShiftTo}}</td><td><a ui-sref=\"customer-sector-detail({id:workingDay.customerSector.id})\">{{workingDay.customerSector.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"working-day-detail({id:workingDay.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"working-day.edit({id:workingDay.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"working-day.delete({id:workingDay.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/transportation/transportation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.transportation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sigmasfApp.transportation.delete.question\" translate-values=\"{id: \'{{vm.transportation.id}}\'}\">Are you sure you want to delete this Transportation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/transportation/transportation-detail.html","<div><h2><span translate=\"sigmasfApp.transportation.detail.title\">Transportation</span> {{vm.transportation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sigmasfApp.transportation.name\">Name</span></dt><dd><span>{{vm.transportation.name}}</span></dd><dt><span translate=\"sigmasfApp.transportation.cost\">Cost</span></dt><dd><span>{{vm.transportation.cost}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/transportation/transportation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTransportationLabel\" translate=\"sigmasfApp.transportation.home.createOrEditLabel\">Create or edit a Transportation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.transportation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.transportation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.transportation.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.transportation.name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sigmasfApp.transportation.cost\" for=\"field_cost\">Cost</label><input type=\"number\" class=\"form-control\" name=\"cost\" id=\"field_cost\" ng-model=\"vm.transportation.cost\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/transportation/transportations.html","<div><h2 translate=\"sigmasfApp.transportation.home.title\">Transportations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"transportation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"sigmasfApp.transportation.home.createLabel\">Create new Transportation</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sigmasfApp.transportation.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cost\"><span translate=\"sigmasfApp.transportation.cost\">Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"transportation in vm.transportations track by transportation.id\"><td><a ui-sref=\"transportation-detail({id:transportation.id})\">{{transportation.id}}</a></td><td>{{transportation.name}}</td><td>{{transportation.cost}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"transportation-detail({id:transportation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"transportation.edit({id:transportation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"transportation.delete({id:transportation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/masterData/addConditions/addConditions.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/addDiseases/addDiseases.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/agreementValuations/agreementValuations.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/callTypes/callTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/collaborations/collaborations.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddDoctorSpecialtyClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/clinicNames/clinicNames.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/communicationStatuses/communicationStatuses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/communicationTypes/communicationTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/competitors/competitors.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/costTypes/costTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/customerTitles/customerTitles.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddTitleClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/discountRates/discountRates.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/customerCategories/customerCategories.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddCategoryClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainCategoriesGrid\" options=\"vm.mainCategoriesGridOptions\"></kendo-grid><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.secondPageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddSubcategoryClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainSubcategoriesGrid\" options=\"vm.mainSubcategoriesGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/diseases/diseases.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/discountReasons/discountReasons.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/diseaseTypes/diseaseTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/doctorSpecialties/doctorSpecialties.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddDoctorSpecialtyClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/eventPlaces/eventPlaces.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/eventStatuses/eventStatuses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/eventTypes/eventTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/hospitalizationTypes/hospitalizationTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/followupTypes/followupTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/leadParameters/leadParameters.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/hospitalizationTypeParents/hospitalizationTypeParents.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/materialCategories/materialCategories.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/nativeLanguages/nativeLanguages.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/measurementUnits/measurementUnits.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/prefectures/prefectures.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" translate=\"masterData.prefectures.cities\">Prefectures</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid>");
$templateCache.put("app/masterData/presentLists/presentLists.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddPresentListClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Λίστας</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" translate=\"masterData.products.title\">Products</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid><div id=\"popup-new-grid\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\" k-on-open=\"vm.kendoGrid.refresh(vm.popupProductsGridOptions)\" k-on-close=\"vm.statusChanged = \'closed\';\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"pull-left left-section\"><div class=\"k-edit-label\"><label>Ποσότητα:</label></div><input id=\"quantity\" class=\"custom-combobox\" kendo-numeric-text-box min=\"1\" ng-model=\"vm.quantity\"></div><div class=\"employee-assign\"><h5>Προσθήκη Προϊόντων <span style=\"float: right; color: red; font-style: italic\">Προϊόντα που υπάρχουν ήδη στη λίστα ΔΕΝ θα προστεθούν</span></h5><div selectable-grid items=\"vm.selectedProducts\" kendo-grid id=\"popupProductsGrid\" k-options=\"vm.popupProductsGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\" k-ng-delay=\"vm.initPopupGrid\"></div></div></div></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closeCustomPopup()\">Ακύρωση</button> <button type=\"button\" class=\"k-primary k-button\" ng-click=\"vm.savePresentListProducts()\" ng-disabled=\"!vm.quantity || !vm.selectedProducts.length\">Αποθήκευση</button></div></div>");
$templateCache.put("app/masterData/patchItems/patchItems.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/productCategories/productCategories.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-shopping_basket-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddProductLotClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Κατηγορίας</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/paymentMethods/paymentMethods.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/productLotMass/productLotMass.html","<span kendo-notification=\"notification\"></span> <span id=\"centeredNotification\" style=\"display:none\"></span><div class=\"inline\" style=\"width: 100%\"><div class=\"form-group\"><div class=\"col-sm-3 pull-left\"><input kendo-upload name=\"file\" type=\"file\" k-show-file-list=\"false\" k-multiple=\"false\" k-select=\"vm.onSelect\" k-localization=\'{\"select\": \"Διάλεξε ένα αρχείο για ανέβασμα...\"}\'></div></div><div class=\"form-group\"><div class=\"col-sm-1 pull-right\"><md-button class=\"md-raised md-warn\" id=\"save\" ng-click=\"vm.save()\"><md-icon ng-bind=\'\"save\"\'></md-icon>Αποθήκευση</md-button></div></div></div><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-spreadsheet id=\"spreadsheet\" k-scope-field=\"spreadsheet\" style=\"width: 100%\"></kendo-spreadsheet>");
$templateCache.put("app/masterData/productLots/productLots.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-shopping_basket-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddProductLotClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Παρτίδας</span></md-button></h2></div></md-toolbar><span id=\"centeredNotification\" style=\"display:none\"></span><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/products/products.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-shopping_basket-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddProductClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη Προιόντος</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"multi-filter-column\"><div k-detail-template id=\"detailedGridOptions\" has-any-authority=\"ROLE_ADMIN, ROLE_MANAGEMENT, ROLE_ACCOUNTING_DEP\" application-parameters=\"Purchase_Pharmacies\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" translate=\"masterData.productPrices.title\">Product Prices</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid>");
$templateCache.put("app/masterData/purchaseNumberingRows/purchaseNumberingRows.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"multi-filter-column\"></kendo-grid>");
$templateCache.put("app/masterData/professions/professions.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/rejectionReasons/rejectionReasons.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/regions/regions.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/purchaseStatuses/purchaseStatuses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/relationshipTypes/relationshipTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/roomCosts/roomCosts.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/roomTypes/roomTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/sectorTypes/sectorTypes.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddSectorTypeClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/sortOrders/sortOrders.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-shopping_basket-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-sortable options=\"vm.sortableOptions\"><kendo-grid id=\"mainGrid\" k-scope-field=\"vm.sortableGrid\" options=\"vm.mainGridOptions\"></kendo-grid></kendo-sortable>");
$templateCache.put("app/masterData/sectorPositions/sectorPositions.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span flex=\"\">{{vm.pageHeading.toUpperCase()}}</span><md-button type=\"button\" class=\"md-button md-ink-ripple md-raised md-primary pull-right\" style=\"padding-right: 25px!important; background-color: #F9A22E; color: #0074BC\" aria-label=\"add\" ng-click=\"vm.onAddSectorPositionClick()\"><i class=\"material-icons md-light md-26 md-margin\" style=\"color: #0074BC\">add</i> <span class=\"hidden-sm\">Προσθήκη</span></md-button></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/socialInsurances/socialInsurances.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/taxStatusClasses/taxStatusClasses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/taxClasses/taxClasses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/tradePolicies/tradePolicies.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" k-on-change=\"vm.onSelection(data)\"></kendo-grid>");
$templateCache.put("app/masterData/tradePolicies/tradePoliciesView.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><div class=\"well clearfix\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-media><img ng-src=\"content/images/{{vm.profilePicture}}\" alt=\"TP Picture\" style=\"width:150px;height:150px\"></md-card-title-media><md-card-title-text style=\"margin-left: 15px\"><div><div class=\"col-lg-8 col-sm-2\" style=\"margin-bottom: 1%\"><span class=\"\"><b>Κωδικός : </b><input id=\"tradePolicyCode\" name=\"tradePolicyCode\" value=\"{{vm.tradePolicy.code}}\" ng-model=\"vm.tradePolicy.code\" class=\"k-textbox info pull-right\" placeholder=\"Κωδικός\" required data-required-msg=\"Παρακαλούμε εισάγετε τον κωδικό.\"></span></div><div class=\"col-lg-8 col-sm-2\" style=\"margin-bottom: 1%\"><span class=\"\"><b>Περιγραφή :</b> <input id=\"tradePolicyDescription\" name=\"tradePolicyDescription\" value=\"{{vm.tradePolicy.description}}\" ng-model=\"vm.tradePolicy.description\" class=\"k-textbox info pull-right\" placeholder=\"Περιγραφή\" required data-required-msg=\"Παρακαλούμε εισάγετε την περιγραφή.\"></span></div><div class=\"col-lg-8 col-sm-2\" style=\"margin-bottom: 1%\"><span class=\"\"><b>Ημερ/νία Ισχύος Από :</b> <input id=\"fromDate\" name=\"fromDate\" ng-model=\"vm.tradePolicy.fromDate\" class=\"pull-right\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\"></span></div><div class=\"col-lg-8 col-sm-2\"><span class=\"\"><b>Ημερ/νία Ισχύος Εώς :</b> <input id=\"toDate\" name=\"toDate\" ng-model=\"vm.tradePolicy.toDate\" class=\"pull-right\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\"></span></div></div><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button id=\"update-first\" type=\"button\" ng-click=\"vm.update()\">Αποθήκευση</md-button></md-card-actions></md-card-title-text></md-card-title></md-card></div></md-content></div><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"tradePolicyRules\" ng-class=\"{\'k-state-active\': vm.$state.is(\'tradePolicyRules\')}\"><i class=\"material-icons\">local_pharmacy</i>Κανόνες Εμπορικής Πολιτικής</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div>");
$templateCache.put("app/masterData/taxStatuses/taxStatuses.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/masterData/transportations/transportations.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-assignment-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" k-options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminCustomers/events/events.html","<div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"eventsGrid\" options=\"vm.eventsGridOptions\"></kendo-grid></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");
$templateCache.put("app/displays/adminCustomers/agreements/agreements.html","<div style=\"padding: 1em\"><div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersAgreements\"></div><kendo-grid id=\"agreementsGrid\" options=\"vm.agreementsGridOptions\"></kendo-grid></div></div>");
$templateCache.put("app/displays/adminCustomers/notes/notes.html","<div style=\"padding: 1em\"><div><section class=\"well\"><div class=\"col-sm-10 col-md-8\"><textarea maxlength=\"500\" id=\"notes\" value=\"{{vm.customer.notes}}\" ng-model=\"vm.customer.notes\" class=\"k-textbox info\"></textarea></div><div class=\"clearfix\"></div><div class=\"buttons-wrap\"><input id=\"update-second\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.update()\" ng-hide=\"vm.readOnly\" value=\"Αποθήκευση\"></div></section></div></div>");
$templateCache.put("app/displays/adminCustomers/info/info.html","<div style=\"padding: 1em\"><section class=\"row\"><div id=\"customerFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"last_name\" name=\"last_name\" value=\"{{vm.customer.last_name}}\" ng-model=\"vm.customer.lastName\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Επώνυμο\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του επαγγελματία υγείας.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"first_name\" name=\"first_name\" value=\"{{vm.customer.first_name}}\" ng-model=\"vm.customer.firstName\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Όνομα\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του επαγγελματία υγείας.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα 1η:</label><div class=\"col-sm-8 col-md-6\"><select id=\"specialty\" name=\"specialty\" kendo-combo-box k-ng-model=\"vm.customer.doctorSpecialty.id\" k-options=\"vm.specialtyComboBoxOptions\" ng-readonly=\"vm.readOnly\" data-custom=\"#specialty\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"specialty\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα 2η:</label><div class=\"col-sm-8 col-md-6\"><select id=\"doctorSpecificSpecialty\" name=\"doctorSpecificSpecialty\" kendo-combo-box k-ng-model=\"vm.customer.doctorSpecificSpecialty.id\" k-options=\"vm.specialtyComboBoxOptions\" ng-readonly=\"vm.readOnly\" data-custom=\"#doctorSpecificSpecialty\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"doctorSpecificSpecialty\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κατηγορία:</label><div class=\"col-sm-8 col-md-6\"><select id=\"customer_category\" name=\"customer_category\" kendo-combo-box k-ng-model=\"vm.customer.customerCategory.id\" k-options=\"vm.categoryComboBoxOptions\" ng-readonly=\"vm.readOnly\" data-custom=\"#customer_category\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"customer_category\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Υποκατηγορία:</label><div class=\"col-sm-8 col-md-6\"><select id=\"customerSubCategory\" name=\"customerSubCategory\" kendo-combo-box k-ng-model=\"vm.customer.customerSubCategory.id\" k-options=\"vm.subCategoryComboBoxOptions\" ng-readonly=\"vm.readOnly\" class=\"col-fix\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ωράριο:</label><div class=\"col-sm-8 col-md-6\"><select id=\"day_time\" name=\"day_time\" kendo-combo-box k-ng-model=\"vm.customer.dayTime\" k-options=\"vm.dayTimeDropDownOptions\" ng-readonly=\"vm.readOnly\" class=\"col-fix\"></select></div></div><div ng-if=\"vm.customerView === \'3\'\" class=\"form-group\"><label class=\"control-label col-sm-4\">Συνεργασία:</label><div class=\"col-sm-8 col-md-6\"><select id=\"collaboration\" name=\"collaboration\" kendo-combo-box k-ng-model=\"vm.customer.collaboration.id\" k-options=\"vm.collaborationOptions\" ng-readonly=\"vm.readOnly\" class=\"col-fix\"></select></div></div><div ng-if=\"vm.customerView === \'3\'\" class=\"form-group\"><label class=\"control-label col-sm-4\">Λογισμικό:</label><div class=\"col-sm-8 col-md-6\"><select kendo-drop-down-list id=\"software\" name=\"software\" k-ng-model=\"vm.customer.software\" k-options=\"vm.softwareOptions\" class=\"col-fix\" data-option-label=\"{ value: null, text: \'Όχι\' }\"></select></div></div></div><div id=\"customerSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">A.M.K.A.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"amka\" name=\"cell_phone\" value=\"{{vm.customer.amka}}\" ng-model=\"vm.customer.amka\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"AMKA\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κινητό:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"cell_phone\" name=\"cell_phone\" value=\"{{vm.customer.cellPhone}}\" ng-model=\"vm.customer.cellPhone\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Κινητό Τηλέφωνο\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σταθερό Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.customer.phone}}\" ng-model=\"vm.customer.phone\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Σταθερό Τηλέφωνο\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"email\" id=\"email\" name=\"email\" value=\"{{vm.customer.email}}\" ng-model=\"vm.customer.email\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"example@example.gr\" data-email-msg=\"Το email δεν είναι έγκυρο\"> <span class=\"k-invalid-msg\" data-for=\"email\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τίτλος:</label><div class=\"col-sm-8 col-md-6\"><select id=\"customerTitle\" name=\"customerTitle\" kendo-combo-box k-ng-model=\"vm.customer.customerTitle.id\" ng-readonly=\"vm.readOnly\" k-options=\"vm.customerTitleComboBoxOptions\" data-custom=\"#customerTitle\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"customerTitle\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τύποι Επαγγελματία Υγείας:</label><div class=\"col-sm-8 col-md-6\"><select id=\"customerTypes\" name=\"customerTypes\" kendo-multi-select multiple=\"multiple\" k-ng-model=\"vm.customer.customerTypes\" ng-readonly=\"vm.readOnly\" k-options=\"vm.customerTypesMultiOptions\" class=\"col-fix\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ενεργός:</label><div class=\"col-sm-8 col-md-6\"><md-checkbox id=\"is_active\" class=\"checkbox-toolbar customers green inline\" aria-label=\"selectable\" ng-model=\"vm.isCustomerActive\" ng-disabled=\"vm.readOnly\"></md-checkbox></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">GDPR:</label><div class=\"col-sm-8 col-md-6\"><md-checkbox id=\"is_gdpr\" class=\"checkbox-toolbar customers green inline\" aria-label=\"selectable\" ng-model=\"vm.isCustomerGDPR\" ng-disabled=\"vm.readOnly\"></md-checkbox></div></div></div><!--<div id=\"customerThird\" class=\"form-horizontal form-widgets col-sm-6\">--><!--<div class=\"form-group\">--><!--<img data-ng-src=\"{{\'data:\' + vm.customer.profilePhotoContentType + \';base64,\' + vm.customer.profilePhoto}}\" style=\"max-width: 80%;\" ng-if=\"vm.customer.profilePhoto\"/>--><!--<img ng-src=\"content/images/customer_icon.png\" alt=\"Profile Picture\" style=\"width:150px;height:150px;\" ng-if=\"!vm.customer.profilePhoto\" />--><!--</div>--><!--<div class=\"form-group\">--><!--<a type=\"file\" ngf-select ngf-change=\"vm.setProfilePhoto($file, vm.customer)\" accept=\"image/*\">--><!--{{ (vm.customer.profilePhoto == null) ? \"Προσθήκη εικόνας\" : \"Αλλαγή εικόνας\" }}--><!--</a>--><!--</div>--><!--</div>--><div class=\"clearfix\"></div><div class=\"buttons-wrap\"><input id=\"update-first\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.update()\" ng-hide=\"vm.readOnly\" value=\"Αποθήκευση\"></div></section></div>");
$templateCache.put("app/displays/adminCustomers/patchReports/patchReports.html","<ul class=\"nav nav-pills nav-stacked sub-nav-custom custom-nav-pills\"><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"customerPatchReports.pending\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">update</i>Προς Έγκριση</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"customerPatchReports.pendingHistory\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">history</i>Ιστορικό</md-button></li></ul><div style=\"padding: 1em\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\" class=\"patches-toolbar\"></div><div ui-view></div></div>");
$templateCache.put("app/displays/adminCustomers/scheduler/scheduler.html","<div kendo-tooltip k-content=\"vm.tooltipContent\" k-filter=\"\'.k-event\'\" class=\"k-group\"><kendo-scheduler id=\"scheduler\" k-options=\"vm.schedulerOptions\"><span k-event-template class=\"custom-event\"><span ng-show=\"vm.view == \'day\'\"><span class=\"glyphicon glyphicon-time\"></span> <span>{{dataItem.start | date : \'hh:mm a\'}}&nbsp;&nbsp;</span> <span>{{dataItem.end | date : \'hh:mm a\'}}&nbsp;&nbsp;</span> <span>{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span> <span ng-if=\"dataItem.startedAt\">{{dataItem.eventCategoryType.eventCategory.name}}&nbsp;</span> <span ng-if=\"dataItem.startedAt\">{{dataItem.eventCategoryType.eventType.name}}&nbsp;&nbsp;</span> <span ng-if=\"!dataItem.startedAt\">ΡΑΝΤΕΒΟΥ&nbsp;</span> <span ng-if=\"!dataItem.startedAt\">ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;</span> <span class=\"glyphicon glyphicon-user\"></span> <span>{{dataItem.employee.account.lastName}}, {{dataItem.employee.account.firstName}}</span> </span><span ng-show=\"vm.view == \'week\' || vm.view == \'month\'\"><span>{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span></span></span></kendo-scheduler></div><!--Tooltip Template--><script id=\"template\" type=\"text/x-kendo-template\">#var uid = target.attr(\"data-uid\");#\n    #var scheduler = target.closest(\"[data-role=scheduler]\").data(\"kendoScheduler\");#\n    #if (scheduler) {#\n        #var model = scheduler.occurrenceByUid(uid);#\n\n        #if(model) {#\n            <div class=\"schedule-tooltip\">\n                <i class=\"material-icons md-13\">schedule</i>\n                <span>#=kendo.toString(model.start, \"hh:mm tt\")#&nbsp;&nbsp;</span>\n                <span>#=kendo.toString(model.end, \"hh:mm tt\")#&nbsp;&nbsp;<br></span>\n                <i class=\"material-icons md-13\">lens</i>\n                #if(model.startedAt) {#\n                    <span>#= model.eventCategoryType.eventCategory.name#&nbsp;&nbsp;<br></span>\n                    #if(model.eventStatus) {#\n                        <i class=\"material-icons md-13\">lens</i>\n                        <span>#= model.eventStatus.name#&nbsp;&nbsp;<br></span>\n                    #}#\n                #}#\n                #if(!model.startedAt) {#\n                    <span>ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;<br></span>\n                #}#\n                <i class=\"material-icons md-13\">assignment_ind</i>\n                <span>#= model.employee.account.lastName#, #= model.employee.account.firstName#</span>\n            </div>\n        #}#\n    #}#</script><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor2\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div ng-show=\"vm.isSchedule && vm.currentCustomer.id == vm.selectedUserId\" class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><select name=\"communication_type\" id=\"communicationType\" kendo-combo-box k-ng-model=\"eventCustomerSector.communicationType\" data-bind=\"value:eventCustomerSector.communicationType.id\" k-options=\"vm.communicationTypesComboBoxOptions\"></select><div class=\"k-edit-label\"><label>Τίτλος:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"title\" data-bind=\"value:title\"><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"description\" data-bind=\"value:eventSchedule.description\"><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomer.lastName}} {{vm.currentCustomer.firstName}}</span></span></div><div ng-show=\"!vm.isSchedule || vm.currentCustomer.id != vm.selectedUserId\" class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: eventCustomerSector.communicationType.name#</span></span><div class=\"k-edit-label\"><label>Τίτλος:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: title#</span></span><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: description#</span></span><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomer.lastName}} {{vm.currentCustomer.firstName}}</span></span></div><div ng-show=\"vm.isSchedule && vm.currentCustomer.id == vm.selectedUserId\" class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><input name=\"start\" id=\"startDate\" class=\"half-width pull-right\" kendo-date-picker data-bind=\"value:start\"><div class=\"k-edit-label\"><label>Ώρα:</label></div><input name=\"start\" id=\"startTime\" class=\"half-width pull-right\" kendo-time-picker data-bind=\"value:start\" k-format=\"\'HH:mm\'\"><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><input type=\"number\" class=\"k-input pull-right\" name=\"duration\" data-bind=\"value:durationTime\"><div id=\"sector_object\" ng-show=\"vm.currentCustomer\"><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><select name=\"sector_id\" id=\"sector\" kendo-combo-box k-ng-model=\"eventCustomerSector.customerSector\" data-bind=\"value:eventCustomerSector.customerSector.id\" k-options=\"vm.sectorComboBoxOptions\"></select></div></div><div ng-show=\"!vm.isSchedule || vm.currentCustomer.id != vm.selectedUserId\" class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'dd/MM/yyyy\')#</span></span><div class=\"k-edit-label\"><label>Ώρα:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'HH:mm\')#</span></span><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: durationTime#</span></span><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentSector.name}}</span></span></div></div></div></div>");
$templateCache.put("app/displays/adminCustomers/medReports/medReports.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"customerMedReportsWithLines\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerMedReportsWithLines\')}\"><i class=\"material-icons\">table_chart</i>Διαχείριση Reports</li><li ui-sref=\"customerMedReportsSumsPerMonth\" ng-class=\"{\'k-state-active\': vm.$state.is(\'customerMedReportsSumsPerMonth\')}\"><i class=\"material-icons\">table_chart</i>Σύνολα φαρμακων ανά μήνα</li></ul></div><div ui-view></div></form></div></div>");
$templateCache.put("app/displays/adminCustomers/sectors/sectors.html","<kendo-grid id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\"><!--<div k-detail-template id=\"detailedGridOptions\">\n        <div kendo-tab-strip=\"tabs\" k-content-urls=\"[ null, null]\">\n            <ul>\n                <li class=\"k-state-active\">Ωράριο Εργασίας</li>\n            </ul>\n            <div>\n                <div id = \"workingHoursGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div>\n            </div>\n        </div>\n    </div>--></kendo-grid><div id=\"customSectorWindow\"></div><div id=\"popup-new-customSector\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\" k-options=\"vm.windowOptions\" k-options=\"vm.windowOptions\" k-on-close=\"vm.$state.go(\'customerSectors\', {id: vm.selectedUserId});\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div ui-view></div></div></div><div class=\"window-footer\"><md-button ng-if=\"vm.$state.includes(\'employeesAssignation\')\" class=\"md-raised\" ui-sref=\"customerSectorAssignation\"><md-icon class=\"arrow-left-dark\"></md-icon>Προηγούμενο</md-button></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/adminEmployees/agreements/agreements.html","<div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersAgreements\"></div><kendo-grid id=\"agreementsGrid\" options=\"vm.agreementsGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminCustomers/schedulesGrid/schedulesGrid.html","<kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminEmployees/beautyCenters/beautyCenters.html","<div selectable-grid kendo-grid id=\"sectorsGrid\" k-options=\"vm.sectorGrid.options\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div><div id=\"popup-sector\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"employee-assign\"><h5>Ανάθεση Κέντρων Αισθητικής</h5><div selectable-grid kendo-grid id=\"customerSectorSuggestGrid\" k-options=\"vm.customerSectorSuggestGrid.options\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div></div></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closeWindow()\">Ακύρωση</button> <button type=\"button\" class=\"k-primary k-button\" ng-click=\"vm.saveSectors()\">Αποθήκευση</button></div></div>");
$templateCache.put("app/displays/adminEmployees/customerSectors/customerSectors.html","<div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"customers-all\"></div>");
$templateCache.put("app/displays/adminEmployees/employeeInfo/info.html","<section class=\"well\"><div id=\"employeeFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"first-name\" name=\"first_name\" value=\"{{vm.user.firstName}}\" ng-model=\"vm.user.firstName\" class=\"k-textbox info\" placeholder=\"Όνομα\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του ιατρικού επισκέπτη.\" ng-disabled=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"last_name\" name=\"last_name\" value=\"{{vm.user.lastName}}\" ng-model=\"vm.user.lastName\" class=\"k-textbox info\" placeholder=\"Επώνυμο\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του ιατρικού επισκέπτη.\" ng-disabled=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"email\" id=\"email\" name=\"email\" value=\"{{vm.user.email}}\" ng-model=\"vm.user.email\" class=\"k-textbox info\" placeholder=\"example@example.gr\" data-email-msg=\"Το email δεν είναι έγκυρο\" ng-disabled=\"!vm.canEdit\"> <span class=\"k-invalid-msg\" data-for=\"email\"></span></div></div></div><div class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.employee.phone}}\" ng-model=\"vm.employee.phone\" class=\"k-textbox info\" pattern=\"\\d{10}\" data-pattern-msg=\"Το τηλέφωνο θα πρέπει να περιέχει 10 ψηφία\" placeholder=\"Σταθερό Τηλέφωνο\" ng-disabled=\"!vm.canEdit\"> <span class=\"k-invalid-msg\" data-for=\"phone\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Περιοχή:</label><div class=\"col-sm-8 col-md-6\"><select id=\"district\" name=\"district\" kendo-combo-box k-ng-model=\"vm.employee.district\" k-options=\"vm.districtComboBoxOptions\" data-custom=\"#district\" ng-disabled=\"!vm.canEdit\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"district\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4 employee\">Προϊστάμενος:</label><div class=\"col-sm-8 col-md-6\"><select id=\"supervisor\" name=\"supervisor\" kendo-combo-box ng-model=\"vm.employee.supervisor.name\" k-ng-model=\"vm.employee.supervisor.id\" k-options=\"vm.employeesComboBoxOptions\" data-custom=\"#supervisor\" ng-disabled=\"!vm.canEdit\" class=\"col-fix\"></select><span class=\"k-invalid-msg\" data-for=\"supervisor\"></span></div></div></div><div class=\"clearfix\"></div><div ng-if=\"vm.canEdit\" class=\"buttons-wrap\"><input id=\"update-second\" type=\"button\" class=\"k-button k-state-default update k-primary\" ng-click=\"vm.updateEmployee()\" value=\"Αποθήκευση\"></div></section>");
$templateCache.put("app/displays/adminEmployees/events/events.html","<div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"eventsGrid\" options=\"vm.eventsGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminEmployees/info/info.html","<div layout=\"row\"><!-- Employee frame --><div flex=\"50\"><form id=\"employeeForm\"><fieldset style=\"padding: 1em; border:1px solid #469AD4\"><legend style=\"border-bottom: 0; width: 24%; padding-left: 4px; padding-right: 4px\">Πληροφορίες Ιατρικού Επισκέπτη</legend><div layout=\"row\" layout-wrap=\"\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.employee.phone}}\" ng-model=\"vm.employee.phone\" class=\"k-textbox\" pattern=\"\\d{10}\" data-pattern-msg=\"Το τηλέφωνο θα πρέπει να περιέχει 10 ψηφία\" style=\"width: 100%\" placeholder=\"Τηλέφωνο\" ng-disabled=\"!vm.canEdit\"> <span class=\"k-invalid-msg\" data-for=\"phone\"></span></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Περιοχή:</label></div><div flex=\"60\"><select id=\"district\" name=\"district\" kendo-combo-box k-ng-model=\"vm.employee.district\" k-options=\"vm.districtComboBoxOptions\" data-custom=\"#district\" ng-disabled=\"!vm.canEdit\" style=\"width: 100%\"></select><span class=\"k-invalid-msg\" data-for=\"district\"></span></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Προϊστάμενος:</label></div><div flex=\"60\"><select id=\"supervisor\" name=\"supervisor\" kendo-combo-box k-ng-model=\"vm.employee.supervisor.id\" k-options=\"vm.employeesComboBoxOptions\" data-custom=\"#supervisor\" ng-disabled=\"!vm.canEdit\" style=\"width: 100%\"></select><span class=\"k-invalid-msg\" data-for=\"supervisor\"></span></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κατηγορίες Προϊόντων:</label></div><div flex=\"60\"><select kendo-multi-select multiple=\"multiple\" k-options=\"vm.productCategoriesOptions\" k-ng-model=\"vm.employee.productCategories\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-if=\"vm.hasModulePurchasePharmacies\"><div flex=\"40\"><label>Σειρές Αρίθμησης:</label></div><div flex=\"60\"><select kendo-multi-select multiple=\"multiple\" k-options=\"vm.purchaseNumberingRowsOptions\" k-ng-model=\"vm.employee.purchaseNumberingRows\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κωδικός:</label></div><div flex=\"60\"><input type=\"text\" id=\"code\" name=\"code\" value=\"{{vm.employee.code}}\" ng-model=\"vm.employee.code\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Κωδικός\" ng-disabled=\"!vm.canEdit\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label style=\"color: grey\">GeoData:</label></div><div flex=\"60\"><md-checkbox id=\"geoData\" class=\"customers green inline\" aria-label=\"selectable\" ng-model=\"vm.employee.geodata\" ng-disabled=\"true\" readonly=\"readonly\"></md-checkbox></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label style=\"color: grey\">Mobile Έκδοση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox readonly col-fix pull-left\" ng-model=\"vm.employee.mobileVersion\" data-bind=\"vm.employee.mobileVersion\" style=\"width: 100%\" readonly=\"readonly\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label style=\"color: grey\">Συσκευή:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox readonly col-fix pull-left\" ng-model=\"vm.employee.device\" data-bind=\"vm.employee.device\" style=\"width: 100%\" readonly=\"readonly\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label ng-click=\"vm.onOsVersionInfoClick();\" style=\"color: grey\">Έκδοση Android:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox readonly col-fix pull-left\" ng-model=\"vm.employee.osVersion\" data-bind=\"vm.employee.osVersion\" style=\"width: 100%\" readonly=\"readonly\"></div></div><div style=\"margin-top: 20px\"><input type=\"button\" class=\"k-button k-state-default update k-primary\" ng-click=\"vm.updateEmployee()\" ng-if=\"vm.canEdit\" value=\"Αποθήκευση\" style=\"float: right!important\"></div></fieldset></form></div><!-- User frame --><div flex=\"50\"><form id=\"userForm\" style=\"margin-left: 8px\"><fieldset style=\"padding: 1em; border:1px solid #469AD4\"><legend style=\"border-bottom: 0; width: 24%; padding-left: 4px; padding-right: 4px\">Πληροφορίες Χρήστη</legend><div layout=\"row\" layout-wrap=\"\"><div flex=\"40\"><label>Επώνυμο:</label></div><div flex=\"60\"><input id=\"last-name\" name=\"last-name\" value=\"{{vm.employee.account.firstName}}\" ng-model=\"vm.employee.account.lastName\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Επώνυμο\" required data-required-msg=\"Παρακαλούμε εισάγετε το Επώνυμο του Χρήστη.\" ng-disabled=\"!vm.canEdit\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα:</label></div><div flex=\"60\"><input id=\"first-name\" name=\"first_name\" value=\"{{vm.employee.account.firstName}}\" ng-model=\"vm.employee.account.firstName\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Όνομα\" required data-required-msg=\"Παρακαλούμε εισάγετε το Όνομα του Χρήστη.\" ng-disabled=\"!vm.canEdit\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label style=\"color: grey\">Όνομα Σύνδεσης:</label></div><div flex=\"60\"><input id=\"login\" name=\"login\" value=\"{{vm.employee.account.login}}\" ng-model=\"vm.employee.account.login\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Όνομα Σύνδεσης\" required data-required-msg=\"Παρακαλούμε εισάγετε το Όνομα Σύνδεσης του Χρήστη.\" ng-disabled=\"true\" readonly=\"readonly\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Email:</label></div><div flex=\"60\"><input id=\"email\" name=\"email\" value=\"{{vm.employee.account.email}}\" ng-model=\"vm.employee.account.email\" class=\"k-textbox\" style=\"width: 100%\" placeholder=\"Email\" required data-required-msg=\"Παρακαλούμε εισάγετε το Email του Χρήστη.\" ng-disabled=\"!vm.canEdit\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ενεργός:</label></div><div flex=\"60\"><md-checkbox id=\"active\" class=\"customers green inline\" aria-label=\"selectable\" ng-model=\"vm.employee.account.activated\" ng-disabled=\"!vm.canEdit\"></md-checkbox></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ρόλοι:</label></div><div flex=\"60\"><select kendo-multi-select k-options=\"vm.authoritiesOptions\" k-ng-model=\"vm.employee.account.authorities\" disabled=\"disabled\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px; height: 29px\"><!-- exist for uniformity --></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px; height: 29px\"><!-- exist for uniformity --></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px; height: 29px\"><!-- exist for uniformity --></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px; height: 29px\" ng-if=\"vm.hasModulePurchasePharmacies\"><!-- exist for uniformity --></div><div style=\"margin-top: 20px\"><input type=\"button\" class=\"k-button k-state-default update k-primary\" ng-click=\"vm.updateUser()\" ng-if=\"vm.canEdit\" value=\"Αποθήκευση\" style=\"float: right!important\"></div></fieldset></form></div></div>");
$templateCache.put("app/displays/adminEmployees/medReports/medReports.html","<div class=\"entity-view clearfix\"><div id=\"employee\"><form id=\"form\" name=\"form\"><!--            <div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\">--><!--                <ul>--><!--                    <li ui-sref=\"employeeMedReportsWithLines\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeMedReportsWithLines\')}\">--><!--                        <i class=\"material-icons\">table_chart</i>Αναφορά με γραμμές φαρμάκων</li>--><!--                    <li ui-sref=\"employeeMedReportsSumsPerMonth\" ng-class=\"{\'k-state-active\': vm.$state.is(\'employeeMedReportsSumsPerMonth\')}\">--><!--                        <i class=\"material-icons\">table_chart</i>Σύνολα επαγγελματιών υγείας ανά μήνα</li>--><!--                </ul>--><!--            </div>--><div ui-view></div></form></div></div>");
$templateCache.put("app/displays/adminEmployees/patchReports/patchReports.html","<ul class=\"nav nav-pills nav-stacked sub-nav-custom custom-nav-pills\"><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"employeePatchReports.pending\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">update</i>Προς Έγκριση</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"employeePatchReports.pendingHistory\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">history</i>Ιστορικό</md-button></li></ul><div style=\"padding: 1em\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\" class=\"patches-toolbar\"></div><div ui-view></div></div>");
$templateCache.put("app/displays/adminEmployees/sectors/sectors.html","<div selectable-grid kendo-grid id=\"customerSectorsGrid\" k-options=\"vm.customerSectorGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div><div id=\"popup-customer-sector\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"employee-assign\"><h5>Ανάθεση Μονάδων Υγείας</h5><label>My Target:</label><md-checkbox aria-label=\"myTarget\" ng-checked=\"vm.myTarget\" ng-click=\"vm.myTarget=!vm.myTarget\" class=\"checkbox-toolbar green\"></md-checkbox><div selectable-grid kendo-grid id=\"customerSectorSuggestGrid\" k-options=\"vm.customerSectorSuggestGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div></div></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closeWindow()\">Ακύρωση</button> <button type=\"button\" class=\"k-primary k-button\" ng-click=\"vm.saveCustomerSectors()\">Αποθήκευση</button></div></div>");
$templateCache.put("app/displays/adminEmployees/schedules/schedules.html","<kendo-grid id=\"schedulesGrid\" options=\"vm.schedulesGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminEmployees/pharmacies/pharmacies.html","<div selectable-grid kendo-grid id=\"sectorsGrid\" k-options=\"vm.sectorGrid.options\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div><div id=\"popup-sector\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"true\" style=\"max-height: 800px\"><div id=\"window\" class=\"middle\"><div selectable-grid kendo-grid id=\"customerSectorSuggestGrid\" k-options=\"vm.customerSectorSuggestGrid.options\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\" style=\"height: 700px\"></div><div class=\"window-footer\" style=\"padding-top: 10px\" ng-show=\"!vm.showProgress\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closeWindow()\">Ακύρωση</button> <button type=\"button\" class=\"k-primary k-button\" ng-click=\"vm.saveSectors()\">Αποθήκευση</button></div><div class=\"window-footer\" style=\"padding-top: 10px\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular></div></div></div><!--<div id=\"popup-sector\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" style=\"max-height: 400px;\">\n    <div class=\"box\">\n        <div id=\"popup_editor\" type=\"text/x-kendo-template\">\n            <div class=\"employee-assign\">\n                <h5>Ανάθεση Φαρμακείων</h5>\n                <div selectable-grid kendo-grid id = \"customerSectorSuggestGrid\" k-options=\"vm.customerSectorSuggestGrid.options\"\n                     k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"window-footer\">\n        <button type=\"button\" class=\"k-button\" ng-click = \"vm.closeWindow()\">Ακύρωση</button>\n        <button type=\"button\" class=\"k-primary k-button\" ng-click = \"vm.saveSectors()\">Αποθήκευση</button>\n    </div>\n</div>-->");
$templateCache.put("app/displays/adminEmployees/purchases/purchases.html","<kendo-grid id=\"purchasesGrid\" options=\"vm.purchasesGridOptions\" k-on-change=\"vm.onPurchasesSelection(data)\" k-ng-delay=\"vm.purchasesGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminIndex/adminAgreementsAll/adminAgreementsAll.html","<div favourite-filters-title-card></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/adminCustomersAll/adminCustomersAll.html","<div favourite-filters-title-card></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"customers-all\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/adminCustomerProductsAll/adminCustomerProductsAll.html","<div favourite-filters-title-card></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/adminEmployeesAll/adminEmployeesAll.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"employees-all\"></kendo-grid>");
$templateCache.put("app/displays/adminIndex/adminCustomerSectorsAll/adminCustomerSectorsAll.html","<div favourite-filters-title-card></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"customers-all\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/adminEmployeeVisitsAll/adminEmployeeVisitsAll.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading}}</span></h2></div></md-toolbar><div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><kendo-grid id=\"mainGrid\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"padding-top: 40px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/adminEventsAll/adminEventsAll.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"events-all\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/followUpAll/followUpAll.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\" ng-style=\"{width: vm.contentWidth + \'px\', height: vm.contentHeight + \'px\'}\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/adminEventsOther/adminEventsOther.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"events-other\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsComparisonReport/hospitalizationsComparisonReport.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminIndex/hospitalizationsAll/hospitalizationsAll.html","<div favourite-filters-title-card></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" k-options=\"vm.mainGridOptions\" class=\"hospitalizations-all\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsAggregated/hospitalizationsAggregated.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-trending_up-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"hospitalizationsAggregatedPerSector\" ng-class=\"{\'k-state-active\': vm.$state.is(\'hospitalizationsAggregatedPerSector\')}\"><i class=\"material-icons\">table_chart</i>Ανά Νοσοκομείο</li><li ui-sref=\"hospitalizationsAggregatedPerDoctor\" ng-class=\"{\'k-state-active\': vm.$state.is(\'hospitalizationsAggregatedPerDoctor\')}\"><i class=\"material-icons\">table_chart</i>Ανά Επαγγελματία Υγείας</li><li ui-sref=\"hospitalizationsAggregatedPerClinic\" ng-class=\"{\'k-state-active\': vm.$state.is(\'hospitalizationsAggregatedPerClinic\')}\"><i class=\"material-icons\">table_chart</i>Ανά Κλινική</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsReport/hospitalizationsReport.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/leadCallsAggregated.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-trending_up-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"leadCallsAggregatedPerUser\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedPerUser\')}\"><i class=\"material-icons\">pie_chart</i>Ενημερώσεις Ανά Χρήστη</li><li ui-sref=\"leadCallsAggregatedPerDisease\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedPerDisease\')}\"><i class=\"material-icons\">bar_chart</i>Ενημερώσεις Ανά Πάθηση</li><li ui-sref=\"leadCallsAggregatedPerAgeGroup\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedPerAgeGroup\')}\"><i class=\"material-icons\">pie_chart</i>Ενημερώσεις Ανά Ηλικία</li><li ui-sref=\"leadCallsAggregatedPerParentHospitalizationType\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedPerParentHospitalizationType\')}\"><i class=\"material-icons\">pie_chart</i>Ενημερώσεις Ανά Είδος Ασφάλισης</li><li ui-sref=\"leadCallsAggregatedHeldFollowUp\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedHeldFollowUp\')}\"><i class=\"material-icons\">pie_chart</i>Ενημερώσεις με/χωρίς FollowUp</li><li ui-sref=\"leadCallsAggregatedHeldFollowUpRejectionReasons\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadCallsAggregatedHeldFollowUpRejectionReasons\')}\"><i class=\"material-icons\">bar_chart</i>Λόγοι Απόρριψης</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div></div>");
$templateCache.put("app/displays/adminIndex/leadManagementAggregated/leadManagementAggregated.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-trending_up-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"leadManagementAggregatedGrid\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadManagementAggregatedGrid\')}\"><i class=\"material-icons\">table_chart</i>Πίνακας</li><li ui-sref=\"leadManagementAggregatedPie\" ng-class=\"{\'k-state-active\': vm.$state.is(\'leadManagementAggregatedPie\')}\"><i class=\"material-icons\">pie_chart</i>Πίτα</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div></div>");
$templateCache.put("app/displays/adminIndex/leadHospitalizationDiseasesAll/leadHospitalizationDiseasesAll.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\" ng-style=\"{width: vm.contentWidth + \'px\', height: vm.contentHeight + \'px\'}\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/leadManagementAll/leadManagementAll.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\" ng-style=\"{width: vm.contentWidth + \'px\', height: vm.contentHeight + \'px\'}\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/medReport/medReport.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><!--            <div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\">--><!--                <ul>--><!--                    <li ui-sref=\"medReportsWithLines\" ng-class=\"{\'k-state-active\': vm.$state.is(\'medReportsWithLines\')}\">--><!--                        <i class=\"material-icons\">table_chart</i>Αναφορά με γραμμές φαρμάκων</li>--><!--                    <li ui-sref=\"medReportsSumsPerMonth\" ng-class=\"{\'k-state-active\': vm.$state.is(\'medReportsSumsPerMonth\')}\">--><!--                        <i class=\"material-icons\">table_chart</i>Σύνολα ανά Επαγγελματία Υγείας ανά Φάρμακο</li>--><!--                </ul>--><!--            </div>--><div ui-view></div></form></div></div>");
$templateCache.put("app/displays/adminIndex/patchReportsAll/patchReportsAll.html","<md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-find_in_page-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><h4 class=\"no-span\" style=\"width: 98.5%\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\" style=\"width: 100%\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" ng-style=\"{height: vm.contentHeight + \'px\'}\"></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/purchasesAggregated.html","<div class=\"entity-view clearfix\"><div id=\"customer\"><form id=\"form\" name=\"form\"><md-toolbar class=\"md-hue-1\" style=\"background-color: #0074BC\"><div layout=\"row\"><md-toolbar-filler layout=\"row\" layout-align=\"center center\" style=\"background-color: #469AD4\"><md-icon id=\"filler-icon\" md-svg-icon=\"content/images/baseline-trending_up-24px.svg\"></md-icon></md-toolbar-filler><h2 class=\"md-toolbar-tools\"><span>{{vm.pageHeading.toUpperCase()}}</span></h2></div></md-toolbar><div kendo-tab-strip id=\"tabstrip2\" k-content-urls=\"[ null, null]\"><ul><li ui-sref=\"purchasesAggregatedPerEmployee\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasesAggregatedPerEmployee\')}\"><i class=\"material-icons\">assignment_ind</i>Σύνολα ανά Ιατρικό Επισκέπτη</li><li ui-sref=\"purchasesAggregatedPerEmployeeComparative\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasesAggregatedPerEmployeeComparative\')}\"><i class=\"material-icons\">table_chart</i>Συγκριτικό ανά Ιατρικό Επισκέπτη</li><li ui-sref=\"purchasesAggregatedPerSector\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasesAggregatedPerSector\')}\"><i class=\"material-icons\">business</i>Τζίρος ανά Επαγγελματία Υγείας</li><li ui-sref=\"purchasesAggregatedPerProduct\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasesAggregatedPerProduct\')}\"><i class=\"material-icons\">shopping_basket</i>Τζίρος ανά Είδος</li><li ui-sref=\"purchasesPerEmployeeSectorProduct\" ng-class=\"{\'k-state-active\': vm.$state.is(\'purchasesPerEmployeeSectorProduct\')}\"><i class=\"material-icons\">assessment</i>Τζίρος ανά Ιατρικό Επισκέπτη / Επαγγελματία Υγείας / Είδος</li></ul></div><div style=\"padding: 1em\"><div ui-view></div></div></form></div></div>");
$templateCache.put("app/displays/adminIndex/schedulesAll/schedulesAll.html","<div favourite-filters-title-md-toolbar=\"\"></div><h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><hr class=\"color-line\"><main><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\" ng-style=\"{width: vm.contentWidth + \'px\', height: vm.contentHeight + \'px\'}\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/purchasesReport/purchasesReport.html","<div favourite-filters-title-md-toolbar=\"\"></div><!--<h4 class=\"no-span\">Φίλτρα Αναζήτησης</h4>--><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><!--<hr class=\"color-line\">--><main ng-style=\"{height: vm.contentHeight + \'px\'}\"><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminPharmacies/customers/customers.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"customerSectorGrid\" options=\"vm.gridOptions.customerSector\"></kendo-grid><div id=\"popup-customer\" kendo-window=\"modalWindow\" k-options=\"vm.modalWindowOptions\"><ul class=\"fieldlist\"><li><label for=\"firstName\">Όνομα :</label><input id=\"firstName\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.firstName\"></li><li><label for=\"lastName\">Επίθετο :</label><input id=\"lastName\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.lastName\"></li><li><label for=\"amka\">Α.Μ.Κ.Α. :</label><input id=\"amka\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.amka\"></li><li><label for=\"cellPhone\">Κινητό :</label><input id=\"cellPhone\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.cellPhone\"></li><li><label for=\"phone\">Τηλέφωνο :</label><input id=\"phone\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.phone\"></li><li><label for=\"email\">Email :</label><input id=\"email\" type=\"text\" class=\"k-textbox\" ng-model=\"vm.editableItem.customer.email\"></li><li><label for=\"startedAt\">Από :</label><input id=\"startedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.editableItem.startedAt\"></li><li><label for=\"endedAt\">Εώς :</label><input id=\"endedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.editableItem.endedAt\"></li><li><label for=\"customerType\">Θέση στο φαρμακείο :</label><select id=\"customerType\" kendo-multi-select k-options=\"vm.options.customerTypes\" k-ng-model=\"vm.selectedCustomerTypes\"></select></li><li><button class=\"k-button\" ng-click=\"vm.closeModalWindow()\">Ακύρωση</button>&nbsp; <button class=\"k-button k-primary\" ng-click=\"vm.save()\">Αποθήκευση</button></li></ul><style>.fieldlist {\n            margin: 0 0 -2em;\n            padding: 0;\n        }\n\n        .fieldlist li {\n            list-style: none;\n            padding-bottom: 2em;\n        }\n\n        .fieldlist label {\n            display: block;\n            padding-bottom: 1em;\n            font-weight: bold;\n            text-transform: uppercase;\n            font-size: 12px;\n            color: #444;\n        }\n\n        .fieldlist input {\n            width: 100%;\n        }</style></div>");
$templateCache.put("app/displays/adminPharmacies/events/events.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"eventsGrid\" options=\"vm.gridOptions.events\"></kendo-grid>");
$templateCache.put("app/displays/adminPharmacies/employees/employees.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"employeesGrid\" options=\"vm.gridOptions.employee\"></kendo-grid><div id=\"popup-employee-customer-sector\" kendo-window=\"modalWindow\" k-options=\"vm.modalWindowOptions\"><ul class=\"fieldlist\"><li><label for=\"employees\">Επιλέξτε ιατρικό επισκέπτη/τες :</label><select id=\"employees\" kendo-multi-select k-options=\"vm.options.employees\" k-ng-model=\"vm.selectedEmployeeCustomerSectors\"></select></li><li><button class=\"k-button\" ng-click=\"vm.closeModalWindow()\">Ακύρωση</button>&nbsp; <button class=\"k-button k-primary\" ng-click=\"vm.add()\">Αποθήκευση</button></li></ul><style>.fieldlist {\n            margin: 0 0 -2em;\n            padding: 0;\n        }\n\n        .fieldlist li {\n            list-style: none;\n            padding-bottom: 2em;\n        }\n\n        .fieldlist label {\n            display: block;\n            padding-bottom: 1em;\n            font-weight: bold;\n            text-transform: uppercase;\n            font-size: 12px;\n            color: #444;\n        }\n\n        .fieldlist input {\n            width: 100%;\n        }</style></div>");
$templateCache.put("app/displays/adminPharmacies/purchases/purchases.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchasesGrid\" options=\"vm.purchasesGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.purchasesGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/adminPharmacies/info/info.html","<section kendo-validator=\"vm.validator\"><div layout=\"row\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div flex=\"30\" style=\"padding-left: 5%; padding-top: 2%\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κωδικός Ε.Ε.:</label></div><div flex=\"60\"><input id=\"code\" name=\"code\" value=\"{{vm.sector.code}}\" ng-model=\"vm.sector.code\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Κωδικός\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Επωνυμία:</label></div><div flex=\"60\"><input id=\"vat\" name=\"vat\" value=\"{{vm.sector.vat}}\" ng-model=\"vm.sector.vat\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Α.Φ.Μ.\" required data-required-msg=\"Παρακαλούμε εισάγετε το Α.Φ.Μ. του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Α.Φ.Μ.:</label></div><div flex=\"60\"><input id=\"vat\" name=\"vat\" value=\"{{vm.sector.vat}}\" ng-model=\"vm.sector.vat\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Α.Φ.Μ.\" required data-required-msg=\"Παρακαλούμε εισάγετε το Α.Φ.Μ. του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τύπος εταιρίας:</label></div><div flex=\"60\"><select id=\"companyType\" name=\"companyType\" kendo-combo-box k-ng-model=\"vm.sector.companyType.id\" ng-readonly=\"!vm.canEdit\" k-options=\"vm.dropDownOptions.companyType\" class=\"col-fix\" data-custom=\"#companyType\" style=\"width: 90%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input id=\"brick\" name=\"brick\" value=\"{{vm.sector.brick}}\" ng-model=\"vm.sector.brick\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Brick\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brice ΟΦΣΕ:</label></div><div flex=\"60\"><input id=\"osfeBrick\" name=\"osfeBrick\" value=\"{{vm.sector.osfeBrick}}\" ng-model=\"vm.sector.osfeBrick\" class=\"k-textbox info\" placeholder=\"Brick ΟΦΣΕ\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλεφωνο:</label></div><div flex=\"60\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.sector.phone}}\" ng-model=\"vm.sector.phone\" class=\"k-textbox info\" placeholder=\"Τηλέφωνο\" ng-readonly=\"!vm.canEdit\" required data-required-msg=\"Παρακαλούμε εισάγετε το τηλέφωνο του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλεφωνο 2:</label></div><div flex=\"60\"><input type=\"tel\" id=\"phone2\" name=\"phone2\" value=\"{{vm.sector.phone2}}\" ng-model=\"vm.sector.phone2\" class=\"k-textbox info\" placeholder=\"Τηλεφωνο 2\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Καθεστώς Φ.Π.Α.:</label></div><div flex=\"60\"><select id=\"taxStatus\" name=\"taxStatus\" kendo-combo-box k-ng-model=\"vm.sector.taxStatus.id\" ng-readonly=\"!vm.canEdit\" k-options=\"vm.dropDownOptions.taxStatus\" class=\"col-fix\" data-custom=\"#taxStatus\" required style=\"width: 90%\"></select></div></div></div><div flex=\"30\" style=\"padding-left: 5%\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"!vm.geodata\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><select id=\"prefectures\" name=\"prefecture\" kendo-combo-box k-ng-model=\"vm.sector.prefecture\" k-options=\"vm.prefecturesComboBoxOptions\" class=\"col-fix\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"!vm.geodata\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><select id=\"cities\" name=\"city\" kendo-combo-box k-ng-model=\"vm.sector.city\" k-options=\"vm.citiesComboBoxOptions\" class=\"col-fix\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></select></div></div><div style=\"width: 100%\" ng-if=\"vm.canEdit\" ng-show=\"vm.geodata\"><input id=\"masterFilter\" style=\"width: 100%\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\"></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.geodata\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectureName\" name=\"prefectureName\" type=\"text\" ng-model=\"vm.sector.prefectureName\" class=\"k-textbox info\" placeholder=\"Νομός\" ng-readonly=\"!vm.canEdit\" required data-required-msg=\"Παρακαλούμε εισάγετε τον Νομό του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.geodata\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cityName\" name=\"cityName\" type=\"text\" ng-model=\"vm.sector.cityName\" class=\"k-textbox info\" placeholder=\"Πόλη\" ng-readonly=\"!vm.canEdit\" required data-required-msg=\"Παρακαλούμε εισάγετε τη Πόλη του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input id=\"address\" name=\"address\" type=\"text\" ng-model=\"vm.sector.address\" class=\"k-textbox info\" placeholder=\"Διεύθυνση\" ng-readonly=\"!vm.canEdit\" required data-required-msg=\"Παρακαλούμε εισάγετε τη Διεύθυνση του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input id=\"postalCode\" name=\"postalCode\" type=\"text\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" ng-model=\"vm.sector.postalCode\" class=\"k-textbox info\" placeholder=\"Τ.Κ.\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input id=\"addressNum\" name=\"addressNum\" type=\"text\" ng-model=\"vm.sector.addressNum\" class=\"k-textbox info\" placeholder=\"Αριθμός\" ng-readonly=\"!vm.canEdit\" required data-required-msg=\"Παρακαλούμε εισάγετε τον Αριθμό Διεύθυνσης του Φαρμακείου\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πιστωτικός Έλεγχος:</label></div><div flex=\"60\"><md-checkbox aria-label=\"creditControlCheck\" ng-model=\"vm.sector.creditControlCheck\" class=\"checkbox-toolbar green inline\" ng-readonly=\"!vm.canEdit\" style=\"width: 90%\"></md-checkbox></div></div></div><div flex=\"30\" style=\"padding-left: 5%; padding-top: 2%\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Δευτέρα:</label></div><div flex=\"60\"><select id=\"wh-monday\" name=\"wh-monday\" kendo-combo-box k-ng-model=\"vm.sector.monday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 90%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τρίτη:</label></div><div flex=\"60\"><select id=\"wh-tuesday\" name=\"wh-tuesday\" kendo-combo-box k-ng-model=\"vm.sector.tuesday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 90%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τετάρτη:</label></div><div flex=\"60\"><select id=\"wh-wednesday\" name=\"wh-wednesday\" kendo-combo-box k-ng-model=\"vm.sector.wednesday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 90%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πέμπτη:</label></div><div flex=\"60\"><select id=\"wh-thursday\" name=\"wh-thursday\" kendo-combo-box k-ng-model=\"vm.sector.thursday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 90%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Παρασκευή:</label></div><div flex=\"60\"><select id=\"wh-friday\" name=\"wh-friday\" kendo-combo-box k-ng-model=\"vm.sector.friday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 90%\"><!-- data-custom=\"#companyType\" --></select></div></div></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span><div class=\"buttons-wrap\" ng-show=\"vm.canEdit\"><input id=\"update-first\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.save()\" value=\"Αποθήκευση\"></div></section>");
$templateCache.put("app/displays/adminPatchReports/cancelled/cancelled.html","<kendo-grid id=\"patchReportGrid2\" options=\"vm.canceledGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.detailGridsService.getPatchReportPhotosGridOptions(dataItem, vm.gridColumns)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div>");
$templateCache.put("app/displays/adminPatchReports/pending/pending.html","<div kendo-grid=\"vm.pendingGrid\" id=\"patchReportGrid2\" options=\"vm.pendingGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.detailGridsService.getPatchReportPhotosGridOptions(dataItem, vm.gridColumns)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></div><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/jpeg;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/adminPatchReports/partExecuted/partExecuted.html","<kendo-grid id=\"patchReportGrid2\" options=\"vm.partedExecutedGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.detailGridsService.getPatchReportPhotosGridOptions(dataItem, vm.gridColumns)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div>");
$templateCache.put("app/displays/adminPatchReports/pendingHistory/pendingHistory.html","<kendo-grid id=\"patchReportGrid2\" options=\"vm.pendingHistoryGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.detailGridsService.getPatchReportPhotosGridOptions(dataItem, vm.gridColumns)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div>");
$templateCache.put("app/displays/approvals/changedRecords/changedRecords.html","<ul class=\"nav nav-pills custom-nav-pills nav-stacked sub-nav-custom\"><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"approvals.changedRecords.pending\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">update</i>Προς Έγκριση</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"approvals.changedRecords.pendingHistory\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">history</i>Ιστορικό</md-button></li></ul><div style=\"padding: 1em\"><div ui-view></div></div>");
$templateCache.put("app/displays/approvals/newRecords/newRecords.html","<ul class=\"nav nav-pills custom-nav-pills nav-stacked sub-nav-custom\"><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"approvals.newRecords.pending\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">update</i>Προς Έγκριση</md-button></li><li ui-sref-active=\"active\" class=\"md-warn\"><md-button ui-sref=\"approvals.newRecords.pendingHistory\" class=\"md-raised md-button\" style=\"padding: 2%\"><i class=\"material-icons fixed-icons fixed-icons-2\">history</i>Ιστορικό</md-button></li></ul><div style=\"padding: 1em\"><div ui-view></div></div>");
$templateCache.put("app/displays/assignations/deletions/deletions.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\" class=\"customers-all\"></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/beautyCenters/employees/employees.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"employeesGrid\" options=\"vm.gridOptions.employee\"></kendo-grid><div id=\"popup-employee-customer-sector\" kendo-window=\"modalWindow\" k-options=\"vm.modalWindowOptions\"><ul class=\"fieldlist\"><li><label for=\"employees\">Επιλέξτε ιατρικό επισκέπτη/τες :</label><select id=\"employees\" kendo-multi-select k-options=\"vm.options.employees\" k-ng-model=\"vm.selectedEmployeeCustomerSectors\"></select></li><li><button class=\"k-button\" ng-click=\"vm.closeModalWindow()\">Ακύρωση</button>&nbsp; <button class=\"k-button k-primary\" ng-click=\"vm.add()\">Αποθήκευση</button></li></ul><style>.fieldlist {\n            margin: 0 0 -2em;\n            padding: 0;\n        }\n\n        .fieldlist li {\n            list-style: none;\n            padding-bottom: 2em;\n        }\n\n        .fieldlist label {\n            display: block;\n            padding-bottom: 1em;\n            font-weight: bold;\n            text-transform: uppercase;\n            font-size: 12px;\n            color: #444;\n        }\n\n        .fieldlist input {\n            width: 100%;\n        }</style></div>");
$templateCache.put("app/displays/beautyCenters/customers/customers.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"customerSectorGrid\" options=\"vm.gridOptions.customerSector\"></kendo-grid><div id=\"custom-popup\" kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div id=\"popup-customer\" type=\"text/x-kendo-template\"><div class=\"k-edit-form-container voffset3\"><div class=\"k-edit-label\"><label for=\"firstName\">Όνομα:</label></div><div data-container-for=\"firstName\" class=\"k-edit-field\"><input id=\"firstName\" class=\"k-textbox\" ng-model=\"dataItem.customer.firstName\"></div><div class=\"k-edit-label\"><label for=\"lastName\">Επίθετο:</label></div><div data-container-for=\"lastName\" class=\"k-edit-field\"><input id=\"lastName\" class=\"k-textbox\" ng-model=\"dataItem.customer.lastName\"></div><div class=\"k-edit-label\"><label for=\"amka\">Α.Μ.Κ.Α.:</label></div><div data-container-for=\"amka\" class=\"k-edit-field\"><input id=\"amka\" class=\"k-textbox\" ng-model=\"dataItem.customer.amka\"></div><div class=\"k-edit-label\"><label for=\"cellPhone\">Κινητό:</label></div><div data-container-for=\"cellPhone\" class=\"k-edit-field\"><input id=\"cellPhone\" class=\"k-textbox\" ng-model=\"dataItem.customer.cellPhone\"></div><div class=\"k-edit-label\"><label for=\"phone\">Τηλέφωνο:</label></div><div data-container-for=\"phone\" class=\"k-edit-field\"><input id=\"phone\" class=\"k-textbox\" ng-model=\"dataItem.customer.phone\"></div><div class=\"k-edit-label\"><label for=\"email\">Email:</label></div><div data-container-for=\"phone\" class=\"k-edit-field\"><input id=\"email\" class=\"k-textbox\" ng-model=\"dataItem.customer.email\"></div><div class=\"k-edit-label\"><label for=\"startedAt\">Από:</label></div><div data-container-for=\"startedAt\" class=\"k-edit-field\"><input id=\"startedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"dataItem.startedAt\"></div><div class=\"k-edit-label\"><label for=\"endedAt\">Εώς:</label></div><div data-container-for=\"endedAt\" class=\"k-edit-field\"><input id=\"endedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"dataItem.endedAt\"></div><div class=\"k-edit-label\"><label for=\"customerType\">Θέση στο κέντρο αισθητικής:</label></div><div data-container-for=\"customerType\" class=\"k-edit-field\"><input id=\"customerType\" kendo-multi-select k-options=\"vm.options.customerTypes\" k-ng-model=\"vm.customerTypes\" readonly=\"readonly\"></div><!--<div class=\"window-footer voffset5\">--><!--<md-button class=\"md-primary\" ng-click=\"vm.save()\"><md-icon ng-bind=\'\"save\"\'></md-icon>Αποθήκευση</md-button>--><!--<md-button ng-click=\"vm.closeModalWindow()\"><md-icon ng-bind=\'\"clear\"\'></md-icon>Ακύρωση</md-button>--><!--</div>--></div></div></div>");
$templateCache.put("app/displays/beautyCenters/events/events.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"eventsGrid\" options=\"vm.gridOptions.events\"></kendo-grid>");
$templateCache.put("app/displays/beautyCenters/info/info.html","<div style=\"padding: 1em\"><section id=\"sector-view\" class=\"well\"><div id=\"sectorFirst\" class=\"form-horizontal form-widgets col-sm-6\"><!-- vm.sector.name --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κωδικός Ε.Ε.:</label><div class=\"col-sm-8 col-md-6\"><input id=\"code\" name=\"code\" value=\"{{vm.sector.code}}\" ng-model=\"vm.sector.code\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Κωδικός\"></div></div><!-- vm.sector.name --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επωνυμία:</label><div class=\"col-sm-8 col-md-6\"><input id=\"name\" name=\"name\" value=\"{{vm.sector.name}}\" ng-model=\"vm.sector.name\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Όνομα\"></div></div><!-- vm.sector.vat --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Φ.Μ.:</label><div class=\"col-sm-8 col-md-6\"><input id=\"vat\" name=\"vat\" value=\"{{vm.sector.vat}}\" ng-model=\"vm.sector.vat\" class=\"k-textbox info\" ng-readonly=\"!vm.canEdit\" placeholder=\"Α.Φ.Μ.\"></div></div><!-- vm.sector.companyType --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος εταιρίας:</label><div class=\"col-sm-8 col-md-6 combobox\"><select id=\"companyType\" name=\"companyType\" kendo-combo-box k-ng-model=\"vm.sector.companyType.id\" ng-readonly=\"!vm.canEdit\" k-options=\"vm.dropDownOptions.companyType\" class=\"col-fix\" data-custom=\"#companyType\"></select></div></div><!-- vm.sector.phone --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλεφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.sector.phone}}\" ng-model=\"vm.sector.phone\" class=\"k-textbox info\" placeholder=\"Τηλέφωνο\" ng-readonly=\"!vm.canEdit\"></div></div><!-- vm.sector.phone2 --><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλεφωνο 2:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"phone2\" name=\"phone2\" value=\"{{vm.sector.phone2}}\" ng-model=\"vm.sector.phone2\" class=\"k-textbox info\" placeholder=\"Τηλεφωνο 2\" ng-readonly=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Καθεστώς Φ.Π.Α.:</label><div class=\"col-sm-8 col-md-6 combobox\"><select id=\"taxStatus\" name=\"taxStatus\" kendo-combo-box k-ng-model=\"vm.sector.taxStatus.id\" ng-readonly=\"!vm.canEdit\" k-options=\"vm.dropDownOptions.taxStatus\" class=\"col-fix\" data-custom=\"#taxStatus\"></select></div></div></div><div id=\"sectorSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div ng-show=\"!vm.geodata\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Νομός:</label><div class=\"col-sm-8 col-md-6 combobox\"><select id=\"prefectures\" name=\"prefecture\" kendo-combo-box k-ng-model=\"vm.sector.prefecture\" k-options=\"vm.prefecturesComboBoxOptions\" class=\"col-fix\" ng-readonly=\"!vm.canEdit\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Πόλη:</label><div class=\"col-sm-8 col-md-6 combobox\"><select id=\"cities\" name=\"city\" kendo-combo-box k-ng-model=\"vm.sector.city\" k-options=\"vm.citiesComboBoxOptions\" class=\"col-fix\" ng-readonly=\"!vm.canEdit\"></select></div></div></div><div ng-show=\"vm.geodata\"><div id=\"masterFilterGeodata\" ng-if=\"vm.canEdit\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\"></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Νομός:</label><div class=\"col-sm-8 col-md-6 combobox\"><input id=\"prefectureName\" name=\"prefectureName\" type=\"text\" ng-model=\"vm.sector.prefectureName\" class=\"k-textbox info\" placeholder=\"Νομός\" ng-readonly=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Πόλη:</label><div class=\"col-sm-8 col-md-6 combobox\"><input id=\"cityName\" name=\"cityName\" type=\"text\" ng-model=\"vm.sector.cityName\" class=\"k-textbox info\" placeholder=\"Πόλη\" ng-readonly=\"!vm.canEdit\"></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Διεύθυνση:</label><div class=\"col-sm-8 col-md-6\"><input id=\"address\" name=\"address\" type=\"text\" ng-model=\"vm.sector.address\" class=\"k-textbox info\" placeholder=\"Διεύθυνση\" ng-readonly=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τ.Κ.:</label><div class=\"col-sm-8 col-md-6\"><input id=\"postalCode\" name=\"postalCode\" type=\"text\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" ng-model=\"vm.sector.postalCode\" class=\"k-textbox info\" placeholder=\"Τ.Κ.\" ng-readonly=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Αριθμός:</label><div class=\"col-sm-8 col-md-6\"><input id=\"addressNum\" name=\"addressNum\" type=\"text\" ng-model=\"vm.sector.addressNum\" class=\"k-textbox info\" placeholder=\"Αριθμός\" ng-readonly=\"!vm.canEdit\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Πιστωτικός Έλεγχος:</label><div class=\"col-sm-8 col-md-6\"><md-checkbox aria-label=\"creditControlCheck\" ng-model=\"vm.sector.creditControlCheck\" class=\"checkbox-toolbar green inline\" ng-readonly=\"!vm.canEdit\"></md-checkbox></div></div></div><div class=\"clearfix\"></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n                <i class=\"material-icons fixed-icons\">assignment_late</i>\n                <h6>#= message #</h6>\n            </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n                <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n                <h6>#= message #</h6>\n            </div></script><span id=\"notification\" style=\"display:none\"></span><div class=\"buttons-wrap\" ng-show=\"vm.canEdit\"><input id=\"update-first\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.save()\" value=\"Αποθήκευση\"></div></section></div>");
$templateCache.put("app/displays/beautyCenters/purchases/purchases.html","<md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.pageHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchasesGrid\" options=\"vm.purchasesGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.purchasesGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/patients/hospitalization/hospitalization.html","<div style=\"padding: 1em\"><kendo-grid id=\"hospitalizationsGrid\" options=\"vm.hospitalizationsGridOptions\" k-ng-delay=\"vm.hospitalizationsGridOptions\"></kendo-grid></div>");
$templateCache.put("app/displays/patients/info/info.html","<div style=\"padding: 1em\"><section kendo-validator=\"vm.validator\" class=\"row\"><div id=\"firstSection\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"lastName\" name=\"lastName\" ng-model=\"vm.patient.lastName\" class=\"k-textbox info\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του ασθενή.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"firstName\" name=\"firstName\" ng-model=\"vm.patient.firstName\" class=\"k-textbox info\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του ασθενή.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Έτος Γέννηση:</label><div class=\"col-sm-8 col-md-6\"><input id=\"yearOfBirth\" kendo-date-picker k-options=\"vm.yearOfBirthOptions\" k-format=\"\'yyyy\'\" k-ng-model=\"vm.patient.yearOfBirth\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ηλικία:</label><div class=\"col-sm-8 col-md-6\"><input id=\"age\" kendo-numeric-text-box min=\"0\" k-ng-model=\"vm.patient.age\" k-format=\"\'n0\'\" k-options=\"vm.ageOptions\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Μ.Κ.Α:</label><div class=\"col-sm-8 col-md-6\"><input id=\"amka\" name=\"amka\" ng-model=\"vm.patient.amka\" class=\"k-textbox info\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλ. Επικοινωνίας:</label><div class=\"col-sm-8 col-md-6\"><input id=\"phone\" name=\"phone\" ng-model=\"vm.patient.phone\" class=\"k-textbox info\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email Επικοινωνίας:</label><div class=\"col-sm-8 col-md-6\"><input id=\"email\" name=\"phone\" ng-model=\"vm.patient.email\" class=\"k-textbox info\"></div></div></div><div id=\"secondSection\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σχόλια:</label><div class=\"col-sm-8 col-md-6\"><textarea id=\"notes2\" rows=\"8\" cols=\"150\" name=\"notes2\" ng-model=\"vm.patient.notes\" class=\"k-textbox info\"></textarea></div></div></div><div class=\"clearfix\"></div><div class=\"buttons-wrap\"><md-button class=\"md-raised md-mini md-primary pull-right\" aria-label=\"update\" ng-click=\"vm.update()\"><i class=\"material-icons fixed-icons fixed-icons-2\">save</i>Αποθήκευση</md-button></div></section></div>");
$templateCache.put("app/displays/patients/leadCalls/leadCalls.html","<!--\n<div layout=\"row\">\n    <div flex=\"20\" style=\"padding: 1em\">\n        <kendo-grid id=\"patientLeadCallsGrid\" k-on-change=\"vm.onSelection(data)\" options=\"vm.leadCallsGridOptions\" k-ng-delay=\"vm.leadCallsGridOptions\"></kendo-grid>\n    </div>\n    <div flex=\"80\">\n        <div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.showProgress\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n        <md-card layout=\"column\" ng-cloak class=\"md-inline-form\" ng-if=\"!vm.showProgress\">\n            <div id=\"hospitalization\" layout-padding ng-cloak>\n                <label ng-if=\"vm.selectedLeadCallId === null\"><i>Επιλέξτε κλήση από τη λίστα στα αριστερά</i></label>\n                <div id=\"leadCallForm\" ng-if=\"vm.selectedLeadCallId !== null\" name=\"leadCallForm\" ng-form>\n                    <div class=\"popup-info pull-left full-width\" style=\"padding: 1em\">\n                        <div class=\"k-edit-label\">\n                            <i class=\"material-icons label-icon\">today</i>\n                            <label style=\"font-size: small\">Ημερομηνία & Ώρα: </label>\n                        </div>\n                        <input name=\"dateIssue\" id=\"dateIssue\" class=\"pull-left margin-left-10\" kendo-date-picker\n                               k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.startDate\" onkeydown=\"return false\" readonly>\n                        <input name=\"start\" id=\"startTime\" kendo-time-picker class=\"pull-left margin-left-10\" onkeydown=\"return false\" readonly\n                               k-format=\"\'HH:mm\'\" data-bind=\"value:start\" k-ng-model=\"vm.startTime\"/>\n\n                        <div class=\"separator\"></div>\n\n                        <div class=\"k-edit-label\">\n                            <i class=\"material-icons label-icon\">phone</i>\n                            <label style=\"font-size: small\">Τύπος Κλήσης: </label>\n                        </div>\n                        <md-radio-group layout=\"row\" id=\"callType\" name=\"callType\" ng-model=\"vm.leadCall.callType\"\n                                        class=\"md-primary\" style=\"padding-left: 60px; padding-top: 5px;\">\n                            <md-radio-button ng-repeat=\"d in vm.callTypes\" ng-value=\"d\" id=\"{{\'mdRad\' + d.id}}\" ng-disabled=\"true\">{{ d.name }}</md-radio-button>\n                        </md-radio-group>\n\n                        <div class=\"separator\"></div>\n\n                        &lt;!&ndash; Prospective Patient &ndash;&gt;\n\n                        <div>\n                            <div class=\"k-edit-label\">\n                                <i class=\"material-icons label-icon\">accessibility_new</i>\n                                <label style=\"font-size: small\"> Πιθανός Ασθενής: </label>\n                            </div>\n                            <input name=\"prospectivePatient\" id=\"prospectivePatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\"\n                                   ng-model=\"vm.leadCall.prospectivePatient.fullName\" readonly/>\n                            <md-button ng-if=\"vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                       ng-click=\"vm.goTo(\'prospectivePatient\', vm.leadCall.prospectivePatient.id)\">\n                                <md-icon class=\'material-icons\'>arrow_forward\n                                    <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                </md-icon>\n                            </md-button>\n                            <div class=\"clearfix\"></div>\n                        </div>\n\n                        &lt;!&ndash; /Prospective Patient &ndash;&gt;\n\n                        <div class=\"separator\"></div>\n\n                        &lt;!&ndash; Attendant &ndash;&gt;\n\n                        <div>\n                            <div class=\"k-edit-label\">\n                                <i class=\"material-icons label-icon\">supervised_user_circle</i>\n                                <label style=\"font-size: small\"> Συνοδός: </label>\n                            </div>\n                            <input name=\"attendant\" id=\"attendant\" class=\"pull-left margin-left-10 k-input k-textbox patient\"\n                                   ng-model=\"vm.leadCall.prospectivePatient.attendant.fullName\" readonly/>\n                            <md-button ng-if=\"vm.leadCall.prospectivePatient.attendant && vm.leadCall.prospectivePatient.attendant.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                       ng-click=\"vm.goTo(\'attendant\', vm.leadCall.prospectivePatient.attendant.id)\">\n                                <md-icon class=\'material-icons\'>arrow_forward\n                                    <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                </md-icon>\n                            </md-button>\n                            <div class=\"clearfix\"></div>\n                        </div>\n\n                        &lt;!&ndash; /Attendant &ndash;&gt;\n\n                        <div class=\"separator\"></div>\n\n                        &lt;!&ndash; OLd Patient &ndash;&gt;\n\n                        <div class=\"k-edit-label\">\n                            <i class=\"material-icons label-icon\">supervisor_account</i>\n                            <label style=\"font-size: small\">Συγγενής - Φίλος παλιού ασθενή: </label>\n                        </div>\n                        <md-switch id=\"isOldPatientRelative\" ng-model=\"vm.leadCall.isOldPatientRelative\" aria-label=\"Συγγενείς - Φίλος παλιού ασθενή\"\n                                   md-no-ink style=\"padding-left: 57px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\"\n                                   ng-change=\"vm.toggleSwitch(\'isOldPatientRelative\', vm.leadCall.isOldPatientRelative)\" ng-disabled=\"true\">\n                            {{ vm.leadCall.isOldPatientRelative == true ? \'Ναι\' : \'Όχι\' }}\n                        </md-switch>\n\n                        <div id=\"oldPatientDiv\" ng-if=\"vm.leadCall.isOldPatientRelative\">\n                            <div>\n                                <div class=\"k-edit-label\">\n                                    &lt;!&ndash;<i class=\"material-icons label-icon\">account_circle</i>&ndash;&gt;\n                                    <label style=\"font-size: small\"> Παλιός Ασθενής: </label>\n                                </div>\n                                <input name=\"oldPatient\" id=\"oldPatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\"\n                                       ng-model=\"vm.leadCall.oldPatient.fullName\" readonly/>\n                                <md-button ng-if=\"vm.leadCall.oldPatient && vm.leadCall.oldPatient.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                           ng-click=\"vm.goTo(\'oldPatient\', vm.leadCall.oldPatient.id)\">\n                                    <md-icon class=\'material-icons\'>arrow_forward\n                                        <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                    </md-icon>\n                                </md-button>\n                                <div class=\"clearfix\"></div>\n                            </div>\n                        </div>\n\n                        &lt;!&ndash; /Old Patient &ndash;&gt;\n\n                        <div class=\"separator\"></div>\n\n                        &lt;!&ndash; Old Patient Doctor &ndash;&gt;\n\n                        <div>\n                            <div class=\"k-edit-label\">\n                                <i class=\"material-icons label-icon\">account_circle</i>\n                                <label style=\"font-size: small\"> Επαγγελματίας Υγείας: </label>\n                            </div>\n                            <input name=\"oldPatientDoctor\" id=\"oldPatientDoctor\" class=\"pull-left margin-left-10 k-input k-textbox patient\"\n                                   ng-model=\"vm.leadCall.oldPatientDoctor.fullName\" readonly/>\n                            <md-button ng-if=\"vm.leadCall.oldPatientDoctor && vm.leadCall.oldPatientDoctor.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                       ng-click=\"vm.goTo(\'oldPatientDoctor\', vm.leadCall.oldPatientDoctor.id)\">\n                                <md-icon class=\'material-icons\'>arrow_forward\n                                    <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                </md-icon>\n                            </md-button>\n                            <div class=\"clearfix\"></div>\n                        </div>\n\n                        &lt;!&ndash; /Old Patient Doctor &ndash;&gt;\n\n                        <div class=\"separator\"></div>\n\n                        <div class=\"k-edit-label\">\n                            <i class=\"material-icons label-icon\" style=\"color: #999999\">accessibility</i>\n                            <label style=\"font-size: small\">Παλιός Ασθενής: </label>\n                        </div>\n                        <md-switch id=\"isOldPatient\" ng-model=\"vm.leadCall.isOldPatient\" aria-label=\"Παλιός Ασθενής\"\n                                   md-no-ink style=\"padding-left: 57px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">\n                            {{ vm.leadCall.isOldPatient == true ? \'Ναι\' : \'Όχι\' }}\n                        </md-switch>\n\n                        <div class=\"separator\"></div>\n\n                        <div class=\"k-edit-label\">\n                            <i class=\"material-icons label-icon\">speaker_notes_off</i>\n                            <label style=\"font-size: small\">Δεν άφησε στοιχεία: </label>\n                        </div>\n                        <md-switch id=\"noContact\" ng-model=\"vm.leadCall.noContact\" aria-label=\"Δεν άφησε στοιχεία\"\n                                   md-no-ink style=\"padding-left: 57px; width: 8%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">\n                            {{ vm.leadCall.noContact == true ? \'Ναι\' : \'Όχι\' }}\n                        </md-switch>\n                    </div>\n                </div>\n            </div>\n\n\n\n            &lt;!&ndash;<md-content layout-gt-sm=\"row\" layout-padding> &lt;!&ndash; md-theme=\"docs-dark\" &ndash;&gt;\n                    <div>\n                        <md-input-container style=\"font-size: large\">\n                            <label>Τύπος Κλήσης</label>\n                            <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">phone</i></md-icon>\n                            <input ng-model=\"vm.selectedLeadCall.callType.name\" ng-disabled=\"true\">\n                        </md-input-container>\n                        <md-input-container style=\"font-size: large\">\n                            <label>Ημερομηνία</label>\n                            <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">today</i></md-icon>\n                            <input ng-model=\"vm.selectedLeadCall.date\" ng-disabled=\"true\">\n                        </md-input-container>\n                        <md-input-container style=\"font-size: large\">\n                            <label>Ώρα</label>\n                            <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">access_time</i></md-icon>\n                            <input ng-model=\"vm.selectedLeadCall.time\" ng-disabled=\"true\">\n                        </md-input-container>\n                    </div>\n            </md-content>\n            <md-content layout-gt-sm=\"row\" layout-padding> &lt;!&ndash; md-theme=\"docs-dark\" &ndash;&gt;\n                <div>\n                    <md-input-container style=\"font-size: large\">\n                        <label>Πιθανός Ασθενής</label>\n                        <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">accessibility_new</i></md-icon>\n                        <input ng-model=\"vm.selectedLeadCall.prospectivePatientFullName\" ng-disabled=\"true\">\n                    </md-input-container>\n                    <md-input-container style=\"font-size: large\">\n                        <label>Παλιός Ασθενής</label>\n                        <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">supervisor_account</i></md-icon>\n                        <input ng-model=\"vm.selectedLeadCall.oldPatientFullName\" ng-disabled=\"true\">\n                    </md-input-container>\n                    <md-input-container style=\"font-size: large\">\n                        <label>Επαγγελματίας Υγείας</label>\n                        <md-icon style=\"color: #0074BC\" md-menu-origin><i class=\"material-icons\">account_circle</i></md-icon>\n                        <input ng-model=\"vm.selectedLeadCall.oldPatientFullName\" ng-disabled=\"true\">\n                    </md-input-container>\n                </div>\n            </md-content>\n            <md-content layout-gt-sm=\"row\" layout-padding> &lt;!&ndash; md-theme=\"docs-dark\" &ndash;&gt;\n                <div>\n                    <md-input-container style=\"font-size: large\">\n                        <md-switch id=\"isOldPatient\" ng-model=\"vm.selectedLeadCall.isOldPatient\" aria-label=\"Παλιός Ασθενής\"\n                                   md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">\n                            Παλιός Ασθενής ({{ vm.selectedLeadCall.isOldPatient == true ? \'Ναι\' : \'Όχι\' }})\n                        </md-switch>\n                    </md-input-container>\n                    <md-input-container style=\"font-size: large\">\n                        <md-switch id=\"noContact\" ng-model=\"vm.selectedLeadCall.noContact\" aria-label=\"Δεν άφησε στοιχεία\"\n                                   md-no-ink class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">\n                            Δεν άφησε στοιχεία ({{ vm.selectedLeadCall.noContact == true ? \'Ναι\' : \'Όχι\' }})\n                        </md-switch>\n                    </md-input-container>\n                </div>\n            </md-content>&ndash;&gt;\n        </div>\n    </div>\n</div>\n-->");
$templateCache.put("app/displays/medReportApprovals/history/history.html","<kendo-grid id=\"approvalsPendingGrid\" class=\"fix-height\" k-options=\"vm.historyGridOptions\"></kendo-grid>");
$templateCache.put("app/displays/medReportApprovals/pending/pending.html","<kendo-grid selectable-grid items=\"vm.approvals.getSelectedList()\" id=\"approvalsPendingGrid\" class=\"fix-height\" k-options=\"vm.pendingGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" style=\"display: none\"></li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.medReportLinesGridOptions(dataItem)\"></div></div></div></div></kendo-grid><div kendo-window=\"vm.previewWindow\" k-width=\"1600\" k-height=\"620\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.kendoGrid.refresh(vm.pendingGridOptions)\" k-on-open=\"vm.kendoGrid.refreshList(vm.pendingPreviewGridOptions, vm.approvals.getSelectedList())\"><div class=\"box\"><kendo-grid id=\"pendingPreviewGrid\" class=\"approval-preview-grid\" k-options=\"vm.pendingPreviewGridOptions\" k-ng-delay=\"vm.initPopupGrid\"></kendo-grid></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closePreviewWindow()\">Ακύρωση</button> <button ng-if=\"vm.status == \'approve\'\" type=\"button\" class=\"green-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΈΓΚΡΙΣΗ</button> <button ng-if=\"vm.status == \'reject\'\" type=\"button\" class=\"red-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΑΠΟΡΡΙΨΗ</button></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/pharmacyAssignations/preview/preview.html","<div kendo-toolbar options=\"vm.toolbarPreviewOptions\" k-rebind=\"vm.toolbarPreviewOptions\" id=\"preview_customer_sectors\"></div><div kendo-grid id=\"previewAssignationsGrid\" k-options=\"vm.previewGridOptions\"></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/pharmacyAssignations/sectors/sectors.html","<div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><div selectable-grid kendo-grid id=\"assignationsGrid\" k-options=\"vm.sectorGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div>");
$templateCache.put("app/displays/prospectivePatients/diseases/leadHospitalizationDiseases.html","<div ng-style=\"{height: vm.contentHeight, overflow: auto}\"><md-list ng-cloak style=\"height: 570px; overflow-y: scroll; padding: 0px\"><md-list-item ng-repeat=\"lhDisease in vm.leadHospitalizationDiseases\"><md-card style=\"width: 100%\"><md-card-content><md-card-title-text><span class=\"md-headline\"><b style=\"font-size: medium\">{{ lhDisease.leadHospitalizationDisease.disease.name }}</b></span> <span class=\"md-subhead\"><i style=\"font-size: small\">{{ lhDisease.leadHospitalizationDisease.disease.diseaseType.name }}</i></span></md-card-title-text><div layout=\"row\" style=\"width: 40%; padding-top: 15px\"><div flex><md-icon><i class=\"material-icons label-icon\">phone</i></md-icon>Ημερομηνία Κλήσης: <b>{{ vm.beautifyDate(lhDisease.leadCallDateTime) }}</b></div><div flex><md-icon><i class=\"material-icons label-icon\">today</i></md-icon>Ημερομηνία Διάγνωσης: <b>{{ vm.beautifyDate(lhDisease.leadHospitalizationDiagnosisDate) }}</b></div></div></md-card-content></md-card></md-list-item></md-list></div>");
$templateCache.put("app/displays/prospectivePatients/leadCalls/leadCalls.html","<div layout=\"row\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div flex=\"20\" style=\"padding: 1em\"><kendo-grid id=\"prospectivePatientLeadCallsGrid\" class=\"smallLeadCallsGrid\" k-on-change=\"vm.onSelection(data)\" options=\"vm.leadCallsGridOptions\" k-ng-delay=\"vm.leadCallsGridOptions\"></kendo-grid></div><div flex=\"80\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.showProgress\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-card layout=\"column\" ng-cloak class=\"md-inline-form\" ng-if=\"!vm.showProgress\"><div id=\"hospitalization\" layout-padding ng-cloak><label ng-if=\"vm.selectedLeadCallId === null\"><i>Επιλέξτε κλήση από τη λίστα στα αριστερά</i></label><div id=\"leadCallForm\" ng-if=\"vm.selectedLeadCallId !== null\" name=\"leadCallForm\" ng-form><div class=\"popup-info pull-left full-width\"><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">today</i><label style=\"font-size: small\">Ημερομηνία & Ώρα:</label></div><input name=\"dateIssue\" id=\"dateIssue\" class=\"pull-left margin-left-10\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" k-ng-model=\"vm.startDate\" onkeydown=\"return false\" readonly=\"readonly\"> <input name=\"start\" id=\"startTime\" kendo-time-picker class=\"pull-left margin-left-10\" onkeydown=\"return false\" readonly=\"readonly\" k-format=\"\'HH:mm\'\" data-bind=\"value:start\" k-ng-model=\"vm.startTime\"><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">phone</i><label style=\"font-size: small\">Τύπος Κλήσης:</label></div><md-radio-group layout=\"row\" id=\"callType\" name=\"callType\" ng-model=\"vm.leadCall.callType\" class=\"md-primary\" style=\"padding-left: 60px; padding-top: 5px\"><md-radio-button ng-repeat=\"d in vm.callTypes\" ng-value=\"d\" id=\"{{\'mdRad\' + d.id}}\" ng-disabled=\"true\">{{ d.name }}</md-radio-button></md-radio-group><div class=\"separator\"></div><!-- Prospective Patient --><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">accessibility_new</i><label style=\"font-size: small\">Πιθανός Ασθενής:</label></div><input name=\"prospectivePatient\" id=\"prospectivePatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.prospectivePatient.fullName\" readonly=\"readonly\"><!--<md-button ng-if=\"vm.leadCall.prospectivePatient && vm.leadCall.prospectivePatient.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                       ng-click=\"vm.goTo(\'prospectivePatient\', vm.leadCall.prospectivePatient.id)\">\n                                <md-icon class=\'material-icons\'>arrow_forward\n                                    <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                </md-icon>\n                            </md-button>--><div class=\"clearfix\"></div></div><!-- /Prospective Patient --><div class=\"separator\"></div><!-- Attendant --><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">supervised_user_circle</i><label style=\"font-size: small\">Συνοδός:</label></div><input name=\"attendant\" id=\"attendant\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.prospectivePatient.attendant.fullName\" readonly=\"readonly\"><!--<md-button ng-if=\"vm.leadCall.prospectivePatient.attendant && vm.leadCall.prospectivePatient.attendant.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\"\n                                       ng-click=\"vm.goTo(\'attendant\', vm.leadCall.prospectivePatient.attendant.id)\">\n                                <md-icon class=\'material-icons\'>arrow_forward\n                                    <md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip>\n                                </md-icon>\n                            </md-button>--><div class=\"clearfix\"></div></div><!-- /Attendant --><div class=\"separator\"></div><!-- OLd Patient --><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">supervisor_account</i><label style=\"font-size: small\">Συγγενής - Φίλος παλιού ασθενή:</label></div><md-switch id=\"isOldPatientRelative\" ng-model=\"vm.leadCall.isOldPatientRelative\" aria-label=\"Συγγενείς - Φίλος παλιού ασθενή\" md-no-ink style=\"padding-left: 57px; width: 20%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-change=\"vm.toggleSwitch(\'isOldPatientRelative\', vm.leadCall.isOldPatientRelative)\" ng-disabled=\"true\">{{ vm.leadCall.isOldPatientRelative == true ? \'Ναι\' : \'Όχι\' }}</md-switch><div id=\"oldPatientDiv\" ng-if=\"vm.leadCall.isOldPatientRelative\"><div><div class=\"k-edit-label\"><!--<i class=\"material-icons label-icon\">account_circle</i>--><label style=\"font-size: small\">Παλιός Ασθενής:</label></div><input name=\"oldPatient\" id=\"oldPatient\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.oldPatient.fullName\" readonly=\"readonly\"><md-button ng-if=\"vm.leadCall.oldPatient && vm.leadCall.oldPatient.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.goTo(\'oldPatient\', vm.leadCall.oldPatient.id)\"><md-icon class=\"material-icons\">arrow_forward<md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div></div><!-- /Old Patient --><div class=\"separator\"></div><!-- Old Patient Doctor --><div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">account_circle</i><label style=\"font-size: small\">Επαγγελματίας Υγείας:</label></div><input name=\"oldPatientDoctor\" id=\"oldPatientDoctor\" class=\"pull-left margin-left-10 k-input k-textbox patient\" ng-model=\"vm.leadCall.oldPatientDoctor.fullName\" readonly=\"readonly\"><md-button ng-if=\"vm.leadCall.oldPatientDoctor && vm.leadCall.oldPatientDoctor.id > 0\" class=\"pull-left orange-md-button md-icon-button md-button md-warn md-ink-ripple search-btn\" aria-label=\"search\" ng-click=\"vm.goTo(\'oldPatientDoctor\', vm.leadCall.oldPatientDoctor.id)\"><md-icon class=\"material-icons\">arrow_forward<md-tooltip md-direction=\"bottom\">Μετάβαση</md-tooltip></md-icon></md-button><div class=\"clearfix\"></div></div><!-- /Old Patient Doctor --><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\" style=\"color: #999999\">accessibility</i><label style=\"font-size: small\">Παλιός Ασθενής:</label></div><md-switch id=\"isOldPatient\" ng-model=\"vm.leadCall.isOldPatient\" aria-label=\"Παλιός Ασθενής\" md-no-ink style=\"padding-left: 57px; width: 20%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">{{ vm.leadCall.isOldPatient == true ? \'Ναι\' : \'Όχι\' }}</md-switch><div class=\"separator\"></div><div class=\"k-edit-label\"><i class=\"material-icons label-icon\">speaker_notes_off</i><label style=\"font-size: small\">Δεν άφησε στοιχεία:</label></div><md-switch id=\"noContact\" ng-model=\"vm.leadCall.noContact\" aria-label=\"Δεν άφησε στοιχεία\" md-no-ink style=\"padding-left: 57px; width: 20%\" class=\"md-primary\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"true\">{{ vm.leadCall.noContact == true ? \'Ναι\' : \'Όχι\' }}</md-switch><md-button class=\"md-raised md-mini md-primary pull-right\" aria-label=\"update\" ng-click=\"vm.goTo(\'leadCall\', vm.selectedLeadCallId);\"><i class=\"material-icons fixed-icons fixed-icons-2\">arrow_forward</i>Μετάβαση στη Κλήση</md-button></div></div></div></md-card></div></div>");
$templateCache.put("app/displays/prospectivePatients/info/info.html","<div style=\"padding: 1em\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><section kendo-validator=\"vm.validator\" class=\"row\"><div flex=\"33\" class=\"form-horizontal form-widgets col-sm-4\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"lastName\" name=\"lastName\" ng-model=\"vm.prospectivePatient.lastName\" class=\"k-textbox info\" autocomplete=\"family-name\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του ασθενή.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"firstName\" name=\"firstName\" ng-model=\"vm.prospectivePatient.firstName\" class=\"k-textbox info\" autocomplete=\"family-name\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του ασθενή.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ηλικία:</label><div class=\"col-sm-8 col-md-6\"><input id=\"age\" kendo-numeric-text-box min=\"0\" name=\"age\" k-format=\"\'n0\'\" ng-model=\"vm.prospectivePatient.age\" min=\"0\" maxlength=\"2\" class=\"pull-left\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"text\" class=\"k-textbox info\" name=\"phone\" ng-model=\"vm.prospectivePatient.phone\" autocomplete=\"tel-national\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"email\" class=\"k-textbox info\" name=\"email\" autocomplete=\"email\" ng-model=\"vm.prospectivePatient.email\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κινητό:</label><div class=\"col-sm-8 col-md-6\"><input type=\"text\" class=\"k-textbox info\" name=\"mobile\" autocomplete=\"tel-national\" ng-model=\"vm.prospectivePatient.mobile\"></div></div></div><div flex=\"33\" class=\"form-horizontal form-widgets col-sm-4\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Λάθος Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><div class=\"margin-left-10 btn-group no-outline pull-left margin-top-2\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.prospectivePatient.isWrongPhone\" uib-btn-radio=\"true\">Ναι</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.prospectivePatient.isWrongPhone\" uib-btn-radio=\"false\">Όχι</label></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Λάθος Στοιχεία Επικοινωνίας:</label><div class=\"col-sm-8 col-md-6\"><div class=\"margin-left-10 btn-group no-outline pull-left margin-top-2\"><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.prospectivePatient.isWrongContact\" uib-btn-radio=\"true\">Ναι</label><label class=\"btn btn-radio btn-primary\" ng-model=\"vm.prospectivePatient.isWrongContact\" uib-btn-radio=\"false\">Όχι</label></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επάγγελμα:</label><div class=\"col-sm-8 col-md-6\"><select id=\"profession\" name=\"profession\" kendo-combo-box k-ng-model=\"vm.prospectivePatient.profession\" k-options=\"vm.professionOptions\" class=\"col-fix-2\" autocomplete=\"off\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">ΑΜΚΑ:</label><div class=\"col-sm-8 col-md-6\"><input type=\"text\" class=\"k-textbox info\" name=\"amka\" autocomplete=\"amka\" ng-model=\"vm.prospectivePatient.amka\"></div></div></div><div flex=\"33\" class=\"form-horizontal form-widgets col-sm-4\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Συνοδός:</label><div class=\"col-sm-8 col-md-6\"><div layout=\"row\" layout=\"row\"><input type=\"text\" class=\"k-input k-textbox\" style=\"width: 100%;  margin-right: 5px\" ng-disabled=\"true\" ng-model=\"vm.attendant.fullName\" flex=\"70\"><div id=\"actions\" layout-align=\"center\" flex=\"30\" layout=\"row\" ng-if=\"vm.showAttendantActions\"><div flex><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #3F51B5\" ng-click=\"vm.onAttendantActionButtonsClick(\'add\')\">add</i><md-tooltip md-direction=\"bottom\">Προσθήκη</md-tooltip></md-icon></span></div><div flex ng-if=\"vm.attendant.id > 0\"><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #3F51B5\" ng-click=\"vm.onAttendantActionButtonsClick(\'edit\')\">edit</i><md-tooltip md-direction=\"bottom\">Επεξεργασία</md-tooltip></md-icon></span></div><div flex ng-if=\"vm.attendant.id > 0\"><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #D84315\" ng-click=\"vm.onAttendantActionButtonsClick(\'delete\', $event)\">delete</i><md-tooltip md-direction=\"bottom\">Διαγραφή</md-tooltip></md-icon></span></div></div><div id=\"secondaryActions\" layout-align=\"center\" flex=\"30\" layout=\"row\" ng-if=\"vm.showAttendantSecondaryActions\"><div flex><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #3F51B5\" ng-click=\"vm.onAttendantActionButtonsClick(\'save\')\">save</i><md-tooltip md-direction=\"bottom\">Αποθήκευση</md-tooltip></md-icon></span></div><div flex><span><md-icon class=\"name\"><i class=\"material-icons\" style=\"color: #D84315\" ng-click=\"vm.onAttendantActionButtonsClick(\'close\')\">close</i><md-tooltip md-direction=\"bottom\">Κλείσιμο</md-tooltip></md-icon></span></div><div flex></div></div></div></div></div><div class=\"form-group\" kendo-validator=\"vm.attendantValidator\"><div ng-if=\"vm.showAttendantLayout\" style=\"background-color: #EDF4F8\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"aLastName\" name=\"lastName\" ng-model=\"vm.attendant.lastName\" class=\"k-textbox info\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του Συνοδού.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"aFirstName\" name=\"lastName\" ng-model=\"vm.attendant.firstName\" class=\"k-textbox info\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του Συνοδού.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"aPhone\" name=\"lastName\" ng-model=\"vm.attendant.phone\" class=\"k-textbox info\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input id=\"aEmail\" name=\"lastName\" ng-model=\"vm.attendant.email\" class=\"k-textbox info\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επάγγελμα:</label><md-select ng-model=\"vm.attendant.profession\" class=\"k-textbox pull-left\" style=\"margin-top: 0px; margin-left: 17px; margin-bottom: 0px; background-color: white!important\" aria-label=\"Επάγγελμα\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"profession in vm.professions\" ng-value=\"profession\">{{profession.name}}</md-option></md-select></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Βαθμός Συγγένειας:</label><md-select ng-model=\"vm.attendant.relationshipType\" class=\"k-textbox pull-left\" style=\"margin-top: 0px; margin-left: 17px; margin-bottom: 0px; background-color: white!important\" aria-label=\"Βαθμός Συγγένειας\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"relationshipType in vm.relationshipTypes\" ng-value=\"relationshipType\">{{relationshipType.name}}</md-option></md-select></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Λάθος στοιχ. επικ.:</label><md-checkbox ng-model=\"vm.prospectivePatient.attendant.isWrongContact\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος στοιχεία επικοινωνίας\"></md-checkbox></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Λάθος τηλέφωνο:</label><md-checkbox ng-model=\"vm.attendant.isWrongPhone\" class=\"info pull-left margin-left-10\" style=\"margin-left: 30px; margin-top: 5px\" aria-label=\"Λάθος τηλέφωνο\"></md-checkbox></div></div></div></div><div class=\"clearfix\"></div><div><md-button class=\"md-raised md-mini md-primary pull-right\" aria-label=\"update\" ng-click=\"vm.update()\"><i class=\"material-icons fixed-icons fixed-icons-2\">save</i>Αποθήκευση</md-button><!-- Removed ECRM-351 --><!--<md-button class=\"md-raised md-mini md-primary pull-right\" aria-label=\"update\" ng-click=\"vm.convertToPatient();\" ng-show=\"vm.showConvertButton\">\n                <i class=\"material-icons fixed-icons fixed-icons-2\">accessibility</i>Μετατροπή σε Ασθενή</md-button>--></div></section></div>");
$templateCache.put("app/displays/recDoctors/events/events.html","<div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"eventsGrid\" options=\"vm.eventsGridOptions\"></kendo-grid></div>");
$templateCache.put("app/displays/recDoctors/hospitalization/hospitalization.html","<div style=\"padding: 1em\"><kendo-grid id=\"hospitalizationsGrid\" options=\"vm.hospitalizationsGridOptions\" k-ng-delay=\"vm.hospitalizationsGridOptions\"></kendo-grid></div>");
$templateCache.put("app/displays/recDoctors/info/info.html","<div style=\"padding: 1em\"><section class=\"row\" kendo-validator=\"vm.validator\" k-options=\"vm.validatorOptions\"><div id=\"customerFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input id=\"last_name\" name=\"last_name\" value=\"{{vm.customer.last_name}}\" ng-model=\"vm.customer.lastName\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Επώνυμο\" required data-required-msg=\"Παρακαλούμε εισάγετε το επώνυμο του επαγγελματία υγείας.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input id=\"first_name\" name=\"first_name\" value=\"{{vm.customer.first_name}}\" ng-model=\"vm.customer.firstName\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Όνομα\" required data-required-msg=\"Παρακαλούμε εισάγετε το όνομα του επαγγελματία υγείας.\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα:</label><div class=\"col-sm-8 col-md-6\"><select id=\"specialty\" name=\"specialty\" kendo-combo-box k-ng-model=\"vm.customer.doctorSpecialty.id\" k-options=\"vm.specialtyComboBoxOptions\" ng-readonly=\"vm.readOnly\" data-custom=\"#specialty\" class=\"col-fix pull-left\" required data-required-msg=\"Παρακαλούμε εισάγετε την ειδικότητα του επαγγελματία υγείας.\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος:</label><div class=\"col-sm-8 col-md-6\"><select id=\"type\" name=\"type\" kendo-combo-box k-ng-model=\"vm.customer.customerTitle.id\" k-options=\"vm.customerTitleComboBoxOptions\" ng-readonly=\"vm.readOnly\" data-custom=\"#type\" class=\"col-fix pull-left\"></select><span class=\"k-invalid-msg\" data-for=\"type\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">A.M.K.A.:</label><div class=\"col-sm-8 col-md-6\"><input id=\"amka\" name=\"amka\" value=\"{{vm.customer.amka}}\" ng-model=\"vm.customer.amka\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"A.M.K.A.\"></div></div></div><div id=\"customerSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κινητό:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"cell_phone\" name=\"cell_phone\" value=\"{{vm.customer.cellPhone}}\" ng-model=\"vm.customer.cellPhone\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Κινητό Τηλέφωνο\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σταθερό Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.customer.phone}}\" ng-model=\"vm.customer.phone\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"Σταθερό Τηλέφωνο\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"email\" id=\"email\" name=\"email\" value=\"{{vm.customer.email}}\" ng-model=\"vm.customer.email\" ng-readonly=\"vm.readOnly\" class=\"k-textbox info\" placeholder=\"example@example.gr\" data-email-msg=\"Το email δεν είναι έγκυρο\"> <span class=\"k-invalid-msg\" data-for=\"email\"></span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Ενεργός:</label><div class=\"col-sm-8 col-md-6\"><md-checkbox id=\"is_active\" class=\"checkbox-toolbar customers green inline\" aria-label=\"selectable\" ng-model=\"vm.isCustomerActive\" ng-disabled=\"vm.readOnly\"></md-checkbox></div></div></div><div class=\"clearfix\"></div><div class=\"buttons-wrap\"><input id=\"update-first\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.update()\" ng-hide=\"vm.readOnly\" value=\"Αποθήκευση\"></div></section></div>");
$templateCache.put("app/displays/recDoctors/notes/notes.html","<div style=\"padding: 1em\"><div><section class=\"well\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" maxlength=\"500\" value=\"{{vm.customer.notes}}\" ng-model=\"vm.customer.notes\" class=\"k-textbox info\" ng-readonly=\"vm.readOnly\"></textarea></div><div class=\"clearfix\"></div><div class=\"buttons-wrap\"><input id=\"update-second\" type=\"button\" class=\"k-button k-primary k-state-default\" ng-click=\"vm.update()\" ng-hide=\"vm.readOnly\" value=\"Αποθήκευση\"></div></section></div></div>");
$templateCache.put("app/displays/recDoctors/sectors/sectors.html","<kendo-grid id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\"></kendo-grid><div id=\"popup-new-customSector\" selectable-grid kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\" k-on-open=\"vm.kendoGrid.refresh(vm.employeeAllGridOptions)\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"customer-sector-info pull-left full-width popup-new-customSector\"><h5>Στοιχεία Μονάδας Συνταγογράφησης του Επαγγελματία Υγείας</h5><div class=\"pull-left left-section\"><div ng-hide=\"vm.newSector || vm.savedSector\"><div class=\"k-edit-label\"><label>Θέση στη Μονάδα Υγείας:</label></div><select kendo-combo-box id=\"sectorPosition\" name=\"sector_position_id\" class=\"custom-combobox\" ng-model=\"vm.newCustomerSector.sectorPosition.id\" data-bind=\"value:sectorPosition.id\" k-options=\"vm.sectorPositionComboBoxOptions\"></select></div><div class=\"k-edit-label\"><label>Τηλέφωνο:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"customer_sector_phone\" ng-model=\"vm.newCustomerSector.phone\"></div><div class=\"pull-right right-section\"><div class=\"k-edit-label\"><label>Ημερομηνία Έναρξης ΜΣ:</label></div><input id=\"started_at\" class=\"custom-combobox\" name=\"started_at\" ng-model=\"vm.newCustomerSector.startedAt\" kendo-date-picker k-format=\"\'yyyy-MM-dd\'\" data-bind=\"value:startedAt\" readonly=\"readonly\"></div><div class=\"pull-right right-section\"><div class=\"k-edit-label\"><label>Βασική Μονάδα:</label></div><md-checkbox class=\"checkbox-toolbar customers green inline\" aria-label=\"main\" ng-model=\"dataItem.main\"></md-checkbox></div></div><div class=\"sector-info pull-left full-width\"><h5>Στοιχεία Μονάδας Υγείας</h5><div class=\"pull-left left-section\"><div class=\"k-edit-label\"><label>Τύπος Μονάδας Υγείας:</label></div><input ng-readonly=\"vm.savedSector\" id=\"sectorType\" class=\"custom-combobox\" kendo-combo-box ng-model=\"vm.saveNewSector.sectorType.id\" data-bind=\"value:sectorType\" k-options=\"vm.sectorTypeComboBoxOptions\"></div><div ng-hide=\"vm.newSector && !vm.savedSector\" class=\"sector-info pull-left left-section popup-new-customSector\"><div><div ng-hide=\"!vm.savedSector\" class=\"k-edit-label\"><label class=\"fix-width\">Μονάδα Υγείας:</label></div><div ng-hide=\"vm.savedSector\" class=\"k-edit-label\"><label class=\"fix-width\">Επιλέξτε μια Μονάδα Υγείας:</label></div><select ng-readonly=\"vm.savedSector\" id=\"sectors\" name=\"sector_id\" class=\"custom-combobox\" ng-model=\"vm.newCustomerSector.sector.id\" kendo-combo-box k-options=\"vm.sectorsComboBoxOptions\"></select></div><div ng-hide=\"vm.newSector\" class=\"pull-left\"><label>Θέλετε να προσθέσετε μια νέα Μονάδα Υγείας;</label><kendo-button id=\"kendo-button-blue\" ng-click=\"vm.addSector()\">Προσθήκη</kendo-button></div></div><div ng-hide=\"!vm.newSector || vm.savedSector\"><div class=\"sector-info pull-left left-section popup-new-customSector\"><div><div class=\"k-edit-label\"><label>Όνομα Μονάδας Υγείας:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"name\" ng-model=\"vm.saveNewSector.name\"></div><!--<div class = \"float-left\">--><!--<div class=\"k-edit-label\">--><!--<label>Ειδικότητες στη ΜΣ: </label>--><!--</div>--><!--<input class = \"custom-combobox\"  kendo-combo-box ng-model=\"vm.saveNewSector.doctorSpecialty.id\" data-bind=\"value:doctorSpecialty\" k-options=\"vm.specialtyComboBoxOptions\"/>--><!--</div>--></div><div class=\"minus-margin-top pull-right right-section popup-new-customSector\"><div><div class=\"k-edit-label\"><label>Brick:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"brick\" ng-model=\"vm.saveNewSector.brick\"></div><div><div class=\"k-edit-label\"><label>Brick ΟΣΦΕ:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"osfeBrick\" ng-model=\"vm.saveNewSector.osfeBrick\"></div></div><div class=\"sector-info pull-left full-width\"><h5>Στοιχεία Διεύθυνσης</h5></div><div ng-if=\"!vm.geodata\" class=\"sector-info pull-left left-section popup-new-customSector\"><!--<div>--><!--<div class=\"k-edit-label\">--><!--<label>Περιφέρεια: </label>&lt;!&ndash;regionName&ndash;&gt;--><!--</div>--><!--<input id=\"regions\" class = \"custom-combobox\"  kendo-combo-box ng-model=\"vm.saveNewSector.regionName\" k-options=\"vm.regionsComboBoxOptions\"/>--><!--</div>--><div><div class=\"k-edit-label\"><label>Νομός:</label><!--prefectureName--></div><input id=\"prefectures\" class=\"custom-combobox\" kendo-combo-box ng-model=\"vm.saveNewSector.prefectureName\" k-ng-model=\"vm.saveNewSector.prefecture\" k-options=\"vm.prefecturesComboBoxOptions\"></div><div><div class=\"k-edit-label\"><label>Πόλη:</label></div><input id=\"cities\" class=\"custom-combobox\" kendo-combo-box ng-model=\"vm.saveNewSector.cityName\" k-ng-model=\"vm.saveNewSector.city\" k-options=\"vm.citiesComboBoxOptions\"></div><div><div class=\"k-edit-label\"><label>Διεύθυνση:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-model=\"vm.saveNewSector.address\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Τ.Κ.:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-change=\"vm.suggestBricks(vm.saveNewSector.postalCode)\" ng-model=\"vm.saveNewSector.postalCode\"></div><div><div class=\"k-edit-label\"><label>Αριθμός:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-model=\"vm.saveNewSector.addressNum\"></div></div><div ng-if=\"vm.geodata\"><div id=\"masterFilterGeodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\"></div><div class=\"sector-info pull-left left-section\"><div><div class=\"k-edit-label\"><label>Νομός:</label><!--prefectureName--></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" ng-model=\"vm.saveNewSector.prefectureName\"></div><div><div class=\"k-edit-label\"><label>Πόλη:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" ng-model=\"vm.saveNewSector.cityName\"></div><div><div class=\"k-edit-label\"><label>Διεύθυνση:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-model=\"vm.saveNewSector.address\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Τ.Κ.:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-change=\"vm.suggestBricks(vm.saveNewSector.postalCode)\" ng-model=\"vm.saveNewSector.postalCode\"></div><div class=\"float-left\"><div class=\"k-edit-label\"><label>Αριθμός:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"address\" ng-model=\"vm.saveNewSector.addressNum\"></div></div></div><div class=\"pull-right right-section popup-new-customSector\"><div><div class=\"k-edit-label\"><label>Τηλέφωνο:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"phone\" ng-model=\"vm.saveNewSector.phone\"></div><div><div class=\"k-edit-label\"><label>Τηλέφωνο 2:</label></div><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"phone\" ng-model=\"vm.saveNewSector.phone2\"></div></div><div class=\"pull-right margin-right-sm\"><kendo-button class=\"k-button k-button-icontext k-grid-cancel\" ng-click=\"vm.cancelSector()\">Ακύρωση</kendo-button><kendo-button id=\"kendo-button-blue\" class=\"k-button k-button-icontext k-primary k-grid-update\" ng-click=\"vm.updateSector()\">Αποθήκευση</kendo-button></div><!--<div class = \"float-left\">--><!--<div class=\"k-edit-label\">--><!--<label>Ανήκει στη ΜΣ: </label>--><!--</div>--><!--<input class = \"custom-combobox\"  kendo-combo-box ng-model=\"vm.saveNewSector.parent.id\" data-bind=\"value:parent\" k-options=\"vm.sectorsAllComboBoxOptions\"/>--><!--</div>--></div></div><div ng-if=\"vm.hasAssignations\" class=\"employee-assign\"><h5>Ανάθεση Ιατρικών Επισκεπτών</h5><label>My Target:</label><md-checkbox aria-label=\"myTarget\" ng-checked=\"vm.myTarget\" ng-click=\"vm.myTarget=!vm.myTarget\" class=\"checkbox-toolbar green\"></md-checkbox><div selectable-grid items=\"vm.selectedEmployees\" kendo-grid id=\"employeeAllGrid\" k-options=\"vm.employeeAllGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\" k-ng-delay=\"vm.initPopupGrid\"></div></div></div></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closeWindow()\">Ακύρωση</button> <button type=\"button\" class=\"k-primary k-button\" ng-click=\"vm.saveCustomerSectors()\">Αποθήκευση</button></div></div>");
$templateCache.put("app/displays/recDoctors/scheduler/scheduler.html","<div kendo-tooltip k-content=\"vm.tooltipContent\" k-filter=\"\'.k-event\'\" class=\"k-group\"><kendo-scheduler id=\"scheduler\" k-options=\"vm.schedulerOptions\"><span k-event-template class=\"custom-event\"><span ng-show=\"vm.view == \'day\'\"><span class=\"glyphicon glyphicon-time\"></span> <span>{{dataItem.start | date : \'hh:mm a\'}}&nbsp;&nbsp;</span> <span>{{dataItem.end | date : \'hh:mm a\'}}&nbsp;&nbsp;</span> <span>{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span> <span ng-if=\"dataItem.startedAt\">{{dataItem.eventCategoryType.eventCategory.name}}&nbsp;</span> <span ng-if=\"dataItem.startedAt\">{{dataItem.eventCategoryType.eventType.name}}&nbsp;&nbsp;</span> <span ng-if=\"!dataItem.startedAt\">ΡΑΝΤΕΒΟΥ&nbsp;</span> <span ng-if=\"!dataItem.startedAt\">ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;</span> <span class=\"glyphicon glyphicon-user\"></span> <span>{{dataItem.employee.account.lastName}}, {{dataItem.employee.account.firstName}}</span> </span><span ng-show=\"vm.view == \'week\' || vm.view == \'month\'\"><span>{{dataItem.eventCustomerSector.customerSector.customer.lastName}}, {{dataItem.eventCustomerSector.customerSector.customer.firstName}}&nbsp;&nbsp;</span></span></span></kendo-scheduler></div><!--Tooltip Template--><script id=\"template\" type=\"text/x-kendo-template\">#var uid = target.attr(\"data-uid\");#\n    #var scheduler = target.closest(\"[data-role=scheduler]\").data(\"kendoScheduler\");#\n    #if (scheduler) {#\n        #var model = scheduler.occurrenceByUid(uid);#\n\n        #if(model) {#\n            <div class=\"schedule-tooltip\">\n                <i class=\"material-icons md-13\">schedule</i>\n                <span>#=kendo.toString(model.start, \"hh:mm tt\")#&nbsp;&nbsp;</span>\n                <span>#=kendo.toString(model.end, \"hh:mm tt\")#&nbsp;&nbsp;<br></span>\n                <i class=\"material-icons md-13\">lens</i>\n                #if(model.startedAt) {#\n                    <span>#= model.eventCategoryType.eventCategory.name#&nbsp;&nbsp;<br></span>\n                    #if(model.eventStatus) {#\n                        <i class=\"material-icons md-13\">lens</i>\n                        <span>#= model.eventStatus.name#&nbsp;&nbsp;<br></span>\n                    #}#\n                #}#\n                #if(!model.startedAt) {#\n                    <span>ΡΑΝΤΕΒΟΥ&nbsp;&nbsp;<br></span>\n                #}#\n                <i class=\"material-icons md-13\">assignment_ind</i>\n                <span>#= model.employee.account.lastName#, #= model.employee.account.firstName#</span>\n            </div>\n        #}#\n    #}#</script><div id=\"popup\" kendo-window=\"window\" k-visible=\"false\"><div class=\"box\"><div id=\"popup_editor2\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div ng-show=\"vm.isSchedule && vm.currentCustomer.id == vm.selectedUserId\" class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><select name=\"communication_type\" id=\"communicationType\" kendo-combo-box k-ng-model=\"eventCustomerSector.communicationType\" data-bind=\"value:eventCustomerSector.communicationType.id\" k-options=\"vm.communicationTypesComboBoxOptions\"></select><div class=\"k-edit-label\"><label>Τίτλος:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"title\" data-bind=\"value:title\"><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><input type=\"text\" class=\"k-input k-textbox\" name=\"description\" data-bind=\"value:eventSchedule.description\"><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomer.lastName}} {{vm.currentCustomer.firstName}}</span></span></div><div ng-show=\"!vm.isSchedule || vm.currentCustomer.id != vm.selectedUserId\" class=\"pull-left half-width\"><div class=\"k-edit-label\"><label>Τύπος επικοινωνίας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: eventCustomerSector.communicationType.name#</span></span><div class=\"k-edit-label\"><label>Τίτλος:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: title#</span></span><div class=\"k-edit-label\"><label>Περιγραφή:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: description#</span></span><div class=\"k-edit-label\"><label>Επαγγελματίας Υγείας:</label></div><span class=\"k-textbox k-space-right pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentCustomer.lastName}} {{vm.currentCustomer.firstName}}</span></span></div><div ng-show=\"vm.isSchedule && vm.currentCustomer.id == vm.selectedUserId\" class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><input name=\"start\" id=\"startDate\" class=\"half-width pull-right\" kendo-date-picker data-bind=\"value:start\"><div class=\"k-edit-label\"><label>Ώρα:</label></div><input name=\"start\" id=\"startTime\" class=\"half-width pull-right\" kendo-time-picker data-bind=\"value:start\" k-format=\"\'HH:mm\'\"><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><input type=\"number\" class=\"k-input pull-right\" name=\"duration\" data-bind=\"value:durationTime\"><div id=\"sector_object\" ng-show=\"vm.currentCustomer\"><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><select name=\"sector_id\" id=\"sector\" kendo-combo-box k-ng-model=\"eventCustomerSector.customerSector\" data-bind=\"value:eventCustomerSector.customerSector.id\" k-options=\"vm.sectorComboBoxOptions\"></select></div></div><div ng-show=\"!vm.isSchedule || vm.currentCustomer.id != vm.selectedUserId\" class=\"pull-right half-width\"><div class=\"k-edit-label\"><label>Ημερομηνία:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'dd/MM/yyyy\')#</span></span><div class=\"k-edit-label\"><label>Ώρα:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: kendo.toString(kendo.parseDate(start), \'HH:mm\')#</span></span><div class=\"k-edit-label\"><label>Διάρκεια:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">#: durationTime#</span></span><div class=\"k-edit-label\"><label>Μονάδα Υγείας:</label></div><span class=\"k-textbox pull-right readonly-input-margin\"><span class=\"k-input k-textbox\">{{vm.currentSector.name}}</span></span></div></div></div></div>");
$templateCache.put("app/displays/purchases/items/purchaseItems.html","<span id=\"centeredNotification\" style=\"display:none\"></span><kendo-grid ng-show=\"!vm.purchaseGrids.getExportState()\" id=\"purchaseItemsGrid\" options=\"vm.purchaseItemsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.purchaseItemsGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\" ng-show=\"!vm.showProgress\"><ul><li class=\"k-state-active\">Παρτίδες Φαρμάκων</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" style=\"height: 200px\"><md-progress-circular md-mode=\"indeterminate\" style=\"margin-top: 60px\"></md-progress-circular></div></div></kendo-grid><div ng-show=\"vm.purchaseGrids.getExportState()\"><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.purchaseItemsGridHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchaseItemsForPDFGrid\" options=\"vm.purchaseItemsForPDFGridOptions\" k-ng-delay=\"vm.purchaseItemsForPDFGridOptions\"></kendo-grid><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.purchasePresentItemsGridHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchasePresentItemsGrid\" options=\"vm.purchasePresentItemsGridOptions\" k-ng-delay=\"vm.purchasePresentItemsGridOptions\"></kendo-grid></div><kendo-grid ng-show=\"false\" id=\"purchaseItemLotsGrid\" options=\"vm.purchaseItemLotsGridOptions\" k-on-change=\"vm.onSelection(data)\" k-ng-delay=\"vm.purchaseItemLotsGridOptions\"></kendo-grid><script id=\"gridItemsRowTemplate\" type=\"text/x-kendo-template\"><tr data-uid=\"#= uid #\">\n        <td title=\"#= name #\">\n            #= name #\n        </td>\n        <td title=\"#= quantity #\">\n            #= quantity #\n        </td>\n        <td>\n            <a class=\"k-button k-button-icontext k-grid-delete\"><span class=\"k-icon k-delete\"></span>Διαγραφή</a>\n        </td>\n    </tr></script>");
$templateCache.put("app/displays/purchases/purchasePresentItems/purchasePresentItems.html","<span id=\"centeredNotification\" style=\"display:none\"></span><md-card md-theme=\"default\" md-theme-watch ng-show=\"vm.purchaseGrids.getExportState()\"><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.purchasePresentItemsGridHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchasePresentItemsGrid\" options=\"vm.purchasePresentItemsGridOptions\" k-ng-delay=\"vm.purchasePresentItemsGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\" ng-show=\"!vm.showProgress\"><ul><li class=\"k-state-active\">Παρτίδες Δώρων</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" style=\"height: 200px\"><md-progress-circular md-mode=\"indeterminate\" style=\"margin-top: 60px\"></md-progress-circular></div></div></kendo-grid><div ng-show=\"vm.purchaseGrids.getExportState()\"><md-card md-theme=\"default\" md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.purchaseItemsGridHeading }}</span></md-card-title-text></md-card-title></md-card><kendo-grid id=\"purchaseItemsForPDFGrid\" options=\"vm.purchaseItemsForPDFGridOptions\" k-ng-delay=\"vm.purchaseItemsForPDFGridOptions\"></kendo-grid></div><script id=\"gridPresentItemsRowTemplate\" type=\"text/x-kendo-template\"><tr data-uid=\"#= uid #\">\n        <td title=\"#= name #\">\n            #= name #\n        </td>\n        <td title=\"#= quantity #\">\n            #= quantity #\n        </td>\n        <td>\n            <a class=\"k-button k-button-icontext k-grid-delete\"><span class=\"k-icon k-delete\"></span>Διαγραφή</a>\n        </td>\n    </tr></script>");
$templateCache.put("app/displays/sectors/info/info.html","<div layout=\"row\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"><div flex=\"33\" style=\"padding-left: 5%; padding-top: 2%\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Όνομα ΜΣ:</label></div><div flex=\"60\"><input id=\"name\" name=\"name\" value=\"{{vm.sector.name}}\" ng-model=\"vm.sector.name\" class=\"k-textbox\" placeholder=\"Όνομα ΜΣ\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τύπος ΜΣ:</label></div><div flex=\"60\"><select id=\"sectorType\" name=\"sectorType\" kendo-combo-box k-ng-model=\"vm.sector.sectorType.id\" k-options=\"vm.dropDownOptions.sectorType\" data-custom=\"#sectorType\" style=\"width: 80%\" ng-disabled=\"!vm.editSectorType\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Α.Φ.Μ.:</label></div><div flex=\"60\"><input id=\"vat\" name=\"vat\" value=\"{{vm.sector.vat}}\" ng-model=\"vm.sector.vat\" class=\"k-textbox info\" placeholder=\"Α.Φ.Μ.\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.sector.sectorType.id == 8\"><div flex=\"40\"><label>Τύπος εταιρίας:</label></div><div flex=\"60\"><select id=\"companyType\" name=\"companyType\" kendo-combo-box k-ng-model=\"vm.sector.companyType.id\" k-options=\"vm.dropDownOptions.companyType\" data-custom=\"#companyType\" style=\"width: 80%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.sector.sectorType.id != 8\"><div flex=\"40\"><label>Ειδικότητες στη ΜΣ:</label></div><div flex=\"60\"><select id=\"doctorSpecialty\" name=\"doctorSpecialty\" kendo-combo-box=\"vm.specialtyComboBox\" k-ng-model=\"vm.sector.doctorSpecialty.id\" k-options=\"vm.dropDownOptions.doctorSpecialty\" data-custom=\"#doctorSpecialty\" ng-disabled=\"vm.isPrivate\" style=\"width: 80%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.sector.sectorType.id != 8\"><div flex=\"40\"><label>Ανήκει στη ΜΣ:</label></div><div flex=\"60\"><select id=\"parent\" name=\"parent\" kendo-combo-box=\"vm.sectorsComboBox\" k-ng-model=\"vm.sector.parent\" k-options=\"vm.dropDownOptions.sector\" class=\"col-fix\" data-custom=\"#sector\" ng-disabled=\"vm.isPrivate\" style=\"width: 80%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input id=\"brick\" name=\"brick\" value=\"{{vm.sector.brick}}\" ng-model=\"vm.sector.brick\" class=\"k-textbox info\" placeholder=\"Brick\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Brice ΟΦΣΕ:</label></div><div flex=\"60\"><input id=\"osfeBrick\" name=\"osfeBrick\" value=\"{{vm.sector.osfeBrick}}\" ng-model=\"vm.sector.osfeBrick\" class=\"k-textbox info\" placeholder=\"Brick ΟΦΣΕ\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλεφωνο:</label></div><div flex=\"60\"><input type=\"tel\" id=\"phone\" name=\"phone\" value=\"{{vm.sector.phone}}\" ng-model=\"vm.sector.phone\" class=\"k-textbox info\" placeholder=\"Τηλέφωνο\" style=\"width: 80%\"></div></div></div><div flex=\"33\" style=\"padding-left: 5%\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"!vm.geodata\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><select id=\"prefectures\" name=\"prefecture\" kendo-combo-box k-ng-model=\"vm.sector.prefecture\" k-options=\"vm.prefecturesComboBoxOptions\" class=\"col-fix\" style=\"width: 80%\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"!vm.geodata\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><select id=\"cities\" name=\"city\" kendo-combo-box k-ng-model=\"vm.sector.city\" k-options=\"vm.citiesComboBoxOptions\" class=\"col-fix\" style=\"width: 80%\"></select></div></div><div ng-show=\"vm.geodata\" style=\"width: 100%\"><input id=\"masterFilter\" style=\"width: 100%\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 80%\"></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 15px\" ng-show=\"vm.geodata\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectureName\" name=\"prefectureName\" type=\"text\" ng-model=\"vm.sector.prefectureName\" class=\"k-textbox info\" placeholder=\"Νομός\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-show=\"vm.geodata\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cityName\" name=\"cityName\" type=\"text\" ng-model=\"vm.sector.cityName\" class=\"k-textbox info\" placeholder=\"Πόλη\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input id=\"address\" name=\"address\" type=\"text\" ng-model=\"vm.sector.address\" class=\"k-textbox info\" placeholder=\"Διεύθυνση\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input id=\"postalCode\" name=\"postalCode\" type=\"text\" ng-model=\"vm.sector.postalCode\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" class=\"k-textbox info\" placeholder=\"Τ.Κ.\" style=\"width: 80%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input id=\"addressNum\" name=\"addressNum\" type=\"text\" ng-model=\"vm.sector.addressNum\" class=\"k-textbox info\" placeholder=\"Αριθμός\" style=\"width: 80%\"></div></div></div><div flex=\"33\" style=\"padding-left: 5%; padding-top: 2%\" ng-show=\"vm.isPrivate !== null && vm.isPrivate !== undefined && !vm.isPrivate\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Δευτέρα:</label></div><div flex=\"60\"><select id=\"wh-monday\" name=\"wh-monday\" kendo-combo-box k-ng-model=\"vm.sector.monday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 80%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τρίτη:</label></div><div flex=\"60\"><select id=\"wh-tuesday\" name=\"wh-tuesday\" kendo-combo-box k-ng-model=\"vm.sector.tuesday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 80%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τετάρτη:</label></div><div flex=\"60\"><select id=\"wh-wednesday\" name=\"wh-wednesday\" kendo-combo-box k-ng-model=\"vm.sector.wednesday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 80%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πέμπτη:</label></div><div flex=\"60\"><select id=\"wh-thursday\" name=\"wh-thursday\" kendo-combo-box k-ng-model=\"vm.sector.thursday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 80%\"><!-- data-custom=\"#companyType\" --></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Παρασκευή:</label></div><div flex=\"60\"><select id=\"wh-friday\" name=\"wh-friday\" kendo-combo-box k-ng-model=\"vm.sector.friday\" k-options=\"vm.dropDownOptions.workingHours\" class=\"col-fix\" style=\"width: 80%\"><!-- data-custom=\"#companyType\" --></select></div></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n            <i class=\"material-icons fixed-icons\">assignment_late</i>\n            <h6>#= message #</h6>\n        </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n            <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n            <h6>#= message #</h6>\n        </div></script><span id=\"notification\" style=\"display:none\"></span></div><input type=\"button\" class=\"k-button k-primary k-state-default\" style=\"float: right\" ng-click=\"vm.update()\" value=\"Αποθήκευση\">");
$templateCache.put("app/displays/sectors/clinicNames/clinicNames.html","<div kendo-grid selectable-grid id=\"mainGrid\" k-options=\"vm.sectorClinicNamesGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"></div><div id=\"custom-popup\" selectable-grid kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"header-info pull-left full-width\"><h5>Επιλογή Κλινικών</h5><div kendo-grid selectable-grid id=\"popupGrid\" k-options=\"vm.clinicNamesGridOptions\" k-rebind=\"vm.initPopupGrid\" class=\"pull-left\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div></div></div></div>");
$templateCache.put("app/displays/sectors/customers/customers.html","<div><kendo-grid id=\"customerSectorGrid\" options=\"vm.gridOptions.customerSector\" ng-style=\"{height: vm.contentHeight, overflow: auto}\"></kendo-grid></div><div id=\"custom-popup\" selectable-grid kendo-window=\"window\" k-visible=\"false\" k-modal=\"true\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div class=\"pull-left\"><div class=\"k-edit-label\"><label>Ημερομηνία Έναρξης:</label></div><input id=\"started_at\" class=\"custom-combobox\" name=\"started_at\" ng-model=\"vm.startedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" readonly=\"readonly\"></div><div class=\"header-info pull-left full-width\"><h5>Επιλογή Επαγγελματιών Υγείας</h5><label class=\"pull-left\">Ιατρικοί Επισκέπτες:</label><select id=\"multiSelect\" name=\"multiSelect\" class=\"custom-combobox pull-left custom-popup-multi\" kendo-multi-select=\"vm.employeesMulti\" multiple=\"multiple\" k-options=\"vm.employeesMultiOptions\" k-ng-model=\"vm.selectedEmployees\"></select><div kendo-grid selectable-grid id=\"popupGrid\" k-options=\"vm.gridOptions.suggestedCustomers\" k-ng-delay=\"vm.initPopupGrid\" class=\"pull-left\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div></div></div></div></div>");
$templateCache.put("app/masterData/tradePolicies/tradePolicyRules/tradePolicyRules.html","<div style=\"padding: 1em\"><div><kendo-grid id=\"tradePolicyRulesGrid\" options=\"vm.tradePolicyRulesGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" translate=\"masterData.tradePolicyRuleEffects.title\">Trade Policy Rule Effects</li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.detailedGridOptions(dataItem)\"></div></div></div></div></kendo-grid></div></div>");
$templateCache.put("app/displays/adminCustomers/patchReports/pending/pending.html","<div kendo-grid=\"vm.pendingGrid\" id=\"pendingGrid\" options=\"vm.pendingGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.patchReportPhotosGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></div><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/adminCustomers/patchReports/pendingHistory/pendingHistory.html","<kendo-grid id=\"pendingGrid\" options=\"vm.pendingHistoryGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.patchReportPhotosGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div>");
$templateCache.put("app/displays/adminCustomers/sectors/customerSector/customerSector.html","<div class=\"customer-sector-info full-width popup-new-customSector\"><h5>Στοιχεία Μονάδας Συνταγογράφησης του Επαγγελματία Υγείας</h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" ng-hide=\"vm.newSector || vm.sectorIsSaved\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Θέση στη Μονάδα Υγείας:</label></div><div flex=\"60\"><select kendo-combo-box id=\"sectorPosition\" name=\"sector_position_id\" ng-model=\"vm.newCustomerSector.sectorPosition.id\" data-bind=\"value:sectorPosition.id\" k-options=\"vm.sectorPositionComboBoxOptions\"></select></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"customer_sector_phone\" ng-model=\"vm.newCustomerSector.phone\" style=\"float: none!important\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Βασική Μονάδα:</label></div><div flex=\"60\"><md-checkbox class=\"checkbox-toolbar customers green inline\" aria-label=\"main\" ng-model=\"vm.newCustomerSector.main\"></md-checkbox></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ημερομηνία Έναρξης ΜΣ:</label></div><div flex=\"60\"><input id=\"started_at\" name=\"started_at\" k-ng-model=\"vm.newCustomerSector.startedAt\" kendo-date-picker k-format=\"\'dd/MM/yyyy\'\" data-bind=\"value:startedAt\" readonly=\"readonly\"></div></div></div></div></div><div class=\"sector-info full-width\"><h5><span ng-if=\"!vm.sector.sectorType.id\">Στοιχεία Μονάδας Υγείας</span> <span ng-if=\"vm.sector.sectorType.id && !vm.newSector\">Επιλογή Μονάδας Υγείας</span> <span ng-if=\"vm.sector.sectorType.id && vm.newSector && !vm.sectorIsSaved\">Προσθήκη Μονάδας Υγείας</span></h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τύπος Μονάδας Υγείας:</label></div><div flex=\"60\"><input ng-readonly=\"vm.customerSectorsService.getIsSectorSaved()\" id=\"sectorType\" kendo-combo-box ng-model=\"vm.sector.sectorType.id\" data-bind=\"value:sectorType\" k-options=\"vm.sectorTypeComboBoxOptions\" style=\"width: 90%\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-if=\"vm.sector.sectorType.id && vm.newSector && !vm.sectorIsSaved\"><div flex=\"40\"><label>Όνομα Μονάδας Υγείας:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"name\" ng-model=\"vm.sector.name\" style=\"float: none!important; width: 90%\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-if=\"vm.sector.sectorType.id && vm.newSector && !vm.sectorIsSaved\"><div flex=\"40\"><label>Brick:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"brick\" ng-model=\"vm.sector.brick\" style=\"float: none!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\" ng-if=\"vm.sector.sectorType.id && vm.newSector && !vm.sectorIsSaved\"><div flex=\"40\"><label>Brick ΟΣΦΕ:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"osfeBrick\" ng-model=\"vm.sector.osfeBrick\" style=\"float: none!important\"></div></div></div></div><div class=\"clearfix\"></div><kendo-grid ng-if=\"vm.sector.sectorType.id && !vm.newSector\" id=\"sectorsGrid\" options=\"vm.sectorsGridOptions\" style=\"margin-top: 10px\"></kendo-grid><div ng-if=\"vm.sector.sectorType.id && vm.newSector && !vm.sectorIsSaved\"><div class=\"sector-info pull-left full-width\"><h5>Στοιχεία Διεύθυνσης</h5></div><div ng-if=\"!vm.geodata\" class=\"sector-info full-width\"><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input id=\"prefectures\" kendo-combo-box ng-model=\"vm.sector.prefectureName\" k-ng-model=\"vm.sector.prefecture\" k-options=\"vm.prefecturesComboBoxOptions\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input id=\"cities\" kendo-combo-box ng-model=\"vm.sector.cityName\" k-ng-model=\"vm.sector.city\" k-options=\"vm.citiesComboBoxOptions\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.address\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" ng-model=\"vm.sector.postalCode\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.addressNum\" style=\"float: none;!important\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\" ng-model=\"vm.sector.phone\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο #2:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"phone\" ng-model=\"vm.sector.phone2\" style=\"float: none;!important\"></div></div></div></div></div><div ng-if=\"vm.geodata\"><input id=\"masterFilter\" kendo-combo-box k-options=\"vm.masterFilterComboBoxOptions\" style=\"width: 60%\"><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Νομός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.sector.prefectureName\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Πόλη:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" ng-model=\"vm.sector.cityName\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διεύθυνση:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.address\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τ.Κ.:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-change=\"vm.suggestBricks(vm.sector.postalCode)\" ng-model=\"vm.sector.postalCode\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Αριθμός:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"address\" ng-model=\"vm.sector.addressNum\" style=\"float: none;!important\"></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox\" name=\"phone\" ng-model=\"vm.sector.phone\" style=\"float: none;!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Τηλέφωνο #2:</label></div><div flex=\"60\"><input type=\"text\" class=\"k-input k-textbox custom-textbox\" name=\"phone\" ng-model=\"vm.sector.phone2\" style=\"float: none;!important\"></div></div></div></div></div></div></div><div class=\"window-footer\"><md-button ng-click=\"vm.nextView()\" class=\"next-button-toolbar md-raised md-warn\" ui-sref=\"employeesAssignation\" ng-disabled=\"!vm.sector.name\">Επόμενο<md-icon class=\"arrow-right\"></md-icon></md-button></div>");
$templateCache.put("app/displays/adminCustomers/medReports/medReportSumsPerMonth/medReportSumsPerMonth.html","<div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"medReportSumsGrid\"></kendo-grid></div>");
$templateCache.put("app/displays/adminCustomers/medReports/medReportWithLines/medReportWithLines.html","<div><kendo-grid id=\"medReportsGrid\" options=\"vm.medReportsGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" style=\"display: none\"></li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.medReportLinesGridOptions(dataItem)\"></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" style=\"height: 200px\"><md-progress-circular md-mode=\"indeterminate\" style=\"margin-top: 60px\"></md-progress-circular></div></div></kendo-grid></div><div id=\"custom-med-report-window\"></div><div id=\"popup-new-medReport\" kendo-window=\"vm.window\" k-visible=\"false\" k-modal=\"true\" k-options=\"vm.windowOptions\" k-options=\"vm.windowOptions\" k-on-close=\"vm.$state.go(\'customerMedReportsWithLines\', {id: vm.selectedUserId});\"><div class=\"box\"><div id=\"popup_editor\" class=\"popup_editor\" type=\"text/x-kendo-template\"><div ui-view></div></div></div></div>");
$templateCache.put("app/displays/adminCustomers/sectors/employees/employees.html","<div ng-if=\"vm.hasAssignations\" class=\"employee-assign full-width\"><h5>Ανάθεση Ιατρικών Επισκεπτών</h5><label>My Target:</label><md-checkbox aria-label=\"myTarget\" ng-checked=\"vm.myTarget\" ng-click=\"vm.myTarget=!vm.myTarget\" class=\"checkbox-toolbar green\"></md-checkbox><div selectable-grid items=\"vm.selectedEmployees\" kendo-grid id=\"employeeAllGrid\" k-options=\"vm.employeeAllGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\" k-ng-delay=\"vm.employeesService.getInitPopupGrid()\"></div></div><div class=\"clearfix\"></div><div class=\"window-footer\"><md-button class=\"next-button-toolbar md-raised md-primary\" ng-click=\"vm.updateSector()\"><md-icon ng-bind=\'\"save\"\'></md-icon>Αποθήκευση</md-button></div>");
$templateCache.put("app/displays/adminEmployees/medReports/medReportSumsPerMonth/medReportSumsPerMonth.html","<div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"medReportSumsGrid\"></kendo-grid></div>");
$templateCache.put("app/displays/adminEmployees/medReports/medReportWithLines/medReportWithLines.html","<div><div kendo-toolbar options=\"vm.toolbarOptions\" id=\"masterFiltersEvents\"></div><kendo-grid id=\"medReportsGrid\" options=\"vm.medReportsGridOptions\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" style=\"display: none\"></li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.medReportLinesGridOptions(dataItem)\"></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" style=\"height: 200px\"><md-progress-circular md-mode=\"indeterminate\" style=\"margin-top: 60px\"></md-progress-circular></div></div></kendo-grid></div>");
$templateCache.put("app/displays/adminEmployees/patchReports/pending/pending.html","<div kendo-grid=\"vm.pendingGrid\" id=\"pendingGrid\" options=\"vm.pendingGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.patchReportPhotosGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></div><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div><!--<script id=\"errorTemplate\" type=\"text/x-kendo-template\">--><!--<div class=\"wrong-pass\">--><!--<i class=\"material-icons fixed-icons\">assignment_late</i>--><!--<h6>#= message #</h6>--><!--</div>--><!--</script>--><!--<script id=\"successTemplate\" type=\"text/x-kendo-template\">--><!--<div class=\"upload-success\">--><!--<i class=\"material-icons fixed-icons\">assignment_turned_in</i>--><!--<h6>#= message #</h6>--><!--</div>--><!--</script>--> <!--<span id=\"notification\" style=\"display:none;\"></span>-->");
$templateCache.put("app/displays/adminEmployees/patchReports/pendingHistory/pendingHistory.html","<kendo-grid id=\"pendingGrid\" options=\"vm.pendingHistoryGridOptions\"><div k-detail-template id=\"detailedTemplate\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Επιθέματα</li><li><i class=\"material-icons\">photo_library</i>Φωτογραφίες</li><li><i class=\"material-icons\">event_note</i>Σχόλια</li></ul><div style=\"padding: 1em\"><div kendo-grid id=\"detailedGrid\" k-options=\"vm.detailGridsService.getPatchReportItemsGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><div kendo-grid id=\"detailedPatchReportPhotosGrid\" k-options=\"vm.patchReportPhotosGridOptions(dataItem)\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.comment\" class=\"k-textbox info\" readonly=\"readonly\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div id=\"photownd\" kendo-window=\"vm.photoWindow\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.closePhotoWindow()\"><div id=\"window\" class=\"middle\"><div ng-if=\"vm.patchPhoto\" class=\"box\"><img class=\"photo\" ng-src=\"{{\'data:image/png;base64,\' + vm.patchPhoto}}\"></div><div ng-if=\"!vm.patchPhoto\" class=\"inner\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-warn md-hue-3\"></md-progress-circular></div></div><div class=\"window-footer-photo\"><md-button ng-if=\"vm.patchPhoto\" type=\"button\" class=\"md-button md-ink-ripple md-raised md-warn photo-btn\" ng-click=\"vm.savePhoto()\"><i class=\"material-icons md-light md-26 md-margin\">file_download</i> <span class=\"hidden-sm\">Αποθήκευση</span></md-button></div></div></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsAggregated/perClinic/hospitalizationsAggregatedPerClinic.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτη:</label></div><div flex=\"85\"><select id=\"yearsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.yearsOptions\" k-ng-model=\"vm.selectedYears\" style=\"width: 100%\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"monthsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select></div></div></div><div flex=\"15\"><md-button class=\"md-raised md-primary\" style=\"background-color: #0074BC; color: white\" ng-click=\"vm.getData();\">Αναζήτηση</md-button></div><div flex=\"35\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-click=\"vm.exportData();\" flex><span class=\"k-icon k-i-excel\"></span>Export</md-button></div></div></div></div><kendo-grid id=\"mainGrid\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsAggregated/perSector/hospitalizationsAggregatedPerSector.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτη:</label></div><div flex=\"85\"><select id=\"yearsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.yearsOptions\" k-ng-model=\"vm.selectedYears\" style=\"width: 100%\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"monthsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select></div></div></div><div flex=\"15\"><md-button class=\"md-raised md-primary\" style=\"background-color: #0074BC; color: white\" ng-click=\"vm.getData();\">Αναζήτηση</md-button></div><div flex=\"35\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-click=\"vm.exportData();\" flex><span class=\"k-icon k-i-excel\"></span>Export</md-button></div></div></div></div><kendo-grid id=\"mainGrid\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/hospitalizationsAggregated/perDoctor/hospitalizationsAggregatedPerDoctor.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτη:</label></div><div flex=\"85\"><select id=\"yearsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.yearsOptions\" k-ng-model=\"vm.selectedYears\" style=\"width: 100%\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"monthsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select></div></div></div><div flex=\"15\"><md-button class=\"md-raised md-primary\" style=\"background-color: #0074BC; color: white\" ng-click=\"vm.getData();\">Αναζήτηση</md-button></div><div flex=\"35\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-click=\"vm.exportData();\" flex><span class=\"k-icon k-i-excel\"></span>Export</md-button></div></div></div></div><kendo-grid id=\"mainGrid\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/heldFollowUpRejectionReasons/leadCallsAggregatedHeldFollowUpRejectionReasons.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"barChartsContainer\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" ng-style=\"{height: vm.contentHeight + \'px\'}\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/perAgeGroup/leadCallsAggregatedPerAgeGroup.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"barChartsContainer\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" ng-style=\"{height: vm.contentHeight + \'px\'}\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/perDisease/leadCallsAggregatedPerDisease.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"barChartsContainer\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" ng-style=\"{height: vm.contentHeight + \'px\'}\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/perUser/leadCallsAggregatedPerUser.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"pieChartsContainer\"><div flex><div layout=\"row\"><div flex style=\"border-right: 1px solid #9E9E9E\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div></div><div flex><div layout=\"column\"><div id=\"chart2\" name=\"chart2\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum2Label }}</p></div></div></div></div></div><md-divider></md-divider><div flex><div layout=\"row\"><div flex style=\"border-right: 1px solid #9E9E9E\"><div layout=\"column\"><div id=\"chart3\" name=\"chart3\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum3Label }}</p></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadManagementAggregated/grid/grid.html","<kendo-grid id=\"mainGrid\" options=\"vm.mainGridOptions\" ng-style=\"{height: vm.contentHeight + \'px\'}\"></kendo-grid>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/perParentHospitalizationType/leadCallsAggregatedPerParentHospitalizationType.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"barChartsContainer\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" ng-style=\"{height: vm.contentHeight + \'px\'}\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadCallsAggregated/heldFollowUp/leadCallsAggregatedHeldFollowUp.html","<div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"barChartsContainer\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" ng-style=\"{height: vm.contentHeight + \'px\'}\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div>");
$templateCache.put("app/displays/adminIndex/leadManagementAggregated/pie/pie.html","<div><!-- ng-style=\"{height: vm.contentHeight + \'px\'}\" style=\"overflow-y: scroll\" --><div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτος:</label></div><div flex=\"85\"><select id=\"year\" name=\"year\" class=\"inline\" kendo-drop-down-list k-options=\"vm.yearsOptions\" k-ng-model=\"vm.year\" style=\"padding-left: 10px\"></select></div></div></div><div flex=\"35\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"multiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select><!-- kendo-multi-select=\'vm.employeesMulti\' --></div></div></div><div flex=\"50\"><div layout=\"row\" layout-align=\"end center\"><div><label style=\"color: #0074BC\">{{ vm.sumLabel }}</label></div><div><md-button class=\"md-raised md-mini md-primary k-button-icontext\" aria-label=\"excel\" ng-click=\"vm.exportPDF();\" style=\"background-color: #e61f00; color: white\" flex><span class=\"k-icon k-i-pdf\"></span>Export</md-button></div></div></div></div><div layout=\"column\" id=\"pieChartsContainer\"><div flex><div layout=\"row\"><div flex style=\"border-right: 1px solid #9E9E9E\"><div layout=\"column\"><div id=\"chart1\" name=\"chart1\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum1Label }}</p></div></div></div><div flex><div layout=\"column\"><div id=\"chart2\" name=\"chart2\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum2Label }}</p></div></div></div></div></div><md-divider></md-divider><div flex><div layout=\"row\"><div flex style=\"border-right: 1px solid #9E9E9E\"><div layout=\"column\"><div id=\"chart3\" name=\"chart3\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum3Label }}</p></div></div></div><div flex><div layout=\"column\"><div id=\"chart4\" name=\"chart4\" flex></div><div flex style=\"background-color: white\"><p style=\"color: #0074BC; float: right; padding-right: 8px\" flex>{{ vm.sum4Label }}</p></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: white\"><md-chips ng-model=\"vm.selectedLabelMonths\" readonly=\"true\"></md-chips></div></div></div>");
$templateCache.put("app/displays/adminIndex/medReport/medReportSumsPerCustomerAndMonth/medReportSumsPerCustomerAndMonth.html","<div favourite-filters-title-md-toolbar=\"\"></div><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><main ng-style=\"{height: vm.contentHeight + \'px\'}\"><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/medReport/medReportSumsPerMonth/medReportSumsPerMonth.html","<div favourite-filters-title-md-toolbar=\"\"></div><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><main ng-style=\"{height: vm.contentHeight + \'px\'}\"><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" style=\"margin-left:20px!important\"></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/perEmployee/purchasesAggregatedPerEmployee.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\"></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/perEmployeeComparative/purchasesAggregatedPerEmployeeComparative.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div layout=\"row\" layout-align=\" center\" style=\"margin: 0px\"><div flex=\"15\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Έτη:</label></div><div flex=\"85\"><select id=\"yearsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.yearsOptions\" k-ng-model=\"vm.selectedYears\" style=\"width: 100%\"></select></div></div></div><div flex=\"25\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"10\" style=\"padding-top: 5px\"><label>Μήνες:</label></div><div flex=\"90\" style=\"padding-left: 7px\"><select id=\"monthsMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.monthsOptions\" k-ng-model=\"vm.selectedMonths\" style=\"width: 100%\"></select></div></div></div><div flex=\"30\" style=\"padding: 5px\"><div layout=\"row\"><div flex=\"15\" style=\"padding-top: 5px\"><label>Ιατρικοί Επισκέπτες:</label></div><div flex=\"85\" style=\"padding-left: 7px\"><select id=\"employeesMultiSelect\" class=\"inline\" kendo-multi-select k-options=\"vm.employeesOptions\" k-ng-model=\"vm.selectedEmployees\" style=\"width: 100%\"></select></div></div></div><div flex=\"10\"><md-button class=\"md-raised md-mini md-primary\" style=\"background-color: #0074BC; color: white\" ng-click=\"vm.getData();\"><md-icon class=\"search-refresh\"></md-icon>Αναζήτηση</md-button></div><div flex=\"20\"><div layout=\"row\" layout-align=\"end center\"><div><md-button class=\"md-raised md-mini md-primary k-button-icontext k-button-icontext k-grid-excel\" aria-label=\"excel\" ng-click=\"vm.exportData();\" flex><span class=\"k-icon k-i-excel\"></span>Export</md-button></div></div></div></div><kendo-grid id=\"mainGrid\"></kendo-grid></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/medReport/medReportWithLines/medReportWithLines.html","<div favourite-filters-title-md-toolbar=\"\"></div><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><main ng-style=\"{height: vm.contentHeight + \'px\'}\"><div favourite-filters-main></div><div id=\"main-panel\"><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" k-options=\"vm.mainGridOptions\" style=\"margin-left:20px!important\"><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\" style=\"display: none\"></li></ul><div><div id=\"detailGrid\" kendo-grid k-options=\"vm.medReportLinesGridOptions(dataItem)\"></div></div></div></div></div></div></main><div favourite-filters-window></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/perEmployeeSectorProduct/purchasesPerEmployeeSectorProduct.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\"></div><!--<div id=\"grid\"></div>--></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/perProduct/purchasesAggregatedPerProduct.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\"></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/adminIndex/purchasesAggregated/perSector/purchasesAggregatedPerSector.html","<div id=\"mainContainer\" ng-show=\"!vm.showProgress\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters\"></div><div kendo-grid=\"vm.mainGrid\" id=\"mainGrid\" options=\"vm.mainGridOptions\"></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.showProgress\" ng-style=\"{height: vm.contentHeight + \'px\'}\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/displays/approvals/changedRecords/pending/pending.html","<kendo-grid selectable-grid items=\"vm.approvals.getSelectedList()\" id=\"pendingGrid\" class=\"fix-height\" k-options=\"vm.pendingGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_approvals\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"></div></kendo-grid><div kendo-window=\"vm.previewWindow\" k-width=\"1600\" k-height=\"620\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.kendoGrid.refresh(vm.pendingGridOptions)\" k-on-open=\"vm.kendoGrid.refreshList(vm.pendingPreviewGridOptions, vm.approvals.getSelectedList())\"><div class=\"box\"><kendo-grid id=\"pendingPreviewGrid\" class=\"approval-preview-grid\" k-options=\"vm.pendingPreviewGridOptions\" k-ng-delay=\"vm.initPopupGrid\"></kendo-grid></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closePreviewWindow()\">Ακύρωση</button> <button ng-if=\"vm.status == \'approve\'\" type=\"button\" class=\"green-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΈΓΚΡΙΣΗ</button> <button ng-if=\"vm.status == \'reject\'\" type=\"button\" class=\"red-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΑΠΟΡΡΙΨΗ</button></div></div><span id=\"notification\"></span>");
$templateCache.put("app/displays/approvals/changedRecords/pendingHistory/pendingHistory.html","<kendo-grid id=\"pendingGrid\" options=\"vm.pendingHistoryGridOptions\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_approvals\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"></div></kendo-grid>");
$templateCache.put("app/displays/approvals/newRecords/pending/pending.html","<kendo-grid selectable-grid items=\"vm.approvals.getSelectedList()\" id=\"pendingGrid\" class=\"fix-height\" k-options=\"vm.pendingGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_approvals\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"></div><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Στοιχεία Επαγγελματία Υγείας</li><li><i class=\"material-icons\">business</i>Στοιχεία Μονάδας Υγείας</li><li><i class=\"material-icons\">event_note</i>Σημειώσεις</li></ul><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div id=\"customerFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.lastName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.firstName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Μ.Κ.Α.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.amka\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Από:</label><div class=\"col-sm-8 col-md-6\"><input name=\"startedAt\" id=\"startedAt\" kendo-date-picker ng-model=\"dataItem.tempCustomerSectors[0].startedAt\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Εώς:</label><div class=\"col-sm-8 col-md-6\"><input name=\"endedAt\" id=\"endedAt\" kendo-date-picker ng-model=\"dataItem.tempCustomerSectors[0].endedAt\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Θέση:</label><div class=\"col-sm-8 col-md-6\"><input id=\"customerTypes\" name=\"customerTypes\" kendo-multi-select multiple=\"multiple\" k-ng-model=\"dataItem.customerTypes\" readonly=\"readonly\" k-options=\"vm.customerTypesMultiOptions\" class=\"col-fix\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.doctorSpecialty.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα 2η:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.doctorSpecificSpecialty.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Κατηγορία:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerCategory.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Υποκατηγορία:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerSubCategory.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ωράριο:</label><div class=\"col-sm-8 col-md-6\"><input ng-if=\"dataItem.dayTime == \'day\'\" type=\"textbox\" value=\"Πρωινό\" class=\"k-textbox info\" readonly=\"readonly\"> <input ng-if=\"dataItem.dayTime == \'night\'\" type=\"textbox\" value=\"Απογευματινό\" class=\"k-textbox info\" readonly=\"readonly\"></div></div></div><div id=\"customerSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κινητό:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.cellPhone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σταθερό Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.phone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.email\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Τίτλος:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerTitle.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">My Target:</label><div class=\"col-sm-8 col-md-6\"><div layout=\"row\" layout-wrap flex><md-checkbox aria-label=\"saw\" ng-checked=\"dataItem.saw\" class=\"green\"></md-checkbox></div></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ενεργός:</label><div class=\"col-sm-8 col-md-6\"><div layout=\"row\" layout-wrap flex><md-checkbox aria-label=\"isActive\" ng-checked=\"dataItem.isActive\" class=\"green\"></md-checkbox></div></div></div></div></md-content><div class=\"clearfix\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><md-tabs md-selected=\"dataItem.selectedIndex\" md-border-bottom md-autoselect><md-tab ng-repeat=\"customerSector in dataItem.tempCustomerSectors\"><md-tab-label><span ng-show=\"customerSector.newSector\"><span class=\"label label-success\">Νέο</span> </span><span>{{customerSector.displaySector.sectorType.name}}</span></md-tab-label><md-tab-body><div id=\"sectorFirst\" class=\"form-horizontal form-widgets col-sm-6 margin-top\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος Μονάδας Υγείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.sectorType.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα Μονάδας Υγείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.phone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο 2:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.phone2\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"customerSector.tempSector.sectorType.id == 8\" class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Φ.Μ.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.tempSector.vat\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"customerSector.tempSector.sectorType.id == 8\" class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος Εταιρείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.tempSector.companyType.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><!--<div ng-if=\"customerSector.tempSector.sectorType.id == 8\"--><!--class=\"form-group\">--><!--<label class=\"control-label col-sm-4\">Δ.Ο.Υ.:</label>--><!--<div class=\"col-sm-8 col-md-6\">--><!--<input type=\"textbox\" ng-model=\"customerSector.tempSector.taxOffice.name\" class=\"k-textbox info\" readonly/>--><!--</div>--><!--</div>--></div><div id=\"sectorSecond\" class=\"form-horizontal form-widgets col-sm-6 margin-top\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Νομός:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.prefectureName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Πόλη:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.cityName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Διεύθυνση:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.address\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τ.Κ.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.postalCode\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Αριθμός:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.addressNum\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\" ng-show=\"customerSector.displaySector.sectorType.sectorTypeCategory != \'beautyCenter\'\"><label class=\"control-label col-sm-4\">Brick:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.brick\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\" ng-show=\"customerSector.displaySector.sectorType.sectorTypeCategory != \'beautyCenter\'\"><label class=\"control-label col-sm-4\">Brick ΟΣΦΕ:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.osfeBrick\" class=\"k-textbox info\" readonly=\"readonly\"></div></div></div><div class=\"clearfix\"></div></md-tab-body></md-tab></md-tabs></md-content></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.notes\" class=\"k-textbox info\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><div kendo-window=\"vm.previewWindow\" k-width=\"1600\" k-height=\"620\" k-visible=\"false\" k-modal=\"true\" k-resizable=\"false\" k-draggable=\"false\" k-on-close=\"vm.kendoGrid.refresh(vm.pendingGridOptions)\" k-on-open=\"vm.kendoGrid.refreshList(vm.pendingPreviewGridOptions, vm.approvals.getSelectedList())\"><div class=\"box\"><kendo-grid id=\"pendingPreviewGrid\" class=\"approval-preview-grid\" k-options=\"vm.pendingPreviewGridOptions\" k-ng-delay=\"vm.initPopupGrid\"></kendo-grid></div><div class=\"window-footer\"><button type=\"button\" class=\"k-button\" ng-click=\"vm.closePreviewWindow()\">Ακύρωση</button> <button ng-if=\"vm.status == \'approve\'\" type=\"button\" class=\"green-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΈΓΚΡΙΣΗ</button> <button ng-if=\"vm.status == \'reject\'\" type=\"button\" class=\"red-color k-button\" ng-click=\"vm.approveRejectSelected(vm.status)\">ΑΠΟΡΡΙΨΗ</button></div></div><!--Label Template--><div id=\"labelsTemplate\" type=\"text/x-kendo-template\" ng-show=\"false\"><span ng-show=\"!dataItem.customer\" class=\"label label-success\">Επαγγελματίας Υγείας</span> <span ng-show=\"dataItem.customer || dataItem.newSector\"><span class=\"label label-info\">Μονάδα</span></span></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/approvals/newRecords/pendingHistory/pendingHistory.html","<kendo-grid id=\"pendingGrid\" options=\"vm.pendingHistoryGridOptions\"><div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filters_approvals\" has-any-authority=\"ROLE_ADMIN, ROLE_SYSTEM, ROLE_MANAGEMENT, ROLE_SUPERVISOR\" application-parameters=\"Visit_Pharmacies\"></div><div k-detail-template id=\"detailedGridOptions\"><div kendo-tab-strip=\"tabs\"><ul><li class=\"k-state-active\"><i class=\"material-icons\">person</i>Στοιχεία Επαγγελματία Υγείας</li><li><i class=\"material-icons\">business</i>Στοιχεία Μονάδας Υγείας</li><li><i class=\"material-icons\">event_note</i>Σημειώσεις</li></ul><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div id=\"customerFirst\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Επώνυμο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.lastName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.firstName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Μ.Κ.Α.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.amka\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Από:</label><div class=\"col-sm-8 col-md-6\"><input name=\"startedAt\" id=\"startedAt\" kendo-date-picker ng-model=\"dataItem.tempCustomerSectors[0].startedAt\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Εώς:</label><div class=\"col-sm-8 col-md-6\"><input name=\"endedAt\" id=\"endedAt\" kendo-date-picker ng-model=\"dataItem.tempCustomerSectors[0].endedAt\" readonly=\"readonly\"></div></div><div ng-if=\"dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\')\" class=\"form-group\"><label class=\"control-label col-sm-4\">Θέση:</label><div class=\"col-sm-8 col-md-6\"><input id=\"customerTypes\" name=\"customerTypes\" kendo-multi-select multiple=\"multiple\" k-ng-model=\"dataItem.customerTypes\" readonly=\"readonly\" k-options=\"vm.customerTypesMultiOptions\" class=\"col-fix\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.doctorSpecialty.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ειδικότητα 2η:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.doctorSpecificSpecialty.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Κατηγορία:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerCategory.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Υποκατηγορία:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerSubCategory.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ωράριο:</label><div class=\"col-sm-8 col-md-6\"><input ng-if=\"dataItem.dayTime == \'day\'\" type=\"textbox\" value=\"Πρωινό\" class=\"k-textbox info\" readonly=\"readonly\"> <input ng-if=\"dataItem.dayTime == \'night\'\" type=\"textbox\" value=\"Απογευματινό\" class=\"k-textbox info\" readonly=\"readonly\"></div></div></div><div id=\"customerSecond\" class=\"form-horizontal form-widgets col-sm-6\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Κινητό:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.cellPhone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Σταθερό Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.phone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Email:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.email\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Τίτλος:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"dataItem.customerTitle.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">My Target:</label><div class=\"col-sm-8 col-md-6\"><div layout=\"row\" layout-wrap flex><md-checkbox aria-label=\"saw\" ng-checked=\"dataItem.saw\" class=\"green\"></md-checkbox></div></div></div><div ng-if=\"!(dataItem.tempCustomerSectors.length == 1 && (dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\n                            || dataItem.tempCustomerSectors[0].tempSector.sectorType.sectorTypeCategory == \'beautyCenter\'))\" class=\"form-group\"><label class=\"control-label col-sm-4\">Ενεργός:</label><div class=\"col-sm-8 col-md-6\"><div layout=\"row\" layout-wrap flex><md-checkbox aria-label=\"isActive\" ng-checked=\"dataItem.isActive\" class=\"green\"></md-checkbox></div></div></div></div></md-content><div class=\"clearfix\"></div></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><md-tabs md-selected=\"dataItem.selectedIndex\" md-border-bottom md-autoselect><md-tab ng-repeat=\"customerSector in dataItem.tempCustomerSectors\"><md-tab-label><span ng-show=\"customerSector.newSector\"><span class=\"label label-success\">Νέο</span> </span><span>{{customerSector.displaySector.sectorType.name}}</span></md-tab-label><md-tab-body><div id=\"sectorFirst\" class=\"form-horizontal form-widgets col-sm-6 margin-top\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος Μονάδας Υγείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.sectorType.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Όνομα Μονάδας Υγείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\" ng-show=\"customerSector.displaySector.sectorType.sectorTypeCategory != \'beautyCenter\'\"><label class=\"control-label col-sm-4\">Brick:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.brick\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\" ng-show=\"customerSector.displaySector.sectorType.sectorTypeCategory != \'beautyCenter\'\"><label class=\"control-label col-sm-4\">Brick ΟΣΦΕ:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.osfeBrick\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.phone\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τηλέφωνο 2:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.phone2\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"customerSector.tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\" class=\"form-group\"><label class=\"control-label col-sm-4\">Α.Φ.Μ.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.tempSector.vat\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div ng-if=\"customerSector.tempSector.sectorType.sectorTypeCategory == \'pharmacy\'\" class=\"form-group\"><label class=\"control-label col-sm-4\">Τύπος Εταιρείας:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.tempSector.companyType.name\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><!--<div ng-if=\"customerSector.tempSector.sectorType.id == 8\"--><!--class=\"form-group\">--><!--<label class=\"control-label col-sm-4\">Δ.Ο.Υ.:</label>--><!--<div class=\"col-sm-8 col-md-6\">--><!--<input type=\"textbox\" ng-model=\"customerSector.tempSector.taxOffice.name\" class=\"k-textbox info\" readonly/>--><!--</div>--><!--</div>--></div><div id=\"sectorSecond\" class=\"form-horizontal form-widgets col-sm-6 margin-top\"><div class=\"form-group\"><label class=\"control-label col-sm-4\">Νομός:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.prefectureName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Πόλη:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.cityName\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Διεύθυνση:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.address\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Τ.Κ.:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.postalCode\" class=\"k-textbox info\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Αριθμός:</label><div class=\"col-sm-8 col-md-6\"><input type=\"textbox\" ng-model=\"customerSector.displaySector.addressNum\" class=\"k-textbox info\" readonly=\"readonly\"></div></div></div><div class=\"clearfix\"></div></md-tab-body></md-tab></md-tabs></md-content></div><div style=\"padding: 1em\"><md-content class=\"md-padding\"><div class=\"col-sm-10 col-md-8\"><textarea id=\"notes\" ng-model=\"dataItem.notes\" class=\"k-textbox info\"></textarea></div><div class=\"clearfix\"></div></md-content></div></div></div></kendo-grid><!--Label Template--><div id=\"labelsTemplate\" type=\"text/x-kendo-template\" ng-show=\"false\"><span ng-show=\"!dataItem.customer\" class=\"label label-success\">Επαγγελματίας Υγείας</span> <span ng-show=\"dataItem.customer || dataItem.newSector\"><span class=\"label label-info\">Μονάδα</span></span></div>");
$templateCache.put("app/displays/assignations/transfers/customerSectors/customerSectors.html","<div kendo-toolbar options=\"vm.toolbarOptions\" k-rebind=\"vm.toolbarOptions\" id=\"master_filter_customer_sectors\"></div><div selectable-grid kendo-grid id=\"assignationsGrid\" k-options=\"vm.customerSectorGridOptions\" k-on-change=\"onSelectItem(kendoEvent.sender, dataItem)\"></div>");
$templateCache.put("app/displays/assignations/transfers/preview/preview.html","<div kendo-toolbar options=\"vm.toolbarPreviewOptions\" k-rebind=\"vm.toolbarPreviewOptions\" id=\"preview_customer_sectors\"></div><div kendo-grid id=\"previewAssignationsGrid\" k-options=\"vm.previewGridOptions\"></div><script id=\"errorTemplate\" type=\"text/x-kendo-template\"><div class=\"wrong-pass\">\n        <i class=\"material-icons fixed-icons\">assignment_late</i>\n        <h6>#= message #</h6>\n    </div></script><script id=\"successTemplate\" type=\"text/x-kendo-template\"><div class=\"upload-success\">\n        <i class=\"material-icons fixed-icons\">assignment_turned_in</i>\n        <h6>#= message #</h6>\n    </div></script><span id=\"notification\" style=\"display:none\"></span>");
$templateCache.put("app/displays/adminCustomers/medReports/medReportWithLines/medReportPopup/medReportPopup.html","<div class=\"med-report-info full-width popup-new-medReport\"><h5>Στοιχεία Report</h5><div layout=\"row\"><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Διάστημα:</label></div><div flex=\"60\"><input id=\"fromToDate\" name=\"started_at\" k-ng-model=\"vm.medReport.fromToDate\" kendo-date-picker k-format=\"\'MMMM yyyy\'\" k-options=\"vm.dateSelectorOptions\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Check Digit 1:</label></div><div flex=\"50\"><input type=\"text\" class=\"k-input k-textbox\" name=\"checkDigit1\" ng-model=\"vm.medReport.checkDigit1\" style=\"float: none!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Ιατρικός Επισκέπτης:</label></div><div flex=\"50\"><select id=\"employee\" name=\"employee\" required data-required-msg=\"Παρακαλούμε εισάγετε Ιατρικό Επισκέπτη.\" kendo-combo-box k-options=\"vm.employeesComboBoxOptions\" k-ng-model=\"vm.medReport.employee\"></select></div></div></div><div flex=\"50\"><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Κωδικός:</label></div><div flex=\"50\"><input type=\"text\" class=\"k-input k-textbox\" name=\"code\" ng-model=\"vm.medReport.code\" style=\"float: none!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Check Digit 2:</label></div><div flex=\"50\"><input type=\"text\" class=\"k-input k-textbox\" name=\"checkDigit2\" ng-model=\"vm.medReport.checkDigit2\" style=\"float: none!important\"></div></div><div layout=\"row\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=\"40\"><label>Επαγγελματίας Υγείας:</label></div><div flex=\"50\"><input type=\"text\" class=\"k-input k-textbox\" name=\"checkDigit2\" ng-model=\"vm.medReport.customer.fullName\" style=\"float: none!important\" readonly=\"readonly\"></div></div></div></div></div><div class=\"window-footer\"><md-button ng-click=\"vm.save()\" class=\"next-button-toolbar md-raised md-primary\" ng-disabled=\"true\"><md-icon class=\"save-icon\"></md-icon>Αποθήκευση</md-button></div>");}]);})();